msgid ""
msgstr ""
"POT-Creation-Date: 2025-07-16 14:41+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: zh-TW\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: displayBoxSize || 'w-full h-full'
#: apps/dp-business/src/components/PrivateImage/index.tsx:115
#: apps/dp-business/src/components/PhotoUploader/components/PhotoDisplay.tsx:95
msgid ""
"\n"
"      {0}\n"
"      border border-dashed border-gray-300\n"
"      rounded-lg\n"
"      flex items-center justify-center\n"
"      overflow-hidden\n"
"      box-border\n"
"    "
msgstr ""
"\n"
"      {0}\n"
"      border border-dashed border-gray-300\n"
"      rounded-lg\n"
"      flex items-center justify-center\n"
"      overflow-hidden\n"
"      box-border\n"
"    "

#. placeholder {0}: uploadBoxSize || 'w-full h-full'
#. placeholder {1}: businessThemeColors.borderBrand
#: apps/dp-business/src/components/PhotoUploader/components/PhotoUploadArea.tsx:50
msgid ""
"\n"
"      {0} box-border\n"
"      {uploadBorderWidth} {uploadBorderStyle} {borderColor}\n"
"      rounded-lg\n"
"      flex flex-col items-center justify-center\n"
"      overflow-hidden\n"
"      hover:border-color-[{1}]\n"
"      transition-colors duration-200\n"
"    "
msgstr ""
"\n"
"      {0} box-border\n"
"      {uploadBorderWidth} {uploadBorderStyle} {borderColor}\n"
"      rounded-lg\n"
"      flex flex-col items-center justify-center\n"
"      overflow-hidden\n"
"      hover:border-color-[{1}]\n"
"      transition-colors duration-200\n"
"    "

#: apps/dp-business/src/pages/AccountDeactivationSuccess/index.tsx:49
msgid "    若需重新使用商家端帳號"
msgstr "    若需重新使用商家端帳號"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:106
msgid "  本樹：{treeName}"
msgstr "  本樹：{treeName}"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:117
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeMountNodeModal.web.tsx:134
msgid " · 結算路徑不變"
msgstr " · 結算路徑不變"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:132
msgid " · 藍新已簽約"
msgstr " · 藍新已簽約"

#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:137
msgid " (已到期)"
msgstr " (已到期)"

#: apps/dp-client/src/screens/splash-ad/components/SplashSkipButton.tsx:31
msgid " | 跳過"
msgstr " | 跳過"

#. placeholder {0}: dayjs( claimedCouponData?.validStartTime ).format('YYYY/MM/DD')
#. placeholder {1}: dayjs( claimedCouponData?.validEndTime ).format('YYYY/MM/DD')
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:358
msgid " 使用期限:{0}~{1}"
msgstr " 使用期限:{0}~{1}"

#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:88
msgid " 則{contentName}發佈中，發佈成功後可獲得點數"
msgstr " 則{contentName}發佈中，發佈成功後可獲得點數"

#. placeholder {0}: formatCurrency(discountData.platformDiscountAmount, { decimals: 0, })
#. placeholder {0}: formatCurrency(discountData.shopDiscountAmount, { decimals: 0, })
#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:43
#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:56
msgid "-{0}"
msgstr "-{0}"

#. placeholder {1}: formatCurrency(discountData.totalDiscountAmount, { decimals: 0, })
#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:75
msgid "-{1}"
msgstr "-{1}"

#. placeholder {0}: orderData?.platformDiscountAmount || 0
#. placeholder {0}: orderData?.shopDiscountAmount || 0
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:944
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:952
msgid "-${0}"
msgstr "-${0}"

#: apps/dp-client/src/screens/account/pages/notifications/pages/likes/index.tsx:162
#: apps/dp-client/src/screens/account/pages/notifications/pages/follow/index.tsx:193
#: apps/dp-client/src/screens/account/pages/notifications/pages/comments/index.tsx:173
#: apps/dp-client/src/screens/account/pages/notifications/pages/CategoryNotifications/index.tsx:201
msgid "-THE END-"
msgstr "-THE END-"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:503
msgid "，{failCount} 個任務失敗"
msgstr "，{failCount} 個任務失敗"

#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:152
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:201
msgid "，且"
msgstr "，且"

#: apps/dp-client/src/screens/login/components/privacy-agreement/index.tsx:82
msgid "，並提供您的心生活會員代碼與遠傳幣資訊以完成用戶註冊並開始使用本服務"
msgstr "，並提供您的心生活會員代碼與遠傳幣資訊以完成用戶註冊並開始使用本服務"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:219
msgid "，你也可以自行修改。"
msgstr "，你也可以自行修改。"

#: apps/dp-business/src/components/StoreInfoCard/index.tsx:494
#: apps/dp-business/src/components/StoreInfoCard/index.tsx:603
msgid "，共{reviewCount}條評論"
msgstr "，共{reviewCount}條評論"

#. placeholder {0}: userPoints?.rankingDisplaySize || 10
#: apps/dp-client/src/screens/diary/pages/my/components/TabSwitch.tsx:178
msgid "，快衝刺進入排行榜前{0}！"
msgstr "，快衝刺進入排行榜前{0}！"

#: apps/dp-business/src/pages/BusinessStatus/components/ShopClosedImpactContent.tsx:78
msgid "，會自動下架共"
msgstr "，會自動下架共"

#: apps/dp-business/src/pages/BusinessStatus/components/SharedTemplatesContent.tsx:94
msgid "，為避免產生異常訂單，"
msgstr "，為避免產生異常訂單，"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/SharedTemplatesModal/index.web.tsx:79
msgid "，為避免產生異常訂單，請至套餐券列表檢查並手動下架"
msgstr "，為避免產生異常訂單，請至套餐券列表檢查並手動下架"

#: apps/dp-business/src/pages/MenuManagement.tsx:489
msgid "，跳過{duplicateCount}個重複餐點"
msgstr "，跳過{duplicateCount}個重複餐點"

#. placeholder {0}: incentiveEnabled ? '賺積分' : '寫日記'
#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:166
msgid "，點擊『立即開始{0}』即視為同意，同時可完成用戶註冊並開始使用服務。"
msgstr "，點擊『立即開始{0}』即視為同意，同時可完成用戶註冊並開始使用服務。"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:732
msgid "、"
msgstr "、"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:335
msgid "... 還有"
msgstr "... 還有"

#. placeholder {0}: events.length
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:187
msgid "…等 {0} 項"
msgstr "…等 {0} 項"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:73
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:79
msgid "。"
msgstr "。"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:68
msgid "。解掛後本樹不再管轄該店，"
msgstr "。解掛後本樹不再管轄該店，"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:410
msgid "· 當前結算亦在此"
msgstr "· 當前結算亦在此"

#. placeholder {0}: reviewCount ?? 0
#: apps/dp-client/src/components/ShopBriefCard/index.tsx:55
msgid "({0})"
msgstr "({0})"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/EntryDetailCard/index.web.tsx:23
msgid "（{approveMethod}）"
msgstr "（{approveMethod}）"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:688
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:362
msgid "（1天 ≤ 截止日期−銷售結束日期 ≤ 85天）"
msgstr "（1天 ≤ 截止日期−銷售結束日期 ≤ 85天）"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1477
msgid "（企業）"
msgstr "（企業）"

#. placeholder {0}: profile.name
#: apps/dp-client/src/screens/account/pages/invoice/components/InvoiceProfileCard/index.tsx:50
msgid "(企業){0}"
msgstr "(企業){0}"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:219
msgid "（保持關閉也不影響參與活動）"
msgstr "（保持關閉也不影響參與活動）"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1476
msgid "（個人）"
msgstr "（個人）"

#. placeholder {0}: profile.name
#: apps/dp-client/src/screens/account/pages/invoice/components/InvoiceProfileCard/index.tsx:44
msgid "(個人){0}"
msgstr "(個人){0}"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageDescriptionCard.tsx:62
msgid "（最多 500 字，提交後機器審核）"
msgstr "（最多 500 字，提交後機器審核）"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:260
msgid "(可選)"
msgstr "(可選)"

#. placeholder {0}: merchantId || '未獲取'
#. placeholder {1}: statisticsData.length
#. placeholder {1}: keywordData.length
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingDistribution.web.tsx:227
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/KeywordStats.web.tsx:107
msgid "(商家ID: {0}, 數據量:{1})"
msgstr "(商家ID: {0}, 數據量:{1})"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:151
msgid "（完整）公司登記表"
msgstr "（完整）公司登記表"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelParentSelect/index.web.tsx:31
msgid "（已停用）"
msgstr "（已停用）"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1141
msgid "(庫存預警)"
msgstr "(庫存預警)"

#: apps/dp-client/src/screens/diary/pages/rank/components/rank-item.tsx:97
#: apps/dp-client/src/screens/diary/pages/rank/components/rank-item-nocoin.tsx:112
msgid "（我）"
msgstr "（我）"

#: apps/dp-admin/src/components/BusinessHours/components/BusinessStatusSelector.web.tsx:214
msgid "（所選時間已覆蓋24小時）"
msgstr "（所選時間已覆蓋24小時）"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1474
msgid "（捐贈）"
msgstr "（捐贈）"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:409
msgid "(支援多選)"
msgstr "(支援多選)"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:113
msgid "（目前）"
msgstr "（目前）"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:13
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelHistoryList/index.web.tsx:27
msgid "（空）"
msgstr "（空）"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:165
msgid "(空內容)"
msgstr "(空內容)"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:134
msgid "（美食金）"
msgstr "（美食金）"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:19
msgid "（自動）"
msgstr "（自動）"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:174
msgid "(自動建議關聯商家最多的標籤)"
msgstr "(自動建議關聯商家最多的標籤)"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:77
msgid "（自動生成）"
msgstr "（自動生成）"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:160
msgid "(若當月無該日期，默認當月最後一天)"
msgstr "(若當月無該日期，默認當月最後一天)"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:581
msgid "（該項為線下約定，僅展示）"
msgstr "（該項為線下規定，僅展示）"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:666
msgid "（該項為線下約定）"
msgstr "（該項為線下規定）"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:375
msgid "（跨夜）"
msgstr "（跨夜）"

#: apps/dp-client/src/components/Version/index.tsx:24
msgid "[Version] 立即更新失敗:"
msgstr "[Version] 立即更新失敗:"

#. placeholder {0}: businessStatus.closeTime
#. placeholder {0}: formatAdvanceMinutes(reservation.stopBookingMinutes)
#. placeholder {0}: formatAdvanceMinutes(reservation.maxAdvanceMinutes)
#: apps/dp-client/src/utils/businessStatus.ts:192
#: apps/dp-client/src/utils/businessStatus.ts:212
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:422
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:434
#: apps/dp-client/src/screens/reservation/pages/main/components/TimeModal.tsx:147
#: apps/dp-client/src/screens/reservation/pages/main/components/TimeModal.tsx:156
#: apps/dp-client/src/screens/home/pages/ShareKing/components/WinningList/index.tsx:122
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapView/Marker.tsx:1038
#: apps/dp-client/src/screens/diary/pages/my/components/UserProfileSection.tsx:58
#: apps/dp-client/src/screens/diary/pages/home/components/task-section/index.tsx:41
#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:70
#: apps/dp-business/src/pages/MerchantInfo/components/RankingCard.tsx:71
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1388
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/SubsidyCard.tsx:87
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:765
#: apps/dp-business/src/pages/CouponVerification/components/VerificationModal.tsx:289
msgid "{0}"
msgstr "{0}"

#. placeholder {0}: businessStatus.nextOpenTime
#: apps/dp-client/src/utils/businessStatus.ts:201
msgid "{0} "
msgstr "{0} "

#. placeholder {0}: data.benefitName
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:52
msgid "{0} - 中獎人數"
msgstr "{0} - 中獎人數"

#. placeholder {0}: detail.cycleType || '-'
#. placeholder {1}: detail.cycleCount ?? '-'
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:195
msgid "{0} · {1} 期"
msgstr "{0} · {1} 期"

#. placeholder {0}: viewTarget?.treeName || ''
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:308
msgid "{0} · 樹上位置"
msgstr "{0} · 樹上位置"

#. placeholder {0}: lot.distance
#. placeholder {1}: lot.walkMinutes
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:140
msgid "{0} · 步行 {1} 分鐘"
msgstr "{0} · 步行 {1} 分鐘"

#. placeholder {0}: treeName || '-'
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:139
msgid "{0} · 選擇掛接節點"
msgstr "{0} · 選擇掛接節點"

#. placeholder {0}: tt.tableTypeName
#. placeholder {1}: tt.inventory
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:368
msgid "{0} ({1}桌)"
msgstr "{0} ({1}桌)"

#. placeholder {0}: l.levelThree
#. placeholder {1}: l.id
#. placeholder {2}: l.merchantCount
#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:181
msgid "{0} (ID: {1}, 商家: {2})"
msgstr "{0} (ID: {1}, 商家: {2})"

#. placeholder {0}: item.platformDiscount
#. placeholder {1}: item.platformLimit
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/SubsidyCard.tsx:69
msgid "{0} (補貼上限：{1})"
msgstr "{0} (補貼上限：{1})"

#. placeholder {0}: import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'; import { t } from '@lingui/core/macro'; import type { UploadFile } from 'antd'; import { Button, Image, Input, message, Radio, Steps } from 'antd'; import React, { useEffect, useRef, useState } from 'react'; import ImageUpload from '@/components/ImageUpload'; import { useIsMobile } from '@/modules/hooks/useResponsive'; import { resolveStaticImageSrc } from '@/utils/common'; import bus1Img from '../../merchant-decoration/services/imgs/bus1.png'; import bus2Img from '../../merchant-decoration/services/imgs/bus2.png'; import bus3Img from '../../merchant-decoration/services/imgs/bus3.png'; import drive1Img from '../../merchant-decoration/services/imgs/drive1.png'; import drive2Img from '../../merchant-decoration/services/imgs/drive2.png'; import drive3Img from '../../merchant-decoration/services/imgs/drive3.png'; import finalShopImg from '../../merchant-decoration/services/imgs/finalShop.png'; import transit1Img from '../../merchant-decoration/services/imgs/transit1.png'; import transit2Img from '../../merchant-decoration/services/imgs/transit2.png'; import transit3Img from '../../merchant-decoration/services/imgs/transit3.png'; import type { ArrivalGuideData } from '../../shared/interface'; import { ArrivalGuideModeType } from '../../shared/interface'; const { TextArea } = Input; interface ArrivalGuideSectionProps { arrivalGuide?: ArrivalGuideData; onChange: (data: ArrivalGuideData) => void; } const MODE_CONFIGS: { type: ArrivalGuideModeType; label: string }[] = [ { type: ArrivalGuideModeType.DRIVING, label: t`開車到店` }, { type: ArrivalGuideModeType.METRO, label: t`捷運到店` }, { type: ArrivalGuideModeType.BUS, label: t`公車到店` }, ]; interface ExampleStepConfig { title: string; description: string; /** * 示例圖片資源，可以是 webpack 的字串 URL、Expo 的資源ID 或帶 uri 的對象 */ image: unknown; } const EXAMPLE_STEPS: Record<ArrivalGuideModeType, ExampleStepConfig[]> = { [ArrivalGuideModeType.DRIVING]: [ { title: t`第一步`, description: t`車輛行駛至路口，指示牌顯示「大熊美食餐廳停車場由此進」，道路旁有小熊造型路燈。`, image: drive1Img, }, { title: t`第二步`, description: t`停車場內車輛停放整齊，出口處有「餐廳入口→」的指示箭頭，旁邊有卡通指示牌。`, image: drive2Img, }, { title: t`第三步`, description: t`顧客穿過裝飾有餐廳海報的樓道，地面有引導腳印貼紙，兩側掛著食物卡通畫。`, image: drive3Img, }, { title: t`第四步`, description: t`餐廳門口有旋轉門和歡迎牌，門口站著戴廚師帽的小熊玩偶，上方有餐廳招牌。`, image: finalShopImg, }, ], [ArrivalGuideModeType.METRO]: [ { title: t`第一步`, description: t`捷運站出口處，指示牌顯示「大熊美食餐廳由此出」，旁邊有小熊指示箭頭。`, image: transit1Img, }, { title: t`第二步`, description: t`從捷運站出來後，街道旁有「餐廳方向→」的路牌，配有小熊圖案。`, image: transit2Img, }, { title: t`第三步`, description: t`沿著街道走到十字路口，紅綠燈旁有「餐廳左轉」的小熊指示牌。`, image: transit3Img, }, { title: t`第四步`, description: t`餐廳門口有旋轉門和歡迎牌，門口站著戴廚師帽的小熊玩偶，上方有餐廳招牌。`, image: finalShopImg, }, ], [ArrivalGuideModeType.BUS]: [ { title: t`第一步`, description: t`公車站牌顯示 “大熊美食餐廳站”，站牌旁有小熊圖案和路線圖。`, image: bus1Img, }, { title: t`第二步`, description: t`公車到站後，乘客從車門走出，站臺旁有 “餐廳方向→” 指示牌。`, image: bus2Img, }, { title: t`第三步`, description: t`沿著人行道前行，十字路口處有 “餐廳直行” 的小熊指示牌。`, image: bus3Img, }, { title: t`第四步`, description: t`餐廳門口有旋轉門和歡迎牌，門口站著戴廚師帽的小熊玩偶，上方有餐廳招牌。`, image: finalShopImg, }, ], }; function createEmptyGuide(): ArrivalGuideData { return { exampleAcknowledged: false, modes: MODE_CONFIGS.map((cfg) => ({ mode: cfg.type, label: cfg.label, enabled: true, steps: [], })), }; } const ArrivalGuideSection: React.FC<ArrivalGuideSectionProps> = ({ arrivalGuide, onChange, }) => { const [viewMode, setViewMode] = useState<'EXAMPLE' | 'EDIT'>('EXAMPLE'); const [activeMode, setActiveMode] = useState<ArrivalGuideModeType>( ArrivalGuideModeType.DRIVING ); const isMobile = useIsMobile(); const initializedRef = useRef(false); const guide: ArrivalGuideData = arrivalGuide ?? createEmptyGuide(); useEffect(() => { if (initializedRef.current) return; const hasSteps = guide.modes.some((m) => m.steps.length > 0); if (guide.exampleAcknowledged || hasSteps) { setViewMode('EDIT'); } initializedRef.current = true; }, [guide]); const updateGuide = (next: ArrivalGuideData) => { onChange(next); }; const updateSteps = ( modeType: ArrivalGuideModeType, updater: ( steps: (typeof guide.modes)[0]['steps'] ) => (typeof guide.modes)[0]['steps'] ) => { const modes = guide.modes.map((mode) => mode.mode === modeType ? { ...mode, steps: updater(mode.steps) } : mode ); updateGuide({ ...guide, exampleAcknowledged: true, modes }); setViewMode('EDIT'); }; const handleAddStep = (modeType: ArrivalGuideModeType) => { // 檢查當前交通方式的步驟數量 const currentMode = guide.modes.find((m) => m.mode === modeType); const currentStepCount = currentMode?.steps.length || 0; // 最多隻能添加10步 if (currentStepCount >= 10) { message.warning(t`每種交通方式最多隻能添加10個步驟`); return; } updateSteps(modeType, (steps) => [ ...steps, { id: `${modeType}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, description: '', imageUrl: undefined, }, ]); }; const handleDeleteStep = (modeType: ArrivalGuideModeType, stepId: string) => { updateSteps(modeType, (steps) => steps.filter((s) => s.id !== stepId)); }; const handleStepDescriptionChange = ( modeType: ArrivalGuideModeType, stepId: string, value: string ) => { updateSteps(modeType, (steps) => steps.map((s) => (s.id === stepId ? { ...s, description: value } : s)) ); }; const handleStepImageChange = ( modeType: ArrivalGuideModeType, stepId: string, fileList: UploadFile[] ) => { const firstFile = fileList[0]; const response = firstFile?.response as { url?: string } | undefined; const url = typeof firstFile?.url === 'string' ? firstFile.url : typeof response?.url === 'string' ? response.url : undefined; updateSteps(modeType, (steps) => steps.map((s) => (s.id === stepId ? { ...s, imageUrl: url } : s)) ); }; const handleAcknowledgeExample = () => { setViewMode('EDIT'); updateGuide({ ...guide, exampleAcknowledged: true }); }; const renderExampleCard = (mode: (typeof MODE_CONFIGS)[0]) => { const steps = EXAMPLE_STEPS[mode.type] || []; return ( <div key={mode.type} className="bg-white border border-gray-200 rounded-lg p-4 space-y-3 flex flex-col" > <div className="text-sm font-medium text-gray-900 text-center"> {mode.label} </div> <div className="text-xs text-gray-500 text-center mb-2"> {t`以下為示範路線，實際到店方式可依店家所在地調整。`} </div> <Steps direction="vertical" size="small" current={3} items={steps.map((step) => ({ title: step.title, description: ( <div className="space-y-2"> <div className="text-[11px] text-gray-600 leading-snug"> {step.description} </div> <Image src={resolveStaticImageSrc(step.image)} alt={step.title} className="w-full h-28 object-cover rounded-md" preview /> </div> ), }))} /> </div> ); }; const renderExampleView = () => { const activeModeConfig = MODE_CONFIGS.find((m) => m.type === activeMode); return ( <div className="space-y-4"> {/* 頂部條 */} <div className="bg-lime-400 rounded-lg p-4 flex items-center justify-between"> <div className="text-sm font-medium text-gray-900"> {t`以下是到店指引的示範`} </div> <Button type="primary" size="small" onClick={handleAcknowledgeExample} > {isMobile ? t`開始填寫` : t`我已知道，開始填寫`} </Button> </div> {/* 移動端：Radio 切換 */} {isMobile && ( <div className="space-y-4 text-center"> <div className="mb-3"> <Radio.Group value={activeMode} onChange={(e) => setActiveMode(e.target.value as ArrivalGuideModeType) } > {MODE_CONFIGS.map((mode) => ( <Radio.Button key={mode.type} value={mode.type}> {mode.label} </Radio.Button> ))} </Radio.Group> </div> {activeModeConfig && renderExampleCard(activeModeConfig)} </div> )} {/* 桌面端：三卡片並排 */} {!isMobile && ( <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1rem', }} > {MODE_CONFIGS.map((mode) => renderExampleCard(mode))} </div> )} </div> ); }; const renderEditCard = (mode: (typeof guide.modes)[0], key?: string) => { const fileListMap: Record<string, UploadFile[]> = {}; mode.steps.forEach((step) => { if (step.imageUrl) { fileListMap[step.id] = [ { uid: step.id, name: t`步驟圖片`, status: 'done', url: step.imageUrl, }, ]; } }); return ( <div key={key || mode.mode} className="bg-white border border-gray-200 rounded-lg p-4 space-y-3" > <div className="text-sm font-medium text-gray-900 text-center"> {mode.label || MODE_CONFIGS.find((m) => m.type === mode.mode)?.label} </div> {mode.steps.length === 0 && ( <div className="text-xs text-gray-400 text-center"> {t`目前尚未添加步驟，可點擊下方按鈕新增。`} </div> )} {mode.steps.length > 0 && ( <Steps className="arrival-guide-steps-edit" direction="vertical" size="small" current={mode.steps.length - 1} items={mode.steps.map((step, index) => { const fileList = fileListMap[step.id] || []; return { title: ( <div className="flex items-center justify-between w-full"> <span className="whitespace-nowrap"> {t`${t`第`} ${index + 1} ${t`步`}`} </span> <Button type="text" size="small" danger icon={<DeleteOutlined />} onClick={() => handleDeleteStep(mode.mode, step.id)} /> </div> ), description: ( <div className="space-y-2"> <TextArea rows={3} maxLength={500} showCount placeholder={t`請輸入此步驟的到店說明`} value={step.description} onChange={(e) => handleStepDescriptionChange( mode.mode, step.id, e.target.value ) } /> <div className="flex items-center gap-3"> <ImageUpload fileList={fileList} onChange={(newFileList) => handleStepImageChange(mode.mode, step.id, newFileList) } businessType="arrival_guide" maxCount={1} maxSize={5} acceptedTypes={['image/jpeg', 'image/png']} uploadText={step.imageUrl ? t`重新上傳` : t`上傳圖片`} listType="picture-card" showUploadList /> </div> </div> ), }; })} /> )} <Button type="dashed" block icon={<PlusOutlined />} onClick={() => handleAddStep(mode.mode)} disabled={mode.steps.length >= 10} > {mode.steps.length >= 10 ? t`已達到最大步驟數（10步）` : t`新增步驟`} </Button> </div> ); }; const renderEditView = () => { const activeModeData = guide.modes.find((m) => m.mode === activeMode); return ( <div className="space-y-4"> <div className="flex items-center justify-between"> <h4 className="text-base font-medium text-gray-900"> {t`編輯到店指引`} </h4> <Button type="link" size="small" onClick={() => setViewMode('EXAMPLE')} > {t`查看示範`} </Button> </div> {/* 移動端：Radio 切換 */} {isMobile && ( <div className="space-y-4"> <Radio.Group value={activeMode} onChange={(e) => setActiveMode(e.target.value as ArrivalGuideModeType) } > {MODE_CONFIGS.map((mode) => ( <Radio key={mode.type} value={mode.type}> {mode.label} </Radio> ))} </Radio.Group> {activeModeData && renderEditCard(activeModeData)} </div> )} {/* 桌面端：三卡片並排 */} {!isMobile && ( <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1rem', }} > {guide.modes.map((mode) => renderEditCard(mode, mode.mode))} </div> )} </div> ); }; return ( <div className="space-y-4"> {viewMode === 'EXAMPLE' ? renderExampleView() : renderEditView()} </div> ); }; export default ArrivalGuideSection; 
#. placeholder {1}: index + 1
#. placeholder {2}: import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'; import { t } from '@lingui/core/macro'; import type { UploadFile } from 'antd'; import { Button, Image, Input, message, Radio, Steps } from 'antd'; import React, { useEffect, useRef, useState } from 'react'; import ImageUpload from '@/components/ImageUpload'; import { useIsMobile } from '@/modules/hooks/useResponsive'; import { resolveStaticImageSrc } from '@/utils/common'; import bus1Img from '../../merchant-decoration/services/imgs/bus1.png'; import bus2Img from '../../merchant-decoration/services/imgs/bus2.png'; import bus3Img from '../../merchant-decoration/services/imgs/bus3.png'; import drive1Img from '../../merchant-decoration/services/imgs/drive1.png'; import drive2Img from '../../merchant-decoration/services/imgs/drive2.png'; import drive3Img from '../../merchant-decoration/services/imgs/drive3.png'; import finalShopImg from '../../merchant-decoration/services/imgs/finalShop.png'; import transit1Img from '../../merchant-decoration/services/imgs/transit1.png'; import transit2Img from '../../merchant-decoration/services/imgs/transit2.png'; import transit3Img from '../../merchant-decoration/services/imgs/transit3.png'; import type { ArrivalGuideData } from '../../shared/interface'; import { ArrivalGuideModeType } from '../../shared/interface'; const { TextArea } = Input; interface ArrivalGuideSectionProps { arrivalGuide?: ArrivalGuideData; onChange: (data: ArrivalGuideData) => void; } const MODE_CONFIGS: { type: ArrivalGuideModeType; label: string }[] = [ { type: ArrivalGuideModeType.DRIVING, label: t`開車到店` }, { type: ArrivalGuideModeType.METRO, label: t`捷運到店` }, { type: ArrivalGuideModeType.BUS, label: t`公車到店` }, ]; interface ExampleStepConfig { title: string; description: string; /** * 示例圖片資源，可以是 webpack 的字串 URL、Expo 的資源ID 或帶 uri 的對象 */ image: unknown; } const EXAMPLE_STEPS: Record<ArrivalGuideModeType, ExampleStepConfig[]> = { [ArrivalGuideModeType.DRIVING]: [ { title: t`第一步`, description: t`車輛行駛至路口，指示牌顯示「大熊美食餐廳停車場由此進」，道路旁有小熊造型路燈。`, image: drive1Img, }, { title: t`第二步`, description: t`停車場內車輛停放整齊，出口處有「餐廳入口→」的指示箭頭，旁邊有卡通指示牌。`, image: drive2Img, }, { title: t`第三步`, description: t`顧客穿過裝飾有餐廳海報的樓道，地面有引導腳印貼紙，兩側掛著食物卡通畫。`, image: drive3Img, }, { title: t`第四步`, description: t`餐廳門口有旋轉門和歡迎牌，門口站著戴廚師帽的小熊玩偶，上方有餐廳招牌。`, image: finalShopImg, }, ], [ArrivalGuideModeType.METRO]: [ { title: t`第一步`, description: t`捷運站出口處，指示牌顯示「大熊美食餐廳由此出」，旁邊有小熊指示箭頭。`, image: transit1Img, }, { title: t`第二步`, description: t`從捷運站出來後，街道旁有「餐廳方向→」的路牌，配有小熊圖案。`, image: transit2Img, }, { title: t`第三步`, description: t`沿著街道走到十字路口，紅綠燈旁有「餐廳左轉」的小熊指示牌。`, image: transit3Img, }, { title: t`第四步`, description: t`餐廳門口有旋轉門和歡迎牌，門口站著戴廚師帽的小熊玩偶，上方有餐廳招牌。`, image: finalShopImg, }, ], [ArrivalGuideModeType.BUS]: [ { title: t`第一步`, description: t`公車站牌顯示 “大熊美食餐廳站”，站牌旁有小熊圖案和路線圖。`, image: bus1Img, }, { title: t`第二步`, description: t`公車到站後，乘客從車門走出，站臺旁有 “餐廳方向→” 指示牌。`, image: bus2Img, }, { title: t`第三步`, description: t`沿著人行道前行，十字路口處有 “餐廳直行” 的小熊指示牌。`, image: bus3Img, }, { title: t`第四步`, description: t`餐廳門口有旋轉門和歡迎牌，門口站著戴廚師帽的小熊玩偶，上方有餐廳招牌。`, image: finalShopImg, }, ], }; function createEmptyGuide(): ArrivalGuideData { return { exampleAcknowledged: false, modes: MODE_CONFIGS.map((cfg) => ({ mode: cfg.type, label: cfg.label, enabled: true, steps: [], })), }; } const ArrivalGuideSection: React.FC<ArrivalGuideSectionProps> = ({ arrivalGuide, onChange, }) => { const [viewMode, setViewMode] = useState<'EXAMPLE' | 'EDIT'>('EXAMPLE'); const [activeMode, setActiveMode] = useState<ArrivalGuideModeType>( ArrivalGuideModeType.DRIVING ); const isMobile = useIsMobile(); const initializedRef = useRef(false); const guide: ArrivalGuideData = arrivalGuide ?? createEmptyGuide(); useEffect(() => { if (initializedRef.current) return; const hasSteps = guide.modes.some((m) => m.steps.length > 0); if (guide.exampleAcknowledged || hasSteps) { setViewMode('EDIT'); } initializedRef.current = true; }, [guide]); const updateGuide = (next: ArrivalGuideData) => { onChange(next); }; const updateSteps = ( modeType: ArrivalGuideModeType, updater: ( steps: (typeof guide.modes)[0]['steps'] ) => (typeof guide.modes)[0]['steps'] ) => { const modes = guide.modes.map((mode) => mode.mode === modeType ? { ...mode, steps: updater(mode.steps) } : mode ); updateGuide({ ...guide, exampleAcknowledged: true, modes }); setViewMode('EDIT'); }; const handleAddStep = (modeType: ArrivalGuideModeType) => { // 檢查當前交通方式的步驟數量 const currentMode = guide.modes.find((m) => m.mode === modeType); const currentStepCount = currentMode?.steps.length || 0; // 最多隻能添加10步 if (currentStepCount >= 10) { message.warning(t`每種交通方式最多隻能添加10個步驟`); return; } updateSteps(modeType, (steps) => [ ...steps, { id: `${modeType}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`, description: '', imageUrl: undefined, }, ]); }; const handleDeleteStep = (modeType: ArrivalGuideModeType, stepId: string) => { updateSteps(modeType, (steps) => steps.filter((s) => s.id !== stepId)); }; const handleStepDescriptionChange = ( modeType: ArrivalGuideModeType, stepId: string, value: string ) => { updateSteps(modeType, (steps) => steps.map((s) => (s.id === stepId ? { ...s, description: value } : s)) ); }; const handleStepImageChange = ( modeType: ArrivalGuideModeType, stepId: string, fileList: UploadFile[] ) => { const firstFile = fileList[0]; const response = firstFile?.response as { url?: string } | undefined; const url = typeof firstFile?.url === 'string' ? firstFile.url : typeof response?.url === 'string' ? response.url : undefined; updateSteps(modeType, (steps) => steps.map((s) => (s.id === stepId ? { ...s, imageUrl: url } : s)) ); }; const handleAcknowledgeExample = () => { setViewMode('EDIT'); updateGuide({ ...guide, exampleAcknowledged: true }); }; const renderExampleCard = (mode: (typeof MODE_CONFIGS)[0]) => { const steps = EXAMPLE_STEPS[mode.type] || []; return ( <div key={mode.type} className="bg-white border border-gray-200 rounded-lg p-4 space-y-3 flex flex-col" > <div className="text-sm font-medium text-gray-900 text-center"> {mode.label} </div> <div className="text-xs text-gray-500 text-center mb-2"> {t`以下為示範路線，實際到店方式可依店家所在地調整。`} </div> <Steps direction="vertical" size="small" current={3} items={steps.map((step) => ({ title: step.title, description: ( <div className="space-y-2"> <div className="text-[11px] text-gray-600 leading-snug"> {step.description} </div> <Image src={resolveStaticImageSrc(step.image)} alt={step.title} className="w-full h-28 object-cover rounded-md" preview /> </div> ), }))} /> </div> ); }; const renderExampleView = () => { const activeModeConfig = MODE_CONFIGS.find((m) => m.type === activeMode); return ( <div className="space-y-4"> {/* 頂部條 */} <div className="bg-lime-400 rounded-lg p-4 flex items-center justify-between"> <div className="text-sm font-medium text-gray-900"> {t`以下是到店指引的示範`} </div> <Button type="primary" size="small" onClick={handleAcknowledgeExample} > {isMobile ? t`開始填寫` : t`我已知道，開始填寫`} </Button> </div> {/* 移動端：Radio 切換 */} {isMobile && ( <div className="space-y-4 text-center"> <div className="mb-3"> <Radio.Group value={activeMode} onChange={(e) => setActiveMode(e.target.value as ArrivalGuideModeType) } > {MODE_CONFIGS.map((mode) => ( <Radio.Button key={mode.type} value={mode.type}> {mode.label} </Radio.Button> ))} </Radio.Group> </div> {activeModeConfig && renderExampleCard(activeModeConfig)} </div> )} {/* 桌面端：三卡片並排 */} {!isMobile && ( <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1rem', }} > {MODE_CONFIGS.map((mode) => renderExampleCard(mode))} </div> )} </div> ); }; const renderEditCard = (mode: (typeof guide.modes)[0], key?: string) => { const fileListMap: Record<string, UploadFile[]> = {}; mode.steps.forEach((step) => { if (step.imageUrl) { fileListMap[step.id] = [ { uid: step.id, name: t`步驟圖片`, status: 'done', url: step.imageUrl, }, ]; } }); return ( <div key={key || mode.mode} className="bg-white border border-gray-200 rounded-lg p-4 space-y-3" > <div className="text-sm font-medium text-gray-900 text-center"> {mode.label || MODE_CONFIGS.find((m) => m.type === mode.mode)?.label} </div> {mode.steps.length === 0 && ( <div className="text-xs text-gray-400 text-center"> {t`目前尚未添加步驟，可點擊下方按鈕新增。`} </div> )} {mode.steps.length > 0 && ( <Steps className="arrival-guide-steps-edit" direction="vertical" size="small" current={mode.steps.length - 1} items={mode.steps.map((step, index) => { const fileList = fileListMap[step.id] || []; return { title: ( <div className="flex items-center justify-between w-full"> <span className="whitespace-nowrap"> {t`${t`第`} ${index + 1} ${t`步`}`} </span> <Button type="text" size="small" danger icon={<DeleteOutlined />} onClick={() => handleDeleteStep(mode.mode, step.id)} /> </div> ), description: ( <div className="space-y-2"> <TextArea rows={3} maxLength={500} showCount placeholder={t`請輸入此步驟的到店說明`} value={step.description} onChange={(e) => handleStepDescriptionChange( mode.mode, step.id, e.target.value ) } /> <div className="flex items-center gap-3"> <ImageUpload fileList={fileList} onChange={(newFileList) => handleStepImageChange(mode.mode, step.id, newFileList) } businessType="arrival_guide" maxCount={1} maxSize={5} acceptedTypes={['image/jpeg', 'image/png']} uploadText={step.imageUrl ? t`重新上傳` : t`上傳圖片`} listType="picture-card" showUploadList /> </div> </div> ), }; })} /> )} <Button type="dashed" block icon={<PlusOutlined />} onClick={() => handleAddStep(mode.mode)} disabled={mode.steps.length >= 10} > {mode.steps.length >= 10 ? t`已達到最大步驟數（10步）` : t`新增步驟`} </Button> </div> ); }; const renderEditView = () => { const activeModeData = guide.modes.find((m) => m.mode === activeMode); return ( <div className="space-y-4"> <div className="flex items-center justify-between"> <h4 className="text-base font-medium text-gray-900"> {t`編輯到店指引`} </h4> <Button type="link" size="small" onClick={() => setViewMode('EXAMPLE')} > {t`查看示範`} </Button> </div> {/* 移動端：Radio 切換 */} {isMobile && ( <div className="space-y-4"> <Radio.Group value={activeMode} onChange={(e) => setActiveMode(e.target.value as ArrivalGuideModeType) } > {MODE_CONFIGS.map((mode) => ( <Radio key={mode.type} value={mode.type}> {mode.label} </Radio> ))} </Radio.Group> {activeModeData && renderEditCard(activeModeData)} </div> )} {/* 桌面端：三卡片並排 */} {!isMobile && ( <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1rem', }} > {guide.modes.map((mode) => renderEditCard(mode, mode.mode))} </div> )} </div> ); }; return ( <div className="space-y-4"> {viewMode === 'EXAMPLE' ? renderExampleView() : renderEditView()} </div> ); }; export default ArrivalGuideSection; 
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:358
msgid "{0} {1} {2}"
msgstr "{0} {1} {2}"

#. placeholder {0}: agentStatus?.currentTicketCount ?? 0
#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:83
msgid "{0} / 不限制"
msgstr "{0} / 不限制"

#. placeholder {0}: log.fromStatusName
#. placeholder {1}: log.toStatusName
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:576
msgid "{0} → {1}"
msgstr "{0} → {1}"

#. placeholder {0}: dish.name
#. placeholder {1}: dish.quantity
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PreviewCard.tsx:92
msgid "{0} x{1}"
msgstr "{0} x{1}"

#. placeholder {0}: data.diningPeopleMin
#. placeholder {0}: d.minPeople
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:339
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:437
msgid "{0} 人"
msgstr "{0} 人"

#. placeholder {0}: failedIds.length
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/FixedPackageImportField/index.web.tsx:207
msgid "{0} 個ID導入失敗"
msgstr "{0} 個ID導入失敗"

#. placeholder {0}: benefit.packageCount
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:165
msgid "{0} 個套餐"
msgstr "{0} 個套餐"

#. placeholder {0}: summary.structureNodeCount
#. placeholder {0}: summary.merchantChangeCount
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:52
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:56
msgid "{0} 個節點"
msgstr "{0} 個節點"

#. placeholder {0}: dayjs(coupon.validEndTime).format(`YYYY/MM/DD`)
#: apps/dp-client/src/components/CouponCard/index.tsx:281
msgid "{0} 到期"
msgstr "{0} 到期"

#. placeholder {0}: start.format('YYYY/MM/DD HH:mm:ss')
#. placeholder {0}: startTime.format('YYYY/MM/DD HH:mm:ss')
#: apps/dp-client/src/components/CouponCard/index.tsx:299
#: apps/dp-client/src/components/CouponCard/index.tsx:412
msgid "{0} 可用"
msgstr "{0} 可用"

#. placeholder {0}: file.name
#: apps/dp-admin/src/components/ImageListUploader/index.web.tsx:192
msgid "{0} 大小超過 {maxSize}MB"
msgstr "{0} 大小超過 {maxSize}MB"

#. placeholder {0}: item.coveredShopCount
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:188
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:483
msgid "{0} 家"
msgstr "{0} 家"

#. placeholder {0}: dayjs(coupon.usedTime).format('YYYY/MM/DD HH:mm:ss')
#: apps/dp-client/src/components/CouponCard/index.tsx:287
msgid "{0} 已使用"
msgstr "{0} 已使用"

#. placeholder {0}: dayjs(coupon.validEndTime).format('YYYY/MM/DD HH:mm:ss')
#: apps/dp-client/src/components/CouponCard/index.tsx:289
msgid "{0} 已過期"
msgstr "{0} 已過期"

#. placeholder {0}: imageUrls.length
#. placeholder {0}: item.settlementOrderCount
#. placeholder {0}: value || 0
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:289
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:173
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:241
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:246
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:380
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:255
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:261
msgid "{0} 張"
msgstr "{0} 張"

#. placeholder {0}: detail.successCount
#. placeholder {1}: detail.failedCount
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:504
msgid "{0} 成功 / {1} 失敗"
msgstr "{0} 成功 / {1} 失敗"

#. placeholder {0}: bdInfo.accountName
#: apps/dp-business/src/pages/ContactBD/index.tsx:162
msgid "{0} 為您服務"
msgstr "{0} 為您服務"

#. placeholder {0}: import { t } from '@lingui/core/macro'; import React from 'react'; import { html } from 'react-strict-dom'; import { tw } from 'react-strict-dom-tailwind'; import { showStandardModal } from '@/services'; import { businessThemeColors, iconColorMap } from '@/theme/colors'; import type { PoiItem } from './PoiList'; interface PoiConfirmModalProps { /** * 是否顯示模態框 */ visible: boolean; /** * 選中的POI */ poi: PoiItem | null; /** * 確認按鈕回調 */ onConfirm: () => void; /** * 取消按鈕回調 */ onCancel: () => void; /** * 手動添加按鈕回調 */ onManualAdd: () => void; } /** * POI確認模態框組件 * 用於確認選擇的POI */ const PoiConfirmModal: React.FC<PoiConfirmModalProps> = ({ visible, poi, onConfirm, onCancel, onManualAdd, }) => { if (!visible || !poi) { return null; } return ( <html.div style={tw( 'fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50' )} > <html.div style={tw('bg-white rounded-lg shadow-xl w-full max-w-sm mx-4')} > {/* 標題 */} <html.div style={tw('px-4 py-3 border-b border-gray-200')}> <html.h3 style={tw('text-lg font-medium text-gray-900')} >{t`${t`使用Google Map搜尋`} 的位置信息`}</html.h3> </html.div> {/* 內容 */} <html.div style={tw('px-4 py-3')}> <html.p style={tw('text-sm text-gray-500 mb-2')} >{t`以下是本系統的建議：`}</html.p> <html.div style={tw('bg-gray-100 p-3 rounded-md')}> <html.p style={tw('text-sm font-medium')}>{poi.name}</html.p> <html.p style={tw('text-xs text-gray-500 mt-1')}> {poi.address} </html.p> </html.div> </html.div> {/* 按鈕 */} <html.div style={tw( 'px-4 py-3 bg-gray-50 flex flex-col space-y-2 rounded-b-lg' )} > <html.button type="button" onClick={onConfirm} style={tw( `w-full py-2 text-sm font-medium text-white bg-[${businessThemeColors.bgPrimary}] border border-transparent rounded-md ` )} >{t`確定`}</html.button> <html.button type="button" onClick={onCancel} style={tw( 'w-full py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md ' )} >{t`取消`}</html.button> <html.button type="button" onClick={onManualAdd} style={tw( `w-full py-2 text-sm font-medium color-[${iconColorMap.active}] bg-white border border-color-[${businessThemeColors.borderBrand}] rounded-md ` )} >{t`手動新增`}</html.button> </html.div> </html.div> </html.div> ); }; /** * 使用全局Modal系統顯示POI確認對話框 * 這是新的推薦方式，無需在組件中維護Modal狀態 */ export const showPoiConfirmModal = async ( poi: PoiItem, onConfirm: () => void, onManualAdd: () => void ): Promise<'confirm' | 'manual' | 'cancel'> => { return new Promise((resolve) => { const content = ( <html.div> <html.p style={tw('text-sm text-gray-500 mb-3')} >{t`以下是本系統的建議：`}</html.p> <html.div style={tw('bg-gray-100 p-3 rounded-md')}> <html.p style={tw('text-sm font-medium')}>{poi.name}</html.p> <html.p style={tw('text-xs text-gray-500 mt-1')}> {poi.address} </html.p> </html.div> <html.div style={tw('mt-4 space-y-2')}> <html.button type="button" onClick={() => { onConfirm(); resolve('confirm'); }} style={tw( `w-full py-2 text-sm font-medium text-white bg-[${businessThemeColors.bgPrimary}] border border-transparent rounded-md ` )} >{t`確定`}</html.button> <html.button type="button" onClick={() => { onManualAdd(); resolve('manual'); }} style={tw( `w-full py-2 text-sm font-medium color-[${iconColorMap.active}] bg-white border border-color-[${businessThemeColors.borderBrand}] rounded-md ` )} >{t`手動新增`}</html.button> </html.div> </html.div> ); showStandardModal(t`使用Google Map搜索 ${poi.name} 的位置信息`, content, { showFooter: false, width: '90%', closeOnOverlayClick: true, }).then(() => { resolve('cancel'); }); }); }; export default PoiConfirmModal; 
#: apps/dp-business/src/pages/AddStore/components/PoiConfirmModal.tsx:62
msgid "{0} 的位置信息"
msgstr "{0} 的位置資訊"

#. placeholder {0}: countdown.seconds
#. placeholder {1}: sendCount > 0 ? t`重新` : ''
#: apps/dp-client/src/components/verify-code-sender/index.tsx:185
msgid "{0} 秒後{1}獲取驗證碼"
msgstr "{0} 秒後{1}獲取驗證碼"

#. placeholder {0}: formatExchangeRate(rate)
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:62
msgid "{0} 積分 / 1 元"
msgstr "{0} 積分 / 1 元"

#. placeholder {0}: resp.successShops || 0
#. placeholder {1}: resp.failedShopCount || 0
#: apps/dp-business/src/pages/UserManagement/BatchCopyUsers.tsx:82
msgid "{0} 筆成功，{1} 筆失敗"
msgstr "{0} 筆成功，{1} 筆失敗"

#. placeholder {0}: formatDate(record.validStartTime)
#. placeholder {1}: formatDate(value)
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:338
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:380
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:410
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:440
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:308
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:360
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:400
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:440
msgid "{0} 至 {1}"
msgstr "{0} 至 {1}"

#. placeholder {0}: err.period1
#. placeholder {1}: err.period2
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:730
msgid "{0} 與 {1}"
msgstr "{0} 與 {1}"

#. placeholder {0}: getNextOpenTime(hoursData)
#: apps/dp-client/src/utils/businessStatus.ts:203
msgid "{0} 開始營業"
msgstr "{0} 開始營業"

#. placeholder {0}: businessStatus.nextOpenTime
#. placeholder {0}: getNextOpenTime(hoursData)
#: apps/dp-client/src/utils/businessStatus.ts:230
#: apps/dp-client/src/utils/businessStatus.ts:232
msgid "{0} 開門"
msgstr "{0} 開門"

#. placeholder {0}: summary.bindingCount
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:54
msgid "{0} 項"
msgstr "{0} 項"

#. placeholder {0}: data.diningPeopleMin
#. placeholder {0}: d.minPeople
#. placeholder {1}: data.diningPeopleMax
#. placeholder {1}: d.maxPeople
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:340
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:438
msgid "{0}-{1} 人"
msgstr "{0}-{1} 人"

#. placeholder {0}: table.minCapacity
#. placeholder {0}: data.diningPeopleMin
#. placeholder {0}: record.minPeople
#. placeholder {1}: table.maxCapacity
#. placeholder {1}: data.diningPeopleMax
#. placeholder {1}: record.maxPeople
#: apps/dp-business/src/pages/TableManagement/index.tsx:942
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:939
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:205
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:225
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:257
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:250
msgid "{0}-{1}人"
msgstr "{0}-{1}人"

#. placeholder {0}: tableType.minCapacity
#. placeholder {1}: tableType.maxCapacity
#: apps/dp-client/src/screens/reservation/pages/main/components/SeatTypeSelector.tsx:81
msgid "{0}-{1}人可訂"
msgstr "{0}-{1}人可訂"

#. placeholder {0}: table.minCapacity
#. placeholder {1}: table.maxCapacity
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:591
msgid "{0}-{1}人桌"
msgstr "{0}-{1}人桌"

#. placeholder {0}: detail.name
#. placeholder {0}: detailB.name
#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:373
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:732
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:857
msgid "{0}-副本"
msgstr "{0}-副本"

#. placeholder {0}: record.name
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:288
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:151
msgid "{0}-動態圖片"
msgstr "{0}-動態圖片"

#. placeholder {0}: record.name
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:273
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:136
msgid "{0}-靜態圖片"
msgstr "{0}-靜態圖片"

#. placeholder {0}: DAY_NAMES[index]
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:100
msgid "{0}: 24小時營業"
msgstr "{0}: 24小時營業"

#. placeholder {0}: DAY_NAMES[index]
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:98
msgid "{0}: 休息"
msgstr "{0}: 休息"

#. placeholder {0}: channel.channelName || t`渠道`
#. placeholder {1}: channel.id
#. placeholder {2}: channel.level
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignChannelFields/index.web.tsx:49
msgid "{0}（{1} · L{2}）"
msgstr "{0}（{1} · L{2}）"

#. placeholder {0}: item.name
#. placeholder {1}: item.population
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:250
msgid "{0}({avgStars}星) {1} ( {percentage}%)"
msgstr "{0}({avgStars}星) {1} ( {percentage}%)"

#. placeholder {0}: cat.name
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:418
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:497
msgid "{0}(0個餐點)"
msgstr "{0}(0個餐點)"

#. placeholder {0}: option.benefitName
#. placeholder {1}: option.benefitId
#. placeholder {2}: option.couponType === ChannelCampaignCouponType.PERCENT_DISCOUNT ? `${(option.discountRate || 0) * 10} 折` : `${option.maximumDiscount ?? '-'} 元`
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/BenefitPicker/index.web.tsx:17
msgid "{0}（ID {1}） · {2}"
msgstr "{0}（ID {1}） · {2}"

#. placeholder {0}: userPoints?.nickname || ''
#. placeholder {0}: currentUserRank?.nickname || ''
#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:200
#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:215
msgid "{0}（我）"
msgstr "{0}（我）"

#. placeholder {0}: item.quantity
#. placeholder {1}: import { useNavigation, useRouteParams } from '@dp-frontend/navigation'; import { request } from '@dp-frontend/request'; import { t } from '@lingui/core/macro'; import { Trans } from '@lingui/react/macro'; import React, { useEffect, useRef, useState } from 'react'; import { html } from 'react-strict-dom'; import { tw } from 'react-strict-dom-tailwind'; import Countdown from '@/components/Countdown'; import DeleteModal from '@/components/Modal/DeleteModal'; import StandardModal from '@/components/Modal/StandardModal'; import Tooltip from '@/components/Tooltip'; import { PERMISSIONS } from '@/constants/permissions'; import useDeviceType from '@/hooks/useDeviceType'; import { showToast } from '@/services'; import { showConfirm } from '@/services/modal'; import { businessThemeColors } from '@/theme/colors'; import { CURRENCY_SYMBOL, formatCurrency } from '@/utils/currency'; import { handleErrorWithToast } from '@/utils/errorHandler'; import { hasPermissionCode } from '@/utils/permissionUtils'; import Button from '../../components/Button'; import Card from '../../components/Card'; import Container from '../../components/Layout/Container'; import Loading from '../../components/Loading'; import { PermissionWrapper } from '../../components/Permission'; import Table, { type TableColumn } from '../../components/Table'; import Text from '../../components/Text'; import type { CouponCodeStatus, CouponOperationLog, MerchantDiscountPaymentRefundDTO, MerchantSetMealRefundDTO, OrderCommissionRateVO, OrderRefundVO, OrderUsedCouponSummaryVO, ReverseVerificationOrderDTO, } from '../../servers/order'; import { CommissionRateSourceType, getCouponStatusStyle, getCouponStatusText, getCouponStatusType, getOrderCommissionRates, getOrderCoupons, getOrderStatusColor, getOrderStatusText, getOrderUsedCoupons, OrderStatus, OrderType, refundDiscountPaymentOrder, refundSetMealOrder, RefundStatus, reverseVerificationOrder, } from '../../servers/order'; import { formatFromLocalDateTime, maskCouponCode, maskPhoneNumber, } from '../../utils/format'; import { getMerchantId, getShopId } from '../../utils/tokenManager'; import { getUserId } from '../../utils/user'; import DetailAmountBlocks, { type DetailAmountItem, } from '../OrderDetails/components/DetailAmountBlocks'; import DetailSection, { DetailRow, } from '../OrderDetails/components/DetailSection'; import StatusTag from '../OrderDetails/components/StatusTag'; // 訂單項數據類型 interface OrderItem { id: number; name: string; price: number; quantity: number; } enum couponStatus { UNUSED = 'unused', USED = 'used', REFUNDING = 'refunding', REFUNDED = 'refunded', OFFLINE_REFUND = 'offline_refund', } /** 平台補貼優惠券類型枚舉 */ enum DiscountCouponType { /** 滿減券 */ FULL_REDUCTION = 1, /** 折扣券 */ DISCOUNT = 2, /** 美食金（現金券） */ FOOD_MONEY = 3, /** 立減券 */ IMMEDIATE_REDUCTION = 4, /** 兌換券 */ EXCHANGE = 6, /** 套餐券 */ PACKAGE_COUPON = 8, /** 套餐優惠 */ PACKAGE_DISCOUNT = 9, } // 核銷方式枚舉 enum RedeemMethod { /** 商家核銷 */ MERCHANT_REDEEM = 'MERCHANT_REDEEM', /** 用戶自主核銷 */ USER_REDEEM = 'USER_REDEEM', /** POS 核銷 */ POS_REDEEM = 'POS_REDEEM', } // 佣金「查看明細」入口，hover 時變淺 const CommissionDetailLink: React.FC = () => { const [hovered, setHovered] = useState(false); return ( <html.span style={tw(`cursor-pointer ${hovered ? 'opacity-60' : ''}`)} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} > <Text textStyle="brand_12">{t`查看明細`}</Text> </html.span> ); }; // 券碼數據類型 interface CouponData { id: string; code: string; price: number; actualPaymentAmount?: number; // 實付金額 status: string; validPeriod: string; statusType: couponStatus; selected?: boolean; // 是否選中，用於批量退款 canRefund?: boolean; // 是否可以退款 writeOffMethod?: string; // 核銷方式 writeOffTime?: string; // 核銷時間 usedAt?: string; // 核銷時間（原始值） operationLogs?: CouponOperationLog[]; // 操作記錄 usedShopId?: number; // 使用店家ID usedShopName?: string; // 使用店家名稱 commission?: number; // 佣金金額（券維度） } // 訂單詳情數據類型 interface OrderDetailData { id: number; orderTime: string; payId: string; orderType: number; orderTypeText: string; orderStatus: number; flowType: number; orderRemark: string | null; cancelReason: string | null; totalAmount: number; platformDiscountAmount: number; shopDiscountAmount: number; discountAmount: number; actualAmount: number; platformFee: number; paymentGatewayFee: number; merchantIncome: number; userId: number; userName: string; userSex: number; userPhoneAreaCode: string; userPhone: string; shopId: number; shopName: string; shopStoreHeadPictureUrl: string; shopPhoneAreaCode: string; shopPhone: string; payTime?: string; verifyTime?: string; isPay: number; isEvaluate: number; isRefund: number; userBirthday: string | null; userEmail: string | null; userAvatar: string | null; shopAddress: string; shopLongitude: number; shopLatitude: number; shopDescription: string; shopBusinessHours: string; shopAverageRating: number; shopReviewCount: number; shopCategoryId: number; shopCategoryName: string; shopLat: number; shopLon: number; couponCodes: string[]; couponStatusText: string; /** 來源：結帳折扣(orderType=0): 0-APP付款, 1-POS機掃碼 */ source?: number; orderItems: OrderItem[]; discountPaymentOrderItemDTO: DiscountPaymentOrderItemDTO | null; discountPaymentOrderCouponsItemDTOs: | DiscountPaymentOrderCouponsItemDTO[] | null; setMealOrderItemDTO: SetMealOrderItemDTO | null; payOrder: PaymentResult | null; orderRefunds?: OrderRefundVO[]; } // 結帳折扣訂單項 interface DiscountPaymentOrderItemDTO { id: number; orderId: number; userId: number; shopId: number; orderItemRemark: string; totalAmount: number; platformDiscountAmount: number; totalDiscountAmount: number; totalAfterDiscountAmount: number; shopDiscountAmount: number; platformBearDiscountAmount: number; shopBearDiscountAmount: number; commission?: number; // 佣金字段 } // 優惠券項 interface DiscountPaymentOrderCouponsItemDTO { id: number | null; orderId: number; userId: number; shopId: number; campaignId?: string; templateId?: number; userCouponsId: number; couponsId: number; couponsType: number; couponsName: string; discountRate: number; discountAmount: number; maximumDiscountAmount: number; minimumAmount: number | null; couponsPlatformType: string; couponsCode: string; /** 優惠券使用狀態(0-待付款,1-待使用,2-已完成,3-已取消,4-退款中,5-退款成功) */ status?: number; /** 退款抵扣金額（僅美食金類型，後端暫未返回） */ refundDiscountAmount?: number; } // 套餐訂單項 interface SetMealOrderItemDTO { id: number; orderId: number; userId: number; shopId: number; orderItemRemark: string; setMealId: number; setMealItems: string; couponIds: string; couponCodes: string; setMealItemQuantity: number; setMealName: string; setMealImage: string; originalAmount: number; discountAmount: number; totalDiscountAmount: number; totalOriginalAmount: number; totalAfterDiscountAmount: number; commission?: number; // 佣金字段 createShopName?: string; // 套餐券創建店家名稱 } // 套餐項目類型 interface SetMealItem { itemId: string; itemName: string; quantity: number; unitPrice: number; description: string; } // 套餐分組類型 - 統一格式 interface SetMealGroup { type: 'FIXED' | 'OPTIONAL'; // 套餐項類型 name: string; items: SetMealItem[]; // 統一的餐點列表 displayOrder?: number; // 顯示順序 // 可選套餐項字段 totalCount?: number; selectCount?: number; multiTimes?: boolean; } // 支付結果 interface PaymentResult { success: boolean; errorCode: string; errorMessage: string; paymentOrderId: string; businessOrderNo: string; amount: number; currency: string; status: string; statusDesc: string; thirdPartyOrderNo: string; thirdPartyTradeNo: string; channelId: string; channelName: string; paymentHtml: string; paymentUrl: string; qrCode: string; paymentForm: string; expireTime: string; paidTime: string; createTime: string; } /** * 獲取平台折扣金額 */ const getPlatformDiscountAmount = ( orderData: OrderDetailData | null ): number => { if (!orderData) return 0; if (orderData.orderType === 0) { // 結帳折扣 - 使用 discountPaymentOrderItemDTO.platformDiscountAmount return orderData.discountPaymentOrderItemDTO?.platformDiscountAmount || 0; } else if (orderData.orderType === 1) { // 套餐券 - 使用訂單級別的平台折扣金額 return orderData.platformDiscountAmount || 0; } return 0; }; /** * 計算商家收入 * 公式：商家收入 = 實付金額 + 平台補貼 - 平台佣金 */ const calculateMerchantIncome = (orderData: OrderDetailData | null): number => { if (!orderData) return 0; const actualAmount = orderData.actualAmount || 0; const platformSubsidy = getPlatformDiscountAmount(orderData); // 根據訂單類型獲取佣金 let commission = 0; if (orderData.orderType === 0) { // 結帳折扣 commission = orderData.discountPaymentOrderItemDTO?.commission || 0; } else if (orderData.orderType === 1) { // 套餐券 commission = orderData.setMealOrderItemDTO?.commission || 0; } return actualAmount + platformSubsidy - commission; }; /** * 訂單詳情頁面 */ interface OrderDetailRouteParams { id?: string; referrer?: string; referrerParams?: { activityId?: string; activeTab?: string; templateId?: string; // 套餐券模板ID activeMenu?: string; // 連鎖視角菜單鍵 }; fromVerification?: string; } const OrderDetail: React.FC = () => { const navigation = useNavigation(); const params = useRouteParams() as OrderDetailRouteParams; // 數據狀態 const [data, setData] = useState<OrderDetailData | null>(null); const [loading, setLoading] = useState(true); const [couponData, setCouponData] = useState<CouponData[]>([]); const [couponLoading, setCouponLoading] = useState(false); const [selectedCoupons, setSelectedCoupons] = useState<string[]>([]); const [refundLoading, setRefundLoading] = useState(false); const [canViewRefundList, setCanViewRefundList] = useState(false); const [canOperateRefund, setCanOperateRefund] = useState(false); // 反核銷和操作記錄相關狀態 const [operationLogVisible, setOperationLogVisible] = useState(false); const [selectedCoupon, setSelectedCoupon] = useState<CouponData | null>(null); const [reverseWriteOffLoading, setReverseWriteOffLoading] = useState(false); // 當前店家ID（用於佣金金額展示判斷） const [currentShopIdState, setCurrentShopIdState] = useState<string | null>( null ); // 平台補貼明細 Modal const [subsidyDetailVisible, setSubsidyDetailVisible] = useState(false); const [subsidyData, setSubsidyData] = useState<OrderUsedCouponSummaryVO | null>(null); const [subsidyLoading, setSubsidyLoading] = useState(false); // 佣金比例明細 const [commissionRates, setCommissionRates] = useState< OrderCommissionRateVO[] >([]); // Modal refs const reverseWriteOffModalRef = useRef<{ open: () => void; close: () => void; }>(null); // 退款備註輸入框的 ref（用於確保數據獲取） const discountRefundTextareaRef = useRef<HTMLTextAreaElement>(null); const batchRefundTextareaRef = useRef<HTMLTextAreaElement>(null); // 計算商家收入和平台折扣 const merchantIncome = calculateMerchantIncome(data); const platformDiscountAmount = getPlatformDiscountAmount(data); const { isPhone } = useDeviceType(); // 獲取券碼數據 const fetchCouponDataWithOrderData = async (orderData: OrderDetailData) => { if (!orderData?.id || !orderData?.userId) { return; } setCouponLoading(true); try { // 獲取當前店家ID，用於與券的usedShopId比較 const currentShopId = await getShopId(); setCurrentShopIdState(currentShopId); const [success, result] = await getOrderCoupons({ orderId: orderData.id, userId: orderData.userId, }); if (success && Array.isArray(result)) { // 轉換API響應數據為組件需要的格式 const transformedCoupons: CouponData[] = result.map((coupon) => { const statusType = getStatusType(coupon.status); // 券碼退款條件： // 1. 券碼狀態必須是已使用（未使用的不能退款） // 2. 訂單狀態不能是待支付（待支付訂單不可退款） // 3. 如果券有usedShopId字段，需要與當前店家ID匹配才能退款 const isShopMatch = coupon.usedShopId == null || (currentShopId != null && String(coupon.usedShopId) === String(currentShopId)); const canRefund = statusType === couponStatus.USED && orderData.orderStatus !== OrderStatus.PENDING_PAYMENT && isShopMatch; return { id: coupon.couponId, code: coupon.couponCode, price: coupon.price || 0, // 使用API返回的價格字段 actualPaymentAmount: coupon.actualPaymentAmount, status: getStatusText(coupon.status), validPeriod: `${formatFromLocalDateTime(coupon.validStartTime)} ~ ${formatFromLocalDateTime(coupon.validEndTime)}`, statusType, selected: false, canRefund, writeOffMethod: coupon.redeemMethod, writeOffTime: coupon.usedAt ? formatFromLocalDateTime(coupon.usedAt) : undefined, usedAt: coupon.usedAt ? formatFromLocalDateTime(coupon.usedAt) : undefined, operationLogs: coupon.operationLogs, usedShopId: coupon.usedShopId, usedShopName: coupon.usedShopName, commission: coupon.commission, }; }); setCouponData(transformedCoupons); } else { console.error('獲取券碼數據失敗:', result); setCouponData([]); } } catch (error) { console.error('獲取券碼數據失敗:', error); setCouponData([]); } finally { setCouponLoading(false); } }; // 獲取佣金比例明細 const fetchCommissionRates = async (orderId: number) => { const [success, result] = await getOrderCommissionRates(orderId); setCommissionRates(success ? result : []); }; // 按券碼匹配佣金比例：優先核銷來源，無則取購買來源 const getCouponCommissionRate = ( record: CouponData ): OrderCommissionRateVO | undefined => commissionRates.find( (item) => item.sourceType === CommissionRateSourceType.VERIFICATION && ((item.couponCode != null && item.couponCode === record.code) || (item.couponId != null && String(item.couponId) === record.id)) ) ?? commissionRates.find( (item) => item.sourceType === CommissionRateSourceType.PURCHASE ); // 佣金比例明細氣泡內容 const renderCommissionRateDetail = (rate: OrderCommissionRateVO) => { const formatRate = (value?: number | null) => value == null ? '--' : `${value}%`; const reduction = rate.reductionCommissionRate; return ( <html.div style={tw('flex flex-col')}> <html.div style={tw('flex flex-row justify-between items-center py-1')}> <Text textStyle="body_14">{t`原始佣金率`}</Text> <Text textStyle="body_14">{formatRate(rate.baseCommissionRate)}</Text> </html.div> <html.div style={tw('flex flex-row justify-between items-center py-1')}> <Text textStyle="body_14">{t`活動減免率`}</Text> <Text textStyle="body_14" color={reduction ? businessThemeColors.textError : undefined} > {reduction ? `-${reduction}%` : formatRate(reduction)} </Text> </html.div> <html.div style={tw('h-px bg-gray-200 my-2')} /> <html.div style={tw('flex flex-row justify-between items-center py-1')}> <Text textStyle="body_14">{t`實際佣金率`}</Text> <Text textStyle="body_14"> {formatRate(rate.finalCommissionRate)} </Text> </html.div> </html.div> ); }; // 查看明細入口 const renderCommissionDetailTrigger = (record: CouponData) => { const rate = getCouponCommissionRate(record); if (!rate) return null; return ( <Tooltip content={renderCommissionRateDetail(rate)} trigger="click" placement="right" variant="light" showArrow={false} offset={6} width={180} > <CommissionDetailLink /> </Tooltip> ); }; // 券碼狀態文本轉換（使用統一的枚舉） const getStatusText = (status: string): string => { return getCouponStatusText(status as CouponCodeStatus); }; // 券碼狀態類型轉換（使用統一的枚舉） const getStatusType = (status: string): CouponData['statusType'] => { return getCouponStatusType( status as CouponCodeStatus ) as CouponData['statusType']; }; // 券碼展示：已使用的不隱碼，其餘隱碼 const getDisplayCouponCode = (coupon: CouponData): string => coupon.statusType === couponStatus.USED ? coupon.code : maskCouponCode(coupon.code); // 獲取訂單詳情 const fetchOrderDetail = async () => { try { setLoading(true); if (!params.id) { showToast(t`訂單ID不能為空`); return; } const response = await request.get<OrderDetailData>( `/merchant-api/order/detail?id=${params.id}` ); // 正確提取data字段 if (response?.shopName) { setData(response); // 如果是套餐券訂單，獲取券碼數據 if (response.orderType === 1) { // 直接調用券碼數據獲取，傳入response數據 fetchCouponDataWithOrderData(response); fetchCommissionRates(response.id); } } else { throw new Error(t`訂單詳情資料格式錯誤`); } } catch (error) { console.error('獲取訂單詳情失敗:', error); handleErrorWithToast(error, t`取得訂單詳情失敗`); } finally { setLoading(false); } }; // 頁面加載時獲取數據 useEffect(() => { fetchOrderDetail(); }, [params.id]); useEffect(() => { const loadRefundPermissions = async () => { const [viewRefundList, operateRefund] = await Promise.all([ hasPermissionCode(PERMISSIONS.ORDER_REFUND_LIST_VIEW), hasPermissionCode(PERMISSIONS.ORDER_REFUND_OPERATE), ]); setCanViewRefundList(viewRefundList); setCanOperateRefund(operateRefund); }; loadRefundPermissions(); }, []); const ensureRefundOperatePermission = async () => { const hasPermission = await hasPermissionCode( PERMISSIONS.ORDER_REFUND_OPERATE ); if (!hasPermission) { showToast(t`無操作退款權限`, 'warning'); return false; } return true; }; // 獲取狀態顏色（使用統一的枚舉） const getStatusColor = (status: number) => { return getOrderStatusColor(status as OrderStatus); }; // 獲取退款狀態文本 const getRefundStatusText = (status: number): string => { switch (status) { case RefundStatus.USER_INITIATED: return t`用戶發起`; case RefundStatus.PENDING_MERCHANT: return t`待商家處理`; case RefundStatus.MERCHANT_APPROVED: return t`商家已通過`; case RefundStatus.AUTO_APPROVED: return t`自動審核通過`; case RefundStatus.SYSTEM_AUTO_REFUND: return t`系統自動退款`; case RefundStatus.MERCHANT_REJECTED: return t`商家已拒絕`; case RefundStatus.AUTO_REJECTED: return t`自動駁回`; case RefundStatus.REFUND_ACCEPTED: return t`退款已受理`; case RefundStatus.REFUND_SUCCESS: return t`退款成功`; case RefundStatus.REFUND_FAILED: return t`退款失敗`; case RefundStatus.CANCELLED: return t`已撤銷`; case RefundStatus.PLATFORM_INITIATED: return t`平台發起`; case RefundStatus.MERCHANT_INITIATED: return t`商家主動發起退款`; default: return t`未知狀態`; } }; // 獲取退款狀態顏色 const getRefundStatusColor = (status: number) => { switch (status) { case RefundStatus.USER_INITIATED: case RefundStatus.PLATFORM_INITIATED: case RefundStatus.MERCHANT_INITIATED: return `bg-[${businessThemeColors.bgSecondary}] color-[#304000]`; // 發起狀態 case RefundStatus.PENDING_MERCHANT: return 'bg-yellow-100 text-yellow-800'; // 待處理 case RefundStatus.MERCHANT_APPROVED: case RefundStatus.AUTO_APPROVED: case RefundStatus.REFUND_ACCEPTED: return 'bg-orange-100 text-orange-800'; // 處理中 case RefundStatus.REFUND_SUCCESS: return 'bg-green-100 text-green-800'; // 成功 case RefundStatus.MERCHANT_REJECTED: case RefundStatus.AUTO_REJECTED: case RefundStatus.REFUND_FAILED: case RefundStatus.CANCELLED: return 'bg-red-100 text-red-800'; // 失敗/拒絕 case RefundStatus.SYSTEM_AUTO_REFUND: return 'bg-purple-100 text-purple-800'; // 系統處理 default: return 'bg-gray-100 text-gray-800'; // 未知狀態 } }; // 處理退款 const handleRefund = async () => { if (!data) return; // POS 結帳不支援退款，直接提示在 POS 後臺操作 if (data.source === 1) { showToast(t`請在POS後臺操作退款`, 'error'); return; } const hasPermission = await ensureRefundOperatePermission(); if (!hasPermission) { return; } // 彈框內部的退款備註組件 - 維護自己的 state const DiscountRefundRemarkSection = () => { const [localRemark, setLocalRemark] = useState(''); return ( <html.div style={tw('border-t pt-4')}> <Text textStyle="body_14_bold" style="mb-2 block">{t`退款備註`}</Text> <html.textarea ref={discountRefundTextareaRef} style={tw( 'w-full box-border p-2 border border-gray-300 rounded-md text-sm' )} placeholder={t`請輸入退款原因（選填）`} rows={3} value={localRemark} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => { setLocalRemark(e.target.value); }} maxLength={200} /> <Text textStyle="subvalue_14" style="mt-1 block"> {localRemark.length}/200 </Text> </html.div> ); }; // 構建退款確認彈框內容 const refundContent = ( <html.div style={tw('space-y-3')}> {/* Card 1: 商品資訊 */} <html.div style={tw('border border-gray-200 rounded-lg p-4 bg-white')}> <Text textStyle="body_14_bold" style="mb-3 block">{t`商品資訊`}</Text> <html.div style={tw('space-y-2')}> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`訂單號`}</Text> <Text textStyle="body_14">{data.id}</Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`狀態`}</Text> <Text textStyle="body_14"> {getOrderStatusText(data.orderStatus as OrderStatus)} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`下單時間`}</Text> <Text textStyle="body_14"> {formatFromLocalDateTime(data.orderTime)} </Text> </html.div> </html.div> </html.div> {/* Card 2: 用戶資訊 */} <html.div style={tw('border border-gray-200 rounded-lg p-4 bg-white')}> <Text textStyle="body_14_bold" style="mb-3 block">{t`用戶資訊`}</Text> <html.div style={tw('space-y-2')}> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`來源`}</Text> <Text textStyle="body_14">{data.userName}</Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`聯絡方式`}</Text> <Text textStyle="body_14"> {data.userPhoneAreaCode} {maskPhoneNumber(data.userPhone)} </Text> </html.div> </html.div> </html.div> {/* Card 3: 退款金額 */} <html.div style={tw( 'border-[1px] border-gray-200 border-solid rounded-lg p-4 bg-white' )} > <Text textStyle="body_14_bold" style="mb-3 block">{t`退款金額`}</Text> <html.div style={tw('space-y-2')}> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`原價`}</Text> <Text textStyle="body_14"> {formatCurrency(data.totalAmount)} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`平台補貼`}</Text> <Text textStyle="body_14"> {formatCurrency(platformDiscountAmount)} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`商家補貼`}</Text> <Text textStyle="body_14"> {formatCurrency(data.shopDiscountAmount || '0')} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`實付金額`}</Text> <Text textStyle="body_14"> {formatCurrency(data.actualAmount)} </Text> </html.div> <html.div style={tw('flex justify-between pt-2 border-t border-gray-200')} > <Text textStyle="body_14_bold">{t`退款金額`}</Text> <Text style={tw('text-lg font-bold text-red-600')}> {formatCurrency(data.actualAmount)} </Text> </html.div> </html.div> </html.div> {/* 退款備註 */} <DiscountRefundRemarkSection /> {/* 警告提示 */} <html.div style={tw('bg-orange-50 border border-orange-200 rounded-md p-3')} > <html.div style={tw('flex')}> <Text style={tw('text-orange-700 text-xs ml-2')}> {t`退款提交後，款項預計24小時內會原路返回至用戶的付款帳戶。`} </Text> </html.div> </html.div> </html.div> ); showConfirm(t`退款確認`, refundContent, { confirmText: t`確認退款`, cancelText: t`取消`, onConfirm: async () => { if (!data) return; setRefundLoading(true); try { // 通過 ref 獲取退款備註 const refundDesc = discountRefundTextareaRef.current?.value || ''; // 獲取shopId和merchantId const shopIdStr = await getShopId(); const merchantIdStr = await getMerchantId(); // 構建結帳折扣退款參數 const refundParams: MerchantDiscountPaymentRefundDTO = { orderId: data.id, refundRemark: refundDesc || t`結帳折扣退款`, shopId: shopIdStr ? parseInt(shopIdStr) : undefined, merchantId: merchantIdStr ? parseInt(merchantIdStr) : undefined, }; const [success, message] = await refundDiscountPaymentOrder(refundParams); if (success) { showToast(message, 'success'); // 清空備註 if (discountRefundTextareaRef.current) { discountRefundTextareaRef.current.value = ''; } // 重新獲取訂單詳情 await fetchOrderDetail(); } else { showToast(message, 'error'); } } catch (error) { handleErrorWithToast(error, t`退款申請提交失敗`); } finally { setRefundLoading(false); } }, }); }; // 處理返回邏輯 const handleBack = () => { if (params.referrer === 'simple-dashboard') { // 從簡潔版跳轉過來的，返回簡潔版首頁 navigation.navigate('SimpleDashboard'); } else if (params.fromVerification === 'true') { // 從核銷頁面跳轉過來的，返回時打開核銷彈窗 navigation.popTo('MerchantDashboard', { activeTab: 'set-meal-sales-order', openVerification: 'true', }); } else if ( params.referrer === 'package-coupon-detail' && params.referrerParams?.templateId ) { // 從套餐券明細頁面跳轉過來的，返回套餐券明細頁面 navigation.popTo('PackageCouponDetail', { templateId: params.referrerParams.templateId, couponId: params.referrerParams.templateId, }); } else if (params.referrer === 'chain-dashboard') { // 從連鎖報表跳轉過來的，返回連鎖管理頁面並恢復原報表菜單 navigation.navigate('ChainDashboard', { activeMenu: params.referrerParams?.activeMenu, }); } else if ( params.referrer === 'activity-tracking' && params.referrerParams ) { // 從活動追蹤頁面跳轉過來的，返回活動管理頁面 navigation.popTo('MerchantDashboard', { activeTab: 'activity-management', }); } else if ( params.referrer === 'order-details' && params.referrerParams?.activeTab ) { // 從訂單明細子菜單跳轉過來的，返回對應子菜單 navigation.popTo('MerchantDashboard', { activeTab: params.referrerParams.activeTab, }); } else if (data?.orderType === 0) { // 結帳折扣訂單默認返回結帳折扣訂單列表 navigation.popTo('MerchantDashboard', { activeTab: 'discount-order', }); } else { // 默認返回套餐券銷售訂單 navigation.popTo('MerchantDashboard', { activeTab: 'set-meal-sales-order', }); } }; // 如果加載中，顯示加載狀態 if (loading) { return ( <Container header={{ title: t`訂單詳情`, titleTextStyle: 'title_24_bold', onBack: handleBack, }} > <html.div style={tw('py-8')}> <Loading inline={true} text={t`載入中...`} /> </html.div> </Container> ); } // 判斷是否為結帳折扣訂單 const isDiscountPaymentOrder = data?.orderType === 0; // 判斷結帳折扣是否可以顯示退款按鈕 // 如果是結帳折扣，且處於跟退款有關的狀態一律不顯示 const canShowDiscountRefundButton = () => { if (!isDiscountPaymentOrder || !data || !canOperateRefund) return false; // 退款相關狀態：退款中(3)、已關閉(4) // 或者已經有退款記錄的情況 const isRefundRelatedStatus = data.orderStatus === 3 || data.orderStatus === 4; const hasRefundRecords = data.orderRefunds && data.orderRefunds.length > 0; return !isRefundRelatedStatus && !hasRefundRecords; }; // 判斷套餐券是否可以顯示退款按鈕 // 如果是套餐券詳情，則要根據券碼諮詢列表，只有列表中有可以發起退款的選項才出現退款按鈕 const canShowSetMealRefundButton = () => { if (isDiscountPaymentOrder || !data || !canOperateRefund) return false; // 檢查是否有可以退款的券碼 const hasRefundableCoupons = couponData.some((coupon) => coupon.canRefund); return hasRefundableCoupons; }; // 解析套餐券明細 const parseSetMealItems = (setMealItemsStr: string): SetMealGroup[] => { try { return JSON.parse(setMealItemsStr) as SetMealGroup[]; } catch (error) { console.error('解析套餐券明細失敗:', error); return []; } }; // 獲取狀態樣式（使用統一的工具函數） const getStatusStyle = (statusType: CouponData['statusType']) => { return getCouponStatusStyle(statusType); }; // 券碼選中狀態管理 const handleCouponSelect = (couponId: string, checked: boolean) => { if (checked) { setSelectedCoupons((prev) => [...prev, couponId]); } else { setSelectedCoupons((prev) => prev.filter((id) => id !== couponId)); } }; // 批量退款功能 const handleBatchRefund = async () => { if (!data) return; const hasPermission = await ensureRefundOperatePermission(); if (!hasPermission) { return; } // 檢查是否有選中的券碼 if (selectedCoupons.length === 0) { showToast(t`請選中可退款券碼`, 'error'); return; } // 計算選中券碼的總金額 const selectedCouponData = couponData.filter((coupon) => selectedCoupons.includes(coupon.id) ); const totalSelectedPrice = selectedCouponData.reduce( (sum, coupon) => sum + (coupon.actualPaymentAmount ?? coupon.price), 0 ); // 彈框內部的退款備註組件 - 維護自己的 state const BatchRefundRemarkSection = () => { const [localRemark, setLocalRemark] = useState(''); return ( <html.div style={tw('border-t pt-4')}> <Text textStyle="body_14_bold" style="mb-2 block">{t`退款備註`}</Text> <html.textarea ref={batchRefundTextareaRef} style={tw( 'w-full box-border p-2 border border-gray-300 rounded-md text-sm' )} placeholder={t`請輸入退款原因（選填）`} rows={3} value={localRemark} onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => { setLocalRemark(e.target.value); }} maxLength={200} /> <Text textStyle="subvalue_14" style="mt-1 block"> {localRemark.length}/200 </Text> </html.div> ); }; // 構建批量退款確認彈框內容 const refundContent = ( <html.div style={tw('flex flex-col gap-4')}> {/* Card 1: 商品資訊 */} <html.div style={tw( 'border-[1px] border-solid border-gray-200 shadow-md rounded-lg p-4 bg-white' )} > <Text textStyle="body_14_bold" style="mb-3 block">{t`商品資訊`}</Text> <html.div style={tw('space-y-2')}> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`訂單號`}</Text> <Text textStyle="body_14">{data?.id}</Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`狀態`}</Text> <Text textStyle="body_14"> {data ? getOrderStatusText(data.orderStatus as OrderStatus) : '--'} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`下單時間`}</Text> <Text textStyle="body_14"> {data?.orderTime ? formatFromLocalDateTime(data.orderTime) : '--'} </Text> </html.div> </html.div> </html.div> {/* Card 2: 用戶資訊 */} <html.div style={tw( 'border-[1px] border-solid border-gray-200 shadow-md rounded-lg p-4 bg-white' )} > <Text textStyle="body_14_bold" style="mb-3 block">{t`用戶資訊`}</Text> <html.div style={tw('space-y-2')}> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`來源`}</Text> <Text textStyle="body_14">{data?.userName || '--'}</Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`聯絡方式`}</Text> <Text textStyle="body_14"> {data?.userPhoneAreaCode} {maskPhoneNumber(data?.userPhone)} </Text> </html.div> </html.div> </html.div> {/* Card 3: 退款金額 */} <html.div style={tw( 'border-[1px] border-solid border-gray-200 shadow-md rounded-lg p-4 bg-white' )} > <Text textStyle="body_14_bold" style="mb-3 block">{t`退款金額`}</Text> <html.div style={tw('space-y-2')}> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`原價`}</Text> <Text textStyle="body_14"> {formatCurrency(data?.totalAmount || '0')} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`平台券補貼`}</Text> <Text textStyle="body_14"> {formatCurrency(data ? getPlatformDiscountAmount(data) : '0')} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`商家補貼`}</Text> <Text textStyle="body_14"> {formatCurrency(data?.shopDiscountAmount || '0')} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text textStyle="subvalue_14">{t`實付金額`}</Text> <Text textStyle="body_14"> {formatCurrency(data?.actualAmount || '0')} </Text> </html.div> <html.div style={tw('flex justify-between pt-2 border-t border-gray-200')} > <Text textStyle="body_14_bold">{t`實際退款`}</Text> <Text style={tw('text-lg font-bold text-red-600')}> {formatCurrency(totalSelectedPrice)} </Text> </html.div> </html.div> </html.div> {/* 退款備註 */} <BatchRefundRemarkSection /> {/* 警告提示 */} <html.div style={tw('bg-orange-50 border border-orange-200 rounded-md p-3')} > <html.div style={tw('flex')}> <Text style={tw('text-orange-700 text-xs ')}> {t`退款提交後，款項預計24小時內會原路返回至用戶的付款帳戶。`} </Text> </html.div> </html.div> </html.div> ); showConfirm(t`退款確認`, refundContent, { confirmText: t`確認退款`, cancelText: t`取消`, onConfirm: async () => { setRefundLoading(true); try { // 通過 ref 獲取退款備註 const refundDesc = batchRefundTextareaRef.current?.value || ''; // 獲取shopId和merchantId const shopIdStr = await getShopId(); const merchantIdStr = await getMerchantId(); const shopIdNum = shopIdStr ? parseInt(shopIdStr) : undefined; const merchantIdNum = merchantIdStr ? parseInt(merchantIdStr) : undefined; if (data.orderType === 0) { // 結帳折扣訂單退款 const refundParams: MerchantDiscountPaymentRefundDTO = { orderId: data.id, refundRemark: refundDesc || t`批量退款券碼`, shopId: shopIdNum, merchantId: merchantIdNum, }; const [success, message] = await refundDiscountPaymentOrder(refundParams); if (success) { showToast(message, 'success'); // 清空選中狀態和備註 setSelectedCoupons([]); if (batchRefundTextareaRef.current) { batchRefundTextareaRef.current.value = ''; } fetchOrderDetail(); // 重新獲取訂單數據 } else { showToast(message, 'error'); } } else if (data.orderType === 1) { // 套餐券訂單退款 const refundParams: MerchantSetMealRefundDTO = { orderId: data.id, refundType: 2, // 部分退款 refundRemark: refundDesc || t`批量退款券碼`, refundActualAmount: totalSelectedPrice, refundQuantity: selectedCoupons.length, couponIds: selectedCoupons.map(Number), shopId: shopIdNum, merchantId: merchantIdNum, }; const [success, message] = await refundSetMealOrder(refundParams); if (success) { showToast(message, 'success'); // 清空選中狀態和備註 setSelectedCoupons([]); if (batchRefundTextareaRef.current) { batchRefundTextareaRef.current.value = ''; } fetchOrderDetail(); // 重新獲取訂單數據 } else { showToast(message, 'error'); } } } catch (error) { console.error('批量退款失敗:', error); handleErrorWithToast(error, t`退款失敗，請稍後重試`, showToast); } finally { setRefundLoading(false); } }, }); }; // 處理反核銷 const handleReverseWriteOff = (coupon: CouponData) => { setSelectedCoupon(coupon); reverseWriteOffModalRef.current?.open(); }; // 處理操作記錄 const handleShowOperationLog = (coupon: CouponData) => { setSelectedCoupon(coupon); setOperationLogVisible(true); }; // 確認反核銷 const confirmReverseWriteOff = async () => { if (!selectedCoupon || !data) return; try { setReverseWriteOffLoading(true); const merchantIdStr = await getMerchantId(); const shopIdStr = await getShopId(); const userIdNum = await getUserId(); if (!merchantIdStr) { showToast(t`取得商家資訊失敗，請重新登入`, 'error'); return; } const reverseParams: ReverseVerificationOrderDTO = { orderId: data.id.toString(), orderType: OrderType.SET_MEAL, couponCode: selectedCoupon.code, shopId: shopIdStr ? parseInt(shopIdStr) : undefined, merchantId: parseInt(merchantIdStr), operatedBy: userIdNum, }; const [success, result] = await reverseVerificationOrder(reverseParams); if (success) { showToast(t`反核銷成功`, 'success'); reverseWriteOffModalRef.current?.close(); // 反核銷後該券變為未使用，不可退款，需從選中列表中移除 setSelectedCoupons((prev) => prev.filter((id) => id !== selectedCoupon.id) ); await fetchCouponDataWithOrderData(data); } else { showToast(typeof result === 'string' ? result : t`反核銷失敗`, 'error'); } } catch (error) { console.error('反核銷失敗:', error); handleErrorWithToast(error, t`反核銷失敗，請稍後重試`, showToast); } finally { setReverseWriteOffLoading(false); } }; // 券碼錶格列定義 const couponColumns: TableColumn<CouponData>[] = [ ...(canOperateRefund ? [ { key: 'select', title: t`選擇`, dataIndex: 'select', width: 50, render: (_: unknown, record: CouponData) => ( <html.input type="checkbox" checked={selectedCoupons.includes(record.id)} disabled={!record.canRefund || !canOperateRefund} onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleCouponSelect(record.id, e.target.checked) } style={tw('w-4 h-4')} /> ), }, ] : []), { key: 'code', title: t`券碼`, dataIndex: 'code', width: 150, render: (_: unknown, record: CouponData) => ( <Text textStyle="brand_14">{getDisplayCouponCode(record) || '-'}</Text> ), }, { key: 'actualPaymentAmount', title: t`實付金額`, dataIndex: 'actualPaymentAmount', width: 100, render: (value: unknown, record: CouponData) => ( <Text textStyle="body_16"> {formatCurrency(Number(value ?? record.price))} </Text> ), }, { key: 'commission', title: t`佣金金額`, dataIndex: 'commission', width: 100, render: (_: unknown, record: CouponData) => { // 非已核銷狀態：顯示 -- if (record.statusType !== couponStatus.USED) { return ( <html.div style={tw('flex flex-col items-start')}> <Text textStyle="body_16">--</Text> {renderCommissionDetailTrigger(record)} </html.div> ); } // 已核銷 + 核銷店家 = 當前店家（或後端未回傳核銷店家，視為同店）：顯示金額 const isShopMatch = record.usedShopId == null || (currentShopIdState != null && String(record.usedShopId) === String(currentShopIdState)); if (isShopMatch) { return ( <html.div style={tw('flex flex-col items-start')}> <Text textStyle="body_16"> {formatCurrency(record.commission ?? 0, { keepOriginalDecimals: true, })} </Text> {renderCommissionDetailTrigger(record)} </html.div> ); } // 已核銷 + 核銷店家 ≠ 當前店家：顯示 $*** return ( <html.span style={tw('cursor-pointer text-gray-500')} onClick={() => showToast(t`非核銷店舖無法查看具體佣金金額`)} > <Text textStyle="body_16">$***</Text> </html.span> ); }, }, { key: 'status', title: t`狀態`, dataIndex: 'status', width: 100, render: (value: unknown, record: CouponData) => ( <html.span style={tw( `text-xs px-2 py-1 rounded ${getStatusStyle(record.statusType)}` )} > {String(value)} </html.span> ), }, { key: 'validPeriod', title: t`有效期`, dataIndex: 'validPeriod', width: 240, render: (value: unknown) => ( <Text textStyle="body_16">{String(value)}</Text> ), }, // { // key: 'usedShopName', // title: t`核銷店家`, // dataIndex: 'usedShopName', // width: 200, // render: (value: unknown) => ( // <Text textStyle="body_16">{value ? String(value) : '-'}</Text> // ), // }, // { // key: 'writeOffMethod', // title: t`核銷方式`, // dataIndex: 'writeOffMethod', // width: 120, // render: (value: unknown) => { // if (!value) return <Text textStyle="body_16">-</Text>; // const methodMap: Record<RedeemMethod, string> = { // [RedeemMethod.MERCHANT_REDEEM]: t`商家核銷`, // [RedeemMethod.USER_REDEEM]: t`用戶自主核銷`, // [RedeemMethod.POS_REDEEM]: t`POS核銷`, // }; // return ( // <Text textStyle="body_16"> // {methodMap[String(value) as RedeemMethod] || String(value)} // </Text> // ); // }, // }, // { // key: 'usedAt', // title: t`核銷時間`, // dataIndex: 'usedAt', // width: 150, // render: (value: unknown) => { // return <Text textStyle="body_16">{value ? String(value) : '-'}</Text>; // }, // }, { key: 'action', title: t`操作`, dataIndex: 'action', width: isPhone ? 100 : 200, fixed: 'right', render: (_: unknown, record: CouponData) => ( <html.div style={tw(`flex gap-2 ${isPhone ? 'flex-col ' : ''}`)}> {/* 已核銷且有核銷方式的券，且在核銷時間15分鐘內才顯示反核銷按鈕，canRefund已包含usedShopId與當前shopId匹配邏輯；POS核銷不顯示反核銷 */} {record.statusType === couponStatus.USED && record.writeOffMethod && record.writeOffMethod !== RedeemMethod.POS_REDEEM && record.canRefund && ( <Countdown startTime={record.usedAt} duration={15}> <Text textStyle="brand_14" style="cursor-pointer" onClick={() => handleReverseWriteOff(record)} > {t`反核銷`} </Text> </Countdown> )} {/* 有操作記錄數據才顯示操作記錄按鈕 */} {record.operationLogs && record.operationLogs.length > 0 && ( <Text textStyle="brand_14" style="cursor-pointer" onClick={() => handleShowOperationLog(record)} > {t`操作記錄`} </Text> )} </html.div> ), }, ]; // ===================== 平台補貼明細 相關函數 ===================== /** 拉取訂單用券明細 */ const fetchSubsidyData = async () => { if (!data?.id) return; setSubsidyLoading(true); try { const [success, result] = await getOrderUsedCoupons(data.id); if (success && result) { setSubsidyData(result); } else { setSubsidyData(null); } } catch { setSubsidyData(null); } finally { setSubsidyLoading(false); } }; /** 獲取優惠券類型文字 */ const getCouponTypeName = (type: number | null | undefined): string => { switch (type) { case DiscountCouponType.FULL_REDUCTION: return t`滿減券`; case DiscountCouponType.DISCOUNT: return t`折扣券`; case DiscountCouponType.FOOD_MONEY: return t`美食金`; case DiscountCouponType.IMMEDIATE_REDUCTION: return t`立減券`; case DiscountCouponType.EXCHANGE: return t`兌換券`; case DiscountCouponType.PACKAGE_COUPON: return t`套餐券`; case DiscountCouponType.PACKAGE_DISCOUNT: return t`套餐優惠`; default: return type != null ? String(type) : '-'; } }; // 基礎信息組件 - 金額塊 + 訂單基本資訊 const BasicInfoCard = () => { if (!data) return null; // 金額塊 - 有數據才顯示 const amountItems: DetailAmountItem[] = []; if (data.totalAmount != null) { amountItems.push({ key: 'totalAmount', label: t`原價`, value: formatCurrency(data.totalAmount), }); } if (data.shopDiscountAmount != null) { amountItems.push({ key: 'shopDiscountAmount', label: t`商家折扣`, value: formatCurrency(data.shopDiscountAmount), }); } if (platformDiscountAmount != null) { amountItems.push({ key: 'platformDiscountAmount', label: t`平台券補貼`, value: formatCurrency(platformDiscountAmount), }); } if (data.actualAmount != null) { amountItems.push({ key: 'actualAmount', label: t`實付金額`, value: formatCurrency(data.actualAmount), }); } // 平台佣金 - 僅優惠買單頂層顯示（套餐券不在頂層顯示佣金） if (isDiscountPaymentOrder && data.platformFee != null) { amountItems.push({ key: 'platformFee', label: t`平台傭金`, value: formatCurrency(data.platformFee, { keepOriginalDecimals: true }), }); } // 訂單佣金 - 結帳折扣的佣金 if ( isDiscountPaymentOrder && data.discountPaymentOrderItemDTO?.commission != null ) { amountItems.push({ key: 'commission', label: t`訂單佣金`, value: formatCurrency( data.discountPaymentOrderItemDTO.commission || 0, { keepOriginalDecimals: true } ), }); } if (data.paymentGatewayFee != null) { amountItems.push({ key: 'paymentGatewayFee', label: t`交易手續費`, value: formatCurrency(data.paymentGatewayFee), }); } return ( <> {/* 金額資訊 */} {amountItems.length > 0 && ( <Card style="mx-4 mt-4 mb-6"> <DetailAmountBlocks items={amountItems} /> </Card> )} {/* 基礎資訊 */} <DetailSection title={t`基礎資訊`} style={amountItems.length > 0 ? 'mx-4 mb-6' : 'mx-4 mt-4 mb-6'} > <DetailRow label={t`訂單編號`}>{data.id}</DetailRow> {data.shopName && ( <DetailRow label={t`店家名稱`}>{data.shopName}</DetailRow> )} {data.payId && ( <DetailRow label={t`支付編號`}>{data.payId}</DetailRow> )} {data.orderTime && ( <DetailRow label={t`訂單時間`}> {formatFromLocalDateTime(data.orderTime)} </DetailRow> )} {data.orderTypeText && ( <DetailRow label={t`訂單類型`}>{data.orderTypeText}</DetailRow> )} {isDiscountPaymentOrder && data.source != null && ( <DetailRow label={t`付款方式`}> {data.source === 0 ? t`APP付款` : data.source === 1 ? t`POS機掃碼` : ''} </DetailRow> )} <DetailRow label={t`訂單狀態`}> <StatusTag text={getOrderStatusText(data.orderStatus as OrderStatus)} colorClass={getStatusColor(data.orderStatus)} style={`text-[16px] rounded-[6px] ${ data.orderStatus === OrderStatus.COMPLETED ? 'color-[#00C25E]' : '' }`} /> </DetailRow> {data.payTime && ( <DetailRow label={t`支付時間`}> {formatFromLocalDateTime(data.payTime)} </DetailRow> )} {data.verifyTime && ( <DetailRow label={t`核銷時間`}> {formatFromLocalDateTime(data.verifyTime)} </DetailRow> )} {data.orderRemark && ( <DetailRow label={t`訂單備註`}>{data.orderRemark}</DetailRow> )} </DetailSection> </> ); }; return ( <Container maxWidth="100%" header={{ title: t`訂單詳情`, titleTextStyle: 'title_24_bold', onBack: handleBack, // 為結帳折扣訂單添加退款按鈕 rightContent: canShowDiscountRefundButton() ? ( <PermissionWrapper permissionCode={PERMISSIONS.ORDER_REFUND_OPERATE}> <Button type="primary" size="small" onClick={handleRefund} loading={refundLoading} style="bg-red-500 hover:bg-red-600 text-white px-3 py-1 text-sm" > {t`退款`} </Button> </PermissionWrapper> ) : undefined, }} > <html.div style={tw('flex flex-col min-h-full bg-gray-50')}> {/* 如果詳情接口失敗，顯示錯誤提示 */} {!data && ( <Card style="m-4"> <html.div style={tw('text-center py-8')}> <Text style={tw('text-red-500')}>{t`訂單詳情載入失敗`}</Text> </html.div> </Card> )} {/* 根據訂單類型顯示不同佈局 */} {data && isDiscountPaymentOrder && ( <> {/* 結帳折扣 - 金額 */} <Card style="mx-4 mt-4 mb-6"> <DetailAmountBlocks items={[ { key: 'totalAmount', label: t`原價`, value: formatCurrency(data.totalAmount ?? 0), }, { key: 'actualAmount', label: t`用戶實付`, value: formatCurrency(data.actualAmount ?? 0), }, { key: 'platformDiscountAmount', label: t`平台補貼`, value: formatCurrency(platformDiscountAmount), }, { key: 'refundAmount', label: t`退款金額`, value: formatCurrency( (data.orderRefunds || []).reduce( (sum, refund) => sum + (refund.refundAmount || 0), 0 ) ), }, { key: 'orderRevenue', label: t`訂單收入`, value: formatCurrency( (data.actualAmount || 0) + platformDiscountAmount ), }, ]} /> </Card> {/* 結帳折扣 - 基本資訊 */} <DetailSection title={t`基本資訊`} style="mx-4 mb-6"> <DetailRow label={t`訂單編號`}>{data.id}</DetailRow> <DetailRow label={t`訂單狀態`}> <StatusTag text={getOrderStatusText(data.orderStatus as OrderStatus)} colorClass={getStatusColor(data.orderStatus)} style={`text-[16px] rounded-[6px] ${ data.orderStatus === OrderStatus.COMPLETED ? 'color-[#00C25E]' : '' }`} /> </DetailRow> <DetailRow label={t`店家名稱`}>{data.shopName}</DetailRow> <DetailRow label={t`支付編號`}>{data.payId}</DetailRow> <DetailRow label={t`訂單時間`}> {data.orderTime ? formatFromLocalDateTime(data.orderTime) : ''} </DetailRow> <DetailRow label={t`訂單類型`}>{data.orderTypeText}</DetailRow> <DetailRow label={t`付款方式`}> {data.source === 0 ? t`APP付款` : data.source === 1 ? t`POS機掃碼` : ''} </DetailRow> <DetailRow label={t`支付時間`}> {data.payTime ? formatFromLocalDateTime(data.payTime) : ''} </DetailRow> {data.orderRemark && ( <DetailRow label={t`訂單備註`}>{data.orderRemark}</DetailRow> )} </DetailSection> {/* 結帳折扣 - 用戶資訊 */} <DetailSection title={t`用戶資訊`} style="mx-4 mb-6"> <DetailRow label={t`用戶名稱`}>{data.userName}</DetailRow> <DetailRow label={t`用戶ID`}>{data.userId}</DetailRow> </DetailSection> {/* 結帳折扣 - 優惠資訊 */} {(() => { // 從優惠券數據中分離平台券和商家券 const adminCoupons = data.discountPaymentOrderCouponsItemDTOs?.filter( (coupon) => coupon.couponsPlatformType === 'admin' ) || []; const merchantCoupons = data.discountPaymentOrderCouponsItemDTOs?.filter( (coupon) => coupon.couponsPlatformType === 'merchant' ) || []; return ( <DetailSection title={t`優惠資訊`} style="mx-4 mb-6"> <DetailRow label={t`平台減免`}> {adminCoupons.length > 0 && adminCoupons[0].discountRate ? `${(adminCoupons[0].discountRate * 100).toFixed(0)}%` : platformDiscountAmount && data.totalAmount ? `${((platformDiscountAmount / data.totalAmount) * 100).toFixed(0)}%` : ''} </DetailRow> <DetailRow label={t`平台券碼`}> {adminCoupons[0]?.couponsCode || adminCoupons[0]?.couponsName || ''} </DetailRow> <DetailRow label={t`商家券碼`}> {merchantCoupons[0]?.couponsCode || merchantCoupons[0]?.couponsName || ''} </DetailRow> </DetailSection> ); })()} {/* 結帳折扣 - 第四個Card：退款記錄（如果有退款記錄才顯示） */} {canViewRefundList && data.orderRefunds && data.orderRefunds.length > 0 && ( <DetailSection title={t`退款記錄`} style="mx-4 mb-6"> <html.div style={tw('flex flex-col gap-2')}> {data.orderRefunds.map((refund, index) => ( <html.div key={index} style={tw( refund.refundStatus === RefundStatus.PENDING_MERCHANT ? 'bg-yellow-50 px-3 py-2 rounded-lg' : 'bg-gray-50 px-3 py-2 rounded-lg' )} > <html.div style={tw('flex justify-between items-center mb-2')} > <Text textStyle="body_14_bold"> {formatFromLocalDateTime(refund.refundProcessTime)} </Text> <html.span style={tw( `text-xs px-2 py-0.5 rounded ${getRefundStatusColor(refund.refundStatus)}` )} > {getRefundStatusText(refund.refundStatus)} </html.span> </html.div> <html.div style={tw('flex flex-col gap-1')}> <DetailRow label={t`金額`}> {formatCurrency(refund.refundAmount)} </DetailRow> <DetailRow label={t`退款人`}> {refund.refundInitiatorType === 0 ? t`用戶` : refund.refundInitiatorType === 1 ? t`商家` : t`平台客服`} </DetailRow> <DetailRow label={t`退款原因`}> {refund.refundReason || t`無退款原因`} </DetailRow> <DetailRow label={t`退款說明`}> {refund.refundRemark?.length > 10 ? ( <Tooltip content={refund.refundRemark}> <Text textStyle="body_14"> {refund.refundRemark.slice(0, 10) + '...'} </Text> </Tooltip> ) : ( refund.refundRemark || t`無退款說明` )} </DetailRow> </html.div> {/* 如果是待商家處理狀態，顯示操作按鈕 */} {/* {canOperateRefund && refund.refundStatus === RefundStatus.PENDING_MERCHANT && ( <html.div style={tw( 'flex justify-end gap-2 mt-3 pt-3 border-t border-yellow-200' )} > <Button type="secondary" onClick={() => { // TODO: 實現拒絕退款邏輯 showToast(t`拒絕退款功能待實現`); }} style="border border-gray-300 text-gray-700 px-3 py-1 text-xs" > {t`拒絕退款`} </Button> <Button type="primary" onClick={() => { // TODO: 實現統一退款邏輯 showToast(t`統一退款功能待實現`); }} style="bg-green-500 hover:bg-green-600 text-white px-3 py-1 text-xs" > {t`統一退款`} </Button> </html.div> )} */} </html.div> ))} </html.div> </DetailSection> )} </> )} {/* 套餐券訂單 - 第一個Card：基礎信息 */} {data && !isDiscountPaymentOrder && <BasicInfoCard />} {/* 套餐券訂單佈局 */} {data && !isDiscountPaymentOrder && ( <> {/* 套餐券 - 第二個Card：用戶信息 */} <DetailSection title={t`用戶資訊`} style="mx-4 mb-6"> <DetailRow label={t`用戶編號`}> {`${data.userName ?? ''} ${data.userId ?? ''}`.trim()} </DetailRow> <DetailRow label={t`使用者ID`}>{data.userId}</DetailRow> </DetailSection> {/* 套餐券 - 第三個Card：店家資訊 */} <DetailSection title={t`店家資訊`} style="mx-4 mb-6"> <DetailRow label={t`商家名稱`}>{data.shopName}</DetailRow> <DetailRow label={t`餐廳電話`}> {`${data.shopPhoneAreaCode ? `${data.shopPhoneAreaCode} ` : ''}${ // 處理電話號碼格式，去除引號和方括號 typeof data.shopPhone === 'string' ? data.shopPhone.replace(/["'[\]]/g, '') : (data.shopPhone ?? '') }`.trim()} </DetailRow> <DetailRow label={t`商家地址`}>{data.shopAddress}</DetailRow> </DetailSection> {/* 套餐券 - 第四個Card：套餐券明細 */} <DetailSection title={t`套餐券明細`} style="mx-4 mb-6"> <html.div> {/* 套餐信息 */} <html.div style={tw('bg-gray-50 px-3 py-2 rounded-lg')}> <html.div style={tw('flex items-center gap-3 flex-wrap mb-2')} > <Text textStyle="body_14_bold"> {data.setMealOrderItemDTO?.setMealName || t`套餐券`} </Text> <Text textStyle="subvalue_14">{t`套餐明細如下`}</Text> </html.div> {/* 套餐分組列表 */} {data.setMealOrderItemDTO?.setMealItems && (() => { const setMealGroups: SetMealGroup[] = parseSetMealItems( data.setMealOrderItemDTO.setMealItems ); // 按 displayOrder 排序 const sortedGroups = setMealGroups; return ( <html.div style={tw('flex flex-col gap-2')}> {sortedGroups.map((group, groupIndex) => { const isOptional = group.type === 'OPTIONAL'; return ( <html.div key={groupIndex} style={tw( `border-l-2 border-color-[${businessThemeColors.borderBrand}] pl-3` )} > {/* 分組名稱和類型標籤 */} <html.div style={tw( 'flex items-center gap-2 flex-wrap mb-1' )} > <Text style={tw( 'text-sm font-medium text-gray-800' )} > {group.name} </Text> {/* 分組類型標籤 */} <html.span style={tw( `px-2 py-0.5 text-xs rounded ${ isOptional ? 'bg-blue-100 text-blue-700' : 'bg-green-100 text-green-700' }` )} > {isOptional ? t`可選套餐組合` : t`固定套餐組合`} </html.span> {/* 可選分組顯示幾選幾 */} {isOptional && group.selectCount !== undefined && group.totalCount !== undefined && ( <Text textStyle="subvalue_14"> ({group.totalCount} {t`選`} {group.selectCount}) </Text> )} {/* 是否可重複選擇 */} {isOptional && (group.multiTimes ? ( <Text style={tw('text-xs text-orange-600')} > {t`同一餐點可選多次`} </Text> ) : ( <Text textStyle="subvalue_14"> {t`同一餐點不可選多次`} </Text> ))} </html.div> {/* 餐點列表 - 統一渲染 */} {group.items && group.items.length > 0 && ( <html.div style={tw('flex flex-col gap-0.5')}> {group.items.map((item, itemIndex) => ( <html.div key={itemIndex} style={tw( 'flex items-start gap-3 text-xs' )} > <html.div style={tw('w-[100px] shrink-0')} > <Text style={tw('text-gray-700')}> {item.itemName} {item.description && ` (${item.description})`} </Text> </html.div> <html.div style={tw('flex-1 min-w-0')}> <Text style={tw('text-gray-600')}> <Trans> {item.quantity} {t`份`} ×{' '} {formatCurrency(item.unitPrice)} </Trans> </Text> </html.div> </html.div> ))} </html.div> )} </html.div> ); })} </html.div> ); })()} </html.div> </html.div> </DetailSection> {/* 套餐券 - 第五個：券的table */} <DetailSection title={t`券碼資訊`} style="mx-4 mb-6" extra={ canShowSetMealRefundButton() && ( <Button type="primary" onClick={handleBatchRefund} loading={refundLoading} style="bg-red-500 hover:bg-red-600 text-white px-4 py-2 text-sm" > {selectedCoupons.length > 0 ? t`退款 (${selectedCoupons.length})` : t`退款`} </Button> ) } > {/* 券碼錶格 - 使用Table組件 */} {couponLoading ? ( <html.div style={tw('flex justify-center items-center py-8')}> <Loading size="medium" inline={true} text={t`載入券碼資料中...`} /> </html.div> ) : ( <Table columns={couponColumns} dataSource={couponData} rowKey="id" rowHeight={60} headerHeight={50} isMobile={true} /> )} </DetailSection> </> )} {/* 退款中和已退款的券顯示為card */} {data && !isDiscountPaymentOrder && ( <> {/* 套餐券 - 退款記錄（如果有退款記錄才顯示） */} {canViewRefundList && data.orderRefunds && data.orderRefunds.length > 0 && ( <DetailSection title={t`退款記錄`} style="mx-4 mb-6"> <html.div style={tw('flex flex-col gap-2')}> {data.orderRefunds.map((refund, index) => ( <html.div key={index} style={tw( refund.refundStatus === RefundStatus.PENDING_MERCHANT ? 'bg-yellow-50 px-3 py-2 rounded-lg' : 'bg-gray-50 px-3 py-2 rounded-lg' )} > <html.div style={tw( 'flex justify-between items-center gap-3 mb-2' )} > <html.div style={tw('flex items-center gap-3 flex-wrap')} > <Text textStyle="body_14_bold"> {refund.refundSn} </Text> <Text textStyle="subvalue_14"> {formatFromLocalDateTime( refund.refundProcessTime )} </Text> </html.div> <html.span style={tw( `text-xs px-2 py-0.5 rounded ${getRefundStatusColor(refund.refundStatus)}` )} > {getRefundStatusText(refund.refundStatus)} </html.span> </html.div> <html.div style={tw('flex flex-col gap-1')}> <DetailRow label={t`金額`}> {formatCurrency(refund.refundAmount)} </DetailRow> <DetailRow label={t`退款人`}> {refund.refundInitiatorType === 0 ? t`用戶` : refund.refundInitiatorType === 1 ? t`商家` : t`平台客服`} </DetailRow> <DetailRow label={t`退款原因`}> {refund.refundReason || t`無退款原因`} </DetailRow> <DetailRow label={t`退款說明`}> {refund.refundRemark?.length > 10 ? ( <Tooltip content={refund.refundRemark}> <Text textStyle="body_14"> {refund.refundRemark.slice(0, 10) + '...'} </Text> </Tooltip> ) : ( refund.refundRemark || t`無退款說明` )} </DetailRow> </html.div> {/* 如果是待商家處理狀態，顯示操作按鈕 */} {/* {canOperateRefund && refund.refundStatus === RefundStatus.PENDING_MERCHANT && ( <html.div style={tw('flex justify-end gap-2')}> <Button type="secondary" size="small" onClick={() => { // TODO: 實現拒絕退款邏輯 showToast(t`拒絕退款功能待實現`); }} style="border border-gray-300 text-gray-700 px-3 py-1 text-xs" > {t`拒絕`} </Button> <Button type="primary" size="small" onClick={() => { // TODO: 實現同意退款邏輯 showToast(t`同意退款功能待實現`); }} style="bg-green-500 hover:bg-green-600 text-white px-3 py-1 text-xs" > {t`同意退款`} </Button> </html.div> )} */} </html.div> ))} </html.div> </DetailSection> )} </> )} {/* 套餐訂單項信息 */} {data && data.setMealOrderItemDTO && ( <DetailSection title={t`套餐資訊`} style="mx-4 mb-6"> <DetailRow label={t`套餐名稱`}> {data.setMealOrderItemDTO.setMealName} </DetailRow> <DetailRow label={t`套餐數量`}> {data.setMealOrderItemDTO.setMealItemQuantity} </DetailRow> <DetailRow label={t`套餐原始單價`}> {formatCurrency(data.setMealOrderItemDTO.originalAmount)} </DetailRow> <DetailRow label={t`套餐原始總金額`}> {formatCurrency(data.setMealOrderItemDTO.totalOriginalAmount)} </DetailRow> <DetailRow label={t`套餐優惠金額`}> {formatCurrency( (data.shopDiscountAmount || 0) + (platformDiscountAmount || 0) )} </DetailRow> <DetailRow label={t`套餐實付金額`}> {formatCurrency(data.actualAmount)} </DetailRow> {data.setMealOrderItemDTO.setMealImage && ( <DetailRow label={t`套餐圖片`}> <html.img src={data.setMealOrderItemDTO.setMealImage} alt={t`套餐圖片`} style={tw('w-16 h-16 rounded')} /> </DetailRow> )} {data.setMealOrderItemDTO.orderItemRemark && ( <DetailRow label={t`套餐備註`}> {data.setMealOrderItemDTO.orderItemRemark} </DetailRow> )} {data.setMealOrderItemDTO.createShopName && ( <DetailRow label={t`套餐券創建店家`}> {data.setMealOrderItemDTO.createShopName} </DetailRow> )} </DetailSection> )} {/* 優惠券使用信息 */} {/* {data && data.discountPaymentOrderCouponsItemDTOs && data.discountPaymentOrderCouponsItemDTOs.length > 0 && ( <Card style="m-4"> <html.div style={tw('border-b border-gray-200 pb-4 mb-4')}> <html.h2 style={tw('text-lg font-medium text-gray-900')}> {t`優惠券使用資訊`} </html.h2> </html.div> <html.div style={tw('space-y-4')}> {data.discountPaymentOrderCouponsItemDTOs.map( (coupon, index) => ( <html.div key={index} style={tw('border border-gray-200 rounded-lg p-4')} > <html.div style={tw('grid grid-cols-1 gap-2')}> <html.div style={tw('flex justify-between')}> <Text style={tw('text-sm text-gray-500')} >{t`優惠券名稱`}</Text> <Text style={tw('text-sm text-gray-900 font-medium')}> {coupon.couponsName} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text style={tw('text-sm text-gray-500')} >{t`優惠金額`}</Text> <Text style={tw('text-sm text-gray-900')}> {formatCurrency(coupon.discountAmount)} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text style={tw('text-sm text-gray-500')} >{t`最低消費金額`}</Text> <Text style={tw('text-sm text-gray-900')}> {formatCurrency(coupon.minimumAmount)} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text style={tw('text-sm text-gray-500')} >{t`平台類型`}</Text> <Text style={tw('text-sm text-gray-900')} >{t`商家端`}</Text> </html.div> </html.div> </html.div> ) )} </html.div> </Card> )} */} {/* 支付信息 */} {data && data.payOrder && ( <DetailSection title={t`支付資訊`} style="mx-4 mb-6"> <DetailRow label={t`支付狀態`}> <html.div style={tw( `inline-flex px-2 py-1 text-xs font-medium rounded-full ${ data.payOrder.success ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800' }` )} > {data.payOrder.success ? t`支付成功` : t`支付失敗`} </html.div> </DetailRow> <DetailRow label={t`支付訂單號`}> {data.payOrder.paymentOrderId} </DetailRow> <DetailRow label={t`業務訂單號`}> {data.payOrder.businessOrderNo} </DetailRow> <DetailRow label={t`支付金額`}> {`${CURRENCY_SYMBOL} ${data.payOrder.amount?.toLocaleString() ?? ''}`} </DetailRow> <DetailRow label={t`支付渠道`}> {data.payOrder.channelName} </DetailRow> {data.payOrder.thirdPartyOrderNo && ( <DetailRow label={t`第三方訂單號`}> {data.payOrder.thirdPartyOrderNo} </DetailRow> )} {data.payOrder.paidTime && ( <DetailRow label={t`支付完成時間`}> {formatFromLocalDateTime(data.payOrder.paidTime)} </DetailRow> )} {!data.payOrder.success && data.payOrder.errorMessage && ( <DetailRow label={t`錯誤資訊`}> <Text style={tw('text-sm text-red-600')}> {data.payOrder.errorMessage} </Text> </DetailRow> )} </DetailSection> )} {/* 反核銷確認 Modal */} <DeleteModal ref={reverseWriteOffModalRef} title={t`確定反核銷？`} confirmText={t`反核銷`} confirmButtonColor="#FF5449" onConfirm={confirmReverseWriteOff} onCancel={() => reverseWriteOffModalRef.current?.close()} loading={reverseWriteOffLoading} > <html.div style={tw('flex flex-col gap-4')}> {/* 提示文字 */} <Text size="sm">{t`確定反核銷以下套餐券`}</Text> {/* 灰色背景展示券碼信息 */} {selectedCoupon && ( <html.div style={tw('bg-gray-100 p-3 rounded-lg flex flex-col gap-2')} > <html.div style={tw('flex justify-between')}> <Text size="sm" style="text-gray-600"> {t`券碼`} </Text> <Text size="sm" bold> {getDisplayCouponCode(selectedCoupon)} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text size="sm" style="text-gray-600"> {t`實付金額`} </Text> <Text size="sm" bold> {formatCurrency( selectedCoupon.actualPaymentAmount ?? selectedCoupon.price )} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text size="sm" style="text-gray-600"> {t`核銷時間`} </Text> <Text size="sm" bold> {selectedCoupon.writeOffTime || '-'} </Text> </html.div> </html.div> )} {/* 底部提示文字 */} <Text size="sm" style="text-gray-600"> {t`券將從「已使用」恢復為「未使用」，該操作不會產生退款，用戶可重新使用此券。請確認已與客戶溝通。`} </Text> </html.div> </DeleteModal> {/* 操作記錄 Modal */} <StandardModal visible={operationLogVisible} title={t`操作記錄`} onClose={() => setOperationLogVisible(false)} showFooter={true} showConfirm={false} closeText={t`關閉`} width="90%" maxHeight="80vh" > {selectedCoupon && ( <html.div style={tw('flex flex-col gap-4')}> {/* 商品資訊 Card */} <Card style="border"> <Text size="md" bold style="mb-3"> {t`商品資訊`} </Text> <html.div style={tw('flex flex-col gap-2')}> <html.div style={tw('flex justify-between')}> <Text size="sm" style="text-gray-600"> {t`券碼`} </Text> <Text size="sm"> {getDisplayCouponCode(selectedCoupon)} </Text> </html.div> <html.div style={tw('flex justify-between')}> <Text size="sm" style="text-gray-600"> {t`有效期間`} </Text> <Text size="sm">{selectedCoupon.validPeriod}</Text> </html.div> <html.div style={tw('flex justify-between')}> <Text size="sm" style="text-gray-600"> {t`狀態`} </Text> <Text size="sm">{selectedCoupon.status}</Text> </html.div> </html.div> </Card> {/* 操作記錄 Table */} <html.div> <Table columns={[ { key: 'operationTime', title: t`時間`, dataIndex: 'operationTime', width: 180, render: (value: unknown) => ( <Text style={tw('text-sm')}> {value ? formatFromLocalDateTime(String(value)) : '-'} </Text> ), }, { key: 'operationType', title: t`操作`, dataIndex: 'operationType', width: 120, render: (value: unknown) => { const typeMap: Record<number, string> = { 1: t`用戶自主核銷`, 2: t`商家核銷`, 3: t`商家撤銷核銷`, 4: t`退款申請中`, 5: t`退款完成`, 6: t`取消`, 7: t`還原`, 8: t`POS核銷`, 9: t`系統過期`, }; return ( <Text style={tw('text-sm')}> {typeMap[Number(value)] || '-'} </Text> ); }, }, { key: 'operationByName', title: t`操作人`, dataIndex: 'operationByName', width: 150, render: (value: unknown, record) => { return ( <Text style={tw('text-sm')}> {value ? String(value) : record.operatedBy ? String(record.operatedBy) : '-'} </Text> ); }, }, ]} dataSource={selectedCoupon.operationLogs || []} rowKey="operationTime" /> </html.div> </html.div> )} </StandardModal> {/* 平台補貼明細 Modal */} {data && ( <StandardModal visible={subsidyDetailVisible} title={t`補貼明細`} onClose={() => setSubsidyDetailVisible(false)} showConfirm={false} width="100%" maxWidth="800px" maxHeight="85vh" > {(() => { if (subsidyLoading) { return ( <html.div style={tw('text-center py-8')}> <Loading inline text={t`載入中...`} /> </html.div> ); } const coupons = subsidyData?.coupons || []; const platformCoupons = coupons.filter( (c) => c.couponsPlatformType === 'admin' ); const merchantCoupons = coupons.filter( (c) => c.couponsPlatformType === 'merchant' ); const platformTotal = subsidyData?.orderPlatformDiscountAmount ?? 0; const merchantTotal = subsidyData?.orderShopDiscountAmount ?? 0; const subsidyColumns = [ { key: 'couponsType', title: t`券類型`, dataIndex: 'couponsType', width: 140, render: (value: unknown) => ( <Text textStyle="body_14"> {getCouponTypeName(value as number)} </Text> ), }, { key: 'couponsName', title: t`券名稱`, dataIndex: 'couponsName', width: 150, render: (value: unknown) => ( <Text textStyle="body_14"> {value ? String(value) : '-'} </Text> ), }, { key: 'couponCode', title: t`券號`, dataIndex: 'couponCode', width: 200, render: (value: unknown) => ( <Text textStyle="body_14"> {value ? String(value) : '-'} </Text> ), }, { key: 'originalDiscountAmount', title: t`抵扣金額`, dataIndex: 'originalDiscountAmount', width: 90, render: (value: unknown) => ( <Text textStyle="body_14"> {formatCurrency(Number(value) || 0)} </Text> ), }, { key: 'activity', title: t`所屬活動`, dataIndex: 'campaign', width: 150, render: (value: unknown, record: { campaignId: string }) => { const c = value as { name?: string } | null; return ( <Text textStyle="body_14"> {c?.name || record.campaignId || '-'} </Text> ); }, }, { key: 'description', title: t`描述`, dataIndex: 'campaign', width: 200, render: ( _value: unknown, record: { originalDiscountAmount: number } ) => { return ( <html.div style={tw('flex flex-col gap-1')}> <Text textStyle="body_14"> {`${t`金額`}：${formatCurrency(record.originalDiscountAmount)}`} </Text> </html.div> ); }, }, { key: 'status', title: t`狀態`, dataIndex: 'usageStatusDesc', width: 90, render: (value: unknown) => ( <Text textStyle="body_14"> {value ? String(value) : '-'} </Text> ), }, ]; const hasAny = platformCoupons.length > 0 || merchantCoupons.length > 0; return ( <html.div style={tw('flex flex-col gap-6')}> {!hasAny && ( <html.div style={tw('text-center py-8')}> <Text textStyle="subvalue_14">{t`無數據`}</Text> </html.div> )} {/* 有平台補貼才顯示 */} {platformCoupons.length > 0 && ( <html.div> <Text textStyle="title_16_bold" style="mb-3 block"> {`${t`平台總計補貼`}：${formatCurrency(platformTotal)}`} </Text> <Table columns={subsidyColumns} dataSource={platformCoupons} rowKey="userCouponId" /> </html.div> )} {/* 有商家補貼才顯示 */} {merchantCoupons.length > 0 && ( <html.div> <Text textStyle="title_16_bold" style="mb-3 block"> {`${t`商家總計補貼`}：${formatCurrency(merchantTotal)}`} </Text> <Table columns={subsidyColumns} dataSource={merchantCoupons} rowKey="userCouponId" /> </html.div> )} {/* 底部：總共實際生效補貼匯總 */} {subsidyData && ( <html.div style={tw( 'border-t border-gray-200 pt-4 mt-2 text-right' )} > <html.div> <Text textStyle="body_14_bold" style="inline" >{`${t`總共實際生效補貼`}：`}</Text> <Text textStyle="body_14_bold" style="inline ml-1"> {formatCurrency( (subsidyData?.orderPlatformDiscountAmount ?? 0) + (subsidyData?.orderShopDiscountAmount ?? 0) - (subsidyData?.totalRefundedDiscountAmount ?? 0) )} </Text> {(() => { const platform = subsidyData?.orderPlatformDiscountAmount ?? 0; const shop = subsidyData?.orderShopDiscountAmount ?? 0; const refund = subsidyData?.totalRefundedDiscountAmount ?? 0; const positiveParts: number[] = []; if (platform > 0) positiveParts.push(platform); if (shop > 0) positiveParts.push(shop); let formula = ''; if (refund > 0) { formula = `=${positiveParts.join('+')}-${refund}`; } else if (positiveParts.length > 1) { formula = `=${positiveParts.join('+')}`; } return formula ? ( <Text textStyle="subvalue_14" style="inline text-gray-400 ml-1" > {formula} </Text> ) : null; })()} </html.div> <Text textStyle="subvalue_14" style="mt-1 block text-right" > {t`平台 + 商家的補貼，在該筆訂單中實際生效的總金額`} </Text> </html.div> )} </html.div> ); })()} </StandardModal> )} </html.div> </Container> ); }; export default OrderDetail; 
#. placeholder {2}: formatCurrency(item.unitPrice)
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2067
msgid "{0}{1} × {2}"
msgstr "{0}{1} × {2}"

#. placeholder {0}: '$'
#. placeholder {1}: formatPrice(review.pricePerPerson)
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:393
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:417
msgid "{0}{1}/人"
msgstr "{0}{1}/人"

#. placeholder {0}: SERVICE_TYPE_LABEL[serviceType] || ''
#. placeholder {1}: isOpened ? '開啟' : '關閉'
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:544
msgid "{0}{1}成功"
msgstr "{0}{1}成功"

#. placeholder {0}: record.minAdvanceHours
#. placeholder {0}: rule.minAdvanceHours
#. placeholder {1}: record.maxAdvanceHours
#. placeholder {1}: rule.maxAdvanceHours
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:395
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:620
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:817
msgid "{0}~{1}小時"
msgstr "{0}~{1}小時"

#. placeholder {0}: item.day
#: apps/dp-business/src/pages/BusinessHours/index.tsx:743
msgid "{0}24小時營業"
msgstr "{0}24小時營業"

#. placeholder {0}: userProfile?.email ? '綁定其他' : '綁定'
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:79
msgid "{0}Email"
msgstr "{0}Email"

#. placeholder {0}: getUnitNameLabel(poiType)
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:859
msgid "{0}不能重複"
msgstr "{0}不能重複"

#. placeholder {0}: conflictOrder?.peopleCount
#. placeholder {0}: order.peopleCount
#. placeholder {0}: data.diningPeopleMin
#: apps/dp-client/src/screens/reservation/pages/main/components/ConflictModal.tsx:68
#: apps/dp-client/src/screens/reservation/components/ReservationCard/index.tsx:129
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:204
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:148
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:903
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:256
msgid "{0}人"
msgstr "{0}人"

#. placeholder {0}: invitationData?.reservationInfo?.peopleCount
#. placeholder {1}: invitationData?.tableTypeName
#: apps/dp-client/src/screens/reservation/pages/invitation/index.tsx:151
msgid "{0}人 {1}"
msgstr "{0}人 {1}"

#. placeholder {0}: item.day
#: apps/dp-business/src/pages/BusinessHours/index.tsx:718
msgid "{0}休息"
msgstr "{0}休息"

#. placeholder {0}: record.manualInterventionTaskCount
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:120
msgid "{0}個任務需人工介入"
msgstr "{0}個任務需人工介入"

#. placeholder {0}: counts.descriptionLength
#. placeholder {0}: countInfo.descriptionLength
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:131
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1019
msgid "{0}個字描述"
msgstr "{0}個字描述"

#. placeholder {0}: counts.facilitiesCount
#. placeholder {0}: countInfo.facilitiesCount
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:124
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1017
msgid "{0}個服務設施"
msgstr "{0}個服務設施"

#. placeholder {0}: tags.length
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantTags/index.web.tsx:61
msgid "{0}個標籤"
msgstr "{0}個標籤"

#. placeholder {0}: cat.foodItemCount
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:924
msgid "{0}個餐點"
msgstr "{0}個餐點"

#. placeholder {0}: coupon.maximumDiscount
#: apps/dp-client/src/components/CouponCard/utils.ts:59
msgid "{0}元"
msgstr "{0}元"

#. placeholder {0}: option.avgFeePerGroup
#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:127
msgid "{0}元/每組"
msgstr "{0}元/每組"

#. placeholder {0}: claimedCouponData.brandName || ''
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:308
msgid "{0}兌換券"
msgstr "{0}兌換券"

#. placeholder {0}: route.title
#: apps/dp-client/src/components/TabView/example.tsx:30
msgid "{0}內容區域"
msgstr "{0}內容區域"

#. placeholder {0}: meters / 1000
#: apps/dp-client/src/screens/home/pages/FoodMap/components/ScaleBar.tsx:36
msgid "{0}公里"
msgstr "{0}公里"

#. placeholder {0}: formData.name.trim()
#. placeholder {0}: values.name.trim()
#: apps/dp-business/src/pages/MenuItemForm.tsx:398
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:315
msgid "{0}出現在了{categoryListStr}中，請核對資訊是否準確"
msgstr "{0}出現在了{categoryListStr}中，請核對資訊是否準確"

#. placeholder {0}: i * 5
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:444
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:445
msgid "{0}分鐘"
msgstr "{0}分鐘"

#. placeholder {0}: trimZero((n / 1000).toFixed(1))
#: apps/dp-client/src/screens/account/pages/user-profile/utils.ts:19
msgid "{0}千"
msgstr "{0}千"

#. placeholder {0}: responsibleInfo.imageLabel
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:170
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:176
msgid "{0}反面"
msgstr "{0}反面"

#. placeholder {0}: result.name
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:119
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:116
msgid "{0}填寫不完整，請檢查"
msgstr "{0}填寫不完整，請檢查"

#. placeholder {0}: Math.round((minutes / (60 * 24)) * 10) / 10
#: apps/dp-client/src/screens/reservation/pages/main/types.ts:49
msgid "{0}天"
msgstr "{0}天"

#. placeholder {0}: nicknameQuota.windowDays
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:216
msgid "{0}天內修改次數已達上限，"
msgstr "{0}天內修改次數已達上限，"

#. placeholder {0}: nicknameQuota.windowDays
#. placeholder {1}: nicknameQuota.limit
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:198
msgid "{0}天內可修改{1}次暱稱"
msgstr "{0}天內可修改{1}次暱稱"

#. placeholder {0}: nicknameQuota.windowDays
#. placeholder {1}: nicknameQuota.limit
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:204
msgid "{0}天內可修改{1}次暱稱，"
msgstr "{0}天內可修改{1}次暱稱，"

#. placeholder {0}: Math.floor(diffInHours / 24)
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:212
msgid "{0}天前"
msgstr "{0}天前"

#. placeholder {0}: Math.max(0, Math.ceil((new Date(record.expireAt).getTime() - Date.now()) / 86400000))
#: apps/dp-business/src/pages/UserManagement/index.tsx:442
msgid "{0}天有效"
msgstr "{0}天有效"

#. placeholder {0}: isEnable ? '啟用' : '停用'
#. placeholder {1}: res.failedCategories?.[0]?.reason
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:554
msgid "{0}失敗：{1}"
msgstr "{0}失敗：{1}"

#. placeholder {0}: getContentLengthWithoutSpaces(content)
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:850
msgid "{0}字"
msgstr "{0}字"

#. placeholder {0}: userProfile?.pwdFlag ? '修改' : '設置'
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:97
msgid "{0}密碼"
msgstr "{0}密碼"

#. placeholder {0}: SERVICE_TYPE_LABEL[serviceType] || ''
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceChangeAuditHistory/index.web.tsx:83
msgid "{0}審核歷史"
msgstr "{0}審核歷史"

#. placeholder {0}: Math.round((minutes / 60) * 10) / 10
#. placeholder {0}: result.tableOccupationTime / 60
#: apps/dp-client/src/screens/reservation/pages/main/types.ts:48
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:287
msgid "{0}小時"
msgstr "{0}小時"

#. placeholder {0}: dayjs(month).format('YYYY')
#. placeholder {0}: selectedYearMonth[0]
#. placeholder {0}: group.year
#: apps/dp-client/src/screens/reservation/components/ReservationCalendar/index.tsx:196
#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:76
#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:373
msgid "{0}年"
msgstr "{0}年"

#. placeholder {0}: currentDate.getFullYear()
#. placeholder {1}: months[currentDate.getMonth()]
#: apps/dp-business/src/components/DatePicker.tsx:419
msgid "{0}年{1}"
msgstr "{0}年{1}"

#. placeholder {0}: selectedYearMonth[0]
#. placeholder {1}: selectedYearMonth[1]
#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:80
msgid "{0}年{1}月"
msgstr "{0}年{1}月"

#. placeholder {0}: newDate.getFullYear()
#. placeholder {0}: date.getFullYear()
#. placeholder {1}: String( newDate.getMonth() + 1 ).padStart(2, '0')
#. placeholder {1}: date.getMonth() + 1
#. placeholder {2}: String(newDate.getDate()).padStart(2, '0')
#. placeholder {2}: date.getDate()
#: apps/dp-client/src/utils/format.ts:56
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:226
msgid "{0}年{1}月{2}日"
msgstr "{0}年{1}月{2}日"

#. placeholder {0}: couponDetail.totalStock
#. placeholder {0}: couponDetail.issuedCount
#. placeholder {0}: couponDetail.usedCount
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:401
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:405
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:514
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:524
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:537
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:770
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:775
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1143
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1145
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1163
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1165
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1187
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1189
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1208
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:466
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:470
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:591
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:603
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:617
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:95
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:899
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:981
msgid "{0}張"
msgstr "{0}張"

#. placeholder {0}: formData.usageCount
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:134
msgid "{0}張/人"
msgstr "{0}張/人"

#. placeholder {0}: previewData.discount
#. placeholder {0}: couponDetail.discountInfo.discountRate
#. placeholder {0}: data.discount
#: apps/dp-business/src/pages/MarketingCenter/components/PreviewCard.tsx:63
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:525
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:301
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:367
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:347
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:390
msgid "{0}折"
msgstr "{0}折"

#. placeholder {0}: shopDetail?.shopName
#. placeholder {1}: shopDetail?.categoryIds ?.reverse() ?.map((item: any) => item.name) ?.join?.('-')
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/hooks.ts:46
msgid "{0}是一家{1}餐廳"
msgstr "{0}是一家{1}餐廳"

#. placeholder {0}: dayjs(month).format('M')
#. placeholder {0}: month + 1
#. placeholder {0}: i + 1
#: apps/dp-client/src/screens/reservation/components/ReservationCalendar/index.tsx:218
#: apps/dp-client/src/screens/account/pages/edit-profile/components/WheelDatePicker/hooks.ts:40
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:33
msgid "{0}月"
msgstr "{0}月"

#. placeholder {0}: date.month() + 1
#. placeholder {0}: date.getMonth() + 1
#. placeholder {1}: date.date()
#. placeholder {1}: date.getDate()
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:90
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewTrendChart.web.tsx:38
msgid "{0}月{1}日"
msgstr "{0}月{1}日"

#. placeholder {0}: counts.videoCount
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:157
msgid "{0}條"
msgstr "{0}條"

#. placeholder {0}: option.label
#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:42
msgid "{0}模板"
msgstr "{0}模板"

#. placeholder {0}: menu.menuName
#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:57
msgid "{0}權限"
msgstr "{0}權限"

#. placeholder {0}: item.count
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/HotIssues.web.tsx:137
msgid "{0}次"
msgstr "{0}次"

#. placeholder {0}: item.rewardsPerUser
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:125
msgid "{0}次/人"
msgstr "{0}次/人"

#. placeholder {0}: item.rewardsPerUser
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:353
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:101
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:133
msgid "{0}次/每人"
msgstr "{0}次/每人"

#. placeholder {0}: topic.noteCount || 0
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteTopicSearchList.tsx:105
msgid "{0}次觀看"
msgstr "{0}次觀看"

#. placeholder {0}: responsibleInfo.imageLabel
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:154
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:160
msgid "{0}正面"
msgstr "{0}正面"

#. placeholder {0}: item.arrivalGuide.driving
#. placeholder {0}: item.arrivalGuide.metro
#. placeholder {0}: item.arrivalGuide.bus
#: apps/dp-business/src/components/MaintenanceList/index.tsx:1033
#: apps/dp-business/src/components/MaintenanceList/index.tsx:1046
#: apps/dp-business/src/components/MaintenanceList/index.tsx:1059
msgid "{0}步"
msgstr "{0}步"

#. placeholder {0}: item.day
#: apps/dp-business/src/pages/BusinessHours/index.tsx:744
msgid "{0}營業時間"
msgstr "{0}營業時間"

#. placeholder {0}: formatReviewTime(video.createdAt) ?? ''
#. placeholder {0}: formatReviewTime(noteDetail?.createdAt)
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/VideoOverlay.tsx:175
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:823
msgid "{0}發佈"
msgstr "{0}發佈"

#. placeholder {0}: dayLabelMap[dayAKey]
#. placeholder {1}: rA.startTime
#. placeholder {2}: rA.endTime
#. placeholder {3}: dayLabelMap[dayBKey]
#. placeholder {4}: rB.startTime
#. placeholder {5}: rB.endTime
#: apps/dp-admin/src/components/BusinessHours/utils.ts:428
msgid "{0}的{periodLabelA}（{1}-{2}）與{3}的{periodLabelB}（{4}-{5}）時間重疊"
msgstr "{0}的{periodLabelA}（{1}-{2}）與{3}的{periodLabelB}（{4}-{5}）時間重疊"

#. placeholder {0}: (num / 10000).toFixed(1)
#. placeholder {0}: trimZero((n / 10000).toFixed(1))
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/VideoInteraction.tsx:30
#: apps/dp-client/src/screens/account/pages/user-profile/utils.ts:21
msgid "{0}萬"
msgstr "{0}萬"

#. placeholder {0}: time.toString()
#: apps/dp-business/src/components/CountdownButton/index.tsx:160
msgid "{0}秒"
msgstr "{0}秒"

#. placeholder {0}: userPoints?.pointsToRanking
#: apps/dp-client/src/screens/diary/pages/my/components/TabSwitch.tsx:176
msgid "{0}積分"
msgstr "{0}積分"

#. placeholder {0}: displayNames.join('，')
#. placeholder {1}: selectedCategories.length
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:183
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:263
msgid "{0}等{1}個類別"
msgstr "{0}等{1}個類別"

#. placeholder {0}: displayNames.join('，')
#. placeholder {1}: selectedDishes.length
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:167
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:247
msgid "{0}等{1}個餐點"
msgstr "{0}等{1}個餐點"

#. placeholder {0}: String(depth)
#: apps/dp-business/src/servers/chain/nodeApi.ts:165
msgid "{0}級"
msgstr "{0}級"

#. placeholder {0}: option.freeGroups
#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:124
msgid "{0}組/月"
msgstr "{0}組/月"

#. placeholder {0}: todayTime[1]
#: apps/dp-client/src/utils/businessStatus.ts:193
#: apps/dp-client/src/utils/businessStatus.ts:252
msgid "{0}結束營業"
msgstr "{0}結束營業"

#. placeholder {0}: d.startDate
#. placeholder {0}: WeekDays[item.weekStart]
#. placeholder {1}: d.endDate
#. placeholder {1}: WeekDays[item.weekEnd]
#: apps/dp-client/src/screens/home/utils/order.ts:1157
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:207
msgid "{0}至{1}"
msgstr "{0}至{1}"

#. placeholder {0}: dayjs(currentPackage?.validityStartTime).format('YYYY/MM/DD')
#. placeholder {1}: dayjs(currentPackage?.validityEndTime).format('YYYY/MM/DD')
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:450
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:113
msgid "{0}至{1}可用"
msgstr "{0}至{1}可用"

#. placeholder {0}: SERVICE_TYPE_LABEL[serviceType] || ''
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:364
msgid "{0}變更已提交審核"
msgstr "{0}變更已提交審核"

#. placeholder {0}: failedNames.join('、')
#: apps/dp-business/src/components/CopyResultView/index.tsx:58
msgid "{0}資訊未複製成功，請重新嘗試"
msgstr "{0}資訊未複製成功，請重新嘗試"

#. placeholder {0}: reward.reward
#: apps/dp-client/src/screens/diary/pages/home/components/points-card/index.tsx:323
msgid "{0}遠傳幣"
msgstr "{0}遠傳幣"

#. placeholder {0}: group?.items?.length
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:292
msgid "{0}選"
msgstr "{0}選"

#. placeholder {0}: group.dishes.length
#. placeholder {0}: group.maxSelectCount
#. placeholder {0}: group.totalCount || dishes.length
#. placeholder {1}: group.selectCount || 1
#. placeholder {1}: group.selectCount
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:156
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:402
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/index.web.tsx:60
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:89
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:501
msgid "{0}選{1}"
msgstr "{0}選{1}"

#. placeholder {0}: todayTime[1]
#: apps/dp-client/src/utils/businessStatus.ts:213
msgid "{0}關門"
msgstr "{0}關門"

#. placeholder {0}: categoryRatings.length
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:84
msgid "{0}項分類"
msgstr "{0}項分類"

#. placeholder {0}: Math.ceil(consumeAmount / maximumDiscount)
#: apps/dp-client/src/screens/account/pages/task-wall/components/rewardLabels.ts:32
msgid "{0}點可兌換1美食金"
msgstr "{0}點可兌換1美食金"

#: apps/dp-business/src/pages/UserManagement/index.tsx:365
msgid "{actionLabel}帳號"
msgstr "{actionLabel}帳號"

#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:342
msgid "{actionText}失敗"
msgstr "{actionText}失敗"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:58
msgid "{actionText}失敗，請稍後重試"
msgstr "{actionText}失敗，請稍後重試"

#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:339
msgid "{actionText}成功"
msgstr "{actionText}成功"

#: apps/dp-business/src/utils/dateRange.ts:120
msgid "{amount}個月後"
msgstr "{amount}個月後"

#: apps/dp-business/src/utils/dateRange.ts:116
msgid "{amount}分鐘後"
msgstr "{amount}分鐘後"

#: apps/dp-business/src/utils/dateRange.ts:119
msgid "{amount}周後"
msgstr "{amount}周後"

#: apps/dp-business/src/utils/dateRange.ts:118
msgid "{amount}天后"
msgstr "{amount}天后"

#: apps/dp-business/src/utils/dateRange.ts:117
msgid "{amount}小時後"
msgstr "{amount}小時後"

#: apps/dp-business/src/utils/dateRange.ts:121
msgid "{amount}年後"
msgstr "{amount}年後"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:556
msgid "{avatarCount}張門市大頭照，{entranceCount}張店門口照片，{storefrontCount}張門牌照片，{environmentCount}張環境照片，{promotionCount}張宣傳照片，{foodCount}張餐點圖片"
msgstr "{avatarCount}張門市大頭照，{entranceCount}張店門口照片，{storefrontCount}張門牌照片，{environmentCount}張環境照片，{promotionCount}張宣傳照片，{foodCount}張餐點圖片"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:238
msgid "{basisTitle}：無變化"
msgstr "{basisTitle}：無變化"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:251
msgid "{basisTitle}。左樹黃底＝有改動的節點，右上角數字為改動數，點下方標籤跳轉。"
msgstr "{basisTitle}。左樹黃底＝有改動的節點，右上角數字為改動數，點下方標籤跳轉。"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:940
msgid "{categoryCount}個分類"
msgstr "{categoryCount}個分類"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:633
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:640
msgid "{categoryCount}個分類，{menuItemCount}個餐點"
msgstr "{categoryCount}個分類，{menuItemCount}個餐點"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:70
msgid "{completedTime}已使用"
msgstr "{completedTime}已使用"

#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:43
msgid "{contentName}正在發佈中"
msgstr "{contentName}正在發佈中"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:286
msgid "{count}人"
msgstr "{count}人"

#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:148
msgid "{count}張"
msgstr "{count}張"

#: apps/dp-business/src/components/CodeVerification/index.tsx:244
msgid "{countdown}s 後重新發送驗證碼"
msgstr "{countdown}s 後重新發送驗證碼"

#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:150
msgid "{createdCount} 間店家成功，{failedCount} 間店家失敗"
msgstr "{createdCount} 間店家成功，{failedCount} 間店家失敗"

#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:149
msgid "{createdCount} 間店家成功，{failedCount} 間店家失敗：{reasons}"
msgstr "{createdCount} 間店家成功，{failedCount} 間店家失敗：{reasons}"

#: apps/dp-client/src/screens/home/utils/order.ts:1171
msgid "{dateStr} {timeStr}可用"
msgstr "{dateStr} {timeStr}可用"

#: apps/dp-client/src/screens/account/pages/edit-profile/components/WheelDatePicker/hooks.ts:62
#: apps/dp-client/src/screens/account/pages/edit-profile/components/DatePickerModal/index.tsx:259
#: apps/dp-client/src/screens/account/pages/edit-profile/components/DatePickerModal/index.tsx:518
msgid "{day}日"
msgstr "{day}日"

#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:64
msgid "{days}天"
msgstr "{days}天"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:572
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:575
msgid "{dayTag}的跨天時段與{nextDayTag}的時段重疊，請調整"
msgstr "{dayTag}的跨天時段與{nextDayTag}的時段重疊，請調整"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:744
msgid "{descriptionCount}段餐廳描述"
msgstr "{descriptionCount}段餐廳描述"

#: apps/dp-client/src/utils/formatTime.ts:58
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:55
msgid "{diffInDays}天前"
msgstr "{diffInDays}天前"

#: apps/dp-client/src/utils/formatTime.ts:54
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:51
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:211
msgid "{diffInHours}小時前"
msgstr "{diffInHours}小時前"

#: apps/dp-client/src/utils/formatTime.ts:50
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:47
msgid "{diffInMinutes}分鐘前"
msgstr "{diffInMinutes}分鐘前"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:359
msgid "{discount}折"
msgstr "{discount}折"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:116
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:110
msgid "{discountRate}折"
msgstr "{discountRate}折"

#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:255
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:237
msgid "{displayId} - {actionType}"
msgstr "{displayId} - {actionType}"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:402
msgid "{f} 正在下載，請稍等"
msgstr "{f} 正在下載，請稍等"

#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:90
msgid "{fee}元/月"
msgstr "{fee}元/月"

#. placeholder {0}: rule.max
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:331
msgid "{field}最多允許{0}個字符"
msgstr "{field}最多允許{0}個字符"

#. placeholder {0}: rule.min
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:328
msgid "{field}最少需要{0}個字符"
msgstr "{field}最少需要{0}個字符"

#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:323
msgid "{field}是必填項"
msgstr "{field}是必填項"

#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:334
msgid "{field}格式不正確"
msgstr "{field}格式不正確"

#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:69
msgid "{hours}小時"
msgstr "{hours}小時"

#: apps/dp-admin/src/components/RichTextEditor/index.web.tsx:218
msgid "{imageCount}/{maxImages} 圖"
msgstr "{imageCount}/{maxImages} 圖"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:105
msgid "{imageDescription}，數量上限為2張圖片"
msgstr "{imageDescription}，數量上限為2張圖片"

#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:103
msgid "{itemCount}個餐點"
msgstr "{itemCount}個餐點"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:622
msgid "{itemCount}道餐點"
msgstr "{itemCount}道餐點"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:69
msgid "{l}"
msgstr "{l}"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:200
msgid "{label} 必須為整數"
msgstr "{label} 必須為整數"

#. placeholder {0}: isPassed ? passText : failText
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:590
msgid "{label}：{0}"
msgstr "{label}：{0}"

#. placeholder {0}: rule.max
#: apps/dp-business/src/components/ValidatedItem/index.tsx:136
msgid "{label}最多允許{0}個字符"
msgstr "{label}最多允許{0}個字元"

#. placeholder {0}: rule.max
#: apps/dp-business/src/components/ValidatedItem/index.tsx:137
msgid "{label}最大值為{0}"
msgstr "{label}最大值為{0}"

#. placeholder {0}: rule.min
#: apps/dp-business/src/components/ValidatedItem/index.tsx:124
msgid "{label}最小值為{0}"
msgstr "{label}最小值為{0}"

#. placeholder {0}: rule.min
#: apps/dp-business/src/components/ValidatedItem/index.tsx:123
msgid "{label}最少需要{0}個字符"
msgstr "{label}最少需要{0}個字元"

#: apps/dp-admin/src/pages/order/order-detail/components/BasicInfo/index.web.tsx:69
msgid "{label}已複製到剪貼簿"
msgstr "{label}已複製到剪貼簿"

#: apps/dp-business/src/components/ValidatedItem/index.tsx:145
msgid "{label}格式不正確"
msgstr "{label}格式不正確"

#: apps/dp-business/src/components/ValidatedItem/index.tsx:95
#: apps/dp-business/src/components/ValidatedItem/index.tsx:107
msgid "{label}為必填項"
msgstr "{label}為必填項"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/index.web.tsx:220
msgid "{levelLabel}渠道列表"
msgstr "{levelLabel}渠道列表"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/variantB/VariantBListCard.tsx:94
msgid "{matchedShopCount}家店可用"
msgstr "{matchedShopCount}家店可用"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:612
msgid "{menuImageCount}張菜單，{categoryCount}個類別，{foodItemCount}個餐點"
msgstr "{menuImageCount}張菜單，{categoryCount}個類別，{foodItemCount}個餐點"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/ScaleBar.tsx:35
msgid "{meters}米"
msgstr "{meters}米"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/diningPeopleTitle.ts:16
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:318
msgid "{min} 人餐"
msgstr "{min} 人餐"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:356
msgid "{min} 次"
msgstr "{min} 次"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:354
msgid "{min} 次以上"
msgstr "{min} 次以上"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/diningPeopleTitle.ts:17
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:319
msgid "{min}-{max} 人餐"
msgstr "{min}-{max} 人餐"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:356
msgid "{min}–{end} 次"
msgstr "{min}–{end} 次"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:464
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:103
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:127
msgid "{minPeople}-{maxPeople}人"
msgstr "{minPeople}-{maxPeople}人"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/MealSummaryCard.tsx:33
msgid "{minPeople}–{maxPeople}人餐"
msgstr "{minPeople}–{maxPeople}人餐"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:462
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:100
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:125
msgid "{minPeople}人"
msgstr "{minPeople}人"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/MealSummaryCard.tsx:32
msgid "{minPeople}人餐"
msgstr "{minPeople}人餐"

#: apps/dp-client/src/screens/home/utils/utils.ts:282
msgid "{minutes}分{seconds}秒"
msgstr "{minutes}分{seconds}秒"

#: apps/dp-client/src/screens/reservation/pages/main/types.ts:47
msgid "{minutes}分鐘"
msgstr "{minutes}分鐘"

#: apps/dp-business/src/utils/dateRange.ts:127
msgid "{minutes}分鐘後"
msgstr "{minutes}分鐘後"

#: apps/dp-client/src/screens/diary/hooks/useUserPunishmentCheck.ts:55
msgid "{month}/{day}"
msgstr "{month}/{day}"

#: apps/dp-client/src/screens/account/pages/edit-profile/components/DatePickerModal/index.tsx:214
#: apps/dp-client/src/screens/account/pages/edit-profile/components/DatePickerModal/index.tsx:478
msgid "{month}月"
msgstr "{month}月"

#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:61
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:60
msgid "{month}月{day}日"
msgstr "{month}月{day}日"

#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:62
msgid "{months}個月"
msgstr "{months}個月"

#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:60
msgid "{months}個月{days}天"
msgstr "{months}個月{days}天"

#: apps/dp-client/src/screens/diary/components/YearMonthPicker/index.tsx:60
#: apps/dp-client/src/screens/diary/components/MonthPicker/index.tsx:43
msgid "{monthStr}月"
msgstr "{monthStr}月"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:86
msgid "{name}（不符合藍新資格）"
msgstr "{name}（不符合藍新資格）"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:85
msgid "{name}（符合藍新資格）"
msgstr "{name}（符合藍新資格）"

#: apps/dp-client/src/screens/login/components/third-party-button/index.tsx:67
msgid "{name}登錄開發中"
msgstr "{name}登錄開發中"

#: apps/dp-admin/src/pages/resource-config/category-management/services/apis.ts:388
msgid "{name}相關品類1"
msgstr "{name}相關品類1"

#: apps/dp-admin/src/pages/resource-config/category-management/services/apis.ts:388
msgid "{name}相關品類2"
msgstr "{name}相關品類2"

#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:467
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:586
msgid "{names}為空，將會覆蓋其他店家，請確認是否繼續"
msgstr "{names}為空，將會覆蓋其他店家，請確認是否繼續"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1025
msgid "{optionLabel}："
msgstr "{optionLabel}："

#: apps/dp-client/src/screens/reservation/pages/detail/components/StatusSection.tsx:115
#: apps/dp-client/src/screens/reservation/components/ReservationSuccessModal/index.tsx:86
#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:115
msgid "{peopleCount}人"
msgstr "{peopleCount}人"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:247
msgid "{platform} 已有版本號 {version}，不可重複。"
msgstr "{platform} 已有版本號 {version}，不可重複。"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/index.web.tsx:46
msgid "{poiName} 活動位配置"
msgstr "{poiName} 活動位配置"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:604
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:607
msgid "{prevDayTag}的跨天時段與{dayTag}的時段重疊，請調整"
msgstr "{prevDayTag}的跨天時段與{dayTag}的時段重疊，請調整"

#: apps/dp-business/src/pages/SimpleDashboard/components/RedeemCard.tsx:57
msgid "{rate}折"
msgstr "{rate}折"

#: apps/dp-client/src/screens/reservation/pages/detail/components/OrderInfoSection.tsx:85
msgid "{remark}"
msgstr "{remark}"

#: apps/dp-client/src/screens/reservation/components/ReservationNotes/index.tsx:65
msgid "{reserveTime}分鐘"
msgstr "{reserveTime}分鐘"

#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:471
msgid "{reviewTotal}則評論"
msgstr "{reviewTotal}則評論"

#. placeholder {0}: category.facilities.length
#: apps/dp-admin/src/pages/merchant/components/StoreSettingsSection/index.web.tsx:293
msgid "{selectedCount} / {0} 項"
msgstr "{selectedCount} / {0} 項"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:681
msgid "{serviceLabel}設定"
msgstr "{serviceLabel}設定"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:58
msgid "{settlementCount} 家店"
msgstr "{settlementCount} 家店"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:53
msgid "{shopCount} 家（保留，標停用）"
msgstr "{shopCount} 家（保留，標停用）"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopOffline.tsx:30
msgid "{shopName}已下架，暫無法提供服務"
msgstr "{shopName}已下架，暫無法提供服務"

#: apps/dp-client/src/screens/home/utils/order.ts:458
msgid "{startDate}至{endDate}"
msgstr "{startDate}至{endDate}"

#: apps/dp-client/src/screens/diary/pages/home/components/points-card/index.tsx:367
msgid "{step} 分"
msgstr "{step} 分"

#. placeholder {0}: failedShops.length
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:170
msgid "{successCount} 位成功，{0} 位失敗"
msgstr "{successCount} 位成功，{0} 位失敗"

#. placeholder {0}: failedShops.length
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:169
msgid "{successCount} 位成功，{0} 位失敗：{reasons}"
msgstr "{successCount} 位成功，{0} 位失敗：{reasons}"

#: apps/dp-client/src/components/QuillRichEditor/QuillRichEditor.native.tsx:606
msgid "{textLength}/{maxLength}"
msgstr "{textLength}/{maxLength}"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:134
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:303
msgid "{timeStr} {operator} 已將該用戶設置為不予中獎，設置原因為 {reason}，確認取消不予中獎設置嗎？"
msgstr "{timeStr} {operator} 已將該用戶設置為不予中獎，設置原因為 {reason}，確認取消不予中獎設置嗎？"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:178
msgid "{title}_獨家套餐券_{name}"
msgstr "{title}_獨家套餐券_{name}"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/MallShopList/index.tsx:264
msgid "{title}_精選店家_{name}"
msgstr "{title}_精選店家_{name}"

#: apps/dp-client/src/components/RefundResonModal/index.tsx:94
msgid "{title}原因"
msgstr "{title}原因"

#: apps/dp-business/src/App.web.tsx:259
msgid "{title}通知"
msgstr "{title}通知"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1205
msgid "{total}則評論"
msgstr "{total}則評論"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ShopArea.tsx:127
msgid "{totalShopsCount}家適用店家"
msgstr "{totalShopsCount}家適用店家"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:394
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:254
msgid "{uncategorizedCount}個菜品未分類"
msgstr "{uncategorizedCount}個餐點未分類"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:368
msgid "{unreadCount} 條未讀"
msgstr "{unreadCount} 條未讀"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:450
msgid "{userLimit}次/人"
msgstr "{userLimit}次/人"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:136
msgid "{val}分"
msgstr "{val}分"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/PackageColumns/index.web.tsx:20
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:66
msgid "{value} 元"
msgstr "{value} 元"

#: apps/dp-admin/src/pages/marketing/components/OverviewSection/index.web.tsx:103
msgid "{value} 張"
msgstr "{value} 張"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:190
msgid "{value}分"
msgstr "{value}分"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:384
msgid "{value}分鐘"
msgstr "{value}分鐘"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:76
msgid "{value}次/每人"
msgstr "{value}次/每人"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:499
msgid "{videoCount}條視頻"
msgstr "{videoCount}條影片"

#: apps/dp-client/src/screens/diary/pages/my/utils.ts:44
msgid "{year}/{month}月"
msgstr "{year}/{month}月"

#: apps/dp-client/src/screens/diary/components/YearMonthPicker/index.tsx:66
#: apps/dp-client/src/screens/account/pages/edit-profile/components/WheelDatePicker/hooks.ts:26
#: apps/dp-client/src/screens/account/pages/edit-profile/components/DatePickerModal/index.tsx:173
#: apps/dp-client/src/screens/account/pages/edit-profile/components/DatePickerModal/index.tsx:440
msgid "{year}年"
msgstr "{year}年"

#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:68
msgid "{year}年{month}月{day}日"
msgstr "{year}年{month}月{day}日"

#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:57
msgid "{years}年"
msgstr "{years}年"

#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:55
msgid "{years}年{months}個月"
msgstr "{years}年{months}個月"

#: apps/dp-client/src/screens/login/components/privacy-agreement/index.tsx:75
msgid "《去哪吃使用條款》"
msgstr "《去哪吃使用條款》"

#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:157
msgid "《美食日記使用條款》"
msgstr "《美食日記使用條款》"

#: apps/dp-client/src/screens/login/components/privacy-agreement/index.tsx:80
#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:164
msgid "《隱私權政策》"
msgstr "《隱私權政策》"

#. placeholder {0}: failed.join('、')
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1778
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1227
msgid "「{0}」查詢結算路徑版本失敗，請稍後重試"
msgstr "「{0}」查詢結算路徑版本失敗，請稍後重試"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1759
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1209
msgid "「{names}」已掛在本樹其他節點，調整掛接不支持同時設為結算路徑，請關閉開關或取消勾選"
msgstr "「{names}」已掛在本樹其他節點，調整掛接不支持同時設為結算路徑，請關閉開關或取消勾選"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:16
msgid "「任一完成即可（或）」表示用戶完成其中任何一條即可發獎；「需全部命中（且）」表示必須完成全部觸發條件才發獎。"
msgstr "「任一完成即可（或）」表示用戶完成其中任何一條即可發獎；「需全部命中（且）」表示必須完成全部觸發條件才發獎。"

#: apps/dp-business/src/pages/Login/index.tsx:890
#: apps/dp-business/src/pages/Login/index.tsx:1364
msgid "「去哪吃」✋🏻店家平台"
msgstr "「去哪吃」✋🏻店家平台"

#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:87
msgid "「寶島點評」想使用你的位置"
msgstr "「去哪吃」想使用您的定位"

#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:75
#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:107
msgid "「寶島點評」想存取你的照片"
msgstr "「去哪吃」想存取您的照片"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:81
msgid "「店家環境」這樣拍"
msgstr "「店家環境」這樣拍"

#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:81
msgid "「美食日記」想存取你的照片"
msgstr "「美食日記」想存取你的照片"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:20
msgid "「首次」表示第一次達成就發，整個活動每位用戶最多領取一次。「每次」表示每次達成都可發獎，仍受獎勵限制約束；可按整個活動或每週期設定領取上限。獎勵週期與活動生效時間分開設定。"
msgstr "「首次」表示第一次達成就發，整個活動每位用戶最多領取一次。「每次」表示每次達成都可發獎，仍受獎勵限制約束；可按整個活動或每週期設定領取上限。獎勵週期與活動生效時間分開設定。"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:518
msgid "【{merchantName}】的這個【{packageName}】CP值超高，快來搶購！"
msgstr "【{merchantName}】的這個【{packageName}】CP值超高，快來搶購！"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:99
msgid "【你可以寫這些內容】"
msgstr "【你可以寫這些內容】"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:12
msgid "【去哪吃】"
msgstr "【去哪吃】"

#. placeholder {0}: voucherName || EMPTY_TEXT
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCells.tsx:98
msgid "【套餐券名稱】{0}"
msgstr "【套餐券名稱】{0}"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:107
msgid "【我們獨特的美食記錄方式】"
msgstr "【我們獨特的美食記錄方式】"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:103
msgid "【為什麼要寫美食筆記？】"
msgstr "【為什麼要寫美食筆記？】"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:95
msgid "【美食筆記是什麼？】"
msgstr "【美食筆記是什麼？】"

#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:46
msgid "【銷售推廣】三人套餐"
msgstr "【銷售推廣】三人套餐"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:265
msgid "【限時優惠】三人套餐"
msgstr "【限時優惠】三人套餐"

#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:159
msgid "【限時優惠】全場8折券"
msgstr "【限時優惠】全場8折券"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:46
msgid "【限時優惠】全店滿減券 500 元折 100 元"
msgstr "【限時優惠】全店滿額折扣券 500 元折 100 元"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1691
msgid "*"
msgstr "*"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:248
msgid "*加碼結帳折扣（1-100整數）"
msgstr "*加碼結帳折扣（1-100整數）"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:282
msgid "*折扣金額上限（大於0的整數）"
msgstr "*折扣金額上限（大於0的整數）"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:313
msgid "*結帳折扣可用次數"
msgstr "*結帳折扣可用次數"

#. placeholder {0}: parseInt(part)
#: apps/dp-client/src/screens/diary/pages/my/components/MyDiaryContent.tsx:268
msgid "/{0}月"
msgstr "/{0}月"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:79
msgid "／末級"
msgstr "／末級"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitCard/index.web.tsx:85
msgid "% 折抵券"
msgstr "% 折抵券"

#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:160
msgid "• List"
msgstr "• List"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:347
msgid "• 不可使用 +886-"
msgstr "• 不可使用 +886-"

#: apps/dp-business/src/pages/StoreDescription.tsx:195
msgid "• 可以將店家的亮點和業務規則輸入在此"
msgstr "• 可以將店家的亮點和業務規則輸入在此"

#: apps/dp-admin/src/pages/merchant/components/ImageOperationTips/index.web.tsx:32
msgid "• 可透過拖曳調整圖片顯示順序"
msgstr "• 可透過拖曳調整圖片顯示順序"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:322
msgid "• 國際格式：+886 + 去掉開頭0的號碼"
msgstr "• 國際格式：+886 + 去掉開頭0的號碼"

#: apps/dp-admin/src/pages/merchant/components/ImageOperationTips/index.web.tsx:31
msgid "• 圖片將自動壓縮和最佳化以提升載入速度"
msgstr "• 圖片將自動壓縮和最佳化以提升載入速度"

#: apps/dp-admin/src/pages/merchant/components/ImageOperationTips/index.web.tsx:29
msgid "• 圖片庫中的圖片將在商家詳情頁面中展示"
msgstr "• 圖片庫中的圖片將在商家詳情頁面中展示"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:758
msgid "• 套餐內容、價格、有效期等核心資訊將無法再修改。"
msgstr "• 套餐內容、價格、有效期等核心資訊將無法再修改。"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:319
msgid "• 客服專線：0800 或 0809 開頭（例如：0800-123-456）"
msgstr "• 客服專線：0800 或 0809 開頭（例如：0800-123-456）"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:759
msgid "• 已購用戶將依照目前設定的規則享有使用權。"
msgstr "• 已購用戶將依照目前設定的規則享有使用權。"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:316
msgid "• 市話號碼：含區碼 9～10 碼，可加 -（例如：02-12345678）"
msgstr "• 市話號碼：含區碼 9～10 碼，可加 -（例如：02-12345678）"

#: apps/dp-admin/src/pages/merchant/components/ImageOperationTips/index.web.tsx:30
msgid "• 建議上傳高品質、清晰的商家實景照片"
msgstr "• 建議上傳高品質、清晰的商家實景照片"

#: apps/dp-business/src/pages/OnboardingComplete/index.tsx:115
msgid "• 您可以登入商家後臺管理您的店家"
msgstr "• 您可以登入商家後台管理您的店家"

#: apps/dp-business/src/pages/OnboardingComplete/index.tsx:116
msgid "• 您可以開始接收訂單並提供服務"
msgstr "• 您可以開始接收訂單並提供服務"

#: apps/dp-business/src/pages/OnboardingComplete/index.tsx:112
msgid "• 您將收到審核通過的簡訊通知"
msgstr "• 您將收到審核通過的簡訊通知"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:313
msgid "• 手機號碼：09 開頭，共 10 碼（例如：0987654321）"
msgstr "• 手機號碼：09 開頭，共 10 碼（例如：0987654321）"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:355
msgid "• 正確格式：+886-987654321（去掉開頭的0）"
msgstr "• 正確格式：+886-987654321（去掉開頭的0）"

#: apps/dp-business/src/pages/StoreDescription.tsx:200
msgid "• 請不要重複填寫已經有的資訊，比如營業時間"
msgstr "• 請不要重複填寫已經有的資訊，比如營業時間"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:303
msgid "※ 各目標落地後均固定帶入權益的商家圈選（同一商家組）作為預設篩選，C 端不可手動移除；權益為全平台通用券（無圈選）時不帶入限制。"
msgstr "※ 各目標落地後均固定帶入權益的商家圈選（同一商家組）作為預設篩選，C 端不可手動移除；權益為全平台通用券（無圈選）時不帶入限制。"

#: apps/dp-admin/src/pages/login/index.web.tsx:91
msgid "© 2025 營運管理系統版權所有"
msgstr "© 2025 營運管理系統版權所有"

#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:343
#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:73
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/index.web.tsx:169
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:847
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:343
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:62
#: apps/dp-admin/src/pages/marketing/activity-detail-list/index.web.tsx:317
msgid "← 返回"
msgstr "← 返回"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:151
msgid "+ {quantity}（本次追加）"
msgstr "+ {quantity}（本次追加）"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:194
msgid "+ 新增圍欄"
msgstr "+ 新增圍欄"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:295
msgid "+ 新增店家電話"
msgstr "+ 新增店家電話"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:1508
msgid "+ 新增特殊日期"
msgstr "+ 新增特殊日期"

#. placeholder {0}: reward.points
#: apps/dp-client/src/hooks/tasks/useTaskRewardFeedback.ts:78
msgid "+{0}"
msgstr "+{0}"

#. placeholder {0}: shop.availablePoints
#. placeholder {0}: diaryPoints || 0
#. placeholder {0}: shopInfoPoints || 0
#: apps/dp-client/src/screens/diary/components/shop-list-card/index.tsx:83
#: apps/dp-client/src/screens/diary/components/MissionsModal/index.tsx:135
#: apps/dp-client/src/screens/diary/components/MissionsModal/index.tsx:171
#: apps/dp-business/src/components/StoreInfoCard/index.tsx:183
msgid "+{0}分"
msgstr "+{0}分"

#: apps/dp-client/src/screens/diary/components/points-display/index.tsx:24
#: apps/dp-client/src/screens/diary/components/points-display/index.tsx:36
msgid "＋{points} 分"
msgstr "＋{points} 分"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:335
msgid "+字形"
msgstr "+字形"

#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:157
msgid "+新增標籤"
msgstr "+新增標籤"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/QuickFilterChips.tsx:44
msgid "<$200"
msgstr "<$200"

#: apps/dp-client/src/screens/login/components/privacy-agreement-modal/index.tsx:70
msgid "<0>首次登入會自動建立新帳號，且代表同意</0><1>使用條款</1><2>和</2><3>隱私權政策</3>"
msgstr "<0>首次登入會自動建立新帳號，且代表同意</0><1>使用條款</1><2>和</2><3>隱私權政策</3>"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:130
msgid ""
"<Collapse title=\"範例\">\n"
"  <p>內容</p>\n"
"</Collapse>"
msgstr ""
"<Collapse title=\"範例\">\n"
"  <p>內容</p>\n"
"</Collapse>"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:328
msgid "◦ +886-2-1234-5678（臺北市話）"
msgstr "◦ +886-2-1234-5678（臺北市話）"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:331
msgid "◦ +886-800-123-456（客服專線）"
msgstr "◦ +886-800-123-456（客服專線）"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:325
msgid "◦ +886-987-654-321（手機）"
msgstr "◦ +886-987-654-321（手機）"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:684
msgid "⚠️ 使用限制與領取限制可能有矛盾，請檢查設定"
msgstr "⚠️ 使用限制與領取限制可能有矛盾，請檢查設定"

#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:711
msgid "✓ 位置取得成功"
msgstr "✓ 位置取得成功"

#. placeholder {0}: (shop.avgPrice / 100).toFixed(0)
#: apps/dp-client/src/screens/home/pages/FoodMap/components/HorizontalShopCard.tsx:166
#: apps/dp-client/src/screens/home/pages/FoodMap/components/ShopList/MapShopCard.tsx:164
#: apps/dp-client/src/screens/home/components/ShopCard/index.tsx:391
msgid "${0}/人"
msgstr "${0}/人"

#: apps/dp-client/src/components/ShopBriefCard/index.tsx:62
msgid "${averagePrice}"
msgstr "${averagePrice}"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:43
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:54
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:65
msgid "$120/小時"
msgstr "$120/小時"

#: apps/dp-business/src/components/DragContainer.tsx:218
msgid "0 4px 12px rgba(0, 0, 0, 0.1)"
msgstr "0 4px 12px rgba(0, 0, 0, 0.1)"

#: apps/dp-business/src/components/DragContainer.tsx:216
msgid "0 8px 25px rgba(0, 0, 0, 0.15)"
msgstr "0 8px 25px rgba(0, 0, 0, 0.15)"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1146
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1166
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1190
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1209
msgid "0 張"
msgstr "0 張"

#: apps/dp-client/src/screens/home/utils/filterData.ts:204
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:127
msgid "0-6時"
msgstr "0-6 時"

#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:106
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:145
#: apps/dp-admin/src/pages/data-center/services/constants.ts:60
msgid "0.5-1星"
msgstr "0.5-1星"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:87
msgid "0.5小時"
msgstr "0.5小時"

#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:90
msgid "0元/月"
msgstr "0元/月"

#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:127
#: apps/dp-business/src/pages/CouponVerification/index.tsx:417
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:571
msgid "1 人份"
msgstr "1 人份"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:102
msgid "1 至 10000"
msgstr "1 至 10000"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:53
msgid "① 跳轉鏈接"
msgstr "① 跳轉鏈接"

#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:60
msgid "1-2 星"
msgstr "1-2 星"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:442
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:192
msgid "1-20字元，允許中文/英文/數字/點/底線"
msgstr "1-20 字元，允許中文/英文/數字/點/底線"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:482
msgid "1-3個工作天退還至原付款帳戶"
msgstr "1-3個工作天退還至原付款帳戶"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:352
msgid "1–{end} 次"
msgstr "1–{end} 次"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:38
msgid ""
"1、本平台僅提供美食與餐廳體驗分享相關內容之張貼。\n"
"2、請僅張貼合法、真實，且不侵犯他人權益的原創內容。\n"
"3、不得張貼不實、辱罵、攻擊、色情、不雅，或違反法律與善良風俗的內容。\n"
"4、不得張貼含廣告與導流宣傳內容，或利益衝突等相關資訊。\n"
"5、平台有權移除違規內容，並視情況限制或停用帳號。"
msgstr ""
"1、本平台僅提供美食與餐廳體驗分享相關內容之張貼。\n"
"2、請僅張貼合法、真實，且不侵犯他人權益的原創內容。\n"
"3、不得張貼不實、辱罵、攻擊、色情、不雅，或違反法律與善良風俗的內容。\n"
"4、不得張貼含廣告與導流宣傳內容，或利益衝突等相關資訊。\n"
"5、平台有權移除違規內容，並視情況限制或停用帳號。"

#: apps/dp-business/src/pages/Settings/index.tsx:174
msgid "1、開啟語音播報後，套餐券核銷成功、結帳付款成功，都會自動播放提示音。"
msgstr "1、開啟語音播報後，套餐券核銷成功、結帳付款成功，都會自動播放提示音。"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:203
msgid ""
"1. 帳號相關服務(包含我的美食日記及去哪吃)。\n"
"2. 同意刪除帳號，視同放棄原帳號內的個人資料，包含行動門號、電子信箱。\n"
"3. 在完成刪除帳號後，您將無法登入使用原帳號，亦無法查詢原帳號相關服務資訊。"
msgstr ""
"1. 帳號相關服務(包含我的美食日記及去哪吃)。\n"
"2. 同意刪除帳號，視同放棄原帳號內的個人資料，包含行動門號、電子信箱。\n"
"3. 在完成刪除帳號後，您將無法登入使用原帳號，亦無法查詢原帳號相關服務資訊。"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:77
msgid ""
"1. 本活動限首次註冊「去哪吃」用戶參加，且需完成「去哪吃」新用戶註冊程序，始具備本活動參與資格。\n"
"2. 每位用戶限領「註冊有禮」票券乙次，票券採程式隨機配獎，票券品項為結帳折扣$500一張、結帳折扣5%兩張(使用金額上限$50)，星巴克星享飲料券$110一張。\n"
"3. 票券限本人使用，不得轉贈。票券使用期間以券上時間為準，逾期恕不補發。\n"
"4. 結帳折扣限臺灣地區之合作活動商家使用，合作活動商家以票券列表為準，單筆交易限使用一張，無法併用，結帳折扣僅限使用本平台支持的結帳方式完成付款。票券金額未使用完畢，恕不退還差額、找零亦不得更換現金或其他商品，禁止轉讓、轉售與退換貨，有效期限以票券揭露為準，逾期失效恕不補發，其他注意事項依票券揭露為準。\n"
"5. 星巴克星享飲料券$110使用辦法：用戶可於兌換期間內，開啟去哪吃>票券匣>選擇該票券，並於全臺灣星巴克持條碼兌換，部分店別不適用，請以星巴克商店實際可提供商品之店家為準。\n"
"6. 隱私權聲明：參加本活動即視為同意聚流平台科技股份有限公司得於本活動之目的範圍內（包括但不限於資格驗證、獎項發放等），蒐集、處理及利用其個人資料。相關權利義務及處理方式，請詳閱聚流平台科技股份有限公司之隱私權政策。\n"
"7. 活動變更與終止：若因天災、或任何其他不可抗力或不可歸責於主辦單位之事由，致使活動的公平性或正常執行受到影響時，聚流有權決定取消、終止、修改或暫停本活動，並將於本活動網站上公告，恕不另行通知。\n"
"8. 準據法與管轄法院：本活動之一切事宜，均以中華民國法律為準據法。因本活動所生或與本活動有關之任何爭議，各方同意以臺灣臺北地方法院為第一審管轄法院。\n"
"9. 本活動參加者參與本活動，即視為已詳閱並同意接受本活動所有條款與條件。就本活動之一切相關事宜，若本活動條款與條件之約定與協辦單位相關服務契約、「去哪吃註冊有禮」使用條款或隱私權政策有任何歧異或衝突之處，應以本活動條款與條件之規定為準。本活動辦法如有未盡事宜，聚流保留得隨時補充或修正之權利，或由聚流本於誠信原則解釋之。\n"
"10. 聚流保留對本活動最終內容修改、變更、取消、終止、或暫停之權利。本活動相關內容及規範，悉依最終公告內容為準。"
msgstr ""
"1. 本活動限首次註冊「去哪吃」用戶參加，且需完成「去哪吃」新用戶註冊程序，始具備本活動參與資格。\n"
"2. 每位用戶限領「註冊有禮」票券乙次，票券採程式隨機配獎，票券品項為結帳折扣$500一張、結帳折扣5%兩張(使用金額上限$50)，星巴克星享飲料券$110一張。\n"
"3. 票券限本人使用，不得轉贈。票券使用期間以券上時間為準，逾期恕不補發。\n"
"4. 結帳折扣限臺灣地區之合作活動商家使用，合作活動商家以票券列表為準，單筆交易限使用一張，無法併用，結帳折扣僅限使用本平台支持的結帳方式完成付款。票券金額未使用完畢，恕不退還差額、找零亦不得更換現金或其他商品，禁止轉讓、轉售與退換貨，有效期限以票券揭露為準，逾期失效恕不補發，其他注意事項依票券揭露為準。\n"
"5. 星巴克星享飲料券$110使用辦法：用戶可於兌換期間內，開啟去哪吃>票券匣>選擇該票券，並於全臺灣星巴克持條碼兌換，部分店別不適用，請以星巴克商店實際可提供商品之店家為準。\n"
"6. 隱私權聲明：參加本活動即視為同意聚流平台科技股份有限公司得於本活動之目的範圍內（包括但不限於資格驗證、獎項發放等），蒐集、處理及利用其個人資料。相關權利義務及處理方式，請詳閱聚流平台科技股份有限公司之隱私權政策。\n"
"7. 活動變更與終止：若因天災、或任何其他不可抗力或不可歸責於主辦單位之事由，致使活動的公平性或正常執行受到影響時，聚流有權決定取消、終止、修改或暫停本活動，並將於本活動網站上公告，恕不另行通知。\n"
"8. 準據法與管轄法院：本活動之一切事宜，均以中華民國法律為準據法。因本活動所生或與本活動有關之任何爭議，各方同意以臺灣臺北地方法院為第一審管轄法院。\n"
"9. 本活動參加者參與本活動，即視為已詳閱並同意接受本活動所有條款與條件。就本活動之一切相關事宜，若本活動條款與條件之約定與協辦單位相關服務契約、「去哪吃註冊有禮」使用條款或隱私權政策有任何歧異或衝突之處，應以本活動條款與條件之規定為準。本活動辦法如有未盡事宜，聚流保留得隨時補充或修正之權利，或由聚流本於誠信原則解釋之。\n"
"10. 聚流保留對本活動最終內容修改、變更、取消、終止、或暫停之權利。本活動相關內容及規範，悉依最終公告內容為準。"

#. placeholder {0}: impactTemplates.length
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:996
msgid "1. 狀態變更為已下架，會自動下架共 {0} 個套餐券，請確認"
msgstr "1. 狀態變更為已下架，會自動下架共 {0} 個套餐券，請確認"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:912
msgid "1. 請確保上傳的合約為完整的原始文檔，文字清晰可辨識"
msgstr "1. 請確保上傳的合約為完整的原始文件，文字清晰可辨識"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:41
msgid "1. 資訊收集"
msgstr "1. 資訊收集"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:602
msgid "1. 顧客可能於未實際到店或未消費前完成核銷"
msgstr "1. 顧客可能於未實際到店或未消費前完成核銷"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:31
msgid "1.0.0"
msgstr "1.0.0"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:32
msgid "1.0.1"
msgstr "1.0.1"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:33
msgid "1.0.2"
msgstr "1.0.2"

#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:105
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:141
#: apps/dp-admin/src/pages/data-center/services/constants.ts:56
msgid "1.5-2星"
msgstr "1.5-2星"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:128
msgid "1.5小時"
msgstr "1.5小時"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:171
msgid "1.如有相同角色，會覆蓋該角色原有權限設定"
msgstr "1.如有相同角色，會覆蓋該角色原有權限設定"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1661
#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:154
msgid "1.本券優惠期間以票券標示內容為準。若逾期未兌換，本平台將於到期後次一工作日針對未使用序號按比例自動辦理全額退款。"
msgstr "1.本券優惠期間以票券標示內容為準。若逾期未兌換，本平台將於到期後次一工作日針對未使用序號按比例自動辦理全額退款。"

#: apps/dp-client/src/screens/home/pages/Purchase/components/RuleModal/index.tsx:30
msgid ""
"1.本活動限首次註冊「去哪吃」用戶參加，且需完成「去哪吃」新用戶註冊程序，始具備本活動參與資格。\n"
"2.        每位用戶限領「註冊有禮」票券乙次，票券採程式隨機配獎，票券品項為結帳折扣$500一張、結帳折扣5%兩張(使用金額上限$50)，星巴克星享飲料券$110一張。\n"
"3.        票券限本人使用，不得轉贈。票券使用期間以券上時間為準，逾期恕不補發。\n"
"4.        結帳折扣限臺灣地區之合作活動商家使用，合作活動商家以票券列表為準，單筆交易限使用一張，無法併用，結帳折扣僅限使用本平台支持的結帳方式完成付款。票券金額未使用完畢，恕不退還差額、找零亦不得更換現金或其他商品，禁止轉讓、轉售與退換貨，有效期限以票券揭露為準，逾期失效恕不補發，其他注意事項依票券揭露為準。\n"
"5.        星巴克星享飲料券$110使用辦法：用戶可於兌換期間內，開啟去哪吃>票券匣>選擇該票券，並於全臺灣星巴克持條碼兌換，部分店別不適用，請以星巴克商店實際可提供商品之店家為準。\n"
"6.        隱私權聲明：參加本活動即視為同意聚流平台科技股份有限公司得於本活動之目的範圍內（包括但不限於資格驗證、獎項發放等），蒐集、處理及利用其個人資料。相關權利義務及處理方式，請詳閱聚流平台科技股份有限公司之隱私權政策。\n"
"7.        活動變更與終止：若因天災、或任何其他不可抗力或不可歸責於主辦單位之事由，致使活動的公平性或正常執行受到影響時，聚流有權決定取消、終止、修改或暫停本活動，並將於本活動網站上公告，恕不另行通知。\n"
"8.        準據法與管轄法院：本活動之一切事宜，均以中華民國法律為準據法。因本活動所生或與本活動有關之任何爭議，各方同意以臺灣臺北地方法院為第一審管轄法院。\n"
"9.        本活動參加者參與本活動，即視為已詳閱並同意接受本活動所有條款與條件。就本活動之一切相關事宜，若本活動條款與條件之約定與協辦單位相關服務契約、「去哪吃註冊有禮」使用條款或隱私權政策有任何歧異或衝突之處，應以本活動條款與條件之規定為準。本活動辦法如有未盡事宜，聚流保留得隨時補充或修正之權利，或由聚流本於誠信原則解釋之。\n"
"10.        聚流保留對本活動最終內容修改、變更、取消、終止、或暫停之權利。本活動相關內容及規範，悉依最終公告內容為準。"
msgstr ""
"1.本活動限首次註冊「去哪吃」用戶參加，且需完成「去哪吃」新用戶註冊程序，始具備本活動參與資格。\n"
"2.        每位用戶限領「註冊有禮」票券乙次，票券採程式隨機配獎，票券品項為結帳折扣$500一張、結帳折扣5%兩張(使用金額上限$50)，星巴克星享飲料券$110一張。\n"
"3.        票券限本人使用，不得轉贈。票券使用期間以券上時間為準，逾期恕不補發。\n"
"4.        結帳折扣限臺灣地區之合作活動商家使用，合作活動商家以票券列表為準，單筆交易限使用一張，無法併用，結帳折扣僅限使用本平台支持的結帳方式完成付款。票券金額未使用完畢，恕不退還差額、找零亦不得更換現金或其他商品，禁止轉讓、轉售與退換貨，有效期限以票券揭露為準，逾期失效恕不補發，其他注意事項依票券揭露為準。\n"
"5.        星巴克星享飲料券$110使用辦法：用戶可於兌換期間內，開啟去哪吃>票券匣>選擇該票券，並於全臺灣星巴克持條碼兌換，部分店別不適用，請以星巴克商店實際可提供商品之店家為準。\n"
"6.        隱私權聲明：參加本活動即視為同意聚流平台科技股份有限公司得於本活動之目的範圍內（包括但不限於資格驗證、獎項發放等），蒐集、處理及利用其個人資料。相關權利義務及處理方式，請詳閱聚流平台科技股份有限公司之隱私權政策。\n"
"7.        活動變更與終止：若因天災、或任何其他不可抗力或不可歸責於主辦單位之事由，致使活動的公平性或正常執行受到影響時，聚流有權決定取消、終止、修改或暫停本活動，並將於本活動網站上公告，恕不另行通知。\n"
"8.        準據法與管轄法院：本活動之一切事宜，均以中華民國法律為準據法。因本活動所生或與本活動有關之任何爭議，各方同意以臺灣臺北地方法院為第一審管轄法院。\n"
"9.        本活動參加者參與本活動，即視為已詳閱並同意接受本活動所有條款與條件。就本活動之一切相關事宜，若本活動條款與條件之約定與協辦單位相關服務契約、「去哪吃註冊有禮」使用條款或隱私權政策有任何歧異或衝突之處，應以本活動條款與條件之規定為準。本活動辦法如有未盡事宜，聚流保留得隨時補充或修正之權利，或由聚流本於誠信原則解釋之。\n"
"10.        聚流保留對本活動最終內容修改、變更、取消、終止、或暫停之權利。本活動相關內容及規範，悉依最終公告內容為準。"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:357
msgid "1）上述的金額請開立在同一張收據，收據上註明本次所申請的「結算週期」期間"
msgstr "1）上述的金額請開立在同一張收據，收據上註明本次所申請的「結算週期」期間"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:304
msgid "1）上述的金額請開立在同一張發票，發票上註明本次所申請的「結算週期」期間"
msgstr "1）上述的金額請開立在同一張發票，發票上註明本次所申請的「結算週期」期間"

#: apps/dp-client/src/screens/home/utils/filterData.ts:214
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:137
msgid "10-14時"
msgstr "10-14 時"

#: apps/dp-client/src/screens/home/utils/filterData.ts:162
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:72
msgid "1000以上"
msgstr "1000以上"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:88
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:125
msgid "10分鐘"
msgstr "10分鐘"

#: apps/dp-business/src/components/ExpoUpdate/index.tsx:23
msgid "10分鐘後提醒我"
msgstr "10分鐘後提醒我"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:112
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:126
#: apps/dp-business/src/components/DatePicker.tsx:246
msgid "10月"
msgstr "10月"

#: apps/dp-business/src/utils/validation.ts:138
#: apps/dp-business/src/utils/validation.ts:345
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1063
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1162
msgid "10碼，1位字母+9位數字"
msgstr "10碼，1位字母+9位數字"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:63
msgid "1117財團法人臺灣早產兒基金會"
msgstr "1117財團法人臺灣早產兒基金會"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:113
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:127
#: apps/dp-business/src/components/DatePicker.tsx:247
msgid "11月"
msgstr "11月"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:114
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:128
#: apps/dp-business/src/components/DatePicker.tsx:248
msgid "12月"
msgstr "12月"

#: apps/dp-client/src/screens/home/utils/filterData.ts:219
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:142
msgid "14-17時"
msgstr "14-17 時"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:86
msgid "14天"
msgstr "14天"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/index.web.tsx:98
msgid "15分"
msgstr "15分"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:131
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:492
msgid "15分鐘"
msgstr "15分鐘"

#: apps/dp-business/src/utils/validation.ts:240
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:944
msgid "16碼，1位字母+15位數字，例如：A123456789000000"
msgstr "16碼，1位字母+15位數字，例如：A123456789000000"

#: apps/dp-client/src/screens/home/utils/filterData.ts:224
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:147
msgid "17-21時"
msgstr "17-21 時"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:77
msgid "1人"
msgstr "1人"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:183
msgid "1分"
msgstr "1分"

#: apps/dp-business/src/utils/dateRange.ts:138
msgid "1分鐘前"
msgstr "1分鐘前"

#: apps/dp-business/src/utils/dateRange.ts:116
msgid "1分鐘後"
msgstr "1分鐘後"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:85
#: apps/dp-business/src/store/ReservationRulesContext.tsx:130
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:121
msgid "1小時"
msgstr "1小時"

#: apps/dp-business/src/utils/dateRange.ts:139
msgid "1小時前"
msgstr "1小時前"

#: apps/dp-business/src/utils/dateRange.ts:117
msgid "1小時後"
msgstr "1小時後"

#: apps/dp-admin/src/pages/data-center/merchant-stats/services/hooks.tsx:122
msgid "1星"
msgstr "1星"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:103
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:117
#: apps/dp-business/src/components/DatePicker.tsx:237
msgid "1月"
msgstr "1月"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:348
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:352
msgid "1次"
msgstr "1次"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:450
msgid "1次/人"
msgstr "1次/人"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:102
msgid "② 兜底頁面"
msgstr "② 兜底頁面"

#: apps/dp-business/src/pages/Settings/index.tsx:175
msgid "2、電腦端：瀏覽器登錄【去哪吃店家端】即可播放；不關閉網頁，切換其他視窗也能收到提示。建議停留在該頁面，確保播放功能正常。"
msgstr "2、電腦端：瀏覽器登錄【去哪吃店家端】即可播放；不關閉網頁，切換其他視窗也能收到提示。建議停留在該頁面，確保播放功能正常。"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:915
msgid "2. 支援上傳PDF、JPG、PNG格式，單個檔案不超過20MB"
msgstr "2. 支援上傳PDF、JPG、PNG格式，單個檔案不超過20MB"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:605
msgid "2. 核銷後若產生爭議，需由商家與顧客自行溝通處理"
msgstr "2. 核銷後若產生爭議，需由商家與顧客自行溝通處理"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:74
msgid "2. 資訊使用"
msgstr "2. 資訊使用"

#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:104
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:137
#: apps/dp-admin/src/pages/data-center/services/constants.ts:52
msgid "2.5-3星"
msgstr "2.5-3星"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:174
msgid "2.如未有相同角色，則會新增該角色"
msgstr "2.如未有相同角色，則會新增該角色"

#: apps/dp-client/src/screens/diary/components/TrafficExampleModal.tsx:84
msgid "2.搭乘計程車抵達賣場臨停區，下車後由正門進入並搭乘電梯至5樓後即可看見 AA 泰式料理。"
msgstr "2. 搭乘計程車抵達賣場臨停區，下車後由正門進入並搭乘電梯至5樓後即可看見 AA 泰式料理。"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1664
#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:157
msgid "2.餐點內容若遇品項缺貨或季節調整，店家將提供等值商品替代或由消費者申請退貨。"
msgstr "2.餐點內容若遇品項缺貨或季節調整，店家將提供等值商品替代或由消費者申請退貨。"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:307
#: apps/dp-business/src/components/InvoiceForm/index.tsx:360
msgid "2）貴公司對上述的金額有異議，請於十日內通知聚流聯絡窗口查明處理。"
msgstr "2）貴公司對上述的金額有異議，請於十日內通知聚流聯絡窗口查明處理。"

#: apps/dp-client/src/screens/home/utils/filterData.ts:142
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:52
msgid "200以下"
msgstr "200以下"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/types.ts:112
msgid "2025年08月13日"
msgstr "2025年08月13日"

#: apps/dp-client/src/screens/home/utils/filterData.ts:229
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:152
msgid "21-24時"
msgstr "21-24時"

#: apps/dp-client/src/utils/businessStatus.ts:191
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:47
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:83
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:729
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:813
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1199
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2004
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1309
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1401
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1463
#: apps/dp-business/src/pages/BusinessHours/TimeRangePicker.tsx:197
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:339
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:367
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:506
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/components/DayBusinessHours/index.web.tsx:213
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/components/DayBusinessHours/index.web.tsx:253
#: apps/dp-admin/src/components/BusinessHours/utils.ts:291
#: apps/dp-admin/src/components/BusinessHours/utils.ts:302
msgid "24小時營業"
msgstr "24小時營業"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:65
msgid "25885財團法人伊甸社會福利基金會"
msgstr "25885財團法人伊甸社會福利基金會"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:78
msgid "2人"
msgstr "2人"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:184
msgid "2分"
msgstr "2分"

#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:489
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:491
msgid "2小時"
msgstr "2小時"

#: apps/dp-business/src/pages/CustomerReviews/index.tsx:487
msgid "2年2個月"
msgstr "2年2個月"

#: apps/dp-admin/src/pages/data-center/merchant-stats/services/hooks.tsx:123
msgid "2星"
msgstr "2星"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:104
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:118
#: apps/dp-business/src/components/DatePicker.tsx:238
msgid "2月"
msgstr "2月"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:287
msgid "3-4 人"
msgstr "3-4 人"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:189
msgid "3-4人餐"
msgstr "3-4人餐"

#: apps/dp-business/src/pages/Settings/index.tsx:176
msgid "3、手機端：登錄【去哪吃店家端】APP 即可播放；可背景執行播放功能"
msgstr "3、手機端：登錄【去哪吃店家端】APP 即可播放；可背景執行播放功能"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:608
msgid "3. 平台不承擔因自核銷所產生的誤核、糾紛或損失責任"
msgstr "3. 平台不承擔因自核銷所產生的誤核、糾紛或損失責任"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:918
msgid "3. 建議使用白色背景拍攝，避免反光和陰影"
msgstr "3. 建議使用白色背景拍攝，避免反光和陰影"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:98
msgid "3. 資訊共享"
msgstr "3. 資訊共享"

#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:103
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:133
#: apps/dp-admin/src/pages/data-center/services/constants.ts:48
msgid "3.5-4星"
msgstr "3.5-4星"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1667
#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:160
msgid "3.本券可能包含多組兌換序號，每組限用一次，可分次兌換，但不得找零或折現。請妥善保管，若已使用、遺失或遭盜用者恕不補發。"
msgstr "3.本券可能包含多組兌換序號，每組限用一次，可分次兌換，但不得找零或折現。請妥善保管，若已使用、遺失或遭盜用者恕不補發。"

#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:488
msgid "30分鐘"
msgstr "30分鐘"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:79
msgid "3人"
msgstr "3人"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:185
msgid "3分"
msgstr "3分"

#: apps/dp-admin/src/pages/data-center/merchant-stats/services/hooks.tsx:124
msgid "3星"
msgstr "3星"

#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:58
msgid "3星以上"
msgstr "3星以上"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:105
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:119
#: apps/dp-business/src/components/DatePicker.tsx:239
msgid "3月"
msgstr "3月"

#: apps/dp-business/src/pages/Settings/index.tsx:177
msgid "4、使用前請檢查電腦 / 手機音量，確保能聽清提示。"
msgstr "4、使用前請檢查電腦 / 手機音量，確保能聽清提示。"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:921
msgid "4. 如有問題請聯繫，第一時間為您處理文檔"
msgstr "4. 如有問題請聯繫，第一時間為您處理文件"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:123
msgid "4. 資料安全"
msgstr "4. 資料安全"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/QuickFilterChips.tsx:36
msgid "4.0★+"
msgstr "4.0★+"

#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:102
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:129
#: apps/dp-admin/src/pages/data-center/services/constants.ts:44
msgid "4.5-5星"
msgstr "4.5-5星"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1670
#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:163
msgid "4.票券有效性以發行人系統紀錄為準；如網路延遲，依兌換店家系統顯示為主。"
msgstr "4.票券有效性以發行人系統紀錄為準；如網路延遲，依兌換店家系統顯示為主。"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:80
msgid "4人"
msgstr "4人"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:186
msgid "4分"
msgstr "4分"

#: apps/dp-admin/src/pages/data-center/merchant-stats/services/hooks.tsx:125
msgid "4星"
msgstr "4星"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:106
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:120
#: apps/dp-business/src/components/DatePicker.tsx:240
msgid "4月"
msgstr "4月"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:295
msgid "5-6 人"
msgstr "5-6 人"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:190
msgid "5-6人餐"
msgstr "5-6人餐"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:130
msgid "5. 您的權利"
msgstr "5. 您的權利"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1673
#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:166
msgid "5.本券屬有價證券，禁止偽造或變造，以免觸犯刑責。"
msgstr "5.本券屬有價證券，禁止偽造或變造，以免觸犯刑責。"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:35
msgid "500PAN"
msgstr "500PAN"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:36
msgid "500TIAN"
msgstr "500TIAN"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:34
msgid "500WAN"
msgstr "500WAN"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/SimpleTypeSwitcher/index.tsx:22
#: apps/dp-client/src/screens/home/components/ShopCard/components/S500Label.tsx:23
msgid "500甜"
msgstr "500甜"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/index.tsx:167
msgid "500甜最新入選名單"
msgstr "500甜最新入選名單"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:309
msgid "500甜相關筆記"
msgstr "500甜相關筆記"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/OnlineShopList/index.tsx:154
#: apps/dp-client/src/configs/page-configs.tsx:486
msgid "500甜線上通路"
msgstr "500甜線上通路"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:1620
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/SimpleTypeSwitcher/index.tsx:23
#: apps/dp-client/src/screens/home/components/ShopCard/components/S500Label.tsx:22
msgid "500盤"
msgstr "500盤"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/index.tsx:169
msgid "500盤最新入選名單"
msgstr "500盤最新入選名單"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:308
msgid "500盤相關筆記"
msgstr "500盤相關筆記"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/SimpleTypeSwitcher/index.tsx:21
#: apps/dp-client/src/screens/home/components/ShopCard/components/S500Label.tsx:21
msgid "500碗"
msgstr "500碗"

#: apps/dp-client/src/screens/home/components/ShopCard/components/S500Label.tsx:60
msgid "500碗、甜、盤"
msgstr "500碗、甜、盤"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/index.tsx:165
msgid "500碗最新入選名單"
msgstr "500碗最新入選名單"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:307
msgid "500碗相關筆記"
msgstr "500碗相關筆記"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/CustomHeader/index.tsx:50
#: apps/dp-client/src/screens/home/pages/Home/components/HotRanking/index.tsx:72
msgid "500輯"
msgstr "500輯"

#: apps/dp-client/src/configs/page-configs.tsx:445
msgid "500輯榜單"
msgstr "500輯榜單"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:81
msgid "5人"
msgstr "5人"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:187
msgid "5分"
msgstr "5分"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:273
msgid "5分鐘"
msgstr "5分鐘"

#: apps/dp-admin/src/pages/data-center/merchant-stats/services/hooks.tsx:126
msgid "5星"
msgstr "5星"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:107
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:121
#: apps/dp-business/src/components/DatePicker.tsx:241
msgid "5月"
msgstr "5月"

#: apps/dp-client/src/screens/home/utils/filterData.ts:209
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:132
msgid "6-10時"
msgstr "6-10時"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:303
msgid "6-7 人"
msgstr "6-7 人"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:191
msgid "6-7人餐"
msgstr "6-7人餐"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:145
msgid "6. Cookie和類似技術"
msgstr "6. Cookie和類似技術"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1676
#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:169
msgid "6.發行公司：聚流平台科技股份有限公司，地址：臺北市內湖區瑞光路468號8樓、統一編號：60560109、消費者服務電話：02-77287575。本商品券實際商品及服務由合作店家提供，惟發行公司仍負履約責任。"
msgstr "6.發行公司：聚流平台科技股份有限公司，地址：臺北市內湖區瑞光路468號8樓、統一編號：60560109、消費者服務電話：02-77287575。本商品券實際商品及服務由合作店家提供，惟發行公司仍負履約責任。"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:82
msgid "6人"
msgstr "6人"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:108
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:122
#: apps/dp-business/src/components/DatePicker.tsx:242
msgid "6月"
msgstr "6月"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:152
msgid "7. 兒童隱私"
msgstr "7. 兒童隱私"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1679
#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:172
msgid "7.本商品券所收取之金額，已先時存入於遠東商銀開立之信託專戶，專款專用，信託期間自出售日起算一年。信託存續期間屆滿後，發行公司可將信託專戶餘額領回，惟發行公司仍負履約責任。"
msgstr "7.本商品券所收取之金額，已先時存入於遠東商銀開立之信託專戶，專款專用，信託期間自出售日起算一年。信託存續期間屆滿後，發行公司可將信託專戶餘額領回，惟發行公司仍負履約責任。"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:64
msgid "7000財團法人臺灣世界展望會"
msgstr "7000財團法人臺灣世界展望會"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:83
msgid "7人"
msgstr "7人"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:129
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:490
msgid "7天"
msgstr "7天"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:109
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:123
#: apps/dp-business/src/components/DatePicker.tsx:243
msgid "7月"
msgstr "7月"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:159
msgid "8. 政策變更"
msgstr "8. 政策變更"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1682
#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:175
msgid "8.消費者同意發行公司得於預收款信託相關之特定目的範圍內，依個人資料保護法規定，將其個人資料提供予受託銀行為蒐集、處理或利用。"
msgstr "8.消費者同意發行公司得於預收款信託相關之特定目的範圍內，依個人資料保護法規定，將其個人資料提供予受託銀行為蒐集、處理或利用。"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:62
msgid "8585財團法人臺灣兒童暨家庭扶助基金會"
msgstr "8585財團法人臺灣兒童暨家庭扶助基金會"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:84
msgid "8人及以上"
msgstr "8人及以上"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:136
msgid "8個分類"
msgstr "8個分類"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:274
msgid "8分鐘"
msgstr "8分鐘"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:110
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:124
#: apps/dp-business/src/components/DatePicker.tsx:244
msgid "8月"
msgstr "8月"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:166
msgid "9. 聯繫我們"
msgstr "9. 聯繫我們"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1686
#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:179
msgid "9.遠東商銀禮券信託查詢請至遠東商銀網站："
msgstr "9.遠東商銀禮券信託查詢請至遠東商銀網站："

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:61
msgid "9527財團法人罕見疾病基金會"
msgstr "9527財團法人罕見疾病基金會"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:111
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:125
#: apps/dp-business/src/components/DatePicker.tsx:245
msgid "9月"
msgstr "9月"

#: apps/dp-client/src/screens/diary/components/TrafficExampleModal.tsx:48
msgid "AA 泰式料理到店指引"
msgstr "AA 泰式料理到店秘笈"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:162
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:169
msgid "AirPods"
msgstr "AirPods"

#: apps/dp-client/src/screens/diary/pages/winning/components/WinningList/index.tsx:86
msgid "AirPods中獎名單"
msgstr "AirPods中獎名單"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:14
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:145
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:170
msgid "Android"
msgstr "Android"

#: apps/dp-client/src/utils/sso.ts:286
msgid "Android 功能不可用"
msgstr "Android 功能不可用"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:455
msgid "api key"
msgstr "API 金鑰"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:457
msgid "API 金鑰錯誤"
msgstr "API 金鑰錯誤"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:545
msgid "API介面"
msgstr "API介面"

#: apps/dp-admin/src/pages/order/services/utils.ts:102
msgid "APP"
msgstr "APP"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/AppPushTemplateSection.web.tsx:23
msgid "App Push內容可包含多個佔位符, 佔位符規範：｛中間填寫英文｝"
msgstr "App Push內容可包含多個佔位符, 佔位符規範：｛中間填寫英文｝"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/AppPushTemplateSection.web.tsx:16
msgid "App Push標題不能超過15字"
msgstr "App Push標題不能超過15字"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/AppPushTemplateSection.web.tsx:45
msgid "App Push跳轉"
msgstr "App Push跳轉"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/TargetingSection/index.web.tsx:30
msgid "App 最低版本"
msgstr "App 最低版本"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:33
msgid "App 閃退"
msgstr "App 閃退"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:40
msgid "Apple Pay"
msgstr "Apple Pay"

#: apps/dp-business/src/pages/OrderList/index.tsx:614
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1649
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1782
msgid "APP付款"
msgstr "APP付款"

#: apps/dp-admin/src/components/UserFilterSection/index.web.tsx:12
msgid "App版本(最小版本號)"
msgstr "App版本(最小版本號)"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:78
msgid "App跳轉"
msgstr "App跳轉"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:858
msgid "arrivalTime"
msgstr "arrivalTime"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:13
msgid "Banner"
msgstr "Banner"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:81
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:176
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:215
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:158
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:211
msgid "BD"
msgstr "BD"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:117
msgid "BD人員"
msgstr "BD人員"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:386
msgid "BD專員"
msgstr "BD專員"

#: apps/dp-admin/src/modules/hooks/options/useBDOptions.ts:119
msgid "BD選項資料取得失敗"
msgstr "BD選項資料取得失敗"

#: apps/dp-admin/src/modules/hooks/options/useBDOptions.ts:128
msgid "BD選項資料取得異常"
msgstr "BD選項資料取得異常"

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:67
#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:76
#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:85
msgid "Blanc Roswe"
msgstr "Blanc Roswe"

#: apps/dp-admin/src/pages/order/services/utils.ts:104
msgid "B端"
msgstr "B端"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:178
msgid "B端搜索"
msgstr "B端搜索"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:60
msgid "CITY PARK 松仁路停車場"
msgstr "CITY PARK 松仁路停車場"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:81
msgid "Client ID"
msgstr "Client ID"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:160
msgid "Client Secret"
msgstr "Client Secret"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:18
msgid "Collapse 摺疊面板元件範例"
msgstr "Collapse 摺疊面板元件範例"

#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewEditorToolbar.tsx:26
msgid "CP值"
msgstr "CP值"

#: apps/dp-business/src/pages/MenuManagement.tsx:138
#: apps/dp-business/src/pages/MenuItemForm.tsx:49
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:55
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:55
msgid "CP值高的推薦餐點"
msgstr "CP值高的推薦餐點"

#: apps/dp-admin/src/components/ConfigurableForm/ConfigurableForm.web.tsx:330
msgid "custom 組件類型需要提供 render 函數"
msgstr "custom 組件類型需要提供 render 函數"

#: apps/dp-admin/src/components/ClientVersionDropdown/index.web.tsx:105
msgid "C端最新發版記錄"
msgstr "C端最新發版記錄"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ClientSearchPanel/index.web.tsx:38
msgid "C端搜索能力接入 · Beta"
msgstr "C端搜索能力接入 · Beta"

#: apps/dp-admin/src/router/config/routes.web.tsx:692
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:710
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:486
msgid "C端版本號管理"
msgstr "C端版本號管理"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/SubmitConfirmModal.tsx:126
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1364
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/SubmitConfirmModal/index.web.tsx:137
msgid "C端詳情頁預覽"
msgstr "C端詳情頁預覽"

#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:53
msgid "DAU"
msgstr "DAU"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/OverviewCards.web.tsx:21
msgid "DAU (當日)"
msgstr "DAU (當日)"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/OverviewCards.web.tsx:30
msgid "DAU (當日活躍)"
msgstr "DAU (當日活躍)"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:470
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:709
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:753
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:78
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:295
#: apps/dp-business/src/pages/Login/Email/index.tsx:225
#: apps/dp-business/src/pages/AddUser/index.tsx:240
#: apps/dp-business/src/components/EmailVerification/index.tsx:352
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:73
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:169
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:209
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:225
msgid "Email"
msgstr "Email"

#: apps/dp-client/src/screens/account/pages/account-security/email/email-old/index.tsx:85
#: apps/dp-client/src/screens/account/pages/account-security/email/bind-email/index.tsx:79
msgid "Email地址"
msgstr "Email地址"

#: apps/dp-business/src/utils/validation.ts:77
#: apps/dp-business/src/utils/validation.ts:333
msgid "Email地址必須包含@符號"
msgstr "Email地址必須包含@符號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:500
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:518
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:532
msgid "Email地址長度不能超過100個字符"
msgstr "Email地址長度不能超過100個字符"

#: apps/dp-client/src/screens/account/pages/account-security/email/check-email/index.tsx:35
msgid "Email已不可用？"
msgstr "Email已無法使用？"

#: apps/dp-business/src/pages/ChangeEmail/index.tsx:30
msgid "Email換綁成功，請重新登入"
msgstr "Email換綁成功，請重新登入"

#: apps/dp-client/src/screens/login/pages/password-login/index.tsx:62
#: apps/dp-business/src/components/EmailVerification/index.tsx:161
#: apps/dp-business/src/components/EmailVerification/index.tsx:204
#: apps/dp-business/src/components/EmailVerification/index.tsx:205
msgid "Email格式不正確"
msgstr "Email格式不正確"

#: apps/dp-business/src/pages/Login/Email/index.tsx:188
msgid "Email登入"
msgstr "Email登入"

#: apps/dp-business/src/pages/ChangeEmail/index.tsx:48
#: apps/dp-business/src/pages/BindEmail/index.tsx:47
msgid "Email綁定失敗，請稍後重試"
msgstr "Email綁定失敗，請稍後重試"

#: apps/dp-client/src/screens/account/pages/account-security/email/verification-email/index.tsx:57
#: apps/dp-business/src/pages/BindEmail/index.tsx:34
msgid "Email綁定成功"
msgstr "Email綁定成功"

#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:31
msgid "Email驗證"
msgstr "Email驗證"

#: apps/dp-client/src/screens/account/pages/account-security/email/check-email/index.tsx:61
msgid "Email驗證成功"
msgstr "Email驗證成功"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:650
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:652
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:705
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:707
msgid "ERP"
msgstr "ERP"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:111
msgid "ERP 檔案下載失敗"
msgstr "ERP 檔案下載失敗"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:110
msgid "ERP 檔案下載成功"
msgstr "ERP 檔案下載成功"

#: apps/dp-admin/src/pages/merchant/signing-management/index.web.tsx:138
msgid "ERPID"
msgstr "ERPID"

#. placeholder {0}: (blob as any)?.message
#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:116
msgid "ERP文件下載失敗: {0}"
msgstr "ERP文件下載失敗: {0}"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:121
msgid "ERP文件下載失敗: {error}"
msgstr "ERP文件下載失敗: {error}"

#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:122
msgid "ERP資料_{timestamp}.xlsx"
msgstr "ERP資料_{timestamp}.xlsx"

#: apps/dp-admin/src/router/config/routes.web.tsx:780
msgid "ES異常處理"
msgstr "ES異常處理"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:222
msgid "Excel 上傳失敗"
msgstr "Excel 上傳失敗"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/index.web.tsx:138
msgid "Excel 導入"
msgstr "Excel 導入"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:233
msgid "Excel 導入結果"
msgstr "Excel 導入結果"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ImportShopModal/index.web.tsx:106
msgid "Excel 導入關聯店家"
msgstr "Excel 導入關聯店家"

#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:203
msgid "Excel 文件<0>*</0>"
msgstr "Excel 文件<0>*</0>"

#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:203
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:206
msgid "Excel 文件選擇成功"
msgstr "Excel 文件選擇成功"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/Details.web.tsx:90
msgid "Excel 行號"
msgstr "Excel 行號"

#: apps/dp-client/src/screens/account/pages/coupon/GiftRuleOfPackage/index.tsx:94
#: apps/dp-client/src/screens/account/pages/coupon/GiftRule/index.tsx:104
msgid "Failed to fetch HTML content:"
msgstr "Failed to fetch HTML content:"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserInfoCard/index.web.tsx:69
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:38
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:135
#: apps/dp-admin/src/pages/marketing/services/groupImportConstants.ts:18
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:184
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:312
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:71
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:138
msgid "FetUID"
msgstr "FetUID"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:103
msgid "FetUID 請使用文字格式，最長 64 個字元。"
msgstr "FetUID 請使用文字格式，最長 64 個字元。"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:216
msgid "Flowable 任務 ID 不存在"
msgstr "Flowable 任務 ID 不存在"

#. placeholder {0}: getRank500TypeLabel(currentActiveType)
#. placeholder {1}: getRank500TypeLabel(type)
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/index.tsx:130
msgid "from_{0}_to_{1}"
msgstr "from_{0}_to_{1}"

#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:59
msgid "GMV"
msgstr "GMV"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:895
msgid "Google / 平台資訊"
msgstr "Google / 平台資訊"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:141
msgid "Google ID"
msgstr "Google ID"

#: apps/dp-admin/src/components/MapPicker/index.web.tsx:439
msgid "Google Maps API Key 未配置"
msgstr "Google Maps API Key 未配置"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/ReviewHeader.web.tsx:96
msgid "Google Maps評分"
msgstr "Google Maps評分"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:42
msgid "Google Pay"
msgstr "Google Pay"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:897
msgid "Google POI ID"
msgstr "Google POI ID"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:907
msgid "Google 評價數"
msgstr "Google 評價數"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:900
msgid "Google 評分"
msgstr "Google 評分"

#: apps/dp-admin/src/pages/audit-center/info-confirm/services/config.ts:68
msgid "GoogleID"
msgstr "GoogleID"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:723
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:331
msgid "Google均價"
msgstr "Google均價"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/config.ts:79
msgid "google是否永久停業"
msgstr "google是否永久停業"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:741
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:345
msgid "Google評價數量"
msgstr "Google評價數量"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:705
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:317
msgid "Google評分"
msgstr "Google評分"

#: apps/dp-admin/src/pages/audit-center/info-confirm/index.web.tsx:129
msgid "Google資訊"
msgstr "Google資訊"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:47
msgid "HappyGo Pay"
msgstr "HappyGo Pay"

#: apps/dp-business/src/hooks/useHeicImage.ts:109
msgid "HEIC 轉換失敗"
msgstr "HEIC 轉換失敗"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:407
msgid "Home/Note/AddNote"
msgstr "Home/Note/AddNote"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:553
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:249
msgid "ⓘ 以下兩種時間設定，都受限制\"購買後最長有效期為85天（第85天的晚上20:59:59失效）\"。"
msgstr "ⓘ 以下兩種時間設定，都受限制\"購買後最長有效期為85天（第85天的晚上20:59:59失效）\"。"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:59
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:65
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:33
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeColumns.web.tsx:22
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:26
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:544
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:90
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:117
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:175
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:210
msgid "ID"
msgstr "ID"

#. placeholder {0}: store.id
#. placeholder {0}: shop?.id || '-'
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:102
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:334
msgid "ID {0}"
msgstr "ID {0}"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:62
msgid "ID / 編碼 / 名稱"
msgstr "ID / 編碼 / 名稱"

#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:74
msgid "ID:"
msgstr "ID:"

#. placeholder {0}: userProfile?.displayUid || ''
#. placeholder {0}: userProfile?.uid || ''
#. placeholder {0}: item.displayUid
#: apps/dp-client/src/screens/account/pages/user-profile/components/UserInfoSection/index.tsx:105
#: apps/dp-client/src/screens/account/pages/profile/components/UserInfoSection/index.tsx:90
#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/hooks/usePrivacyListData.ts:109
#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:50
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:119
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedMallTable/index.web.tsx:73
#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:62
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:176
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:110
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:113
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:126
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:330
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:333
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:346
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:74
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:73
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:76
msgid "ID：{0}"
msgstr "ID：{0}"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/NameCell.web.tsx:29
msgid "ID：{id}"
msgstr "ID：{id}"

#: apps/dp-business/src/utils/businessHours.ts:103
msgid "Invalid time format"
msgstr "無效的時間格式"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:13
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:144
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:169
msgid "iOS"
msgstr "iOS"

#: apps/dp-client/src/utils/sso.ts:269
msgid "iOS 功能不可用"
msgstr "iOS 功能不可用"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:104
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:114
msgid "IP 白名單"
msgstr "IP 白名單"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:161
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:168
msgid "iPhone"
msgstr "iPhone"

#: apps/dp-client/src/screens/diary/pages/winning/components/WinningList/index.tsx:84
msgid "iPhone中獎名單"
msgstr "iPhone中獎名單"

#. placeholder {0}: record.i + 1
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:234
msgid "L{0}"
msgstr "L{0}"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:43
msgid "LinePay"
msgstr "LinePay"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShareModal/index.tsx:78
#: apps/dp-client/src/screens/home/pages/MallDetail/index.tsx:257
#: apps/dp-client/src/components/ShareCard/index.tsx:135
msgid "LINE聊天室"
msgstr "LINE聊天室"

#: apps/dp-business/src/pages/Login/Phone/index.tsx:74
msgid "Login failed"
msgstr "登入失敗"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:33
#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:46
msgid "Logo"
msgstr "Logo"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:102
msgid "Markdown 語法示例"
msgstr "Markdown 語法範例"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/OverviewCards.web.tsx:39
msgid "MAU (近30日)"
msgstr "MAU (近30日)"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/OverviewCards.web.tsx:48
msgid "MAU (近30日活躍)"
msgstr "MAU (近30日活躍)"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:81
msgid "mid"
msgstr "mid"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:142
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/services/utils.ts:44
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:159
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:170
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/services/utils.ts:44
msgid "MID"
msgstr "MID"

#: apps/dp-client/src/screens/diary/pages/winning/index.tsx:127
msgid "MM月DD日"
msgstr "MM月DD日"

#: apps/dp-client/src/screens/reservation/components/ReservationCard/index.tsx:125
msgid "MM月DD日 HH:mm"
msgstr "MM月DD日 HH:mm"

#: apps/dp-client/src/screens/reservation/utils/index.ts:141
msgid "M月D日"
msgstr "M月D日"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:84
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:65
msgid "NFC支付"
msgstr "NFC支付"

#. placeholder {0}: row.transactionAmount
#. placeholder {1}: row.payableAmount
#. placeholder {1}: row.settlementAmount
#: apps/dp-business/src/pages/ChainDashboard/components/reports/voucherUsageColumns.tsx:65
#: apps/dp-business/src/pages/ChainDashboard/components/reports/voucherSalesColumns.tsx:63
msgid "NT${0}／NT${1}"
msgstr "NT${0}／NT${1}"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:256
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:193
#: apps/dp-admin/src/pages/merchant/components/identity-fields/PersonalIdentityFields.web.tsx:71
#: apps/dp-admin/src/pages/merchant/components/identity-fields/DomesticIdentityFields.web.tsx:96
#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:196
msgid "OCR 識別"
msgstr "OCR 識別"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:108
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:128
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:242
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:276
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:229
msgid "OCR 識別失敗，請重試"
msgstr "OCR 識別失敗，請重試"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:64
msgid "OCR 識別結果"
msgstr "OCR 識別結果"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:69
msgid "One Tap"
msgstr "One Tap"

#: apps/dp-admin/src/pages/order/services/utils.ts:105
msgid "OPEN-API"
msgstr "OPEN-API"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:79
msgid "P0 · 嚴重影響"
msgstr "P0 · 嚴重影響"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:80
msgid "P1 · 高度影響"
msgstr "P1 · 高度影響"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:81
msgid "P2 · 一般影響"
msgstr "P2 · 一般影響"

#: apps/dp-business/src/components/PhotoUploader/upload.ts:302
msgid "PDF 上傳失敗，請稍後重試"
msgstr "PDF 上傳失敗，請稍後重試"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:683
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:225
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:235
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:429
msgid "POI"
msgstr "POI"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:52
msgid "POI ID"
msgstr "POI ID"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:75
msgid "POI ID、業務編碼、名稱"
msgstr "POI ID、業務編碼、名稱"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:296
msgid "POI 審核歷史"
msgstr "POI 審核歷史"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:230
msgid "POI 詳情"
msgstr "POI 詳情"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:15
msgid "POI修改"
msgstr "POI修改"

#: apps/dp-admin/src/router/config/routes.web.tsx:360
msgid "POI審核"
msgstr "POI審核"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:230
msgid "POI審核狀態"
msgstr "POI審核狀態"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:298
msgid "POI審核詳情"
msgstr "POI審核詳情"

#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:59
msgid "POI店家名稱/ID"
msgstr "POI店家名稱/ID"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:14
msgid "POI新增"
msgstr "POI新增"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:475
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:219
msgid "POI狀態"
msgstr "POI狀態"

#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:69
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:132
msgid "POI類型"
msgstr "POI類型"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:23
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:121
msgid "POS"
msgstr "POS"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:29
msgid "POS 核銷數據報表"
msgstr "POS 核銷數據報表"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1255
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:302
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:323
msgid "POS商品名稱"
msgstr "POS商品名稱"

#: apps/dp-admin/src/pages/transaction/service-management/components/PosSettings/index.web.tsx:60
msgid "POS廠商代號"
msgstr "POS廠商代號"

#: apps/dp-admin/src/pages/order/services/utils.ts:103
msgid "POS掃碼"
msgstr "POS掃碼"

#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:620
msgid "POS服務設定保存成功"
msgstr "POS服務設定保存成功"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:38
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2519
#: apps/dp-admin/src/pages/order/services/utils.ts:512
#: apps/dp-admin/src/pages/order/services/utils.ts:586
msgid "POS核銷"
msgstr "POS核銷"

#: apps/dp-business/src/constants/enums.ts:516
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:30
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:82
msgid "POS機導入"
msgstr "POS機導入"

#: apps/dp-business/src/pages/OrderList/index.tsx:615
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1651
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1784
msgid "POS機掃碼"
msgstr "POS機掃碼"

#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:34
msgid "POS機服務"
msgstr "POS機服務"

#: apps/dp-admin/src/pages/transaction/service-management/components/PosSettings/index.web.tsx:48
msgid "POS關聯資訊"
msgstr "POS關聯資訊"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:152
msgid "Push推送"
msgstr "Push推送"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:553
msgid "qnc://… / https://…"
msgstr "qnc://… / https://…"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:393
msgid "QR Code無效"
msgstr "QR Code無效"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:798
msgid "Safari 用戶：點擊\"嘗試訪問相機\"後，請在瀏覽器彈出的權限對話框中選擇\"允許\""
msgstr "Safari 用戶：點擊\"嘗試訪問相機\"後，請在瀏覽器彈出的權限對話框中選擇\"允許\""

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:41
msgid "Samsung Pay"
msgstr "Samsung Pay"

#: apps/dp-client/src/screens/home/components/ShopFilter/hooks/useShopFilterRawData.ts:88
msgid "ShopFilter 分類數據獲取失敗:"
msgstr "ShopFilter 分類數據獲取失敗:"

#: apps/dp-client/src/screens/home/components/ShopFilter/hooks/useShopFilterRawData.ts:111
msgid "ShopFilter 地區數據獲取失敗:"
msgstr "ShopFilter 地區數據獲取失敗:"

#: apps/dp-client/src/screens/home/components/ShopFilter/hooks/useShopFilterRawData.ts:175
msgid "ShopFilter 榜單年份獲取失敗:"
msgstr "ShopFilter 榜單年份獲取失敗:"

#: apps/dp-client/src/screens/home/components/ShopFilter/hooks/useShopFilterRawData.ts:134
msgid "ShopFilter 設施數據獲取失敗:"
msgstr "ShopFilter 設施數據獲取失敗:"

#. placeholder {0}: frame.headers.message
#: apps/dp-business/src/store/NotificationContext.tsx:578
msgid "STOMP連接失敗: {0}"
msgstr "STOMP連接失敗: {0}"

#: apps/dp-client/src/components/TabView/example.tsx:41
msgid "TabView 組件示例"
msgstr "TabView 組件範例"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:134
msgid "Token 有效期"
msgstr "Token 有效期"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:793
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1258
msgid "TOP_返回"
msgstr "TOP_返回"

#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:226
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:144
msgid "UID"
msgstr "UID"

#: apps/dp-client/src/screens/diary/pages/winning/components/RankItem/index.tsx:61
msgid "UID："
msgstr "UID："

#: packages/utils/src/upload/upload-file/index.native.ts:133
msgid "UploadFile.from: native 端 File 對象缺少 uri，請改傳 uri 字符串、ImagePickerAsset 或 {uri, fileName, mimeType}"
msgstr "UploadFile.from: native 端 File 對象缺少 uri，請改傳 uri 字符串、ImagePickerAsset 或 {uri, fileName, mimeType}"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:136
msgid "URL 長度不能超過500個字符"
msgstr "URL 長度不能超過500個字符"

#: apps/dp-business/src/store/ChainBootstrapContext.tsx:144
msgid "useChainBootstrap必須使用ChainBootstrapProvider"
msgstr "useChainBootstrap必須使用ChainBootstrapProvider"

#: apps/dp-business/src/store/ChainPermissionContext.tsx:149
msgid "useChainPermissionContext必須使用ChainPermissionProvider"
msgstr "useChainPermissionContext必須使用ChainPermissionProvider"

#: apps/dp-business/src/store/ChainTreeContext.tsx:154
msgid "useChainTreeContext必須使用ChainTreeProvider"
msgstr "useChainTreeContext必須使用ChainTreeProvider"

#: apps/dp-business/src/store/FormContext.tsx:257
msgid "useFormContext must be used within a FormProvider"
msgstr "useFormContext必須在FormProvider內使用"

#: apps/dp-business/src/store/HolidayContext.tsx:394
msgid "useHolidayContext must be used within a HolidayProvider"
msgstr "useHolidayContext必須在HolidayProvider內使用"

#: apps/dp-business/src/store/MenuContext.tsx:294
msgid "useMenuContext must be used within a MenuProvider"
msgstr "useMenuContext 必須在 MenuProvider 內使用"

#: apps/dp-business/src/store/NotificationContext.tsx:1336
msgid "useNotificationContext必須在NotificationProvider內使用"
msgstr "useNotificationContext必須在NotificationProvider內使用"

#: apps/dp-business/src/store/PerspectiveContext.tsx:426
msgid "usePerspectiveContext必須使用PerspectiveProvider"
msgstr "usePerspectiveContext必須使用PerspectiveProvider"

#: apps/dp-business/src/store/ShopContext.tsx:546
msgid "useShopContext必須使用ShopProvider"
msgstr "useShopContext必須使用ShopProvider"

#: apps/dp-business/src/store/TableContext.tsx:374
msgid "useTableContext必須使用TableProvider"
msgstr "useTableContext必須使用TableProvider"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/OverviewCards.web.tsx:30
msgid "WAU (近7日)"
msgstr "WAU (近7日)"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/OverviewCards.web.tsx:39
msgid "WAU (近7日活躍)"
msgstr "WAU (近7日活躍)"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:15
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:171
msgid "Web"
msgstr "Web"

#: apps/dp-client/src/screens/account/pages/notification-settings/index.tsx:74
msgid "Web 端暫不支持通知功能"
msgstr "Web 端暫不支持通知功能"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:475
msgid "WebSocket 連接中斷，正在重連..."
msgstr "WebSocket 連接中斷，正在重連..."

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:474
msgid "WebSocket 連線已中斷，請重新整理頁面"
msgstr "WebSocket 連線已中斷，請重新整理頁面"

#: apps/dp-business/src/store/NotificationContext.tsx:588
msgid "WebSocket連接失敗"
msgstr "WebSocket連接失敗"

#: apps/dp-business/src/store/NotificationContext.tsx:474
msgid "WebSocket連接失敗，已達到最大重連次數"
msgstr "WebSocket連接失敗，已達到最大重連次數"

#: apps/dp-client/src/configs/page-configs.tsx:3039
msgid "Webview"
msgstr "Webview"

#: apps/dp-client/src/screens/diary/pages/my/components/CropPhoto/index.web.tsx:273
msgid "Web端裁剪失敗: "
msgstr "網頁裁剪失敗: "

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:66
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:47
msgid "wifi"
msgstr "wifi"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:359
msgid "x.x 折"
msgstr "x.x 折"

#. placeholder {0}: coupon.count
#: apps/dp-client/src/components/CouponCard/index.tsx:359
msgid "x{0}"
msgstr "x{0}"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:338
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:358
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:464
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:482
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:315
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:68
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:85
msgid "YYYY-MM-DD"
msgstr "YYYY-MM-DD"

#: apps/dp-client/src/screens/home/pages/CouponShopList/components/CouponCard.tsx:104
msgid "YYYY/MM/DD"
msgstr "YYYY/MM/DD"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:156
msgid "YYYY年 M月D日"
msgstr "YYYY年 M月D日"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:593
msgid "YYYY年MM月DD日 HH:mm"
msgstr "YYYY年MM月DD日 HH:mm"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:167
msgid "YYYY年MM月DD日 HH:mm:ss 前"
msgstr "YYYY年MM月DD日 HH:mm:ss 前"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:1174
msgid "yyyy年M月"
msgstr "yyyy年M月"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:162
msgid "YYYY年M月D日 HH:mm:ss"
msgstr "YYYY年M月D日 HH:mm:ss"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:130
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:131
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:563
#: apps/dp-business/src/components/DatePicker.tsx:235
#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:14
msgid "一"
msgstr "一"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:301
#: apps/dp-business/src/components/InvoiceForm/index.tsx:354
msgid "一、注意事項"
msgstr "一、注意事項"

#: apps/dp-client/src/screens/home/pages/UserGift/hooks/useUserGiftData.ts:127
msgid "一個手機號只能領取一次註冊禮喔"
msgstr "一個手機號只能領取一次註冊禮喔"

#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/index.tsx:133
#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/index.tsx:136
msgid "一個討厭的人都沒有"
msgstr "一個討厭的人都沒有"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1185
msgid "一個門店在當前樹上只能掛載一次"
msgstr "一個門店在當前樹上只能掛載一次"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:246
msgid "一商家可以掛在多棵樹上。每棵樹先看掛在第幾層、這一層是請款還是隻簽約。請款＝有哪些店的帳匯進本商家。店綁定哪個商家、帳匯進哪個商家，可以不是同一家。"
msgstr "一商家可以掛在多棵樹上。每棵樹先看掛在第幾層、這一層是請款還是隻簽約。請款＝有哪些店的帳匯進本商家。店綁定哪個商家、帳匯進哪個商家，可以不是同一家。"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:174
msgid "一審拒絕"
msgstr "一審拒絕"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:170
msgid "一審透過"
msgstr "一審透過"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:92
msgid "一店可掛多棵樹，用來管店、看報表。結算全店只有一條：帳匯進哪個商家的結算單。請款不是另一條路，只是結算審核通過後要不要開發票。"
msgstr "一店可掛多棵樹，用來管店、看報表。結算全店只有一條：帳匯進哪個商家的結算單。請款不是另一條路，只是結算審核通過後要不要開發票。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:360
msgid "一店可掛多棵樹（管理／報表）。"
msgstr "一店可掛多棵樹（管理／報表）。"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:968
msgid "一次性支付"
msgstr "一次性支付"

#: apps/dp-business/src/servers/chain/nodeApi.ts:164
#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeNodeRow.tsx:33
#: apps/dp-business/src/components/CascadeSelector/index.tsx:111
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:45
msgid "一級"
msgstr "一級"

#: apps/dp-admin/src/pages/org-tree/org-create/services/constants.ts:27
msgid "一級/集團"
msgstr "一級/集團"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:76
msgid "一級／集團"
msgstr "一級／集團"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:37
msgid "一級代碼"
msgstr "一級代碼"

#: apps/dp-admin/src/pages/resource-config/category-management/index.web.tsx:46
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:98
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:165
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:669
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:235
msgid "一級品類"
msgstr "一級品類"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:159
msgid "一級品類ID"
msgstr "一級品類ID"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:171
msgid "一級品類圖片"
msgstr "一級品類圖片"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:50
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:724
msgid "一級品類狀態"
msgstr "一級品類狀態"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:680
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:195
msgid "一級品類詳情"
msgstr "一級品類詳情"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:189
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:251
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:24
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:66
msgid "一級標籤"
msgstr "一級標籤"

#: apps/dp-admin/src/pages/marketing/channel-management/index.web.tsx:40
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:30
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/searchConfig.ts:20
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:286
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:289
msgid "一級渠道"
msgstr "一級渠道"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignLevel1Select/index.web.tsx:26
msgid "一級渠道選項加載失敗"
msgstr "一級渠道選項加載失敗"

#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:48
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:51
msgid "一級管理人"
msgstr "一級管理人"

#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:74
msgid "一級管理人信息"
msgstr "一級管理人信息"

#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionConfirmContent/index.tsx:114
msgid "一經核銷序號將立即失效！若您並未希望即刻進行兌換，請勿按下「確認核銷」"
msgstr "一經核銷序號將立即失效！若您並未希望即刻進行兌換，請勿按下「確認核銷」"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:144
msgid "一線城市"
msgstr "一線城市"

#: apps/dp-client/src/utils/utils.ts:145
#: apps/dp-client/src/utils/format.ts:76
#: apps/dp-client/src/screens/home/utils/utils.ts:34
#: apps/dp-client/src/screens/home/utils/utils.ts:40
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:38
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:44
#: apps/dp-client/src/screens/home/pages/Note/utils/index.ts:6
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:51
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:57
msgid "一般"
msgstr "一般"

#: apps/dp-client/src/screens/diary/pages/my/components/PointsInfoCard.tsx:69
msgid "一般任務"
msgstr "一般任務"

#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:53
msgid "一般商場"
msgstr "一般商場"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:70
msgid "一般影響／單一使用者／詢問"
msgstr "一般影響／單一使用者／詢問"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:286
msgid "一般會員"
msgstr "一般會員"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:200
msgid "一行一筆，可僅建立一級、一級＋二級，或完整三層渠道；未使用的下級欄位可留空。"
msgstr "一行一筆，可僅建立一級、一級＋二級，或完整三層渠道；未使用的下級欄位可留空。"

#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:514
msgid "一鍵全選"
msgstr "一鍵全選"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:67
msgid "一鍵應用"
msgstr "一鍵應用"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:796
msgid "一鍵核銷"
msgstr "一鍵核銷"

#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:20
msgid "七"
msgstr "七"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:130
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:131
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:563
#: apps/dp-business/src/components/DatePicker.tsx:235
#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:16
msgid "三"
msgstr "三"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:378
msgid "三、收據相關資訊"
msgstr "三、收據相關資訊"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:325
msgid "三、發票相關資訊"
msgstr "三、發票相關資訊"

#: apps/dp-business/src/data/regions.ts:64
msgid "三峽區"
msgstr "三峽區"

#: apps/dp-business/src/servers/chain/nodeApi.ts:164
#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeNodeRow.tsx:33
#: apps/dp-business/src/components/CascadeSelector/index.tsx:111
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:76
#: apps/dp-admin/src/pages/org-tree/org-create/services/constants.ts:29
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:49
msgid "三級"
msgstr "三級"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:63
msgid "三級代碼"
msgstr "三級代碼"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:105
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:131
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:86
msgid "三級別名"
msgstr "三級別名"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:203
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:265
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:26
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:78
msgid "三級標籤"
msgstr "三級標籤"

#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:144
msgid "三級標題"
msgstr "三級標題"

#: apps/dp-admin/src/pages/marketing/channel-management/index.web.tsx:50
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:141
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:56
msgid "三級渠道"
msgstr "三級渠道"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:310
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:129
msgid "三級渠道名稱"
msgstr "三級渠道名稱"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:146
msgid "三線城市"
msgstr "三線城市"

#: apps/dp-business/src/data/regions.ts:74
msgid "三芝區"
msgstr "三芝區"

#: apps/dp-business/src/data/regions.ts:55
msgid "三重區"
msgstr "三重區"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:736
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:465
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:500
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:523
#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:630
#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:220
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:702
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:448
msgid "上一步"
msgstr "上一步"

#: apps/dp-admin/src/pages/org-tree/services/shopPathActions.ts:102
msgid "上一筆變更結果尚未確認，請先以原操作重試"
msgstr "上一筆變更結果尚未確認，請先以原操作重試"

#: apps/dp-business/src/pages/CustomerReviews/components/QualityMonitoringSection.tsx:125
msgid "上一週平均評分較前週下降0.2分，建議注意服務品質並及時改進。"
msgstr "上一週平均評分較前週下降0.2分，建議注意服務品質並及時改進。"

#: apps/dp-business/src/pages/PermissionManagement/index.tsx:274
#: apps/dp-business/src/pages/ComplaintList/index.tsx:467
msgid "上一頁"
msgstr "上一頁"

#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:123
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:968
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:501
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:819
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:112
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:200
msgid "上下架"
msgstr "上下架"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1197
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:1049
msgid "上下架操作日誌"
msgstr "上下架操作日誌"

#: apps/dp-admin/src/pages/org-tree/org-list/components/ShelfHistoryModal/index.web.tsx:78
#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:141
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:989
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:839
msgid "上下架歷史"
msgstr "上下架歷史"

#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:80
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:524
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:376
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:321
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:132
msgid "上下架狀態"
msgstr "上下架狀態"

#: apps/dp-admin/src/pages/audit-center/components/PublishOperationLogsCard/index.web.tsx:30
msgid "上下架記錄"
msgstr "上下架記錄"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:175
msgid "上下線狀態"
msgstr "上下線狀態"

#: apps/dp-business/src/pages/StoreDescription.tsx:235
#: apps/dp-business/src/pages/ImageManagement/index.tsx:509
#: apps/dp-business/src/components/ModificationReason/index.tsx:137
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:683
msgid "上傳"
msgstr "上傳"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:171
msgid "上傳 Excel 檔案"
msgstr "上傳 Excel 檔案"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:231
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:231
msgid "上傳 Excel："
msgstr "上傳 Excel："

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:144
msgid "上傳 Logo"
msgstr "上傳 Logo"

#. placeholder {0}: doc.title
#. placeholder {0}: image.title
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:1030
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:1165
msgid "上傳{0}"
msgstr "上傳{0}"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:168
msgid "上傳一段影片，分享您的品牌故事、開店理念、店面風格與環境，或是料理過程，讓更多客戶認識您的店家。"
msgstr "上傳一段影片，分享您的品牌故事、開店理念、店面風格與環境，或是料理過程，讓更多客戶認識您的店家。"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:659
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:657
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:41
msgid "上傳中"
msgstr "上傳中"

#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:113
#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/index.tsx:109
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:383
#: apps/dp-business/src/components/PhotoUploader/index.tsx:211
#: apps/dp-business/src/components/PhotoUploader/components/PhotoUploadArea.tsx:74
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:840
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:354
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:135
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:383
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:67
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:245
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:245
#: apps/dp-admin/src/pages/merchant/shared/constants.ts:98
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:889
#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:372
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:314
#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:682
#: apps/dp-admin/src/components/ImageListUploader/index.web.tsx:330
msgid "上傳中..."
msgstr "上傳中..."

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:188
msgid "上傳中…"
msgstr "上傳中…"

#. placeholder {0}: p.percent
#. placeholder {0}: progress.toFixed(0)
#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:128
#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/index.tsx:135
msgid ""
"上傳中...\n"
"{0}%"
msgstr ""
"上傳中...\n"
"{0}%"

#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:374
msgid "上傳主圖"
msgstr "上傳主圖"

#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:103
msgid "上傳人"
msgstr "上傳人"

#: apps/dp-business/src/components/ModificationReason/index.tsx:113
msgid "上傳修改理由圖片"
msgstr "上傳修改理由圖片"

#: apps/dp-admin/src/components/ImageListUploader/index.web.tsx:173
#: apps/dp-admin/src/components/ImageListUploader/index.web.tsx:230
msgid "上傳出錯"
msgstr "上傳出錯"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:41
msgid "上傳參數（三擇一，必選）"
msgstr "上傳參數（三擇一，必選）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/SigningSteps/index.web.tsx:11
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/services/constants.ts:35
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicContractTabs/index.web.tsx:33
msgid "上傳合約"
msgstr "上傳合約"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:686
msgid "上傳名單（選填）"
msgstr "上傳名單（選填）"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:735
msgid "上傳商家ID文件"
msgstr "上傳商家ID文件"

#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:140
msgid "上傳商家列表"
msgstr "上傳商家列表"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:79
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:411
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:45
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:46
msgid "上傳圖像時出錯"
msgstr "上傳照片時出錯"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/CorrectionModal.tsx:244
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:84
#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:71
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:69
#: apps/dp-client/src/components/FeedBackModal/index.tsx:354
#: apps/dp-business/src/components/PhotoUploader/index.tsx:376
#: apps/dp-business/src/components/PhotoUploader/index.tsx:430
#: apps/dp-business/src/components/PhotoUploader/components/PhotoUploadArea.tsx:96
#: apps/dp-business/src/components/PhotoUploader/components/PhotoUploadArea.tsx:115
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:140
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:388
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:72
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:395
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:140
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:154
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:169
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:184
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:199
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:214
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:45
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:79
msgid "上傳圖片"
msgstr "上傳圖片"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:729
msgid "上傳圖片（選填）"
msgstr "上傳圖片（選填）"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:384
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:388
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:471
msgid "上傳圖片或動圖"
msgstr "上傳圖片或動圖"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:263
msgid "上傳圖示"
msgstr "上傳圖示"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:280
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:204
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:304
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:114
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:361
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:113
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:138
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:138
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:609
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:618
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:792
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:939
#: apps/dp-admin/src/modules/hooks/useImageUpload.ts:305
#: apps/dp-admin/src/components/ImageListUploader/index.web.tsx:160
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:53
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:56
#: apps/dp-admin/src/components/FileUpload/index.web.tsx:276
msgid "上傳失敗"
msgstr "上傳失敗"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:287
msgid "上傳失敗，請檢查網路連線"
msgstr "上傳失敗，請檢查網路連線"

#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:268
msgid "上傳失敗，請檢查網路連線後重試"
msgstr "上傳失敗，請檢查網路連線後重試"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:205
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:242
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:248
msgid "上傳失敗，請稍後重試"
msgstr "上傳失敗，請稍後重試"

#: apps/dp-client/src/components/Upload/index.tsx:587
#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:261
#: apps/dp-admin/src/modules/hooks/useImageUpload.ts:290
msgid "上傳失敗，請重試"
msgstr "上傳失敗，請重試"

#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:550
#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:562
#: apps/dp-admin/src/components/ImageListUploader/index.web.tsx:60
msgid "上傳已取消"
msgstr "上傳已取消"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/index.web.tsx:234
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/index.web.tsx:232
msgid "上傳店家列表"
msgstr "上傳店家列表"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:166
msgid "上傳店家影片"
msgstr "上傳店家影片"

#: apps/dp-business/src/servers/shop/api.ts:435
msgid "上傳店家照片失敗"
msgstr "上傳店家照片失敗"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:363
msgid "上傳店門口照片"
msgstr "上傳店門口照片"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:153
#: apps/dp-business/src/pages/VideoUpload/index.tsx:178
#: apps/dp-business/src/pages/VideoUpload/index.tsx:230
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:624
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:226
msgid "上傳影片"
msgstr "上傳影片"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:988
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1000
msgid "上傳您的身分證反面"
msgstr "上傳您的身分證反面"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:957
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:970
msgid "上傳您的身分證正面"
msgstr "上傳您的身分證正面"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:94
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:48
#: apps/dp-admin/src/components/FileUpload/index.web.tsx:268
msgid "上傳成功"
msgstr "上傳成功"

#. placeholder {0}: data.batchId
#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:252
msgid "上傳成功！批次ID: {0}"
msgstr "上傳成功！批次ID: {0}"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1406
msgid "上傳截圖"
msgstr "上傳截圖"

#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:122
msgid "上傳數量"
msgstr "上傳數量"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:634
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:116
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:176
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:275
msgid "上傳時間"
msgstr "上傳時間"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:137
msgid "上傳模板"
msgstr "上傳模板"

#: apps/dp-business/src/components/PhotoUploader/index.tsx:429
msgid "上傳檔案"
msgstr "上傳檔案"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:343
msgid "上傳檔案（圖片或PDF，僅限1張）"
msgstr "上傳檔案（圖片或PDF，僅限1張）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:344
msgid "上傳檔案（圖片或PDF）"
msgstr "上傳檔案（圖片或PDF）"

#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:99
msgid "上傳檔案名稱"
msgstr "上傳檔案名稱"

#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:367
#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:237
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:237
msgid "上傳歷史"
msgstr "上傳歷史"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:118
msgid "上傳活動圖片"
msgstr "上傳活動圖片"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:64
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:62
msgid "上傳照片"
msgstr "上傳照片"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:603
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:602
msgid "上傳照片失敗，請嘗試更換照片重試"
msgstr "上傳照片失敗，請更換照片重試"

#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/MediaSection.tsx:29
msgid "上傳照片或影片"
msgstr "上傳照片或影片"

#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:129
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:153
msgid "上傳狀態"
msgstr "上傳狀態"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:862
msgid "上傳環境圖/餐點圖"
msgstr "上傳環境照片/餐點照片"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:688
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:685
#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:436
msgid "上傳的圖片"
msgstr "上傳的照片"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:297
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:519
msgid "上傳結果中沒有找到圖片URL"
msgstr "上傳結果中沒有找到照片URL"

#: apps/dp-admin/src/modules/hooks/useImageUpload.ts:295
msgid "上傳結果缺少文件地址，請重試"
msgstr "上傳結果缺少文件地址，請重試"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:765
msgid "上傳補充商家ID檔案"
msgstr "上傳補充商家ID檔案"

#: apps/dp-admin/src/pages/merchant/components/UploadTips/index.web.tsx:28
msgid "上傳要求"
msgstr "上傳要求"

#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:196
msgid "上傳說明"
msgstr "上傳說明"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:389
msgid "上傳證據圖片"
msgstr "上傳證據照片"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1203
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1215
msgid "上傳負責人身份證反面"
msgstr "上傳負責人身份證反面"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1173
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1185
msgid "上傳負責人身份證正面"
msgstr "上傳負責人身份證正面"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1106
msgid "上傳負責人身份資訊"
msgstr "上傳負責人身份資訊"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:743
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:752
#: apps/dp-business/src/pages/OnboardingComplete/index.tsx:86
#: apps/dp-business/src/pages/MerchantReview/index.tsx:73
#: apps/dp-business/src/pages/AddStore/index.tsx:1205
msgid "上傳資料"
msgstr "上傳資料"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:117
msgid "上傳頭像"
msgstr "上傳頭像"

#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:300
msgid "上傳類型："
msgstr "上傳類型："

#: apps/dp-business/src/pages/MenuItemForm.tsx:519
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:462
msgid "上傳餐點的動態圖片"
msgstr "上傳餐點的動態圖片"

#: apps/dp-client/src/screens/reservation/pages/main/types.ts:25
msgid "上午{time}"
msgstr "上午{time}"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:438
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:205
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileList/index.web.tsx:142
msgid "上拉載入更多"
msgstr "上拉載入更多"

#: apps/dp-business/src/utils/dateRange.ts:142
msgid "上月"
msgstr "上月"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:455
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1432
#: apps/dp-admin/src/pages/resource-config/app-notice/services.ts:46
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:445
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:75
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:31
#: apps/dp-admin/src/pages/merchant/service/constants.ts:64
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/interface.ts:23
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:69
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:105
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:370
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:392
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:259
#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:186
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:189
msgid "上架"
msgstr "上架"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:214
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:790
msgid "上架失敗"
msgstr "上架失敗"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:796
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:191
msgid "上架失敗，請重試"
msgstr "上架失敗，請重試"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:239
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:200
msgid "上架套餐券模板數"
msgstr "上架套餐券模板數"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:754
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:275
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:567
msgid "上架後，套餐券將立即對用戶展示並開放購買。"
msgstr "上架後，套餐券將立即對用戶展示並開放購買。"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:776
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:351
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:208
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:107
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:194
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:322
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:548
msgid "上架成功"
msgstr "上架成功"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1119
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:609
msgid "上架確認"
msgstr "上架確認"

#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:291
msgid "上榜年份"
msgstr "上榜年份"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:74
msgid "上榜數量"
msgstr "上榜數量"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:64
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:160
msgid "上榜狀態"
msgstr "上榜狀態"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:130
msgid "上榜用戶"
msgstr "上榜用戶"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:108
msgid "上次值"
msgstr "上次值"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:81
msgid "上次提交"
msgstr "上次提交"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1467
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1796
msgid "上次提交審核的建單結果尚未確認，將以原請求重試確認；之後的新改動不會一併提交。"
msgstr "上次提交審核的建單結果尚未確認，將以原請求重試確認；之後的新改動不會一併提交。"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1585
msgid "上次提交審核的結果尚未確認，請先點擊「保存」確認結果"
msgstr "上次提交審核的結果尚未確認，請先點擊「保存」確認結果"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1461
msgid "上次提交審核的結果尚未確認，請先點擊「保存並提交審核」確認結果"
msgstr "上次提交審核的結果尚未確認，請先點擊「保存並提交審核」確認結果"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:40
msgid "上次登錄縣市"
msgstr "上次登錄縣市"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:578
msgid "上海"
msgstr "上海"

#: apps/dp-client/src/screens/home/pages/Review/components/ModelSummary/index.tsx:70
msgid "上百種模型推論，確保真實評論"
msgstr "使用AI驗證，確保真實評論"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:106
msgid "上級 ID"
msgstr "上級 ID"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:253
msgid "上級一級渠道"
msgstr "上級一級渠道"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:254
msgid "上級二級渠道"
msgstr "上級二級渠道"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:64
msgid "上級停用"
msgstr "上級停用"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:217
#: apps/dp-admin/src/pages/org-tree/org-detail/components/AddChildNodeModal/index.web.tsx:53
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:36
msgid "上級節點"
msgstr "上級節點"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1514
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1640
msgid "上級節點已停用，請先啟用上級節點"
msgstr "上級節點已停用，請先啟用上級節點"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:40
#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:137
msgid "上線"
msgstr "上線"

#: apps/dp-business/src/utils/dateRange.ts:141
msgid "上週"
msgstr "上週"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:270
msgid "上限{userAmount}元"
msgstr "上限{userAmount}元"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ExchangeLimitEditor/index.web.tsx:54
msgid "上限必須大於 0"
msgstr "上限必須大於 0"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:386
msgid "上限金額"
msgstr "上限金額"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:1124
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/ImageThumbnailList.tsx:157
#: apps/dp-business/src/pages/Login/index.tsx:1125
#: apps/dp-business/src/pages/Login/index.tsx:1600
#: apps/dp-business/src/components/PhoneVerification/index.tsx:303
#: apps/dp-business/src/components/ForgotPassword/index.tsx:461
#: apps/dp-business/src/components/EmailVerification/index.tsx:309
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:470
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:487
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:528
#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:635
#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:227
#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:232
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:705
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:458
msgid "下一步"
msgstr "下一步"

#: apps/dp-business/src/pages/PermissionManagement/index.tsx:330
#: apps/dp-business/src/pages/ComplaintList/index.tsx:480
msgid "下一頁"
msgstr "下一頁"

#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:124
msgid "下劃線"
msgstr "下劃線"

#. placeholder {0}: hour > 12 ? hour - 12 : hour
#. placeholder {1}: time.split(':')[1] || '00'
#: apps/dp-client/src/screens/reservation/pages/main/types.ts:27
msgid "下午{0}:{1}"
msgstr "下午{0}:{1}"

#: apps/dp-client/src/screens/reservation/pages/main/types.ts:29
msgid "下午{time}"
msgstr "下午{time}"

#: apps/dp-business/src/types/orderFilter.ts:196
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:419
#: apps/dp-business/src/constants/enums.ts:44
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:262
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1253
#: apps/dp-admin/src/components/BusinessHours/constants.ts:38
msgid "下午茶"
msgstr "下午茶"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:123
msgid "下午茶時段"
msgstr "下午茶時段"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1042
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1792
#: apps/dp-business/src/pages/OrderOverview/FilterModal.tsx:39
#: apps/dp-business/src/pages/OrderList/index.tsx:631
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:215
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:134
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesFilterBar.tsx:81
#: apps/dp-business/src/pages/OrderDetail/index.tsx:777
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1105
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:397
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1311
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:589
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherSalesReport.tsx:130
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:149
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:244
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:90
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:106
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:852
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1128
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:123
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:316
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:171
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:176
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:93
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:154
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:152
msgid "下單時間"
msgstr "下單時間"

#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:344
msgid "下單時間："
msgstr "下單時間："

#: apps/dp-business/src/pages/OrderList/index.tsx:853
msgid "下單時間範圍"
msgstr "下單時間範圍"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:70
msgid "下單次數"
msgstr "下單次數"

#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:56
msgid "下單用戶"
msgstr "下單用戶"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:204
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:155
msgid "下單資訊"
msgstr "下單資訊"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:186
msgid "下屬二級品類數量"
msgstr "下屬二級品類數量"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:639
msgid "下拉選擇"
msgstr "下拉選擇"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:231
msgid "下方為本次送審的完整內容，請逐項核對後再審批。"
msgstr "下方為本次送審的完整內容，請逐項核對後再審批。"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:205
msgid "下方階梯的字數及圖片數不可低於上一階梯，已自動調整"
msgstr "下方階梯的字數及圖片數不可低於上一階梯，已自動調整"

#: apps/dp-business/src/utils/dateRange.ts:120
msgid "下月"
msgstr "下月"

#: apps/dp-client/src/screens/account/pages/task-wall/components/rewardLabels.ts:24
msgid "下期可再兌換"
msgstr "下期可再兌換"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:455
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:97
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1445
#: apps/dp-admin/src/pages/resource-config/app-notice/services.ts:47
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:445
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:76
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:32
#: apps/dp-admin/src/pages/merchant/service/constants.ts:65
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/interface.ts:24
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:70
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:106
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:382
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:405
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:260
#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:177
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:179
msgid "下架"
msgstr "下架"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:288
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:580
msgid "下架不會影響退款中或未使用的訂單。"
msgstr "下架不會影響退款中或未使用的訂單。"

#: apps/dp-admin/src/pages/audit-center/components/PublishOperationLogsCard/index.web.tsx:64
msgid "下架原因"
msgstr "下架原因"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:215
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:843
msgid "下架失敗"
msgstr "下架失敗"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:849
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:260
msgid "下架失敗，請重試"
msgstr "下架失敗，請重試"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:116
msgid "下架店家"
msgstr "下架店家"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:284
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:576
msgid "下架後，套餐券將不再對用戶展示，且無法再次購買。"
msgstr "下架後，套餐券將不再對用戶展示，且無法再次購買。"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:223
msgid "下架後相關前臺／權限按產品約定將不可用，請確認。"
msgstr "下架後相關前臺／權限按產品約定將不可用，請確認。"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:341
msgid "下架後記錄仍留在列表，工單、客服不再展示這筆。"
msgstr "下架後記錄仍留在列表，工單、客服不再展示這筆。"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:829
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:351
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:208
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:107
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:263
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:322
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:548
msgid "下架成功"
msgstr "下架成功"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1119
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:609
msgid "下架確認"
msgstr "下架確認"

#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ActionButtons/index.web.tsx:86
msgid "下架該店家"
msgstr "下架該店家"

#: apps/dp-admin/src/modules/constants/options.ts:138
msgid "下次追蹤"
msgstr "下次追蹤"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:54
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:119
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:123
#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:160
#: apps/dp-admin/src/pages/merchant/components/HistoryTable/index.web.tsx:111
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:103
msgid "下次追蹤時間"
msgstr "下次追蹤時間"

#: apps/dp-admin/src/pages/merchant/task-list/components/FollowUpHistoryModal/index.web.tsx:92
msgid "下次追蹤時間："
msgstr "下次追蹤時間："

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:87
msgid "下次重試時間"
msgstr "下次重試時間"

#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeNodeCard.tsx:124
msgid "下級店家"
msgstr "下級店家"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:40
#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:129
msgid "下線"
msgstr "下線"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:206
msgid "下車後步行路線"
msgstr "下車後步行路線"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:653
#: apps/dp-business/src/components/PhotoUploader/index.tsx:346
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:144
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:96
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:207
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:105
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:173
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:107
#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:112
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:97
#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:84
msgid "下載"
msgstr "下載"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:239
msgid "下載 ERP 檔案"
msgstr "下載 ERP 檔案"

#. placeholder {0}: queryResult.totalMerchantCount
#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:209
msgid "下載{0}份藍新ERP Excel"
msgstr "下載{0}份藍新ERP Excel"

#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:183
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:218
msgid "下載ERP"
msgstr "下載ERP"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:159
msgid "下載並填寫範本"
msgstr "下載並填寫範本"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:60
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:77
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:99
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:116
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:75
msgid "下載中..."
msgstr "下載中..."

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/ScanQrCodeModal.web.tsx:92
msgid "下載二維碼"
msgstr "下載二維碼"

#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:89
msgid "下載合約模板"
msgstr "下載合約模板"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:166
msgid "下載報表"
msgstr "下載報表"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:677
#: apps/dp-admin/src/pages/report-center/services/apis.ts:714
#: apps/dp-admin/src/pages/report-center/services/apis.ts:751
#: apps/dp-admin/src/modules/hooks/useDownload.ts:128
#: apps/dp-admin/src/modules/hooks/useDownload.ts:144
#: apps/dp-admin/src/modules/hooks/useDownload.ts:195
#: apps/dp-admin/src/modules/apis/index.ts:133
#: apps/dp-admin/src/modules/apis/index.ts:138
msgid "下載失敗"
msgstr "下載失敗"

#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:133
msgid "下載失敗，請檢查網絡連接後重試"
msgstr "下載失敗，請檢查網絡連接後重試"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:94
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:126
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:153
msgid "下載失敗，請稍後重試"
msgstr "下載失敗，請稍後重試"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:62
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:79
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:101
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:118
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:89
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:94
#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:129
msgid "下載失敗，請重試"
msgstr "下載失敗，請重試"

#: apps/dp-admin/src/modules/hooks/useDownload.ts:147
#: apps/dp-admin/src/modules/hooks/useDownload.ts:198
msgid "下載失敗：{errorMessage}"
msgstr "下載失敗：{errorMessage}"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ImportShopModal/index.web.tsx:116
msgid "下載導入模板"
msgstr "下載導入模板"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ImportPackageFields/index.web.tsx:28
msgid "下載導入範本"
msgstr "下載導入範本"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:61
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:78
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:100
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:117
#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:126
#: apps/dp-admin/src/pages/marketing/channel-management/services/useChannelImport.ts:235
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:108
msgid "下載成功"
msgstr "下載成功"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:1100
msgid "下載文件失敗"
msgstr "下載文件失敗"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:124
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/FixedPackageImportField/index.web.tsx:196
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:311
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:220
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:220
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ImportShopModal/index.web.tsx:122
msgid "下載模板"
msgstr "下載模板"

#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:115
#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:376
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:363
msgid "下載源 Excel"
msgstr "下載源 Excel"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:141
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/BatchUploadForm/index.web.tsx:38
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:726
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:752
#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:171
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:168
msgid "下載範本"
msgstr "下載範本"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:656
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:204
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:204
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:164
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:311
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:328
msgid "下載範本："
msgstr "下載範本："

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/ExportHistoryTab/index.web.tsx:122
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/ExportHistoryTab/index.web.tsx:122
#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/Details.web.tsx:80
msgid "下載結果"
msgstr "下載結果"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:298
msgid "下載錯誤清單"
msgstr "下載錯誤清單"

#: apps/dp-business/src/utils/dateRange.ts:119
msgid "下週"
msgstr "下週"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:541
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:506
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:285
msgid "不予中獎"
msgstr "不予中獎"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/RejectWinnerModal.web.tsx:73
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchRejectWinnerModal.web.tsx:92
msgid "不予中獎原因"
msgstr "不予中獎原因"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/apis.ts:81
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/RejectWinnerModal.web.tsx:48
msgid "不予中獎失敗"
msgstr "不予中獎失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/RejectWinnerModal.web.tsx:44
msgid "不予中獎成功"
msgstr "不予中獎成功"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:358
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:156
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:299
msgid "不予發獎"
msgstr "不予發獎"

#: apps/dp-admin/src/pages/org-tree/org-create/components/UnsavedNodeModal/index.web.tsx:30
msgid "不保存"
msgstr "不保存"

#: apps/dp-business/src/components/UnsavedChangesDialog/index.tsx:58
msgid "不儲存"
msgstr "不儲存"

#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:89
#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:381
msgid "不允許"
msgstr "不允許"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:410
msgid "不允許同時使用"
msgstr "不允許同時使用"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:353
msgid "不刪除"
msgstr "不刪除"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:149
msgid "不包含上下限"
msgstr "不包含上下限"

#: apps/dp-business/src/pages/OrderList/index.tsx:754
msgid "不包含退費金額/券"
msgstr "不包含退費金額/券"

#: apps/dp-business/src/pages/OrderList/index.tsx:786
#: apps/dp-business/src/pages/OrderList/index.tsx:812
msgid "不包含退費金額/訂單"
msgstr "不包含退費金額/訂單"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:533
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:230
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowUserListItem.tsx:119
#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:420
msgid "不取消"
msgstr "不取消"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2359
msgid "不可以"
msgstr "不可以"

#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:37
msgid "不可到期自動退"
msgstr "無法到期自動退款"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/PackageColumns/index.web.tsx:28
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:37
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:77
msgid "不可售"
msgstr "不可售"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:243
msgid "不可售套餐"
msgstr "不可售套餐"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:204
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:176
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/templatePreviewData.ts:96
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:242
msgid "不可用"
msgstr "不可用"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:210
msgid "不可用優惠"
msgstr "不可用優惠"

#: apps/dp-client/src/screens/home/pages/Meal/pages/shopSelect/index.tsx:344
#: apps/dp-client/src/components/ShopSelectSheet/index.tsx:326
msgid "不可用店家"
msgstr "不可用店家"

#: apps/dp-client/src/screens/home/utils/order.ts:1010
msgid "不可用時段"
msgstr "不可用時段"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1750
msgid "不可用設置"
msgstr "不可用設置"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:459
msgid "不可疊加"
msgstr "不可疊加"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:32
msgid "不可退款"
msgstr "不可退款"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:74
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:562
msgid "不可選"
msgstr "不可選"

#. placeholder {0}: MERCHANT_UNSELECTABLE_REASON[code] || code || '-'
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:96
msgid "不可選：{0}"
msgstr "不可選：{0}"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:152
msgid "不可選擇"
msgstr "不可選擇"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:138
msgid "不可重發"
msgstr "不可重發"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:38
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/hooks.ts:27
msgid "不可重試"
msgstr "不可重試"

#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:27
msgid "不可隨時退款"
msgstr "無法隨時退款"

#: apps/dp-client/src/screens/login/components/privacy-agreement-modal/index.tsx:89
#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:286
#: apps/dp-client/src/screens/login/components/fet-login-modal/index.tsx:118
#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:77
#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:83
#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:109
msgid "不同意"
msgstr "不同意"

#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:105
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:110
msgid "不含即將開業、暫停營業、永久歇業"
msgstr "不含即將開業、暫停營業、永久歇業"

#: apps/dp-business/src/utils/location.ts:154
msgid "不在 WebView 環境中"
msgstr "不在 WebView 環境中"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:46
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:43
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:336
msgid "不實資訊"
msgstr "不實資訊"

#: apps/dp-admin/src/pages/marketing/components/CombinedListForm/index.web.tsx:120
#: apps/dp-admin/src/components/CombinationFilterForm/index.web.tsx:25
msgid "不屬於"
msgstr "不屬於"

#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:229
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:210
msgid "不屬於名單 ID"
msgstr "不屬於名單 ID"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:255
msgid "不想去了"
msgstr "不想去了"

#. placeholder {0}: restaurantInfo.recommendations.dislike
#: apps/dp-client/src/screens/diary/pages/my/components/DiaryCard.tsx:195
msgid "不推：{0}"
msgstr "不推薦：{0}"

#: apps/dp-client/src/screens/diary/components/DiaryTags/index.tsx:102
msgid "不推：{notRecommended}"
msgstr "不推薦：{notRecommended}"

#. placeholder {0}: fileExt.toUpperCase()
#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:193
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:189
msgid "不支持{0}格式，請選擇JPG、PNG或WEBP格式的圖片"
msgstr "不支持{0}格式，請選擇JPG、PNG或WEBP格式的照片"

#: apps/dp-business/src/utils/location.ts:227
msgid "不支持定位功能"
msgstr "不支持定位功能"

#: apps/dp-business/src/components/PhotoUploader/validation.ts:114
msgid "不支持的{typeNames}格式，請選擇正確的文件類型"
msgstr "不支持的{typeNames}格式，請選擇正確的文件類型"

#. placeholder {0}: this.mediaType
#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/MediaReplacer.tsx:78
msgid "不支持的媒體類型: {0}"
msgstr "不支持的媒體類型: {0}"

#. placeholder {0}: acceptedTypes.join(', ')
#: apps/dp-admin/src/modules/hooks/useImageUpload.ts:129
msgid "不支持的文件類型。支持的類型：{0}"
msgstr "不支持的文件類型。支持的類型：{0}"

#: apps/dp-business/src/utils/dateRange.ts:82
msgid "不支持的時間方向: {direction}"
msgstr "不支持的時間方向: {direction}"

#: apps/dp-admin/src/components/ConfigurableForm/ConfigurableForm.web.tsx:344
msgid "不支持的組件類型:{component}"
msgstr "不支持的組件類型:{component}"

#: apps/dp-client/src/screens/account/pages/notifications/pages/CategoryNotifications/index.tsx:80
msgid "不支持的通知類型"
msgstr "不支持的通知類型"

#: apps/dp-business/src/utils/dateRange.ts:301
msgid "不支持的預設時間範圍: {preset}"
msgstr "不支持的預設時間範圍: {preset}"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:68
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:70
msgid "不支援上傳影片檔案"
msgstr "不支援上傳影片檔案"

#: apps/dp-business/src/components/PhotoUploader/hooks/useImageAspectRatio.tsx:70
msgid "不支援的圖片格式"
msgstr "不支援的圖片格式"

#: apps/dp-business/src/components/PhotoUploader/validation.ts:105
msgid "不支援的影片格式，請選擇 MP4、MOV、AVI 等格式的影片檔案"
msgstr "不支援的影片格式，請選擇 MP4、MOV、AVI 等格式的影片檔案"

#: apps/dp-client/src/components/Upload/index.tsx:440
msgid "不支援的檔案類型"
msgstr "不支援的檔案類型"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:540
msgid "不支援的複製類型"
msgstr "不支援的複製類型"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:93
msgid "不會改店家已綁定的簽約 / 請款商家。已完成結算單不回溯。之後新產生的請款走店家商家，不再走本樹。"
msgstr "不會改店家已綁定的簽約 / 請款商家。已完成結算單不回溯。之後新產生的請款走店家商家，不再走本樹。"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:94
msgid "不會改店家已綁定的簽約 / 請款商家。結算仍走「{settleTreeName}」，不受本次解除影響。"
msgstr "不會改店家已綁定的簽約 / 請款商家。結算仍走「{settleTreeName}」，不受本次解除影響。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:58
msgid "不會自動改次級結算路徑；管理員在本節點範圍內不可再新增操作；下級節點不連帶停用。"
msgstr "不會自動改次級結算路徑；管理員在本節點範圍內不可再新增操作；下級節點不連帶停用。"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:33
msgid "不當內容"
msgstr "不當內容"

#: apps/dp-client/src/screens/home/utils/utils.ts:424
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:289
msgid "不當或違法內容"
msgstr "不當或違法內容"

#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/index.tsx:32
msgid "不看他/她"
msgstr "不看他/她"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:85
msgid "不符合藍新資格"
msgstr "不符合藍新資格"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFilter.tsx:43
msgid "不符合門檻"
msgstr "不符合門檻"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:220
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:69
msgid "不能為空值"
msgstr "不能留空"

#: apps/dp-client/src/screens/home/components/InputMaskOverlay/index.tsx:553
msgid "不能超過{maxLength}個字喔"
msgstr "不能超過{maxLength}個字喔"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:399
msgid "不解除"
msgstr "不解除"

#: apps/dp-business/src/components/ClaimAmountAlert/index.tsx:37
msgid "不論您當月金額是否達到 3,500 元，皆可於下月5號結算日請款一次。"
msgstr "不論您當月金額是否達到 3,500 元，皆可於下月5號結算日請款一次。"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:78
msgid "不變"
msgstr "不變"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:56
msgid "不變（{settleTreeName}）"
msgstr "不變（{settleTreeName}）"

#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/index.tsx:31
msgid "不讓他/她看"
msgstr "不讓他/她看"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/PromotionTab/index.web.tsx:99
msgid "不超過20字"
msgstr "不超過20字"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/PromotionTab/index.web.tsx:81
msgid "不超過6字"
msgstr "不超過6字"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:238
msgid "不通知"
msgstr "不通知"

#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:76
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:96
#: apps/dp-admin/src/pages/merchant/audit-detail/components/SelectableCard/index.web.tsx:72
msgid "不通過"
msgstr "不通過"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:631
msgid "不達標"
msgstr "不達標"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:56
msgid "不選則為全部店家；選擇指定店家組後，使用者僅能在所選組別的店內完成指定事件方為有效. 舉例：若「發布訂單評論」任務配置了特定商家組，使用者必須在該組別的店家完成下單並發表評論，該筆任務才算達成"
msgstr "不選則為全部店家；選擇指定店家組後，使用者僅能在所選組別的店內完成指定事件方為有效. 舉例：若「發布訂單評論」任務配置了特定商家組，使用者必須在該組別的店家完成下單並發表評論，該筆任務才算達成"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:56
msgid "不錯"
msgstr "不錯"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:34
msgid "不錯！"
msgstr "不錯！"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/Card.tsx:166
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:514
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:604
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:622
#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:620
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:769
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:348
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:448
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:459
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:465
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:471
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:477
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2204
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:315
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:406
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:481
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:566
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:87
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:103
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:114
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:132
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:467
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:244
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:277
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:110
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:152
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:69
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:20
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:23
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:48
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:57
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:70
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:29
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:32
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:66
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:75
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:88
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:15
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:444
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:569
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:571
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2165
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2211
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:78
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:130
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:185
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:240
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:43
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/BenefitInfoPanel/index.web.tsx:23
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:61
#: apps/dp-admin/src/components/UserFilterSection/index.web.tsx:14
#: apps/dp-admin/src/components/UserFilterSection/components/UserGroupSelect.web.tsx:28
#: apps/dp-admin/src/components/UserFilterSection/components/TargetCitySelect.web.tsx:12
#: apps/dp-admin/src/components/UserFilterSection/components/DeviceSystemSelect.web.tsx:10
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:18
msgid "不限"
msgstr "不限"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:161
msgid "不限（無兌換消耗上限）"
msgstr "不限（無兌換消耗上限）"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:468
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:108
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:131
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:180
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:104
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:111
msgid "不限使用張數"
msgstr "不限使用張數"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2270
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:190
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:201
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:151
#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:159
msgid "不限制"
msgstr "不限制"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:157
msgid "不限則留空"
msgstr "不限則留空"

#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:122
#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:133
msgid "不限時間"
msgstr "不限時間"

#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:276
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/types.ts:136
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:396
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:817
msgid "不需事先預約"
msgstr "不需事先預約"

#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:406
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:502
msgid "不需要"
msgstr "不需要"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageConditionTree/index.web.tsx:26
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:98
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:69
#: apps/dp-admin/src/pages/marketing/components/CombinedListForm/index.web.tsx:114
#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:228
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:209
#: apps/dp-admin/src/components/CombinationFilterForm/index.web.tsx:19
msgid "且"
msgstr "且"

#: apps/dp-admin/src/pages/merchant/task-list/components/PriorityTag/index.web.tsx:25
#: apps/dp-admin/src/pages/merchant/service/constants.ts:455
msgid "中"
msgstr "中"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:61
msgid "中優先級"
msgstr "中優先級"

#: apps/dp-business/src/data/regions.ts:56
msgid "中和區"
msgstr "中和區"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:42
msgid "中大"
msgstr "中大"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:40
msgid "中小"
msgstr "中小"

#: apps/dp-business/src/data/regions.ts:38
msgid "中山區"
msgstr "中山區"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:134
msgid "中心點經度（±180）"
msgstr "中心點經度（±180）"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:139
msgid "中心點緯度（±90）"
msgstr "中心點緯度（±90）"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:86
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:62
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:185
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:463
msgid "中性"
msgstr "中性"

#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:40
msgid "中期"
msgstr "中期"

#: apps/dp-business/src/data/regions.ts:36
msgid "中正區"
msgstr "中正區"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:439
msgid "中獎人數"
msgstr "中獎人數"

#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:523
#: apps/dp-client/src/screens/diary/pages/winning/components/WinningList/index.tsx:88
#: apps/dp-client/src/configs/page-configs.tsx:2960
#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:167
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/useLotteryWinnersExport.ts:43
msgid "中獎名單"
msgstr "中獎名單"

#: apps/dp-client/src/screens/home/pages/ShareKing/pages/RaffleWinners/index.tsx:354
#: apps/dp-client/src/configs/page-configs.tsx:1183
#: apps/dp-client/src/configs/page-configs.tsx:1185
msgid "中獎名單公告"
msgstr "中獎名單公告"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/PublishPreviewModal.web.tsx:41
msgid "中獎名單預覽"
msgstr "中獎名單預覽"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:355
msgid "中獎權益名稱"
msgstr "中獎權益名稱"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:79
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:181
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:208
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:343
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryUserDrawHistoryModal.web.tsx:84
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:637
msgid "中獎狀態"
msgstr "中獎狀態"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryUserDrawHistoryModal.web.tsx:98
msgid "中獎獎項名稱"
msgstr "中獎獎項名稱"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:134
msgid "中獎用戶"
msgstr "中獎用戶"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:619
msgid "中獎用戶列表"
msgstr "中獎用戶列表"

#: apps/dp-business/src/store/HolidayContext.tsx:135
#: apps/dp-business/src/store/HolidayContext.tsx:153
msgid "中秋"
msgstr "中秋"

#: apps/dp-business/src/store/HolidayContext.tsx:135
msgid "中秋節"
msgstr "中秋節"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:41
#: apps/dp-client/src/components/TabView/example.tsx:19
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:73
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:98
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:124
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:233
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:40
msgid "中等"
msgstr "中等"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingDistribution.web.tsx:115
msgid "中等（2-3星）"
msgstr "中等（2-3星）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:141
msgid "中英文250字內"
msgstr "中英文250字內"

#: apps/dp-business/src/data/categories.ts:23
msgid "中餐"
msgstr "中餐"

#: apps/dp-admin/src/pages/resource-config/rank-list/components/RankDetailModal/index.web.tsx:53
msgid "主分類編碼"
msgstr "主分類編碼"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:356
msgid "主圖"
msgstr "主圖"

#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:513
msgid "主圖將作為商家的<0>主要展示圖片</0>"
msgstr "主圖將作為商家的<0>主要展示圖片</0>"

#: apps/dp-business/src/pages/MenuManagement.tsx:121
#: apps/dp-business/src/pages/MenuItemForm.tsx:32
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:38
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:38
msgid "主打"
msgstr "主打"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:193
msgid "主標籤:"
msgstr "主標籤:"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:232
msgid "主標籤屬性中備註被合併標籤的數量及名稱"
msgstr "主標籤屬性中備註被合併標籤的數量及名稱"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:173
msgid "主標籤選擇"
msgstr "主標籤選擇"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:101
msgid "主標題"
msgstr "主標題"

#: apps/dp-client/src/configs/main-config.tsx:56
#: apps/dp-client/src/configs/main-config.tsx:118
msgid "主頁"
msgstr "首頁"

#: apps/dp-client/src/configs/page-configs.tsx:2236
msgid "主頁搜尋"
msgstr "主頁搜尋"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/EmailTemplateSection.web.tsx:16
msgid "主題名"
msgstr "主題名"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/types.ts:139
#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:78
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:59
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:60
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:67
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:60
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:61
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:68
msgid "主食"
msgstr "主食"

#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:161
msgid "主體類型"
msgstr "主體類型"

#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:22
msgid "九"
msgstr "九"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:133
msgid "事件"
msgstr "事件"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:130
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:131
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:563
#: apps/dp-business/src/components/DatePicker.tsx:235
#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:15
msgid "二"
msgstr "二"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:315
#: apps/dp-business/src/components/InvoiceForm/index.tsx:368
msgid "二、聚流拆帳事項聯絡窗口"
msgstr "二、聚流拆帳事項聯絡窗口"

#: apps/dp-business/src/servers/chain/nodeApi.ts:164
#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeNodeRow.tsx:33
#: apps/dp-business/src/components/CascadeSelector/index.tsx:111
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:76
#: apps/dp-admin/src/pages/org-tree/org-create/services/constants.ts:28
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:47
msgid "二級"
msgstr "二級"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:50
msgid "二級代碼"
msgstr "二級代碼"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:104
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:124
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:83
msgid "二級別名"
msgstr "二級別名"

#: apps/dp-admin/src/pages/resource-config/category-management/index.web.tsx:51
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:258
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:162
msgid "二級品類"
msgstr "二級品類"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:252
msgid "二級品類ID"
msgstr "二級品類ID"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:264
msgid "二級品類圖片"
msgstr "二級品類圖片"

#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:225
msgid "二級品類數量"
msgstr "二級品類數量"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:118
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:698
msgid "二級品類狀態"
msgstr "二級品類狀態"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:687
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:205
msgid "二級品類詳情"
msgstr "二級品類詳情"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:718
msgid "二級品類資訊"
msgstr "二級品類資訊"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:196
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:258
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:25
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:72
msgid "二級標籤"
msgstr "二級標籤"

#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:134
msgid "二級標題"
msgstr "二級標題"

#: apps/dp-admin/src/pages/marketing/channel-management/index.web.tsx:45
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:43
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:300
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:304
msgid "二級渠道"
msgstr "二級渠道"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:303
msgid "二級渠道名稱"
msgstr "二級渠道名稱"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:320
msgid "二級渠道選項加載失敗"
msgstr "二級渠道選項加載失敗"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/ScanQrCodeModal.web.tsx:30
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/ScanQrCodeModal.web.tsx:36
msgid "二維碼下載失敗"
msgstr "二維碼下載失敗"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:145
msgid "二線城市"
msgstr "二線城市"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:117
#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:271
msgid "互斥組名稱"
msgstr "互斥組名稱"

#: apps/dp-client/src/screens/account/pages/user-profile/components/UserInfoSection/index.tsx:209
#: apps/dp-client/src/screens/account/pages/notifications/components/FollowNotificationCard/index.tsx:41
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowUserListItem.tsx:54
msgid "互相追蹤"
msgstr "互相追蹤"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:130
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:131
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:563
#: apps/dp-business/src/components/DatePicker.tsx:235
#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:18
msgid "五"
msgstr "五"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:397
msgid "五、收據樣本"
msgstr "五、收據樣本"

#: apps/dp-business/src/servers/chain/nodeApi.ts:164
#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeNodeRow.tsx:33
#: apps/dp-business/src/components/CascadeSelector/index.tsx:111
msgid "五級"
msgstr "五級"

#: apps/dp-business/src/data/regions.ts:68
msgid "五股區"
msgstr "五股區"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:435
#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:188
msgid "交易 ID"
msgstr "交易 ID"

#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:294
msgid "交易序號"
msgstr "交易序號"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/CheckoutDiscountReport.tsx:118
msgid "交易成功時間"
msgstr "交易成功時間"

#. placeholder {0}: paidAt || EMPTY_TEXT
#. placeholder {0}: row.paidAt || EMPTY_TEXT
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCells.tsx:107
#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:69
msgid "交易成功時間：{0}"
msgstr "交易成功時間：{0}"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1612
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:70
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:247
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:149
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:154
msgid "交易手續費"
msgstr "交易手續費"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:403
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFeeInfo.tsx:41
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:869
msgid "交易手續費："
msgstr "交易手續費："

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:161
msgid "交易手續費(%)"
msgstr "交易手續費(%)"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:175
msgid "交易手續費必須在0-100之間"
msgstr "交易手續費必須在0-100之間"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:108
msgid "交易手續費率"
msgstr "交易手續費率"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:746
msgid "交易明細"
msgstr "交易明細"

#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:118
msgid "交易明細列表"
msgstr "交易明細列表"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:350
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:597
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:726
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:46
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:242
msgid "交易時間"
msgstr "交易時間"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:155
msgid "交易管理"
msgstr "交易管理"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:995
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:343
msgid "交易編號"
msgstr "交易編號"

#: apps/dp-admin/src/pages/report-center/transaction-data/index.web.tsx:81
msgid "交易訂單與金額"
msgstr "交易訂單與金額"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:55
msgid "交易資訊："
msgstr "交易資訊："

#: apps/dp-business/src/pages/ChainDashboard/components/reports/voucherUsageColumns.tsx:60
msgid "交易金額／應付商家金額"
msgstr "交易金額／應付商家金額"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/voucherSalesColumns.tsx:58
msgid "交易金額／應入帳金額"
msgstr "交易金額／應入帳金額"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:683
msgid "交易類別"
msgstr "交易類別"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:486
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:666
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:34
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:121
msgid "交易類型"
msgstr "交易類型"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:564
msgid "交通資訊"
msgstr "交通資訊"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:314
msgid "亮度"
msgstr "亮度"

#: apps/dp-client/src/screens/reservation/pages/main/components/EditView.tsx:189
#: apps/dp-client/src/screens/reservation/pages/detail/components/OrderInfoSection.tsx:66
#: apps/dp-business/src/pages/TableManagement/index.tsx:536
#: apps/dp-business/src/pages/TableManagement/index.tsx:710
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1187
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1994
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:370
#: apps/dp-admin/src/pages/marketing/user-group-create/components/PreviewConfirmModal/index.web.tsx:64
msgid "人"
msgstr "人"

#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:668
msgid "人均"
msgstr "均消"

#. placeholder {0}: (shop.avgPrice / 100).toFixed(0)
#: apps/dp-client/src/screens/home/components/ShopCardRank/index.tsx:93
msgid "人均 ${0}"
msgstr "人均 ${0}"

#: apps/dp-business/src/pages/CustomerReviews/index.tsx:484
msgid "人均 $300-500"
msgstr "人均 $300-500"

#: apps/dp-client/src/screens/diary/components/DiaryTags/index.tsx:116
msgid "人均：{averagePrice}"
msgstr "均消：{averagePrice}"

#. placeholder {0}: formatCurrency(averagePrice)
#: apps/dp-admin/src/pages/data-center/components/ReviewItem.web.tsx:158
msgid "人均{0}"
msgstr "人均{0}"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewContent.tsx:281
msgid "人均{avgPrice}"
msgstr "人均{avgPrice}"

#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:303
msgid "人均價格"
msgstr "人均價格"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:424
#: apps/dp-business/src/utils/validation.ts:201
msgid "人均價格不能超過999999"
msgstr "人均消費不能超過 999999"

#: apps/dp-business/src/utils/validation.ts:163
msgid "人均價格必須在1-100000之間"
msgstr "人均價格必須在1-100000之間"

#: apps/dp-business/src/utils/validation.ts:350
msgid "人均價格必須在1-10000之間"
msgstr "人均價格必須在1-10000之間"

#: apps/dp-business/src/utils/validation.ts:197
msgid "人均價格必須大於0"
msgstr "人均價格必須大於0"

#: apps/dp-business/src/utils/validation.ts:167
#: apps/dp-business/src/utils/validation.ts:351
msgid "人均價格必須是整數"
msgstr "人均價格必須是整數"

#: apps/dp-admin/src/pages/report-center/audit-data/components/OverviewCards.web.tsx:23
msgid "人均審核量"
msgstr "人均審核量"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:968
#: apps/dp-business/src/utils/moduleTypeMapping.ts:81
#: apps/dp-business/src/utils/moduleTypeMapping.ts:242
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1084
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1157
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:105
#: apps/dp-business/src/pages/AveragePrice/index.tsx:227
#: apps/dp-business/src/pages/AveragePrice/index.tsx:244
#: apps/dp-business/src/pages/AveragePrice/index.tsx:288
msgid "人均消費"
msgstr "人均消費"

#: apps/dp-business/src/pages/AveragePrice/index.tsx:195
msgid "人均消費儲存成功"
msgstr "人均消費儲存成功"

#: apps/dp-business/src/pages/AveragePrice/index.tsx:150
#: apps/dp-business/src/pages/AveragePrice/index.tsx:157
msgid "人均消費每7天只能修改一次"
msgstr "人均消費每7天只能修改一次"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1393
msgid "人均消費編輯功能開發中..."
msgstr "人均消費編輯功能開發中..."

#: apps/dp-business/src/utils/moduleTypeMapping.ts:82
msgid "人均消費資訊完整度評分"
msgstr "人均消費資訊完整度評分"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:106
msgid "人均消費金額"
msgstr "人均消費金額"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:26
msgid "人審拒絕"
msgstr "人審拒絕"

#: apps/dp-admin/src/pages/merchant/information-review/components/ReviewInfoSection/index.web.tsx:44
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:133
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:78
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:227
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/MerchantBasicInfo/index.web.tsx:98
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:284
msgid "人審時間"
msgstr "人審時間"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:61
msgid "人審未通過"
msgstr "人審未通過"

#: apps/dp-admin/src/pages/audit-center/components/AuditIssuesList/index.web.tsx:63
msgid "人審歷史"
msgstr "人審歷史"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:25
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:60
msgid "人審通過"
msgstr "人審通過"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:66
#: apps/dp-admin/src/pages/customer-service/services/constants.ts:11
msgid "人工已回覆"
msgstr "人工已回覆"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:128
msgid "人工手動發送"
msgstr "人工手動發送"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1200
#: apps/dp-business/src/pages/OrderOverview/index.tsx:2003
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:91
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:42
msgid "人工接單"
msgstr "人工接單"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:22
msgid "人工稽核"
msgstr "人工稽核"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:248
msgid "人工處理"
msgstr "人工處理"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:255
msgid "人工補償操作"
msgstr "人工補償操作"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:548
#: apps/dp-admin/src/pages/merchant/service/constants.ts:568
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:182
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ActionButtons/index.web.tsx:77
msgid "人工錄入"
msgstr "人工錄入"

#. placeholder {0}: fieldTitles[field]
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:182
msgid "人工錄入 - {0}"
msgstr "人工錄入 - {0}"

#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:467
msgid "人數"
msgstr "人數"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1026
msgid "人數 "
msgstr "人數 "

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1990
msgid "人數/桌位"
msgstr "人數/桌位"

#: apps/dp-client/src/screens/reservation/pages/detail/components/OrderInfoSection.tsx:65
msgid "人數桌型"
msgstr "人數桌型"

#: apps/dp-client/src/screens/home/pages/Home/components/HotRanking/index.tsx:59
msgid "人氣榜"
msgstr "人氣榜"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:228
msgid "人餐"
msgstr "用餐"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:90
msgid "什麼是美食筆記"
msgstr "什麼是美食筆記"

#: apps/dp-business/src/utils/dateRange.ts:103
#: apps/dp-business/src/types/orderFilter.ts:142
#: apps/dp-business/src/types/orderFilter.ts:154
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:576
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1944
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1025
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1782
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1808
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:208
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:220
msgid "今天"
msgstr "今天"

#: apps/dp-business/src/utils/dateRange.ts:106
msgid "今年"
msgstr "今年"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:64
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:30
msgid "今日"
msgstr "今日"

#. placeholder {0}: dayjs(coupon.validEndTime).format('HH:mm')
#: apps/dp-client/src/components/CouponCard/index.tsx:279
msgid "今日 {0} 到期"
msgstr "今日 {0} 到期"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/OverviewCards.web.tsx:21
msgid "今日GMV"
msgstr "今日GMV"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:938
msgid "今日交易用戶數"
msgstr "今日交易用戶數"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/OverviewCards.web.tsx:41
msgid "今日交易筆數"
msgstr "今日交易筆數"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:902
msgid "今日人均交易金額"
msgstr "今日人均交易金額"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/OverviewCards.web.tsx:31
msgid "今日人均交易額"
msgstr "今日人均交易額"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/records/components/PointsRecordItem/index.tsx:18
#: apps/dp-client/src/screens/account/pages/task-wall/pages/home/index.tsx:433
#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:223
#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:226
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:220
msgid "今日任務"
msgstr "今日任務"

#. placeholder {0}: shareStats?.dailyIssuedCount ?? 0
#. placeholder {1}: shareStats?.dailyLimit ?? 0
#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:698
msgid "今日分享{0}/{1}次"
msgstr "今日分享{0}/{1}次"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1090
msgid "今日可售剩餘"
msgstr "今日可售剩餘"

#: apps/dp-client/src/screens/home/utils/commerceHelpers.ts:55
msgid "今日售罄"
msgstr "今日售罄"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:920
msgid "今日套餐券核銷量"
msgstr "今日套餐券核銷量"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:956
msgid "今日套餐券核銷金額"
msgstr "今日套餐券核銷金額"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:865
msgid "今日套餐券營業額"
msgstr "今日套餐券營業額"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:402
msgid "今日就餐訂單"
msgstr "今日就餐訂單"

#: apps/dp-client/src/screens/home/utils/commerceHelpers.ts:63
msgid "今日庫存{dailyRemaining}"
msgstr "今日庫存{dailyRemaining}"

#: apps/dp-client/src/screens/account/pages/profile/components/TaskWallEntry/index.tsx:56
msgid "今日未領"
msgstr "今日未領"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:372
msgid "今日用餐訂單"
msgstr "今日用餐訂單"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:883
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:965
msgid "今日結帳折扣營業額"
msgstr "今日結帳折扣營業額"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:847
msgid "今日訂單成交單量"
msgstr "今日訂單成交單量"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:19
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:18
#: apps/dp-admin/src/modules/constants/userGroup.ts:129
msgid "介於"
msgstr "介於"

#: apps/dp-admin/src/pages/marketing/user-group-create/services/transform.ts:324
msgid "介於條件的最大值需大於最小值，請重新輸入"
msgstr "介於條件的最大值需大於最小值，請重新輸入"

#: apps/dp-business/src/pages/BusinessStatus/components/SharedTemplatesContent.tsx:90
#: apps/dp-admin/src/pages/merchant/shop-detail/components/SharedTemplatesModal/index.web.tsx:78
msgid "仍於其他適用門市販售中"
msgstr "仍於其他適用門市販售中"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:2096
msgid "仍要付款"
msgstr "仍要付款"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:140
msgid "仍要刪除"
msgstr "仍要刪除"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:293
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:306
msgid "仍要變更"
msgstr "仍要變更"

#: apps/dp-client/src/screens/home/pages/Note/pages/editPhoto/index.tsx:276
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:803
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:257
msgid "仍要退出"
msgstr "仍要退出"

#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:129
msgid "付款"
msgstr "付款"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:816
#: apps/dp-client/src/screens/home/pages/Meal/pages/result/index.tsx:66
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:103
msgid "付款失敗"
msgstr "付款失敗"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:730
#: apps/dp-client/src/screens/home/pages/Meal/pages/result/index.tsx:56
msgid "付款成功"
msgstr "付款成功"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:214
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:966
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:375
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:81
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1647
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1780
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:183
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:62
msgid "付款方式"
msgstr "付款方式"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:760
msgid "付款結果以訂單狀態為準"
msgstr "付款結果以訂單狀態為準"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:761
msgid "付款金額"
msgstr "付款金額"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:56
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:37
msgid "付費停車場"
msgstr "付費停車場"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:168
msgid "付錯金額"
msgstr "付款金額錯誤"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1158
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1295
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1361
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1376
msgid "代客預定"
msgstr "代客預定"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:702
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:709
msgid "代客預定失敗"
msgstr "代客預定失敗"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:696
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1301
msgid "代客預定成功"
msgstr "代客預定成功"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:2001
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:2053
msgid "代客預訂"
msgstr "代客預訂"

#: apps/dp-business/src/servers/reservation/api.ts:986
msgid "代客預訂失敗"
msgstr "代客預訂失敗"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:424
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:110
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/MemberTypeSection.web.tsx:53
msgid "代表人國籍"
msgstr "代表人國籍"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:327
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:92
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:130
msgid "代表人姓名"
msgstr "代表人姓名"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:89
msgid "代表人居留證"
msgstr "代表人居留證"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:91
msgid "代表人居留證反面"
msgstr "代表人居留證反面"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:90
msgid "代表人居留證正面"
msgstr "代表人居留證正面"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:80
msgid "代表人居留證號"
msgstr "代表人居留證號"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:177
msgid "代表人手機"
msgstr "代表人手機"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:92
msgid "代表人護照"
msgstr "代表人護照"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:84
msgid "代表人護照效期"
msgstr "代表人護照效期"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:82
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/hooks.ts:70
msgid "代表人護照號碼"
msgstr "代表人護照號碼"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:86
msgid "代表人身份證"
msgstr "代表人身份證"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:88
msgid "代表人身份證反面"
msgstr "代表人身份證反面"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:87
msgid "代表人身份證正面"
msgstr "代表人身份證正面"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:144
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:78
msgid "代表人身份證號"
msgstr "代表人身份證號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:155
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:100
msgid "代表人身分證字號"
msgstr "代表人身分證字號"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:131
msgid "代表圖或logo"
msgstr "代表圖或logo"

#: apps/dp-client/src/screens/diary/pages/home/components/upgrade-modal/index.tsx:85
msgid "令人期待的升級！"
msgstr "令人期待的升級！"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:445
msgid "以上資訊由網友提供，僅供參考"
msgstr "以上資訊由網友提供，僅供參考"

#. placeholder {0}: item.failedIds.join('、')
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ImportPackageFields/index.web.tsx:54
msgid "以下 ID 未匹配：{0}"
msgstr "以下 ID 未匹配：{0}"

#: apps/dp-admin/src/pages/org-tree/components/S9BlockModal/index.web.tsx:98
msgid "以下單據結清前不可更換請款主體，請待單據完成後再操作。"
msgstr "以下單據結清前不可更換請款主體，請待單據完成後再操作。"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:269
msgid "以下是到店指引的示範"
msgstr "以下是到店指引的示範"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:614
msgid "以下是到店時的示範"
msgstr "以下是到店時的示範"

#. placeholder {0}: _selectedPoi?.name || ''
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:150
msgid "以下是去哪吃平台記錄【{0}】的基本資訊，是否帶入此資料？"
msgstr "以下是去哪吃平台記錄【{0}】的基本資訊，是否帶入此資料？"

#: apps/dp-business/src/pages/AddStore/components/PoiConfirmModal.tsx:69
#: apps/dp-business/src/pages/AddStore/components/PoiConfirmModal.tsx:125
msgid "以下是本系統的建議："
msgstr "以下是本系統的建議："

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:738
msgid "以下為支付憑證，請向商家出示"
msgstr "以下為支付憑證，請向商家出示"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:234
msgid "以下為示範路線，實際到店方式可依店家所在地調整。"
msgstr "以下為示範路線，實際到店方式可依店家所在地調整。"

#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:260
msgid "以下菜品未選擇類別，請先為其選擇類別：{itemNames}"
msgstr "以下餐點未選擇類別，請先為其選擇類別：{itemNames}"

#: apps/dp-business/src/pages/BusinessStatus/components/SharedTemplatesContent.tsx:88
#: apps/dp-admin/src/pages/merchant/shop-detail/components/SharedTemplatesModal/index.web.tsx:77
msgid "以下餐券"
msgstr "以下餐券"

#: apps/dp-business/src/pages/Login/index.tsx:982
#: apps/dp-business/src/pages/Login/index.tsx:1436
msgid "以帳號使用"
msgstr "以帳號使用"

#: apps/dp-business/src/pages/Login/index.tsx:1155
#: apps/dp-business/src/pages/Login/index.tsx:1629
msgid "以帳號登入"
msgstr "以帳號登入"

#: apps/dp-business/src/pages/Login/index.tsx:953
#: apps/dp-business/src/pages/Login/index.tsx:1410
msgid "以手機門號使用"
msgstr "以手機門號使用"

#: apps/dp-business/src/pages/Login/index.tsx:938
#: apps/dp-business/src/pages/Login/index.tsx:1400
msgid "以電子信箱使用"
msgstr "以電子信箱使用"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:20
msgid "任一事件完成"
msgstr "任一事件完成"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:294
msgid "任一頁面"
msgstr "任一頁面"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchAssignModal/index.web.tsx:77
msgid "任務"
msgstr "任務"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:230
msgid "任務 Icon（卡片左上角圖示）"
msgstr "任務 Icon（卡片左上角圖示）"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:246
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:19
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:34
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchAssignModal/index.web.tsx:25
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:78
#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:62
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:618
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:87
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:63
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:63
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:196
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:39
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:166
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:130
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:174
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:130
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:167
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:132
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:152
msgid "任務ID"
msgstr "任務ID"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceToggleCard/index.web.tsx:57
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:147
msgid "任務ID：{pendingTaskId}"
msgstr "任務ID：{pendingTaskId}"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:156
#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:113
msgid "任務優先級"
msgstr "任務優先級"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:256
msgid "任務分配者"
msgstr "任務分配者"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:136
msgid "任務分配者ID"
msgstr "任務分配者ID"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:90
msgid "任務列表"
msgstr "任務列表"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:177
msgid "任務創建時間"
msgstr "任務創建時間"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:136
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:279
msgid "任務名稱"
msgstr "任務名稱"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:91
#: apps/dp-admin/src/pages/merchant/task-list/components/FollowUpHistoryModal/index.web.tsx:62
#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:170
msgid "任務名稱："
msgstr "任務名稱："

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:248
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:447
msgid "任務圖示"
msgstr "任務圖示"

#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:238
msgid "任務完成"
msgstr "任務完成"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:234
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:177
msgid "任務完成成功"
msgstr "任務完成成功"

#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:237
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:207
msgid "任務已受理，成員數據正由後臺非同步匯入。可前往「上傳歷史」查看進度，頁面可見時會自動更新。"
msgstr "任務已受理，成員數據正由後臺非同步匯入。可前往「上傳歷史」查看進度，頁面可見時會自動更新。"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:190
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:149
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:66
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:46
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:173
#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:99
#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:115
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/ExportHistoryTab/index.web.tsx:73
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/ExportHistoryTab/index.web.tsx:73
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:138
msgid "任務狀態"
msgstr "任務狀態"

#: apps/dp-admin/src/pages/merchant/task-list/components/FollowUpHistoryModal/index.web.tsx:80
msgid "任務狀態："
msgstr "任務狀態："

#: apps/dp-admin/src/router/config/routes.web.tsx:65
msgid "任務管理"
msgstr "任務管理"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskFilterHeader/index.web.tsx:73
msgid "任務篩選"
msgstr "任務篩選"

#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:60
msgid "任務累積積分即可列入排行榜，最高可獲得3,000遠傳幣，還有機會拿iPhone 17 Pro！"
msgstr "任務累積積分即可列入排行榜，最高可獲得3,000遠傳幣，還有機會拿iPhone 17 Pro！"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:214
msgid "任務統計"
msgstr "任務統計"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:187
msgid "任務編號"
msgstr "任務編號"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:216
msgid "任務總數"
msgstr "任務總數"

#: apps/dp-admin/src/pages/merchant/task-list/index.web.tsx:144
#: apps/dp-admin/src/pages/merchant/my-task/index.web.tsx:136
msgid "任務處理失敗,請稍後再試!"
msgstr "任務處理失敗,請稍後再試!"

#: apps/dp-admin/src/pages/merchant/task-list/index.web.tsx:139
#: apps/dp-admin/src/pages/merchant/my-task/index.web.tsx:131
msgid "任務處理成功"
msgstr "任務處理成功"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:67
#: apps/dp-admin/src/pages/merchant/task-detail/index.web.tsx:198
msgid "任務詳情"
msgstr "任務詳情"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:136
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:287
#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:94
msgid "任務說明"
msgstr "任務說明"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:88
#: apps/dp-admin/src/pages/merchant/task-list/components/FollowUpHistoryModal/index.web.tsx:59
#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:167
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:194
msgid "任務資訊"
msgstr "任務資訊"

#: apps/dp-admin/src/pages/other/services/constants.ts:47
msgid "任務通知"
msgstr "任務通知"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:40
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:139
#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:126
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchAssignModal/index.web.tsx:31
#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:74
msgid "任務類型"
msgstr "任務類型"

#: apps/dp-admin/src/pages/merchant/task-list/components/FollowUpHistoryModal/index.web.tsx:86
msgid "任務類型："
msgstr "任務類型："

#: apps/dp-business/src/pages/MenuManagement.tsx:1005
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2069
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:738
msgid "份"
msgstr "份"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:64
msgid "份數"
msgstr "份數"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:168
msgid "企業"
msgstr "企業"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:166
msgid "企業-外國籍-居留證"
msgstr "企業-外國籍-居留證"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:170
msgid "企業-外國籍-護照"
msgstr "企業-外國籍-護照"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:162
msgid "企業-本國籍"
msgstr "企業-本國籍"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:116
msgid "企業交易："
msgstr "企業交易："

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/index.web.tsx:47
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/index.web.tsx:86
msgid "企業代表人資料"
msgstr "企業代表人資料"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:58
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/CompanyRegistration/index.web.tsx:46
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:206
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:138
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:48
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:186
msgid "企業名稱"
msgstr "企業名稱"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:51
msgid "企業名稱不能超過50個字符"
msgstr "企業名稱不能超過50個字符"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/MemberTypeSelect/index.web.tsx:19
#: apps/dp-admin/src/pages/merchant/service/constants.ts:38
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/constants.ts:42
msgid "企業會員"
msgstr "企業會員"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:140
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:152
msgid "企業會員-外國籍居留證"
msgstr "企業會員-外國籍居留證"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:144
msgid "企業會員-外國籍護照"
msgstr "企業會員-外國籍護照"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:156
msgid "企業會員-外籍護照"
msgstr "企業會員-外籍護照"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:137
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:149
msgid "企業會員-本國籍"
msgstr "企業會員-本國籍"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:182
msgid "企業會員外國籍居留證"
msgstr "企業會員外國籍居留證"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:186
msgid "企業會員外國籍護照"
msgstr "企業會員外國籍護照"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:179
msgid "企業會員本國籍"
msgstr "企業會員本國籍"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/index.web.tsx:37
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/index.web.tsx:65
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:44
msgid "企業登記資料"
msgstr "企業登記資料"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/RepresentativeSection.web.tsx:41
msgid "企業負責人資料"
msgstr "企業負責人資料"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:167
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:181
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1642
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1949
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1996
#: apps/dp-business/src/pages/BusinessHours/index.tsx:202
#: apps/dp-business/src/pages/BusinessHours/index.tsx:226
#: apps/dp-business/src/pages/BusinessHours/index.tsx:232
#: apps/dp-business/src/pages/BusinessHours/index.tsx:316
#: apps/dp-business/src/pages/BusinessHours/index.tsx:354
#: apps/dp-business/src/pages/BusinessHours/index.tsx:357
#: apps/dp-business/src/pages/BusinessHours/index.tsx:402
#: apps/dp-business/src/pages/BusinessHours/index.tsx:430
#: apps/dp-business/src/pages/BusinessHours/index.tsx:437
#: apps/dp-business/src/pages/BusinessHours/index.tsx:521
#: apps/dp-business/src/pages/BusinessHours/index.tsx:552
#: apps/dp-business/src/pages/BusinessHours/index.tsx:559
#: apps/dp-business/src/pages/BusinessHours/index.tsx:714
#: apps/dp-business/src/pages/BusinessHours/index.tsx:772
#: apps/dp-business/src/pages/BusinessHours/index.tsx:861
#: apps/dp-business/src/pages/BusinessHours/index.tsx:862
#: apps/dp-business/src/pages/BusinessHours/index.tsx:963
#: apps/dp-business/src/pages/BusinessHours/index.tsx:989
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1021
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1223
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1308
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1308
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1402
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1403
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1460
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1461
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:330
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:366
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:505
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:684
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:684
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:705
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:705
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/components/DayBusinessHours/index.web.tsx:211
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/components/DayBusinessHours/index.web.tsx:252
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:109
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:891
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1642
#: apps/dp-admin/src/components/BusinessHours/utils.ts:252
#: apps/dp-admin/src/components/BusinessHours/components/DaySelector.web.tsx:62
msgid "休息"
msgstr "休息"

#: apps/dp-client/src/utils/businessStatus.ts:198
#: apps/dp-client/src/utils/businessStatus.ts:227
#: apps/dp-client/src/screens/home/utils/businessStatus.ts:23
msgid "休息中"
msgstr "休息中"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:323
msgid "伺服器返回的資料不完整"
msgstr "伺服器回傳的資料不完整"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:310
msgid "伺服器返回的資料格式不正確"
msgstr "伺服器回傳的資料格式不正確"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:356
msgid "伺服器返回資料不完整，請聯繫客服"
msgstr "伺服器回傳資料不完整，請聯繫客服"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:354
msgid "伺服器返回資料格式錯誤，請聯繫客服"
msgstr "伺服器回傳資料格式錯誤，請聯繫客服"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:319
msgid "伽瑪"
msgstr "伽瑪"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:285
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:577
msgid "但請注意："
msgstr "但請注意："

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:161
msgid "佈局導覽圖片"
msgstr "佈局導覽圖片"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:193
msgid "位置更新成功"
msgstr "位置更新成功"

#: apps/dp-admin/src/modules/hooks/options/useLocationTagOptions.ts:104
msgid "位置標籤資料取得失敗"
msgstr "位置標籤資料取得失敗"

#: apps/dp-admin/src/modules/hooks/options/useLocationTagOptions.ts:113
msgid "位置標籤資料取得異常"
msgstr "位置標籤資料取得異常"

#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:164
#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:178
#: apps/dp-business/src/utils/location.ts:321
#: apps/dp-admin/src/modules/hooks/useGeolocation.ts:142
#: apps/dp-admin/src/modules/hooks/useGeolocation.ts:201
msgid "位置權限被拒絕，請在裝置設定中允許取得位置資訊"
msgstr "未允許定位權限，請在裝置設定中允許定位權限"

#: apps/dp-business/src/utils/location.ts:197
#: apps/dp-business/src/utils/location.ts:257
msgid "位置權限被拒絕，請在設定中允許取得位置資訊"
msgstr "位置權限被拒絕，請在設定中允許取得位置資訊"

#. placeholder {0}: locationError.message
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:706
msgid "位置獲取失敗：{0}"
msgstr "位置獲取失敗：{0}"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:67
msgid "位置資訊："
msgstr "位置資訊："

#: apps/dp-client/src/hooks/useCurrentLocation.ts:110
#: apps/dp-business/src/utils/location.ts:260
msgid "位置資訊不可用"
msgstr "定位資訊無法使用"

#: apps/dp-admin/src/pages/merchant/task-list/components/PriorityTag/index.web.tsx:20
#: apps/dp-admin/src/pages/merchant/service/constants.ts:456
msgid "低"
msgstr "低"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:62
msgid "低優先級"
msgstr "低優先級"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:115
msgid "佔位符參數導入"
msgstr "佔位符參數導入"

#. placeholder {0}: target.templateId
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:72
msgid "佔位符模板_{0}.xlsx"
msgstr "佔位符模板_{0}.xlsx"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:481
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:491
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/OperationLogSection/index.web.tsx:34
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:494
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:514
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/OperationLogSection/index.web.tsx:34
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:309
msgid "作廢"
msgstr "作廢"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/VoidInventoryModal.web.tsx:65
msgid "作廢原因"
msgstr "作廢原因"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/VoidInventoryModal.web.tsx:41
msgid "作廢原因最多 {VOID_REASON_MAX_LENGTH} 字"
msgstr "作廢原因最多 {VOID_REASON_MAX_LENGTH} 字"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:113
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:270
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:275
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:311
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:316
#: apps/dp-admin/src/pages/split-account/services/constants.ts:254
msgid "作廢失敗"
msgstr "作廢失敗"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:263
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:304
msgid "作廢完成：成功 {successCount} 張，失敗 {failCount} 張"
msgstr "作廢完成：成功 {successCount} 張，失敗 {failCount} 張"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:254
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:192
msgid "作廢成功"
msgstr "作廢成功"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:266
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:307
msgid "作廢成功 {successCount} 張"
msgstr "作廢成功 {successCount} 張"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:162
msgid "作用範圍"
msgstr "作用範圍"

#. placeholder {0}: userPoints?.rankingDisplaySize || 10
#: apps/dp-client/src/screens/diary/pages/my/components/TabSwitch.tsx:186
msgid "你太棒了！現在是排行榜前{0}，繼續保持！"
msgstr "你太棒了！現在是排行榜前{0}，繼續保持！"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:104
#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:108
msgid ""
"你寫下的每一篇筆記，都可能成為別人下一餐的靈感。\n"
"你的美食經驗，會被其他熱愛美食的用戶看見，讓好吃的餐廳持續被傳遞下去。"
msgstr ""
"你寫下的每一篇筆記，都可能成為別人下一餐的靈感。\n"
"你的美食經驗，會被其他熱愛美食的用戶看見，讓好吃的餐廳持續被傳遞下去。"

#: apps/dp-business/src/pages/AccountDeactivation/index.tsx:107
msgid "你將無法登入商家端"
msgstr "你將無法登入商家端"

#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:416
msgid ""
"你已封鎖該用戶\n"
"無法查看其內容"
msgstr ""
"你已封鎖該用戶\n"
"無法查看其內容"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:769
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:754
msgid ""
"你已封鎖該用戶\n"
"無法查看該內容"
msgstr ""
"你已封鎖該用戶\n"
"無法查看該內容"

#: apps/dp-business/src/pages/AddStore/index.tsx:1276
msgid "你已經修改店家地址，但保留原店家名稱。如需修改請點擊更改。"
msgstr "你已經修改店家地址，但保留原店家名稱。如需修改請點擊更改。"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:390
msgid "你已領取過這張兌換券"
msgstr "你已領取過這張兌換券"

#: apps/dp-client/src/screens/home/pages/Search/index.tsx:692
msgid "你是否想搜尋"
msgstr "你是否想搜尋"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:81
msgid "你是該商家唯一超級管理員！"
msgstr "你是該商家唯一超級管理員！"

#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:341
msgid "你曾經去過..."
msgstr "您曾經去過..."

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:302
msgid "你消費過"
msgstr "您曾消費過"

#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/index.tsx:38
msgid "你無法被動刷到這些用戶的筆記、評論動態，但可以主動點擊該用戶頭像查看"
msgstr "你無法被動刷到這些用戶的筆記、評論動態，但可以主動點擊該用戶頭像查看"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1032
msgid "你的姓名"
msgstr "你的姓名"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1062
msgid "你的身分證字號"
msgstr "你的身分證字號"

#. placeholder {0}: task.periodLimitCount
#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:46
msgid ""
"你目前有 {auditingCount} 則{contentName}正在發佈中，\n"
"任務總計可完成 {0} 則，獎勵點數將依據「實際發佈成功」的{contentName}數量發放喔～"
msgstr ""
"你目前有 {auditingCount} 則{contentName}正在發佈中，\n"
"任務總計可完成 {0} 則，獎勵點數將依據「實際發佈成功」的{contentName}數量發放喔～"

#: apps/dp-business/src/pages/AddStore/index.tsx:1266
msgid "你輸入的自訂名稱"
msgstr "你輸入的自訂名稱"

#: apps/dp-business/src/pages/AddStore/index.tsx:1431
msgid "你選擇的位置會影響店家在地圖上的位置，但不影響店家名稱。"
msgstr "你選擇的位置會影響店家在地圖上的位置，但不影響店家名稱。"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:88
msgid "你點擊了: {word}"
msgstr "您點擊了: {word}"

#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:254
msgid "佣金"
msgstr "佣金"

#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:221
msgid "佣金方案"
msgstr "佣金方案"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:346
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:215
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:216
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:231
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:232
#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:39
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:58
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:68
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:660
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:666
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:33
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:79
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:148
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:39
#: apps/dp-admin/src/modules/constants/options.ts:167
msgid "佣金比例"
msgstr "佣金比例"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:398
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFeeInfo.tsx:46
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:864
msgid "佣金比例："
msgstr "佣金比例："

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:116
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:95
msgid "佣金比例(%)"
msgstr "佣金比例(%)"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:63
msgid "佣金比例（不含交易手續費）"
msgstr "佣金比例（不含交易手續費）"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:692
msgid "佣金比例僅包含去哪吃平台商家服務費，不含交易手續費。"
msgstr "佣金比例僅包含去哪吃平台商家服務費，不含交易手續費。"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:618
msgid "佣金比例必須在0-100%之間"
msgstr "佣金比例必須在0-100%之間"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:132
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:137
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:109
msgid "佣金比例必須在0-100之間"
msgstr "佣金比例必須在0-100之間"

#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:91
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityGridCard.tsx:107
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:65
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:319
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityGridCard.tsx:79
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:54
#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:215
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:50
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:341
msgid "佣金減免"
msgstr "佣金減免"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:105
msgid "佣金率"
msgstr "佣金率"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:164
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1371
#: apps/dp-business/src/pages/CouponVerification/index.tsx:668
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/PackageCouponCard/index.web.tsx:44
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:288
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:116
msgid "佣金金額"
msgstr "佣金金額"

#: apps/dp-client/src/screens/home/components/CitySelect/CityModal.tsx:146
#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:280
msgid "使用"
msgstr "使用"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ClientSearchPanel/index.web.tsx:40
msgid "使用 C 端搜索接口測試店家名稱、類別與行政區查詢"
msgstr "使用 C 端搜索接口測試店家名稱、類別與行政區查詢"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/MealSectionTabs.tsx:35
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:272
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:363
msgid "使用/退款規則"
msgstr "使用/退款規則"

#: apps/dp-business/src/pages/AddStore/components/PoiConfirmModal.tsx:62
msgid "使用Google Map搜尋"
msgstr "使用Google Map搜尋"

#. placeholder {0}: poi.name
#: apps/dp-business/src/pages/AddStore/components/PoiConfirmModal.tsx:158
msgid "使用Google Map搜索 {0} 的位置信息"
msgstr "使用Google Map搜尋 {0} 的位置資訊"

#: apps/dp-client/src/screens/home/pages/CouponShopList/index.tsx:144
msgid "使用優惠券"
msgstr "使用優惠券"

#: apps/dp-client/src/screens/login/pages/login/index.tsx:387
msgid "使用其他方式註冊/登入"
msgstr "使用其他方式註冊/登入"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:195
msgid "使用帳號數"
msgstr "使用帳號數"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:442
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:589
msgid "使用張數"
msgstr "使用張數"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2262
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2203
msgid "使用數量限制"
msgstr "使用數量限制"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:375
msgid "使用日期"
msgstr "使用日期"

#: apps/dp-client/src/screens/home/utils/order.ts:773
#: apps/dp-client/src/screens/home/utils/order.ts:1014
#: apps/dp-client/src/screens/home/utils/order.ts:1031
#: apps/dp-client/src/screens/home/utils/order.ts:1104
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:212
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:201
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:491
msgid "使用時間"
msgstr "使用時間"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFeeInfo.tsx:33
msgid "使用時間："
msgstr "使用時間："

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:196
msgid "使用有效期"
msgstr "使用有效期"

#: apps/dp-client/src/screens/home/pages/UserGift/components/SlideInCouponCard/index.tsx:132
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:194
msgid "使用期限:"
msgstr "使用期限:"

#. placeholder {0}: dayjs(validStartTime).format('YYYY/MM/DD')
#. placeholder {0}: dayjs(claimedCouponData.validStartTime).format( 'YYYY/MM/DD' )
#. placeholder {1}: dayjs(validEndTime).format('YYYY/MM/DD')
#. placeholder {1}: dayjs(claimedCouponData.validEndTime).format( 'YYYY/MM/DD' )
#: apps/dp-client/src/screens/home/pages/UserGift/components/SlideInCouponCard/index.tsx:216
#: apps/dp-client/src/screens/home/pages/UserGift/components/SlideInCouponCard/index.tsx:275
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:251
msgid "使用期限: {0}~{1}"
msgstr "使用期限: {0}~{1}"

#. placeholder {0}: dayjs( claimedCouponData?.validStartTime ).format('YYYY/MM/DD')
#. placeholder {1}: dayjs( claimedCouponData?.validEndTime ).format('YYYY/MM/DD')
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:138
msgid "使用期限:{0} ~{1}"
msgstr "使用期限:{0} ~{1}"

#. placeholder {0}: dayjs( claimedCouponData?.validStartTime ).format('YYYY/MM/DD')
#. placeholder {1}: dayjs( claimedCouponData?.validEndTime ).format('YYYY/MM/DD')
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:321
msgid "使用期限:{0}~{1}"
msgstr "使用期限:{0}~{1}"

#: apps/dp-client/src/screens/login/components/privacy-agreement-modal/index.tsx:37
#: apps/dp-client/src/screens/login/components/privacy-agreement-modal/index.tsx:38
#: apps/dp-client/src/screens/login/components/privacy-agreement/index.tsx:46
#: apps/dp-client/src/screens/account/pages/settings/index.tsx:124
#: apps/dp-client/src/screens/account/pages/settings/index.tsx:125
#: apps/dp-client/src/screens/account/pages/settings/index.tsx:247
#: apps/dp-business/src/pages/TermsAndPrivacy/index.tsx:76
#: apps/dp-business/src/pages/Login/index.tsx:1009
#: apps/dp-business/src/pages/Login/index.tsx:1462
#: apps/dp-business/src/pages/Login/index.tsx:1798
msgid "使用條款"
msgstr "使用條款"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:316
msgid "使用次數限制"
msgstr "使用次數限制"

#: apps/dp-admin/src/pages/marketing/components/OverviewSection/index.web.tsx:79
msgid "使用狀態分佈"
msgstr "使用狀態分佈"

#: apps/dp-business/src/pages/MarketingCenter/components/StoreSelectionCard.tsx:280
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:97
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:94
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageScopeSection/index.web.tsx:167
msgid "使用範圍"
msgstr "使用範圍"

#: apps/dp-business/src/pages/Login/components/LiteModeToggle.tsx:40
msgid "使用簡易版登入（登入後可切換完整版）"
msgstr "使用簡易版登入（登入後可切換完整版）"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:19
msgid "使用者C"
msgstr "使用者C"

#: apps/dp-business/src/pages/RefundList/index.tsx:225
#: apps/dp-business/src/pages/RefundList/index.tsx:369
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1943
#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:517
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:44
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:242
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserInfoCard/index.web.tsx:65
#: apps/dp-admin/src/pages/order/order-detail/components/UserInfo/index.web.tsx:36
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:32
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:131
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:125
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:89
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:126
#: apps/dp-admin/src/pages/audit-center/user-audit/components/UserBasicInfo/index.web.tsx:104
msgid "使用者ID"
msgstr "使用者ID"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:276
msgid "使用者保存失敗"
msgstr "使用者保存失敗"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:34
msgid "使用者反映開啟訂單頁時 App 立即閃退"
msgstr "使用者反映開啟訂單頁時 App 立即閃退"

#: apps/dp-business/src/pages/UserManagement/index.tsx:431
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:292
#: apps/dp-business/src/pages/EditUser/index.tsx:249
#: apps/dp-business/src/pages/AddUser/index.tsx:194
msgid "使用者名稱"
msgstr "使用者名稱"

#: apps/dp-business/src/utils/phoneValidation.ts:111
msgid "使用者名稱不能超過50個字元"
msgstr "使用者名稱不能超過50個字元"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserInfoCard/index.web.tsx:49
#: apps/dp-admin/src/pages/audit-center/user-audit/components/UserBasicInfo/index.web.tsx:67
#: apps/dp-admin/src/pages/audit-center/user-audit/components/UserBasicInfo/index.web.tsx:76
msgid "使用者基本資訊"
msgstr "使用者基本資訊"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:279
msgid "使用者已建立"
msgstr "使用者已建立"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:336
msgid "使用者已提供截圖佐證"
msgstr "使用者已提供截圖佐證"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:279
msgid "使用者已更新"
msgstr "使用者已更新"

#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:179
msgid "使用者建立成功"
msgstr "使用者建立成功"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/MerchantComplaintSection/index.web.tsx:51
msgid "使用者投訴內容"
msgstr "使用者投訴內容"

#: apps/dp-client/src/hooks/useCurrentLocation.ts:107
msgid "使用者拒絕了定位請求"
msgstr "使用者拒絕了定位權限"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:72
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:251
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserInfoCard/index.web.tsx:73
#: apps/dp-admin/src/pages/order/order-detail/components/UserInfo/index.web.tsx:30
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:26
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:132
#: apps/dp-admin/src/pages/audit-center/user-audit/components/UserBasicInfo/index.web.tsx:111
msgid "使用者暱稱"
msgstr "使用者暱稱"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:146
msgid "使用者欲取消訂位但按鈕無反應"
msgstr "使用者欲取消訂位但按鈕無反應"

#: apps/dp-business/src/utils/permissionData.ts:126
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:146
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:674
#: apps/dp-business/src/pages/UserManagement/index.tsx:690
#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:96
msgid "使用者管理"
msgstr "使用者管理"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:939
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:188
#: apps/dp-client/src/components/CouponCard/index.tsx:374
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:273
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/UsageRulesSection/index.web.tsx:30
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/UsageRulesSection/index.web.tsx:31
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:364
msgid "使用規則"
msgstr "使用規則"

#. placeholder {0}: buildUsageRuleText(data)
#. placeholder {0}: buildUsageRuleText(d)
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:247
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:276
msgid "使用規則：{0}"
msgstr "使用規則：{0}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1090
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:388
msgid "使用規則：{usageRuleLabel}"
msgstr "使用規則：{usageRuleLabel}"

#: apps/dp-client/src/screens/home/pages/CouponShopList/components/CouponCard.tsx:117
#: apps/dp-business/src/pages/MarketingCenter/components/UsageDescriptionCard.tsx:55
#: apps/dp-business/src/pages/MarketingCenter/components/UsageDescriptionCard.tsx:59
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:107
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:483
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:104
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:603
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2343
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:508
msgid "使用說明"
msgstr "使用說明"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:180
msgid "使用說明不能超過1000個字符"
msgstr "使用說明不能超過1000個字符"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:63
msgid "使用資料："
msgstr "使用資料："

#: apps/dp-business/src/pages/MarketingCenter/components/PreviewCard.tsx:72
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:463
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:528
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:355
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:449
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:62
msgid "使用門檻"
msgstr "使用門檻"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:121
msgid "使用門檻不能小於 0"
msgstr "使用門檻不能小於 0"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:129
msgid "使用門檻不能為空"
msgstr "使用門檻不能為空"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:133
msgid "使用門檻僅支援大於等於 0 的數字"
msgstr "使用門檻僅支援大於等於 0 的數字"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:138
msgid "使用門檻最多一位小數"
msgstr "使用門檻最多一位小數"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:113
msgid "使用門檻必須為大於等於 0 的數字，最多一位小數"
msgstr "使用門檻必須為大於等於 0 的數字，最多一位小數"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:306
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:613
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:92
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:424
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:89
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:575
msgid "使用限制"
msgstr "使用限制"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:73
msgid "使用限制次數/每人"
msgstr "使用限制次數/每人"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:239
#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:178
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:581
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:503
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:582
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:245
msgid "使用須知"
msgstr "使用須知"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:246
msgid "使用須知不能超過1000個字符"
msgstr "使用須知不能超過1000個字符"

#: apps/dp-business/src/pages/OrderList/index.tsx:606
#: apps/dp-business/src/pages/OrderList/index.tsx:885
#: apps/dp-business/src/pages/OrderDetail/index.tsx:790
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1124
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1242
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:72
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:91
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:80
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:228
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:83
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:290
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:317
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:67
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:300
#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:109
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:474
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:325
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:89
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:94
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:145
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/MerchantBasicInfo/index.web.tsx:132
#: apps/dp-admin/src/pages/audit-center/components/AuditInfoHeader/config.ts:29
msgid "來源"
msgstr "來源"

#. placeholder {0}: detail.sourceDesc || detail.source
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/BasicInfoCard.web.tsx:80
msgid "來源 : {0}"
msgstr "來源 : {0}"

#: apps/dp-business/src/pages/AddStore/index.tsx:1265
msgid "來源："
msgstr "來源："

#. placeholder {0}: item.sourceImageUrl
#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:201
#: apps/dp-admin/src/pages/merchant/components/MenuManagementSection/index.web.tsx:152
msgid "來源圖片：{0}"
msgstr "來源圖片：{0}"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:60
msgid "來源描述"
msgstr "來源描述"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:75
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:40
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:238
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:132
msgid "來源渠道"
msgstr "來源渠道"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:163
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:552
msgid "例如 3.12.0"
msgstr "例如 3.12.0"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/AddShopModal/index.web.tsx:90
msgid ""
"例如：\n"
"10001,1,備註1\n"
"10002,2,備註2"
msgstr ""
"例如：\n"
"10001,1,備註1\n"
"10002,2,備註2"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/UpdateLocationModal/index.web.tsx:105
msgid "例如：A區101鋪"
msgstr "例如：A區101鋪"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:363
msgid "例如：完成分享任務，多重好禮一次拿"
msgstr "例如：完成分享任務，多重好禮一次拿"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:409
msgid "例如：新店開業折扣優惠券"
msgstr "例如：新店開業折扣優惠券"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:327
msgid "例如：新店開業滿減優惠券"
msgstr "例如：新店開業滿額折扣優惠券"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:632
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:226
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1184
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:295
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:1036
msgid "供應商代碼（聚流商家標識）"
msgstr "供應商代碼（聚流商家標識）"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:635
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:229
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1187
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:298
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:1039
msgid "供應商代碼不能超過 100 個字元"
msgstr "供應商代碼不能超過 100 個字元"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:58
msgid "依「消耗的積分值 ÷ 兌換權益的券面額」自動計算，僅供確認不可修改"
msgstr "依「消耗的積分值 ÷ 兌換權益的券面額」自動計算，僅供確認不可修改"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:123
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:44
msgid "依券面展示為準"
msgstr "依券面展示為準"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:207
msgid "依循環週期與次數自動帶出"
msgstr "依循環週期與次數自動帶出"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ExchangeLimitEditor/index.web.tsx:58
msgid "依所選週期維度，同一用戶在每個週期內最多可兌換消耗的次數。"
msgstr "依所選週期維度，同一用戶在每個週期內最多可兌換消耗的次數。"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:171
msgid "依日曆自然日（00:00～23:59）循環；全員統一週期，與日曆對齊。"
msgstr "依日曆自然日（00:00～23:59）循環；全員統一週期，與日曆對齊。"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:173
msgid "依日曆自然月（每月 1 號～月底）循環；全員統一週期，與日曆對齊。"
msgstr "依日曆自然月（每月 1 號～月底）循環；全員統一週期，與日曆對齊。"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:172
msgid "依日曆自然週（週一～週日）循環；全員統一週期，與日曆對齊。"
msgstr "依日曆自然週（週一～週日）循環；全員統一週期，與日曆對齊。"

#: apps/dp-admin/src/pages/marketing/verification-record-detail/components/StatusLogTable/index.web.tsx:61
msgid "依時間倒序展示該券的狀態變化"
msgstr "依時間倒序展示該券的狀態變化"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/PreviewConfirmModal/index.web.tsx:39
msgid "依目前條件取得的預覽結果如下，請確認無誤後再保存名單。"
msgstr "依目前條件取得的預覽結果如下，請確認無誤後再保存名單。"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/PreviewConfirmModal/index.web.tsx:57
msgid "依目前條件預估命中的用戶數量如下，請確認無誤後再建立名單。"
msgstr "依目前條件預估命中的用戶數量如下，請確認無誤後再建立名單。"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:156
msgid "依範本填寫渠道資料並上傳，完成預覽與校驗後，再確認匯入。"
msgstr "依範本填寫渠道資料並上傳，完成預覽與校驗後，再確認匯入。"

#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:55
msgid "依規範完善指定店家資訊即可累積積分，達標兌換遠傳幣"
msgstr "依規範完善指定店家資訊即可累積積分，達標兌換遠傳幣"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:430
msgid "依財政部令此副本僅供參考，不可直接兌獎"
msgstr "依財政部令此副本僅供參考，不可直接兌獎"

#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:276
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:31
#: apps/dp-business/src/components/ImageEditorModal/index.tsx:266
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:308
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:467
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:258
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:520
#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:237
#: apps/dp-admin/src/pages/org-tree/org-create/components/UnsavedNodeModal/index.web.tsx:33
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:141
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:281
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/index.web.tsx:123
#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:67
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:57
#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:269
#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:629
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:709
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/index.web.tsx:122
#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:585
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:1273
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:31
#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:481
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:227
msgid "保存"
msgstr "保存"

#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:146
msgid "保存並提交審核"
msgstr "保存並提交審核"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:231
msgid "保存並提交審核時一併保存，審批生效後才改變正式結算。"
msgstr "保存並提交審核時一併保存，審批生效後才改變正式結算。"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteFormFooter.tsx:41
#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:276
msgid "保存中..."
msgstr "保存中..."

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1240
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1244
msgid "保存備註失敗"
msgstr "保存備註失敗"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:340
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:397
msgid "保存商家名單失敗，請重試"
msgstr "保存商家名單失敗，請重試"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:261
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:413
msgid "保存失敗"
msgstr "保存失敗"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:429
msgid "保存失敗，請稍後重試"
msgstr "保存失敗，請稍後重試"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:415
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:179
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/index.web.tsx:71
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:370
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:372
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:410
msgid "保存成功"
msgstr "保存成功"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1407
msgid "保存掛接失敗，結算路徑未設置"
msgstr "保存掛接失敗，結算路徑未設置"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1395
msgid "保存掛接失敗，請稍後重試"
msgstr "保存掛接失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:695
msgid "保存方式"
msgstr "保存方式"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ManualPackageFields/index.web.tsx:32
msgid "保存時將沿用已保存的固定套餐名單"
msgstr "保存時將沿用已保存的固定套餐名單"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/apis.ts:235
msgid "保存獎勵失敗"
msgstr "保存獎勵失敗"

#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:156
msgid "保存節點"
msgstr "保存節點"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1380
msgid "保存節點商家失敗，請稍後重試"
msgstr "保存節點商家失敗，請稍後重試"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:258
msgid "保存結帳設定失敗"
msgstr "保存結帳設定失敗"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:254
msgid "保存結帳設定成功"
msgstr "保存結帳設定成功"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:579
msgid "保存結果"
msgstr "保存結果"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1427
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1438
msgid "保存結算路徑失敗，請稍後重試"
msgstr "保存結算路徑失敗，請稍後重試"

#: apps/dp-client/src/screens/home/pages/Note/pages/editPhoto/index.tsx:382
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:51
msgid "保存編輯"
msgstr "保存編輯"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteFormFooter.tsx:43
#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:139
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:41
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1297
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:189
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:220
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:223
msgid "保存草稿"
msgstr "保存草稿"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:548
msgid "保存草稿失敗，請稍後重試"
msgstr "保存草稿失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1012
msgid "保存菜單數據失敗"
msgstr "保存菜單數據失敗"

#: apps/dp-business/src/pages/Settings/index.tsx:131
#: apps/dp-business/src/pages/Settings/index.tsx:135
msgid "保存設置失敗"
msgstr "保存設置失敗"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1348
msgid "保存變更失敗，請稍後重試"
msgstr "保存變更失敗，請稍後重試"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/index.web.tsx:156
msgid "保存跟進記錄失敗"
msgstr "保存跟進記錄失敗"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/index.web.tsx:149
#: apps/dp-admin/src/pages/merchant/shop-list-v2/index.web.tsx:157
#: apps/dp-admin/src/pages/merchant/shop-list/index.web.tsx:146
#: apps/dp-admin/src/pages/merchant/shop-list/index.web.tsx:154
#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:160
#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:168
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:183
msgid "保存追蹤記錄失敗，請重試"
msgstr "保存追蹤記錄失敗，請重試"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/index.web.tsx:591
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:756
msgid "保存配置"
msgstr "保存配置"

#: apps/dp-business/src/servers/shop/api.ts:612
msgid "保存餐廳設置失敗"
msgstr "保存餐廳設置失敗"

#: apps/dp-client/src/screens/account/pages/edit-profile/components/GenderSelectModal/index.tsx:36
#: apps/dp-client/src/screens/account/pages/edit-profile/components/GenderSelectModal/index.tsx:43
msgid "保密"
msgstr "保密"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:356
msgid "保持縱橫比"
msgstr "保持長寬比"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:804
msgid "保留"
msgstr "保留"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:350
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:258
#: apps/dp-client/src/screens/account/pages/order/index.tsx:212
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:156
msgid "保留訂單"
msgstr "保留訂單"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:97
msgid "保證買票佣金明細"
msgstr "保證買票佣金明細"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:513
msgid "保證金額"
msgstr "保證金額"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:378
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:83
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:36
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:64
msgid "信用卡"
msgstr "信用卡"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:104
msgid "信用卡付款一直失敗，但銀行端顯示已扣款"
msgstr "信用卡付款一直失敗，但銀行端顯示已扣款"

#: apps/dp-business/src/components/SetPassword/index.tsx:206
#: apps/dp-business/src/components/ForgotPassword/index.tsx:430
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserInfoCard/index.web.tsx:79
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:199
msgid "信箱地址"
msgstr "信箱地址"

#: apps/dp-client/src/screens/account/pages/account-security/email/verification-email/index.tsx:43
msgid "信箱地址不能為空"
msgstr "信箱地址不能為空"

#: apps/dp-client/src/screens/account/pages/account-security/email/email-old/index.tsx:25
msgid "信箱已不可用"
msgstr "信箱已無法使用"

#: apps/dp-business/src/pages/ChangeEmail/index.tsx:43
#: apps/dp-business/src/pages/BindEmail/index.tsx:42
msgid "信箱綁定失敗"
msgstr "信箱綁定失敗"

#: apps/dp-business/src/data/regions.ts:42
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:98
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:408
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:419
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:430
msgid "信義區"
msgstr "信義區"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:49
msgid "信義區公所地下停車場"
msgstr "信義區公所地下停車場"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:373
msgid "修剪"
msgstr "修剪"

#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:698
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:701
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:68
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:168
#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:69
#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:71
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:227
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:326
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:207
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:197
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:65
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:237
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:63
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:345
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:234
msgid "修改"
msgstr "修改"

#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:310
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:110
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:120
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1133
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:167
msgid "修改人"
msgstr "修改人"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:669
msgid "修改人員"
msgstr "修改人員"

#: apps/dp-client/src/configs/page-configs.tsx:2924
msgid "修改個人資料"
msgstr "修改個人資訊"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:154
msgid "修改個性簽名失敗，請稍後重試"
msgstr "修改簽名檔失敗，請稍後重試"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:48
msgid "修改個性簽名成功"
msgstr "修改簽名檔成功"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:62
msgid "修改優惠金額"
msgstr "修改優惠金額"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:676
msgid "修改內容"
msgstr "修改內容"

#: apps/dp-business/src/pages/TableManagement/index.tsx:374
msgid "修改分區名稱不會影響已經生成的訂位訂單"
msgstr "修改分區名稱不會影響已經生成的訂位訂單"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponStatusModal.web.tsx:74
msgid "修改券狀態"
msgstr "修改券狀態"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponStatusModal.web.tsx:59
msgid "修改券狀態失敗"
msgstr "修改券狀態失敗"

#: apps/dp-admin/src/pages/merchant/information-review/components/InformationChangeSection/index.web.tsx:49
msgid "修改前"
msgstr "修改前"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:487
#: apps/dp-admin/src/pages/merchant/information-review/components/InformationChangeSection/index.web.tsx:98
msgid "修改原因"
msgstr "修改原因"

#: apps/dp-admin/src/pages/merchant/brand-list/services/hooks.ts:261
msgid "修改品牌成功"
msgstr "修改品牌成功"

#: apps/dp-business/src/servers/permission/api.ts:325
msgid "修改員工帳號失敗"
msgstr "修改員工帳號失敗"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:53
msgid "修改商家名單規則"
msgstr "修改商家名單規則"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1025
msgid "修改報名資訊"
msgstr "修改報名資訊"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1109
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1309
msgid "修改套餐券"
msgstr "修改套餐券"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1122
msgid "修改套餐券模板，調整菜品組合和價格資訊"
msgstr "修改套餐券模板，調整餐點組合和價格資訊"

#: apps/dp-business/src/pages/MyProfile/index.tsx:295
#: apps/dp-business/src/pages/ChangePassword/index.tsx:187
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:301
msgid "修改密碼"
msgstr "修改密碼"

#: apps/dp-business/src/servers/auth/api.ts:514
#: apps/dp-business/src/pages/ChangePassword/index.tsx:162
#: apps/dp-business/src/pages/ChangePassword/index.tsx:167
msgid "修改密碼失敗，請重試"
msgstr "修改密碼失敗，請重試"

#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:195
msgid "修改帳號"
msgstr "修改帳號"

#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:223
msgid "修改帳號失敗"
msgstr "修改帳號失敗"

#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:220
msgid "修改帳號成功"
msgstr "修改帳號成功"

#: apps/dp-admin/src/pages/merchant/information-review/components/InformationChangeSection/index.web.tsx:60
msgid "修改後"
msgstr "修改後"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:57
#: apps/dp-client/src/screens/reservation/pages/detail/components/ModifyReservationModal.tsx:17
msgid "修改後，預訂訂金、優惠等可能產生變化，以修改成功訂單為準"
msgstr "修改後，預訂訂金、優惠等可能產生變化，以修改成功訂單為準"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:722
msgid "修改後生效時間"
msgstr "修改後生效時間"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:187
msgid "修改成功"
msgstr "修改成功"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:58
#: apps/dp-client/src/screens/reservation/pages/detail/components/ModifyReservationModal.tsx:18
msgid "修改成功前，將為你保留原訂單"
msgstr "修改成功前，將為你保留原訂單"

#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:65
msgid "修改折扣率"
msgstr "修改折扣率"

#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:175
msgid "修改折扣資訊"
msgstr "修改折扣資訊"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:662
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:118
#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:125
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:170
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:170
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:151
msgid "修改時間"
msgstr "修改時間"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ManualPackageFields/index.web.tsx:45
msgid "修改時默認保留已固化的全部套餐名單"
msgstr "修改時默認保留已固化的全部套餐名單"

#: apps/dp-client/src/configs/page-configs.tsx:1770
#: apps/dp-client/src/configs/page-configs.tsx:1772
msgid "修改暱稱"
msgstr "修改暱稱"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:252
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:127
msgid "修改暱稱失敗，請稍後重試"
msgstr "修改暱稱失敗，請稍後重試"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:245
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:37
msgid "修改暱稱成功"
msgstr "修改暱稱成功"

#: apps/dp-business/src/pages/TableManagement/index.tsx:718
msgid "修改桌位名稱不會影響已經生成的訂位訂單"
msgstr "修改桌位名稱不會影響已經生成的訂位訂單"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:375
msgid "修改標籤"
msgstr "修改標籤"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:101
msgid "修改歷史"
msgstr "修改歷史"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:364
msgid "修改活動設定失敗，請稍後重試"
msgstr "修改活動設定失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:408
msgid "修改活動配置失敗"
msgstr "修改活動配置失敗"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:307
msgid "修改狀態"
msgstr "修改狀態"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:401
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:653
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:302
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:332
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:807
msgid "修改理由"
msgstr "修改理由"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:63
msgid "修改用戶名單資料"
msgstr "修改用戶名單資料"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:56
#: apps/dp-client/src/screens/reservation/pages/detail/components/ModifyReservationModal.tsx:16
msgid "修改用餐時間、桌型、人數 需等待商家再次確認訂單"
msgstr "修改用餐時間、桌型、人數 需等待商家再次確認訂單"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:882
msgid "修改筆記"
msgstr "修改筆記"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:303
msgid "修改簽名檔"
msgstr "修改簽名檔"

#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:499
msgid "修改行銷活動"
msgstr "修改行銷活動"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:369
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:473
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:175
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:411
#: apps/dp-client/src/screens/reservation/pages/detail/components/ModifyReservationModal.tsx:42
msgid "修改訂位"
msgstr "修改訂位"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:586
msgid "修改訂單"
msgstr "修改訂單"

#: apps/dp-business/src/servers/reservation/api.ts:1006
msgid "修改訂單失敗"
msgstr "修改訂單失敗"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:319
msgid "修改記錄"
msgstr "修改記錄"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:348
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:369
msgid "修改設定"
msgstr "修改設定"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:870
msgid "修改評論"
msgstr "修改評論"

#: apps/dp-business/src/components/ModificationReason/index.tsx:86
msgid "修改說明 "
msgstr "修改說明 "

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:361
msgid "修飾"
msgstr "修飾"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:37
msgid "個"
msgstr "個"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:172
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:48
msgid "個人"
msgstr "個人"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:57
msgid "個人/群體自拍"
msgstr "個人/群體自拍"

#: apps/dp-client/src/configs/page-configs.tsx:2220
msgid "個人主頁"
msgstr "個人主頁"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:49
msgid "個人券"
msgstr "個人券"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:202
msgid "個人化推薦清單出現大量重複餐廳"
msgstr "個人化推薦清單出現大量重複餐廳"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/MemberTypeSelect/index.web.tsx:20
#: apps/dp-admin/src/pages/merchant/service/constants.ts:39
#: apps/dp-admin/src/pages/merchant/service/constants.ts:172
#: apps/dp-admin/src/pages/merchant/service/constants.ts:188
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/constants.ts:43
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:146
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:158
msgid "個人會員"
msgstr "個人會員"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/index.web.tsx:65
msgid "個人登記資料"
msgstr "個人登記資料"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:47
msgid "個人識別資訊："
msgstr "個人識別資訊："

#: apps/dp-admin/src/router/config/baseRoutes.ts:42
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:67
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:203
#: apps/dp-admin/src/components/layout/components/header/index.web.tsx:48
msgid "個人資料"
msgstr "個人資料"

#: apps/dp-client/src/configs/page-configs.tsx:1406
msgid "個人資訊"
msgstr "個人資訊"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:348
msgid "個停車場"
msgstr "個停車場"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PreviewCard.tsx:103
msgid "個分組"
msgstr "個分組"

#: apps/dp-business/src/pages/BusinessStatus/components/ShopClosedImpactContent.tsx:83
msgid "個套餐券，請確認"
msgstr "個套餐券，請確認"

#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:93
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:134
#: apps/dp-client/src/configs/page-configs.tsx:1789
#: apps/dp-client/src/configs/page-configs.tsx:1791
msgid "個性簽名"
msgstr "簽名檔"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:121
msgid "個性簽名不可用，請重新輸入"
msgstr "簽名檔無法使用，請重新輸入"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:73
msgid "個性簽名不能超過{MAX_LENGTH}個字符"
msgstr "簽名檔不能超過{MAX_LENGTH}個字符"

#: apps/dp-client/src/screens/account/pages/profile/components/ContentTabsSection/UserNoteSection.tsx:209
#: apps/dp-client/src/screens/account/pages/profile/components/ContentTabsSection/UserNoteSection.tsx:272
msgid "個筆記未發布"
msgstr "篇筆記未發佈"

#: apps/dp-client/src/screens/account/pages/favorites/pages/searchResult/index.tsx:266
#: apps/dp-client/src/screens/account/pages/favorites/pages/searchResult/index.tsx:342
msgid "個結果"
msgstr "個結果"

#: apps/dp-client/src/screens/account/pages/profile/components/MyReviewsContent/index.tsx:238
msgid "個評論未發布"
msgstr "個評論未發布"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:166
msgid "倒計時設置"
msgstr "倒計時設置"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:32
msgid "值"
msgstr "值"

#: apps/dp-business/src/store/HolidayContext.tsx:193
msgid "假"
msgstr "假"

#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:31
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:95
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:39
msgid "假日類型"
msgstr "假日類型"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:202
msgid "假日類型列表"
msgstr "假日類型列表"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:29
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:21
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:21
msgid "偏移"
msgstr "偏移"

#: apps/dp-client/src/configs/page-configs.tsx:1424
msgid "做任務領積分"
msgstr "做任務領積分"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:175
msgid "停好車後要怎麼走到餐廳？"
msgstr "停好車後要怎麼走到餐廳？"

#: apps/dp-admin/src/modules/constants/options.ts:577
msgid "停業"
msgstr "停業"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:423
#: apps/dp-client/src/screens/reservation/pages/main/components/TimeModal.tsx:148
msgid "停止預訂"
msgstr "停止預訂"

#: apps/dp-business/src/pages/UserManagement/index.tsx:361
#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeNodeCard.tsx:107
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:211
#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:15
#: apps/dp-admin/src/pages/user-info/services/interface/queryUserList.ts:23
#: apps/dp-admin/src/pages/resource-config/services/constants.ts:137
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:158
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/services/searchConfig.ts:8
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:98
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:94
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:135
#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:10
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:69
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:105
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:230
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:329
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:703
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:210
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:240
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:200
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:230
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:63
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:250
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:19
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:39
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:116
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:130
#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:12
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:255
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:18
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/index.web.tsx:109
#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:10
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:226
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:16
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:64
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:264
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelHistoryList/index.web.tsx:29
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:178
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:143
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateDetailInfo/index.web.tsx:78
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:336
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:243
#: apps/dp-admin/src/modules/constants/options.ts:350
msgid "停用"
msgstr "停用"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:110
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDisableModal/index.web.tsx:71
msgid "停用原因"
msgstr "停用原因"

#. placeholder {0}: textOrDash(record.disableReason)
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:52
msgid "停用原因：{0}"
msgstr "停用原因：{0}"

#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:411
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:110
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:561
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:105
msgid "停用失敗"
msgstr "停用失敗"

#. placeholder {0}: res.failedCategories?.[0]?.reason
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:405
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:103
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:98
msgid "停用失敗：{0}"
msgstr "停用失敗：{0}"

#. placeholder {0}: res.failedCategories?.[0]?.reason
#. placeholder {1}: res?.successIds?.length
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:476
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:593
msgid "停用失敗：{0}, 成功停用{1}個品類"
msgstr "停用失敗：{0}, 成功停用{1}個品類"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDisableModal/index.web.tsx:66
msgid "停用後，其下級渠道的實際生效狀態將變為停用"
msgstr "停用後，其下級渠道的實際生效狀態將變為停用"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:48
msgid "停用後不可再往本節點新掛接，已有掛接與商家關係保留並標停用。"
msgstr "停用後不可再往本節點新掛接，已有掛接與商家關係保留並標停用。"

#. placeholder {0}: record.benefitName
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:177
msgid "停用後活動將無法繼續發放此權益，確定要停用「{0}」嗎？"
msgstr "停用後活動將無法繼續發放此權益，確定要停用「{0}」嗎？"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:765
msgid "停用後部分平台活動無法參與，將錯過平台曝光與補貼機會！"
msgstr "停用後部分平台活動無法參與，將錯過平台曝光與補貼機會！"

#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:147
#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:68
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:408
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:106
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:558
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:101
#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:84
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:80
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDisableModal/index.web.tsx:41
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:184
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:86
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:135
msgid "停用成功"
msgstr "停用成功"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:111
msgid "停用時間"
msgstr "停用時間"

#. placeholder {0}: formatTime(record.disabledAt)
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:53
msgid "停用時間：{0}"
msgstr "停用時間：{0}"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:109
msgid "停用服務成功"
msgstr "停用服務成功"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDisableModal/index.web.tsx:54
msgid "停用渠道：{channelName}"
msgstr "停用渠道：{channelName}"

#: apps/dp-business/src/servers/chain/roleApi.ts:159
msgid "停用角色失敗"
msgstr "停用角色失敗"

#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:142
msgid "停用配置"
msgstr "停用配置"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:53
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:336
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:34
msgid "停車"
msgstr "停車"

#: apps/dp-client/src/configs/page-configs.tsx:391
msgid "停車信息"
msgstr "停車信息"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:228
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:156
msgid "停車場"
msgstr "停車場"

#: apps/dp-admin/src/pages/audit-center/services/apis.ts:411
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:422
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:433
msgid "停車場、WiFi"
msgstr "停車場、WiFi"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:172
msgid "停車場位置"
msgstr "停車場位置"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:374
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:54
msgid "停車場內車輛停放整齊，出口處有「餐廳入口→」的指示箭頭，旁邊有卡通指示牌。"
msgstr "停車場內車輛停放整齊，出口處有「餐廳入口→」的指示箭頭，旁邊有卡通指示牌。"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:204
msgid "停車場名稱"
msgstr "停車場名稱"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:175
msgid "停車後步行路線"
msgstr "停車後步行路線"

#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:180
msgid "停車資訊"
msgstr "停車資訊"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:198
msgid "停車選項"
msgstr "停車選項"

#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:86
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:145
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:184
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:223
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:246
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:269
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:292
msgid "備注"
msgstr "備注"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:106
msgid "備注最多 500 個字符"
msgstr "備注最多 500 個字符"

#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailCard/index.tsx:291
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1000
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:276
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:195
#: apps/dp-admin/src/pages/worker-order/components/ProcessTimeline.web.tsx:40
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BlueHeartServiceInfo/index.web.tsx:25
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:86
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:552
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:265
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:255
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:321
#: apps/dp-admin/src/pages/org-tree/org-list/components/ShelfHistoryModal/index.web.tsx:70
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:253
#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:121
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:363
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:367
#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/Details.web.tsx:122
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:218
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:445
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:97
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:181
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:279
msgid "備註"
msgstr "備註"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:258
msgid "備註不能超過 {REMARK_MAX_LENGTH} 個字符"
msgstr "備註不能超過 {REMARK_MAX_LENGTH} 個字符"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1194
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:426
msgid "備註內容"
msgstr "備註內容"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BlueHeartServiceInfo/index.web.tsx:35
msgid "備註內容不能超過500個字符"
msgstr "備註內容不能超過500個字符"

#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:167
msgid "備註原因"
msgstr "備註原因"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1237
msgid "備註已保存"
msgstr "備註已保存"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:462
msgid "備註已添加"
msgstr "備註已添加"

#: apps/dp-client/src/screens/reservation/pages/detail/components/OrderInfoSection.tsx:80
#: apps/dp-client/src/screens/reservation/components/RemarkInput/index.tsx:18
#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:118
msgid "備註訊息"
msgstr "備註訊息"

#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:348
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:272
msgid "備註資訊"
msgstr "備註資訊"

#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:99
msgid "傳統日式料理專店家，由日本師傅親自主理。新鮮刺身每日空運直送，壽司製作工藝精湛。店內裝潢典雅，提供包廂服務，是商務招待的理想選擇。"
msgstr "傳統日式料理專店家，由日本師傅親自主理。新鮮刺身每日空運直送，壽司製作工藝精湛。店內裝潢典雅，提供包廂服務，是商務招待的理想選擇。"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:61
msgid "僅供運營人員查看"
msgstr "僅供運營人員查看"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:558
msgid "僅儲存目前選用的按鈕文字及跳轉頁面。"
msgstr "僅儲存目前選用的按鈕文字及跳轉頁面。"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:222
msgid "僅可上傳1個影片"
msgstr "僅可上傳1個影片"

#: apps/dp-business/src/pages/ImageManagement/components/imageTips.tsx:87
#: apps/dp-admin/src/pages/merchant/components/imageTips/index.web.tsx:96
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:132
msgid "僅可上傳1張照片"
msgstr "僅可上傳1張照片"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:268
msgid "僅可選擇有效啟用的三級渠道"
msgstr "僅可選擇有效啟用的三級渠道"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:102
msgid "僅可選擇有效啟用的三級渠道，請移除不可用渠道後再保存"
msgstr "僅可選擇有效啟用的三級渠道，請移除不可用渠道後再保存"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:282
msgid "僅可選擇有效啟用的三級渠道；未建立至第三級的渠道不完整，不可用於渠道活動。"
msgstr "僅可選擇有效啟用的三級渠道；未建立至第三級的渠道不完整，不可用於渠道活動。"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignChannelFields/index.web.tsx:29
msgid "僅可選擇有效啟用的三級渠道。未建立至第三級的渠道不完整，不可用於渠道活動。"
msgstr "僅可選擇有效啟用的三級渠道。未建立至第三級的渠道不完整，不可用於渠道活動。"

#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeSwitcher.tsx:62
msgid "僅報表／簽約，結算不在此樹"
msgstr "僅報表／簽約，結算不在此樹"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/Card.tsx:163
msgid "僅外帶"
msgstr "僅外帶"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:75
#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:81
msgid "僅套餐券可選"
msgstr "僅套餐券可選"

#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:199
msgid "僅展示該賬號為超級管理員的店家列表（只顯示開通結帳服務的門市）"
msgstr "僅展示該賬號為超級管理員的店家列表（只顯示開通結帳服務的門市）"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/index.web.tsx:167
msgid "僅待啟動活動可以修改"
msgstr "僅待啟動活動可以修改"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:365
msgid "僅接受數字、+ 、 -和#，不接受其他符號或英文字母。"
msgstr "僅接受數字、+ 、 -和#，不接受其他符號或英文字母。"

#: apps/dp-admin/src/pages/marketing/channel-management/services/useChannelImport.ts:167
msgid "僅支持 .xlsx 或 .xls 文件"
msgstr "僅支持 .xlsx 或 .xls 文件"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreName/index.web.tsx:46
msgid "僅支持中英文、數字、\"-\"、\"_\"及空格，且長度不可超過20個字符"
msgstr "僅支持中英文、數字、\"-\"、\"_\"及空格，且長度不可超過20個字符"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreName/index.web.tsx:65
msgid "僅支持純英文、數字、\"-\"、\"_\"及空格"
msgstr "僅支持純英文、數字、\"-\"、\"_\"及空格"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:119
msgid "僅支援 JPG/PNG 格式，單個檔案不超過 5MB"
msgstr "僅支援 JPG/PNG 格式，單個檔案不超過 5MB"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:196
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:192
msgid "僅支援JPG、PNG、WEBP格式的圖片"
msgstr "僅支援JPG、PNG、WEBP格式的圖片"

#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:367
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:411
msgid "僅支援PNG和JPG格式的圖片"
msgstr "僅支援PNG和JPG格式的圖片"

#: apps/dp-client/src/screens/diary/pages/my/components/CropPhoto/index.web.tsx:21
#: apps/dp-client/src/screens/diary/pages/my/components/CropPhoto/index.web.tsx:40
msgid "僅支援Web環境"
msgstr "僅支援Web環境"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:444
msgid "僅支援上傳PDF、JPG、PNG格式，單個檔案不超過20MB"
msgstr "僅支援上傳PDF、JPG、PNG格式，單個檔案不超過20MB"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:122
#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:123
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:118
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:119
msgid "僅支援上傳圖片"
msgstr "僅支援上傳圖片"

#: apps/dp-business/src/utils/validation.ts:100
#: apps/dp-business/src/utils/validation.ts:337
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:813
msgid "僅支援數字，且必須為8位數"
msgstr "僅支援數字，且必須為8位數"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:24
msgid "僅收藏、打卡、發布事件可設定。不選商家組表示適用所有商家；選擇商家組後，適用範圍為該組內的商家。商家組沿用既有名單配置。"
msgstr "僅收藏、打卡、發布事件可設定。不選商家組表示適用所有商家；選擇商家組後，適用範圍為該組內的商家。商家組沿用既有名單配置。"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:150
msgid "僅有效啟用的三級渠道可用於渠道活動"
msgstr "僅有效啟用的三級渠道可用於渠道活動"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:175
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:76
msgid "僅未到結束時間的進行中活動可追加券碼"
msgstr "僅未到結束時間的進行中活動可追加券碼"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:227
msgid "僅未開始活動可刪除"
msgstr "僅未開始活動可刪除"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:178
msgid "僅活動類型 = 掃碼時顯示；用戶需位於任一圍欄範圍內方可領取"
msgstr "僅活動類型 = 掃碼時顯示；用戶需位於任一圍欄範圍內方可領取"

#: apps/dp-client/src/screens/home/utils/order.ts:965
#: apps/dp-client/src/screens/home/utils/order.ts:966
#: apps/dp-client/src/screens/home/utils/order.ts:1036
#: apps/dp-client/src/screens/home/utils/order.ts:1037
#: apps/dp-client/src/screens/home/utils/order.ts:1095
msgid "僅特定日期"
msgstr "僅特定日期"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:189
msgid "僅特定日期可用"
msgstr "僅特定日期可用"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:98
msgid "僅用於運營端展示"
msgstr "僅用於運營端展示"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:121
msgid "僅管理"
msgstr "僅管理"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:175
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:184
msgid "僅管理掛接"
msgstr "僅管理掛接"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:136
msgid "僅能改掛到同一棵樹的其他節點，末級與非末級均可掛。改掛後本樹報表歸屬跟著走；其他樹不變。結算路徑獨立，不隨改掛自動變更。"
msgstr "僅能改掛到同一棵樹的其他節點，末級與非末級均可掛。改掛後本樹報表歸屬跟著走；其他樹不變。結算路徑獨立，不隨改掛自動變更。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:149
msgid "僅能選後端標為可選的起點（有請款商家的節點或店家自行結算）。更換結算只改請款所走的樹，不解除管理掛接；保存僅形成草稿，審批生效後才改變正式結算。"
msgstr "僅能選後端標為可選的起點（有請款商家的節點或店家自行結算）。更換結算只改請款所走的樹，不解除管理掛接；保存僅形成草稿，審批生效後才改變正式結算。"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountUnbindModal.tsx:88
msgid "僅解除所選節點的授權，不會刪除該使用者或其他樹的身份"
msgstr "僅解除所選節點的授權，不會刪除該使用者或其他樹的身份"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/ChainPermissionPanel.tsx:133
msgid "僅該節點管理者或其上級節點管理者可編輯帳號與角色"
msgstr "僅該節點管理者或其上級節點管理者可編輯帳號與角色"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:83
msgid "僅調整商場／商圈的管理歸屬，不會刪除商場資料本身"
msgstr "僅調整商場／商圈的管理歸屬，不會刪除商場資料本身"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:98
msgid "僅調整店家管理歸屬，不會修改店家的簽約商家和請款商家"
msgstr "僅調整店家管理歸屬，不會修改店家的簽約商家和請款商家"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:128
#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:99
msgid "僅適用購買套餐券"
msgstr "僅適用購買套餐券"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:236
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2212
msgid "僅限內用"
msgstr "僅限內用"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:238
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2220
msgid "僅限外帶"
msgstr "僅限外帶"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:147
msgid "僅限新用戶"
msgstr "僅限新用戶"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:145
msgid "僅限會員"
msgstr "僅限會員"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:148
msgid "僅限老用戶"
msgstr "僅限老用戶"

#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:146
msgid "僅需上傳商家ID列表（平台ID），上傳後全量覆蓋原選擇商家"
msgstr "僅需上傳商家ID列表（平台ID），上傳後全量覆蓋原選擇商家"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/index.web.tsx:241
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/index.web.tsx:239
msgid "僅需上傳店家ID列表（平台ID），上傳後全量覆蓋原選擇店家"
msgstr "僅需上傳店家ID列表（平台ID），上傳後全量覆蓋原選擇店家"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:32
msgid "像這樣「店門口環境」的清楚照片，避免逆光或遮住太多店面（例如汽車、路人）"
msgstr "像這樣「店門口環境」的清楚照片，避免逆光或遮住太多店面（例如汽車、路人）"

#: apps/dp-client/src/screens/home/utils/filterData.ts:138
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:48
#: apps/dp-business/src/pages/MenuManagement.tsx:595
#: apps/dp-business/src/pages/MenuManagement.tsx:1300
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:897
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:957
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1023
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:211
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:436
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:676
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:292
#: apps/dp-business/src/pages/BusinessStatus/components/ShopClosedImpactContent.tsx:44
#: apps/dp-business/src/pages/BusinessStatus/components/SharedTemplatesContent.tsx:65
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/PackageCouponCard/index.web.tsx:33
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:239
#: apps/dp-admin/src/pages/merchant/shop-detail/components/ShopClosedImpactModal/index.web.tsx:43
#: apps/dp-admin/src/pages/merchant/shop-detail/components/SharedTemplatesModal/index.web.tsx:57
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:250
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:226
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:115
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:364
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:99
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:156
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1227
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:247
msgid "價格"
msgstr "價格"

#: apps/dp-business/src/pages/MenuItemForm.tsx:437
msgid "價格 "
msgstr "價格 "

#: apps/dp-client/src/screens/home/utils/filterData.ts:115
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:196
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:22
msgid "價格低到高"
msgstr "價格低到高"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:369
msgid "價格僅限數字"
msgstr "價格僅限數字"

#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:29
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/HotIssues.web.tsx:94
msgid "價格合理"
msgstr "價格合理"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:145
msgid "價格必須為大於等於0的整數"
msgstr "價格必須為大於等於0的整數"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:782
msgid "價格明細"
msgstr "價格明細"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:382
msgid "價格範圍為0-99999"
msgstr "價格範圍為0-99999"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:163
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:191
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:216
msgid "價格資訊"
msgstr "價格資訊"

#: apps/dp-client/src/screens/home/utils/filterData.ts:116
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:197
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:23
msgid "價格高到低"
msgstr "價格高到低"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:47
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:64
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:335
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:222
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:99
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:218
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:72
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:136
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:268
#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:86
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:44
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:42
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:60
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:167
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:652
msgid "優先級"
msgstr "優先級"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:457
msgid "優先通過APP回覆"
msgstr "優先通過APP回覆"

#: apps/dp-business/src/pages/MerchantInfo/components/OptimizationCard.tsx:64
msgid "優化餐廳頁面"
msgstr "優化餐廳頁面"

#: apps/dp-client/src/screens/home/utils/filterData.ts:170
#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:403
#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:713
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:794
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/QuickFilterChips.tsx:52
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:80
msgid "優惠"
msgstr "優惠"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1664
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1385
msgid "優惠使用限制"
msgstr "優惠使用限制"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1180
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:130
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:89
msgid "優惠價格"
msgstr "優惠價格"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:38
msgid "優惠分組"
msgstr "優惠分組"

#: apps/dp-client/src/screens/login/components/account-info-card/index.tsx:80
#: apps/dp-client/src/screens/home/pages/Purchase/components/PurchaseModal/index.tsx:271
#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:196
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:683
#: apps/dp-client/src/components/CouponCard/index.tsx:259
#: apps/dp-admin/src/pages/marketing/services/constants.ts:402
msgid "優惠券"
msgstr "優惠券"

#. placeholder {0}: coupon.couponId
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:768
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:769
msgid "優惠券{0}"
msgstr "優惠券{0}"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:234
msgid "優惠券ID"
msgstr "優惠券ID"

#. placeholder {0}: couponDetail.couponId
#. placeholder {0}: couponDetail?.templateId || '-'
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:393
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:759
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:458
msgid "優惠券ID：{0}"
msgstr "優惠券ID：{0}"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:421
msgid "優惠券互斥組"
msgstr "優惠券互斥組"

#: apps/dp-business/src/pages/MarketingCenter/components/PreviewCard.tsx:67
msgid "優惠券名稱"
msgstr "優惠券名稱"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:99
msgid "優惠券名稱不能為空"
msgstr "優惠券名稱不能為空"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:55
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:104
msgid "優惠券名稱僅支援繁體中文與數字"
msgstr "優惠券名稱僅支援繁體中文與數字"

#: apps/dp-business/src/pages/MarketingCenter/components/PreviewCard.tsx:50
msgid "優惠券在商品詳情頁的展示樣式"
msgstr "優惠券在商品詳情頁的展示樣式"

#: apps/dp-client/src/screens/home/pages/Home/components/FetCouponMigrationPopup/index.tsx:80
msgid "優惠券歸屬調整通知"
msgstr "優惠券歸屬調整通知"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:47
msgid "優惠券無法使用"
msgstr "優惠券無法使用"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:378
msgid "優惠券管理"
msgstr "優惠券管理"

#: apps/dp-client/src/configs/page-configs.tsx:2556
msgid "優惠券詳情"
msgstr "優惠券詳情"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:695
#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:570
msgid "優惠已鎖定 等待支付"
msgstr "優惠已鎖定 等待支付"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:301
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:258
msgid "優惠序號"
msgstr "優惠序號"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:126
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:136
msgid "優惠序號不存在"
msgstr "優惠序號不存在"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:293
msgid "優惠序號生成數量"
msgstr "優惠序號生成數量"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:275
msgid "優惠序號生成規則"
msgstr "優惠序號生成規則"

#: apps/dp-client/src/screens/home/pages/CouponShopList/components/CouponCard.tsx:99
#: apps/dp-client/src/components/CouponCard/index.tsx:255
#: apps/dp-client/src/components/CouponCard/index.tsx:255
msgid "優惠折價券"
msgstr "優惠折價券"

#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:524
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:423
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:55
msgid "優惠折扣"
msgstr "優惠折扣"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:112
msgid "優惠折扣不能為空"
msgstr "優惠折扣不能為空"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:116
msgid "優惠折扣僅支援 0.1～9.9 的數字"
msgstr "優惠折扣僅支援 0.1～9.9 的數字"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:121
msgid "優惠折扣最多一位小數"
msgstr "優惠折扣最多一位小數"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:88
msgid "優惠折扣範圍為 0.1～9.9"
msgstr "優惠折扣範圍為 0.1～9.9"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:80
msgid "優惠折扣範圍為 0.1～9.9，最多一位小數"
msgstr "優惠折扣範圍為 0.1～9.9，最多一位小數"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:128
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:454
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:692
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:809
msgid "優惠折抵"
msgstr "優惠折抵"

#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:73
msgid "優惠抵扣總金額"
msgstr "優惠抵扣總金額"

#: apps/dp-business/src/components/MerchantBenefits/index.tsx:53
msgid "優惠推廣"
msgstr "優惠推廣"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:173
msgid "優惠期間"
msgstr "優惠期間"

#. placeholder {0}: timeAvailabilityInfo.label
#. placeholder {0}: buildTimeAvailabilityText(data)
#. placeholder {0}: buildTimeAvailabilityText(d)
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1013
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:353
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:215
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:262
msgid "優惠期間：{0}"
msgstr "優惠期間：{0}"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:2028
msgid "優惠說明"
msgstr "優惠說明"

#: apps/dp-client/src/screens/account/pages/notifications/components/OrderNotificationCard/index.tsx:24
#: apps/dp-admin/src/pages/marketing/services/constants.ts:313
msgid "優惠買單"
msgstr "優惠買單"

#: apps/dp-admin/src/pages/transaction/service/help/validate.ts:267
#: apps/dp-admin/src/pages/transaction/service/help/validate.ts:406
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:46
msgid "優惠買單佣金規則"
msgstr "優惠買單佣金規則"

#: apps/dp-business/src/servers/contract-management/api.ts:434
msgid "優惠買單合約"
msgstr "結帳折扣合約"

#: apps/dp-client/src/screens/home/pages/Purchase/components/PurchaseModal/index.tsx:170
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:56
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:50
msgid "優惠買單折扣券"
msgstr "結帳折扣券"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:46
msgid "優惠買點佣金規則"
msgstr "優惠買點佣金規則"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1814
#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:19
msgid "優惠資訊"
msgstr "優惠資訊"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:459
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:336
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:103
msgid "優惠金額"
msgstr "優惠金額"

#: apps/dp-client/src/screens/home/pages/Home/components/RecommendSetmeal/index.tsx:202
msgid "優惠餐券"
msgstr "優惠餐券"

#: apps/dp-business/src/pages/StoreDescription.tsx:186
msgid "優秀實例"
msgstr "優秀實例"

#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:88
msgid "優秀實例 1"
msgstr "優秀實例 1"

#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:93
msgid "優秀實例 2"
msgstr "優秀實例 2"

#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:98
msgid "優秀實例 3"
msgstr "優秀實例 3"

#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:75
msgid "優秀描述實例"
msgstr "優秀描述實例"

#: apps/dp-business/src/pages/StoreDescription.tsx:142
#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:57
msgid "優秀案例"
msgstr "優秀案例"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:647
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:670
#: apps/dp-business/src/pages/MenuManagement.tsx:1417
#: apps/dp-business/src/pages/VideoUpload/index.tsx:236
#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:588
#: apps/dp-business/src/pages/PhoneEdit/index.tsx:387
#: apps/dp-business/src/pages/MerchantDashboard/MobileLayout.tsx:205
#: apps/dp-business/src/pages/MerchantDashboard/DesktopLayout.tsx:237
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:687
#: apps/dp-business/src/pages/AveragePrice/index.tsx:294
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:494
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:584
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:251
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:165
#: apps/dp-admin/src/pages/merchant/task-detail/index.web.tsx:173
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/index.web.tsx:203
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/index.web.tsx:201
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:596
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:845
#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:383
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:427
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:537
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:220
#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:112
msgid "儲存"
msgstr "儲存"

#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:627
msgid "儲存POS服務設定失敗"
msgstr "儲存POS服務設定失敗"

#: apps/dp-business/src/components/UnsavedChangesDialog/index.tsx:69
msgid "儲存並離開"
msgstr "儲存並離開"

#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:415
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:512
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:644
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:884
#: apps/dp-admin/src/pages/merchant/shared/constants.ts:96
msgid "儲存中..."
msgstr "儲存中..."

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:990
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:467
msgid "儲存修改"
msgstr "儲存修改"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:244
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:605
#: apps/dp-admin/src/pages/merchant/task-detail/index.web.tsx:142
#: apps/dp-admin/src/pages/merchant/task-detail/index.web.tsx:146
#: apps/dp-admin/src/pages/merchant/shop-detail/services/hooks.ts:85
#: apps/dp-admin/src/pages/merchant/shop-detail/services/hooks.ts:88
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:480
#: apps/dp-admin/src/pages/merchant/shared/constants.ts:83
#: apps/dp-admin/src/pages/merchant/merchant-menu/services/hooks.ts:168
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:755
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:265
msgid "儲存失敗"
msgstr "儲存失敗"

#: apps/dp-business/src/pages/StoreDescription.tsx:130
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:322
#: apps/dp-business/src/pages/MenuManagement.tsx:1074
#: apps/dp-business/src/pages/VideoUpload/index.tsx:135
#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:343
#: apps/dp-business/src/pages/PhoneEdit/index.tsx:200
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:623
#: apps/dp-business/src/pages/BusinessHours/index.tsx:836
#: apps/dp-business/src/pages/AveragePrice/index.tsx:210
#: apps/dp-business/src/pages/AddressEdit/index.tsx:582
msgid "儲存失敗，請檢查網路連線"
msgstr "儲存失敗，請檢查網路連線"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:266
msgid "儲存失敗，請檢查網路連線後重試"
msgstr "儲存失敗，請檢查網路連線後重試"

#: apps/dp-business/src/pages/AveragePrice/index.tsx:206
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:199
msgid "儲存失敗，請稍後重試"
msgstr "儲存失敗，請稍後重試"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1992
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1998
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:262
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/hooks.ts:507
msgid "儲存失敗，請重試"
msgstr "儲存失敗，請重試"

#: apps/dp-business/src/servers/shop/api.ts:269
msgid "儲存店家設施失敗"
msgstr "儲存店家設施失敗"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/SaveModeSelector/index.web.tsx:38
msgid "儲存後產生，不再變動"
msgstr "儲存後產生，不再變動"

#: apps/dp-admin/src/pages/merchant/task-detail/index.web.tsx:138
#: apps/dp-admin/src/pages/merchant/shared/constants.ts:77
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:191
msgid "儲存成功"
msgstr "儲存成功"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/index.web.tsx:140
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:73
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/index.web.tsx:121
#: apps/dp-admin/src/pages/marketing/components/CombinedListForm/index.web.tsx:684
msgid "儲存方式"
msgstr "儲存方式"

#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:426
msgid "儲存服務設定失敗"
msgstr "儲存服務設定失敗"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:426
msgid "儲存營業資訊"
msgstr "儲存營業資訊"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/index.tsx:952
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:392
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:415
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:490
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:512
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:182
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2254
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:179
msgid "儲存草稿"
msgstr "暫存草稿"

#: apps/dp-business/src/servers/menu/api.ts:58
msgid "儲存菜單管理資訊失敗"
msgstr "儲存菜單管理資訊失敗"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:308
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:686
msgid "儲存設定"
msgstr "儲存設定"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:85
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:66
msgid "儲蓄卡"
msgstr "儲蓄卡"

#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:88
#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:374
msgid "允許"
msgstr "允許"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:401
msgid "允許同時使用"
msgstr "允許同時使用"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:114
msgid "允許大寫字母/數字/下劃線"
msgstr "允許大寫字母/數字/下劃線"

#: apps/dp-client/src/screens/account/pages/notification-settings/index.tsx:133
msgid "允許系統通知"
msgstr "允許系統通知"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:462
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:347
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:366
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:237
msgid "元"
msgstr "元"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:409
msgid "元/單"
msgstr "元/單"

#: apps/dp-business/src/store/HolidayContext.tsx:140
#: apps/dp-business/src/store/HolidayContext.tsx:140
#: apps/dp-business/src/store/HolidayContext.tsx:200
msgid "元旦"
msgstr "元旦"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:223
msgid "先不退了"
msgstr "先不退了"

#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:31
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:144
#: apps/dp-business/src/pages/OrderOverview/index.tsx:75
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:49
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:34
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:821
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:247
msgid "先生"
msgstr "先生"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:59
msgid "先選「用戶要做什麼才發獎」，再選「第幾次發」，最後設定獎勵內容和領取限制。"
msgstr "先選「用戶要做什麼才發獎」，再選「第幾次發」，最後設定獎勵內容和領取限制。"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:47
msgid "兌換"
msgstr "兌換"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:498
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1543
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:46
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:30
#: apps/dp-admin/src/modules/constants/options.ts:240
msgid "兌換券"
msgstr "兌換券"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:75
msgid "兌換失敗"
msgstr "兌換失敗"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:82
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:220
msgid "兌換失敗，請稍後重試"
msgstr "兌換失敗，請稍後重試"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/home/index.tsx:321
#: apps/dp-client/src/configs/page-configs.tsx:1440
msgid "兌換專區"
msgstr "兌換專區"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:115
msgid "兌換庫存與匯率"
msgstr "兌換庫存與匯率"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:791
msgid "兌換得到的權益不能與消耗積分權益相同"
msgstr "兌換得到的權益不能與消耗積分權益相同"

#: apps/dp-client/src/screens/account/pages/task-wall/components/ExchangeSuccessModal/index.tsx:66
msgid "兌換成功"
msgstr "兌換成功"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:427
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:578
msgid "兌換時間"
msgstr "兌換時間"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:391
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:492
msgid "兌換期限"
msgstr "兌換期限"

#. placeholder {0}: validTimeInfo.text
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1045
msgid "兌換期限：{0}"
msgstr "兌換期限：{0}"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:221
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:268
msgid "兌換期限：{validText}"
msgstr "兌換期限：{validText}"

#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:365
msgid "兌換期限：{validTime}"
msgstr "兌換期限：{validTime}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1044
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:138
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:56
msgid "兌換期限已過"
msgstr "兌換期限已過"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ExchangeLimitEditor/index.web.tsx:37
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:111
msgid "兌換消耗限制"
msgstr "兌換消耗限制"

#: apps/dp-admin/src/modules/constants/options.ts:241
msgid "兌換特定商品或服務"
msgstr "兌換特定商品或服務"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:102
msgid "兌換生效期由「活動配置」中的活動時間（起/止）控制，此處不另設。"
msgstr "兌換生效期由「活動配置」中的活動時間（起/止）控制，此處不另設。"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:256
msgid "兌換碼ID只能包含字母和數字"
msgstr "兌換碼ID只能包含字母和數字"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/records/index.tsx:26
#: apps/dp-client/src/screens/account/pages/task-wall/pages/records/index.tsx:221
msgid "兌換紀錄"
msgstr "兌換紀錄"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:101
msgid "兌換與消耗配置"
msgstr "兌換與消耗配置"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:57
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:38
msgid "免費停車場"
msgstr "免費停車場"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:109
msgid "免費取消"
msgstr "免費取消"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:156
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:47
msgid "免開發票商家"
msgstr "免開發票商家"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:251
msgid "免開發票商家可以使用收據樣本開立交易金額，並將收據紙本寄送指定郵寄地址"
msgstr "免開發票商家可以使用收據樣本開立交易金額，並將收據紙本寄送指定郵寄地址"

#: apps/dp-client/src/screens/home/pages/Meal/constants/index.ts:32
msgid "免預約"
msgstr "免預約"

#: apps/dp-business/src/store/HolidayContext.tsx:129
#: apps/dp-business/src/store/HolidayContext.tsx:129
msgid "兒童"
msgstr "兒童"

#: apps/dp-business/src/store/HolidayContext.tsx:130
msgid "兒童節"
msgstr "兒童節"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:164
msgid "兜底頁與跳轉目標「同理」配置：同樣走「新增落地頁」流程，完成後回填該兜底頁的 URL。自定義鏈接不可用（失效 / 下架 / 未通過校驗）時，C 端回落此頁並帶入商家圈選。"
msgstr "兜底頁與跳轉目標「同理」配置：同樣走「新增落地頁」流程，完成後回填該兜底頁的 URL。自定義鏈接不可用（失效 / 下架 / 未通過校驗）時，C 端回落此頁並帶入商家圈選。"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:40
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/hooks.ts:29
msgid "入隊失敗"
msgstr "入隊失敗"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:59
msgid "入駐_{batchId}.xlsx"
msgstr "入駐_{batchId}.xlsx"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:415
msgid "入駐主體類型"
msgstr "入駐主體類型"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:324
msgid "入駐圖片"
msgstr "入駐圖片"

#: apps/dp-admin/src/router/config/routes.web.tsx:310
#: apps/dp-admin/src/router/config/routes.web.tsx:458
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:154
msgid "入駐審核"
msgstr "入駐審核"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:244
msgid "入駐審核狀態"
msgstr "入駐審核狀態"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/OnboardHistoryModal/index.web.tsx:71
msgid "入駐審核記錄"
msgstr "入駐審核記錄"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:205
msgid "入駐待審批"
msgstr "入駐待審批"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:699
msgid "入駐成功"
msgstr "入駐成功"

#: apps/dp-admin/src/modules/constants/options.ts:52
msgid "入駐推進中"
msgstr "入駐推進中"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:327
msgid "入駐時上傳的門牌圖片"
msgstr "入駐時上傳的門牌圖片"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:91
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:37
msgid "入駐時間"
msgstr "入駐時間"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:610
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:231
msgid "入駐狀態"
msgstr "入駐狀態"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/EntryDetailCard/index.web.tsx:25
msgid "入駐詳情"
msgstr "入駐詳情"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/index.web.tsx:113
msgid "入駐變更歷史"
msgstr "入駐變更歷史"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/OverviewCards.web.tsx:21
msgid "入駐進度"
msgstr "入駐進度"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:512
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:179
msgid "內容"
msgstr "內容"

#: apps/dp-business/src/pages/TermsAndPrivacy/index.tsx:106
msgid "內容 URL 未配置"
msgstr "內容 URL 未配置"

#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:153
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:157
msgid "內容ID"
msgstr "內容ID"

#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:149
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:149
msgid "內容上架失敗"
msgstr "內容上架失敗"

#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:100
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:100
#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:297
#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:298
msgid "內容下架失敗"
msgstr "內容下架失敗"

#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:62
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:62
msgid "內容不可下架"
msgstr "內容不可下架"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:526
msgid "內容名稱"
msgstr "內容名稱"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:65
msgid "內容字數"
msgstr "內容字數"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:503
msgid "內容導入"
msgstr "內容導入"

#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:146
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:146
msgid "內容已上架"
msgstr "內容已上架"

#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:97
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:97
msgid "內容已下架"
msgstr "內容已下架"

#: apps/dp-admin/src/components/RichTextEditor/services/hooks.ts:158
#: apps/dp-admin/src/components/RichTextEditor/services/hooks.ts:196
msgid "內容已超過字數限制"
msgstr "內容已超過字數限制"

#: apps/dp-client/src/screens/home/pages/ReviewRule/index.tsx:18
msgid "內容待補充"
msgstr "內容待補充"

#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:219
msgid "內容文本"
msgstr "內容文本"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:21
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:84
msgid "內容檢舉"
msgstr "內容檢舉"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:85
msgid "內容檢舉處理"
msgstr "內容檢舉處理"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:412
msgid "內容無變化"
msgstr "內容無變化"

#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:179
msgid "內容狀態"
msgstr "內容狀態"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:127
msgid "內容發佈須知"
msgstr "內容發佈須知"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:19
msgid "內容發布須知"
msgstr "內容發布須知"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:88
msgid "內容舉報詳情"
msgstr "內容舉報詳情"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:226
msgid "內容要求\\次數"
msgstr "內容要求\\次數"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:138
msgid "內容詳情"
msgstr "內容詳情"

#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:216
msgid "內容資訊"
msgstr "內容資訊"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:77
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:177
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:150
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:123
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:158
msgid "內容類型"
msgstr "內容類型"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:112
msgid "內容類型："
msgstr "內容類型："

#: apps/dp-client/src/screens/home/utils/utils.ts:422
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:285
msgid "內容類型不符"
msgstr "內容類型不符"

#: apps/dp-admin/src/router/config/routes.web.tsx:449
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:203
msgid "內容風控審核"
msgstr "內容風控審核"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:270
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:246
msgid "內容風控審核詳情"
msgstr "內容風控審核詳情"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:518
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:77
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/OrderStatusArea.tsx:73
msgid "內未付款，訂單將自動關閉"
msgstr "內未付款，訂單將自動關閉"

#: apps/dp-business/src/data/regions.ts:45
msgid "內湖區"
msgstr "內湖區"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:345
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:444
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2163
msgid "內用"
msgstr "內用"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:239
msgid "內用外帶皆可"
msgstr "內用外帶皆可"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:438
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2196
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:586
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2155
msgid "內用外帶約定"
msgstr "內用外帶規定"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:25
msgid "內部跳轉"
msgstr "內部跳轉"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/constants.ts:83
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:139
msgid "內部連結"
msgstr "內部連結"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:143
msgid "內部鏈接"
msgstr "內部鏈接"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:59
msgid "內部頁面"
msgstr "內部頁面"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:77
msgid "內部頁面：由運營手動輸入站內頁面 URL（路徑或完整連結），系統不做下拉選擇。"
msgstr "內部頁面：由運營手動輸入站內頁面 URL（路徑或完整連結），系統不做下拉選擇。"

#: apps/dp-client/src/screens/home/pages/Ranking/hooks/useRanking.ts:111
#: apps/dp-client/src/screens/home/pages/Ranking/hooks/useRanking.ts:275
#: apps/dp-client/src/screens/home/pages/Ranking/hooks/useRanking.ts:349
#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/RankingFilters/index.tsx:562
#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/RankingFilters/index.tsx:763
#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/RankingFilters/index.tsx:846
#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/RankingFilters/index.tsx:856
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:180
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:732
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/CategoryQuickChips.tsx:63
msgid "全區"
msgstr "全區"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:386
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:511
msgid "全場通用"
msgstr "全場通用"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/templatePreviewData.ts:94
msgid "全天"
msgstr "全天"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:187
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:234
msgid "全天可用"
msgstr "全天可用"

#: apps/dp-client/src/screens/home/utils/filterData.ts:199
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:122
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1262
msgid "全天營業"
msgstr "全天營業"

#: apps/dp-admin/src/pages/audit-center/user-audit/services/hooks.ts:118
msgid "全市（Chengwu.Jin）"
msgstr "全市（Chengwu.Jin）"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:45
msgid "全支付"
msgstr "全支付"

#: apps/dp-client/src/screens/diary/pages/my/components/DiaryCard.tsx:206
#: apps/dp-client/src/screens/diary/components/TextEllipsis/index.tsx:29
#: apps/dp-client/src/screens/diary/components/DiaryContent/index.tsx:103
msgid "全文"
msgstr "全文"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:339
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:401
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:544
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:567
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:794
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:121
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:343
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:182
#: apps/dp-client/src/screens/home/components/ShopFilter/hooks/useFilterSelection.ts:183
#: apps/dp-client/src/screens/home/components/ShopFilter/hooks/useFilterSelection.ts:185
#: apps/dp-client/src/screens/home/components/ShopFilter/components/CascaderFilterContent.tsx:110
msgid "全臺"
msgstr "全臺"

#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:102
#: apps/dp-admin/src/pages/merchant/components/StoreSettingsSection/index.web.tsx:160
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:886
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:963
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionPickerModal.web.tsx:56
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionPickerModal.web.tsx:48
#: apps/dp-admin/src/components/BusinessHours/components/DaySelector.web.tsx:55
msgid "全選"
msgstr "全選"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:363
msgid "全選符合條件的渠道（跨頁）"
msgstr "全選符合條件的渠道（跨頁）"

#: apps/dp-client/src/screens/home/pages/ShopDetail/constants/index.ts:19
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:185
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:108
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:137
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:144
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:154
#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:55
#: apps/dp-client/src/screens/home/pages/Review/pages/draft/index.tsx:18
#: apps/dp-client/src/screens/home/pages/PrivateChef/constants.ts:8
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:84
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:91
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:95
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Media/index.tsx:31
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallShopSection/index.tsx:56
#: apps/dp-client/src/screens/home/pages/Home/components/HotRanking/index.tsx:370
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/MapFilterBarRow.tsx:31
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/FilterButtonRow.tsx:36
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:66
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:83
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:146
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:174
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:383
#: apps/dp-client/src/screens/home/components/ShopFilter/hooks/useFilterSelection.ts:357
#: apps/dp-client/src/screens/home/components/ShopFilter/hooks/useFilterSelection.ts:375
#: apps/dp-client/src/screens/home/components/ShopFilter/components/FilterBar.tsx:53
#: apps/dp-client/src/screens/account/pages/order/index.tsx:45
#: apps/dp-client/src/screens/account/pages/drafts/main/index.tsx:34
#: apps/dp-client/src/components/TabView/example.tsx:17
#: apps/dp-business/src/types/orderFilter.ts:126
#: apps/dp-business/src/types/orderFilter.ts:140
#: apps/dp-business/src/types/orderFilter.ts:152
#: apps/dp-business/src/types/orderFilter.ts:164
#: apps/dp-business/src/types/orderFilter.ts:173
#: apps/dp-business/src/types/orderFilter.ts:183
#: apps/dp-business/src/types/orderFilter.ts:193
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1779
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1805
#: apps/dp-business/src/pages/OrderList/index.tsx:890
#: apps/dp-business/src/pages/OrderList/index.tsx:908
#: apps/dp-business/src/pages/OrderList/index.tsx:926
#: apps/dp-business/src/pages/OrderDetails/utils.ts:36
#: apps/dp-business/src/pages/OrderDetails/utils.ts:45
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesFilterBar.tsx:101
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesFilterBar.tsx:112
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/components/DiscountFilterBar.tsx:90
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/components/DiscountFilterBar.tsx:101
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:928
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:70
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:63
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:71
#: apps/dp-business/src/pages/CustomerReviews/components/KeywordStatsSection.tsx:106
#: apps/dp-business/src/pages/ComplaintList/index.tsx:35
#: apps/dp-business/src/components/DateRangeSelector/index.tsx:172
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:161
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:206
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:218
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:230
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:239
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:249
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:259
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:144
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:155
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:182
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:30
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:49
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponListModal.web.tsx:181
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:145
#: apps/dp-admin/src/pages/marketing/benefit-management/services/constants.ts:19
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/KeywordStats.web.tsx:63
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:29
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:38
msgid "全部"
msgstr "全部"

#. placeholder {0}: node.name
#. placeholder {0}: region.name
#. placeholder {0}: filterParams.mainCategory
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:61
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:154
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:80
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:212
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:317
msgid "全部{0}"
msgstr "全部{0}"

#. placeholder {0}: totalCount ?? dishes.length
#: apps/dp-client/src/screens/home/pages/Review/components/DishesSection/index.tsx:47
msgid "全部{0}道菜"
msgstr "全部{0}道菜"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:121
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:125
msgid "全部BD"
msgstr "全部BD"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:290
msgid "全部一級渠道"
msgstr "全部一級渠道"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:21
msgid "全部事件完成"
msgstr "全部事件完成"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:305
msgid "全部二級渠道"
msgstr "全部二級渠道"

#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:41
msgid "全部人工處理單"
msgstr "全部人工處理單"

#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:82
msgid "全部來源"
msgstr "全部來源"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:102
msgid "全部允許"
msgstr "全部允許"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/home/index.tsx:418
msgid "全部兌換商品"
msgstr "全部兌換商品"

#: apps/dp-admin/src/modules/constants/userGroup.ts:44
msgid "全部名單"
msgstr "全部名單"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:730
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:731
#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterSelects.tsx:130
msgid "全部品牌"
msgstr "全部品牌"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/MallShopList/index.tsx:79
#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterSelects.tsx:114
#: apps/dp-admin/src/router/config/routes.web.tsx:48
#: apps/dp-admin/src/pages/merchant/all-merchant/index.web.tsx:8
msgid "全部商家"
msgstr "全部商家"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/chainReportFilterFields.ts:48
msgid "全部型態"
msgstr "全部型態"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:711
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:718
msgid "全部城市"
msgstr "全部城市"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:61
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:38
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:39
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:41
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:67
msgid "全部失敗"
msgstr "全部失敗"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:44
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/searchConfig.ts:47
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:251
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitCard/index.web.tsx:135
msgid "全部套餐"
msgstr "全部套餐"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:295
msgid "全部已標記為已讀"
msgstr "全部已標記為已讀"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:384
msgid "全部已讀"
msgstr "全部已讀"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterSelects.tsx:120
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:99
msgid "全部店家"
msgstr "全部店家"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:277
msgid "全部店家名單不支持編輯篩選條件"
msgstr "全部店家名單不支持編輯篩選條件"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:125
msgid "全部店家名單將涵蓋平台內所有店家，無需配置篩選條件，亦不可被組合名單引用。"
msgstr "全部店家名單將涵蓋平台內所有店家，無需配置篩選條件，亦不可被組合名單引用。"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:57
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:36
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:37
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:39
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:65
msgid "全部成功"
msgstr "全部成功"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:425
msgid "全部或編號"
msgstr "全部或編號"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:294
#: apps/dp-client/src/configs/page-configs.tsx:2309
msgid "全部打卡"
msgstr "全部打卡"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:42
msgid "全部拒絕"
msgstr "全部拒絕"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:182
msgid "全部掛接店"
msgstr "全部掛接店"

#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:402
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:599
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:352
msgid "全部樓層"
msgstr "全部樓層"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:1060
msgid "全部標示為已讀"
msgstr "全部標示為已讀"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:87
msgid "全部權益類型可選"
msgstr "全部權益類型可選"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:61
msgid "全部活動"
msgstr "全部活動"

#. placeholder {0}: activitiesWithTags.length
#. placeholder {0}: tabCounts[JoinedActivityTabKey.All]
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:128
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityFilterCard.tsx:91
msgid "全部活動 {0}"
msgstr "全部活動 {0}"

#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:52
#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:61
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:156
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:796
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:715
#: apps/dp-business/src/pages/RefundList/index.tsx:145
#: apps/dp-business/src/pages/RefundList/index.tsx:402
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1757
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1798
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:54
#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterSelects.tsx:218
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:37
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:46
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:85
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:297
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:255
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:245
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:252
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:379
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:54
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:136
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:144
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:77
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:202
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:72
#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:66
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:135
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:145
msgid "全部狀態"
msgstr "全部狀態"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:116
msgid "全部用戶"
msgstr "全部用戶"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:126
msgid "全部用戶名單將涵蓋平台內所有已註冊用戶，無需配置篩選條件，亦不可被組合名單引用。"
msgstr "全部用戶名單將涵蓋平台內所有已註冊用戶，無需配置篩選條件，亦不可被組合名單引用。"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ClientSearchPanel/index.web.tsx:92
msgid "全部縣市 / 全部行政區"
msgstr "全部縣市 / 全部行政區"

#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/RankingFilters/index.tsx:68
#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/RankingFilters/index.tsx:120
msgid "全部美食"
msgstr "全部美食"

#: apps/dp-client/src/screens/home/pages/Purchase/components/SelectDishContent/index.tsx:230
msgid "全部菜品"
msgstr "全部菜品"

#: apps/dp-business/src/components/CopyResultView/index.tsx:86
msgid "全部複製成功"
msgstr "全部複製成功"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:474
#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:229
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepRoles.web.tsx:113
msgid "全部角色"
msgstr "全部角色"

#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:69
#: apps/dp-business/src/servers/order/types.ts:270
#: apps/dp-admin/src/pages/order/services/utils.ts:330
#: apps/dp-admin/src/pages/marketing/services/constants.ts:323
msgid "全部退款"
msgstr "全部退款"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:101
msgid "全部通知"
msgstr "全部通知"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:43
msgid "全部通過"
msgstr "全部通過"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFilter.tsx:41
msgid "全部門檻"
msgstr "全部門檻"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:693
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:366
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:373
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ClientSearchPanel/index.web.tsx:80
msgid "全部類別"
msgstr "全部類別"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:672
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:64
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFilter.tsx:35
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:85
msgid "全部類型"
msgstr "全部類型"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/service/constants.ts:60
msgid "全額退款"
msgstr "全額退款"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/MealSummaryCard.tsx:29
msgid "兩人餐"
msgstr "兩人餐"

#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:39
#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:58
#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:91
#: apps/dp-business/src/pages/ChangePassword/index.tsx:67
#: apps/dp-business/src/components/SetPassword/index.tsx:104
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:118
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:381
msgid "兩次輸入的密碼不一致"
msgstr "兩次輸入的密碼不一致"

#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:21
msgid "八"
msgstr "八"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:35
msgid "八月小丘"
msgstr "八月小丘"

#: apps/dp-business/src/data/regions.ts:82
msgid "八里區"
msgstr "八里區"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:213
msgid "公休"
msgstr "公休"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:586
msgid "公佈結果"
msgstr "公佈結果"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/apis.ts:213
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:388
msgid "公佈結果失敗"
msgstr "公佈結果失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:383
msgid "公佈結果成功"
msgstr "公佈結果成功"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:49
msgid "公司"
msgstr "公司"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:74
msgid "公司登記名"
msgstr "公司登記名"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:645
msgid "公司登記名不能超過 100 個字元"
msgstr "公司登記名不能超過 100 個字元"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:371
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:133
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:93
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/CompanyRegistration/index.web.tsx:82
msgid "公司登記地址"
msgstr "公司登記地址"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:650
msgid "公司登記地址不能超過200個字符"
msgstr "公司登記地址不能超過200個字符"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:175
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:391
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:153
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:32
msgid "公司登記表"
msgstr "公司登記表"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:151
msgid "公司聯絡地址"
msgstr "公司聯絡地址"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:733
msgid "公司行政抬頭"
msgstr "公司行政抬頭"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:294
msgid "公告"
msgstr "公告"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:330
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:673
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:202
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:338
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:502
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:582
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:212
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:591
msgid "公車"
msgstr "公車"

#: apps/dp-client/src/screens/diary/components/TrafficExampleModal.tsx:69
msgid "公車：下車後往右前方步行約 5 分鐘，過十字路口後抵達百貨公司，由正門進入百貨公司，出電梯往右走，第一個路口左轉，即可看見 AA 泰式料理"
msgstr "公車：下車後往右前方步行約 5 分鐘，過十字路口後抵達百貨公司，由正門進入百貨公司，出電梯往右走，第一個路口左轉，即可看見 AA 泰式料理"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:34
msgid "公車到店"
msgstr "公車到店"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:98
msgid "公車到站後，乘客從車門走出，站臺旁有 “餐廳方向→” 指示牌。"
msgstr "公車到站後，乘客從車門走出，站臺旁有 “餐廳方向→” 指示牌。"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:418
msgid "公車到站後，乘客從車門走出，站臺旁有「餐廳方向→」指示牌。"
msgstr "公車到站後，乘客從車門走出，站臺旁有「餐廳方向→」指示牌。"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:500
#: apps/dp-business/src/components/MaintenanceList/index.tsx:1056
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:254
msgid "公車指引"
msgstr "公車指引"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:204
msgid "公車站"
msgstr "公車站"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:93
msgid "公車站牌顯示 “大熊美食餐廳站”，站牌旁有小熊圖案和路線圖。"
msgstr "公車站牌顯示 “大熊美食餐廳站”，站牌旁有小熊圖案和路線圖。"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:413
msgid "公車站牌顯示「大熊美食餐廳站」，站牌旁有小熊圖案和路線圖。"
msgstr "公車站牌顯示「大熊美食餐廳站」，站牌旁有小熊圖案和路線圖。"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:144
msgid "公開領取"
msgstr "公開領取"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:128
msgid "公開領取券"
msgstr "公開領取券"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:130
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:131
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:563
#: apps/dp-business/src/components/DatePicker.tsx:235
#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:19
msgid "六"
msgstr "六"

#. placeholder {0}: listData?.total ?? 0
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:348
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:365
msgid "共 {0} 個券碼"
msgstr "共 {0} 個券碼"

#. placeholder {0}: session.totalRows
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:220
msgid "共 {0} 列"
msgstr "共 {0} 列"

#. placeholder {0}: record.shops?.length ?? 0
#: apps/dp-admin/src/pages/merchant/shop-detail/components/SharedTemplatesModal/index.web.tsx:51
msgid "共 {0} 家"
msgstr "共 {0} 家"

#. placeholder {0}: notifications.length
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:352
msgid "共 {0} 條消息"
msgstr "共 {0} 條消息"

#. placeholder {0}: historyList.length
#: apps/dp-admin/src/pages/merchant/task-list/components/FollowUpHistoryModal/index.web.tsx:105
msgid "共 {0} 條記錄"
msgstr "共 {0} 條記錄"

#. placeholder {0}: Object.keys(materials).length
#. placeholder {1}: tableData.length
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:166
msgid "共 {0} 種材料類型，{1} 個文件"
msgstr "共 {0} 種材料類型，{1} 個文件"

#. placeholder {0}: messages.length
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:107
msgid "共 {0} 項"
msgstr "共 {0} 項"

#. placeholder {0}: merchantInfo?.reviewCount
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/ReviewHeader.web.tsx:117
msgid "共 {0}條評價"
msgstr "共 {0}條評價"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:414
msgid "共 {count} 個三級渠道"
msgstr "共 {count} 個三級渠道"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ManualPackageSelector/index.web.tsx:105
msgid "共 {count} 個可售套餐"
msgstr "共 {count} 個可售套餐"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:85
msgid "共 {count} 個套餐"
msgstr "共 {count} 個套餐"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:216
msgid "共 {count} 個渠道"
msgstr "共 {count} 個渠道"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:234
msgid "共 {count} 條"
msgstr "共 {count} 條"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/MemberPreviewPanel/index.web.tsx:131
msgid "共 {n} 人"
msgstr "共 {n} 人"

#: apps/dp-admin/src/pages/merchant/components/BlueNewContractHistory/index.web.tsx:92
#: apps/dp-admin/src/pages/audit-center/components/ContentAuditTaskHistory/index.web.tsx:117
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditRecordsModal/index.web.tsx:113
msgid "共 {n} 條"
msgstr "共 {n} 條"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/MemberPreviewPanel/index.web.tsx:85
msgid "共 {n} 間"
msgstr "共 {n} 間"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageCouponPicker/index.web.tsx:212
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/FixedPackageImportField/index.web.tsx:234
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/DynamicConditionField/index.web.tsx:134
msgid "共 {t_total} 條"
msgstr "共 {t_total} 條"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:222
msgid "共 {t2} 條記錄"
msgstr "共 {t2} 條記錄"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/DynamicPackageFields/index.web.tsx:141
msgid "共 {total} 個可售套餐"
msgstr "共 {total} 個可售套餐"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:146
msgid "共 {total} 個批次"
msgstr "共 {total} 個批次"

#: apps/dp-admin/src/pages/marketing/activity-create/components/MerchantPreviewTable/index.web.tsx:43
msgid "共 {total} 家"
msgstr "共 {total} 家"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:553
msgid "共 {total} 家商家"
msgstr "共 {total} 家商家"

#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:210
msgid "共 {total} 張圖片"
msgstr "共 {total} 張圖片"

#: apps/dp-admin/src/pages/users/roles/components/RoleTable/index.web.tsx:127
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:193
#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:157
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/index.web.tsx:80
#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:193
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:778
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:819
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:151
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:119
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:389
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:245
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:269
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:264
#: apps/dp-admin/src/pages/marketing/verification-record-detail/components/StatusLogTable/index.web.tsx:74
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1240
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:556
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:385
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:382
#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:661
#: apps/dp-admin/src/components/OperationLogTable/index.web.tsx:130
msgid "共 {total} 條"
msgstr "共 {total} 條"

#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:200
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:229
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:277
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:387
msgid "共 {total} 條記錄"
msgstr "共 {total} 條記錄"

#. placeholder {0}: total - unreadCount < 0 ? 0 : total - unreadCount
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:950
msgid "共 {total} 條通知，其中 {unreadCount} 條未讀，{0} 條已讀"
msgstr "共 {total} 條通知，其中 {unreadCount} 條未讀，{0} 條已讀"

#: apps/dp-admin/src/pages/marketing/verification-record/components/VerificationRecordTable/index.web.tsx:89
msgid "共 {total} 筆"
msgstr "共 {total} 筆"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:469
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/index.web.tsx:353
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:343
msgid "共 {totalCount} 條"
msgstr "共 {totalCount} 條"

#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:248
msgid "共 {totalCount} 條記錄"
msgstr "共 {totalCount} 條記錄"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:99
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:134
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:133
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:160
#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:136
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:62
#: apps/dp-admin/src/pages/report-center/audit-data/components/AuditTable.web.tsx:62
#: apps/dp-admin/src/pages/customer-service/components/TicketTable.web.tsx:96
msgid "共 {totalItem} 條"
msgstr "共 {totalItem} 條"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:159
msgid "共 {value} 條"
msgstr "共 {value} 條"

#. placeholder {0}: noteComments.length
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/CommentSection.tsx:116
msgid "共{0}則留言"
msgstr "共{0}則留言"

#. placeholder {0}: shops.length
#: apps/dp-business/src/pages/BusinessStatus/components/SharedTemplatesContent.tsx:57
msgid "共{0}家"
msgstr "共{0}家"

#. placeholder {0}: replies.length
#: apps/dp-client/src/screens/home/components/ReplayCard/index.tsx:388
msgid "共{0}條回覆"
msgstr "共{0}條回覆"

#. placeholder {0}: pagination.total
#. placeholder {1}: pagination.pageNum
#: apps/dp-business/src/pages/ComplaintList/index.tsx:454
msgid "共{0}條記錄，第{1}頁"
msgstr "共{0}條記錄，第{1}頁"

#. placeholder {0}: actualData.totalReviews
#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:188
msgid "共{0}條評論"
msgstr "共{0}條評論"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:899
msgid "共{quantity}件"
msgstr "共{quantity}件"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1031
msgid "共{quantity}件 現省"
msgstr "共{quantity}件 現省"

#: apps/dp-client/src/screens/home/pages/PackageZone/components/PackageZoneContent/index.tsx:240
msgid "共{total}個套餐"
msgstr "共{total}個套餐"

#. placeholder {0}: item.previewTotal || 0
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/DynamicPackageFields/index.web.tsx:128
msgid "共命中 {0} 個可售套餐"
msgstr "共命中 {0} 個可售套餐"

#. placeholder {0}: total ?? shops.length
#. placeholder {0}: total ?? malls.length
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:260
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedMallTable/index.web.tsx:121
msgid "共計 {0} 家"
msgstr "共計 {0} 家"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:170
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailMallTable.tsx:73
msgid "共計 {total} 家"
msgstr "共計 {total} 家"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:259
#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:32
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:45
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailCard/index.tsx:230
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Media/index.tsx:34
#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:47
#: apps/dp-client/src/components/RefundResonModal/index.tsx:30
#: apps/dp-client/src/components/RefundResonModal/index.tsx:77
#: apps/dp-client/src/components/RefundResonModal/index.tsx:79
#: apps/dp-client/src/components/RefundResonModal/index.tsx:129
#: apps/dp-client/src/components/RefundResonModal/index.tsx:175
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:145
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:309
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:44
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:36
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:46
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:17
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:173
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:397
#: apps/dp-admin/src/pages/data-center/services/constants.ts:64
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:292
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:337
msgid "其他"
msgstr "其他"

#: apps/dp-client/src/screens/diary/components/TrafficExampleModal.tsx:81
msgid "其他：1.騎機車可以從敬業四路進入賣場停車場，單次收費50元，消費滿500元可折抵。"
msgstr "其他：1.騎機車可以從敬業四路進入賣場停車場，單次收費50元，消費滿500元可折抵。"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractUpload/index.web.tsx:35
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/ContractUpload/index.web.tsx:39
msgid "其他備註"
msgstr "其他備註"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:272
msgid "其他備註 (僅運營後臺查看，用戶看不到)"
msgstr "其他備註 (僅運營後臺查看，用戶看不到)"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:233
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1400
msgid "其他優惠"
msgstr "其他優惠"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:255
msgid "其他指引"
msgstr "其他指引"

#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:109
msgid "其他方式驗證"
msgstr "其他方式驗證"

#. placeholder {0}: otherLabel || EMPTY_TEXT
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/AttachmentCell.web.tsx:45
msgid "其他樹：{0}"
msgstr "其他樹：{0}"

#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:89
msgid "其他登入方式"
msgstr "其他登入方式"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractUpload/components/OtherRemarks/index.web.tsx:28
msgid "其他簽約備註"
msgstr "其他簽約備註"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractUpload/components/OtherRemarks/index.web.tsx:29
msgid "其他簽約備註不能超過250字"
msgstr "其他簽約備註不能超過250字"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:288
msgid "其他補充"
msgstr "其他補充"

#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:109
msgid "其他週期"
msgstr "其他週期"

#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:270
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:260
msgid "其他配置"
msgstr "其他配置"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:219
msgid "其他限制"
msgstr "其他限制"

#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:416
msgid "其他限制:"
msgstr "其他限制："

#. placeholder {0}: currentPackage.usageRules.otherRestrictions
#. placeholder {0}: d.usageRules.otherRestrictions
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1143
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:294
msgid "其他限制：{0}"
msgstr "其他限制：{0}"

#: apps/dp-client/src/screens/login/pages/verify-identify-code/components/OtherTypeModal/index.tsx:56
msgid "其他驗證方式"
msgstr "其他驗證方式"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:581
msgid "具體內容"
msgstr "具體內容"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:246
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:253
msgid "再享商家加碼優惠"
msgstr "再享商家加碼優惠"

#: apps/dp-client/src/hooks/tasks/useTaskRewardHint.ts:105
msgid "再加{remainingImages}張圖，可得"
msgstr "再加{remainingImages}張圖，可得"

#: apps/dp-client/src/hooks/tasks/useTaskRewardHint.ts:103
msgid "再寫{remainingWords}字，可得"
msgstr "再寫{remainingWords}字，可得"

#: apps/dp-client/src/hooks/tasks/useTaskRewardHint.ts:101
msgid "再寫{remainingWords}字＋加{remainingImages}張圖，可得"
msgstr "再寫{remainingWords}字＋加{remainingImages}張圖，可得"

#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:187
#: apps/dp-business/src/pages/ChangePassword/index.tsx:249
#: apps/dp-business/src/pages/ChangePassword/index.tsx:253
#: apps/dp-business/src/components/SetPassword/index.tsx:236
#: apps/dp-business/src/components/SetPassword/index.tsx:240
msgid "再次輸入密碼"
msgstr "再次輸入密碼"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:255
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:441
#: apps/dp-client/src/screens/reservation/components/ReservationFailModal/index.tsx:74
msgid "再次預訂"
msgstr "再次預訂"

#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:49
msgid "再發佈一則"
msgstr "再發佈一則"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:657
#: apps/dp-client/src/screens/home/pages/Meal/pages/result/index.tsx:70
#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:469
msgid "再試一次"
msgstr "再試一次"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/index.tsx:108
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:677
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:733
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:813
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:860
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:99
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:109
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:122
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:141
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:147
msgid "再買一次"
msgstr "再買一次"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:917
msgid "最不推薦的餐點"
msgstr "最不推薦的餐點"

#: apps/dp-client/src/screens/home/components/ShopFilter/components/PriceInputSection.tsx:45
msgid "最低價"
msgstr "最低價"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:68
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:94
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:115
msgid "最低價格"
msgstr "最低價格"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:123
msgid "最低評分"
msgstr "最低評分"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:635
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:332
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:423
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:501
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:588
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:81
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:133
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:243
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:220
msgid "最多"
msgstr "最多"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PosterListField/index.web.tsx:76
msgid "最多 {LANDING_PAGE_POSTER_MAX_COUNT} 張"
msgstr "最多 {LANDING_PAGE_POSTER_MAX_COUNT} 張"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:141
msgid "最多 {max} 個字"
msgstr "最多 {max} 個字"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:509
msgid "最多9張，≤5MB／張）"
msgstr "最多9張，≤5MB／張）"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:400
msgid "最多9張圖片"
msgstr "最多 9 張圖片"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:420
msgid "最多上傳9張圖片，單張不超過5MB"
msgstr "最多上傳9張圖片，單張不超過5MB"

#: apps/dp-business/src/pages/TableManagement/index.tsx:590
#: apps/dp-business/src/pages/TableManagement/index.tsx:768
msgid "最多人數"
msgstr "最多人數"

#: apps/dp-business/src/pages/TableManagement/index.tsx:632
#: apps/dp-business/src/pages/TableManagement/index.tsx:810
msgid "最多人數必須大於最少人數"
msgstr "最多人數必須大於最少人數"

#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:150
msgid "最多可上傳 {maxCount} 張，本次僅可再上傳 {remaining} 張"
msgstr "最多可上傳 {maxCount} 張，本次僅可再上傳 {remaining} 張"

#: apps/dp-business/src/pages/ImageManagement/components/imageTips.tsx:106
#: apps/dp-admin/src/pages/merchant/components/imageTips/index.web.tsx:115
msgid "最多可上傳{maxCount}張{label}"
msgstr "最多可上傳{maxCount}張{label}"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:431
#: apps/dp-client/src/screens/reservation/pages/main/components/TimeModal.tsx:153
msgid "最多可提前"
msgstr "最多可提前"

#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:294
msgid "最多可核銷{maxRedemptionQuantity}張"
msgstr "最多可核銷{maxRedemptionQuantity}張"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:435
msgid "最多可退{maxRefundQuantity}張"
msgstr "最多可退{maxRefundQuantity}張"

#: apps/dp-admin/src/pages/audit-center/claim-audit/index.web.tsx:76
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:40
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:106
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:402
msgid "最多可選擇 {CLAIM_BATCH_LIMIT} 筆請款單"
msgstr "最多可選擇 {CLAIM_BATCH_LIMIT} 筆請款單"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1421
msgid "最多提前"
msgstr "最多提前"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:751
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:752
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1438
msgid "最多提前時間不能小於至少提前時間"
msgstr "最多提前時間不能小於至少提前時間"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1112
#: apps/dp-admin/src/pages/org-tree/org-create/components/EditableOrgTree/index.web.tsx:60
msgid "最多支持 {MAX_NODE_LEVEL} 層"
msgstr "最多支持 {MAX_NODE_LEVEL} 層"

#: apps/dp-client/src/screens/home/utils/filterData.ts:40
msgid "最多支持{maxDecimalPlaces}位小數"
msgstr "最多支持{maxDecimalPlaces}位小數"

#: apps/dp-business/src/utils/validation.ts:207
msgid "最多支持2位小數"
msgstr "最多支持2位小數"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/index.tsx:816
msgid "最多選擇 10 個標籤"
msgstr "最多選擇 10 個標籤"

#. placeholder {0}: maxCount ?? 0
#. placeholder {1}: remainingCount ?? 0
#: apps/dp-business/src/components/PhotoUploader/hooks/useFileUpload.ts:247
msgid "最多隻能上傳 {0} 張，還可選擇 {1} 張"
msgstr "最多隻能上傳 {0} 張，還可選擇 {1} 張"

#: apps/dp-admin/src/components/FileUpload/index.web.tsx:200
msgid "最多隻能上傳 {maxCount} 個檔案"
msgstr "最多隻能上傳 {maxCount} 個檔案"

#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:271
#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:516
msgid "最多隻能上傳 {maxCount} 張圖片"
msgstr "最多隻能上傳 {maxCount} 張圖片"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:130
#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:524
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:126
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:523
msgid "最多隻能上傳{maxFiles}張圖片"
msgstr "最多只能上傳{maxFiles}張圖片"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:528
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:527
msgid "最多隻能上傳{maxFiles}張圖片，還可以選擇{remainingSlots}張"
msgstr "最多只能上傳{maxFiles}張圖片，還可以選擇{remainingSlots}張"

#: apps/dp-business/src/utils/validation.ts:234
msgid "最多隻能包含1個連接符號"
msgstr "最多隻能包含1個連接符號"

#: apps/dp-admin/src/components/RichTextEditor/services/hooks.ts:73
msgid "最多隻能插入 {maxImages} 張圖片"
msgstr "最多隻能插入 {maxImages} 張圖片"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:635
msgid "最多隻能標註15個商家"
msgstr "最多只能標註15個商家"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:124
#: apps/dp-admin/src/pages/merchant/components/TagEditor/index.web.tsx:102
msgid "最多隻能添加 {maxCount} 個標籤"
msgstr "最多隻能添加 {maxCount} 個標籤"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:224
msgid "最多隻能添加10個步驟"
msgstr "最多隻能添加10個步驟"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:888
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:919
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:1101
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteTopicSection.tsx:77
msgid "最多隻能添加10個話題"
msgstr "最多隻能添加10個話題"

#: apps/dp-client/src/screens/home/utils/filterData.ts:46
#: apps/dp-client/src/screens/home/utils/filterData.ts:53
#: apps/dp-client/src/screens/home/utils/filterData.ts:96
msgid "最多隻能輸入{maxDigits}位數哦"
msgstr "最多只能輸入{maxDigits}位數哦"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:370
msgid "最多隻能輸入1000字哦"
msgstr "最多只能輸入1000字哦"

#: apps/dp-business/src/utils/validation.ts:213
msgid "最多隻能輸入6位數字"
msgstr "最多隻能輸入6位數字"

#: apps/dp-client/src/screens/home/pages/Note/pages/editPhoto/index.tsx:319
msgid "最多隻能選擇 12 張圖片"
msgstr "最多只能選擇 12 張圖片"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/hooks/useGalleryAccess.ts:146
#: apps/dp-client/src/screens/home/pages/Note/hooks/usePhotoSelection.ts:241
msgid "最多隻能選擇{maxImageCount}個檔案"
msgstr "最多隻能選擇{maxImageCount}個檔案"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:146
msgid "最大人數不能小於最少人數"
msgstr "最大人數不能小於最少人數"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:101
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:113
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:80
msgid "最大值"
msgstr "最大值"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:118
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:85
msgid "最大值需大於最小值"
msgstr "最大值需大於最小值"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:92
msgid "最大優惠價格"
msgstr "最大優惠價格"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:156
msgid "最大可處理工單數"
msgstr "最大可處理工單數"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:129
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:336
msgid "最大折扣："
msgstr "最大折扣："

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:54
msgid "最大排名"
msgstr "最大排名"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:92
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:95
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:66
msgid "最小值"
msgstr "最小值"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:81
msgid "最小優惠價格"
msgstr "最小優惠價格"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:75
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:406
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:42
msgid "最小尺寸為{minWidth} &times; {minHeight}"
msgstr "最小尺寸為{minWidth} &times; {minHeight}"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:44
msgid "最小排名"
msgstr "最小排名"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:209
msgid "最少"
msgstr "最少"

#: apps/dp-business/src/pages/TableManagement/index.tsx:581
#: apps/dp-business/src/pages/TableManagement/index.tsx:759
msgid "最少人數"
msgstr "最少人數"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:116
msgid "最少人數不能大於最多人數"
msgstr "最少人數不能大於最多人數"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:226
msgid "最少分享數"
msgstr "最少分享數"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:345
msgid "最常打卡{categoryText}"
msgstr "最常打卡{categoryText}"

#: apps/dp-client/src/screens/account/pages/task-wall/components/rewardLabels.ts:28
msgid "最後{remainingStock}張"
msgstr "最後{remainingStock}張"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:167
msgid "最後上線時間"
msgstr "最後上線時間"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:178
msgid "最後下線時間"
msgstr "最後下線時間"

#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:97
msgid "最後刷新時間"
msgstr "最後刷新時間"

#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:126
msgid "最後審核人"
msgstr "最後審核人"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:117
msgid "最後更新"
msgstr "最後更新"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:68
msgid "最後登入時間"
msgstr "最後登入時間"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:177
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/columns/index.web.tsx:61
#: apps/dp-admin/src/pages/marketing/user-group-create/components/MemberPreviewPanel/index.web.tsx:98
msgid "最後登錄時間"
msgstr "最後登錄時間"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1208
msgid "最後處理人員"
msgstr "最後處理人員"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1197
msgid "最後處理時間"
msgstr "最後處理時間"

#: apps/dp-business/src/pages/SimpleDashboard/components/ScanCard.tsx:116
msgid "最快方式，點擊後開啟掃描視窗"
msgstr "最快方式，點擊後開啟掃描視窗"

#: apps/dp-business/src/pages/SimpleDashboard/components/ScanCard.tsx:58
msgid "最快方式，點擊開始掃描"
msgstr "最快方式，點擊開始掃描"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:871
msgid "最推薦的餐點"
msgstr "最推薦的餐點"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:47
#: apps/dp-client/src/components/TabView/example.tsx:22
msgid "最新"
msgstr "最新"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:298
msgid "最新一期排行榜及中獎名單"
msgstr "最新一期排行榜及中獎名單"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:13
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:67
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/constants.ts:78
#: apps/dp-admin/src/pages/resource-config/components/ContentFilterSelector/index.web.tsx:15
msgid "最新上架"
msgstr "最新上架"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:183
msgid "最新任務時間"
msgstr "最新任務時間"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:42
msgid "最新修改時間"
msgstr "最新修改時間"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/index.tsx:171
msgid "最新入選名單"
msgstr "最新入選名單"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:404
msgid "最早可預訂時間："
msgstr "最早可預訂時間："

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:407
msgid "最短影片時長為 {minDuration} 秒"
msgstr "最短影片時長為 {minDuration} 秒"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:373
msgid "最終價格"
msgstr "最終價格"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:246
msgid "最終價格（用戶看到的價格）"
msgstr "最終價格（用戶看到的價格）"

#: apps/dp-business/src/components/DateRangeSelector/index.tsx:164
msgid "最近30天"
msgstr "最近30天"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1945
#: apps/dp-business/src/components/DateRangeSelector/index.tsx:163
msgid "最近7天"
msgstr "最近7天"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:89
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:57
msgid "最近下單時間"
msgstr "最近下單時間"

#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:165
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:146
msgid "最近修改人"
msgstr "最近修改人"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:821
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:870
msgid "最近修改時間"
msgstr "最近修改時間"

#: apps/dp-admin/src/pages/resource-config/category-management/services/constants.ts:89
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:632
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:663
msgid "最近停用"
msgstr "最近停用"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:112
msgid "最近停用原因"
msgstr "最近停用原因"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:107
msgid "最近停用時間"
msgstr "最近停用時間"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/constants.ts:12
msgid "最近分配"
msgstr "最近分配"

#: apps/dp-client/src/screens/home/pages/LocationSelect/components/HistorySection.tsx:54
msgid "最近指定"
msgstr "最近指定"

#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:173
msgid "最近操作時間"
msgstr "最近操作時間"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:103
msgid "最近啟用時間"
msgstr "最近啟用時間"

#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:428
msgid "最近登入區域"
msgstr "最近登入區域"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:51
msgid "最近訪問時間"
msgstr "最近訪問時間"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:245
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:262
msgid "最高{userAmount}元"
msgstr "最高{userAmount}元"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:371
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:351
msgid "最高上限金額"
msgstr "最高上限金額"

#: apps/dp-client/src/screens/home/components/ShopFilter/components/PriceInputSection.tsx:60
msgid "最高價"
msgstr "最高價"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:74
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:106
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:127
msgid "最高價格"
msgstr "最高價格"

#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:71
msgid "最高優惠"
msgstr "最高優惠"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:62
msgid "最高分享次數"
msgstr "最高分享次數"

#: apps/dp-client/src/hooks/tasks/useTaskTooltip.ts:185
msgid "最高可得"
msgstr "最高可得"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:200
msgid "最高可得 {count} {unit}"
msgstr "最高可得 {count} {unit}"

#. placeholder {0}: item.benefitOption.maximumDiscount
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitCard/index.web.tsx:90
msgid "最高折抵 {0} 元"
msgstr "最高折抵 {0} 元"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:80
msgid "最高排行值"
msgstr "最高排行值"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:102
msgid "最高消耗活動點數值"
msgstr "最高消耗活動點數值"

#. placeholder {0}: reward.maximumDiscount
#. placeholder {0}: couponInfo.maximumDiscount
#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:130
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:337
msgid "最高減{0}"
msgstr "最高減{0}"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:142
msgid "最高積分"
msgstr "最高積分"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:91
msgid "最高簽到次數"
msgstr "最高簽到次數"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:135
msgid "最高評分"
msgstr "最高評分"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:93
msgid "最高連續簽到次數"
msgstr "最高連續簽到次數"

#: apps/dp-business/src/data/categories.ts:207
msgid "冰淇淋"
msgstr "冰淇淋"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:297
msgid "冷"
msgstr "冷"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:55
msgid "凍結"
msgstr "凍結"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:331
msgid "凹凸效果"
msgstr "凹凸效果"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:212
msgid "出了點問題，等會兒再試試吧"
msgstr "出了點問題，等會兒再試試吧"

#: apps/dp-admin/src/pages/merchant/components/MetroStationExitSelector/index.web.tsx:52
#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:273
msgid "出入口"
msgstr "出入口"

#: apps/dp-admin/src/modules/hooks/options/useMetroExitOptions.ts:137
#: apps/dp-admin/src/modules/hooks/options/useMetroExitOptions.ts:138
#: apps/dp-admin/src/modules/hooks/options/useMetroExitOptions.ts:143
#: apps/dp-admin/src/modules/hooks/options/useMetroExitOptions.ts:145
msgid "出入口選項資料取得失敗"
msgstr "出入口選項資料取得失敗"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:216
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:154
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:477
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:311
msgid "出生年月日"
msgstr "出生年月日"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:127
msgid "出生日期"
msgstr "出生日期"

#: apps/dp-client/src/screens/home/components/ShopCard/utils.tsx:55
msgid "出站{formattedDistance}"
msgstr "出站{formattedDistance}"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:191
msgid "出站後步行路線"
msgstr "出站後步行路線"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/HotIssues.web.tsx:87
msgid "出餐速度"
msgstr "出餐速度"

#: apps/dp-client/src/screens/home/pages/PackageZone/templates/ActivityTemplate.tsx:167
#: apps/dp-client/src/screens/home/pages/PackageZone/templates/ActivityTemplate.tsx:179
#: apps/dp-client/src/screens/diary/pages/my/components/TabSwitch.tsx:124
#: apps/dp-business/src/components/StoreInfoCard/index.tsx:491
#: apps/dp-business/src/components/StoreInfoCard/index.tsx:600
msgid "分"
msgstr "分"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:505
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:801
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1280
#: apps/dp-client/src/screens/account/pages/check-in/components/CheckInRecordItem/index.tsx:108
#: apps/dp-client/src/configs/page-configs.tsx:3025
msgid "分享"
msgstr "分享"

#. placeholder {0}: SHARE_CHANNEL_ANALYTICS_TITLE[e]
#: apps/dp-client/src/screens/home/pages/MallDetail/index.tsx:261
msgid "分享_{0}"
msgstr "分享_{0}"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShareModal/index.tsx:92
#: apps/dp-client/src/screens/home/pages/MallDetail/index.tsx:258
#: apps/dp-client/src/components/ShareCard/index.tsx:151
msgid "分享到其他"
msgstr "分享到其他"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:354
msgid "分享店舖獲得領取資格"
msgstr "分享餐廳獲得領取資格"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:455
msgid "分享打卡"
msgstr "分享打卡"

#: apps/dp-client/src/configs/page-configs.tsx:1166
msgid "分享抽獎活動"
msgstr "分享抽獎活動"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:399
msgid "分享數量"
msgstr "分享數量"

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:257
msgid "分享此App給好友"
msgstr "分享此App給好友"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:107
msgid "分享活動"
msgstr "分享活動"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShareModal/index.tsx:172
#: apps/dp-client/src/components/ShareCard/index.tsx:257
msgid "分享至"
msgstr "分享至"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:382
msgid "分割"
msgstr "分割"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1452
#: apps/dp-business/src/pages/ReservationManagement/TableCells.tsx:76
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:725
#: apps/dp-business/src/pages/OrderOverview/Detail/components/ReservationSlots.tsx:62
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/components/ReservationSlots.web.tsx:97
msgid "分區"
msgstr "分區"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:367
msgid "分區不存在或刪除失敗"
msgstr "分區不存在或刪除失敗"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:401
msgid "分區不存在或創建桌位失敗"
msgstr "分區不存在或創建桌位失敗"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:340
msgid "分區不存在或更新失敗"
msgstr "分區不存在或更新失敗"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:373
msgid "分區刪除成功"
msgstr "分區刪除成功"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:316
msgid "分區創建成功"
msgstr "分區創建成功"

#: apps/dp-business/src/pages/TableManagement/index.tsx:280
#: apps/dp-business/src/pages/TableManagement/index.tsx:385
msgid "分區名稱"
msgstr "分區名稱"

#: apps/dp-business/src/pages/TableManagement/index.tsx:316
#: apps/dp-business/src/pages/TableManagement/index.tsx:421
msgid "分區名稱長度必須在2-12字符之間"
msgstr "分區名稱長度必須在2-12字符之間"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:346
msgid "分區更新成功"
msgstr "分區更新成功"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:603
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:800
msgid "分區桌位"
msgstr "分區桌位"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1095
msgid "分區配置"
msgstr "分區配置"

#: apps/dp-business/src/utils/storeNameValidation.ts:94
msgid "分店名稱不能包含 + - @ / ～ 等字元"
msgstr "分店名稱不能包含 + - @ / ～ 等字元"

#: apps/dp-business/src/utils/storeNameValidation.ts:85
msgid "分店名稱不能超過50個字元"
msgstr "分店名稱不能超過50個字元"

#: apps/dp-business/src/utils/storeNameValidation.ts:105
msgid "分店名稱中文字元之間不能有空格"
msgstr "分店名稱中文字元之間不能有空格"

#: apps/dp-admin/src/utils/validation.ts:44
msgid "分機號只能包含數字"
msgstr "分機號只能包含數字"

#. placeholder {0}: groupIndex + 1
#: apps/dp-business/src/pages/CouponVerification/components/VerificationModal.tsx:230
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:485
msgid "分組 {0}"
msgstr "分組 {0}"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:276
msgid "分組名1"
msgstr "分組名1"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:285
msgid "分組名2 (3選2)"
msgstr "分組名2 (3選2)"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:205
msgid "分組名稱僅支援中文、英文、數字與空格"
msgstr "分組名稱僅支援中文、英文、數字與空格"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:598
msgid "分行代碼不能超過10個字符"
msgstr "分行代碼不能超過10個字符"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:102
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:140
msgid "分行或支行"
msgstr "分行或支行"

#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:534
msgid "分配"
msgstr "分配"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:678
msgid "分配BD"
msgstr "分配BD"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:135
msgid "分配人"
msgstr "分配人"

#: apps/dp-admin/src/pages/merchant/task-list/components/ActionButtons/index.web.tsx:62
#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:148
msgid "分配任務"
msgstr "分配任務"

#: apps/dp-admin/src/pages/customer-service/services/api.ts:126
#: apps/dp-admin/src/pages/customer-service/services/api.ts:128
msgid "分配失敗"
msgstr "分配失敗"

#: apps/dp-admin/src/pages/merchant/task-list/index.web.tsx:159
#: apps/dp-admin/src/pages/merchant/my-task/index.web.tsx:151
msgid "分配失敗,請稍後再試!"
msgstr "分配失敗,請稍後再試!"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:187
#: apps/dp-admin/src/pages/merchant/task-list/index.web.tsx:154
#: apps/dp-admin/src/pages/merchant/my-task/index.web.tsx:146
#: apps/dp-admin/src/pages/customer-service/services/api.ts:124
msgid "分配成功"
msgstr "分配成功"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:141
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:102
msgid "分配時間"
msgstr "分配時間"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:899
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:903
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:720
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:724
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:340
msgid "分配更新失敗，請重試"
msgstr "分配更新失敗，請重試"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:893
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:710
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:343
msgid "分配更新成功"
msgstr "分配更新成功"

#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:220
msgid "分配歷史"
msgstr "分配歷史"

#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:185
msgid "分配設定"
msgstr "分配設定"

#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:232
msgid "分配負責人"
msgstr "分配負責人"

#: apps/dp-admin/src/pages/org-tree/org-list/components/AssignBdModal/index.web.tsx:45
msgid "分配跟進 BD"
msgstr "分配跟進 BD"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:277
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:474
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:475
msgid "分鐘"
msgstr "分鐘"

#: apps/dp-client/src/screens/home/utils/utils.ts:70
msgid "分鐘前"
msgstr "分鐘前"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:182
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:736
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/CategoryQuickChips.tsx:67
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:403
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:362
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:220
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:158
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:26
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1222
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:206
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:472
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:239
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:282
msgid "分類"
msgstr "分類"

#. placeholder {0}: index + 1
#: apps/dp-client/src/screens/account/pages/advice/advice-feedback/index.tsx:54
msgid "分類 {0}"
msgstr "分類 {0}"

#. placeholder {0}: shopInfo.category
#: apps/dp-business/src/pages/AddStore/index.tsx:1025
#: apps/dp-business/src/pages/AddStore/index.tsx:1070
msgid "分類：{0}"
msgstr "分類：{0}"

#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:162
msgid "分類：{categoryText}"
msgstr "分類：{categoryText}"

#. placeholder {0}: groupIndex + 1
#. placeholder {0}: index + 1
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:577
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:227
msgid "分類{0}"
msgstr "分類{0}"

#: apps/dp-business/src/pages/MenuManagement.tsx:802
msgid "分類及相關餐點已刪除"
msgstr "分類及相關餐點已刪除"

#: apps/dp-business/src/pages/MenuManagement.tsx:821
msgid "分類已刪除"
msgstr "分類已刪除"

#: apps/dp-business/src/pages/MenuManagement.tsx:725
msgid "分類已新增"
msgstr "分類已新增"

#: apps/dp-business/src/pages/MenuManagement.tsx:769
msgid "分類已更新"
msgstr "分類已更新"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:63
msgid "分類星級"
msgstr "分類星級"

#: apps/dp-business/src/servers/chain/contextApi.ts:155
msgid "切換失敗"
msgstr "切換失敗"

#: apps/dp-business/src/servers/shop/api.ts:515
msgid "切換店家失敗"
msgstr "切換店家失敗"

#: apps/dp-business/src/servers/reservation/api.ts:694
msgid "切換時段狀態失敗"
msgstr "切換時段狀態失敗"

#: apps/dp-business/src/servers/reservation/api.ts:277
msgid "切換桌型狀態失敗"
msgstr "切換桌型狀態失敗"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/index.tsx:360
msgid "切換活動"
msgstr "切換活動"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:418
msgid "切換篩選或翻頁會保留已選渠道；點擊「確認選擇」後才會套用，取消不會修改原選擇。"
msgstr "切換篩選或翻頁會保留已選渠道；點擊「確認選擇」後才會套用，取消不會修改原選擇。"

#: apps/dp-admin/src/pages/exception/services/constants.ts:21
#: apps/dp-admin/src/pages/exception/services/constants.ts:42
msgid "切換索引別名"
msgstr "切換索引別名"

#: apps/dp-business/src/servers/reservation/api.ts:559
msgid "切換規則上架狀態失敗"
msgstr "切換規則上架狀態失敗"

#: apps/dp-business/src/servers/reservation/api.ts:534
msgid "切換規則狀態失敗"
msgstr "切換規則狀態失敗"

#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeSwitcher.tsx:146
msgid "切換連鎖樹（帳號有權的樹）"
msgstr "切換連鎖樹（帳號有權的樹）"

#: apps/dp-business/src/store/PerspectiveContext.tsx:190
msgid "切換連鎖視角失敗"
msgstr "切換連鎖視角失敗"

#: apps/dp-business/src/servers/reservation/api.ts:582
msgid "切換類別狀態失敗"
msgstr "切換類別狀態失敗"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:640
msgid "列表展示位置"
msgstr "列表展示位置"

#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:154
msgid "列表頁顯示位置"
msgstr "列表頁顯示位置"

#: apps/dp-admin/src/pages/exception/services/constants.ts:13
#: apps/dp-admin/src/pages/exception/services/constants.ts:34
msgid "初始化 ES 數據"
msgstr "初始化 ES 數據"

#: apps/dp-client/src/screens/home/pages/Ranking/hooks/useRanking.ts:387
msgid "初始化數據失敗"
msgstr "資料設定失敗"

#: apps/dp-business/src/store/HolidayContext.tsx:276
msgid "初始化節假日快取失敗"
msgstr "初始化節假日快取失敗"

#: apps/dp-admin/src/pages/exception/services/constants.ts:17
#: apps/dp-admin/src/pages/exception/services/constants.ts:38
msgid "初始化聯想詞數據"
msgstr "初始化聯想詞數據"

#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:244
#: apps/dp-admin/src/pages/merchant/shared/constants.ts:95
msgid "初始化資料..."
msgstr "初始化資料..."

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:373
msgid "初始密碼"
msgstr "初始密碼"

#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:83
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:235
msgid "初次匯入"
msgstr "初次匯入"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:68
msgid "初發"
msgstr "初發"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:432
#: apps/dp-client/src/screens/reservation/components/ReservationCard/index.tsx:65
#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:271
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:327
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:610
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:627
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:337
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:323
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:105
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:249
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:381
#: apps/dp-client/src/screens/account/pages/order/index.tsx:239
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:178
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:108
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:113
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:121
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:124
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:140
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:143
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:153
#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:84
#: apps/dp-client/src/screens/account/pages/invoice/components/InvoiceProfileCard/index.tsx:113
#: apps/dp-client/src/screens/account/pages/drafts/main/index.tsx:87
#: apps/dp-client/src/screens/account/pages/drafts/components/DraftCard.tsx:182
#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:209
#: apps/dp-client/src/screens/account/pages/check-in/components/CheckInRecordItem/index.tsx:97
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:166
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:206
#: apps/dp-business/src/pages/MenuManagement.tsx:543
#: apps/dp-business/src/pages/MenuManagement.tsx:680
#: apps/dp-business/src/pages/MenuManagement.tsx:869
#: apps/dp-business/src/pages/MenuManagement.tsx:1362
#: apps/dp-business/src/pages/UserManagement/index.tsx:577
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:387
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:321
#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:302
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:476
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:676
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:873
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1458
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:467
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:596
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:248
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:422
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1041
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1336
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1482
#: apps/dp-business/src/components/Modal/DeleteModal.tsx:44
#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:116
#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:86
#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:87
#: apps/dp-admin/src/pages/users/permissions/components/PermissionTreeTable/index.web.tsx:91
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:384
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:762
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:163
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BookingFeeRules/index.web.tsx:133
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:156
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:141
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/BookingFeeRules/index.web.tsx:104
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:212
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:181
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:176
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageCouponPicker/index.web.tsx:155
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/FixedPackageImportField/index.web.tsx:172
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:269
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:205
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:157
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:455
#: apps/dp-admin/src/pages/other/notifications/components/NotificationCard/index.web.tsx:94
#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:167
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:64
#: apps/dp-admin/src/pages/merchant/components/StoreSettingsSection/index.web.tsx:202
#: apps/dp-admin/src/pages/merchant/components/SortableItem/index.web.tsx:101
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:198
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:244
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:249
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/PromotionTab/index.web.tsx:109
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:166
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:738
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:790
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:877
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:162
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:124
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:138
#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:245
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:396
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:242
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:423
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:501
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:218
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:226
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:245
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:198
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:275
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:163
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:313
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:120
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:164
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:165
#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:284
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:190
#: apps/dp-admin/src/components/BusinessHours/SpecialBusinessHours.web.tsx:315
msgid "刪除"
msgstr "刪除"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:60
msgid "刪除／解除"
msgstr "刪除／解除"

#: apps/dp-client/src/screens/account/pages/drafts/main/index.tsx:87
msgid "刪除中..."
msgstr "刪除中..."

#: apps/dp-business/src/utils/permissionData.ts:149
msgid "刪除使用者"
msgstr "刪除使用者"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1609
msgid "刪除僅在本頁生效，提交審核通過後才會正式刪除。"
msgstr "刪除僅在本頁生效，提交審核通過後才會正式刪除。"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:378
msgid "刪除分區失敗"
msgstr "刪除分區失敗"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:126
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:221
msgid "刪除券碼失敗"
msgstr "刪除券碼失敗"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:188
msgid "刪除前，請確認以下內容"
msgstr "刪除前，請確認以下內容"

#: apps/dp-business/src/servers/permission/api.ts:197
msgid "刪除員工帳號失敗"
msgstr "刪除員工帳號失敗"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:196
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:213
msgid "刪除商家失敗"
msgstr "刪除商家失敗"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:387
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:444
#: apps/dp-business/src/utils/permissionData.ts:108
msgid "刪除回覆"
msgstr "刪除回覆"

#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:124
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageItem/index.web.tsx:111
msgid "刪除圖片"
msgstr "刪除圖片"

#: apps/dp-client/src/screens/home/pages/Note/pages/draft/index.tsx:72
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:893
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:204
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:207
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:322
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:271
msgid "刪除失敗"
msgstr "刪除失敗"

#: apps/dp-business/src/pages/ReviewDetail/index.tsx:253
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:152
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:361
msgid "刪除失敗，請檢查網路連線"
msgstr "刪除失敗，請檢查網路連線"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:221
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:249
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:148
msgid "刪除失敗，請稍後重試"
msgstr "刪除失敗，請稍後重試"

#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:95
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:341
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:344
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:640
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:643
msgid "刪除失敗，請重試"
msgstr "刪除失敗，請重試"

#: apps/dp-business/src/servers/coupon/api.ts:192
msgid "刪除套餐券失敗"
msgstr "刪除套餐券失敗"

#. placeholder {0}: selectedIds.size
#. placeholder {0}: selectedUids.size
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:945
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:991
msgid "刪除已選({0})"
msgstr "刪除已選({0})"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:94
msgid "刪除帳號失敗，請稍後重試"
msgstr "刪除帳號失敗，請稍後重試"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:85
msgid "刪除帳號成功"
msgstr "刪除帳號成功"

#: apps/dp-business/src/servers/shop/api.ts:245
msgid "刪除店家設施失敗"
msgstr "刪除店家設施失敗"

#. placeholder {0}: deletableRows.length
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:274
msgid "刪除後不可恢復，確定要刪除選中的 {0} 個權益嗎？"
msgstr "刪除後不可恢復，確定要刪除選中的 {0} 個權益嗎？"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:161
msgid "刪除後不可恢復，請謹慎操作"
msgstr "刪除後不可恢復，請謹慎操作"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:208
msgid "刪除後可以在商家詳情頁中重新打卡"
msgstr "刪除後可以在商家詳情頁中重新打卡"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:243
msgid "刪除後將同步處理子資源，請謹慎操作"
msgstr "刪除後將同步處理子資源，請謹慎操作"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:326
#: apps/dp-client/src/screens/account/pages/order/index.tsx:238
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:177
msgid "刪除後將無法恢復，請謹慎操作"
msgstr "刪除後將無法恢復，請謹慎操作"

#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:170
msgid "刪除後無法恢復，確定要刪除嗎？"
msgstr "刪除後無法恢復，確定要刪除嗎？"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:350
msgid "刪除後無法恢復，確定要刪除此模板嗎？"
msgstr "刪除後無法恢復，確定要刪除此模板嗎？"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:153
#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:130
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:304
msgid "刪除後無法恢復和查看訂單喔"
msgstr "刪除後無法恢復和查看訂單喔"

#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:82
#: apps/dp-client/src/screens/account/pages/drafts/main/index.tsx:65
msgid "刪除後無法找回喔"
msgstr "刪除後無法找回喔"

#. placeholder {0}: record.benefitName
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:197
msgid "刪除後該權益將不可恢復，確定要刪除「{0}」嗎？"
msgstr "刪除後該權益將不可恢復，確定要刪除「{0}」嗎？"

#. placeholder {0}: record.roleName
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:128
msgid "刪除後該角色將無法再被指派，確定刪除「{0}」？"
msgstr "刪除後該角色將無法再被指派，確定刪除「{0}」？"

#: apps/dp-admin/src/pages/merchant/components/SortableItem/index.web.tsx:91
msgid "刪除後該類別下的所有餐點也將被移除"
msgstr "刪除後該類別下的所有餐點也將被移除"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:137
msgid "刪除您的個人資料"
msgstr "刪除您的個人資料"

#: apps/dp-client/src/screens/home/pages/Note/pages/draft/index.tsx:67
#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:89
#: apps/dp-business/src/pages/TableManagement/index.tsx:467
#: apps/dp-business/src/pages/TableManagement/index.tsx:871
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:235
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:877
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:141
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:201
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/index.web.tsx:36
#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:278
#: apps/dp-admin/src/pages/resource-config/message-list/services/hooks.ts:126
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:319
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:362
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:260
#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:256
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:202
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/services/hooks.ts:136
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:169
#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:96
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:338
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:632
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:91
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:210
msgid "刪除成功"
msgstr "刪除成功"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:220
msgid "刪除打卡記錄失敗"
msgstr "刪除打卡記錄失敗"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:224
msgid "刪除授權"
msgstr "刪除授權"

#: apps/dp-business/src/pages/TableManagement/index.tsx:864
msgid "刪除桌位"
msgstr "刪除桌位"

#: apps/dp-business/src/servers/reservation/api.ts:402
#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:472
#: apps/dp-business/src/pages/TableManagement/index.tsx:897
msgid "刪除桌位失敗"
msgstr "刪除桌位失敗"

#: apps/dp-business/src/pages/TableManagement/index.tsx:460
msgid "刪除桌型"
msgstr "刪除桌型"

#: apps/dp-business/src/servers/reservation/api.ts:318
#: apps/dp-business/src/pages/TableManagement/index.tsx:478
msgid "刪除桌型失敗"
msgstr "刪除桌型失敗"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:355
msgid "刪除模板"
msgstr "刪除模板"

#: apps/dp-business/src/servers/file/api.ts:154
msgid "刪除檔案失敗"
msgstr "刪除檔案失敗"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/PhoneEditor/index.web.tsx:80
msgid "刪除此電話號碼"
msgstr "刪除此電話號碼"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:228
msgid "刪除活動"
msgstr "刪除活動"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:235
msgid "刪除活動失敗，請重新載入後重試"
msgstr "刪除活動失敗，請重新載入後重試"

#: apps/dp-business/src/pages/UserManagement/index.tsx:328
msgid "刪除用戶"
msgstr "刪除用戶"

#: apps/dp-client/src/store/invoiceStore.ts:140
msgid "刪除發票抬頭失敗"
msgstr "刪除發票抬頭失敗"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeBasicInfo/index.web.tsx:95
msgid "刪除節點"
msgstr "刪除節點"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:238
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:175
msgid "刪除結果未確認，請核對列表"
msgstr "刪除結果未確認，請核對列表"

#: apps/dp-business/src/servers/category/api.ts:83
msgid "刪除自訂分類失敗"
msgstr "刪除自訂分類失敗"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:237
msgid "刪除要求該樹只剩空根，且無指定管理員與店家／商場掛接；刪除後不可恢復。"
msgstr "刪除要求該樹只剩空根，且無指定管理員與店家／商場掛接；刪除後不可恢復。"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:290
msgid "刪除規則"
msgstr "刪除規則"

#: apps/dp-business/src/servers/reservation/api.ts:510
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:301
msgid "刪除規則失敗"
msgstr "刪除規則失敗"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:297
msgid "刪除規則成功"
msgstr "刪除規則成功"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:199
#: apps/dp-business/src/pages/PermissionManagement/index.tsx:120
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:127
msgid "刪除角色"
msgstr "刪除角色"

#: apps/dp-business/src/servers/permission/api.ts:147
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:138
msgid "刪除角色失敗"
msgstr "刪除角色失敗"

#: apps/dp-business/src/utils/permissionData.ts:181
msgid "刪除角色設定"
msgstr "刪除角色設定"

#: apps/dp-business/src/servers/reservation/api.ts:185
#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:207
msgid "刪除訂位規則失敗"
msgstr "刪除訂位規則失敗"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:340
#: apps/dp-client/src/screens/account/pages/order/index.tsx:253
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:188
msgid "刪除訂單失敗，請稍後重試"
msgstr "刪除訂單失敗，請稍後重試"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:350
msgid "刪除評論"
msgstr "刪除評論"

#. placeholder {0}: selectedShopIds.length
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:537
msgid "刪除選中（{0}）"
msgstr "刪除選中（{0}）"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:195
msgid "刪除配置"
msgstr "刪除配置"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:130
msgid "刪除電話"
msgstr "刪除電話"

#: apps/dp-business/src/pages/TableManagement/index.tsx:585
#: apps/dp-business/src/pages/TableManagement/index.tsx:763
msgid "到"
msgstr "到"

#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:95
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:192
msgid "到店"
msgstr "到店"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:434
#: apps/dp-admin/src/pages/audit-center/services/hooks.ts:77
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:248
msgid "到店引導"
msgstr "到店秘笈"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopLocationInfo.tsx:213
#: apps/dp-client/src/configs/page-configs.tsx:281
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:124
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1204
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:391
msgid "到店指引"
msgstr "到店指引"

#. placeholder {0}: index + 1
#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantImages/index.web.tsx:180
msgid "到店指引圖片 {0}"
msgstr "到店指引圖片 {0}"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1074
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1766
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1982
#: apps/dp-business/src/pages/OrderOverview/FilterModal.tsx:38
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:169
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:259
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:138
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:859
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1111
msgid "到店時間"
msgstr "到店時間"

#: apps/dp-client/src/screens/reservation/utils/index.ts:13
#: apps/dp-client/src/screens/reservation/utils/index.ts:19
#: apps/dp-client/src/screens/reservation/utils/index.ts:31
#: apps/dp-client/src/screens/reservation/utils/index.ts:38
msgid "到店用餐"
msgstr "到店用餐"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1594
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1658
msgid "到店訂單平均遲到時間"
msgstr "到店訂單平均遲到時間"

#: apps/dp-client/src/screens/diary/pages/my/components/PointsInfoCard.tsx:60
msgid "到店路線引導"
msgstr "到店路線引導"

#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:129
#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:109
msgid "到期時間"
msgstr "到期時間"

#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:36
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:284
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:375
msgid "到期自動退"
msgstr "過期自動退款"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:327
#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:561
#: apps/dp-client/src/screens/home/pages/PrivateChef/index.tsx:313
#: apps/dp-client/src/screens/home/pages/PrivateChef/components/PrivateChefFilterTabs/index.tsx:191
#: apps/dp-client/src/screens/home/pages/MerchantGroup/index.tsx:224
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:638
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:147
#: apps/dp-admin/src/components/ListPage/index.web.tsx:91
msgid "刷新"
msgstr "刷新"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:325
#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:559
#: apps/dp-client/src/screens/home/pages/PrivateChef/index.tsx:312
#: apps/dp-client/src/screens/home/pages/MerchantGroup/index.tsx:222
msgid "刷新一下試試"
msgstr "刷新一下試試"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:832
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:881
msgid "刷新中..."
msgstr "刷新中..."

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:76
msgid "刷新失敗，請稍後重試"
msgstr "刷新失敗，請稍後重試"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:832
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:881
msgid "刷新店家"
msgstr "刷新店家"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:73
msgid "刷新成功"
msgstr "刷新成功"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:70
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:68
msgid "刷新方式"
msgstr "刷新方式"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1082
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:260
msgid "券ID"
msgstr "券ID"

#: apps/dp-client/src/configs/page-configs.tsx:2474
msgid "券使用歷史"
msgstr "券使用歷史"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponListModal.web.tsx:80
msgid "券列表"
msgstr "券列表"

#: apps/dp-admin/src/pages/user-info/user-detail/index.web.tsx:103
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:427
msgid "券包列表"
msgstr "券包列表"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/CouponDetailModal/index.web.tsx:85
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/CouponDetailModal/index.web.tsx:86
msgid "券包詳情"
msgstr "券包詳情"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2600
#: apps/dp-business/src/pages/CouponVerification/index.tsx:584
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:108
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:128
msgid "券名稱"
msgstr "券名稱"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:78
msgid "券名稱1"
msgstr "券名稱1"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:78
msgid "券名稱2"
msgstr "券名稱2"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:132
msgid "券名稱最多8個字"
msgstr "券名稱最多8個字"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:990
msgid "券封面"
msgstr "券封面"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:970
msgid "券封面圖 + 券名稱"
msgstr "券封面圖 + 券名稱"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2443
msgid "券將從「已使用」恢復為「未使用」，該操作不會產生退款，用戶可重新使用此券。請確認已與客戶溝通。"
msgstr "券將從「已使用」恢復為「未使用」，該操作不會產生退款，用戶可重新使用此券。請確認已與客戶溝通。"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:179
msgid "券描述"
msgstr "券描述"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/BenefitInfoPanel/index.web.tsx:79
msgid "券有效期"
msgstr "券有效期"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:143
msgid "券模板ID"
msgstr "券模板ID"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:711
msgid "券狀態"
msgstr "券狀態"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponStatusModal.web.tsx:54
msgid "券狀態修改成功"
msgstr "券狀態修改成功"

#: apps/dp-admin/src/pages/marketing/verification-record-detail/components/StatusLogTable/index.web.tsx:59
msgid "券狀態記錄"
msgstr "券狀態記錄"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:175
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/columns.tsx:38
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/components/VerificationFilterBar.tsx:57
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesFilterBar.tsx:63
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1351
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2414
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2469
#: apps/dp-business/src/pages/CouponVerification/index.tsx:595
#: apps/dp-business/src/pages/ChainDashboard/components/reports/voucherUsageColumns.tsx:49
#: apps/dp-business/src/pages/ChainDashboard/components/reports/voucherSalesColumns.tsx:47
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:103
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:821
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:81
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:212
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:46
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:41
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:266
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponStatusModal.web.tsx:84
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:165
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:50
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:234
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:267
msgid "券碼"
msgstr "券碼"

#. placeholder {0}: maskSensitiveInfo(data.couponCode)
#: apps/dp-business/src/pages/CouponVerification/components/VerificationModal.tsx:204
msgid "券碼：{0}"
msgstr "券碼：{0}"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:355
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:370
msgid "券碼列表"
msgstr "券碼列表"

#: apps/dp-admin/src/modules/constants/options.ts:303
msgid "券碼尚未發放給用戶"
msgstr "券碼尚未發放給用戶"

#: apps/dp-admin/src/modules/constants/options.ts:309
msgid "券碼已發放給用戶但未使用"
msgstr "券碼已發放給用戶但未使用"

#: apps/dp-admin/src/modules/constants/options.ts:321
msgid "券碼已被作廢，無法使用"
msgstr "券碼已被作廢，無法使用"

#: apps/dp-admin/src/modules/constants/options.ts:315
msgid "券碼已被用戶使用"
msgstr "券碼已被用戶使用"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:118
msgid "券碼批次匯出"
msgstr "券碼批次匯出"

#: apps/dp-admin/src/pages/marketing/activity-config-list/services/couponCodes.ts:135
msgid "券碼批次匯出失敗，請稍後重試"
msgstr "券碼批次匯出失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:186
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:285
msgid "券碼有效期"
msgstr "券碼有效期"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:290
msgid "券碼核銷"
msgstr "券碼核銷"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:317
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:334
msgid "券碼模板"
msgstr "券碼模板"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:325
msgid "券碼清單"
msgstr "券碼清單"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2090
msgid "券碼資訊"
msgstr "券碼資訊"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:361
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:403
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:335
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:387
msgid "券種名稱"
msgstr "券種名稱"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:31
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:77
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:248
msgid "券組ID"
msgstr "券組ID"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:83
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:91
msgid "券組主圖"
msgstr "券組主圖"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:37
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:106
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:94
msgid "券組名稱"
msgstr "券組名稱"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:97
msgid "券組名稱不能超過50個字符"
msgstr "券組名稱不能超過50個字符"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:119
msgid "券組圖片"
msgstr "券組圖片"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:58
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:113
msgid "券組狀態"
msgstr "券組狀態"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/AddStockModal.web.tsx:45
msgid "券組資訊不存在"
msgstr "券組資訊不存在"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:49
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:99
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:82
msgid "券組類型"
msgstr "券組類型"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2611
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/PackageCouponCard/index.web.tsx:24
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:115
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:261
msgid "券號"
msgstr "券號"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/BenefitInfoPanel/index.web.tsx:70
msgid "券面額"
msgstr "券面額"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2589
#: apps/dp-business/src/pages/CouponVerification/index.tsx:644
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:101
msgid "券類型"
msgstr "券類型"

#: apps/dp-client/src/screens/diary/pages/my/index.tsx:369
msgid "則筆記"
msgstr "篇筆記"

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:172
msgid "則評論，為"
msgstr "則評論，為"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:564
msgid "前 2 碼為英文字母，後 8 碼為數字，共 10 碼"
msgstr "前 2 碼為英文字母，後 8 碼為數字，共 10 碼"

#: apps/dp-client/src/screens/diary/pages/winning/index.tsx:209
msgid "前公佈，感謝您的耐心等候。"
msgstr "前公佈，感謝您的耐心等候。"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:283
msgid "前去審核POI"
msgstr "前去審核POI"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:232
msgid "前去審核商家入駐"
msgstr "前去審核商家入駐"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:751
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:774
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:797
msgid "前去設置"
msgstr "前去設置"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1944
msgid "前往付款"
msgstr "前往付款"

#: apps/dp-admin/src/pages/marketing/components/TaskSubmittedModal/index.web.tsx:71
msgid "前往名單詳情查看匯入進度"
msgstr "前往名單詳情查看匯入進度"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/BlockedOverlay/index.web.tsx:17
msgid "前往審核"
msgstr "前往審核"

#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:254
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:224
msgid "前往導出歷史"
msgstr "前往導出歷史"

#: apps/dp-client/src/bootstrap/hooks/useMaintenanceCheck.ts:47
msgid "前往更新"
msgstr "前往更新"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:603
msgid "前往訂單"
msgstr "前往訂單"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:680
#: apps/dp-business/src/pages/BusinessHours/index.tsx:681
msgid "前日"
msgstr "前日"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:129
#: apps/dp-business/src/pages/BusinessHours/index.tsx:214
#: apps/dp-business/src/pages/BusinessHours/index.tsx:338
#: apps/dp-business/src/pages/BusinessHours/index.tsx:417
#: apps/dp-business/src/pages/BusinessHours/index.tsx:539
msgid "前日{endTime}"
msgstr "前日{endTime}"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:124
#: apps/dp-business/src/pages/BusinessHours/index.tsx:209
#: apps/dp-business/src/pages/BusinessHours/index.tsx:333
#: apps/dp-business/src/pages/BusinessHours/index.tsx:411
#: apps/dp-business/src/pages/BusinessHours/index.tsx:533
msgid "前日{startTime}"
msgstr "前日{startTime}"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:203
msgid "前端卡片配置"
msgstr "前端卡片配置"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:393
msgid "前端顯示預覽"
msgstr "前端顯示預覽"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:206
msgid "前還可修改"
msgstr "前還可修改"

#: apps/dp-client/src/utils/formatTime.ts:28
#: apps/dp-client/src/utils/formatTime.ts:36
#: apps/dp-client/src/utils/formatTime.ts:46
#: apps/dp-client/src/utils/formatTime.ts:69
#: apps/dp-client/src/screens/home/utils/utils.ts:72
#: apps/dp-client/src/screens/diary/pages/my/utils.ts:54
#: apps/dp-client/src/screens/diary/pages/my/utils.ts:60
#: apps/dp-client/src/screens/diary/pages/my/utils.ts:66
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:43
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:210
msgid "剛剛"
msgstr "剛剛"

#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:71
msgid "剛剛入駐"
msgstr "剛剛入駐"

#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:47
msgid "剛剛那則{contentName}還在發佈中。確定再發一則嗎？獎勵將維持 1 則的點數"
msgstr "剛剛那則{contentName}還在發佈中。確定再發一則嗎？獎勵將維持 1 則的點數"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:108
msgid "副標題"
msgstr "副標題"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:192
msgid "剩餘"
msgstr "剩餘"

#. placeholder {0}: `${record.remainingStock && record.remainingStock < 0 ? '無限制' : record.remainingStock}` || 0
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:240
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:265
msgid "剩餘: {0}"
msgstr "剩餘: {0}"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponListModal.web.tsx:61
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:239
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/BenefitInfoPanel/index.web.tsx:92
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:124
msgid "剩餘庫存"
msgstr "剩餘庫存"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:281
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:709
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:62
msgid "創建"
msgstr "創建"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:67
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:148
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:113
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/searchConfig.ts:46
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:99
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:253
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:243
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:682
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:333
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:161
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:92
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:218
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:90
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:150
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:92
#: apps/dp-admin/src/components/UserGroup/UserGroupDetailInfo/index.web.tsx:56
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupDetailInfo/index.web.tsx:56
#: apps/dp-admin/src/components/LandingPage/LandingPageDetailInfo/index.web.tsx:65
msgid "創建人"
msgstr "創建人"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:313
msgid "創建人 / 時間"
msgstr "創建人 / 時間"

#. placeholder {0}: r.createdByName || '-'
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:319
msgid "創建人:{0}"
msgstr "創建人:{0}"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:215
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:64
msgid "創建假日類型"
msgstr "創建假日類型"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:102
msgid "創建券組"
msgstr "創建券組"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/services/hooks.ts:290
msgid "創建券組成功"
msgstr "創建券組成功"

#: apps/dp-admin/src/router/config/routes.web.tsx:183
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:480
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:154
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:51
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:57
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupSelector/index.web.tsx:349
msgid "創建商家名單"
msgstr "創建商家名單"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:815
#: apps/dp-admin/src/pages/marketing/services/apis.ts:818
msgid "創建商家名單失敗"
msgstr "創建商家名單失敗"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:177
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:177
msgid "創建圖片任務失敗，請重試"
msgstr "創建圖片任務失敗，請重試"

#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:362
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:529
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:525
#: apps/dp-admin/src/pages/marketing/services/apis.ts:1387
#: apps/dp-admin/src/pages/marketing/services/apis.ts:1391
msgid "創建失敗"
msgstr "創建失敗"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:760
msgid "創建失敗，請稍後重試"
msgstr "創建失敗，請稍後重試"

#. placeholder {0}: (response?.[0] as any)?.errorMessage
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:521
msgid "創建失敗：{0}"
msgstr "創建失敗：{0}"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1310
msgid "創建套餐券"
msgstr "創建套餐券"

#: apps/dp-business/src/servers/coupon/api.ts:144
msgid "創建套餐券模板失敗"
msgstr "創建套餐券模板失敗"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/index.web.tsx:155
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:185
#: apps/dp-admin/src/pages/customer-service/components/CreateTicketModal.web.tsx:67
msgid "創建工單"
msgstr "創建工單"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1007
#: apps/dp-business/src/pages/BusinessStatus/components/ShopClosedImpactContent.tsx:38
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:423
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:237
#: apps/dp-admin/src/pages/merchant/shop-detail/components/ShopClosedImpactModal/index.web.tsx:41
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:224
msgid "創建店家"
msgstr "創建店家"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:162
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:200
msgid "創建店舖"
msgstr "創建店舖"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/index.web.tsx:505
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:68
#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:256
#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:459
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:53
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:66
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:524
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:519
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:165
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:170
#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:171
#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:559
#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:480
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:1078
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:1171
msgid "創建成功"
msgstr "創建成功"

#. placeholder {0}: result.memberCount
#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:278
msgid "創建成功，共 {0} 人"
msgstr "創建成功，共 {0} 人"

#. placeholder {0}: result.memberCount
#. placeholder {1}: result.registeredCount
#. placeholder {2}: result.unregisteredCount
#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:425
msgid "創建成功，共 {0} 人，已註冊 {1} 人，未註冊 {2} 人"
msgstr "創建成功，共 {0} 人，已註冊 {1} 人，未註冊 {2} 人"

#. placeholder {0}: result.memberCount
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:289
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:386
msgid "創建成功，共 {0} 間店家"
msgstr "創建成功，共 {0} 間店家"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:138
msgid "創建成功，已回填至權益配置"
msgstr "創建成功，已回填至權益配置"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:288
msgid "創建成功，已啟用全部店家名單"
msgstr "創建成功，已啟用全部店家名單"

#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:277
msgid "創建成功，已啟用全部用戶名單"
msgstr "創建成功，已啟用全部用戶名單"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:385
msgid "創建成功，正在計算成員"
msgstr "創建成功，正在計算成員"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:142
msgid "創建成功，跳轉鏈接已生成，請前往列表中複製"
msgstr "創建成功，跳轉鏈接已生成，請前往列表中複製"

#: apps/dp-business/src/configs/page-configs.ts:1083
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:185
msgid "創建折扣券"
msgstr "創建折扣券"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1123
msgid "創建新的套餐券模板，設置菜品組合和價格資訊"
msgstr "創建新的套餐券模板，設置餐點組合和價格資訊"

#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:56
msgid "創建方式"
msgstr "創建方式"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:710
#: apps/dp-business/src/pages/ContractManagement/index.tsx:477
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:233
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:401
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:129
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:106
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeColumns.web.tsx:55
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:82
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:182
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:256
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:246
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:254
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:421
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:600
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/UserInfoCard/index.web.tsx:48
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:94
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/RefundOrdersCard/index.web.tsx:73
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/InvoiceInfoCard/index.web.tsx:74
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:145
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:182
#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:155
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:164
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:96
#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:56
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:94
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:34
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:154
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:157
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:274
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:505
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:143
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:342
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:190
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:180
#: apps/dp-admin/src/components/UserGroup/UserGroupDetailInfo/index.web.tsx:59
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupDetailInfo/index.web.tsx:59
#: apps/dp-admin/src/components/LandingPage/LandingPageDetailInfo/index.web.tsx:68
msgid "創建時間"
msgstr "創建時間"

#: apps/dp-business/src/servers/reservation/api.ts:340
msgid "創建桌位失敗"
msgstr "創建桌位失敗"

#: apps/dp-business/src/servers/reservation/api.ts:233
msgid "創建桌型失敗"
msgstr "創建桌型失敗"

#: apps/dp-admin/src/components/Benefit/BenefitSelector/index.web.tsx:264
msgid "創建權益"
msgstr "創建權益"

#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:208
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:467
msgid "創建活動"
msgstr "創建活動"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1007
#: apps/dp-admin/src/pages/marketing/activity-create/services/hooks.ts:341
msgid "創建活動失敗"
msgstr "創建活動失敗"

#: apps/dp-admin/src/pages/marketing/activity-create/services/hooks.ts:348
msgid "創建活動失敗，請重試"
msgstr "創建活動失敗，請重試"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:83
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepTemplate.web.tsx:236
msgid "創建消息模板"
msgstr "創建消息模板"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateSelector/index.web.tsx:190
msgid "創建消息模版"
msgstr "創建消息模版"

#: apps/dp-admin/src/router/config/routes.web.tsx:159
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:464
#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:61
#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:67
#: apps/dp-admin/src/components/UserGroup/UserGroupSelector/index.web.tsx:265
msgid "創建用戶名單"
msgstr "創建用戶名單"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:603
#: apps/dp-admin/src/pages/marketing/services/apis.ts:606
msgid "創建用戶名單失敗"
msgstr "創建用戶名單失敗"

#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:386
#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:436
msgid "創建用戶名單失敗，請重試"
msgstr "創建用戶名單失敗，請重試"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:47
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:114
msgid "創建端"
msgstr "創建端"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:170
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:77
msgid "創建節假日"
msgstr "創建節假日"

#: apps/dp-admin/src/components/LandingPage/LandingPageSelector/index.web.tsx:282
msgid "創建落地頁"
msgstr "創建落地頁"

#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:499
msgid "創建行銷活動"
msgstr "創建行銷活動"

#: apps/dp-business/src/servers/reservation/api.ts:469
msgid "創建規則失敗"
msgstr "創建規則失敗"

#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:302
msgid "創建角色成功"
msgstr "創建角色成功"

#: apps/dp-business/src/servers/reservation/api.ts:93
#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:61
msgid "創建訂位規則失敗"
msgstr "創建訂位規則失敗"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:624
msgid "創建請款申請失敗"
msgstr "創建請款申請失敗"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:366
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:283
msgid "創建餐點"
msgstr "創建餐點"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteTopicSection.tsx:57
msgid "創造話題"
msgstr "創造話題"

#: apps/dp-business/src/pages/RefundList/index.tsx:131
msgid "劉小強"
msgstr "劉小強"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:294
msgid "功能權限"
msgstr "功能權限"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:219
msgid "功能權限的選單數量超出上限"
msgstr "功能權限的選單數量超出上限"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:229
msgid "功能開發中"
msgstr "功能開發中"

#: apps/dp-client/src/screens/account/pages/profile/index.tsx:331
msgid "功能開發中..."
msgstr "功能開發中..."

#. placeholder {0}: targetTier.imageCount
#: apps/dp-client/src/hooks/tasks/useTaskRewardHint.ts:88
msgid "加{0}張圖，可得"
msgstr "加{0}張圖，可得"

#: apps/dp-business/src/pages/Onboarding/index.tsx:70
msgid "加入去哪吃"
msgstr "加入去哪吃"

#: apps/dp-client/src/screens/account/pages/user-profile/pages/permission-settings/index.tsx:82
msgid "加入封鎖清單"
msgstr "加入封鎖清單"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:131
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:185
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:211
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:275
msgid "加入活動"
msgstr "加入活動"

#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewEditorToolbar.tsx:80
msgid "加入菜品"
msgstr "加入菜品"

#. placeholder {0}: userPoints.pointsToNextStage
#. placeholder {1}: userPoints.nextStageCoins
#: apps/dp-client/src/screens/diary/pages/my/components/TabSwitch.tsx:151
msgid "加油，只差<0>{0}積分</0>，就可再獲得<1>{1}遠傳幣</1>"
msgstr "加油，只差<0>{0}積分</0>，就可再獲得<1>{1}遠傳幣</1>"

#: apps/dp-client/src/screens/home/pages/ShareKing/components/WinningList/index.tsx:164
msgid "加油！活動正在進行中"
msgstr "加油！活動正在進行中"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/chainReportFilterFields.ts:50
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:32
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:41
#: apps/dp-admin/src/pages/marketing/services/constants.ts:259
msgid "加盟"
msgstr "加盟"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:69
msgid "加盟店"
msgstr "加盟店"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:429
msgid "加碼結帳折扣："
msgstr "加碼結帳折扣："

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:485
msgid "加碼結帳折扣（1-100整數）"
msgstr "加碼結帳折扣（1-100整數）"

#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:108
msgid "加粗"
msgstr "加粗"

#: apps/dp-client/src/screens/reservation/pages/main/hooks/useReservation.ts:206
#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:196
#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:165
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:714
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:1017
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:285
#: apps/dp-client/src/screens/account/pages/notifications/components/BaseNotificationList/index.tsx:72
#: apps/dp-client/src/screens/account/pages/likes/components/ReviewContent/index.tsx:245
#: apps/dp-client/src/screens/account/pages/likes/components/NotesContent/index.tsx:205
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowListScene.tsx:107
#: apps/dp-client/src/screens/account/pages/favorites/components/NotesContent/index.tsx:143
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:662
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:155
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/CouponDetailModal/index.web.tsx:109
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/CouponDetailModal/index.web.tsx:119
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:964
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:273
msgid "加載中..."
msgstr "加載中..."

#: apps/dp-client/src/screens/home/pages/Ranking/RankRule/index.tsx:34
#: apps/dp-client/src/screens/account/pages/coupon/GiftRuleOfPackage/index.tsx:97
#: apps/dp-client/src/screens/account/pages/coupon/GiftRule/index.tsx:107
msgid "加載內容失敗，請稍後重試"
msgstr "加載內容失敗，請稍後重試"

#: apps/dp-business/src/pages/ChainDashboard/components/ChainErrorState.tsx:39
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:314
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedMallTable/index.web.tsx:155
msgid "加載失敗，請重試"
msgstr "加載失敗，請重試"

#: apps/dp-client/src/screens/home/pages/UserGift/components/ShopListSection/index.tsx:642
msgid "加載失敗:{searchError}"
msgstr "載入失敗:{searchError}"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:130
msgid "加載數據失敗"
msgstr "加載數據失敗"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:2115
msgid "加載更多"
msgstr "加載更多"

#: apps/dp-client/src/screens/home/pages/UserGift/components/ShopListSection/index.tsx:616
#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/index.tsx:300
msgid "加載更多..."
msgstr "加載更多..."

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:140
msgid "加載更多失敗"
msgstr "加載更多失敗"

#: apps/dp-client/src/store/couponStore.ts:322
msgid "加載更多套餐券失敗"
msgstr "載入更多套餐券失敗"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:229
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:234
msgid "加載桌位數據失敗"
msgstr "加載桌位數據失敗"

#: apps/dp-business/src/store/TableContext.tsx:312
#: apps/dp-business/src/store/TableContext.tsx:315
#: apps/dp-business/src/pages/TableManagement/index.tsx:163
#: apps/dp-business/src/pages/TableManagement/index.tsx:166
msgid "加載桌型數據失敗"
msgstr "加載桌型數據失敗"

#: apps/dp-business/src/pages/Settings/index.tsx:86
msgid "加載設置失敗"
msgstr "加載設置失敗"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:296
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:157
msgid "動"
msgstr "動"

#: apps/dp-admin/src/pages/org-tree/org-list/components/ShelfHistoryModal/index.web.tsx:57
msgid "動作"
msgstr "動作"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:330
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:302
msgid "動作類型"
msgstr "動作類型"

#: apps/dp-business/src/components/ImageEditorModal/index.tsx:78
msgid "動圖不支援靜態裁剪，請上傳所需比例的動圖以保留動畫效果"
msgstr "動圖不支援靜態裁剪，請上傳所需比例的動圖以保留動畫效果"

#: apps/dp-admin/src/pages/marketing/components/CombinedListForm/index.web.tsx:188
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:26
msgid "動態"
msgstr "動態"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/DynamicPackageFields/index.web.tsx:45
msgid "動態全部套餐將持續匹配當前所有可售套餐"
msgstr "動態全部套餐將持續匹配當前所有可售套餐"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/SaveModeSelector/index.web.tsx:42
#: apps/dp-admin/src/modules/constants/userGroup.ts:20
msgid "動態名單"
msgstr "動態名單"

#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:23
msgid "動態商家名單"
msgstr "動態商家名單"

#: apps/dp-client/src/screens/home/pages/Home/components/ReviewSection/index.tsx:38
msgid "動態圈"
msgstr "動態圈"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:133
msgid "動態圈選請選擇全部套餐或至少配置一項條件"
msgstr "動態圈選請選擇全部套餐或至少配置一項條件"

#: apps/dp-business/src/pages/MenuItemForm.tsx:528
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:472
msgid "動態圖片"
msgstr "動態圖片"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:116
msgid "動態圖片：GIF，1125×2400（9:16），時長 3s–5s，文件大小 ≤ 500KB"
msgstr "動態圖片：GIF，1125×2400（9:16），時長 3s–5s，文件大小 ≤ 500KB"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:75
msgid "動態圖片（GIF）文件大小不能超過 500KB"
msgstr "動態圖片（GIF）文件大小不能超過 500KB"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:214
msgid "動態圖片上傳失敗"
msgstr "動態圖片上傳失敗"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:219
msgid "動態圖片上傳失敗！"
msgstr "動態圖片上傳失敗！"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:212
msgid "動態圖片上傳成功！"
msgstr "動態圖片上傳成功！"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:232
msgid "動態圖片已刪除"
msgstr "動態圖片已刪除"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:25
msgid "動態用戶名單"
msgstr "動態用戶名單"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageSourceField/index.web.tsx:143
msgid "動態篩選"
msgstr "動態篩選"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/DynamicPackageFields/index.web.tsx:49
msgid "動態篩選條件"
msgstr "動態篩選條件"

#: apps/dp-business/src/pages/MenuManagement.tsx:634
msgid "動態餐點圖片"
msgstr "動態餐點圖片"

#: apps/dp-business/src/store/HolidayContext.tsx:132
#: apps/dp-business/src/store/HolidayContext.tsx:132
#: apps/dp-business/src/store/HolidayContext.tsx:150
#: apps/dp-business/src/store/HolidayContext.tsx:150
msgid "勞動"
msgstr "勞動"

#: apps/dp-business/src/store/HolidayContext.tsx:133
#: apps/dp-business/src/store/HolidayContext.tsx:201
msgid "勞動節"
msgstr "勞動節"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:251
msgid "勾選後，可關聯樓層/排"
msgstr "勾選後，可關聯樓層/排"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:286
msgid "勿擾設置"
msgstr "勿擾設置"

#: apps/dp-admin/src/modules/constants/userGroup.ts:124
msgid "包含"
msgstr "包含"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:148
msgid "包含上下限"
msgstr "包含上下限"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:123
msgid "包含券"
msgstr "包含券"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/ShopClosedImpactModal/index.web.tsx:64
msgid "包含套餐券如下（已上架且無其他適用店家的套餐券）："
msgstr "包含套餐券如下（已上架且無其他適用店家的套餐券）："

#: apps/dp-business/src/pages/OrderList/index.tsx:782
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:884
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:968
msgid "包含平台補貼"
msgstr "包含平台補貼"

#. placeholder {0}: formatCurrency(priceWithServiceFee)
#. placeholder {0}: formatCurrency(basePrice, { noSpace: false })
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:309
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:167
msgid "包含服務費後套餐原價：{0}"
msgstr "包含服務費後套餐原價：{0}"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:113
msgid "包含複雜內容的面板"
msgstr "包含複雜內容的面板"

#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:245
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:245
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:588
msgid "包廂"
msgstr "包廂"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1109
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:397
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:251
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:280
msgid "包廂不可用"
msgstr "包廂不可用"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:203
msgid "包廂使用"
msgstr "包廂使用"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1108
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:397
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:251
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:280
msgid "包廂可以使用"
msgstr "包廂可以使用"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:48
msgid "包括姓名、電子郵件地址、電話號碼、郵寄地址等。"
msgstr "包括姓名、電子郵件地址、電話號碼、郵寄地址等。"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:64
msgid "包括您如何使用我們的服務、訪問時間和瀏覽的頁面。"
msgstr "包括您如何使用我們的服務、訪問時間和瀏覽的頁面。"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:60
msgid "包括您的IP地址、瀏覽器類型、作業系統和設備標識符。"
msgstr "包括您的IP地址、瀏覽器類型、作業系統和設備標識符。"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:52
msgid "包括您的用戶名、密碼和帳戶偏好設置。"
msgstr "包括您的用戶名、密碼和帳戶偏好設定。"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:56
msgid "包括您的購買歷史、支付方式和帳單資訊。"
msgstr "包括您的購買歷史、支付方式和帳單資訊。"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:135
msgid "包間"
msgstr "包間"

#: apps/dp-business/src/store/TableContext.tsx:57
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:414
msgid "包間1"
msgstr "包間1"

#: apps/dp-business/src/store/TableContext.tsx:66
msgid "包間2"
msgstr "包間2"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:137
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:419
msgid "包間A"
msgstr "包間A"

#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:426
msgid "包間B"
msgstr "包間B"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:578
msgid "北京"
msgstr "北京"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:43
msgid "北京市"
msgstr "北京市"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:91
msgid "北區"
msgstr "北區"

#: apps/dp-business/src/data/regions.ts:44
msgid "北投區"
msgstr "北投區"

#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:161
#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:97
msgid "匯入失敗"
msgstr "匯入失敗"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:239
msgid "匯入失敗，請修正後重新上傳"
msgstr "匯入失敗，請修正後重新上傳"

#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:159
msgid "匯入完成"
msgstr "匯入完成"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:213
msgid "匯入結果"
msgstr "匯入結果"

#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:78
msgid "匯入類型"
msgstr "匯入類型"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:66
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:243
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:361
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/index.web.tsx:324
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:284
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:177
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:362
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:704
#: apps/dp-admin/src/pages/marketing/components/DiscountOrderListSection/index.web.tsx:110
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:372
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:361
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:109
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:182
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:385
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:572
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:252
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:378
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:388
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:366
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:317
msgid "匯出"
msgstr "匯出"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:190
msgid "匯出券碼"
msgstr "匯出券碼"

#: apps/dp-business/src/servers/chain/reportApi.ts:71
#: apps/dp-business/src/pages/ChainDashboard/components/reports/useChainReport.ts:183
#: apps/dp-business/src/pages/ChainDashboard/components/reports/useChainReport.ts:186
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:177
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:237
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:241
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/useLotteryWinnersExport.ts:35
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/useLotteryWinnersExport.ts:47
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:133
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:61
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:244
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:255
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:259
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:275
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:286
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:290
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:98
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:102
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:382
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:393
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:397
msgid "匯出失敗"
msgstr "匯出失敗"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:225
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:366
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:234
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:62
#: apps/dp-admin/src/modules/http/download.ts:38
msgid "匯出失敗，請稍後再試"
msgstr "匯出失敗，請稍後再試"

#: apps/dp-admin/src/pages/marketing/activity-statistics/services/hooks.ts:217
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/hooks.ts:234
msgid "匯出失敗，請稍後重試"
msgstr "匯出失敗，請稍後重試"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:250
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:256
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:413
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:419
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:554
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:560
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/useLotteryWinnersExport.ts:39
msgid "匯出失敗，請重試"
msgstr "匯出失敗，請重試"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/PackageTemplateSection/index.web.tsx:52
msgid "匯出套餐券"
msgstr "匯出套餐券"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1114
msgid "匯出套餐券訂單失敗"
msgstr "匯出套餐券訂單失敗"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/index.web.tsx:148
msgid "匯出店家"
msgstr "匯出店家"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/useChainReport.ts:181
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:224
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:176
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:255
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:418
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:559
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:235
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/useLotteryWinnersExport.ts:46
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:129
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:365
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:233
msgid "匯出成功"
msgstr "匯出成功"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1174
msgid "匯出折扣券訂單失敗"
msgstr "匯出折扣券訂單失敗"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterBar.tsx:107
msgid "匯出數據"
msgstr "匯出數據"

#: apps/dp-admin/src/pages/split-account/invoice-list/index.web.tsx:51
msgid "匯出查詢發票"
msgstr "匯出查詢發票"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/CheckoutDiscountOrderSection/index.web.tsx:73
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/OrderListTab.web.tsx:56
#: apps/dp-admin/src/pages/marketing/activity-statistics/index.web.tsx:159
msgid "匯出訂單"
msgstr "匯出訂單"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:360
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:425
msgid "匯出資料"
msgstr "匯出資料"

#: apps/dp-client/src/screens/home/pages/UserGift/index.tsx:396
#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:1788
#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:538
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:899
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/CommentSection.tsx:102
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:355
#: apps/dp-client/src/screens/home/pages/Note/components/ReviewCard/index.tsx:89
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:325
#: apps/dp-client/src/screens/diary/pages/plaza/index.tsx:31
#: apps/dp-client/src/screens/diary/pages/my/hooks.ts:128
#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:360
#: apps/dp-client/src/screens/diary/pages/detail/hooks/useComments.ts:88
#: apps/dp-client/src/screens/diary/pages/detail/hooks/useComments.ts:196
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:116
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:143
#: apps/dp-business/src/pages/CustomerReviews/index.tsx:257
#: apps/dp-business/src/pages/ComplaintList/index.tsx:261
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:115
#: apps/dp-admin/src/pages/data-center/review-detail/services/hooks.ts:46
#: apps/dp-admin/src/pages/data-center/components/ReviewItem.web.tsx:239
msgid "匿名用戶"
msgstr "匿名用戶"

#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:461
#: apps/dp-admin/src/pages/merchant/information-review/index.web.tsx:118
msgid "區域"
msgstr "區域"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1018
msgid "區域 "
msgstr "區域 "

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:39
msgid "區域名稱"
msgstr "區域名稱"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:130
msgid "區縣"
msgstr "區縣"

#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:23
msgid "十"
msgstr "十"

#: apps/dp-business/src/types/orderFilter.ts:195
#: apps/dp-business/src/store/ReservationRulesContext.tsx:78
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:475
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:418
#: apps/dp-business/src/constants/enums.ts:36
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:261
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1252
#: apps/dp-admin/src/components/BusinessHours/constants.ts:29
msgid "午餐"
msgstr "午餐"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:122
msgid "午餐時段"
msgstr "午餐時段"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:32
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:24
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:369
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:459
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:159
#: apps/dp-admin/src/components/MapPicker/index.web.tsx:617
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:24
msgid "半徑"
msgstr "半徑"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:658
msgid "半徑（公尺）"
msgstr "半徑（公尺）"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:115
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:144
msgid "半徑（米）"
msgstr "半徑（米）"

#: apps/dp-client/src/screens/login/components/fet-login-agreement-modal/index.tsx:110
#: apps/dp-client/src/screens/account/pages/agreement/index.tsx:27
#: apps/dp-client/src/configs/page-configs.tsx:2047
msgid "協議內容"
msgstr "協議內容"

#: apps/dp-business/src/data/regions.ts:19
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:26
msgid "南投"
msgstr "南投"

#: apps/dp-business/src/data/regions.ts:46
msgid "南港區"
msgstr "南港區"

#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:63
msgid "卡片"
msgstr "卡片"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:368
msgid "卡片副標題"
msgstr "卡片副標題"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:356
msgid "卡片副標題（多權益必填）"
msgstr "卡片副標題（多權益必填）"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:271
msgid "卡片按鈕文字"
msgstr "卡片按鈕文字"

#: apps/dp-client/src/utils/businessStatus.ts:209
#: apps/dp-client/src/screens/home/utils/businessStatus.ts:22
#: apps/dp-client/src/screens/home/utils/businessStatus.ts:268
msgid "即將休息"
msgstr "即將休息"

#. placeholder {0}: result.closingTime
#: apps/dp-client/src/screens/home/utils/businessStatus.ts:269
msgid "即將休息 將於{0}關門"
msgstr "即將休息 將於{0}關門"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/utils/activityUtils.ts:38
#: apps/dp-admin/src/modules/constants/options.ts:482
msgid "即將報名結束"
msgstr "即將報名結束"

#: apps/dp-admin/src/pages/merchant/brand-list/components/EnableBrandModal/index.web.tsx:76
msgid "即將啟用品牌「{brandName}」，啟用後該品牌恢復可用狀態。"
msgstr "即將啟用品牌「{brandName}」，啟用後該品牌恢復可用狀態。"

#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:84
msgid "即將禁用品牌「{brandName}」，禁用後該品牌將不可使用，是否確認禁用？"
msgstr "即將禁用品牌「{brandName}」，禁用後該品牌將不可使用，是否確認禁用？"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/constants.ts:14
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:124
msgid "即將超時"
msgstr "即將超時"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:110
#: apps/dp-business/src/constants/enums.ts:476
msgid "即將開幕"
msgstr "即將開幕"

#: apps/dp-client/src/utils/businessStatus.ts:238
#: apps/dp-client/src/screens/home/utils/businessStatus.ts:26
msgid "即將開業"
msgstr "即將開業"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:52
msgid "即將關閉"
msgstr "即將關閉"

#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:36
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:33
msgid "即時發送"
msgstr "即時發送"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2488
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2536
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:395
msgid "即時預覽"
msgstr "即時預覽"

#: apps/dp-business/src/data/categories.ts:160
msgid "卷壽司"
msgstr "卷壽司"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:676
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:786
#: apps/dp-business/src/pages/OrderList/index.tsx:523
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:137
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:83
#: apps/dp-business/src/pages/OrderDetail/index.tsx:811
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1145
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1562
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1726
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:454
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:375
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:235
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:437
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:111
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:92
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:477
msgid "原價"
msgstr "原價"

#. placeholder {0}: data.includeServiceFeeRate ?? 0
#. placeholder {0}: d.serviceFeeRate ?? 0
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:374
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:476
msgid "原價（包含{0}%服務費）"
msgstr "原價（包含{0}%服務費）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:103
msgid "原兩側名下的店家權限會合併，登入後看到的店家數據可能與合併前任一側單獨登入時不同；"
msgstr "原兩側名下的店家權限會合併，登入後看到的店家數據可能與合併前任一側單獨登入時不同；"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1268
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:525
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:589
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:30
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:793
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:264
msgid "原因"
msgstr "原因"

#: apps/dp-admin/src/pages/merchant/brand-list/components/EnableBrandModal/index.web.tsx:90
#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:98
msgid "原因不能以空格開頭或結尾"
msgstr "原因不能以空格開頭或結尾"

#: apps/dp-admin/src/pages/merchant/brand-list/components/EnableBrandModal/index.web.tsx:87
#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:95
msgid "原因不能超過200個字符"
msgstr "原因不能超過200個字符"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/Details.web.tsx:112
msgid "原因說明"
msgstr "原因說明"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:77
msgid "原圖"
msgstr "原圖"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:147
msgid "原始："
msgstr "原始："

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:192
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CurrentCommissionCard.web.tsx:57
msgid "原始佣金比例"
msgstr "原始佣金比例"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:526
msgid "原始佣金率"
msgstr "原始佣金率"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:215
msgid "原始佣金率:"
msgstr "原始佣金率:"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:743
msgid "原始時間"
msgstr "原始時間"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/OriginalReviewSection/index.web.tsx:66
msgid "原始評價"
msgstr "原始評價"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:503
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:133
msgid "原始金額"
msgstr "原始金額"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:102
msgid "原為店家自行結算，只能選本樹的結算節點"
msgstr "原為店家自行結算，只能選本樹的結算節點"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:644
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:699
msgid "去上傳ERP"
msgstr "去上傳ERP"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:334
msgid "去下單"
msgstr "去下單"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:513
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:609
#: apps/dp-client/src/components/CouponCard/index.tsx:437
msgid "去使用"
msgstr "去使用"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:213
msgid "去使用跳轉配置"
msgstr "去使用跳轉配置"

#: apps/dp-client/src/screens/diary/components/PointsStatus.tsx:78
msgid "去修改"
msgstr "去修改"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:291
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:148
msgid "去停車"
msgstr "去停車"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:408
#: apps/dp-client/src/hooks/tasks/useTaskRewardFeedback.ts:91
msgid "去兌換"
msgstr "去兌換"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:333
msgid "去分享"
msgstr "去分享"

#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:285
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:139
#: apps/dp-admin/src/pages/marketing/services/constants.ts:131
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:94
msgid "去哪吃"
msgstr "去哪吃"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/AppPushTemplateSection.web.tsx:12
msgid "去哪吃App Push 模板"
msgstr "去哪吃App Push 模板"

#: apps/dp-admin/src/components/ClientVersionDropdown/index.web.tsx:146
msgid "去哪吃C端版本：{version}"
msgstr "去哪吃C端版本：{version}"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:1621
msgid "去哪吃人氣好評獎"
msgstr "去哪吃人氣好評獎"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:33
msgid "去哪吃僅提供美食與餐廳體驗分享相關內容之張貼："
msgstr "去哪吃僅提供美食與餐廳體驗分享相關內容之張貼："

#: apps/dp-business/src/pages/MerchantDashboard/MobileLayout.tsx:267
msgid "去哪吃完整版"
msgstr "去哪吃完整版"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:47
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:223
msgid "去哪吃平台ID"
msgstr "去哪吃平台ID"

#: apps/dp-business/src/components/ClaimAmountAlert/index.tsx:38
msgid "去哪吃平台保留修改、暫停或終止上述請款規範之權利。如有異動將以平台公佈內容為主。"
msgstr "去哪吃平台保留修改、暫停或終止上述請款規範之權利。如有異動將以平台公佈內容為主。"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:185
msgid "去哪吃會員"
msgstr "去哪吃會員"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:55
msgid "去哪吃服務載具"
msgstr "去哪吃服務載具"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:131
msgid "去哪吃版本號 :"
msgstr "去哪吃版本號 :"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/InAppTemplateSection.web.tsx:12
msgid "去哪吃站內信模板"
msgstr "去哪吃站內信模板"

#: apps/dp-business/src/pages/SimpleDashboard/SimpleLayout.tsx:121
msgid "去哪吃簡易版"
msgstr "去哪吃簡易版"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:31
msgid "去哪吃自增長"
msgstr "去哪吃自增長"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:338
msgid "去回答"
msgstr "去回答"

#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:98
#: apps/dp-client/src/screens/account/pages/task-wall/components/OnboardingTaskSection/index.tsx:124
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:339
msgid "去完成"
msgstr "去完成"

#: apps/dp-business/src/utils/dateRange.ts:143
msgid "去年"
msgstr "去年"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:331
msgid "去打卡"
msgstr "去打卡"

#: apps/dp-client/src/screens/home/pages/PackageZone/components/PackageZoneShopSheet/index.tsx:110
msgid "去搶購"
msgstr "去搶購"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:329
msgid "去收藏"
msgstr "去收藏"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:837
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1049
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:335
msgid "去核銷"
msgstr "去核銷"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:337
msgid "去瀏覽"
msgstr "去瀏覽"

#: apps/dp-client/src/screens/account/pages/profile/components/UserInfoSection/index.tsx:83
#: apps/dp-client/src/screens/account/pages/profile/components/UserInfoSection/index.tsx:83
msgid "去登入"
msgstr "去登入"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:332
msgid "去發布"
msgstr "去發布"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:330
msgid "去簽到"
msgstr "去簽到"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:199
msgid "去簽約"
msgstr "去簽約"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:398
msgid "去結帳"
msgstr "去結帳"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:706
msgid "去維護"
msgstr "去維護"

#: apps/dp-client/src/screens/home/pages/Review/pages/draft/index.tsx:89
msgid "去編輯"
msgstr "去編輯"

#: apps/dp-client/src/utils/permission.ts:58
#: apps/dp-client/src/utils/permission.ts:67
#: apps/dp-client/src/utils/permission.ts:76
#: apps/dp-client/src/utils/permission.ts:85
#: apps/dp-business/src/utils/passwordManager.ts:410
msgid "去設定"
msgstr "去設定"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:1237
#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:124
msgid "去設置"
msgstr "去設置"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:340
msgid "去註冊"
msgstr "去註冊"

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:310
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:616
msgid "去評論"
msgstr "去評論"

#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:607
msgid "去認領"
msgstr "去認領"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementPanel.tsx:103
msgid "去請款"
msgstr "去請款"

#: apps/dp-client/src/screens/account/pages/profile/components/TaskWallEntry/index.tsx:88
msgid "去賺點數"
msgstr "去賺點數"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/LandingUrlField.web.tsx:42
msgid "去配置"
msgstr "去配置"

#: apps/dp-business/src/utils/passwordManager.ts:181
msgid "去開啟"
msgstr "去開啟"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1082
msgid "去開通結帳服務！參與更多活動"
msgstr "去開通結帳服務！參與更多活動"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:336
msgid "去關注"
msgstr "去關注"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallIntro/index.tsx:61
msgid "參加先領{claimRewardPoint}點"
msgstr "參加先領{claimRewardPoint}點"

#: apps/dp-client/src/screens/diary/components/SharedButton/index.tsx:79
msgid "參加活動"
msgstr "參加活動"

#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:49
msgid "參加資格"
msgstr "參加資格"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:266
msgid "參數 key，例如：searchIndex"
msgstr "參數 key，例如：searchIndex"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:109
msgid "參數 key【{key}】重複，請檢查後重新提交"
msgstr "參數 key【{key}】重複，請檢查後重新提交"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:275
msgid "參數 value，例如：shop_wide_doc_v6_test 或 [10001,10002]"
msgstr "參數 value，例如：shop_wide_doc_v6_test 或 [10001,10002]"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:118
msgid "參數【{key}】的 value 不是合法 JSON，請檢查格式"
msgstr "參數【{key}】的 value 不是合法 JSON，請檢查格式"

#: apps/dp-client/src/screens/reservation/pages/main/hooks/useReservation.ts:358
#: apps/dp-client/src/screens/reservation/pages/main/hooks/useReservation.ts:430
msgid "參數不完整"
msgstr "參數不完整"

#: apps/dp-client/src/screens/home/pages/MerchantGroup/index.tsx:129
msgid "參數錯誤"
msgstr "參數錯誤"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:471
msgid "參與中"
msgstr "參與中"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:364
msgid "參與商家"
msgstr "參與商家"

#: apps/dp-admin/src/pages/marketing/activity-detail-list/index.web.tsx:74
msgid "參與商家列表"
msgstr "參與商家列表"

#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:145
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:126
msgid "參與商家數量"
msgstr "參與商家數量"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:132
msgid "參與城市"
msgstr "參與城市"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:325
msgid "參與明細"
msgstr "參與明細"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:319
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:159
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:239
msgid "參與時間"
msgstr "參與時間"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:23
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:32
#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:73
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:58
msgid "參與活動"
msgstr "參與活動"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:931
msgid "參與活動需要填寫相關資訊，具體要求請查看報名錶單"
msgstr "參與活動需要填寫相關資訊，具體要求請查看報名表單"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:99
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:81
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:204
msgid "參與狀態"
msgstr "參與狀態"

#. placeholder {0}: campaignDetail.participationStatusDescription
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:167
msgid "參與狀態：{0}"
msgstr "參與狀態：{0}"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/index.web.tsx:48
msgid "參與用戶"
msgstr "參與用戶"

#: apps/dp-admin/src/pages/marketing/activity-detail-list/index.web.tsx:76
msgid "參與用戶列表"
msgstr "參與用戶列表"

#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:155
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:136
msgid "參與用戶數量"
msgstr "參與用戶數量"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:215
msgid "參與結算金額"
msgstr "參與結算金額"

#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:99
msgid "參與訂單數"
msgstr "參與訂單數"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:160
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFilter.tsx:85
msgid "參與門檻"
msgstr "參與門檻"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:513
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:902
msgid "友善發言，期待你的回覆"
msgstr "友善發言，期待你的回覆"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1492
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2397
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:811
msgid "反核銷"
msgstr "反核銷"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1316
msgid "反核銷失敗"
msgstr "反核銷失敗"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1320
msgid "反核銷失敗，請稍後重試"
msgstr "反核銷失敗，請稍後重試"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1308
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:163
msgid "反核銷成功"
msgstr "反核銷成功"

#: apps/dp-business/src/servers/order/api.ts:295
msgid "反核銷訂單失敗"
msgstr "反核銷訂單失敗"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:107
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:140
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:152
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:197
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ActualManagerCard.web.tsx:79
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/OwnerInfo/index.web.tsx:71
msgid "反面"
msgstr "反面"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:644
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:688
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:392
msgid "反饋成功"
msgstr "反饋成功"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:150
#: apps/dp-client/src/screens/account/components/feedback-modal/index.tsx:73
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:160
msgid "反饋方式"
msgstr "反饋方式"

#: apps/dp-business/src/servers/shop/api.ts:540
msgid "取得BD資訊失敗"
msgstr "取得BD資訊失敗"

#: apps/dp-business/src/pages/VerifyEmail/index.tsx:117
msgid "取得Email失敗"
msgstr "取得Email失敗"

#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:148
msgid "取得上傳歷史失敗"
msgstr "取得上傳歷史失敗"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:256
msgid "取得任務列表失敗"
msgstr "取得任務列表失敗"

#: apps/dp-client/src/screens/diary/pages/merchant/index.tsx:101
msgid "取得任務列表失敗，請稍後重試"
msgstr "取得任務列表失敗，請稍後重試"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:263
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/index.web.tsx:317
msgid "取得任務列表錯誤"
msgstr "取得任務列表錯誤"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/index.web.tsx:313
msgid "取得任務清單失敗，請重新進入"
msgstr "取得任務清單失敗，請重新進入"

#: apps/dp-admin/src/pages/merchant/task-detail/index.web.tsx:51
#: apps/dp-admin/src/pages/merchant/task-detail/index.web.tsx:55
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:62
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:66
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:58
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:62
msgid "取得任務詳情失敗"
msgstr "取得任務詳情失敗"

#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:149
msgid "取得任務資訊失敗，請稍後重試"
msgstr "取得任務資訊失敗，請稍後重試"

#: apps/dp-client/src/hooks/useCurrentLocation.ts:103
#: apps/dp-business/src/utils/location.ts:253
#: apps/dp-business/src/contexts/LocationContext.tsx:87
#: apps/dp-business/src/components/GoogleMap/index.tsx:913
#: apps/dp-business/src/components/GoogleMap/WebViewMap.tsx:687
msgid "取得位置失敗"
msgstr "取得位置失敗"

#: apps/dp-business/src/utils/location.ts:266
#: apps/dp-business/src/utils/location.ts:392
msgid "取得位置失敗，請檢查網路連線或GPS設定"
msgstr "取得位置失敗，請檢查網路連線或GPS設定"

#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:95
msgid "取得位置失敗，請稍後重試"
msgstr "取得定位失敗，請稍後重試"

#: apps/dp-business/src/utils/cache.ts:234
#: apps/dp-business/src/servers/photo/api.ts:54
msgid "取得位置標籤失敗"
msgstr "取得位置標籤失敗"

#: apps/dp-admin/src/modules/hooks/useGeolocation.ts:170
#: apps/dp-admin/src/modules/hooks/useGeolocation.ts:233
msgid "取得位置資訊失敗"
msgstr "取得位置資訊失敗"

#: apps/dp-client/src/hooks/useCurrentLocation.ts:113
msgid "取得位置超時"
msgstr "取得定位超時"

#: apps/dp-business/src/utils/location.ts:202
#: apps/dp-business/src/utils/location.ts:234
#: apps/dp-business/src/utils/location.ts:263
#: apps/dp-business/src/utils/location.ts:333
msgid "取得位置超時，請稍後再試"
msgstr "取得位置超時，請稍後再試"

#: apps/dp-business/src/servers/chain/accountApi.ts:117
msgid "取得使用者列表失敗"
msgstr "取得使用者列表失敗"

#: apps/dp-business/src/servers/permission/api.ts:455
msgid "取得使用者權限樹失敗"
msgstr "取得使用者權限樹失敗"

#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:482
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:487
msgid "取得優惠券資訊失敗"
msgstr "取得優惠券資訊失敗"

#: apps/dp-client/src/store/couponStore.ts:463
msgid "取得最優組合失敗"
msgstr "取得最優折扣失敗"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:143
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:161
msgid "取得分配歷史失敗，請重試"
msgstr "取得分配歷史失敗，請重試"

#: apps/dp-admin/src/pages/marketing/activity-config-list/services/couponCodes.ts:110
msgid "取得券碼摘要失敗"
msgstr "取得券碼摘要失敗"

#: apps/dp-business/src/servers/location/api.ts:26
msgid "取得區域樹狀資料失敗"
msgstr "取得區域樹狀資料失敗"

#: apps/dp-business/src/hooks/useRegion.ts:42
msgid "取得區域資料失敗"
msgstr "取得區域資料失敗"

#: apps/dp-business/src/servers/shop/api.ts:293
#: apps/dp-admin/src/pages/merchant/brand-list/services/hooks.ts:105
msgid "取得品牌列表失敗"
msgstr "取得品牌列表失敗"

#: apps/dp-admin/src/pages/merchant/brand-list/services/hooks.ts:109
msgid "取得品牌列表失敗，請稍後重試"
msgstr "取得品牌列表失敗，請稍後重試"

#: apps/dp-business/src/pages/UserManagement/index.tsx:214
#: apps/dp-business/src/pages/UserManagement/index.tsx:220
msgid "取得員工列表失敗"
msgstr "取得員工列表失敗"

#: apps/dp-client/src/store/shopStore.ts:629
msgid "取得商圈訊息失敗"
msgstr "取得商圈訊息失敗"

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:127
#: apps/dp-client/src/screens/diary/pages/note/index.tsx:128
msgid "取得商家任務資訊失敗"
msgstr "取得商家任務資訊失敗"

#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/index.web.tsx:182
msgid "取得商家列表出錯"
msgstr "取得商家列表出錯"

#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/index.web.tsx:178
msgid "取得商家列表失敗"
msgstr "取得商家列表失敗"

#: apps/dp-business/src/servers/auth/api.ts:266
msgid "取得商家狀態失敗"
msgstr "取得商家狀態失敗"

#: apps/dp-business/src/servers/merchantReview/api.ts:74
msgid "取得商家申請詳情失敗"
msgstr "取得商家申請詳情失敗"

#: apps/dp-admin/src/pages/merchant/audit-detail/index.web.tsx:147
msgid "取得商家詳情失敗"
msgstr "取得商家詳情失敗"

#: apps/dp-admin/src/pages/merchant/audit-detail/index.web.tsx:151
msgid "取得商家詳情錯誤"
msgstr "取得商家詳情錯誤"

#: apps/dp-client/src/store/couponStore.ts:359
msgid "取得商家買單折扣失敗"
msgstr "取得商家買單折扣失敗"

#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:141
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:76
msgid "取得商家資訊失敗"
msgstr "取得商家資訊失敗"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1292
msgid "取得商家資訊失敗，請重新登入"
msgstr "取得商家資訊失敗，請重新登入"

#: apps/dp-business/src/utils/cache.ts:248
msgid "取得圖片類型失敗"
msgstr "取得圖片類型失敗"

#: apps/dp-client/src/store/regionStore.ts:76
#: apps/dp-client/src/screens/home/components/CitySelect/useRegion.ts:127
#: apps/dp-client/src/screens/diary/store/location.ts:519
msgid "取得地區資料失敗"
msgstr "取得地區資訊失敗"

#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:90
msgid "取得地址資訊失敗，請稍後重試"
msgstr "取得地址資訊失敗，請稍後重試"

#: apps/dp-client/src/store/rankingStore.ts:150
msgid "取得城市數據失敗"
msgstr "取得城市資訊失敗"

#: apps/dp-business/src/servers/chain/reportApi.ts:116
#: apps/dp-business/src/servers/chain/reportApi.ts:154
#: apps/dp-business/src/servers/chain/reportApi.ts:192
msgid "取得報表資料失敗"
msgstr "取得報表資料失敗"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/index.tsx:81
msgid "取得套餐券核銷明細失敗，請稍後重試"
msgstr "取得套餐券核銷明細失敗，請稍後重試"

#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/index.tsx:80
msgid "取得套餐券銷售訂單失敗，請稍後重試"
msgstr "取得套餐券銷售訂單失敗，請稍後重試"

#: apps/dp-business/src/servers/permission/api.ts:432
msgid "取得完整權限失敗"
msgstr "取得完整權限失敗"

#: apps/dp-client/src/screens/diary/store/location.ts:398
msgid "取得定位資訊失敗"
msgstr "取得定位資訊失敗"

#: apps/dp-admin/src/pages/audit-center/services/hooks/useAuditData.ts:208
msgid "取得審核任務列表失敗"
msgstr "取得審核任務列表失敗"

#: apps/dp-admin/src/pages/audit-center/services/hooks.ts:333
#: apps/dp-admin/src/pages/audit-center/services/hooks.ts:343
msgid "取得審核任務詳情失敗"
msgstr "取得審核任務詳情失敗"

#: apps/dp-admin/src/pages/audit-center/user-audit/services/hooks.ts:125
msgid "取得審核問題失敗"
msgstr "取得審核問題失敗"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:152
#: apps/dp-business/src/pages/MerchantReview/index.tsx:157
msgid "取得審核狀態失敗，請稍後重試"
msgstr "取得審核狀態失敗，請稍後重試"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:75
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/hooks.ts:85
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/hooks.ts:89
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/hooks.ts:45
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/hooks.ts:49
msgid "取得審核詳情失敗"
msgstr "取得審核詳情失敗"

#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:101
#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:107
msgid "取得帳號列表失敗"
msgstr "取得帳號列表失敗"

#: apps/dp-business/src/servers/permission/api.ts:264
#: apps/dp-business/src/pages/UserManagement/index.tsx:405
#: apps/dp-business/src/pages/UserManagement/index.tsx:412
msgid "取得帳號密碼失敗"
msgstr "取得帳號密碼失敗"

#: apps/dp-client/src/screens/diary/pages/search/index.tsx:130
#: apps/dp-business/src/servers/shop/api.ts:72
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:326
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:131
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:136
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:336
msgid "取得店家列表失敗"
msgstr "取得店家列表失敗"

#: apps/dp-client/src/store/shopStore.ts:464
msgid "取得店家照片失敗"
msgstr "取得店家照片失敗"

#: apps/dp-business/src/servers/photo/api.ts:32
msgid "取得店家照片類型失敗"
msgstr "取得店家照片類型失敗"

#: apps/dp-business/src/servers/shop/api.ts:315
msgid "取得店家狀態選項失敗"
msgstr "取得店家狀態選項失敗"

#: apps/dp-client/src/store/shopStore.ts:551
msgid "取得店家菜單失敗"
msgstr "取得店家菜單失敗"

#: apps/dp-business/src/servers/reviews/api.ts:40
msgid "取得店家評價清單失敗"
msgstr "取得店家評價清單失敗"

#: apps/dp-client/src/store/shopStore.ts:577
msgid "取得店家評論統計失敗"
msgstr "取得店家評論統計失敗"

#: apps/dp-client/src/store/shopStore.ts:242
#: apps/dp-business/src/servers/shop/api.ts:101
#: apps/dp-business/src/servers/chain/nodeApi.ts:335
msgid "取得店家詳情失敗"
msgstr "取得店家詳情失敗"

#: apps/dp-admin/src/pages/merchant/components/BdAssignmentField/index.web.tsx:122
msgid "取得影響範圍失敗，請稍後重試"
msgstr "取得影響範圍失敗，請稍後重試"

#: apps/dp-business/src/pages/VerifyPhone/index.tsx:116
msgid "取得手機號失敗"
msgstr "取得手機號失敗"

#: apps/dp-client/src/store/shopStore.ts:315
msgid "取得招牌菜失敗"
msgstr "取得招牌菜失敗"

#: apps/dp-client/src/screens/home/pages/Ranking/hooks/useRanking.ts:211
#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:172
msgid "取得排行榜資料失敗"
msgstr "取得排行榜資料失敗"

#: apps/dp-client/src/store/regionStore.ts:132
msgid "取得搜尋地區資料失敗"
msgstr "取得搜尋地區資料失敗"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:140
msgid "取得日記詳情失敗"
msgstr "取得日記詳情失敗"

#: apps/dp-business/src/servers/notification/api.ts:191
msgid "取得未讀消息數量失敗"
msgstr "取得未讀消息數量失敗"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:65
msgid "取得核銷詳情失敗，請稍後重試"
msgstr "取得核銷詳情失敗，請稍後重試"

#: apps/dp-business/src/servers/notification/api.ts:216
msgid "取得業務模塊未讀數量失敗"
msgstr "取得業務模組未讀數量失敗"

#: apps/dp-admin/src/modules/hooks/options/useTagOptions.ts:61
msgid "取得標籤選項出錯"
msgstr "取得標籤選項出錯"

#: apps/dp-admin/src/modules/hooks/options/useTagOptions.ts:57
msgid "取得標籤選項失敗"
msgstr "取得標籤選項失敗"

#: apps/dp-client/src/screens/diary/store/location.ts:542
msgid "取得歷史記錄失敗"
msgstr "取得歷史記錄失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:234
#: apps/dp-admin/src/pages/marketing/services/apis.ts:238
#: apps/dp-admin/src/pages/marketing/platform-activities/services/hooks.ts:92
msgid "取得活動列表失敗"
msgstr "取得活動列表失敗"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/services/hooks.ts:202
msgid "取得活動詳情失敗"
msgstr "取得活動詳情失敗"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/index.tsx:124
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:227
msgid "取得活動詳情失敗，請稍後重試"
msgstr "取得活動詳情失敗，請稍後重試"

#: apps/dp-client/src/screens/diary/store/activity.ts:121
#: apps/dp-client/src/screens/diary/pages/home/index.tsx:241
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:95
msgid "取得活動資訊失敗"
msgstr "取得活動資訊失敗"

#: apps/dp-client/src/screens/diary/pages/plaza/index.tsx:175
msgid "取得熱門日記失敗"
msgstr "取得熱門日記失敗"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:111
msgid "取得獎勵規則失敗"
msgstr "取得獎勵規則失敗"

#: apps/dp-admin/src/pages/marketing/activity-config-list/services/couponCodes.ts:128
msgid "取得生成批次失敗"
msgstr "取得生成批次失敗"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:98
msgid "取得用戶排名失敗"
msgstr "取得用戶排名失敗"

#: apps/dp-client/src/store/userStore.ts:146
#: apps/dp-business/src/servers/verification/api.ts:238
#: apps/dp-business/src/pages/MyProfile/index.tsx:73
#: apps/dp-business/src/pages/MyProfile/index.tsx:76
#: apps/dp-business/src/pages/EditUser/index.tsx:74
#: apps/dp-business/src/pages/EditUser/index.tsx:78
msgid "取得用戶資料失敗"
msgstr "取得用戶資料失敗"

#: apps/dp-client/src/store/userStore.ts:238
#: apps/dp-business/src/pages/SetPasswordPage/index.tsx:63
#: apps/dp-business/src/pages/ForgotPasswordPage/index.tsx:60
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:348
#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:65
#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:134
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/services/hooks.ts:29
#: apps/dp-admin/src/pages/audit-center/user-audit/services/hooks.ts:41
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:128
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:178
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:222
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:81
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:125
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:165
msgid "取得用戶資訊失敗"
msgstr "取得用戶資訊失敗"

#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:164
#: apps/dp-business/src/pages/CouponVerification/index.tsx:517
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:671
msgid "取得用戶資訊失敗，請重新登入"
msgstr "取得用戶資訊失敗，請重新登入"

#: apps/dp-client/src/store/invoiceStore.ts:90
msgid "取得發票抬頭列表失敗"
msgstr "取得發票抬頭列表失敗"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:366
msgid "取得發票抬頭詳情失敗"
msgstr "取得發票抬頭詳情失敗"

#: apps/dp-admin/src/pages/split-account/invoice-detail/services/hooks.ts:35
#: apps/dp-admin/src/pages/split-account/invoice-detail/services/hooks.ts:40
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:49
msgid "取得發票詳情失敗"
msgstr "取得發票詳情失敗"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:176
#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:177
msgid "取得第三方綁定清單失敗，請稍後重試"
msgstr "取得第三方綁定清單失敗，請稍後重試"

#: apps/dp-business/src/store/HolidayContext.tsx:314
msgid "取得節假日資料失敗"
msgstr "取得節假日資料失敗"

#: apps/dp-business/src/servers/chain/nodeApi.ts:255
#: apps/dp-business/src/servers/chain/nodeApi.ts:262
msgid "取得節點詳情失敗"
msgstr "取得節點詳情失敗"

#: apps/dp-business/src/servers/chain/nodeApi.ts:373
msgid "取得管轄商場失敗"
msgstr "取得管轄商場失敗"

#: apps/dp-business/src/servers/chain/nodeApi.ts:300
msgid "取得管轄店家失敗"
msgstr "取得管轄店家失敗"

#: apps/dp-business/src/servers/chain/reportApi.ts:92
msgid "取得篩選選項失敗"
msgstr "取得篩選選項失敗"

#: apps/dp-business/src/servers/contract-management/api.ts:47
msgid "取得簽約資訊失敗"
msgstr "取得簽約資訊失敗"

#: apps/dp-business/src/servers/chain/treeApi.ts:110
msgid "取得組織架構失敗"
msgstr "取得組織架構失敗"

#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/index.tsx:86
msgid "取得結帳折扣訂單失敗，請稍後重試"
msgstr "取得結帳折扣訂單失敗，請稍後重試"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:302
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:310
msgid "取得結算單交易列表失敗，請重試"
msgstr "取得結算單交易列表失敗，請重試"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:91
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:101
msgid "取得結算訂單列表失敗"
msgstr "取得結算訂單列表失敗"

#: apps/dp-admin/src/pages/marketing/activity-statistics/services/hooks.ts:80
msgid "取得統計數據失敗，請稍後重試"
msgstr "取得統計數據失敗，請稍後重試"

#: apps/dp-client/src/screens/diary/hooks/useEditData.ts:110
msgid "取得編輯資料失敗，請重試"
msgstr "取得編輯資料失敗，請重試"

#: apps/dp-client/src/store/shopStore.ts:349
msgid "取得菜品失敗"
msgstr "取得菜品失敗"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:373
msgid "取得菜單分類出錯，請重試"
msgstr "取得菜單分類出錯，請重試"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:367
msgid "取得菜單分類失敗，請重試"
msgstr "取得菜單分類失敗，請重試"

#: apps/dp-admin/src/contexts/AuthContext.tsx:139
msgid "取得菜單數據失敗，請重新登錄"
msgstr "取得菜單數據失敗，請重新登錄"

#: apps/dp-business/src/servers/menu/api.ts:34
msgid "取得菜單管理資訊失敗"
msgstr "取得菜單管理資訊失敗"

#: apps/dp-business/src/pages/MenuManagement.tsx:324
#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:227
#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:231
msgid "取得菜單資料失敗"
msgstr "取得菜單資料失敗"

#: apps/dp-business/src/servers/permission/api.ts:175
msgid "取得角色下拉清單失敗"
msgstr "取得角色下拉清單失敗"

#: apps/dp-business/src/servers/chain/roleApi.ts:94
#: apps/dp-business/src/pages/PermissionManagement/index.tsx:68
#: apps/dp-business/src/pages/PermissionManagement/index.tsx:74
#: apps/dp-business/src/pages/AddUser/index.tsx:70
#: apps/dp-business/src/pages/AddUser/index.tsx:74
msgid "取得角色列表失敗"
msgstr "取得角色列表失敗"

#: apps/dp-business/src/pages/AddRole/index.tsx:99
#: apps/dp-business/src/pages/AddRole/index.tsx:106
msgid "取得角色詳情失敗"
msgstr "取得角色詳情失敗"

#: apps/dp-business/src/pages/OrderList/index.tsx:188
msgid "取得訂單明細失敗，請稍後重試"
msgstr "取得訂單明細失敗，請稍後重試"

#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:112
msgid "取得訂單詳情出錯"
msgstr "取得訂單詳情出錯"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:200
#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:80
#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:101
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:115
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:136
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:350
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:310
#: apps/dp-business/src/servers/order/api.ts:90
#: apps/dp-business/src/pages/OrderDetail/index.tsx:614
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:108
msgid "取得訂單詳情失敗"
msgstr "取得訂單詳情失敗"

#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:156
#: apps/dp-business/src/pages/CouponVerification/index.tsx:505
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:659
msgid "取得訂單資訊失敗"
msgstr "取得訂單資訊失敗"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:278
#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:283
msgid "取得評價分佈統計失敗"
msgstr "取得評價分佈統計失敗"

#: apps/dp-admin/src/pages/data-center/review-detail/services/hooks.ts:133
#: apps/dp-admin/src/pages/data-center/review-detail/services/hooks.ts:140
msgid "取得評價詳情失敗"
msgstr "取得評價詳情失敗"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:49
#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:54
msgid "取得評分趨勢失敗"
msgstr "取得評分趨勢失敗"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:159
#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:170
msgid "取得評論列表失敗"
msgstr "取得評論列表失敗"

#: apps/dp-client/src/screens/diary/pages/detail/hooks/useComments.ts:146
msgid "取得評論失敗"
msgstr "取得評論失敗"

#: apps/dp-admin/src/pages/data-center/review-detail/services/hooks.ts:82
#: apps/dp-admin/src/pages/data-center/review-detail/services/hooks.ts:86
msgid "取得評論詳情失敗"
msgstr "取得評論詳情失敗"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/index.tsx:564
msgid "取得評論詳情失敗，請重試"
msgstr "取得評論詳情失敗，請重試"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/index.web.tsx:262
msgid "取得詳情失敗"
msgstr "取得詳情失敗"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:741
msgid "取得詳情失敗，請重試"
msgstr "取得詳情失敗，請重試"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:101
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:107
msgid "取得請款單列表失敗"
msgstr "取得請款單列表失敗"

#: apps/dp-business/src/servers/chain/settlementApi.ts:221
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:78
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:97
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:101
msgid "取得請款單詳情失敗"
msgstr "取得請款單詳情失敗"

#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:86
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:88
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:91
#: apps/dp-admin/src/pages/audit-center/settlement-audit/services/hooks.ts:98
#: apps/dp-admin/src/pages/audit-center/settlement-audit/services/hooks.ts:104
#: apps/dp-admin/src/pages/audit-center/poi-audit/services/hooks.ts:128
#: apps/dp-admin/src/pages/audit-center/poi-audit/services/hooks.ts:134
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/services/hooks.ts:111
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/services/hooks.ts:117
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/services/hooks.ts:91
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/services/hooks.ts:97
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/services/hooks.ts:111
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/services/hooks.ts:117
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/services/hooks.ts:111
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/services/hooks.ts:117
#: apps/dp-admin/src/pages/audit-center/complaint-audit/services/hooks.ts:122
#: apps/dp-admin/src/pages/audit-center/complaint-audit/services/hooks.ts:128
msgid "取得資料失敗"
msgstr "取得資料失敗"

#: apps/dp-admin/src/pages/audit-center/info-audit/services/hooks.ts:64
msgid "取得資訊審核列表失敗"
msgstr "取得資訊審核列表失敗"

#: apps/dp-admin/src/pages/merchant/task-detail/index.web.tsx:100
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:845
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:660
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:129
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:134
msgid "取得追蹤歷史失敗"
msgstr "取得追蹤歷史失敗"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/index.web.tsx:125
#: apps/dp-admin/src/pages/merchant/shop-list/index.web.tsx:122
#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:136
msgid "取得追蹤歷史失敗，請重試"
msgstr "取得追蹤歷史失敗，請重試"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/index.tsx:49
msgid "取得退款資料失敗"
msgstr "取得退款資料失敗"

#: apps/dp-business/src/servers/notification/api.ts:47
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:102
msgid "取得通知列表失敗"
msgstr "取得通知列表失敗"

#: apps/dp-business/src/servers/chain/contextApi.ts:124
msgid "取得連鎖上下文失敗"
msgstr "取得連鎖上下文失敗"

#: apps/dp-business/src/servers/permission/api.ts:393
msgid "取得選單權限樹失敗"
msgstr "取得選單權限樹失敗"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/hooks.ts:26
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/hooks.ts:30
msgid "取得配置詳情失敗"
msgstr "取得配置詳情失敗"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:238
#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:243
msgid "取得關鍵詞統計失敗"
msgstr "取得關鍵詞統計失敗"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:903
#: apps/dp-business/src/pages/Login/Email/index.tsx:240
#: apps/dp-business/src/components/VerificationInput/index.tsx:110
#: apps/dp-business/src/components/PhoneVerification/index.tsx:390
#: apps/dp-business/src/components/EmailVerification/index.tsx:382
#: apps/dp-business/src/components/CountdownButton/index.tsx:54
msgid "取得驗證碼"
msgstr "取得驗證碼"

#: apps/dp-client/src/utils/permission.ts:57
#: apps/dp-client/src/utils/permission.ts:66
#: apps/dp-client/src/utils/permission.ts:75
#: apps/dp-client/src/utils/permission.ts:84
#: apps/dp-client/src/screens/reservation/pages/main/components/TimeModal.tsx:184
#: apps/dp-client/src/screens/reservation/pages/main/components/DateModal.tsx:85
#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:155
#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:132
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:306
#: apps/dp-client/src/screens/reservation/components/ReservationCard/index.tsx:53
#: apps/dp-client/src/screens/login/components/account-recreate-modal/index.tsx:64
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/CorrectionModal.tsx:294
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/MapNaviation/index.tsx:61
#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:390
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:328
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:408
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:594
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:447
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:599
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:662
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:687
#: apps/dp-client/src/screens/home/pages/Note/hooks/usePhotoSelection.ts:296
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:48
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:113
#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/index.tsx:121
#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:177
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:501
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1214
#: apps/dp-client/src/screens/home/pages/LocationSelect/components/HistorySection.tsx:40
#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:104
#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:415
#: apps/dp-client/src/screens/home/bizComponents/NoteActionModal/NoteActionModalContent.tsx:82
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:372
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:755
#: apps/dp-client/src/screens/diary/components/MissionsModal/index.tsx:194
#: apps/dp-client/src/screens/account/pages/user-profile/pages/permission-settings/index.tsx:55
#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:71
#: apps/dp-client/src/screens/account/pages/order/index.tsx:240
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:599
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:179
#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:263
#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:83
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:632
#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:90
#: apps/dp-client/src/screens/account/pages/edit-profile/components/WheelDatePicker/index.tsx:183
#: apps/dp-client/src/screens/account/pages/edit-profile/components/DatePickerModal/index.tsx:655
#: apps/dp-client/src/screens/account/pages/drafts/main/index.tsx:77
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:254
#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:95
#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:103
#: apps/dp-client/src/components/RefundResonModal/index.tsx:46
#: apps/dp-client/src/components/RefundResonModal/index.tsx:168
#: apps/dp-client/src/components/FeedBackModal/index.tsx:92
#: apps/dp-client/src/components/FeedBackModal/index.tsx:377
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:233
#: apps/dp-client/src/components/ConfirmModal/index.tsx:111
#: apps/dp-client/src/components/CallPhoneModal/index.tsx:99
#: apps/dp-business/src/services/modal.ts:305
#: apps/dp-business/src/services/modal.ts:336
#: apps/dp-business/src/pages/StoreDescription.tsx:162
#: apps/dp-business/src/pages/MenuManagement.tsx:792
#: apps/dp-business/src/pages/MenuManagement.tsx:817
#: apps/dp-business/src/pages/MenuManagement.tsx:870
#: apps/dp-business/src/pages/UserManagement/index.tsx:332
#: apps/dp-business/src/pages/UserManagement/index.tsx:369
#: apps/dp-business/src/pages/TableManagement/index.tsx:303
#: apps/dp-business/src/pages/TableManagement/index.tsx:408
#: apps/dp-business/src/pages/TableManagement/index.tsx:605
#: apps/dp-business/src/pages/TableManagement/index.tsx:783
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:589
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:753
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1206
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:292
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1150
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1070
#: apps/dp-business/src/pages/PhoneEdit/index.tsx:132
#: apps/dp-business/src/pages/PermissionManagement/index.tsx:124
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:297
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:367
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:437
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:77
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:176
#: apps/dp-business/src/pages/OrderDetail/index.tsx:863
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1197
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2517
#: apps/dp-business/src/pages/MyProfile/index.tsx:122
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:767
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:820
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:870
#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:297
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/SubmitConfirmModal.tsx:157
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:235
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:502
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:447
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:484
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:520
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:965
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:284
#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:125
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:1198
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:131
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:228
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountCopyForm.tsx:128
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:839
#: apps/dp-business/src/pages/BusinessHours/index.tsx:904
#: apps/dp-business/src/pages/BusinessHours/index.tsx:999
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1040
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1276
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:1150
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:732
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:469
#: apps/dp-business/src/pages/AddStore/index.tsx:848
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:523
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:531
#: apps/dp-business/src/pages/AddStore/components/PoiConfirmModal.tsx:97
#: apps/dp-business/src/pages/AddRole/index.tsx:369
#: apps/dp-business/src/components/TimePicker/TimePickerModal.tsx:121
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:459
#: apps/dp-business/src/components/ModalContainer/index.tsx:53
#: apps/dp-business/src/components/Modal/DeleteModal.tsx:43
#: apps/dp-business/src/components/Modal/ConfirmDialog.tsx:89
#: apps/dp-business/src/components/InvoiceForm/index.tsx:240
#: apps/dp-business/src/components/InvoiceForm/index.tsx:282
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:28
#: apps/dp-business/src/components/ImageEditorModal/index.tsx:257
#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:132
#: apps/dp-business/src/components/ConfirmModal/index.tsx:48
#: apps/dp-business/src/components/CityDistrictCascadeSelector/index.tsx:164
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:441
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:244
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:160
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:106
#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:35
#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:54
#: apps/dp-admin/src/pages/users/roles/components/RoleForm/index.web.tsx:62
#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:280
#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:327
#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:33
#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:46
#: apps/dp-admin/src/pages/users/permissions/index.web.tsx:86
#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:313
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:399
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:380
#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:215
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:239
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:306
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:600
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:684
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:230
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:535
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:68
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:83
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:469
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:306
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:627
#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:151
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:177
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:194
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:301
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:121
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:470
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:517
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/index.web.tsx:584
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:155
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:747
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:149
#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:353
#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:360
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:162
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:173
#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:440
#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:625
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:261
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:256
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:486
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:576
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:243
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:322
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:521
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:207
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:236
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:267
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:176
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:261
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:100
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:235
#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:153
#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:225
#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:240
#: apps/dp-admin/src/pages/org-tree/org-list/components/AssignBdModal/index.web.tsx:51
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1040
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1469
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1612
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1646
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1723
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1851
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1908
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:191
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:214
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:186
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:198
#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:44
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:177
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:199
#: apps/dp-admin/src/pages/org-tree/org-detail/components/AddChildNodeModal/index.web.tsx:47
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:677
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1143
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1395
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1798
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1807
#: apps/dp-admin/src/pages/org-tree/org-create/components/UnsavedNodeModal/index.web.tsx:27
#: apps/dp-admin/src/pages/org-tree/org-create/components/MountPanel/index.web.tsx:94
#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:452
#: apps/dp-admin/src/pages/org-tree/org-audit/components/RejectModal/index.web.tsx:43
#: apps/dp-admin/src/pages/org-tree/org-audit/components/RejectModal/index.web.tsx:53
#: apps/dp-admin/src/pages/order/services/utils.ts:576
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:175
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:817
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:68
#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:434
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:188
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:203
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:218
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:233
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:248
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:222
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:160
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:213
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:221
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1125
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1178
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:198
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/index.web.tsx:204
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:238
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:271
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:287
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:615
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:198
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/index.web.tsx:202
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:212
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:554
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:569
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:588
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:838
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:101
#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:265
#: apps/dp-admin/src/pages/merchant/service/hooks.ts:33
#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:375
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:357
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:90
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:115
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:133
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:290
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:418
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:172
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:604
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:618
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:632
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:646
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:667
#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:154
#: apps/dp-admin/src/pages/merchant/components/TagEditor/index.web.tsx:226
#: apps/dp-admin/src/pages/merchant/components/SortableItem/index.web.tsx:94
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:190
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:988
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:1031
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:218
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:345
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:214
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:588
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:597
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:791
#: apps/dp-admin/src/pages/merchant/components/CategoryEditModal/index.web.tsx:61
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:144
#: apps/dp-admin/src/pages/merchant/components/ActionButtons/index.web.tsx:150
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:209
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:245
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/index.web.tsx:116
#: apps/dp-admin/src/pages/merchant/brand-list/components/EnableBrandModal/index.web.tsx:66
#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:69
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:105
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:74
#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:113
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:242
#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:132
#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:150
#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:182
#: apps/dp-admin/src/pages/marketing/user-group-create/components/PreviewConfirmModal/index.web.tsx:51
#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/WinningConfirmModal.web.tsx:62
#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:110
#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:82
#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:104
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:308
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:393
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1288
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/SubmitConfirmModal/index.web.tsx:167
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:290
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:607
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:420
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:213
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:133
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:129
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:157
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/PreviewConfirmModal/index.web.tsx:33
#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:259
#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:623
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:144
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:197
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/RejectWinnerModal.web.tsx:67
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:136
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:198
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:305
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:351
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchRejectWinnerModal.web.tsx:82
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchConfirmWinnerModal.web.tsx:50
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchCancelRejectWinnerModal.web.tsx:46
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:701
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:212
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:361
#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:104
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/index.web.tsx:114
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:227
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:274
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:158
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:179
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:199
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:252
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:276
#: apps/dp-admin/src/pages/marketing/benefit-management/components/VoidInventoryModal.web.tsx:61
#: apps/dp-admin/src/pages/marketing/benefit-management/components/ExtendInventoryModal.web.tsx:71
#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:577
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:304
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:50
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:444
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:138
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:165
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:203
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:100
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:1266
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:518
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:153
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:124
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:149
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:378
#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:147
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:386
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:132
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:253
#: apps/dp-admin/src/pages/customer-service/components/CreateTicketModal.web.tsx:72
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:224
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:501
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:531
#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:76
#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:133
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/components/PoiActionButtons/index.web.tsx:38
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:63
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:372
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:422
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:114
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:320
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:305
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:44
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:76
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:133
#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:211
#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:277
#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:250
#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:282
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:227
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:506
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:536
#: apps/dp-admin/src/pages/audit-center/claim-audit/index.web.tsx:197
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:383
#: apps/dp-admin/src/modules/hooks/useUnsavedChangesWarning.ts:68
#: apps/dp-admin/src/components/layout/services/hooks.ts:52
#: apps/dp-admin/src/components/MapPicker/index.web.tsx:154
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:181
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:28
#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:482
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:228
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:340
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:360
#: apps/dp-admin/src/components/BusinessHours/index.web.tsx:457
#: apps/dp-admin/src/components/ActionBar/index.web.tsx:155
msgid "取消"
msgstr "取消"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:311
msgid "取消上榜"
msgstr "取消上榜"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:206
msgid "取消上榜失敗"
msgstr "取消上榜失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:203
msgid "取消上榜成功"
msgstr "取消上榜成功"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:553
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:515
msgid "取消不予中獎"
msgstr "取消不予中獎"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:146
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:315
msgid "取消不予中獎失敗"
msgstr "取消不予中獎失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:143
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:312
msgid "取消不予中獎成功"
msgstr "取消不予中獎成功"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:319
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:350
msgid "取消不予發獎"
msgstr "取消不予發獎"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:349
msgid "取消不予發獎失敗"
msgstr "取消不予發獎失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:346
msgid "取消不予發獎成功"
msgstr "取消不予發獎成功"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:331
msgid "取消中獎"
msgstr "取消中獎"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:263
msgid "取消中獎失敗"
msgstr "取消中獎失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:260
msgid "取消中獎成功"
msgstr "取消中獎成功"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:660
msgid "取消使用"
msgstr "取消使用"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:235
msgid "取消使用失敗，請稍後重試"
msgstr "取消使用失敗，請稍後重試"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:247
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:227
msgid "取消使用這張券嗎？"
msgstr "取消使用這張券嗎？"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:215
#: apps/dp-client/src/screens/reservation/pages/detail/components/ModifyReservationModal.tsx:78
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:317
msgid "取消修改"
msgstr "取消修改"

#: apps/dp-admin/src/components/BusinessHours/components/DaySelector.web.tsx:55
msgid "取消全選"
msgstr "取消全選"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:356
#: apps/dp-admin/src/pages/order/order-detail/components/BasicInfo/index.web.tsx:203
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:381
msgid "取消原因"
msgstr "取消原因"

#: apps/dp-client/src/screens/reservation/pages/main/components/ConflictModal.tsx:97
msgid "取消原預訂"
msgstr "取消原預訂"

#: apps/dp-client/src/screens/account/pages/user-profile/components/UserInfoSection/index.tsx:188
#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/index.tsx:105
msgid "取消封鎖"
msgstr "取消封鎖"

#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/hooks/usePrivacyListData.ts:88
msgid "取消封鎖中..."
msgstr "取消封鎖中..."

#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/hooks/usePrivacyListData.ts:92
msgid "取消封鎖成功"
msgstr "取消封鎖成功"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:251
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:230
msgid ""
"取消後，券碼狀態將更新為未使用狀態；\n"
"後續可在「我的票券」中更改。"
msgstr ""
"取消後，券碼狀態將更新為未使用狀態；\n"
"後續可在「我的票券」中更改。"

#: apps/dp-client/src/screens/reservation/components/ConfirmModal/index.tsx:23
msgid "取消後可再次預訂"
msgstr "取消後可再次預訂"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:130
#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:107
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:240
msgid "取消後需要重新預訂"
msgstr "取消後需要重新預訂"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:391
#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:467
msgid "取消按讚成功"
msgstr "取消按讚成功"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:947
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:480
msgid "取消收藏成功"
msgstr "取消收藏成功"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:412
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:639
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:836
msgid "取消政策"
msgstr "取消政策"

#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:211
#: apps/dp-business/src/pages/CouponVerification/index.tsx:467
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:621
msgid "取消核銷"
msgstr "取消核銷"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:181
msgid "取消申請"
msgstr "取消申請"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:418
#: apps/dp-admin/src/components/layout/components/header/index.web.tsx:54
msgid "取消登入"
msgstr "取消登入"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:421
msgid "取消綁定"
msgstr "取消綁定"

#: apps/dp-admin/src/pages/org-tree/services/constants.ts:61
msgid "取消舊申請中"
msgstr "取消舊申請中"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:252
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:375
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:398
msgid "取消訂位"
msgstr "取消訂位"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:275
msgid "取消訂位失敗"
msgstr "取消訂位失敗"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:272
msgid "取消訂位成功"
msgstr "取消訂位成功"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:347
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:349
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:776
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:255
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:257
#: apps/dp-client/src/screens/account/pages/order/index.tsx:209
#: apps/dp-client/src/screens/account/pages/order/index.tsx:211
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:153
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:155
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:128
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:352
msgid "取消訂單"
msgstr "取消訂單"

#: apps/dp-business/src/servers/reservation/api.ts:921
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:397
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:404
msgid "取消訂單失敗"
msgstr "取消訂單失敗"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:323
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:364
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:250
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:272
#: apps/dp-client/src/screens/account/pages/order/index.tsx:228
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:167
msgid "取消訂單失敗，請稍後重試"
msgstr "取消訂單失敗，請稍後重試"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:532
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:229
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowUserListItem.tsx:120
msgid "取消追蹤"
msgstr "取消追蹤"

#: apps/dp-client/src/screens/account/pages/follow-list/hooks/useFollowListData.ts:207
msgid "取消追蹤成功"
msgstr "取消追蹤成功"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:952
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:994
msgid "取消選擇"
msgstr "取消選擇"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:380
msgid "取消靜音"
msgstr "取消靜音"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:224
msgid "受影響流程"
msgstr "受影響流程"

#: apps/dp-client/src/screens/home/pages/Review/components/RatingSection/index.tsx:170
#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewEditorToolbar.tsx:23
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:229
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:321
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:794
#: apps/dp-client/src/screens/diary/components/diary-entry/index.tsx:103
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewContent.tsx:244
#: apps/dp-admin/src/pages/user-info/services/apis.ts:140
#: apps/dp-admin/src/pages/data-center/components/ReviewItem.web.tsx:126
#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:141
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/OriginalReviewSection/index.web.tsx:77
msgid "口味"
msgstr "口味"

#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/CommentSection.tsx:96
msgid "口味、服務、環境如何、有哪些超讚的美食？"
msgstr "口味、服務、環境如何？有哪些超讚的美食？"

#: apps/dp-client/src/screens/diary/components/DiaryContent/index.tsx:70
msgid "口味："
msgstr "口味："

#: apps/dp-admin/src/pages/merchant/signing-management/components/NoContractActions/index.web.tsx:49
msgid "只聚流簽約"
msgstr "只聚流簽約"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:325
msgid "只能上傳圖片文件！"
msgstr "只能上傳圖片文件！"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeMountNodeModal.web.tsx:155
msgid "只能在本樹內改掛（末級或非末級節點均可）；報表歸屬隨掛接位置變更，結算路徑另行管理、不受影響。"
msgstr "只能在本樹內改掛（末級或非末級節點均可）；報表歸屬隨掛接位置變更，結算路徑另行管理、不受影響。"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:578
msgid "只能編輯自己的筆記"
msgstr "只能編輯自己的筆記"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/hooks/useGalleryAccess.ts:153
msgid "只能選擇照片或影片，不能混合選擇"
msgstr "只能選擇照片或影片，不能混合選擇"

#: apps/dp-client/src/screens/home/pages/Note/hooks/usePhotoSelection.ts:249
msgid "只能選擇照片或視頻，不能混合選擇"
msgstr "只能選擇照片或視頻，不能混合選擇"

#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:116
msgid "只要是遠傳月租型用戶都可參加喔!"
msgstr "只要是遠傳月租型用戶都可參加喔!"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:120
msgid "只讀。一店可掛多棵樹（管理／報表），結算路徑全店唯一；更換結算、改掛或解掛請到運營端。"
msgstr "只讀。一店可掛多棵樹（管理／報表），結算路徑全店唯一；更換結算、改掛或解掛請到運營端。"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2351
msgid "可以"
msgstr "可以"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:67
msgid "可以不掛組織樹"
msgstr "可以不掛組織樹"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:204
msgid "可以使用"
msgstr "可以使用"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ReviewGuide.tsx:60
msgid "可以先給美食拍個照～ 稍後再評論"
msgstr "可以先給美食拍個照～ 稍後再評論"

#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:59
msgid "可以填寫店家的來點和菜系特點幫助顧客入店，請不要重複填寫已經有的資訊，比如營業時間"
msgstr "可以填寫店家的來點和菜系特點幫助顧客入店，請不要重複填寫已經有的資訊，比如營業時間"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallProgressCard/index.tsx:87
msgid "可兌換"
msgstr "可兌換"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:72
msgid "可匯入"
msgstr "可匯入"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/PackageColumns/index.web.tsx:28
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:75
msgid "可售"
msgstr "可售"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:265
msgid "可填寫審核說明..."
msgstr "可填寫審核說明..."

#: apps/dp-client/src/hooks/tasks/useTaskTooltip.ts:185
msgid "可得"
msgstr "可得"

#: apps/dp-client/src/screens/diary/pages/rank/components/rank-item.tsx:47
msgid "可抽獎"
msgstr "可抽獎"

#: apps/dp-admin/src/components/MapPicker/index.web.tsx:576
msgid "可拖拉藍色圓形調整半徑；拖拉綠色點位可形成不規則多邊形邊界，坐標格式為 [經度, 緯度]。"
msgstr "可拖拉藍色圓形調整半徑；拖拉綠色點位可形成不規則多邊形邊界，坐標格式為 [經度, 緯度]。"

#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:204
#: apps/dp-business/src/pages/MarketingCenter/components/StoreSelectionCard.tsx:296
msgid "可搜尋門市名稱或地址"
msgstr "可搜尋門市名稱或地址"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:34
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:92
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:659
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:698
msgid "可搜索品類名稱、品類ID"
msgstr "可搜索品類名稱、品類ID"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:547
msgid "可根據目前填寫內容定位"
msgstr "可根據目前填寫內容定位"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/types.ts:151
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:62
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:63
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:293
msgid "可樂"
msgstr "可樂"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:199
msgid "可獲得 {count} {unit}"
msgstr "可獲得 {count} {unit}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:209
msgid "可用優惠"
msgstr "可用優惠"

#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:665
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:100
msgid "可用性校驗失敗，請重新選擇以重試"
msgstr "可用性校驗失敗，請重新選擇以重試"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1149
msgid "可用日期與販售日期並非完全一致，建議再次確認設定是否符合商家預期，避免影響消費者【即買即用】使用體驗。若是預售套餐，請忽略。"
msgstr "可用日期與販售日期並非完全一致，建議再次確認設定是否符合商家預期，避免影響消費者【即買即用】使用體驗。若是預售套餐，請忽略。"

#: apps/dp-client/src/screens/home/utils/order.ts:1005
#: apps/dp-client/src/screens/home/utils/order.ts:1027
#: apps/dp-client/src/screens/home/utils/order.ts:1032
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:695
msgid "可用時段"
msgstr "可用時段"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1668
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1688
msgid "可用時間"
msgstr "可用時間"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:460
msgid "可疊加"
msgstr "可疊加"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:434
msgid "可疊加使用"
msgstr "可疊加使用"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:25
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:186
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:161
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:404
msgid "可管理"
msgstr "可管理"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:24
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:184
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:160
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:172
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:183
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:244
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:197
msgid "可結算請款"
msgstr "可結算請款"

#: apps/dp-client/src/screens/home/pages/Purchase/components/SelectDishContent/index.tsx:389
msgid "可能是店家沒有添加此菜品，先看看其他菜吧～"
msgstr "可能是店家沒有添加此菜品，先看看其他菜吧～"

#: apps/dp-business/src/pages/ReservationManagement/StockInputGroup.tsx:85
msgid "可訂"
msgstr "可訂"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1581
#: apps/dp-business/src/pages/ReservationManagement/TableCells.tsx:117
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:767
#: apps/dp-business/src/pages/OrderOverview/Detail/components/ReservationSlots.tsx:78
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/components/ReservationSlots.web.tsx:143
msgid "可訂庫存"
msgstr "可訂庫存"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:960
msgid "可訂庫存："
msgstr "可訂庫存："

#: apps/dp-client/src/screens/home/pages/Meal/constants/index.ts:17
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:168
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:98
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:31
msgid "可退款"
msgstr "可退款"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/variantB/VariantBListCard.tsx:74
#: apps/dp-client/src/screens/home/components/SetMealCard/index.tsx:263
msgid "可適用店家"
msgstr "可適用店家"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:229
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:561
msgid "可選"
msgstr "可選"

#. placeholder {0}: group.maxSelectCount ?? 1
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:435
msgid "可選{0}張"
msgstr "可選{0}張"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:495
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/index.web.tsx:61
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:272
msgid "可選分組"
msgstr "可選分組"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:271
msgid "可選填寫審核說明，幫助商家瞭解審核結果。"
msgstr "可選填寫審核說明，幫助商家瞭解審核結果。"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:861
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:991
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:62
msgid "可選套餐"
msgstr "可選套餐"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2018
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:865
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:991
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:590
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:585
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:634
#: apps/dp-business/src/pages/CouponVerification/components/VerificationModal.tsx:242
msgid "可選套餐組合"
msgstr "可選套餐組合"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:148
msgid "可選擇"
msgstr "可選擇"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:284
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:291
msgid "可選數量"
msgstr "可選數量"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:197
msgid "可選數量必須大於 0"
msgstr "可選數量必須大於 0"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:355
msgid "可選標籤"
msgstr "可選標籤"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:158
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:372
msgid "可選範圍"
msgstr "可選範圍"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:880
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:336
msgid "可選餐點次數超過餐點數量，不可以取消喔～"
msgstr "可選餐點次數超過餐點數量，不可以取消喔～"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:136
msgid "可重發"
msgstr "可重發"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:235
msgid "可關聯 C 端客服工單編號"
msgstr "可關聯 C 端客服工單編號"

#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:26
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:282
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:373
msgid "可隨時退款"
msgstr "可隨時退款"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:36
msgid "可領取"
msgstr "可領取"

#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:61
msgid "右上"
msgstr "右上"

#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:62
msgid "右下"
msgstr "右下"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:179
msgid "右對齊文本"
msgstr "靠右對齊"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:258
msgid "右旋轉"
msgstr "右旋轉"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:100
msgid ""
"吃了什麼？有沒有必點或踩雷？\n"
"口味與份量的感覺、價格值不值得？\n"
"適合誰來吃、什麼時候來？\n"
"想寫多少都可以，回憶沒有標準格式。"
msgstr ""
"吃了什麼？有沒有必點或踩雷？\n"
"口味與份量的感覺、價格值不值得？\n"
"適合誰來吃、什麼時候來？\n"
"想寫多少都可以，回憶沒有標準格式。"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:203
msgid "各層代碼為選填，請填寫該層自身代碼（不含父級前綴，例如 S0001）；留空則由系統自動生成，並組合完整路徑，例如 C001-S0001-E0001。"
msgstr "各層代碼為選填，請填寫該層自身代碼（不含父級前綴，例如 S0001）；留空則由系統自動生成，並組合完整路徑，例如 C001-S0001-E0001。"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:65
msgid "各排名稱"
msgstr "各排名稱"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/variantB/BrandPackageSectionB.tsx:40
msgid "合作品牌限定｜專屬套餐優惠"
msgstr "合作品牌限定｜專屬套餐優惠"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:877
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:544
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:289
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:406
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:421
#: apps/dp-admin/src/pages/merchant/components/HistoryTable/index.web.tsx:92
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:92
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:182
msgid "合作意向"
msgstr "合作意向"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:383
msgid "合併"
msgstr "合併"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:81
msgid "合併失敗"
msgstr "合併失敗"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:102
msgid "合併後，手機號與郵箱都可登入同一個帳號；"
msgstr "合併後，手機號與郵箱都可登入同一個帳號；"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:228
msgid "合併後規則"
msgstr "合併後規則"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:203
msgid "合併後關聯商家總數(預估):"
msgstr "合併後關聯商家總數(預估):"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:77
msgid "合併成功"
msgstr "合併成功"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:143
msgid "合併標籤預覽"
msgstr "合併標籤預覽"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:215
msgid "合併理由說明"
msgstr "合併理由說明"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:59
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/services/hooks.ts:23
msgid "合約 ID 不能為空"
msgstr "合約 ID 不能為空"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:818
#: apps/dp-business/src/components/CustomTabs/index.tsx:245
msgid "合約&服務管理"
msgstr "合約&服務管理"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:203
#: apps/dp-business/src/pages/ContractManagement/index.tsx:434
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:111
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:154
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:198
msgid "合約ID"
msgstr "合約ID"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:280
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:699
msgid "合約ID不存在"
msgstr "合約ID不存在"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/ContractTypeForm/index.web.tsx:53
msgid "合約上傳注意事項"
msgstr "合約上傳注意事項"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:908
msgid "合約上傳注意事項："
msgstr "合約上傳注意事項："

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:367
msgid "合約內容"
msgstr "合約內容"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:597
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:203
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/common/ContractTable/index.web.tsx:43
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:266
msgid "合約列表"
msgstr "合約列表"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:217
msgid "合約名稱"
msgstr "合約名稱"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:779
msgid "合約提交失敗"
msgstr "合約上傳失敗"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/hooks.ts:480
msgid "合約提交失敗，請檢查網路連線後重試"
msgstr "合約提交失敗，請檢查網路連線後重試"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/hooks.ts:473
msgid "合約提交失敗，請重試"
msgstr "合約提交失敗，請重試"

#. placeholder {0}: result.errorMessage || '未知錯誤'
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:773
msgid "合約提交失敗：{0}"
msgstr "合約提交失敗：{0}"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/hooks.ts:468
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:396
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:413
msgid "合約提交成功"
msgstr "合約提交成功"

#. placeholder {0}: result.statusDesc || '處理中'
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:764
msgid "合約提交成功！簽約狀態：{0}"
msgstr "合約提交成功！簽約狀態：{0}"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:743
msgid "合約更新失敗"
msgstr "合約更新失敗"

#. placeholder {0}: result.errorMessage || '未知錯誤'
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:737
msgid "合約更新失敗：{0}"
msgstr "合約更新失敗：{0}"

#. placeholder {0}: result.statusDesc || '處理中'
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:728
msgid "合約更新成功！狀態：{0}"
msgstr "合約更新成功！狀態：{0}"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:453
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:538
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:230
msgid "合約期間"
msgstr "合約期間"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:108
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:176
msgid "合約期限"
msgstr "合約期限"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:163
msgid "合約材料"
msgstr "合約材料"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:49
msgid "合約模板下載失敗"
msgstr "合約模板下載失敗"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:450
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:482
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:125
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:211
msgid "合約狀態"
msgstr "合約狀態"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:163
msgid "合約生效狀態"
msgstr "合約生效狀態"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:262
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:819
#: apps/dp-business/src/components/CustomTabs/index.tsx:253
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:553
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:559
#: apps/dp-admin/src/pages/transaction/contract-management/index.web.tsx:152
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:123
msgid "合約管理"
msgstr "合約管理"

#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:64
msgid "合約簽約流程"
msgstr "合約簽約流程"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:210
#: apps/dp-business/src/pages/ContractManagement/index.tsx:441
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:102
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:424
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:464
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:118
msgid "合約編號"
msgstr "合約編號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/hooks.ts:504
msgid "合約草稿儲存成功"
msgstr "合約草稿儲存成功"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:831
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:846
msgid "合約表單"
msgstr "合約表單"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:360
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractEditTabs/index.web.tsx:42
msgid "合約詳情"
msgstr "合約詳情"

#: apps/dp-admin/src/pages/merchant/components/BlueNewContractHistory/index.web.tsx:21
#: apps/dp-admin/src/pages/audit-center/components/ContentAuditTaskHistory/index.web.tsx:55
msgid "合約變更歷史"
msgstr "合約變更歷史"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:540
msgid "合約資訊"
msgstr "合約資訊"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:224
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:856
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:151
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:43
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:431
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:476
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:156
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:204
msgid "合約類型"
msgstr "合約類型"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:383
#: apps/dp-client/src/screens/diary/pages/my/components/TabSwitch.tsx:118
msgid "合計"
msgstr "合計"

#. placeholder {0}: formatAmount(summary?.totalOriginalAmount)
#. placeholder {0}: formatAmount(summary?.totalSettlementAmount)
#. placeholder {0}: formatAmount(summary?.totalNetSettlementAmount)
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:507
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:528
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:549
msgid "合計：{0}"
msgstr "合計：{0}"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:31
msgid "吉野家"
msgstr "吉野家"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:259
msgid "同一平台＋同一版本號只保留一筆，不論已有記錄是手動還是自動。"
msgstr "同一平台＋同一版本號只保留一筆，不論已有記錄是手動還是自動。"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:547
msgid "同一平台下版本號不可重複。Android、iOS、H5各自獨立。"
msgstr "同一平台下版本號不可重複。Android、iOS、H5各自獨立。"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:116
msgid "同一活動中的權益不可重複"
msgstr "同一活動中的權益不可重複"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:814
msgid "同一活動內優惠分組不可重複：{duplicateKey}"
msgstr "同一活動內優惠分組不可重複：{duplicateKey}"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:132
msgid "同一父級下渠道名稱已存在"
msgstr "同一父級下渠道名稱已存在"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:206
msgid "同一管理員可掛多個節點"
msgstr "同一管理員可掛多個節點"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:513
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:71
msgid "同一菜品不可選多次"
msgstr "同一菜品不可選多次"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:509
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:70
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:289
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:317
msgid "同一菜品可選多次"
msgstr "同一餐點可選多次"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:132
msgid "同一請求號攜帶了不同內容，請核對後再操作"
msgstr "同一請求號攜帶了不同內容，請核對後再操作"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2041
#: apps/dp-business/src/pages/CouponVerification/components/VerificationModal.tsx:262
msgid "同一餐點不可選多次"
msgstr "同一餐點不可選多次"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2037
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:866
#: apps/dp-business/src/pages/CouponVerification/components/VerificationModal.tsx:258
msgid "同一餐點可選多次"
msgstr "同一餐點可選多次"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:97
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:97
msgid "同事"
msgstr "同事"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/NoSigned.tsx:22
msgid "同城商家已陸續簽約參與，平台正在集中推流~"
msgstr "同城商家已陸續簽約參與，平台正在集中推流~"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:238
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:37
msgid "同層排序"
msgstr "同層排序"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:339
msgid "同平台目前上架的是 {replacedVersion}，確認後會改為下架。工單、客服只展示這筆。"
msgstr "同平台目前上架的是 {replacedVersion}，確認後會改為下架。工單、客服只展示這筆。"

#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:76
#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:82
#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:108
#: apps/dp-business/src/store/NotificationContext.tsx:659
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:730
msgid "同意"
msgstr "同意"

#: apps/dp-client/src/screens/login/components/privacy-agreement-modal/index.tsx:88
#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:285
#: apps/dp-client/src/screens/login/components/fet-login-modal/index.tsx:117
msgid "同意並繼續"
msgstr "同意並繼續"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:192
msgid "同時將本節點設為所選店家的結算路徑"
msgstr "同時將本節點設為所選店家的結算路徑"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:165
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:449
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:26
#: apps/dp-admin/src/pages/split-account/services/constants.ts:89
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:183
msgid "同步中"
msgstr "同步中"

#: apps/dp-admin/src/pages/merchant/components/BdAssignmentField/index.web.tsx:146
msgid "同步修改同統編店家"
msgstr "同步修改同統編店家"

#: apps/dp-admin/src/pages/merchant/components/BdAssignmentField/index.web.tsx:137
msgid "同步修改商家"
msgstr "同步修改商家"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:185
msgid "同步失敗"
msgstr "同步失敗"

#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:196
msgid "同步應用於其他門市"
msgstr "同步應用於其他門市"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:175
msgid "同步狀態"
msgstr "同步狀態"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:62
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:93
#: apps/dp-admin/src/pages/split-account/services/constants.ts:166
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:14
msgid "同步第三方失敗"
msgstr "同步第三方失敗"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:416
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/index.web.tsx:53
msgid "同步開通套餐券服務"
msgstr "同步開通套餐券服務"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:439
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/index.web.tsx:76
msgid "同步開通訂位服務"
msgstr "同步開通訂位服務"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:143
msgid "同組內多條規則：選「任一完成即可」＝命中任意一條即發放獎勵；選「需全部命中」＝所有規則皆命中才發放。"
msgstr "同組內多條規則：選「任一完成即可」＝命中任意一條即發放獎勵；選「需全部命中」＝所有規則皆命中才發放。"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:39
msgid "同組可疊加，不填則不分組"
msgstr "同組可疊加，不填則不分組"

#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:20
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:55
#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:123
msgid "名單 ID"
msgstr "名單 ID"

#. placeholder {0}: groupName || '—'
#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:64
msgid "名單「{0}」匯入結果。"
msgstr "名單「{0}」匯入結果。"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:24
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:58
msgid "名單ID"
msgstr "名單ID"

#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:74
#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:31
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:67
#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:27
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:62
#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:126
msgid "名單名稱"
msgstr "名單名稱"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:156
msgid "名單基礎資訊已建立，狀態為「匯入處理中」，店家數據正由後臺非同步匯入，請前往「上傳歷史」查看進度，頁面可見時會自動更新。"
msgstr "名單基礎資訊已建立，狀態為「匯入處理中」，店家數據正由後臺非同步匯入，請前往「上傳歷史」查看進度，頁面可見時會自動更新。"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:181
msgid "名單基礎資訊已建立，狀態為「匯入處理中」，成員數據正由後臺非同步匯入，請前往「上傳歷史」查看進度，頁面可見時會自動更新。"
msgstr "名單基礎資訊已建立，狀態為「匯入處理中」，成員數據正由後臺非同步匯入，請前往「上傳歷史」查看進度，頁面可見時會自動更新。"

#: apps/dp-client/src/screens/diary/pages/winning/index.tsx:191
msgid "名單尚未公佈，請耐心等待"
msgstr "名單尚未公佈，請耐心等待"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:38
msgid "名單狀態"
msgstr "名單狀態"

#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:28
msgid "名單篩選"
msgstr "名單篩選"

#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:236
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:206
msgid "名單追加任務已提交"
msgstr "名單追加任務已提交"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:70
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:92
#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:112
#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:45
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:87
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:97
#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:129
msgid "名單類型"
msgstr "名單類型"

#: apps/dp-admin/src/pages/resource-config/rank-list/components/RankDetailModal/index.web.tsx:18
msgid "名次"
msgstr "名次"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:162
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1291
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:408
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:101
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:155
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:111
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:64
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:68
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:121
msgid "名稱"
msgstr "名稱"

#: apps/dp-admin/src/components/BusinessHours/SpecialBusinessHours.web.tsx:290
msgid "名稱（如：春節）"
msgstr "名稱（如：春節）"

#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/services/constants.ts:17
msgid "名稱審核"
msgstr "名稱審核"

#: apps/dp-admin/src/components/BusinessHours/SpecialBusinessHours.web.tsx:296
msgid "名稱為必填項"
msgstr "名稱為必填項"

#: apps/dp-business/src/pages/MenuItemForm.tsx:397
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:314
msgid "名稱重複提示"
msgstr "名稱重複提示"

#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:500
msgid "向右旋轉"
msgstr "向右旋轉"

#: apps/dp-business/src/components/ImageEditorModal/locale.ts:54
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:55
msgid "向右旋轉90°"
msgstr "向右旋轉90°"

#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:494
msgid "向左旋轉"
msgstr "向左旋轉"

#: apps/dp-business/src/components/ImageEditorModal/locale.ts:53
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:54
msgid "向左旋轉90°"
msgstr "向左旋轉90°"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:519
msgid "向店家展示"
msgstr "向店家展示"

#. placeholder {0}: formatPayee(path.payeeMerchant)
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:247
msgid "向根解析請款商家：{0}"
msgstr "向根解析請款商家：{0}"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:996
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:915
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:450
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2189
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:43
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:49
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCommonColumns.tsx:64
#: apps/dp-business/src/pages/AddStore/index.tsx:1038
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:117
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/ContractSettings/index.web.tsx:41
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:49
#: apps/dp-admin/src/pages/split-account/services/constants.ts:314
#: apps/dp-admin/src/pages/split-account/services/constants.ts:322
#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:252
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:71
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:48
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:73
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:97
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:109
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:26
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:129
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:57
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:123
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:17
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:78
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:223
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:510
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:590
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2144
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2332
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:903
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/hooks.ts:28
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:58
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:234
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:264
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:112
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:253
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/searchConfig.ts:53
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:252
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:206
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:308
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:153
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:165
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:48
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:279
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:282
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:285
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:96
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:150
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:179
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/config.ts:80
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:175
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:188
msgid "否"
msgstr "否"

#: apps/dp-admin/src/pages/audit-center/user-audit/services/hooks.ts:33
#: apps/dp-admin/src/pages/audit-center/user-audit/services/hooks.ts:91
msgid "吧啦吧啦小魔仙"
msgstr "吧啦吧啦小魔仙"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:42
msgid "含有非拍攝內容的照片"
msgstr "含有非拍攝內容的照片"

#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:102
msgid "含稅"
msgstr "含稅"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:487
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:420
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:330
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:232
msgid "含稅金額"
msgstr "含稅金額"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:165
msgid "含結算單"
msgstr "含結算單"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:81
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:137
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:193
msgid "吳產品"
msgstr "吳產品"

#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:47
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:51
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:24
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:30
msgid "周"
msgstr "周"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:332
msgid "味道不錯，下次還來！"
msgstr "味道不錯，下次還來！"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:329
msgid "味道好"
msgstr "味道好"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallIntro/index.tsx:39
msgid "呷飽沒？"
msgstr "呷飽沒？"

#: apps/dp-business/src/pages/Login/index.tsx:1013
#: apps/dp-business/src/pages/Login/index.tsx:1466
#: apps/dp-business/src/pages/Login/index.tsx:1802
msgid "和"
msgstr "和"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:1045
msgid "和誰一起用餐？"
msgstr "和誰一起用餐？"

#: apps/dp-business/src/data/categories.ts:227
msgid "咖啡"
msgstr "咖啡"

#: apps/dp-business/src/pages/RefundList/index.tsx:102
msgid "咖啡小屋"
msgstr "咖啡小屋"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallSummary/index.tsx:92
msgid "咬吉任務牆"
msgstr "咬吉任務牆"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallIntro/index.tsx:42
msgid "咬吉邀請你參加賺點數任務！"
msgstr "咬吉邀請你參加賺點數任務！"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:71
msgid "品位主鮮超市"
msgstr "品位主鮮超市"

#: apps/dp-client/src/screens/home/pages/PackageZone/hooks/usePackageZoneList.ts:172
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:732
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:74
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:84
#: apps/dp-admin/src/pages/report-center/services/apis.ts:395
#: apps/dp-admin/src/pages/report-center/services/apis.ts:450
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:373
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/columns.web.tsx:42
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:97
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:747
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:13
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/config.ts:87
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:180
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:248
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:148
msgid "品牌"
msgstr "品牌"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:128
msgid "品牌 Logo"
msgstr "品牌 Logo"

#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:81
msgid "品牌「{brandName}」目前已關聯 {shopCount} 家店家，禁用後該品牌將不可使用（已關聯店家不會被自動解綁），是否確認禁用？"
msgstr "品牌「{brandName}」目前已關聯 {shopCount} 家店家，禁用後該品牌將不可使用（已關聯店家不會被自動解綁），是否確認禁用？"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:74
#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:40
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:155
msgid "品牌ID"
msgstr "品牌ID"

#: apps/dp-admin/src/router/config/routes.web.tsx:92
#: apps/dp-admin/src/pages/merchant/brand-list/index.web.tsx:136
#: apps/dp-admin/src/pages/merchant/brand-list/index.web.tsx:149
msgid "品牌列表"
msgstr "品牌列表"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:126
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:146
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:75
#: apps/dp-admin/src/pages/merchant/brand-list/services/searchConfig.ts:17
#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:65
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:113
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:105
msgid "品牌名稱"
msgstr "品牌名稱"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:120
msgid "品牌名稱不能以空格開頭或結尾"
msgstr "品牌名稱不能以空格開頭或結尾"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:117
msgid "品牌名稱不能超過50個字符"
msgstr "品牌名稱不能超過50個字符"

#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:71
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:150
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:173
msgid "品牌描述"
msgstr "品牌描述"

#: apps/dp-client/src/screens/home/pages/ShopDetail/constants/index.ts:11
msgid "品牌故事"
msgstr "品牌故事"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:15
msgid "品牌榜"
msgstr "品牌榜"

#: apps/dp-admin/src/pages/merchant/brand-list/services/searchConfig.ts:27
#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:94
msgid "品牌狀態"
msgstr "品牌狀態"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterSelects.tsx:198
msgid "品牌篩選"
msgstr "品牌篩選"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:102
msgid "品牌詳情"
msgstr "品牌詳情"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:18
msgid "品牌資源位"
msgstr "品牌資源位"

#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:224
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:214
msgid "品類ID"
msgstr "品類ID"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:60
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:128
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:207
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:304
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:714
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:738
msgid "品類來源"
msgstr "品類來源"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:351
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:441
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:506
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:225
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:215
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:169
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:612
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:260
msgid "品類名稱"
msgstr "品類名稱"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:363
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:453
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:518
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:618
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:266
msgid "品類名稱不能以空格開頭或結尾"
msgstr "品類名稱不能以空格開頭或結尾"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:360
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:450
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:515
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:615
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:263
msgid "品類名稱不能超過50個字符"
msgstr "品類名稱不能超過50個字符"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:178
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:271
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:228
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:218
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:212
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:669
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:319
msgid "品類圖片"
msgstr "品類圖片"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:385
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:475
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:525
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:244
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:234
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:197
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:642
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:290
msgid "品類描述"
msgstr "品類描述"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:192
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:285
msgid "品類狀態"
msgstr "品類狀態"

#: apps/dp-admin/src/router/config/routes.web.tsx:620
msgid "品類管理"
msgstr "品類管理"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:370
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:460
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:184
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:631
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:279
msgid "品類編碼"
msgstr "品類編碼"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:379
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:469
msgid "品類編碼不能超過100個字符"
msgstr "品類編碼不能超過100個字符"

#: apps/dp-client/src/screens/diary/pages/my/components/TabSwitch.tsx:172
msgid "哇！只差"
msgstr "哇！只差"

#: apps/dp-client/src/screens/diary/components/WarningModal/index.tsx:65
msgid "哎呀，晚來一步！這個加分任務已被其他小夥伴領走啦！"
msgstr "哎呀，晚來一步！這個加分任務已被其他人領走啦！"

#: apps/dp-client/src/screens/home/pages/Note/components/AddNoteTip/index.tsx:50
msgid "哎呀！上傳失敗，請符合以下條件喔～"
msgstr "哎呀！上傳失敗，請符合以下條件喔～"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:399
msgid "員工"
msgstr "員工"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:132
msgid "員工姓名"
msgstr "員工姓名"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:84
msgid "員工姓名不能超過20個字符"
msgstr "員工姓名不能超過20個字符"

#: apps/dp-business/src/pages/AddUser/index.tsx:153
#: apps/dp-business/src/pages/AddUser/index.tsx:158
msgid "員工建立失敗"
msgstr "員工建立失敗"

#: apps/dp-business/src/pages/AddUser/index.tsx:140
msgid "員工建立成功"
msgstr "員工建立成功"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:49
msgid "員工編碼"
msgstr "員工編碼"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:144
msgid "員工編號"
msgstr "員工編號"

#: apps/dp-business/src/pages/UserManagement/EditUserPage.tsx:113
#: apps/dp-business/src/pages/UserManagement/EditUserPage.tsx:117
#: apps/dp-business/src/pages/EditUser/index.tsx:159
#: apps/dp-business/src/pages/EditUser/index.tsx:164
msgid "員工資訊更新失敗"
msgstr "員工資訊更新失敗"

#: apps/dp-business/src/pages/UserManagement/EditUserPage.tsx:100
#: apps/dp-business/src/pages/EditUser/index.tsx:146
msgid "員工資訊更新成功"
msgstr "員工資訊更新成功"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:427
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:817
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:492
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:368
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/packageCouponColumns.web.tsx:43
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:182
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:249
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:470
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/PackageColumns/index.web.tsx:16
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:62
msgid "售價"
msgstr "售價"

#. placeholder {0}: data.includeServiceFeeRate ?? 0
#. placeholder {0}: d.serviceFeeRate ?? 0
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:367
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:469
msgid "售價（包含{0}%服務費）"
msgstr "售價（包含{0}%服務費）"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:214
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/columns.tsx:85
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:173
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:38
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:102
msgid "售出店家"
msgstr "售出店家"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/Card.tsx:218
#: apps/dp-client/src/screens/home/components/SetMealCard/index.tsx:234
msgid "售罄"
msgstr "售罄"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:336
msgid "商品價格"
msgstr "商品價格"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/constants.ts:56
msgid "商品列表"
msgstr "商品列表"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:36
msgid "商品原價"
msgstr "商品原價"

#: apps/dp-business/src/pages/RefundList/index.tsx:137
msgid "商品品質問題"
msgstr "商品品質問題"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:59
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:36
msgid "商品圖片"
msgstr "商品圖片"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:212
msgid "商品圖片1"
msgstr "商品圖片1"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:220
msgid "商品圖片2"
msgstr "商品圖片2"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:94
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:104
msgid "商品照片"
msgstr "商品照片"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:74
msgid "商品種類較全，但部分水果不太新鮮。"
msgstr "商品種類較全，但部分水果不太新鮮。"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:764
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1090
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2464
msgid "商品資訊"
msgstr "商品資訊"

#: apps/dp-business/src/pages/RefundList/index.tsx:76
msgid "商品退款中"
msgstr "商品退款中"

#: apps/dp-business/src/pages/RefundList/index.tsx:77
msgid "商品退款原因"
msgstr "商品退款原因"

#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:211
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:144
msgid "商品類目"
msgstr "商品類目"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:172
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:172
msgid "商圈"
msgstr "商圈"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:819
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:389
msgid "商圈/夜市"
msgstr "商圈/夜市"

#: apps/dp-admin/src/modules/hooks/options/useMallOptions.ts:27
msgid "商圈選項資料取得失敗"
msgstr "商圈選項資料取得失敗"

#. placeholder {0}: mall?.name || ''
#: apps/dp-client/src/screens/home/pages/MallDetail/index.tsx:250
msgid "商圈頁_{0}_{name}"
msgstr "商圈頁_{0}_{name}"

#. placeholder {0}: mall?.name
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:296
msgid "商圈頁_{0}_導航"
msgstr "商圈頁_{0}_導航"

#. placeholder {0}: detail?.name
#. placeholder {1}: activity.title
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallActivityModal/index.tsx:385
msgid "商圈頁_{0}_蓋板_{1}_查看詳情"
msgstr "商圈頁_{0}_蓋板_{1}_查看詳情"

#. placeholder {0}: detail?.name
#. placeholder {1}: activity.title
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallActivityModal/index.tsx:288
msgid "商圈頁_{0}_蓋板_{1}_關閉"
msgstr "商圈頁_{0}_蓋板_{1}_關閉"

#. placeholder {0}: mall?.name
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:275
msgid "商圈頁_{0}_電話"
msgstr "商圈頁_{0}_電話"

#. placeholder {0}: next.title
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallTabBar/index.tsx:83
msgid "商圈頁_{title}_{0}"
msgstr "商圈頁_{title}_{0}"

#. placeholder {0}: item.title
#. placeholder {1}: item.id
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallNoteSection/index.tsx:67
msgid "商圈頁_{title}_{0}_{1}"
msgstr "商圈頁_{title}_{0}_{1}"

#. placeholder {0}: tabs[index].title
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallTabBar/index.tsx:112
msgid "商圈頁_{title}_{0}_查看更多"
msgstr "商圈頁_{title}_{0}_查看更多"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallDetailHeader/index.tsx:96
msgid "商圈頁_{title}_分享"
msgstr "商圈頁_{title}_分享"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallDealsSection/index.tsx:67
msgid "商圈頁_{title}_查看全部餐券"
msgstr "商圈頁_{title}_查看全部餐券"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallShopSection/index.tsx:126
msgid "商圈頁_{title}_查看全部餐廳"
msgstr "商圈頁_{title}_查看全部餐廳"

#. placeholder {0}: floor.name
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallShopSection/index.tsx:83
msgid "商圈頁_{title}_精選店家_{0}"
msgstr "商圈頁_{title}_精選店家_{0}"

#. placeholder {0}: item.title
#. placeholder {1}: index + 1
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallMarketing/index.tsx:54
msgid "商圈頁_{title}_行銷板位_{0}_{1}"
msgstr "商圈頁_{title}_行銷板位_{0}_{1}"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallDetailHeader/index.tsx:71
msgid "商圈頁_{title}_返回"
msgstr "商圈頁_{title}_返回"

#: apps/dp-client/src/screens/home/pages/Search/index.tsx:499
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:811
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:383
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:44
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:74
msgid "商場"
msgstr "商場"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedMallTable/index.web.tsx:50
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:84
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/columns.web.tsx:20
msgid "商場／商圈"
msgstr "商場／商圈"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:433
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:180
msgid "商場/商圈/夜市名稱"
msgstr "商場/商圈/夜市名稱"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:146
msgid "商場/商圈/夜市地理位置"
msgstr "商場/商圈/夜市地理位置"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:176
msgid "商場/夜市內景圖片"
msgstr "商場/夜市內景圖片"

#: apps/dp-admin/src/router/config/routes.web.tsx:110
msgid "商場/夜市商圈列表"
msgstr "商場/夜市商圈列表"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:540
msgid "商場/夜市商圈名稱"
msgstr "商場/夜市商圈名稱"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailMallTable.tsx:47
msgid "商場／夜市商圈名稱"
msgstr "商場／夜市商圈名稱"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/index.web.tsx:35
msgid "商場/夜市商圈管理"
msgstr "商場/夜市商圈管理"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:146
msgid "商場/夜市門口圖片"
msgstr "商場/夜市門口圖片"

#: apps/dp-client/src/configs/page-configs.tsx:299
msgid "商場詳情"
msgstr "商場詳情"

#: apps/dp-business/src/types/orderFilter.ts:185
#: apps/dp-business/src/pages/RefundList/index.tsx:243
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1874
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2182
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:251
#: apps/dp-admin/src/pages/report-center/services/apis.ts:384
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:135
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:71
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:169
#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:72
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchAssignModal/index.web.tsx:80
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:134
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:209
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:172
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:397
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:199
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:41
msgid "商家"
msgstr "商家"

#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:41
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:138
msgid "商家 ID"
msgstr "商家 ID"

#. placeholder {0}: merchant.merchantId
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:113
msgid "商家 ID {0}"
msgstr "商家 ID {0}"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:96
msgid "商家 ID 不能為空"
msgstr "商家 ID 不能為空"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:71
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:93
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:110
msgid "商家 ID 為平台商家 ID"
msgstr "商家 ID 為平台商家 ID"

#. placeholder {0}: merchant.merchantName || merchant.merchantId
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:180
msgid "商家：{0}"
msgstr "商家：{0}"

#. placeholder {0}: Math.floor(Math.random() * 100) + 1
#: apps/dp-admin/src/pages/user-info/services/apis.ts:153
msgid "商家{0}"
msgstr "商家{0}"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:735
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BlueNewContractTab/index.web.tsx:225
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:186
msgid "商家&店家藍新簽約"
msgstr "商家&店家藍新簽約"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:146
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:39
msgid "商家Email"
msgstr "商家Email"

#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:149
msgid "商家ERP資料下載"
msgstr "商家ERP資料下載"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:30
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:52
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:58
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:96
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:132
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:30
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:137
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:49
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:172
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:134
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:23
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:156
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:307
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/OrderInfoCard/index.web.tsx:34
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:77
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:86
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:136
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:239
#: apps/dp-admin/src/pages/merchant/signing-management/index.web.tsx:106
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:393
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:200
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchAssignModal/index.web.tsx:38
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantSummaryHeader/index.web.tsx:39
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/MerchantInfoSummaryHeader/index.web.tsx:35
#: apps/dp-admin/src/pages/merchant/information-review/components/ReviewInfoSection/index.web.tsx:32
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:344
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:738
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:137
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:67
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:100
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:60
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ImageUploadTips/index.web.tsx:111
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:852
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:98
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:45
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:28
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:34
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:86
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/TaskGroupSummary/index.web.tsx:31
msgid "商家ID"
msgstr "商家ID"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/DetailMobile/components/MerchantBasicInfo.web.tsx:66
msgid "商家ID:"
msgstr "商家ID:"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:130
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:242
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/AppealInfoSection/index.web.tsx:76
msgid "商家ID："
msgstr "商家ID："

#. placeholder {0}: formatEmpty(merchant.merchantId)
#. placeholder {0}: second.value ?? '-'
#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:102
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditTaskHeader/index.web.tsx:53
msgid "商家ID：{0}"
msgstr "商家ID：{0}"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/index.web.tsx:35
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingTrend.web.tsx:76
msgid "商家ID不存在"
msgstr "商家ID不存在"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:53
msgid "商家ID為平台店家ID，可以不填"
msgstr "商家ID為平台店家ID，可以不填"

#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:344
msgid "商家上傳"
msgstr "商家上傳"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:259
msgid "商家主動暫停"
msgstr "商家主動暫停"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:495
msgid "商家主動暫停參與"
msgstr "商家主動暫停參與"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:684
#: apps/dp-admin/src/pages/order/services/utils.ts:459
msgid "商家主動發起退款"
msgstr "商家主動發起退款"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:458
msgid "商家主動退出活動"
msgstr "商家主動退出活動"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:25
msgid "商家介紹"
msgstr "商家介紹"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:34
msgid "商家介紹內容涉嫌虛假宣傳，並且包含不當暗示內容，可能誤導消費者。"
msgstr "商家介紹內容涉嫌虛假宣傳，並且包含不當暗示內容，可能誤導消費者。"

#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:372
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:168
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:38
msgid "商家代表圖或logo"
msgstr "商家代表圖或logo"

#: apps/dp-admin/src/pages/merchant/task-list/index.web.tsx:174
#: apps/dp-admin/src/pages/merchant/my-task/index.web.tsx:165
msgid "商家任務管理"
msgstr "商家任務管理"

#: apps/dp-business/src/pages/AddressEdit/index.tsx:705
msgid "商家位置"
msgstr "商家位置"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCommonColumns.tsx:41
msgid "商家信息"
msgstr "商家信息"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:331
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:355
msgid "商家修改報名資訊"
msgstr "商家修改報名資訊"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1060
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1220
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1064
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:311
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:185
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:512
msgid "商家備註"
msgstr "商家備註"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:610
msgid "商家傭金比例"
msgstr "商家傭金比例"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1372
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:950
#: apps/dp-client/src/screens/home/pages/Purchase/components/PurchaseModal/index.tsx:270
msgid "商家優惠"
msgstr "商家優惠"

#: apps/dp-client/src/store/couponStore.ts:421
msgid "商家優惠券領取成功"
msgstr "商家優惠券領取成功"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:146
#: apps/dp-admin/src/pages/report-center/services/apis.ts:159
#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:42
#: apps/dp-admin/src/pages/merchant/merchant-onboard/index.web.tsx:65
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:157
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:228
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/EntryAuditTab/index.web.tsx:178
msgid "商家入駐"
msgstr "商家入駐"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:225
msgid "商家入駐-代表人身份證正面識別"
msgstr "商家入駐-代表人身份證正面識別"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:280
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:314
msgid "商家入駐-實際管理人身分證正面識別"
msgstr "商家入駐-實際管理人身分證正面識別"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:256
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:290
msgid "商家入駐-負責人身分證正面識別"
msgstr "商家入駐-負責人身分證正面識別"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/index.web.tsx:113
msgid "商家入駐審核"
msgstr "商家入駐審核"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/EntryDetailCard/index.web.tsx:29
msgid "商家入駐狀態為：{statusText}{suffix}"
msgstr "商家入駐狀態為：{statusText}{suffix}"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/index.web.tsx:82
msgid "商家入駐與簽約"
msgstr "商家入駐與簽約"

#: apps/dp-admin/src/pages/merchant/merchant-onboard/index.web.tsx:62
msgid "商家入駐詳情"
msgstr "商家入駐詳情"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/index.web.tsx:286
#: apps/dp-admin/src/pages/merchant/shop-list/index.web.tsx:284
#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:309
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:969
msgid "商家分配"
msgstr "商家分配"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:524
#: apps/dp-business/src/pages/AddStore/CategoryPage.tsx:249
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:42
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:138
#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:102
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:152
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:20
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:31
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:169
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:552
msgid "商家分類"
msgstr "商家分類"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1000
msgid "商家分類:"
msgstr "商家分類:"

#: apps/dp-client/src/configs/page-configs.tsx:113
#: apps/dp-client/src/configs/page-configs.tsx:338
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:144
msgid "商家列表"
msgstr "商家列表"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:82
msgid "商家刪除失敗"
msgstr "商家刪除失敗"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:76
msgid "商家刪除成功"
msgstr "商家刪除成功"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1827
msgid "商家券碼"
msgstr "商家券碼"

#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:133
msgid "商家區域"
msgstr "商家區域"

#: apps/dp-business/src/pages/RefundList/index.tsx:122
msgid "商家同意退款"
msgstr "商家同意退款"

#: apps/dp-admin/src/router/config/routes.web.tsx:175
#: apps/dp-admin/src/pages/marketing/services/constants.ts:217
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:135
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/CombinedListForm/index.web.tsx:30
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/CombinedListForm/index.web.tsx:31
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:879
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:218
msgid "商家名單"
msgstr "商家名單"

#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:46
msgid "商家名單ID"
msgstr "商家名單ID"

#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupSelector/index.web.tsx:113
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupSelector/index.web.tsx:210
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupSelector/index.web.tsx:243
msgid "商家名單加載失敗"
msgstr "商家名單加載失敗"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:482
msgid "商家名單及角色圈選"
msgstr "商家名單及角色圈選"

#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:49
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:79
msgid "商家名單名稱"
msgstr "商家名單名稱"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepMerchantGroup.web.tsx:30
msgid "商家名單圈選"
msgstr "商家名單圈選"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:155
msgid "商家名單已建立，匯入任務執行中"
msgstr "商家名單已建立，匯入任務執行中"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:89
msgid "商家名單描述"
msgstr "商家名單描述"

#: apps/dp-admin/src/router/config/routes.web.tsx:191
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:488
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:347
msgid "商家名單詳情"
msgstr "商家名單詳情"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:873
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:303
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:486
#: apps/dp-business/src/utils/moduleTypeMapping.ts:251
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:654
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:800
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:849
#: apps/dp-business/src/pages/OrderList/index.tsx:514
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:50
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/columns.tsx:51
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1948
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:332
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:362
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:404
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:434
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:36
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:131
#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:95
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:300
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:340
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:392
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:432
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:304
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:50
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:26
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:65
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/OrderInfoCard/index.web.tsx:37
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:80
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchAssignModal/index.web.tsx:37
#: apps/dp-admin/src/pages/merchant/signing-management/index.web.tsx:112
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchAssignModal/index.web.tsx:44
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:142
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:99
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/services/utils.ts:43
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantSummaryHeader/index.web.tsx:38
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:159
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:170
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/services/utils.ts:43
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/MerchantInfoSummaryHeader/index.web.tsx:34
#: apps/dp-admin/src/pages/merchant/information-review/components/ReviewInfoSection/index.web.tsx:36
#: apps/dp-admin/src/pages/merchant/information-review/components/InformationChangeSection/index.web.tsx:78
#: apps/dp-admin/src/pages/merchant/information-error/index.web.tsx:32
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:338
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:727
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:56
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:139
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:69
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:107
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ImageUploadTips/index.web.tsx:118
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:107
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:711
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:84
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:305
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:74
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:50
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/TaskGroupSummary/index.web.tsx:34
msgid "商家名稱"
msgstr "商家名稱"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:97
#: apps/dp-admin/src/pages/merchant/task-list/components/FollowUpHistoryModal/index.web.tsx:68
#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:124
#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:176
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:238
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/AppealInfoSection/index.web.tsx:80
msgid "商家名稱："
msgstr "商家名稱："

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:153
#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:60
msgid "商家名稱/ID"
msgstr "商家名稱/ID"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:156
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:274
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:243
msgid "商家名稱/商家ID"
msgstr "商家名稱/商家ID"

#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:58
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:58
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:54
msgid "商家名稱/統編"
msgstr "商家名稱/統編"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/chainReportFilterFields.ts:31
#: apps/dp-business/src/pages/ChainDashboard/components/reports/chainReportFilterFields.ts:39
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:233
msgid "商家名稱／統編"
msgstr "商家名稱／統編"

#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:250
msgid "商家名稱不能超過50個字符"
msgstr "商家名稱不能超過50個字符"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:163
msgid "商家名稱資訊完整度評分"
msgstr "商家名稱資訊完整度評分"

#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:48
msgid "商家和用戶都將收到退款通知，錢款將進行退回至原帳戶"
msgstr "商家和用戶都將收到退款通知，錢款將進行退回至原帳戶"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:827
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:307
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:412
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:287
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:642
msgid "商家品牌"
msgstr "商家品牌"

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:265
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:794
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:92
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:100
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:18
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:30
#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantImages/index.web.tsx:64
msgid "商家圖片"
msgstr "商家圖片"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:950
msgid "商家圖片："
msgstr "商家圖片："

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1957
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:104
#: apps/dp-admin/src/pages/merchant/shop-detail/components/DetailMobile/components/MerchantContactInfo.web.tsx:44
#: apps/dp-admin/src/pages/merchant/information-review/components/InformationChangeSection/index.web.tsx:77
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:756
msgid "商家地址"
msgstr "商家地址"

#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:202
msgid "商家報名時間"
msgstr "商家報名時間"

#: apps/dp-business/src/servers/activity/api.ts:197
msgid "商家報名活動失敗"
msgstr "商家報名活動失敗"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:211
msgid "商家大頭照"
msgstr "商家大頭照"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:768
msgid "商家套餐券"
msgstr "商家套餐券"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/config.ts:87
msgid "商家對應的google網址"
msgstr "商家對應的google網址"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:83
msgid "商家導入"
msgstr "商家導入"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:784
msgid "商家已取消"
msgstr "商家已取消"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:670
#: apps/dp-admin/src/pages/order/services/utils.ts:424
msgid "商家已拒絕"
msgstr "商家已拒絕"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:664
#: apps/dp-admin/src/pages/order/services/utils.ts:409
msgid "商家已通過"
msgstr "商家已通過"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:80
msgid "商家建立失敗"
msgstr "商家建立失敗"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:74
msgid "商家建立成功"
msgstr "商家建立成功"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:106
msgid "商家影片"
msgstr "商家影片"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:132
msgid "商家後臺上傳菜單圖片失敗"
msgstr "商家後臺上傳菜單圖片失敗"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:531
msgid "商家恢復參與活動"
msgstr "商家恢復參與活動"

#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:107
msgid "商家承擔優惠"
msgstr "商家承擔優惠"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/MerchantComplaintSection/index.web.tsx:54
msgid "商家投訴內容"
msgstr "商家投訴內容"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:457
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1493
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1569
msgid "商家折扣"
msgstr "商家折扣"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1555
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1631
msgid "商家拒絕率"
msgstr "商家拒絕率"

#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:16
msgid "商家提交"
msgstr "商家提交"

#: apps/dp-client/src/configs/page-configs.tsx:2858
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:157
msgid "商家搜尋"
msgstr "商家搜尋"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2514
#: apps/dp-admin/src/pages/order/services/utils.ts:561
msgid "商家撤銷核銷"
msgstr "商家撤銷核銷"

#: apps/dp-admin/src/pages/transaction/service-management/components/MerchantPackageServiceOverview/index.web.tsx:93
msgid "商家操作記錄"
msgstr "商家操作記錄"

#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:145
msgid "商家數據複製記錄"
msgstr "商家數據複製記錄"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:78
msgid "商家會在1-3天內完成退款處理，請耐心等待。"
msgstr "商家會在1-3天內完成退款處理，請耐心等待。"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:36
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2513
#: apps/dp-admin/src/pages/order/services/utils.ts:507
#: apps/dp-admin/src/pages/order/services/utils.ts:556
msgid "商家核銷"
msgstr "商家核銷"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantTags/index.web.tsx:58
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:625
msgid "商家標籤"
msgstr "商家標籤"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:168
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:110
msgid "商家檢索"
msgstr "商家檢索"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:471
#: apps/dp-business/src/components/MerchantBenefits/index.tsx:69
#: apps/dp-admin/src/router/config/routes.web.tsx:221
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:519
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:439
msgid "商家權益"
msgstr "商家權益"

#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:338
msgid "商家活動"
msgstr "商家活動"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/index.tsx:127
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/index.tsx:386
msgid "商家活動平台"
msgstr "商家活動平台"

#: apps/dp-admin/src/router/config/routes.web.tsx:252
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:527
msgid "商家活動編輯"
msgstr "商家活動編輯"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:420
msgid "商家活動詳情"
msgstr "商家活動詳情"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:611
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:148
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:240
#: apps/dp-admin/src/pages/merchant/signing-management/index.web.tsx:118
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:622
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:296
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:126
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:240
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:225
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:228
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:677
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:188
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:205
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:79
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:55
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:504
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:71
msgid "商家狀態"
msgstr "商家狀態"

#: apps/dp-admin/src/modules/hooks/options/useShopStatusOptions.ts:96
#: apps/dp-admin/src/modules/hooks/options/useMerchantStatusOptions.ts:98
msgid "商家狀態資料取得失敗"
msgstr "商家狀態資料取得失敗"

#: apps/dp-admin/src/modules/hooks/options/useShopStatusOptions.ts:105
#: apps/dp-admin/src/modules/hooks/options/useMerchantStatusOptions.ts:107
msgid "商家狀態資料取得異常"
msgstr "商家狀態資料取得異常"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1749
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1765
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:526
#: apps/dp-admin/src/modules/constants/options.ts:651
msgid "商家確認中"
msgstr "商家確認中"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1331
msgid "商家確認憑證"
msgstr "商家確認憑證"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1391
msgid "商家確認截圖（最多上傳5張）"
msgstr "商家確認截圖（最多上傳5張）"

#: apps/dp-business/src/constants/enums.ts:519
#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:88
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:22
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:11
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:415
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:120
msgid "商家端"
msgstr "商家端"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:29
msgid "商家端創建"
msgstr "商家端創建"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:908
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:492
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:418
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:303
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:129
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:582
msgid "商家等級"
msgstr "商家等級"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:824
#: apps/dp-admin/src/router/config/routes.web.tsx:40
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:41
#: apps/dp-admin/src/configs/page-configs.tsx:25
#: apps/dp-admin/src/configs/page-configs.tsx:26
msgid "商家管理"
msgstr "商家管理"

#: apps/dp-business/src/pages/MerchantDashboard/components/SideMenu.tsx:85
msgid "商家管理平台"
msgstr "商家管理平台"

#: apps/dp-business/src/pages/SimpleDashboard/SimpleLayout.tsx:121
msgid "商家管理平台 簡易版"
msgstr "商家管理平台 簡易版"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterSelects.tsx:170
msgid "商家篩選"
msgstr "商家篩選"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:362
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:364
msgid "商家簽約"
msgstr "商家簽約"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:323
msgid "商家簽約 - {contractLabel}"
msgstr "商家簽約 - {contractLabel}"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:450
msgid "商家簽約 — 基礎合約"
msgstr "商家簽約 — 基礎合約"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:581
msgid "商家簽約－基礎合約"
msgstr "商家簽約－基礎合約"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:103
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:123
msgid "商家簽約-身分證正面識別"
msgstr "商家簽約-身分證正面識別"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:40
msgid "商家簽約狀態"
msgstr "商家簽約狀態"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:118
#: apps/dp-admin/src/pages/merchant/signing-management/index.web.tsx:88
msgid "商家簽約管理"
msgstr "商家簽約管理"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:735
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:566
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/index.web.tsx:74
msgid "商家簽約詳情"
msgstr "商家簽約詳情"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/ContractInfoUpload/index.web.tsx:16
msgid "商家簽約資訊上傳"
msgstr "商家簽約資訊上傳"

#: apps/dp-client/src/configs/page-configs.tsx:550
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/DynamicPackageFields/index.web.tsx:50
msgid "商家組"
msgstr "商家組"

#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:164
msgid "商家組列表"
msgstr "商家組列表"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/DynamicPackageFields/index.web.tsx:71
msgid "商家組加載失敗"
msgstr "商家組加載失敗"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/voucherUsageColumns.tsx:78
msgid "商家結帳日期"
msgstr "商家結帳日期"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:648
msgid "商家結帳服務"
msgstr "商家結帳服務"

#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:36
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:90
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:30
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:332
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantSummaryHeader/index.web.tsx:40
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/MerchantInfoSummaryHeader/index.web.tsx:36
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:158
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:312
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/TaskGroupSummary/index.web.tsx:37
msgid "商家統編"
msgstr "商家統編"

#: apps/dp-admin/src/modules/constants/options.ts:66
msgid "商家維護待跟進"
msgstr "商家維護待跟進"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2705
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:201
msgid "商家總計補貼"
msgstr "商家總計補貼"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:541
msgid "商家聚流狀態"
msgstr "商家聚流狀態"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:173
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/SigningAuditTab/index.web.tsx:160
msgid "商家聚流簽約"
msgstr "商家聚流簽約"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/index.web.tsx:148
msgid "商家聚流簽約審核"
msgstr "商家聚流簽約審核"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:50
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:84
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCommonColumns.tsx:76
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:429
msgid "商家自開發票"
msgstr "商家自開發票"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:563
msgid "商家英文名不能超過100個字符"
msgstr "商家英文名不能超過100個字符"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:76
msgid "商家處理中"
msgstr "商家處理中"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:541
msgid "商家處理中，款項會在 1-3 個工作日內退回"
msgstr "商家處理中，款項會在 1-3 個工作日內退回"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:413
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:850
msgid "商家行銷管理"
msgstr "商家行銷管理"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:823
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1157
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/IncomeCalculationSection.tsx:148
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:689
#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:37
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:236
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:131
msgid "商家補貼"
msgstr "商家補貼"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:38
msgid "商家補貼後"
msgstr "商家補貼後"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:32
#: apps/dp-admin/src/pages/order/merchant-order-list/index.web.tsx:65
msgid "商家訂單列表"
msgstr "商家訂單列表"

#: apps/dp-admin/src/router/config/routes.web.tsx:289
#: apps/dp-admin/src/pages/data-center/merchant-stats/index.web.tsx:29
msgid "商家評價統計"
msgstr "商家評價統計"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:629
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:571
msgid "商家評分"
msgstr "商家評分"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:168
#: apps/dp-admin/src/pages/data-center/merchant-reviews/index.web.tsx:30
msgid "商家評論"
msgstr "商家評論"

#: apps/dp-client/src/configs/page-configs.tsx:151
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:139
#: apps/dp-admin/src/pages/merchant/task-list/components/ActionButtons/index.web.tsx:91
#: apps/dp-admin/src/pages/merchant/task-list/components/ActionButtons/index.web.tsx:92
#: apps/dp-admin/src/pages/merchant/shop-detail/components/DetailMobile/components/DetailHeader.web.tsx:55
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:221
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/index.web.tsx:139
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/index.web.tsx:201
#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantBasicInfo/index.web.tsx:74
msgid "商家詳情"
msgstr "商家詳情"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:789
msgid "商家詳情頁展示的位置/形式"
msgstr "商家詳情頁展示的位置/形式"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:424
msgid "商家變為已簽約後，服務自動開啟"
msgstr "商家變為已簽約後，服務自動開啟"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractEditTabs/index.web.tsx:34
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicContractTabs/index.web.tsx:29
msgid "商家資料"
msgstr "商家資料"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:141
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:182
msgid "商家資料審核"
msgstr "商家資料審核"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:640
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:125
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:223
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:48
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:241
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:79
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:66
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:354
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:155
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:66
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:97
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:114
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:335
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:513
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:235
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:55
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/index.web.tsx:83
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:127
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:69
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:289
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:288
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:127
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:201
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/TaskGroupSummary/index.web.tsx:26
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:228
msgid "商家資訊"
msgstr "商家資訊"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:89
msgid "商家資訊取得失敗"
msgstr "商家資訊取得失敗"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:263
#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:264
#: apps/dp-business/src/pages/ImageManagement/index.tsx:202
#: apps/dp-business/src/pages/BusinessHours/index.tsx:649
#: apps/dp-business/src/pages/AveragePrice/index.tsx:182
#: apps/dp-business/src/pages/AddressEdit/index.tsx:500
msgid "商家資訊取得失敗，請稍後重試"
msgstr "商家資訊取得失敗，請稍後重試"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1644
#: apps/dp-admin/src/pages/merchant/service/constants.ts:442
msgid "商家資訊完善"
msgstr "商家資訊完整填寫"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:81
msgid "商家資訊更新失敗"
msgstr "商家資訊更新失敗"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:75
msgid "商家資訊更新成功"
msgstr "商家資訊更新成功"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/DetailMobile/index.web.tsx:74
msgid "商家資訊正在審核中，無法編輯"
msgstr "商家資訊正在審核中，無法編輯"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:33
msgid "商家資訊異常"
msgstr "商家資訊異常"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:927
msgid "商家輸入資訊"
msgstr "商家輸入資訊"

#: apps/dp-admin/src/pages/other/services/constants.ts:51
msgid "商家通知"
msgstr "商家通知"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:356
msgid "商家通知規則"
msgstr "商家通知規則"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:197
msgid "商家連鎖樹掛接&結算"
msgstr "商家連鎖樹掛接&結算"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/PageHeader/index.web.tsx:24
msgid "商家進駐審核"
msgstr "商家進駐審核"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:297
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:47
msgid "商家選擇"
msgstr "商家選擇"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:682
msgid "商家選擇配置"
msgstr "商家選擇配置"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:55
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:86
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:434
msgid "商家開立收據"
msgstr "商家開立收據"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:47
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:169
msgid "商家電話"
msgstr "商家電話"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:443
msgid "商家靜態資訊審核"
msgstr "商家靜態資訊審核"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:90
msgid "商家頁評論排序錯亂且部分缺漏"
msgstr "商家頁評論排序錯亂且部分缺漏"

#: apps/dp-admin/src/pages/marketing/activity-create/components/MerchantPreviewTable/index.web.tsx:48
msgid "商家預覽"
msgstr "商家預覽"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:153
#: apps/dp-business/src/utils/moduleTypeMapping.ts:250
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:234
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:96
#: apps/dp-admin/src/pages/merchant/information-review/components/InformationChangeSection/index.web.tsx:76
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:337
msgid "商家類別"
msgstr "商家類別"

#: apps/dp-admin/src/modules/hooks/options/useCategoryOptions.ts:101
msgid "商家類別資料取得失敗"
msgstr "商家類別資料取得失敗"

#: apps/dp-admin/src/modules/hooks/options/useCategoryOptions.ts:110
msgid "商家類別資料取得異常"
msgstr "商家類別資料取得異常"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:154
msgid "商家類別資訊完整度評分"
msgstr "商家類別資訊完整度評分"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:100
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/BusinessLicenseInfo/index.web.tsx:31
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:65
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:99
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:146
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:65
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:187
msgid "商家類型"
msgstr "商家類型"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/DynamicPackageFields/index.web.tsx:76
msgid "商家類目"
msgstr "商家類目"

#: apps/dp-business/src/pages/SimpleDashboard/hooks/useSimpleShop.ts:30
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:205
msgid "商家餐廳"
msgstr "商家餐廳"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:83
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1750
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1766
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:528
#: apps/dp-admin/src/modules/constants/options.ts:656
msgid "商家駁回"
msgstr "商家駁回"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:127
msgid "商店影像"
msgstr "商店影像"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:181
msgid "商店爭議款信箱"
msgstr "商店爭議款信箱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:582
msgid "商店簡介不能超過200個字符"
msgstr "商店簡介不能超過200個字符"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:87
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:93
#: apps/dp-admin/src/pages/merchant/audit-detail/components/BusinessLicense/index.web.tsx:49
#: apps/dp-admin/src/pages/merchant/audit-detail/components/BusinessLicense/index.web.tsx:54
msgid "商業登記副本"
msgstr "商業登記副本"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:767
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:780
msgid "商業登記副本上傳欄"
msgstr "商業登記副本上傳欄"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/BusinessLicenseInfo/index.web.tsx:27
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:75
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:199
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:206
msgid "商業登記副本資訊"
msgstr "商業登記副本資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:394
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:156
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:132
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:142
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:37
msgid "商業登記抄本"
msgstr "商業登記抄本"

#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:183
msgid "商詳頁顯示位置"
msgstr "商詳頁顯示位置"

#: apps/dp-admin/src/pages/audit-center/components/AuditIssueItem/index.web.tsx:102
msgid "問題內容"
msgstr "問題內容"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:382
#: apps/dp-client/src/screens/account/pages/advice/advice-feedback/index.tsx:283
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:230
msgid "問題分類"
msgstr "問題分類"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:293
msgid "問題原因"
msgstr "問題原因"

#: apps/dp-admin/src/pages/audit-center/components/RenderContent/index.web.tsx:152
msgid "問題圖片"
msgstr "問題圖片"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:344
#: apps/dp-client/src/configs/page-configs.tsx:1584
#: apps/dp-client/src/configs/page-configs.tsx:1586
msgid "問題或建議回報"
msgstr "問題或建議回報"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:275
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:398
#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:320
#: apps/dp-client/src/components/FeedBackModal/index.tsx:122
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:290
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:467
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:245
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:318
msgid "問題描述"
msgstr "問題描述"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:82
msgid "問題描述 :"
msgstr "問題描述 :"

#: apps/dp-admin/src/pages/merchant/information-error/components/ErrorInfoSection/index.web.tsx:91
msgid "問題描述："
msgstr "問題描述："

#: apps/dp-client/src/screens/account/pages/advice/advice-detail/index.tsx:150
#: apps/dp-client/src/configs/page-configs.tsx:1567
#: apps/dp-client/src/configs/page-configs.tsx:1569
msgid "問題詳情"
msgstr "問題詳情"

#: apps/dp-admin/src/pages/audit-center/components/AuditIssueItem/index.web.tsx:94
msgid "問題說明"
msgstr "問題說明"

#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:49
msgid "問題跟蹤"
msgstr "問題追蹤"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/CorrectionModal.tsx:183
#: apps/dp-client/src/components/FeedBackModal/index.tsx:295
msgid "問題選擇"
msgstr "問題選擇"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:99
msgid "問題附件 :"
msgstr "問題附件 :"

#: apps/dp-admin/src/pages/audit-center/components/AuditIssueItem/index.web.tsx:78
msgid "問題類別"
msgstr "問題類別"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:44
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:28
#: apps/dp-admin/src/pages/customer-service/components/TicketTable.web.tsx:39
msgid "問題類型"
msgstr "問題類型"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:72
msgid "問題類型 :"
msgstr "問題類型 :"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:377
msgid "單一權益由事件及獎勵自動帶出，可自行修改。"
msgstr "單一權益由事件及獎勵自動帶出，可自行修改。"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:227
msgid "單一選單的功能權限超出上限"
msgstr "單一選單的功能權限超出上限"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:109
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:145
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:155
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/MealSummaryCard.tsx:28
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/diningPeopleTitle.ts:14
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:271
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:316
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:187
msgid "單人餐"
msgstr "單人餐"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:197
msgid "單位"
msgstr "單位"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:223
msgid "單個影片大小不超過200MB"
msgstr "單個影片大小不超過200MB"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopActionButtons/index.web.tsx:44
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:362
msgid "單個新增"
msgstr "單個新增"

#: apps/dp-admin/src/pages/org-tree/org-create/services/constants.ts:115
#: apps/dp-admin/src/components/FileUpload/index.web.tsx:92
msgid "單個檔案大小不超過 5M"
msgstr "單個檔案大小不超過 5M"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:190
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:255
msgid "單價"
msgstr "單價"

#: apps/dp-business/src/pages/MenuItemForm.tsx:522
#: apps/dp-business/src/pages/ImageManagement/components/imageTips.tsx:76
#: apps/dp-admin/src/pages/merchant/components/imageTips/index.web.tsx:40
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:464
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:135
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:149
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:164
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:179
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:194
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:209
msgid "單張照片大小不超過5MB"
msgstr "單張照片大小不超過5MB"

#: apps/dp-admin/src/pages/org-tree/components/S9BlockModal/index.web.tsx:40
msgid "單據編號"
msgstr "單據編號"

#: apps/dp-admin/src/pages/org-tree/components/S9BlockModal/index.web.tsx:34
msgid "單據類型"
msgstr "單據類型"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/OverviewCards.web.tsx:50
msgid "單日人均交易次數"
msgstr "單日人均交易次數"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:75
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:77
msgid "單檔大小不可超過 20MB"
msgstr "單檔大小不可超過 20MB"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:325
msgid "單次使用"
msgstr "單次使用"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1481
msgid "單次最多保存 {MAX_BINDING_ITEMS} 項掛接變更"
msgstr "單次最多保存 {MAX_BINDING_ITEMS} 項掛接變更"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:336
msgid "單次最多可選擇{selectionLimit}張圖片"
msgstr "單次最多可選擇{selectionLimit}張圖片"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1193
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1687
msgid "單次最多提交 {MAX_BINDING_ITEMS} 項掛接變更"
msgstr "單次最多提交 {MAX_BINDING_ITEMS} 項掛接變更"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1198
msgid "單次最多提交 {MAX_SETTLEMENT_ROUTE_ITEMS} 項結算路徑變更"
msgstr "單次最多提交 {MAX_SETTLEMENT_ROUTE_ITEMS} 項結算路徑變更"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:257
msgid "單次最多選擇 {MAX_SELECT} 張結算單"
msgstr "單次最多選擇 {MAX_SELECT} 張結算單"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:195
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/hooks.ts:167
msgid "單次最多重試 {RETRY_MAX} 條，請縮小範圍"
msgstr "單次最多重試 {RETRY_MAX} 條，請縮小範圍"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:220
msgid "單次移除授權的節點數量超出上限"
msgstr "單次移除授權的節點數量超出上限"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountUnbindModal.tsx:60
msgid "單次解除授權的節點數量超出上限"
msgstr "單次解除授權的節點數量超出上限"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardLimitConfigEditor/index.web.tsx:72
msgid "單用戶次數上限"
msgstr "單用戶次數上限"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:340
msgid "單用戶發放數量"
msgstr "單用戶發放數量"

#. placeholder {0}: claimedCouponData.maximumDiscount || 0
#. placeholder {0}: claimedCouponData.maximumDiscount
#. placeholder {0}: claimedCouponData?.maximumDiscount || 0
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:133
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:185
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:355
#: apps/dp-client/src/screens/home/pages/CouponShopList/components/CouponCard.tsx:108
msgid "單筆最高折${0}"
msgstr "單筆最高折${0}"

#: apps/dp-client/src/screens/home/pages/UserGift/components/SlideInCouponCard/index.tsx:125
#: apps/dp-client/src/screens/home/pages/UserGift/components/SlideInCouponCard/index.tsx:213
msgid "單筆最高折${maximumDiscount}"
msgstr "單筆最高折${maximumDiscount}"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:300
msgid "單色"
msgstr "單色"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:277
msgid "單號："
msgstr "單號："

#: apps/dp-business/src/data/regions.ts:21
msgid "嘉義市"
msgstr "嘉義市"

#: apps/dp-business/src/data/regions.ts:22
msgid "嘉義縣"
msgstr "嘉義縣"

#: apps/dp-client/src/screens/home/pages/Search/index.tsx:680
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:787
msgid "嘗試使用其他關鍵詞"
msgstr "嘗試使用其他關鍵詞"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:808
msgid "嘗試訪問相機"
msgstr "嘗試啟動相機"

#: apps/dp-admin/src/pages/audit-center/components/AuditIssueItem/index.web.tsx:82
msgid "嚴重度"
msgstr "嚴重度"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:69
msgid "嚴重影響／部分功能失效"
msgstr "嚴重影響／部分功能失效"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:130
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:131
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:563
#: apps/dp-business/src/components/DatePicker.tsx:235
#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:17
msgid "四"
msgstr "四"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:388
msgid "四、收據寄送方式"
msgstr "四、收據寄送方式"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:335
msgid "四、發票寄送方式"
msgstr "四、發票寄送方式"

#: apps/dp-business/src/servers/chain/nodeApi.ts:164
#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeNodeRow.tsx:33
#: apps/dp-business/src/components/CascadeSelector/index.tsx:111
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:76
msgid "四級"
msgstr "四級"

#: apps/dp-admin/src/pages/org-tree/org-create/services/constants.ts:30
msgid "四級/末級"
msgstr "四級/末級"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:147
msgid "四線城市"
msgstr "四線城市"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:80
msgid "回傳失敗"
msgstr "回傳失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:79
msgid "回傳成功"
msgstr "回傳成功"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:115
msgid "回傳所屬第三方"
msgstr "回傳所屬第三方"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:133
msgid "回傳時間"
msgstr "回傳時間"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:139
msgid "回傳狀態"
msgstr "回傳狀態"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:55
msgid "回傳第三方"
msgstr "回傳第三方"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:122
msgid "回傳第三方狀態"
msgstr "回傳第三方狀態"

#: apps/dp-client/src/screens/diary/pages/add-merchant/submit-success/index.tsx:53
msgid "回到首頁"
msgstr "回到首頁"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:756
msgid "回應一下..."
msgstr "回應一下..."

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:83
msgid "回應您的評論、問題和請求"
msgstr "回應您的評論、問題和請求"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:245
#: apps/dp-client/src/screens/home/pages/Note/components/ReviewCard/index.tsx:119
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:714
#: apps/dp-client/src/screens/home/components/ReplayCard/index.tsx:261
#: apps/dp-client/src/screens/home/components/ReplayCard/index.tsx:297
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:239
#: apps/dp-client/src/screens/diary/components/DiaryActions/index.tsx:66
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:136
msgid "回覆"
msgstr "回覆"

#. placeholder {0}: replyTarget.nickName
#. placeholder {0}: replyTarget.userName
#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:564
#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:889
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:512
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:901
msgid "回覆 {0}"
msgstr "回覆 {0}"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:543
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:361
msgid "回覆 {userName}"
msgstr "回覆 {userName}"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:755
msgid "回覆 @{replyTarget}"
msgstr "回覆 @{replyTarget}"

#. placeholder {0}: reply.userName
#. placeholder {0}: replyTarget?.userName
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:256
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:275
msgid "回覆{0}"
msgstr "回覆{0}"

#. placeholder {0}: comment.replyTo
#. placeholder {0}: reply.replyTo
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:219
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:395
msgid "回覆{0}："
msgstr "回覆{0}："

#: apps/dp-client/src/screens/account/pages/notifications/components/InteractionNotificationCard/index.tsx:64
#: apps/dp-client/src/screens/account/pages/notifications/components/InteractionNotificationCard/index.tsx:66
msgid "回覆了你的留言"
msgstr "回覆了你的留言"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:394
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:451
msgid "回覆刪除成功"
msgstr "回覆刪除成功"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:112
msgid "回覆失敗，請檢查網路連線"
msgstr "回覆失敗，請檢查網路連線"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:108
msgid "回覆失敗，請稍後重試"
msgstr "回覆失敗，請稍後重試"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:441
msgid "回覆失敗，請重試"
msgstr "回覆失敗，請重試"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:594
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:418
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:478
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:101
msgid "回覆成功"
msgstr "回覆成功"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:108
msgid "回覆數"
msgstr "回覆數"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:245
msgid "回覆文字描述"
msgstr "回覆文字描述"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/OverviewCards.web.tsx:23
msgid "回覆率"
msgstr "回覆率"

#: apps/dp-business/src/utils/permissionData.ts:84
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:129
msgid "回覆評價"
msgstr "回覆評價"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:122
msgid "回頭客率"
msgstr "回頭客率"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopOffline.tsx:56
#: apps/dp-client/src/screens/diary/pages/comment-success/index.tsx:183
msgid "回首頁"
msgstr "回首頁"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:113
msgid "因網絡線路問題退款失敗"
msgstr "因網絡線路問題退款失敗"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:403
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:502
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:229
#: apps/dp-admin/src/pages/marketing/components/CombinedListForm/index.web.tsx:188
msgid "固定"
msgstr "固定"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:495
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:270
msgid "固定分組"
msgstr "固定分組"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:26
#: apps/dp-admin/src/pages/marketing/user-group-create/components/SaveModeSelector/index.web.tsx:36
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:24
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:708
#: apps/dp-admin/src/modules/constants/userGroup.ts:21
msgid "固定名單"
msgstr "固定名單"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:860
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:928
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:62
msgid "固定套餐"
msgstr "固定套餐"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2019
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:864
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:928
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:578
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:585
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:633
#: apps/dp-business/src/pages/CouponVerification/components/VerificationModal.tsx:242
msgid "固定套餐組合"
msgstr "固定套餐組合"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:101
msgid "固定尺寸"
msgstr "固定尺寸"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:423
msgid "固定日期"
msgstr "固定日期"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:33
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:196
msgid "固定時間"
msgstr "固定時間"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:1363
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:209
msgid "固定營業時間"
msgstr "固定營業時間"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:52
msgid "固定獎勵"
msgstr "固定獎勵"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:357
msgid "圈選商家"
msgstr "圈選商家"

#: apps/dp-admin/src/pages/marketing/activity-detail-list/index.web.tsx:72
msgid "圈選商家列表"
msgstr "圈選商家列表"

#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:135
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:116
msgid "圈選商家數量"
msgstr "圈選商家數量"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/searchConfig.ts:37
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:235
msgid "圈選方式"
msgstr "圈選方式"

#: apps/dp-client/src/screens/home/utils/order.ts:606
#: apps/dp-client/src/screens/home/utils/order.ts:632
#: apps/dp-client/src/screens/home/utils/order.ts:648
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1767
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1927
msgid "國定節假日不可用"
msgstr "國定節假日不可用"

#: apps/dp-business/src/store/HolidayContext.tsx:136
#: apps/dp-business/src/store/HolidayContext.tsx:136
#: apps/dp-business/src/store/HolidayContext.tsx:149
#: apps/dp-business/src/store/HolidayContext.tsx:149
msgid "國慶"
msgstr "國慶"

#: apps/dp-business/src/store/HolidayContext.tsx:137
#: apps/dp-business/src/store/HolidayContext.tsx:202
msgid "國慶節"
msgstr "國慶節"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:146
msgid "國民身分證"
msgstr "國民身分證"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:344
msgid "國際格式注意事項："
msgstr "國際格式注意事項："

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:137
msgid "圓形"
msgstr "圓形"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/ImageAuditItem/index.web.tsx:52
msgid "圖"
msgstr "圖"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:245
msgid "圖≥"
msgstr "圖≥"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:82
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:414
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:48
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:49
msgid "圖像處理中&hellip;"
msgstr "圖像處理中&hellip;"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:78
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:410
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:44
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:45
msgid "圖像載入中&hellip;"
msgstr "圖像載入中&hellip;"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:349
msgid "圖像輸出大小"
msgstr "圖像輸出大小"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:265
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:416
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:59
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:60
msgid "圖像邊緣"
msgstr "圖像邊緣"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:300
msgid "圖文筆記"
msgstr "圖文筆記"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:324
msgid "圖框"
msgstr "圖框"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:79
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:135
msgid "圖標"
msgstr "圖標"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:506
msgid "圖標設定"
msgstr "圖標設定"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/Media/index.tsx:100
#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/MediaReplacer.tsx:61
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Media/index.tsx:116
#: apps/dp-business/src/utils/moduleTypeMapping.ts:72
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1003
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:218
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:299
#: apps/dp-business/src/pages/ImageManagement/index.tsx:326
#: apps/dp-business/src/pages/ImageManagement/index.tsx:386
#: apps/dp-business/src/pages/ImageManagement/index.tsx:431
#: apps/dp-business/src/pages/ImageManagement/index.tsx:503
#: apps/dp-business/src/components/PhotoUploader/validation.ts:110
#: apps/dp-business/src/components/PhotoUploader/upload.ts:363
#: apps/dp-business/src/components/PhotoUploader/upload.ts:409
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:86
#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:46
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PosterListField/SortableRow.web.tsx:77
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:169
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:144
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:171
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:261
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:126
#: apps/dp-admin/src/pages/merchant/components/ImageGallery/index.web.tsx:34
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:121
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:134
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:163
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/services/hooks.ts:28
#: apps/dp-admin/src/components/PrivateImage/index.web.tsx:120
#: apps/dp-admin/src/components/PrivateImage/index.web.tsx:144
#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:627
#: apps/dp-admin/src/components/HeicImage/index.web.tsx:47
msgid "圖片"
msgstr "圖片"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PosterListField/SortableRow.web.tsx:47
msgid "圖片 {index}"
msgstr "圖片 {index}"

#. placeholder {0}: index + 1
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/ImageAuditItem/index.web.tsx:60
msgid "圖片{0}"
msgstr "圖片{0}"

#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:230
msgid "圖片/文件"
msgstr "圖片/文件"

#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:226
msgid "圖片/文件<0>*</0>"
msgstr "圖片/文件<0>*</0>"

#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:106
msgid "圖片URL"
msgstr "圖片URL"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:596
#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:201
msgid "圖片上傳"
msgstr "圖片上傳"

#: apps/dp-admin/src/components/RichTextEditor/services/hooks.ts:79
msgid "圖片上傳中，請稍候"
msgstr "圖片上傳中，請稍候"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:131
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:311
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:121
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:368
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:120
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:152
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:185
#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:303
#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:308
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:186
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:191
#: apps/dp-admin/src/components/RichTextEditor/services/hooks.ts:91
#: apps/dp-admin/src/components/RichTextEditor/services/hooks.ts:111
#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:641
msgid "圖片上傳失敗"
msgstr "圖片上傳失敗"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:221
msgid "圖片上傳失敗，請檢查圖片是否符合要求"
msgstr "圖片上傳失敗，請檢查圖片是否符合要求"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:282
#: apps/dp-business/src/components/PhotoUploader/upload.ts:160
msgid "圖片上傳失敗，請稍後重試"
msgstr "圖片上傳失敗，請稍後重試"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:321
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:270
msgid "圖片上傳失敗，請重試"
msgstr "圖片上傳失敗，請重試"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:190
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:689
msgid "圖片上傳失敗！"
msgstr "圖片上傳失敗！"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:269
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:302
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:112
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:359
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:111
#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:301
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:184
#: apps/dp-admin/src/components/RichTextEditor/services/hooks.ts:106
#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:616
msgid "圖片上傳成功"
msgstr "圖片上傳成功"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:183
msgid "圖片上傳成功！"
msgstr "圖片上傳成功！"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:201
msgid "圖片上傳成功（已通過校驗）"
msgstr "圖片上傳成功（已通過校驗）"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:471
#: apps/dp-business/src/pages/ImageManagement/index.tsx:487
msgid "圖片上傳說明"
msgstr "圖片上傳說明"

#: apps/dp-business/src/utils/download.ts:86
msgid "圖片下載失敗"
msgstr "圖片下載失敗"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:183
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:221
msgid "圖片不符合規範"
msgstr "圖片不符合規範"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:182
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:220
#: apps/dp-business/src/components/PhotoUploader/upload.ts:139
msgid "圖片不符合規範，請重新上傳"
msgstr "圖片不符規範，請重新上傳"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:172
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:172
msgid "圖片任務創建成功"
msgstr "圖片任務創建成功"

#: apps/dp-client/src/components/Upload/index.tsx:521
msgid "圖片內容不符合規範，請重新選擇"
msgstr "圖片內容不符合規範，請重新選擇"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:275
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:506
msgid "圖片內容不符合規範，請重新選擇圖片"
msgstr "圖片內容不符合規範，請重新選擇圖片"

#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:316
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:205
msgid "圖片刪除成功"
msgstr "圖片刪除成功"

#: apps/dp-admin/src/components/PrivateImage/index.web.tsx:126
msgid "圖片加載失敗"
msgstr "圖片加載失敗"

#: apps/dp-business/src/pages/MenuManagement.tsx:1307
msgid "圖片及動態圖片"
msgstr "圖片及動態圖片"

#: apps/dp-client/src/components/Upload/index.tsx:229
msgid "圖片和視頻最多隻能上傳{maxCount}個"
msgstr "圖片和影片最多隻能上傳{maxCount}個"

#: apps/dp-admin/src/modules/services/private-image-resolver/privateImageResolver.ts:60
msgid "圖片地址無效"
msgstr "圖片地址無效"

#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:733
msgid "圖片地址無效，無法編輯"
msgstr "圖片地址無效，無法編輯"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:192
#: apps/dp-client/src/screens/diary/pages/my/components/RNCropPhoto/CropPhoto.tsx:255
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:139
msgid "圖片大小不能超過4MB"
msgstr "圖片大小不能超過4MB"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:330
msgid "圖片大小不能超過5MB！"
msgstr "圖片大小不能超過5MB！"

#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:418
msgid "圖片大小超過5MB，請壓縮後上傳"
msgstr "圖片大小超過5MB，請壓縮後上傳"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:295
#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:414
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:291
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:413
#: apps/dp-client/src/components/Upload/index.tsx:490
msgid "圖片太大了哦，請更換圖片上傳"
msgstr "圖片太大了哦，請更換圖片上傳"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:257
#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:324
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:253
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:323
msgid "圖片太大了哦，請選擇10M以內的圖片上傳"
msgstr "圖片太大了哦，請選擇10MB以內的圖片上傳"

#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/services/constants.ts:32
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/MerchantBasicInfo/index.web.tsx:67
msgid "圖片審核"
msgstr "圖片審核"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:52
msgid "圖片審核結果已提交"
msgstr "圖片審核結果已提交"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:256
msgid "圖片審核詳情"
msgstr "圖片審核詳情"

#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:525
msgid "圖片將按上傳順序展示"
msgstr "圖片將按上傳順序展示"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:136
msgid "圖片尺寸建議686*200"
msgstr "圖片尺寸建議686*200"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:195
msgid "圖片尺寸建議750*460"
msgstr "圖片尺寸建議750*460"

#: apps/dp-admin/src/components/SensitiveInfo/MaskedImage/index.web.tsx:31
msgid "圖片已上傳"
msgstr "圖片已上傳"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:226
msgid "圖片已刪除"
msgstr "圖片已刪除"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:200
msgid "圖片影片"
msgstr "圖片影片"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:66
msgid "圖片數量"
msgstr "圖片數量"

#: apps/dp-admin/src/components/RichTextEditor/index.web.tsx:176
msgid "圖片數量已達上限"
msgstr "圖片數量已達上限"

#: apps/dp-admin/src/modules/hooks/useImageUpload.ts:198
#: apps/dp-admin/src/modules/hooks/useImageUpload.ts:263
msgid "圖片校驗不通過"
msgstr "圖片校驗不通過"

#: apps/dp-admin/src/modules/hooks/useImageUpload.ts:180
#: apps/dp-admin/src/modules/hooks/useImageUpload.ts:205
msgid "圖片校驗失敗，請重試"
msgstr "圖片校驗失敗，請重試"

#: apps/dp-admin/src/modules/hooks/useImageUpload.ts:191
msgid "圖片校驗結果異常，請重試"
msgstr "圖片校驗結果異常，請重試"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:16
msgid "圖片格式為JPG、JPEG、PNG，單張大小不超過5M"
msgstr "圖片格式為JPG、JPEG、PNG，單張大小不超過5M"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:247
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:275
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:234
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:269
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:407
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:430
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:507
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:197
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:216
#: apps/dp-admin/src/pages/org-tree/org-create/services/constants.ts:127
msgid "圖片格式為JPG、JPEG、PNG，單張大小不超過5M，每張圖片解析度為 96dpi"
msgstr "圖片格式為JPG、JPEG、PNG，單張大小不超過5M，每張圖片解析度為 96dpi"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:176
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:205
msgid "圖片格式為JPG、JPEG、PNG、PDF，單張大小不超過5M，每張圖片解析度為 96dpi"
msgstr "圖片格式為JPG、JPEG、PNG、PDF，單張大小不超過5M，每張圖片解析度為 96dpi"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:139
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:163
msgid "圖片格式為JPG、JPEG、PNG、PDF，單張大小不超過5M，每張圖片解析度為96dpi"
msgstr "圖片格式為JPG、JPEG、PNG、PDF，單張大小不超過5M，每張圖片解析度為96dpi"

#: apps/dp-business/src/servers/file/api.ts:175
msgid "圖片檢查失敗"
msgstr "圖片檢查失敗"

#: apps/dp-client/src/components/Upload/index.tsx:526
msgid "圖片檢測失敗，請重試"
msgstr "圖片檢測失敗，請重試"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:305
msgid "圖片正在上傳中，請稍候"
msgstr "圖片正在上傳中，請稍候"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:392
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:475
msgid "圖片比例4:3，建議400x300px，檔案大小5MB"
msgstr "圖片比例4:3，建議400x300px，檔案大小5MB"

#: apps/dp-business/src/pages/ImageManagement/components/imageTips.tsx:27
#: apps/dp-admin/src/pages/merchant/components/imageTips/index.web.tsx:33
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:150
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:165
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:180
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:210
msgid "圖片比例建議1:1"
msgstr "圖片比例建議1:1"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:162
msgid "圖片管理"
msgstr "圖片管理"

#: apps/dp-business/src/components/ImageEditorModal/index.tsx:140
#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:765
msgid "圖片編輯失敗，請重試"
msgstr "圖片編輯失敗，請重試"

#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:761
msgid "圖片編輯成功"
msgstr "圖片編輯成功"

#: apps/dp-client/src/screens/home/pages/Note/pages/editPhoto/index.tsx:240
#: apps/dp-business/src/components/ImageEditorModal/index.tsx:103
#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:461
#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:470
msgid "圖片處理失敗，請重試"
msgstr "圖片處理失敗，請重試"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:668
msgid "圖片處理失敗: "
msgstr "圖片處理失敗: "

#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:224
msgid "圖片讀取失敗，請確認圖片可跨域訪問後重試"
msgstr "圖片讀取失敗，請確認圖片可跨域訪問後重試"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:258
#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:325
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:254
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:324
msgid "圖片超過10MB"
msgstr "圖片超過10MB"

#: apps/dp-client/src/utils/imageCompression.ts:35
#: apps/dp-client/src/utils/imageCompression.ts:89
msgid "圖片超過15MB"
msgstr "圖片超過15MB"

#: apps/dp-business/src/components/ImageEditorModal/index.tsx:236
msgid "圖片載入中..."
msgstr "圖片載入中..."

#: apps/dp-client/src/screens/diary/pages/my/components/CropPhoto/index.web.tsx:258
#: apps/dp-client/src/screens/diary/components/ImageViewer/index.tsx:82
#: apps/dp-client/src/components/ImageViewer/index.tsx:303
msgid "圖片載入失敗"
msgstr "圖片載入失敗"

#: apps/dp-business/src/components/ImageEditorModal/index.tsx:86
msgid "圖片載入失敗，請重試"
msgstr "圖片載入失敗，請重試"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:610
msgid "圖片轉換失敗: "
msgstr "圖片轉換失敗: "

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:273
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:606
msgid "圖片過大"
msgstr "圖片過大"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:277
msgid "圖片違規"
msgstr "圖片違規"

#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:446
msgid "圖片重新加載失敗，請重試"
msgstr "圖片重新加載失敗，請重試"

#: apps/dp-business/src/components/MediaPreview/index.tsx:51
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:1010
msgid "圖片預覽"
msgstr "圖片預覽"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/config.ts:71
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:131
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/config.ts:60
#: apps/dp-admin/src/pages/audit-center/info-audit/components/InfoAuditTable/index.web.tsx:51
#: apps/dp-admin/src/pages/audit-center/components/AuditInfoHeader/config.ts:33
msgid "圖霸ID"
msgstr "圖霸ID"

#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:13
#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:32
msgid "圖霸刪除"
msgstr "圖霸刪除"

#: apps/dp-admin/src/pages/audit-center/info-confirm/index.web.tsx:122
msgid "圖霸資訊"
msgstr "圖霸資訊"

#: apps/dp-client/src/screens/account/pages/notifications/components/OrderNotificationCard/index.tsx:26
#: apps/dp-client/src/configs/page-configs.tsx:853
#: apps/dp-client/src/configs/page-configs.tsx:870
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:25
msgid "團購套餐"
msgstr "團購套餐"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/MealSectionTabs.tsx:30
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailCard/index.tsx:203
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:271
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:362
msgid "團購詳情"
msgstr "團購詳情"

#: apps/dp-business/src/data/regions.ts:60
msgid "土城區"
msgstr "土城區"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/GradualSearchHeader/index.tsx:47
msgid "在區域內搜尋"
msgstr "在區域內搜尋"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/GradualSearchHeader/index.tsx:47
msgid "在商場內搜尋"
msgstr "在商場內搜尋"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:103
#: apps/dp-admin/src/pages/customer-service/components/AssignModal.web.tsx:39
msgid "在線"
msgstr "在線"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:995
msgid ""
"在線用戶\n"
"cafe333"
msgstr ""
"在線用戶\n"
"cafe333"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:224
msgid "在菜單中隱藏"
msgstr "在菜單中隱藏"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:18
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:122
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:83
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:485
msgid "地區"
msgstr "地區"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:759
msgid "地區/地址"
msgstr "地區/地址"

#: apps/dp-admin/src/modules/hooks/options/useRegionOptions.ts:106
msgid "地區資料取得失敗"
msgstr "地區資料取得失敗"

#: apps/dp-admin/src/modules/hooks/options/useRegionOptions.ts:115
msgid "地區資料取得異常"
msgstr "地區資料取得異常"

#: apps/dp-client/src/screens/home/pages/ShopList/components/CustomHeader/index.tsx:108
#: apps/dp-client/src/screens/home/pages/Home/components/HeaderContent/index.tsx:130
#: apps/dp-client/src/screens/home/pages/Home/components/HeaderContent/index.tsx:142
msgid "地圖"
msgstr "地圖"

#: apps/dp-admin/src/components/MapPicker/index.web.tsx:452
msgid "地圖加載中…"
msgstr "地圖加載中…"

#: apps/dp-admin/src/components/MapPicker/index.web.tsx:444
msgid "地圖加載失敗"
msgstr "地圖加載失敗"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:61
msgid "地圖定位偏移"
msgstr "地圖定位偏移"

#: apps/dp-client/src/configs/page-configs.tsx:265
msgid "地圖導航"
msgstr "地圖導航"

#: apps/dp-client/src/screens/diary/pages/search/index.tsx:38
msgid "地圖找餐廳"
msgstr "地圖找餐廳"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:465
msgid "地圖服務暫時不可用，請稍後重試"
msgstr "地圖服務暫時無法使用，請稍後重試"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:458
msgid "地圖服務配置異常，請聯繫技術支援"
msgstr "地圖服務異常，請與客服聯繫"

#: apps/dp-business/src/pages/AddStore/index.tsx:1266
msgid "地圖資料"
msgstr "地圖資料"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:199
#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:569
#: apps/dp-business/src/pages/AddressEdit/index.tsx:739
#: apps/dp-business/src/components/GoogleMap/index.tsx:801
#: apps/dp-business/src/components/GoogleMap/WebViewMap.tsx:778
msgid "地圖載入中..."
msgstr "地圖載入中..."

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:488
#: apps/dp-business/src/components/GoogleMap/WebViewMap.tsx:701
msgid "地圖載入失敗"
msgstr "地圖載入失敗"

#: apps/dp-business/src/components/GoogleMap/index.tsx:778
msgid "地圖載入失敗，請檢查網路連線或API金鑰"
msgstr "地圖載入失敗，請檢查網路連線或API金鑰"

#: apps/dp-business/src/components/GoogleMap/index.tsx:779
msgid "地圖載入超時，請重新整理頁面重試"
msgstr "地圖載入超時，請重新整理頁面重試"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:501
msgid "地圖載入逾時"
msgstr "地圖載入逾時"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:261
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:300
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:232
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:619
#: apps/dp-admin/src/components/MapPicker/index.web.tsx:152
msgid "地圖選點"
msgstr "地圖選點"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:806
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:855
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1075
#: apps/dp-business/src/pages/AddressEdit/index.tsx:656
#: apps/dp-business/src/pages/AddressEdit/index.tsx:789
#: apps/dp-admin/src/pages/transaction/components/MerchantInfo/index.web.tsx:134
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:206
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:94
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:675
#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:47
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:119
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:95
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:221
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:635
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ImageUploadTips/index.web.tsx:125
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:95
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:122
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageScopeSection/index.web.tsx:156
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:484
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:210
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:207
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:177
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:208
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:310
msgid "地址"
msgstr "地址"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:144
msgid "地址："
msgstr "地址："

#. placeholder {0}: record.merchantAddress || '-'
#. placeholder {0}: record.address || '-'
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:127
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:347
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:75
msgid "地址：{0}"
msgstr "地址：{0}"

#: apps/dp-business/src/pages/AddressEdit/index.tsx:578
msgid "地址儲存失敗，請稍後重試"
msgstr "地址儲存失敗，請稍後重試"

#: apps/dp-business/src/pages/AddressEdit/index.tsx:568
msgid "地址儲存成功"
msgstr "地址儲存成功"

#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/services/constants.ts:27
msgid "地址審核"
msgstr "地址審核"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:616
msgid "地址與定位"
msgstr "地址與定位"

#: apps/dp-admin/src/components/MapPicker/index.web.tsx:272
msgid "地址解析失敗，請手動確認地址"
msgstr "地址解析失敗，請手動確認地址"

#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:12
#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:31
msgid "地址變動"
msgstr "地址變動"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:144
#: apps/dp-business/src/utils/moduleTypeMapping.ts:249
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:168
msgid "地址資訊"
msgstr "地址資訊"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:145
msgid "地址資訊完整度評分"
msgstr "地址資訊完整度評分"

#: apps/dp-business/src/components/StoreSelector/index.tsx:284
msgid "地址資訊待完善"
msgstr "地址資訊待完整填寫"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopLocationInfo.tsx:388
#: apps/dp-client/src/screens/home/pages/Meal/components/ShopInfoCard/index.tsx:268
#: apps/dp-client/src/screens/home/pages/Meal/components/ShopInfoCard/index.tsx:283
msgid "地址資訊暫無"
msgstr "地址資訊暫無"

#: apps/dp-business/src/pages/AddressEdit/index.tsx:474
msgid "地址資訊正在審核中，無法修改"
msgstr "地址資訊正在審核中，無法修改"

#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:347
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:368
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:387
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:415
msgid "地址載入中..."
msgstr "地址載入中..."

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:211
msgid "地域限制"
msgstr "地域限制"

#. placeholder {0}: currentPackage.usageRules.locationRestriction
#. placeholder {0}: d.usageRules.locationRestriction
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1126
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:406
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:286
msgid "地域限制：{0}"
msgstr "地域限制：{0}"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:140
msgid "均價"
msgstr "均價"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:677
msgid "坐標點格式為 [經度, 緯度]，至少 3 個有效點位才會形成不規則多邊形。"
msgstr "坐標點格式為 [經度, 緯度]，至少 3 個有效點位才會形成不規則多邊形。"

#: apps/dp-business/src/data/regions.ts:78
msgid "坪林區"
msgstr "坪林區"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:104
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:260
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:56
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:57
msgid "垂直翻轉"
msgstr "垂直翻轉"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/config.ts:54
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/config.ts:46
msgid "城區"
msgstr "城區"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:719
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:127
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:129
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:66
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:84
msgid "城市"
msgstr "城市"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:134
msgid "城市獲取失敗"
msgstr "城市獲取失敗"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:166
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:450
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:63
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:27
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:94
#: apps/dp-admin/src/pages/split-account/services/constants.ts:90
#: apps/dp-admin/src/pages/split-account/services/constants.ts:170
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:32
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:161
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:15
msgid "執行中"
msgstr "執行中"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:65
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:96
#: apps/dp-admin/src/pages/split-account/services/constants.ts:172
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:17
msgid "執行失敗"
msgstr "執行失敗"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:64
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:95
#: apps/dp-admin/src/pages/split-account/services/constants.ts:171
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:16
msgid "執行成功"
msgstr "執行成功"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/apis.ts:60
msgid "執行抽獎失敗"
msgstr "執行抽獎失敗"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:440
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:391
#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:325
msgid "執行時間"
msgstr "執行時間"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:328
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:142
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:251
msgid "執行狀態"
msgstr "執行狀態"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:431
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:382
#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:314
msgid "執行結果"
msgstr "執行結果"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:449
msgid "執行訊息"
msgstr "執行訊息"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:424
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:378
msgid "執行資訊"
msgstr "執行資訊"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:55
msgid "基於原商家名單複製一份新的名單"
msgstr "基於原商家名單複製一份新的名單"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:65
msgid "基於原用戶名單複製一份新的名單"
msgstr "基於原用戶名單複製一份新的名單"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:369
msgid "基本信息"
msgstr "基本信息"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:190
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:32
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:56
msgid "基本合約"
msgstr "基本合約"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:66
msgid "基本用法"
msgstr "基本用法"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:49
msgid "基本設置"
msgstr "基本設置"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:23
msgid "基本資料"
msgstr "基本資料"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1761
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:72
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:354
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:407
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:69
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:303
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:264
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:297
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:398
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:222
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:212
#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:207
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:46
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:9
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:450
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:135
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:207
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:44
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:9
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:43
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:142
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:92
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:171
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:231
#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantBasicInfo/index.web.tsx:84
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:320
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:171
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:165
msgid "基本資訊"
msgstr "基本資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:123
msgid "基礎佣金比例(%不包含交易手續費)"
msgstr "基礎佣金比例(%不包含交易手續費)"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:407
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:43
msgid "基礎合約"
msgstr "基礎合約"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:449
msgid "基礎合約詳情"
msgstr "基礎合約詳情"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:25
msgid "基礎摺疊面板"
msgstr "基礎摺疊面板"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:24
msgid "基礎用法"
msgstr "基礎用法"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:128
msgid "基礎規則"
msgstr "基礎規則"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:131
#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:108
msgid "基礎設定"
msgstr "基礎設定"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:62
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:181
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:43
msgid "基礎設施"
msgstr "基礎設施"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1628
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:812
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:106
#: apps/dp-admin/src/pages/order/order-detail/components/BasicInfo/index.web.tsx:127
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:187
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:538
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:78
#: apps/dp-admin/src/pages/marketing/services/constants.ts:296
msgid "基礎資訊"
msgstr "基礎資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:39
msgid "基礎資訊（作為設定金流交易使用）"
msgstr "基礎資訊（作為設定金流交易使用）"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:121
msgid "基礎資訊表單尚未初始化"
msgstr "基礎資訊表單尚未初始化"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:179
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:33
msgid "基礎資訊配置"
msgstr "基礎資訊配置"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:981
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:590
#: apps/dp-admin/src/pages/report-center/services/apis.ts:455
msgid "堂食"
msgstr "餐廳"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:578
msgid "堂食外帶約定"
msgstr "餐廳外帶規定"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:303
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:275
msgid "報修問題描述"
msgstr "報修問題描述"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:269
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:126
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:283
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:201
msgid "報修類型"
msgstr "報修類型"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:39
msgid "報名即將截止"
msgstr "報名即將截止"

#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:69
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:124
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:195
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:90
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:216
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:325
#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:39
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:105
msgid "報名時間"
msgstr "報名時間"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:779
msgid "報名時間：{activityRegistartTime}"
msgstr "報名時間：{activityRegistartTime}"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:76
msgid "報名時間段"
msgstr "報名時間段"

#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:219
msgid "報名時間範圍"
msgstr "報名時間範圍"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:38
msgid "報名火熱"
msgstr "報名火熱"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:79
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:140
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:334
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:225
msgid "報名結束時間"
msgstr "報名結束時間"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:335
msgid "報名資訊修改成功"
msgstr "報名資訊修改成功"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:79
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:134
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:334
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:225
msgid "報名開始時間"
msgstr "報名開始時間"

#: apps/dp-admin/src/router/config/routes.web.tsx:719
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:736
msgid "報表中心"
msgstr "報表中心"

#: apps/dp-admin/src/pages/marketing/activity-statistics/services/hooks.ts:231
msgid "報表匯出成功"
msgstr "報表匯出成功"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:280
msgid "報表含全部掛接店；結算 / 請款只含「可結算請款」"
msgstr "報表含全部掛接店；結算 / 請款只含「可結算請款」"

#: apps/dp-admin/src/pages/report-center/user-registration-data/index.web.tsx:71
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/index.web.tsx:73
#: apps/dp-admin/src/pages/report-center/transaction-data/index.web.tsx:73
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/index.web.tsx:73
msgid "報表已生成"
msgstr "報表已生成"

#: apps/dp-admin/src/pages/report-center/user-registration-data/index.web.tsx:68
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/index.web.tsx:70
#: apps/dp-admin/src/pages/report-center/transaction-data/index.web.tsx:70
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/index.web.tsx:70
msgid "報表生成中，請等待"
msgstr "報表生成中，請等待"

#: apps/dp-admin/src/pages/report-center/risk-control-analysis/index.web.tsx:8
#: apps/dp-admin/src/pages/report-center/channel-analysis/index.web.tsx:8
msgid "報表開發中..."
msgstr "報表開發中..."

#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:228
msgid "報錯內容"
msgstr "報錯內容"

#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:221
msgid "報錯資訊"
msgstr "報錯資訊"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:825
msgid "場所結構"
msgstr "場所結構"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:206
msgid "場景"
msgstr "場景"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:128
msgid "場景原因"
msgstr "場景原因"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:54
msgid "場景描述"
msgstr "場景描述"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:34
msgid "塔吉特千層蛋糕"
msgstr "塔吉特千層蛋糕"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:279
msgid "填充"
msgstr "填充"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:123
msgid "填充色"
msgstr "填充色"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:206
msgid "填到哪一層就建到哪一層，上層路徑不存在時自動建立，路徑完全相同者跳過。"
msgstr "填到哪一層就建到哪一層，上層路徑不存在時自動建立，路徑完全相同者跳過。"

#: apps/dp-admin/src/pages/transaction/service-management/components/PosSettings/index.web.tsx:63
msgid "填寫POS的廠商代碼"
msgstr "填寫POS的廠商代碼"

#: apps/dp-admin/src/pages/transaction/service-management/components/PosSettings/index.web.tsx:79
msgid "填寫POS門市（店家）代碼"
msgstr "填寫POS門市（店家）代碼"

#: apps/dp-admin/src/pages/transaction/service-management/components/PosSettings/index.web.tsx:71
msgid "填寫POS餐廳（商家）代碼"
msgstr "填寫POS餐廳（商家）代碼"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:44
msgid "填寫券組基本資訊"
msgstr "填寫券組基本資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/SigningSteps/index.web.tsx:9
msgid "填寫商家資料"
msgstr "填寫商家資料"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:334
msgid "填寫基礎資訊和合約內容"
msgstr "填寫基礎資訊和合約內容"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:570
msgid "填寫本版更新說明，用戶可見"
msgstr "填寫本版更新說明，用戶可見"

#: apps/dp-client/src/screens/diary/components/TrafficExampleModal.tsx:39
msgid "填寫範例內容"
msgstr "填寫範例內容"

#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:172
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:209
msgid "填寫綁定"
msgstr "填寫綁定"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:197
msgid "填寫規則"
msgstr "填寫規則"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:1094
msgid "增加備註"
msgstr "增加備註"

#: apps/dp-client/src/utils/imageCompression.ts:64
#: apps/dp-client/src/utils/imageCompression.ts:110
#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:296
#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:416
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:292
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:415
msgid "壓縮後圖片仍大於4MB"
msgstr "壓縮後圖片仍大於4MB"

#: apps/dp-business/src/data/regions.ts:43
msgid "士林區"
msgstr "士林區"

#: apps/dp-business/src/data/categories.ts:148
msgid "壽司"
msgstr "壽司"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:433
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:117
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/constants.ts:51
msgid "外國籍"
msgstr "外國籍"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:597
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:347
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:444
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2164
msgid "外帶"
msgstr "外帶"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:304
msgid "外籍法人"
msgstr "外籍法人"

#: apps/dp-client/src/screens/home/pages/ShopDetail/constants/index.ts:22
msgid "外觀"
msgstr "外觀"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:994
#: apps/dp-admin/src/pages/report-center/services/apis.ts:455
msgid "外賣"
msgstr "外賣"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:64
msgid "外部代碼"
msgstr "外部代碼"

#: apps/dp-admin/src/modules/constants/options.ts:272
msgid "外部兌換券"
msgstr "外部兌換券"

#: apps/dp-admin/src/modules/constants/options.ts:273
msgid "外部合作夥伴兌換券"
msgstr "外部合作夥伴兌換券"

#: apps/dp-admin/src/components/RichTextEditor/services/hooks.ts:165
#: apps/dp-admin/src/components/RichTextEditor/services/hooks.ts:203
msgid "外部圖片需重新上傳，已移除外部圖片"
msgstr "外部圖片需重新上傳，已移除外部圖片"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:26
msgid "外部跳轉"
msgstr "外部跳轉"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/constants.ts:84
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:140
msgid "外部連結"
msgstr "外部連結"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:144
#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:63
msgid "外部鏈接"
msgstr "外部鏈接"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:76
msgid "外部鏈接：請輸入以 http:// 或 https:// 開頭的完整連結。"
msgstr "外部鏈接：請輸入以 http:// 或 https:// 開頭的完整連結。"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:86
msgid "外部鏈接需以 http:// 或 https:// 開頭"
msgstr "外部鏈接需以 http:// 或 https:// 開頭"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:111
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:147
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:157
msgid "多人餐"
msgstr "多人餐"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:40
msgid "多個手機號用逗號或空格分隔（支持中英文逗號）"
msgstr "多個手機號用逗號或空格分隔（支持中英文逗號）"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:48
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:53
msgid "多個用戶ID用逗號或空格分隔（支持中英文逗號）"
msgstr "多個用戶ID用逗號或空格分隔（支持中英文逗號）"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:44
msgid "多個郵箱用逗號或空格分隔（支持中英文逗號）"
msgstr "多個郵箱用逗號或空格分隔（支持中英文逗號）"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:15
msgid "多條之間：用「或」還是「且」"
msgstr "多條之間：用「或」還是「且」"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:358
msgid "多權益時請填寫卡片副標題"
msgstr "多權益時請填寫卡片副標題"

#: apps/dp-business/src/hooks/usePermissions.ts:144
msgid "多權限檢查失敗"
msgstr "多權限檢查失敗"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:336
msgid "多次使用，券可以核銷"
msgstr "多次使用，券可以核銷"

#: apps/dp-client/src/notifications/multi-login.ts:45
msgid "多裝置登入"
msgstr "多裝置登入"

#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:264
msgid "夜宵"
msgstr "夜宵"

#: apps/dp-client/src/screens/home/pages/Search/index.tsx:501
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:45
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:75
msgid "夜市/商圈"
msgstr "夜市/商圈"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:43
msgid "大"
msgstr "大"

#: apps/dp-business/src/data/regions.ts:37
msgid "大同區"
msgstr "大同區"

#: apps/dp-business/src/data/regions.ts:40
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:99
msgid "大安區"
msgstr "大安區"

#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:606
msgid "大小"
msgstr "大小"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:95
msgid "大小：200k以內"
msgstr "大小：200k以內"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:101
msgid "大小：300k以內"
msgstr "大小：300k以內"

#: apps/dp-business/src/store/TableContext.tsx:44
#: apps/dp-business/src/store/ReservationRulesContext.tsx:92
#: apps/dp-business/src/store/ReservationRulesContext.tsx:100
#: apps/dp-business/src/store/ReservationRulesContext.tsx:143
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:384
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:496
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:504
msgid "大廳"
msgstr "大廳"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:983
msgid ""
"大廳-小桌\n"
"1人"
msgstr ""
"大廳-小桌\n"
"1人"

#: apps/dp-client/src/screens/diary/pages/my/components/DiaryCard.tsx:180
msgid "大推："
msgstr "大推："

#: apps/dp-client/src/screens/diary/components/DiaryTags/index.tsx:92
msgid "大推：{recommended}"
msgstr "大推：{recommended}"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/constants.ts:19
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:20
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:14
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:23
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:14
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:22
#: apps/dp-admin/src/modules/constants/userGroup.ts:125
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:118
msgid "大於"
msgstr "大於"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/constants.ts:20
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:23
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:15
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:24
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:15
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:23
#: apps/dp-admin/src/modules/constants/userGroup.ts:126
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:119
msgid "大於等於"
msgstr "大於等於"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:58
msgid "大毛"
msgstr "大毛"

#: apps/dp-admin/src/modules/constants/options.ts:7
msgid "大連鎖"
msgstr "大連鎖"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:260
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:492
msgid "大頭照上傳中..."
msgstr "頭像上傳中…"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:314
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:544
msgid "大頭照更新失敗，請重試"
msgstr "頭像更新失敗，請重試"

#: apps/dp-client/src/screens/home/pages/PackageZone/templates/ActivityTemplate.tsx:165
#: apps/dp-client/src/screens/home/pages/PackageZone/templates/ActivityTemplate.tsx:177
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:433
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:46
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:50
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:23
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:29
#: apps/dp-admin/src/modules/constants/userGroup.ts:135
msgid "天"
msgstr "天"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:678
msgid "天內有效"
msgstr "天內有效"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:613
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:279
msgid "天內未使用，系統將會自動退款"
msgstr "天內未使用，系統將會自動退款"

#: apps/dp-client/src/screens/home/utils/utils.ts:66
msgid "天前"
msgstr "天前"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:602
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:274
msgid "天數"
msgstr "天數"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:593
msgid "天數不能少於原始值 {originalValue}"
msgstr "天數不能少於原始值 {originalValue}"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:163
#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:219
msgid "天數必須為 1-85 之間的整數"
msgstr "天數必須為 1-85 之間的整數"

#: apps/dp-client/src/screens/diary/pages/my/index.tsx:361
msgid "太棒啦！已成功發布"
msgstr "太棒啦！已成功發佈"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:261
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CommissionBenefitListCard.web.tsx:49
msgid "失效時間"
msgstr "失效時間"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:168
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:452
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:594
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCells.tsx:155
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:29
#: apps/dp-admin/src/pages/split-account/services/constants.ts:92
#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:160
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:34
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:166
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:227
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:454
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:664
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:116
#: apps/dp-admin/src/pages/marketing/services/interface/batchTask.ts:201
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:200
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:77
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:79
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:135
#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:330
msgid "失敗"
msgstr "失敗"

#. placeholder {0}: failedItems.length
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:100
msgid "失敗 ({0})"
msgstr "失敗 ({0})"

#. placeholder {0}: result?.failedCount ?? 0
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:87
msgid "失敗 {0} 家"
msgstr "失敗 {0} 家"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:393
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:168
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:107
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:691
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:102
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:140
msgid "失敗原因"
msgstr "失敗原因"

#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:154
msgid "失敗數量"
msgstr "失敗數量"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:31
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:334
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:23
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:23
msgid "套印"
msgstr "套印"

#: apps/dp-admin/src/pages/org-tree/services/constants.ts:40
msgid "套用中"
msgstr "套用中"

#: apps/dp-admin/src/pages/org-tree/services/constants.ts:42
msgid "套用失敗"
msgstr "套用失敗"

#: apps/dp-admin/src/pages/org-tree/services/constants.ts:41
msgid "套用成功"
msgstr "套用成功"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:217
msgid "套索"
msgstr "套索"

#: apps/dp-client/src/components/CouponCard/index.tsx:261
#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:128
#: apps/dp-business/src/pages/CouponVerification/index.tsx:418
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:572
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:297
msgid "套餐"
msgstr "套餐"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/PackageColumns/index.web.tsx:8
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:51
msgid "套餐 ID"
msgstr "套餐 ID"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:168
msgid "套餐 ID 必須為正整數"
msgstr "套餐 ID 必須為正整數"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:419
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:126
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:107
msgid "套餐ID"
msgstr "套餐ID"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2271
msgid "套餐備註"
msgstr "套餐備註"

#. placeholder {0}: formatCurrency(storePrice)
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:136
msgid "套餐價不能大於門店價 {0}"
msgstr "套餐價不能大於門店價 {0}"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:328
msgid "套餐價不能大於門店價 NT$ {storePrice}"
msgstr "套餐價不能大於店內價 NT$ {storePrice}"

#. placeholder {0}: formatCurrency(maxPrice)
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:135
msgid "套餐價不能大於門店價+服務費 {0}"
msgstr "套餐價不能大於門店價+服務費 {0}"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:104
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:105
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:162
msgid "套餐價格"
msgstr "套餐價格"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:20
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/constants.ts:70
msgid "套餐價格區間"
msgstr "套餐價格區間"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:313
msgid "套餐價格只能是0或正整數"
msgstr "套餐價格只能是0或正整數"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:684
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1547
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:59
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:53
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:50
msgid "套餐優惠"
msgstr "套餐優惠"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2253
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:443
msgid "套餐優惠金額"
msgstr "套餐優惠金額"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:278
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:570
msgid "套餐內容、價格、有效期等核心資訊將無法再修改。"
msgstr "套餐內容、價格、有效期等核心資訊將無法再修改。"

#: apps/dp-client/src/configs/page-configs.tsx:316
msgid "套餐列表"
msgstr "套餐列表"

#: apps/dp-client/src/screens/home/utils/filterData.ts:177
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:413
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/Card.tsx:108
#: apps/dp-client/src/screens/home/pages/FoodMap/components/HorizontalShopCard.tsx:226
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:87
#: apps/dp-client/src/screens/home/components/SetMealCard/index.tsx:175
#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:114
#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:197
#: apps/dp-client/src/configs/page-configs.tsx:2151
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:320
#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:125
#: apps/dp-business/src/pages/SimpleDashboard/components/RedeemCard.tsx:84
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:423
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:695
#: apps/dp-business/src/pages/RefundList/index.tsx:73
#: apps/dp-business/src/pages/RefundList/index.tsx:103
#: apps/dp-business/src/pages/RefundList/index.tsx:133
#: apps/dp-business/src/pages/OrderList/index.tsx:622
#: apps/dp-business/src/pages/OrderList/index.tsx:891
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:127
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1545
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1969
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:139
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:621
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1560
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1761
#: apps/dp-business/src/pages/CouponVerification/index.tsx:413
#: apps/dp-business/src/pages/CouponVerification/index.tsx:649
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:567
#: apps/dp-business/src/pages/ContractManagement/index.tsx:194
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:60
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:58
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:52
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:139
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageSourceField/index.web.tsx:67
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageSourceField/index.web.tsx:107
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/MerchantGroupCouponField/index.web.tsx:98
#: apps/dp-admin/src/pages/order/services/utils.ts:80
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:48
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:563
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:120
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:133
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:162
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/index.web.tsx:181
#: apps/dp-admin/src/pages/marketing/services/constants.ts:15
#: apps/dp-admin/src/pages/marketing/services/constants.ts:314
#: apps/dp-admin/src/pages/marketing/services/constants.ts:403
#: apps/dp-admin/src/pages/marketing/services/constants.ts:494
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:394
msgid "套餐券"
msgstr "套餐券"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/FixedPackageImportField/index.web.tsx:159
msgid "套餐券ID"
msgstr "套餐券ID"

#: apps/dp-admin/src/pages/transaction/service/help/validate.ts:238
#: apps/dp-admin/src/pages/transaction/service/help/validate.ts:372
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:44
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:16
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:39
msgid "套餐券佣金規則"
msgstr "套餐券佣金規則"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:753
msgid "套餐券修改成功！"
msgstr "套餐券修改成功！"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:634
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:442
#: apps/dp-admin/src/pages/resource-config/services/constants.ts:122
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:87
#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:80
#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:125
msgid "套餐券列表"
msgstr "套餐券列表"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:134
msgid "套餐券列表："
msgstr "套餐券列表："

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1334
msgid "套餐券創建人："
msgstr "套餐券創建人："

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2276
msgid "套餐券創建店家"
msgstr "套餐券創建店家"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:753
msgid "套餐券創建成功！"
msgstr "套餐券創建成功！"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/PackageCouponSelect/index.web.tsx:136
msgid "套餐券加載失敗"
msgstr "套餐券加載失敗"

#: apps/dp-business/src/servers/contract-management/api.ts:434
msgid "套餐券合約"
msgstr "套餐券合約"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:453
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/columns.tsx:76
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:59
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:115
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:236
#: apps/dp-admin/src/pages/merchant/shop-detail/components/ShopClosedImpactModal/index.web.tsx:40
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:223
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:132
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:178
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:95
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:148
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:186
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:26
msgid "套餐券名稱"
msgstr "套餐券名稱"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/chainReportFilterFields.ts:34
msgid "套餐券名稱／ID"
msgstr "套餐券名稱／ID"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:495
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:612
msgid "套餐券圖片"
msgstr "套餐券圖片"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PreviewCard.tsx:51
msgid "套餐券在商品詳情頁的展示樣式"
msgstr "套餐券在商品詳情頁的展示樣式"

#: apps/dp-admin/src/router/config/routes.web.tsx:378
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/index.web.tsx:274
msgid "套餐券審核"
msgstr "套餐券審核"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/index.web.tsx:282
msgid "套餐券審核列表"
msgstr "套餐券審核列表"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1961
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:702
msgid "套餐券明細"
msgstr "套餐券明細"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:406
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:485
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:502
#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:90
#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:220
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:31
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:127
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:734
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:281
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:561
msgid "套餐券服務"
msgstr "套餐券服務"

#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:57
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:198
#: apps/dp-admin/src/pages/transaction/service-management/components/MerchantPackageServiceOverview/index.web.tsx:74
msgid "套餐券服務設定"
msgstr "套餐券服務設定"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherUsageReport.tsx:119
#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:56
msgid "套餐券核銷報表"
msgstr "套餐券核銷報表"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/index.tsx:151
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/index.tsx:172
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:807
#: apps/dp-business/src/components/CustomTabs/index.tsx:167
msgid "套餐券核銷明細"
msgstr "套餐券核銷明細"

#: apps/dp-business/src/pages/OrderList/index.tsx:869
msgid "套餐券核銷時間範圍"
msgstr "套餐券核銷時間範圍"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:105
#: apps/dp-admin/src/modules/constants/userGroup.ts:158
msgid "套餐券核銷次數"
msgstr "套餐券核銷次數"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:236
#: apps/dp-business/src/configs/page-configs.ts:929
msgid "套餐券核銷詳情"
msgstr "套餐券核銷詳情"

#: apps/dp-business/src/servers/coupon/api.ts:96
msgid "套餐券模板上架失敗"
msgstr "套餐券模板上架失敗"

#: apps/dp-business/src/servers/coupon/api.ts:120
msgid "套餐券模板下架失敗"
msgstr "套餐券模板下架失敗"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/PackageTemplateSection/index.web.tsx:60
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:789
msgid "套餐券模板列表"
msgstr "套餐券模板列表"

#: apps/dp-business/src/pages/OrderList/index.tsx:750
msgid "套餐券營業額/券數量"
msgstr "套餐券營業額/券數量"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:570
msgid "套餐券用戶自核銷"
msgstr "套餐券用戶自核銷"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:791
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1868
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1899
#: apps/dp-business/src/components/CustomTabs/index.tsx:87
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:434
msgid "套餐券管理"
msgstr "套餐券管理"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:123
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:149
msgid "套餐券缺少券碼資訊"
msgstr "套餐券缺少券碼資訊"

#: apps/dp-admin/src/pages/order/services/utils.ts:464
msgid "套餐券自動退款"
msgstr "套餐券自動退款"

#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailCard/index.tsx:203
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:351
#: apps/dp-business/src/configs/page-configs.ts:1069
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:427
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/index.web.tsx:173
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:212
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1107
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:447
msgid "套餐券詳情"
msgstr "套餐券詳情"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:208
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:473
msgid "套餐券詳情獲取失敗，請稍後重試"
msgstr "套餐券詳情獲取失敗，請稍後重試"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:737
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/PackageCouponCard/index.web.tsx:111
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/index.web.tsx:136
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:276
#: apps/dp-admin/src/pages/marketing/components/CouponInfoSection/index.web.tsx:73
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:67
msgid "套餐券資訊"
msgstr "套餐券資訊"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:99
msgid "套餐券購買數量"
msgstr "套餐券購買數量"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:487
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:607
msgid "套餐券適用店家"
msgstr "套餐券適用店家"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageSourceField/index.web.tsx:137
msgid "套餐券選擇"
msgstr "套餐券選擇"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:143
msgid "套餐券配置"
msgstr "套餐券配置"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherSalesReport.tsx:119
#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:50
msgid "套餐券銷售報表"
msgstr "套餐券銷售報表"

#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesSummaryCards.tsx:33
msgid "套餐券銷售總額"
msgstr "套餐券銷售總額"

#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/index.tsx:123
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/index.tsx:143
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:806
#: apps/dp-business/src/configs/page-configs.ts:912
#: apps/dp-business/src/components/CustomTabs/index.tsx:161
msgid "套餐券銷售訂單"
msgstr "套餐券銷售訂單"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1342
msgid "套餐券預覽圖"
msgstr "套餐券預覽圖"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:523
msgid "套餐券預覽圖下載失敗"
msgstr "套餐券預覽圖下載失敗"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:250
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:116
msgid "套餐原價"
msgstr "套餐原價"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2247
msgid "套餐原始單價"
msgstr "套餐原始單價"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2250
msgid "套餐原始總金額"
msgstr "套餐原始總金額"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/channelCampaignPackageActions.ts:77
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/channelCampaignPackageActions.ts:94
msgid "套餐名單導入失敗"
msgstr "套餐名單導入失敗"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:314
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2241
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:357
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PreviewCard.tsx:80
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/InteractiveCouponPreview.tsx:112
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:422
#: apps/dp-business/src/pages/BusinessStatus/components/ShopClosedImpactContent.tsx:28
#: apps/dp-business/src/pages/BusinessStatus/components/SharedTemplatesContent.tsx:28
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:331
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:433
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:295
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:427
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/packageCouponColumns.web.tsx:13
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:180
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:824
#: apps/dp-admin/src/pages/merchant/shop-detail/components/SharedTemplatesModal/index.web.tsx:35
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:328
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:457
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:149
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/PackageColumns/index.web.tsx:10
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:53
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:81
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:70
msgid "套餐名稱"
msgstr "套餐名稱"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:179
msgid "套餐名稱不能超過 30 個字元"
msgstr "套餐名稱不能超過 30 個字元"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:157
msgid "套餐名稱不能超過30個字符"
msgstr "套餐名稱不能超過30個字符"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:362
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:464
msgid "套餐售價"
msgstr "套餐售價"

#: apps/dp-client/src/screens/home/utils/commerceHelpers.ts:36
msgid "套餐售罄"
msgstr "套餐售罄"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitCard/index.web.tsx:101
msgid "套餐圈選方式"
msgstr "套餐圈選方式"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2262
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2265
msgid "套餐圖片"
msgstr "套餐圖片"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2258
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:452
msgid "套餐實付金額"
msgstr "套餐實付金額"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:448
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:238
msgid "套餐封面"
msgstr "套餐封面"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:556
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:702
#: apps/dp-client/src/screens/home/pages/PackageZone/components/SearchBar/index.tsx:117
#: apps/dp-client/src/screens/home/pages/Home/components/PackageZoneEntry/index.tsx:45
#: apps/dp-client/src/configs/page-configs.tsx:989
#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:74
msgid "套餐專區"
msgstr "套餐專區"

#. placeholder {0}: kw.label
#. placeholder {1}: index + 1
#: apps/dp-client/src/screens/home/pages/PackageSearch/index.tsx:477
msgid "套餐專區搜尋介面_推薦搜尋_{0}_{1}"
msgstr "套餐專區搜尋介面_推薦搜尋_{0}_{1}"

#: apps/dp-client/src/screens/home/pages/PackageSearch/index.tsx:467
msgid "套餐專區搜尋介面_搜尋歷史_{kw}"
msgstr "套餐專區搜尋介面_搜尋歷史_{kw}"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:58
msgid "套餐已刪除"
msgstr "套餐已刪除"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:180
msgid "套餐折扣價"
msgstr "套餐折扣價"

#. placeholder {0}: formatCurrency(maxPrice, { noSpace: false })
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:218
msgid "套餐折扣價不能大於套餐價 {0}"
msgstr "套餐折扣價不能大於套餐價 {0}"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:202
msgid "套餐折扣價不能為負數"
msgstr "套餐折扣價不能為負數"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:21
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/constants.ts:71
msgid "套餐折扣區間"
msgstr "套餐折扣區間"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:805
#: apps/dp-client/src/configs/page-configs.tsx:1005
msgid "套餐搜尋"
msgstr "套餐搜尋"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useManualPackageSearch.ts:38
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useManualPackageSearch.ts:46
msgid "套餐搜索失敗"
msgstr "套餐搜索失敗"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/DynamicPackageFields/index.web.tsx:98
msgid "套餐數值條件"
msgstr "套餐數值條件"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2244
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:238
msgid "套餐數量"
msgstr "套餐數量"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1971
msgid "套餐明細如下"
msgstr "套餐明細如下"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:19
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/constants.ts:69
msgid "套餐用餐人數"
msgstr "套餐用餐人數"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitCard/index.web.tsx:124
msgid "套餐範圍"
msgstr "套餐範圍"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:410
msgid "套餐詳情"
msgstr "套餐詳情"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:576
msgid "套餐詳情_用戶資訊_"
msgstr "套餐詳情_用戶資訊_"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2240
msgid "套餐資訊"
msgstr "套餐資訊"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1493
#: apps/dp-client/src/screens/account/pages/order/index.tsx:284
msgid "套餐資訊不存在"
msgstr "套餐資訊不存在"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/InteractiveCouponPreview.tsx:97
msgid "套餐載入失敗，請重試"
msgstr "套餐載入失敗，請重試"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:149
msgid "套餐項"
msgstr "套餐項"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/channelCampaignPackageActions.ts:133
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/channelCampaignPackageActions.ts:148
msgid "套餐預覽失敗"
msgstr "套餐預覽失敗"

#: apps/dp-client/src/screens/account/pages/edit-profile/components/GenderSelectModal/index.tsx:41
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:18
#: apps/dp-admin/src/pages/marketing/services/constants.ts:278
msgid "女"
msgstr "女"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:143
#: apps/dp-business/src/pages/OrderOverview/index.tsx:76
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:50
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:35
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:823
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:249
msgid "女士"
msgstr "女士"

#: apps/dp-business/src/data/categories.ts:221
msgid "奶茶"
msgstr "奶茶"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:575
msgid "好友邀請"
msgstr "好友邀請"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:56
msgid "好吃"
msgstr "好吃"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:159
msgid "好的"
msgstr "好的"

#: apps/dp-client/src/screens/home/pages/Home/components/ClaimedCouponModal/index.tsx:153
msgid ""
"好禮別錯過，今晚就享用！\n"
"提醒您美食金僅適用於線上購買套餐券"
msgstr ""
"好禮別錯過，今晚就享用！\n"
"提醒您美食金僅適用於線上購買套餐券"

#: apps/dp-client/src/components/TabView/example.tsx:18
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:72
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:97
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:123
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:231
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:39
msgid "好評"
msgstr "好評"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingDistribution.web.tsx:108
msgid "好評（4-5星）"
msgstr "好評（4-5星）"

#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:24
#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:75
msgid "好評回覆"
msgstr "好評回覆"

#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:77
msgid "好評回覆數"
msgstr "好評回覆數"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:72
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:72
msgid "好評提示"
msgstr "好評提示"

#: apps/dp-client/src/screens/home/pages/Home/components/HotRanking/index.tsx:64
msgid "好評榜"
msgstr "好評榜"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/OverviewCards.web.tsx:32
#: apps/dp-admin/src/pages/data-center/merchant-stats/services/hooks.tsx:108
msgid "好評率"
msgstr "好評率"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:95
msgid "如：/pages/package-zone?pid=pg_2048"
msgstr "如：/pages/package-zone?pid=pg_2048"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:262
msgid "如：/target/path"
msgstr "如：/target/path"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:94
msgid "如：https://example.com/page"
msgstr "如：https://example.com/page"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:157
msgid "如：SystemLogManagement、UserProfile 等"
msgstr "如：SystemLogManagement、UserProfile 等"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:129
msgid "如：USER_CREATE、DATA_DELETE"
msgstr "如：USER_CREATE、DATA_DELETE"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:175
msgid "如：UserOutlined、SettingOutlined 等"
msgstr "如：UserOutlined、SettingOutlined 等"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:102
msgid "如：新人優惠券"
msgstr "如：新人優惠券"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:115
msgid "如：新增用戶、刪除數據"
msgstr "如：新增用戶、刪除數據"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:531
msgid "如：環境舒適"
msgstr "如：環境舒適"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:140
msgid "如：系統日誌管理"
msgstr "如：系統日誌管理"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:341
msgid "如0936123456，此欄位在多項服務提供時將進行驗證，請正確填寫。"
msgstr "如0936123456，此欄位在多項服務提供時將進行驗證，請正確填寫。"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ImportPackageFields/index.web.tsx:61
msgid "如保留原導入名單，無需重新上傳；重新導入將替換名單。"
msgstr "如保留原導入名單，無需重新上傳；重新導入將替換名單。"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:446
msgid "如合約頁數較多，請一次性上傳完整檔案"
msgstr "如合約頁數較多，請一次性上傳完整檔案"

#: apps/dp-client/src/screens/reservation/components/RemarkInput/index.tsx:28
msgid ""
"如有需求，可在此填寫讓店家知道\n"
"ex.海鮮過敏/慶生佈置······"
msgstr ""
"如有需求，可在此填寫讓店家知道\n"
"ex.海鮮過敏/慶生佈置······"

#: apps/dp-business/src/components/GoogleMap/index.tsx:785
msgid "如果問題持續存在，請聯繫技術支援"
msgstr "如果問題持續存在，請聯繫技術支援"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:168
msgid "如果您對本隱私政策有任何問題或疑慮，請透過以下方式聯繫我們："
msgstr "如果您對本隱私政策有任何問題或疑慮，請透過以下方式聯繫我們："

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:68
msgid "如果您授權，我們可能收集您的精確位置資訊。"
msgstr "如果您授權，我們可能收集您的精確位置資訊。"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:113
msgid "如果法律要求或為了保護我們的權利。"
msgstr "如果法律要求或為了保護我們的權利。"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:612
msgid "如發生誤核，您可於在核銷後15分鐘內，商家端執行「反核銷」操作，將訂單恢復為未使用狀態。"
msgstr "如發生誤核，您可於在核銷後15分鐘內，商家端執行「反核銷」操作，將訂單恢復為未使用狀態。"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:182
msgid "如需修改請重置密碼"
msgstr "如需修改請重置密碼"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/ChainPermissionPanel.tsx:87
msgid "如需恢復，請聯繫 BD 人員後臺操作"
msgstr "如需恢復，請聯繫 BD 人員後臺操作"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:275
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:309
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:34
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:89
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:226
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:84
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:109
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/OwnerInfo/index.web.tsx:50
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:200
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:115
#: apps/dp-admin/src/pages/merchant/audit-detail/components/LegalPerson/index.web.tsx:46
#: apps/dp-admin/src/pages/merchant/audit-detail/components/AccountInfo/index.web.tsx:40
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:295
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:112
msgid "姓名"
msgstr "姓名"

#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:49
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:52
msgid "姓名／手機號"
msgstr "姓名／手機號"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:232
msgid "姓名不允許特殊字符"
msgstr "姓名不允許特殊字符"

#: apps/dp-business/src/utils/validation.ts:120
#: apps/dp-business/src/utils/validation.ts:341
msgid "姓名只能包含中文、英文字母和空格，長度2-50個字元"
msgstr "姓名只能包含中文、英文字母和空格，長度2-50個字元"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:185
msgid "姓名字數限制10個字喔"
msgstr "姓名字數限制10個字喔"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:229
msgid "姓名長度限制為 20 個字"
msgstr "姓名長度限制為 20 個字"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:111
msgid "娛樂"
msgstr "娛樂"

#: apps/dp-business/src/utils/voiceBroadcast.ts:730
msgid "婷婷"
msgstr "婷婷"

#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:175
msgid "媒體上傳失敗：{message}"
msgstr "媒體上傳失敗：{message}"

#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:227
msgid "媒體內容"
msgstr "媒體內容"

#: apps/dp-client/src/screens/home/pages/MediaGift/index.tsx:155
#: apps/dp-client/src/configs/page-configs.tsx:518
msgid "媒體專屬禮"
msgstr "媒體專屬禮"

#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/MediaReplacer.tsx:142
msgid "媒體替換失敗"
msgstr "媒體替換失敗"

#: apps/dp-business/src/pages/AddStore/CategoryPage.tsx:249
msgid "子分類"
msgstr "子分類"

#: apps/dp-admin/src/pages/resource-config/rank-list/components/RankDetailModal/index.web.tsx:60
msgid "子分類編碼"
msgstr "子分類編碼"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:55
msgid "子面板 1"
msgstr "子面板 1"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:61
msgid "子面板 2"
msgstr "子面板 2"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:89
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:197
msgid "子類型"
msgstr "子類型"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:236
msgid "字≥"
msgstr "字≥"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:126
msgid "字型"
msgstr "字型"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/AppPushTemplateSection.web.tsx:26
msgid "字數超過50字無法正常顯示"
msgstr "字數超過50字無法正常顯示"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:30
msgid "字段"
msgstr "字段"

#. placeholder {0}: field.name || index + 1
#: apps/dp-admin/src/components/ConfigurableForm/ConfigurableForm.web.tsx:170
msgid "字段 {0}: component 是必需的"
msgstr "欄位 {0}: component 是必需的"

#. placeholder {0}: index + 1
#: apps/dp-admin/src/components/ConfigurableForm/ConfigurableForm.web.tsx:167
msgid "字段 {0}: name 是必需的"
msgstr "欄位 {0}: name 是必需的"

#. placeholder {0}: content.length
#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:168
msgid "字符數: {0}"
msgstr "字符數: {0}"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.web.tsx:213
msgid "字體下載失敗"
msgstr "字體下載失敗"

#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:78
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:54
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:52
msgid "存儲方式"
msgstr "存儲方式"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:135
msgid "存取您的個人資料"
msgstr "存取您的個人資料"

#: apps/dp-admin/src/pages/error/403.web.tsx:76
msgid "存取被拒絕"
msgstr "存取被拒絕"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:139
msgid "存在相近名稱的渠道，是否繼續保存？"
msgstr "存在相近名稱的渠道，是否繼續保存？"

#: apps/dp-admin/src/pages/org-tree/components/S9BlockModal/index.web.tsx:84
msgid "存在進行中單據，暫不可提交"
msgstr "存在進行中單據，暫不可提交"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1772
msgid "存在進行中的結算或請款單據，暫不可提交審核"
msgstr "存在進行中的結算或請款單據，暫不可提交審核"

#. placeholder {0}: duplicateNames.join(', ')
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:877
msgid "存在重複標籤: {0}"
msgstr "存在重複標籤: {0}"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:123
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:138
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:147
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:162
msgid "存摺和影本"
msgstr "存摺和影本"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:82
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:124
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:159
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:93
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:29
msgid "存摺正本"
msgstr "存摺正本"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteFormFooter.tsx:43
msgid "存為草稿"
msgstr "存為草稿"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/index.web.tsx:76
#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:10
#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:29
msgid "存疑商家"
msgstr "存疑商家"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:291
#: apps/dp-admin/src/pages/audit-center/info-audit/services/hooks.ts:122
msgid "存疑商家審核"
msgstr "存疑商家審核"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:190
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:197
msgid "存草稿"
msgstr "存草稿"

#: apps/dp-admin/src/pages/audit-center/services/apis.ts:312
msgid "孫七"
msgstr "孫七"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:66
msgid "孫子面板"
msgstr "孫子面板"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:28
msgid "完全不對胃口"
msgstr "完全不對胃口"

#: apps/dp-client/src/screens/diary/components/MissionsModal/index.tsx:167
msgid "完善店家資訊"
msgstr "完善店家資訊"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:849
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/SuccessModal.tsx:61
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/CorrectionModal.tsx:162
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:467
#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewHeader.tsx:49
#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewEditorToolbar.tsx:93
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:965
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteTopicSection.tsx:104
#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:186
#: apps/dp-client/src/screens/diary/pages/my/components/RNCropPhoto/CropPhotoControls.tsx:52
#: apps/dp-client/src/screens/diary/pages/my/components/CropPhoto/index.web.tsx:345
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:177
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:160
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:309
#: apps/dp-client/src/components/FeedBackModal/index.tsx:265
#: apps/dp-business/src/pages/OnboardingComplete/index.tsx:99
#: apps/dp-admin/src/pages/worker-order/services/constants.ts:108
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:201
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:248
msgid "完成"
msgstr "完成"

#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:206
msgid "完成任務即可獲得積分"
msgstr "完成任務即可獲得積分"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:241
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:184
msgid "完成任務失敗"
msgstr "完成任務失敗"

#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:72
msgid "完成合約簽約，即可參與各類活動，拓展更多客戶，提高店家生意。"
msgstr "完成合約簽約，即可參與各類活動，拓展更多客戶，提高店家生意。"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:668
msgid "完成合約簽約，即可參與平台各類活動與服務，吸引更多顧客，拓展店家生意。"
msgstr "完成合約簽約，即可參與平台各類活動與服務，吸引更多顧客，拓展餐廳生意。"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1284
msgid "完成度 {overallProgress}% ({completedItems}/{totalItems})"
msgstr "完成度 {overallProgress}% ({completedItems}/{totalItems})"

#. placeholder {0}: suggestion.currentScore
#. placeholder {1}: suggestion.maxScore
#: apps/dp-business/src/pages/MerchantInfo/components/OptimizationCard.tsx:122
msgid "完成度：{0}/{1}"
msgstr "完成度：{0}/{1}"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:88
msgid "完成必填+10分/滿50字且至少一張圖+20分"
msgstr "完成必填+10分/滿50字且至少一張圖+20分"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:590
msgid "完成憑證"
msgstr "完成憑證"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:40
#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:56
msgid "完成簽約"
msgstr "完成簽約"

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:184
msgid "完成評論"
msgstr "完成評論"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1651
msgid "完成進度"
msgstr "完成進度"

#: apps/dp-client/src/screens/reservation/pages/main/components/BottomBar.tsx:54
msgid "完成預訂"
msgstr "完成預訂"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:236
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:69
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:61
msgid "完整代碼"
msgstr "完整代碼"

#: apps/dp-business/src/pages/SimpleDashboard/components/ModeSwitchTabs.tsx:90
msgid "完整版"
msgstr "完整版"

#: apps/dp-client/src/screens/home/pages/FoodMap/index.tsx:1699
msgid "定位不在臺灣區域，已自動定位到默認位置"
msgstr "定位不在臺灣區域，已自動定位到默認位置"

#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:86
msgid "定位中..."
msgstr "定位中..."

#: apps/dp-business/src/pages/AddressEdit/index.tsx:755
msgid "定位中……"
msgstr "定位中……"

#: apps/dp-client/src/screens/diary/store/location.ts:416
msgid "定位失敗"
msgstr "定位失敗"

#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/index.web.tsx:72
msgid "定位失敗，已按默認排序展示"
msgstr "定位失敗，已按默認排序展示"

#: apps/dp-business/src/pages/AddressEdit/index.tsx:344
msgid "定位失敗，請嘗試更具體的地址"
msgstr "定位失敗，請嘗試更具體的地址"

#: apps/dp-business/src/pages/AddressEdit/index.tsx:350
msgid "定位失敗，請檢查網路連線"
msgstr "定位失敗，請檢查網路連線"

#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:329
msgid "定位已開啟"
msgstr "定位已開啟"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:84
msgid "定位收費規則"
msgstr "定位收費規則"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/MapNaviation/index.tsx:59
#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:328
msgid "定位未開啟"
msgstr "定位未開啟"

#: apps/dp-client/src/screens/home/utils/location.ts:296
#: apps/dp-client/src/screens/diary/pages/home/components/city-select/index.tsx:141
msgid "定位權限已開啟，正在取得位置資訊"
msgstr "定位權限已開啟，正在取得位置資訊"

#: apps/dp-client/src/screens/home/utils/location.ts:301
#: apps/dp-client/src/screens/diary/pages/home/components/city-select/index.tsx:132
#: apps/dp-client/src/screens/diary/pages/home/components/city-select/index.tsx:144
#: apps/dp-client/src/screens/diary/pages/home/components/city-select/index.tsx:148
msgid "定位權限被拒絕，您可以在設定中手動開啟定位權限"
msgstr "定位權限被拒絕，您可以在設定中手動開啟定位權限"

#: apps/dp-business/src/components/MerchantBenefits/index.tsx:58
msgid "定向推廣"
msgstr "精準行銷"

#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:684
msgid "定向方式"
msgstr "定向方式"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/PublishPreviewModal.web.tsx:80
msgid "定時發佈"
msgstr "定時發佈"

#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:37
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:34
msgid "定時發送"
msgstr "定時發送"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:126
msgid "定時發送時間"
msgstr "定時發送時間"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:705
msgid "定期更新"
msgstr "定期更新"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitCard/index.web.tsx:86
msgid "定額折抵券"
msgstr "定額折抵券"

#: apps/dp-business/src/data/regions.ts:24
msgid "宜蘭"
msgstr "宜蘭"

#: apps/dp-business/src/pages/MenuManagement.tsx:142
#: apps/dp-business/src/pages/MenuItemForm.tsx:53
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:59
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:59
msgid "客人最愛"
msgstr "客人最愛"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:96
msgid "客戶券佣金明細"
msgstr "客戶券佣金明細"

#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:189
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:205
msgid "客戶類型"
msgstr "客戶類型"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:63
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:105
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:147
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:203
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:249
msgid "客服"
msgstr "客服"

#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:64
msgid "客服A"
msgstr "客服A"

#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:65
msgid "客服B"
msgstr "客服B"

#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:66
msgid "客服C"
msgstr "客服C"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:124
msgid "客服Email"
msgstr "客服Email"

#: apps/dp-admin/src/router/config/routes.web.tsx:742
#: apps/dp-admin/src/router/config/routes.web.tsx:750
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:752
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:369
msgid "客服中心"
msgstr "客服中心"

#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:57
msgid "客服人員"
msgstr "客服人員"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:53
msgid "客服信箱"
msgstr "客服信箱"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:154
#: apps/dp-client/src/screens/account/components/feedback-modal/index.tsx:79
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:164
msgid "客服信箱："
msgstr "客服信箱："

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyItem.web.tsx:70
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:91
msgid "客服備註 :"
msgstr "客服備註 :"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:93
msgid "客服名稱"
msgstr "客服名稱"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyItem.web.tsx:32
msgid "客服回覆"
msgstr "客服回覆"

#: apps/dp-business/src/utils/phoneValidation.ts:84
#: apps/dp-admin/src/utils/validation.ts:95
msgid "客服專線：0800123456 或 +886-800-123-456"
msgstr "客服專線：0800123456 或 +886-800-123-456"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:213
msgid "客服小美"
msgstr "客服小美"

#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:364
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:232
msgid "客服工單"
msgstr "客服工單"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:288
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:233
msgid "客服工單編號"
msgstr "客服工單編號"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/index.web.tsx:54
msgid "客服工單評價"
msgstr "客服工單評價"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:160
#: apps/dp-client/src/screens/account/components/feedback-modal/index.tsx:85
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:170
msgid "客服電話：{customerPhone}"
msgstr "客服電話：{customerPhone}"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:243
#: apps/dp-business/src/pages/ImageManagement/index.tsx:424
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:405
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:305
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:40
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:191
msgid "宣傳圖片"
msgstr "宣傳圖片"

#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:68
#: apps/dp-business/src/components/MaintenanceList/index.tsx:598
msgid "宣傳照片"
msgstr "宣傳照片"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/PromotionTab/index.web.tsx:93
msgid "宣傳語"
msgstr "宣傳語"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:196
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:67
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:43
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:34
msgid "室內照"
msgstr "室內照"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:204
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:51
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:35
msgid "室外環境"
msgstr "室外環境"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:82
msgid "室外環境照"
msgstr "室外環境照"

#: apps/dp-business/src/types/orderFilter.ts:198
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:421
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:422
#: apps/dp-business/src/constants/enums.ts:60
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1255
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1256
#: apps/dp-admin/src/components/BusinessHours/constants.ts:56
msgid "宵夜"
msgstr "宵夜"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:125
msgid "宵夜時段"
msgstr "宵夜時段"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:96
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:96
msgid "家人"
msgstr "家人"

#: apps/dp-business/src/data/categories.ts:34
msgid "家常川菜"
msgstr "家常川菜"

#: apps/dp-client/src/screens/home/pages/Note/pages/draft/index.tsx:144
msgid "家店家"
msgstr "家店家"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:937
msgid "容納人數："
msgstr "容納人數："

#: apps/dp-client/src/screens/login/pages/verify-password/components/verify-password-form/index.tsx:110
#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:306
#: apps/dp-client/src/screens/login/pages/password-login/components/password-login-form/index.tsx:151
#: apps/dp-client/src/screens/login/pages/login/index.tsx:440
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:96
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:363
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:177
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:280
#: apps/dp-admin/src/pages/login/components/LoginForm/index.web.tsx:67
msgid "密碼"
msgstr "密碼"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:166
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:173
msgid "密碼不可包含空格"
msgstr "密碼不可包含空格"

#: apps/dp-business/src/utils/validation.ts:259
#: apps/dp-business/src/utils/validation.ts:355
msgid "密碼不能少於8位"
msgstr "密碼不能少於8位"

#: apps/dp-business/src/pages/ChangePassword/index.tsx:142
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:132
msgid "密碼修改成功，請重新登入"
msgstr "密碼修改成功，請重新登入"

#: apps/dp-client/src/utils/utils.ts:83
msgid "密碼只能包含數字、字母、符號，不允許其他字符"
msgstr "密碼只能包含數字、字母、符號，不允許其他字符"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:332
msgid "密碼安全保護"
msgstr "密碼安全保護"

#: apps/dp-business/src/utils/validation.ts:265
#: apps/dp-business/src/utils/validation.ts:356
msgid "密碼必須包含數字與字母，且不少於 8 位"
msgstr "密碼必須包含數字與字母，且不少於 8 位"

#: apps/dp-client/src/screens/login/pages/password-login/index.tsx:136
#: apps/dp-client/src/configs/page-configs.tsx:1274
#: apps/dp-business/src/pages/Login/index.tsx:924
#: apps/dp-business/src/pages/Login/index.tsx:1388
msgid "密碼登入"
msgstr "密碼登入"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:361
msgid "密碼至少6個字元"
msgstr "密碼至少6個字元"

#: apps/dp-business/src/pages/Login/index.tsx:1294
#: apps/dp-business/src/pages/Login/index.tsx:1766
#: apps/dp-business/src/components/SetPassword/index.tsx:156
msgid "密碼設定成功"
msgstr "密碼設定成功"

#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:106
#: apps/dp-business/src/pages/SetPasswordPage/index.tsx:80
msgid "密碼設置成功，請重新登入"
msgstr "密碼設定成功，請重新登入"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:106
msgid "密碼重置成功，請查收郵件"
msgstr "密碼重置成功，請查收郵件"

#: apps/dp-client/src/screens/login/pages/verify-password/index.tsx:58
msgid "密碼錯誤，請重新輸入"
msgstr "密碼錯誤，請重新輸入"

#: apps/dp-client/src/utils/utils.ts:76
#: apps/dp-client/src/utils/utils.ts:99
msgid "密碼長度8-32位，需包含數字、字母、符號至少2種或以上元素"
msgstr "密碼長度8-32位，需包含數字、字母、符號至少2種或以上元素"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:169
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:382
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:176
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:386
msgid "密碼長度需為8~22位，且需同時包含字母與數字"
msgstr "密碼長度需為8~22位，且需同時包含字母與數字"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:137
msgid "密碼需包含數字/字母/符號至少兩類"
msgstr "密碼需包含數字/字母/符號至少兩類"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:128
msgid "密碼需為 8-32 位"
msgstr "密碼需為 8-32 位"

#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:33
#: apps/dp-client/src/configs/page-configs.tsx:1325
msgid "密碼驗證"
msgstr "密碼驗證"

#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:336
msgid "實付$"
msgstr "實付$"

#. placeholder {0}: order.actualAmount
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:316
msgid "實付${0}"
msgstr "實付${0}"

#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:86
msgid "實付小計"
msgstr "實付小計"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:124
msgid "實付總金額"
msgstr "實付總金額"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:784
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:895
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:958
#: apps/dp-business/src/pages/OrderList/index.tsx:545
#: apps/dp-business/src/pages/OrderDetail/index.tsx:829
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1163
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1360
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1583
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2422
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:199
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:221
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:697
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:618
#: apps/dp-business/src/pages/CouponVerification/index.tsx:655
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:111
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:245
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:277
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:93
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:179
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:121
msgid "實付金額"
msgstr "實付金額"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:140
msgid "實心圓"
msgstr "實心圓"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:141
msgid "實心方形"
msgstr "實心方形"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:142
msgid "實心箭頭"
msgstr "實心箭頭"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:341
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:106
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:112
msgid "實收資本額"
msgstr "實收資本額"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:655
msgid "實收資本額不能超過50個字符"
msgstr "實收資本額不能超過50個字符"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:702
msgid "實時更新"
msgstr "實時更新"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:540
msgid "實際佣金率"
msgstr "實際佣金率"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:233
msgid "實際佣金率:"
msgstr "實際佣金率:"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:57
msgid "實際匯率"
msgstr "實際匯率"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:58
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:38
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:38
msgid "實際尺寸"
msgstr "實際尺寸"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:119
msgid "實際庫存"
msgstr "實際庫存"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:139
msgid "實際庫存不得大於所選權益剩餘庫存（{stockLimit}）"
msgstr "實際庫存不得大於所選權益剩餘庫存（{stockLimit}）"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:122
msgid "實際庫存必須大於 0"
msgstr "實際庫存必須大於 0"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:208
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:230
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:188
msgid "實際收入"
msgstr "實際收入"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:96
msgid "實際生效"
msgstr "實際生效"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ActualManagerCard.web.tsx:39
#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:72
#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:74
msgid "實際管理人姓名"
msgstr "實際管理人姓名"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:77
msgid "實際管理人姓名不能超過20個字符"
msgstr "實際管理人姓名不能超過20個字符"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ActualManagerCard.web.tsx:60
#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:85
msgid "實際管理人手機號"
msgstr "實際管理人手機號"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:124
msgid "實際管理人手機門號"
msgstr "實際管理人手機門號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:558
msgid "實際管理人英文名不能超過100個字符"
msgstr "實際管理人英文名不能超過100個字符"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:106
#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:60
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:195
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:201
msgid "實際管理人資訊"
msgstr "實際管理人資訊"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:152
msgid "實際管理人身份證"
msgstr "實際管理人身份證"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:226
msgid "實際管理人身份證反面"
msgstr "實際管理人身份證反面"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:184
msgid "實際管理人身份證正面"
msgstr "實際管理人身份證正面"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:91
msgid "實際管理人身份證號"
msgstr "實際管理人身份證號"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ActualManagerCard.web.tsx:68
msgid "實際管理人身分證"
msgstr "實際管理人身分證"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:131
msgid "實際管理人身分證正面"
msgstr "實際管理人身分證正面"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:154
msgid "實際管理人身分證背面"
msgstr "實際管理人身分證背面"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ActualManagerCard.web.tsx:47
#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:116
msgid "實際管理人身分證號"
msgstr "實際管理人身分證號"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1171
msgid "實際退款"
msgstr "實際退款"

#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:159
msgid "實際退款金額"
msgstr "實際退款金額"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:520
msgid "實際金額"
msgstr "實際金額"

#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:137
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:212
msgid "審批人"
msgstr "審批人"

#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:138
msgid "審批人姓名"
msgstr "審批人姓名"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:507
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:398
msgid "審批意見"
msgstr "審批意見"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:508
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:399
msgid "審批意見不能超過 500 個字元"
msgstr "審批意見不能超過 500 個字元"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:122
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:172
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:75
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:119
msgid "審批批次 ID 不存在"
msgstr "審批批次 ID 不存在"

#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:435
msgid "審批批次 ID："
msgstr "審批批次 ID："

#: apps/dp-business/src/pages/ContractManagement/index.tsx:277
#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:155
#: apps/dp-admin/src/modules/constants/options.ts:545
msgid "審批拒絕"
msgstr "審核拒絕"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:246
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:250
#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:171
msgid "審批拒絕失敗"
msgstr "審批拒絕失敗"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:241
#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:174
msgid "審批拒絕成功"
msgstr "審批拒絕成功"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:436
msgid "審批結果未知，請刷新後核對"
msgstr "審批結果未知，請刷新後核對"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:193
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:197
#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:117
msgid "審批通過失敗"
msgstr "審批通過失敗"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:189
#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:120
msgid "審批通過成功"
msgstr "審批通過成功"

#: apps/dp-admin/src/pages/org-tree/components/ReviewHistoryModal/index.web.tsx:99
msgid "審核"
msgstr "審核"

#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:28
#: apps/dp-admin/src/pages/merchant/audit-detail/components/SystemInfo/index.web.tsx:56
msgid "審核ID"
msgstr "審核ID"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:51
msgid "審核不通過"
msgstr "審核不通過"

#. placeholder {0}: couponDetail.approvalReason
#: apps/dp-admin/src/pages/marketing/components/CouponInfoSection/index.web.tsx:78
msgid "審核不通過原因：{0}"
msgstr "審核不通過原因：{0}"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:413
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:139
msgid "審核不通過原因：{rejectReason}"
msgstr "審核不通過原因：{rejectReason}"

#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:282
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1747
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1763
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:522
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:56
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:87
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:882
#: apps/dp-business/src/pages/AddressEdit/index.tsx:795
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceToggleCard/index.web.tsx:55
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:145
#: apps/dp-admin/src/pages/split-account/services/constants.ts:80
#: apps/dp-admin/src/pages/split-account/services/constants.ts:151
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:29
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:22
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:62
#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:125
#: apps/dp-admin/src/pages/merchant/service/constants.ts:126
#: apps/dp-admin/src/pages/merchant/service/constants.ts:236
#: apps/dp-admin/src/pages/merchant/service/constants.ts:241
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/index.web.tsx:81
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:199
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:223
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditStatusBanner/index.web.tsx:28
#: apps/dp-admin/src/modules/constants/options.ts:641
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:30
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:48
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:73
msgid "審核中"
msgstr "審核中"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:104
#: apps/dp-admin/src/router/config/routes.web.tsx:302
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:243
msgid "審核中心"
msgstr "審核中心"

#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:108
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:431
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:150
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:188
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/MerchantBasicInfo/index.web.tsx:93
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:178
msgid "審核人"
msgstr "審核人"

#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:50
#: apps/dp-admin/src/pages/report-center/audit-data/components/AuditTable.web.tsx:29
msgid "審核人員"
msgstr "審核人員"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditTaskHeader/index.web.tsx:60
msgid "審核人員：{approverNameText}"
msgstr "審核人員：{approverNameText}"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:347
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/index.web.tsx:177
msgid "審核任務詳情"
msgstr "審核任務詳情"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/RemarkSection/index.web.tsx:47
msgid "審核備註"
msgstr "審核備註"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/index.web.tsx:389
msgid "審核分類"
msgstr "審核分類"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/RemarkSection/index.web.tsx:59
msgid "審核分類："
msgstr "審核分類："

#: apps/dp-admin/src/router/config/routes.web.tsx:333
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:201
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:98
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:158
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:154
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:137
msgid "審核列表"
msgstr "審核列表"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:256
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditStatusBanner/index.web.tsx:36
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:80
msgid "審核取消"
msgstr "審核取消"

#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:95
msgid "審核商家套餐券、訂位、結帳服務的開關與設定變更"
msgstr "審核商家套餐券、訂位、結帳服務的開關與設定變更"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:142
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:183
msgid "審核商家提交的基本資料"
msgstr "審核商家提交的基本資料"

#: apps/dp-admin/src/pages/users/services/apis.ts:390
msgid "審核商家申請"
msgstr "審核商家申請"

#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:42
#: apps/dp-admin/src/pages/org-tree/components/ReviewHistoryModal/index.web.tsx:75
msgid "審核單 ID"
msgstr "審核單 ID"

#. placeholder {0}: taskInfo?.taskId || taskId
#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:167
msgid "審核單 ID：{0}"
msgstr "審核單 ID：{0}"

#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:283
msgid "審核單ID"
msgstr "審核單ID"

#. placeholder {0}: taskId ?? '-'
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditTaskHeader/index.web.tsx:45
msgid "審核單ID：{0}"
msgstr "審核單ID：{0}"

#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:137
msgid "審核失敗"
msgstr "審核失敗"

#: apps/dp-business/src/pages/SubmitSuccess/index.tsx:84
msgid "審核完成後，您即可開始管理店家"
msgstr "審核完成後，您即可開始管理店家"

#: apps/dp-admin/src/pages/report-center/audit-data/components/AuditTable.web.tsx:25
msgid "審核工單ID"
msgstr "審核工單ID"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:201
msgid "審核已通過，但變更落地失敗，可重新落地或撤銷失敗變更。"
msgstr "審核已通過，但變更落地失敗，可重新落地或撤銷失敗變更。"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:111
msgid "審核已通過，正在跳轉到店家管理..."
msgstr "審核已通過，正在跳轉到店家管理..."

#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:95
msgid "審核店家資訊"
msgstr "審核店家資訊"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1753
msgid "審核建單結果尚未確認，請再次點擊「保存」以原請求確認結果"
msgstr "審核建單結果尚未確認，請再次點擊「保存」以原請求確認結果"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1235
msgid "審核建單結果尚未確認，請再次點擊「保存並提交審核」以原請求確認結果"
msgstr "審核建單結果尚未確認，請再次點擊「保存並提交審核」以原請求確認結果"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditTaskHeader/index.web.tsx:39
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditTaskHeader/index.web.tsx:40
msgid "審核後展示"
msgstr "審核後展示"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:400
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:112
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:367
#: apps/dp-admin/src/pages/merchant/components/ReviewResultSection/index.web.tsx:51
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:140
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:512
#: apps/dp-admin/src/pages/audit-center/claim-audit/index.web.tsx:217
msgid "審核意見"
msgstr "審核意見"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/RemarkSection/index.web.tsx:67
msgid "審核意見："
msgstr "審核意見："

#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:113
#: apps/dp-admin/src/pages/audit-center/claim-audit/index.web.tsx:218
msgid "審核意見不能超過 500 個字"
msgstr "審核意見不能超過 500 個字"

#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:513
msgid "審核意見不能超過500個字元"
msgstr "審核意見不能超過500個字元"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:162
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:446
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:58
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:23
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:89
#: apps/dp-admin/src/pages/split-account/services/constants.ts:86
#: apps/dp-admin/src/pages/split-account/services/constants.ts:153
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:24
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:74
#: apps/dp-admin/src/pages/merchant/service/constants.ts:136
#: apps/dp-admin/src/pages/merchant/service/constants.ts:251
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/interface.ts:51
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/hooks.ts:144
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/SigningAuditTab/index.web.tsx:112
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:366
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/EntryAuditTab/index.web.tsx:144
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:135
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:189
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:211
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditStatusBanner/index.web.tsx:24
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:77
msgid "審核拒絕"
msgstr "審核拒絕"

#: apps/dp-admin/src/pages/merchant/audit-detail/index.web.tsx:280
msgid "審核提交出錯"
msgstr "審核提交出錯"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:391
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:199
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:355
#: apps/dp-admin/src/pages/report-center/audit-data/components/AuditTable.web.tsx:40
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:116
#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:102
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:424
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:299
msgid "審核時間"
msgstr "審核時間"

#: apps/dp-admin/src/pages/audit-center/components/ManualAuditIssueItem/index.web.tsx:65
#: apps/dp-admin/src/pages/audit-center/components/AuditIssueItem/index.web.tsx:71
msgid "審核時間："
msgstr "審核時間："

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditTaskHeader/index.web.tsx:57
msgid "審核時間：{auditTimeText}"
msgstr "審核時間：{auditTimeText}"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1748
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1764
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:524
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:52
#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:277
#: apps/dp-admin/src/modules/constants/options.ts:646
msgid "審核未通過"
msgstr "審核未通過"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:174
msgid "審核未通過，即將刷新頁面..."
msgstr "審核未通過，即將刷新頁面..."

#: apps/dp-business/src/pages/SubmitSuccess/index.tsx:29
msgid "審核未通過，正在跳轉..."
msgstr "審核未通過，正在跳轉..."

#: apps/dp-business/src/pages/MerchantReview/index.tsx:446
msgid "審核未通過，駁回原因是{reason}"
msgstr "審核未通過，駁回原因是{reason}"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:191
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:73
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:80
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:148
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:269
#: apps/dp-admin/src/pages/audit-center/components/AuditIssuesList/index.web.tsx:65
#: apps/dp-admin/src/pages/audit-center/components/AuditIssuesList/index.web.tsx:102
msgid "審核歷史"
msgstr "審核歷史"

#. placeholder {0}: treeName || treeId || ''
#: apps/dp-admin/src/pages/org-tree/components/ReviewHistoryModal/index.web.tsx:133
msgid "審核歷史 · {0}"
msgstr "審核歷史 · {0}"

#: apps/dp-admin/src/pages/report-center/audit-data/components/AuditTable.web.tsx:31
#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:69
#: apps/dp-admin/src/pages/org-tree/org-list/components/ApplicationModal/index.web.tsx:75
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:94
#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:81
#: apps/dp-admin/src/pages/org-tree/components/ReviewHistoryModal/index.web.tsx:77
#: apps/dp-admin/src/pages/merchant/components/ReviewResultSection/index.web.tsx:44
#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:146
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:146
#: apps/dp-admin/src/pages/merchant/audit-detail/components/SystemInfo/index.web.tsx:58
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:38
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:107
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:173
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:393
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:79
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:115
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:207
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:68
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:98
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:67
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:58
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:190
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:67
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:41
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:150
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:177
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:51
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:150
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:104
#: apps/dp-admin/src/pages/audit-center/info-audit/components/InfoAuditTable/index.web.tsx:79
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/MerchantBasicInfo/index.web.tsx:103
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:63
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:170
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:191
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:188
#: apps/dp-admin/src/pages/audit-center/components/AuditInfoHeader/config.ts:20
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:49
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:170
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:132
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:245
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:257
msgid "審核狀態"
msgstr "審核狀態"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:382
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:352
#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:58
#: apps/dp-admin/src/pages/merchant/components/ReviewResultSection/index.web.tsx:38
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:270
msgid "審核結果"
msgstr "審核結果"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/RemarkSection/index.web.tsx:51
msgid "審核結果："
msgstr "審核結果："

#. placeholder {0}: result.successCount
#. placeholder {1}: result.failedCount
#: apps/dp-admin/src/pages/audit-center/components/ClaimAuditFailureFeedback/index.web.tsx:24
msgid "審核結果：成功 {0} 筆，失敗 {1} 筆"
msgstr "審核結果：成功 {0} 筆，失敗 {1} 筆"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:409
#: apps/dp-admin/src/pages/merchant/audit-detail/components/SystemInfo/index.web.tsx:65
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:58
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:120
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:155
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:87
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:86
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:200
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:87
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:61
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:71
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:126
#: apps/dp-admin/src/pages/audit-center/info-audit/components/InfoAuditTable/index.web.tsx:94
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:83
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:279
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:276
#: apps/dp-admin/src/pages/audit-center/components/AuditInfoHeader/config.ts:16
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:69
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:177
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:275
msgid "審核者"
msgstr "審核者"

#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:364
msgid "審核者 ID"
msgstr "審核者 ID"

#: apps/dp-admin/src/pages/audit-center/components/ManualAuditIssueItem/index.web.tsx:71
msgid "審核者："
msgstr "審核者："

#: apps/dp-admin/src/pages/merchant/components/PageHeader/index.web.tsx:69
msgid "審核處理"
msgstr "審核處理"

#: apps/dp-client/src/screens/home/pages/ReviewRule/index.tsx:13
#: apps/dp-client/src/configs/page-configs.tsx:1153
msgid "審核規則"
msgstr "審核規則"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:74
msgid "審核詳情"
msgstr "審核詳情"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:354
msgid "審核詳情跳轉"
msgstr "審核詳情跳轉"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:136
msgid "審核說明"
msgstr "審核說明"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:141
msgid "審核說明不能超過 400 個字"
msgstr "審核說明不能超過 400 個字"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:375
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:158
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:348
#: apps/dp-admin/src/pages/merchant/information-review/components/ReviewInfoSection/index.web.tsx:51
msgid "審核資訊"
msgstr "審核資訊"

#: apps/dp-admin/src/pages/merchant/audit-detail/index.web.tsx:276
msgid "審核送出失敗"
msgstr "審核送出失敗"

#: apps/dp-admin/src/pages/merchant/audit-detail/index.web.tsx:273
#: apps/dp-admin/src/pages/audit-center/services/hooks.ts:518
msgid "審核送出成功"
msgstr "審核送出成功"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:161
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:445
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:57
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:22
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:88
#: apps/dp-admin/src/pages/split-account/services/constants.ts:82
#: apps/dp-admin/src/pages/split-account/services/constants.ts:152
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:23
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:68
#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:441
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:129
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:158
#: apps/dp-admin/src/pages/merchant/service/constants.ts:131
#: apps/dp-admin/src/pages/merchant/service/constants.ts:246
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/interface.ts:50
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:405
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/hooks.ts:111
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:52
#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:245
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/SigningAuditTab/index.web.tsx:112
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:365
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/EntryAuditTab/index.web.tsx:144
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:135
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditStatusBanner/index.web.tsx:20
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:76
msgid "審核通過"
msgstr "審核通過"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:420
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/hooks.ts:79
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/hooks.ts:84
msgid "審核通過失敗"
msgstr "審核通過失敗"

#: apps/dp-business/src/pages/OnboardingComplete/index.tsx:108
msgid "審核通過後"
msgstr "審核通過後"

#. placeholder {0}: getReviewingStoreName()
#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:228
msgid "審核通過後，店家名稱將變為 {0}"
msgstr "審核通過後，店家名稱將變為 {0}"

#. placeholder {0}: getReviewingAddress()
#: apps/dp-business/src/pages/AddressEdit/index.tsx:675
msgid "審核通過後，店家地址將變為 {0}"
msgstr "審核通過後，店家地址將變為 {0}"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:690
msgid "審核通過後，店家類別將變為 {reviewCategoryInfo}"
msgstr "審核通過後，店家類別將變為 {reviewCategoryInfo}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:54
#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:103
msgid "審核通過後，會在1~3天內完成退款處理。"
msgstr "審核通過後，會在1~3天內完成退款處理。"

#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:57
msgid "審核通過後即可完成簽約"
msgstr "審核通過後即可完成簽約"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:450
msgid "審核通過後由後端執行生效，生效結果以組織申請回讀為準。"
msgstr "審核通過後由後端執行生效，生效結果以組織申請回讀為準。"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:416
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/hooks.ts:76
msgid "審核通過成功"
msgstr "審核通過成功"

#: apps/dp-admin/src/pages/report-center/audit-data/components/OverviewCards.web.tsx:31
msgid "審核通過率"
msgstr "審核通過率"

#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:36
#: apps/dp-admin/src/pages/report-center/audit-data/components/AuditTable.web.tsx:27
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:83
#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:69
#: apps/dp-admin/src/pages/merchant/information-review/components/ReviewInfoSection/index.web.tsx:40
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:119
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:104
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:180
msgid "審核類型"
msgstr "審核類型"

#: apps/dp-admin/src/modules/hooks/options/useReviewTypeOptions.ts:101
msgid "審核類型資料取得異常"
msgstr "審核類型資料取得異常"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:130
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:162
#: apps/dp-admin/src/pages/org-tree/org-audit/components/RejectModal/index.web.tsx:51
msgid "審核駁回"
msgstr "審核駁回"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:471
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/hooks.ts:112
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/hooks.ts:117
msgid "審核駁回失敗"
msgstr "審核駁回失敗"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:467
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/hooks.ts:109
msgid "審核駁回成功"
msgstr "審核駁回成功"

#: apps/dp-admin/src/pages/report-center/audit-data/components/OverviewCards.web.tsx:40
msgid "審核駁回率"
msgstr "審核駁回率"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:808
msgid "寫下您的用餐體驗"
msgstr "寫下您的用餐體驗"

#: apps/dp-client/src/screens/diary/pages/plaza/components/PlazaSearchBar/index.tsx:77
#: apps/dp-client/src/screens/diary/pages/my/components/MyPointsContent.tsx:93
#: apps/dp-client/src/screens/diary/pages/my/components/MyDiaryContent.tsx:215
#: apps/dp-client/src/screens/diary/components/task-card/index.tsx:108
#: apps/dp-client/src/screens/diary/components/shop-list-card/index.tsx:91
#: apps/dp-client/src/screens/diary/components/diary-list/index.tsx:89
#: apps/dp-client/src/screens/diary/components/MissionsModal/index.tsx:131
msgid "寫日記"
msgstr "寫日記"

#. placeholder {0}: targetTier.wordCount
#: apps/dp-client/src/hooks/tasks/useTaskRewardHint.ts:86
msgid "寫滿{0}字，可得"
msgstr "寫滿{0}字，可得"

#. placeholder {0}: targetTier.wordCount
#. placeholder {1}: targetTier.imageCount
#: apps/dp-client/src/hooks/tasks/useTaskRewardHint.ts:84
msgid "寫滿{0}字＋加{1}張圖，可得"
msgstr "寫滿{0}字＋加{1}張圖，可得"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:1285
#: apps/dp-client/src/screens/home/pages/Home/components/NoteAction/index.tsx:43
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:110
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:114
msgid "寫筆記"
msgstr "寫筆記"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:1269
#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewHeader.tsx:20
msgid "寫評論"
msgstr "寫評論"

#: apps/dp-client/src/screens/diary/pages/home/components/header-section/index.tsx:112
msgid "寫食記、賺積分、吃遍各地拿好禮"
msgstr "寫食記、賺積分、吃遍各地拿好禮"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:27
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:351
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:352
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:19
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:19
msgid "寬"
msgstr "寬"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:171
msgid "寬度"
msgstr "寬度"

#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:248
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:248
msgid "寵物友善"
msgstr "寵物友善"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1533
msgid "寵物政策"
msgstr "寵物政策"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:338
msgid "寶麗萊"
msgstr "寶麗萊"

#: apps/dp-client/src/screens/account/pages/user-profile/pages/permission-settings/index.tsx:54
msgid "封鎖"
msgstr "封鎖"

#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/index.tsx:36
msgid "封鎖後這些用戶只能看到你的頭像、暱稱、ID，無法看到你的筆記、評論，也無法對你的內容做點讚、收藏、評論等動作"
msgstr "封鎖後這些用戶只能看到你的頭像、暱稱、ID，無法看到你的筆記、評論，也無法對你的內容做點讚、收藏、評論等動作"

#: apps/dp-client/src/screens/account/pages/privacy-settings/index.tsx:53
#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/index.tsx:30
msgid "封鎖清單"
msgstr "封鎖清單"

#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/index.tsx:253
msgid "封面"
msgstr "封面"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:498
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:615
msgid "封面圖"
msgstr "封面圖"

#: apps/dp-client/src/screens/account/pages/user-profile/pages/permission-settings/index.tsx:52
msgid "將「{nickname}」封鎖"
msgstr "將「{nickname}」封鎖"

#: apps/dp-client/src/screens/account/pages/coupon/CouponScan/index.tsx:291
msgid "將QR Code置於框內即可掃描"
msgstr "將QR Code置於框內即可掃描"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:338
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:358
msgid "將使用該草稿覆蓋當前正在編輯的內容，是否繼續？"
msgstr "將使用該草稿覆蓋當前正在編輯的內容，是否繼續？"

#: apps/dp-admin/src/pages/customer-service/components/AssignModal.web.tsx:91
msgid "將分配 {ticketCount} 個工單給選中的客服"
msgstr "將分配 {ticketCount} 個工單給選中的客服"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:152
msgid "將受影響"
msgstr "將受影響"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:405
msgid "將對當前批次所有已確認的中獎者發放實際獎勵進行保存，是否繼續？"
msgstr "將對當前批次所有已確認的中獎者發放實際獎勵進行保存，是否繼續？"

#. placeholder {0}: _selectedPoi?.name || ''
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:151
msgid "將從Map8和Google Map獲取{0}的以下基本信息，是否自動填入？"
msgstr "將從Map8和Google Map獲取{0}的以下基本資訊，是否自動填入？"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:498
msgid "將按本審核單內容重新執行生效。"
msgstr "將按本審核單內容重新執行生效。"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:499
msgid "將撤銷本審核單中未生效的變更，樹結構保持現狀。"
msgstr "將撤銷本審核單中未生效的變更，樹結構保持現狀。"

#: apps/dp-client/src/screens/home/utils/businessStatus.ts:265
msgid "將於"
msgstr "將於"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:53
msgid "將於 8:00 開門"
msgstr "將於 8:00 開門"

#: apps/dp-client/src/utils/businessStatus.ts:288
msgid "將於{closeTime}結束營業"
msgstr "將於{closeTime}結束營業"

#: apps/dp-client/src/utils/businessStatus.ts:290
#: apps/dp-client/src/utils/businessStatus.ts:292
msgid "將於{openTime}營業"
msgstr "將於{openTime}營業"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:233
msgid "將通知相關運營及標籤關聯的商家"
msgstr "將通知相關運營及標籤關聯的商家"

#: apps/dp-business/src/pages/ContactBD/index.tsx:163
msgid "專業團隊為您服務"
msgstr "專業團隊為您服務"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:37
msgid "對應係用帳號"
msgstr "對應係用帳號"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:140
msgid "對接人"
msgstr "對接人"

#: apps/dp-client/src/screens/account/pages/user-profile/pages/permission-settings/index.tsx:53
msgid "對方將無法查看你公開發布的內容，也無法與你互動。對方不會收到被限制通知"
msgstr "對方將無法查看你公開發布的內容，也無法與你互動。對方不會收到被限制通知"

#. placeholder {0}: diff?.basis || '-'
#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:132
msgid "對比 {0}"
msgstr "對比 {0}"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:80
msgid "對比上次提交"
msgstr "對比上次提交"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:76
msgid "對比已生效版本"
msgstr "對比已生效版本"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:315
msgid "對比度"
msgstr "對比度"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:25
msgid "對賬不一致"
msgstr "對賬不一致"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:25
msgid "導入"
msgstr "導入"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/FixedPackageImportField/index.web.tsx:187
msgid "導入Excel"
msgstr "導入Excel"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:230
msgid "導入失敗"
msgstr "導入失敗"

#. placeholder {0}: data.successCount
#. placeholder {1}: data.failedCount
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/FixedPackageImportField/index.web.tsx:132
msgid "導入完成：成功 {0} 條，失敗 {1} 條"
msgstr "導入完成：成功 {0} 條，失敗 {1} 條"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:197
msgid "導入碼庫"
msgstr "導入碼庫"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:319
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:276
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:601
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:448
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/index.web.tsx:63
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:232
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/RefreshHistoryTab/index.web.tsx:78
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/ExportHistoryTab/index.web.tsx:141
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:208
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/RefreshHistoryTab/index.web.tsx:78
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/ExportHistoryTab/index.web.tsx:141
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/index.web.tsx:228
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:280
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:158
msgid "導出"
msgstr "導出"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/index.web.tsx:228
msgid "導出（{selectedCount}）"
msgstr "導出（{selectedCount}）"

#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:130
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:131
msgid "導出任務將在後臺異步處理，完成後可在「導出歷史」中下載結果"
msgstr "導出任務將在後臺異步處理，完成後可在「導出歷史」中下載結果"

#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:253
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:223
msgid "導出任務將在後臺異步處理，完成後可在名單詳情的「導出歷史」中下載結果。"
msgstr "導出任務將在後臺異步處理，完成後可在名單詳情的「導出歷史」中下載結果。"

#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:252
#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:140
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:222
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:141
msgid "導出任務已提交"
msgstr "導出任務已提交"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:770
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:755
#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:120
msgid "導出報表"
msgstr "導出報表"

#: apps/dp-admin/src/pages/user-info/services/apis.ts:347
#: apps/dp-admin/src/pages/report-center/services/apis.ts:189
#: apps/dp-admin/src/pages/report-center/services/apis.ts:244
#: apps/dp-admin/src/pages/report-center/services/apis.ts:298
#: apps/dp-admin/src/pages/report-center/services/apis.ts:358
#: apps/dp-admin/src/pages/report-center/services/apis.ts:423
#: apps/dp-admin/src/pages/report-center/services/apis.ts:487
#: apps/dp-admin/src/pages/report-center/services/apis.ts:553
#: apps/dp-admin/src/pages/report-center/services/apis.ts:617
msgid "導出失敗"
msgstr "導出失敗"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:144
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:148
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:355
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:359
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:942
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:948
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:763
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:769
#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:188
#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:197
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:188
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:197
msgid "導出失敗，請重試"
msgstr "導出失敗，請重試"

#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:524
msgid "導出店家"
msgstr "導出店家"

#: apps/dp-admin/src/pages/user-info/services/apis.ts:347
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:947
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:768
#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:196
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:196
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/index.web.tsx:128
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/index.web.tsx:146
msgid "導出成功"
msgstr "導出成功"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/index.web.tsx:161
msgid "導出數量超出上限"
msgstr "導出數量超出上限"

#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:257
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:257
msgid "導出歷史"
msgstr "導出歷史"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/apis.ts:188
msgid "導出用戶活動明細失敗"
msgstr "導出用戶活動明細失敗"

#: apps/dp-business/src/servers/settlement/api.ts:125
#: apps/dp-business/src/servers/settlement/api.ts:132
#: apps/dp-business/src/servers/settlement/api.ts:142
#: apps/dp-business/src/servers/chain/settlementApi.ts:198
msgid "導出結算單交易明細失敗"
msgstr "導出結算單交易明細失敗"

#: apps/dp-business/src/servers/settlement/api.ts:163
#: apps/dp-business/src/servers/settlement/api.ts:167
#: apps/dp-business/src/servers/settlement/api.ts:176
#: apps/dp-business/src/servers/chain/settlementApi.ts:184
msgid "導出結算單列表失敗"
msgstr "導出結算單列表失敗"

#: apps/dp-business/src/servers/chain/settlementApi.ts:262
msgid "導出請款單失敗"
msgstr "導出請款單失敗"

#: apps/dp-client/src/screens/reservation/pages/invitation/index.tsx:237
#: apps/dp-client/src/screens/reservation/pages/detail/components/ShopInfoCard.tsx:124
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopLocationInfo.tsx:420
#: apps/dp-client/src/screens/home/pages/Meal/components/ShopInfoCard/index.tsx:348
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:302
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:1113
msgid "導航"
msgstr "導航"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/MapNaviation/index.tsx:151
msgid "導航資訊不完整"
msgstr "導航資訊不完整"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Media/index.tsx:33
msgid "導覽圖"
msgstr "導覽圖"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:39
msgid "小"
msgstr "小"

#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:30
msgid "小姐"
msgstr "小姐"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/constants.ts:21
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:21
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:16
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:28
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:16
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:27
#: apps/dp-admin/src/modules/constants/userGroup.ts:127
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:120
msgid "小於"
msgstr "小於"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/constants.ts:22
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:24
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:17
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:29
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:17
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:28
#: apps/dp-admin/src/modules/constants/userGroup.ts:128
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:121
msgid "小於等於"
msgstr "小於等於"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:10
msgid "小明"
msgstr "小明"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:93
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:426
#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:299
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:22
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:28
#: apps/dp-admin/src/modules/constants/userGroup.ts:134
msgid "小時"
msgstr "小時"

#: apps/dp-client/src/screens/home/utils/utils.ts:68
msgid "小時前"
msgstr "小時前"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:996
msgid ""
"小桌-大桌\n"
"4人"
msgstr ""
"小桌-大桌\n"
"4人"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:26
msgid "小紅"
msgstr "小紅"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:280
msgid "小菜拼盤"
msgstr "小菜拼盤"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:42
msgid "小華"
msgstr "小華"

#: apps/dp-admin/src/pages/merchant/information-error/index.web.tsx:30
msgid "小葉"
msgstr "小葉"

#: apps/dp-admin/src/modules/constants/options.ts:8
msgid "小連鎖"
msgstr "小連鎖"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:317
msgid "尚未執行處理操作，執行後將在此展示最近一次結果。"
msgstr "尚未執行處理操作，執行後將在此展示最近一次結果。"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:149
msgid "尚未建立三級渠道"
msgstr "尚未建立三級渠道"

#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:95
msgid "尚未建立組織架構"
msgstr "尚未建立組織架構"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:255
msgid "尚未添加參數，可先新增一組 key / value；若接口無需額外參數，也可以直接提交。"
msgstr "尚未添加參數，可先新增一組 key / value；若接口無需額外參數，也可以直接提交。"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionGroupCard.web.tsx:62
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionGroupCard.web.tsx:49
msgid "尚未添加條件"
msgstr "尚未添加條件"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:127
msgid "尚未選擇參數，暫無對應範本"
msgstr "尚未選擇參數，暫無對應範本"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailManagers.tsx:41
msgid "尚無管理員"
msgstr "尚無管理員"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:28
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:20
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:20
msgid "尺寸"
msgstr "尺寸"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:684
msgid "尺寸建議180*66以內，格式png"
msgstr "尺寸建議180*66以內，格式png"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:178
msgid "居中對齊文本"
msgstr "置中對齊"

#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:217
msgid "居住地更新成功"
msgstr "居住地更新成功"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:287
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/constants.ts:60
#: apps/dp-admin/src/pages/merchant/audit-detail/utils/transformers.ts:248
msgid "居留證"
msgstr "居留證"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:429
msgid "居留證反面"
msgstr "居留證反面"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:386
msgid "居留證圖片"
msgstr "居留證圖片"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:351
#: apps/dp-admin/src/pages/merchant/components/identity-fields/ArcMetaFields.web.tsx:56
msgid "居留證期限"
msgstr "居留證期限"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/OwnerInfo/index.web.tsx:39
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:241
msgid "居留證正反面"
msgstr "居留證正反面"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:406
msgid "居留證正面"
msgstr "居留證正面"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:331
#: apps/dp-admin/src/pages/merchant/components/identity-fields/ArcMetaFields.web.tsx:44
msgid "居留證發證日期"
msgstr "居留證發證日期"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:312
#: apps/dp-admin/src/pages/merchant/audit-detail/utils/transformers.ts:247
msgid "居留證統一證號"
msgstr "居留證統一證號"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:371
#: apps/dp-admin/src/pages/merchant/components/identity-fields/ArcMetaFields.web.tsx:65
msgid "居留證背面序號"
msgstr "居留證背面序號"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:81
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/OwnerInfo/index.web.tsx:34
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/hooks.ts:67
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:240
msgid "居留證號"
msgstr "居留證號"

#: apps/dp-business/src/data/regions.ts:23
msgid "屏東"
msgstr "屏東"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:51
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:113
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:165
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:106
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:204
msgid "展示位置"
msgstr "展示位置"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:537
msgid "展示名稱（選填）"
msgstr "展示名稱（選填）"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:221
msgid "展示在用戶端結賬折扣的優惠規則說明處"
msgstr "展示在用戶端結賬折扣的優惠規則說明處"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:240
msgid "展示日期"
msgstr "展示日期"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:51
msgid "展示日期 / 時間"
msgstr "展示日期 / 時間"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:258
msgid "展示日期範圍"
msgstr "展示日期範圍"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:214
msgid "展示時長"
msgstr "展示時長"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:227
msgid "展示時長不能超過視頻時長（{maxDuration} 秒）"
msgstr "展示時長不能超過視頻時長（{maxDuration} 秒）"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:273
msgid "展示時間"
msgstr "展示時間"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:291
msgid "展示時間範圍"
msgstr "展示時間範圍"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:179
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:33
msgid "展示樣式與內容配置"
msgstr "展示樣式與內容配置"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:292
msgid "展示間隔"
msgstr "展示間隔"

#: apps/dp-client/src/screens/home/pages/Note/components/ReviewCard/index.tsx:103
#: apps/dp-client/src/screens/home/components/ReplayCard/index.tsx:279
#: apps/dp-client/src/screens/home/bizComponents/ExpandableHtmlContent/index.tsx:235
#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:83
#: apps/dp-client/src/screens/account/pages/coupon/GiftRule/index.tsx:235
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:279
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:913
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:120
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityDetails.tsx:167
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:363
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:172
#: apps/dp-admin/src/components/SearchForm/index.web.tsx:222
msgid "展開"
msgstr "展開"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterSelects.tsx:301
msgid "展開全部篩選（{hiddenCount}）"
msgstr "展開全部篩選（{hiddenCount}）"

#. placeholder {0}: nodeShops.length
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:143
msgid "展開店家（{0}）"
msgstr "展開店家（{0}）"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:438
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:503
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:124
msgid "展開折扣資訊"
msgstr "展開折扣資訊"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:184
msgid "展開搜索條件"
msgstr "展開搜索條件"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:538
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailCard/index.tsx:322
#: apps/dp-client/src/screens/account/pages/favorites/pages/searchResult/index.tsx:307
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:277
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:368
msgid "展開更多"
msgstr "展開更多"

#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:272
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:324
msgid "展開更多回覆"
msgstr "展開更多回覆"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:111
msgid "展開條件"
msgstr "展開條件"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/index.web.tsx:95
msgid "展開菜品資訊"
msgstr "展開餐點資訊"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:828
msgid "展開餐點資訊"
msgstr "展開餐點資訊"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeBasicInfo/index.web.tsx:104
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:51
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:46
msgid "層級"
msgstr "層級"

#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:111
msgid "層級數量"
msgstr "層級數量"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:227
msgid "層級詳情"
msgstr "層級詳情"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:241
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeBasicInfo/index.web.tsx:103
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:222
#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:52
msgid "層級路徑"
msgstr "層級路徑"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1493
msgid "履約表現"
msgstr "履約表現"

#: apps/dp-admin/src/pages/marketing/components/CombinedListForm/index.web.tsx:119
#: apps/dp-admin/src/components/CombinationFilterForm/index.web.tsx:24
msgid "屬於"
msgstr "屬於"

#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:229
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:210
msgid "屬於名單 ID"
msgstr "屬於名單 ID"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:49
msgid "嵌套摺疊面板"
msgstr "嵌套摺疊面板"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/types.ts:142
msgid "川拌"
msgstr "川拌"

#: apps/dp-business/src/data/categories.ts:28
#: apps/dp-admin/src/pages/user-info/services/apis.ts:143
msgid "川菜"
msgstr "川菜"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:72
msgid "工作日午餐規則"
msgstr "工作日午餐規則"

#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:470
msgid "工作日規則"
msgstr "工作日規則"

#: apps/dp-business/src/pages/ContactBD/index.tsx:225
msgid "工作時間"
msgstr "工作時間"

#. placeholder {0}: created.woDispatchNo
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:131
msgid "工單 {0} 已建立，附件上傳失敗，請稍後再試"
msgstr "工單 {0} 已建立，附件上傳失敗，請稍後再試"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:28
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:25
#: apps/dp-admin/src/pages/customer-service/components/TicketTable.web.tsx:36
msgid "工單ID"
msgstr "工單ID"

#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:210
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:98
msgid "工單ID/用戶ID"
msgstr "工單ID/用戶ID"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:265
msgid "工單內容"
msgstr "工單內容"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:376
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:235
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:587
msgid "工單列表"
msgstr "工單列表"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:154
msgid "工單創建成功"
msgstr "工單創建成功"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:185
msgid "工單回覆"
msgstr "工單回覆"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:223
msgid "工單建立"
msgstr "工單建立"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:195
msgid "工單無處理人"
msgstr "工單無處理人"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:134
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:58
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:30
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:227
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:121
#: apps/dp-admin/src/pages/customer-service/components/TicketTable.web.tsx:48
msgid "工單狀態"
msgstr "工單狀態"

#: apps/dp-admin/src/router/config/routes.web.tsx:764
#: apps/dp-admin/src/pages/worker-order/management/index.web.tsx:16
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:222
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:568
msgid "工單管理"
msgstr "工單管理"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:240
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:261
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:439
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:290
msgid "工單編號"
msgstr "工單編號"

#. placeholder {0}: detail.ticketNo
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/BasicInfoCard.web.tsx:38
msgid "工單編號 : {0}"
msgstr "工單編號 : {0}"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:112
msgid "工單編號 / 用戶ID"
msgstr "工單編號 / 用戶ID"

#: apps/dp-admin/src/router/config/routes.web.tsx:757
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:759
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:222
msgid "工單詳情"
msgstr "工單詳情"

#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:216
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:454
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:104
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:305
msgid "工單類型"
msgstr "工單類型"

#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:59
msgid "左上"
msgstr "左上"

#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:60
msgid "左下"
msgstr "左下"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:177
msgid "左對齊文本"
msgstr "靠左對齊"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:257
msgid "左旋轉"
msgstr "左旋轉"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/variantA/BrandPackageSectionA.tsx:272
#: apps/dp-client/src/screens/home/pages/Home/components/RecommendSetmeal/index.tsx:298
#: apps/dp-client/src/screens/home/pages/Home/components/HotRanking/index.tsx:431
msgid "左滑查看更多"
msgstr "左滑查看更多"

#: apps/dp-client/src/utils/utils.ts:146
#: apps/dp-client/src/screens/home/utils/utils.ts:32
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:36
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:49
msgid "差"
msgstr "差"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/OverviewCards.web.tsx:41
msgid "差評率"
msgstr "差評率"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:55
msgid "已{actionText}"
msgstr "已{actionText}"

#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:905
msgid "已上傳 {doneCount} 張"
msgstr "已上傳 {doneCount} 張"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:906
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:678
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:682
msgid "已上傳{totalPhotos}張"
msgstr "已上傳{totalPhotos}張"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:118
msgid "已上傳3張"
msgstr "已上傳3張"

#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:201
msgid "已上傳圖片"
msgstr "已上傳圖片"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:700
#: apps/dp-business/src/components/MaintenanceList/index.tsx:842
msgid "已上傳店家影片"
msgstr "已上傳店家影片"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/ShopIdUpload.web.tsx:64
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponCodeUpload.web.tsx:157
msgid "已上傳檔案"
msgstr "已上傳檔案"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:215
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:266
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:161
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:43
msgid "已上架"
msgstr "已上架"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:136
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:282
msgid "已上榜"
msgstr "已上榜"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1743
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1759
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:287
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:516
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:559
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:321
#: apps/dp-admin/src/modules/constants/options.ts:621
msgid "已上線"
msgstr "已上線"

#: apps/dp-client/src/screens/home/pages/Meal/pages/shopSelect/index.tsx:272
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ShopArea.tsx:91
#: apps/dp-client/src/components/ShopSelectSheet/index.tsx:269
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:226
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1746
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1762
#: apps/dp-business/src/constants/enums.ts:484
#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:215
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:120
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:45
#: apps/dp-admin/src/modules/constants/options.ts:631
msgid "已下架"
msgstr "已下架"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:113
msgid "已下架該店家"
msgstr "已下架該店家"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:143
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:288
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:18
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:50
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:82
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/interface.ts:53
msgid "已中獎"
msgstr "已中獎"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:93
#: apps/dp-admin/src/pages/split-account/services/constants.ts:251
#: apps/dp-admin/src/pages/marketing/benefit-management/services/constants.ts:24
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:60
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:271
#: apps/dp-admin/src/modules/constants/options.ts:319
#: apps/dp-admin/src/modules/constants/options.ts:405
#: apps/dp-admin/src/modules/constants/options.ts:549
msgid "已作廢"
msgstr "已作廢"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:101
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:81
#: apps/dp-client/src/screens/account/pages/coupon/CouponHistory/index.tsx:81
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:348
#: apps/dp-business/src/servers/order/types.ts:185
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherUsageReport.tsx:65
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherSalesReport.tsx:65
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:44
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:38
#: apps/dp-admin/src/pages/order/services/utils.ts:165
#: apps/dp-admin/src/pages/marketing/verification-record/services/utils.ts:16
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponListModal.web.tsx:73
#: apps/dp-admin/src/pages/marketing/benefit-management/services/constants.ts:23
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:59
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:263
#: apps/dp-admin/src/modules/constants/options.ts:313
msgid "已使用"
msgstr "已使用"

#. placeholder {0}: statusCounts.used
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:211
msgid "已使用（{0}）"
msgstr "已使用（{0}）"

#. placeholder {0}: usedCoupons.length
#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:613
msgid "已使用{0}張折扣券"
msgstr "已使用{0}張折扣券"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:170
msgid "已使用數量"
msgstr "已使用數量"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:188
msgid "已使用餐券"
msgstr "已使用餐券"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:36
msgid "已保存 {packageCount} 個套餐"
msgstr "已保存 {packageCount} 個套餐"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:34
msgid "已保存 {total} 個套餐"
msgstr "已保存 {total} 個套餐"

#: apps/dp-admin/src/components/ModifiedFieldTag/index.web.tsx:39
msgid "已修改"
msgstr "已修改"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:52
#: apps/dp-admin/src/pages/resource-config/category-management/services/constants.ts:14
#: apps/dp-admin/src/pages/resource-config/category-management/services/constants.ts:38
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:201
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:729
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:55
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:57
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:93
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:64
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:152
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:119
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:17
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:59
msgid "已停用"
msgstr "已停用"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:278
msgid "已兌換"
msgstr "已兌換"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:387
#: apps/dp-admin/src/pages/merchant/service/constants.ts:393
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:29
msgid "已入駐"
msgstr "已入駐"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:98
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:865
msgid "已全部退款"
msgstr "已全部退款"

#: apps/dp-admin/src/pages/org-tree/services/constants.ts:53
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:118
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:208
msgid "已刪除"
msgstr "已刪除"

#: apps/dp-client/src/screens/reservation/utils/index.ts:89
#: apps/dp-business/src/types/orderFilter.ts:175
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1107
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1941
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:874
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:45
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:28
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:241
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:214
msgid "已到店"
msgstr "已到店"

#: apps/dp-business/src/types/orderFilter.ts:129
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:176
msgid "已到店（用戶已到店用餐）"
msgstr "已到店（用戶已到店用餐）"

#: apps/dp-client/src/screens/reservation/utils/index.ts:25
#: apps/dp-client/src/screens/reservation/utils/index.ts:71
msgid "已到店用餐"
msgstr "已到店用餐"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:321
#: apps/dp-admin/src/pages/merchant/service/constants.ts:327
msgid "已創建"
msgstr "已創建"

#: apps/dp-client/src/screens/account/pages/user-profile/pages/permission-settings/index.tsx:36
msgid "已加入封鎖清單"
msgstr "已加入封鎖清單"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1807
msgid "已加入本次改動，提交審核後生效"
msgstr "已加入本次改動，提交審核後生效"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:397
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:716
msgid "已包含"
msgstr "已包含"

#. placeholder {0}: result.successCount
#. placeholder {0}: item.packageTemplateIds.length
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/channelCampaignPackageActions.ts:92
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ImportPackageFields/index.web.tsx:47
msgid "已匹配 {0} 個套餐"
msgstr "已匹配 {0} 個套餐"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:793
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/index.tsx:165
#: apps/dp-business/src/configs/page-configs.ts:999
#: apps/dp-business/src/components/CustomTabs/index.tsx:103
msgid "已參加活動管理"
msgstr "已參加活動管理"

#. placeholder {0}: activity.participantCount
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:574
msgid "已參與商家：{0}家"
msgstr "已參與商家：{0}家"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:372
msgid "已參與活動的用戶數量"
msgstr "已參與活動的用戶數量"

#: apps/dp-client/src/screens/reservation/utils/index.ts:30
#: apps/dp-client/src/screens/reservation/utils/index.ts:82
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:118
#: apps/dp-client/src/screens/account/pages/order/index.tsx:50
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:83
#: apps/dp-business/src/servers/order/types.ts:106
#: apps/dp-business/src/servers/order/types.ts:189
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:169
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:453
#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:51
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1109
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1944
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:877
#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:37
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:66
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherUsageReport.tsx:67
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherSalesReport.tsx:67
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:30
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:97
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:46
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:46
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:40
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:29
#: apps/dp-admin/src/pages/transaction/service-management/services/commission-format.ts:44
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:216
#: apps/dp-admin/src/pages/split-account/services/constants.ts:93
#: apps/dp-admin/src/pages/split-account/services/constants.ts:173
#: apps/dp-admin/src/pages/split-account/services/constants.ts:265
#: apps/dp-admin/src/pages/report-center/abnormal-orders/service/constants.ts:50
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:36
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:32
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:68
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:80
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:131
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:177
#: apps/dp-admin/src/pages/order/services/utils.ts:185
#: apps/dp-admin/src/pages/merchant/task-list/components/StatusTag/index.web.tsx:35
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:77
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:97
#: apps/dp-admin/src/pages/marketing/verification-record/services/utils.ts:24
#: apps/dp-admin/src/pages/marketing/services/interface/batchTask.ts:35
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:38
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:55
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:67
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:164
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:44
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:63
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:186
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:18
msgid "已取消"
msgstr "已取消"

#: apps/dp-business/src/types/orderFilter.ts:130
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:181
msgid "已取消（用戶主動取消）"
msgstr "已取消（用戶主動取消）"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:137
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:283
msgid "已取消上榜"
msgstr "已取消上榜"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:144
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:289
msgid "已取消中獎"
msgstr "已取消中獎"

#: apps/dp-client/src/screens/reservation/utils/index.ts:64
msgid "已取消訂位"
msgstr "已取消訂位"

#: apps/dp-client/src/screens/account/pages/notifications/pages/follow/index.tsx:150
msgid "已取消追蹤"
msgstr "已取消追蹤"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:37
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/hooks.ts:26
msgid "已受理"
msgstr "已受理"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:216
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/hooks.ts:187
msgid "已受理 {accepted} 條重試請求"
msgstr "已受理 {accepted} 條重試請求"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallProgressCard/index.tsx:61
msgid "已可兌換 "
msgstr "已可兌換 "

#: apps/dp-business/src/store/NotificationContext.tsx:679
#: apps/dp-business/src/pages/RefundList/index.tsx:136
#: apps/dp-business/src/pages/RefundList/index.tsx:147
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:390
msgid "已同意"
msgstr "已同意"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:181
msgid "已同步"
msgstr "已同步"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:61
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:92
#: apps/dp-admin/src/pages/split-account/services/constants.ts:161
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:13
msgid "已同步第三方"
msgstr "已同步第三方"

#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:274
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:207
msgid "已售"
msgstr "已售"

#. placeholder {0}: item.soldQuantity ?? 0
#. placeholder {0}: item.soldQuantity
#. placeholder {0}: formatSoldCount(soldQuantity)
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageTile.tsx:55
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/BrandPackageCouponCard/index.tsx:52
#: apps/dp-client/src/screens/home/components/SetMealCard/index.tsx:127
msgid "已售 {0}"
msgstr "已售 {0}"

#. placeholder {0}: record.soldQuantity || 0
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:263
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:288
msgid "已售: {0}"
msgstr "已售: {0}"

#. placeholder {0}: formatSoldCount(packageData.soldQuantity)
#. placeholder {0}: data.soldQuantity ?? 0
#. placeholder {0}: d.soldQuantity ?? d.soldCount ?? 0
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/Card.tsx:136
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:294
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:387
msgid "已售{0}"
msgstr "已售{0}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/MealSummaryCard.tsx:268
msgid "已售{soldQuantity}"
msgstr "已售{soldQuantity}"

#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesSummaryCards.tsx:48
msgid "已售券數"
msgstr "已售券數"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:239
msgid "已售數量"
msgstr "已售數量"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:121
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:19
msgid "已售罄"
msgstr "已售罄"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/LandingUrlField.web.tsx:29
msgid "已回填"
msgstr "已回填"

#: apps/dp-client/src/screens/account/pages/advice/my-feedback/index.tsx:67
#: apps/dp-client/src/screens/account/pages/advice/my-feedback/index.tsx:77
#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:62
#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:72
msgid "已回覆"
msgstr "已回覆"

#: apps/dp-admin/src/modules/hooks/useDownload.ts:206
msgid "已在新視窗中開啟檔案"
msgstr "已在新視窗中開啟檔案"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityGridCard.tsx:115
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/utils/activityUtils.ts:43
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:120
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:62
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:25
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:37
msgid "已報名"
msgstr "已報名"

#. placeholder {0}: tabCounts[JoinedActivityTabKey.Registered]
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityFilterCard.tsx:95
msgid "已報名 {0}"
msgstr "已報名 {0}"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:953
msgid "已填寫{descLength}字"
msgstr "已填寫{descLength}字"

#: apps/dp-client/src/screens/account/pages/coupon/CouponHistory/index.tsx:82
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:282
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/utils/activityUtils.ts:53
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:130
#: apps/dp-admin/src/pages/transaction/service-management/services/commission-format.ts:42
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:43
msgid "已失效"
msgstr "已失效"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:132
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:153
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:303
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:312
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:337
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:346
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:252
msgid "已套用 OCR 識別結果"
msgstr "已套用 OCR 識別結果"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:129
msgid "已存在・跳過"
msgstr "已存在・跳過"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:74
msgid "已存在·跳過"
msgstr "已存在·跳過"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:82
msgid "已存在同名組織樹"
msgstr "已存在同名組織樹"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:69
#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:92
#: apps/dp-client/src/screens/account/pages/order/index.tsx:48
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:61
#: apps/dp-business/src/servers/order/types.ts:102
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:167
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:451
#: apps/dp-business/src/pages/RefundList/index.tsx:91
#: apps/dp-business/src/pages/RefundList/index.tsx:150
#: apps/dp-business/src/pages/OrderList/index.tsx:936
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:222
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:229
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:236
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:262
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:291
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:332
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:456
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1120
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:145
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:172
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:181
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:190
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:656
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:716
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:28
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:57
#: apps/dp-admin/src/pages/worker-order/services/constants.ts:40
#: apps/dp-admin/src/pages/split-account/services/constants.ts:91
#: apps/dp-admin/src/pages/report-center/services/apis.ts:454
#: apps/dp-admin/src/pages/order/services/utils.ts:62
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskFilterHeader/index.web.tsx:50
#: apps/dp-admin/src/pages/merchant/task-list/components/StatusTag/index.web.tsx:30
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:137
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:137
#: apps/dp-admin/src/pages/merchant/service/constants.ts:49
#: apps/dp-admin/src/pages/marketing/services/constants.ts:335
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:462
msgid "已完成"
msgstr "已完成"

#: apps/dp-business/src/components/CopyResultView/index.tsx:55
msgid "已完成{successCount}家店的複製"
msgstr "已完成{successCount}家店的複製"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:365
msgid "已完成報名的門市數量"
msgstr "已完成報名的門市數量"

#: apps/dp-business/src/pages/ReservationManagement/StockInputGroup.tsx:73
msgid "已定"
msgstr "已定"

#: apps/dp-admin/src/pages/split-account/services/constants.ts:325
msgid "已寄到"
msgstr "已寄到"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:322
msgid "已將該用戶設置為不予發獎，設置原因為："
msgstr "已將該用戶設置為不予發獎，設置原因為："

#. placeholder {0}: value.length
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/FixedPackageImportField/index.web.tsx:199
msgid "已導入 {0} 項"
msgstr "已導入 {0} 項"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:147
msgid "已建立"
msgstr "已建立"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:535
msgid "已恢復參與活動"
msgstr "已恢復參與活動"

#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:292
msgid "已成功下架{validRowLength}條內容"
msgstr "已成功下架{validRowLength}條內容"

#: apps/dp-admin/src/modules/hooks/useBlobDownload.ts:180
msgid "已成功下載 {totalCount} 個文件"
msgstr "已成功下載 {totalCount} 個文件"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/hooks/useReviewSubmit.ts:233
msgid "已成功保存至草稿箱"
msgstr "已成功儲存草稿"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:79
msgid "已成功匯入的資料"
msgstr "已成功匯入的資料"

#. placeholder {0}: selectedUsers.length
#. placeholder {1}: selectedShops.length
#: apps/dp-business/src/pages/UserManagement/BatchCopyUsers.tsx:87
msgid "已成功將 {0} 位使用者複製到 {1} 個店家"
msgstr "已成功將 {0} 位使用者複製到 {1} 個店家"

#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:224
msgid "已成功標記{validCount}條內容為抽檢"
msgstr "已成功標記{validCount}條內容為抽檢"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:150
msgid "已成功處理 {successCount} 筆活動位"
msgstr "已成功處理 {successCount} 筆活動位"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:462
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:293
msgid "已成功退出活動"
msgstr "已成功退出活動"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:61
msgid "已成功退款，實際入帳時間以銀行通知為準。"
msgstr "已成功退款，實際入帳時間以銀行通知為準。"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:1251
msgid "已打卡"
msgstr "已打卡"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:625
msgid "已打烊"
msgstr "已打烊"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:98
#: apps/dp-admin/src/pages/split-account/services/constants.ts:258
msgid "已折讓"
msgstr "已折讓"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:445
msgid "已抽人數"
msgstr "已抽人數"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:150
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:294
msgid "已拉黑"
msgstr "已拉黑"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1113
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1950
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:883
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:53
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:35
msgid "已拒單"
msgstr "已拒單"

#: apps/dp-business/src/types/orderFilter.ts:132
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:191
msgid "已拒單（商家拒絕）"
msgstr "已拒單（商家拒絕）"

#: apps/dp-client/src/screens/reservation/utils/index.ts:85
#: apps/dp-client/src/screens/diary/components/StatusTag.tsx:11
#: apps/dp-client/src/screens/diary/components/PointsStatus.tsx:59
#: apps/dp-business/src/store/NotificationContext.tsx:667
#: apps/dp-business/src/pages/RefundList/index.tsx:106
#: apps/dp-business/src/pages/RefundList/index.tsx:148
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:411
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:220
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:33
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:185
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:115
msgid "已拒絕"
msgstr "已拒絕"

#: apps/dp-client/src/screens/account/pages/profile/components/FunctionEntrySection/index.tsx:74
msgid "已按讚"
msgstr "已按讚"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:78
#: apps/dp-admin/src/pages/split-account/services/constants.ts:252
msgid "已捐贈"
msgstr "已捐贈"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:26
msgid "已授權"
msgstr "已授權"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:399
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:717
msgid "已排除"
msgstr "已排除"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/OrgNodeTree/index.web.tsx:101
#: apps/dp-admin/src/pages/org-tree/org-create/components/EditableOrgTree/index.web.tsx:51
msgid "已掛商家"
msgstr "已掛商家"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:52
msgid "已掛接於其他樹"
msgstr "已掛接於其他樹"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:51
msgid "已掛接於本樹"
msgstr "已掛接於本樹"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:128
msgid "已掛為簽約"
msgstr "已掛為簽約"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:129
msgid "已掛為請款"
msgstr "已掛為請款"

#: apps/dp-client/src/screens/reservation/utils/index.ts:87
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1105
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1938
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:872
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:44
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:27
msgid "已接單"
msgstr "已接單"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:236
msgid "已接單，開始排查"
msgstr "已接單，開始排查"

#: apps/dp-business/src/types/orderFilter.ts:128
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:171
msgid "已接單（商家已確認）"
msgstr "已接單（商家已確認）"

#: apps/dp-admin/src/modules/constants/options.ts:51
msgid "已接觸"
msgstr "已接觸"

#: apps/dp-client/src/screens/account/pages/advice/my-feedback/index.tsx:57
#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:52
msgid "已提交"
msgstr "已提交"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:406
msgid "已提交，等待審核"
msgstr "已提交，等待審核"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:317
msgid "已提交，請到歷史頁查看結果"
msgstr "已提交，請到歷史頁查看結果"

#: apps/dp-business/src/pages/ComplaintList/index.tsx:312
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1255
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:113
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeSettlePathModal.web.tsx:59
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeMountNodeModal.web.tsx:78
msgid "已提交審核"
msgstr "已上傳審核"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1259
msgid "已提交審核，詳情刷新失敗，請手動重新整理"
msgstr "已提交審核，詳情刷新失敗，請手動重新整理"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:273
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:168
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:189
msgid "已提交重試"
msgstr "已提交重試"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:680
#: apps/dp-admin/src/pages/order/services/utils.ts:449
msgid "已撤銷"
msgstr "已撤銷"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:507
msgid "已撤銷失敗變更"
msgstr "已撤銷失敗變更"

#: apps/dp-business/src/pages/SimpleDashboard/components/RedeemCard.tsx:28
#: apps/dp-business/src/pages/OrderOverview/index.tsx:986
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:64
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:74
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:399
msgid "已支付"
msgstr "已支付"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:401
msgid "已收到您上傳的商家資料, 審核中"
msgstr "已收到您上傳的商家資料, 審核中"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/HorizontalShopCard.tsx:261
msgid "已收藏"
msgstr "已收藏"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:400
msgid "已放入你的券匣，正在前往查看"
msgstr "已放入你的券匣，正在前往查看"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:51
#: apps/dp-admin/src/pages/resource-config/category-management/services/constants.ts:13
#: apps/dp-admin/src/pages/resource-config/category-management/services/constants.ts:37
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:201
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:728
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:54
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:47
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:91
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:32
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:58
msgid "已啟用"
msgstr "已啟用"

#: apps/dp-admin/src/pages/merchant/brand-list/services/hooks.ts:313
msgid "已啟用品牌"
msgstr "已啟用品牌"

#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:285
msgid "已新增的使用者"
msgstr "已新增的使用者"

#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:271
msgid "已新增的臨時使用者"
msgstr "已新增的臨時使用者"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:78
msgid "已新建"
msgstr "已新建"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:71
msgid "已是「{location}」的請款商家"
msgstr "已是「{location}」的請款商家"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/utils/activityUtils.ts:47
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:124
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:27
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:27
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:39
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:39
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:41
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:41
#: apps/dp-admin/src/modules/constants/options.ts:395
msgid "已暫停"
msgstr "已暫停"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:499
msgid "已暫停參與活動"
msgstr "已暫停參與活動"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:403
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1663
msgid "已暫存為草稿，尚未生效"
msgstr "已暫存為草稿，尚未生效"

#: apps/dp-client/src/components/ExpoUpdate/index.tsx:98
#: apps/dp-business/src/components/ExpoUpdate/index.tsx:58
msgid "已更新至最新版本"
msgstr "已更新至最新版本"

#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:391
msgid "已更新附近捷運候選"
msgstr "已更新附近捷運候選"

#. placeholder {0}: activity.participantCount
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityCard.tsx:54
msgid "已有{0}家參與"
msgstr "已有{0}家參與"

#. placeholder {0}: activity.participantCount
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityCard.tsx:56
msgid "已有{0}家預約"
msgstr "已有{0}家預約"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:251
msgid "已有方式"
msgstr "已有方式"

#: apps/dp-admin/src/pages/org-tree/services/shopPathActions.ts:108
msgid "已有未完成的連鎖變更，請先到組織樹管理處理草稿"
msgstr "已有未完成的連鎖變更，請先到組織樹管理處理草稿"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:328
msgid "已有標籤"
msgstr "已有標籤"

#: apps/dp-client/src/components/Upload/index.tsx:393
msgid "已有視頻文件，視頻最多隻能上傳1個"
msgstr "已上傳影片，影片最多只能上傳 1個"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/index.tsx:938
msgid "已有評論內容，是否要直接發布？"
msgstr "已有評論內容，是否要直接發布？"

#: apps/dp-admin/src/pages/audit-center/info-confirm/index.web.tsx:136
msgid "已有資訊"
msgstr "已有資訊"

#: apps/dp-business/src/pages/SimpleDashboard/components/RedeemCard.tsx:27
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:293
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:523
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:556
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:569
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1158
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1226
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1239
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:327
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:356
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:602
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:638
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:58
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:68
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:32
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:403
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:45
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:81
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:285
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:72
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:115
msgid "已核銷"
msgstr "已核銷"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:225
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:247
msgid "已核銷/未核銷"
msgstr "已核銷/未核銷"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/index.tsx:140
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesSummaryCards.tsx:56
msgid "已核銷券數"
msgstr "已核銷券數"

#: apps/dp-business/src/pages/OrderList/index.tsx:556
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:101
msgid "已核銷數量"
msgstr "已核銷數量"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:133
msgid "已核銷的套餐券還可以退款嗎？"
msgstr "已核銷的套餐券還可以退款嗎？"

#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:42
msgid "已核銷量"
msgstr "已核銷量"

#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:281
msgid "已標記所有通知為已讀"
msgstr "已標記所有通知為已讀"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:191
msgid "已標記為已讀"
msgstr "已標記為已讀"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:499
msgid "已標記顧客到店"
msgstr "已標記顧客到店"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:529
msgid "已標記顧客未到店"
msgstr "已標記顧客未到店"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:98
msgid "已歇業"
msgstr "已歇業"

#: apps/dp-admin/src/modules/constants/options.ts:70
msgid "已流失"
msgstr "已流失"

#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:56
msgid "已消費評論"
msgstr "已消費評論"

#. placeholder {0}: tagsToAdd.length
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:162
msgid "已添加 {0} 個標籤"
msgstr "已添加 {0} 個標籤"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponCodeUpload.web.tsx:127
msgid "已清空券碼列表"
msgstr "已清空券碼列表"

#. placeholder {0}: suggestedDisplayScope.displayName
#: apps/dp-client/src/screens/home/pages/ShopList/components/AllRegionTip/index.tsx:85
msgid "已為您搜尋{0}結果"
msgstr "已為您搜尋{0}結果"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/index.web.tsx:48
#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:42
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/index.web.tsx:48
#: apps/dp-admin/src/pages/report-center/audit-data/index.web.tsx:48
msgid "已生成: {url}"
msgstr "已生成: {url}"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:72
msgid "已生成張數"
msgstr "已生成張數"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:266
#: apps/dp-admin/src/pages/transaction/service-management/services/commission-format.ts:40
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:52
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:66
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:96
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:117
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:182
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeBasicInfo/index.web.tsx:41
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:45
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:77
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:195
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:207
#: apps/dp-admin/src/modules/constants/options.ts:543
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:106
msgid "已生效"
msgstr "已生效"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:140
msgid "已生效連鎖的跟進 BD 變更請在列表頁使用「分配 BD」操作"
msgstr "已生效連鎖的跟進 BD 變更請在列表頁使用「分配 BD」操作"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:210
msgid "已用"
msgstr "已用"

#. placeholder {0}: record.usedCount || 0
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:266
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:291
msgid "已用: {0}"
msgstr "已用: {0}"

#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:53
#: apps/dp-client/src/screens/diary/components/StatusTag.tsx:9
#: apps/dp-client/src/screens/diary/components/StatusTag.tsx:10
#: apps/dp-admin/src/modules/constants/options.ts:390
msgid "已發佈"
msgstr "已發佈"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponListModal.web.tsx:69
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:37
#: apps/dp-admin/src/pages/marketing/benefit-management/services/constants.ts:21
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:57
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:247
#: apps/dp-admin/src/modules/constants/options.ts:307
msgid "已發放"
msgstr "已發放"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:155
msgid "已發放數量"
msgstr "已發放數量"

#: apps/dp-client/src/components/ExpoUpdate/index.tsx:69
#: apps/dp-business/src/components/ExpoUpdate/index.tsx:21
msgid "已發現新版本，需要進行更新"
msgstr "已發現新版本，需要進行更新"

#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:212
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:35
msgid "已確認"
msgstr "已確認"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:88
msgid "已確認商家正常營業"
msgstr "已確認商家正常營業"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1278
msgid "已確認訂單，並分配 "
msgstr "已確認訂單，並分配 "

#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:34
msgid "已禁用"
msgstr "已禁用"

#: apps/dp-admin/src/pages/merchant/brand-list/services/hooks.ts:287
msgid "已禁用品牌"
msgstr "已禁用品牌"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:243
msgid "已移除該使用者在當前樹的授權"
msgstr "已移除該使用者在當前樹的授權"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:618
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:78
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:64
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:109
#: apps/dp-admin/src/pages/merchant/service/constants.ts:208
#: apps/dp-admin/src/pages/merchant/service/constants.ts:366
#: apps/dp-admin/src/pages/merchant/service/constants.ts:372
#: apps/dp-admin/src/pages/merchant/service/constants.ts:409
#: apps/dp-admin/src/pages/merchant/service/constants.ts:415
#: apps/dp-admin/src/pages/marketing/services/constants.ts:251
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:44
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:53
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:45
msgid "已簽約"
msgstr "已簽約"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:264
#: apps/dp-admin/src/modules/constants/options.ts:542
msgid "已簽署"
msgstr "已簽署"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1880
msgid "已簽署行銷合約"
msgstr "已簽署行銷合約"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityCornerStatusTag.tsx:34
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/utils/activityUtils.ts:62
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/utils/activityUtils.ts:49
#: apps/dp-business/src/pages/ContractManagement/index.tsx:270
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:42
#: apps/dp-admin/src/modules/constants/options.ts:486
#: apps/dp-admin/src/modules/constants/options.ts:548
msgid "已終止"
msgstr "已終止"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1745
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1761
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:289
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:520
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:563
#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:35
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:323
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityCornerStatusTag.tsx:32
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/utils/activityUtils.ts:54
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/utils/activityUtils.ts:45
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:122
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:64
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:26
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:28
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:40
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:17
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:42
#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:21
#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:40
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/index.web.tsx:81
#: apps/dp-admin/src/modules/constants/options.ts:400
#: apps/dp-admin/src/modules/constants/options.ts:487
#: apps/dp-admin/src/modules/constants/options.ts:636
msgid "已結束"
msgstr "已結束"

#. placeholder {0}: tabCounts[JoinedActivityTabKey.Ended]
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityFilterCard.tsx:103
msgid "已結束 {0}"
msgstr "已結束 {0}"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:42
msgid "已結案"
msgstr "已結案"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:342
#: apps/dp-admin/src/pages/merchant/service/constants.ts:348
msgid "已綁定"
msgstr "已綁定"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:121
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:200
msgid "已經過了報名時間，無法參與活動"
msgstr "已經過了報名時間，無法參與活動"

#. placeholder {0}: selectedFoodItems.length
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1256
msgid "已經餐點：{0}"
msgstr "已經餐點：{0}"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/previewDownload.ts:186
msgid "已臨時隱藏可滾動元素捲軸"
msgstr "已臨時隱藏可滾動元素捲軸"

#: apps/dp-business/src/pages/ComplaintList/index.tsx:38
msgid "已處理"
msgstr "已處理"

#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:47
msgid "已處理人工工單"
msgstr "已處理人工工單"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/OverviewCards/index.web.tsx:30
msgid "已處理異常訂單數"
msgstr "已處理異常訂單數"

#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:64
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:26
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:26
msgid "已複製{label}"
msgstr "已複製{label}"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:130
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:140
msgid "已複製優惠序號"
msgstr "已複製優惠序號"

#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:532
msgid "已複製到剪貼簿"
msgstr "已複製到剪貼簿"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:135
msgid "已複製單號"
msgstr "已複製單號"

#: apps/dp-business/src/pages/UserManagement/index.tsx:419
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:261
msgid "已複製帳號資訊"
msgstr "已複製帳號資訊"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/index.web.tsx:253
msgid "已複製訂單號"
msgstr "已複製訂單號"

#: apps/dp-client/src/utils/externalApp.ts:236
msgid "已複製連結"
msgstr "已複製連結"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:115
#: apps/dp-client/src/screens/account/components/feedback-modal/index.tsx:35
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:125
msgid "已複製郵箱地址"
msgstr "已複製郵箱地址"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:115
msgid "已解掛"
msgstr "已解掛"

#. placeholder {0}: merchantSelectionData.shopTotal ?? shopListData.total ?? 0
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:527
msgid "已解析商家列表（{0}家）"
msgstr "已解析商家列表（{0}家）"

#: apps/dp-client/src/screens/account/pages/advice/my-feedback/index.tsx:72
#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:67
#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:482
#: apps/dp-client/src/screens/account/pages/advice/advice-detail/index.tsx:258
#: apps/dp-admin/src/pages/report-center/services/apis.ts:212
msgid "已解決"
msgstr "已解決"

#. placeholder {0}: account.platform
#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:282
msgid "已解除 {0} 帳號綁定"
msgstr "已解除 {0} 帳號綁定"

#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:252
#: apps/dp-client/src/screens/account/pages/user-profile/pages/permission-settings/index.tsx:36
msgid "已解除封鎖"
msgstr "已解除封鎖"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountUnbindModal.tsx:72
msgid "已解除所選節點授權"
msgstr "已解除所選節點授權"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1564
#: apps/dp-business/src/pages/ReservationManagement/TableCells.tsx:116
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:752
#: apps/dp-business/src/pages/OrderOverview/Detail/components/ReservationSlots.tsx:74
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/components/ReservationSlots.web.tsx:130
msgid "已訂庫存"
msgstr "已訂庫存"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:953
msgid "已訂庫存："
msgstr "已訂庫存："

#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:101
msgid "已設定"
msgstr "已設定"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:712
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:715
msgid "已設定類別"
msgstr "已設定類別"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1175
msgid "已設置"
msgstr "已設置"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:383
msgid "已設置定時公佈"
msgstr "已設置定時公佈"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/RefreshHistoryTab/index.web.tsx:59
msgid "已註冊用戶數"
msgstr "已註冊用戶數"

#: apps/dp-admin/src/pages/user-info/services/interface/queryUserList.ts:24
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:20
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:40
msgid "已註銷"
msgstr "已註銷"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/NoteModule/index.tsx:304
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/VideoInfo.tsx:58
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:597
#: apps/dp-client/src/screens/home/pages/Home/components/RecommendMasonryList/RecommendCard/Review.tsx:101
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:326
#: apps/dp-client/src/screens/home/components/ReplayCard/index.tsx:104
#: apps/dp-client/src/screens/home/bizComponents/NoteCard/index.tsx:123
#: apps/dp-client/src/screens/account/pages/likes/components/ReviewContent/ReviewCard.tsx:116
msgid "已註銷用戶"
msgstr "已註銷用戶"

#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/components/MerchantCard.tsx:30
msgid "已認領"
msgstr "已認領"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:799
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:942
msgid "已讀"
msgstr "已讀"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:287
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:579
msgid "已購用戶仍可依照原有有效期正常核銷。"
msgstr "已購用戶仍可依照原有有效期正常核銷。"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:279
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:571
msgid "已購用戶將依照目前設定的規則享有使用權。"
msgstr "已購用戶將依照目前設定的規則享有使用權。"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskFilterHeader/index.web.tsx:62
#: apps/dp-admin/src/pages/merchant/service/constants.ts:50
msgid "已超時"
msgstr "已超時"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountCopyForm.tsx:93
msgid "已追加節點授權"
msgstr "已追加節點授權"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:562
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/AuthorRelationshipButton.tsx:23
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:188
#: apps/dp-client/src/screens/account/pages/user-profile/components/UserInfoSection/index.tsx:209
#: apps/dp-client/src/screens/account/pages/notifications/pages/follow/index.tsx:150
#: apps/dp-client/src/screens/account/pages/notifications/components/FollowNotificationCard/index.tsx:43
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowUserListItem.tsx:56
msgid "已追蹤"
msgstr "已追蹤"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/utils/activityUtils.ts:51
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:128
#: apps/dp-admin/src/pages/marketing/services/constants.ts:473
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:29
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:41
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:40
msgid "已退出"
msgstr "已退出"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:41
msgid "已退單"
msgstr "已退單"

#: apps/dp-business/src/pages/ComplaintList/index.tsx:37
#: apps/dp-admin/src/pages/data-center/review-detail/index.web.tsx:30
msgid "已退回"
msgstr "已退回"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:556
#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:64
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:103
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:394
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:85
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:62
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:68
#: apps/dp-business/src/servers/order/types.ts:193
#: apps/dp-business/src/servers/order/types.ts:268
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1203
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCells.tsx:119
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCells.tsx:154
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherUsageReport.tsx:69
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherSalesReport.tsx:69
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:48
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:42
#: apps/dp-admin/src/pages/report-center/services/apis.ts:454
#: apps/dp-admin/src/pages/order/services/utils.ts:175
#: apps/dp-admin/src/pages/order/services/utils.ts:325
#: apps/dp-admin/src/pages/marketing/verification-record/services/utils.ts:32
#: apps/dp-admin/src/pages/marketing/services/constants.ts:322
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:57
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:91
msgid "已退款"
msgstr "已退款"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:197
msgid "已退款（{total}）"
msgstr "已退款（{total}）"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:162
#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:65
#: apps/dp-admin/src/pages/report-center/audit-data/components/AuditTable.web.tsx:36
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:30
#: apps/dp-admin/src/pages/data-center/review-detail/index.web.tsx:28
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:184
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:197
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:55
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:102
msgid "已通過"
msgstr "已通過"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/Statistics/index.web.tsx:41
msgid "已通過請款單"
msgstr "已通過請款單"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/Statistics/index.web.tsx:47
msgid "已通過金額"
msgstr "已通過金額"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:52
msgid "已進駐"
msgstr "已進駐"

#. placeholder {0}: actualData.joinedTime
#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:231
msgid "已進駐{0}"
msgstr "已進駐{0}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:102
#: apps/dp-client/src/screens/diary/components/PointsStatus.tsx:84
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:82
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:280
#: apps/dp-business/src/servers/order/types.ts:187
#: apps/dp-business/src/pages/UserManagement/index.tsx:460
#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:49
#: apps/dp-business/src/pages/ContractManagement/index.tsx:268
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherUsageReport.tsx:66
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherSalesReport.tsx:66
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:45
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:39
#: apps/dp-admin/src/pages/order/services/utils.ts:170
#: apps/dp-admin/src/pages/marketing/verification-record/services/utils.ts:19
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:405
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:287
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:116
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:120
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:18
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:26
#: apps/dp-admin/src/modules/constants/options.ts:547
msgid "已過期"
msgstr "已過期"

#: apps/dp-admin/src/pages/marketing/services/interface/batchTask.ts:203
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:194
#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:91
msgid "已過濾"
msgstr "已過濾"

#: apps/dp-client/src/screens/reservation/utils/index.ts:111
msgid "已過用餐時間，如未到店，座位可能無法為您保留"
msgstr "已過用餐時間，如未到店，座位可能無法為您保留"

#: apps/dp-client/src/screens/reservation/utils/index.ts:119
msgid "已過用餐時間，座位無法保留，敬請諒解"
msgstr "已過用餐時間，座位無法保留，敬請諒解"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:368
msgid "已過用餐時間半小時待到店訂單"
msgstr "已過用餐時間半小時待到店訂單"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeCard/index.tsx:141
#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardCard/index.tsx:129
msgid "已達上限"
msgstr "已達上限"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:88
msgid "已達兌換上限"
msgstr "已達兌換上限"

#: apps/dp-client/src/hooks/tasks/useTaskRewardHint.ts:75
msgid "已達最高獎勵，本次可得"
msgstr "已達最高獎勵，本次可得"

#: apps/dp-business/src/components/PhotoUploader/hooks/useFileUpload.ts:234
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:317
msgid "已達到最大上傳數量 {maxCount} 張"
msgstr "已達到最大上傳數量 {maxCount} 張"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:413
msgid "已達到最大步驟數（10步）"
msgstr "已達到最大步驟數（10步）"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:518
#: apps/dp-client/src/screens/home/pages/Meal/components/CouponPickerModal/index.tsx:227
msgid "已達到訂單最大金額"
msgstr "已達到訂單最大金額"

#: apps/dp-client/src/screens/home/pages/Review/components/RecommendDishesModal/index.tsx:387
msgid "已選"
msgstr "已選"

#. placeholder {0}: value.length
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ManualPackageSelector/index.web.tsx:47
msgid "已選 {0} 個套餐："
msgstr "已選 {0} 個套餐："

#. placeholder {0}: channels.length
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignChannelFields/index.web.tsx:32
msgid "已選 {0} 個渠道"
msgstr "已選 {0} 個渠道"

#. placeholder {0}: selectedRowKeys.length
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:192
msgid "已選 {0} 家{unitLabel}"
msgstr "已選 {0} 家{unitLabel}"

#. placeholder {0}: selectedRowKeys.length
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:171
msgid "已選 {0} 家{unitLabel}，其中 {otherCount} 家已掛在其他節點，確認後新增「{targetPath}」的掛接，保留其他節點的已有掛接關係。是否繼續？"
msgstr "已選 {0} 家{unitLabel}，其中 {otherCount} 家已掛在其他節點，確認後新增「{targetPath}」的掛接，保留其他節點的已有掛接關係。是否繼續？"

#. placeholder {0}: selection.length
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:335
msgid "已選 {0} 筆，最多 {CLAIM_BATCH_LIMIT} 筆"
msgstr "已選 {0} 筆，最多 {CLAIM_BATCH_LIMIT} 筆"

#. placeholder {0}: selectedRows.length
#. placeholder {1}: approvalRows.length
#: apps/dp-admin/src/pages/audit-center/claim-audit/index.web.tsx:208
msgid "已選 {0} 筆請款單，本次將通過 {1} 筆待審核請款單，確認繼續？"
msgstr "已選 {0} 筆請款單，本次將通過 {1} 筆待審核請款單，確認繼續？"

#. placeholder {0}: value.length
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageCouponPicker/index.web.tsx:185
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:284
msgid "已選 {0} 項"
msgstr "已選 {0} 項"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:366
msgid "已選 {selectedCount} 個"
msgstr "已選 {selectedCount} 個"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:812
msgid "已選 {selectedCount} 張"
msgstr "已選 {selectedCount} 張"

#. placeholder {0}: overrideIds?.length
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/index.web.tsx:214
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/index.web.tsx:212
#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:123
msgid "已選 <0>{0}</0> 個商家"
msgstr "已選 <0>{0}</0> 個商家"

#. placeholder {0}: selectedIds.length
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:447
msgid "已選 <0>{0}</0> 張"
msgstr "已選 <0>{0}</0> 張"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:124
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:113
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeMountNodeModal.web.tsx:130
msgid "已選："
msgstr "已選："

#. placeholder {0}: category.facilities.filter((f) => f.isSelected).length
#. placeholder {1}: category.facilities.length
#: apps/dp-admin/src/pages/merchant/components/StoreSettingsSection/index.web.tsx:162
msgid "已選{0} / {1}項"
msgstr "已選{0} / {1}項"

#. placeholder {0}: selectedCoupons.length
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:508
#: apps/dp-client/src/screens/home/pages/Meal/components/CouponPickerModal/index.tsx:212
msgid "已選{0}張"
msgstr "已選{0}張"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:586
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:928
msgid "已選{selectedCount}項"
msgstr "已選{selectedCount}項"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:277
msgid "已選「{selectedRoleName}」，聯絡方式可以不填。"
msgstr "已選「{selectedRoleName}」，聯絡方式可以不填。"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:127
msgid "已選25項"
msgstr "已選25項"

#. placeholder {0}: selectedRowKeys.length
#. placeholder {1}: sureSettlementOrderIds.length
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:402
msgid "已選中 {0} 個結算訂單，其中可審批 {1} 個"
msgstr "已選中 {0} 個結算訂單，其中可審批 {1} 個"

#. placeholder {0}: selectedRowKeys.length
#. placeholder {1}: sureClaimRequestIds.length
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:406
msgid "已選中 {0} 個請款單，其中可審批 {1} 個"
msgstr "已選中 {0} 個請款單，其中可審批 {1} 個"

#. placeholder {0}: selectedTaskIds.length
#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:181
msgid "已選中 {0} 項任務"
msgstr "已選中 {0} 項任務"

#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:568
msgid "已選中{globalSelectedCount}個商家（跨頁面選擇）"
msgstr "已選中{globalSelectedCount}個商家（跨頁面選擇）"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1079
msgid "已選中{globalSelectedCount}個店家（跨頁面選擇）"
msgstr "已選中{globalSelectedCount}個店家（跨頁面選擇）"

#. placeholder {0}: selectedItems.length
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:173
msgid "已選中的 {itemTypeName} {0} 個"
msgstr "已選中的 {itemTypeName} {0} 個"

#. placeholder {0}: value.length
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageCouponPicker/index.web.tsx:227
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:330
msgid "已選套餐（{0}）"
msgstr "已選套餐（{0}）"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:66
msgid "已選擇"
msgstr "已選擇"

#. placeholder {0}: selections.length
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:161
msgid "已選擇 {0} 個分類"
msgstr "已選擇 {0} 個分類"

#. placeholder {0}: selections.length
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:207
msgid "已選擇 {0} 個商圈/夜市"
msgstr "已選擇 {0} 個商圈/夜市"

#. placeholder {0}: selections.length
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:206
msgid "已選擇 {0} 個商場"
msgstr "已選擇 {0} 個商場"

#. placeholder {0}: partialDates.length
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:397
msgid "已選擇 {0} 個日期段"
msgstr "已選擇 {0} 個日期段"

#. placeholder {0}: partialTimes.length
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:520
msgid "已選擇 {0} 個時間段"
msgstr "已選擇 {0} 個時間段"

#. placeholder {0}: selections.length
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:160
msgid "已選擇 {0} 個縣市/行政區"
msgstr "已選擇 {0} 個縣市/行政區"

#. placeholder {0}: records.length
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/UpdateLocationModal/index.web.tsx:92
msgid "已選擇 {0} 家店家，將統一設置為以下樓層與位置。"
msgstr "已選擇 {0} 家店家，將統一設置為以下樓層與位置。"

#. placeholder {0}: selectedRowKeys.length
#. placeholder {0}: state.selected.rowKeys.length
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:637
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:668
msgid "已選擇 {0} 項"
msgstr "已選擇 {0} 項"

#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:332
msgid "已選擇{selectedCount}條"
msgstr "已選擇{selectedCount}條"

#. placeholder {0}: selectedOption.label
#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:56
msgid "已選擇「{0}」"
msgstr "已選擇「{0}」"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:373
msgid "已選擇的使用者"
msgstr "已選擇的使用者"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:579
msgid "已選擇的內容"
msgstr "已選擇的內容"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:418
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:540
msgid "已選擇的店家"
msgstr "已選擇的店家"

#: apps/dp-admin/src/pages/merchant/components/StoreSettingsSection/index.web.tsx:280
msgid "已選擇項目統計"
msgstr "已選擇項目統計"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:198
msgid "已選渠道"
msgstr "已選渠道"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:276
msgid "已選超級管理員，接下來 Email 與手機門號都要填。"
msgstr "已選超級管理員，接下來 Email 與手機門號都要填。"

#. placeholder {0}: selected.length
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:488
msgid "已選餐點：{0}"
msgstr "已選餐點：{0}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:91
msgid "已部分退款"
msgstr "已部分退款"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:507
msgid "已重新落地"
msgstr "已重新落地"

#: apps/dp-admin/src/modules/hooks/useDownload.ts:249
#: apps/dp-admin/src/modules/hooks/useDownload.ts:288
msgid "已開始下載 {totalCount} 個文件"
msgstr "已開始下載 {totalCount} 個文件"

#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:155
msgid "已開啟"
msgstr "已開啟"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:73
#: apps/dp-admin/src/pages/split-account/services/constants.ts:249
msgid "已開票"
msgstr "已開票"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:129
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:143
#: apps/dp-admin/src/pages/merchant/service/constants.ts:420
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:741
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:764
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:787
msgid "已開通"
msgstr "已開通"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1891
msgid "已開通用戶自核銷"
msgstr "已開通用戶自核銷"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:467
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:105
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:63
#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:155
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:59
msgid "已關閉"
msgstr "已關閉"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:213
msgid "已關閉額外加碼"
msgstr "已關閉額外加碼"

#: apps/dp-client/src/screens/reservation/components/ReservationTimeSelector/index.tsx:62
msgid "已預訂"
msgstr "已預訂"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/records/components/PointsRecordItem/index.tsx:42
msgid "已領取"
msgstr "已領取"

#: apps/dp-client/src/screens/home/pages/MediaGift/index.tsx:193
msgid "已領取，前往票券匣"
msgstr "已領取，前往票券匣"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:404
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:774
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:469
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:258
msgid "已領數量"
msgstr "已領數量"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:20
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:84
msgid "已領獎"
msgstr "已領獎"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsList.tsx:103
msgid "已顯示全部評價"
msgstr "已顯示全部評價"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:716
msgid "已顯示全部評論"
msgstr "已顯示全部評論"

#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/components/FloatingList.tsx:217
msgid "已顯示最多60條結果"
msgstr "已顯示最多60條結果"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:162
#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:66
#: apps/dp-admin/src/pages/report-center/audit-data/components/AuditTable.web.tsx:36
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:31
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:64
#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:441
msgid "已駁回"
msgstr "已駁回"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:195
msgid "已駁回：{rejectReason}"
msgstr "已駁回：{rejectReason}"

#: apps/dp-business/src/components/VerificationInput/index.tsx:121
msgid "已驗證"
msgstr "已驗證"

#: apps/dp-business/src/utils/phoneValidation.ts:87
msgid "市區號碼：02-12345678 或 +886-2-12345678"
msgstr "市區號碼：02-12345678 或 +886-2-12345678"

#: apps/dp-admin/src/utils/validation.ts:99
msgid "市區號碼：02-12345678 或 +886-2-12345678（可加分機，如 +886-3910-0988#2867）"
msgstr "市區號碼：02-12345678 或 +886-2-12345678（可加分機，如 +886-3910-0988#2867）"

#: apps/dp-admin/src/modules/constants/options.ts:129
msgid "市話"
msgstr "市話"

#. placeholder {0}: route.merchantName
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:136
msgid "帳匯進 {0}"
msgstr "帳匯進 {0}"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:134
msgid "帳匯進本商家"
msgstr "帳匯進本商家"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:180
msgid "帳匯進本商家的店家"
msgstr "帳匯進本商家的店家"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:127
msgid "帳戶之金融機構代碼"
msgstr "帳戶之金融機構代碼"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:125
msgid "帳戶名"
msgstr "帳戶名"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:43
msgid "帳戶名稱"
msgstr "帳戶名稱"

#: apps/dp-business/src/pages/ForgotPasswordPage/index.tsx:48
msgid "帳戶未綁定信箱或手機號，無法找回密碼"
msgstr "帳戶未綁定信箱或手機號，無法找回密碼"

#: apps/dp-business/src/pages/SetPasswordPage/index.tsx:51
msgid "帳戶未綁定信箱或手機號，無法設定密碼"
msgstr "帳戶未綁定信箱或手機號，無法設定密碼"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserInfoCard/index.web.tsx:82
msgid "帳戶狀態"
msgstr "帳戶狀態"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:51
msgid "帳戶資訊："
msgstr "帳戶資訊："

#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:57
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:15
msgid "帳戶通知"
msgstr "帳戶通知"

#: apps/dp-admin/src/pages/org-tree/components/S9BlockModal/index.web.tsx:42
msgid "帳期"
msgstr "帳期"

#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:297
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:261
#: apps/dp-client/src/screens/account/pages/privacy-settings/index.tsx:62
#: apps/dp-client/src/screens/account/pages/privacy-settings/account/index.tsx:50
#: apps/dp-client/src/configs/page-configs.tsx:2081
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:108
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:133
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:269
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:146
msgid "帳號"
msgstr "帳號"

#. placeholder {0}: merchantUserInfo.accountName
#. placeholder {0}: operatorUserInfo.accountName
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:60
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:71
msgid "帳號：{0}"
msgstr "帳號：{0}"

#. placeholder {0}: maskString(account || '')
#. placeholder {0}: maskPhoneNumber(userProfile?.phone || '')
#: apps/dp-client/src/screens/login/pages/verify-password/index.tsx:80
#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:151
msgid "帳號{0}"
msgstr "帳號{0}"

#: apps/dp-admin/src/pages/users/services/apis.ts:320
msgid "帳號ID不能為空"
msgstr "帳號ID不能為空"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:42
msgid "帳號下店家數量"
msgstr "帳號下店家數量"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:603
msgid "帳號不能超過30個字符"
msgstr "帳號不能超過30個字符"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:110
#: apps/dp-client/src/screens/account/pages/privacy-settings/account/index.tsx:40
#: apps/dp-client/src/configs/page-configs.tsx:2100
msgid "帳號刪除"
msgstr "帳號刪除"

#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:283
#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:287
msgid "帳號刪除失敗"
msgstr "帳號刪除失敗"

#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:280
msgid "帳號刪除成功"
msgstr "帳號刪除成功"

#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:74
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:71
msgid "帳號名"
msgstr "帳號名"

#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:193
msgid "帳號名/郵箱/手機號"
msgstr "帳號名/郵箱/手機號"

#: apps/dp-business/src/pages/UserManagement/index.tsx:451
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:317
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:285
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:323
msgid "帳號名稱"
msgstr "帳號名稱"

#: apps/dp-business/src/pages/UserManagement/index.tsx:417
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:258
msgid "帳號名稱：{loginName}"
msgstr "帳號名稱：{loginName}"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:155
msgid "帳號名稱不可包含空格"
msgstr "帳號名稱不可包含空格"

#: apps/dp-business/src/utils/passwordGenerator.ts:52
msgid "帳號名稱不能為 11 位純數字"
msgstr "帳號名稱不能為 11 位純數字"

#: apps/dp-business/src/utils/passwordGenerator.ts:46
msgid "帳號名稱只能包含字母、數字和下劃線"
msgstr "帳號名稱只能包含字母、數字和下劃線"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:160
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:335
msgid "帳號名稱長度需為6~22位，且需同時包含字母與數字"
msgstr "帳號名稱長度需為6~22位，且需同時包含字母與數字"

#: apps/dp-business/src/utils/passwordGenerator.ts:43
msgid "帳號名稱須為 6 至 22 位"
msgstr "帳號名稱須為 6 至 22 位"

#: apps/dp-business/src/utils/passwordGenerator.ts:49
msgid "帳號名稱首尾不能為下劃線"
msgstr "帳號名稱首尾不能為下劃線"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:51
msgid "帳號問題"
msgstr "帳號問題"

#: apps/dp-business/src/pages/UserManagement/index.tsx:417
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:258
msgid "帳號密碼：{pwd}"
msgstr "帳號密碼：{pwd}"

#: apps/dp-business/src/pages/UserManagement/index.tsx:377
msgid "帳號已{actionLabel}"
msgstr "帳號已{actionLabel}"

#: apps/dp-business/src/pages/AccountDeactivationSuccess/index.tsx:43
msgid "帳號成功註銷"
msgstr "帳號成功註銷"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:36
msgid "帳號所有人資訊異常"
msgstr "帳號所有人資訊異常"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:186
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:287
#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:201
msgid "帳號狀態"
msgstr "帳號狀態"

#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:267
#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:271
msgid "帳號狀態更新失敗"
msgstr "帳號狀態更新失敗"

#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:264
msgid "帳號狀態更新成功"
msgstr "帳號狀態更新成功"

#: apps/dp-client/src/screens/account/pages/privacy-settings/index.tsx:89
msgid "帳號相關"
msgstr "帳號相關"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:815
#: apps/dp-business/src/components/CustomTabs/index.tsx:226
#: apps/dp-admin/src/router/config/routes.web.tsx:496
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:161
#: apps/dp-admin/src/pages/users/user-tasks/index.web.tsx:47
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:98
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:108
#: apps/dp-admin/src/pages/merchant/shop-detail/components/DetailMobile/components/MerchantActionButtons.web.tsx:35
#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:179
msgid "帳號管理"
msgstr "帳號管理"

#: apps/dp-client/src/screens/home/hooks/useHomeBindRedirect.ts:61
#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:106
#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:311
#: apps/dp-client/src/screens/account/pages/account-security/third-party/bind/index.tsx:102
msgid "帳號綁定成功"
msgstr "帳號綁定成功"

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:158
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:187
#: apps/dp-client/src/configs/page-configs.tsx:1827
msgid "帳號設定"
msgstr "帳號設定"

#: apps/dp-client/src/configs/page-configs.tsx:1240
msgid "帳號資訊"
msgstr "帳號資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:111
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:136
msgid "帳號長度不能超過14碼"
msgstr "帳號長度不能超過14碼"

#: apps/dp-business/src/utils/passwordGenerator.ts:55
msgid "帳號需同時包含字母和數字"
msgstr "帳號需同時包含字母和數字"

#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:80
msgid "帳號類別"
msgstr "帳號類別"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:81
msgid "帶回調的面板"
msgstr "帶回調的面板"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:79
msgid "帶狀態回調"
msgstr "帶狀態回調"

#: apps/dp-client/src/screens/diary/pages/rule/index.tsx:150
#: apps/dp-client/src/screens/diary/pages/question/index.tsx:61
#: apps/dp-client/src/screens/diary/pages/home/components/header-section/index.tsx:91
#: apps/dp-client/src/configs/page-configs.tsx:2788
msgid "常見問題"
msgstr "常見問題"

#: apps/dp-client/src/screens/diary/pages/no-access/index.tsx:89
msgid "常見問題說明"
msgstr "常見問題說明"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:118
msgid "常規"
msgstr "常規"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1679
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1398
msgid "常規可用時間"
msgstr "常規可用時間"

#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:196
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:191
msgid "幣種"
msgstr "幣種"

#: apps/dp-client/src/screens/login/pages/login/index.tsx:134
#: apps/dp-client/src/configs/page-configs.tsx:2622
#: apps/dp-client/src/configs/page-configs.tsx:2623
msgid "幫助"
msgstr "幫助"

#: apps/dp-client/src/screens/account/pages/advice/advice-feedback/index.tsx:262
#: apps/dp-client/src/configs/page-configs.tsx:1549
#: apps/dp-client/src/configs/page-configs.tsx:1551
msgid "幫助中心"
msgstr "幫助中心"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:105
msgid "幫助我們提供服務的第三方公司。"
msgstr "幫助我們提供服務的第三方公司。"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:140
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:249
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:332
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:373
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:533
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:591
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:50
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:133
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:209
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:171
msgid "平台"
msgstr "平台"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2764
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:248
msgid "平台 + 商家的補貼，在該筆訂單中實際生效的總金額"
msgstr "平台 + 商家的補貼，在該筆訂單中實際生效的總金額"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1107
msgid "平台 ID"
msgstr "平台 ID"

#: apps/dp-admin/src/pages/audit-center/info-audit/components/InfoAuditTable/index.web.tsx:44
msgid "平台ID"
msgstr "平台ID"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1937
msgid "平台一週年慶典系列活動"
msgstr "平台一週年慶典系列活動"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCommonColumns.tsx:77
msgid "平台代開發票"
msgstr "平台代開發票"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/IncomeCalculationSection.tsx:162
msgid "平台佣金"
msgstr "平台佣金"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1591
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:703
msgid "平台傭金"
msgstr "平台佣金"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1321
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:942
#: apps/dp-client/src/screens/home/pages/Purchase/components/PurchaseModal/index.tsx:268
msgid "平台優惠"
msgstr "平台優惠"

#: apps/dp-client/src/store/couponStore.ts:386
msgid "平台優惠券領取失敗"
msgstr "平台優惠券領取失敗"

#: apps/dp-client/src/store/couponStore.ts:384
msgid "平台優惠券領取成功"
msgstr "平台優惠券領取成功"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1822
msgid "平台券碼"
msgstr "平台券碼"

#: apps/dp-admin/src/router/config/routes.web.tsx:199
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/index.web.tsx:172
msgid "平台券管理"
msgstr "平台券管理"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:147
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1151
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1576
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:98
msgid "平台券補貼"
msgstr "平台券補貼"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:121
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/MerchantBasicInfo/index.web.tsx:80
#: apps/dp-admin/src/pages/audit-center/components/AuditInfoHeader/config.ts:8
msgid "平台商家ID"
msgstr "平台商家ID"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:714
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:324
msgid "平台均價"
msgstr "平台均價"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:792
#: apps/dp-business/src/components/CustomTabs/index.tsx:95
msgid "平台官方活動管理"
msgstr "平台官方活動管理"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1875
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2183
msgid "平台客服"
msgstr "平台客服"

#: apps/dp-business/src/pages/ComplaintList/index.tsx:380
msgid "平台審核中"
msgstr "平台審核中"

#: apps/dp-business/src/components/CheckoutServiceModal/index.tsx:38
msgid "平台已為您開通結帳服務！"
msgstr "平台已為您開通結帳服務！"

#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:99
msgid "平台承擔優惠"
msgstr "平台承擔優惠"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:450
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1457
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:48
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:108
msgid "平台折扣"
msgstr "平台折扣"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:142
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:660
msgid "平台折扣使用時間"
msgstr "平台折扣使用時間"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:389
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:855
msgid "平台折扣使用時間："
msgstr "平台折扣使用時間："

#: apps/dp-client/src/screens/home/pages/Purchase/components/PurchaseModal/index.tsx:187
msgid "平台折扣券"
msgstr "平台折扣券"

#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/index.tsx:155
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/columns.tsx:84
msgid "平台折扣補貼"
msgstr "平台折扣補貼"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:125
msgid "平台整體"
msgstr "平台整體"

#: apps/dp-admin/src/router/config/routes.web.tsx:135
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:170
#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:205
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:735
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:67
#: apps/dp-admin/src/modules/constants/userGroup.ts:160
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:239
msgid "平台活動"
msgstr "平台活動"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:747
msgid "平台活動列表"
msgstr "平台活動列表"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/NoDiscount.tsx:27
msgid "平台活動推廣中，同城商家已陸續參加~"
msgstr "平台活動推廣中，同城商家已陸續參加~"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1815
#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:33
msgid "平台減免"
msgstr "平台減免"

#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:41
msgid "平台減扣金額"
msgstr "平台減扣金額"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:45
msgid "平台營運相關"
msgstr "平台營運相關"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:682
#: apps/dp-admin/src/pages/order/services/utils.ts:454
msgid "平台發起"
msgstr "平台發起"

#: apps/dp-business/src/servers/chain/reportApi.ts:208
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:22
msgid "平台結帳折扣"
msgstr "平台結帳折扣"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2691
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:191
msgid "平台總計補貼"
msgstr "平台總計補貼"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:817
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1736
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/IncomeCalculationSection.tsx:140
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:681
#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:39
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:238
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:140
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:188
msgid "平台補貼"
msgstr "平台補貼"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:67
msgid "平台補貼上限"
msgstr "平台補貼上限"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:198
msgid "平台補貼必須在 0-100 之間"
msgstr "平台補貼必須在 0-100 之間"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:61
msgid "平台補貼比例"
msgstr "平台補貼比例"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:170
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:348
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:813
msgid "平台補貼說明"
msgstr "平台補貼說明"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:921
msgid "平台評價數"
msgstr "平台評價數"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:914
msgid "平台評分"
msgstr "平台評分"

#: apps/dp-business/src/servers/chain/reportApi.ts:132
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:23
msgid "平台銷售報表"
msgstr "平台銷售報表"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:24
msgid "平台銷售發票明細"
msgstr "平台銷售發票明細"

#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:99
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:69
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:167
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:138
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:21
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:128
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:204
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:165
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateDetailInfo/index.web.tsx:65
msgid "平台類型"
msgstr "平台類型"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:61
msgid "平均分享次數"
msgstr "平均分享次數"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:91
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/OverviewCards.web.tsx:75
#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:68
msgid "平均客單價"
msgstr "平均客單價"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:79
msgid "平均排行值"
msgstr "平均排行值"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1584
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1651
msgid "平均接單時間"
msgstr "平均接單時間"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:101
msgid "平均消耗活動點數值"
msgstr "平均消耗活動點數值"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:138
msgid "平均積分"
msgstr "平均積分"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:90
msgid "平均簽到次數"
msgstr "平均簽到次數"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:355
msgid "平均訂單價值"
msgstr "平均訂單價值"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityStatsCards.web.tsx:53
msgid "平均訂單金額"
msgstr "平均訂單金額"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/OverviewCards.web.tsx:50
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/OverviewCards.web.tsx:66
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:67
#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:80
#: apps/dp-admin/src/pages/data-center/merchant-stats/services/hooks.tsx:85
#: apps/dp-admin/src/pages/data-center/merchant-stats/services/hooks.tsx:93
msgid "平均評分"
msgstr "平均評分"

#. placeholder {0}: payload[0].value.toFixed(1)
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewTrendChart.web.tsx:43
msgid "平均評分: {0} 分"
msgstr "平均評分: {0} 分"

#: apps/dp-client/src/screens/home/utils/order.ts:472
#: apps/dp-client/src/screens/home/utils/order.ts:885
msgid "平日"
msgstr "平日"

#: apps/dp-client/src/screens/home/utils/order.ts:884
msgid "平日可用"
msgstr "平日可用"

#: apps/dp-business/src/data/regions.ts:73
msgid "平溪區"
msgstr "平溪區"

#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:49
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:53
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:26
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:31
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:32
#: apps/dp-admin/src/modules/constants/userGroup.ts:138
msgid "年"
msgstr "年"

#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:42
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:106
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:45
msgid "年份"
msgstr "年份"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:21
msgid "年齡"
msgstr "年齡"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:206
msgid "幾月"
msgstr "幾月"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:221
msgid "幾號"
msgstr "幾號"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:865
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:455
#: apps/dp-admin/src/components/BusinessHours/index.web.tsx:475
#: apps/dp-admin/src/components/BusinessHours/SpecialBusinessHours.web.tsx:321
msgid "幾點營業"
msgstr "幾點營業"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:313
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:106
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryUserDrawHistoryModal.web.tsx:74
#: apps/dp-admin/src/components/DataTable/index.web.tsx:79
msgid "序號"
msgstr "序號"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/ShopHeader.tsx:49
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/ShopHeader.tsx:102
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:500
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:578
#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:219
msgid "店"
msgstr "店"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1195
msgid "店內價格"
msgstr "店內價格"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1066
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/config.ts:26
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:29
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:151
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/config.ts:26
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:175
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:194
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/MerchantBasicInfo/index.web.tsx:113
msgid "店名"
msgstr "店名"

#. placeholder {0}: shopInfo.name
#: apps/dp-business/src/pages/AddStore/index.tsx:1022
#: apps/dp-business/src/pages/AddStore/index.tsx:1067
msgid "店名：{0}"
msgstr "店名：{0}"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:82
msgid "店名已複製"
msgstr "店名已複製"

#: apps/dp-client/src/screens/home/pages/Meal/components/ShopInfoCard/index.tsx:203
msgid "店名暫無"
msgstr "暫無店名"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:77
msgid "店名為空，無法複製"
msgstr "店名為空，無法複製"

#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:11
#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:30
msgid "店名變動"
msgstr "店名變動"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:461
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:484
#: apps/dp-client/src/screens/home/components/ReplayCard/index.tsx:143
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:456
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:551
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:576
#: apps/dp-client/src/screens/account/pages/favorites/pages/searchResult/index.tsx:262
#: apps/dp-client/src/screens/account/pages/favorites/pages/main/index.tsx:16
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/packageCouponColumns.web.tsx:24
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:181
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:99
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:128
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:173
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:49
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:112
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:398
msgid "店家"
msgstr "店家"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:83
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:372
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:34
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:48
msgid "店家 ID"
msgstr "店家 ID"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:653
msgid "店家 ID 無效，請重新選擇店家"
msgstr "店家 ID 無效，請重新選擇店家"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:174
msgid "店家，掛在某一層"
msgstr "店家，掛在某一層"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:331
msgid "店家："
msgstr "店家："

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:117
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:105
msgid "店家：{shopName}  ID {shopId}"
msgstr "店家：{shopName}  ID {shopId}"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:106
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:66
#: apps/dp-admin/src/pages/transaction/contract-management/index.web.tsx:161
#: apps/dp-admin/src/pages/transaction/components/MerchantInfo/index.web.tsx:121
#: apps/dp-admin/src/pages/resource-config/rank-list/components/RankDetailModal/index.web.tsx:32
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:65
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:330
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:219
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantSummaryHeader/index.web.tsx:42
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:116
#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:35
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:144
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:76
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageScopeSection/index.web.tsx:146
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:469
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:91
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:51
#: apps/dp-admin/src/pages/marketing/activity-create/components/MerchantPreviewTable/index.web.tsx:23
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:34
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:43
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:116
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:214
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:105
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:79
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:180
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:200
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:89
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:180
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:219
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:87
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:202
msgid "店家ID"
msgstr "店家ID"

#: apps/dp-admin/src/pages/merchant/information-error/components/ErrorInfoSection/index.web.tsx:81
msgid "店家ID："
msgstr "店家ID："

#. placeholder {0}: merchantUserInfo.shopId
#. placeholder {0}: second.value ?? '-'
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:57
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditTaskHeader/index.web.tsx:49
msgid "店家ID：{0}"
msgstr "店家ID：{0}"

#: apps/dp-business/src/pages/ContactBD/index.tsx:48
msgid "店家ID格式錯誤"
msgstr "店家ID格式錯誤"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/index.web.tsx:100
msgid "店家POI審核"
msgstr "店家POI審核"

#: apps/dp-business/src/pages/MerchantDashboard/DesktopLayout.tsx:303
msgid "店家中心"
msgstr "店家中心"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:68
msgid "店家中文地址"
msgstr "店家中文地址"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:244
msgid "店家主動修改營業狀態"
msgstr "店家主動修改營業狀態"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:69
msgid "店家主圖"
msgstr "店家主圖"

#: apps/dp-business/src/pages/MenuManagement.tsx:124
#: apps/dp-business/src/pages/MenuItemForm.tsx:35
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:41
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:41
msgid "店家主要推薦的招牌餐點"
msgstr "店家主要推薦的招牌餐點"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:596
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:663
msgid "店家交通資訊"
msgstr "店家交通資訊"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:318
msgid "店家交通資訊儲存失敗，請稍後重試"
msgstr "店家交通資訊儲存失敗，請稍後重試"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:302
msgid "店家交通資訊儲存成功"
msgstr "店家交通資訊儲存成功"

#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:66
msgid "店家代表圖/Logo"
msgstr "店家代表圖/Logo"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:345
#: apps/dp-business/src/components/MaintenanceList/index.tsx:580
msgid "店家代表圖或Logo"
msgstr "店家代表圖或Logo"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCommonColumns.tsx:50
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:79
msgid "店家信息"
msgstr "店家信息"

#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:390
msgid "店家入口的實拍照片"
msgstr "店家入口的實拍照片"

#: apps/dp-business/src/components/LoginCustomBars/index.tsx:37
msgid "店家入駐"
msgstr "店家入駐"

#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:398
msgid "店家內部環境照片，可包含位置標籤"
msgstr "店家內部環境照片，可包含位置標籤"

#: apps/dp-business/src/pages/AddStore/index.tsx:1301
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:82
#: apps/dp-admin/src/pages/merchant/audit-detail/components/StoreInfo/index.web.tsx:70
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:125
#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantBasicInfo/index.web.tsx:113
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:242
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:245
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:75
msgid "店家分類"
msgstr "店家分類"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:618
msgid "店家分類儲存失敗，請稍後重試"
msgstr "店家分類儲存失敗，請稍後重試"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:605
msgid "店家分類儲存成功"
msgstr "店家分類儲存成功"

#: apps/dp-business/src/pages/MerchantDashboard/MobileLayout.tsx:299
msgid "店家切換失敗"
msgstr "店家切換失敗"

#: apps/dp-business/src/store/ShopContext.tsx:361
#: apps/dp-business/src/store/ShopContext.tsx:472
#: apps/dp-business/src/pages/SimpleDashboard/hooks/useSimpleShop.ts:87
#: apps/dp-business/src/pages/SimpleDashboard/hooks/useSimpleShop.ts:107
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:459
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:502
msgid "店家切換失敗，請稍後重試"
msgstr "店家切換失敗，請稍後重試"

#: apps/dp-admin/src/router/config/routes.web.tsx:83
#: apps/dp-admin/src/pages/transaction/components/MerchantInfo/index.web.tsx:199
#: apps/dp-admin/src/pages/merchant/shop-list-v2/index.web.tsx:227
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:865
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:214
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/MemberListTab/index.web.tsx:64
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/MemberListTab/index.web.tsx:74
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:477
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupSelector/index.web.tsx:389
msgid "店家列表"
msgstr "店家列表"

#: apps/dp-admin/src/pages/merchant/shop-list/index.web.tsx:202
msgid "店家列表管理"
msgstr "店家列表管理"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:359
msgid "店家列表頁（店家組搜索結果）"
msgstr "店家列表頁（店家組搜索結果）"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:126
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageSourceField/index.web.tsx:51
#: apps/dp-admin/src/pages/resource-config/components/ShopFilterSelector/index.web.tsx:131
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:189
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:146
msgid "店家名單"
msgstr "店家名單"

#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:208
#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:276
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:444
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1633
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1774
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:356
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:64
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:82
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:268
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:114
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:74
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/index.web.tsx:37
#: apps/dp-admin/src/pages/transaction/components/MerchantInfo/index.web.tsx:127
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:109
#: apps/dp-admin/src/pages/resource-config/rank-list/components/RankDetailModal/index.web.tsx:25
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:371
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/columns.web.tsx:35
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:71
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:290
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ClientSearchPanel/index.web.tsx:63
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:193
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:234
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:276
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:78
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantSummaryHeader/index.web.tsx:41
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:84
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:430
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:120
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:246
#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:41
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:62
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:146
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:77
#: apps/dp-admin/src/pages/merchant/audit-detail/components/StoreInfo/index.web.tsx:58
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:116
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:242
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:453
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageScopeSection/index.web.tsx:151
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:87
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:470
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:57
#: apps/dp-admin/src/pages/marketing/activity-create/components/MerchantPreviewTable/index.web.tsx:16
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:74
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:52
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:49
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:172
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:114
#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantBasicInfo/index.web.tsx:97
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:88
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:174
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:201
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:98
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:174
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:206
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:276
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:227
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:96
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:196
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:120
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:66
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupShopList/index.web.tsx:76
msgid "店家名稱"
msgstr "店家名稱"

#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:236
msgid "店家名稱 "
msgstr "店家名稱 "

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/types.ts:113
msgid "店家名稱 (分店名)"
msgstr "店家名稱 (分店名)"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:250
msgid "店家名稱 / ID"
msgstr "店家名稱 / ID"

#: apps/dp-admin/src/pages/merchant/information-error/components/ErrorInfoSection/index.web.tsx:75
msgid "店家名稱："
msgstr "店家名稱："

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:123
msgid "店家名稱/ID"
msgstr "店家名稱/ID"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/chainReportFilterFields.ts:32
#: apps/dp-business/src/pages/ChainDashboard/components/reports/chainReportFilterFields.ts:40
msgid "店家名稱／代碼"
msgstr "店家名稱／代碼"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:286
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:576
msgid "店家名稱／店家 ID"
msgstr "店家名稱／店家 ID"

#: apps/dp-business/src/utils/storeNameValidation.ts:26
msgid "店家名稱不能為空"
msgstr "店家名稱不能為空"

#: apps/dp-business/src/utils/storeNameValidation.ts:34
msgid "店家名稱不能超過50個字符"
msgstr "店家名稱不能超過50個字元"

#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:174
msgid "店家名稱更新成功"
msgstr "店家名稱更新成功"

#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:140
msgid "店家名稱格式錯誤"
msgstr "店家名稱格式錯誤"

#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:122
msgid "店家名稱正在審核中，無法修改"
msgstr "店家名稱正在審核中，無法修改"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:523
msgid "店家品牌"
msgstr "店家品牌"

#: apps/dp-admin/src/pages/resource-config/components/ShopFilterSelector/index.web.tsx:133
msgid "店家圈選"
msgstr "店家圈選"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:210
msgid "店家圈選（可以使用權益的店家）"
msgstr "店家圈選（可以使用權益的店家）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/index.web.tsx:55
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:419
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:259
msgid "店家圖片"
msgstr "店家圖片"

#: apps/dp-business/src/components/ShopSelectTable/index.tsx:275
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:395
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:83
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:131
#: apps/dp-admin/src/pages/merchant/audit-detail/components/StoreInfo/index.web.tsx:77
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:132
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:109
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:64
#: apps/dp-admin/src/pages/marketing/activity-create/components/MerchantPreviewTable/index.web.tsx:30
#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantBasicInfo/index.web.tsx:105
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:253
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:77
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupShopList/index.web.tsx:77
msgid "店家地址"
msgstr "店家地址"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:359
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:449
msgid "店家地理位置"
msgstr "店家地理位置"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:111
msgid "店家型別"
msgstr "店家型別"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:789
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:828
msgid "店家基本資訊"
msgstr "店家基本資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/index.web.tsx:46
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:660
msgid "店家基礎資訊"
msgstr "店家基礎資訊"

#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:406
msgid "店家宣傳推廣圖片"
msgstr "店家宣傳推廣圖片"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:60
msgid "店家實際管理人資訊"
msgstr "店家實際管理人資訊"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:67
msgid "店家實際管理人資訊，和商家負責人的保持一致"
msgstr "店家實際管理人資訊，和商家負責人的保持一致"

#: apps/dp-business/src/components/MerchantReviewTabs/index.tsx:37
msgid "店家審核"
msgstr "店家審核"

#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:521
msgid "店家已被認領"
msgstr "店家已被認領"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:85
msgid "店家已駁回，若有問題請聯繫商家。"
msgstr "店家已拒絕，若有問題請與店家聯繫。"

#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:251
msgid "店家店門口圖片"
msgstr "店家店門口圖片"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:33
msgid "店家影片"
msgstr "店家影片"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:19
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:151
msgid "店家所在地"
msgstr "店家所在地"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:54
msgid "店家掛接"
msgstr "店家掛接"

#: apps/dp-admin/src/pages/org-tree/services/shopPathActions.ts:295
msgid "店家掛接已變更，請重新整理後操作"
msgstr "店家掛接已變更，請重新整理後操作"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:923
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:369
msgid "店家接單時間"
msgstr "店家接單時間"

#: apps/dp-business/src/pages/StoreDescription.tsx:155
#: apps/dp-business/src/pages/StoreDescription.tsx:170
#: apps/dp-business/src/pages/StoreDescription.tsx:229
#: apps/dp-business/src/components/MaintenanceList/index.tsx:554
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:369
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:166
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:379
#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:43
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:509
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:22
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:32
msgid "店家描述"
msgstr "店家描述"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:63
msgid "店家描述/到店指引"
msgstr "店家描述/到店指引"

#: apps/dp-business/src/pages/StoreDescription.tsx:126
msgid "店家描述儲存失敗，請稍後重試"
msgstr "店家描述儲存失敗，請稍後重試"

#: apps/dp-business/src/pages/StoreDescription.tsx:114
msgid "店家描述儲存成功"
msgstr "店家描述儲存成功"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:64
msgid "店家描述和到店指引資訊完整度評分"
msgstr "店家描述和到店指引資訊完整度評分"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:96
msgid "店家描述與交通建議"
msgstr "店家描述與交通建議"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:240
msgid "店家描述與指引"
msgstr "店家描述與指引"

#: apps/dp-client/src/screens/account/pages/favorites/components/ShopContent/index.tsx:167
msgid "店家收藏夾空空的"
msgstr "店家收藏夾空空的"

#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/RefreshHistoryTab/index.web.tsx:59
msgid "店家數"
msgstr "店家數"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/AddShopModal/index.web.tsx:84
msgid "店家數據列表"
msgstr "店家數據列表"

#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:117
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:803
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:87
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupDetailInfo/index.web.tsx:53
msgid "店家數量"
msgstr "店家數量"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:472
msgid "店家暫停"
msgstr "店家暫停"

#: apps/dp-business/src/components/CopyResultView/index.tsx:87
msgid "店家未複製成功"
msgstr "店家未複製成功"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:13
msgid "店家榜"
msgstr "店家榜"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:468
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:426
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:604
msgid "店家標籤"
msgstr "店家標籤"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:814
#: apps/dp-business/src/components/CustomTabs/index.tsx:218
msgid "店家權限管理"
msgstr "店家權限管理"

#: apps/dp-admin/src/modules/hooks/options/useShopListStatusOptions.ts:102
msgid "店家清單狀態資料取得失敗"
msgstr "店家清單狀態資料取得失敗"

#: apps/dp-admin/src/modules/hooks/options/useShopListStatusOptions.ts:111
msgid "店家清單狀態資料取得異常"
msgstr "店家清單狀態資料取得異常"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:295
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CommissionBenefitListCard.web.tsx:86
msgid "店家減免權益明細"
msgstr "店家減免權益明細"

#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:54
msgid "店家減扣金額"
msgstr "店家減扣金額"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:675
#: apps/dp-admin/src/pages/merchant/audit-detail/components/StoreInfo/index.web.tsx:117
#: apps/dp-admin/src/pages/merchant/audit-detail/components/StoreInfo/index.web.tsx:125
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:98
msgid "店家照片"
msgstr "餐廳照片"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:408
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:239
msgid "店家營業狀態"
msgstr "店家營業狀態"

#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:104
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:235
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:386
msgid "店家狀態"
msgstr "店家狀態"

#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:374
msgid "店家的主要展示圖片，用於列表和詳情頁展示"
msgstr "店家的主要展示圖片，用於列表和詳情頁展示"

#: apps/dp-client/src/screens/reservation/utils/index.ts:11
#: apps/dp-client/src/screens/reservation/utils/index.ts:17
#: apps/dp-client/src/screens/reservation/utils/index.ts:23
#: apps/dp-client/src/screens/reservation/utils/index.ts:29
#: apps/dp-client/src/screens/reservation/utils/index.ts:36
#: apps/dp-client/src/screens/reservation/utils/index.ts:42
msgid "店家確認"
msgstr "店家確認"

#: apps/dp-business/src/pages/ChainDashboard/components/PerspectiveSwitchTabs.tsx:136
msgid "店家視角"
msgstr "店家視角"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:549
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:121
msgid "店家等級"
msgstr "店家等級"

#: apps/dp-business/src/App.web.tsx:271
#: apps/dp-business/src/configs/page-configs.ts:24
#: apps/dp-business/src/configs/page-configs.ts:36
#: apps/dp-business/src/configs/page-configs.ts:48
#: apps/dp-business/src/configs/page-configs.ts:60
#: apps/dp-business/src/configs/page-configs.ts:72
#: apps/dp-business/src/configs/page-configs.ts:84
#: apps/dp-business/src/configs/page-configs.ts:96
#: apps/dp-business/src/configs/page-configs.ts:157
#: apps/dp-business/src/configs/page-configs.ts:172
#: apps/dp-business/src/configs/page-configs.ts:187
#: apps/dp-business/src/configs/page-configs.ts:272
#: apps/dp-business/src/configs/page-configs.ts:313
#: apps/dp-business/src/configs/page-configs.ts:328
#: apps/dp-business/src/configs/page-configs.ts:343
#: apps/dp-business/src/configs/page-configs.ts:358
#: apps/dp-business/src/configs/page-configs.ts:373
#: apps/dp-business/src/configs/page-configs.ts:388
#: apps/dp-business/src/configs/page-configs.ts:403
#: apps/dp-business/src/configs/page-configs.ts:418
#: apps/dp-business/src/configs/page-configs.ts:433
#: apps/dp-business/src/configs/page-configs.ts:448
#: apps/dp-business/src/configs/page-configs.ts:463
#: apps/dp-business/src/configs/page-configs.ts:478
#: apps/dp-business/src/configs/page-configs.ts:493
#: apps/dp-business/src/configs/page-configs.ts:508
#: apps/dp-business/src/configs/page-configs.ts:523
#: apps/dp-business/src/configs/page-configs.ts:538
#: apps/dp-business/src/configs/page-configs.ts:553
#: apps/dp-business/src/configs/page-configs.ts:568
#: apps/dp-business/src/configs/page-configs.ts:583
#: apps/dp-business/src/configs/page-configs.ts:598
#: apps/dp-business/src/configs/page-configs.ts:613
#: apps/dp-business/src/configs/page-configs.ts:628
#: apps/dp-business/src/configs/page-configs.ts:643
#: apps/dp-business/src/configs/page-configs.ts:658
#: apps/dp-business/src/configs/page-configs.ts:673
#: apps/dp-business/src/configs/page-configs.ts:688
#: apps/dp-business/src/configs/page-configs.ts:703
#: apps/dp-business/src/configs/page-configs.ts:718
#: apps/dp-business/src/configs/page-configs.ts:733
#: apps/dp-business/src/configs/page-configs.ts:748
#: apps/dp-business/src/configs/page-configs.ts:763
#: apps/dp-business/src/configs/page-configs.ts:778
#: apps/dp-business/src/configs/page-configs.ts:793
#: apps/dp-business/src/configs/page-configs.ts:808
#: apps/dp-business/src/configs/page-configs.ts:823
#: apps/dp-business/src/configs/main-config.tsx:14
#: apps/dp-business/src/configs/main-config.tsx:25
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:233
msgid "店家管理"
msgstr "店家管理"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ActualManagerCard.web.tsx:35
msgid "店家管理人資訊"
msgstr "店家管理人資訊"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterSelects.tsx:184
msgid "店家篩選"
msgstr "店家篩選"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:132
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:377
msgid "店家簡介"
msgstr "店家簡介"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:135
msgid "店家簡介不能超過250字"
msgstr "店家簡介不能超過250字"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:573
msgid "店家簽約"
msgstr "店家簽約"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:118
msgid "店家簽約商家"
msgstr "店家簽約商家"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:104
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:67
msgid "店家簽約狀態"
msgstr "店家簽約狀態"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:118
msgid "店家組列表"
msgstr "店家組列表"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:126
msgid "店家組與套餐券列表"
msgstr "店家組與套餐券列表"

#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:151
msgid "店家結帳服務"
msgstr "店家結帳服務"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:237
msgid "店家綁定"
msgstr "店家綁定"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:707
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/index.web.tsx:267
msgid "店家綁定商家"
msgstr "店家綁定商家"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/index.web.tsx:128
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:234
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:253
msgid "店家綁定商家審核"
msgstr "店家綁定商家審核"

#. placeholder {0}: binding.auditStatusDesc
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:244
msgid "店家綁定商家審核狀態為：{0}"
msgstr "店家綁定商家審核狀態為：{0}"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/index.web.tsx:275
msgid "店家綁定商家歷史"
msgstr "店家綁定商家歷史"

#: apps/dp-business/src/pages/AddStore/index.tsx:1463
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/ShopInfoSection.web.tsx:43
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/ShopInfoSection/index.web.tsx:53
msgid "店家聯絡電話"
msgstr "店家聯絡電話"

#: apps/dp-admin/src/pages/org-tree/services/shopPathActions.ts:323
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:37
msgid "店家自行結算"
msgstr "店家自行結算"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:257
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:72
msgid "店家自身請款商家"
msgstr "店家自身請款商家"

#: apps/dp-admin/src/pages/org-tree/services/shopPathActions.ts:306
#: apps/dp-admin/src/pages/org-tree/services/shopPathActions.ts:361
msgid "店家自身請款商家不可用，請先更換結算路徑再解除掛接"
msgstr "店家自身請款商家不可用，請先更換結算路徑再解除掛接"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:308
msgid "店家英文名"
msgstr "店家英文名"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:117
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:327
msgid "店家英文地址"
msgstr "店家英文地址"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:569
msgid "店家英文地址不能少於 30 個字元"
msgstr "店家英文地址不能少於 30 個字元"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:120
msgid "店家英文地址不能少於30字符"
msgstr "店家英文地址不能少於30字符"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:568
msgid "店家英文地址不能超過 200 個字元"
msgstr "店家英文地址不能超過 200 個字元"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:403
msgid "店家藍新簽約審核狀態為：待POI綁定審核，需要資料中的店家POI綁定審核通過後，系統才會自動提交給藍新審核，請先等待POI綁定審核通過"
msgstr "店家藍新簽約審核狀態為：待POI綁定審核，需要資料中的店家POI綁定審核通過後，系統才會自動提交給藍新審核，請先等待POI綁定審核通過"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ClientSearchPanel/index.web.tsx:88
msgid "店家行政區"
msgstr "店家行政區"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:44
#: apps/dp-client/src/components/RefundResonModal/index.tsx:29
msgid "店家表示商品無貨/缺貨"
msgstr "店家表示商品無貨/缺貨"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/DetailMobile/components/MerchantActionButtons.web.tsx:40
msgid "店家裝修"
msgstr "店家裝修"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepRoles.web.tsx:186
msgid "店家角色圈選"
msgstr "店家角色圈選"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:924
msgid "店家訊息不存在"
msgstr "店家訊息不存在"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:99
msgid "店家設施"
msgstr "店家設施"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:100
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:101
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:152
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:112
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/constants.ts:77
#: apps/dp-admin/src/pages/resource-config/components/ContentFilterSelector/index.web.tsx:14
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:689
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:301
msgid "店家評分"
msgstr "店家評分"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:91
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:132
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:172
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:173
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:190
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:191
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:793
#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:233
msgid "店家詳情"
msgstr "店家詳情"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1111
msgid "店家認領需要負責人身份證明，認領成功後您可直接管理店家"
msgstr "店家認領需要負責人身份證明，認領成功後您可直接管理店家"

#. placeholder {0}: check.fallbackMerchant?.merchantName || '-'
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:55
msgid "店家請款商家：{0}"
msgstr "店家請款商家：{0}"

#: apps/dp-client/src/screens/diary/pages/my/components/PointsInfoCard.tsx:65
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:244
msgid "店家諮詢"
msgstr "店家諮詢"

#: apps/dp-client/src/screens/diary/components/task-card/index.tsx:143
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:17
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:753
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1947
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:787
#: apps/dp-business/src/components/CustomTabs/index.tsx:70
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:102
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractEditTabs/index.web.tsx:38
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:57
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:317
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:77
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:87
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:71
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:75
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/ShopInfoSection.web.tsx:25
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:62
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/ShopInfoSection/index.web.tsx:35
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:170
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:112
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:120
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:340
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:69
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:196
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:203
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:244
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:196
msgid "店家資訊"
msgstr "店家資訊"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:342
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:344
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:395
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:397
msgid "店家資訊儲存成功！"
msgstr "店家資訊儲存成功！"

#: apps/dp-business/src/pages/MenuManagement.tsx:964
msgid "店家資訊取得失敗"
msgstr "店家資訊取得失敗"

#: apps/dp-business/src/pages/StoreDescription.tsx:82
#: apps/dp-business/src/pages/PhoneEdit/index.tsx:164
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:308
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:383
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:592
#: apps/dp-business/src/pages/BusinessStatus/index.tsx:236
msgid "店家資訊取得失敗，請稍後重試"
msgstr "店家資訊取得失敗，請稍後重試"

#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:158
msgid "店家資訊取得失敗，請重試"
msgstr "店家資訊取得失敗，請重試"

#: apps/dp-admin/src/router/config/routes.web.tsx:369
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:305
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:254
#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantBasicInfo/index.web.tsx:54
msgid "店家資訊審核"
msgstr "店家資訊審核"

#: apps/dp-admin/src/pages/audit-center/merchant-audit/index.web.tsx:165
msgid "店家資訊審核詳情"
msgstr "店家資訊審核詳情"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:47
msgid "店家資訊暫時無法載入"
msgstr "店家資訊暫時無法載入"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:196
msgid "店家資訊正在審核中，無法編輯"
msgstr "店家資訊正在審核中，無法編輯"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:129
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/BdInfoCard.web.tsx:15
#: apps/dp-admin/src/pages/merchant/components/BdSection/index.web.tsx:22
msgid "店家跟進BD"
msgstr "店家跟進BD"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:327
msgid "店家路徑管理"
msgstr "店家路徑管理"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:758
msgid "店家連鎖樹掛接&結算"
msgstr "店家連鎖樹掛接&結算"

#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:382
msgid "店家門頭的實拍照片，展示店家外觀"
msgstr "店家門頭的實拍照片，展示店家外觀"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:98
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:572
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:158
msgid "店家電話"
msgstr "店家電話"

#. placeholder {0}: index > 0 ? index + 1 : ''
#: apps/dp-business/src/pages/PhoneEdit/index.tsx:264
msgid "店家電話{0}"
msgstr "店家電話{0}"

#: apps/dp-admin/src/pages/merchant/components/UploadTips/index.web.tsx:59
msgid "店家頭像作為商家的 <0>主要展示圖片</0>"
msgstr "店家頭像作為商家的 <0>主要展示圖片</0>"

#: apps/dp-business/src/components/ShopSelectTable/index.tsx:289
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:374
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:402
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:323
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ClientSearchPanel/index.web.tsx:76
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:245
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:251
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:243
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:287
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:96
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:510
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:75
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:25
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:152
msgid "店家類別"
msgstr "店家類別"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:170
msgid "店家類型"
msgstr "店家類型"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:767
msgid "店家類目"
msgstr "店家類目"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:153
msgid "店結算"
msgstr "店結算"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:295
msgid "店舖"
msgstr "店舖"

#: apps/dp-client/src/utils/distance.ts:95
msgid "店舖暫無定位"
msgstr "店舖暫無定位"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:453
msgid "店舖標籤"
msgstr "店舖標籤"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:451
msgid "店舖營業時間"
msgstr "店舖營業時間"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:452
msgid "店舖營業狀態"
msgstr "店舖營業狀態"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:112
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:121
msgid "店長"
msgstr "店長"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:88
msgid "店長帶路"
msgstr "店長帶路"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:445
msgid "店長指路-公交指引"
msgstr "店長指路-公交指引"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:446
msgid "店長指路-捷運指引"
msgstr "店長指路-捷運指引"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:447
msgid "店長指路-駕車指引"
msgstr "店長指路-駕車指引"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:376
msgid "店門口圖"
msgstr "店門口圖"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:411
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:388
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:216
msgid "店門口圖片"
msgstr "店門口圖片"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:222
#: apps/dp-business/src/components/MaintenanceList/index.tsx:586
msgid "店門口照片"
msgstr "店門口照片"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:366
msgid "店面圖"
msgstr "店面圖"

#: apps/dp-client/src/screens/reservation/components/ReservationNotes/index.tsx:63
msgid "座位保留"
msgstr "座位保留"

#: apps/dp-client/src/screens/reservation/components/ReservationSuccessModal/index.tsx:94
msgid "座位為您保留{confirmTime}分鐘"
msgstr "座位為您保留{confirmTime}分鐘"

#: apps/dp-client/src/screens/reservation/pages/main/components/SeatTypeSelector.tsx:23
msgid "座位類型"
msgstr "座位類型"

#. placeholder {0}: packageData.remainingStock
#: apps/dp-client/src/screens/home/utils/commerceHelpers.ts:73
msgid "庫存{0}"
msgstr "庫存{0}"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1931
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:214
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:358
msgid "庫存不能小於已發放庫存 {issuedCount}"
msgstr "庫存不能小於已發放庫存 {issuedCount}"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:92
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:147
msgid "庫存數量必須大於0"
msgstr "庫存數量必須大於0"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:318
msgid "庫存明細"
msgstr "庫存明細"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:318
msgid "庫存明細 - {benefitName}"
msgstr "庫存明細 - {benefitName}"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1304
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1518
#: apps/dp-business/src/pages/ReservationManagement/TableCells.tsx:115
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:737
msgid "庫存總數"
msgstr "庫存總數"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:946
msgid "庫存總數："
msgstr "庫存總數："

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1292
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1373
msgid "庫存總數不可小於已訂庫存數量（{bookedStock}）"
msgstr "庫存總數不可小於已訂庫存數量（{bookedStock}）"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:576
msgid "庫存設定"
msgstr "庫存設定"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1186
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1199
msgid "庫存設置"
msgstr "庫存設置"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1395
msgid "庫存調整失敗"
msgstr "庫存調整失敗"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1386
msgid "庫存調整成功"
msgstr "庫存調整成功"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:186
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:234
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:259
msgid "庫存資訊"
msgstr "庫存資訊"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:221
msgid "庫存項ID"
msgstr "庫存項ID"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/services/searchConfig.ts:20
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:90
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:64
msgid "廠商名稱"
msgstr "廠商名稱"

#: apps/dp-client/src/screens/home/utils/utils.ts:425
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:291
msgid "廣告或導流內容"
msgstr "廣告或導流內容"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:575
msgid "廣告投放"
msgstr "廣告投放"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:578
msgid "廣州"
msgstr "廣州"

#: apps/dp-business/src/data/categories.ts:60
msgid "廣州菜"
msgstr "廣州菜"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:480
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:490
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/OperationLogSection/index.web.tsx:32
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:489
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:509
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/OperationLogSection/index.web.tsx:32
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:300
msgid "延期"
msgstr "延期"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:197
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:129
msgid "延期券包"
msgstr "延期券包"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:224
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:229
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:261
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:266
msgid "延期失敗"
msgstr "延期失敗"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:217
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:254
msgid "延期完成：成功 {successCount} 張，失敗 {failCount} 張"
msgstr "延期完成：成功 {successCount} 張，失敗 {failCount} 張"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:237
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:172
msgid "延期成功"
msgstr "延期成功"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:220
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:257
msgid "延期成功 {successCount} 張"
msgstr "延期成功 {successCount} 張"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2262
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2276
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1307
msgid "延長銷售時間"
msgstr "延長銷售時間"

#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:278
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/index.web.tsx:177
msgid "建立"
msgstr "建立"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:95
msgid "建立人"
msgstr "建立人"

#: apps/dp-business/src/servers/permission/api.ts:228
msgid "建立員工帳號失敗"
msgstr "建立員工帳號失敗"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/services/constants.ts:34
msgid "建立商家資訊"
msgstr "建立商家資訊"

#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:176
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:183
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:186
#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:133
#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:156
#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:162
#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:165
msgid "建立失敗"
msgstr "建立失敗"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:168
msgid "建立工單"
msgstr "建立工單"

#: apps/dp-business/src/servers/chain/accountApi.ts:138
msgid "建立帳號失敗"
msgstr "建立帳號失敗"

#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:276
msgid "建立店家"
msgstr "建立店家"

#: apps/dp-business/src/servers/shop/api.ts:363
msgid "建立店家描述失敗"
msgstr "建立店家描述失敗"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/SigningSteps/index.web.tsx:10
msgid "建立店家資訊"
msgstr "建立店家資訊"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:139
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:357
#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:547
msgid "建立成功"
msgstr "建立成功"

#: apps/dp-client/src/screens/login/components/account-recreate-modal/index.tsx:77
msgid "建立新帳號"
msgstr "建立新帳號"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:269
msgid "建立新的 POI 資料"
msgstr "建立新的 POI 資料"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1052
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:196
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:225
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:341
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:200
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserInfoCard/index.web.tsx:89
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:558
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:169
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:143
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:85
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:264
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:163
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:185
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:335
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:103
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:138
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:244
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:110
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:234
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:157
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:932
#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:111
#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:60
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:177
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:78
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:286
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:118
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:311
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:139
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:332
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:160
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/config.web.tsx:77
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:173
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:356
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:173
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:337
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:154
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:257
msgid "建立時間"
msgstr "建立時間"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/index.web.tsx:160
msgid "建立派工工單"
msgstr "建立派工工單"

#: apps/dp-business/src/configs/page-configs.ts:1097
msgid "建立滿減券"
msgstr "建立滿額折扣券"

#: apps/dp-client/src/store/invoiceStore.ts:106
msgid "建立發票抬頭失敗"
msgstr "建立發票抬頭失敗"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1070
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:164
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/ExportHistoryTab/index.web.tsx:65
#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:94
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:147
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/ExportHistoryTab/index.web.tsx:65
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:85
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:130
msgid "建立者"
msgstr "建立者"

#: apps/dp-business/src/servers/permission/api.ts:302
msgid "建立臨時帳號失敗"
msgstr "建立臨時帳號失敗"

#: apps/dp-business/src/servers/category/api.ts:35
msgid "建立自訂分類失敗"
msgstr "建立自訂分類失敗"

#: apps/dp-business/src/servers/permission/api.ts:61
#: apps/dp-business/src/servers/chain/roleApi.ts:115
msgid "建立角色失敗"
msgstr "建立角色失敗"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1566
msgid "建立訂單失敗，請重試"
msgstr "建立訂單失敗，請重試"

#: apps/dp-business/src/servers/claim/api.ts:127
#: apps/dp-business/src/servers/chain/settlementApi.ts:253
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:432
msgid "建立請款申請失敗"
msgstr "建立請款申請失敗"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:77
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:409
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:43
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:44
msgid "建立預覽&hellip;"
msgstr "建立預覽&hellip;"

#: apps/dp-admin/src/pages/merchant/components/UploadTips/index.web.tsx:50
#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:503
msgid "建議圖片尺寸不小於 <0>300x300</0> 像素"
msgstr "建議圖片尺寸不小於 <0>300x300</0> 像素"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:145
msgid "建議尺寸 200×200，支持 JPG / PNG，最大 5MB"
msgstr "建議尺寸 200×200，支持 JPG / PNG，最大 5MB"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:602
msgid "建議尺寸：1080x1920"
msgstr "建議尺寸：1080x1920"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:286
msgid "建議尺寸：1280x720px，最多9張，檔案大小5MB。可拖拽調整順序"
msgstr "建議尺寸：1280x720px，最多9張，檔案大小5MB。可拖拽調整順序"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:118
msgid "建議尺寸：200x200像素，小於5MB"
msgstr "建議尺寸：200x200像素，小於5MB"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:215
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:672
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:322
msgid "建議尺寸：200x200像素，支持JPG、PNG格式，小於5MB"
msgstr "建議尺寸：200x200像素，支持JPG、PNG格式，小於5MB"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:251
msgid "建議尺寸：400x300px，最多5MB"
msgstr "建議尺寸：400x300px，最多5MB"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:509
msgid "建議尺寸：60x60像素，小於2MB"
msgstr "建議尺寸：60x60像素，小於2MB"

#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:142
msgid "建議尺寸400*300px，檔案大小10mb"
msgstr "建議尺寸400*300px，檔案大小10mb"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:172
msgid "建議尺寸為393*266, 支持 JPG/PNG/GIF 格式，大小不超過 5MB"
msgstr "建議尺寸為393*266, 支持 JPG/PNG/GIF 格式，大小不超過 5MB"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:443
msgid "建議您來電洽詢商家，或關注後續庫存更新哦～"
msgstr "建議您來電洽詢商家，或關注後續庫存更新哦～"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:461
msgid ""
"建議您來電洽詢店家，或關注後\n"
"續庫存更新哦～"
msgstr ""
"建議您來電洽詢店家，或關注後\n"
"續庫存更新哦～"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:264
msgid "建議正方形、48×48 以上，支援 PNG / JPEG / WebP / SVG，最大 2 MB。"
msgstr "建議正方形、48×48 以上，支援 PNG / JPEG / WebP / SVG，最大 2 MB。"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:216
msgid "建議開啟，加碼將帶來更高的曝光與訂單增長"
msgstr "建議開啟，加碼將帶來更高的曝光與訂單增長"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:61
msgid "引流 ?"
msgstr "引流 ?"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:42
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:841
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:332
#: apps/dp-business/src/pages/OrderList/index.tsx:747
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/index.tsx:142
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesSummaryCards.tsx:50
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesSummaryCards.tsx:58
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:642
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:664
#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:654
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2296
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2329
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:381
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:456
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:541
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:623
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2258
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2310
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:108
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:163
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:218
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:273
msgid "張"
msgstr "張"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:60
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:97
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:63
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:100
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:180
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:126
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:264
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:399
msgid "張三"
msgstr "張三"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:429
msgid "張套餐券"
msgstr "張套餐券"

#: apps/dp-business/src/pages/RefundList/index.tsx:116
msgid "張小紅"
msgstr "張小紅"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:65
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:107
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:149
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:191
msgid "張工程"
msgstr "張工程"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:76
msgid "張曉峰"
msgstr "張曉峰"

#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:54
msgid "彈幕"
msgstr "彈幕"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:299
msgid "彩筆"
msgstr "彩筆"

#: apps/dp-business/src/data/regions.ts:18
msgid "彰化"
msgstr "彰化"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:79
#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:84
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/services/hooks.ts:47
msgid "影像資料提交失敗"
msgstr "影像資料提交失敗"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:76
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/services/hooks.ts:40
msgid "影像資料提交成功"
msgstr "影像資料提交成功"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/Media/index.tsx:98
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopMediaGallery/index.tsx:180
#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/MediaReplacer.tsx:68
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Media/index.tsx:114
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallMediaGallery/index.tsx:149
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:994
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:159
#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:47
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:221
msgid "影片"
msgstr "影片"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:117
msgid "影片：MP4（H.264），1125×2400（9:16），時長 3s–5s，文件大小 ≤ 1.6MB，幀率 24/25/30fps，碼率 1500–3000kbps，音頻靜音"
msgstr "影片：MP4（H.264），1125×2400（9:16），時長 3s–5s，文件大小 ≤ 1.6MB，幀率 24/25/30fps，碼率 1500–3000kbps，音頻靜音"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:78
msgid "影片（MP4）文件大小不能超過 1.6MB"
msgstr "影片（MP4）文件大小不能超過 1.6MB"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:616
msgid "影片上傳"
msgstr "影片上傳"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:83
#: apps/dp-business/src/components/PhotoUploader/upload.ts:105
msgid "影片上傳失敗，請稍後重試"
msgstr "影片上傳失敗，請稍後重試"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:56
msgid "影片將以文件列表形式展示，點擊文件名可預覽"
msgstr "影片將以文件列表形式展示，點擊文件名可預覽"

#: apps/dp-client/src/configs/page-configs.tsx:1203
msgid "影片播放"
msgstr "影片播放"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:685
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:758
#: apps/dp-client/src/screens/home/pages/Note/hooks/usePhotoSelection.ts:194
msgid "影片處理失敗，請重試"
msgstr "影片處理失敗，請重試"

#: apps/dp-business/src/components/PrivateImage/index.tsx:177
#: apps/dp-business/src/components/PhotoUploader/index.tsx:243
#: apps/dp-business/src/components/PhotoUploader/components/PhotoDisplay.tsx:132
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:290
msgid "影片預覽"
msgstr "影片預覽"

#. placeholder {0}: data.length
#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:82
msgid "影響商家數：{0}"
msgstr "影響商家數：{0}"

#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:87
msgid "影響店家數：{relatedShopCount}"
msgstr "影響店家數：{relatedShopCount}"

#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:68
msgid "影響的店家和商家"
msgstr "影響的店家和商家"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:62
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:191
msgid "待POI綁定審核"
msgstr "待POI綁定審核"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:44
msgid "待上架"
msgstr "待上架"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:24
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:51
msgid "待人審"
msgstr "待人審"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:54
msgid "待人審(機審未通過)"
msgstr "待人審(機審未通過)"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:510
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:38
#: apps/dp-client/src/screens/account/pages/order/index.tsx:46
#: apps/dp-business/src/servers/order/types.ts:98
#: apps/dp-business/src/pages/OrderList/index.tsx:928
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:55
msgid "待付款"
msgstr "待付款"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:56
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:100
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:895
#: apps/dp-client/src/screens/account/pages/order/index.tsx:47
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:80
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:956
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:60
#: apps/dp-business/src/servers/order/types.ts:100
#: apps/dp-business/src/pages/OrderList/index.tsx:932
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:56
#: apps/dp-admin/src/pages/order/services/utils.ts:61
#: apps/dp-admin/src/pages/marketing/services/constants.ts:334
msgid "待使用"
msgstr "待使用"

#. placeholder {0}: statusCounts.pending
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:209
msgid "待使用（{0}）"
msgstr "待使用（{0}）"

#. placeholder {0}: statusCounts.pending
#. placeholder {1}: statusCounts.refunded
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:205
msgid "待使用({0}), 已退款({1})"
msgstr "待使用({0}), 已退款({1})"

#. placeholder {0}: statusCounts.pending
#. placeholder {1}: statusCounts.refunding
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:201
msgid "待使用({0}), 退款中({1})"
msgstr "待使用({0}), 退款中({1})"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:182
msgid "待使用餐券"
msgstr "待使用餐券"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:386
#: apps/dp-admin/src/pages/merchant/service/constants.ts:392
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:31
msgid "待入駐"
msgstr "待入駐"

#: apps/dp-admin/src/pages/customer-service/services/constants.ts:8
msgid "待分配"
msgstr "待分配"

#: apps/dp-business/src/types/orderFilter.ts:176
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:242
msgid "待到店"
msgstr "待到店"

#: apps/dp-client/src/screens/reservation/utils/index.ts:62
msgid "待到店用餐"
msgstr "待到店用餐"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:158
msgid "待合併標籤列表"
msgstr "待合併標籤列表"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:662
#: apps/dp-admin/src/pages/order/services/utils.ts:404
msgid "待商家處理"
msgstr "待商家處理"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:78
msgid "待回傳"
msgstr "待回傳"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:31
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:156
msgid "待執行"
msgstr "待執行"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:963
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:100
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:109
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:154
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:163
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:674
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:713
msgid "待完善"
msgstr "待完整填寫"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:275
#: apps/dp-admin/src/pages/merchant/service/constants.ts:207
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditStatusBanner/index.web.tsx:32
#: apps/dp-admin/src/modules/constants/options.ts:541
msgid "待審批"
msgstr "待審批"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:160
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:444
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:21
#: apps/dp-admin/src/pages/split-account/services/constants.ts:79
#: apps/dp-admin/src/pages/split-account/services/constants.ts:150
#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:64
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:63
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:90
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:128
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:140
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/interface.ts:48
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/interface.ts:49
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:31
#: apps/dp-admin/src/pages/data-center/review-detail/index.web.tsx:26
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:183
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:196
#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:20
#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:39
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:54
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:109
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:39
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:50
msgid "待審核"
msgstr "待審核"

#: apps/dp-admin/src/modules/hooks/notificationConnection.ts:85
msgid "待審核數與消息通知已停止更新，請重新整理頁面"
msgstr "待審核數與消息通知已停止更新，請重新整理頁面"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/Statistics/index.web.tsx:29
msgid "待審核請款單"
msgstr "待審核請款單"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/Statistics/index.web.tsx:35
msgid "待審核金額"
msgstr "待審核金額"

#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:74
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:94
msgid "待店家確認"
msgstr "待店家確認"

#: apps/dp-client/src/screens/reservation/utils/index.ts:59
msgid "待店家確認訂單"
msgstr "待店家確認訂單"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:44
msgid "待提交"
msgstr "待提交"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:159
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:443
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:55
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:20
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:86
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:7
msgid "待提審"
msgstr "待提出審核"

#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:59
#: apps/dp-business/src/pages/OrderOverview/index.tsx:999
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1007
#: apps/dp-admin/src/pages/report-center/abnormal-orders/service/constants.ts:25
#: apps/dp-admin/src/pages/order/services/utils.ts:60
#: apps/dp-admin/src/pages/marketing/services/constants.ts:333
msgid "待支付"
msgstr "待支付"

#: apps/dp-admin/src/modules/constants/options.ts:478
msgid "待啟動"
msgstr "待啟動"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:54
#: apps/dp-admin/src/pages/transaction/service-management/services/commission-format.ts:38
msgid "待生效"
msgstr "待生效"

#: apps/dp-admin/src/modules/constants/options.ts:385
msgid "待發布"
msgstr "待發布"

#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:210
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:34
msgid "待確認"
msgstr "待確認"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:360
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:398
msgid "待確認訂單"
msgstr "待確認訂單"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:206
#: apps/dp-admin/src/pages/merchant/service/constants.ts:365
#: apps/dp-admin/src/pages/merchant/service/constants.ts:371
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:47
msgid "待簽約"
msgstr "待簽約"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:262
#: apps/dp-admin/src/modules/constants/options.ts:538
msgid "待簽署"
msgstr "待簽署"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:157
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:441
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:18
msgid "待結算"
msgstr "待結算"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:341
#: apps/dp-admin/src/pages/merchant/service/constants.ts:347
msgid "待綁定"
msgstr "待綁定"

#: apps/dp-client/src/screens/reservation/utils/index.ts:80
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:401
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:718
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1103
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1935
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:870
#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:25
#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:68
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:43
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:26
#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:158
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:64
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:222
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskFilterHeader/index.web.tsx:44
#: apps/dp-admin/src/pages/merchant/task-list/components/StatusTag/index.web.tsx:20
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:135
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:135
#: apps/dp-admin/src/pages/merchant/service/constants.ts:47
#: apps/dp-admin/src/pages/merchant/information-error/index.web.tsx:78
#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:22
#: apps/dp-admin/src/pages/customer-service/services/constants.ts:9
msgid "待處理"
msgstr "待處理"

#. placeholder {0}: agent.currentTicketCount
#: apps/dp-admin/src/pages/customer-service/components/AssignModal.web.tsx:40
msgid "待處理: {0}"
msgstr "待處理: {0}"

#: apps/dp-business/src/types/orderFilter.ts:127
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:166
msgid "待處理（待商家確認）"
msgstr "待處理（待商家確認）"

#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:44
msgid "待處理人工工單"
msgstr "待處理人工工單"

#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:71
msgid "待處理問題"
msgstr "待處理問題"

#: apps/dp-client/src/screens/others/NoNetwork.tsx:27
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:83
msgid "待補充"
msgstr "待補充"

#: apps/dp-admin/src/pages/split-account/services/constants.ts:244
msgid "待補充抬頭資訊"
msgstr "待補充抬頭資訊"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityCornerStatusTag.tsx:36
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/utils/activityUtils.ts:22
msgid "待解鎖"
msgstr "待解鎖"

#: apps/dp-admin/src/pages/split-account/services/constants.ts:77
msgid "待計算"
msgstr "待計算"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:163
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:447
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:24
#: apps/dp-admin/src/pages/split-account/services/constants.ts:87
msgid "待請款"
msgstr "待請款"

#: apps/dp-admin/src/modules/constants/merchantStatus.ts:46
msgid "待財務審核"
msgstr "待財務審核"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:95
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:54
msgid "待財務確認"
msgstr "待財務確認"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:51
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:33
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:34
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:36
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:62
msgid "待運行"
msgstr "待運行"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:37
msgid "待開始"
msgstr "待開始"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:91
msgid "待開幕"
msgstr "待開幕"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:96
#: apps/dp-admin/src/modules/constants/options.ts:573
msgid "待開業"
msgstr "待開業"

#: apps/dp-admin/src/pages/split-account/services/constants.ts:242
msgid "待開票"
msgstr "待開票"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:421
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:741
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:764
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:787
msgid "待開通"
msgstr "待開通"

#: apps/dp-client/src/utils/utils.ts:144
msgid "很好"
msgstr "很好"

#: apps/dp-client/src/utils/utils.ts:147
msgid "很差"
msgstr "很差"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:35
msgid "很棒！"
msgstr "很棒！"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:218
msgid "後可再次修改暱稱"
msgstr "後可再次修改暱稱"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:85
msgid "後臺處理中，款項會在 24 小時內退回"
msgstr "後臺處理中，款項會在 24 小時內退回"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:396
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:76
msgid "從捷運站出來後，街道旁有「餐廳方向→」的路牌，配有小熊圖案。"
msgstr "從捷運站出來後，街道旁有「餐廳方向→」的路牌，配有小熊圖案。"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:176
msgid "從現有停車場中選擇，或直接於下方新建"
msgstr "從現有停車場中選擇，或直接於下方新建"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:817
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:1245
msgid "從相冊選擇"
msgstr "從相簿選擇"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:93
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:171
msgid "循環次數"
msgstr "循環次數"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:160
msgid "循環週期"
msgstr "循環週期"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:576
msgid "微信"
msgstr "微信"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:459
msgid "微信支付"
msgstr "微信支付"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:310
msgid "微調"
msgstr "微調"

#: apps/dp-client/src/screens/login/pages/login/index.tsx:430
#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:229
msgid "心生活"
msgstr "心生活"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:29
msgid "心生活APP/遠傳傳媒"
msgstr "心生活APP/遠傳傳媒"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:233
msgid "心生活MID"
msgstr "心生活MID"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:153
msgid "心生活Push推送"
msgstr "心生活Push推送"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:52
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:227
msgid "心生活用戶ID"
msgstr "心生活用戶ID"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:892
#: apps/dp-business/src/pages/AddStore/index.tsx:1244
#: apps/dp-business/src/pages/AddStore/index.tsx:1307
#: apps/dp-business/src/pages/AddStore/index.tsx:1383
#: apps/dp-business/src/pages/AddStore/index.tsx:1451
#: apps/dp-business/src/pages/AddStore/index.tsx:1468
#: apps/dp-business/src/components/InputField.tsx:121
#: apps/dp-business/src/components/FormField/index.tsx:100
#: apps/dp-business/src/components/FormField/index.tsx:134
msgid "必填"
msgstr "必填"

#: apps/dp-business/src/components/NecessaryDocuments/index.tsx:66
msgid "必要資訊"
msgstr "必要資訊"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:339
msgid "必須同時包含字母和數字，支援下劃線，長度 6-22 位"
msgstr "必須同時包含字母和數字，支援下劃線，長度 6-22 位"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConsumeConfigEditor/index.web.tsx:59
msgid "必須是已啟用的積分權益"
msgstr "必須是已啟用的積分權益"

#: apps/dp-business/src/pages/Login/index.tsx:1137
#: apps/dp-business/src/pages/Login/index.tsx:1215
#: apps/dp-business/src/pages/Login/index.tsx:1611
#: apps/dp-business/src/pages/Login/index.tsx:1689
#: apps/dp-business/src/pages/ForgotPasswordPage/index.tsx:89
#: apps/dp-business/src/pages/ForgotPasswordPage/index.tsx:107
#: apps/dp-business/src/pages/ChangePassword/index.tsx:196
#: apps/dp-business/src/components/ForgotPassword/index.tsx:72
msgid "忘記密碼"
msgstr "忘記密碼"

#: apps/dp-client/src/screens/account/pages/profile/components/ContentTabsSection/UserNoteSection.tsx:226
msgid "快來分享您的精彩時刻吧"
msgstr "快來分享您的精彩時刻吧"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/CommentSection.tsx:155
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:856
#: apps/dp-client/src/screens/home/components/ReviewCad/empty.tsx:16
msgid "快來成為第一個留言！"
msgstr "快來成為第一個留言！"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:273
#: apps/dp-admin/src/modules/constants/options.ts:544
msgid "快到期"
msgstr "快到期"

#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/UsergiftBanner.tsx:381
msgid "快去用"
msgstr "快去用"

#: apps/dp-client/src/screens/account/pages/follow-list/hooks/useFollowListData.ts:54
msgid "快去追蹤一些喜歡的人吧"
msgstr "快去追蹤一些喜歡的人吧"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/records/index.tsx:196
msgid "快把任務點數拿來兌換美食金吧"
msgstr "快把任務點數拿來兌換美食金吧"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1674
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1069
msgid "快捷篩選"
msgstr "快捷篩選"

#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:610
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:637
msgid "快速篩選"
msgstr "快速篩選"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:377
msgid "快遞編碼"
msgstr "快遞編碼"

#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:99
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:143
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:14
msgid "性別"
msgstr "性別"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1046
msgid "恢復參與"
msgstr "恢復參與"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:538
msgid "恢復參與失敗，請稍後重試"
msgstr "恢復參與失敗，請稍後重試"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:73
msgid "恢復掛接"
msgstr "恢復掛接"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallProgressCard/index.tsx:72
msgid "恭喜！已可兌換最高獎勵"
msgstr "恭喜！已可兌換最高獎勵"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/RegistrationStatusBanner.tsx:51
msgid "恭喜您已報名參加「{activityName}活動」！"
msgstr "恭喜您已報名參加「{activityName}活動」！"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/RegistrationStatusBanner.tsx:53
msgid "恭喜您已自動參加「{activityName}活動」！"
msgstr "恭喜您已自動參加「{activityName}活動」！"

#: apps/dp-client/src/screens/home/pages/ShareKing/pages/RaffleWinners/index.tsx:198
msgid "恭喜您本期中獎！請留意近期領獎通知或簡訊！"
msgstr "恭喜您本期中獎！請留意近期領獎通知或簡訊！"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:385
#: apps/dp-client/src/components/TaskRewardToast/index.tsx:22
msgid "恭喜獲得"
msgstr "恭喜獲得"

#. placeholder {0}: (claimedCouponData.count ?? 0) > 1 ? `${claimedCouponData.count}張` : ''
#. placeholder {1}: claimedCouponData?.type === 2 ? '結帳折扣券' : `${claimedCouponData?.brandName || ''}兌換券`
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:63
msgid "恭喜獲得{0}{1}"
msgstr "恭喜獲得{0}{1}"

#: apps/dp-client/src/hooks/tasks/useTaskRewardFeedback.ts:77
msgid "恭喜獲得點數"
msgstr "恭喜獲得點數"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:51
msgid "悅品評茶餐廳"
msgstr "悅品評茶餐廳"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:46
msgid "悠遊付"
msgstr "悠遊付"

#: apps/dp-client/src/screens/diary/pages/no-access/index.tsx:118
msgid "您仍可繼續瀏覽現有的食記，後續活動以官方公告為準，敬請期待。"
msgstr "您仍可繼續瀏覽現有的食記，後續活動以官方公告為準，敬請期待。"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:394
msgid "您最早可以在哪一天恢復營業?"
msgstr "您最早可以在哪一天恢復營業?"

#: apps/dp-client/src/screens/diary/pages/home/components/upgrade-modal/index.tsx:110
msgid "您可使用門號註冊登入直接使用，或使用心生活帳號登入以保有原有的日記內容及帳號資訊，您的權益不會受到任何影響，並可隨時於服務內申請刪除帳號與相關資料。若您在升級過程中有任何疑問，歡迎隨時透過客服信箱"
msgstr "您可使用門號註冊登入直接使用，或使用心生活帳號登入以保有原有的日記內容及帳號資訊，您的權益不會受到任何影響，並可隨時於服務內申請刪除帳號與相關資料。若您在升級過程中有任何疑問，歡迎隨時透過客服信箱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BlueHeartServiceInfo/index.web.tsx:40
msgid "您可在此填寫商家簽約的特殊資訊"
msgstr "您可在此填寫商家簽約的特殊資訊"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:2070
msgid "您可能不在店內"
msgstr "您可能不在店內"

#: apps/dp-admin/src/pages/error/404.web.tsx:73
msgid "您可能輸入了錯誤的地址，或者該頁面已被移動或刪除"
msgstr "您可能輸入了錯誤的地址，或者該頁面已被移動或刪除"

#. placeholder {0}: result.duplicateType === DuplicateType.SAME_SHOP ? '本餐廳' : '其他餐廳'
#. placeholder {0}: conflictOrder?.duplicateType === DuplicateType.SAME_SHOP ? '本餐廳' : '其他餐廳'
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:316
#: apps/dp-client/src/screens/reservation/pages/main/components/ConflictModal.tsx:41
msgid "您在{0}此時段已有預訂"
msgstr "您在{0}此時段已有預訂"

#. placeholder {0}: invitationData?.contactName || ''
#. placeholder {1}: invitationData?.gender || ''
#: apps/dp-client/src/screens/reservation/pages/invitation/index.tsx:62
msgid "您好，{0} {1}邀請您一起用餐"
msgstr "您好，{0} {1}邀請您一起用餐"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:547
msgid "您對本次回饋的滿意度是？"
msgstr "您對本次回饋的滿意度是？"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:118
msgid "您對本次推薦餐廳的滿意度是？"
msgstr "您對本次推薦餐廳的滿意度是？"

#: apps/dp-client/src/screens/satisfaction-feedback/SatisfactionPrompt.tsx:78
msgid "您對本次服務滿意嗎？"
msgstr "您對本次服務滿意嗎？"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/RegistrationStatusBanner.tsx:57
msgid "您尚未滿足活動參與條件，完成套餐券上架即可自動享受3個月免傭優惠"
msgstr "您尚未滿足活動參與條件，完成套餐券上架即可自動享受3個月免傭優惠"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1117
msgid "您已報名"
msgstr "您已報名"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/RegistrationStatusBanner.tsx:55
msgid "您已符合活動資格，請抓緊報名參與～"
msgstr "您已符合活動資格，請抓緊報名參與～"

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:170
msgid "您已累計發佈"
msgstr "您已累計發佈"

#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:136
msgid "您已綁定手機門號"
msgstr "您已綁定手機門號"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:681
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ReviewGuide.tsx:80
msgid "您已評論"
msgstr "您已評論"

#: apps/dp-business/src/components/ServiceNotEnabled/index.tsx:49
msgid "您已開啟 {remainingDays} 天，快來聯繫我們開啟吧～"
msgstr "您已開啟 {remainingDays} 天，快來聯繫我們開啟吧～"

#: apps/dp-client/src/screens/home/pages/UserGift/hooks/useUserGiftData.ts:126
msgid "您已領取過註冊禮"
msgstr "您已領取過註冊禮"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:240
msgid "您希望在平台補貼的基礎上額外減免百分之多少？"
msgstr "您希望在平台補貼的基礎上額外減免百分之多少？"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:64
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:64
msgid "您店主評價臺，連續3天評分低於3.5星"
msgstr "您店主評價臺，連續3天評分低於3.5星"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:55
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:55
msgid "您店評分有客戶投訴，人員服務不佳"
msgstr "您店評分有客戶投訴，人員服務不佳"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:192
msgid "您得隨時透過本公司指定之方式通知本公司或經本服務應用程式內之「帳號設定」功能(如有)，發起帳號刪除程序，終止您的帳號。提醒您若刪除此帳號，您將失去下列權益及優惠："
msgstr "您得隨時透過本公司指定之方式通知本公司或經本服務應用程式內之「帳號設定」功能(如有)，發起帳號刪除程序，終止您的帳號。提醒您若刪除此帳號，您將失去下列權益及優惠："

#: apps/dp-business/src/pages/MerchantReview/index.tsx:451
msgid "您提供的資料不符合要求，請根據提示重新提交。"
msgstr "您提供的資料不符合要求，請根據提示重新上傳。"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/NoSigned.tsx:23
msgid "您暫未簽約，將錯過平台曝光與補貼機會"
msgstr "您暫未簽約，將錯過平台曝光與補貼機會"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/NoDiscount.tsx:30
msgid "您暫未開通結帳服務，"
msgstr "您暫未開通結帳服務，"

#: apps/dp-client/src/screens/login/pages/welcome-back/index.tsx:43
msgid "您曾使用此手機門號註冊，這裡是為您保留的資料"
msgstr "您曾使用此手機門號註冊，這裡是為您保留的資料"

#: apps/dp-business/src/components/UnsavedChangesDialog/index.tsx:47
msgid "您有尚未儲存的編輯內容，離開當前頁面前請選擇您的操作："
msgstr "您有尚未儲存的編輯內容，離開當前頁面前請選擇您的操作："

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/index.tsx:361
msgid "您正在填寫活動報名錶單，切換活動將丟失當前填寫的內容。是否繼續切換？"
msgstr "您正在填寫活動報名表單，切換活動將遺失當前填寫的內容。是否繼續切換？"

#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:467
msgid "您正在更改信息"
msgstr "您正在更改信息"

#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:468
msgid "您正在更改回傳遠傳心生活的Mid信息，若需重新觸發回傳，請至發放明細中手動重新觸發回傳"
msgstr "您正在更改回傳遠傳心生活的Mid信息，若需重新觸發回傳，請至發放明細中手動重新觸發回傳"

#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:984
msgid "您正在更改回傳遠傳心生活的Mid資訊，若需重新觸發回傳，請至發放明細中手動重新觸發回傳"
msgstr "您正在更改回傳遠傳心生活的Mid資訊，若需重新觸發回傳，請至發放明細中手動重新觸發回傳"

#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:983
msgid "您正在更改資訊"
msgstr "您正在更改資訊"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:82
msgid "您正在申請註銷帳號！"
msgstr "您正在申請註銷帳號！"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:567
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:113
msgid "您正在編輯，切換頁籤將會遺失未儲存的更改。是否繼續？"
msgstr "您正在編輯，切換頁籤將會遺失未儲存的更改。是否繼續？"

#: apps/dp-admin/src/pages/error/403.web.tsx:77
msgid "您沒有存取此係統的權限，請聯絡管理員或重新登入"
msgstr "您沒有存取此係統的權限，請聯絡管理員或重新登入"

#: apps/dp-business/src/utils/authNavigation.ts:107
#: apps/dp-business/src/pages/SimpleDashboard/index.tsx:40
msgid "您沒有收銀臺權限，已為您切換至完整版"
msgstr "您沒有收銀臺權限，已為您切換至完整版"

#: apps/dp-business/src/pages/ChainDashboard/components/NoPermissionState.tsx:39
msgid "您無此節點的數據查看權限，請選擇有權節點"
msgstr "您無此節點的數據查看權限，請選擇有權節點"

#: apps/dp-client/src/screens/home/utils/utils.ts:446
msgid "您發布的{label}因有《{reasons}》的情形，故目前不會公開顯示，您可修改後重新發"
msgstr "您發布的{label}因有《{reasons}》的情形，故目前不會公開顯示，您可修改後重新發"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:759
#: apps/dp-client/src/screens/payment/pages/result/index.tsx:788
#: apps/dp-client/src/screens/payment/pages/result/index.tsx:819
msgid "您的優惠券已放回券包，可以重新發起結帳折扣。"
msgstr "您的優惠券已放回券包，可以重新發起結帳折扣。"

#: apps/dp-client/src/screens/home/bizComponents/NoteCard/index.tsx:95
#: apps/dp-client/src/screens/account/pages/profile/components/MyReviewsContent/index.tsx:258
msgid "您的內容暫時無法發佈"
msgstr "您的內容暫時無法發佈"

#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:193
msgid "您的初始預設評分參考了公開信息，後續則將根據去哪吃平台所有用戶給您的評分與評價進行計算，確保真實可靠"
msgstr "您的初始預設評分參考了公開信息，後續則將根據去哪吃平台所有用戶給您的評分與評價進行計算，確保真實可靠"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:414
msgid "您的合約已提交成功"
msgstr "您的合約已提交成功"

#: apps/dp-business/src/pages/OnboardingComplete/index.tsx:58
msgid "您的商家進駐申請已提交成功，我們將在1-3個工作日內完成審核，請耐心等待。"
msgstr "您的商家進駐申請已上傳成功，我們將在1-3個工作日內完成審核，請耐心等待。"

#: apps/dp-client/src/screens/home/utils/location.ts:241
msgid "您的定位不在臺灣，已默認定位到臺北市"
msgstr "您的定位不在臺灣，已默認定位到臺北市"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:163
msgid "您的帳號中還有未完成的訂單<0/>或尚未處理的資產<1/>暫時無法進行刪除"
msgstr "您的帳號中還有未完成的訂單<0/>或尚未處理的資產<1/>暫時無法進行刪除"

#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:99
msgid ""
"您的帳號將會被立即註銷\n"
"確認繼續？您的帳號將會被立即注銷\n"
"確認繼續？"
msgstr ""
"您的帳號將會被立即註銷\n"
"確認繼續？您的帳號將會被立即注銷\n"
"確認繼續？"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:69
msgid "您的帳號將被立即刪除"
msgstr "您的帳號將被立即刪除"

#: apps/dp-client/src/notifications/multi-login.ts:46
msgid "您的帳號已在其他裝置登入，請重新登入"
msgstr "您的帳號已在其他裝置登入，請重新登入"

#: apps/dp-client/src/screens/satisfaction-feedback/SatisfactionPrompt.tsx:85
msgid "您的支持是我們持續挖掘美食的動力！"
msgstr "您的支持是我們持續挖掘美食的動力！"

#: apps/dp-business/src/pages/Unauthorized/index.tsx:99
msgid "您的登入狀態已過期，請重新登入以繼續使用"
msgstr "您的登入狀態已過期，請重新登入以繼續使用"

#: apps/dp-business/src/components/MerchantBenefits/index.tsx:45
msgid "您的行銷活動會在多樣的管道曝光，幫助您快速觸及更多潛在客戶。"
msgstr "您的行銷活動會在多樣的管道曝光，幫助您快速觸及更多潛在客戶。"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:165
msgid "您的補貼"
msgstr "您的補貼"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:163
msgid "您的補貼規則"
msgstr "您的補貼規則"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:150
msgid "您的補貼說明"
msgstr "您的補貼說明"

#: apps/dp-client/src/screens/home/pages/Meal/pages/result/index.tsx:67
msgid ""
"您的訂單還未完成支付，\n"
"請在訂單取消前儘快支付。您的訂單還未完成支付，\n"
"請在訂單取消前儘快支付。"
msgstr ""
"您的訂單還未完成支付，\n"
"請在訂單取消前儘快支付。您的訂單還未完成支付，\n"
"請在訂單取消前儘快支付。"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:821
msgid "您的訂單還未完成支付，請在訂單取消前儘快支付。"
msgstr "您的訂單還未完成支付，請在訂單取消前儘快支付。"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:777
msgid "您的評論正在審核中，審核通過後將對其他用戶展示"
msgstr "您的評論正在發佈中，發佈完成後將對其他用戶展示"

#: apps/dp-client/src/screens/diary/pages/no-access/index.tsx:68
msgid "您的身份無法參與此活動"
msgstr "您的身份無法參與此活動"

#: apps/dp-business/src/components/NecessaryDocuments/index.tsx:60
msgid "您的身分證件"
msgstr "您的身分證件"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:193
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:231
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:412
msgid "您的額外加碼"
msgstr "您的額外加碼"

#. placeholder {0}: shopState.shopDetail?.shopName || ''
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:664
msgid "您的餐廳「{0}」暫時不符合本次活動參與條件，請繼續努力！"
msgstr "您的餐廳「{0}」暫時不符合本次活動參與條件，請繼續努力！"

#. placeholder {0}: shopState.shopDetail?.shopName || ''
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:661
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:663
msgid "您的餐廳「{0}」符合本次活動參與條件，立即報名參與活動！"
msgstr "您的餐廳「{0}」符合本次活動參與條件，立即報名參與活動！"

#: apps/dp-business/src/components/MerchantBenefits/index.tsx:60
msgid "您的餐廳優惠與活動，可以有效投放至您的目標客群，提高成交率與營收。"
msgstr "您的餐廳優惠與活動，可以有效投放至您的目標客群，提高成交率與營收。"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:592
msgid "您確定要刪除此筆記嗎？此操作不可撤銷，請謹慎選擇。"
msgstr "您確定要刪除此筆記嗎？此操作無法反悔，請謹慎選擇。"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:210
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:552
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:88
msgid "您確定要取消編輯嗎？未儲存的更改將會遺失。"
msgstr "您確定要取消編輯嗎？未儲存的更改將會遺失。"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:351
msgid "您確定要移除這則評論？刪除後不可還原。"
msgstr "您確定要移除這則評論？刪除後不可還原。"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:107
msgid "您確定要離開券組頁面嗎？未儲存的更改將會遺失。"
msgstr "您確定要離開券組頁面嗎？未儲存的更改將會遺失。"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:74
msgid "您確定要離開商家裝修頁面嗎？未儲存的更改將會遺失。"
msgstr "您確定要離開商家裝修頁面嗎？未儲存的更改將會遺失。"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:185
msgid "您確定要離開店家詳情頁面嗎？未儲存的更改將會遺失。"
msgstr "您確定要離開店家詳情頁面嗎？未儲存的更改將會遺失。"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:204
msgid "您確定要離開模板編輯頁面嗎？未儲存的更改將會遺失。"
msgstr "您確定要離開模板編輯頁面嗎？未儲存的更改將會遺失。"

#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:242
msgid "您確定要離開活動頁面嗎？未儲存的更改將會遺失。"
msgstr "您確定要離開活動頁面嗎？未儲存的更改將會遺失。"

#: apps/dp-admin/src/pages/merchant/service/hooks.ts:31
#: apps/dp-admin/src/modules/hooks/useUnsavedChangesWarning.ts:66
msgid "您確定要離開目前頁面嗎？未儲存的更改將會遺失。"
msgstr "您確定要離開目前頁面嗎？未儲存的更改將會遺失。"

#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:137
msgid "您確定要離開菜單頁面嗎？未儲存的更改將會遺失。"
msgstr "您確定要離開菜單頁面嗎？未儲存的更改將會遺失。"

#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:89
msgid "您確定要離開頁面嗎？未儲存的更改將會遺失。"
msgstr "您確定要離開頁面嗎？未儲存的更改將會遺失。"

#: apps/dp-business/src/pages/TableManagement/index.tsx:544
#: apps/dp-business/src/pages/TableManagement/index.tsx:722
msgid "您設置的桌位將展示給用戶在訂位時選擇，桌位不是桌子的概念，您可以在訂位規則中配置每個桌位的庫存數量，可以在桌位體現您的桌位優勢，比如「景觀位、庭院邊、吧檯前⋯⋯」"
msgstr "您設置的桌位將展示給用戶在訂位時選擇，桌位不是桌子的概念，您可以在訂位規則中配置每個桌位的庫存數量，可以在桌位體現您的桌位優勢，比如「景觀位、庭院邊、吧檯前⋯⋯」"

#: apps/dp-business/src/pages/TableManagement/index.tsx:273
#: apps/dp-business/src/pages/TableManagement/index.tsx:378
msgid "您設置的桌型將展示給用戶在訂位時選擇"
msgstr "您設置的桌型將展示給用戶在訂位時選擇"

#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/UsergiftBanner.tsx:382
msgid "您還有"
msgstr "您還有"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/hooks/useReviewSubmit.ts:96
msgid "您還沒有為口味打分"
msgstr "您還沒有為口味打分"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/hooks/useReviewSubmit.ts:91
msgid "您還沒有為星級打分"
msgstr "您還沒有為星級打分"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/hooks/useReviewSubmit.ts:101
msgid "您還沒有為服務打分"
msgstr "您還沒有為服務打分"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/hooks/useReviewSubmit.ts:106
msgid "您還沒有為環境打分"
msgstr "您還沒有為環境打分"

#: apps/dp-client/src/components/GuestLoginPop/index.tsx:39
msgid "您需要先登錄才能繼續"
msgstr "您需要先登錄才能繼續"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:98
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:98
msgid "情侶"
msgstr "情侶"

#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:246
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:246
msgid "情侶約會"
msgstr "情侶約會"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:78
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:51
msgid "情緒傾向"
msgstr "情緒傾向"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:41
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:38
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:331
msgid "惡意負評或人身攻擊"
msgstr "惡意負評或人身攻擊"

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:229
msgid "意見回饋"
msgstr "意見回饋"

#: apps/dp-client/src/screens/reservation/utils/index.ts:114
msgid "感謝使用，期待下次預訂"
msgstr "感謝使用，期待下次預訂"

#: apps/dp-client/src/screens/reservation/utils/index.ts:121
msgid "感謝使用去哪吃訂位，祝您用餐愉快"
msgstr "感謝使用去哪吃訂位，祝您用餐愉快"

#: apps/dp-client/src/screens/home/pages/Review/pages/complaintComplete/index.tsx:21
msgid "感謝回饋"
msgstr "感謝回饋"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:520
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:684
msgid "感謝您的分享~目前筆記正在發布中，通過後將會與大家見面喔!"
msgstr "感謝您的分享~目前筆記正在發布中，通過後將會與大家見面喔!"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:206
msgid "感謝您的反饋，我們會持續優化體驗"
msgstr "感謝您的反饋，我們會持續優化體驗"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/SuccessModal.tsx:51
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/CorrectionModal.tsx:143
#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:147
#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:170
#: apps/dp-client/src/components/FeedBackModal/index.tsx:249
msgid "感謝您的寶貴回饋"
msgstr "感謝您的寶貴回饋"

#: apps/dp-client/src/screens/diary/pages/add-merchant/submit-success/index.tsx:40
msgid "感謝提交！"
msgstr "感謝送出！"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:964
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:176
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCommonColumns.tsx:70
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/ContractSettings/index.web.tsx:52
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:65
msgid "憑證開立方式"
msgstr "憑證開立方式"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:40
msgid "應付商家補貼"
msgstr "應付商家補貼"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:636
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:766
msgid "應付金額"
msgstr "應付金額"

#: apps/dp-client/src/screens/diary/pages/my/components/PointsInfoCard.tsx:73
msgid "懸賞任務"
msgstr "懸賞任務"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCells.tsx:153
#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:159
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:33
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:171
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:232
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:454
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:663
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:115
#: apps/dp-admin/src/pages/marketing/services/interface/batchTask.ts:200
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:122
#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:196
#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:330
msgid "成功"
msgstr "成功"

#. placeholder {0}: successItems.length
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:93
msgid "成功 ({0})"
msgstr "成功 ({0})"

#. placeholder {0}: result?.successCount ?? 0
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:85
msgid "成功 {0} 家"
msgstr "成功 {0} 家"

#. placeholder {0}: res.successCount
#. placeholder {1}: res.failed.length
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:142
msgid "成功 {0} 家，失敗 {1} 家："
msgstr "成功 {0} 家，失敗 {1} 家："

#. placeholder {0}: successCount ?? '—'
#. placeholder {1}: duplicateCount ?? '—'
#. placeholder {2}: filteredCount ?? '—'
#. placeholder {3}: failureCount ?? '—'
#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:66
msgid "成功 {0} 筆 ／ 重複 {1} 筆 ／ 已過濾 {2} 筆 ／ 匯入失敗 {3} 筆"
msgstr "成功 {0} 筆 ／ 重複 {1} 筆 ／ 已過濾 {2} 筆 ／ 匯入失敗 {3} 筆"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/batchResult.ts:17
msgid "成功 {successCount} 筆，失敗 {failedCount} 筆。{detail}"
msgstr "成功 {successCount} 筆，失敗 {failedCount} 筆。{detail}"

#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:502
msgid "成功/失敗"
msgstr "成功/失敗"

#: apps/dp-admin/src/modules/hooks/useDownload.ts:251
#: apps/dp-admin/src/modules/hooks/useDownload.ts:290
#: apps/dp-admin/src/modules/hooks/useBlobDownload.ts:182
msgid "成功下載 {successCount}/{totalCount} 個文件"
msgstr "成功下載 {successCount}/{totalCount} 個文件"

#. placeholder {0}: codeIds.length
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:144
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:223
msgid "成功刪除 {0} 個券碼"
msgstr "成功刪除 {0} 個券碼"

#. placeholder {0}: selectedShopIds.length
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:258
msgid "成功刪除 {0} 家商家"
msgstr "成功刪除 {0} 家商家"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:78
msgid "成功匯入"
msgstr "成功匯入"

#. placeholder {0}: failCount > 0 ? t`，${failCount} 個任務失敗` : ''
#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:502
msgid "成功完成 {successCount} 個任務{0}"
msgstr "成功完成 {successCount} 個任務{0}"

#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:144
msgid "成功數量"
msgstr "成功數量"

#: apps/dp-admin/src/pages/order/order-detail/components/RefundRecords/index.web.tsx:75
msgid "成功時間"
msgstr "成功時間"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/hooks.ts:190
msgid "成功添加庫存"
msgstr "成功添加庫存"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/ExportHistoryTab/index.web.tsx:100
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/ExportHistoryTab/index.web.tsx:100
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:181
msgid "成功筆數 / 總筆數"
msgstr "成功筆數 / 總筆數"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:323
msgid "成功解析"
msgstr "成功解析"

#. placeholder {0}: mockData.length
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:196
msgid "成功解析 {0} 條任務數據"
msgstr "成功解析 {0} 條任務數據"

#. placeholder {0}: selectedTaskIds.length
#: apps/dp-admin/src/pages/merchant/components/FollowUpModal/services/hooks/index.ts:108
msgid "成功關聯 {0} 項任務"
msgstr "成功關聯 {0} 項任務"

#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:214
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/MemberListTab/index.web.tsx:84
msgid "成員列表"
msgstr "成員列表"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:89
#: apps/dp-admin/src/components/UserGroup/UserGroupDetailInfo/index.web.tsx:53
msgid "成員數量"
msgstr "成員數量"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/MemberListTab/index.web.tsx:74
msgid "成員預覽"
msgstr "成員預覽"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:148
msgid "我們使用cookie和類似技術來收集和儲存資訊，以提供更好的使用者體驗，分析使用模式，並改進我們的服務。"
msgstr "我們使用cookie和類似技術來收集和儲存資訊，以提供更好的使用者體驗，分析使用模式，並改進我們的服務。"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:77
msgid "我們使用收集的資訊用於以下目的："
msgstr "我們使用收集的資訊用於以下目的："

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:44
msgid "我們可能收集以下類型的資訊："
msgstr "我們可能收集以下類型的資訊："

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:162
msgid "我們可能會不時更新本隱私政策。如有重大變更，我們會透過在我們的網站上發佈新的隱私政策或透過其他方式通知您。"
msgstr "我們可能會不時更新本隱私政策。如有重大變更，我們會透過在我們的網站上發佈新的隱私政策或透過其他方式通知您。"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:101
msgid "我們可能與以下各方共享您的資訊："
msgstr "我們可能與以下各方共享您的資訊："

#: apps/dp-business/src/pages/MerchantReview/index.tsx:404
msgid "我們將在7個工作日內完成審核，審核結果將以Email或簡訊告知您"
msgstr "我們將在7個工作日內完成審核，審核結果將以Email或簡訊告知您"

#: apps/dp-client/src/screens/diary/pages/add-merchant/submit-success/index.tsx:43
msgid "我們將盡快確認並通知您"
msgstr "我們將盡快確認並通知您"

#: apps/dp-client/src/screens/home/pages/Review/pages/complaintComplete/index.tsx:24
msgid "我們將盡快處理"
msgstr "我們將盡快處理"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:126
msgid "我們採取合理的措施來保護您的個人資訊不被未經授權的存取、使用或披露。然而，沒有任何電子傳輸或儲存方法是100%安全的，我們不能保證絕對的安全性。"
msgstr "我們採取合理的措施來保護您的個人資訊不被未經授權的存取、使用或披露。然而，沒有任何電子傳輸或儲存方法是100%安全的，我們不能保證絕對的安全性。"

#: apps/dp-business/src/components/MerchantBenefits/index.tsx:40
msgid "我們提供專屬訂位與排隊功能，協助您提高經營效率，提升翻桌率與營收。"
msgstr "我們提供專屬訂位與排隊功能，協助您提高經營效率，提升翻桌率與營收。"

#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:53
msgid "我們會審核您提交的資料"
msgstr "我們會審核您提交的資料"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/SuccessModal.tsx:54
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/CorrectionModal.tsx:146
#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:173
#: apps/dp-client/src/components/FeedBackModal/index.tsx:252
msgid "我們會迅速審核並修正資訊"
msgstr "我們會迅速審核並修正資訊"

#: apps/dp-business/src/components/MerchantBenefits/index.tsx:55
msgid "我們有多樣的優惠活動設計，幫您吸引新客、提升營收、吸引回頭客。"
msgstr "我們有多樣的優惠活動設計，幫您吸引新客、提升營收、吸引回頭客。"

#: apps/dp-client/src/screens/login/pages/account-info/index.tsx:83
msgid "我們發現這個手機門號曾建立過帳號"
msgstr "我們發現這個手機門號曾建立過帳號"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:155
msgid "我們的服務不面向13歲以下的兒童。如果我們得知我們收集了13歲以下兒童的個人資訊，我們將採取措施刪除該資訊。"
msgstr "我們的服務不提供給13歲以下的兒童。如果我們得知我們收集了13歲以下兒童的個人資訊，我們將採取措施刪除該資訊。"

#. placeholder {0}: bdInfo?.accountName || ''
#: apps/dp-business/src/pages/ContactBD/index.tsx:167
msgid "我們的業務專員{0}為您提供幫助，解答您的疑問，協助您完成入駐流程。"
msgstr "我們的業務專員{0}為您提供幫助，解答您的疑問，協助您完成入駐流程。"

#: apps/dp-client/src/screens/reservation/pages/main/components/ConflictModal.tsx:85
msgid "我同意取消原預訂"
msgstr "我同意取消原預訂"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:615
msgid "我同意辦理退貨時,由聚流平台代為處理發票及銷貨退回證明單,以加速退貨退款作業。同時也瞭解依統一發票給獎辦法第11條全額折讓之發票交易金額將視同為零不具兌獎資格"
msgstr "我同意辦理退貨時,由聚流平台代為處理發票及銷貨退回證明單,以加速退貨退款作業。同時也瞭解依統一發票給獎辦法第11條全額折讓之發票交易金額將視同為零不具兌獎資格"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:342
msgid "我同意辦理退貨時，由聚流平台代為處理發票及銷貨退回證明單以加速退貨退款作業"
msgstr "我同意辦理退貨時，由聚流平台代為處理發票及銷貨退回證明單以加速退貨退款作業"

#. placeholder {0}: diaryData.restaurantName
#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:779
msgid "我在{0}有一次難忘的美食體驗！真心分享我的第一手心得✨"
msgstr "我在{0}有一次難忘的美食體驗！真心分享我的第一手心得✨"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:333
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:294
msgid "我已使用完優惠券"
msgstr "我已使用完優惠券"

#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:129
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:491
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:583
msgid "我已向店家出示確認"
msgstr "我已向店家出示確認"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:544
#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:587
msgid "我已支付"
msgstr "我已支付"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:276
msgid "我已知道，開始填寫"
msgstr "我已知道，開始填寫"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:178
msgid "我已閱讀並同意"
msgstr "我已閱讀並同意"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:623
msgid "我已閱讀並理解自核銷功能之風險說明，並同意自行承擔相關責任"
msgstr "我已閱讀並理解自核銷功能之風險說明，並同意自行承擔相關責任"

#: apps/dp-client/src/screens/satisfaction-feedback/SatisfactionPrompt.tsx:139
msgid "我想說點意見"
msgstr "我想說點意見"

#: apps/dp-client/src/screens/account/pages/likes/pages/main/index.tsx:57
#: apps/dp-client/src/configs/page-configs.tsx:2325
#: apps/dp-client/src/configs/page-configs.tsx:2327
msgid "我按的讚"
msgstr "我按的讚"

#: apps/dp-client/src/screens/home/pages/Home/components/HeaderContent/index.tsx:154
#: apps/dp-client/src/configs/main-config.tsx:96
#: apps/dp-client/src/configs/main-config.tsx:98
#: apps/dp-client/src/configs/main-config.tsx:174
#: apps/dp-client/src/configs/main-config.tsx:175
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:332
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:843
#: apps/dp-business/src/pages/MyProfile/index.tsx:371
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:822
#: apps/dp-business/src/components/MerchantReviewTabs/index.tsx:44
#: apps/dp-business/src/components/LoginCustomBars/index.tsx:44
#: apps/dp-business/src/components/CustomTabs/index.tsx:282
#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:110
msgid "我的"
msgstr "我的"

#: apps/dp-admin/src/router/config/routes.web.tsx:74
msgid "我的任務"
msgstr "我的任務"

#: apps/dp-admin/src/router/config/routes.web.tsx:56
#: apps/dp-admin/src/pages/merchant/my-signed-merchant/index.web.tsx:8
msgid "我的商家"
msgstr "我的商家"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:449
#: apps/dp-admin/src/pages/marketing/my-package-coupon-list/index.web.tsx:11
msgid "我的套餐券"
msgstr "我的套餐券"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:376
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:385
msgid "我的工單"
msgstr "我的工單"

#: apps/dp-admin/src/router/config/routes.web.tsx:101
#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:233
msgid "我的店家"
msgstr "我的店家"

#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:106
msgid "我的推薦人序號"
msgstr "我的推薦人序號"

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:167
msgid "我的推薦碼"
msgstr "我的推薦碼"

#: apps/dp-client/src/screens/account/pages/advice/my-feedback/index.tsx:295
#: apps/dp-client/src/screens/account/pages/advice/advice-feedback/index.tsx:274
#: apps/dp-client/src/configs/page-configs.tsx:1621
#: apps/dp-client/src/configs/page-configs.tsx:1623
msgid "我的提問"
msgstr "我的提問"

#: apps/dp-client/src/screens/account/pages/favorites/pages/main/index.tsx:55
#: apps/dp-client/src/configs/page-configs.tsx:2254
#: apps/dp-client/src/configs/page-configs.tsx:2256
msgid "我的收藏"
msgstr "我的收藏"

#: apps/dp-client/src/screens/diary/pages/my/index.tsx:212
msgid "我的日記"
msgstr "我的日記"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:794
#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/index.tsx:91
#: apps/dp-business/src/configs/page-configs.ts:1013
#: apps/dp-business/src/components/CustomTabs/index.tsx:111
msgid "我的權益"
msgstr "我的權益"

#: apps/dp-client/src/configs/page-configs.tsx:2456
#: apps/dp-client/src/configs/page-configs.tsx:2458
msgid "我的票券"
msgstr "我的票券"

#: apps/dp-client/src/screens/diary/pages/my/index.tsx:208
msgid "我的積分"
msgstr "我的積分"

#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:103
#: apps/dp-client/src/screens/diary/pages/home/components/header-section/index.tsx:109
msgid "我的美食日記"
msgstr "我的美食日記"

#: apps/dp-client/src/screens/diary/pages/my/pages/terms/index.tsx:44
msgid "我的美食日記使用條款"
msgstr "我的美食日記使用條款"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallSummary/index.tsx:145
#: apps/dp-client/src/screens/account/pages/profile/components/TaskWallEntry/index.tsx:43
msgid "我的點數"
msgstr "我的點數"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:244
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:260
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:329
#: apps/dp-client/src/screens/reservation/components/ReservationSuccessModal/index.tsx:108
#: apps/dp-client/src/screens/reservation/components/ReservationFailModal/index.tsx:64
#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:254
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:183
#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:21
#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:134
#: apps/dp-client/src/screens/home/pages/UserGift/hooks/useUserGiftData.ts:128
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:339
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:2085
#: apps/dp-client/src/screens/home/pages/Note/pages/editPhoto/index.tsx:359
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:632
#: apps/dp-client/src/screens/home/pages/Note/hooks/usePhotoSelection.ts:274
#: apps/dp-client/src/screens/home/pages/Home/components/FetCouponMigrationPopup/index.tsx:82
#: apps/dp-client/src/screens/diary/pages/note/index.tsx:501
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:386
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:482
#: apps/dp-client/src/screens/diary/components/content-warn-modal/index.tsx:63
#: apps/dp-client/src/screens/account/pages/order/index.tsx:298
#: apps/dp-client/src/components/Upload/index.tsx:344
#: apps/dp-business/src/pages/CouponVerification/components/VerificationErrorDialog.tsx:64
#: apps/dp-business/src/pages/BusinessStatus/index.tsx:197
#: apps/dp-admin/src/pages/org-tree/components/S9BlockModal/index.web.tsx:90
#: apps/dp-admin/src/pages/merchant/shop-detail/components/SharedTemplatesModal/index.web.tsx:72
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:51
msgid "我知道了"
msgstr "我知道了"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:141
msgid "我自己不小心核銷了套餐券怎麼辦？"
msgstr "我自己不小心核銷了套餐券怎麼辦？"

#: apps/dp-client/src/screens/satisfaction-feedback/SatisfactionPrompt.tsx:113
msgid "我覺得很好"
msgstr "我覺得很好"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageConditionTree/index.web.tsx:27
#: apps/dp-admin/src/pages/marketing/components/CombinedListForm/index.web.tsx:115
#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:228
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:209
#: apps/dp-admin/src/components/CombinationFilterForm/index.web.tsx:20
msgid "或"
msgstr "或"

#: apps/dp-client/src/screens/home/pages/LocationSelect/components/EmptyState.tsx:38
msgid "或換個搜尋詞試試～"
msgstr "或換個搜尋詞試試～"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:862
msgid "截圖失敗，請重試"
msgstr "截圖失敗，請重試"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/previewDownload.ts:224
msgid "截圖完成"
msgstr "截圖完成"

#: apps/dp-business/src/utils/download.ts:205
msgid "截圖生成失敗"
msgstr "截圖生成失敗"

#. placeholder {0}: b.format('M月D日 HH:mm:ss')
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:144
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:62
msgid "截止 {0}"
msgstr "截止 {0}"

#. placeholder {0}: dateB.format('M月D日 HH:mm:ss')
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:437
msgid "截止{0}"
msgstr "截止{0}"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:632
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:293
msgid "截止到"
msgstr "截止到"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:644
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:354
msgid "截止日期一定要大於銷售時間"
msgstr "截止日期一定要大於銷售時間"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:96
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:122
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:143
msgid "戶名"
msgstr "戶名"

#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:111
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:158
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:24
msgid "所在地"
msgstr "所在地"

#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:98
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:95
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:74
msgid "所屬一級"
msgstr "所屬一級"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:279
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:425
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:595
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:698
msgid "所屬一級品類"
msgstr "所屬一級品類"

#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:108
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:108
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:79
msgid "所屬二級"
msgstr "所屬二級"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:44
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:54
msgid "所屬品牌"
msgstr "所屬品牌"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:37
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:154
msgid "所屬商圈/夜市"
msgstr "所屬商圈/夜市"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:31
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:153
msgid "所屬商場"
msgstr "所屬商場"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:178
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:63
msgid "所屬城市"
msgstr "所屬城市"

#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupShopList/index.web.tsx:78
msgid "所屬店家名單"
msgstr "所屬店家名單"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2633
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:129
msgid "所屬活動"
msgstr "所屬活動"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:223
msgid "所屬第三方"
msgstr "所屬第三方"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:316
msgid "所屬節點"
msgstr "所屬節點"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1296
msgid "所有信息已完成 ({completedItems}/{totalItems})"
msgstr "所有資訊已完成 ({completedItems}/{totalItems})"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:192
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:490
msgid "所有品類"
msgstr "所有品類"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:473
msgid "所有品類表示不限制；部分品類可選擇一級或二級品類。"
msgstr "所有品類表示不限制；部分品類可選擇一級或二級品類。"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:214
msgid "所有商家"
msgstr "所有商家"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:103
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:107
msgid "所有商家類型"
msgstr "所有商家類型"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:139
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:143
msgid "所有城市行政區"
msgstr "所有城市行政區"

#. placeholder {0}: totalProbability.toFixed(2)
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:314
msgid "所有折扣規則的概率總和不能超過100%，當前總和：{0}%"
msgstr "所有折扣規則的機率總和不能超過100%，當前總和：{0}%"

#: apps/dp-business/src/components/PhotoUploader/hooks/useFileUpload.ts:290
msgid "所有文件上傳失敗，請重試"
msgstr "所有文件上傳失敗，請重試"

#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:100
msgid "所有方案均支援線上預訂功能"
msgstr "所有方案均支援線上預訂功能"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:384
msgid "所有日期可用"
msgstr "所有日期可用"

#: apps/dp-client/src/screens/diary/pages/my/utils.ts:41
#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:67
#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:72
#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:83
#: apps/dp-client/src/screens/diary/components/YearMonthPicker/index.tsx:47
#: apps/dp-client/src/screens/diary/components/MonthPicker/index.tsx:37
msgid "所有月份"
msgstr "所有月份"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1705
msgid "所有營業時段"
msgstr "所有營業時段"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:224
msgid "所有用戶"
msgstr "所有用戶"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:435
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:163
msgid "所有節假日可用"
msgstr "所有節假日可用"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/exchange/index.tsx:205
#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallSummary/index.tsx:111
#: apps/dp-client/src/configs/page-configs.tsx:1457
#: apps/dp-client/src/configs/page-configs.tsx:1458
msgid "所有紀錄"
msgstr "所有紀錄"

#: apps/dp-business/src/pages/UserManagement/index.tsx:740
#: apps/dp-business/src/pages/UserManagement/index.tsx:746
#: apps/dp-business/src/pages/UserManagement/index.tsx:770
#: apps/dp-business/src/pages/UserManagement/index.tsx:776
msgid "所有角色"
msgstr "所有角色"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1301
msgid "所有資訊已完善，可以申請上架了！"
msgstr "所有資訊已完整填寫，可以申請上架了！"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:418
msgid "所選任務中沒有分配給您的任務"
msgstr "所選任務中沒有分配給您的任務"

#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:250
msgid "所選內容中沒有可下架的評價或筆記"
msgstr "所選內容中沒有可下架的評價或筆記"

#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:203
msgid "所選內容均已在抽檢中，無需重複標記"
msgstr "所選內容均已在抽檢中，無需重複標記"

#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:460
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:577
msgid "所選品類均已停用"
msgstr "所選品類均已停用"

#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:711
msgid "所選商家類型與進駐主體類型不一致，請重新選擇"
msgstr "所選商家類型與進駐主體類型不一致，請重新選擇"

#. placeholder {0}: shopCount ?? 0
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:75
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:217
msgid "所選標籤下已有{0}家商家，停用後將從以上商家中移除所選標籤，請確認"
msgstr "所選標籤下已有{0}家商家，停用後將從以上商家中移除所選標籤，請確認"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:148
msgid "所選標籤已全部添加"
msgstr "所選標籤已全部添加"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:149
msgid "所選權益剩餘庫存：{stockLimit}，實際庫存不得超過此數量"
msgstr "所選權益剩餘庫存：{stockLimit}，實際庫存不得超過此數量"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:132
msgid "所選權益已無剩餘庫存，請更換權益"
msgstr "所選權益已無剩餘庫存，請更換權益"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:148
msgid "所選權益庫存不限時，可留空表示不限"
msgstr "所選權益庫存不限時，可留空表示不限"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:135
msgid "所選權益庫存有限，請填寫實際庫存"
msgstr "所選權益庫存有限，請填寫實際庫存"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:50
msgid "所選權益無券面額資訊，無法計算匯率"
msgstr "所選權益無券面額資訊，無法計算匯率"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:271
msgid "所選結算單的發票設置不一致，請重新整理列表後確認"
msgstr "所選結算單的發票設置不一致，請重新整理列表後確認"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:265
msgid "所選結算單須屬同一商家"
msgstr "所選結算單須屬同一商家"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:268
msgid "所選結算單須為同一幣種"
msgstr "所選結算單須為同一幣種"

#: apps/dp-admin/src/pages/org-tree/services/shopPathActions.ts:268
msgid "所選結算起點已不可用，請重新選擇"
msgstr "所選結算起點已不可用，請重新選擇"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:202
msgid "所選項目均不可作廢"
msgstr "所選項目均不可作廢"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1743
msgid "所選項目已掛接於本節點，無需變更"
msgstr "所選項目已掛接於本節點，無需變更"

#: apps/dp-admin/src/pages/resource-config/app-notice/services.ts:41
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:24
msgid "手動"
msgstr "手動"

#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:577
#: apps/dp-admin/src/pages/customer-service/components/AssignModal.web.tsx:84
msgid "手動分配"
msgstr "手動分配"

#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:130
msgid "手動創建"
msgstr "手動創建"

#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:498
msgid "手動創建人"
msgstr "手動創建人"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:224
msgid "手動建立"
msgstr "手動建立"

#: apps/dp-business/src/types/orderFilter.ts:166
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:407
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:656
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:853
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1516
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1188
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:232
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:835
msgid "手動接單"
msgstr "手動接單"

#: apps/dp-business/src/pages/AddStore/components/PoiConfirmModal.tsx:104
#: apps/dp-business/src/pages/AddStore/components/PoiConfirmModal.tsx:153
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:495
msgid "手動新增"
msgstr "手動新增"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:517
msgid "手動新增版本"
msgstr "手動新增版本"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/MemberListTab/index.web.tsx:92
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/MemberListTab/index.web.tsx:82
msgid "手動更新"
msgstr "手動更新"

#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:157
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:158
msgid "手動更新成功"
msgstr "手動更新成功"

#: apps/dp-business/src/pages/SimpleDashboard/components/ManualInputCard.tsx:73
#: apps/dp-business/src/pages/CouponVerification/index.tsx:824
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1036
msgid "手動輸入券碼"
msgstr "手動輸入券碼"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:237
msgid "手工發送消息"
msgstr "手工發送消息"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:343
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:85
#: apps/dp-admin/src/modules/constants/options.ts:127
msgid "手機"
msgstr "手機"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:718
msgid "手機條碼"
msgstr "手機條碼"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:101
msgid "手機與郵箱分屬兩帳號，提交並且審核通過後，系統會將郵箱帳號合併到手機號上；"
msgstr "手機與郵箱分屬兩帳號，提交並且審核通過後，系統會將郵箱帳號合併到手機號上；"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:218
msgid "手機與郵箱至少填寫一項"
msgstr "手機與郵箱至少填寫一項"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:986
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:66
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:48
#: apps/dp-admin/src/pages/report-center/services/apis.ts:576
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/UserInfoCard/index.web.tsx:42
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:122
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/OwnerInfo/index.web.tsx:65
#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:115
#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:195
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:77
#: apps/dp-admin/src/pages/customer-service/components/CreateTicketModal.web.tsx:112
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:297
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:132
msgid "手機號"
msgstr "手機號"

#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:125
msgid "手機號或用戶ID"
msgstr "手機號碼或用戶ID"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:452
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:678
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:82
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:81
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:260
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserInfoCard/index.web.tsx:76
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:326
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:219
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:128
#: apps/dp-admin/src/pages/merchant/audit-detail/components/LegalPerson/index.web.tsx:49
#: apps/dp-admin/src/pages/merchant/audit-detail/components/AccountInfo/index.web.tsx:51
#: apps/dp-admin/src/pages/marketing/services/groupImportConstants.ts:8
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:139
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:198
msgid "手機號碼"
msgstr "手機門號"

#: apps/dp-admin/src/pages/merchant/information-error/components/ErrorInfoSection/index.web.tsx:39
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/OriginalReviewSection/index.web.tsx:52
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/MerchantComplaintSection/index.web.tsx:66
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/AppealInfoSection/index.web.tsx:41
msgid "手機號碼已複製到剪貼簿"
msgstr "手機號碼已複製到剪貼簿"

#: apps/dp-business/src/pages/ChangePhone/index.tsx:43
msgid "手機號碼更新失敗"
msgstr "手機號碼更新失敗"

#: apps/dp-business/src/pages/ChangePhone/index.tsx:48
msgid "手機號碼更新失敗，請稍後重試"
msgstr "手機號碼更新失敗，請稍後重試"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:177
#: apps/dp-business/src/components/ForgotPassword/index.tsx:114
msgid "手機號碼格式不正確，請輸入有效的臺灣手機號"
msgstr "手機號碼格式不正確，請輸入有效的臺灣手機號"

#: apps/dp-business/src/pages/BindPhone/index.tsx:43
msgid "手機號碼綁定失敗"
msgstr "手機號碼綁定失敗"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:187
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:56
msgid "手機載具"
msgstr "手機載具"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:424
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:359
#: apps/dp-client/src/screens/bind/pages/phone-bind/index.tsx:118
#: apps/dp-client/src/screens/bind/pages/phone-bind/components/phone-bind-form/index.tsx:62
#: apps/dp-client/src/screens/account/pages/check-phone/bind-phone/index.tsx:78
#: apps/dp-business/src/pages/UserManagement/index.tsx:478
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:444
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:302
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1020
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1093
#: apps/dp-business/src/pages/AddUser/index.tsx:230
#: apps/dp-business/src/pages/AddUser/index.tsx:260
#: apps/dp-business/src/components/SetPassword/index.tsx:206
#: apps/dp-business/src/components/PhoneVerification/index.tsx:355
#: apps/dp-business/src/components/ForgotPassword/index.tsx:431
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:157
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:80
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:86
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:39
#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:95
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/columns/index.web.tsx:37
#: apps/dp-admin/src/pages/marketing/user-group-create/components/MemberPreviewPanel/index.web.tsx:80
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:177
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:304
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:62
msgid "手機門號"
msgstr "手機門號"

#. placeholder {0}: formatPhone(userProfile.phone)
#: apps/dp-business/src/pages/MyProfile/index.tsx:252
msgid "手機門號：{0}"
msgstr "手機門號：{0}"

#: apps/dp-business/src/utils/phoneValidation.ts:81
#: apps/dp-admin/src/utils/validation.ts:92
msgid "手機門號：0912345678 或 +886-912345678"
msgstr "手機門號：0912345678 或 +886-912345678"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:211
msgid "手機門號「{tok}」格式錯誤：{err}"
msgstr "手機門號「{tok}」格式錯誤：{err}"

#: apps/dp-business/src/pages/OrderList/index.tsx:842
msgid "手機門號/用戶ID/用戶信箱"
msgstr "手機門號/用戶ID/用戶信箱"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:252
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:181
msgid "手機門號已被綁定"
msgstr "手機門號已被綁定"

#: apps/dp-client/src/screens/login/pages/password-login/components/password-login-form/index.tsx:135
msgid "手機門號或郵箱"
msgstr "手機門號或郵箱"

#: apps/dp-client/src/screens/login/pages/password-login/index.tsx:62
#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:148
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:109
#: apps/dp-client/src/screens/bind/pages/phone-bind/index.tsx:69
#: apps/dp-business/src/pages/Login/index.tsx:345
#: apps/dp-business/src/components/PhoneVerification/index.tsx:121
#: apps/dp-business/src/components/PhoneVerification/index.tsx:164
#: apps/dp-business/src/components/PhoneVerification/index.tsx:206
#: apps/dp-business/src/components/PhoneVerification/index.tsx:207
#: apps/dp-business/src/components/PhoneVerification/index.tsx:371
msgid "手機門號格式不正確"
msgstr "手機門號格式不正確"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:421
msgid "手機門號格式不正確，請以 / 開頭，後接 7 位數字、大寫字母或特殊符號（.-+）"
msgstr "手機門號格式不正確，請以 / 開頭，後接 7 位數字、大寫字母或特殊符號（.-+）"

#: apps/dp-client/src/screens/account/pages/check-phone/bind-phone/index.tsx:42
#: apps/dp-client/src/screens/account/pages/check-phone/bind-phone/index.tsx:50
msgid "手機門號格式不正確，請輸入有效的臺灣手機門號"
msgstr "手機門號格式不正確，請輸入有效的臺灣手機門號"

#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:68
msgid "手機門號確認"
msgstr "手機門號確認"

#: apps/dp-business/src/pages/BindPhone/index.tsx:48
msgid "手機門號綁定失敗，請稍後重試"
msgstr "手機門號綁定失敗，請稍後重試"

#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:175
#: apps/dp-client/src/screens/account/pages/check-phone/verification-code/index.tsx:71
#: apps/dp-business/src/pages/BindPhone/index.tsx:35
msgid "手機門號綁定成功"
msgstr "手機門號綁定成功"

#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:29
msgid "手機驗證"
msgstr "手機驗證"

#: apps/dp-client/src/screens/account/pages/check-phone/index.tsx:92
msgid "手機驗證成功"
msgstr "手機驗證成功"

#: apps/dp-client/src/screens/account/pages/coupon/CouponScan/index.tsx:316
msgid "手電筒"
msgstr "手電筒"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:1251
#: apps/dp-client/src/screens/account/pages/profile/components/FunctionEntrySection/index.tsx:60
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:258
msgid "打卡"
msgstr "打卡"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:283
msgid "打卡中"
msgstr "打卡中"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:315
msgid "打卡失敗"
msgstr "打卡失敗"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:365
msgid "打卡成功"
msgstr "打卡成功"

#: apps/dp-client/src/screens/satisfaction-feedback/index.ts:88
msgid "打開StoreReview失敗"
msgstr "打開StoreReview失敗"

#: apps/dp-client/src/screens/home/pages/Note/constants/index.ts:27
msgid "打開相冊失敗"
msgstr "打開相簿失敗"

#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:121
msgid "批次"
msgstr "批次"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:233
#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:292
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:872
msgid "批次上傳"
msgstr "批次上傳"

#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:342
msgid "批次下架"
msgstr "批次下架"

#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:221
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:62
msgid "批次分配"
msgstr "批次分配"

#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:107
msgid "批次分配 BD"
msgstr "批次分配 BD"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchAssignModal/index.web.tsx:75
msgid "批次分配任務"
msgstr "批次分配任務"

#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchAssignModal/index.web.tsx:78
msgid "批次分配商家"
msgstr "批次分配商家"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:464
msgid "批次分配失敗"
msgstr "批次分配失敗"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:453
msgid "批次分配成功"
msgstr "批次分配成功"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:468
msgid "批次分配錯誤"
msgstr "批次分配錯誤"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:556
msgid "批次創建失敗"
msgstr "批次創建失敗"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:560
msgid "批次創建錯誤"
msgstr "批次創建錯誤"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:487
msgid "批次完成任務"
msgstr "批次完成任務"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:519
#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:523
msgid "批次完成任務失敗"
msgstr "批次完成任務失敗"

#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:232
msgid "批次完結"
msgstr "批次完結"

#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:243
msgid "批次建立"
msgstr "批次建立"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:207
msgid "批次建立任務"
msgstr "批次建立任務"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:161
msgid "批次建立任務模板.csv"
msgstr "批次建立任務模板.csv"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/index.web.tsx:198
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/index.web.tsx:196
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/apis.ts:132
msgid "批次操作"
msgstr "批次操作"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:743
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:748
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:558
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:563
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:302
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:306
msgid "批次操作失敗，請重試"
msgstr "批次操作失敗，請重試"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:54
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:43
msgid "批次新增"
msgstr "批次新增"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:349
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/RefreshHistoryTab/index.web.tsx:43
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/RefreshHistoryTab/index.web.tsx:43
msgid "批次號"
msgstr "批次號"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:4
msgid "批註"
msgstr "批註"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:117
#: apps/dp-admin/src/pages/marketing/services/constants.ts:216
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:100
#: apps/dp-admin/src/modules/constants/userGroup.ts:41
#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:368
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:355
msgid "批量上傳"
msgstr "批量上傳"

#: apps/dp-admin/src/components/ImageListUploader/index.web.tsx:236
msgid "批量上傳失敗，請重試"
msgstr "批量上傳失敗，請重試"

#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:461
msgid "批量上架"
msgstr "批量上架"

#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:469
msgid "批量下架"
msgstr "批量下架"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopActionButtons/index.web.tsx:64
msgid "批量下載ERP"
msgstr "批量下載ERP"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:47
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:549
msgid "批量下載ERP資料"
msgstr "批量下載ERP資料"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:338
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:686
#: apps/dp-admin/src/pages/marketing/activity-detail-list/index.web.tsx:307
msgid "批量不予中獎"
msgstr "批量不予中獎"

#. placeholder {0}: winnerIds.length
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchRejectWinnerModal.web.tsx:76
msgid "批量不予中獎 ({0})"
msgstr "批量不予中獎 ({0})"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/apis.ts:102
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchRejectWinnerModal.web.tsx:63
msgid "批量不予中獎失敗"
msgstr "批量不予中獎失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchRejectWinnerModal.web.tsx:59
msgid "批量不予中獎成功"
msgstr "批量不予中獎成功"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:451
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:467
#: apps/dp-admin/src/pages/marketing/benefit-management/components/VoidInventoryModal.web.tsx:54
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:356
msgid "批量作廢"
msgstr "批量作廢"

#: apps/dp-admin/src/pages/user-info/services/apis.ts:331
msgid "批量作廢失敗"
msgstr "批量作廢失敗"

#: apps/dp-admin/src/pages/user-info/services/apis.ts:331
msgid "批量作廢成功"
msgstr "批量作廢成功"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/index.web.tsx:76
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:225
#: apps/dp-admin/src/pages/resource-config/landing-page-list/index.web.tsx:70
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:166
#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:157
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:758
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:785
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/index.web.tsx:69
#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:149
msgid "批量停用"
msgstr "批量停用"

#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:485
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:605
msgid "批量停用失敗"
msgstr "批量停用失敗"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:107
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:480
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:598
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:228
msgid "批量停用成功"
msgstr "批量停用成功"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:584
msgid "批量儲存"
msgstr "批量儲存"

#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:534
msgid "批量入駐"
msgstr "批量入駐"

#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:187
msgid "批量分配將會覆蓋所選 {itemTypeName} 的當前跟進人，請確認後再進行操作。"
msgstr "批量分配將會覆蓋所選 {itemTypeName} 的當前跟進人，請確認後再進行操作。"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageCouponPicker/index.web.tsx:238
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:341
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/index.web.tsx:72
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:364
msgid "批量刪除"
msgstr "批量刪除"

#. placeholder {0}: selectedCodeIds.length
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:367
msgid "批量刪除（{0}）"
msgstr "批量刪除（{0}）"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:241
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:261
msgid "批量刪除商家失敗"
msgstr "批量刪除商家失敗"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:39
msgid "批量匯入失敗"
msgstr "批量匯入失敗"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:46
msgid "批量匯入完成"
msgstr "批量匯入完成"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:43
msgid "批量匯入已取消"
msgstr "批量匯入已取消"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:45
msgid "批量匯入處理中"
msgstr "批量匯入處理中"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:41
msgid "批量匯入部分成功"
msgstr "批量匯入部分成功"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:343
msgid "批量匯出"
msgstr "批量匯出"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:347
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:692
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchCancelRejectWinnerModal.web.tsx:40
msgid "批量取消不予中獎"
msgstr "批量取消不予中獎"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/apis.ts:123
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchCancelRejectWinnerModal.web.tsx:32
msgid "批量取消不予中獎失敗"
msgstr "批量取消不予中獎失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchCancelRejectWinnerModal.web.tsx:29
msgid "批量取消不予中獎成功"
msgstr "批量取消不予中獎成功"

#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:129
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:144
msgid "批量審核失敗"
msgstr "批量審核失敗"

#. placeholder {0}: result.approvedCount
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:139
msgid "批量審核成功：通過 {0} 筆"
msgstr "批量審核成功：通過 {0} 筆"

#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:18
msgid "批量導入"
msgstr "批量導入"

#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:145
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:437
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:451
msgid "批量導出"
msgstr "批量導出"

#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:171
msgid "批量導出名單"
msgstr "批量導出名單"

#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:352
msgid "批量導出失敗"
msgstr "批量導出失敗"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:349
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:444
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:318
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:460
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:349
#: apps/dp-admin/src/pages/marketing/benefit-management/components/ExtendInventoryModal.web.tsx:65
msgid "批量延期"
msgstr "批量延期"

#: apps/dp-admin/src/pages/user-info/services/apis.ts:315
msgid "批量延期失敗"
msgstr "批量延期失敗"

#: apps/dp-admin/src/pages/user-info/services/apis.ts:315
msgid "批量延期成功"
msgstr "批量延期成功"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:522
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:413
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:527
msgid "批量拒絕"
msgstr "批量拒絕"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:199
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:204
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:142
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:147
msgid "批量拒絕失敗"
msgstr "批量拒絕失敗"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:139
msgid "批量拒絕成功"
msgstr "批量拒絕成功"

#. placeholder {0}: result.successCount
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:195
msgid "批量拒絕成功，共處理 {0} 條記錄"
msgstr "批量拒絕成功，共處理 {0} 條記錄"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedMallTable/index.web.tsx:159
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:81
msgid "批量掛接商場／商圈"
msgstr "批量掛接商場／商圈"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:318
msgid "批量掛接店家"
msgstr "批量掛接店家"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:96
msgid "批量掛載店家"
msgstr "批量掛載店家"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopActionButtons/index.web.tsx:111
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:560
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:396
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:411
msgid "批量操作"
msgstr "批量操作"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:734
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:545
msgid "批量操作成功！"
msgstr "批量操作成功！"

#. placeholder {0}: result.successCount ?? 0
#. placeholder {1}: result.totalCount ?? 0
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:294
msgid "批量操作成功！成功 {0} / {1}"
msgstr "批量操作成功！成功 {0} / {1}"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/index.web.tsx:69
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:225
#: apps/dp-admin/src/pages/resource-config/landing-page-list/index.web.tsx:63
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:166
#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:150
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/index.web.tsx:64
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:354
#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:148
msgid "批量啟用"
msgstr "批量啟用"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:107
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:182
msgid "批量啟用成功"
msgstr "批量啟用成功"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopActionButtons/index.web.tsx:50
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:368
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/index.web.tsx:154
msgid "批量新增"
msgstr "批量新增"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:543
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:569
msgid "批量新增二級品類"
msgstr "批量新增二級品類"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:179
msgid "批量新增結果"
msgstr "批量新增結果"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/AddShopModal/index.web.tsx:73
msgid "批量新增關聯店家"
msgstr "批量新增關聯店家"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/apis.ts:163
msgid "批量更新用戶狀態失敗"
msgstr "批量更新用戶狀態失敗"

#: apps/dp-business/src/servers/reservation/api.ts:740
msgid "批量查詢庫存失敗"
msgstr "批量查詢庫存失敗"

#: apps/dp-admin/src/pages/user-info/services/apis.ts:299
msgid "批量核銷失敗"
msgstr "批量核銷失敗"

#: apps/dp-admin/src/pages/user-info/services/apis.ts:299
msgid "批量核銷成功"
msgstr "批量核銷成功"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:364
msgid "批量添加"
msgstr "批量添加"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopActionButtons/index.web.tsx:79
msgid "批量生成圖片任務"
msgstr "批量生成圖片任務"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopActionButtons/index.web.tsx:74
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:571
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:105
msgid "批量生成菜單"
msgstr "批量生成菜單"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:445
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:492
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:363
msgid "批量確認"
msgstr "批量確認"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:357
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:699
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchConfirmWinnerModal.web.tsx:44
msgid "批量確認中獎"
msgstr "批量確認中獎"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/apis.ts:144
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchConfirmWinnerModal.web.tsx:36
msgid "批量確認中獎失敗"
msgstr "批量確認中獎失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchConfirmWinnerModal.web.tsx:33
msgid "批量確認中獎成功"
msgstr "批量確認中獎成功"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:150
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:155
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:98
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:103
msgid "批量確認失敗"
msgstr "批量確認失敗"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:95
msgid "批量確認成功"
msgstr "批量確認成功"

#. placeholder {0}: result.successCount
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:146
msgid "批量確認成功，共處理 {0} 條記錄"
msgstr "批量確認成功，共處理 {0} 條記錄"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/index.web.tsx:131
msgid "批量移除"
msgstr "批量移除"

#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:544
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:384
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:66
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:83
msgid "批量簽約"
msgstr "批量簽約"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopActionButtons/index.web.tsx:59
msgid "批量簽約藍新"
msgstr "批量簽約藍新"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopActionButtons/index.web.tsx:90
msgid "批量綁定商家"
msgstr "批量綁定商家"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:348
#: apps/dp-business/src/pages/UserManagement/BatchCopyUsers.tsx:119
msgid "批量複製使用者資訊"
msgstr "批量複製使用者資訊"

#: apps/dp-business/src/pages/UserManagement/BatchCopyUsers.tsx:98
#: apps/dp-business/src/pages/UserManagement/BatchCopyUsers.tsx:104
msgid "批量複製失敗"
msgstr "批量複製失敗"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:491
#: apps/dp-business/src/components/StoreInfoCard/index.tsx:787
msgid "批量複製資訊"
msgstr "批量複製資訊"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopActionButtons/index.web.tsx:69
msgid "批量設置店家資訊"
msgstr "批量設置店家資訊"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/index.web.tsx:123
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/UpdateLocationModal/index.web.tsx:81
msgid "批量設置樓層/位置"
msgstr "批量設置樓層/位置"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1216
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1238
msgid "批量退款券碼"
msgstr "批量退款券碼"

#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:458
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:497
#: apps/dp-admin/src/pages/audit-center/claim-audit/index.web.tsx:188
msgid "批量通過"
msgstr "批量通過"

#. placeholder {0}: approvableRows.length
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:352
msgid "批量通過（{0}）"
msgstr "批量通過（{0}）"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueDetailTab.web.tsx:109
msgid "批量重新回傳"
msgstr "批量重新回傳"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueDetailTab.web.tsx:116
msgid "批量重新發放"
msgstr "批量重新發放"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:456
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/index.web.tsx:79
msgid "批量重試"
msgstr "批量重試"

#: apps/dp-client/src/screens/diary/pages/search/index.tsx:37
msgid "找不到你要的餐廳嗎？ 可以用"
msgstr "找不到你要的餐廳嗎？ 可以用"

#: apps/dp-client/src/screens/account/pages/user-profile/components/ReviewList/index.tsx:211
#: apps/dp-client/src/screens/account/pages/user-profile/components/NoteList/index.tsx:208
msgid "找不到內容"
msgstr "找不到內容"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:89
msgid "找不到本次變更所依據的原版本資料，無法標出具體改動。"
msgstr "找不到本次變更所依據的原版本資料，無法標出具體改動。"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:349
msgid "找不到相關店家"
msgstr "找不到相關店家"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:181
#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:95
#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:706
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:267
#: apps/dp-client/src/screens/account/pages/user-profile/components/ReviewList/index.tsx:208
#: apps/dp-client/src/screens/account/pages/user-profile/components/NoteList/index.tsx:205
#: apps/dp-client/src/screens/account/pages/profile/components/MyReviewsContent/index.tsx:186
#: apps/dp-client/src/screens/account/pages/profile/components/ContentTabsSection/UserNoteSection.tsx:222
#: apps/dp-client/src/screens/account/pages/notifications/pages/likes/index.tsx:185
#: apps/dp-client/src/screens/account/pages/notifications/pages/follow/index.tsx:212
#: apps/dp-client/src/screens/account/pages/notifications/pages/comments/index.tsx:196
#: apps/dp-client/src/screens/account/pages/notifications/pages/CategoryNotifications/index.tsx:181
#: apps/dp-client/src/screens/account/pages/likes/components/NotesContent/index.tsx:189
#: apps/dp-client/src/screens/account/pages/favorites/components/ShopContent/index.tsx:164
#: apps/dp-client/src/screens/account/pages/favorites/components/NotesContent/index.tsx:128
msgid "找不到符合的內容"
msgstr "找不到符合的內容"

#: apps/dp-client/src/screens/diary/pages/my/components/MyDiaryContent.tsx:320
msgid "找不到符合的日記喔!"
msgstr "找不到符合的日記喔!"

#: apps/dp-client/src/screens/diary/pages/plaza/index.tsx:311
msgid "找不到符合的日記喔！"
msgstr "找不到符合的日記喔！"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:184
msgid "找不到符合的訂位"
msgstr "找不到符合的訂位"

#: apps/dp-client/src/screens/diary/pages/search/index.tsx:255
#: apps/dp-client/src/screens/diary/pages/search/index.tsx:265
msgid "找不到符合要求的餐廳"
msgstr "找不到符合要求的餐廳"

#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:326
msgid "找不到這個地址"
msgstr "找不到這個地址"

#: apps/dp-client/src/screens/home/pages/LocationSelect/components/EmptyState.tsx:32
msgid "找不到這個地點"
msgstr "找不到這個地點"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1768
msgid "找其他菜品"
msgstr "找其他菜品"

#. placeholder {0}: dishList.length
#: apps/dp-client/src/screens/home/pages/Purchase/components/SelectDishContent/index.tsx:401
msgid "找到 {0} 個結果"
msgstr "找到 {0} 個結果"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:118
msgid "技術對接人"
msgstr "技術對接人"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:362
msgid "投訴原因"
msgstr "投訴原因"

#: apps/dp-business/src/pages/ComplaintList/index.tsx:389
msgid "投訴成立"
msgstr "投訴成立"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:388
msgid "投訴描述"
msgstr "投訴描述"

#: apps/dp-business/src/pages/ComplaintList/index.tsx:191
msgid "投訴描述："
msgstr "投訴描述："

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:210
msgid "投訴描述不能超過1000個字"
msgstr "投訴描述不能超過1000個字"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:208
msgid "投訴描述至少需要10個字"
msgstr "投訴描述至少需要10個字"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:272
msgid "投訴提交成功，我們會盡快處理"
msgstr "投訴上傳成功，我們會盡快處理"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:54
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:54
msgid "投訴提醒"
msgstr "投訴提醒"

#: apps/dp-business/src/pages/ComplaintList/index.tsx:413
msgid "投訴未通過"
msgstr "投訴未通過"

#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:23
#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:68
msgid "投訴處理"
msgstr "投訴處理"

#: apps/dp-business/src/utils/permissionData.ts:92
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:310
msgid "投訴評價"
msgstr "投訴評價"

#. placeholder {0}: formData.reason
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:244
msgid "投訴評價 - {0}"
msgstr "投訴評價 - {0}"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:355
msgid "投訴資訊"
msgstr "投訴資訊"

#: apps/dp-business/src/pages/ComplaintList/index.tsx:181
msgid "投訴類型："
msgstr "投訴類型："

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:353
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:128
msgid "投遞內容"
msgstr "投遞內容"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:271
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:386
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:161
msgid "投遞時間"
msgstr "投遞時間"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:255
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:345
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:43
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:120
msgid "投遞渠道"
msgstr "投遞渠道"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:263
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:365
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:53
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:140
msgid "投遞狀態"
msgstr "投遞狀態"

#: apps/dp-client/src/components/DiscountBadge/index.tsx:107
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:436
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:58
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:249
msgid "折"
msgstr "折"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:16
#: apps/dp-admin/src/pages/marketing/services/constants.ts:17
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:278
#: apps/dp-admin/src/modules/constants/options.ts:219
msgid "折價券"
msgstr "折價券"

#: apps/dp-business/src/pages/MarketingCenter/components/PreviewCard.tsx:64
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:352
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/packageCouponColumns.web.tsx:44
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:183
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:28
msgid "折扣"
msgstr "折扣"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:236
msgid "折扣：-"
msgstr "折扣：-"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:236
msgid "折扣：{discount} 折"
msgstr "折扣：{discount} 折"

#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:537
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:474
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:69
msgid "折扣上限"
msgstr "折扣上限"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:154
msgid "折扣上限不能小於 0"
msgstr "折扣上限不能小於 0"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:146
msgid "折扣上限不能為空"
msgstr "折扣上限不能為空"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:150
msgid "折扣上限僅支援大於等於 0 的數字"
msgstr "折扣上限僅支援大於等於 0 的數字"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:155
msgid "折扣上限最多一位小數"
msgstr "折扣上限最多一位小數"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:146
msgid "折扣上限必須為大於等於 0 的數字，最多一位小數"
msgstr "折扣上限必須為大於等於 0 的數字，最多一位小數"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:66
msgid "折扣最大"
msgstr "折扣最大"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1537
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/SubsidyCard.tsx:101
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:40
msgid "折扣券"
msgstr "折扣券"

#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:246
msgid "折扣券ID"
msgstr "折扣券ID"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:403
msgid "折扣券名稱"
msgstr "折扣券名稱"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:397
msgid "折扣券基本資訊"
msgstr "折扣券基本資訊"

#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:411
msgid "折扣券明細"
msgstr "折扣券明細"

#. placeholder {0}: new Date().toISOString().slice(0, 19).replace(/:/g, '-')
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:123
msgid "折扣券訂單明細_{0}.xlsx"
msgstr "折扣券訂單明細_{0}.xlsx"

#: apps/dp-business/src/configs/page-configs.ts:1111
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:457
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:297
msgid "折扣券詳情"
msgstr "折扣券詳情"

#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:438
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:165
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:284
msgid "折扣券資訊"
msgstr "折扣券資訊"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:365
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:345
msgid "折扣力度"
msgstr "折扣力度"

#: apps/dp-admin/src/modules/constants/merchantStatus.ts:114
msgid "折扣合約"
msgstr "折扣合約"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:9
#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:22
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/constants.ts:74
#: apps/dp-admin/src/pages/resource-config/components/ContentFilterSelector/index.web.tsx:12
msgid "折扣數"
msgstr "折扣數"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:690
msgid "折扣有效時間區間"
msgstr "折扣有效時間區間"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:637
msgid "折扣有效期類型"
msgstr "折扣有效期類型"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:246
msgid "折扣比例"
msgstr "折扣比例"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:482
msgid "折扣說明"
msgstr "折扣說明"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:455
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:520
msgid "折扣資訊"
msgstr "折扣資訊"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:797
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:611
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:120
msgid "折扣金額"
msgstr "折扣金額"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:438
msgid "折扣金額上限："
msgstr "折扣金額上限："

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:524
msgid "折扣金額上限（大於0的整數）"
msgstr "折扣金額上限（大於0的整數）"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:147
msgid "折扣類型"
msgstr "折扣類型"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:748
msgid "折抵！"
msgstr "折抵！"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:108
msgid "折讓中"
msgstr "折讓中"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:103
#: apps/dp-admin/src/pages/split-account/services/constants.ts:259
msgid "折讓失敗"
msgstr "折讓失敗"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/InvoiceInfoCard/index.web.tsx:68
msgid "折讓金額"
msgstr "折讓金額"

#: apps/dp-business/src/data/categories.ts:107
msgid "披薩"
msgstr "披薩"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:142
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:256
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:204
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:200
msgid "抬頭名稱"
msgstr "抬頭名稱"

#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:102
msgid "抬頭地址更新成功"
msgstr "抬頭地址更新成功"

#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:292
msgid "抬頭資訊"
msgstr "抬頭資訊"

#: apps/dp-client/src/screens/reservation/utils/index.ts:117
msgid "抱歉，店家無法接單，再試試其他時段吧"
msgstr "抱歉，店家無法接單，再試試其他時段吧"

#: apps/dp-admin/src/pages/error/404.web.tsx:72
msgid "抱歉，您存取的頁面不存在"
msgstr "抱歉，您存取的頁面不存在"

#: apps/dp-business/src/components/ErrorPage/index.tsx:61
msgid "抱歉，頁面遇到了一些問題，請嘗試重新整理頁面"
msgstr "抱歉，頁面遇到了一些問題，請嘗試重新整理頁面"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2622
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:122
msgid "抵扣金額"
msgstr "抵扣金額"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:53
#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:197
#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:218
msgid "抽檢中"
msgstr "抽檢中"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:236
msgid "抽獎失敗"
msgstr "抽獎失敗"

#. placeholder {0}: result.actualWinnerCount
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:231
msgid "抽獎完成，實際中獎 {0} 人"
msgstr "抽獎完成，實際中獎 {0} 人"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryUserDrawHistoryModal.web.tsx:75
msgid "抽獎批次ID"
msgstr "抽獎批次ID"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:595
msgid "抽獎方式"
msgstr "抽獎方式"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryUserDrawHistoryModal.web.tsx:77
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryUserDrawHistoryModal.web.tsx:123
msgid "抽獎時間"
msgstr "抽獎時間"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:362
msgid "抽獎次數"
msgstr "抽獎次數"

#: apps/dp-client/src/screens/home/pages/ShareKing/components/WinningList/index.tsx:175
msgid "抽獎正在進行中"
msgstr "抽獎正在進行中"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:516
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryUserDrawHistoryModal.web.tsx:114
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:488
msgid "抽獎歷史"
msgstr "抽獎歷史"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:108
msgid "抽獎活動"
msgstr "抽獎活動"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:601
msgid "抽獎狀態"
msgstr "抽獎狀態"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:427
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:607
msgid "抽獎結果"
msgstr "抽獎結果"

#: apps/dp-admin/src/router/config/routes.web.tsx:519
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:599
msgid "拆帳管理"
msgstr "拆帳管理"

#: apps/dp-business/src/data/categories.ts:168
msgid "拉麵"
msgstr "拉麵"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:35
msgid "拍出店內空間與裝潢"
msgstr "拍出店內空間與裝潢"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:1151
#: apps/dp-client/src/configs/page-configs.tsx:713
msgid "拍照"
msgstr "拍照"

#: apps/dp-client/src/screens/home/pages/Note/constants/index.ts:24
msgid "拍照失敗"
msgstr "拍照失敗"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:124
msgid "拐角半徑"
msgstr "拐角半徑"

#: apps/dp-business/src/store/NotificationContext.tsx:658
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:59
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:137
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:739
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:171
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:281
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:530
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:314
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:421
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:299
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/ImageAuditItem/index.web.tsx:90
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:535
msgid "拒絕"
msgstr "拒絕"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:166
msgid "拒絕 處罰期"
msgstr "拒絕 處罰期"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:286
#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:157
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:523
#: apps/dp-admin/src/pages/merchant/audit-detail/components/SystemInfo/index.web.tsx:62
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:537
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:427
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:315
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:542
msgid "拒絕原因"
msgstr "拒絕原因"

#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:161
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:527
msgid "拒絕原因不能超過 200 個字元"
msgstr "拒絕原因不能超過 200 個字元"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:540
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:430
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:545
msgid "拒絕原因不能超過 500 個字元"
msgstr "拒絕原因不能超過 500 個字元"

#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:160
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:526
msgid "拒絕原因至少需要 5 個字元"
msgstr "拒絕原因至少需要 5 個字元"

#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:145
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:511
msgid "拒絕審批"
msgstr "拒絕審批"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:108
msgid "拒絕的店家"
msgstr "拒絕的店家"

#: apps/dp-business/src/servers/permission/api.ts:692
msgid "拒絕臨時帳號申請失敗"
msgstr "拒絕臨時帳號申請失敗"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:282
msgid "拒絕訂單"
msgstr "拒絕訂單"

#: apps/dp-business/src/servers/reservation/api.ts:881
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:327
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:334
msgid "拒絕訂單失敗"
msgstr "拒絕訂單失敗"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:785
msgid "拖拽中..."
msgstr "拖拽中..."

#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:238
#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:106
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageItem/index.web.tsx:96
#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:130
msgid "拖拽排序"
msgstr "拖拽排序"

#: apps/dp-business/src/components/GoogleMap/index.tsx:603
msgid "拖曳"
msgstr "拖曳"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/types.ts:131
msgid "招牌川拌套餐"
msgstr "招牌川拌套餐"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:59
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:60
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:279
msgid "招牌牛肉麵"
msgstr "招牌牛肉麵"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:414
#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:714
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/SignatureDishes/SignatureDishesPage.tsx:117
#: apps/dp-client/src/screens/home/pages/ShopDetail/constants/index.ts:8
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopDishGallery.tsx:87
#: apps/dp-client/src/configs/page-configs.tsx:183
msgid "招牌菜"
msgstr "招牌菜"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:333
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:341
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:576
msgid "指定位置"
msgstr "指定位置"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListUrlSync.ts:93
#: apps/dp-client/src/screens/home/components/ShopFilter/components/LocationSelector.tsx:98
#: apps/dp-client/src/screens/home/components/ShopFilter/components/CascaderFilterContent.tsx:264
msgid "指定地點"
msgstr "指定地點"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1740
msgid "指定星期使用"
msgstr "指定星期使用"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1422
msgid "指定星期使用（限制在營業星期內選擇）"
msgstr "指定星期使用（限制在營業星期內選擇）"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:744
msgid "指定時間生效"
msgstr "指定時間生效"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:67
msgid "指定時間範圍"
msgstr "指定時間範圍"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:138
msgid "指定用戶發放"
msgstr "指定用戶發放"

#. placeholder {0}: record.operationValue
#. placeholder {0}: benefit.operationValue
#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:64
#: apps/dp-admin/src/pages/transaction/service-management/services/commission-format.ts:23
msgid "指定費率 {0}%"
msgstr "指定費率 {0}%"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:409
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:535
msgid "指定類別"
msgstr "指定類別"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:397
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:523
msgid "指定餐點"
msgstr "指定餐點"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/CorrectionModal.tsx:206
msgid "指路描述"
msgstr "指路描述"

#. placeholder {0}: formatUnit(timeRange.unit)
#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:131
msgid "按{0}頻次"
msgstr "按{0}頻次"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:152
msgid "按最新版本重試"
msgstr "按最新版本重試"

#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:118
msgid "按審核完成時間篩選，審核中的單據不會命中"
msgstr "按審核完成時間篩選，審核中的單據不會命中"

#: apps/dp-admin/src/modules/constants/options.ts:220
msgid "按比例折扣"
msgstr "按比例折扣"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ManualPackageFields/index.web.tsx:55
msgid "按當前商品重新固化全部套餐名單"
msgstr "按當前商品重新固化全部套餐名單"

#. placeholder {0}: noteDetail?.id
#. placeholder {1}: noteDetail?.title
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:426
msgid "按讚_{0}_{1}"
msgstr "按讚_{0}_{1}"

#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:157
#: apps/dp-client/src/configs/page-configs.tsx:1695
#: apps/dp-client/src/configs/page-configs.tsx:1697
msgid "按讚和收藏"
msgstr "按讚和收藏"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:391
#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:467
msgid "按讚成功"
msgstr "按讚成功"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:470
msgid "按讚操作失敗"
msgstr "按讚操作失敗"

#: apps/dp-admin/src/pages/users/permissions/components/PermissionTreeTable/index.web.tsx:50
msgid "按鈕"
msgstr "按鈕"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:111
msgid "按鈕名稱"
msgstr "按鈕名稱"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:146
msgid "按鈕名稱：顯示在介面上的按鈕文字"
msgstr "按鈕名稱：顯示在介面上的按鈕文字"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:524
msgid "按鈕文字"
msgstr "按鈕文字"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:50
msgid "按鈕權限設定"
msgstr "按鈕權限設定"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:170
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:50
msgid "捐贈"
msgstr "捐贈"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:766
msgid "捐贈機構"
msgstr "捐贈機構"

#: apps/dp-client/src/screens/account/pages/invoice/components/InvoiceProfileCard/index.tsx:47
msgid "捐贈發票"
msgstr "捐贈發票"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/index.tsx:964
msgid "捨棄"
msgstr "捨棄"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:329
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:666
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:171
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/rawDataMapper.ts:186
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:184
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:337
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:490
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:570
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:206
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:585
#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:243
#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:426
msgid "捷運"
msgstr "捷運"

#: apps/dp-client/src/screens/diary/components/TrafficExampleModal.tsx:65
msgid "捷運：出站後往右前方步行約 3分鐘，過十字路口後抵達百貨公司，由正門進入百貨公司，出電梯往右走，第一個路口左轉，即可看見 AA 泰式料理"
msgstr "捷運：出站後往右前方步行約 3分鐘，過十字路口後抵達百貨公司，由正門進入百貨公司，出電梯往右走，第一個路口左轉，即可看見 AA 泰式料理"

#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:377
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:132
msgid "捷運出入口"
msgstr "捷運出入口"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:33
msgid "捷運到店"
msgstr "捷運到店"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:478
#: apps/dp-business/src/components/MaintenanceList/index.tsx:1043
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:253
msgid "捷運指引"
msgstr "捷運指引"

#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:371
#: apps/dp-admin/src/pages/merchant/components/MetroStationExitSelector/index.web.tsx:51
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:126
msgid "捷運站"
msgstr "捷運站"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:391
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:71
msgid "捷運站出口處，指示牌顯示「大熊美食餐廳由此出」，旁邊有小熊指示箭頭。"
msgstr "捷運站出口處，指示牌顯示「大熊美食餐廳由此出」，旁邊有小熊指示箭頭。"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:187
msgid "捷運站及出口"
msgstr "捷運站及出口"

#: apps/dp-admin/src/modules/hooks/options/useMetroStationOptions.ts:59
msgid "捷運站選項資料取得失敗"
msgstr "捷運站選項資料取得失敗"

#: apps/dp-business/src/pages/SimpleDashboard/components/ScanCard.tsx:55
#: apps/dp-business/src/pages/SimpleDashboard/components/ScanCard.tsx:113
msgid "掃描 QRCode 核銷"
msgstr "掃描 QRCode 核銷"

#: apps/dp-client/src/screens/account/pages/coupon/CouponScan/index.tsx:205
msgid "掃描QR Code"
msgstr "掃描QR Code"

#: apps/dp-business/src/pages/MarketingCenter/components/RedemptionRulesCard.tsx:77
#: apps/dp-business/src/pages/CouponVerification/index.tsx:789
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:999
msgid "掃描QRCode核銷"
msgstr "掃描QRCode核銷"

#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:329
msgid "掃描中..."
msgstr "掃描中..."

#: apps/dp-client/src/configs/page-configs.tsx:2490
msgid "掃描優惠券"
msgstr "掃描優惠券"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/ScanQrCodeModal.web.tsx:46
msgid "掃描後進入領券流程"
msgstr "掃描後進入領券流程"

#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:200
#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:364
#: apps/dp-business/src/hooks/useQRScanner.ts:141
msgid "掃描逾時，請重試"
msgstr "掃描逾時，請重試"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:113
msgid "掃碼活動"
msgstr "掃碼活動"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/ScanQrCodeModal.web.tsx:76
msgid "掃碼網址"
msgstr "掃碼網址"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:808
msgid "授予權限"
msgstr "授予權限"

#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:65
msgid "授權"
msgstr "授權"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:101
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:146
msgid "授權範圍"
msgstr "授權範圍"

#: apps/dp-client/src/screens/home/pages/Ranking/DishRank/components/CustomHeader/index.tsx:60
msgid "排名規則"
msgstr "排名規則"

#: apps/dp-business/src/pages/MenuManagement.tsx:1170
#: apps/dp-business/src/pages/MenuManagement.tsx:1245
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeColumns.web.tsx:48
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:174
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:118
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:243
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:233
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:66
msgid "排序"
msgstr "排序"

#: apps/dp-business/src/pages/MenuManagement.tsx:910
#: apps/dp-business/src/pages/MenuManagement.tsx:956
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuCategorySection/index.web.tsx:121
#: apps/dp-admin/src/pages/merchant/components/MenuCategorySection/index.web.tsx:108
msgid "排序已更新"
msgstr "排序已更新"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:158
msgid "排序規則"
msgstr "排序規則"

#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:90
msgid "排序順序"
msgstr "排序順序"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:62
msgid "排數"
msgstr "排數"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/searchConfig.ts:38
msgid "排行對象"
msgstr "排行對象"

#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/index.tsx:409
#: apps/dp-client/src/configs/main-config.tsx:152
#: apps/dp-client/src/configs/main-config.tsx:153
msgid "排行榜"
msgstr "排行榜"

#: apps/dp-client/src/screens/diary/pages/no-access/index.tsx:135
msgid "排行榜公告"
msgstr "排行榜公告"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:347
msgid "排行榜前100名 可抽iPhone17"
msgstr "排行榜前100名 可抽iPhone17"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:159
msgid "排行榜未更新"
msgstr "排行榜未更新"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:472
msgid "排行榜發布失敗"
msgstr "排行榜發布失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:466
msgid "排行榜發布成功"
msgstr "排行榜發布成功"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:83
msgid "排行榜預覽"
msgstr "排行榜預覽"

#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewEditorToolbar.tsx:27
msgid "排隊"
msgstr "排隊"

#: apps/dp-admin/src/pages/marketing/services/interface/batchTask.ts:30
msgid "排隊中"
msgstr "排隊中"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:43
#: apps/dp-client/src/components/RefundResonModal/index.tsx:28
msgid "排隊太久"
msgstr "排隊太久"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:46
msgid "掛接位置"
msgstr "掛接位置"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedMallTable/index.web.tsx:126
msgid "掛接商場／商圈"
msgstr "掛接商場／商圈"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:248
#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:53
msgid "掛接店家"
msgstr "掛接店家"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:146
msgid "掛接成功"
msgstr "掛接成功"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:139
msgid "掛接路徑"
msgstr "掛接路徑"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:187
msgid "掛載簽約商家"
msgstr "掛載簽約商家"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:198
msgid "掛載請款商家"
msgstr "掛載請款商家"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:337
msgid "掛鉤"
msgstr "掛鉤"

#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:50
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:129
msgid "接受"
msgstr "接受"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:38
msgid "接受NFC支付"
msgstr "接受NFC支付"

#: apps/dp-admin/src/components/OperationLogDetailModal/index.web.tsx:66
msgid "接受的資料"
msgstr "接受的資料"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:39
msgid "接受金融卡"
msgstr "接受金融卡"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:110
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:98
msgid "接口白名單"
msgstr "接口白名單"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:353
msgid "接口返回"
msgstr "接口返回"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:105
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:192
msgid "接單"
msgstr "接單"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1194
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1999
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1185
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:289
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:162
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:936
msgid "接單方式"
msgstr "接單方式"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:403
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:653
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:850
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1487
msgid "接單模式"
msgstr "接單模式"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1543
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1622
msgid "接單率"
msgstr "接單率"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1174
msgid "接單詳情"
msgstr "接單詳情"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1818
#: apps/dp-business/src/pages/OrderOverview/FilterModal.tsx:40
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1145
msgid "接單類型"
msgstr "接單類型"

#: apps/dp-client/src/utils/sso.ts:258
#: apps/dp-client/src/utils/sso.ts:280
msgid "接收到無效的資料格式"
msgstr "接收到無效的資料格式"

#: apps/dp-business/src/pages/VerifyPhone/index.tsx:125
#: apps/dp-business/src/pages/VerifyEmail/index.tsx:126
msgid "接收驗證碼"
msgstr "接收驗證碼"

#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:488
msgid "推"
msgstr "推"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:432
msgid "推廣圖"
msgstr "推廣圖"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:132
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:45
msgid "推廣活動"
msgstr "推廣活動"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:75
msgid "推播未收到"
msgstr "推播未收到"

#: apps/dp-client/src/utils/format.ts:75
#: apps/dp-client/src/screens/home/utils/utils.ts:36
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:40
#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:8
#: apps/dp-client/src/screens/home/pages/Note/utils/index.ts:5
#: apps/dp-client/src/screens/home/pages/Home/index.tsx:231
#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:56
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:53
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/constants.ts:75
#: apps/dp-admin/src/pages/resource-config/components/ContentFilterSelector/index.web.tsx:11
msgid "推薦"
msgstr "推薦"

#. placeholder {0}: marketing.marketingName
#. placeholder {1}: index + 1
#: apps/dp-client/src/screens/home/pages/Home/components/RecommendMasonryList/index.tsx:435
msgid "推薦_{0}_{1}"
msgstr "推薦_{0}_{1}"

#. placeholder {0}: record.recommendedPeople
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:228
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:253
msgid "推薦{0}人"
msgstr "推薦{0}人"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:201
msgid "推薦內容重複"
msgstr "推薦內容重複"

#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/ScrollImage/index.tsx:26
msgid "推薦在地的美食指南"
msgstr "推薦在地的美食指南"

#: apps/dp-client/src/screens/home/pages/Home/components/RecommendSetmeal/SetmealCard.tsx:121
msgid "推薦套餐"
msgstr "推薦套餐"

#: apps/dp-client/src/screens/home/pages/Home/components/RecommendSetmeal/SetmealCard.tsx:112
msgid "推薦店家"
msgstr "推薦店家"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:61
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:71
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:73
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:141
msgid "推薦排序"
msgstr "推薦排序"

#: apps/dp-client/src/screens/home/pages/PackageSearch/index.tsx:618
msgid "推薦搜尋"
msgstr "推薦搜尋"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityListSection.tsx:75
msgid "推薦活動"
msgstr "推薦活動"

#: apps/dp-client/src/configs/page-configs.tsx:1532
#: apps/dp-client/src/configs/page-configs.tsx:1534
msgid "推薦碼"
msgstr "推薦碼"

#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:80
msgid "推薦碼格式不正確，請輸入6-12位數字"
msgstr "推薦碼格式不正確，請輸入6-12位數字"

#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:65
msgid "推薦碼設置失敗，請稍後重試"
msgstr "推薦碼設置失敗，請稍後重試"

#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:61
msgid "推薦碼設置成功"
msgstr "推薦碼設置成功"

#: apps/dp-client/src/screens/home/pages/Review/components/DishesSection/index.tsx:39
msgid "推薦菜"
msgstr "推薦菜"

#: apps/dp-business/src/pages/StoreDescription.tsx:183
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:180
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2647
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:585
#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:132
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:70
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:87
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeColumns.web.tsx:40
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:134
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:74
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:352
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:136
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:327
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:188
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:610
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:80
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:50
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:68
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:120
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:102
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:103
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:100
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateDetailInfo/index.web.tsx:88
#: apps/dp-admin/src/components/UserGroup/UserGroupDetailInfo/index.web.tsx:62
#: apps/dp-admin/src/components/OperationLogTable/index.web.tsx:105
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupDetailInfo/index.web.tsx:62
msgid "描述"
msgstr "描述"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:148
msgid "描述：可選，用於說明按鈕的具體功能"
msgstr "描述：可選，用於說明按鈕的具體功能"

#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:61
msgid "描述一下您的店家吧"
msgstr "描述一下您的店家吧"

#: apps/dp-business/src/pages/MenuItemForm.tsx:575
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:511
msgid "描述一下餐點的製作過程、原料、優勢等"
msgstr "描述一下餐點的製作過程、原料、優勢等"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:152
msgid "描述不能超過500個字符"
msgstr "描述不能超過500個字符"

#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:45
msgid "描述您的店家特色，幫助顧客更好地瞭解您的餐廳"
msgstr "描述您的店家特色，幫助顧客更好地瞭解您的餐廳"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:203
msgid "描述資訊"
msgstr "描述資訊"

#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:319
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/CorrectionModal.tsx:107
#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:111
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:722
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:648
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:370
#: apps/dp-client/src/components/FeedBackModal/index.tsx:385
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:1206
#: apps/dp-business/src/pages/BusinessStatus/index.tsx:458
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1530
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:480
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:538
#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:367
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:260
#: apps/dp-admin/src/pages/org-tree/components/ReviewHistoryModal/index.web.tsx:86
#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:278
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:919
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:394
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:251
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:383
msgid "提交"
msgstr "送出"

#: apps/dp-client/src/screens/account/pages/advice/my-feedback/index.tsx:235
#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:294
msgid "提交："
msgstr "提交："

#. placeholder {0}: [taskInfo?.initiatorName, formatDate(taskInfo?.createdAt)] .filter(Boolean) .join(' ') || '-'
#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:178
msgid "提交：{0}"
msgstr "提交：{0}"

#: apps/dp-admin/src/pages/org-tree/services/constants.ts:62
msgid "提交中"
msgstr "提交中"

#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:319
#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewActions.tsx:30
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1942
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:370
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:732
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1057
#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:423
#: apps/dp-client/src/screens/diary/pages/note/index.tsx:493
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:378
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:474
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:722
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:645
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:370
#: apps/dp-client/src/components/FeedBackModal/index.tsx:385
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1159
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:795
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:988
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:1206
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:321
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:520
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:251
msgid "提交中..."
msgstr "正在送出..."

#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:130
#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:96
#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:187
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:138
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:204
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:417
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:161
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:214
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:112
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:181
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:177
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:218
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:197
msgid "提交人"
msgstr "提交人"

#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:185
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:204
msgid "提交人ID"
msgstr "提交人ID"

#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:149
msgid "提交人ID/內容ID/商家ID/商家名稱"
msgstr "提交人ID/內容ID/商家ID/商家名稱"

#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:131
msgid "提交人姓名"
msgstr "提交人姓名"

#: apps/dp-admin/src/pages/merchant/information-error/components/ErrorInfoSection/index.web.tsx:65
msgid "提交使用者："
msgstr "提交使用者："

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:531
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:737
msgid "提交入駐資訊失敗"
msgstr "提交入駐資訊失敗"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:786
msgid "提交合約失敗，請稍後重試"
msgstr "提交合約失敗，請稍後重試"

#: apps/dp-business/src/servers/contract-management/api.ts:184
msgid "提交合約簽約失敗"
msgstr "提交合約簽約失敗"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:555
#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:107
msgid "提交合約資訊"
msgstr "提交合約資訊"

#: apps/dp-business/src/servers/notification/api.ts:93
msgid "提交商家任務二次審批失敗"
msgstr "提交商家任務二次審批失敗"

#: apps/dp-business/src/servers/documentSubmission/api.ts:47
msgid "提交商家資料失敗"
msgstr "上傳商家資料失敗"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:991
msgid "提交報名"
msgstr "上傳報名"

#: apps/dp-client/src/store/couponStore.ts:202
#: apps/dp-client/src/store/couponStore.ts:228
#: apps/dp-business/src/pages/ContractManagement/index.tsx:279
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:220
#: apps/dp-admin/src/modules/constants/options.ts:546
msgid "提交失敗"
msgstr "送出失敗"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1273
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1779
msgid "提交失敗，本次修改已撤回，請調整後重新提交"
msgstr "提交失敗，本次修改已撤回，請調整後重新提交"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1272
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1778
msgid "提交失敗，本次修改已撤回：{reason}"
msgstr "提交失敗，本次修改已撤回：{reason}"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:210
msgid "提交失敗，請檢查網路連接後重試"
msgstr "提交失敗，請檢查網路連接後重試"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:206
msgid "提交失敗，請檢查表單資訊"
msgstr "提交失敗，請檢查表單資訊"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:214
msgid "提交失敗，請稍後重試"
msgstr "提交失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/services/groupImport.ts:195
msgid "提交失敗，請重新整理操作記錄確認任務是否已受理後再重試"
msgstr "提交失敗，請重新整理操作記錄確認任務是否已受理後再重試"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:347
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:351
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:557
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:717
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:276
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:280
#: apps/dp-business/src/pages/AddStore/index.tsx:1190
msgid "提交失敗，請重試"
msgstr "送出失敗，請重試"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:713
msgid "提交失敗: "
msgstr "上傳失敗: "

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:41
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:190
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:197
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:60
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:67
msgid "提交審核"
msgstr "提交審核"

#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:360
msgid "提交審核失敗"
msgstr "提交審核失敗"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1277
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1783
msgid "提交審核失敗，請稍後重試"
msgstr "提交審核失敗，請稍後重試"

#: apps/dp-business/src/servers/addStore/api.ts:236
msgid "提交店家申請失敗"
msgstr "上傳店家申請失敗"

#: apps/dp-business/src/pages/AddStore/index.tsx:966
msgid "提交店家申請失敗，請重試"
msgstr "上傳店家申請失敗，請重試"

#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:88
msgid "提交後不可更改喔"
msgstr "提交後不可更改喔"

#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:197
msgid "提交後任務將進入排隊，後臺非同步處理檔案。請於名單詳情頁「上傳歷史」查看進度；頁面可見時會自動更新。若提交逾時，請先重新整理記錄確認是否已受理，再決定是否重試。"
msgstr "提交後任務將進入排隊，後臺非同步處理檔案。請於名單詳情頁「上傳歷史」查看進度；頁面可見時會自動更新。若提交逾時，請先重新整理記錄確認是否已受理，再決定是否重試。"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/SubmitConfirmModal/index.web.tsx:162
msgid "提交後自動下載預覽圖"
msgstr "提交後自動下載預覽圖"

#: apps/dp-client/src/store/couponStore.ts:197
#: apps/dp-client/src/store/couponStore.ts:223
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:291
#: apps/dp-client/src/configs/page-configs.tsx:2908
#: apps/dp-business/src/pages/OnboardingComplete/index.tsx:26
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:332
#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:208
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:337
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:178
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:51
msgid "提交成功"
msgstr "送出成功"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:342
msgid "提交成功，我們將在24小時內確認資訊"
msgstr "送出成功，我們將在24小時內確認資訊"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:321
msgid "提交投訴"
msgstr "送出投訴"

#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:166
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:131
msgid "提交方式"
msgstr "提交方式"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:58
msgid "提交時由系統檢查"
msgstr "提交時由系統檢查"

#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:93
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:86
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:26
#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:73
#: apps/dp-admin/src/pages/report-center/audit-data/components/AuditTable.web.tsx:26
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:105
#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:90
#: apps/dp-admin/src/pages/merchant/information-review/components/ReviewInfoSection/index.web.tsx:28
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:198
#: apps/dp-admin/src/pages/merchant/audit-detail/components/SystemInfo/index.web.tsx:57
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/ExportHistoryTab/index.web.tsx:58
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/ExportHistoryTab/index.web.tsx:58
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:123
#: apps/dp-admin/src/pages/customer-service/components/TicketTable.web.tsx:37
#: apps/dp-admin/src/pages/audit-center/user-audit/components/UserBasicInfo/index.web.tsx:118
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:50
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:124
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:197
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:403
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:217
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:80
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:119
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:79
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:79
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:53
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:186
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:63
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:210
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:75
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:267
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:261
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:61
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:232
msgid "提交時間"
msgstr "提交時間"

#: apps/dp-admin/src/pages/merchant/information-error/components/ErrorInfoSection/index.web.tsx:59
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/AppealInfoSection/index.web.tsx:70
#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantImages/index.web.tsx:201
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:438
msgid "提交時間："
msgstr "提交時間："

#: apps/dp-business/src/servers/photo/api.ts:76
msgid "提交照片失敗"
msgstr "上傳照片失敗"

#: apps/dp-admin/src/components/OperationLogDetailModal/index.web.tsx:74
msgid "提交的資料"
msgstr "提交的資料"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:520
msgid "提交簽約申請"
msgstr "提交簽約申請"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:168
msgid "提交結果"
msgstr "提交結果"

#: apps/dp-admin/src/pages/marketing/services/groupImport.ts:179
msgid "提交結果尚未確認，請先重新整理操作記錄確認是否已受理，再決定是否重試"
msgstr "提交結果尚未確認，請先重新整理操作記錄確認是否已受理，再決定是否重試"

#: apps/dp-admin/src/pages/org-tree/services/shopPathActions.ts:205
msgid "提交結果尚未確認，請重試原操作以確認結果"
msgstr "提交結果尚未確認，請重試原操作以確認結果"

#: apps/dp-business/src/servers/shop/api.ts:640
msgid "提交複製任務失敗"
msgstr "提交複製任務失敗"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:223
msgid "提交複製任務失敗，請稍後重試"
msgstr "提交複製任務失敗，請稍後重試"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:571
msgid "提交複製任務失敗，請重試"
msgstr "提交複製任務失敗，請重試"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:254
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:645
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:160
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:287
msgid "提交記錄"
msgstr "提交記錄"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:170
msgid "提交評分失敗"
msgstr "提交評分失敗"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:245
msgid "提交評論失敗"
msgstr "送出評論失敗"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:219
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:147
msgid "提交資料"
msgstr "提交資料"

#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:103
msgid "提交追加"
msgstr "提交追加"

#: apps/dp-admin/src/pages/org-tree/org-audit/components/RejectModal/index.web.tsx:52
msgid "提交駁回"
msgstr "提交駁回"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:81
msgid "提供、維護和改進我們的服務"
msgstr "提供、維護和改進我們的服務"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:87
msgid "提供個人化的內容和推薦"
msgstr "提供個人化的內容和推薦"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:225
msgid "提供更多訊息取得積分吧～"
msgstr "提供更多訊息取得積分吧～"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:39
#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:49
#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:52
msgid "提供相關資料並上傳至系統"
msgstr "提供相關資料並上傳至系統"

#. placeholder {0}: rule.cancelAdvanceMinutes
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:643
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:840
msgid "提前{0}分鐘"
msgstr "提前{0}分鐘"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:418
msgid "提前{value}分鐘"
msgstr "提前{value}分鐘"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:128
msgid "提前{value}天{periodText}"
msgstr "提前{value}天{periodText}"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:152
msgid "提前2小時免費取消"
msgstr "提前2小時免費取消"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:617
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:814
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:957
msgid "提前預定時間"
msgstr "提前預定時間"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:390
msgid "提前預訂時間"
msgstr "提前預訂時間"

#. placeholder {0}: improvementSuggestions.length
#: apps/dp-business/src/pages/MerchantInfo/components/OptimizationCard.tsx:70
msgid "提升以下{0}項完善度可以顯著提高餐廳排名和曝光機會。"
msgstr "提升以下{0}項完善度可以顯著提高餐廳排名和曝光機會。"

#: apps/dp-business/src/pages/MerchantInfo/components/ProgressCard.tsx:59
msgid "提升資訊分數可以讓店家更容易被客人看到哦"
msgstr "提升資訊分數可以讓店家更容易被客人看到哦"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:210
msgid "提問提交成功"
msgstr "提問提交成功"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:226
#: apps/dp-client/src/configs/page-configs.tsx:1639
#: apps/dp-client/src/configs/page-configs.tsx:1641
msgid "提問詳情"
msgstr "提問詳情"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:319
msgid "提報人員"
msgstr "提報人員"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:273
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:118
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:298
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:187
msgid "提報單位"
msgstr "提報單位"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:405
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:165
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:201
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:1130
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:712
#: apps/dp-business/src/hooks/useUnsavedChangesGuard.ts:94
#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:192
#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:204
#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:212
#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:222
msgid "提示"
msgstr "提示"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantTags/index.web.tsx:113
msgid "提示：標籤用於分類和篩選商家，建議使用簡潔明確的詞語"
msgstr "提示：標籤用於分類和篩選商家，建議使用簡潔明確的詞語"

#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:356
msgid "提示：每個權限獨立控制，頁面權限控制頁面展示，按鈕權限控制按鈕顯示"
msgstr "提示：每個權限獨立控制，頁面權限控制頁面展示，按鈕權限控制按鈕顯示"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/EmailTemplateSection.web.tsx:27
msgid "提示：跳轉連接直接配置在郵件內容中，使用佔位符"
msgstr "提示：跳轉連接直接配置在郵件內容中，使用佔位符"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/PublishPreviewModal.web.tsx:115
msgid "提示：點擊\"立即公佈\"後將在用戶端公佈中獎名單並對用戶發放獎勵，點擊後不可修改"
msgstr "提示：點擊\"立即公佈\"後將在用戶端公佈中獎名單並對用戶發放獎勵，點擊後不可修改"

#: apps/dp-admin/src/components/BusinessHours/components/BusinessStatusSelector.web.tsx:169
msgid "提醒：與已有時間段重合。"
msgstr "提醒：與已有時間段重合。"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/NoSigned.tsx:20
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/NoDiscount.tsx:25
msgid "提醒您：補貼活動已啟動！"
msgstr "提醒您：補貼活動已啟動！"

#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:189
msgid "插入圖片"
msgstr "插入圖片"

#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:172
msgid "插入連結"
msgstr "插入連結"

#: apps/dp-client/src/screens/home/pages/PackageZone/components/PackageZoneContent/index.tsx:222
#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:329
msgid "換個搜尋詞試試吧"
msgstr "換個搜尋詞試試吧"

#: apps/dp-client/src/screens/reservation/pages/main/components/ConflictModal.tsx:106
msgid "換個時段"
msgstr "換個時段"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/ShopList/ShopList.tsx:372
msgid "換個篩選條件或移動地圖試試"
msgstr "換個篩選條件或移動地圖試試"

#: apps/dp-client/src/screens/home/pages/UserGift/components/ShopListSection/index.tsx:664
#: apps/dp-client/src/screens/home/components/CommonShopListSection/index.tsx:173
msgid "換個篩選條件試試吧"
msgstr "換個篩選條件試試吧"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:70
msgid "換發"
msgstr "換發"

#: apps/dp-business/src/data/categories.ts:154
msgid "握壽司"
msgstr "握壽司"

#: apps/dp-client/src/screens/login/pages/login/index.tsx:346
#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:391
msgid "搜、訂、吃、評、分享，一站搞定"
msgstr "搜、訂、吃、評、分享，一站搞定"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:256
#: apps/dp-client/src/screens/reservation/pages/list/pages/search/index.tsx:121
#: apps/dp-client/src/screens/home/pages/Search/index.tsx:594
#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:553
#: apps/dp-client/src/screens/home/pages/PackageSearch/index.tsx:546
#: apps/dp-client/src/screens/home/pages/LocationSelect/components/SearchHeader.tsx:75
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:510
#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:718
#: apps/dp-client/src/screens/account/pages/likes/pages/searchResult/index.tsx:220
#: apps/dp-client/src/screens/account/pages/likes/pages/search/index.tsx:121
#: apps/dp-client/src/screens/account/pages/favorites/pages/searchResult/index.tsx:227
#: apps/dp-client/src/screens/account/pages/favorites/pages/search/index.tsx:137
#: apps/dp-client/src/configs/page-configs.tsx:63
#: apps/dp-client/src/configs/page-configs.tsx:2807
#: apps/dp-business/src/pages/OrderDetails/components/FilterCard.tsx:41
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountToolbar/index.web.tsx:44
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountToolbar/index.web.tsx:129
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageCouponPicker/index.web.tsx:179
#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:208
#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:221
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ManualPackageSelector/index.web.tsx:36
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:346
#: apps/dp-admin/src/components/MapPicker/index.web.tsx:562
msgid "搜尋"
msgstr "搜尋"

#: apps/dp-client/src/screens/account/pages/user-profile/pages/search/index.tsx:74
msgid "搜尋 他/她 的筆記"
msgstr "搜尋 他/她 的筆記"

#: apps/dp-client/src/screens/account/pages/user-profile/pages/search/index.tsx:74
msgid "搜尋 他/她 的評論"
msgstr "搜尋 他/她 的評論"

#. placeholder {0}: mallInfo.name
#. placeholder {0}: searchKeyword.trim()
#: apps/dp-client/src/screens/home/pages/ShopList/components/MallCard/index.tsx:65
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:99
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/MallShopList/index.tsx:170
msgid "搜尋_{0}"
msgstr "搜尋_{0}"

#. placeholder {0}: shouldShowNearbyText ? '返回附近搜尋' : `返回${cityName}搜尋`
#: apps/dp-client/src/screens/home/pages/ShopList/components/LocationTip/index.tsx:103
msgid "搜尋_地理位置調整_{0}"
msgstr "搜尋_地理位置調整_{0}"

#: apps/dp-admin/src/pages/merchant/components/GoogleShopSearchSelect/index.web.tsx:62
msgid "搜尋Google店家..."
msgstr "搜尋Google店家..."

#: apps/dp-business/src/servers/addStore/api.ts:54
msgid "搜尋Google店家失敗"
msgstr "搜尋Google店家失敗"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:344
msgid "搜尋三級渠道"
msgstr "搜尋三級渠道"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:345
msgid "搜尋三級渠道名稱、渠道代碼或外部代碼"
msgstr "搜尋三級渠道名稱、渠道代碼或外部代碼"

#: apps/dp-client/src/screens/home/pages/Search/index.tsx:658
#: apps/dp-client/src/screens/home/pages/Note/components/MarkShopModal/index.tsx:370
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:770
#: apps/dp-client/src/screens/home/pages/FoodMap/components/Loading/index.tsx:26
#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/components/FloatingList.tsx:78
#: apps/dp-client/src/screens/account/pages/user-profile/pages/search/index.tsx:158
msgid "搜尋中..."
msgstr "搜尋中..."

#: apps/dp-client/src/screens/home/pages/Purchase/components/SelectDishContent/index.tsx:451
msgid "搜尋你想評論的菜品"
msgstr "搜尋你想評論的菜品"

#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:108
msgid "搜尋你有寫日記的餐廳..."
msgstr "搜尋你有寫日記的餐廳..."

#: apps/dp-client/src/screens/diary/pages/home/components/city-select/index.tsx:226
msgid "搜尋你要寫日記的餐廳..."
msgstr "搜尋你要寫日記的餐廳..."

#: apps/dp-client/src/screens/account/pages/likes/components/NotesContent/index.tsx:157
msgid "搜尋你點贊的筆記"
msgstr "搜尋你點贊的筆記"

#: apps/dp-client/src/screens/account/pages/likes/components/ReviewContent/index.tsx:199
msgid "搜尋你點贊的評論"
msgstr "搜尋你點贊的評論"

#: apps/dp-business/src/pages/UserManagement/index.tsx:731
#: apps/dp-business/src/pages/UserManagement/index.tsx:787
msgid "搜尋使用者名稱或email"
msgstr "搜尋使用者名稱或email"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:283
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/MallShopList/index.tsx:357
msgid "搜尋列表_返回"
msgstr "搜尋列表_返回"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:870
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1110
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:438
msgid "搜尋券名稱"
msgstr "搜尋券名稱"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:879
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1124
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:450
msgid "搜尋券碼"
msgstr "搜尋券碼"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:33
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:91
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:657
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:696
msgid "搜尋品類"
msgstr "搜尋品類"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:85
msgid "搜尋商家ID或名稱"
msgstr "搜尋商家ID或名稱"

#: apps/dp-client/src/screens/diary/pages/add-merchant/address-select/index.tsx:291
#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:235
msgid "搜尋地址"
msgstr "搜尋地址"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:364
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:454
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:154
msgid "搜尋地址（如：臺北101、臺中火車站、高雄港等）"
msgstr "搜尋地址（如：臺北101、臺中火車站、高雄港等）"

#: apps/dp-business/src/servers/addStore/api.ts:165
msgid "搜尋地址失敗"
msgstr "搜尋地址失敗"

#: apps/dp-client/src/screens/home/pages/Home/components/HeaderContent/index.tsx:100
msgid "搜尋地點、餐廳"
msgstr "搜尋地點、餐廳"

#: apps/dp-client/src/screens/home/pages/Note/components/MarkShopModal/index.tsx:326
#: apps/dp-client/src/screens/home/pages/Meal/pages/shopSelect/index.tsx:307
msgid "搜尋城市/分店"
msgstr "搜尋城市/分店"

#: apps/dp-client/src/screens/home/pages/UserGift/components/ShopListSection/index.tsx:371
#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListSearch.ts:339
#: apps/dp-client/src/screens/home/components/CommonShopListSection/index.tsx:525
#: apps/dp-client/src/screens/account/pages/favorites/components/ShopContent/index.tsx:75
msgid "搜尋失敗"
msgstr "搜尋失敗"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1805
msgid "搜尋套餐券"
msgstr "搜尋套餐券"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:817
#: apps/dp-client/src/screens/home/pages/PackageZone/components/SearchBar/index.tsx:148
msgid "搜尋套餐名、店家名"
msgstr "搜尋套餐名、店家名"

#: apps/dp-client/src/screens/home/pages/PackageSearch/index.tsx:526
msgid "搜尋套餐名／店家名"
msgstr "搜尋套餐名／店家名"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:467
msgid "搜尋姓名、登入名或聯絡方式"
msgstr "搜尋姓名、登入名或聯絡方式"

#: apps/dp-business/src/servers/addStore/api.ts:112
msgid "搜尋已註冊餐廳失敗"
msgstr "搜尋已註冊餐廳失敗"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:53
msgid "搜尋店家"
msgstr "搜尋店家"

#: apps/dp-client/src/screens/account/pages/favorites/pages/searchResult/index.tsx:213
#: apps/dp-client/src/screens/account/pages/favorites/pages/search/index.tsx:122
msgid "搜尋店家/商家名"
msgstr "搜尋店家/商家名"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:678
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:341
msgid "搜尋店家名稱/地址"
msgstr "搜尋店家名稱/地址"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:784
msgid "搜尋店家統編"
msgstr "搜尋店家統編"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1136
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:460
msgid "搜尋手機/用戶ID"
msgstr "搜尋手機/用戶ID"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:634
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:694
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:50
msgid "搜尋手機號碼或會員 ID"
msgstr "搜尋手機號碼或會員 ID"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:888
msgid "搜尋手機門號/用戶ID"
msgstr "搜尋手機門號/用戶ID"

#: apps/dp-business/src/pages/ComplaintList/index.tsx:160
msgid "搜尋投訴內容..."
msgstr "搜尋投訴內容..."

#: apps/dp-client/src/screens/diary/pages/plaza/components/PlazaSearchBar/index.tsx:30
msgid "搜尋日記或餐廳"
msgstr "搜尋日記或餐廳"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:145
msgid "搜尋是否有同一家商家"
msgstr "搜尋是否有同一家商家"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:479
msgid "搜尋是否有同一家店家"
msgstr "搜尋是否有同一家店家"

#: apps/dp-business/src/pages/OrderDetails/components/FilterCard.tsx:31
msgid "搜尋條件"
msgstr "搜尋條件"

#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:50
msgid "搜尋標籤"
msgstr "搜尋標籤"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/BenefitPicker/index.web.tsx:35
msgid "搜尋權益名稱或輸入權益 ID"
msgstr "搜尋權益名稱或輸入權益 ID"

#: apps/dp-client/src/screens/reservation/pages/list/pages/search/index.tsx:131
#: apps/dp-client/src/screens/home/pages/Search/index.tsx:608
#: apps/dp-client/src/screens/home/pages/PackageSearch/index.tsx:587
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:523
#: apps/dp-client/src/screens/account/pages/order/pages/search/index.tsx:132
#: apps/dp-client/src/screens/account/pages/likes/pages/search/index.tsx:131
#: apps/dp-client/src/screens/account/pages/favorites/pages/search/index.tsx:147
msgid "搜尋歷史"
msgstr "搜尋歷史"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:163
msgid "搜尋活動"
msgstr "搜尋活動"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:175
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFilter.tsx:99
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityFilterCard.tsx:133
msgid "搜尋活動名稱"
msgstr "搜尋活動名稱"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:117
msgid "搜尋無結果"
msgstr "搜尋無結果"

#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/components/FloatingList.tsx:104
#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/components/FloatingList.tsx:218
msgid "搜尋無結果？手動添加"
msgstr "搜尋無結果？手動添加"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:118
msgid "搜尋特定餐廳名稱無任何結果"
msgstr "搜尋特定餐廳名稱無任何結果"

#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowListSearchBar.tsx:26
msgid "搜尋粉絲id/暱稱"
msgstr "搜尋粉絲id/暱稱"

#: apps/dp-client/src/screens/home/pages/PackageZone/components/PackageZoneContent/index.tsx:237
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:634
#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:293
#: apps/dp-client/src/configs/page-configs.tsx:1089
msgid "搜尋結果"
msgstr "搜尋結果"

#. placeholder {0}: packageData.templateName
#. placeholder {0}: shop.name
#. placeholder {1}: packageData.shopId
#. placeholder {1}: shop.shopId
#. placeholder {2}: index + 1
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:187
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/MallShopList/index.tsx:274
msgid "搜尋結果_{0}_{1}_{2}"
msgstr "搜尋結果_{0}_{1}_{2}"

#. placeholder {0}: packageData.templateName
#. placeholder {1}: packageData.shopId
#. placeholder {2}: getStockStatus(packageData).isSoldOut ? '售罄' : '搶購'
#. placeholder {3}: index + 1
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:204
msgid "搜尋結果_{0}_{1}_{2}_{3}"
msgstr "搜尋結果_{0}_{1}_{2}_{3}"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:277
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:567
msgid "搜尋結算單號／店名"
msgstr "搜尋結算單號／店名"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:285
msgid "搜尋角色名稱或編碼"
msgstr "搜尋角色名稱或編碼"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:242
#: apps/dp-client/src/screens/reservation/pages/list/pages/search/index.tsx:108
#: apps/dp-client/src/configs/page-configs.tsx:1073
msgid "搜尋訂位"
msgstr "搜尋訂位"

#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:308
#: apps/dp-client/src/screens/account/pages/order/pages/search/index.tsx:118
msgid "搜尋訂單/商家名/店名"
msgstr "搜尋訂單/商家名/店名"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:861
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1100
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:428
msgid "搜尋訂單ID"
msgstr "搜尋訂單ID"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:289
msgid "搜尋評價內容..."
msgstr "搜尋評價內容..."

#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:543
msgid "搜尋評論內容"
msgstr "搜尋評論內容"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:237
msgid "搜尋請款單號"
msgstr "搜尋請款單號"

#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowListSearchBar.tsx:25
msgid "搜尋追蹤id/暱稱"
msgstr "搜尋追蹤id/暱稱"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:153
msgid "搜尋關鍵詞..."
msgstr "搜尋關鍵詞..."

#: apps/dp-client/src/screens/diary/pages/merchant/index.tsx:166
#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/index.tsx:379
msgid "搜尋餐廳"
msgstr "搜尋餐廳"

#: apps/dp-client/src/screens/home/pages/UserGift/components/ShopListSection/index.tsx:534
#: apps/dp-client/src/screens/home/pages/UserGift/components/ShopListSection/index.tsx:694
#: apps/dp-client/src/screens/home/pages/ShopList/components/CustomHeader/index.tsx:62
#: apps/dp-client/src/screens/home/pages/Search/index.tsx:572
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:491
#: apps/dp-client/src/screens/home/pages/FoodMap/index.tsx:2035
#: apps/dp-client/src/screens/home/components/CommonShopListSection/index.tsx:152
#: apps/dp-client/src/screens/diary/pages/search/index.tsx:227
msgid "搜尋餐廳..."
msgstr "搜尋餐廳..."

#: apps/dp-client/src/screens/account/pages/likes/pages/searchResult/index.tsx:206
msgid "搜尋點贊"
msgstr "搜尋點贊"

#: apps/dp-client/src/screens/account/pages/likes/pages/search/index.tsx:108
msgid "搜尋點贊筆記"
msgstr "搜尋點贊筆記"

#: apps/dp-business/src/pages/RefundList/index.tsx:415
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1707
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1855
#: apps/dp-business/src/pages/OrderList/index.tsx:953
#: apps/dp-business/src/components/SearchBar/index.tsx:43
#: apps/dp-business/src/components/Input/index.tsx:460
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:151
#: apps/dp-admin/src/pages/users/roles/components/RoleToolbar/index.web.tsx:128
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1179
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:278
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:195
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ClientSearchPanel/index.web.tsx:45
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:172
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/shopConfig.web.tsx:12
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:240
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryUserDrawHistoryModal.web.tsx:130
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:657
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/config.web.tsx:19
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:110
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:154
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:197
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:231
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:200
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:146
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:25
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:150
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupShopList/index.web.tsx:98
msgid "搜索"
msgstr "搜尋"

#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:258
msgid "搜索中..."
msgstr "搜索中..."

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:263
msgid "搜索商品"
msgstr "搜索商品"

#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:340
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:403
msgid "搜索失敗，請稍後重試"
msgstr "搜尋失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/MemberPreviewPanel/index.web.tsx:68
msgid "搜索店家名稱 / 店家 ID"
msgstr "搜索店家名稱 / 店家 ID"

#: apps/dp-business/src/pages/OrderList/index.tsx:824
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:148
msgid "搜索條件"
msgstr "搜尋條件"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:369
msgid "搜索標籤"
msgstr "搜索標籤"

#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:738
msgid "搜索無結果？手動添加"
msgstr "搜尋不到？手動新增"

#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:184
msgid "搜索用戶ID"
msgstr "搜索用戶ID"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/MemberPreviewPanel/index.web.tsx:114
msgid "搜索用戶暱稱 / 手機 / UID"
msgstr "搜索用戶暱稱 / 手機 / UID"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:238
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:193
msgid "搜索票券名稱"
msgstr "搜索票券名稱"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:51
msgid "搜索關鍵詞"
msgstr "搜索關鍵詞"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:17
msgid "搜索關鍵詞推薦"
msgstr "搜索關鍵詞推薦"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:16
msgid "搜索關鍵詞跳轉位"
msgstr "搜索關鍵詞跳轉位"

#: apps/dp-business/src/components/GoogleMap/index.tsx:940
#: apps/dp-business/src/components/GoogleMap/WebViewMap.tsx:825
msgid "搜索附近地點中..."
msgstr "搜尋附近地點中..."

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuCategorySection/index.web.tsx:143
msgid "搜索類別名稱"
msgstr "搜索類別名稱"

#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:688
#: apps/dp-business/src/pages/AddStore/components/SearchBar.tsx:21
msgid "搜索餐廳"
msgstr "搜尋餐廳"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1155
msgid "搜索餐點名稱或分類"
msgstr "搜索餐點名稱或分類"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:434
msgid "搜索餐點名稱或類別"
msgstr "搜索餐點名稱或類別"

#: apps/dp-client/src/screens/home/pages/PrivateChef/constants.ts:9
msgid "搶訂中"
msgstr "搶訂中"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageTile.tsx:125
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageTile.tsx:140
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/BrandPackageCouponCard/index.tsx:124
#: apps/dp-client/src/screens/home/components/SetMealCard/index.tsx:234
msgid "搶購"
msgstr "搶購"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:117
msgid "摺疊面板可以包含任意複雜的內容："
msgstr "摺疊面板可以包含任意複雜的內容："

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1471
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:410
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:437
msgid "撤回"
msgstr "撤回"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:911
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:495
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:888
msgid "撤回內容經修改後可重新提交審核．"
msgstr "撤回內容經修改後可重新提交審核．"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:140
msgid "撤回同意"
msgstr "撤回同意"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:938
msgid "撤回失敗"
msgstr "撤回失敗"

#: apps/dp-business/src/servers/coupon/api.ts:217
msgid "撤回套餐券審核失敗"
msgstr "撤回套餐券審核失敗"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:924
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:374
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:681
msgid "撤回成功"
msgstr "撤回成功"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:49
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:29
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:29
msgid "撤銷"
msgstr "撤銷"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:826
msgid "撤銷原因"
msgstr "撤銷原因"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:210
msgid "撤銷失敗變更"
msgstr "撤銷失敗變更"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:72
msgid "撤銷掛接"
msgstr "撤銷掛接"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:311
msgid "撤銷改掛"
msgstr "撤銷改掛"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:179
msgid "撤銷更換"
msgstr "撤銷更換"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:292
msgid "撤銷解除"
msgstr "撤銷解除"

#: apps/dp-business/src/pages/ContactBD/index.tsx:85
msgid "撥打"
msgstr "撥打"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:166
#: apps/dp-client/src/screens/account/components/feedback-modal/index.tsx:115
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:176
msgid "撥打電話"
msgstr "撥打電話"

#: apps/dp-admin/src/modules/hooks/usePhoneCall.ts:63
#: apps/dp-admin/src/modules/hooks/usePhoneCall.ts:113
msgid "撥打電話失敗"
msgstr "撥打電話失敗"

#: apps/dp-business/src/utils/voiceBroadcast.ts:786
msgid "播報內容不能為空"
msgstr "播報內容不能為空"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:376
msgid "播放"
msgstr "播放"

#: apps/dp-business/src/pages/MenuManagement.tsx:525
#: apps/dp-business/src/pages/MenuManagement.tsx:662
#: apps/dp-business/src/pages/UserManagement/index.tsx:532
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:240
#: apps/dp-business/src/pages/TableManagement/index.tsx:979
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:721
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:606
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:427
#: apps/dp-business/src/pages/RefundList/index.tsx:312
#: apps/dp-business/src/pages/PermissionManagement/index.tsx:175
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1251
#: apps/dp-business/src/pages/OrderList/index.tsx:653
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/columns.tsx:137
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:152
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/columns.tsx:137
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1475
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2507
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1337
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:451
#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:134
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:230
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:491
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:252
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:635
#: apps/dp-business/src/pages/CouponVerification/index.tsx:722
#: apps/dp-business/src/pages/ContractManagement/index.tsx:342
#: apps/dp-business/src/pages/ContractManagement/index.tsx:490
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:641
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:205
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCommonColumns.tsx:108
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:217
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:391
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:246
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:206
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:148
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1319
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:306
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:333
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:130
#: apps/dp-admin/src/pages/users/roles/components/RoleTable/index.web.tsx:78
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:211
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:191
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:339
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:943
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:112
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:87
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:565
#: apps/dp-admin/src/pages/transaction/components/MerchantInfo/index.web.tsx:157
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:256
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:183
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:280
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:216
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:204
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:169
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:125
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:166
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:127
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:408
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:136
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:113
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageCouponPicker/index.web.tsx:145
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/FixedPackageImportField/index.web.tsx:162
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeColumns.web.tsx:62
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:89
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:241
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:189
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:195
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:220
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:319
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:428
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:191
#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:148
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:187
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedMallTable/index.web.tsx:82
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/columns.web.tsx:71
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/columns.web.tsx:33
#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:114
#: apps/dp-admin/src/pages/org-tree/components/ReviewHistoryModal/index.web.tsx:112
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:357
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:209
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:147
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:152
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:998
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:516
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:230
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:290
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:340
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:224
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:159
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:124
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:112
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:845
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:201
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:653
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:697
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:178
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:71
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:251
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:207
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:223
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:696
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:91
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:109
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:219
#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:139
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:164
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ImageUploadTips/index.web.tsx:132
#: apps/dp-admin/src/pages/marketing/verification-record-detail/components/StatusLogTable/index.web.tsx:31
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:161
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:191
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/RefreshHistoryTab/index.web.tsx:66
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/ExportHistoryTab/index.web.tsx:107
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:298
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:180
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:230
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:298
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:178
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:325
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1210
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:182
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:346
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:177
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:174
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/RefreshHistoryTab/index.web.tsx:66
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/ExportHistoryTab/index.web.tsx:107
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:489
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:451
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:473
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:146
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:212
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:490
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:202
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:206
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:243
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:191
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:337
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:164
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:288
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:297
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:184
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:257
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:299
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:159
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:98
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:152
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:220
#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:124
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:512
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:349
#: apps/dp-admin/src/pages/customer-service/components/TicketTable.web.tsx:54
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:363
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:131
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:225
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:452
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:188
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:156
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:148
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:234
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:193
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:217
#: apps/dp-admin/src/pages/audit-center/info-audit/components/InfoAuditTable/index.web.tsx:113
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:292
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:239
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:344
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:287
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:161
msgid "操作"
msgstr "操作"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:208
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:486
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2531
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:478
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:554
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:277
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:291
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:511
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:584
#: apps/dp-admin/src/pages/org-tree/org-list/components/ShelfHistoryModal/index.web.tsx:51
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:779
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:95
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1127
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:93
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelHistoryList/index.web.tsx:117
#: apps/dp-admin/src/pages/audit-center/components/PublishOperationLogsCard/index.web.tsx:55
#: apps/dp-admin/src/components/OperationLogTable/index.web.tsx:99
msgid "操作人"
msgstr "操作人"

#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:196
msgid "操作人ID"
msgstr "操作人ID"

#: apps/dp-admin/src/pages/audit-center/components/PublishOperationLogsCard/index.web.tsx:59
msgid "操作內容"
msgstr "操作內容"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:87
#: apps/dp-admin/src/components/OperationLogTable/index.web.tsx:93
msgid "操作動作"
msgstr "操作動作"

#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:212
msgid "操作受限"
msgstr "操作受限"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:200
msgid "操作執行失敗，請稍後重試"
msgstr "操作執行失敗，請稍後重試"

#: apps/dp-business/src/store/NotificationContext.tsx:670
#: apps/dp-business/src/store/NotificationContext.tsx:682
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:978
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:870
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:397
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:418
#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:246
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:196
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:298
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/components/PoiActionButtons/index.web.tsx:42
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/hooks.ts:68
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/hooks.ts:72
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:387
msgid "操作失敗"
msgstr "操作失敗"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:480
msgid "操作失敗，請檢查網路連線"
msgstr "操作失敗，請檢查網路連線"

#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:288
msgid "操作失敗，請稍後再試"
msgstr "操作失敗，請稍後再試"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/home/index.tsx:87
#: apps/dp-client/src/screens/account/pages/account-security/email/email-old/index.tsx:61
#: apps/dp-client/src/screens/account/pages/account-security/email/bind-email/index.tsx:59
#: apps/dp-business/src/pages/UserManagement/index.tsx:383
#: apps/dp-business/src/pages/UserManagement/index.tsx:387
msgid "操作失敗，請稍後重試"
msgstr "操作失敗，請稍後重試"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:984
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:394
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:484
#: apps/dp-client/src/screens/home/pages/FoodMap/index.tsx:1885
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:191
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:213
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:258
#: apps/dp-client/src/screens/account/pages/user-profile/pages/permission-settings/index.tsx:40
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:804
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:858
#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:123
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:100
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:125
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/hooks.ts:114
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/hooks.ts:119
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/hooks.ts:147
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/hooks.ts:152
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/SigningAuditTab/index.web.tsx:116
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:370
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/EntryAuditTab/index.web.tsx:148
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:139
msgid "操作失敗，請重試"
msgstr "操作失敗，請重新嘗試"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:680
msgid "操作完成"
msgstr "操作完成"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:635
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:141
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:242
#: apps/dp-admin/src/pages/resource-config/rank-list/services/hooks.ts:157
#: apps/dp-admin/src/pages/resource-config/message-template-list/services/hooks.ts:154
#: apps/dp-admin/src/pages/resource-config/message-list/services/hooks.ts:115
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:183
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:153
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/services/hooks.ts:127
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:126
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:480
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/hooks.ts:64
msgid "操作成功"
msgstr "操作成功"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/batchResult.ts:20
msgid "操作成功，共 {successCount} 筆"
msgstr "操作成功，共 {successCount} 筆"

#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:212
msgid "操作成功，正在刷新活動狀態"
msgstr "操作成功，正在刷新活動狀態"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/OperationLogSection/index.web.tsx:52
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/OperationLogSection/index.web.tsx:53
msgid "操作日誌"
msgstr "操作日誌"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:214
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:494
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:286
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:299
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:518
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:786
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:101
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:199
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:637
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1130
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:80
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelHistoryList/index.web.tsx:123
#: apps/dp-admin/src/components/OperationLogTable/index.web.tsx:86
msgid "操作時間"
msgstr "操作時間"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:178
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:145
msgid "操作歷史"
msgstr "操作歷史"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:64
msgid "操作結果"
msgstr "操作結果"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:126
msgid "操作結果未知，請刷新後核對"
msgstr "操作結果未知，請刷新後核對"

#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:215
msgid "操作結果未確認，請先核對列表狀態"
msgstr "操作結果未確認，請先核對列表狀態"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1503
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2451
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:488
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:217
#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:491
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:400
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:756
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:82
msgid "操作記錄"
msgstr "操作記錄"

#: apps/dp-admin/src/pages/merchant/components/ImageOperationTips/index.web.tsx:26
msgid "操作說明"
msgstr "操作說明"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:501
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:267
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:769
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelHistoryList/index.web.tsx:95
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:93
#: apps/dp-admin/src/pages/audit-center/info-audit/components/InfoAuditTable/index.web.tsx:58
msgid "操作類型"
msgstr "操作類型"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:41
#: apps/dp-client/src/components/RefundResonModal/index.tsx:26
msgid "擔心安全問題（天氣等）"
msgstr "擔心安全問題（天氣等）"

#: apps/dp-business/src/hooks/useQRScanner.ts:73
msgid "攝影機被佔用"
msgstr "攝影機被佔用"

#: apps/dp-client/src/configs/page-configs.tsx:2995
#: apps/dp-client/src/configs/page-configs.tsx:2997
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:673
#: apps/dp-admin/src/pages/split-account/services/constants.ts:68
msgid "支付"
msgstr "支付"

#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:310
#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:314
msgid "支付 URL 或 HTML 為空"
msgstr "支付 URL 或 HTML 為空"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:708
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:35
#: apps/dp-business/src/servers/order/types.ts:148
#: apps/dp-admin/src/pages/report-center/abnormal-orders/service/constants.ts:30
#: apps/dp-admin/src/pages/order/services/utils.ts:65
#: apps/dp-admin/src/pages/order/services/utils.ts:289
msgid "支付中"
msgstr "支付中"

#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:270
msgid "支付中..."
msgstr "支付中..."

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:500
msgid "支付剩餘時間<0>{minutesText}</0>分<1>{secondsText}</1>秒"
msgstr "支付剩餘時間<0>{minutesText}</0>分<1>{secondsText}</1>秒"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/OrderInfoCard/index.web.tsx:46
msgid "支付創建時間"
msgstr "支付創建時間"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:33
#: apps/dp-business/src/servers/order/types.ts:146
#: apps/dp-admin/src/pages/order/services/utils.ts:284
#: apps/dp-admin/src/pages/marketing/services/constants.ts:348
msgid "支付取消"
msgstr "支付取消"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:94
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:51
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/OrderInfoCard/index.web.tsx:25
msgid "支付單號"
msgstr "支付單號"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:29
#: apps/dp-business/src/servers/order/types.ts:142
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2358
#: apps/dp-admin/src/pages/report-center/abnormal-orders/service/constants.ts:40
#: apps/dp-admin/src/pages/order/services/utils.ts:274
#: apps/dp-admin/src/pages/marketing/services/constants.ts:346
msgid "支付失敗"
msgstr "支付失敗"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2379
msgid "支付完成時間"
msgstr "支付完成時間"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:985
#: apps/dp-admin/src/pages/report-center/services/apis.ts:459
msgid "支付寶"
msgstr "支付寶"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:27
#: apps/dp-business/src/servers/order/types.ts:140
#: apps/dp-business/src/pages/OrderList/index.tsx:910
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2358
#: apps/dp-admin/src/pages/report-center/abnormal-orders/service/constants.ts:35
#: apps/dp-admin/src/pages/order/services/utils.ts:269
#: apps/dp-admin/src/pages/marketing/services/constants.ts:345
msgid "支付成功"
msgstr "支付成功"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:119
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:143
msgid "支付方式"
msgstr "支付方式"

#: apps/dp-business/src/pages/OrderList/index.tsx:642
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:143
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/columns.tsx:128
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/components/DiscountFilterBar.tsx:70
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1667
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1787
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:458
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:177
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:63
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:164
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:105
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:182
msgid "支付時間"
msgstr "支付時間"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2370
msgid "支付渠道"
msgstr "支付管道"

#: apps/dp-business/src/pages/OrderList/index.tsx:565
#: apps/dp-business/src/pages/OrderList/index.tsx:903
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:110
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesFilterBar.tsx:95
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/columns.tsx:104
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/components/DiscountFilterBar.tsx:84
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2348
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:70
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:88
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/OrderInfoCard/index.web.tsx:43
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:103
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:325
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:111
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/config.web.tsx:67
msgid "支付狀態"
msgstr "支付狀態"

#: apps/dp-client/src/configs/page-configs.tsx:3010
msgid "支付結果"
msgstr "支付結果"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1636
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1775
msgid "支付編號"
msgstr "支付編號"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:37
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:132
msgid "支付訂單 ID"
msgstr "支付訂單 ID"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2361
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:134
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:136
msgid "支付訂單號"
msgstr "支付訂單號"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2347
msgid "支付資訊"
msgstr "支付資訊"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:31
#: apps/dp-business/src/servers/order/types.ts:144
#: apps/dp-admin/src/pages/report-center/abnormal-orders/service/constants.ts:45
#: apps/dp-admin/src/pages/order/services/utils.ts:279
#: apps/dp-admin/src/pages/marketing/services/constants.ts:347
msgid "支付超時"
msgstr "支付超時"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2367
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:79
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/OrderInfoCard/index.web.tsx:40
msgid "支付金額"
msgstr "支付金額"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:561
msgid "支付金額為 $0，所以沒有款項退回。"
msgstr "支付金額為 $0，所以沒有款項退回。"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:193
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:131
msgid "支出："
msgstr "支出："

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:160
msgid "支持 .xlsx / .xls，單次單檔，最多 100,000 筆"
msgstr "支持 .xlsx / .xls，單次單檔，最多 100,000 筆"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ImportShopModal/index.web.tsx:144
msgid "支持 .xlsx、.xls 格式，單次僅可上傳一個文件"
msgstr "支持 .xlsx、.xls 格式，單次僅可上傳一個文件"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/BatchUploadForm/index.web.tsx:53
#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:189
msgid "支持 .xlsx、.xls 格式，單次僅可上傳一個文件，最多 100,000 筆"
msgstr "支持 .xlsx、.xls 格式，單次僅可上傳一個文件，最多 100,000 筆"

#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:493
msgid "支持 <0>JPG、PNG</0> 格式，單個文件不超過 <1>5MB</1>"
msgstr "支持 <0>JPG、PNG</0> 格式，單個文件不超過 <1>5MB</1>"

#. placeholder {0}: fileSizeLimit !== undefined && ( <> ，單個文件不超過{' '} <span className="font-medium text-orange-600"> {fileSizeLimit}MB </span> </> )
#: apps/dp-admin/src/pages/merchant/components/UploadTips/index.web.tsx:33
msgid "支持 <0>JPG、PNG</0> 格式{0}"
msgstr "支援 <0>JPG、PNG</0> 格式{0}"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:738
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:769
msgid "支持 Excel 和 CSV 格式，文件大小不超過 10MB"
msgstr "支持 Excel 和 CSV 格式，文件大小不超過 10MB"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:146
#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:169
msgid "支持 JPG、PNG 格式，最大 10MB"
msgstr "支持 JPG、PNG 格式，最大 10MB"

#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:355
msgid "支持 jpg、png、gif、pdf 格式，單個文件不超過 5MB"
msgstr "支持 jpg、png、gif、pdf 格式，單個文件不超過 5MB"

#. placeholder {0}: imageType.maxSize
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:111
msgid "支持 JPG、PNG、WebP 格式，單張不超過 {0}MB"
msgstr "支持 JPG、PNG、WebP 格式，單張不超過 {0}MB"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:83
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityStepsField/index.web.tsx:70
msgid "支持 JPG/PNG/GIF 格式，大小不超過 5MB"
msgstr "支持 JPG/PNG/GIF 格式，大小不超過 5MB"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:626
msgid "支持 mp4 格式，單個檔案大小不超過 500MB"
msgstr "支持 mp4 格式，單個檔案大小不超過 500MB"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1543
msgid "支持寵物預訂"
msgstr "支持寵物預訂"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:153
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateDetailInfo/index.web.tsx:81
msgid "支持渠道"
msgstr "支持渠道"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:211
msgid "支持的事件與過濾項組合已全部使用"
msgstr "支持的事件與過濾項組合已全部使用"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:69
msgid "支持部分匹配"
msgstr "支持部分匹配"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:721
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:215
msgid "支援 .xlsx 格式，大小不超過 10MB"
msgstr "支援 .xlsx 格式，大小不超過 10MB"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:192
msgid "支援 .xlsx／.xls，單檔上限 10 MB，不限制列數"
msgstr "支援 .xlsx／.xls，單檔上限 10 MB，不限制列數"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:121
msgid "支援 @用戶名 提及和 :smile: 表情"
msgstr "支援 @用戶名 提及和 :smile: 表情"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:105
msgid "支援 **粗體**、*斜體*、[連結](https://example.com) 語法"
msgstr "支援 **粗體**、*斜體*、[連結](https://example.com) 語法"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:338
msgid "支援 Excel (.xlsx, .xls) 和 CSV 格式，可一次選擇多個檔案"
msgstr "支援 Excel (.xlsx, .xls) 和 CSV 格式，可一次選擇多個檔案"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponCodeUpload.web.tsx:150
msgid "支援 Excel (.xlsx, .xls) 和 CSV 格式，每行一個券碼"
msgstr "支援 Excel (.xlsx, .xls) 和 CSV 格式，每行一個券碼"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/ShopIdUpload.web.tsx:56
msgid "支援 Excel (.xlsx, .xls) 和 CSV 格式，每行一個商家ID"
msgstr "支援 Excel (.xlsx, .xls) 和 CSV 格式，每行一個商家ID"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:355
msgid "支援 Excel (.xlsx) 和 CSV 格式，可一次選擇多個檔案"
msgstr "支援 Excel (.xlsx) 和 CSV 格式，可一次選擇多個檔案"

#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:379
msgid "支援 JPG、PNG 格式"
msgstr "支援 JPG、PNG 格式"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:734
msgid "支援 jpg、png 等常見圖片格式，可多選，單個文件不超過 5MB"
msgstr "支援 jpg、png 等常見圖片格式，可多選，單個文件不超過 5MB"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:139
msgid "支援 JPG、PNG、GIF 格式，大小不超過 5MB"
msgstr "支援 JPG、PNG、GIF 格式，大小不超過 5MB"

#: apps/dp-business/src/pages/MenuItemForm.tsx:522
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:464
msgid "支援gif格式"
msgstr "支援gif格式"

#: apps/dp-business/src/pages/ImageManagement/components/imageTips.tsx:75
#: apps/dp-admin/src/pages/merchant/components/imageTips/index.web.tsx:39
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:134
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:148
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:163
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:178
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:193
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:208
msgid "支援jpg、png格式"
msgstr "支援jpg、png格式"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:223
msgid "支援mp4、mov、webm格式"
msgstr "支援mp4、mov、webm格式"

#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:98
msgid "支援月繳和年繳，年繳享優惠2個月"
msgstr "支援月繳和年繳，年繳享優惠2個月"

#: apps/dp-admin/src/pages/org-tree/org-create/services/constants.ts:114
#: apps/dp-admin/src/components/FileUpload/index.web.tsx:91
msgid "支援檔案格式為PDF、JPG、JPEG、PNG"
msgstr "支援檔案格式為PDF、JPG、JPEG、PNG"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:282
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:31
msgid "收件人"
msgstr "收件人"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:183
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:121
msgid "收入："
msgstr "收入："

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/IncomeCalculationSection.tsx:96
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:615
msgid "收入試算"
msgstr "收入試算"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:111
msgid "收合條件"
msgstr "收合條件"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:380
msgid "收據抬頭：聚流平台科技股份有限公司"
msgstr "收據抬頭：聚流平台科技股份有限公司"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:406
msgid "收據樣本.pdf"
msgstr "收據樣本.pdf"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:390
msgid "收據請郵寄至地址：臺北市承德路一段70號18樓"
msgstr "收據請郵寄至地址：臺北市承德路一段70號18樓"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:76
msgid "收款存摺帳戶"
msgstr "收款存摺帳戶"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:60
msgid "收款諮詢"
msgstr "收款諮詢"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/index.web.tsx:64
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/index.web.tsx:97
msgid "收款資訊"
msgstr "收款資訊"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/HorizontalShopCard.tsx:261
#: apps/dp-client/src/screens/account/pages/profile/components/FunctionEntrySection/index.tsx:67
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:242
msgid "收藏"
msgstr "收藏"

#. placeholder {0}: noteDetail?.id
#. placeholder {1}: noteDetail?.title
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:430
msgid "收藏_{0}_{1}"
msgstr "收藏_{0}_{1}"

#: apps/dp-client/src/screens/account/pages/notifications/components/InteractionNotificationCard/index.tsx:47
msgid "收藏了你的筆記"
msgstr "收藏了你的筆記"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:750
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:352
msgid "收藏人數"
msgstr "收藏人數"

#: apps/dp-client/src/configs/page-configs.tsx:2272
#: apps/dp-client/src/configs/page-configs.tsx:2274
msgid "收藏夾搜尋"
msgstr "收藏夾搜尋"

#: apps/dp-client/src/configs/page-configs.tsx:2290
#: apps/dp-client/src/configs/page-configs.tsx:2292
msgid "收藏夾搜尋結果"
msgstr "收藏夾搜尋結果"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:176
msgid "收藏店家"
msgstr "收藏店家"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:341
#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:979
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:472
msgid "收藏成功"
msgstr "收藏成功"

#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:64
msgid "收藏數量"
msgstr "收藏數量"

#: apps/dp-client/src/screens/login/components/account-info-card/index.tsx:74
msgid "收藏餐廳"
msgstr "收藏餐廳"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:366
msgid "收藏餐廳獲得領取資格"
msgstr "收藏餐廳獲得領取資格"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:435
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:664
msgid "收費方案"
msgstr "收費方案"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:790
msgid "收費規則"
msgstr "收費規則"

#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:99
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:905
msgid "收費類型"
msgstr "收費類型"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:217
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailCard/index.tsx:341
#: apps/dp-client/src/screens/diary/components/diary-entry/index.tsx:143
#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:83
#: apps/dp-client/src/screens/account/pages/favorites/pages/searchResult/index.tsx:307
#: apps/dp-client/src/screens/account/pages/coupon/GiftRule/index.tsx:235
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:278
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:279
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:893
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:120
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityDetails.tsx:152
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:363
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:369
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:172
#: apps/dp-admin/src/components/SearchForm/index.web.tsx:222
msgid "收起"
msgstr "收起"

#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:272
msgid "收起回覆"
msgstr "收起回覆"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:29
msgid "收起已保存套餐"
msgstr "收起已保存套餐"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:143
msgid "收起店家"
msgstr "收起店家"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:496
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:572
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:124
msgid "收起折扣資訊"
msgstr "收起折扣資訊"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:184
msgid "收起搜索條件"
msgstr "收起搜索條件"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:908
msgid "收起明細"
msgstr "收起明細"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterSelects.tsx:301
msgid "收起篩選"
msgstr "收起篩選"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:861
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:291
#: apps/dp-client/src/screens/home/pages/PackageSearch/index.tsx:284
msgid "收起篩選選單"
msgstr "收起篩選選單"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/index.web.tsx:95
msgid "收起菜品資訊"
msgstr "收起餐點資訊"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1086
msgid "收起餐點資訊"
msgstr "收起餐點資訊"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:764
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialogTrigger.tsx:94
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialogTrigger.tsx:96
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:805
#: apps/dp-business/src/configs/page-configs.ts:257
msgid "收銀臺"
msgstr "收銀臺"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:855
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1073
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1087
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:408
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:415
msgid "收銀記錄"
msgstr "收銀記錄"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:272
msgid "改上級與左樹拖拽同一套校驗：子節點一併移動，移動後整棵子樹不超過 {MAX_NODE_LEVEL} 層。不會自動修改已掛店家的簽約、請款與結算路徑；根節點不可改上級，同層排序不影響結算。"
msgstr "改上級與左樹拖拽同一套校驗：子節點一併移動，移動後整棵子樹不超過 {MAX_NODE_LEVEL} 層。不會自動修改已掛店家的簽約、請款與結算路徑；根節點不可改上級，同層排序不影響結算。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:67
msgid "改掛後由本節點看本樹報表／簽約"
msgstr "改掛後由本節點看本樹報表／簽約"

#. placeholder {0}: record.moveTargetName
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:113
msgid "改掛至 {0}"
msgstr "改掛至 {0}"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:55
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:35
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:35
#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:515
msgid "放大"
msgstr "放大"

#: apps/dp-client/src/screens/diary/components/WarningModal/index.tsx:66
msgid "放心，提交後還是可以獲得基本積分"
msgstr "放心，送出後還是可以獲得基本積分"

#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:119
#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:372
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:637
msgid "放棄付款將關閉這筆訂單，還可重新進入買單"
msgstr "放棄付款將關閉這筆訂單，還可重新進入買單"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:598
msgid "放棄後會清除目前的錄製內容"
msgstr "放棄後會清除目前的錄製內容"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:64
msgid "政治敏感"
msgstr "政治敏感"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:324
msgid "效果追蹤"
msgstr "效果追蹤"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:38
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:39
msgid "啟停狀態"
msgstr "啟停狀態"

#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:198
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:209
msgid "啟動"
msgstr "啟動"

#: apps/dp-business/src/hooks/useQRScanner.ts:150
msgid "啟動掃描失敗，請重試"
msgstr "啟動掃描失敗，請重試"

#: apps/dp-business/src/pages/UserManagement/index.tsx:361
#: apps/dp-business/src/pages/UserManagement/index.tsx:605
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:211
#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:29
#: apps/dp-admin/src/pages/users/roles/components/StatusTag/index.web.tsx:28
#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:13
#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:27
#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:306
#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:307
#: apps/dp-admin/src/pages/users/permissions/components/StatusTag/index.web.tsx:19
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:202
#: apps/dp-admin/src/pages/resource-config/services/constants.ts:136
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:158
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/services/searchConfig.ts:7
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:97
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:92
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:152
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:68
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:122
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:165
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:143
#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:9
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:69
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:109
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:260
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:331
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:234
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:333
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:702
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:214
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:240
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:204
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:230
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:62
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:250
#: apps/dp-admin/src/pages/merchant/service/constants.ts:527
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:116
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:130
#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:159
#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:11
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:255
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:17
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/index.web.tsx:109
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:246
#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:9
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:226
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:15
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:65
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:265
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelHistoryList/index.web.tsx:29
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:64
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:157
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:251
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:138
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateDetailInfo/index.web.tsx:78
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:339
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:248
#: apps/dp-admin/src/modules/constants/options.ts:345
msgid "啟用"
msgstr "啟用"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:118
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:16
msgid "啟用中"
msgstr "啟用中"

#: apps/dp-admin/src/pages/merchant/brand-list/components/EnableBrandModal/index.web.tsx:83
msgid "啟用原因"
msgstr "啟用原因"

#: apps/dp-admin/src/pages/merchant/brand-list/components/EnableBrandModal/index.web.tsx:61
msgid "啟用品牌"
msgstr "啟用品牌"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:152
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:155
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:439
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:138
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:561
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:132
msgid "啟用失敗"
msgstr "啟用失敗"

#. placeholder {0}: res.failedCategories?.[0]?.reason
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:432
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:130
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:125
msgid "啟用失敗：{0}"
msgstr "啟用失敗：{0}"

#: apps/dp-admin/src/pages/merchant/brand-list/components/EnableBrandModal/index.web.tsx:77
msgid "啟用後該品牌恢復可用狀態。"
msgstr "啟用後該品牌恢復可用狀態。"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:149
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:127
#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:68
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:436
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:134
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:558
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:128
#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:84
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:80
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/index.web.tsx:96
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:162
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:107
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:160
msgid "啟用成功"
msgstr "啟用成功"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:109
msgid "啟用時間"
msgstr "啟用時間"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:109
msgid "啟用服務成功"
msgstr "啟用服務成功"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:426
#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:116
msgid "啟用活動失敗"
msgstr "啟用活動失敗"

#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:64
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:116
msgid "啟用狀態"
msgstr "啟用狀態"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:143
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:122
msgid "啟用配置"
msgstr "啟用配置"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:126
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:102
msgid "敏感詞檢測失敗，請重試"
msgstr "敏感詞檢測失敗，請重試"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:81
msgid "整個活動"
msgstr "整個活動"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:163
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ExchangeLimitEditor/index.web.tsx:49
msgid "整個活動內可兌換消耗上限"
msgstr "整個活動內可兌換消耗上限"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ExchangeLimitEditor/index.web.tsx:59
msgid "整個活動期間，同一用戶最多可兌換消耗的次數。"
msgstr "整個活動期間，同一用戶最多可兌換消耗的次數。"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:168
msgid "整樹"
msgstr "整樹"

#: apps/dp-client/src/screens/diary/components/diary-entry/index.tsx:94
msgid "整體"
msgstr "整體"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:64
msgid "整體服務技術不錯，就是等待時間有點長。"
msgstr "整體服務技術不錯，就是等待時間有點長。"

#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:44
msgid "數據報表"
msgstr "數據報表"

#: apps/dp-admin/src/pages/report-center/audit-data/index.web.tsx:54
msgid "數據審核"
msgstr "數據審核"

#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:48
msgid "數據時間"
msgstr "數據時間"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:505
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1103
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:581
msgid "數據概況"
msgstr "數據概況"

#: apps/dp-admin/src/pages/marketing/components/OverviewSection/index.web.tsx:51
msgid "數據概覽"
msgstr "數據總覽"

#: apps/dp-business/src/store/ChainBootstrapContext.tsx:83
msgid "數據異常無法跳轉"
msgstr "數據異常無法跳轉"

#: apps/dp-admin/src/pages/marketing/components/OverviewSection/index.web.tsx:58
msgid "數據統計"
msgstr "數據統計"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:324
#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:558
#: apps/dp-client/src/screens/home/pages/PrivateChef/index.tsx:311
#: apps/dp-client/src/screens/home/pages/MerchantGroup/index.tsx:221
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:85
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/MallShopList/index.tsx:156
msgid "數據載入失敗"
msgstr "數據載入失敗"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:190
msgid "數據預覽"
msgstr "數據預覽"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:30
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:325
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:886
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:946
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1012
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:371
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:452
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:531
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:619
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:675
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:22
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:140
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:183
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2246
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2298
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:139
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:99
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:154
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:209
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:264
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:123
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:241
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:248
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:22
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:114
msgid "數量"
msgstr "數量"

#. placeholder {0}: data.count
#. placeholder {1}: data.percentage
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingDistribution.web.tsx:212
msgid "數量: {0} ({1}%)"
msgstr "數量: {0} ({1}%)"

#. placeholder {0}: payload[0].value.toLocaleString()
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/RatingDistributionChart.web.tsx:41
msgid "數量: {0} 個評價"
msgstr "數量: {0} 個評價"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:189
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:197
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:205
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:36
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:44
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:52
msgid "數量上限為1張圖片"
msgstr "數量上限為1張圖片"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:60
msgid "數量上限為2張圖片"
msgstr "數量上限為2張圖片"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:168
msgid "數量必須大於 0"
msgstr "數量必須大於 0"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:188
msgid "文件上傳"
msgstr "文件上傳"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:135
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:135
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:150
msgid "文件上傳失敗"
msgstr "文件上傳失敗"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:131
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:131
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/ShopIdUpload.web.tsx:34
msgid "文件上傳成功"
msgstr "文件上傳成功"

#: apps/dp-business/src/utils/download.ts:105
msgid "文件下載失敗"
msgstr "文件下載失敗"

#: apps/dp-admin/src/modules/hooks/useBlobDownload.ts:62
msgid "文件下載成功"
msgstr "文件下載成功"

#. placeholder {0}: maxSize ?? 5
#: apps/dp-business/src/components/PhotoUploader/hooks/useImageAspectRatio.tsx:66
msgid "文件大小不能超過 {0}MB"
msgstr "文件大小不能超過 {0}MB"

#: apps/dp-business/src/components/PhotoUploader/validation.ts:120
msgid "文件大小不能超過 {fileSizeLimit}MB"
msgstr "文件大小不能超過 {fileSizeLimit}MB"

#: apps/dp-admin/src/modules/hooks/useImageUpload.ts:135
msgid "文件大小不能超過 {maxSize}MB"
msgstr "文件大小不能超過 {maxSize}MB"

#: apps/dp-admin/src/pages/marketing/channel-management/services/useChannelImport.ts:175
msgid "文件大小不能超過 10 MB"
msgstr "文件大小不能超過 10 MB"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageSourceField/index.web.tsx:148
msgid "文件導入"
msgstr "文件導入"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractUpload/components/ContractInfo/index.web.tsx:61
msgid "文件格式為PDF，文件大小不超過10M"
msgstr "文件格式為PDF，文件大小不超過10M"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/ContractUpload/components/ContractInfo/index.web.tsx:63
msgid "文件格式為PDF/JPG/JPEG/PNG，文件大小不超過10M，最多支持上傳10個文件"
msgstr "文件格式為PDF/JPG/JPEG/PNG，文件大小不超過10M，最多支持上傳10個文件"

#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:93
msgid "文件解析失敗"
msgstr "文件解析失敗"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/index.web.tsx:163
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/index.web.tsx:164
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/index.web.tsx:161
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/index.web.tsx:162
#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:94
msgid "文件解析失敗!"
msgstr "文件解析失敗!"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:45
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:89
msgid "文字"
msgstr "文字"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:140
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:194
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:194
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:203
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:203
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:212
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:212
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:162
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:216
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:216
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:225
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:225
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:234
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:234
msgid "文字內容"
msgstr "文字內容"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:127
msgid "文字大小"
msgstr "文字大小"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/Menu/index.tsx:100
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopDishGallery.tsx:277
#: apps/dp-client/src/configs/page-configs.tsx:248
#: apps/dp-business/src/pages/MenuManagement.tsx:1161
#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:346
#: apps/dp-admin/src/pages/merchant/components/MenuManagementSection/index.web.tsx:207
msgid "文字菜單"
msgstr "文字菜單"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:170
msgid "文字輪廓"
msgstr "文字輪廓"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:172
msgid "文字陰影"
msgstr "文字陰影"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:175
msgid "文字顏色"
msgstr "文字顏色"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:128
msgid "文字風格"
msgstr "文字風格"

#: apps/dp-business/src/data/regions.ts:47
msgid "文山區"
msgstr "文山區"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:194
msgid "文本"
msgstr "內文"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:176
msgid "文本對齊"
msgstr "內文對齊"

#: apps/dp-client/src/screens/home/components/RichTextInput/utils/constants.ts:205
msgid "文本解析規則錯誤"
msgstr "內文解析規則錯誤"

#: apps/dp-business/src/components/PhotoUploader/hooks/useFileUpload.ts:215
msgid "文檔選擇失敗，請重試"
msgstr "文件選擇失敗，請重試"

#: apps/dp-client/src/screens/home/utils/utils.ts:419
#: apps/dp-client/src/screens/home/utils/utils.ts:426
msgid "文章審查確認中"
msgstr "文章審查確認中"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:333
msgid "斑紋"
msgstr "斑紋"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:120
#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:116
msgid "斜體"
msgstr "斜體"

#: apps/dp-business/src/pages/MenuManagement.tsx:131
#: apps/dp-business/src/pages/MenuItemForm.tsx:42
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:48
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:48
msgid "新上架的餐點"
msgstr "新上架的餐點"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1928
msgid "新人專屬活動"
msgstr "新人專屬活動"

#: apps/dp-client/src/screens/home/pages/UserGift/hooks/useUserGiftData.ts:143
msgid "新人禮活動資料調用失敗:"
msgstr "新人禮活動資料調用失敗:"

#: apps/dp-client/src/configs/page-configs.tsx:502
msgid "新人註冊禮"
msgstr "新人註冊禮"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:438
msgid "新分配"
msgstr "新分配"

#: apps/dp-business/src/data/regions.ts:10
msgid "新北"
msgstr "新北"

#: apps/dp-business/src/pages/MenuManagement.tsx:128
#: apps/dp-business/src/pages/MenuItemForm.tsx:39
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:45
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:45
msgid "新品"
msgstr "新品"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:437
msgid "新商家進駐"
msgstr "新商家進駐"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:166
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:178
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:364
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:409
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:278
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:350
#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:263
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:56
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:508
#: apps/dp-business/src/components/MaintenanceList/index.tsx:177
#: apps/dp-business/src/components/AddPillButton/index.tsx:26
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/index.web.tsx:525
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:109
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:63
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:114
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantTags/index.web.tsx:107
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/index.web.tsx:42
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionGroupCard.web.tsx:54
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionGroupCard.web.tsx:43
msgid "新增"
msgstr "新增"

#. placeholder {0}: getUnitNameLabel(poiType)
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:888
msgid "新增{0}"
msgstr "新增{0}"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/index.web.tsx:208
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:232
msgid "新增{levelLabel}渠道"
msgstr "新增{levelLabel}渠道"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:105
msgid "新增POI"
msgstr "新增POI"

#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:209
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:236
msgid "新增一級品類"
msgstr "新增一級品類"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:288
msgid "新增下級"
msgstr "新增下級"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:517
msgid "新增並選用"
msgstr "新增並選用"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:259
msgid "新增互斥組"
msgstr "新增互斥組"

#: apps/dp-business/src/utils/permissionData.ts:157
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:694
#: apps/dp-business/src/pages/UserManagement/index.tsx:716
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:355
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:248
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:265
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:249
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:484
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:301
#: apps/dp-business/src/pages/AddUser/index.tsx:173
msgid "新增使用者"
msgstr "新增使用者"

#: apps/dp-business/src/pages/AddUser/index.tsx:312
msgid "新增使用者後，該使用者需要在24小時內使用填寫的聯絡方式登入，以啟用帳號"
msgstr "新增使用者後，該使用者需要在24小時內使用填寫的聯絡方式登入，以啟用帳號"

#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:258
msgid "新增使用者後，該使用者需要在24小時內使用填寫的聯絡方式登入，以啟用帳號。"
msgstr "新增使用者後，該使用者需要在24小時內使用填寫的聯絡方式登入，以啟用帳號。"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/index.web.tsx:111
msgid "新增停車場"
msgstr "新增停車場"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:110
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:205
msgid "新增備註"
msgstr "新增備註"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:353
msgid "新增內容要求階梯"
msgstr "新增內容要求階梯"

#: apps/dp-business/src/pages/TableManagement/index.tsx:300
msgid "新增分區"
msgstr "新增分區"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:320
#: apps/dp-business/src/pages/TableManagement/index.tsx:344
msgid "新增分區失敗"
msgstr "新增分區失敗"

#: apps/dp-business/src/pages/TableManagement/index.tsx:332
msgid "新增分區成功"
msgstr "新增分區成功"

#: apps/dp-business/src/pages/MenuManagement.tsx:704
msgid "新增分類"
msgstr "新增分類"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:414
msgid "新增可用日期"
msgstr "新增可用日期"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteContentEditor.tsx:77
msgid "新增吸引人的標題..."
msgstr "新增吸引人的標題..."

#: apps/dp-admin/src/pages/merchant/brand-list/index.web.tsx:140
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:100
msgid "新增品牌"
msgstr "新增品牌"

#: apps/dp-admin/src/pages/merchant/brand-list/services/hooks.ts:233
msgid "新增品牌成功"
msgstr "新增品牌成功"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:178
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:265
msgid "新增商場/夜市商圈"
msgstr "新增商場/夜市商圈"

#: apps/dp-client/src/configs/page-configs.tsx:2874
#: apps/dp-client/src/configs/page-configs.tsx:2876
#: apps/dp-business/src/pages/SubmitSuccess/index.tsx:56
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:727
#: apps/dp-business/src/pages/AddStore/index.tsx:1574
#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:54
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:405
msgid "新增商家"
msgstr "新增商家"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/services/interface.ts:20
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/services/interface.ts:20
msgid "新增商家資訊"
msgstr "新增商家資訊"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:204
msgid "新增圍欄"
msgstr "新增圍欄"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1908
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2177
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2208
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2291
#: apps/dp-business/src/configs/page-configs.ts:1055
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1112
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:781
msgid "新增套餐券"
msgstr "新增套餐券"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:912
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1116
msgid "新增套餐組合"
msgstr "新增套餐組合"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeBasicInfo/index.web.tsx:90
#: apps/dp-admin/src/pages/org-tree/org-detail/components/AddChildNodeModal/index.web.tsx:43
msgid "新增子節點"
msgstr "新增子節點"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/PromotionTab/index.web.tsx:114
msgid "新增宣傳語"
msgstr "新增宣傳語"

#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:188
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountToolbar/index.web.tsx:135
msgid "新增帳號"
msgstr "新增帳號"

#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:234
msgid "新增帳號失敗"
msgstr "新增帳號失敗"

#: apps/dp-admin/src/pages/users/user-tasks/services/hooks.ts:231
msgid "新增帳號成功"
msgstr "新增帳號成功"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:751
#: apps/dp-business/src/pages/OnboardingComplete/index.tsx:73
#: apps/dp-business/src/pages/MerchantReview/index.tsx:68
#: apps/dp-business/src/pages/AddStore/index.tsx:1204
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopActionButtons/index.web.tsx:105
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:578
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:215
#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:233
msgid "新增店家"
msgstr "新增店家"

#: apps/dp-business/src/servers/shop/api.ts:221
msgid "新增店家設施失敗"
msgstr "新增店家設施失敗"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:113
msgid "新增店家資訊"
msgstr "新增店家資訊"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:296
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/index.web.tsx:71
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:204
msgid "新增成功"
msgstr "新增成功"

#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:172
msgid "新增折扣券"
msgstr "新增折扣券"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:287
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:513
msgid "新增按鈕文字"
msgstr "新增按鈕文字"

#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:468
msgid "新增捷運"
msgstr "新增捷運"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:151
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:334
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:386
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:593
msgid "新增方式"
msgstr "新增方式"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:229
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:526
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:541
msgid "新增日常規則"
msgstr "新增日常規則"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:529
msgid "新增時段"
msgstr "新增時段"

#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/components/TimeSlotItem/index.web.tsx:52
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/components/TimeSlotItem/index.web.tsx:69
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/components/DayBusinessHours/index.web.tsx:184
msgid "新增時間段與現有時間段重疊，請手動調整時間"
msgstr "新增時間段與現有時間段重疊，請手動調整時間"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:182
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BookingFeeRules/index.web.tsx:165
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:164
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/BookingFeeRules/index.web.tsx:127
msgid "新增時間規則"
msgstr "新增時間規則"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:458
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:850
msgid "新增服務時間設定"
msgstr "新增服務時間設定"

#: apps/dp-business/src/pages/TableManagement/index.tsx:602
#: apps/dp-business/src/pages/TableManagement/index.tsx:1186
msgid "新增桌位"
msgstr "新增桌位"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:412
#: apps/dp-business/src/pages/TableManagement/index.tsx:666
msgid "新增桌位失敗"
msgstr "新增桌位失敗"

#: apps/dp-business/src/pages/TableManagement/index.tsx:650
msgid "新增桌位成功"
msgstr "新增桌位成功"

#: apps/dp-business/src/pages/TableManagement/index.tsx:1064
msgid "新增桌型"
msgstr "新增桌型"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:664
#: apps/dp-admin/src/pages/resource-config/rank-list/index.web.tsx:85
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:379
msgid "新增榜單"
msgstr "新增榜單"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:354
msgid "新增榜單成功"
msgstr "新增榜單成功"

#: apps/dp-admin/src/pages/merchant/components/TagEditor/index.web.tsx:235
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:375
msgid "新增標籤"
msgstr "新增標籤"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitFields/index.web.tsx:61
msgid "新增權益"
msgstr "新增權益"

#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:166
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityStepsField/index.web.tsx:83
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:413
msgid "新增步驟"
msgstr "新增步驟"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/index.web.tsx:85
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/index.web.tsx:53
msgid "新增活動位"
msgstr "新增活動位"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PosterListField/index.web.tsx:77
msgid "新增海報圖片"
msgstr "新增海報圖片"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:175
msgid "新增滿減券"
msgstr "新增滿額折扣券"

#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/components/DayBusinessHours/index.web.tsx:238
msgid "新增營業時間段"
msgstr "新增營業時間段"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:1255
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2075
msgid "新增特殊日期"
msgstr "新增特殊日期"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:229
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:721
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:736
msgid "新增特殊時間規則"
msgstr "新增特殊時間規則"

#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:227
msgid "新增特殊營業時間"
msgstr "新增特殊營業時間"

#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:181
msgid "新增用戶名單"
msgstr "新增用戶名單"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/index.web.tsx:66
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:79
msgid "新增第三方渠道"
msgstr "新增第三方渠道"

#: apps/dp-admin/src/pages/org-tree/org-list/index.web.tsx:67
msgid "新增組織樹"
msgstr "新增組織樹"

#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:128
msgid "新增統編/個人載具"
msgstr "新增統編/個人載具"

#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:224
#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:245
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:209
msgid "新增臨時使用者"
msgstr "新增臨時使用者"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:513
msgid "新增自訂鏈接"
msgstr "新增自訂鏈接"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:843
msgid "新增自訂類目"
msgstr "新增自訂類別"

#: apps/dp-admin/src/pages/users/permissions/index.web.tsx:149
#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:276
msgid "新增菜單"
msgstr "新增菜單"

#: apps/dp-admin/src/pages/resource-config/landing-page-list/index.web.tsx:52
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:166
msgid "新增落地頁"
msgstr "新增落地頁"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:239
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:867
msgid "新增規則成功"
msgstr "新增規則成功"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:171
#: apps/dp-business/src/pages/PermissionManagement/index.tsx:227
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:290
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:272
#: apps/dp-business/src/pages/AddRole/index.tsx:347
#: apps/dp-business/src/pages/AddRole/index.tsx:362
#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:50
#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:204
#: apps/dp-admin/src/pages/users/roles/components/RoleToolbar/index.web.tsx:133
msgid "新增角色"
msgstr "新增角色"

#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:201
msgid "新增角色將會覆蓋目標店家的同名角色，請知悉！"
msgstr "新增角色將會覆蓋目標店家的同名角色，請知悉！"

#: apps/dp-business/src/utils/permissionData.ts:189
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:722
msgid "新增角色設定"
msgstr "新增角色設定"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteContentEditor.tsx:113
msgid "新增說明內文..."
msgstr "新增說明內文..."

#: apps/dp-admin/src/pages/resource-config/slot-material-list/index.web.tsx:56
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/index.web.tsx:55
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:375
msgid "新增資源位"
msgstr "新增資源位"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:234
#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:107
msgid "新增連鎖"
msgstr "新增連鎖"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:479
msgid "新增金剛位設定"
msgstr "新增金剛位設定"

#: apps/dp-business/src/pages/OrderList/index.tsx:809
msgid "新增銷售訂單總金額/訂單數"
msgstr "新增銷售訂單總金額/訂單數"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:818
msgid "新增電話"
msgstr "新增電話"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuCategorySection/index.web.tsx:135
#: apps/dp-admin/src/pages/merchant/components/MenuCategorySection/index.web.tsx:122
#: apps/dp-admin/src/pages/merchant/components/CategoryEditModal/index.web.tsx:56
msgid "新增類別"
msgstr "新增類別"

#: apps/dp-business/src/pages/MenuManagement.tsx:831
#: apps/dp-business/src/pages/MenuManagement.tsx:1395
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:791
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:405
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:264
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:340
msgid "新增餐點"
msgstr "新增餐點"

#: apps/dp-business/src/pages/MenuManagement.tsx:1231
msgid "新增餐點類別"
msgstr "新增餐點類別"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:683
#: apps/dp-admin/src/components/MapPicker/index.web.tsx:643
msgid "新增點位"
msgstr "新增點位"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:61
msgid "新客"
msgstr "新客"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:358
msgid "新密碼"
msgstr "新密碼"

#: apps/dp-business/src/utils/validation.ts:290
#: apps/dp-business/src/utils/validation.ts:357
msgid "新密碼不能與舊密碼相同"
msgstr "新密碼不能與舊密碼相同"

#: apps/dp-business/src/data/regions.ts:59
msgid "新店區"
msgstr "新店區"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityDescriptionField/LandingPagePicker.web.tsx:187
msgid "新建"
msgstr "新建"

#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:791
msgid "新建一級品類"
msgstr "新建一級品類"

#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:760
msgid "新建二級品類"
msgstr "新建二級品類"

#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:70
msgid "新建商家權益"
msgstr "新建商家權益"

#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:175
msgid "新建商家活動"
msgstr "新建商家活動"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:365
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:153
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:575
msgid "新建工單"
msgstr "新建工單"

#: apps/dp-admin/src/pages/resource-config/message-template-list/index.web.tsx:222
msgid "新建模板"
msgstr "新建模板"

#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:332
#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:157
msgid "新建權益"
msgstr "新建權益"

#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:266
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:288
msgid "新建活動"
msgstr "新建活動"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/index.web.tsx:70
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:288
msgid "新建渠道活動"
msgstr "新建渠道活動"

#: apps/dp-client/src/configs/page-configs.tsx:749
msgid "新建筆記"
msgstr "新建筆記"

#: apps/dp-admin/src/pages/resource-config/message-list/index.web.tsx:79
msgid "新建通知發送"
msgstr "新建通知發送"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/records/components/PointsRecordItem/index.tsx:16
#: apps/dp-client/src/screens/account/pages/task-wall/components/OnboardingTaskSection/index.tsx:45
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:407
msgid "新手任務"
msgstr "新手任務"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponStatusModal.web.tsx:124
msgid "新狀態"
msgstr "新狀態"

#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:208
msgid "新獲得"
msgstr "新獲得"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:583
msgid "新用戶優惠"
msgstr "新用戶優惠"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:36
msgid "新用戶首單免費"
msgstr "新用戶首單免費"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:212
msgid "新的"
msgstr "新的"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/ExtendInventoryModal.web.tsx:76
msgid "新的截止時間"
msgstr "新的截止時間"

#: apps/dp-business/src/data/regions.ts:15
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:87
msgid "新竹市"
msgstr "新竹市"

#: apps/dp-business/src/data/regions.ts:16
msgid "新竹縣"
msgstr "新竹縣"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1087
msgid "新節點"
msgstr "新節點"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/AddChildNodeModal/index.web.tsx:72
msgid "新節點僅保存在本頁，點「保存並提交審核」後才會生效。管理員、簽約／請款商家與店家可在選中新節點後設置。"
msgstr "新節點僅保存在本頁，點「保存並提交審核」後才會生效。管理員、簽約／請款商家與店家可在選中新節點後設置。"

#: apps/dp-business/src/data/regions.ts:58
msgid "新莊區"
msgstr "新莊區"

#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:55
msgid "新註冊用戶"
msgstr "新註冊用戶"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/LegalPerson/index.web.tsx:92
#: apps/dp-admin/src/pages/merchant/audit-detail/components/BusinessLicense/index.web.tsx:68
#: apps/dp-admin/src/pages/merchant/audit-detail/components/AccountInfo/index.web.tsx:96
msgid "新資料"
msgstr "新資料"

#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:200
msgid "新追蹤者"
msgstr "新追蹤者"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:222
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:233
#: apps/dp-admin/src/pages/worker-order/services/constants.ts:37
msgid "新開單"
msgstr "新開單"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:138
msgid "方形"
msgstr "方形"

#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:117
msgid "方案區間"
msgstr "方案區間"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:346
msgid "於 {diningDate} 用餐"
msgstr "於 {diningDate} 用餐"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:343
msgid "於 {diningDate} 與 {companionText} 一起用餐"
msgstr "於 {diningDate} 與 {companionText} 一起用餐"

#: apps/dp-client/src/screens/diary/pages/plaza/index.tsx:82
msgid "於 {formattedDate} 用餐"
msgstr "於 {formattedDate} 用餐"

#: apps/dp-client/src/screens/diary/pages/plaza/index.tsx:78
msgid "於 {formattedDate} 與 {companionText} 一起用餐"
msgstr "於 {formattedDate} 與 {companionText} 一起用餐"

#: apps/dp-client/src/utils/businessStatus.ts:315
msgid "於{date}暫停兌換，請至其他分店使用"
msgstr "於{date}暫停兌換，請至其他分店使用"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:268
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:61
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:62
msgid "旋轉"
msgstr "旋轉"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useExistingFixedPackages.ts:37
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useExistingFixedPackages.ts:44
msgid "既有套餐名單加載失敗"
msgstr "既有套餐名單加載失敗"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:130
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:131
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:563
#: apps/dp-business/src/components/DatePicker.tsx:235
msgid "日"
msgstr "日"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:566
msgid "日 週"
msgstr "日 週"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:407
msgid "日常任務"
msgstr "日常任務"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:445
msgid "日常拜訪"
msgstr "日常拜訪"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:510
msgid "日常規則設置"
msgstr "日常規則設置"

#: apps/dp-admin/src/pages/user-info/services/apis.ts:145
msgid "日料"
msgstr "日料"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1891
#: apps/dp-business/src/pages/BusinessStatus/index.tsx:400
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1297
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1454
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:449
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:162
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1106
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:391
msgid "日期"
msgstr "日期"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1002
msgid "日期 "
msgstr "日期 "

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:776
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:425
#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:54
msgid "日期範圍"
msgstr "日期範圍"

#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:121
msgid "日期範圍與已有特殊營業時間重疊，請重新選擇"
msgstr "日期範圍與已有特殊營業時間重疊，請重新選擇"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:1217
msgid "日期範圍重疊，請重新選擇"
msgstr "日期範圍重疊，請重新選擇"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:352
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:394
msgid "日期選擇器"
msgstr "日期選擇器"

#: apps/dp-business/src/data/categories.ts:143
msgid "日本料理"
msgstr "日本料理"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:57
msgid "日本料理·壽司餐廳"
msgstr "日本料理·壽司餐廳"

#: apps/dp-client/src/screens/diary/pages/my/components/PointsInfoCard.tsx:44
#: apps/dp-client/src/screens/diary/components/task-card/index.tsx:151
#: apps/dp-client/src/configs/page-configs.tsx:2643
msgid "日記"
msgstr "日記"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:112
msgid "日記ID不存在"
msgstr "日記ID不存在"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:565
msgid "日記不存在"
msgstr "日記不存在"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:243
msgid "日記任務"
msgstr "日記任務"

#: apps/dp-client/src/screens/diary/components/MediaItem/index.tsx:50
msgid "日記圖片"
msgstr "日記圖片"

#: apps/dp-client/src/configs/page-configs.tsx:2667
msgid "日記詳情"
msgstr "日記詳情"

#: apps/dp-admin/src/components/OperationLogDetailModal/index.web.tsx:56
msgid "日誌詳情"
msgstr "日誌詳情"

#: apps/dp-business/src/types/orderFilter.ts:194
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:417
#: apps/dp-business/src/constants/enums.ts:28
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:260
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1251
#: apps/dp-admin/src/components/BusinessHours/constants.ts:20
msgid "早餐"
msgstr "早餐"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:121
msgid "早餐時段"
msgstr "早餐時段"

#: apps/dp-business/src/utils/dateRange.ts:118
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1026
msgid "明天"
msgstr "明天"

#: apps/dp-business/src/utils/dateRange.ts:121
msgid "明年"
msgstr "明年"

#: apps/dp-client/src/screens/reservation/pages/main/types.ts:41
msgid "明日 {time}"
msgstr "明日 {time}"

#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:209
msgid "明日再來"
msgstr "明日再來"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:403
msgid "明日就餐訂單"
msgstr "明日就餐訂單"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:373
msgid "明日用餐訂單"
msgstr "明日用餐訂單"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.web.tsx:53
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:287
msgid "明體"
msgstr "明體"

#: apps/dp-client/src/screens/home/pages/UserGift/components/SlideInCouponCard/index.tsx:266
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:235
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:242
msgid "星巴克"
msgstr "星巴克"

#: apps/dp-client/src/screens/home/pages/UserGift/components/SlideInCouponCard/index.tsx:259
#: apps/dp-client/src/screens/home/pages/UserGift/components/CouponFlipCard/index.tsx:313
msgid "星巴克兌換券"
msgstr "星巴克兌換券"

#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/UsergiftBanner.tsx:389
msgid "星巴克券"
msgstr "星巴克券"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1486
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:346
msgid "星期"
msgstr "星期"

#: apps/dp-business/src/utils/businessHours.ts:23
#: apps/dp-business/src/utils/businessHours.ts:43
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:3
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:20
msgid "星期一"
msgstr "星期一"

#: apps/dp-business/src/utils/businessHours.ts:25
#: apps/dp-business/src/utils/businessHours.ts:45
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:5
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:22
msgid "星期三"
msgstr "星期三"

#: apps/dp-business/src/utils/businessHours.ts:24
#: apps/dp-business/src/utils/businessHours.ts:44
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:4
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:21
msgid "星期二"
msgstr "星期二"

#: apps/dp-business/src/utils/businessHours.ts:27
#: apps/dp-business/src/utils/businessHours.ts:47
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:7
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:24
msgid "星期五"
msgstr "星期五"

#: apps/dp-business/src/utils/businessHours.ts:28
#: apps/dp-business/src/utils/businessHours.ts:48
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:8
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:25
msgid "星期六"
msgstr "星期六"

#: apps/dp-business/src/utils/businessHours.ts:26
#: apps/dp-business/src/utils/businessHours.ts:46
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:6
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:23
msgid "星期四"
msgstr "星期四"

#: apps/dp-business/src/utils/businessHours.ts:29
#: apps/dp-business/src/utils/businessHours.ts:49
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:9
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:26
msgid "星期日"
msgstr "星期日"

#: apps/dp-business/src/store/HolidayContext.tsx:138
#: apps/dp-business/src/store/HolidayContext.tsx:138
#: apps/dp-business/src/store/HolidayContext.tsx:139
#: apps/dp-business/src/store/HolidayContext.tsx:148
#: apps/dp-business/src/store/HolidayContext.tsx:148
msgid "春節"
msgstr "春節"

#: apps/dp-business/src/utils/dateRange.ts:140
#: apps/dp-business/src/utils/dateRange.ts:193
#: apps/dp-business/src/types/orderFilter.ts:141
#: apps/dp-business/src/types/orderFilter.ts:153
#: apps/dp-business/src/pages/OrderOverview/index.tsx:349
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1027
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1781
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1807
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:207
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:219
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:393
msgid "昨天"
msgstr "昨天"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:997
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:914
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:450
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2181
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:42
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:49
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCommonColumns.tsx:64
#: apps/dp-business/src/pages/AddStore/index.tsx:1037
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:117
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/ContractSettings/index.web.tsx:40
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:49
#: apps/dp-admin/src/pages/split-account/services/constants.ts:315
#: apps/dp-admin/src/pages/split-account/services/constants.ts:323
#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:251
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:70
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:48
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:73
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:95
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:107
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:25
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:129
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:56
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:123
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:16
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:77
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:524
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:590
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2143
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2331
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:917
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/hooks.ts:28
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:57
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:233
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:263
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:112
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:257
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/searchConfig.ts:52
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:252
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:207
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:309
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:154
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:166
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:47
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:279
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:282
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:285
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:96
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:150
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:179
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/config.ts:80
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:175
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:188
msgid "是"
msgstr "是"

#. placeholder {0}: unappliedBusinessDistrictScope.displayName
#: apps/dp-client/src/screens/home/pages/ShopList/components/LocationTip/index.tsx:67
msgid "是，前往查看{0}"
msgstr "是，前往查看{0}"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:64
msgid "是否下單"
msgstr "是否下單"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:801
msgid "是否保留草稿"
msgstr "是否保留草稿"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:749
msgid "是否停用結帳服務？"
msgstr "是否停用結帳服務？"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:365
msgid "是否允許疊加"
msgstr "是否允許疊加"

#: apps/dp-client/src/screens/reservation/pages/main/components/ConflictModal.tsx:46
msgid "是否取消原預訂，改為本次新預訂？"
msgstr "是否取消原預訂，改為本次新預訂？"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:418
msgid "是否取消應用綁定"
msgstr "是否取消應用綁定"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2343
msgid "是否可使用包廂"
msgstr "是否可使用包廂"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:450
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:590
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2324
msgid "是否可用包廂"
msgstr "是否可用包廂"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:446
msgid "是否可疊加優惠"
msgstr "是否可疊加優惠"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:390
msgid "是否可與平台活動同時使用"
msgstr "是否可與平台活動同時使用"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:246
msgid "是否可跳過"
msgstr "是否可跳過"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:132
msgid "是否可重發"
msgstr "是否可重發"

#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:146
msgid "是否在列表頁頭圖上顯示"
msgstr "是否在列表頁頭圖上顯示"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:281
msgid "是否在商家詳情頁展示"
msgstr "是否在商家詳情頁展示"

#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:175
msgid "是否在商詳頁顯示"
msgstr "是否在商詳頁顯示"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:626
msgid "是否在用戶端商家列表頁展示"
msgstr "是否在用戶端商家列表頁展示"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:775
msgid "是否在用戶端商家詳情頁展示"
msgstr "是否在用戶端商家詳情頁展示"

#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:261
msgid "是否將所有消息標為已讀？"
msgstr "是否將所有消息標為已讀？"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:52
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:111
msgid "是否平台活動"
msgstr "是否平台活動"

#. placeholder {0}: unappliedBusinessDistrictScope.displayName
#: apps/dp-client/src/screens/home/pages/ShopList/components/AllRegionTip/index.tsx:81
msgid "是否想搜{0}"
msgstr "是否想搜{0}"

#. placeholder {0}: unappliedBusinessDistrictScope.displayName
#: apps/dp-client/src/screens/home/pages/ShopList/components/AllRegionTip/index.tsx:80
msgid "是否想搜{businessDistrictCityName}的{0}"
msgstr "是否想搜{businessDistrictCityName}的{0}"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:64
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:45
msgid "是否有圖片"
msgstr "是否有圖片"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:90
msgid "是否有庫存"
msgstr "是否有庫存"

#: apps/dp-client/src/screens/login/pages/account-info/index.tsx:86
msgid "是否沿用該帳號登入？"
msgstr "是否沿用該帳號登入？"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCommonColumns.tsx:59
msgid "是否為免開發票"
msgstr "是否為免開發票"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:937
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/ContractSettings/index.web.tsx:36
msgid "是否為免開發票商家"
msgstr "是否為免開發票商家"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:199
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:159
msgid "是否為第三方活動"
msgstr "是否為第三方活動"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:233
msgid "是否為重定向路由"
msgstr "是否為重定向路由"

#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:437
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:959
msgid "是否現在回傳第三方？"
msgstr "是否現在回傳第三方？"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:101
msgid "是否留存(30天)"
msgstr "是否留存(30天)"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:89
msgid "是否留存(7天)"
msgstr "是否留存(7天)"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:45
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:576
msgid "是否百貨"
msgstr "是否百貨"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/index.tsx:937
msgid "是否直接發布"
msgstr "是否直接發布"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:771
msgid "是否確認停用"
msgstr "是否確認停用"

#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:359
msgid "是否確認刪除留言？"
msgstr "是否確認刪除留言？"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:228
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:169
msgid "是否確認此批量操作？"
msgstr "是否確認此批量操作？"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:994
msgid "是否確認發佈"
msgstr "是否確認發佈"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:119
msgid "是否確認註銷？"
msgstr "是否確認註銷？"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:107
msgid "是否第三方活動"
msgstr "是否第三方活動"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:44
msgid "是否綁定郵箱"
msgstr "是否綁定郵箱"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:37
msgid "是否綁定門號"
msgstr "是否綁定門號"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:445
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:110
msgid "是否聯繫成功"
msgstr "是否聯繫成功"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:531
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:228
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowUserListItem.tsx:118
msgid "是否要取消追蹤？"
msgstr "是否要取消追蹤？"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:153
msgid "是否要打開相冊？"
msgstr "是否要打開相冊？"

#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:438
msgid "是否要現在將權益信息回傳至第三方？若選擇現在不回傳，可進入權益發放明細中手動觸發回傳。"
msgstr "是否要現在將權益信息回傳至第三方？若選擇現在不回傳，可進入權益發放明細中手動觸發回傳。"

#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:960
msgid "是否要現在將權益資訊回傳至第三方？若選擇現在不回傳，可進入權益發放明細中手動觸發回傳。"
msgstr "是否要現在將權益資訊回傳至第三方？若選擇現在不回傳，可進入權益發放明細中手動觸發回傳。"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:125
msgid "是否評價"
msgstr "是否評價"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:52
msgid "是否評論"
msgstr "是否評論"

#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:164
msgid "是否開啟"
msgstr "是否開啟"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:238
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:112
msgid "是否需人工介入"
msgstr "是否需人工介入"

#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:395
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:491
msgid "是否需要保存草稿？"
msgstr "是否需要保存草稿？"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:293
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:147
msgid "是否需要商家報名"
msgstr "是否需要商家報名"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:251
msgid "是否需要確認使用"
msgstr "是否需要確認使用"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2173
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2139
msgid "是否需要預約"
msgstr "是否需要預約"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:100
msgid "是否需預約"
msgstr "是否需預約"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:69
msgid "是否首單"
msgstr "是否首單"

#: apps/dp-client/src/screens/home/pages/PackageZone/templates/ActivityTemplate.tsx:166
#: apps/dp-client/src/screens/home/pages/PackageZone/templates/ActivityTemplate.tsx:178
msgid "時"
msgstr "時"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:242
msgid "時分"
msgstr "時分"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1436
#: apps/dp-business/src/pages/ReservationManagement/TableCells.tsx:37
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1684
#: apps/dp-admin/src/components/BusinessHours/utils.ts:464
#: apps/dp-admin/src/components/BusinessHours/components/BusinessStatusSelector.web.tsx:278
msgid "時段"
msgstr "時段"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:341
msgid "時段信息"
msgstr "時段信息"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:970
msgid "時段已啟用"
msgstr "時段已啟用"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:970
msgid "時段已禁用"
msgstr "時段已禁用"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1444
#: apps/dp-business/src/pages/ReservationManagement/TableCells.tsx:53
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2496
#: apps/dp-business/src/pages/BusinessStatus/index.tsx:418
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1303
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1458
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:455
#: apps/dp-admin/src/pages/org-tree/org-list/components/ShelfHistoryModal/index.web.tsx:49
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:172
#: apps/dp-admin/src/pages/marketing/verification-record-detail/components/StatusLogTable/index.web.tsx:24
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1117
msgid "時間"
msgstr "時間"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1010
msgid "時間 "
msgstr "時間 "

#: apps/dp-business/src/pages/VideoUpload/index.tsx:213
msgid "時間30-60秒為佳，支援 MP4、MOV格式，檔案大小不超過 100MB"
msgstr "時間30-60秒為佳，支援 MP4、MOV格式，檔案大小不超過 100MB"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:74
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:131
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:141
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:195
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:220
msgid "時間區間"
msgstr "時間區間"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1528
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1982
#: apps/dp-admin/src/pages/marketing/services/constants.ts:449
msgid "時間段"
msgstr "時間段"

#. placeholder {0}: index + 1
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:546
msgid "時間段{0}"
msgstr "時間段{0}"

#: apps/dp-admin/src/pages/transaction/service/help/validate.ts:116
msgid "時間段不連續，請檢查後提交"
msgstr "時間段不連續，請檢查後提交"

#: apps/dp-admin/src/pages/transaction/service/help/validate.ts:219
msgid "時間段存在空值，請檢查後提交"
msgstr "時間段存在空值，請檢查後提交"

#: apps/dp-admin/src/pages/transaction/service/help/validate.ts:57
msgid "時間段存在重疊，請檢查後提交"
msgstr "時間段存在重疊，請檢查後提交"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:738
msgid "時間段重疊，請調整時間設置"
msgstr "時間段重疊，請調整時間設置"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:1177
msgid "時間段重疊，請重新設定"
msgstr "時間段重疊，請重新設定"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:735
msgid "時間段重疊：{errorMessage}，請調整時間設置"
msgstr "時間段重疊：{errorMessage}，請調整時間設置"

#: apps/dp-admin/src/pages/transaction/service/help/validate.ts:102
msgid "時間段順序錯誤，請檢查後提交"
msgstr "時間段順序錯誤，請檢查後提交"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:87
msgid "時間範圍"
msgstr "時間範圍"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/useChainReport.ts:153
msgid "時間範圍不能為空"
msgstr "時間範圍不能為空"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:66
msgid "時間設定"
msgstr "時間設定"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:337
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:715
msgid "時間設定校驗失敗"
msgstr "時間設定校驗失敗"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:269
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:630
msgid "時間設定校驗失敗，請檢查後重試"
msgstr "時間設定校驗失敗，請檢查後重試"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:240
msgid "時間設置"
msgstr "時間設置"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:629
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:826
msgid "時間間隔"
msgstr "時間間隔"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:128
msgid "時間順序好像填錯咯"
msgstr "時間順序好像填錯咯"

#: apps/dp-business/src/types/orderFilter.ts:197
#: apps/dp-business/src/store/ReservationRulesContext.tsx:121
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:482
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:420
#: apps/dp-business/src/constants/enums.ts:52
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:263
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1254
#: apps/dp-admin/src/components/BusinessHours/constants.ts:47
msgid "晚餐"
msgstr "晚餐"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:124
msgid "晚餐時段"
msgstr "晚餐時段"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:31
msgid "普普通通"
msgstr "普普通通"

#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:247
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:247
msgid "景觀位"
msgstr "景觀位"

#: apps/dp-client/src/screens/home/utils/filterData.ts:111
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:183
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:740
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/CategoryQuickChips.tsx:71
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:404
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:372
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:192
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:201
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:202
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:18
msgid "智慧排序"
msgstr "智慧排序"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:321
msgid "暈影"
msgstr "暈影"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:298
msgid "暖"
msgstr "暖"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:132
#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:109
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:242
#: apps/dp-client/src/screens/reservation/components/ConfirmModal/index.tsx:24
msgid "暫不取消"
msgstr "暫不取消"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1085
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1120
msgid "暫不可報名"
msgstr "暫不可報名"

#: apps/dp-client/src/screens/home/pages/PackageZone/index.tsx:894
msgid "暫不支持此落地頁類型"
msgstr "暫不支持此落地頁類型"

#. placeholder {0}: pageType || '未知'
#: apps/dp-admin/src/pages/audit-center/audit-detail-redirect/index.web.tsx:50
msgid "暫不支持的審核類型：{0}"
msgstr "暫不支持的審核類型：{0}"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:392
msgid "暫不符合領取資格"
msgstr "暫不符合領取資格"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:294
#: apps/dp-business/src/pages/BusinessStatus/index.tsx:337
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:308
#: apps/dp-admin/src/pages/merchant/shop-detail/components/ShopClosedImpactModal/index.web.tsx:59
msgid "暫不變更"
msgstr "暫不變更"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:377
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:93
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:460
msgid "暫停"
msgstr "暫停"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:266
msgid "暫停／恢復活動失敗，請稍後重試"
msgstr "暫停／恢復活動失敗，請稍後重試"

#: apps/dp-client/src/utils/businessStatus.ts:312
msgid "暫停兌換，請至其他分店使用"
msgstr "暫停兌換，請至其他分店使用"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1037
msgid "暫停參與"
msgstr "暫停參與"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:502
msgid "暫停參與失敗，請稍後重試"
msgstr "暫停參與失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:444
msgid "暫停活動失敗"
msgstr "暫停活動失敗"

#: apps/dp-client/src/utils/businessStatus.ts:218
#: apps/dp-client/src/screens/home/utils/businessStatus.ts:24
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:112
#: apps/dp-business/src/constants/enums.ts:479
#: apps/dp-admin/src/pages/merchant/service/constants.ts:490
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:61
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:85
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:99
#: apps/dp-admin/src/modules/constants/options.ts:580
msgid "暫停營業"
msgstr "暫停營業"

#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:223
msgid "暫存並退出"
msgstr "暫存並退出"

#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/UsergiftBanner.tsx:235
msgid "暫時未獲取到券的內容"
msgstr "暫時未獲取到券的內容"

#: apps/dp-client/src/screens/home/components/CitySelect/CityModal.tsx:207
#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:381
msgid "暫時沒有地區資訊"
msgstr "暫時沒有地區資訊"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:183
msgid "暫時沒有符合條件的活動喔～"
msgstr "暫時沒有符合條件的活動喔～"

#: apps/dp-client/src/screens/diary/pages/home/components/shop-list-section/index.tsx:43
msgid "暫時無法取得店家資訊"
msgstr "暫時無法取得店家資訊"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:99
msgid "暫時無法產生變更對比，無法標出具體改動（原因代碼：{reason}）。"
msgstr "暫時無法產生變更對比，無法標出具體改動（原因代碼：{reason}）。"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:394
msgid "暫時無法領取"
msgstr "暫時無法領取"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:595
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BlueNewContractTab/index.web.tsx:142
msgid "暫時藍新簽約只支持本國籍企業"
msgstr "暫時藍新簽約只支持本國籍企業"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:96
msgid "暫未取得變更對比資料，無法標出具體改動。"
msgstr "暫未取得變更對比資料，無法標出具體改動。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:123
msgid "暫未指定"
msgstr "暫未指定"

#: apps/dp-client/src/screens/home/pages/Home/components/HotRanking/index.tsx:381
msgid "暫未獲取到該榜單數據"
msgstr "暫未獲取到該榜單數據"

#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:86
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:314
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedMallTable/index.web.tsx:155
msgid "暫未設置"
msgstr "暫未設置"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/hooks.ts:34
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/hooks.ts:35
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/hooks.ts:41
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/hooks.ts:43
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/hooks.ts:44
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:71
msgid "暫無"
msgstr "暫無"

#. placeholder {0}: category.categoryName
#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:459
msgid "暫無{0}選項"
msgstr "暫無{0}選項"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:570
msgid "暫無POI審核數據"
msgstr "暫無POI審核數據"

#: apps/dp-admin/src/pages/audit-center/components/PublishOperationLogsCard/index.web.tsx:79
msgid "暫無上下架記錄"
msgstr "暫無上下架記錄"

#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:381
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:368
msgid "暫無上傳文件"
msgstr "暫無上傳文件"

#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:213
msgid "暫無上傳的圖片"
msgstr "暫無上傳的圖片"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:397
msgid "暫無不可用優惠券"
msgstr "暫無不可用優惠券"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/PublishPreviewModal.web.tsx:69
msgid "暫無中獎用戶"
msgstr "暫無中獎用戶"

#: apps/dp-client/src/screens/home/utils/location.ts:350
#: apps/dp-client/src/screens/home/utils/location.ts:362
#: apps/dp-client/src/screens/home/utils/location.ts:370
#: apps/dp-client/src/screens/home/utils/location.ts:380
#: apps/dp-client/src/screens/home/utils/location.ts:415
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopLocationInfo.tsx:123
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:65
msgid "暫無交通訊息"
msgstr "暫無交通訊息"

#: apps/dp-client/src/screens/diary/components/task-card/index.tsx:157
msgid "暫無任務資訊"
msgstr "暫無任務資訊"

#: apps/dp-admin/src/pages/audit-center/user-audit/components/UserBasicInfo/index.web.tsx:69
msgid "暫無使用者資料"
msgstr "暫無使用者資料"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1339
msgid "暫無使用記錄資料"
msgstr "暫無使用記錄資料"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:587
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:591
msgid "暫無使用須知"
msgstr "暫無使用須知"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:843
msgid "暫無停車場資料"
msgstr "暫無停車場資料"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/index.web.tsx:92
msgid "暫無停車場配置"
msgstr "暫無停車場配置"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:48
msgid "暫無優惠買點佣金規則數據"
msgstr "暫無優惠買點佣金規則數據"

#: apps/dp-client/src/screens/diary/pages/my/pages/terms/index.tsx:86
#: apps/dp-business/src/components/MaintenanceList/index.tsx:561
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityDescriptionField/PreviewModal.web.tsx:62
#: apps/dp-admin/src/components/RichTextEditor/components/Preview.web.tsx:42
msgid "暫無內容"
msgstr "暫無內容"

#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:247
msgid "暫無其他超管門市"
msgstr "暫無其他超管門市"

#: apps/dp-admin/src/pages/marketing/components/OverviewSection/index.web.tsx:140
msgid "暫無分佈數據"
msgstr "暫無分佈數據"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1102
msgid "暫無分區數據，請先在桌位管理中添加分區"
msgstr "暫無分區數據，請先在桌位管理中添加分區"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/TextMenu/components/CategoryList.tsx:61
msgid "暫無分類"
msgstr "暫無分類"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:741
#: apps/dp-business/src/pages/AddStore/CategoryPage.tsx:233
msgid "暫無分類資料"
msgstr "暫無分類資料"

#: apps/dp-business/src/pages/AddStore/index.tsx:819
msgid "暫無分類資料，請稍後重試"
msgstr "暫無分類資料，請稍後重試"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:518
msgid "暫無到店指引"
msgstr "暫無到店指引"

#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:258
msgid "暫無匹配的品牌"
msgstr "暫無匹配的品牌"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:770
msgid "暫無區域資料"
msgstr "暫無區域資料"

#: apps/dp-admin/src/pages/marketing/components/GroupExcelDownload/index.web.tsx:36
msgid "暫無可下載文件"
msgstr "暫無可下載文件"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:282
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:161
msgid "暫無可匯出的資料"
msgstr "暫無可匯出的資料"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:322
msgid "暫無可授予的功能權限"
msgstr "暫無可授予的功能權限"

#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:351
msgid "暫無可授權的菜單"
msgstr "暫無可授權的菜單"

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:466
msgid "暫無可用任務"
msgstr "暫無可用任務"

#: apps/dp-client/src/screens/home/pages/Purchase/components/PurchaseModal/index.tsx:282
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:397
msgid "暫無可用優惠券"
msgstr "暫無可用優惠券"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:679
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:224
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:224
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:187
msgid "暫無可用模板"
msgstr "暫無可用模板"

#: apps/dp-business/src/store/PerspectiveContext.tsx:368
msgid "暫無可用的連鎖視角"
msgstr "暫無可用的連鎖視角"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:400
msgid "暫無可發放的抽獎批次"
msgstr "暫無可發放的抽獎批次"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageScopeSection/index.web.tsx:199
msgid "暫無可選店家"
msgstr "暫無可選店家"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:208
msgid "暫無可選結算起點"
msgstr "暫無可選結算起點"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:417
msgid "暫無可選角色"
msgstr "暫無可選角色"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:282
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:407
msgid "暫無可選類別，請先新增類別"
msgstr "暫無可選類別，請先新增類別"

#: apps/dp-client/src/screens/reservation/components/ReservationTimeSelector/index.tsx:112
msgid "暫無可預訂時段"
msgstr "暫無可預訂時段"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/MallShopList/index.tsx:321
#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:116
msgid "暫無商家"
msgstr "暫無商家"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/DetailMobile/index.web.tsx:62
msgid "暫無商家資料"
msgstr "暫無商家資料"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:200
msgid "暫無商業登記副本資訊"
msgstr "暫無商業登記副本資訊"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/DishDetail/DishDetailPage.tsx:222
#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantImages/index.web.tsx:119
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:154
#: apps/dp-admin/src/components/PrivateImage/index.web.tsx:87
msgid "暫無圖片"
msgstr "暫無圖片"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:508
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:610
msgid "暫無地址"
msgstr "暫無地址"

#: apps/dp-business/src/pages/MarketingCenter/components/StoreSelectionCard.tsx:108
#: apps/dp-business/src/pages/MarketingCenter/components/StoreSelectionCard.tsx:132
msgid "暫無地址資訊"
msgstr "暫無地址資訊"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:247
msgid "暫無套餐"
msgstr "暫無套餐"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:18
msgid "暫無套餐券佣金規則數據"
msgstr "暫無套餐券佣金規則數據"

#: apps/dp-admin/src/pages/marketing/components/CouponInfoSection/index.web.tsx:57
msgid "暫無套餐券資訊"
msgstr "暫無套餐券資訊"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:644
msgid "暫無套餐數據"
msgstr "暫無套餐數據"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:86
msgid "暫無定位收費規則數據"
msgstr "暫無定位收費規則數據"

#: apps/dp-admin/src/pages/audit-center/components/AuditIssuesList/index.web.tsx:132
msgid "暫無審核問題"
msgstr "暫無審核問題"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:61
msgid "暫無審核數據"
msgstr "暫無審核數據"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/index.web.tsx:191
msgid "暫無審核聚合數據"
msgstr "暫無審核聚合數據"

#: apps/dp-admin/src/pages/audit-center/components/AuditInfoHeader/index.web.tsx:63
msgid "暫無審核資料"
msgstr "暫無審核資料"

#: apps/dp-client/src/screens/help/pages/help/index.tsx:146
msgid "暫無幫助內容"
msgstr "暫無幫助內容"

#: apps/dp-client/src/screens/home/pages/MerchantGroup/index.tsx:241
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:488
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:608
msgid "暫無店家"
msgstr "暫無店家"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:782
msgid "暫無店家信息"
msgstr "暫無店家信息"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:703
msgid "暫無店家影片"
msgstr "暫無店家影片"

#: apps/dp-client/src/screens/account/pages/favorites/pages/searchResult/index.tsx:284
msgid "暫無店家結果"
msgstr "暫無店家結果"

#: apps/dp-business/src/pages/MarketingCenter/components/StoreSelectionCard.tsx:311
#: apps/dp-business/src/components/StoreSelector/index.tsx:562
msgid "暫無店家資料"
msgstr "暫無餐廳資料"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BasicInfoTab/index.web.tsx:80
msgid "暫無店家資訊"
msgstr "暫無店家資訊"

#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:76
msgid "暫無影響數據"
msgstr "暫無影響數據"

#: apps/dp-admin/src/modules/constants/options.ts:103
msgid "暫無意願"
msgstr "暫無意願"

#: apps/dp-client/src/screens/diary/pages/merchant/index.tsx:198
msgid "暫無懸賞任務"
msgstr "暫無懸賞任務"

#: apps/dp-business/src/pages/ComplaintList/index.tsx:172
msgid "暫無投訴記錄"
msgstr "暫無投訴記錄"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:74
msgid "暫無折扣規則"
msgstr "暫無折扣規則"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/SignatureDishes/SignatureDishesPage.tsx:84
msgid "暫無招牌菜推薦"
msgstr "暫無招牌菜推薦"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:463
#: apps/dp-business/src/components/MaintenanceList/index.tsx:485
#: apps/dp-business/src/components/MaintenanceList/index.tsx:507
msgid "暫無指引"
msgstr "暫無指引"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:365
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:567
msgid "暫無指引資訊"
msgstr "暫無指引資訊"

#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:459
msgid "暫無捷運設定"
msgstr "暫無捷運設定"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/ScanQrCodeModal.web.tsx:62
msgid "暫無掃碼網址"
msgstr "暫無掃碼網址"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:187
msgid "暫無排行榜數據"
msgstr "暫無排行榜數據"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:462
msgid "暫無排行獎勵活動"
msgstr "暫無排行獎勵活動"

#: apps/dp-client/src/screens/home/pages/Home/components/RecommendMasonryList/index.tsx:649
msgid "暫無推薦內容"
msgstr "暫無推薦內容"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityListSection.tsx:92
msgid "暫無推薦活動"
msgstr "暫無推薦活動"

#: apps/dp-client/src/screens/diary/pages/home/components/shop-list-section/index.tsx:53
msgid "暫無推薦餐廳，請更換城市查找吧"
msgstr "暫無推薦餐廳，請更換城市查詢"

#: apps/dp-client/src/screens/account/pages/advice/my-feedback/index.tsx:283
msgid "暫無提問記錄"
msgstr "暫無提問記錄"

#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/components/FloatingList.tsx:91
msgid "暫無搜尋結果"
msgstr "暫無搜尋結果"

#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:595
msgid "暫無操作日誌"
msgstr "暫無操作日誌"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:188
msgid "暫無操作歷史"
msgstr "暫無操作歷史"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:709
msgid "暫無收費方案"
msgstr "暫無收費方案"

#: apps/dp-business/src/pages/SimpleDashboard/SimpleLayout.tsx:206
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1169
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:487
msgid "暫無收銀記錄"
msgstr "暫無收銀記錄"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1480
msgid "暫無改動，無需提交"
msgstr "暫無改動，無需提交"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:2067
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1100
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ResponsiveChart.tsx:135
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/CouponDetailModal/index.web.tsx:109
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/CouponDetailModal/index.web.tsx:119
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:76
msgid "暫無數據"
msgstr "暫無數據"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/FixedPackageImportField/index.web.tsx:219
msgid "暫無數據，請導入 Excel"
msgstr "暫無數據，請導入 Excel"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:307
msgid "暫無數據，請搜索"
msgstr "暫無數據，請搜索"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageCouponPicker/index.web.tsx:196
msgid "暫無數據，請輸入關鍵詞或條件後點擊搜索"
msgstr "暫無數據，請輸入關鍵詞或條件後點擊搜索"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/DynamicConditionField/index.web.tsx:118
msgid "暫無數據，請選擇店家組或條件後點擊查詢"
msgstr "暫無數據，請選擇店家組或條件後點擊查詢"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:324
msgid "暫無數據，請點擊篩選預覽"
msgstr "暫無數據，請點擊篩選預覽"

#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:165
msgid "暫無明細"
msgstr "暫無明細"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/ShopList/ShopList.tsx:350
msgid "暫無更多店家"
msgstr "暫無更多店家"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:206
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CurrentCommissionCard.web.tsx:47
msgid "暫無有效比例佣金設置"
msgstr "暫無有效比例佣金設置"

#: apps/dp-business/src/pages/ChainDashboard/index.tsx:137
msgid "暫無有效連鎖授權"
msgstr "暫無有效連鎖授權"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:417
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:487
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:639
#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:186
msgid "暫無服務數據"
msgstr "暫無服務數據"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/index.tsx:183
msgid "暫無核銷數據"
msgstr "暫無核銷數據"

#: apps/dp-business/src/pages/TableManagement/index.tsx:1169
msgid "暫無桌位數據"
msgstr "暫無桌位數據"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:760
msgid "暫無桌位數據，請先在桌位管理中添加分區和桌位"
msgstr "暫無桌位數據，請先在桌位管理中添加分區和桌位"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:236
msgid "暫無業務結算項資料"
msgstr "暫無業務結算項資料"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:343
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantTags/index.web.tsx:82
msgid "暫無標籤"
msgstr "暫無標籤"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantTags/index.web.tsx:82
msgid "暫無標籤，請新增"
msgstr "暫無標籤，請新增"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/StepSelectType/index.web.tsx:48
msgid "暫無模板"
msgstr "暫無模板"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:127
msgid "暫無模板詳情"
msgstr "暫無模板詳情"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/DisplayFieldWithPreview/index.web.tsx:98
msgid "暫無樣式圖"
msgstr "暫無樣式圖"

#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:76
msgid "暫無權益詳情"
msgstr "暫無權益詳情"

#: apps/dp-business/src/pages/AddRole/index.tsx:429
msgid "暫無權限資料，請聯絡管理員"
msgstr "暫無權限資料，請聯絡管理員"

#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/index.tsx:332
#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/index.tsx:335
msgid "暫無此榜單資料"
msgstr "暫無此榜單資料"

#: apps/dp-client/src/screens/home/pages/Ranking/DishRank/index.tsx:282
#: apps/dp-client/src/screens/home/pages/Ranking/DishRank/index.tsx:285
msgid "暫無此餐點榜單資料"
msgstr "暫無此餐點榜單資料"

#: apps/dp-client/src/screens/home/pages/Search/index.tsx:645
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:557
msgid "暫無歷史搜尋記錄"
msgstr "暫無歷史搜尋記錄"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/common/HistorySection/index.web.tsx:56
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditRecordsModal/index.web.tsx:120
msgid "暫無歷史資訊"
msgstr "暫無歷史資訊"

#: apps/dp-business/src/servers/chain/settlementApi.ts:279
#: apps/dp-business/src/hooks/useShopChainTakeover.ts:48
msgid "暫無法取得接管狀態"
msgstr "暫無法取得接管狀態"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:399
msgid "暫無活動"
msgstr "暫無活動"

#: apps/dp-client/src/screens/home/pages/PackageZone/pages/ActivityDescription/index.tsx:188
#: apps/dp-client/src/screens/account/pages/task-wall/pages/activity-description/index.tsx:104
msgid "暫無活動說明"
msgstr "暫無活動說明"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:397
msgid "暫無消息通知"
msgstr "暫無消息通知"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1600
msgid "暫無營業時段數據，請先在店家管理中設置營業時間"
msgstr "暫無營業時段數據，請先在店家管理中設置營業時間"

#: apps/dp-client/src/utils/businessStatus.ts:173
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:235
msgid "暫無營業時間"
msgstr "暫無營業時間"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:116
msgid "暫無營銷服務時間數據"
msgstr "暫無營銷服務時間數據"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1166
msgid "暫無特殊營業時間，請先在營業時間設定中新增"
msgstr "暫無特殊營業時間，請先在營業時間設定中新增"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1878
msgid "暫無特殊營業時間，請先在營業時間設定中新增特殊營業日期"
msgstr "暫無特殊營業時間，請先在營業時間設定中新增特殊營業日期"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2082
msgid "暫無特殊營業時間可選，您可以先去營業時間創建特殊營業時間段"
msgstr "暫無特殊營業時間可選，您可以先去營業時間創建特殊營業時間段"

#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:240
msgid "暫無特殊營業時間設定"
msgstr "暫無特殊營業時間設定"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/utils/activityUtils.ts:147
msgid "暫無狀態"
msgstr "暫無狀態"

#: apps/dp-client/src/screens/diary/pages/rank/components/rank-item.tsx:50
msgid "暫無獎勵"
msgstr "暫無獎勵"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/PreviewConfirmModal/index.web.tsx:68
msgid "暫無用戶名單，請更新篩選條件"
msgstr "暫無用戶名單，請更新篩選條件"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserInfoCard/index.web.tsx:39
msgid "暫無用戶資訊"
msgstr "暫無用戶資訊"

#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:158
msgid "暫無發票資訊"
msgstr "暫無發票資訊"

#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:173
msgid "暫無相關任務"
msgstr "暫無相關任務"

#: apps/dp-client/src/screens/account/pages/advice/advice-feedback/index.tsx:123
msgid "暫無相關問題"
msgstr "暫無相關問題"

#: apps/dp-admin/src/pages/merchant/components/LatestTaskPrompt/index.web.tsx:34
msgid "暫無相關工單"
msgstr "暫無相關工單"

#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:393
msgid "暫無相關捷運"
msgstr "暫無相關捷運"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:393
msgid "暫無符合條件的三級渠道，請調整篩選條件，或確認渠道已建立至第三級"
msgstr "暫無符合條件的三級渠道，請調整篩選條件，或確認渠道已建立至第三級"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:454
msgid "暫無符合條件的套餐券"
msgstr "暫無符合條件的套餐券"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:235
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityFilterCard.tsx:182
msgid "暫無符合條件的活動"
msgstr "暫無符合條件的活動"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:271
msgid "暫無筆記"
msgstr "暫無筆記"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/OrgNodeTree/index.web.tsx:180
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:147
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:222
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeMountNodeModal.web.tsx:166
msgid "暫無節點"
msgstr "暫無節點"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:420
msgid "暫無管理掛接"
msgstr "暫無管理掛接"

#: apps/dp-business/src/pages/ChainDashboard/components/ChainErrorState.tsx:39
msgid "暫無組織架構"
msgstr "暫無組織架構"

#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowListScene.tsx:88
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowListScene.tsx:91
msgid "暫無結果"
msgstr "暫無結果"

#: apps/dp-client/src/screens/home/pages/ShopList/components/AllRegionTip/index.tsx:84
msgid "暫無結果，已為您擴大範圍"
msgstr "暫無結果，已為您擴大範圍"

#: apps/dp-admin/src/pages/marketing/components/OverviewSection/index.web.tsx:73
msgid "暫無統計數據"
msgstr "暫無統計數據"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:276
msgid "暫無綁定審核數據"
msgstr "暫無綁定審核數據"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:424
msgid "暫無網友指引"
msgstr "暫無網友指引"

#: apps/dp-client/src/configs/page-configs.tsx:19
msgid "暫無網路"
msgstr "暫無網路"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/OnlineShopList/index.tsx:143
msgid "暫無線上通路店家"
msgstr "暫無線上通路店家"

#: apps/dp-client/src/screens/home/pages/Note/pages/draft/index.tsx:211
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:267
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:334
msgid "暫無草稿"
msgstr "暫無草稿"

#: apps/dp-client/src/screens/account/pages/drafts/main/index.tsx:384
msgid "暫無草稿數據"
msgstr "暫無草稿資訊"

#: apps/dp-client/src/screens/home/pages/Purchase/components/SelectDishContent/index.tsx:384
msgid "暫無菜品"
msgstr "暫無菜單"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:375
msgid "暫無菜品，請添加菜品"
msgstr "暫無餐點，請添加餐點"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/TextMenu/index.tsx:98
msgid "暫無菜單資訊"
msgstr "暫無菜單資訊"

#: apps/dp-client/src/screens/home/pages/PackageZone/index.tsx:878
msgid "暫無落地頁內容"
msgstr "暫無落地頁內容"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/Details.web.tsx:140
msgid "暫無處理明細"
msgstr "暫無處理明細"

#: apps/dp-admin/src/pages/worker-order/components/ProcessTimeline.web.tsx:25
msgid "暫無處理紀錄"
msgstr "暫無處理紀錄"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:667
msgid "暫無複製記錄"
msgstr "暫無複製記錄"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:122
msgid "暫無規則說明"
msgstr "暫無規則說明"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:63
msgid "暫無規則配置"
msgstr "暫無規則配置"

#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:58
msgid "暫無角色詳情"
msgstr "暫無角色詳情"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityListSection.tsx:118
msgid "暫無解鎖中活動"
msgstr "暫無解鎖中活動"

#: apps/dp-client/src/screens/account/pages/order/index.tsx:474
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:250
msgid "暫無訂單"
msgstr "暫無訂單"

#: apps/dp-business/src/pages/OrderList/index.tsx:1012
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/index.tsx:154
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/index.tsx:199
msgid "暫無訂單數據"
msgstr "暫無訂單數據"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:926
msgid "暫無設定"
msgstr "暫無設定"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:516
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:926
msgid "暫無設定，點擊上方按鈕添加"
msgstr "暫無設定，點擊上方按鈕添加"

#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:496
msgid "暫無設施資料"
msgstr "暫無設施資料"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:420
msgid "暫無設施資訊"
msgstr "暫無設施資訊"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsList.tsx:165
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsList.tsx:243
msgid "暫無評價"
msgstr "暫無評價"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingDistribution.web.tsx:257
msgid "暫無評價分佈資料"
msgstr "暫無評價分佈資料"

#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:102
msgid "暫無評價資料"
msgstr "暫無評價資料"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopBasicInfo.tsx:141
#: apps/dp-client/src/screens/home/pages/PrivateChef/components/PrivateChefShopCard/index.tsx:170
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/ShopHeader.tsx:71
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/ShopHeader.tsx:137
#: apps/dp-client/src/screens/home/pages/Home/components/RecommendMasonryList/RecommendCard/Shop.tsx:151
#: apps/dp-client/src/screens/home/pages/FoodMap/components/HorizontalShopCard.tsx:149
#: apps/dp-client/src/screens/home/pages/FoodMap/components/ShopList/MapShopCard.tsx:158
#: apps/dp-client/src/screens/home/components/ShopCardRank/index.tsx:84
#: apps/dp-client/src/screens/home/components/ShopCard/index.tsx:376
msgid "暫無評分"
msgstr "暫無評分"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:716
#: apps/dp-admin/src/pages/data-center/merchant-reviews/index.web.tsx:195
msgid "暫無評論"
msgstr "暫無評論"

#: apps/dp-client/src/screens/account/pages/advice/advice-detail/index.tsx:151
msgid "暫無詳細內容"
msgstr "暫無詳細內容"

#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:103
msgid "暫無說明"
msgstr "暫無說明"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:314
msgid "暫無負責人資訊"
msgstr "暫無負責人資訊"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:826
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1844
#: apps/dp-business/src/pages/CustomerReviews/components/TrendChartSection.tsx:180
#: apps/dp-business/src/pages/CustomerReviews/components/KeywordStatsSection.tsx:148
#: apps/dp-business/src/components/Table.tsx:1218
#: apps/dp-business/src/components/CascadeSelector/index.tsx:399
#: apps/dp-admin/src/pages/users/permissions/components/PermissionTreeTable/index.web.tsx:193
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/index.web.tsx:53
#: apps/dp-admin/src/pages/merchant/information-review/index.web.tsx:91
#: apps/dp-admin/src/pages/merchant/components/CommTable/index.web.tsx:61
#: apps/dp-admin/src/pages/merchant/components/CityDistrictSelector/index.web.tsx:160
#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:91
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/index.web.tsx:106
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityCharts.web.tsx:125
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityCharts.web.tsx:177
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:357
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewTrendChart.web.tsx:119
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/RatingDistributionChart.web.tsx:105
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingTrend.web.tsx:161
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:226
#: apps/dp-admin/src/pages/audit-center/components/MerchantInfoCard/index.web.tsx:107
#: apps/dp-admin/src/components/DataTable/index.web.tsx:91
msgid "暫無資料"
msgstr "暫無資料"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:370
msgid "暫無資訊"
msgstr "暫無資訊"

#: apps/dp-admin/src/pages/merchant/task-list/components/FollowUpHistoryModal/index.web.tsx:119
msgid "暫無追蹤歷史記錄"
msgstr "暫無追蹤歷史記錄"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:596
msgid "暫無追蹤記錄"
msgstr "暫無追蹤記錄"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/index.tsx:142
#: apps/dp-admin/src/pages/order/order-detail/components/RefundRecords/index.web.tsx:101
msgid "暫無退款記錄"
msgstr "暫無退款記錄"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:983
msgid "暫無通知"
msgstr "暫無通知"

#: apps/dp-client/src/screens/home/pages/Meal/pages/shopSelect/index.tsx:331
msgid "暫無適用店家"
msgstr "暫無適用店家"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2097
msgid "暫無選中的特殊日期，點擊上方按鈕添加"
msgstr "暫無選中的特殊日期，點擊上方按鈕添加"

#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:395
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:382
msgid "暫無配置資訊"
msgstr "暫無配置資訊"

#: apps/dp-admin/src/pages/marketing/channel-management/services/useChannelImport.ts:228
msgid "暫無錯誤清單"
msgstr "暫無錯誤清單"

#: apps/dp-client/src/screens/home/pages/PrivateChef/index.tsx:311
msgid "暫無開放座位"
msgstr "暫無開放座位"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:578
msgid "暫無關聯結算單"
msgstr "暫無關聯結算單"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/KeywordStats.web.tsx:134
msgid "暫無關鍵詞資料"
msgstr "暫無關鍵詞資料"

#: apps/dp-client/src/components/CallPhoneModal/index.tsx:87
msgid "暫無電話號碼"
msgstr "暫無電話號碼"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:549
msgid "暫無項目"
msgstr "暫無項目"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:416
msgid "暫無類別"
msgstr "暫無類別"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:279
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:398
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:370
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:497
msgid "暫無餐點"
msgstr "暫無餐點"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1104
msgid "暫無餐點，請添加餐點"
msgstr "暫無餐點，請添加餐點"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:470
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:302
msgid "暫無餐點，點擊上方按鈕新增餐點"
msgstr "暫無餐點，點擊上方按鈕新增餐點"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:416
msgid "暫無餐點資料"
msgstr "暫無餐點資料"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/TextMenu/components/FoodItemList.tsx:72
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopDishGallery.tsx:72
msgid "暫無餐點資訊"
msgstr "暫無餐點資訊"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuCategorySection/index.web.tsx:156
#: apps/dp-admin/src/pages/merchant/components/MenuCategorySection/index.web.tsx:129
msgid "暫無餐點類別"
msgstr "暫無餐點類別"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:407
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:242
#: apps/dp-client/src/screens/account/pages/profile/index.tsx:140
#: apps/dp-client/src/screens/account/pages/follow-list/index.tsx:41
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:87
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:123
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/UserInfoCard/index.web.tsx:39
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/PublishPreviewModal.web.tsx:59
msgid "暱稱"
msgstr "暱稱"

#. placeholder {0}: customerUserInfo.nickname
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:49
msgid "暱稱：{0}"
msgstr "暱稱：{0}"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:97
msgid "暱稱不可用，請重新輸入"
msgstr "暱稱無法使用，請重新輸入"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:72
msgid "暱稱不能超過{MAX_LENGTH}個字符"
msgstr "暱稱長度不能超過{MAX_LENGTH}個字"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:224
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:75
msgid "暱稱只能包含中文、英文、數字、底線、點"
msgstr "暱稱只能包含中文、英文、數字、底線、點"

#: apps/dp-admin/src/pages/audit-center/services/hooks.ts:222
msgid "暴力"
msgstr "暴力"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:44
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:41
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:334
msgid "暴力、仇恨或騷擾"
msgstr "暴力、仇恨或騷擾"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:317
msgid "曝光度"
msgstr "曝光度"

#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:43
msgid "曝光數量"
msgstr "曝光數量"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityCharts.web.tsx:168
msgid "曝光次數"
msgstr "曝光次數"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityCharts.web.tsx:134
msgid "曝光次數趨勢"
msgstr "曝光次數趨勢"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopDishGallery.tsx:97
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopDishGallery.tsx:202
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/NoteModule/index.tsx:205
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/NoteModule/index.tsx:235
#: apps/dp-client/src/screens/diary/components/diary-entry/index.tsx:143
msgid "更多"
msgstr "更多"

#: apps/dp-client/src/screens/home/pages/Home/components/RecommendSetmeal/index.tsx:229
msgid "更多優惠"
msgstr "更多優惠"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:401
msgid "更多大頭照"
msgstr "更多頭像"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:469
msgid "更多套餐"
msgstr "更多套餐"

#: apps/dp-admin/src/pages/merchant/task-list/components/ActionButtons/index.web.tsx:105
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:208
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:226
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:300
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:267
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:277
msgid "更多操作"
msgstr "更多操作"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1743
msgid "更多篩選"
msgstr "更多篩選"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1223
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:512
msgid "更多評論"
msgstr "更多評論"

#: apps/dp-business/src/pages/MyProfile/index.tsx:258
#: apps/dp-business/src/pages/MyProfile/index.tsx:280
#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:97
msgid "更換"
msgstr "更換"

#: apps/dp-business/src/pages/ChangeEmail/index.tsx:72
msgid "更換Email"
msgstr "更換Email"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:127
msgid "更換商家"
msgstr "更換商家"

#: apps/dp-business/src/pages/ChangePhone/index.tsx:69
msgid "更換手機門號"
msgstr "更換手機門號"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:277
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:308
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:159
msgid "更換掛接節點"
msgstr "更換掛接節點"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:194
msgid "更換節點管理員"
msgstr "更換節點管理員"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:76
msgid "更換管理員"
msgstr "更換管理員"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:362
msgid "更換結算只改請款所走的樹，不解除管理掛接；已生成結算單不回溯。"
msgstr "更換結算只改請款所走的樹，不解除管理掛接；已生成結算單不回溯。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:172
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:175
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:155
msgid "更換結算路徑"
msgstr "更換結算路徑"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:248
msgid "更換頭像"
msgstr "更換頭像"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:461
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:595
msgid "更改BD"
msgstr "更改BD"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:869
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:900
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:135
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:153
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:873
msgid "更改分配"
msgstr "更改分配"

#: apps/dp-client/src/screens/account/pages/advice/my-feedback/index.tsx:244
msgid "更新："
msgstr "更新："

#: apps/dp-business/src/servers/contract-management/api.ts:161
msgid "更新HashIV失敗"
msgstr "更新HashIV失敗"

#: apps/dp-business/src/servers/contract-management/api.ts:138
msgid "更新HashKey失敗"
msgstr "更新HashKey失敗"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:111
#: apps/dp-admin/src/pages/users/roles/components/RoleTable/index.web.tsx:63
#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:114
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:259
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:249
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:686
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:337
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:170
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:252
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:415
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:594
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:219
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:122
msgid "更新人"
msgstr "更新人"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:326
msgid "更新人 / 時間"
msgstr "更新人 / 時間"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:351
msgid "更新分區失敗"
msgstr "更新分區失敗"

#: apps/dp-business/src/servers/reservation/api.ts:965
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:503
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:509
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:533
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:539
msgid "更新到店狀態失敗"
msgstr "更新到店狀態失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1251
#: apps/dp-admin/src/pages/marketing/services/apis.ts:1254
msgid "更新券狀態失敗"
msgstr "更新券狀態失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1193
#: apps/dp-admin/src/pages/marketing/services/apis.ts:1197
#: apps/dp-admin/src/pages/marketing/coupon-group-form/services/hooks.ts:297
msgid "更新券組失敗"
msgstr "更新券組失敗"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/services/hooks.ts:287
msgid "更新券組成功"
msgstr "更新券組成功"

#: apps/dp-business/src/servers/contract-management/api.ts:205
msgid "更新合約失敗"
msgstr "更新合約失敗"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:301
msgid "更新大頭照"
msgstr "更新大頭照"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:211
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:362
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:529
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:165
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:525
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:152
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:155
msgid "更新失敗"
msgstr "更新失敗"

#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:191
#: apps/dp-business/src/pages/BusinessStatus/index.tsx:271
msgid "更新失敗，請檢查網路連線"
msgstr "更新失敗，請檢查網路連線"

#: apps/dp-client/src/components/Version/index.tsx:25
msgid "更新失敗，請稍後再試"
msgstr "更新失敗，請稍後再試"

#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:186
msgid "更新失敗，請稍後重試"
msgstr "更新失敗，請稍後重試"

#. placeholder {0}: (response?.[0] as any)?.errorMessage
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:507
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:157
msgid "更新失敗：{0}"
msgstr "更新失敗：{0}"

#: apps/dp-business/src/servers/coupon/api.ts:168
msgid "更新套餐券模板失敗"
msgstr "更新套餐券模板失敗"

#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:222
msgid "更新居住地失敗，請稍後重試"
msgstr "更新居住地失敗，請稍後重試"

#: apps/dp-business/src/servers/chain/accountApi.ts:160
msgid "更新帳號失敗"
msgstr "更新帳號失敗"

#: apps/dp-business/src/servers/shop/api.ts:411
msgid "更新店家人均價格失敗"
msgstr "更新店家人均價格失敗"

#: apps/dp-business/src/servers/shop/api.ts:459
msgid "更新店家名稱失敗"
msgstr "更新店家名稱失敗"

#: apps/dp-business/src/servers/shop/api.ts:125
msgid "更新店家地址失敗"
msgstr "更新店家地址失敗"

#: apps/dp-business/src/servers/shop/api.ts:387
msgid "更新店家描述失敗"
msgstr "更新店家描述失敗"

#: apps/dp-business/src/servers/shop/api.ts:173
msgid "更新店家營業時間失敗"
msgstr "更新店家營業時間失敗"

#: apps/dp-business/src/servers/shop/api.ts:339
msgid "更新店家狀態失敗"
msgstr "更新店家狀態失敗"

#: apps/dp-business/src/servers/shop/api.ts:149
msgid "更新店家聯絡方式失敗"
msgstr "更新店家聯絡方式失敗"

#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:281
msgid "更新性別失敗，請稍後重試"
msgstr "更新性別失敗，請稍後重試"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:201
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/index.web.tsx:497
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:68
#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:256
#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:459
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:124
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:53
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:66
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:354
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:510
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:160
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:519
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:147
#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:171
#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:559
#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:480
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:1078
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:1171
msgid "更新成功"
msgstr "更新成功"

#: apps/dp-business/src/servers/verification/api.ts:216
msgid "更新手機號碼失敗"
msgstr "更新手機號碼失敗"

#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:257
#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:405
msgid "更新接口尚未開放，暫不支持保存"
msgstr "更新接口尚未開放，暫不支持保存"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1270
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1061
#: apps/dp-admin/src/pages/users/roles/components/RoleTable/index.web.tsx:70
#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:121
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:262
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:252
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:101
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:66
#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:185
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:952
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:504
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/constants.ts:18
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:488
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:325
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:143
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:163
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:134
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:188
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:935
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/searchConfig.ts:43
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:89
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/SearchForm/index.web.tsx:51
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:107
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:205
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:184
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:99
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:224
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:292
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:318
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:339
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:167
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:226
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:125
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:269
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:306
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:211
msgid "更新時間"
msgstr "更新時間"

#: apps/dp-business/src/servers/contract-management/api.ts:297
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:115
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:121
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:552
msgid "更新服務狀態失敗"
msgstr "更新服務狀態失敗"

#: apps/dp-business/src/servers/reservation/api.ts:360
#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:445
msgid "更新桌位失敗"
msgstr "更新桌位失敗"

#: apps/dp-business/src/servers/reservation/api.ts:253
#: apps/dp-business/src/pages/TableManagement/index.tsx:504
msgid "更新桌型失敗"
msgstr "更新桌型失敗"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:335
msgid "更新榜單成功"
msgstr "更新榜單成功"

#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:277
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:277
msgid "更新歷史名單記錄"
msgstr "更新歷史名單記錄"

#: apps/dp-admin/src/pages/marketing/activity-create/services/hooks.ts:405
msgid "更新活動配置失敗"
msgstr "更新活動配置失敗"

#: apps/dp-admin/src/pages/marketing/activity-create/services/hooks.ts:417
msgid "更新活動配置失敗，請重試"
msgstr "更新活動配置失敗，請重試"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/hooks.ts:171
msgid "更新狀態失敗"
msgstr "更新狀態失敗"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/hooks.ts:167
msgid "更新狀態成功"
msgstr "更新狀態成功"

#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:262
msgid "更新生日失敗，請稍後重試"
msgstr "更新生日失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/apis.ts:113
msgid "更新用戶備註失敗"
msgstr "更新用戶備註失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/apis.ts:86
msgid "更新用戶狀態失敗"
msgstr "更新用戶狀態失敗"

#: apps/dp-client/src/store/invoiceStore.ts:123
msgid "更新發票抬頭失敗"
msgstr "更新發票抬頭失敗"

#: apps/dp-client/src/screens/home/pages/UserGift/hooks/useUserGiftData.ts:222
msgid "更新票券狀態失敗:"
msgstr "更新票券狀態失敗:"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:220
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:226
msgid "更新結帳服務失敗"
msgstr "更新結帳服務失敗"

#: apps/dp-business/src/servers/contract-management/api.ts:330
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:182
msgid "更新自核銷服務失敗"
msgstr "更新自核銷服務失敗"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:188
msgid "更新自核銷服務開啟失敗"
msgstr "更新自核銷服務開啟失敗"

#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:582
msgid "更新自核銷狀態失敗"
msgstr "更新自核銷狀態失敗"

#: apps/dp-business/src/servers/category/api.ts:59
msgid "更新自訂分類失敗"
msgstr "更新自訂分類失敗"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteFormFooter.tsx:43
msgid "更新草稿"
msgstr "更新草稿"

#: apps/dp-business/src/servers/reservation/api.ts:491
msgid "更新規則失敗"
msgstr "更新規則失敗"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:184
msgid "更新規則狀態失敗"
msgstr "更新規則狀態失敗"

#: apps/dp-business/src/servers/permission/api.ts:83
#: apps/dp-business/src/servers/chain/roleApi.ts:137
msgid "更新角色失敗"
msgstr "更新角色失敗"

#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:286
msgid "更新角色成功"
msgstr "更新角色成功"

#: apps/dp-business/src/servers/reservation/api.ts:140
#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:147
msgid "更新訂位規則失敗"
msgstr "更新訂位規則失敗"

#: apps/dp-admin/src/services/index.ts:27
msgid "更新設備令牌失敗"
msgstr "更新設備令牌失敗"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:174
msgid "更新評論數失敗"
msgstr "更新評論數失敗"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:160
msgid "更新類別狀態失敗"
msgstr "更新類別狀態失敗"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:136
msgid "更正不準確的資料"
msgstr "更正不準確的資料"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/constants.ts:13
msgid "更高優先級"
msgstr "更高優先級"

#: apps/dp-business/src/components/PhotoUploader/index.tsx:375
#: apps/dp-business/src/components/PhotoUploader/index.tsx:427
msgid "替換圖片"
msgstr "替換圖片"

#: apps/dp-business/src/components/PhotoUploader/index.tsx:408
msgid "替換文檔"
msgstr "替換文件"

#: apps/dp-business/src/components/PhotoUploader/index.tsx:356
#: apps/dp-business/src/components/PhotoUploader/index.tsx:426
msgid "替換檔案"
msgstr "替換檔案"

#: apps/dp-client/src/configs/page-configs.tsx:2941
msgid "會員條款"
msgstr "會員條款"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/index.web.tsx:28
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/index.web.tsx:49
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/MemberTypeSection.web.tsx:36
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/MemberTypeSection.web.tsx:40
msgid "會員類型"
msgstr "會員類型"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:566
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:48
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:52
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:25
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:30
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:31
#: apps/dp-admin/src/modules/constants/userGroup.ts:137
msgid "月"
msgstr "月"

#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:109
msgid "月度結算"
msgstr "月度結算"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:348
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:215
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:216
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:231
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:232
#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:41
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:63
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:665
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:40
#: apps/dp-admin/src/modules/constants/options.ts:153
msgid "月度計費"
msgstr "當月計費"

#. placeholder {0}: failedImages.length
#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:203
msgid "有 {0} 張圖片上傳失敗，請刪除後重新上傳"
msgstr "有 {0} 張圖片上傳失敗，請刪除後重新上傳"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:114
msgid "有了您的分享，去哪吃將不再是疑問句。"
msgstr "有了您的分享，去哪吃將不再是疑問句。"

#: apps/dp-admin/src/pages/resource-config/category-management/services/constants.ts:21
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:686
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:712
msgid "有圖片"
msgstr "有圖片"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:33
msgid "有幾家想收藏"
msgstr "有幾家想收藏"

#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:162
msgid "有序列表"
msgstr "有序列表"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:44
msgid "有按鈕、浮水印或平台文字（例如 Google 地圖）的圖片無法通過審核。"
msgstr "有按鈕、浮水印或平台文字（例如 Google 地圖）的圖片無法通過審核。"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountToolbar/index.web.tsx:108
#: apps/dp-admin/src/pages/users/user-tasks/components/StatusTag/index.web.tsx:18
msgid "有效"
msgstr "有效"

#. placeholder {0}: result.validCount ?? 0
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:147
msgid "有效：{0}"
msgstr "有效：{0}"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:355
msgid "有效天數"
msgstr "有效天數"

#. placeholder {0}: user.durationDays
#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:282
msgid "有效天數：{0}"
msgstr "有效天數：{0}"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:668
msgid "有效天數必須在1-365天之間"
msgstr "有效天數必須在1-365天之間"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:268
msgid "有效天數必須大於等於 1"
msgstr "有效天數必須大於等於 1"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:175
msgid "有效天數須為 1 至 180 天"
msgstr "有效天數須為 1 至 180 天"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:335
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:377
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:407
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:437
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:305
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:357
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:397
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:437
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:76
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:52
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:70
msgid "有效日期"
msgstr "有效日期"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:96
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:85
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BookingFeeRules/index.web.tsx:91
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:75
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/BookingFeeRules/index.web.tsx:77
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:57
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:93
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:231
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:232
msgid "有效時間"
msgstr "有效時間"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1429
#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:110
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/PackageCouponCard/index.web.tsx:92
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:346
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:105
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:181
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:254
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:295
msgid "有效期"
msgstr "有效期"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:123
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:330
msgid "有效期："
msgstr "有效期："

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:181
msgid "有效期（天）"
msgstr "有效期（天）"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:153
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:131
msgid "有效期截止日"
msgstr "有效期截止日"

#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:136
msgid "有效期結束"
msgstr "有效期結束"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:276
msgid "有效期至"
msgstr "有效期至"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:316
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:77
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:74
msgid "有效期設定"
msgstr "有效期設定"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:111
msgid "有效期設置"
msgstr "有效期設置"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:304
msgid "有效期起止（僅固定日期）"
msgstr "有效期起止（僅固定日期）"

#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:129
msgid "有效期開始"
msgstr "有效期開始"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2477
msgid "有效期間"
msgstr "有效期間"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:165
#: apps/dp-client/src/screens/home/pages/CouponShopList/components/CouponCard.tsx:104
#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:422
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:381
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:483
msgid "有效期限"
msgstr "有效期限"

#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/index.tsx:140
msgid "有效訂單數"
msgstr "有效訂單數"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:109
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:60
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:78
msgid "有效週期"
msgstr "有效週期"

#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:115
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1014
msgid "有數據"
msgstr "有數據"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:106
msgid "有新增店家POI，請判斷是否和平台已有店家一致"
msgstr "有新增店家POI，請判斷是否和平台已有店家一致"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:258
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:131
msgid "有服務費"
msgstr "有服務費"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/OrgNodeTree/index.web.tsx:112
msgid "有未提交的改動"
msgstr "有未提交的改動"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:40
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:108
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:682
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:708
msgid "有無圖片"
msgstr "有無圖片"

#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:741
#: apps/dp-client/src/screens/diary/components/DiaryActions/index.tsx:89
msgid "有用"
msgstr "有用"

#. placeholder {0}: reviewDetail?.likeCount || ''
#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:250
msgid "有用{0}"
msgstr "有用{0}"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:1133
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:715
msgid "有資訊未儲存，是否確定返回？"
msgstr "有資訊未儲存，是否確定返回？"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1499
msgid "有進行中的申請"
msgstr "有進行中的申請"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:146
msgid "有關聯"
msgstr "有關聯"

#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:266
msgid "有餐點但沒有類別，請先新增類別"
msgstr "有餐點但沒有類別，請先新增類別"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:29
msgid "有點失望"
msgstr "有點失望"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:32
msgid "有點意思"
msgstr "有點意思"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:95
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:95
msgid "朋友"
msgstr "朋友"

#: apps/dp-client/src/screens/home/utils/filterData.ts:183
#: apps/dp-client/src/screens/home/pages/Review/components/RatingSection/index.tsx:175
#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewEditorToolbar.tsx:25
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:93
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:231
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:323
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:796
#: apps/dp-client/src/screens/diary/components/diary-entry/index.tsx:121
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewContent.tsx:272
#: apps/dp-admin/src/pages/user-info/services/apis.ts:140
#: apps/dp-admin/src/pages/data-center/components/ReviewItem.web.tsx:146
#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:143
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/OriginalReviewSection/index.web.tsx:81
msgid "服務"
msgstr "服務"

#: apps/dp-client/src/screens/diary/components/DiaryContent/index.tsx:78
msgid "服務："
msgstr "服務："

#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:53
msgid "服務/設施"
msgstr "服務/設施"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:90
#: apps/dp-business/src/utils/moduleTypeMapping.ts:243
#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:472
#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:582
msgid "服務&設施"
msgstr "服務&設施"

#: apps/dp-business/src/utils/errorHandler.ts:58
#: apps/dp-business/src/utils/errorHandler.ts:85
msgid "服務出錯"
msgstr "服務出錯"

#: apps/dp-client/src/screens/others/Maintenance.tsx:57
msgid "服務將於維護完成後恢復正常，期間造成您的不便，敬請見諒"
msgstr "服務將於維護完成後恢復正常，期間造成您的不便，敬請見諒"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:400
msgid "服務已開啟"
msgstr "服務已開啟"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:400
msgid "服務已關閉"
msgstr "服務已關閉"

#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:26
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/HotIssues.web.tsx:73
msgid "服務態度"
msgstr "服務態度"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:54
msgid "服務態度非常好，餐點新鮮美味，環境整潔舒適，值得推薦！"
msgstr "服務態度非常好，餐點新鮮美味，環境整潔舒適，值得推薦！"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:104
msgid "服務提供商："
msgstr "服務提供商："

#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:393
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:602
msgid "服務數據未載入，請重新整理頁面重試"
msgstr "服務數據未載入，請重新整理頁面重試"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:716
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:394
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:771
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:71
msgid "服務時間"
msgstr "服務時間"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:768
msgid "服務時間內可再次點擊啟用服務"
msgstr "服務時間內可再次點擊啟用服務"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:758
msgid "服務時間內可再次點擊啟用結帳服務，建議開通服務獲取更多流量補貼~"
msgstr "服務時間內可再次點擊啟用結帳服務，建議開通服務獲取更多流量補貼~"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:465
#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:207
msgid "服務時間設定"
msgstr "服務時間設定"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:726
msgid "服務期內可隨時點擊啟用服務，到期後需聯繫BD重新開通服務"
msgstr "服務期內可隨時點擊啟用服務，到期後需聯繫BD重新開通服務"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:110
msgid "服務業"
msgstr "服務業"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:276
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:820
#: apps/dp-business/src/components/CustomTabs/index.tsx:261
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:589
#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:308
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:113
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:131
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:881
msgid "服務管理"
msgstr "服務管理"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1021
msgid "服務與設施"
msgstr "服務與設施"

#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:170
msgid "服務規則"
msgstr "服務規則"

#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:72
msgid "服務設定"
msgstr "服務設定"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:123
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:700
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:75
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:121
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:427
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:362
#: apps/dp-admin/src/pages/merchant/components/StoreSettingsSection/index.web.tsx:256
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:506
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:21
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:29
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:216
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/config.ts:75
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:179
msgid "服務設施"
msgstr "服務設施"

#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:338
msgid "服務設施儲存失敗，請稍後重試"
msgstr "服務設施儲存失敗，請稍後重試"

#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:326
msgid "服務設施儲存成功"
msgstr "服務設施儲存成功"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/MediaTab/index.web.tsx:206
msgid "服務設施圖片"
msgstr "服務設施圖片"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:91
msgid "服務設施資訊完整度評分"
msgstr "服務設施資訊完整度評分"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:123
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1188
msgid "服務設置"
msgstr "服務設置"

#: apps/dp-admin/src/router/config/routes.web.tsx:441
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:94
msgid "服務變更審核"
msgstr "服務變更審核"

#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:200
#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:238
msgid "服務變更審核中，暫不可操作"
msgstr "服務變更審核中，暫不可操作"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:277
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:189
msgid "服務變更審核詳情"
msgstr "服務變更審核詳情"

#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailCard/index.tsx:241
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailCard/index.tsx:249
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:461
msgid "服務費"
msgstr "服務費"

#. placeholder {0}: data.includeServiceFeeRate ?? 0
#. placeholder {0}: d.serviceFeeRate ?? 0
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:310
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:398
msgid "服務費 {0}%"
msgstr "服務費 {0}%"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:149
msgid "服務費率必須在1-99之間"
msgstr "服務費率必須在1-99之間"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:229
msgid "服務費率必須為 0-99 的整數"
msgstr "服務費率必須為 0-99 的整數"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:121
msgid "服務配置資訊"
msgstr "服務配置資訊"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:464
msgid "服務配額超限"
msgstr "服務配額超限"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:508
msgid "服務開放時間："
msgstr "服務開放時間："

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:141
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:360
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:738
msgid "服務開關"
msgstr "服務開關"

#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:202
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:56
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:83
msgid "服務類型"
msgstr "服務類型"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:44
msgid "朝陽區"
msgstr "朝陽區"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:276
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:642
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:655
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/CommentSection.tsx:171
msgid "期待你的回覆"
msgstr "期待你的回覆"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:565
#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:890
msgid "期待你的留言"
msgstr "期待您的留言"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:296
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:263
msgid "期待完成時間"
msgstr "期待完成時間"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:336
msgid "木材"
msgstr "木材"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:451
#: apps/dp-admin/src/components/SensitiveInfo/MaskedImage/index.web.tsx:29
msgid "未上傳"
msgstr "未上傳"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1744
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1760
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:285
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:518
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:555
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:319
#: apps/dp-admin/src/modules/constants/options.ts:626
msgid "未上線"
msgstr "未上線"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:34
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:66
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/interface.ts:54
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryUserDrawHistoryModal.web.tsx:25
msgid "未中獎"
msgstr "未中獎"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:174
#: apps/dp-business/src/servers/order/types.ts:183
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:291
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:536
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:562
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:576
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1182
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1232
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1249
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:325
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:363
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:616
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:644
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherUsageReport.tsx:64
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherSalesReport.tsx:64
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:43
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:37
#: apps/dp-admin/src/pages/order/services/utils.ts:160
#: apps/dp-admin/src/pages/marketing/verification-record/services/utils.ts:15
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:51
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:86
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:288
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:77
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:114
#: apps/dp-admin/src/pages/marketing/benefit-management/services/constants.ts:22
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:58
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:255
msgid "未使用"
msgstr "未使用"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:686
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:360
msgid "未使用，系統將會自動退款"
msgstr "未使用，系統將會自動退款"

#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/UsergiftBanner.tsx:394
msgid "未使用！"
msgstr "未使用！"

#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:32
msgid "未使用不可退"
msgstr "未使用不可退"

#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:31
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:283
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:374
msgid "未使用可退"
msgstr "未使用可退"

#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:48
msgid "未使用量"
msgstr "未使用量"

#: apps/dp-business/src/utils/dateRange.ts:130
msgid "未來{amount}{unit}"
msgstr "未來{amount}{unit}"

#: apps/dp-business/src/types/orderFilter.ts:144
#: apps/dp-business/src/types/orderFilter.ts:156
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1784
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1810
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:210
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:222
msgid "未來7天"
msgstr "未來7天"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:188
msgid "未來七天概況"
msgstr "未來七天概況"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:187
msgid "未來三天概況"
msgstr "未來三天概況"

#: apps/dp-admin/src/pages/org-tree/org-create/components/UnsavedNodeModal/index.web.tsx:22
msgid "未保存提示"
msgstr "未保存提示"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:204
msgid "未入駐"
msgstr "未入駐"

#: apps/dp-admin/src/pages/merchant/components/MetroStationExitSelector/index.web.tsx:86
#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:75
msgid "未分線路"
msgstr "未分線路"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:130
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchAssignModal/index.web.tsx:54
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchAssignModal/index.web.tsx:61
#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:192
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:128
msgid "未分配"
msgstr "未分配"

#: apps/dp-business/src/pages/UserManagement/index.tsx:504
msgid "未分配角色"
msgstr "未分配角色"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:235
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:100
msgid "未分類 ⚠️"
msgstr "未分類 ⚠️"

#: apps/dp-client/src/screens/reservation/utils/index.ts:69
#: apps/dp-client/src/screens/reservation/utils/index.ts:91
#: apps/dp-business/src/types/orderFilter.ts:174
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1111
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1947
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:880
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:104
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:200
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:52
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:34
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:240
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:218
msgid "未到店"
msgstr "未到店"

#: apps/dp-business/src/types/orderFilter.ts:131
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:186
msgid "未到店（超時未到店）"
msgstr "未到店（超時未到店）"

#: apps/dp-client/src/screens/reservation/utils/index.ts:44
msgid "未到店用餐"
msgstr "未到店用餐"

#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:146
#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/hooks.ts:96
msgid "未取得名單識別類型，請重新整理列表後再試"
msgstr "未取得名單識別類型，請重新整理列表後再試"

#: apps/dp-admin/src/pages/marketing/services/groupImport.ts:254
msgid "未取得完整任務資訊，請重新整理操作記錄確認後再重試"
msgstr "未取得完整任務資訊，請重新整理操作記錄確認後再重試"

#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:159
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:250
msgid "未命名"
msgstr "未命名"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ManualPackageSelector/index.web.tsx:52
msgid "未命名套餐"
msgstr "未命名套餐"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/hooks.ts:24
msgid "未命名活動"
msgstr "未命名活動"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:207
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:272
msgid "未命名草稿"
msgstr "未命名草稿"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:75
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:269
#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:22
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:42
msgid "未回覆"
msgstr "未回覆"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:37
msgid "未報名"
msgstr "未報名"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:316
msgid "未填寫原因"
msgstr "未填寫原因"

#: apps/dp-admin/src/pages/org-tree/services/constants.ts:39
msgid "未套用"
msgstr "未套用"

#: apps/dp-business/src/pages/OrderList/index.tsx:940
#: apps/dp-admin/src/pages/order/services/utils.ts:64
#: apps/dp-admin/src/pages/merchant/service/constants.ts:320
#: apps/dp-admin/src/pages/merchant/service/constants.ts:326
#: apps/dp-admin/src/pages/marketing/services/constants.ts:337
msgid "未成立"
msgstr "未成立"

#: apps/dp-client/src/screens/account/pages/account-security/email/check-email/index.tsx:49
msgid "未找到Email地址"
msgstr "未找到Email地址"

#: apps/dp-business/src/pages/MarketingCenter/components/StoreSelectionCard.tsx:312
msgid "未找到匹配的店家"
msgstr "未找到匹配的餐廳"

#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:184
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:174
msgid "未找到品類資訊"
msgstr "未找到品類資訊"

#: apps/dp-business/src/servers/merchantReview/api.ts:55
#: apps/dp-business/src/servers/documentSubmission/api.ts:27
msgid "未找到商家ID，請先完成登入流程"
msgstr "未找到商家ID，請先完成登入流程"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:407
msgid "未找到商家資料"
msgstr "未找到商家資料"

#: apps/dp-admin/src/pages/merchant/audit-detail/index.web.tsx:365
msgid "未找到商家資訊"
msgstr "未找到商家資訊"

#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:275
msgid "未找到城市座標資訊"
msgstr "未找到城市座標資訊"

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:208
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:188
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:267
#: apps/dp-client/src/screens/diary/hooks/useDraftSave.ts:106
msgid "未找到外層任務資訊"
msgstr "未找到外層任務資訊"

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:216
msgid "未找到媒體上傳任務資訊"
msgstr "未找到媒體上傳任務資訊"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:59
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:55
msgid "未找到審批批次 ID"
msgstr "未找到審批批次 ID"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/index.web.tsx:53
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:69
#: apps/dp-admin/src/pages/audit-center/info-confirm/index.web.tsx:90
msgid "未找到審核記錄"
msgstr "未找到審核記錄"

#: apps/dp-admin/src/components/MapPicker/index.web.tsx:309
msgid "未找到對應地址"
msgstr "未找到對應地址"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:160
#: apps/dp-admin/src/pages/customer-service/ticket-detail/index.web.tsx:137
msgid "未找到工單資訊"
msgstr "未找到工單資訊"

#: apps/dp-business/src/servers/addStore/api.ts:182
#: apps/dp-business/src/pages/MerchantReview/index.tsx:92
msgid "未找到店家ID，請先完成登入流程"
msgstr "未找到店家ID，請先完成登入流程"

#: apps/dp-business/src/pages/ContactBD/index.tsx:41
msgid "未找到店家資訊"
msgstr "未找到餐廳資訊"

#: apps/dp-client/src/screens/account/pages/check-phone/verification-code/index.tsx:55
msgid "未找到手機門號"
msgstr "未找到手機門號"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:626
msgid "未找到有效的數據: "
msgstr "未找到有效的數據: "

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:209
msgid "未找到標籤資訊"
msgstr "未找到標籤資訊"

#: apps/dp-business/src/pages/Settings/index.tsx:102
msgid "未找到用戶信息"
msgstr "未找到用戶信息"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:291
msgid "未找到申請ID，請重新整理頁面重試"
msgstr "未找到申請ID，請重新整理頁面重試"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:190
msgid "未找到當前店家"
msgstr "未找到當前店家"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:298
msgid "未找到發票資訊"
msgstr "未找到發票資訊"

#: apps/dp-client/src/screens/home/pages/Note/components/MarkShopModal/index.tsx:361
msgid "未找到相關商家"
msgstr "未找到相關店家"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:222
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:634
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:248
#: apps/dp-admin/src/pages/merchant/components/GoogleShopSearchSelect/index.web.tsx:225
#: apps/dp-admin/src/pages/merchant/components/GoogleShopSearchSelect/index.web.tsx:252
msgid "未找到相關店家"
msgstr "未找到相關店家"

#: apps/dp-client/src/screens/home/pages/Search/index.tsx:679
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:786
msgid "未找到相關的結果"
msgstr "未找到相關的結果"

#: apps/dp-client/src/screens/account/pages/likes/components/NotesContent/index.tsx:170
#: apps/dp-client/src/screens/account/pages/likes/components/NotesContent/index.tsx:173
msgid "未找到相關筆記"
msgstr "未找到相關筆記"

#: apps/dp-client/src/screens/account/pages/likes/components/ReviewContent/index.tsx:214
msgid "未找到相關評論"
msgstr "未找到相關評論"

#: apps/dp-client/src/screens/account/pages/advice/advice-feedback/index.tsx:236
msgid "未找到答案"
msgstr "未找到答案"

#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:352
msgid "未找到訂單資料"
msgstr "未找到訂單資料"

#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:195
msgid "未找到評論任務資訊"
msgstr "未找到評論任務資訊"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:390
msgid "未找到該審批工單"
msgstr "未找到該審批工單"

#: apps/dp-admin/src/pages/customer-service/components/CreateTicketModal.web.tsx:53
msgid "未找到該用戶"
msgstr "未找到該用戶"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1093
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1371
msgid "未找到該節點，請刷新後重試"
msgstr "未找到該節點，請刷新後重試"

#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:243
msgid "未找到請款單詳情"
msgstr "未找到請款單詳情"

#: apps/dp-business/src/utils/voiceBroadcast.ts:412
#: apps/dp-business/src/utils/voiceBroadcast.ts:495
#: apps/dp-business/src/utils/voiceBroadcast.ts:936
msgid "未找到音頻文件: {audioKey}"
msgstr "未找到音頻文件: {audioKey}"

#: apps/dp-business/src/pages/Settings/index.tsx:96
msgid "未找到餐廳信息"
msgstr "未找到餐廳信息"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1221
msgid "未找到餐廳或用戶信息"
msgstr "未找到餐廳或用戶信息"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:262
msgid "未指定樹上結算，也未取得店家自身請款商家"
msgstr "未指定樹上結算，也未取得店家自身請款商家"

#. placeholder {0}: formatPayee(data?.shopPayeeMerchant)
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:261
msgid "未指定樹上結算，請款商家：{0}"
msgstr "未指定樹上結算，請款商家：{0}"

#. placeholder {0}: from.format('YYYY-MM-DD')
#. placeholder {1}: to.format('YYYY-MM-DD')
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:242
msgid "未指定發生時間，將匯出 {0} ~ {1}（近 {EXPORT_MAX_MONTHS} 個月）的資料。"
msgstr "未指定發生時間，將匯出 {0} ~ {1}（近 {EXPORT_MAX_MONTHS} 個月）的資料。"

#. placeholder {0}: from.format('YYYY-MM-DD')
#. placeholder {1}: to.format('YYYY-MM-DD')
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:384
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:251
msgid "未指定發起時間，將匯出 {0} ~ {1}（近 {EXPORT_MAX_MONTHS} 個月）的資料。"
msgstr "未指定發起時間，將匯出 {0} ~ {1}（近 {EXPORT_MAX_MONTHS} 個月）的資料。"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:258
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/BasicInfoCard.web.tsx:78
msgid "未指派"
msgstr "未指派"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:27
msgid "未授權"
msgstr "未授權"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/OrgNodeTree/index.web.tsx:101
#: apps/dp-admin/src/pages/org-tree/org-create/components/EditableOrgTree/index.web.tsx:51
msgid "未掛商家"
msgstr "未掛商家"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:50
msgid "未掛接"
msgstr "未掛接"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:181
msgid "未掛接任何連鎖樹，結算走店家自身商家"
msgstr "未掛接任何連鎖樹，結算走店家自身商家"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:127
msgid "未掛本樹"
msgstr "未掛本樹"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailMerchants.tsx:77
msgid "未掛簽約商家"
msgstr "未掛簽約商家"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailMerchants.tsx:98
msgid "未掛請款商家（非結算節點）"
msgstr "未掛請款商家（非結算節點）"

#: apps/dp-admin/src/modules/constants/options.ts:50
msgid "未接觸"
msgstr "未接觸"

#: apps/dp-admin/src/pages/org-tree/services/constants.ts:28
msgid "未提交"
msgstr "未提交"

#: apps/dp-admin/src/pages/org-tree/services/shopPathActions.ts:215
msgid "未提交審核，請確認申請狀態後重試"
msgstr "未提交審核，請確認申請狀態後重試"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1075
msgid "未提交的改動將全部捨棄，不會產生審核單，也不會取消既有審核。"
msgstr "未提交的改動將全部捨棄，不會產生審核單，也不會取消既有審核。"

#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:308
#: apps/dp-business/src/servers/order/types.ts:138
#: apps/dp-business/src/pages/OrderList/index.tsx:909
#: apps/dp-admin/src/pages/order/services/utils.ts:264
#: apps/dp-admin/src/pages/marketing/services/constants.ts:344
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:399
msgid "未支付"
msgstr "未支付"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:222
msgid "未改上級，僅調整同層排序，可直接保存。"
msgstr "未改上級，僅調整同層排序，可直接保存。"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:30
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:406
msgid "未核銷"
msgstr "未核銷"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2098
msgid "未檢測到任何修改，無需提交"
msgstr "未檢測到任何修改，無需提交"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:62
msgid "未獲取到商場id"
msgstr "未獲取到商場id"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:341
msgid "未獲取到結算單ID"
msgstr "未獲取到結算單ID"

#: apps/dp-admin/src/pages/org-tree/services/constants.ts:51
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:116
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:100
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:107
msgid "未生效"
msgstr "未生效"

#: apps/dp-client/src/screens/home/pages/Home/components/RecommendSetmeal/index.tsx:217
msgid "未用可退"
msgstr "未用可退"

#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:21
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:56
#: apps/dp-admin/src/pages/merchant/service/constants.ts:231
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:49
msgid "未申請"
msgstr "未申請"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:173
#: apps/dp-admin/src/pages/marketing/benefit-management/services/constants.ts:20
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:56
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:272
#: apps/dp-admin/src/modules/constants/options.ts:301
msgid "未發放"
msgstr "未發放"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditStatusBanner/index.web.tsx:40
#: apps/dp-admin/src/modules/constants/merchantStatus.ts:68
msgid "未發起"
msgstr "未發起"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:121
msgid "未發起申請"
msgstr "未發起申請"

#: apps/dp-client/src/utils/businessStatus.ts:233
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:133
#: apps/dp-admin/src/pages/users/user-tasks/components/StatusTag/index.web.tsx:28
#: apps/dp-admin/src/pages/users/roles/components/StatusTag/index.web.tsx:32
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:114
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:168
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:320
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:332
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:115
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:146
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:281
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:72
#: apps/dp-admin/src/pages/data-center/review-detail/index.web.tsx:34
msgid "未知"
msgstr "未知"

#: apps/dp-admin/src/pages/audit-center/components/RenderContent/index.web.tsx:179
#: apps/dp-admin/src/pages/audit-center/components/RenderContent/index.web.tsx:184
msgid "未知內容類型"
msgstr "未知內容類型"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/hooks.ts:25
#: apps/dp-admin/src/pages/merchant/task-detail/index.web.tsx:48
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:92
msgid "未知商家"
msgstr "未知商家"

#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionConfirmContent/index.tsx:73
msgid "未知套餐"
msgstr "未知套餐"

#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:53
msgid "未知子類型"
msgstr "未知子類型"

#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:50
#: apps/dp-client/src/screens/diary/pages/plaza/index.tsx:44
#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:377
msgid "未知店家"
msgstr "未知店家"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/OperationLogSection/index.web.tsx:58
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/OperationLogSection/index.web.tsx:59
msgid "未知操作"
msgstr "未知操作"

#: apps/dp-client/src/screens/diary/components/PointsStatus.tsx:90
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:195
#: apps/dp-business/src/servers/order/types.ts:108
#: apps/dp-business/src/servers/order/types.ts:150
#: apps/dp-business/src/servers/order/types.ts:195
#: apps/dp-business/src/servers/order/types.ts:276
#: apps/dp-business/src/pages/OrderDetail/index.tsx:686
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:530
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:569
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/utils/activityUtils.ts:55
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:132
#: apps/dp-business/src/pages/ComplaintList/index.tsx:434
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/SigningStatus/index.web.tsx:41
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/SigningStatus/index.web.tsx:55
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:19
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:187
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:220
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:49
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:154
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:168
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:87
msgid "未知狀態"
msgstr "狀態未知"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:600
msgid "未知用戶"
msgstr "未知用戶"

#: apps/dp-client/src/screens/home/components/ShopFilter/hooks/useFilterSelection.ts:408
msgid "未知的篩選器類型:"
msgstr "未知的篩選器類型:"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:664
msgid "未知的處理結果類型: "
msgstr "未知的處理結果類型: "

#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:73
msgid "未知計費方式"
msgstr "未知計費方式"

#: apps/dp-business/src/components/GoogleMap/index.tsx:412
#: apps/dp-business/src/components/GoogleMap/WebViewMap.tsx:145
msgid "未知距離"
msgstr "未知距離"

#: apps/dp-client/src/screens/login/pages/third-party-login/index.tsx:89
#: apps/dp-client/src/hooks/useCurrentLocation.ts:116
msgid "未知錯誤"
msgstr "未知錯誤"

#: apps/dp-admin/src/router/core/RouteComposer.ts:426
#: apps/dp-admin/src/router/core/RouteComposer.ts:429
#: apps/dp-admin/src/components/layout/index.web.tsx:297
msgid "未知頁面"
msgstr "未知頁面"

#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:84
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:44
msgid "未知類型"
msgstr "未知類型"

#: apps/dp-client/src/screens/diary/pages/my/hooks.ts:117
msgid "未知餐廳"
msgstr "未知餐廳"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:498
#: apps/dp-business/src/components/InvoiceForm/index.tsx:471
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:427
msgid "未稅金額"
msgstr "未稅金額"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:201
#: apps/dp-business/src/components/InvoiceForm/index.tsx:256
msgid "未稅金額："
msgstr "未稅金額："

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:619
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:79
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:64
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:110
#: apps/dp-admin/src/pages/merchant/service/constants.ts:91
#: apps/dp-admin/src/pages/merchant/service/constants.ts:408
#: apps/dp-admin/src/pages/merchant/service/constants.ts:414
#: apps/dp-admin/src/pages/marketing/services/constants.ts:249
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:44
msgid "未簽約"
msgstr "未簽約"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account/index.tsx:21
msgid "未綁定手機門號，無法刪除帳號"
msgstr "未綁定手機門號，無法刪除帳號"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1805
msgid "未綁定的可稍後通過變更申請繼續掛接。"
msgstr "未綁定的可稍後通過變更申請繼續掛接。"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/OverviewCards/index.web.tsx:39
msgid "未處理異常訂單數"
msgstr "未處理異常訂單數"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:508
#: apps/dp-client/src/screens/account/pages/advice/advice-detail/index.tsx:281
msgid "未解決"
msgstr "未解決"

#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:166
#: apps/dp-admin/src/components/BusinessHours/utils.ts:293
#: apps/dp-admin/src/components/BusinessHours/index.web.tsx:412
msgid "未設定"
msgstr "未設定"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:204
msgid "未設定副標題"
msgstr "未設定副標題"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:501
msgid "未設定按鈕"
msgstr "未設定按鈕"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:478
msgid "未設定活動名稱"
msgstr "未設定活動名稱"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:202
msgid "未設定獎勵"
msgstr "未設定獎勵"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:257
msgid "未設定結算路徑"
msgstr "未設定結算路徑"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:189
msgid "未設定觸發事件"
msgstr "未設定觸發事件"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:504
msgid "未設定跳轉頁面"
msgstr "未設定跳轉頁面"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:733
msgid "未設定餐廳名稱"
msgstr "未設定餐廳名稱"

#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:127
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:138
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:144
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:153
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:159
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:72
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:84
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:102
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:114
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:135
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:142
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:281
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:287
msgid "未設置"
msgstr "未設定"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:188
msgid "未設置簽約商家"
msgstr "未設置簽約商家"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:199
msgid "未設置請款商家，本節點不是結算節點"
msgstr "未設置請款商家，本節點不是結算節點"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:276
msgid "未設階梯"
msgstr "未設階梯"

#: apps/dp-client/src/utils/format.ts:79
#: apps/dp-client/src/screens/home/pages/Note/utils/index.ts:9
msgid "未評分"
msgstr "未評分"

#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/components/MerchantCard.tsx:39
msgid "未認領"
msgstr "未認領"

#: apps/dp-business/src/pages/Onboarding/index.tsx:58
#: apps/dp-business/src/pages/MerchantReview/index.tsx:519
msgid "未認領商家"
msgstr "未認領商家"

#: apps/dp-business/src/pages/MenuManagement.tsx:496
msgid "未識別出菜單"
msgstr "未識別出菜單"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:797
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:935
msgid "未讀"
msgstr "未讀"

#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:55
#: apps/dp-client/src/screens/diary/components/PointsStatus.tsx:67
#: apps/dp-admin/src/pages/merchant/components/ActionButtons/index.web.tsx:48
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1434
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/components/PoiActionButtons/index.web.tsx:95
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:53
#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:85
msgid "未通過"
msgstr "未通過"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1050
#: apps/dp-admin/src/pages/merchant/components/ActionButtons/index.web.tsx:68
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/components/PoiActionButtons/index.web.tsx:103
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:105
#: apps/dp-admin/src/pages/audit-center/components/AuditInfoHeader/config.ts:24
msgid "未通過原因"
msgstr "未通過原因"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:190
msgid "未通過檢舉"
msgstr "未通過檢舉"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:830
#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:66
msgid "未選擇"
msgstr "未選擇"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:57
msgid "未選擇上傳參數（預設）"
msgstr "未選擇上傳參數（預設）"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:421
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:444
msgid "未配置上傳處理函數"
msgstr "未配置上傳處理函數"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:223
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:230
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:237
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:242
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:248
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:257
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:266
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:281
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:293
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:329
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:454
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:459
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:464
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:468
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:845
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:629
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:653
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:695
#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:40
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityCornerStatusTag.tsx:39
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:15
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:24
msgid "未開始"
msgstr "未開始"

#: apps/dp-client/src/utils/distance.ts:94
#: apps/dp-client/src/screens/home/components/ShopFilter/components/CascaderFilterContent.tsx:138
#: apps/dp-client/src/screens/home/components/ShopFilter/components/CascaderFilterContent.tsx:163
msgid "未開啟定位"
msgstr "未開啟定位"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:129
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:143
msgid "未開通"
msgstr "未開通"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:206
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:258
msgid "未限制"
msgstr "未限制"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:52
msgid "未領獎"
msgstr "未領獎"

#: apps/dp-business/src/servers/chain/nodeApi.ts:171
#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeNodeRow.tsx:51
msgid "末級"
msgstr "末級"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:127
msgid "本人已瞭解並同意上述服務條款"
msgstr "本人已瞭解並同意上述服務條款"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:207
msgid "本公司將依據隱私權政策及適用法律，刪除您的個人資料，惟經本公司採取合理技術進行去識別化或彙總統計後，已無法識別特定個人之資料，得在適用法律允許的最大範圍內利用，不受您刪除帳號之限制。此外，本公司為履行法律義務、解決爭議、執行協議或營運之正當目的，部分資訊可能在您的帳號刪除後仍會被保留。關於此等保留之具體情形與處理方式，悉依本公司隱私權政策之規定。"
msgstr "本公司將依據隱私權政策及適用法律，刪除您的個人資料，惟經本公司採取合理技術進行去識別化或彙總統計後，已無法識別特定個人之資料，得在適用法律允許的最大範圍內利用，不受您刪除帳號之限制。此外，本公司為履行法律義務、解決爭議、執行協議或營運之正當目的，部分資訊可能在您的帳號刪除後仍會被保留。關於此等保留之具體情形與處理方式，悉依本公司隱私權政策之規定。"

#: apps/dp-business/src/utils/dateRange.ts:101
msgid "本分鐘"
msgstr "本分鐘"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/MealSummaryCard.tsx:292
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:426
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:304
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:392
msgid "本商品為期間限定優惠"
msgstr "本商品為期間限定優惠"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:89
msgid "本商家"
msgstr "本商家"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:93
msgid "本商家是這一層的請款商家，帳匯進來"
msgstr "本商家是這一層的請款商家，帳匯進來"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:302
msgid "本商家未掛載任何連鎖樹"
msgstr "本商家未掛載任何連鎖樹"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/SigningAuditTab/index.web.tsx:130
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/EntryAuditTab/index.web.tsx:89
msgid "本商家無此類型審核單"
msgstr "本商家無此類型審核單"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:102
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:188
msgid "本商家簽約掛在這裡"
msgstr "本商家簽約掛在這裡"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:108
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:200
msgid "本商家請款掛在這裡"
msgstr "本商家請款掛在這裡"

#. placeholder {0}: diff.changeCount
#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:248
msgid "本單 {0} 處變更"
msgstr "本單 {0} 處變更"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:230
msgid "本單暫無變更對比"
msgstr "本單暫無變更對比"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:401
msgid "本國個人資訊"
msgstr "本國個人資訊"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:163
msgid "本國法人"
msgstr "本國法人"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:412
msgid "本國法人資訊"
msgstr "本國法人資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:429
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:116
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/constants.ts:50
#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:310
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:148
msgid "本國籍"
msgstr "本國籍"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:36
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:72
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:419
msgid "本國籍個人"
msgstr "本國籍個人"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:37
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:74
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:420
msgid "本國籍法人"
msgstr "本國籍法人"

#: apps/dp-client/src/screens/home/pages/Review/pages/draft/index.tsx:135
msgid "本地草稿"
msgstr "暫存草稿"

#: apps/dp-business/src/utils/dateRange.ts:102
msgid "本小時"
msgstr "本小時"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainNonSettlementState.tsx:52
msgid "本層若已掛店家，請款主體將向上解析至最近的結算節點。"
msgstr "本層若已掛店家，請款主體將向上解析至最近的結算節點。"

#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:89
msgid "本店位於臺北市信義區，鄰近101大樓，提供正宗川菜料理。店內環境優雅，適合商務聚餐和家庭聚會。招牌菜有麻婆豆腐、水煮魚等，口味地道，深受顧客喜愛。"
msgstr "本店位於臺北市信義區，鄰近101大樓，提供正宗川菜料理。店內環境優雅，適合商務聚餐和家庭聚會。招牌菜有麻婆豆腐、水煮魚等，口味地道，深受顧客喜愛。"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1195
msgid "本店採取預約制，座位有限，恕不接受現場候位與臨時加人。遲到超過規定時間視同取消，用餐時間自預約時間計算。"
msgstr "本店採取預約制，座位有限，恕不接受現場候位與臨時加人。遲到超過規定時間視同取消，用餐時間自預約時間計算。"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:28
msgid "本店提供最優質的服務，絕對是您的最佳選擇！我們的餐點新鮮美味，環境優雅舒適，服務態度一流。歡迎各位顧客光臨，保證讓您滿意而歸！另外我們還提供特殊服務..."
msgstr "本店提供最優質的服務，絕對是您的最佳選擇！我們的餐點新鮮美味，環境優雅舒適，服務態度一流。歡迎各位顧客光臨，保證讓您滿意而歸！另外我們還提供特殊服務..."

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:909
msgid "本店結算已由連鎖接管"
msgstr "本店結算已由連鎖接管"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:312
msgid "本店請款已由連鎖接管"
msgstr "本店請款已由連鎖接管"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/constants.ts:4
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:143
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:143
msgid "本日"
msgstr "本日"

#: apps/dp-business/src/utils/dateRange.ts:105
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/constants.ts:6
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:155
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:155
msgid "本月"
msgstr "本月"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/OverviewCards.web.tsx:59
msgid "本月GMV"
msgstr "本月GMV"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/OverviewCards.web.tsx:88
msgid "本月人均交易次數"
msgstr "本月人均交易次數"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/OverviewCards.web.tsx:69
msgid "本月人均交易額"
msgstr "本月人均交易額"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/records/components/PointsRecordItem/index.tsx:22
#: apps/dp-client/src/screens/account/pages/task-wall/pages/home/index.tsx:443
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:220
msgid "本月任務"
msgstr "本月任務"

#: apps/dp-business/src/pages/CustomerReviews/components/QualityMonitoringSection.tsx:134
msgid "本月未發現異常評價行為，評價品質良好，請繼續保持。"
msgstr "本月未發現異常評價行為，評價品質良好，請繼續保持。"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/OverviewCards.web.tsx:79
msgid "本月總交易次數"
msgstr "本月總交易次數"

#. placeholder {0}: shareStats?.totalIssuedCount ?? 0
#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:713
msgid "本期共記分享{0}次"
msgstr "本期共記分享{0}次"

#. placeholder {0}: activityInfo?.totalMaxCoins || 300
#: apps/dp-client/src/screens/diary/pages/home/components/points-card/index.tsx:386
msgid "本期最高可得{0}遠傳幣，達標後可繼續累積積分爭取大獎"
msgstr "本期最高可得{0}遠傳幣，達標後可繼續累積積分爭取大獎"

#: apps/dp-client/src/screens/home/pages/ShareKing/components/WinningList/index.tsx:165
msgid "本期幸運兒尚未揭曉，分享越多次，中獎機率越高喔！"
msgstr "本期幸運兒尚未揭曉，分享越多次，中獎機率越高喔！"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:450
msgid "本期排行榜"
msgstr "本期排行榜"

#: apps/dp-client/src/screens/home/pages/ShareKing/pages/RaffleWinners/index.tsx:204
msgid "本期未中獎，感謝您的參與！"
msgstr "本期未中獎，感謝您的參與！"

#: apps/dp-client/src/screens/home/pages/ShareKing/pages/RaffleWinners/index.tsx:210
msgid "本期未參加活動"
msgstr "本期未參加活動"

#: apps/dp-client/src/screens/diary/pages/no-access/index.tsx:112
msgid "本期活動已結束"
msgstr "本期活動已結束"

#: apps/dp-client/src/screens/diary/pages/my/components/UserProfileSection.tsx:52
#: apps/dp-client/src/screens/diary/pages/my/components/TabSwitch.tsx:51
#: apps/dp-client/src/screens/diary/pages/home/components/points-card/index.tsx:222
msgid "本期積分"
msgstr "本期積分"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:402
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:191
msgid "本樹"
msgstr "本樹"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:51
msgid "本樹（樹上請款）"
msgstr "本樹（樹上請款）"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:172
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:250
msgid "本樹掛載"
msgstr "本樹掛載"

#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:180
msgid "本樹有審核中的變更，審核通過或拒絕前不可再次編輯。"
msgstr "本樹有審核中的變更，審核通過或拒絕前不可再次編輯。"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:976
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:996
msgid "本樹有審核中的變更，通過或拒絕後才能再次編輯"
msgstr "本樹有審核中的變更，通過或拒絕後才能再次編輯"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:185
msgid "本樹用途：{roles}"
msgstr "本樹用途：{roles}"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:65
msgid "本樹當前掛接"
msgstr "本樹當前掛接"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:121
msgid "本樹結算"
msgstr "本樹結算"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:96
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:180
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:163
msgid "本樹角色"
msgstr "本樹角色"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:99
msgid "本次值"
msgstr "本次值"

#: apps/dp-client/src/screens/home/pages/ShareKing/components/ShareCompletedCard/index.tsx:23
msgid "本次分享已完成"
msgstr "本次分享已完成"

#. placeholder {0}: currentTreeName || '-'
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:273
msgid "本次只編輯「{0}」，其他樹的掛接請到該樹詳情編輯"
msgstr "本次只編輯「{0}」，其他樹的掛接請到該樹詳情編輯"

#: apps/dp-business/src/components/ClaimAmountAlert/index.tsx:33
msgid "本次可請款金額"
msgstr "本次可請款金額"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/EntryAuditTab/index.web.tsx:185
msgid "本次審核的商家入駐資訊"
msgstr "本次審核的商家入駐資訊"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:438
msgid "本次審核的店家POI資訊"
msgstr "本次審核的店家POI資訊"

#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:259
msgid "本次已選擇{totalSelected}條內容，將下架{validRowLength}條內容。若後續需要重新上架，需對內容進行全部人審，確認進行批量下架操作嗎？"
msgstr "本次已選擇{totalSelected}條內容，將下架{validRowLength}條內容。若後續需要重新上架，需對內容進行全部人審，確認進行批量下架操作嗎？"

#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:209
msgid "本次已選擇{totalSelected}條內容，將標記{validCount}條內容為需要抽檢。確認操作嗎？"
msgstr "本次已選擇{totalSelected}條內容，將標記{validCount}條內容為需要抽檢。確認操作嗎？"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:90
msgid "本次提交的手機號、郵箱分別為兩個帳號"
msgstr "本次提交的手機號、郵箱分別為兩個帳號"

#. placeholder {0}: editSummary.total
#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:129
msgid "本次改動 {0} 項"
msgstr "本次改動 {0} 項"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:300
msgid "本次改掛"
msgstr "本次改掛"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeBasicInfo/index.web.tsx:76
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:109
msgid "本次新增"
msgstr "本次新增"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:162
msgid "本次新增的券碼張數。"
msgstr "本次新增的券碼張數。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:225
msgid "本次更換"
msgstr "本次更換"

#: apps/dp-business/src/components/ClaimAmountAlert/index.tsx:32
msgid "本次未達請款門檻，暫不可請款"
msgstr "本次未達請款門檻，暫不可請款"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:405
msgid "本次活動僅限指定用戶參與"
msgstr "本次活動僅限指定用戶參與"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:391
msgid "本次活動已結束"
msgstr "本次活動已結束"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:198
msgid "本次無商家級變更，確認後將直接提交。"
msgstr "本次無商家級變更，確認後將直接提交。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:291
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:115
msgid "本次解除"
msgstr "本次解除"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:205
msgid "本次變更將影響以下流程與簽約，請確認後再發起。"
msgstr "本次變更將影響以下流程與簽約，請確認後再發起。"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:161
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:462
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:474
msgid "本活動未加碼"
msgstr "本活動未加碼"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:217
msgid "本筆訂單支付金額為$0，若取消或退款，將不會產生款項退回。"
msgstr "本筆訂單支付金額為$0，若取消或退款，將不會產生款項退回。"

#. placeholder {0}: node.selfShopCount ?? '-'
#: apps/dp-admin/src/pages/org-tree/org-detail/components/OrgNodeTree/index.web.tsx:73
msgid "本節點 {0}"
msgstr "本節點 {0}"

#. placeholder {0}: node.selfShopCount ?? '-'
#. placeholder {1}: node.childShopCount ?? '-'
#: apps/dp-admin/src/pages/org-tree/org-detail/components/OrgNodeTree/index.web.tsx:74
msgid "本節點 {0} · 下級 {1}"
msgstr "本節點 {0} · 下級 {1}"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/OrgNodeTree/index.web.tsx:118
msgid "本節點 {changeCount} 處改動"
msgstr "本節點 {changeCount} 處改動"

#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeNodeCard.tsx:124
msgid "本節點店家"
msgstr "本節點店家"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:545
msgid "本節點請款商家尚未完成藍新簽約，可查看結算單但不可提交請款。"
msgstr "本節點請款商家尚未完成藍新簽約，可查看結算單但不可提交請款。"

#: apps/dp-business/src/utils/dateRange.ts:104
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/constants.ts:5
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:149
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:149
msgid "本週"
msgstr "本週"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/records/components/PointsRecordItem/index.tsx:20
#: apps/dp-client/src/screens/account/pages/task-wall/pages/home/index.tsx:438
#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:223
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:220
msgid "本週任務"
msgstr "本週任務"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:37
msgid "本隱私政策描述了我們如何收集、使用和分享您的個人資訊。我們重視您的隱私，並致力於保護您的個人資料。"
msgstr "本隱私政策描述了我們如何收集、使用和分享您的個人資訊。我們重視您的隱私，並致力於保護您的個人資料。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:48
msgid "本頁改動將保存至草稿，暫不提交審核。"
msgstr "本頁改動將保存至草稿，暫不提交審核。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:47
msgid "本頁改動將合併為一張審核單，審核通過後才生效；審核期間本樹不可再次編輯。"
msgstr "本頁改動將合併為一張審核單，審核通過後才生效；審核期間本樹不可再次編輯。"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:66
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:107
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:69
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:110
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:188
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:127
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:35
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:276
msgid "李四"
msgstr "李四"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:66
msgid "李夢琪"
msgstr "李夢琪"

#: apps/dp-business/src/pages/RefundList/index.tsx:86
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:51
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:93
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:135
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:177
msgid "李小華"
msgstr "李小華"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:71
msgid "材料類型"
msgstr "材料類型"

#: apps/dp-admin/src/pages/merchant/information-error/index.web.tsx:28
msgid "東京餐廳"
msgstr "東京餐廳"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:90
msgid "東區"
msgstr "東區"

#: apps/dp-business/src/data/regions.ts:39
msgid "松山區"
msgstr "松山區"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:55
msgid "松葉牛蒡燒"
msgstr "松葉牛蒡燒"

#: apps/dp-business/src/data/regions.ts:54
msgid "板橋區"
msgstr "板橋區"

#: apps/dp-business/src/data/regions.ts:69
msgid "林口區"
msgstr "林口區"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:53
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:109
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:165
msgid "林客服"
msgstr "林客服"

#: apps/dp-business/src/data/categories.ts:233
msgid "果汁"
msgstr "果汁"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:45
msgid "某某街道123號"
msgstr "某某街道123號"

#: apps/dp-admin/src/pages/audit-center/services/apis.ts:409
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:420
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:431
msgid "某某路123號"
msgstr "某某路123號"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:51
msgid "查找用戶"
msgstr "查找用戶"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:42
msgid "查找訂單"
msgstr "查找訂單"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherUsageReport.tsx:76
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherSalesReport.tsx:76
#: apps/dp-business/src/pages/ChainDashboard/components/reports/CheckoutDiscountReport.tsx:64
msgid "查無對應訂單"
msgstr "查無對應訂單"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeCard/index.tsx:141
#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardCard/index.tsx:129
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:24
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:36
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:67
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:80
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:94
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:110
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:122
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:153
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:166
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:226
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:238
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:269
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:283
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:297
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:311
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:325
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:339
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:760
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:772
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:790
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:802
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:820
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:832
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:850
#: apps/dp-business/src/pages/RefundList/index.tsx:323
#: apps/dp-business/src/pages/OrderOverview/index.tsx:988
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1001
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1263
#: apps/dp-business/src/pages/OrderOverview/index.tsx:2033
#: apps/dp-business/src/pages/OrderList/index.tsx:664
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/columns.tsx:148
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:163
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/columns.tsx:148
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1394
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:242
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:264
#: apps/dp-business/src/pages/CouponVerification/index.tsx:740
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCommonColumns.tsx:115
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:54
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:344
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:953
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:295
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:217
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityDescriptionField/LandingPagePicker.web.tsx:194
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:435
#: apps/dp-admin/src/pages/merchant/components/LatestTaskPrompt/index.web.tsx:53
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:220
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:128
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:523
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:360
#: apps/dp-admin/src/pages/customer-service/components/TicketTable.web.tsx:70
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:163
#: apps/dp-admin/src/components/SensitiveInfo/MaskedText/index.web.tsx:52
msgid "查看"
msgstr "查看"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:554
msgid "查看 Google Map"
msgstr "查看 Google Map"

#. placeholder {0}: selectableApplicableShops.length + selectableSuspendedShops.length
#. placeholder {0}: data.stores.length
#. placeholder {0}: shops.length
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:1140
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:325
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:409
msgid "查看{0}家適用店家"
msgstr "查看{0}家適用店家"

#: apps/dp-client/src/screens/home/pages/Meal/components/ShopInfoCard/index.tsx:371
msgid "查看{count}家通用店家"
msgstr "查看{count}家通用店家"

#: apps/dp-client/src/screens/home/pages/Meal/components/ShopInfoCard/index.tsx:370
msgid "查看{count}家適用店家"
msgstr "查看{count}家適用店家"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/index.web.tsx:141
msgid "查看上次結果"
msgstr "查看上次結果"

#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:214
msgid "查看中獎名單"
msgstr "查看中獎名單"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:256
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:261
msgid "查看二維碼"
msgstr "查看二維碼"

#: apps/dp-business/src/utils/permissionData.ts:133
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:684
msgid "查看使用者"
msgstr "查看使用者"

#: apps/dp-admin/src/pages/data-center/review-detail/index.web.tsx:80
msgid "查看使用者評論的完整內容、圖片、評分詳情以及所有商家回覆"
msgstr "查看使用者評論的完整內容、圖片、評分詳情以及所有商家回覆"

#: apps/dp-client/src/screens/home/pages/Home/components/ClaimedCouponModal/index.tsx:225
msgid "查看優惠券"
msgstr "查看優惠券"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopBrandStory.tsx:64
#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/DishRankSection/index.tsx:154
#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/DishRankSection/index.tsx:195
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallTabBar/index.tsx:117
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:354
msgid "查看全部"
msgstr "查看全部"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallTabBar/index.tsx:117
msgid "查看全部 {viewAllCount}"
msgstr "查看全部 {viewAllCount}"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallDealsSection/index.tsx:73
msgid "查看全部餐券"
msgstr "查看全部餐券"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallShopSection/index.tsx:132
msgid "查看全部餐廳"
msgstr "查看全部餐廳"

#: apps/dp-business/src/pages/CustomerReviews/components/QualityMonitoringSection.tsx:126
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:77
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:77
msgid "查看分析"
msgstr "查看分析"

#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:100
msgid "查看券碼"
msgstr "查看票券號碼"

#: apps/dp-admin/src/pages/audit-center/merchant-audit/index.web.tsx:167
msgid "查看和審核商家的基本資訊和資質文件"
msgstr "查看和審核商家的基本資訊和資質文件"

#: apps/dp-admin/src/pages/order/merchant-order-list/index.web.tsx:66
msgid "查看和管理商家的所有訂單資訊"
msgstr "查看和管理商家的所有訂單資訊"

#: apps/dp-admin/src/pages/split-account/settlement-list/index.web.tsx:36
msgid "查看和管理商家結算單資訊"
msgstr "查看和管理商家結算單資訊"

#: apps/dp-admin/src/pages/marketing/order-list/index.web.tsx:47
msgid "查看和管理所有訂單資訊"
msgstr "查看和管理所有訂單資訊"

#: apps/dp-admin/src/pages/split-account/invoice-list/index.web.tsx:42
msgid "查看和管理發票資訊"
msgstr "查看和管理發票資訊"

#: apps/dp-admin/src/pages/merchant/merchant-onboard/index.web.tsx:73
msgid "查看商家入駐資訊，包括會員類型、企業登記資料與代表人資料"
msgstr "查看商家入駐資訊，包括會員類型、企業登記資料與代表人資料"

#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:66
msgid "查看商家權益"
msgstr "查看商家權益"

#: apps/dp-admin/src/pages/users/services/apis.ts:390
msgid "查看商家清單"
msgstr "查看商家清單"

#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:812
msgid "查看商家的進駐資訊，包括基本資訊和相關證件照片"
msgstr "查看商家的進駐資訊，包括基本資訊和相關證件照片"

#: apps/dp-business/src/pages/CustomerReviews/components/QualityMonitoringSection.tsx:135
msgid "查看報告"
msgstr "查看報告"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:643
msgid "查看填寫示例"
msgstr "查看填寫示例"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2288
msgid "查看套餐券"
msgstr "查看套餐券"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1120
msgid "查看套餐券模板的詳細資訊"
msgstr "查看套餐券模板的詳細資訊"

#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:192
msgid "查看審核單"
msgstr "查看審核單"

#: apps/dp-business/src/pages/SubmitSuccess/index.tsx:87
msgid "查看審核狀態"
msgstr "查看審核狀態"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/SigningHistoryModal/index.web.tsx:62
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:487
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/OnboardHistoryModal/index.web.tsx:62
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:294
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditRecordsModal/index.web.tsx:93
msgid "查看審核記錄"
msgstr "查看審核記錄"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:29
msgid "查看已保存套餐"
msgstr "查看已保存套餐"

#: apps/dp-admin/src/pages/data-center/merchant-stats/index.web.tsx:58
msgid "查看平台商家評價資料統計和分析"
msgstr "查看平台商家評價資料統計和分析"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:29
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:765
msgid "查看店家資訊"
msgstr "查看店家資訊"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:958
#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:159
msgid "查看影響的店家"
msgstr "查看影響的店家"

#: apps/dp-admin/src/pages/merchant/components/BdAssignmentField/index.web.tsx:90
#: apps/dp-admin/src/pages/merchant/components/BdAssignmentField/index.web.tsx:187
#: apps/dp-admin/src/pages/merchant/components/BdAssignmentField/index.web.tsx:239
msgid "查看影響的店家和商家"
msgstr "查看影響的店家和商家"

#: apps/dp-business/src/utils/permissionData.ts:100
msgid "查看我的投訴"
msgstr "查看我的投訴"

#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:50
msgid "查看數量"
msgstr "查看數量"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:908
#: apps/dp-business/src/pages/OrderDetail/index.tsx:124
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1419
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:241
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:252
msgid "查看明細"
msgstr "查看明細"

#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailCard/index.tsx:322
msgid "查看更多"
msgstr "查看更多"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:164
msgid "查看更多（共{mainTotal}家）"
msgstr "查看更多（共{mainTotal}家）"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:145
msgid "查看榜單"
msgstr "查看榜單"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/TemplateSelectField/index.web.tsx:85
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/DisplayFieldWithPreview/index.web.tsx:79
msgid "查看樣式"
msgstr "查看樣式"

#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:154
msgid "查看權益"
msgstr "查看權益"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/SigningAuditTab/index.web.tsx:156
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/EntryAuditTab/index.web.tsx:200
msgid "查看歷史記錄"
msgstr "查看歷史記錄"

#: apps/dp-client/src/screens/home/pages/PackageZone/templates/ActivityTemplate.tsx:423
msgid "查看活動說明"
msgstr "查看活動說明"

#: apps/dp-admin/src/pages/resource-config/delivery-record-list/index.web.tsx:57
msgid "查看消息推送記錄"
msgstr "查看消息推送記錄"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:190
msgid "查看生成批次"
msgstr "查看生成批次"

#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:70
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:92
#: apps/dp-admin/src/pages/org-tree/org-list/components/ApplicationModal/index.web.tsx:62
#: apps/dp-admin/src/pages/merchant/service/constants.ts:247
msgid "查看申請"
msgstr "查看申請"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/GestureShopList.tsx:221
msgid "查看當前區域推薦"
msgstr "查看當前區域推薦"

#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/MemberListTab/index.web.tsx:65
msgid "查看當前商家名單店家列表"
msgstr "查看當前商家名單店家列表"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/MemberListTab/index.web.tsx:75
msgid "查看當前用戶名單成員列表"
msgstr "查看當前用戶名單成員列表"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:653
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:703
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:836
msgid "查看發票"
msgstr "查看發票"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:433
msgid "查看示範"
msgstr "查看示範"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:577
#: apps/dp-client/src/screens/home/pages/Meal/pages/result/index.tsx:58
#: apps/dp-client/src/configs/page-configs.tsx:2149
msgid "查看票券"
msgstr "查看票券"

#: apps/dp-client/src/screens/account/pages/task-wall/components/ExchangeSuccessModal/index.tsx:90
msgid "查看票券匣"
msgstr "查看票券匣"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:183
msgid "查看組織樹"
msgstr "查看組織樹"

#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:93
msgid "查看結算單中的交易明細資訊"
msgstr "查看結算單中的交易明細資訊"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:68
msgid "查看編輯我的"
msgstr "查看編輯我的"

#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:136
msgid "查看與篩選商家組資料"
msgstr "查看與篩選商家組資料"

#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:162
msgid "查看與篩選用戶名單資料"
msgstr "查看與篩選用戶名單資料"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:269
msgid "查看與編輯 POI 資料"
msgstr "查看與編輯 POI 資料"

#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:102
msgid "查看衝突"
msgstr "查看衝突"

#: apps/dp-business/src/utils/permissionData.ts:165
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:712
msgid "查看角色"
msgstr "查看角色"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:574
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:231
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:825
msgid "查看訂單"
msgstr "查看訂單"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:672
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:691
msgid "查看訂單詳情"
msgstr "查看訂單詳情"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:712
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:198
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:253
msgid "查看設定"
msgstr "查看設定"

#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:47
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:91
msgid "查看設定功能開發中"
msgstr "查看設定功能開發中"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:115
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:795
msgid "查看評價"
msgstr "查看評價"

#: apps/dp-business/src/utils/permissionData.ts:116
msgid "查看評價監控"
msgstr "查看評價監控"

#: apps/dp-business/src/utils/permissionData.ts:76
msgid "查看評價詳情"
msgstr "查看評價詳情"

#: apps/dp-business/src/utils/permissionData.ts:68
msgid "查看評價頁面入口"
msgstr "查看評價頁面入口"

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:161
msgid "查看評論"
msgstr "查看評論"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:182
msgid "查看該商家審核單"
msgstr "查看該商家審核單"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallActivityModal/index.tsx:389
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:306
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:252
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:208
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:224
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:247
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:731
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:768
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:502
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:644
#: apps/dp-business/src/pages/CustomerReviews/components/QualityMonitoringSection.tsx:117
#: apps/dp-business/src/pages/ComplaintList/index.tsx:286
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:220
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:260
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:220
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:158
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:319
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:152
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:172
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:195
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:774
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:231
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:223
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:206
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:165
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:262
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:222
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:226
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:325
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:64
#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:159
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:198
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedMallTable/index.web.tsx:93
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/columns.web.tsx:81
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/columns.web.tsx:43
#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:124
#: apps/dp-admin/src/pages/org-tree/components/ReviewHistoryModal/index.web.tsx:124
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:163
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:151
#: apps/dp-admin/src/pages/merchant/service/constants.ts:237
#: apps/dp-admin/src/pages/merchant/service/constants.ts:242
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:234
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:135
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:669
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:857
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:661
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ImageUploadTips/index.web.tsx:144
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:186
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:336
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:357
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:188
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:68
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:68
#: apps/dp-admin/src/pages/customer-service/ticket-detail/index.web.tsx:155
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/BasicInfoCard.web.tsx:62
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:379
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:141
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:231
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:466
#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:171
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:194
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:154
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:244
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:203
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:227
#: apps/dp-admin/src/pages/audit-center/info-audit/components/InfoAuditTable/index.web.tsx:126
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:173
#: apps/dp-admin/src/components/Benefit/BenefitSelector/index.web.tsx:274
msgid "查看詳情"
msgstr "查看詳情"

#. placeholder {0}: viewTarget?.treeName || ''
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:205
msgid "查看詳情 · {0}"
msgstr "查看詳情 · {0}"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:356
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:421
msgid "查看詳細設定"
msgstr "查看詳細設定"

#: apps/dp-business/src/utils/permissionData.ts:35
msgid "查看資訊"
msgstr "查看資訊"

#: apps/dp-business/src/utils/permissionData.ts:27
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:650
msgid "查看資訊維護頁面入口"
msgstr "查看資訊維護頁面入口"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:207
msgid "查看路徑"
msgstr "查看路徑"

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:431
#: apps/dp-client/src/screens/diary/pages/comment-success/index.tsx:161
msgid "查看這則筆記"
msgstr "查看這則筆記"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:272
msgid "查看這棵樹"
msgstr "查看這棵樹"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:356
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:377
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateSelector/index.web.tsx:199
#: apps/dp-admin/src/components/UserGroup/UserGroupSelector/index.web.tsx:275
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupSelector/index.web.tsx:359
#: apps/dp-admin/src/components/LandingPage/LandingPageSelector/index.web.tsx:292
msgid "查看配置"
msgstr "查看配置"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:40
msgid "查看配置說明"
msgstr "查看配置說明"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:321
msgid "查看預訂"
msgstr "查看預訂"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/index.web.tsx:89
msgid "查看驗證情況"
msgstr "查看驗證情況"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1697
#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:190
#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterBar.tsx:95
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:444
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/DynamicConditionField/index.web.tsx:107
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:746
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:771
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:264
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:189
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:511
#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:208
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:356
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/SearchForm/index.web.tsx:58
#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:177
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:211
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:341
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:253
#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:140
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:325
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:213
#: apps/dp-admin/src/components/SearchForm/index.web.tsx:99
msgid "查詢"
msgstr "查詢"

#: apps/dp-business/src/servers/reservation/api.ts:1120
msgid "查詢C端用戶信息失敗"
msgstr "查詢C端用戶信息失敗"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useBenefitOptions.ts:72
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/BenefitPicker/index.web.tsx:52
msgid "查詢不到當前權益，權益可能已禁用或不存在"
msgstr "查詢不到當前權益，權益可能已禁用或不存在"

#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:64
msgid "查詢中..."
msgstr "查詢中..."

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/apis.ts:192
msgid "查詢中獎名單失敗"
msgstr "查詢中獎名單失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1409
#: apps/dp-admin/src/pages/marketing/services/apis.ts:1413
msgid "查詢券碼列表失敗"
msgstr "查詢券碼列表失敗"

#: apps/dp-business/src/servers/permission/api.ts:348
msgid "查詢員工帳號清單失敗"
msgstr "查詢員工帳號清單失敗"

#: apps/dp-business/src/servers/permission/api.ts:370
msgid "查詢員工帳號詳情失敗"
msgstr "查詢員工帳號詳情失敗"

#: apps/dp-business/src/servers/notification/api.ts:70
msgid "查詢商家任務詳情失敗"
msgstr "查詢商家任務詳情失敗"

#: apps/dp-admin/src/pages/transaction/service-management/components/MerchantPackageServiceOverview/index.web.tsx:79
msgid "查詢商家套餐券服務設定失敗"
msgstr "查詢商家套餐券服務設定失敗"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:217
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:658
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:197
msgid "查詢商家是否存在失敗"
msgstr "查詢商家是否存在失敗"

#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:70
msgid "查詢失敗"
msgstr "查詢失敗"

#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:77
msgid "查詢失敗，請檢查網絡連接後重試"
msgstr "查詢失敗，請檢查網絡連接後重試"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:518
msgid "查詢失敗，請稍後重試"
msgstr "查詢失敗，請稍後重試"

#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:73
msgid "查詢失敗，請重試"
msgstr "查詢失敗，請重試"

#: apps/dp-business/src/servers/reservation/api.ts:605
msgid "查詢已佔用時段失敗"
msgstr "查詢已佔用時段失敗"

#: apps/dp-business/src/servers/auth/api.ts:297
msgid "查詢帳號聯繫方式失敗"
msgstr "查詢帳號聯繫方式失敗"

#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CommissionBenefitListCard.web.tsx:94
msgid "查詢店家減免權益失敗"
msgstr "查詢店家減免權益失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/apis.ts:169
msgid "查詢抽獎歷史失敗"
msgstr "查詢抽獎歷史失敗"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:295
msgid "查詢支付狀態失敗，請稍後重試"
msgstr "查詢支付狀態失敗，請稍後重試"

#: apps/dp-business/src/servers/order/api.ts:246
msgid "查詢收銀記錄失敗"
msgstr "查詢收銀記錄失敗"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:102
#: apps/dp-admin/src/components/SearchForm/index.web.tsx:96
msgid "查詢條件"
msgstr "查詢條件"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:93
msgid "查詢權益發放明細失敗，請稍後重試"
msgstr "查詢權益發放明細失敗，請稍後重試"

#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CurrentCommissionCard.web.tsx:34
msgid "查詢當前佣金失敗"
msgstr "查詢當前佣金失敗"

#: apps/dp-business/src/servers/addStore/api.ts:136
msgid "查詢相似餐廳失敗"
msgstr "查詢相似餐廳失敗"

#: apps/dp-business/src/servers/settlement/api.ts:79
#: apps/dp-business/src/servers/chain/settlementApi.ts:158
msgid "查詢結算單交易列表失敗"
msgstr "查詢結算單交易列表失敗"

#: apps/dp-business/src/servers/settlement/api.ts:104
#: apps/dp-business/src/servers/chain/settlementApi.ts:171
msgid "查詢結算單交易合計失敗"
msgstr "查詢結算單交易合計失敗"

#: apps/dp-business/src/servers/settlement/api.ts:54
msgid "查詢結算單列表失敗"
msgstr "查詢結算單列表失敗"

#: apps/dp-business/src/servers/permission/api.ts:555
msgid "查詢複製歷史失敗"
msgstr "查詢複製歷史失敗"

#: apps/dp-business/src/servers/permission/api.ts:650
msgid "查詢複製歷史明細失敗"
msgstr "查詢複製歷史明細失敗"

#: apps/dp-business/src/servers/permission/api.ts:622
msgid "查詢複製歷史詳情失敗"
msgstr "查詢複製歷史詳情失敗"

#: apps/dp-business/src/servers/shop/api.ts:671
msgid "查詢複製記錄失敗"
msgstr "查詢複製記錄失敗"

#: apps/dp-business/src/servers/shop/api.ts:693
msgid "查詢複製記錄詳情失敗"
msgstr "查詢複製記錄詳情失敗"

#: apps/dp-business/src/servers/permission/api.ts:105
msgid "查詢角色清單失敗"
msgstr "查詢角色清單失敗"

#: apps/dp-business/src/servers/permission/api.ts:127
msgid "查詢角色詳情失敗"
msgstr "查詢角色詳情失敗"

#: apps/dp-admin/src/pages/marketing/activity-statistics/services/hooks.ts:145
msgid "查詢訂單失敗，請稍後重試"
msgstr "查詢訂單失敗，請稍後重試"

#: apps/dp-business/src/servers/claim/api.ts:39
msgid "查詢請款單列表失敗"
msgstr "查詢請款單列表失敗"

#: apps/dp-business/src/servers/claim/api.ts:71
msgid "查詢請款單詳情失敗"
msgstr "查詢請款單詳情失敗"

#: apps/dp-business/src/servers/claim/api.ts:103
#: apps/dp-business/src/servers/chain/settlementApi.ts:234
msgid "查詢請款單關聯結算單失敗"
msgstr "查詢請款單關聯結算單失敗"

#: apps/dp-business/src/servers/permission/api.ts:481
#: apps/dp-business/src/servers/permission/api.ts:505
msgid "查詢超管可選店家列表失敗"
msgstr "查詢超管可選店家列表失敗"

#: apps/dp-business/src/servers/chain/settlementApi.ts:145
msgid "查詢連鎖結算單失敗"
msgstr "查詢連鎖結算單失敗"

#: apps/dp-business/src/servers/chain/settlementApi.ts:209
msgid "查詢連鎖請款單失敗"
msgstr "查詢連鎖請款單失敗"

#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:69
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:211
msgid "查詢關聯商家數量失敗"
msgstr "查詢關聯商家數量失敗"

#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:433
msgid "查詢附近捷運"
msgstr "查詢附近捷運"

#: apps/dp-business/src/servers/shop/api.ts:588
msgid "查詢餐廳設置失敗"
msgstr "查詢餐廳設置失敗"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:166
msgid "栗色"
msgstr "栗色"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:81
msgid "校驗"
msgstr "校驗"

#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:220
msgid "校驗商家BD失敗"
msgstr "校驗商家BD失敗"

#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:160
msgid "校驗碼"
msgstr "校驗碼"

#: apps/dp-business/src/servers/claim/api.ts:151
#: apps/dp-business/src/servers/chain/settlementApi.ts:244
msgid "校驗請款條件失敗"
msgstr "校驗請款條件失敗"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:51
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:53
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BookingFeeRules/index.web.tsx:45
msgid "校驗錯誤"
msgstr "校驗錯誤"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:359
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:121
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:131
msgid "核准設立日期"
msgstr "核准設立日期"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:98
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:175
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:119
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:31
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:190
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:204
msgid "核定稅籍通知書"
msgstr "核定稅籍通知書"

#: apps/dp-business/src/pages/SimpleDashboard/SimpleLayout.tsx:171
#: apps/dp-business/src/pages/SimpleDashboard/components/ManualInputCard.tsx:109
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/OperationLogSection/index.web.tsx:33
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/OperationLogSection/index.web.tsx:33
msgid "核銷"
msgstr "核銷"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:474
#: apps/dp-client/src/configs/page-configs.tsx:834
#: apps/dp-business/src/pages/SimpleDashboard/components/RedeemCard.tsx:184
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:452
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:173
msgid "核銷券碼"
msgstr "核銷券碼"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:192
msgid "核銷券碼超時自動取消"
msgstr "核銷券碼超時自動取消"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:355
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:397
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:427
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:457
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/VerificationSection/index.web.tsx:42
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:325
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:377
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:417
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:457
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/VerificationSection/index.web.tsx:43
msgid "核銷商家"
msgstr "核銷商家"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:113
msgid "核銷地址"
msgstr "核銷地址"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:114
msgid "核銷地址不能超過200個字符"
msgstr "核銷地址不能超過200個字符"

#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:590
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:594
#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:177
#: apps/dp-business/src/pages/CouponVerification/index.tsx:537
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:691
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:146
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:169
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:175
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:173
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:199
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:205
msgid "核銷失敗"
msgstr "核銷失敗"

#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:226
#: apps/dp-business/src/pages/CouponVerification/index.tsx:551
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:707
msgid "核銷失敗，請稍後重試"
msgstr "核銷失敗，請稍後重試"

#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionSuccessContent/index.tsx:74
#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionConfirmContent/index.tsx:49
msgid "核銷套餐"
msgstr "核銷套餐"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:162
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:192
msgid "核銷完成：成功 {successCount} 張，失敗 {failCount} 張"
msgstr "核銷完成：成功 {successCount} 張，失敗 {failCount} 張"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:139
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:166
msgid ""
"核銷完成：成功 {successCount} 張，失敗 {failureCount} 張\n"
"{failedReasons}"
msgstr ""
"核銷完成：成功 {successCount} 張，失敗 {failureCount} 張\n"
"{failedReasons}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:169
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:225
#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionSuccessContent/index.tsx:67
#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionConfirmContent/index.tsx:43
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:214
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:192
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/columns.tsx:94
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:175
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:330
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:139
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:59
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:109
msgid "核銷店家"
msgstr "核銷店家"

#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionSuccessContent/index.tsx:59
#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:180
#: apps/dp-business/src/pages/CouponVerification/index.tsx:543
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:697
msgid "核銷成功"
msgstr "核銷成功"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:142
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:165
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:169
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:195
msgid "核銷成功 {successCount} 張"
msgstr "核銷成功 {successCount} 張"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:310
msgid "核銷截止日期不能早於原截止日期"
msgstr "核銷截止日期不能早於原截止日期"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:189
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:131
msgid "核銷操作人"
msgstr "核銷操作人"

#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:291
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1290
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:196
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:163
msgid "核銷數量"
msgstr "核銷數量"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:198
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:181
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:336
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:146
msgid "核銷方式"
msgstr "核銷方式"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:348
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:390
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:420
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:450
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:318
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:370
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:410
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:450
msgid "核銷日期"
msgstr "核銷日期"

#: apps/dp-admin/src/router/core/RouteComposer.ts:364
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:535
#: apps/dp-admin/src/pages/order/merchant-order-list/index.web.tsx:82
#: apps/dp-admin/src/pages/marketing/verification-record/index.web.tsx:10
msgid "核銷明細"
msgstr "核銷明細"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:543
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:209
msgid "核銷明細詳情"
msgstr "核銷明細詳情"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:813
#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionSuccessContent/index.tsx:142
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:195
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/columns.tsx:128
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/components/VerificationFilterBar.tsx:75
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1672
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2432
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:162
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:184
#: apps/dp-business/src/pages/CouponVerification/index.tsx:633
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:458
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:177
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherUsageReport.tsx:130
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/VerificationSection/index.web.tsx:48
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/VerificationSection/index.web.tsx:49
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:133
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:323
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:135
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:83
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:147
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:100
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:151
msgid "核銷時間"
msgstr "核銷時間"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/columns.tsx:116
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:83
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:71
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:134
msgid "核銷狀態"
msgstr "核銷狀態"

#: apps/dp-business/src/pages/MarketingCenter/components/RedemptionRulesCard.tsx:57
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:102
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:99
msgid "核銷規則"
msgstr "核銷規則"

#: apps/dp-business/src/servers/order/api.ts:138
msgid "核銷訂單失敗"
msgstr "核銷訂單失敗"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/components/VerificationSection/index.web.tsx:39
#: apps/dp-admin/src/pages/user-info/user-coupon-list/components/VerificationSection/index.web.tsx:40
msgid "核銷詳情"
msgstr "核銷詳情"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:174
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:128
msgid "核銷資訊"
msgstr "核銷資訊"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:152
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/index.tsx:131
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/columns.tsx:103
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:108
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:116
msgid "核銷金額"
msgstr "核銷金額"

#: apps/dp-business/src/servers/order/api.ts:223
msgid "根據商家 ID 查詢核銷記錄失敗"
msgstr "根據商家 ID 查詢核銷記錄失敗"

#: apps/dp-business/src/servers/order/api.ts:271
msgid "根據套餐券 ID 查詢統計信息失敗"
msgstr "根據套餐券 ID 查詢統計信息失敗"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:133
msgid "根據您所在地區的適用法律，您可能擁有以下權利："
msgstr "根據您所在地區的適用法律，您可能擁有以下權利："

#: apps/dp-business/src/servers/order/api.ts:116
msgid "根據核銷碼查詢訂單詳情失敗"
msgstr "根據核銷碼查詢訂單詳情失敗"

#: apps/dp-business/src/servers/order/api.ts:198
msgid "根據訂單 ID 查詢套餐券失敗"
msgstr "根據訂單 ID 查詢套餐券失敗"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:37
msgid "根本為我量身打造！"
msgstr "根本為我量身打造！"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1596
msgid "根節點不可刪除"
msgstr "根節點不可刪除"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1128
msgid "根節點不可刪除，如需改名請回第 1 步修改連鎖名稱"
msgstr "根節點不可刪除，如需改名請回第 1 步修改連鎖名稱"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:221
msgid "根節點不可改上級"
msgstr "根節點不可改上級"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:235
msgid "根節點無上級"
msgstr "根節點無上級"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:174
msgid "根級菜單圖標可選，如：UserOutlined、SettingOutlined 等"
msgstr "根級菜單圖標可選，如：UserOutlined、SettingOutlined 等"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:274
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:607
msgid "格式"
msgstr "格式"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:94
#: apps/dp-admin/src/pages/resource-config/services/constants.ts:100
msgid "格式：JPG"
msgstr "格式：JPG"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:841
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1035
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1134
msgid "格式：只能包含中文、英文字母和空格，長度2-50個字符"
msgstr "格式：只能包含中文、英文字母和空格，長度2-50個字元"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:877
msgid "格式：手機號碼9開頭9位數字，可加+886前綴（如0912345678或+886912345678）"
msgstr "格式：手機號碼9開頭9位數字，可加+886前綴（如0912345678或+886912345678）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:638
msgid "格式為 yyyyMMdd，例：20190515"
msgstr "格式為 yyyyMMdd，例：20190515"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:610
msgid "格式為「民國年(3碼)+月+日」，例：1040101；或 格式為「西元年月日」，例：20220405"
msgstr "格式為「民國年(3碼)+月+日」，例：1040101；或 格式為「西元年月日」，例：20220405"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:662
msgid "格式為「西元年月日」，例：20220405"
msgstr "格式為「西元年月日」，例：20220405"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:275
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:607
msgid "格式錯誤"
msgstr "格式錯誤"

#: apps/dp-business/src/data/regions.ts:11
msgid "桃園"
msgstr "桃園"

#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:73
msgid "案件類型"
msgstr "案件類型"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1478
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1183
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:731
#: apps/dp-business/src/pages/OrderOverview/Detail/components/ReservationSlots.tsx:66
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:588
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/components/ReservationSlots.web.tsx:108
msgid "桌位"
msgstr "桌位"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:782
msgid "桌位 {tableNames} 庫存必須大於等於1"
msgstr "桌位 {tableNames} 庫存必須大於等於1"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:930
msgid "桌位："
msgstr "桌位："

#: apps/dp-business/src/store/TableContext.tsx:47
#: apps/dp-business/src/store/TableContext.tsx:60
#: apps/dp-business/src/store/TableContext.tsx:69
#: apps/dp-business/src/store/TableContext.tsx:78
#: apps/dp-business/src/store/ReservationRulesContext.tsx:94
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:389
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:498
msgid "桌位1"
msgstr "桌位1"

#: apps/dp-business/src/store/TableContext.tsx:48
#: apps/dp-business/src/store/TableContext.tsx:61
#: apps/dp-business/src/store/TableContext.tsx:70
#: apps/dp-business/src/store/TableContext.tsx:79
#: apps/dp-business/src/store/ReservationRulesContext.tsx:102
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:396
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:506
msgid "桌位2"
msgstr "桌位2"

#: apps/dp-business/src/store/TableContext.tsx:49
#: apps/dp-business/src/store/TableContext.tsx:80
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:403
msgid "桌位3"
msgstr "桌位3"

#: apps/dp-business/src/store/TableContext.tsx:50
#: apps/dp-business/src/store/ReservationRulesContext.tsx:145
msgid "桌位4"
msgstr "桌位4"

#: apps/dp-business/src/store/TableContext.tsx:51
msgid "桌位5"
msgstr "桌位5"

#: apps/dp-business/src/store/TableContext.tsx:52
msgid "桌位6"
msgstr "桌位6"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:461
msgid "桌位不存在或刪除失敗"
msgstr "桌位不存在或刪除失敗"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:434
msgid "桌位不存在或更新失敗"
msgstr "桌位不存在或更新失敗"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:467
msgid "桌位刪除成功"
msgstr "桌位刪除成功"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:408
msgid "桌位創建成功"
msgstr "桌位創建成功"

#: apps/dp-business/src/pages/TableManagement/index.tsx:551
#: apps/dp-business/src/pages/TableManagement/index.tsx:729
#: apps/dp-business/src/pages/TableManagement/index.tsx:958
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1196
msgid "桌位名稱"
msgstr "桌位名稱"

#: apps/dp-business/src/pages/TableManagement/index.tsx:621
#: apps/dp-business/src/pages/TableManagement/index.tsx:799
msgid "桌位名稱長度必須在2-12字符之間"
msgstr "桌位名稱長度必須在2-12字符之間"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:784
msgid "桌位庫存設置無效"
msgstr "桌位庫存設置無效"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:440
msgid "桌位更新成功"
msgstr "桌位更新成功"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:800
#: apps/dp-business/src/components/CustomTabs/index.tsx:135
msgid "桌位管理"
msgstr "桌位管理"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:897
msgid "桌位資訊"
msgstr "桌位資訊"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1117
msgid "桌型"
msgstr "桌型"

#: apps/dp-business/src/pages/TableManagement/index.tsx:500
msgid "桌型已啟用"
msgstr "桌型已啟用"

#: apps/dp-business/src/pages/TableManagement/index.tsx:500
msgid "桌型已禁用"
msgstr "桌型已禁用"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:359
msgid "桌型桌位"
msgstr "桌型桌位"

#: apps/dp-business/src/pages/TableManagement/index.tsx:1039
msgid "桌型管理"
msgstr "桌型管理"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:369
msgid "條件已保存，名單將在刷新後更新"
msgstr "條件已保存，名單將在刷新後更新"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:264
#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:118
#: apps/dp-admin/src/pages/marketing/services/constants.ts:215
#: apps/dp-admin/src/pages/marketing/services/constants.ts:225
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:101
#: apps/dp-admin/src/modules/constants/userGroup.ts:42
msgid "條件篩選"
msgstr "條件篩選"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:325
msgid "條任務資料："
msgstr "條任務資料："

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:136
msgid "條形圖"
msgstr "條形圖"

#: apps/dp-business/src/pages/OrderList/index.tsx:969
msgid "條記錄"
msgstr "條記錄"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:337
msgid "條資料"
msgstr "條資料"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:304
msgid "棕褐"
msgstr "棕褐"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:108
msgid "業務合作夥伴："
msgstr "業務合作夥伴："

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:33
msgid "業務名稱"
msgstr "業務名稱"

#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:54
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:76
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:190
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:143
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateDetailInfo/index.web.tsx:68
msgid "業務模塊"
msgstr "業務模塊"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:229
msgid "業務結算項列表"
msgstr "業務結算項列表"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:184
msgid "業務結算項詳情"
msgstr "業務結算項詳情"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:58
msgid "業務編碼"
msgstr "業務編碼"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:462
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2364
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:136
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:43
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:160
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:133
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:111
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:58
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/OrderInfoCard/index.web.tsx:31
msgid "業務訂單號"
msgstr "業務訂單號"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/RefundOrdersCard/index.web.tsx:30
msgid "業務退款號"
msgstr "業務退款號"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:45
msgid "業務金額"
msgstr "業務金額"

#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadHistoryTable/index.web.tsx:109
msgid "業務類型"
msgstr "業務類型"

#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:322
msgid "業務類型："
msgstr "業務類型："

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.web.tsx:54
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:288
msgid "楷體"
msgstr "楷體"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1351
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1368
#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:327
msgid "概況與訂單"
msgstr "概況與訂單"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:279
msgid "概率"
msgstr "機率"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:564
msgid "概率分配完美！"
msgstr "機率分配完美！"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:287
msgid "概率必須在0-100之間"
msgstr "機率必須在0-100之間"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:559
msgid "概率總和不能超過100%，請調整各規則的概率"
msgstr "機率總和不能超過100%，請調整各規則的機率"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/index.web.tsx:120
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:149
msgid "概覽"
msgstr "概覽"

#: apps/dp-client/src/configs/page-configs.tsx:428
msgid "榜單"
msgstr "榜單"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:31
msgid "榜單 ID"
msgstr "榜單 ID"

#: apps/dp-admin/src/pages/resource-config/rank-list/index.web.tsx:94
msgid "榜單列表"
msgstr "榜單列表"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:652
msgid "榜單名單導入"
msgstr "榜單名單導入"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/searchConfig.ts:22
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:38
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:402
msgid "榜單名稱"
msgstr "榜單名稱"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:52
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:410
msgid "榜單排行值"
msgstr "榜單排行值"

#: apps/dp-admin/src/pages/resource-config/rank-list/index.web.tsx:41
msgid "榜單數據"
msgstr "榜單數據"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:461
msgid "榜單時效"
msgstr "榜單時效"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/searchConfig.ts:58
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:81
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:455
msgid "榜單狀態"
msgstr "榜單狀態"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/searchConfig.ts:28
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:45
#: apps/dp-admin/src/pages/resource-config/rank-list/components/RankDetailModal/index.web.tsx:46
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:432
msgid "榜單編碼"
msgstr "榜單編碼"

#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/CustomHeader/index.tsx:112
msgid "榜單規則"
msgstr "榜單規則"

#: apps/dp-admin/src/router/config/routes.web.tsx:594
#: apps/dp-admin/src/pages/resource-config/rank-list/index.web.tsx:77
msgid "榜單配置"
msgstr "榜單配置"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/searchConfig.ts:48
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:64
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:421
msgid "榜單類型"
msgstr "榜單類型"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:181
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/shopConfig.web.tsx:18
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/UpdateLocationModal/index.web.tsx:95
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:199
msgid "樓層"
msgstr "樓層"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:65
msgid "樓層名稱"
msgstr "樓層名稱"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/UpdateLocationModal/index.web.tsx:104
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:201
msgid "樓層描述"
msgstr "樓層描述"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:62
msgid "樓層數量"
msgstr "樓層數量"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.web.tsx:114
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:266
msgid "標準"
msgstr "標準"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:70
msgid "標準登入"
msgstr "標準登入"

#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:133
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:585
msgid "標簽時效"
msgstr "標簽時效"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:286
#: apps/dp-business/src/pages/MenuManagement.tsx:1274
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:925
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:433
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:303
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:164
msgid "標籤"
msgstr "標籤"

#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:51
msgid "標籤ID"
msgstr "標籤ID"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:411
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:270
msgid "標籤使用統計"
msgstr "標籤使用統計"

#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:99
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:613
#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:78
msgid "標籤來源"
msgstr "標籤來源"

#: apps/dp-admin/src/router/config/routes.web.tsx:271
#: apps/dp-admin/src/router/config/routes.web.tsx:711
msgid "標籤列表"
msgstr "標籤列表"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:234
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:391
#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:104
msgid "標籤名稱"
msgstr "標籤名稱"

#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:889
msgid "標籤名稱不能為空"
msgstr "標籤名稱不能為空"

#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:883
msgid "標籤名稱不能超過20個字符"
msgstr "標籤名稱不能超過20個字符"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:353
msgid "標籤名稱重複"
msgstr "標籤名稱重複"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:310
msgid "標籤圖片"
msgstr "標籤圖片"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:729
msgid "標籤圖片預覽"
msgstr "標籤圖片預覽"

#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:43
msgid "標籤審核"
msgstr "標籤審核"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:272
msgid "標籤展示規則"
msgstr "標籤展示規則"

#: apps/dp-admin/src/pages/merchant/components/TagEditor/index.web.tsx:96
msgid "標籤已存在"
msgstr "標籤已存在"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:250
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:196
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:433
msgid "標籤描述"
msgstr "標籤描述"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:311
msgid "標籤描述不能超過50個字元"
msgstr "標籤描述不能超過50個字元"

#: apps/dp-admin/src/modules/hooks/options/useTagTreeOptions.ts:100
msgid "標籤樹資料取得失敗"
msgstr "標籤樹資料取得失敗"

#: apps/dp-admin/src/modules/hooks/options/useTagTreeOptions.ts:109
msgid "標籤樹資料取得異常"
msgstr "標籤樹資料取得異常"

#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:116
#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:62
msgid "標籤狀態"
msgstr "標籤狀態"

#: apps/dp-admin/src/router/config/routes.web.tsx:264
#: apps/dp-admin/src/router/config/routes.web.tsx:702
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:720
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:149
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:149
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:238
msgid "標籤管理"
msgstr "標籤管理"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:727
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:224
msgid "標籤詳情"
msgstr "標籤詳情"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:222
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:272
msgid "標籤説明"
msgstr "標籤説明"

#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:867
msgid "標籤資料必須是陣列格式"
msgstr "標籤資料必須是陣列格式"

#: apps/dp-admin/src/pages/other/notifications/components/NotificationCard/index.web.tsx:82
msgid "標記已讀"
msgstr "標記已讀"

#: apps/dp-business/src/servers/notification/api.ts:115
msgid "標記所有通知為已讀失敗"
msgstr "標記所有通知為已讀失敗"

#: apps/dp-business/src/servers/notification/api.ts:169
msgid "標記業務模塊通知為已讀失敗"
msgstr "標記業務模組通知為已讀失敗"

#: apps/dp-admin/src/pages/report-center/services/interface/manual-compensation.ts:75
msgid "標記為處理成功"
msgstr "標記為處理成功"

#: apps/dp-business/src/servers/notification/api.ts:139
msgid "標記通知為已讀失敗"
msgstr "標記通知為已讀失敗"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteShopSection.tsx:39
#: apps/dp-client/src/screens/home/pages/Note/components/MarkShopModal/index.tsx:51
msgid "標註店家"
msgstr "標註店家"

#: apps/dp-client/src/screens/home/pages/Note/pages/draft/index.tsx:142
msgid "標註店家:"
msgstr "標註店家:"

#: apps/dp-client/src/components/ConfirmModal/index.tsx:108
#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:136
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:88
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:175
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:106
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:160
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:95
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:123
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:35
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:41
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:59
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:93
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:136
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:175
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:136
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:168
msgid "標題"
msgstr "標題"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:134
msgid "標題不能超過 20 個字符（漢字按 2 個字符計算）"
msgstr "標題不能超過 20 個字符（漢字按 2 個字符計算）"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:100
msgid "標題不能超過20個字"
msgstr "標題不能超過20個字"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:92
msgid "標題最多 100 個字符"
msgstr "標題最多 100 個字符"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:49
msgid "模式"
msgstr "模式"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:425
msgid "模擬觸發次數："
msgstr "模擬觸發次數："

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:179
msgid "模板"
msgstr "模板"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:44
msgid "模板ID"
msgstr "模板ID"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/TemplateSelectField/constants.ts:23
msgid "模板一"
msgstr "模板一"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:75
msgid "模板下載失敗，請重試"
msgstr "模板下載失敗，請重試"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/TemplateSelectField/constants.ts:28
msgid "模板二"
msgstr "模板二"

#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:42
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:56
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:338
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:135
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:37
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:106
msgid "模板代碼"
msgstr "模板代碼"

#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:48
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:50
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:146
#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:22
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:67
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:132
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:40
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:63
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:96
msgid "模板名稱"
msgstr "模板名稱"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:105
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:223
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:160
msgid "模板描述"
msgstr "模板描述"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:348
msgid "模板數區間最大值需大於最小值"
msgstr "模板數區間最大值需大於最小值"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:260
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/FixedPackageImportField/index.web.tsx:100
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:81
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:81
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ImportShopModal/index.web.tsx:54
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:138
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:82
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:253
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:132
msgid "模板文件不存在"
msgstr "模板文件不存在"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:46
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:72
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:105
msgid "模板狀態"
msgstr "模板狀態"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:155
msgid "模板編碼"
msgstr "模板編碼"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:121
msgid "模板詳情"
msgstr "模板詳情"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateDetailInfo/index.web.tsx:62
msgid "模版代碼"
msgstr "模版代碼"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:173
msgid "模糊"
msgstr "模糊"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/DisplayFieldWithPreview/index.web.tsx:84
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/DisplayFieldWithPreview/index.web.tsx:93
msgid "樣式預覽"
msgstr "樣式預覽"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:179
msgid "樹上位置"
msgstr "樹上位置"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:166
msgid "樹上的層"
msgstr "樹上的層"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:31
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:32
msgid "樹名稱"
msgstr "樹名稱"

#: apps/dp-business/src/data/regions.ts:62
msgid "樹林區"
msgstr "樹林區"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:161
msgid "橄欖綠"
msgstr "橄欖綠"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:164
msgid "橙色"
msgstr "橙色"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:133
msgid "機器機型 :"
msgstr "機器機型 :"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:982
msgid ""
"機器用戶\n"
"cafe333"
msgstr ""
"機器用戶\n"
"cafe333"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:135
msgid "機器系統 :"
msgstr "機器系統 :"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:150
msgid "機審不透過 待人審"
msgstr "機審不透過 待人審"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:154
msgid "機審不透過 無需人審"
msgstr "機審不透過 無需人審"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:33
msgid "機審中"
msgstr "機審中"

#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:268
msgid "機審時間"
msgstr "機審時間"

#: apps/dp-admin/src/pages/data-center/review-detail/index.web.tsx:32
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:35
msgid "機審未通過"
msgstr "機審未通過"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:57
msgid "機審未通過(無需人審)"
msgstr "機審未通過(無需人審)"

#: apps/dp-admin/src/pages/audit-center/components/AuditIssuesList/index.web.tsx:61
msgid "機審歷史"
msgstr "機審歷史"

#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:205
msgid "機審結果"
msgstr "機審結果"

#: apps/dp-admin/src/pages/audit-center/user-audit/services/hooks.ts:89
#: apps/dp-admin/src/pages/audit-center/user-audit/services/hooks.ts:102
msgid "機審返回的說明"
msgstr "機審返回的說明"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:146
msgid "機審透過 抽檢"
msgstr "機審透過 抽檢"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:142
msgid "機審透過 透過"
msgstr "機審透過 透過"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:34
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:52
msgid "機審通過"
msgstr "機審通過"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:75
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:237
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:119
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:160
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:36
msgid "機車"
msgstr "機車"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:188
msgid "橡皮擦"
msgstr "橡皮擦"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:191
msgid "橢圓"
msgstr "橢圓"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:219
msgid "橢圓選框"
msgstr "橢圓選框"

#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/MediaReplacer.tsx:75
#: apps/dp-business/src/components/PhotoUploader/validation.ts:113
#: apps/dp-business/src/components/PhotoUploader/upload.ts:364
#: apps/dp-business/src/components/PhotoUploader/upload.ts:410
msgid "檔案"
msgstr "檔案"

#. placeholder {0}: oversizedFile.name
#. placeholder {0}: oversized.name
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:259
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:243
msgid "檔案 {0} 大小超過 10MB"
msgstr "檔案 {0} 大小超過 10MB"

#: apps/dp-business/src/servers/file/api.ts:94
msgid "檔案上傳失敗"
msgstr "檔案上傳失敗"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:222
msgid "檔案上傳失敗，請重試"
msgstr "檔案上傳失敗，請重試"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:201
msgid "檔案上傳成功"
msgstr "檔案上傳成功"

#: apps/dp-business/src/servers/contract-management/api.ts:467
#: apps/dp-admin/src/pages/marketing/components/GroupExcelDownload/index.web.tsx:52
#: apps/dp-admin/src/modules/hooks/useBlobDownload.ts:63
#: apps/dp-admin/src/modules/hooks/useBlobDownload.ts:129
msgid "檔案下載失敗"
msgstr "檔案下載失敗"

#: apps/dp-admin/src/pages/marketing/services/groupImport.ts:112
#: apps/dp-admin/src/pages/marketing/services/groupImport.ts:116
#: apps/dp-admin/src/pages/marketing/services/groupImport.ts:126
msgid "檔案下載失敗，請稍後重試"
msgstr "檔案下載失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/components/GroupExcelDownload/index.web.tsx:49
#: apps/dp-admin/src/modules/hooks/useDownload.ts:138
#: apps/dp-admin/src/modules/hooks/useDownload.ts:189
msgid "檔案下載開始"
msgstr "檔案下載開始"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/channelCampaignPackageActions.ts:70
msgid "檔案不能超過 10MB"
msgstr "檔案不能超過 10MB"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:79
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:100
msgid "檔案名"
msgstr "檔案名"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:609
msgid "檔案名稱"
msgstr "檔案名稱"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:627
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:99
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:146
msgid "檔案大小"
msgstr "檔案大小"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:705
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:93
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponCodeUpload.web.tsx:83
msgid "檔案大小不能超過 10MB"
msgstr "檔案大小不能超過 10MB"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:91
msgid "檔案格式"
msgstr "檔案格式"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:146
#: apps/dp-client/src/components/Upload/index.tsx:565
msgid "檔案處理失敗"
msgstr "檔案處理失敗"

#: apps/dp-business/src/components/PhotoUploader/hooks/useFileUpload.ts:170
#: apps/dp-business/src/components/PhotoUploader/hooks/useFileUpload.ts:295
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:376
msgid "檔案處理失敗，請重試"
msgstr "檔案處理失敗，請重試"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponCodeUpload.web.tsx:57
msgid "檔案解析失敗"
msgstr "檔案解析失敗"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponCodeUpload.web.tsx:60
msgid "檔案讀取失敗"
msgstr "檔案讀取失敗"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:323
msgid "檔案選擇器初始化失敗"
msgstr "檔案選擇器初始化失敗"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:100
msgid "檔案附件"
msgstr "檔案附件"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:620
msgid "檔案類型"
msgstr "檔案類型"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:276
msgid "檢測"
msgstr "檢測"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:93
msgid "檢測、調查和預防欺詐和其他非法活動"
msgstr "檢測、調查和預防欺詐和其他非法活動"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:383
#: apps/dp-business/src/components/PhotoUploader/index.tsx:204
#: apps/dp-business/src/components/PhotoUploader/components/PhotoUploadArea.tsx:67
msgid "檢測中..."
msgstr "檢測中..."

#: apps/dp-business/src/pages/CustomerReviews/components/QualityMonitoringSection.tsx:116
msgid "檢測到5條可能的惡意評價，建議及時處理以維護店家聲譽。"
msgstr "檢測到5條可能的惡意評價，建議及時處理以維護店家聲譽。"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:135
msgid "檢測到待完善申請，正在跳轉..."
msgstr "檢測到待完整填寫申請，正在跳轉..."

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:226
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:302
msgid "檢測到您修改了銀行資訊，需要重新上傳ERP，確認繼續修改嗎？"
msgstr "檢測到您修改了銀行資訊，需要重新上傳ERP，確認繼續修改嗎？"

#: apps/dp-client/src/screens/diary/hooks/useEditData.ts:56
msgid "檢測到草稿資料，正在載入..."
msgstr "檢測到草稿資料，正在載入..."

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:95
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:206
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:104
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:172
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:106
#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:111
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:96
#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:83
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:256
#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:121
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeSearchForm/index.web.tsx:44
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:197
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:136
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:174
#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:119
msgid "檢索"
msgstr "檢索"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:284
#: apps/dp-client/src/screens/home/pages/Review/pages/complaintComplete/index.tsx:13
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:933
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:345
#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:294
msgid "檢舉"
msgstr "檢舉"

#. placeholder {0}: noteDetail?.id
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:422
msgid "檢舉_{0}"
msgstr "檢舉_{0}"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:98
msgid "檢舉人"
msgstr "檢舉人"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:101
msgid "檢舉人ID"
msgstr "檢舉人ID"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:160
msgid "檢舉分類"
msgstr "檢舉分類"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:173
msgid "檢舉原因"
msgstr "檢舉原因"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:173
msgid "檢舉商家服務"
msgstr "檢舉商家服務"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:137
msgid "檢舉店家服務"
msgstr "檢舉店家服務"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:195
msgid "檢舉成立"
msgstr "檢舉成立"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:92
msgid "檢舉時間"
msgstr "檢舉時間"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:280
msgid "檢舉此評論"
msgstr "檢舉此評論"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:281
msgid "檢舉此貼文"
msgstr "檢舉此貼文"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:157
msgid "檢舉詳情"
msgstr "檢舉詳情"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:182
msgid "檢舉證據"
msgstr "檢舉證據"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:90
msgid "檢舉資訊"
msgstr "檢舉資訊"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:95
msgid "檢舉類型"
msgstr "檢舉類型"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:84
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:230
msgid "欄位"
msgstr "欄位"

#. placeholder {0}: benefit.benefitId
#. placeholder {0}: index + 1
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:152
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitCard/index.web.tsx:46
msgid "權益 {0}"
msgstr "權益 {0}"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:142
msgid "權益 / 套餐數量"
msgstr "權益 / 套餐數量"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/BenefitInfoPanel/index.web.tsx:57
#: apps/dp-admin/src/components/Benefit/BenefitSelector/index.web.tsx:202
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:87
msgid "權益 ID"
msgstr "權益 ID"

#. placeholder {0}: benefit.benefitId
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:229
msgid "權益 ID {0}"
msgstr "權益 ID {0}"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:170
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:134
msgid "權益ID"
msgstr "權益ID"

#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:142
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:347
msgid "權益列表"
msgstr "權益列表"

#: apps/dp-admin/src/components/Benefit/BenefitSelector/index.web.tsx:188
msgid "權益列表載入失敗，請重新搜尋"
msgstr "權益列表載入失敗，請重新搜尋"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:216
#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:77
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:368
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:209
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:215
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CommissionBenefitListCard.web.tsx:29
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:419
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:433
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:87
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:73
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:183
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:97
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:131
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/BenefitInfoPanel/index.web.tsx:60
msgid "權益名稱"
msgstr "權益名稱"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:147
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:140
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:100
msgid "權益子類型"
msgstr "權益子類型"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:426
msgid "權益數量"
msgstr "權益數量"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useBenefitOptions.ts:78
msgid "權益查詢失敗，請確認權益是否禁用後重試"
msgstr "權益查詢失敗，請確認權益是否禁用後重試"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useBenefitOptions.ts:32
msgid "權益查詢失敗，請重試"
msgstr "權益查詢失敗，請重試"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:130
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:267
msgid "權益歸屬"
msgstr "權益歸屬"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:113
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:212
msgid "權益狀態"
msgstr "權益狀態"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:72
msgid "權益發放數量"
msgstr "權益發放數量"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/index.web.tsx:64
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueDetailTab.web.tsx:137
msgid "權益發放明細"
msgstr "權益發放明細"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:73
msgid "權益發放總數"
msgstr "權益發放總數"

#: apps/dp-admin/src/router/config/routes.web.tsx:214
msgid "權益管理"
msgstr "權益管理"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:67
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:177
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:112
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:90
msgid "權益編碼"
msgstr "權益編碼"

#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:154
#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:439
msgid "權益編碼僅允許大寫字母/數字/下劃線，長度 4-64"
msgstr "權益編碼僅允許大寫字母/數字/下劃線，長度 4-64"

#: apps/dp-admin/src/router/config/routes.web.tsx:229
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:496
msgid "權益編輯"
msgstr "權益編輯"

#: apps/dp-admin/src/components/Benefit/BenefitSelector/index.web.tsx:285
msgid "權益詳情"
msgstr "權益詳情"

#: apps/dp-admin/src/components/Benefit/BenefitSelector/index.web.tsx:136
msgid "權益詳情載入失敗"
msgstr "權益詳情載入失敗"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:372
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:210
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:216
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:143
msgid "權益說明"
msgstr "權益說明"

#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:229
msgid "權益資料或配置載入失敗，請重試"
msgstr "權益資料或配置載入失敗，請重試"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/DynamicConfigSection.web.tsx:225
#: apps/dp-admin/src/pages/marketing/benefit-form/components/DynamicConfigSection.web.tsx:233
#: apps/dp-admin/src/pages/marketing/benefit-form/components/DynamicConfigSection.web.tsx:243
msgid "權益配置"
msgstr "權益配置"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:79
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:189
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:129
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:137
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/BenefitInfoPanel/index.web.tsx:65
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:95
msgid "權益類型"
msgstr "權益類型"

#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:32
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:69
msgid "權益類型載入失敗"
msgstr "權益類型載入失敗"

#: apps/dp-client/src/screens/diary/pages/my/components/RNCropPhoto/CropPhoto.tsx:280
#: apps/dp-business/src/components/PhotoUploader/upload.ts:366
#: apps/dp-business/src/components/PhotoUploader/upload.ts:412
#: apps/dp-admin/src/pages/merchant/shared/constants.ts:86
msgid "權限不足"
msgstr "權限不足"

#: apps/dp-business/src/components/PhotoUploader/upload.ts:365
#: apps/dp-business/src/components/PhotoUploader/upload.ts:411
msgid "權限不足：需要訪問相冊權限才能選擇{fileType}"
msgstr "權限不足：需要訪問相冊權限才能選擇{fileType}"

#: apps/dp-business/src/utils/permissionUtils.ts:345
msgid "權限代碼檢查: {permissionCode}"
msgstr "權限代碼檢查: {permissionCode}"

#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:277
msgid "權限依賴提醒"
msgstr "權限依賴提醒"

#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:106
msgid "權限名稱"
msgstr "權限名稱"

#: apps/dp-business/src/pages/PermissionManagement/index.tsx:162
msgid "權限描述"
msgstr "權限描述"

#: apps/dp-business/src/hooks/usePermissions.ts:46
msgid "權限檢查失敗"
msgstr "權限檢查失敗"

#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:90
#: apps/dp-admin/src/router/config/routes.web.tsx:506
#: apps/dp-admin/src/pages/users/permissions/index.web.tsx:142
msgid "權限管理"
msgstr "權限管理"

#: apps/dp-admin/src/pages/users/permissions/components/PermissionTreeTable/index.web.tsx:184
msgid "權限結構"
msgstr "權限結構"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:119
msgid "權限編碼"
msgstr "權限編碼"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:147
msgid "權限編碼：用於權限控制的唯一標識，建議使用大寫字母和下劃線"
msgstr "權限編碼：用於權限控制的唯一標識，建議使用大寫字母和下劃線"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:125
msgid "權限編碼格式不正確，應以大寫字母開頭，只能包含大寫字母、數字、下劃線"
msgstr "權限編碼格式不正確，應以大寫字母開頭，只能包含大寫字母、數字、下劃線"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:474
msgid "權限被拒絕"
msgstr "權限被拒絕"

#: apps/dp-business/src/pages/AddRole/index.tsx:407
msgid "權限設定"
msgstr "權限設定"

#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:565
#: apps/dp-client/src/screens/account/pages/user-profile/pages/permission-settings/index.tsx:72
#: apps/dp-client/src/configs/page-configs.tsx:2592
msgid "權限設置"
msgstr "權限設置"

#: apps/dp-client/src/screens/home/pages/Note/constants/index.ts:28
msgid "權限請求失敗，請手動在瀏覽器設置中允許相機訪問"
msgstr "權限請求失敗，請手動在瀏覽器設置中允許啟動相機"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:210
#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:331
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:345
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:167
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:293
msgid "次"
msgstr "次"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:367
msgid "次（0 表示不限制）"
msgstr "次（0 表示不限制）"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:334
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:574
msgid "次/人"
msgstr "次/人"

#: apps/dp-client/src/screens/home/utils/order.ts:217
#: apps/dp-business/src/pages/BusinessHours/index.tsx:682
#: apps/dp-business/src/pages/BusinessHours/index.tsx:683
#: apps/dp-business/src/pages/BusinessHours/index.tsx:977
#: apps/dp-business/src/pages/BusinessHours/index.tsx:978
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:380
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:382
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:523
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:525
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:786
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:1041
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:315
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:356
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:358
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:632
#: apps/dp-admin/src/components/BusinessHours/utils.ts:237
msgid "次日"
msgstr "次日"

#. placeholder {0}: firstRange.startTime
#: apps/dp-client/src/utils/businessStatus.ts:147
msgid "次日 {0}"
msgstr "次日 {0}"

#. placeholder {0}: tr.endTime
#. placeholder {0}: custom.startTime
#. placeholder {0}: custom.endTime
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:114
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1554
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1559
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2038
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2043
#: apps/dp-business/src/pages/BusinessHours/index.tsx:870
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1131
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:162
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:136
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:137
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:512
msgid "次日{0}"
msgstr "次日{0}"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:777
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1159
msgid "次日{displayEnd}"
msgstr "次日{displayEnd}"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:772
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1155
msgid "次日{displayStart}"
msgstr "次日{displayStart}"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:694
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:171
msgid "次日{end}"
msgstr "次日{end}"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:152
msgid "次日{endH}:{endM}"
msgstr "次日{endH}:{endM}"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:131
#: apps/dp-business/src/pages/BusinessHours/index.tsx:216
#: apps/dp-business/src/pages/BusinessHours/index.tsx:340
#: apps/dp-business/src/pages/BusinessHours/index.tsx:419
#: apps/dp-business/src/pages/BusinessHours/index.tsx:541
msgid "次日{endTime}"
msgstr "次日{endTime}"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:158
msgid "次日{maxTime}"
msgstr "次日{maxTime}"

#: apps/dp-client/src/utils/businessStatus.ts:294
msgid "次日{openTime}營業"
msgstr "次日{openTime}營業"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:373
msgid "次日{originalEnd}"
msgstr "次日{originalEnd}"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:691
msgid "次日{start}"
msgstr "次日{start}"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:126
#: apps/dp-business/src/pages/BusinessHours/index.tsx:211
#: apps/dp-business/src/pages/BusinessHours/index.tsx:335
#: apps/dp-business/src/pages/BusinessHours/index.tsx:413
#: apps/dp-business/src/pages/BusinessHours/index.tsx:535
msgid "次日{startTime}"
msgstr "次日{startTime}"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1554
msgid "次日{time}"
msgstr "次日{time}"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:95
msgid "歇業"
msgstr "歇業"

#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:62
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:86
msgid "歇業/關閉"
msgstr "歇業/關閉"

#: apps/dp-business/src/pages/Login/index.tsx:886
#: apps/dp-business/src/pages/Login/index.tsx:1360
msgid "歡迎加入"
msgstr "歡迎加入"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/home/index.tsx:227
msgid "歡迎參加！獲得點數"
msgstr "歡迎參加！獲得點數"

#: apps/dp-client/src/screens/login/pages/welcome-back/index.tsx:40
#: apps/dp-client/src/configs/page-configs.tsx:1257
msgid "歡迎回來"
msgstr "歡迎回來"

#: apps/dp-client/src/screens/home/pages/PrivateChef/index.tsx:312
msgid "歡迎關注後續釋出名額"
msgstr "歡迎關注後續釋出名額"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:85
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:61
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:180
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:461
msgid "正向"
msgstr "正向"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:80
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:412
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:46
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:47
msgid "正在上傳圖像&hellip;"
msgstr "正在上傳圖像&hellip;"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:87
msgid "正在儲存中..."
msgstr "正在儲存中..."

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:602
msgid "正在刷新券碼..."
msgstr "正在刷新券碼..."

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:401
msgid "正在前往查看"
msgstr "正在前往查看"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:348
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:365
msgid "正在加載..."
msgstr "正在加載..."

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:228
msgid "正在匯入…"
msgstr "正在匯入…"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:221
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:115
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:237
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:267
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:86
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:375
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:48
msgid "正在匯出..."
msgstr "正在匯出..."

#: apps/dp-business/src/pages/AddStore/index.tsx:1367
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:700
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/index.web.tsx:216
msgid "正在取得位置資訊..."
msgstr "正在取得位置資訊..."

#: apps/dp-client/src/screens/home/utils/location.ts:174
#: apps/dp-client/src/screens/diary/store/location.ts:570
msgid "正在取得定位"
msgstr "正在取得定位"

#: apps/dp-business/src/pages/SetPasswordPage/index.tsx:121
#: apps/dp-business/src/pages/ForgotPasswordPage/index.tsx:95
msgid "正在取得帳戶資訊..."
msgstr "正在取得帳戶資訊..."

#: apps/dp-business/src/pages/SubmitSuccess/index.tsx:79
msgid "正在審核中"
msgstr "正在審核中"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:158
msgid "正在查看歷史審核單的當時快照（只讀）"
msgstr "正在查看歷史審核單的當時快照（只讀）"

#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:60
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:201
msgid "正在查詢關聯商家..."
msgstr "正在查詢關聯商家..."

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:100
msgid "正在檢查您的資產狀態..."
msgstr "正在檢查您的資產狀態..."

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:779
msgid "正在檢查相機權限..."
msgstr "正在檢查相機權限..."

#: apps/dp-client/src/screens/account/pages/coupon/CouponScan/index.tsx:142
msgid "正在準備掃描器..."
msgstr "正在準備掃描器..."

#: apps/dp-client/src/screens/diary/pages/home/components/shop-list-section/index.tsx:47
msgid "正在準備資料..."
msgstr "正在準備資料..."

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:229
msgid "正在營業"
msgstr "正在營業"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/MapNaviation/index.tsx:140
msgid "正在獲取導航資訊…"
msgstr "正在獲取導航資訊…"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:163
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:124
#: apps/dp-client/src/hooks/useVerificationCode.ts:199
msgid "正在發送驗證碼..."
msgstr "正在發送驗證碼..."

#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:302
msgid "正在確認支付狀態"
msgstr "正在確認支付狀態"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:495
msgid "正在確認支付狀態，請耐心等待"
msgstr "正在確認支付狀態，請耐心等待"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:74
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:405
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:41
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:41
msgid "正在等待圖像"
msgstr "正在等待圖像"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponCodeUpload.web.tsx:147
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:335
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:352
msgid "正在解析檔案..."
msgstr "正在解析檔案..."

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:227
msgid "正在解析與校驗…"
msgstr "正在解析與校驗…"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:959
msgid "正在計算優惠，請稍候"
msgstr "正在計算優惠，請稍候"

#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:846
msgid "正在識別菜單圖片..."
msgstr "正在識別菜單圖片..."

#: apps/dp-client/src/screens/share/index.tsx:159
#: apps/dp-admin/src/pages/audit-center/audit-detail-redirect/index.web.tsx:68
msgid "正在跳轉..."
msgstr "正在移動..."

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:318
msgid "正在跳轉到{platform}授權頁面..."
msgstr "正在移動到{platform}授權頁面..."

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:458
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:373
msgid "正在載入任務資訊..."
msgstr "正在載入任務資訊..."

#: apps/dp-client/src/screens/home/components/CitySelect/CityModal.tsx:201
#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:375
msgid "正在載入城市資料..."
msgstr "正在載入城市資料..."

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2215
msgid "正在載入套餐券詳情..."
msgstr "正在載入套餐券詳情..."

#: apps/dp-business/src/pages/AddRole/index.tsx:418
msgid "正在載入權限資料..."
msgstr "正在載入權限資料..."

#: apps/dp-client/src/screens/diary/hooks/useEditData.ts:56
msgid "正在載入編輯資料..."
msgstr "正在載入編輯資料..."

#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:126
msgid "正在載入資料，請稍候..."
msgstr "正在載入資料，請稍候..."

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:411
msgid "正在載入餐點資料..."
msgstr "正在載入餐點資料..."

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:60
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:137
msgid "正在送出..."
msgstr "正在送出..."

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:188
msgid "正在送出評論..."
msgstr "正在送出評論..."

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:363
msgid "正在選取…"
msgstr "正在選取…"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:779
msgid "正在開啟相機..."
msgstr "正在開啟相機..."

#: apps/dp-client/src/screens/diary/pages/home/index.tsx:402
msgid "正在驗證使用者權限..."
msgstr "正在驗證使用者權限..."

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:100
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:612
#: apps/dp-admin/src/pages/user-info/services/interface/queryUserList.ts:21
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:21
#: apps/dp-admin/src/pages/merchant/service/constants.ts:508
#: apps/dp-admin/src/pages/merchant/service/constants.ts:521
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:17
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:37
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:149
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:293
msgid "正常"
msgstr "正常"

#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:109
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:119
#: apps/dp-business/src/constants/enums.ts:473
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/components/DayBusinessHours/index.web.tsx:251
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:95
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/components/SuspiciousActionButtons/index.web.tsx:41
#: apps/dp-admin/src/modules/constants/options.ts:576
msgid "正常營業"
msgstr "正常營業"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:155
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:298
msgid "正常發獎"
msgstr "正常發獎"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:583
msgid "正常結算"
msgstr "正常結算"

#: apps/dp-admin/src/modules/constants/options.ts:69
msgid "正常跟進"
msgstr "正常跟進"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:150
msgid "正式版本已更新"
msgstr "正式版本已更新"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:262
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:449
msgid "正負向"
msgstr "正負向"

#: apps/dp-business/src/pages/CustomerReviews/components/KeywordStatsSection.tsx:107
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:106
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:135
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:151
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:192
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ActualManagerCard.web.tsx:74
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/OwnerInfo/index.web.tsx:70
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/KeywordStats.web.tsx:64
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/KeywordStats.web.tsx:154
msgid "正面"
msgstr "正面"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/HorizontalShopList.tsx:528
#: apps/dp-client/src/screens/home/pages/FoodMap/components/ShopList/ShopList.tsx:370
msgid "此區域找不到符合的餐廳"
msgstr "此區域找不到符合的餐廳"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2474
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2524
msgid "此區域為在用戶端APP展示效果"
msgstr "此區域為在用戶端APP展示效果"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:183
msgid "此帳號未設定姓名，請重新選擇"
msgstr "此帳號未設定姓名，請重新選擇"

#: apps/dp-business/src/components/ForgotPassword/index.tsx:197
msgid "此帳號沒有可用的驗證方式"
msgstr "此帳號沒有可用的驗證方式"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:108
msgid "此操作不可逆，平台不承擔因無管理員造成業務影響。若你確認已完成管理權交接，或不再使用該商家帳號，請繼續。"
msgstr "此操作不可逆，平台不承擔因無管理員造成業務影響。若你確認已完成管理權交接，或不再使用該商家帳號，請繼續。"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:104
msgid "此操作審核通過後自動執行，請向店家確認知情。"
msgstr "此操作審核通過後自動執行，請向店家確認知情。"

#: apps/dp-business/src/components/StoreInfoCard/index.tsx:27
msgid "此數值為平台根據商家提交的人均消費、平台實際消費、公開數據計算的人均消費價格"
msgstr "此數值為平台根據商家提交的人均消費、平台實際消費、公開數據計算的人均消費價格"

#. placeholder {0}: nextPeriodNumber - 1
#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:250
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:393
msgid "此標籤為多期活動標籤，此活動期數：第 {0} 期"
msgstr "此標籤為多期活動標籤，此活動期數：第 {0} 期"

#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:253
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:396
msgid "此標籤為多期活動標籤，當前即將開啟：第 {nextPeriodNumber} 期"
msgstr "此標籤為多期活動標籤，當前即將開啟：第 {nextPeriodNumber} 期"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:142
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/ContactInfo/index.web.tsx:76
#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:132
msgid "此欄位在多項服務提供時將進行驗證，請正確填寫。"
msgstr "此欄位在多項服務提供時將進行驗證，請正確填寫。"

#: apps/dp-business/src/components/InputFormModal/index.tsx:41
msgid "此欄位為必填"
msgstr "此欄位為必填"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:23
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:16
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:16
msgid "此瀏覽器不支援{features}"
msgstr "此瀏覽器不支援{features}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:241
msgid "此為發票開立通知，非正式發票"
msgstr "此為發票開立通知，非正式發票"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:192
msgid "此狀態更改不可逆，是否確認操作？"
msgstr "此狀態更改不可逆，是否確認操作？"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:624
msgid "此申請曾被駁回，請依以下原因修正後重新提交"
msgstr "此申請曾被駁回，請依以下原因修正後重新提交"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainNonSettlementState.tsx:44
msgid "此節點無結算／請款能力"
msgstr "此節點無結算／請款能力"

#: apps/dp-business/src/utils/phoneValidation.ts:49
#: apps/dp-admin/src/utils/validation.ts:62
msgid "此處不允許輸入客服專線"
msgstr "此處不允許輸入客服專線"

#: apps/dp-business/src/utils/phoneValidation.ts:73
#: apps/dp-admin/src/utils/validation.ts:84
msgid "此處不允許輸入市區號碼"
msgstr "此處不允許輸入市區號碼"

#: apps/dp-business/src/utils/phoneValidation.ts:38
#: apps/dp-admin/src/utils/validation.ts:50
msgid "此處不允許輸入手機號碼"
msgstr "此處不允許輸入手機號碼"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:576
msgid "此處只產生「手動」記錄，更新人記當前帳號。C 端啟動上報會自動寫入「自動」記錄，更新人為系統，本頁不可改。"
msgstr "此處只產生「手動」記錄，更新人記當前帳號。C 端啟動上報會自動寫入「自動」記錄，更新人為系統，本頁不可改。"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1357
msgid "此處更新為臨時更新，不影響規則預定的其他庫存"
msgstr "此處更新為臨時更新，不影響規則預定的其他庫存"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:406
msgid "此角色 Email、手機都是選填。"
msgstr "此角色 Email、手機都是選填。"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:789
msgid "此訂單已取消，您可以重新下單。"
msgstr "此訂單已取消，您可以重新下單。"

#: apps/dp-client/src/screens/home/pages/Meal/components/CouponPickerModal/index.tsx:146
msgid "此訂單已無可折抵金額"
msgstr "此訂單已無可折抵金額"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/DynamicConfigSection.web.tsx:244
msgid "此類型暫無可配置項"
msgstr "此類型暫無可配置項"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:358
msgid "步"
msgstr "步"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:277
msgid "步行"
msgstr "步行"

#: apps/dp-client/src/screens/home/utils/location.ts:387
msgid "步行約 {durationMinutes} 分鐘"
msgstr "步行約 {durationMinutes} 分鐘"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityStepsField/index.web.tsx:69
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:324
msgid "步驟圖片"
msgstr "步驟圖片"

#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:168
msgid "歷史使用"
msgstr "歷史使用"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:158
msgid "歷史工單"
msgstr "歷史工單"

#: apps/dp-admin/src/pages/marketing/services/groupImport.ts:100
#: apps/dp-admin/src/pages/marketing/components/GroupExcelDownload/index.web.tsx:35
msgid "歷史文件暫不可下載"
msgstr "歷史文件暫不可下載"

#. placeholder {0}: user.historyRewardCount
#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:62
msgid "歷史獲獎 {0} 次"
msgstr "歷史獲獎 {0} 次"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:441
msgid "歷史紀錄"
msgstr "歷史紀錄"

#: apps/dp-client/src/screens/diary/pages/my/components/TabSwitch.tsx:56
msgid "歷史總積分"
msgstr "歷史總積分"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:191
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1080
msgid "歷史記錄"
msgstr "歷史記錄"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1102
msgid "歷史詳情"
msgstr "歷史詳情"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/handleChainFinanceFailure.ts:81
msgid "歷史資料無法讀取"
msgstr "歷史資料無法讀取"

#: apps/dp-client/src/screens/home/components/CitySelect/CityModal.tsx:157
msgid "歷史造訪城市"
msgstr "歷史造訪城市"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:1027
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:618
msgid "段"
msgstr "段"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:193
msgid "每"
msgstr "每"

#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:44
msgid "每{weekLabel}"
msgstr "每{weekLabel}"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:453
msgid "每5分鐘更新"
msgstr "每5分鐘更新"

#. placeholder {0}: currentPackage.perUserLimit
#. placeholder {0}: orderData.perUserLimit
#. placeholder {0}: data.perPersonLimit || '1'
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:475
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:115
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:138
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:175
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:106
msgid "每人最多使用 {0} 張"
msgstr "每人最多使用 {0} 張"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:188
msgid "每人最多購買"
msgstr "每人最多購買"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:551
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:232
msgid "每人每日購買限制"
msgstr "每人每日購買限制"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:160
msgid "每人每日購買限制不能大於每日庫存"
msgstr "每人每日購買限制不能大於每日庫存"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:157
msgid "每人每日購買限制不能大於用戶購買限制"
msgstr "每人每日購買限制不能大於用戶購買限制"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:163
msgid "每人每日購買限制不能大於總庫存"
msgstr "每人每日購買限制不能大於總庫存"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:170
msgid "每人每日領取限制"
msgstr "每人每日領取限制"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:469
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:598
msgid "每人購買上限"
msgstr "每人購買上限"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:633
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2279
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2214
msgid "每人限用"
msgstr "每人限用"

#. placeholder {0}: data.perPersonLimit || ''
#. placeholder {0}: d.perUserLimit
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:445
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:566
msgid "每人限用 {0} 份"
msgstr "每人限用 {0} 份"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:165
msgid "每人領取限制"
msgstr "每人領取限制"

#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:113
#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:127
msgid "每個用餐時刻都值得被「收藏、分享、探索」，輕鬆留下專屬您的美食紀錄"
msgstr "每個用餐時刻都值得被「收藏、分享、探索」，輕鬆留下專屬您的美食紀錄"

#: apps/dp-client/src/screens/home/utils/order.ts:468
#: apps/dp-client/src/screens/home/utils/order.ts:829
#: apps/dp-client/src/screens/home/utils/order.ts:880
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:204
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/templatePreviewData.ts:90
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:74
msgid "每天"
msgstr "每天"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:257
msgid "每小時費用"
msgstr "每小時費用"

#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:76
msgid "每年"
msgstr "每年"

#: apps/dp-admin/src/pages/org-tree/org-create/services/constants.ts:116
#: apps/dp-admin/src/components/FileUpload/index.web.tsx:93
msgid "每張圖片解析度為 96dpi"
msgstr "每張圖片解析度為 96dpi"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:63
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:41
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:27
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:93
msgid "每日"
msgstr "每日"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/SaveModeSelector/index.web.tsx:44
msgid "每日0:00更新一次"
msgstr "每日0:00更新一次"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/SaveModeSelector/index.web.tsx:44
msgid "每日0:30更新一次"
msgstr "每日0:30更新一次"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:356
msgid "每日使用限制"
msgstr "每日使用限制"

#: apps/dp-client/src/screens/home/utils/order.ts:934
#: apps/dp-client/src/screens/home/utils/order.ts:935
msgid "每日可用"
msgstr "每日可用"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:160
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:463
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:391
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:597
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:122
msgid "每日庫存"
msgstr "每日庫存"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:144
msgid "每日庫存不能大於總庫存"
msgstr "每日庫存不能大於總庫存"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:73
msgid "每日活動須從 00:00 開始"
msgstr "每日活動須從 00:00 開始"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:65
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:75
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:43
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:29
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:95
msgid "每月"
msgstr "每月"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:39
msgid "每月循環的開始日期須為每月 1 號（自然月開始）"
msgstr "每月循環的開始日期須為每月 1 號（自然月開始）"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:76
msgid "每月活動須從 1 日 00:00 開始"
msgstr "每月活動須從 1 日 00:00 開始"

#. placeholder {0}: currentPackage.perDeskLimit
#. placeholder {0}: orderData.perDeskLimit
#. placeholder {0}: data.perTableLimit || '1'
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:482
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:122
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:145
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:178
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:109
msgid "每桌最多使用 {0} 張"
msgstr "每桌最多使用 {0} 張"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:655
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2312
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2266
msgid "每桌限用"
msgstr "每桌限用"

#. placeholder {0}: data.perTableLimit || ''
#. placeholder {0}: d.perDeskLimit
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:447
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:568
msgid "每桌限用 {0} 份"
msgstr "每桌限用 {0} 份"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:219
msgid "每次發放份數(單位: 點)"
msgstr "每次發放份數(單位: 點)"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:40
msgid "每次觸發"
msgstr "每次觸發"

#: apps/dp-business/src/components/ClaimAmountAlert/index.tsx:36
msgid "每次請款需達3,500 元以上(含)才能申請，未達門檻款項將順延至下一期。"
msgstr "每次請款需達3,500 元以上(含)才能申請，未達門檻款項將順延至下一期。"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:171
msgid "每種交通方式最多隻能添加10個步驟"
msgstr "每種交通方式最多隻能添加10個步驟"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:967
msgid "每筆訂位可佔用時間: 用戶預定的訂位最多保留30分鐘。"
msgstr "每筆訂位可佔用時間: 用戶預定的訂位最多保留30分鐘。"

#: apps/dp-client/src/screens/home/pages/UserGift/components/SlideInCouponCard/index.tsx:319
msgid "每筆訂單限用一張，可前往「票券匣」查看"
msgstr "每筆訂單限用一張，可前往「票券匣」查看"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/AddShopModal/index.web.tsx:86
msgid "每行一條，格式為「店家ID,樓層,位置描述」，樓層與位置可省略"
msgstr "每行一條，格式為「店家ID,樓層,位置描述」，樓層與位置可省略"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:64
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:42
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:28
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:94
msgid "每週"
msgstr "每週"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:38
msgid "每週循環的開始日期須為週一（自然週開始）"
msgstr "每週循環的開始日期須為週一（自然週開始）"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ExchangeLimitEditor/index.web.tsx:49
msgid "每週期內可兌換消耗上限"
msgstr "每週期內可兌換消耗上限"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:166
msgid "每週期內可消耗上限"
msgstr "每週期內可消耗上限"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:75
msgid "每週活動須從週一 00:00 開始"
msgstr "每週活動須從週一 00:00 開始"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallIntro/index.tsx:44
msgid "每週都有新任務，解任務累積點數兌換美食金，立即去挑戰吧！"
msgstr "每週都有新任務，解任務累積點數兌換美食金，立即去挑戰吧！"

#. placeholder {0}: rule.reservationInterval
#. placeholder {0}: result.reservationInterval
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:632
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:829
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:286
msgid "每隔{0}分鐘"
msgstr "每隔{0}分鐘"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:127
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:415
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:415
msgid "每隔15分鐘"
msgstr "每隔15分鐘"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:84
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:120
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:416
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:416
msgid "每隔30分鐘"
msgstr "每隔30分鐘"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:417
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:417
msgid "每隔60分鐘"
msgstr "每隔60分鐘"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitFields/index.web.tsx:35
msgid "每項權益固定發放一張，需配置獨立預算承擔方及套餐圈選方式。"
msgstr "每項權益固定發放一張，需配置獨立預算承擔方及套餐圈選方式。"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:84
msgid "比例"
msgstr "比例"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:209
msgid "比例推薦9:16，分辨率：1080p"
msgstr "比例推薦9:16，分辨率：1080p"

#: apps/dp-admin/src/components/RocDatePicker/index.web.tsx:89
msgid "民國"
msgstr "民國"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:103
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:259
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:55
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:56
#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:506
msgid "水平翻轉"
msgstr "水平翻轉"

#: apps/dp-business/src/pages/CustomerReviews/components/QualityMonitoringSection.tsx:133
msgid "水軍監控"
msgstr "網軍監控"

#: apps/dp-client/src/screens/home/pages/Review/pages/draft/index.tsx:95
msgid "永久刪除"
msgstr "永久刪除"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:300
#: apps/dp-admin/src/pages/merchant/components/identity-fields/ArcMetaFields.web.tsx:51
msgid "永久居留證"
msgstr "永久居留證"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:108
msgid "永久有效"
msgstr "永久有效"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:114
#: apps/dp-business/src/pages/BusinessStatus/components/ShopClosedImpactContent.tsx:77
#: apps/dp-business/src/constants/enums.ts:482
msgid "永久歇業"
msgstr "永久歇業"

#: apps/dp-client/src/utils/businessStatus.ts:244
#: apps/dp-client/src/screens/home/utils/businessStatus.ts:21
#: apps/dp-admin/src/pages/merchant/service/constants.ts:493
msgid "永久關閉"
msgstr "永久關閉"

#: apps/dp-business/src/data/regions.ts:57
msgid "永和區"
msgstr "永和區"

#: apps/dp-client/src/configs/page-configs.tsx:2826
msgid "求購"
msgstr "求買"

#: apps/dp-business/src/data/regions.ts:66
msgid "汐止區"
msgstr "汐止區"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:218
msgid "決定 C 端券包「去使用」按鈕點擊後的落地頁。四選一（互斥），預設「適用店家列表」；選中後於卡片內展開該選項的配置，配置完成後的落地頁 URL 會回填到權益配置頁面。"
msgstr "決定 C 端券包「去使用」按鈕點擊後的落地頁。四選一（互斥），預設「適用店家列表」；選中後於卡片內展開該選項的配置，配置完成後的落地頁 URL 會回填到權益配置頁面。"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:72
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:221
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:103
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:159
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:35
msgid "汽車"
msgstr "汽車"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:32
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:29
msgid "沉睡"
msgstr "沉睡"

#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:269
#: apps/dp-client/src/screens/diary/hooks/useDraftSave.ts:96
msgid "沒有內容可保存"
msgstr "沒有內容可保存"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:30
msgid "沒有共鳴"
msgstr "沒有共鳴"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/channelCampaignPackageActions.ts:82
msgid "沒有匹配到有效套餐，請檢查導入文件"
msgstr "沒有匹配到有效套餐，請檢查導入文件"

#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:105
msgid "沒有可下載的數據"
msgstr "沒有可下載的數據"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/ExtendInventoryModal.web.tsx:45
msgid "沒有可延期的個人券"
msgstr "沒有可延期的個人券"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1263
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1769
msgid "沒有可提交的變更"
msgstr "沒有可提交的變更"

#: apps/dp-business/src/hooks/useQRScanner.ts:69
msgid "沒有可用的攝影機"
msgstr "沒有可用的攝影機"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:762
msgid "沒有可用的桌位數據"
msgstr "沒有可用的桌位數據"

#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:622
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:645
msgid "沒有找到店家，點擊查看google店家"
msgstr "沒有找到店家，點擊查看google店家"

#: apps/dp-client/src/screens/home/pages/PackageZone/components/PackageZoneContent/index.tsx:221
msgid "沒有找到相關套餐"
msgstr "沒有找到相關套餐"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:634
#: apps/dp-client/src/screens/home/pages/PackageSearch/index.tsx:248
msgid "沒有找到相關店家或套餐"
msgstr "沒有找到相關店家或套餐"

#: apps/dp-client/src/screens/home/pages/FoodMap/index.tsx:2192
msgid "沒有找到相關結果，換個位置試試"
msgstr "沒有找到相關結果，換個位置試試"

#: apps/dp-client/src/screens/diary/pages/merchant/index.tsx:189
#: apps/dp-client/src/screens/diary/pages/merchant/index.tsx:198
msgid "沒有找到相關餐廳"
msgstr "沒有找到相關餐廳"

#: apps/dp-client/src/screens/home/pages/Purchase/components/SelectDishContent/index.tsx:384
msgid "沒有找到這個菜"
msgstr "沒有找到這個菜"

#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:736
#: apps/dp-client/src/screens/home/pages/Review/pages/draft/index.tsx:190
#: apps/dp-client/src/screens/home/pages/Home/components/RecommendMasonryList/index.tsx:602
#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/index.tsx:162
#: apps/dp-client/src/screens/account/pages/advice/my-feedback/index.tsx:265
msgid "沒有更多了"
msgstr "沒有更多了"

#: apps/dp-client/src/screens/diary/pages/merchant/index.tsx:184
msgid "沒有更多任務了"
msgstr "沒有更多任務了"

#: apps/dp-client/src/screens/home/pages/PackageZone/components/PackageZoneContent/index.tsx:262
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:267
msgid "沒有更多套餐了"
msgstr "沒有更多套餐了"

#: apps/dp-client/src/screens/home/pages/UserGift/components/ShopListSection/index.tsx:629
#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:203
#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:271
#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:291
#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/index.tsx:309
#: apps/dp-client/src/screens/home/pages/Ranking/DishRank/index.tsx:248
#: apps/dp-client/src/screens/home/pages/PrivateChef/index.tsx:280
#: apps/dp-client/src/screens/home/pages/Note/components/MarkShopModal/index.tsx:382
#: apps/dp-client/src/screens/home/pages/MerchantGroup/index.tsx:197
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/MallShopList/index.tsx:341
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:756
#: apps/dp-client/src/screens/home/components/CommonShopListSection/index.tsx:835
#: apps/dp-client/src/screens/account/pages/favorites/components/ShopContent/index.tsx:147
msgid "沒有更多店家了"
msgstr "沒有更多店家了"

#: apps/dp-admin/src/components/InfiniteSearchSelect/index.web.tsx:277
msgid "沒有更多數據"
msgstr "沒有更多數據"

#: apps/dp-client/src/screens/diary/components/diary-list/index.tsx:150
msgid "沒有更多日記了"
msgstr "沒有更多日記了"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/NoteSection/index.tsx:245
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:244
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallNoteSection/index.tsx:267
#: apps/dp-client/src/screens/account/pages/profile/components/ContentTabsSection/UserNoteSection.tsx:330
#: apps/dp-client/src/screens/account/pages/favorites/components/NotesContent/index.tsx:150
msgid "沒有更多筆記了"
msgstr "沒有更多筆記了"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:273
#: apps/dp-client/src/screens/diary/components/PullToLoad/index.tsx:93
#: apps/dp-client/src/screens/account/pages/order/index.tsx:509
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:241
#: apps/dp-client/src/components/PullToLoad/index.tsx:95
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:213
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileList/index.web.tsx:149
msgid "沒有更多資料了"
msgstr "沒有更多資料了"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:446
msgid "沒有更多通知了"
msgstr "沒有更多通知了"

#: apps/dp-client/src/screens/diary/pages/search/index.tsx:247
#: apps/dp-client/src/screens/diary/pages/home/index.tsx:419
msgid "沒有更多餐廳了"
msgstr "沒有更多餐廳了"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:259
msgid "沒有權益資料"
msgstr "沒有權益資料"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/components/SuspiciousActionButtons/index.web.tsx:50
msgid "沒有正常營業，下架該店家"
msgstr "沒有正常營業，下架該店家"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:416
msgid "沒有比對到的項目"
msgstr "沒有比對到的項目"

#: apps/dp-client/src/screens/diary/pages/my/hooks.ts:474
#: apps/dp-client/src/screens/diary/pages/merchant/index.tsx:61
#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:453
#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/index.tsx:170
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:325
msgid "沒有活動資訊"
msgstr "沒有活動資訊"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1889
msgid "沒有特別推薦/不推薦"
msgstr "沒有特別推薦/不推薦"

#: apps/dp-client/src/screens/reservation/pages/main/components/SeatTypeSelector.tsx:124
msgid "沒有符合人數的座位，請嘗試其他人數"
msgstr "沒有符合人數的座位，請嘗試其他人數"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:381
msgid "沒有符合條件的請款單"
msgstr "沒有符合條件的請款單"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:186
msgid "沒有符合重新發放條件的記錄"
msgstr "沒有符合重新發放條件的記錄"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:62
msgid "沒有被合併的標籤"
msgstr "沒有被合併的標籤"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:371
msgid "沒有訂單數據"
msgstr "沒有訂單數據"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/handleChainFinanceFailure.ts:74
msgid "沒有財務權限"
msgstr "沒有財務權限"

#: apps/dp-client/src/screens/home/pages/UserGift/components/ShopListSection/index.tsx:662
#: apps/dp-client/src/screens/home/components/CommonShopListSection/index.tsx:172
msgid "沒有適用的店家"
msgstr "沒有適用的店家"

#: apps/dp-client/src/screens/diary/pages/my/components/RNCropPhoto/CropPhoto.tsx:417
msgid "沒有選擇圖片"
msgstr "沒有選擇圖片"

#: apps/dp-business/src/pages/UserManagement/BatchCopyUsers.tsx:52
msgid "沒有選擇要複製的使用者"
msgstr "沒有選擇要複製的使用者"

#: apps/dp-client/src/screens/home/components/ShopFilter/components/LocationSelector.tsx:88
msgid "沒有開啟定位"
msgstr "沒有開啟定位"

#: apps/dp-business/src/hooks/useQRScanner.ts:65
msgid "沒有開啟攝影機權限"
msgstr "沒有開啟攝影機權限"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:42
#: apps/dp-client/src/components/RefundResonModal/index.tsx:27
msgid "沒看清使用規則，要用時發現限制比較多"
msgstr "沒看清使用規則，要用時發現限制比較多"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:103
msgid "沿著人行道前行，十字路口處有 “餐廳直行” 的小熊指示牌。"
msgstr "沿著人行道前行，十字路口處有 “餐廳直行” 的小熊指示牌。"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:423
msgid "沿著人行道前行，十字路口處有「餐廳直行」的小熊指示牌。"
msgstr "沿著人行道前行，十字路口處有「餐廳直行」的小熊指示牌。"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:401
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:81
msgid "沿著街道走到十字路口，紅綠燈旁有「餐廳左轉」的小熊指示牌。"
msgstr "沿著街道走到十字路口，紅綠燈旁有「餐廳左轉」的小熊指示牌。"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:437
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:119
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/constants.ts:53
#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:307
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:147
msgid "法人"
msgstr "法人"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:170
msgid "法人實收資本額"
msgstr "法人實收資本額"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:673
msgid "法人實收資本額不能超過50個字符"
msgstr "法人實收資本額不能超過50個字符"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:150
msgid "法人登記地址"
msgstr "法人登記地址"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:668
msgid "法人登記地址不能超過200個字符"
msgstr "法人登記地址不能超過200個字符"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:35
msgid "法人資訊異常"
msgstr "法人資訊異常"

#: apps/dp-business/src/data/categories.ts:121
msgid "法國菜"
msgstr "法國菜"

#: apps/dp-business/src/data/categories.ts:127
msgid "法式牛排"
msgstr "法式牛排"

#: apps/dp-business/src/data/categories.ts:133
msgid "法式甜點"
msgstr "法式甜點"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:112
msgid "法律要求："
msgstr "法律要求："

#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:467
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:585
msgid "注意"
msgstr "注意"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1657
#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:147
#: apps/dp-client/src/screens/account/pages/task-wall/pages/activity-description/index.tsx:180
#: apps/dp-client/src/screens/account/pages/coupon/GiftRuleOfPackage/index.tsx:166
#: apps/dp-client/src/screens/account/pages/coupon/GiftRule/index.tsx:224
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:160
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityDescriptionField/PreviewModal.web.tsx:100
msgid "注意事項"
msgstr "注意事項"

#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:70
msgid "注意事項/退款規則"
msgstr "注意事項/退款規則"

#: apps/dp-business/src/data/regions.ts:70
msgid "泰山區"
msgstr "泰山區"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:65
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:46
msgid "洗手間"
msgstr "洗手間"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:40
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:37
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:330
msgid "洗版、抄襲"
msgstr "洗版、抄襲"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:66
msgid "洩露隱私"
msgstr "洩露隱私"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/ScanQrCodeModal.web.tsx:72
msgid "活動 ID"
msgstr "活動 ID"

#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:106
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:58
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:103
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:107
#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:28
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:54
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:128
msgid "活動ID"
msgstr "活動ID"

#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:54
msgid "活動一｜餐廳任務積分拿獎勵"
msgstr "活動一｜餐廳任務積分拿獎勵"

#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:33
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityCornerStatusTag.tsx:30
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/utils/activityUtils.ts:46
msgid "活動中"
msgstr "活動中"

#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:59
msgid "活動二｜挑戰美食英雄榜"
msgstr "活動二｜挑戰美食英雄榜"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/index.web.tsx:81
msgid "活動位列表"
msgstr "活動位列表"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:40
msgid "活動位素材"
msgstr "活動位素材"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/index.web.tsx:60
msgid "活動位素材最多 7 條"
msgstr "活動位素材最多 7 條"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:210
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/index.web.tsx:85
msgid "活動位詳情"
msgstr "活動位詳情"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:203
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:239
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/index.web.tsx:46
msgid "活動位配置"
msgstr "活動位配置"

#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:59
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:17
msgid "活動優惠"
msgstr "活動優惠"

#: apps/dp-client/src/screens/diary/pages/rule/index.tsx:116
msgid "活動內容"
msgstr "活動內容"

#: apps/dp-admin/src/router/config/routes.web.tsx:237
#: apps/dp-admin/src/pages/marketing/user-activities/index.web.tsx:201
#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:217
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:262
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:276
msgid "活動列表"
msgstr "活動列表"

#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:349
msgid "活動創建失敗"
msgstr "活動創建失敗"

#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:373
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:378
msgid "活動創建失敗，請重試"
msgstr "活動創建失敗，請重試"

#: apps/dp-admin/src/pages/marketing/activity-create/services/hooks.ts:336
msgid "活動創建成功"
msgstr "活動創建成功"

#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:346
msgid "活動創建成功！"
msgstr "活動創建成功！"

#: apps/dp-client/src/screens/home/pages/MediaGift/index.tsx:125
msgid "活動參數缺失，無法領取"
msgstr "活動參數缺失，無法領取"

#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:597
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:605
msgid "活動可用性校驗失敗，請重試"
msgstr "活動可用性校驗失敗，請重試"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:172
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:49
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:112
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:52
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:108
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:23
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:96
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:96
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:88
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:181
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:28
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:113
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:189
#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:22
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:59
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:125
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/ScanQrCodeModal.web.tsx:68
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:76
msgid "活動名稱"
msgstr "活動名稱"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:131
msgid "活動名稱不能超過80個字符"
msgstr "活動名稱不能超過80個字符"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:35
msgid "活動名稱最多 20 個字"
msgstr "活動名稱最多 20 個字"

#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:112
msgid "活動名稱或活動ID"
msgstr "活動名稱或活動ID"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/searchConfig.ts:13
msgid "活動名稱或編號"
msgstr "活動名稱或編號"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:349
msgid "活動圖片"
msgstr "活動圖片"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/CampaignMetaSection/index.web.tsx:25
msgid "活動基本資料"
msgstr "活動基本資料"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:337
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:174
msgid "活動基本資訊"
msgstr "活動基本資訊"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:104
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:110
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:183
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:188
msgid "活動報名失敗，請稍後重試"
msgstr "活動報名失敗，請稍後重試"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:98
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:179
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:365
msgid "活動報名成功"
msgstr "活動報名成功"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:234
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:172
msgid "活動已刪除"
msgstr "活動已刪除"

#: apps/dp-client/src/components/CouponCard/index.tsx:291
#: apps/dp-client/src/components/CouponCard/index.tsx:293
msgid "活動已到期"
msgstr "活動已到期"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:254
msgid "活動已恢復"
msgstr "活動已恢復"

#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:112
msgid "活動已啟用"
msgstr "活動已啟用"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:262
msgid "活動已暫停"
msgstr "活動已暫停"

#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:90
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:145
msgid "活動已終止"
msgstr "活動已終止"

#: apps/dp-client/src/screens/home/pages/PackageZone/templates/ActivityTemplate.tsx:330
#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:470
msgid "活動已結束"
msgstr "活動已結束"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useChannelCampaignDetail.ts:56
msgid "活動已結束，不能編輯"
msgstr "活動已結束，不能編輯"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/RegistrationStatusBanner.tsx:49
msgid "活動已結束，感謝您的參與"
msgstr "活動已結束，感謝您的參與"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityStatsCards.web.tsx:38
msgid "活動帶動總訂單金額"
msgstr "活動帶動總訂單金額"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:73
#: apps/dp-business/src/configs/page-configs.ts:1027
#: apps/dp-business/src/configs/page-configs.ts:1041
msgid "活動平台"
msgstr "活動平台"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:348
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:761
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:185
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:160
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:102
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:184
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:42
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:203
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:238
msgid "活動描述"
msgstr "活動描述"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:135
msgid "活動描述不能超過200個字符"
msgstr "活動描述不能超過200個字符"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:43
msgid "活動描述最多 50 個字"
msgstr "活動描述最多 50 個字"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardLimitConfigEditor/index.web.tsx:88
msgid "活動整體次數上限"
msgstr "活動整體次數上限"

#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:206
msgid "活動數據載入成功"
msgstr "活動數據載入成功"

#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:88
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:64
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:118
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:110
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:184
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:258
#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:34
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:99
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:100
msgid "活動時間"
msgstr "活動時間"

#: apps/dp-client/src/screens/diary/pages/home/components/header-section/index.tsx:121
msgid "活動時間："
msgstr "活動時間："

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:792
msgid "活動時間：{activitystartTime}"
msgstr "活動時間：{activitystartTime}"

#: apps/dp-client/src/screens/diary/pages/home/components/header-section/index.tsx:122
msgid "活動時間：08/18 ~ 08/24"
msgstr "活動時間：08/18 ~ 08/24"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:65
msgid "活動時間段"
msgstr "活動時間段"

#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:109
msgid "活動時間範圍"
msgstr "活動時間範圍"

#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:658
msgid "活動時間與已選觸發事件衝突，已清空，請重新選擇"
msgstr "活動時間與已選觸發事件衝突，已清空，請重新選擇"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:76
msgid "活動時間類型"
msgstr "活動時間類型"

#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:201
msgid "活動暫未開始"
msgstr "活動暫未開始"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:340
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:177
msgid "活動期間"
msgstr "活動期間"

#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:191
#: apps/dp-client/src/screens/home/pages/ShareKing/pages/RaffleWinners/index.tsx:114
msgid "活動期間：{startStr}-{endStr}"
msgstr "活動期間：{startStr}-{endStr}"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:331
msgid "活動期間總營業額"
msgstr "活動期間總營業額"

#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:59
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:73
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:93
msgid "活動標籤"
msgstr "活動標籤"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:220
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitFields/index.web.tsx:34
msgid "活動權益"
msgstr "活動權益"

#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:80
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:171
msgid "活動權益歸屬"
msgstr "活動權益歸屬"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:364
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:201
msgid "活動權益說明"
msgstr "活動權益說明"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:85
msgid "活動歸屬"
msgstr "活動歸屬"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:196
msgid "活動減免佣金"
msgstr "活動減免佣金"

#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CurrentCommissionCard.web.tsx:63
msgid "活動減免優惠"
msgstr "活動減免優惠"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:530
msgid "活動減免率"
msgstr "活動減免率"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:224
msgid "活動減免率:"
msgstr "活動減免率:"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:205
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignChannelFields/index.web.tsx:25
msgid "活動渠道"
msgstr "活動渠道"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useChannelCampaignDetail.ts:112
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:121
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:131
msgid "活動渠道加載失敗"
msgstr "活動渠道加載失敗"

#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:67
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:125
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:83
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:130
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:32
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:146
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:149
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/searchConfig.ts:27
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:127
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:121
#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:71
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:111
msgid "活動狀態"
msgstr "活動狀態"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/CampaignMetaSection/index.web.tsx:29
msgid "活動發行廠商"
msgstr "活動發行廠商"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:166
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:63
msgid "活動相關"
msgstr "活動相關"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:87
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:394
#: apps/dp-business/src/configs/page-configs.ts:985
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:392
msgid "活動管理"
msgstr "活動管理"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFilter.tsx:63
msgid "活動篩選"
msgstr "活動篩選"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:126
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:30
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:42
msgid "活動終止"
msgstr "活動終止"

#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:153
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:128
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:280
msgid "活動結束時間"
msgstr "活動結束時間"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:200
msgid "活動結束時間（自動計算）"
msgstr "活動結束時間（自動計算）"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:50
msgid "活動結束時間必須晚於當前時間"
msgstr "活動結束時間必須晚於當前時間"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:399
#: apps/dp-admin/src/pages/marketing/activity-statistics/index.web.tsx:122
msgid "活動統計"
msgstr "活動統計"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:82
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:165
msgid "活動編號"
msgstr "活動編號"

#: apps/dp-admin/src/router/config/routes.web.tsx:244
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:504
msgid "活動編輯"
msgstr "活動編輯"

#: apps/dp-client/src/screens/account/pages/coupon/CouponScan/index.tsx:115
msgid "活動落地頁未配置"
msgstr "活動落地頁未配置"

#: apps/dp-client/src/screens/diary/pages/home/components/header-section/index.tsx:80
#: apps/dp-client/src/configs/page-configs.tsx:2769
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:356
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:191
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:118
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:220
msgid "活動規則"
msgstr "活動規則"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:141
msgid "活動規則不能超過{MAX_TEXT_LENGTH}個字符"
msgstr "活動規則不能超過{MAX_TEXT_LENGTH}個字符"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:879
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityDetails.tsx:138
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:120
msgid "活動規則說明"
msgstr "活動規則說明"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:358
msgid "活動設定修改成功"
msgstr "活動設定修改成功"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityDetails.tsx:120
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:188
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/index.web.tsx:22
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:94
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:250
msgid "活動詳情"
msgstr "活動詳情"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:406
msgid "活動詳情列表"
msgstr "活動詳情列表"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useChannelCampaignDetail.ts:54
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:99
msgid "活動詳情加載失敗"
msgstr "活動詳情加載失敗"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:94
msgid "活動詳情加載失敗，請重試"
msgstr "活動詳情加載失敗，請重試"

#: apps/dp-client/src/screens/diary/pages/rule/index.tsx:174
msgid "活動詳細規則"
msgstr "活動詳細規則"

#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:413
#: apps/dp-client/src/screens/home/pages/PackageZone/templates/ActivityTemplate.tsx:260
#: apps/dp-client/src/screens/home/pages/PackageZone/pages/ActivityDescription/index.tsx:180
#: apps/dp-client/src/screens/account/pages/task-wall/pages/activity-description/index.tsx:95
#: apps/dp-client/src/configs/page-configs.tsx:1478
#: apps/dp-admin/src/pages/resource-config/services/constants.ts:129
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:155
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:200
msgid "活動說明"
msgstr "活動說明"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityDescriptionField/PreviewModal.web.tsx:51
msgid "活動說明詳情"
msgstr "活動說明詳情"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1002
msgid "活動諮詢"
msgstr "活動諮詢"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useChannelCampaignDetail.ts:125
msgid "活動資料加載失敗"
msgstr "活動資料加載失敗"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useChannelCampaignSubmit.ts:29
msgid "活動資料尚未加載完成，請重新載入"
msgstr "活動資料尚未加載完成，請重新載入"

#: apps/dp-client/src/screens/home/pages/MediaGift/index.tsx:84
msgid "活動資料載入失敗，請稍後再試"
msgstr "活動資料載入失敗，請稍後再試"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:342
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityDetailSection.tsx:179
msgid "活動資格"
msgstr "活動資格"

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:91
msgid "活動資訊不存在"
msgstr "活動資訊不存在"

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:200
#: apps/dp-client/src/screens/diary/pages/note/index.tsx:253
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:229
msgid "活動資訊不存在，無法提交"
msgstr "活動資訊不存在，無法提交"

#: apps/dp-client/src/screens/account/pages/coupon/CouponScan/index.tsx:134
msgid "活動資訊取得失敗，請稍後重試"
msgstr "活動資訊取得失敗，請稍後重試"

#: apps/dp-client/src/screens/diary/pages/home/index.tsx:406
msgid "活動資訊載入中..."
msgstr "活動資訊載入中..."

#: apps/dp-client/src/screens/home/pages/UserGift/components/CustomHeader/index.tsx:120
#: apps/dp-client/src/configs/page-configs.tsx:2522
#: apps/dp-client/src/configs/page-configs.tsx:2524
msgid "活動辦法"
msgstr "活動辦法"

#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:189
#: apps/dp-client/src/screens/account/pages/notifications/pages/CategoryNotifications/index.tsx:46
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:165
msgid "活動通知"
msgstr "活動通知"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/index.web.tsx:166
msgid "活動進行中且非直接發放，不可修改"
msgstr "活動進行中且非直接發放，不可修改"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/index.web.tsx:164
msgid "活動進行中僅可修改回傳第三方 mid"
msgstr "活動進行中僅可修改回傳第三方 mid"

#: apps/dp-admin/src/modules/constants/options.ts:61
msgid "活動運營待跟進"
msgstr "活動運營待跟進"

#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:72
msgid "活動配置"
msgstr "活動配置"

#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:373
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:378
msgid "活動配置更新失敗，請重試"
msgstr "活動配置更新失敗，請重試"

#: apps/dp-admin/src/pages/marketing/activity-create/services/hooks.ts:410
msgid "活動配置更新成功"
msgstr "活動配置更新成功"

#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:339
msgid "活動配置更新成功！"
msgstr "活動配置更新成功！"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:43
msgid "活動配置發獎說明"
msgstr "活動配置發獎說明"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:170
msgid "活動金額統計"
msgstr "活動金額統計"

#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:146
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:122
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:280
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:184
msgid "活動開始時間"
msgstr "活動開始時間"

#: apps/dp-admin/src/modules/constants/options.ts:56
msgid "活動開通推進中"
msgstr "活動開通推進中"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/CampaignMetaSection/index.web.tsx:42
msgid "活動附件"
msgstr "活動附件"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:148
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFilter.tsx:70
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:56
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:119
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:74
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:113
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:42
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:104
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:141
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:193
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:119
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:175
#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:44
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:64
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:84
msgid "活動類型"
msgstr "活動類型"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:31
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:27
msgid "活躍"
msgstr "活躍"

#: apps/dp-admin/src/pages/data-center/merchant-stats/services/hooks.tsx:101
msgid "活躍商家數"
msgstr "活躍商家數"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:768
msgid "派工中心"
msgstr "派工中心"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:223
msgid "派工工單"
msgstr "派工工單"

#: apps/dp-admin/src/pages/worker-order/my-orders/index.web.tsx:14
msgid "派工處理"
msgstr "派工處理"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:33
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:31
msgid "流失"
msgstr "流失"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:128
msgid "海報"
msgstr "海報"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:150
msgid "海報圖片"
msgstr "海報圖片"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:157
msgid "海軍藍"
msgstr "海軍藍"

#: apps/dp-client/src/screens/home/pages/Ranking/DishRank/components/ScrollImage/index.tsx:31
msgid "海量用戶的選擇 幫你選出最佳菜品"
msgstr "海量用戶的選擇 幫你選出最佳菜品"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepTemplate.web.tsx:165
msgid "消息模板"
msgstr "消息模板"

#: apps/dp-admin/src/pages/resource-config/message-template-list/index.web.tsx:231
msgid "消息模板列表"
msgstr "消息模板列表"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepTemplate.web.tsx:186
msgid "消息模板加載失敗"
msgstr "消息模板加載失敗"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:228
msgid "消息模板收取上限"
msgstr "消息模板收取上限"

#: apps/dp-admin/src/router/config/routes.web.tsx:628
#: apps/dp-admin/src/pages/resource-config/message-template-list/index.web.tsx:214
msgid "消息模板管理"
msgstr "消息模板管理"

#: apps/dp-admin/src/router/config/routes.web.tsx:636
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:694
msgid "消息模板編輯"
msgstr "消息模板編輯"

#: apps/dp-admin/src/router/config/routes.web.tsx:644
msgid "消息管理"
msgstr "消息管理"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:702
msgid "消息編輯"
msgstr "消息編輯"

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:184
#: apps/dp-client/src/screens/account/pages/settings/index.tsx:217
#: apps/dp-admin/src/router/config/baseRoutes.ts:33
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:65
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:40
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:43
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:346
msgid "消息通知"
msgstr "消息通知"

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:187
msgid "消息通知功能開發中"
msgstr "訊息通知功能開發中"

#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:34
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:81
msgid "消息類型"
msgstr "消息類型"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConsumeConfigEditor/index.web.tsx:75
msgid "消耗的積分值"
msgstr "消耗的積分值"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConsumeConfigEditor/index.web.tsx:82
msgid "消耗的積分值必須為大於 0 的整數"
msgstr "消耗的積分值必須為大於 0 的整數"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:112
msgid "消耗點數兌換"
msgstr "消耗點數兌換"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/index.web.tsx:172
msgid "消耗點數兌換配置"
msgstr "消耗點數兌換配置"

#. placeholder {0}: order.totalAmount
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:313
msgid "消費${0}"
msgstr "消費${0}"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:862
msgid "消費明細"
msgstr "消費明細"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:1029
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:367
msgid "消費時間"
msgstr "消費時間"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:447
msgid "消費滿"
msgstr "消費滿"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:380
msgid "消費滿 $"
msgstr "消費滿 $"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:90
msgid "消費相關"
msgstr "消費相關"

#: apps/dp-admin/src/pages/order/order-detail/components/DiscountDetails/index.web.tsx:25
msgid "消費總金額"
msgstr "消費總金額"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1173
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:767
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:883
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:934
msgid "消費總額"
msgstr "消費總額"

#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:175
msgid "消費金額"
msgstr "消費金額"

#: apps/dp-admin/src/pages/audit-center/services/hooks.ts:221
msgid "涉及政治"
msgstr "涉及政治"

#: apps/dp-admin/src/pages/audit-center/services/hooks.ts:223
msgid "涉及色情"
msgstr "涉及色情"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:65
msgid "涉及色情低俗"
msgstr "涉及低俗"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:181
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:476
msgid "涵蓋店家"
msgstr "涵蓋店家"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:296
msgid "淡化"
msgstr "淡化"

#: apps/dp-business/src/data/regions.ts:65
msgid "淡水區"
msgstr "淡水區"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:683
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:545
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:199
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:205
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:500
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:175
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:330
msgid "淨結算金額"
msgstr "淨結算金額"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:69
msgid "淨金額"
msgstr "淨金額"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:165
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:141
msgid "淨額："
msgstr "淨額："

#: apps/dp-admin/src/pages/report-center/services/apis.ts:578
msgid "深圳"
msgstr "深圳"

#: apps/dp-business/src/data/regions.ts:71
msgid "深坑區"
msgstr "深坑區"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:78
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:161
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:37
msgid "混合"
msgstr "混合"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:159
msgid "淺綠色"
msgstr "淺綠色"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:213
#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:500
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:306
#: apps/dp-admin/src/pages/merchant/components/StoreSettingsSection/index.web.tsx:229
msgid "添加"
msgstr "新增"

#: apps/dp-admin/src/pages/marketing/components/CombinedListForm/index.web.tsx:462
#: apps/dp-admin/src/components/CombinationFilterForm/index.web.tsx:449
#: apps/dp-admin/src/components/BracketTree/index.web.tsx:235
msgid "添加上一級"
msgstr "添加上一級"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:109
#: apps/dp-admin/src/components/BusinessHours/constants.ts:39
msgid "添加下午茶時段"
msgstr "添加下午茶時段"

#: apps/dp-business/src/constants/enums.ts:43
msgid "添加下午茶時間段"
msgstr "添加下午茶時間段"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:223
msgid "添加互斥組"
msgstr "添加互斥組"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:202
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:116
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:617
#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:114
msgid "添加人"
msgstr "添加人"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:303
msgid "添加人/添加時間"
msgstr "添加人/添加時間"

#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:110
#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:94
msgid "添加人ID"
msgstr "添加人ID"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:422
#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:363
msgid "添加備註"
msgstr "添加備註"

#: apps/dp-business/src/servers/reservation/api.ts:941
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:467
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:474
#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:385
msgid "添加備註失敗"
msgstr "添加備註失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:382
msgid "添加備註成功"
msgstr "添加備註成功"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:644
msgid "添加內容"
msgstr "添加內容"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:108
#: apps/dp-admin/src/components/BusinessHours/constants.ts:30
msgid "添加午餐時段"
msgstr "添加午餐時段"

#: apps/dp-business/src/constants/enums.ts:35
msgid "添加午餐時間段"
msgstr "添加午餐時間段"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:294
msgid "添加參數"
msgstr "添加參數"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:394
#: apps/dp-business/src/pages/ImageManagement/index.tsx:439
#: apps/dp-business/src/pages/ImageManagement/index.tsx:456
#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:375
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:314
msgid "添加圖片"
msgstr "添加圖片"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:435
msgid "添加圖片或影片"
msgstr "添加圖片或影片"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:169
msgid "添加客服 Email"
msgstr "添加客服 Email"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:111
#: apps/dp-admin/src/components/BusinessHours/constants.ts:57
msgid "添加宵夜時段"
msgstr "添加宵夜時段"

#: apps/dp-business/src/constants/enums.ts:59
msgid "添加宵夜時間段"
msgstr "添加宵夜時間段"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:358
msgid "添加已有餐點"
msgstr "添加已有餐點"

#. placeholder {0}: couponGroup?.name || ''
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/AddStockModal.web.tsx:86
msgid "添加庫存 - {0}"
msgstr "添加庫存 - {0}"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/hooks.ts:194
msgid "添加庫存失敗"
msgstr "添加庫存失敗"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:92
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:595
msgid "添加折扣規則"
msgstr "添加折扣規則"

#: apps/dp-admin/src/pages/users/permissions/components/PermissionTreeTable/index.web.tsx:81
msgid "添加按鈕"
msgstr "添加按鈕"

#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:274
msgid "添加按鈕權限"
msgstr "添加按鈕權限"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:100
msgid "添加搜索關鍵詞"
msgstr "添加搜索關鍵詞"

#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/components/FloatingList.tsx:113
#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/components/FloatingList.tsx:228
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:748
msgid "添加新店家"
msgstr "新增店家"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteTopicSearchList.tsx:77
msgid "添加新話題"
msgstr "新增話題"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:107
#: apps/dp-admin/src/components/BusinessHours/constants.ts:21
msgid "添加早餐時段"
msgstr "添加早餐時段"

#: apps/dp-business/src/constants/enums.ts:27
msgid "添加早餐時間段"
msgstr "添加早餐時間段"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:1099
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:690
#: apps/dp-admin/src/components/BusinessHours/components/BusinessStatusSelector.web.tsx:164
msgid "添加時段"
msgstr "添加時段"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:71
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:139
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:213
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:310
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:728
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:752
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:209
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:119
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:202
#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:109
msgid "添加時間"
msgstr "添加時間"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:110
#: apps/dp-admin/src/components/BusinessHours/constants.ts:48
msgid "添加晚餐時段"
msgstr "添加晚餐時段"

#: apps/dp-business/src/constants/enums.ts:51
msgid "添加晚餐時間段"
msgstr "添加晚餐時間段"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:741
msgid "添加更多二級品類"
msgstr "添加更多二級品類"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:287
msgid "添加獎勵規則"
msgstr "添加獎勵規則"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:930
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:519
#: apps/dp-admin/src/components/BusinessHours/components/BusinessStatusSelector.web.tsx:256
msgid "添加自定義時段"
msgstr "添加自定義時段"

#: apps/dp-admin/src/pages/merchant/components/StoreSettingsSection/index.web.tsx:212
msgid "添加自定義設施："
msgstr "添加自定義設施："

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:306
msgid "添加規格"
msgstr "添加規格"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:263
msgid "添加觸發事件"
msgstr "添加觸發事件"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:333
msgid "添加資訊"
msgstr "添加資訊"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/InAppTemplateSection.web.tsx:42
msgid "添加跳轉鏈接"
msgstr "添加跳轉鏈接"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:326
#: apps/dp-admin/src/pages/merchant/components/FollowUpModal/index.web.tsx:27
msgid "添加追蹤記錄"
msgstr "添加追蹤記錄"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/PhoneEditor/index.web.tsx:97
msgid "添加電話號碼"
msgstr "添加電話號碼"

#. placeholder {0}: value.length
#: apps/dp-admin/src/pages/merchant/shop-detail/components/PhoneEditor/index.web.tsx:98
msgid "添加電話號碼 ({0}/{maxCount})"
msgstr "添加電話號碼 ({0}/{maxCount})"

#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:276
#: apps/dp-admin/src/pages/users/permissions/components/PermissionTreeTable/index.web.tsx:81
msgid "添加頁面"
msgstr "添加頁面"

#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/index.tsx:147
#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/index.tsx:153
msgid "添加餐廳失敗，試試其他餐廳吧"
msgstr "新增餐廳失敗，試試其他餐廳吧"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:120
msgid "清單項 1"
msgstr "清單第 1 項"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:121
msgid "清單項 2"
msgstr "清單第 2 項"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:122
msgid "清單項 3"
msgstr "清單第 3 項"

#: apps/dp-business/src/store/HolidayContext.tsx:131
#: apps/dp-business/src/store/HolidayContext.tsx:151
msgid "清明"
msgstr "清明"

#: apps/dp-business/src/store/HolidayContext.tsx:131
msgid "清明節"
msgstr "清明節"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:320
msgid "清晰度"
msgstr "清晰度"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:30
msgid "清楚看到店門口、招牌"
msgstr "清楚看到店門口、招牌"

#: apps/dp-client/src/screens/home/pages/Search/index.tsx:616
#: apps/dp-client/src/screens/home/pages/PackageSearch/index.tsx:593
#: apps/dp-client/src/screens/home/pages/Note/components/MarkShopModal/index.tsx:338
#: apps/dp-client/src/screens/home/pages/LocationSelect/components/HistorySection.tsx:41
#: apps/dp-client/src/screens/home/pages/LocationSelect/components/HistorySection.tsx:60
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:530
#: apps/dp-client/src/screens/home/pages/FoodMap/index.tsx:2098
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:646
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:679
msgid "清空"
msgstr "清空"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:372
msgid "清空已選"
msgstr "清空已選"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1086
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:575
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:477
msgid "清空選擇"
msgstr "清空選擇"

#: apps/dp-client/src/screens/reservation/pages/list/pages/search/index.tsx:135
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/CompactAdvancedFilterContent.tsx:205
#: apps/dp-client/src/screens/home/components/ShopFilter/components/AdvancedFilterContent.tsx:280
#: apps/dp-client/src/screens/account/pages/order/pages/search/index.tsx:136
#: apps/dp-client/src/screens/account/pages/likes/pages/search/index.tsx:135
#: apps/dp-client/src/screens/account/pages/favorites/pages/search/index.tsx:151
msgid "清除"
msgstr "清除"

#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:180
msgid "清除格式"
msgstr "清除格式"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:742
msgid "清除篩選"
msgstr "清除篩選"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:224
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CommissionBenefitListCard.web.tsx:34
msgid "減免比例"
msgstr "減免比例"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:86
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignChannelFields/index.web.tsx:50
msgid "渠道"
msgstr "渠道"

#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:76
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:107
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:165
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:58
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:53
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:131
msgid "渠道代碼"
msgstr "渠道代碼"

#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:88
msgid "渠道來源"
msgstr "渠道來源"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:197
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:227
msgid "渠道全選失敗"
msgstr "渠道全選失敗"

#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:59
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:102
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:180
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:266
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:55
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:41
msgid "渠道名稱"
msgstr "渠道名稱"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:101
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:172
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:294
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:137
msgid "渠道外部代碼"
msgstr "渠道外部代碼"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:114
msgid "渠道導入模板.xlsx"
msgstr "渠道導入模板.xlsx"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:115
msgid "渠道導入錯誤清單.xlsx"
msgstr "渠道導入錯誤清單.xlsx"

#: apps/dp-admin/src/pages/report-center/channel-analysis/index.web.tsx:7
msgid "渠道成效分析"
msgstr "渠道成效分析"

#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:103
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:187
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:280
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:70
msgid "渠道描述"
msgstr "渠道描述"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:136
msgid "渠道數"
msgstr "渠道數"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:278
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:339
msgid "渠道活動"
msgstr "渠道活動"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:57
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:66
msgid "渠道活動列表加載失敗"
msgstr "渠道活動列表加載失敗"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useChannelCampaignSubmit.ts:47
msgid "渠道活動已創建"
msgstr "渠道活動已創建"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useChannelCampaignSubmit.ts:47
msgid "渠道活動已更新"
msgstr "渠道活動已更新"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitCard/index.web.tsx:58
msgid "渠道活動權益"
msgstr "渠道活動權益"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:370
msgid "渠道活動編輯"
msgstr "渠道活動編輯"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:148
msgid "渠道活動詳情"
msgstr "渠道活動詳情"

#. placeholder {0}: getChannelLevelLabel(level)
#. placeholder {1}: dayjs().format('YYYYMMDD_HHmmss')
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:119
msgid "渠道管理_{0}_{1}.xlsx"
msgstr "渠道管理_{0}_{1}.xlsx"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:135
msgid "渠道詳情"
msgstr "渠道詳情"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:385
msgid "渠道選項加載失敗"
msgstr "渠道選項加載失敗"

#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:66
msgid "渠道類型"
msgstr "渠道類型"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:645
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:255
msgid "測試發送"
msgstr "測試發送"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:404
msgid "測試發送成功"
msgstr "測試發送成功"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:326
msgid "測試餐廳"
msgstr "測試餐廳"

#: apps/dp-business/src/data/categories.ts:74
msgid "湘菜"
msgstr "湘菜"

#: apps/dp-business/src/data/categories.ts:86
msgid "湘西菜"
msgstr "湘西菜"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:61
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:68
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:62
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:69
msgid "湯品"
msgstr "湯品"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:164
msgid "源規則不存在或複製失敗"
msgstr "源規則不存在或複製失敗"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:61
msgid "源豐美食沙龍"
msgstr "源豐美食沙龍"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:318
msgid "溫度"
msgstr "溫度"

#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:94
msgid "溫馨的家庭式餐廳，主打健康有機料理。使用當地新鮮食材，無添加防腐劑。特色套餐豐富多樣，素食選擇充足。店內設有兒童遊戲區，非常適合親子用餐。"
msgstr "溫馨的家庭式餐廳，主打健康有機料理。使用當地新鮮食材，無添加防腐劑。特色套餐豐富多樣，素食選擇充足。店內設有兒童遊戲區，非常適合親子用餐。"

#: apps/dp-business/src/components/DraggableList/index.web.tsx:155
msgid "滑動圖標可排序"
msgstr "滑動圖標可排序"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:428
msgid "滑動進行兌換"
msgstr "滑動進行兌換"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/NoteSection/index.tsx:235
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallNoteSection/index.tsx:258
msgid "滾動加載更多"
msgstr "滾動載入更多"

#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:64
msgid "滿"
msgstr "滿"

#. placeholder {0}: coupon.minimumAmount
#: apps/dp-client/src/components/CouponCard/index.tsx:145
msgid "滿{0}可用"
msgstr "滿{0}可用"

#. placeholder {0}: previewData.threshold
#: apps/dp-business/src/pages/MarketingCenter/components/PreviewCard.tsx:71
msgid "滿NT${0}可用"
msgstr "滿NT${0}可用"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:27
msgid "滿減"
msgstr "滿減"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1535
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:38
msgid "滿減券"
msgstr "滿減券"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:321
msgid "滿減券名稱"
msgstr "滿額折扣券名稱"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:315
msgid "滿減券基本資訊"
msgstr "滿額折扣券基本資訊"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:346
msgid "滿減券明細"
msgstr "滿額折扣券明細"

#: apps/dp-business/src/configs/page-configs.ts:1125
msgid "滿減券詳情"
msgstr "滿額折扣券詳情"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:373
msgid "滿減券資訊"
msgstr "滿額折扣券資訊"

#: apps/dp-admin/src/modules/constants/options.ts:213
msgid "滿足最低消費金額後免固定金額"
msgstr "滿足最低消費金額後免固定金額"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:133
msgid "滿足條件自動發放"
msgstr "滿足條件自動發放"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:18
#: apps/dp-admin/src/modules/constants/options.ts:212
msgid "滿額折價券"
msgstr "滿額折價券"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:32
msgid "漢堡王"
msgstr "漢堡王"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:302
msgid "漬洗"
msgstr "漬洗"

#: apps/dp-business/src/data/categories.ts:66
msgid "潮州菜"
msgstr "潮州菜"

#: apps/dp-business/src/data/regions.ts:27
msgid "澎湖"
msgstr "澎湖"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:292
msgid "濾鏡"
msgstr "濾鏡"

#: apps/dp-client/src/screens/home/utils/filterData.ts:113
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:194
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:20
msgid "瀏覽最多"
msgstr "瀏覽最多"

#: apps/dp-admin/src/components/VideoPlayer/index.web.tsx:50
msgid "瀏覽器暫不支持播放此視頻"
msgstr "瀏覽器暫不支持播放此視頻"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:62
msgid "灌水"
msgstr "灌水"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/utils/activityUtils.ts:30
#: apps/dp-admin/src/modules/constants/options.ts:479
msgid "火熱報名中"
msgstr "火熱報名中"

#: apps/dp-admin/src/pages/user-info/services/apis.ts:142
msgid "火鍋"
msgstr "火鍋"

#: apps/dp-business/src/pages/RefundList/index.tsx:117
msgid "火鍋店"
msgstr "火鍋店"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:155
msgid "灰色"
msgstr "灰色"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:922
msgid "灰色標記的星期已被其他規則佔用"
msgstr "灰色標記的星期已被其他規則佔用"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:291
msgid "炸雞翅"
msgstr "炸雞翅"

#: apps/dp-client/src/screens/account/pages/check-phone/index.tsx:33
msgid "為了保帳號安全,請驗證身份"
msgstr "為了保帳號安全,請驗證身份"

#: apps/dp-client/src/screens/account/pages/account-security/check-password/index.tsx:88
msgid "為了保護帳號安全，請驗證"
msgstr "為了保護帳號安全，請驗證"

#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:274
#: apps/dp-client/src/screens/account/pages/account-security/email/check-email/index.tsx:83
msgid "為了保護帳號安全,請驗證身份"
msgstr "為了保護帳號安全,請驗證身份"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:335
msgid "為了您的帳戶安全，請輸入目前密碼後設置新密碼"
msgstr "為了您的帳戶安全，請輸入目前密碼後設置新密碼"

#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:250
msgid "為了您的帳號安全，請綁定手機號"
msgstr "為了您的帳號安全，請綁定手機號"

#: apps/dp-client/src/screens/bind/pages/phone-bind/index.tsx:110
#: apps/dp-client/src/screens/account/pages/check-phone/bind-phone/index.tsx:71
msgid "為了您的帳號安全，請綁定手機門號"
msgstr "為了您的帳號安全，請綁定手機門號"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:495
msgid "為了確保您的優惠與權益，請先綁定您的手機門號"
msgstr "為了確保您的優惠與權益，請先綁定您的手機門號"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:737
msgid "為保障您的隱私，此欄位不會對外公開"
msgstr "為保障您的隱私，此欄位不會對外公開"

#: apps/dp-client/src/screens/reservation/utils/index.ts:61
#: apps/dp-client/src/screens/reservation/components/ReservationSuccessModal/index.tsx:58
msgid "為您優先保留座位"
msgstr "為您優先保留座位"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:223
msgid "為您推薦以下餐廳"
msgstr "為您推薦以下餐廳"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:231
msgid "為您推薦相似餐廳"
msgstr "為您推薦相似餐廳"

#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:155
msgid "為提供更佳體驗，請先閱讀"
msgstr "為提供更佳體驗，請先閱讀"

#. placeholder {0}: record.name
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountCopyForm.tsx:104
msgid "為既有使用者「{0}」追加當前節點的角色授權，不會建立新使用者，也不會移除已有角色"
msgstr "為既有使用者「{0}」追加當前節點的角色授權，不會建立新使用者，也不會移除已有角色"

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:174
msgid "為用戶提供決策協助。"
msgstr "為用戶提供決策協助。"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:586
msgid "為確保實用性，您提供的資訊需完整、清晰，若不符合標準將無法獲得積分哦！"
msgstr "為確保實用性，您提供的資訊需完整、清晰，若不符合標準將無法獲得積分哦！"

#: apps/dp-client/src/screens/home/pages/Home/components/FetCouponMigrationPopup/index.tsx:81
msgid "為確保您的權益，系統將依您所綁定的「遠傳心生活」帳號重新同步該帳號之優惠券，非「遠傳心生活」發放之優惠券無影響。"
msgstr "為確保您的權益，系統將依您所綁定的「遠傳心生活」帳號重新同步該帳號之優惠券，非「遠傳心生活」發放之優惠券無影響。"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:114
msgid "為空表示全部允許"
msgstr "為空表示全部允許"

#: apps/dp-business/src/data/regions.ts:81
msgid "烏來區"
msgstr "烏來區"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:20
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:266
#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:93
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1117
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1118
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1120
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1124
#: apps/dp-business/src/pages/OrderOverview/index.tsx:987
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:500
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:507
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:13
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:60
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1500
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:313
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:101
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:293
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:101
#: apps/dp-admin/src/pages/merchant/service/constants.ts:154
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:309
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:170
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:501
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:617
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:624
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:85
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:121
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:74
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:125
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:187
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:194
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:294
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:345
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:73
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:111
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:46
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:204
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:211
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:164
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:171
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:164
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:171
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:190
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:199
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:207
#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:216
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:186
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:193
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:212
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:221
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:229
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:278
#: apps/dp-admin/src/modules/hooks/options/useBDOptions.ts:94
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:67
#: apps/dp-admin/src/components/OperationLogDetailModal/index.web.tsx:69
#: apps/dp-admin/src/components/OperationLogDetailModal/index.web.tsx:77
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:13
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:61
msgid "無"
msgstr "無"

#: apps/dp-business/src/pages/UserManagement/index.tsx:807
msgid "無使用者列表查看權限"
msgstr "無使用者列表查看權限"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:182
msgid "無使用須知"
msgstr "無使用須知"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:330
msgid "無光澤"
msgstr "無光澤"

#: apps/dp-client/src/screens/diary/pages/home/components/points-card/index.tsx:389
msgid "無兌換遠傳幣活動，但依然可衝刺排行榜"
msgstr "無兌換遠傳幣活動，但依然可衝刺排行榜"

#: apps/dp-business/src/pages/ReviewDetail/index.tsx:227
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:129
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:239
msgid "無刪除回覆權限"
msgstr "無刪除回覆權限"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:33
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:42
msgid "無加盟類型"
msgstr "無加盟類型"

#: apps/dp-business/src/store/PerspectiveContext.tsx:281
#: apps/dp-business/src/pages/ChainDashboard/index.tsx:137
msgid "無可用連鎖節點"
msgstr "無可用連鎖節點"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:149
msgid "無合法結算來源"
msgstr "無合法結算來源"

#: apps/dp-business/src/pages/MenuManagement.tsx:628
#: apps/dp-business/src/pages/MenuManagement.tsx:645
#: apps/dp-admin/src/pages/resource-config/category-management/services/constants.ts:22
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:687
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:713
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:107
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:426
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileList/index.web.tsx:69
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:266
msgid "無圖片"
msgstr "無圖片"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/RegistrationStatusBanner.tsx:70
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1108
msgid "無報名平台活動權限"
msgstr "無報名平台活動權限"

#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:156
msgid "無序列表"
msgstr "無序列表"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:820
msgid "無手動核銷權限"
msgstr "無手動核銷權限"

#: apps/dp-business/src/pages/ReviewDetail/index.tsx:182
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:75
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:151
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:221
msgid "無投訴評價權限"
msgstr "無投訴評價權限"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:113
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:110
msgid "無折扣"
msgstr "無折扣"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitCard/index.web.tsx:89
msgid "無折抵上限"
msgstr "無折抵上限"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:785
msgid "無掃碼核銷權限"
msgstr "無掃碼核銷權限"

#: apps/dp-business/src/pages/MenuManagement.tsx:656
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:336
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:197
msgid "無描述"
msgstr "無描述"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:118
msgid "無操作內容"
msgstr "無操作內容"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1124
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1290
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:152
msgid "無操作訂位訂單權限"
msgstr "無操作訂位訂單權限"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:644
msgid "無操作退款權限"
msgstr "無操作退款權限"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountToolbar/index.web.tsx:109
#: apps/dp-admin/src/pages/users/user-tasks/components/StatusTag/index.web.tsx:23
msgid "無效"
msgstr "無效"

#: apps/dp-business/src/pages/AddressEdit/index.tsx:479
msgid "無效地址，無法儲存！"
msgstr "無效地址，無法儲存！"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:44
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:33
msgid "無效的任務 ID"
msgstr "無效的任務 ID"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:314
msgid "無效的商家ID"
msgstr "無效的商家ID"

#: apps/dp-client/src/screens/diary/pages/my/components/CropPhoto/index.web.tsx:266
msgid "無效的圖片URL"
msgstr "無效的圖片URL"

#: apps/dp-client/src/screens/home/pages/Search/index.tsx:424
#: apps/dp-client/src/screens/home/pages/Search/index.tsx:467
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:465
msgid "無效的搜尋關鍵詞"
msgstr "無效的搜尋關鍵詞"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:177
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:284
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:96
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:343
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:95
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:109
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:109
#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:190
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:193
#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/hooks.ts:64
#: apps/dp-admin/src/modules/hooks/useImageUpload.ts:250
#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:578
msgid "無效的檔案物件"
msgstr "無效的檔案物件"

#: apps/dp-admin/src/pages/users/services/apis.ts:141
msgid "無效的角色ID"
msgstr "無效的角色ID"

#: apps/dp-client/src/screens/home/components/RichTextInput/utils/constants.ts:204
msgid "無效的輸入位置"
msgstr "無效的輸入位置"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:936
msgid "無效的餐廳ID"
msgstr "無效的餐廳ID"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2683
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:116
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:184
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1015
msgid "無數據"
msgstr "無數據"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1401
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1816
msgid "無新增優惠券權限"
msgstr "無新增優惠券權限"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1642
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:2134
msgid "無時段"
msgstr "無時段"

#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:23
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:245
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:25
msgid "無時間限制"
msgstr "無時間限制"

#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:122
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:111
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/services/aggregate.ts:152
msgid "無期限"
msgstr "無期限"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1413
msgid "無查看優惠券詳情權限"
msgstr "無查看優惠券詳情權限"

#: apps/dp-business/src/pages/ChainDashboard/components/NoPermissionState.tsx:35
msgid "無查看權限"
msgstr "無查看權限"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1278
msgid "無查看訂位概況和訂單權限"
msgstr "無查看訂位概況和訂單權限"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:165
msgid "無查看評價詳情權限"
msgstr "無查看評價詳情權限"

#: apps/dp-business/src/components/Permission/PermissionWrapper.tsx:53
msgid "無權限"
msgstr "無權限"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:426
msgid "無權限修改商家裝修"
msgstr "無權限修改商家裝修"

#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:276
msgid "無權限創建店家"
msgstr "無權限創建店家"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:404
#: apps/dp-business/src/pages/ContractManagement/index.tsx:502
#: apps/dp-business/src/components/Layout/Container.tsx:226
#: apps/dp-business/src/components/Layout/Container.tsx:293
#: apps/dp-business/src/components/Layout/Container.tsx:314
#: apps/dp-business/src/components/Layout/Container.tsx:366
#: apps/dp-business/src/components/Layout/Container.tsx:382
msgid "無權限執行此操作"
msgstr "無權限執行此操作"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:546
msgid "無權限提交合約資訊"
msgstr "無權限上傳合約資訊"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:1085
msgid "無權限查看資訊詳情"
msgstr "無權限查看資訊詳情"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:200
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:529
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:607
msgid "無權限編輯店家資訊"
msgstr "無權限編輯店家資訊"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:532
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:540
msgid "無法使用，有疑問請聯繫客服"
msgstr "無法使用，有疑問請聯繫客服"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:242
msgid "無法保存"
msgstr "無法保存"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:299
msgid "無法刪除該分類"
msgstr "無法刪除該分類"

#: apps/dp-client/src/configs/page-configs.tsx:2979
msgid "無法參與活動"
msgstr "無法參與活動"

#: apps/dp-client/src/screens/diary/pages/my/components/CropPhoto/index.web.tsx:48
msgid "無法取得 canvas 上下文"
msgstr "無法取得 canvas 上下文"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:433
msgid "無法取得主分類ID，請重新選擇分類"
msgstr "無法取得主分類ID，請重新選擇分類"

#: apps/dp-client/src/screens/home/components/CitySelect/CityModal.tsx:138
#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:89
#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:272
msgid "無法取得你的位置資訊"
msgstr "無法取得您的定位資訊"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:469
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BlueNewContractTab/index.web.tsx:177
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/index.web.tsx:76
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/BlueNewContractTab/index.web.tsx:111
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:123
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:110
msgid "無法取得商家資訊"
msgstr "無法取得商家資訊"

#: apps/dp-client/src/screens/diary/pages/my/components/RNCropPhoto/CropPhoto.tsx:422
msgid "無法取得圖片顯示資訊"
msgstr "無法取得圖片顯示資訊"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:486
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BlueNewContractTab/index.web.tsx:194
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/BlueNewContractTab/index.web.tsx:128
msgid "無法取得店家資訊"
msgstr "無法取得店家資訊"

#: apps/dp-business/src/components/PhoneVerification/index.tsx:158
msgid "無法取得手機門號"
msgstr "無法取得手機門號"

#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:212
msgid "無法取得當前使用者資訊，請重新登入"
msgstr "無法取得當前使用者資訊，請重新登入"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:277
msgid "無法取得發票設置"
msgstr "無法取得發票設置"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:408
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:166
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:196
msgid "無法取得目前用戶資訊"
msgstr "無法取得目前用戶資訊"

#: apps/dp-client/src/screens/diary/pages/my/components/CropPhoto/index.web.tsx:253
msgid "無法取得裁剪區域資訊"
msgstr "無法取得裁剪區域資訊"

#: apps/dp-business/src/components/EmailVerification/index.tsx:155
msgid "無法取得郵件地址"
msgstr "無法取得郵件地址"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:230
msgid "無法取得餐廳資訊，請重試"
msgstr "無法取得餐廳資訊，請重試"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:475
msgid "無法存取地圖服務，請檢查瀏覽器權限設定"
msgstr "無法存取地圖服務，請檢查瀏覽器權限設定"

#: apps/dp-business/src/hooks/useQRScanner.ts:81
msgid "無法存取攝影機"
msgstr "無法存取攝影機"

#: apps/dp-client/src/screens/account/pages/notification-settings/index.tsx:66
msgid "無法打開系統設置"
msgstr "無法打開系統設置"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:184
#: apps/dp-client/src/components/CallPhoneModal/index.tsx:50
msgid "無法撥打電話"
msgstr "無法撥打電話"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:142
#: apps/dp-client/src/screens/account/components/feedback-modal/index.tsx:53
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:152
msgid "無法撥打電話,已複製電話號碼"
msgstr "無法撥打電話,已複製電話號碼"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:181
msgid "無法撥打電話，已複製電話號碼"
msgstr "無法撥打電話，已複製電話號碼"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationErrorDialog.tsx:45
msgid "無法核銷"
msgstr "無法核銷"

#: apps/dp-client/src/screens/home/utils/utils.ts:335
msgid "無法添加圖片"
msgstr "無法添加圖片"

#: apps/dp-client/src/screens/home/utils/utils.ts:306
msgid "無法添加此視頻"
msgstr "無法添加此視頻"

#: apps/dp-client/src/screens/reservation/pages/detail/components/ShopInfoCard.tsx:65
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopLocationInfo.tsx:164
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1118
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1123
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:99
msgid "無法獲取位置"
msgstr "無法獲取定位"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:710
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:521
msgid "無法獲取分配人資訊,稍後繼續"
msgstr "無法獲取分配人資訊,稍後繼續"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:571
msgid "無法獲取商家信息"
msgstr "無法獲取商家信息"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:602
msgid "無法獲取商家資訊，請重新登入"
msgstr "無法獲取商家資訊，請重新登入"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:166
msgid "無法獲取商家電話"
msgstr "無法獲取商家電話"

#: apps/dp-business/src/components/PrivateImage/index.tsx:86
msgid "無法獲取圖片訪問URL"
msgstr "無法獲取圖片訪問URL"

#: apps/dp-client/src/screens/home/pages/LocationSelect/components/NoLocationPermission.tsx:16
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:228
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:425
#: apps/dp-client/src/screens/home/components/ShopFilter/components/CascaderFilterContent.tsx:136
msgid "無法獲取定位"
msgstr "無法獲取定位"

#: apps/dp-admin/src/pages/merchant/components/BdAssignmentField/index.web.tsx:114
msgid "無法獲取影響範圍，請重新選擇資料"
msgstr "無法獲取影響範圍，請重新選擇資料"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:213
msgid "無法獲取您的資產訊息，請稍後重試"
msgstr "無法獲取您的資產訊息，請稍後重試"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:279
msgid "無法獲取操作人資訊，請重新登入後再試"
msgstr "無法獲取操作人資訊，請重新登入後再試"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:131
msgid "無法獲取業務訂單號"
msgstr "無法獲取業務訂單號"

#: apps/dp-admin/src/pages/merchant/brand-list/services/hooks.ts:211
msgid "無法獲取當前操作人資訊，請重新登入後再試"
msgstr "無法獲取當前操作人資訊，請重新登入後再試"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:157
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:157
#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:251
msgid "無法獲取當前用戶 ID"
msgstr "無法獲取當前用戶 ID"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/services/hooks.ts:239
msgid "無法獲取當前用戶資訊"
msgstr "無法獲取當前用戶資訊"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/MapNaviation/index.tsx:154
msgid "無法獲取目的地訊息"
msgstr "無法獲取目的地訊息"

#: apps/dp-client/src/components/Upload/index.tsx:139
msgid "無法獲取視頻時長"
msgstr "無法獲取影片時長"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:215
msgid "無法獲取身份證正面圖片地址，請重新上傳"
msgstr "無法獲取身份證正面圖片地址，請重新上傳"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:92
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:112
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:230
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:264
msgid "無法獲取身分證正面圖片地址，請重新上傳"
msgstr "無法獲取身分證正面圖片地址，請重新上傳"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:548
msgid "無法獲取顧客電話"
msgstr "無法獲取顧客電話"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:96
msgid "無法管理店家與商品"
msgstr "無法管理店家與商品"

#: apps/dp-business/src/utils/passwordManager.ts:178
#: apps/dp-business/src/utils/passwordManager.ts:407
msgid "無法自動保存密碼"
msgstr "無法自動保存密碼"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:100
msgid "無法處理訂單與核銷"
msgstr "無法處理訂單與核銷"

#: apps/dp-client/src/screens/home/pages/Note/constants/index.ts:29
msgid "無法訪問相機，請在瀏覽器設置中允許相機權限"
msgstr "無法開啟相機，請在瀏覽器設置中允許相機權限"

#: apps/dp-admin/src/utils/file.ts:213
msgid "無法讀取視頻元數據"
msgstr "無法讀取視頻元數據"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/Card.tsx:216
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:734
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:677
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:733
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:813
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:860
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1047
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:381
msgid "無法購買"
msgstr "無法購買"

#: apps/dp-client/src/screens/home/pages/ShareKing/components/WinningList/index.tsx:146
msgid "無法載入最新資訊"
msgstr "無法載入最新資訊"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:482
msgid "無法載入發票詳情"
msgstr "無法載入發票詳情"

#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:227
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:175
msgid "無法載入詳情"
msgstr "無法載入詳情"

#: apps/dp-client/src/screens/others/NoNetwork.tsx:32
msgid "無法連結到網際網路"
msgstr "無法連結到網際網路"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:104
msgid "無法進行任何後臺操作"
msgstr "無法進行任何後臺操作"

#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:712
msgid "無法重傳，請刪除後重新上傳"
msgstr "無法重傳，請刪除後重新上傳"

#: apps/dp-client/src/utils/permission.ts:82
msgid "無法開啟位置"
msgstr "無法開啟位置"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:327
msgid "無法開啟檔案選擇器"
msgstr "無法開啟檔案選擇器"

#: apps/dp-client/src/utils/permission.ts:55
msgid "無法開啟照片"
msgstr "無法開啟照片"

#: apps/dp-client/src/utils/permission.ts:64
msgid "無法開啟相機"
msgstr "無法開啟相機"

#: apps/dp-client/src/utils/permission.ts:73
msgid "無法開啟麥克風"
msgstr "無法開啟麥克風"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:254
msgid "無法預覽該檔案"
msgstr "無法預覽該檔案"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:242
msgid "無流程受影響"
msgstr "無流程受影響"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:89
msgid "無特殊備註資訊"
msgstr "無特殊備註資訊"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:163
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/interface/userActivityDetail.ts:170
msgid "無獎品"
msgstr "無獎品"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:416
msgid "無符合條件的餐點"
msgstr "無符合條件的餐點"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1380
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1426
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1439
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1452
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1465
msgid "無編輯優惠券權限"
msgstr "無編輯優惠券權限"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:186
msgid "無編輯商家資訊權限"
msgstr "無編輯商家資訊權限"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:480
msgid "無編輯活動權限"
msgstr "無編輯活動權限"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:285
msgid "無要求"
msgstr "無要求"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1500
#: apps/dp-business/src/pages/ReservationManagement/TableCells.tsx:581
msgid "無規則"
msgstr "無規則"

#: apps/dp-business/src/pages/PermissionManagement/index.tsx:234
msgid "無角色列表查看權限"
msgstr "無角色列表查看權限"

#: apps/dp-business/src/pages/TableManagement/index.tsx:199
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:928
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1264
msgid "無設定桌位權限"
msgstr "無設定桌位權限"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1111
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1181
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:129
msgid "無設定訂位規則權限"
msgstr "無設定訂位規則權限"

#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/constants.ts:9
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/utils/index.ts:18
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/utils/index.ts:20
msgid "無評分"
msgstr "無評分"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:279
msgid "無評論回覆權限"
msgstr "無評論回覆權限"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1677
msgid "無資訊編輯權限"
msgstr "無資訊編輯權限"

#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:191
#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:238
#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:247
#: apps/dp-business/src/pages/CouponVerification/index.tsx:369
#: apps/dp-business/src/pages/CouponVerification/index.tsx:380
#: apps/dp-business/src/pages/CouponVerification/index.tsx:442
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:596
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:722
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:731
msgid "無輸入與掃碼核銷權限"
msgstr "無輸入與掃碼核銷權限"

#: apps/dp-admin/src/pages/order/services/utils.ts:348
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:335
msgid "無退款"
msgstr "無退款"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1878
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2186
msgid "無退款原因"
msgstr "無退款原因"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1888
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2196
msgid "無退款說明"
msgstr "無退款說明"

#: apps/dp-admin/src/modules/constants/options.ts:6
msgid "無連鎖"
msgstr "無連鎖"

#: apps/dp-business/src/components/CascadePicker/index.tsx:266
msgid "無選項"
msgstr "無選項"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:116
msgid "無邊框"
msgstr "無邊框"

#: apps/dp-client/src/components/CouponCard/index.tsx:146
msgid "無門檻"
msgstr "無門檻"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:43
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:40
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:333
msgid "無關內容"
msgstr "無關內容"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:147
msgid "無關聯"
msgstr "無關聯"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1140
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1169
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:124
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:351
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/IncomeCalculationSection.tsx:42
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:100
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:182
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:132
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:135
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:150
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:180
msgid "無限"
msgstr "無限"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:420
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:645
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:842
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityGridCard.tsx:43
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityGridCard.tsx:49
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityGridCard.tsx:65
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:223
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:699
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:708
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityCard.tsx:64
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityCard.tsx:73
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityCard.tsx:99
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/utils/activityUtils.ts:97
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/utils/activityUtils.ts:103
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/utils/activityUtils.ts:115
#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:39
#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:81
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:30
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:174
#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:436
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:43
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:48
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:207
msgid "無限制"
msgstr "無限制"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:88
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:96
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:106
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:106
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:107
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:507
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:898
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:548
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:240
msgid "無限期"
msgstr "無限期"

#: apps/dp-admin/src/pages/transaction/service/help/validate.ts:108
msgid "無限期時間段後不能有其他時間段，請檢查後提交"
msgstr "無限期時間段後不能有其他時間段，請檢查後提交"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:74
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:55
msgid "無障礙停車"
msgstr "無障礙停車"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:75
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:56
msgid "無障礙入口"
msgstr "無障礙入口"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:76
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:57
msgid "無障礙洗手間"
msgstr "無障礙洗手間"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:71
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:182
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:52
msgid "無障礙設施"
msgstr "無障礙設施"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:179
msgid "無障礙選項"
msgstr "無障礙選項"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:23
msgid "無需人審"
msgstr "無需人審"

#: apps/dp-business/src/pages/MarketingCenter/components/RedemptionRulesCard.tsx:70
msgid "無需掃碼核銷"
msgstr "無需掃碼核銷"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:56
msgid "無需領獎"
msgstr "無需領獎"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopMediaGallery/index.tsx:214
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallMediaGallery/index.tsx:161
msgid "照片"
msgstr "照片"

#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:57
#: apps/dp-client/src/components/TabView/example.tsx:21
msgid "照片/影片"
msgstr "照片/影片"

#: apps/dp-client/src/configs/page-configs.tsx:215
#: apps/dp-client/src/configs/page-configs.tsx:355
msgid "照片和影片"
msgstr "照片和影片"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:562
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:561
msgid "照片驗證失敗"
msgstr "照片驗證失敗"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:46
msgid "熱門"
msgstr "熱門"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/HotIssues.web.tsx:105
msgid "熱門問題"
msgstr "熱門問題"

#: apps/dp-client/src/screens/home/pages/Home/components/RecommendMasonryList/RecommendCard/Shop.tsx:34
msgid "熱門榜餐廳"
msgstr "熱門榜餐廳"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:160
msgid "熱門餐廳排行榜數日未更新"
msgstr "熱門餐廳排行榜數日未更新"

#: apps/dp-admin/src/pages/user-info/services/apis.ts:147
msgid "燒烤"
msgstr "燒烤"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:103
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:105
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:281
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:290
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:81
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:87
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:219
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:230
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:82
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:91
msgid "營利事業登記證"
msgstr "營利事業登記證"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/BusinessLicenseInfo/index.web.tsx:40
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/BusinessLicenseInfo/index.web.tsx:46
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:189
msgid "營利事業登記證圖片"
msgstr "營利事業登記證圖片"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:838
msgid "營利事業登記證負責人姓名"
msgstr "營利事業登記證負責人姓名"

#: apps/dp-client/src/utils/businessStatus.ts:187
#: apps/dp-client/src/utils/businessStatus.ts:250
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:253
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:1058
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:624
#: apps/dp-admin/src/pages/merchant/service/constants.ts:489
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:60
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:84
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:97
msgid "營業中"
msgstr "營業中"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:150
msgid "營業執照號"
msgstr "營業執照號"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:34
msgid "營業執照資訊異常"
msgstr "營業執照資訊異常"

#: apps/dp-client/src/screens/home/components/ShopFilter/components/AdvancedFilterContent.tsx:80
msgid "營業情況"
msgstr "營業情況"

#: apps/dp-client/src/screens/home/utils/filterData.ts:194
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:282
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:117
#: apps/dp-business/src/utils/moduleTypeMapping.ts:108
#: apps/dp-business/src/utils/moduleTypeMapping.ts:245
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1030
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1174
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:141
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1347
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1524
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:699
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:74
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:110
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:424
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:156
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:344
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:503
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:19
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:27
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:148
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:208
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:271
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:73
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/config.ts:81
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:178
msgid "營業時間"
msgstr "營業時間"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:831
msgid "營業時間儲存失敗，請稍後重試"
msgstr "營業時間儲存失敗，請稍後重試"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:818
msgid "營業時間儲存成功"
msgstr "營業時間儲存成功"

#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:255
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/types.ts:136
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:389
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:734
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:814
msgid "營業時間即可使用"
msgstr "營業時間即可使用"

#: apps/dp-client/src/screens/home/utils/order.ts:1150
#: apps/dp-client/src/screens/home/utils/order.ts:1174
msgid "營業時間可用"
msgstr "營業時間可用"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:812
msgid "營業時間可能因節假日調整"
msgstr "營業時間可能因節假日調整"

#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:89
msgid "營業時間未設置"
msgstr "營業時間未設置"

#: apps/dp-client/src/screens/home/utils/order.ts:879
msgid "營業時間段都可用"
msgstr "營業時間段都可用"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:109
msgid "營業時間資訊完整度評分"
msgstr "營業時間資訊完整度評分"

#: apps/dp-client/src/screens/home/utils/order.ts:841
#: apps/dp-client/src/screens/home/utils/order.ts:959
#: apps/dp-client/src/screens/home/utils/order.ts:960
#: apps/dp-client/src/screens/home/utils/order.ts:1045
#: apps/dp-client/src/screens/home/utils/order.ts:1046
#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:500
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:195
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:133
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:112
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:709
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1459
msgid "營業時間都可用"
msgstr "營業時間都可用"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:278
#: apps/dp-business/src/utils/moduleTypeMapping.ts:135
#: apps/dp-business/src/utils/moduleTypeMapping.ts:248
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1039
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1167
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:623
#: apps/dp-business/src/pages/BusinessStatus/index.tsx:363
#: apps/dp-business/src/pages/BusinessStatus/index.tsx:377
#: apps/dp-business/src/pages/BusinessStatus/index.tsx:452
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:296
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:386
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:662
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:402
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:114
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:133
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:102
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:138
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:121
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:602
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:117
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:536
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:211
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:210
msgid "營業狀態"
msgstr "營業狀態"

#: apps/dp-business/src/pages/BusinessStatus/components/SharedTemplatesContent.tsx:80
#: apps/dp-admin/src/pages/merchant/shop-detail/components/SharedTemplatesModal/index.web.tsx:68
msgid "營業狀態已變更，請留意其他餐券狀態"
msgstr "營業狀態已變更，請留意其他餐券狀態"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:267
msgid "營業狀態更新失敗，請稍後重試"
msgstr "營業狀態更新失敗，請稍後重試"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:257
msgid "營業狀態更新成功"
msgstr "營業狀態更新成功"

#: apps/dp-business/src/pages/BusinessStatus/components/ShopClosedImpactContent.tsx:76
msgid "營業狀態變更為"
msgstr "營業狀態變更為"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:290
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:304
msgid "營業狀態變更為暫停營業，建議檢查套餐券清單下架對應套餐券，避免產生異常訂單。"
msgstr "營業狀態變更為暫停營業，建議檢查套餐券清單下架對應套餐券，避免產生異常訂單。"

#. placeholder {0}: templates.length
#: apps/dp-admin/src/pages/merchant/shop-detail/components/ShopClosedImpactModal/index.web.tsx:54
msgid "營業狀態變更為永久停業，會自動下架共 {0} 個套餐券，請確認"
msgstr "營業狀態變更為永久停業，會自動下架共 {0} 個套餐券，請確認"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:322
msgid "營業狀態變更預覽失敗，請稍後重試"
msgstr "營業狀態變更預覽失敗，請稍後重試"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:136
msgid "營業狀態資訊完整度評分"
msgstr "營業狀態資訊完整度評分"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:381
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:143
msgid "營業登記文件"
msgstr "營業登記文件"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:295
msgid "營業登記資料"
msgstr "營業登記資料"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:507
#: apps/dp-business/src/components/InvoiceForm/index.tsx:481
msgid "營業稅"
msgstr "營業稅"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:211
#: apps/dp-business/src/components/InvoiceForm/index.tsx:262
msgid "營業稅："
msgstr "營業稅："

#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:442
msgid "營業稅額"
msgstr "營業稅額"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:297
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:162
#: apps/dp-client/src/configs/page-configs.tsx:232
#: apps/dp-client/src/configs/page-configs.tsx:373
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:122
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1119
msgid "營業資訊"
msgstr "營業資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:219
msgid "營登地址"
msgstr "營登地址"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:200
msgid "營登資訊"
msgstr "營登資訊"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:67
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:70
msgid "營運"
msgstr "營運"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:482
msgid "營運狀態"
msgstr "營運狀態"

#: apps/dp-admin/src/configs/page-configs.tsx:14
msgid "營運端"
msgstr "營運端"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:72
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/services/hooks.ts:36
msgid "營運端提交影像資料"
msgstr "營運端提交影像資料"

#: apps/dp-admin/src/pages/login/index.web.tsx:76
#: apps/dp-admin/src/components/layout/components/sidebar/index.web.tsx:195
msgid "營運管理系統"
msgstr "營運管理系統"

#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:60
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:18
msgid "營銷推廣"
msgstr "營銷推廣"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:38
msgid "爭議款信箱"
msgstr "爭議款信箱"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:50
msgid "父級面板"
msgstr "父級面板"

#. placeholder {0}: version.with({ env: !isOnline, buildTime: !isOnline, patchId: isOnline || isRC })
#: apps/dp-client/src/components/Version/index.tsx:34
msgid "版本 v{0}"
msgstr "版本 v{0}"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:399
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:563
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:602
msgid "版本內容"
msgstr "版本內容"

#: apps/dp-admin/src/components/ErrorBoundary/index.web.tsx:92
msgid "版本已更新，請重新加載頁面。"
msgstr "版本已更新，請重新加載頁面。"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:162
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:250
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:333
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:380
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:546
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:592
msgid "版本號"
msgstr "版本號"

#. placeholder {0}: version.with({ env: true, buildTime: true })
#: apps/dp-client/src/screens/diary/pages/rule/index.tsx:212
#: apps/dp-client/src/screens/diary/pages/question/index.tsx:87
msgid "版本號: {0}"
msgstr "版本號: {0}"

#: apps/dp-admin/src/components/ClientVersionDropdown/index.web.tsx:125
msgid "版本號碼"
msgstr "版本號碼"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:581
msgid "版本詳情"
msgstr "版本詳情"

#: apps/dp-client/src/screens/home/utils/filterData.ts:237
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:160
msgid "特別條件"
msgstr "特別條件"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:44
msgid "特大"
msgstr "特大"

#: apps/dp-client/src/screens/home/utils/order.ts:1100
#: apps/dp-client/src/screens/home/utils/order.ts:1105
msgid "特定時期"
msgstr "特定時期"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:470
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:245
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:278
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:111
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:153
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:59
msgid "特定時間段"
msgstr "特定時間段"

#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:244
msgid "特定活動中該內容可在用戶端展示"
msgstr "特定活動中該內容可在用戶端展示"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:137
msgid "特定用戶"
msgstr "特定用戶"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:484
msgid "特定用戶設定"
msgstr "特定用戶設定"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:38
msgid "特小"
msgstr "特小"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:431
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:582
msgid "特殊假日"
msgstr "特殊假日"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1865
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2033
msgid "特殊可用時間"
msgstr "特殊可用時間"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:800
msgid "特殊日期24小時營業"
msgstr "特殊日期24小時營業"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:776
msgid "特殊日期休息"
msgstr "特殊日期休息"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:801
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1438
msgid "特殊日期營業時間"
msgstr "特殊日期營業時間"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:1439
msgid "特殊日期營業時間的設定層級高於常態營業時間"
msgstr "特殊日期營業時間的設定層級高於常態營業時間"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:705
msgid "特殊時間規則設置"
msgstr "特殊時間規則設置"

#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:219
msgid "特殊營業時間"
msgstr "特殊營業時間"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:109
msgid "特殊規則發放"
msgstr "特殊規則發放"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:236
msgid "特色宣傳"
msgstr "特色宣傳"

#: apps/dp-business/src/data/categories.ts:46
msgid "特色川菜"
msgstr "特色川菜"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/PromotionTab/index.web.tsx:80
msgid "特色標籤"
msgstr "特色標籤"

#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:512
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:694
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:582
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:709
#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:272
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1091
#: apps/dp-business/src/pages/OrderDetail/index.tsx:771
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1097
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1414
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2483
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2665
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1018
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:217
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:476
#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:121
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:239
#: apps/dp-business/src/pages/ContractManagement/index.tsx:233
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:527
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:181
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:210
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:330
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:206
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:218
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:185
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:318
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:305
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountToolbar/index.web.tsx:99
#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:92
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:326
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CommissionBenefitListCard.web.tsx:54
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:153
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:128
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:186
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:37
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:155
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/services/searchConfig.ts:27
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:95
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:87
#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:76
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:63
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/searchConfig.ts:36
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:85
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/packageCouponColumns.web.tsx:35
#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:64
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:63
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:123
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:179
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:195
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:345
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:238
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:228
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:178
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:393
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:595
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/PackageCouponCard/index.web.tsx:76
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:245
#: apps/dp-admin/src/pages/org-tree/components/S9BlockModal/index.web.tsx:50
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:146
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:307
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:76
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:76
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:212
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:280
#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:144
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:133
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:199
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:106
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:99
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:185
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:643
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:681
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1113
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:152
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:75
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/searchConfig.ts:23
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:80
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/SearchForm/index.web.tsx:35
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:98
#: apps/dp-admin/src/pages/marketing/verification-record-detail/components/StatusLogTable/index.web.tsx:39
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:148
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:74
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:181
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:206
#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:34
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:131
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/BasicInfoTab/index.web.tsx:72
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:109
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:197
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:170
#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:84
#: apps/dp-admin/src/pages/marketing/channel-management/services/constants.ts:108
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:196
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/PackageColumns/index.web.tsx:23
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:69
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:103
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:59
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:168
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:143
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:254
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:269
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:74
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateDetailInfo/index.web.tsx:76
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:257
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:480
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:331
#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:101
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:53
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:61
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:174
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:317
#: apps/dp-admin/src/components/UserGroup/UserGroupDetailInfo/index.web.tsx:44
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupDetailInfo/index.web.tsx:44
#: apps/dp-admin/src/components/LandingPage/LandingPageDetailInfo/index.web.tsx:51
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:105
msgid "狀態"
msgstr "狀態"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/common/AuditStatusBanner/index.web.tsx:40
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/AuditStatusBanner/index.web.tsx:70
msgid "狀態為："
msgstr "狀態為："

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponListModal.web.tsx:175
msgid "狀態篩選"
msgstr "狀態篩選"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponStatusModal.web.tsx:144
msgid "狀態說明"
msgstr "狀態說明"

#. placeholder {0}: impactTemplates.length
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1138
msgid "狀態變更為已下架，會自動下架共 {0} 個套餐券，請確認"
msgstr "狀態變更為已下架，會自動下架共 {0} 個套餐券，請確認"

#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/QuickPromptSection.tsx:33
msgid "猜你想說"
msgstr "猜你想說"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:59
msgid "獎勵份數不可為空，已恢復原值"
msgstr "獎勵份數不可為空，已恢復原值"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:186
msgid "獎勵份數須為正整數，且下方不可低於上方、右側不可低於左側，已自動調整"
msgstr "獎勵份數須為正整數，且下方不可低於上方、右側不可低於左側，已自動調整"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:181
msgid "獎勵權益"
msgstr "獎勵權益"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:53
msgid "獎勵權益 - 中獎人數"
msgstr "獎勵權益 - 中獎人數"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:55
msgid "獎勵發放概率"
msgstr "獎勵發放機率"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:82
msgid "獎勵自然週期"
msgstr "獎勵自然週期"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:315
msgid "獎勵規則"
msgstr "獎勵規則"

#. placeholder {0}: field.name + 1
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:155
msgid "獎勵規則 {0}"
msgstr "獎勵規則 {0}"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardLimitConfigEditor/index.web.tsx:56
msgid "獎勵週期"
msgstr "獎勵週期"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:198
msgid "獎勵配置"
msgstr "獎勵配置"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:194
msgid "獎勵限制"
msgstr "獎勵限制"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:192
msgid "獎勵類型"
msgstr "獎勵類型"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:203
#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/WinningConfirmModal.web.tsx:78
msgid "獎品類型"
msgstr "獎品類型"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:598
msgid "獎池大小"
msgstr "獎池大小"

#: apps/dp-client/src/screens/home/pages/MallDetail/index.tsx:324
msgid "獨家套餐券"
msgstr "獨家套餐券"

#. placeholder {0}: deal.templateName
#. placeholder {1}: deal.shopName || ''
#. placeholder {2}: index + 1
#: apps/dp-client/src/screens/home/pages/MallDetail/index.tsx:278
msgid "獨家套餐券_{0}_{1}_{2}"
msgstr "獨家套餐券_{0}_{1}_{2}"

#. placeholder {0}: deal.templateName
#. placeholder {1}: deal.shopId
#. placeholder {2}: getStockStatus(deal).isSoldOut ? '售罄' : '搶購'
#. placeholder {3}: index + 1
#: apps/dp-client/src/screens/home/pages/MallDetail/index.tsx:292
msgid "獨家套餐券_{0}_{1}_{2}_{3}"
msgstr "獨家套餐券_{0}_{1}_{2}_{3}"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:26
msgid "獨立榜單"
msgstr "獨立榜單"

#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:110
msgid "獲取 POI 審核快照失敗"
msgstr "獲取 POI 審核快照失敗"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/OnlineShopList/index.tsx:107
msgid "獲取500甜線上通路列表失敗"
msgstr "獲取500甜線上通路列表失敗"

#: apps/dp-client/src/screens/home/components/CommonShopListSection/index.tsx:265
msgid "獲取500甜線上通路年份失敗"
msgstr "獲取500甜線上通路年份失敗"

#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/index.tsx:149
msgid "獲取500碗入口狀態失敗:"
msgstr "獲取500碗入口狀態失敗:"

#: apps/dp-client/src/screens/home/pages/Home/components/HotRanking/index.tsx:111
msgid "獲取500輯入口狀態失敗:"
msgstr "獲取500輯入口狀態失敗:"

#: apps/dp-business/src/pages/ContactBD/index.tsx:64
#: apps/dp-business/src/pages/ContactBD/index.tsx:68
msgid "獲取BD信息失敗"
msgstr "獲取BD信息失敗"

#: apps/dp-business/src/servers/contract-management/api.ts:115
msgid "獲取Hash配置失敗"
msgstr "獲取Hash配置失敗"

#: apps/dp-admin/src/pages/resource-config/category-management/services/hooks.ts:346
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:168
msgid "獲取一級品類選項失敗"
msgstr "獲取一級品類選項失敗"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:1089
msgid "獲取下載鏈接失敗"
msgstr "獲取下載鏈接失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:148
msgid "獲取中獎名單失敗"
msgstr "獲取中獎名單失敗"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/services/hooks.ts:69
msgid "獲取任務詳情失敗"
msgstr "獲取任務詳情失敗"

#. placeholder {0}: error.message
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/index.web.tsx:228
msgid "獲取位置失敗: {0}"
msgstr "獲取位置失敗: {0}"

#: apps/dp-admin/src/pages/resource-config/holiday-management/services/hooks.ts:279
msgid "獲取假日類型列表失敗"
msgstr "獲取假日類型列表失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1364
#: apps/dp-admin/src/pages/marketing/services/apis.ts:1368
msgid "獲取優惠券模板列表失敗"
msgstr "獲取優惠券模板列表失敗"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:296
msgid "獲取分區列表失敗"
msgstr "獲取分區列表失敗"

#: apps/dp-client/src/store/rankingStore.ts:180
msgid "獲取分類數據失敗"
msgstr "獲取分類數據失敗"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/OnlineShopList/index.tsx:108
#: apps/dp-admin/src/pages/resource-config/category-management/services/hooks.ts:70
#: apps/dp-admin/src/pages/resource-config/category-management/services/hooks.ts:218
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:235
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:290
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:303
msgid "獲取列表失敗"
msgstr "獲取列表失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1235
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/hooks.ts:238
msgid "獲取券列表失敗"
msgstr "獲取券列表失敗"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/hooks.ts:147
msgid "獲取券組列表失敗"
msgstr "獲取券組列表失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:512
#: apps/dp-admin/src/pages/marketing/services/apis.ts:516
msgid "獲取參與商家列表失敗"
msgstr "獲取參與商家列表失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:490
#: apps/dp-admin/src/pages/marketing/services/apis.ts:494
msgid "獲取參與用戶列表失敗"
msgstr "獲取參與用戶列表失敗"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:196
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:204
msgid "獲取可用日期失敗"
msgstr "獲取可用日期失敗"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:317
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:324
msgid "獲取可用時間段失敗"
msgstr "獲取可用時間段失敗"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:437
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:441
msgid "獲取可用桌位失敗"
msgstr "獲取可用桌位失敗"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:387
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:393
msgid "獲取可用桌型失敗"
msgstr "獲取可用桌型失敗"

#: apps/dp-business/src/servers/reservation/api.ts:1026
msgid "獲取可預訂日期失敗"
msgstr "獲取可預訂日期失敗"

#: apps/dp-business/src/servers/reservation/api.ts:1049
msgid "獲取可預訂時段失敗"
msgstr "獲取可預訂時段失敗"

#: apps/dp-business/src/servers/reservation/api.ts:1095
msgid "獲取可預訂桌位失敗"
msgstr "獲取可預訂桌位失敗"

#: apps/dp-business/src/servers/reservation/api.ts:1072
msgid "獲取可預訂桌型失敗"
msgstr "獲取可預訂桌型失敗"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:124
#: apps/dp-admin/src/pages/transaction/contract-management/index.web.tsx:95
msgid "獲取合約列表失敗"
msgstr "獲取合約列表失敗"

#: apps/dp-business/src/servers/contract-management/api.ts:227
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/hooks.ts:82
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/hooks.ts:86
msgid "獲取合約詳情失敗"
msgstr "獲取合約詳情失敗"

#: apps/dp-business/src/servers/shop/api.ts:747
msgid "獲取同品牌店家失敗"
msgstr "獲取同品牌店家失敗"

#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:147
msgid "獲取名單詳情失敗"
msgstr "獲取名單詳情失敗"

#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:51
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:54
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:49
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:52
msgid "獲取品類詳情失敗"
msgstr "獲取品類詳情失敗"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:84
msgid "獲取商圈套餐列表失敗"
msgstr "獲取商圈套餐列表失敗"

#: apps/dp-client/src/screens/home/pages/MallDetail/hooks/useCommercialPoiTabContent.ts:117
msgid "獲取商圈套餐券列表失敗:"
msgstr "獲取商圈套餐券列表失敗:"

#: apps/dp-client/src/screens/home/pages/MallDetail/hooks/useCommercialPoiTabContent.ts:156
msgid "獲取商圈店家列表失敗:"
msgstr "獲取商圈店家列表失敗:"

#: apps/dp-client/src/screens/home/pages/MallDetail/hooks/useCommercialPoiActivities.ts:57
msgid "獲取商場 / 夜市商圈活動位失敗:"
msgstr "獲取商場 / 夜市商圈活動位失敗:"

#: apps/dp-client/src/screens/home/pages/MallDetail/hooks/useCommercialPoiDetail.ts:48
msgid "獲取商場 / 夜市商圈詳情失敗:"
msgstr "獲取商場 / 夜市商圈詳情失敗:"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListMallInfo.ts:67
msgid "獲取商場信息失敗"
msgstr "獲取商場信息失敗"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/MallShopList/index.tsx:155
msgid "獲取商場商家列表失敗"
msgstr "獲取商場商家列表失敗"

#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:340
msgid "獲取商場樓層篩選失敗"
msgstr "獲取商場樓層篩選失敗"

#: apps/dp-client/src/screens/home/pages/MallDetail/hooks/useCommercialPoiTabContent.ts:84
msgid "獲取商場樓層篩選項失敗:"
msgstr "獲取商場樓層篩選項失敗:"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallNoteSection/index.tsx:99
msgid "獲取商場筆記失敗"
msgstr "獲取商場筆記失敗"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:559
msgid "獲取商家信息失敗"
msgstr "獲取商家信息失敗"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:136
msgid "獲取商家列表失敗"
msgstr "獲取商家列表失敗"

#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/hooks.ts:162
#: apps/dp-admin/src/modules/apis/merchantGroup.ts:33
#: apps/dp-admin/src/modules/apis/merchantGroup.ts:36
msgid "獲取商家名單列表失敗"
msgstr "獲取商家名單列表失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:792
#: apps/dp-admin/src/pages/marketing/services/apis.ts:795
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/services/hooks.ts:89
msgid "獲取商家名單店家列表失敗"
msgstr "獲取商家名單店家列表失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:881
#: apps/dp-admin/src/pages/marketing/services/apis.ts:884
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/services/hooks.ts:194
msgid "獲取商家名單歷史批次失敗"
msgstr "獲取商家名單歷史批次失敗"

#: apps/dp-admin/src/pages/marketing/merchant-group-detail/services/hooks.ts:71
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:151
#: apps/dp-admin/src/modules/apis/merchantGroup.ts:55
#: apps/dp-admin/src/modules/apis/merchantGroup.ts:58
#: apps/dp-admin/src/modules/apis/merchantGroup.ts:78
#: apps/dp-admin/src/modules/apis/merchantGroup.ts:81
msgid "獲取商家名單詳情失敗"
msgstr "獲取商家名單詳情失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:289
#: apps/dp-admin/src/pages/marketing/services/apis.ts:293
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/hooks.ts:91
msgid "獲取商家活動列表失敗"
msgstr "獲取商家活動列表失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:311
#: apps/dp-admin/src/pages/marketing/services/apis.ts:315
msgid "獲取商家活動詳情失敗"
msgstr "獲取商家活動詳情失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:468
#: apps/dp-admin/src/pages/marketing/services/apis.ts:472
msgid "獲取圈選商家列表失敗"
msgstr "獲取圈選商家列表失敗"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/services/hooks.ts:90
msgid "獲取圖片列表失敗"
msgstr "獲取圖片列表失敗"

#: apps/dp-business/src/components/PrivateImage/index.tsx:90
msgid "獲取圖片失敗"
msgstr "獲取圖片失敗"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/services/hooks.ts:170
msgid "獲取圖片審核詳情失敗"
msgstr "獲取圖片審核詳情失敗"

#: apps/dp-admin/src/modules/services/private-image-resolver/privateImageResolver.ts:120
#: apps/dp-admin/src/modules/services/private-image-resolver/privateImageResolver.ts:127
msgid "獲取圖片訪問地址失敗"
msgstr "獲取圖片訪問地址失敗"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:175
#: apps/dp-admin/src/pages/report-center/services/apis.ts:230
#: apps/dp-admin/src/pages/report-center/services/apis.ts:284
#: apps/dp-admin/src/pages/report-center/services/apis.ts:344
#: apps/dp-admin/src/pages/report-center/services/apis.ts:409
#: apps/dp-admin/src/pages/report-center/services/apis.ts:473
#: apps/dp-admin/src/pages/report-center/services/apis.ts:539
#: apps/dp-admin/src/pages/report-center/services/apis.ts:603
msgid "獲取失敗"
msgstr "獲取失敗"

#: apps/dp-client/src/store/couponStore.ts:276
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/hooks.ts:138
msgid "獲取套餐券列表失敗"
msgstr "獲取套餐券列表失敗"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/hooks.ts:34
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/hooks.ts:38
msgid "獲取套餐券審核列表失敗"
msgstr "獲取套餐券審核列表失敗"

#: apps/dp-business/src/servers/order/api.ts:452
msgid "獲取套餐券核銷明細失敗"
msgstr "獲取套餐券核銷明細失敗"

#: apps/dp-business/src/servers/order/api.ts:475
msgid "獲取套餐券核銷統計失敗"
msgstr "獲取套餐券核銷統計失敗"

#: apps/dp-business/src/servers/order/api.ts:498
msgid "獲取套餐券核銷詳情失敗"
msgstr "獲取套餐券核銷詳情失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1093
msgid "獲取套餐券訂單列表失敗"
msgstr "獲取套餐券訂單列表失敗"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:167
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:171
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:359
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:363
msgid "獲取套餐券詳情失敗"
msgstr "獲取套餐券詳情失敗"

#: apps/dp-business/src/servers/order/api.ts:429
msgid "獲取套餐券銷售統計失敗"
msgstr "獲取套餐券銷售統計失敗"

#: apps/dp-business/src/servers/order/api.ts:406
msgid "獲取套餐券銷售訂單失敗"
msgstr "獲取套餐券銷售訂單失敗"

#: apps/dp-client/src/screens/home/pages/PackageZone/hooks/usePackageZoneList.ts:205
msgid "獲取套餐專區列表失敗:"
msgstr "獲取套餐專區列表失敗:"

#: apps/dp-admin/src/pages/audit-center/services/useTaskSnapshot.ts:54
msgid "獲取審核任務快照失敗"
msgstr "獲取審核任務快照失敗"

#: apps/dp-admin/src/pages/audit-center/audit-detail-redirect/index.web.tsx:38
msgid "獲取審核任務詳情失敗"
msgstr "獲取審核任務詳情失敗"

#: apps/dp-business/src/servers/order/api.ts:319
msgid "獲取對帳匯總失敗"
msgstr "獲取對帳匯總失敗"

#: apps/dp-business/src/servers/reservation/api.ts:763
#: apps/dp-business/src/pages/OrderOverview/index.tsx:540
#: apps/dp-business/src/pages/OrderOverview/index.tsx:668
#: apps/dp-business/src/pages/OrderOverview/index.tsx:709
msgid "獲取履約表現數據失敗"
msgstr "獲取履約表現數據失敗"

#: apps/dp-business/src/servers/reservation/api.ts:809
msgid "獲取已過用餐時間訂單失敗"
msgstr "獲取已過用餐時間訂單失敗"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:340
msgid "獲取店家列表出錯"
msgstr "獲取店家列表出錯"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageScopeSection/index.web.tsx:80
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/MemberPreviewPanel/index.web.tsx:53
#: apps/dp-admin/src/modules/apis/merchantGroup.ts:101
#: apps/dp-admin/src/modules/apis/merchantGroup.ts:104
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupShopList/index.web.tsx:57
msgid "獲取店家列表失敗"
msgstr "獲取店家列表失敗"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageScopeSection/index.web.tsx:95
msgid "獲取店家列表失敗，請稍後重試"
msgstr "獲取店家列表失敗，請稍後重試"

#: apps/dp-client/src/screens/home/pages/Meal/pages/shopSelect/index.tsx:114
msgid "獲取店家列表失敗，請重試"
msgstr "獲取店家列表失敗，請重試"

#: apps/dp-client/src/store/rankingStore.ts:94
msgid "獲取店家排行榜類型失敗"
msgstr "獲取店家排行榜類型失敗"

#: apps/dp-client/src/store/shopStore.ts:601
msgid "獲取店家筆記失敗"
msgstr "獲取店家筆記失敗"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:247
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:224
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:228
msgid "獲取庫存數據失敗"
msgstr "獲取庫存數據失敗"

#: apps/dp-business/src/servers/reservation/api.ts:651
msgid "獲取庫存概況失敗"
msgstr "獲取庫存概況失敗"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/MemberPreviewPanel/index.web.tsx:58
msgid "獲取成員列表失敗"
msgstr "獲取成員列表失敗"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:119
msgid "獲取打卡統計失敗"
msgstr "獲取打卡統計失敗"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:139
msgid "獲取打卡記錄失敗"
msgstr "獲取打卡記錄失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1153
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:104
msgid "獲取折扣券訂單列表失敗"
msgstr "獲取折扣券訂單列表失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1133
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:55
msgid "獲取折扣券詳情失敗"
msgstr "獲取折扣券詳情失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:197
msgid "獲取抽獎數據失敗"
msgstr "獲取抽獎數據失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/apis.ts:37
msgid "獲取抽獎頁面數據失敗"
msgstr "獲取抽獎頁面數據失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:436
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/apis.ts:209
msgid "獲取排行榜預覽失敗"
msgstr "獲取排行榜預覽失敗"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/services/hooks.ts:181
msgid "獲取接口白名單選項失敗"
msgstr "獲取接口白名單選項失敗"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:121
msgid "獲取提問詳情失敗"
msgstr "獲取提問詳情失敗"

#: apps/dp-business/src/servers/order/api.ts:343
msgid "獲取收銀臺統計失敗"
msgstr "獲取收銀臺統計失敗"

#: apps/dp-client/src/screens/home/pages/Ranking/hooks/useDishRankList.ts:125
msgid "獲取數據失敗，請稍後重試"
msgstr "獲取數據失敗，請稍後重試"

#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:134
#: apps/dp-admin/src/components/FileUpload/index.web.tsx:308
msgid "獲取文件訪問地址失敗"
msgstr "獲取文件訪問地址失敗"

#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/UsergiftBanner.tsx:144
msgid "獲取新人註冊禮狀態失敗:"
msgstr "獲取新人註冊禮狀態失敗:"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:82
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:87
msgid "獲取日常規則失敗"
msgstr "獲取日常規則失敗"

#: apps/dp-business/src/servers/contract-management/api.ts:273
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:302
msgid "獲取服務詳情失敗"
msgstr "獲取服務詳情失敗"

#: apps/dp-admin/src/pages/marketing/verification-record/services/hooks.ts:134
msgid "獲取核銷明細失敗"
msgstr "獲取核銷明細失敗"

#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:300
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:320
msgid "獲取核銷記錄失敗"
msgstr "獲取核銷記錄失敗"

#: apps/dp-business/src/servers/reservation/api.ts:382
msgid "獲取桌位列表失敗"
msgstr "獲取桌位列表失敗"

#: apps/dp-business/src/servers/reservation/api.ts:298
msgid "獲取桌型列表失敗"
msgstr "獲取桌型列表失敗"

#: apps/dp-business/src/servers/reservation/api.ts:628
msgid "獲取桌型及桌位列表失敗"
msgstr "獲取桌型及桌位列表失敗"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:200
msgid "獲取桌型桌位數據失敗"
msgstr "獲取桌型桌位數據失敗"

#: apps/dp-admin/src/pages/resource-config/rank-list/components/RankDetailModal/index.web.tsx:96
msgid "獲取榜單詳情失敗"
msgstr "獲取榜單詳情失敗"

#: apps/dp-admin/src/pages/marketing/user-group-detail/services/hooks.ts:254
#: apps/dp-admin/src/pages/marketing/services/apis.ts:725
#: apps/dp-admin/src/pages/marketing/services/apis.ts:728
msgid "獲取歷史批次失敗"
msgstr "獲取歷史批次失敗"

#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:321
#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:399
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:688
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:805
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:883
msgid "獲取活動詳情失敗"
msgstr "獲取活動詳情失敗"

#: apps/dp-client/src/screens/home/pages/PackageZone/pages/ActivityDescription/index.tsx:157
#: apps/dp-client/src/screens/account/pages/task-wall/pages/activity-description/index.tsx:74
msgid "獲取活動說明失敗:"
msgstr "獲取活動說明失敗:"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:369
#: apps/dp-admin/src/pages/marketing/services/apis.ts:373
msgid "獲取活動配置失敗"
msgstr "獲取活動配置失敗"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:107
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:112
msgid "獲取特殊時間規則失敗"
msgstr "獲取特殊時間規則失敗"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:566
msgid "獲取用戶信息失敗"
msgstr "獲取用戶信息失敗"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/hooks.ts:226
#: apps/dp-admin/src/modules/apis/userGroup.ts:30
#: apps/dp-admin/src/modules/apis/userGroup.ts:33
msgid "獲取用戶名單列表失敗"
msgstr "獲取用戶名單列表失敗"

#: apps/dp-admin/src/pages/marketing/user-group-detail/services/hooks.ts:127
#: apps/dp-admin/src/pages/marketing/services/apis.ts:540
#: apps/dp-admin/src/pages/marketing/services/apis.ts:543
#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:378
msgid "獲取用戶名單成員列表失敗"
msgstr "獲取用戶名單成員列表失敗"

#: apps/dp-admin/src/pages/marketing/user-group-detail/services/hooks.ts:98
#: apps/dp-admin/src/modules/apis/userGroup.ts:52
#: apps/dp-admin/src/modules/apis/userGroup.ts:55
msgid "獲取用戶名單詳情失敗"
msgstr "獲取用戶名單詳情失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/apis.ts:31
msgid "獲取用戶活動明細列表失敗"
msgstr "獲取用戶活動明細列表失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/apis.ts:53
msgid "獲取用戶活動明細詳情失敗"
msgstr "獲取用戶活動明細詳情失敗"

#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:446
msgid "獲取當前位置地址失敗:"
msgstr "獲取當前位置地址失敗:"

#: apps/dp-business/src/servers/reservation/api.ts:832
msgid "獲取當前時段訂單失敗"
msgstr "獲取當前時段訂單失敗"

#: apps/dp-business/src/servers/file/api.ts:202
msgid "獲取私有圖片URL失敗"
msgstr "獲取私有圖片URL失敗"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/services/hooks.ts:92
msgid "獲取第三方渠道列表失敗"
msgstr "獲取第三方渠道列表失敗"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:111
msgid "獲取筆記列表失敗"
msgstr "獲取筆記列表失敗"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/NoteSection/index.tsx:100
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:114
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/NoteModule/index.tsx:76
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallNoteSection/index.tsx:102
#: apps/dp-client/src/screens/account/pages/profile/components/ContentTabsSection/UserNoteSection.tsx:100
msgid "獲取筆記失敗"
msgstr "獲取筆記失敗"

#: apps/dp-admin/src/pages/resource-config/holiday-management/services/hooks.ts:164
msgid "獲取節假日列表失敗"
msgstr "獲取節假日列表失敗"

#: apps/dp-business/src/servers/contract-management/api.ts:250
msgid "獲取管理頁面詳情失敗"
msgstr "獲取管理頁面詳情失敗"

#: apps/dp-business/src/servers/order/api.ts:521
msgid "獲取結帳折扣訂單失敗"
msgstr "獲取結帳折扣訂單失敗"

#: apps/dp-business/src/servers/order/api.ts:544
msgid "獲取結帳折扣訂單統計失敗"
msgstr "獲取結帳折扣訂單統計失敗"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:218
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:225
msgid "獲取結算單列表失敗，請重試"
msgstr "獲取結算單列表失敗，請重試"

#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:531
msgid "獲取綁定審核快照失敗"
msgstr "獲取綁定審核快照失敗"

#: apps/dp-business/src/servers/contract-management/api.ts:92
msgid "獲取聚流簽約詳情失敗"
msgstr "獲取聚流簽約詳情失敗"

#: apps/dp-client/src/screens/home/pages/Note/pages/draft/index.tsx:54
msgid "獲取草稿列表失敗"
msgstr "獲取草稿列表失敗"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:517
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:521
msgid "獲取菜品數據失敗"
msgstr "獲取餐點數據失敗"

#: apps/dp-client/src/store/rankingStore.ts:218
#: apps/dp-client/src/screens/home/pages/Ranking/hooks/useDishRankTypes.ts:36
msgid "獲取菜品榜單類型失敗"
msgstr "獲取餐點榜單類型失敗"

#: apps/dp-business/src/servers/reservation/api.ts:426
msgid "獲取規則列表失敗"
msgstr "獲取規則列表失敗"

#: apps/dp-business/src/servers/reservation/api.ts:448
msgid "獲取規則詳情失敗"
msgstr "獲取規則詳情失敗"

#: apps/dp-business/src/servers/reservation/api.ts:210
#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:266
msgid "獲取訂位概況失敗"
msgstr "獲取訂位概況失敗"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:473
#: apps/dp-business/src/pages/OrderOverview/index.tsx:584
#: apps/dp-business/src/pages/OrderOverview/index.tsx:625
msgid "獲取訂位概況數據失敗"
msgstr "獲取訂位概況數據失敗"

#: apps/dp-business/src/servers/reservation/api.ts:116
#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:111
msgid "獲取訂位規則列表失敗"
msgstr "獲取訂位規則列表失敗"

#: apps/dp-client/src/screens/account/pages/order/index.tsx:110
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:83
#: apps/dp-business/src/servers/reservation/api.ts:786
#: apps/dp-admin/src/pages/order/merchant-order-list/services/hooks.ts:131
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:208
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:212
#: apps/dp-admin/src/pages/marketing/order-list/services/hooks.ts:125
msgid "獲取訂單列表失敗"
msgstr "獲取訂單資訊失敗"

#: apps/dp-business/src/servers/order/api.ts:64
#: apps/dp-business/src/pages/OrderOverview/index.tsx:941
#: apps/dp-business/src/pages/OrderList/index.tsx:183
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:296
msgid "獲取訂單明細失敗"
msgstr "獲取訂單明細失敗"

#: apps/dp-business/src/servers/reservation/api.ts:858
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:182
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:186
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:98
msgid "獲取訂單詳情失敗"
msgstr "獲取訂單詳情失敗"

#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:314
msgid "獲取訂單資料失敗"
msgstr "獲取訂單資料失敗"

#: apps/dp-business/src/servers/contract-management/api.ts:70
msgid "獲取財務合約列表失敗"
msgstr "獲取財務合約列表失敗"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:48
msgid "獲取資產訊息失敗，請稍後重試"
msgstr "獲取資產訊息失敗，請稍後重試"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/index.web.tsx:124
msgid "獲取跟進歷史失敗"
msgstr "獲取跟進歷史失敗"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:106
msgid "獲取預訂詳情失敗"
msgstr "獲取預訂詳情失敗"

#: apps/dp-business/src/servers/shop/api.ts:564
msgid "獲取餐廳排名失敗"
msgstr "獲取餐廳排名失敗"

#: apps/dp-client/src/screens/home/pages/Home/components/RecommendSetmeal/index.tsx:102
msgid "獲取首頁推薦套餐失敗:"
msgstr "獲取首頁推薦套餐失敗:"

#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/DisplayPosition.tsx:58
msgid "獲取首頁策劃展示位數據失敗:"
msgstr "獲取首頁策劃展示位數據失敗:"

#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/CarouselResource.tsx:87
msgid "獲取首頁輪播資源位數據失敗:"
msgstr "獲取首頁輪播資源位數據失敗:"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:349
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:238
#: apps/dp-client/src/components/verify-code-sender/index.tsx:189
msgid "獲取驗證碼"
msgstr "獲取驗證碼"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:73
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:73
msgid "獲得客戶好評，本週評價率提升15%"
msgstr "獲得客戶好評，本週評價率提升15%"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:144
msgid "獲得時間"
msgstr "獲得時間"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:395
msgid "獲得領取資格"
msgstr "獲得領取資格"

#: apps/dp-client/src/screens/diary/pages/winning/index.tsx:205
msgid "獲獎名單正在核對，預計於"
msgstr "獲獎名單正在核對，預計於"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/OnlineShopList/index.tsx:55
msgid "獲獎菜品"
msgstr "獲獎菜品"

#: apps/dp-client/src/screens/account/pages/user-profile/components/UserInfoSection/index.tsx:157
msgid "獲讚與收藏"
msgstr "獲讚與收藏"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:72
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:75
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:138
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:128
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:288
msgid "王五"
msgstr "王五"

#: apps/dp-business/src/pages/RefundList/index.tsx:101
msgid "王大明"
msgstr "王大明"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:37
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:79
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:121
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:163
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:205
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:238
msgid "王小明"
msgstr "王小明"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:56
msgid "王思遠"
msgstr "王思遠"

#: apps/dp-business/src/components/CheckoutServiceModal/index.tsx:48
msgid "現在可以參與更多平台補貼活動"
msgstr "現在可以參與更多平台補貼活動"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/QuickFilterChips.tsx:60
msgid "現在營業"
msgstr "現在營業"

#: apps/dp-client/src/screens/home/utils/filterData.ts:196
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:119
msgid "現在營業中"
msgstr "現在營業中"

#: apps/dp-client/src/screens/home/pages/Note/components/NoteSucessToast/index.tsx:69
#: apps/dp-client/src/screens/home/pages/Home/components/NotePublishTip/index.tsx:85
msgid "現在馬上分享好友吧！"
msgstr "現在馬上分享好友吧！"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:171
msgid "現有停車場"
msgstr "現有停車場"

#. placeholder {0}: amount && !amountError ? discountAmount : 0
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1980
msgid "現省${0}"
msgstr "現省${0}"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:37
msgid "現金"
msgstr "現金"

#: apps/dp-admin/src/modules/constants/options.ts:226
msgid "現金券"
msgstr "現金券"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelHistoryList/index.web.tsx:110
msgid "理由"
msgstr "理由"

#: apps/dp-business/src/data/regions.ts:67
msgid "瑞芳區"
msgstr "瑞芳區"

#: apps/dp-client/src/screens/home/pages/ShopDetail/constants/index.ts:20
#: apps/dp-client/src/screens/home/pages/Review/components/RatingSection/index.tsx:180
#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewEditorToolbar.tsx:24
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Media/index.tsx:32
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:230
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:322
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:795
#: apps/dp-client/src/screens/diary/components/diary-entry/index.tsx:112
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewContent.tsx:258
#: apps/dp-admin/src/pages/user-info/services/apis.ts:140
#: apps/dp-admin/src/pages/data-center/components/ReviewItem.web.tsx:136
#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:142
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/OriginalReviewSection/index.web.tsx:85
msgid "環境"
msgstr "環境"

#: apps/dp-client/src/screens/diary/components/DiaryContent/index.tsx:74
msgid "環境："
msgstr "環境："

#: apps/dp-business/src/pages/ImageManagement/index.tsx:233
#: apps/dp-business/src/pages/ImageManagement/index.tsx:379
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:397
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:240
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:247
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:100
msgid "環境圖片"
msgstr "環境圖片"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:73
msgid "環境圖片完整度評分"
msgstr "環境圖片完整度評分"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:329
msgid "環境好"
msgstr "環境好"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:592
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:54
msgid "環境照片"
msgstr "環境照片"

#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:28
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/HotIssues.web.tsx:80
msgid "環境衛生"
msgstr "環境衛生"

#: apps/dp-client/src/screens/home/components/ShopCard/components/S500Label.tsx:28
msgid "甜"
msgstr "甜"

#: apps/dp-business/src/data/categories.ts:195
msgid "甜品"
msgstr "甜點"

#: apps/dp-business/src/pages/RefundList/index.tsx:132
msgid "甜品店"
msgstr "甜點店"

#: apps/dp-business/src/data/categories.ts:190
msgid "甜品飲品"
msgstr "甜點飲品"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/index.web.tsx:46
#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:40
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/index.web.tsx:46
#: apps/dp-admin/src/pages/report-center/audit-data/index.web.tsx:46
msgid "生成中..."
msgstr "生成中..."

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:192
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:565
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:192
msgid "生成圖片任務"
msgstr "生成圖片任務"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:70
msgid "生成批次"
msgstr "生成批次"

#: apps/dp-admin/src/pages/marketing/benefit-form/schemaPatchRules.ts:284
#: apps/dp-admin/src/pages/marketing/benefit-form/schemaPatchRules.ts:296
msgid "生成數量不可小於原數量 {current}"
msgstr "生成數量不可小於原數量 {current}"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:60
#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:174
#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:80
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:69
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:111
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:168
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:70
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:220
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:115
#: apps/dp-admin/src/pages/audit-center/info-audit/components/InfoAuditTable/index.web.tsx:104
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/MerchantBasicInfo/index.web.tsx:88
#: apps/dp-admin/src/pages/audit-center/components/AuditInfoHeader/config.ts:12
msgid "生成時間"
msgstr "生成時間"

#. placeholder {0}: detailData?.createdAt ? dayjs(detailData.createdAt).format('YYYY-MM-DD HH:mm:ss') : ''
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1358
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1382
msgid "生成時間：{0}"
msgstr "生成時間：{0}"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1920
msgid "生成核銷券碼"
msgstr "生成核銷券碼"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:98
msgid "生效"
msgstr "生效"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:47
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:65
msgid "生效中"
msgstr "生效中"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:86
msgid "生效值"
msgstr "生效值"

#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:109
msgid "生效區間"
msgstr "生效區間"

#: apps/dp-admin/src/pages/org-tree/services/constants.ts:67
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:100
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:119
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:196
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:209
msgid "生效失敗"
msgstr "生效失敗"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:252
#: apps/dp-business/src/pages/ContractManagement/index.tsx:329
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CommissionBenefitListCard.web.tsx:44
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:189
msgid "生效時間"
msgstr "生效時間"

#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:103
#: apps/dp-admin/src/pages/org-tree/org-list/components/ApplicationModal/index.web.tsx:78
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:72
msgid "生效狀態"
msgstr "生效狀態"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:210
msgid "生效處理中"
msgstr "生效處理中"

#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:105
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:149
msgid "生日"
msgstr "生日"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:30
msgid "生日月份"
msgstr "生日月份"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:474
msgid "生日當天"
msgstr "生日當天"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/RefreshHistoryTab/index.web.tsx:52
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/RefreshHistoryTab/index.web.tsx:52
msgid "產出時間"
msgstr "產出時間"

#: apps/dp-business/src/servers/permission/api.ts:246
msgid "產生帳號密碼失敗"
msgstr "產生帳號密碼失敗"

#: apps/dp-client/src/screens/login/components/account-info-card/index.tsx:56
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:734
msgid "用"
msgstr "用"

#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:287
msgid "用原圖重新上傳"
msgstr "用原圖重新上傳"

#: apps/dp-business/src/types/orderFilter.ts:186
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1872
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2180
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:252
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:79
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:247
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:396
msgid "用戶"
msgstr "用戶"

#. placeholder {0}: account.id
#: apps/dp-business/src/pages/UserManagement/index.tsx:360
msgid "用戶 {0}"
msgstr "用戶 {0}"

#: apps/dp-business/src/pages/UserManagement/index.tsx:325
msgid "用戶 {userId}"
msgstr "用戶 {userId}"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/MemberPreviewPanel/index.web.tsx:68
msgid "用戶 ID"
msgstr "用戶 ID"

#: apps/dp-admin/src/pages/marketing/services/groupImportConstants.ts:13
msgid "用戶 user ID"
msgstr "用戶 user ID"

#. placeholder {0}: userIdInput.trim()
#. placeholder {0}: index + 3
#. placeholder {0}: userId.slice(-4)
#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:181
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:123
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:126
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/hooks.ts:226
msgid "用戶{0}"
msgstr "用戶{0}"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:326
msgid "用戶{index}"
msgstr "用戶{index}"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1083
msgid "用戶「去哪吃」APP 的帳戶手機號碼或電子信箱或平台 ID"
msgstr "用戶「去哪吃」APP 的帳戶手機號碼或電子信箱或平台 ID"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:989
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:223
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1798
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:246
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:267
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:223
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:100
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:64
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:432
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:46
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:27
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:108
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:26
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:40
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:39
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:51
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:86
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:36
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:27
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:128
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:72
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/UserInfoCard/index.web.tsx:36
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:53
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:188
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/columns/index.web.tsx:20
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:115
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:170
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:301
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:624
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:445
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:296
#: apps/dp-admin/src/pages/customer-service/components/TicketTable.web.tsx:38
msgid "用戶ID"
msgstr "用戶ID"

#. placeholder {0}: detail.displayUid || detail.userId
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/BasicInfoCard.web.tsx:55
msgid "用戶ID : {0}"
msgstr "用戶ID : {0}"

#. placeholder {0}: customerUserInfo.displayUid
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:46
msgid "用戶ID：{0}"
msgstr "用戶ID：{0}"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:96
msgid "用戶UID"
msgstr "用戶UID"

#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:427
msgid "用戶上傳"
msgstr "用戶上傳"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:911
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:354
msgid "用戶下單時間"
msgstr "用戶下單時間"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:137
#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:114
#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:222
#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:317
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:355
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:242
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:264
#: apps/dp-client/src/screens/account/pages/order/index.tsx:218
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:161
msgid "用戶主動取消"
msgstr "用戶主動取消"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1209
#: apps/dp-business/src/pages/OrderOverview/index.tsx:2012
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1048
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:296
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:174
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:494
msgid "用戶備註"
msgstr "用戶備註"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConsumeConfigEditor/index.web.tsx:38
msgid "用戶兌換後實際獲得的權益"
msgstr "用戶兌換後實際獲得的權益"

#: apps/dp-admin/src/router/config/routes.web.tsx:565
#: apps/dp-admin/src/pages/user-info/user-list/index.web.tsx:154
#: apps/dp-admin/src/pages/user-info/user-list/index.web.tsx:162
#: apps/dp-admin/src/components/DataTable/index.web.tsx:67
msgid "用戶列表"
msgstr "用戶列表"

#: apps/dp-business/src/pages/UserManagement/index.tsx:345
#: apps/dp-business/src/pages/UserManagement/index.tsx:350
msgid "用戶刪除失敗"
msgstr "用戶刪除失敗"

#: apps/dp-business/src/pages/UserManagement/index.tsx:340
msgid "用戶刪除成功"
msgstr "用戶刪除成功"

#: apps/dp-admin/src/router/config/routes.web.tsx:573
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:420
msgid "用戶券包管理"
msgstr "用戶券包管理"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:133
msgid "用戶參與資訊"
msgstr "用戶參與資訊"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:66
msgid "用戶反饋"
msgstr "用戶反饋"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1567
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1642
msgid "用戶取消率"
msgstr "用戶取消率"

#: apps/dp-business/src/pages/RefundList/index.tsx:92
msgid "用戶取消訂單"
msgstr "用戶取消訂單"

#: apps/dp-business/src/components/PhotoUploader/upload.ts:317
#: apps/dp-business/src/components/PhotoUploader/upload.ts:391
#: apps/dp-business/src/components/PhotoUploader/upload.ts:436
msgid "用戶取消選擇"
msgstr "用戶取消選擇"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:240
msgid "用戶可使用日期"
msgstr "用戶可使用日期"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:111
msgid "用戶可用條件"
msgstr "用戶可用條件"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:110
#: apps/dp-admin/src/pages/login/components/LoginForm/index.web.tsx:51
msgid "用戶名"
msgstr "用戶名"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:113
msgid "用戶名不超過 30 字"
msgstr "用戶名不超過 30 字"

#: apps/dp-admin/src/router/config/routes.web.tsx:151
#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:161
#: apps/dp-admin/src/pages/marketing/user-group-create/components/CombinedListForm/index.web.tsx:30
#: apps/dp-admin/src/pages/marketing/user-group-create/components/CombinedListForm/index.web.tsx:31
#: apps/dp-admin/src/pages/marketing/services/constants.ts:226
#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:628
#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:718
#: apps/dp-admin/src/modules/constants/userGroup.ts:159
msgid "用戶名單"
msgstr "用戶名單"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:48
msgid "用戶名單ID"
msgstr "用戶名單ID"

#: apps/dp-admin/src/pages/marketing/services/groupImportConstants.ts:19
msgid "用戶名單上傳範本_FetUID.xlsx"
msgstr "用戶名單上傳範本_FetUID.xlsx"

#: apps/dp-admin/src/pages/marketing/services/groupImportConstants.ts:9
msgid "用戶名單上傳範本_手機號碼.xlsx"
msgstr "用戶名單上傳範本_手機號碼.xlsx"

#: apps/dp-admin/src/pages/marketing/services/groupImportConstants.ts:14
msgid "用戶名單上傳範本_用戶ID.xlsx"
msgstr "用戶名單上傳範本_用戶ID.xlsx"

#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:192
msgid "用戶名單列表"
msgstr "用戶名單列表"

#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:637
#: apps/dp-admin/src/components/UserFilterSection/components/UserGroupSelect.web.tsx:164
msgid "用戶名單加載失敗"
msgstr "用戶名單加載失敗"

#: apps/dp-admin/src/pages/marketing/user-group-detail/components/BasicInfoTab/index.web.tsx:51
#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:88
msgid "用戶名單名稱"
msgstr "用戶名單名稱"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:485
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepUserGroup.web.tsx:30
msgid "用戶名單圈選"
msgstr "用戶名單圈選"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:180
msgid "用戶名單已建立，匯入任務執行中"
msgstr "用戶名單已建立，匯入任務執行中"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:100
msgid "用戶名單描述"
msgstr "用戶名單描述"

#: apps/dp-admin/src/router/config/routes.web.tsx:167
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:472
#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:347
msgid "用戶名單詳情"
msgstr "用戶名單詳情"

#: apps/dp-admin/src/components/UserFilterSection/index.web.tsx:26
msgid "用戶名單選擇"
msgstr "用戶名單選擇"

#: apps/dp-business/src/pages/SimpleDashboard/components/RedeemCard.tsx:193
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1797
#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:511
msgid "用戶名稱"
msgstr "用戶名稱"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:223
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:168
msgid "用戶圈選"
msgstr "用戶圈選"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:298
msgid "用戶定向"
msgstr "用戶定向"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:142
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/index.tsx:148
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/columns.tsx:75
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1731
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:94
msgid "用戶實付"
msgstr "用戶實付"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/IncomeCalculationSection.tsx:156
msgid "用戶實付金額"
msgstr "用戶實付金額"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:41
msgid "用戶實際付款金額"
msgstr "用戶實際付款金額"

#: apps/dp-admin/src/pages/report-center/audit-data/components/AuditTable.web.tsx:28
msgid "用戶工單提交人"
msgstr "用戶工單提交人"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:379
msgid "用戶已支付未退款的金額總額"
msgstr "用戶已支付未退款的金額總額"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:67
#: apps/dp-admin/src/pages/customer-service/services/constants.ts:13
msgid "用戶已解決"
msgstr "用戶已解決"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1154
msgid "用戶帳號資訊"
msgstr "用戶帳號資訊"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/OverviewCards.web.tsx:32
msgid "用戶平均評價"
msgstr "用戶平均評價"

#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantBasicInfo/index.web.tsx:56
msgid "用戶建立商家，需要核實真實性"
msgstr "用戶建立商家，需要核實真實性"

#: apps/dp-business/src/store/NotificationContext.tsx:898
msgid "用戶手動標記為已讀"
msgstr "用戶手動標記為已讀"

#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:59
msgid "用戶手機"
msgstr "用戶手機"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:296
#: apps/dp-admin/src/pages/order/order-detail/components/UserInfo/index.web.tsx:42
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:134
msgid "用戶手機號"
msgstr "用戶手機號"

#: apps/dp-business/src/pages/RefundList/index.tsx:234
#: apps/dp-business/src/pages/RefundList/index.tsx:382
#: apps/dp-business/src/pages/CouponVerification/index.tsx:622
msgid "用戶手機門號"
msgstr "用戶手機門號"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:448
msgid "用戶指路-公交指引"
msgstr "用戶指路-公交指引"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:449
msgid "用戶指路-捷運指引"
msgstr "用戶指路-捷運指引"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:450
msgid "用戶指路-駕車指引"
msgstr "用戶指路-駕車指引"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/MerchantBasicInfo/index.web.tsx:70
msgid "用戶提交的商家資訊圖片，請逐別審核屏蔽、模糊圖、網絡圖"
msgstr "用戶提交的商家資訊圖片，請逐別審核屏蔽、模糊圖、網絡圖"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:155
msgid "用戶提問詳情"
msgstr "用戶提問詳情"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:74
msgid "用戶數"
msgstr "用戶數"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:222
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:463
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:181
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:56
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:187
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/columns/index.web.tsx:29
#: apps/dp-admin/src/pages/marketing/user-group-create/components/MemberPreviewPanel/index.web.tsx:74
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:197
msgid "用戶暱稱"
msgstr "用戶暱稱"

#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:188
#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantImages/index.web.tsx:213
msgid "用戶暱稱："
msgstr "用戶暱稱："

#. placeholder {0}: originalReview.reviewer
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/OriginalReviewSection/index.web.tsx:117
msgid "用戶暱稱：{0}"
msgstr "用戶暱稱：{0}"

#: apps/dp-business/src/pages/OrderList/index.tsx:465
#: apps/dp-business/src/pages/CouponVerification/index.tsx:606
msgid "用戶暱稱和ID"
msgstr "用戶暱稱和ID"

#: apps/dp-admin/src/pages/customer-service/services/constants.ts:12
msgid "用戶未解決"
msgstr "用戶未解決"

#: apps/dp-client/src/screens/diary/pages/my/pages/terms/index.tsx:37
#: apps/dp-client/src/screens/diary/pages/my/components/UserProfileSection.tsx:120
msgid "用戶條款"
msgstr "用戶條款"

#: apps/dp-business/src/servers/notification/api.ts:155
msgid "用戶標記{businessModule}所有通知為已讀"
msgstr "用戶標記{businessModule}所有通知為已讀"

#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:438
msgid "用戶權益"
msgstr "用戶權益"

#: apps/dp-admin/src/router/config/routes.web.tsx:143
#: apps/dp-admin/src/pages/marketing/user-activities/index.web.tsx:187
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:337
msgid "用戶活動"
msgstr "用戶活動"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:385
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:512
#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:507
#: apps/dp-admin/src/pages/marketing/general-activity-detail/index.web.tsx:83
msgid "用戶活動明細"
msgstr "用戶活動明細"

#: apps/dp-admin/src/router/config/routes.web.tsx:652
msgid "用戶消息編輯"
msgstr "用戶消息編輯"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:660
#: apps/dp-admin/src/pages/order/services/utils.ts:399
msgid "用戶發起"
msgstr "用戶發起"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:89
msgid "用戶端"
msgstr "用戶端"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:468
#: apps/dp-business/src/pages/ImageManagement/index.tsx:484
msgid "用戶端APP示例圖"
msgstr "用戶端APP示例圖"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:76
msgid "用戶端已有的套餐專區頁面（Home/PackageZone），進入後展示圈選店家下的上架套餐；此選項免落地頁配置。"
msgstr "用戶端已有的套餐專區頁面（Home/PackageZone），進入後展示圈選店家下的上架套餐；此選項免落地頁配置。"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:694
msgid "用戶端預覽"
msgstr "用戶端預覽"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2434
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2497
msgid "用戶端預覽圖"
msgstr "用戶端預覽圖"

#: apps/dp-admin/src/router/config/routes.web.tsx:477
msgid "用戶管理"
msgstr "用戶管理"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:44
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:62
msgid "用戶篩選"
msgstr "用戶篩選"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1940
msgid "用戶編號"
msgstr "用戶編號"

#: apps/dp-business/src/pages/OrderList/index.tsx:477
msgid "用戶聯繫方式"
msgstr "用戶聯繫方式"

#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:50
msgid "用戶自主QA單 (未人工介入)"
msgstr "用戶自主QA單 (未人工介入)"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:37
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2512
#: apps/dp-admin/src/pages/order/services/utils.ts:502
#: apps/dp-admin/src/pages/order/services/utils.ts:551
msgid "用戶自主核銷"
msgstr "用戶自主核銷"

#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:260
msgid "用戶行動電話"
msgstr "用戶行動電話"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/index.web.tsx:81
msgid "用戶行為數據"
msgstr "用戶行為數據"

#: apps/dp-admin/src/pages/report-center/user-registration-data/index.web.tsx:79
msgid "用戶註冊數據"
msgstr "用戶註冊數據"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/index.web.tsx:143
msgid "用戶評論"
msgstr "用戶評論"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:278
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:92
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:548
msgid "用戶評論是否可選"
msgstr "用戶評論是否可選"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:634
#: apps/dp-admin/src/pages/user-info/user-detail/index.web.tsx:121
msgid "用戶詳情"
msgstr "用戶詳情"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:221
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/columns.tsx:61
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/components/VerificationFilterBar.tsx:66
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:68
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesFilterBar.tsx:72
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/columns.tsx:60
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/components/DiscountFilterBar.tsx:61
#: apps/dp-business/src/pages/OrderDetail/index.tsx:787
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1121
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1796
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1939
#: apps/dp-admin/src/router/config/routes.web.tsx:557
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:628
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:52
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/UserInfoCard/index.web.tsx:23
#: apps/dp-admin/src/pages/order/order-detail/components/UserInfo/index.web.tsx:26
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:77
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:185
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:65
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:121
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:286
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:49
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:186
msgid "用戶資訊"
msgstr "用戶資訊"

#: apps/dp-business/src/pages/MenuManagement.tsx:395
msgid "用戶資訊取得失敗"
msgstr "用戶資訊取得失敗"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:488
msgid "用戶資訊取得失敗，請重新登入"
msgstr "用戶資訊取得失敗，請重新登入"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:319
#: apps/dp-admin/src/pages/audit-center/user-audit/index.web.tsx:64
msgid "用戶資訊審核"
msgstr "用戶資訊審核"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:466
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:177
msgid "用戶購買限制"
msgstr "用戶購買限制"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:150
msgid "用戶購買限制不能大於總庫存"
msgstr "用戶購買限制不能大於總庫存"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:191
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:308
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:78
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:267
msgid "用戶郵箱"
msgstr "用戶郵箱"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:127
msgid "用戶領取"
msgstr "用戶領取"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:321
msgid "用戶領取條件"
msgstr "用戶領取條件"

#: apps/dp-client/src/screens/diary/pages/rank/components/rank-item.tsx:84
#: apps/dp-client/src/screens/diary/pages/rank/components/rank-item-nocoin.tsx:95
#: apps/dp-client/src/screens/diary/pages/my/components/UserProfileSection.tsx:86
#: apps/dp-client/src/screens/account/pages/user-profile/components/UserInfoSection/index.tsx:90
#: apps/dp-client/src/screens/account/pages/profile/components/UserInfoSection/index.tsx:59
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:661
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserInfoCard/index.web.tsx:56
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/UserInfoCard/index.web.tsx:30
#: apps/dp-admin/src/pages/audit-center/user-audit/components/UserBasicInfo/index.web.tsx:85
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:190
#: apps/dp-admin/src/components/layout/components/header/index.web.tsx:99
msgid "用戶頭像"
msgstr "用戶頭像"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:214
msgid "用於處理生產搜索 ES 數據異常。請先選擇處理類型，再填寫對應參數後執行。"
msgstr "用於處理生產搜索 ES 數據異常。請先選擇處理類型，再填寫對應參數後執行。"

#: apps/dp-business/src/pages/MenuManagement.tsx:145
#: apps/dp-business/src/pages/MenuItemForm.tsx:56
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:62
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:62
msgid "用於補齊初期用戶行為缺失的替代標籤"
msgstr "用於補齊初期用戶行為缺失的替代標籤"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:889
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:938
msgid "用逗點隔開：A, B"
msgstr "用逗點隔開：A, B"

#: apps/dp-client/src/screens/reservation/pages/main/components/EditView.tsx:115
#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:114
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:108
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:109
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:172
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:181
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:788
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:358
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:261
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:139
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:282
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:146
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:220
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:460
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:176
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:245
msgid "用餐人數"
msgstr "用餐人數"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1076
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:382
msgid "用餐人數：{diningPeople}"
msgstr "用餐人數：{diningPeople}"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:243
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:272
msgid "用餐人數：{diningPeopleText}"
msgstr "用餐人數：{diningPeopleText}"

#: apps/dp-client/src/screens/reservation/pages/main/components/BottomBar.tsx:72
msgid "用餐人數：{peopleCount}人"
msgstr "用餐人數：{peopleCount}人"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:465
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:575
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:625
msgid "用餐人數不能超過{maxCapacity}人"
msgstr "用餐人數不能超過{maxCapacity}人"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:253
msgid "用餐人數必須為 1-30 的整數"
msgstr "用餐人數必須為 1-30 的整數"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:419
#: apps/dp-client/src/screens/reservation/pages/main/components/TimeModal.tsx:144
msgid "用餐前"
msgstr "用餐前"

#: apps/dp-client/src/screens/reservation/pages/main/components/EditView.tsx:227
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:1014
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:732
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:707
#: apps/dp-business/src/pages/OrderOverview/Detail/components/ReservationSlots.tsx:50
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/components/ReservationSlots.web.tsx:64
msgid "用餐日期"
msgstr "用餐日期"

#: apps/dp-client/src/screens/reservation/pages/main/components/EditView.tsx:235
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:754
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:713
#: apps/dp-business/src/pages/OrderOverview/Detail/components/ReservationSlots.tsx:54
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/components/ReservationSlots.web.tsx:75
msgid "用餐時段"
msgstr "用餐時段"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:721
msgid "用餐時間"
msgstr "用餐時間"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:688
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ReviewGuide.tsx:80
msgid "用餐體驗如何？"
msgstr "用餐體驗如何？"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:51
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:430
msgid "由商家自行開立發票給客戶"
msgstr "由商家自行開立發票給客戶"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:56
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:435
msgid "由商家開立收據給客戶"
msgstr "由商家開立收據給客戶"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/ReviewHeader.web.tsx:91
msgid "由於評論數量較少，展示Google Maps評分"
msgstr "由於評論數量較少，展示Google Maps評分"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/ContractSettings/index.web.tsx:70
msgid "由於選擇了免開發票商家,需上傳核定稅籍通知書"
msgstr "由於選擇了免開發票商家,需上傳核定稅籍通知書"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/AppealInfoSection/index.web.tsx:59
msgid "申訴資訊"
msgstr "申訴資訊"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1283
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1295
msgid "申請上架"
msgstr "申請上架"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:65
msgid "申請人"
msgstr "申請人"

#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:329
msgid "申請人 ID"
msgstr "申請人 ID"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:237
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:125
msgid "申請原因"
msgstr "申請原因"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:240
msgid "申請原因不超過 500 字"
msgstr "申請原因不超過 500 字"

#: apps/dp-admin/src/pages/merchant/merchant-account/services/hooks.ts:187
msgid "申請已取消"
msgstr "申請已取消"

#: apps/dp-admin/src/pages/merchant/merchant-account/services/hooks.ts:244
msgid "申請已提交，已進入審核"
msgstr "申請已提交，已進入審核"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:99
msgid "申請時長（天）"
msgstr "申請時長（天）"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:60
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:152
msgid "申請時間"
msgstr "申請時間"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:98
msgid "申請臨時賬號"
msgstr "申請臨時賬號"

#: apps/dp-business/src/pages/AccountDeactivation/index.tsx:148
msgid "申請註銷"
msgstr "申請註銷"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:280
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:298
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:321
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:370
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:854
#: apps/dp-client/src/configs/page-configs.tsx:955
msgid "申請退款"
msgstr "申請退款"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1147
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1078
msgid "申領節點 ID 失敗，請稍後重試"
msgstr "申領節點 ID 失敗，請稍後重試"

#: apps/dp-client/src/screens/account/pages/edit-profile/components/GenderSelectModal/index.tsx:42
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:17
#: apps/dp-admin/src/pages/marketing/services/constants.ts:277
msgid "男"
msgstr "男"

#: apps/dp-client/src/screens/home/pages/Home/components/ReviewSection/index.tsx:52
msgid "留下了一個好評"
msgstr "留下了一個好評"

#: apps/dp-admin/src/pages/marketing/components/TaskSubmittedModal/index.web.tsx:67
msgid "留在當前頁面"
msgstr "留在當前頁面"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:76
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:77
msgid "留存狀態"
msgstr "留存狀態"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/OverviewCards.web.tsx:48
msgid "留存率"
msgstr "留存率"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/OverviewCards.web.tsx:67
msgid "留存率 (第30天)"
msgstr "留存率 (第30天)"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/OverviewCards.web.tsx:57
msgid "留存率 (第7天)"
msgstr "留存率 (第7天)"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:304
msgid "留空表示該一級不使用二級渠道"
msgstr "留空表示該一級不使用二級渠道"

#. placeholder {0}: noteDetail?.id
#. placeholder {1}: noteDetail?.title
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:422
msgid "留言_{0}_{1}"
msgstr "留言_{0}_{1}"

#: apps/dp-client/src/screens/account/pages/notifications/components/InteractionNotificationCard/index.tsx:64
msgid "留言了你的筆記"
msgstr "留言了你的筆記"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:642
msgid "留言失敗，請重試"
msgstr "留言失敗，請重試"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:637
msgid "留言成功"
msgstr "留言成功"

#: apps/dp-client/src/screens/login/pages/login/index.tsx:147
msgid "略過"
msgstr "略過"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:613
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:22
msgid "異常"
msgstr "異常"

#: apps/dp-admin/src/router/config/routes.web.tsx:772
#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:211
msgid "異常處理"
msgstr "異常處理"

#: apps/dp-admin/src/router/config/routes.web.tsx:727
msgid "異常訂單"
msgstr "異常訂單"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/index.web.tsx:74
msgid "異常訂單管理"
msgstr "異常訂單管理"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:743
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:180
msgid "異常訂單詳情"
msgstr "異常訂單詳情"

#: apps/dp-business/src/pages/CustomerReviews/components/QualityMonitoringSection.tsx:115
msgid "異常評價提醒"
msgstr "異常評價提醒"

#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:196
msgid "異步上傳提醒"
msgstr "異步上傳提醒"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:216
msgid "畫筆"
msgstr "畫筆"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:210
msgid "畫筆大小"
msgstr "畫筆大小"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:189
msgid "畫路"
msgstr "畫路"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:49
msgid "畫面不清，無法展現環境"
msgstr "畫面不清，無法展現環境"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:47
msgid "畫面混亂或模糊"
msgstr "畫面混亂或模糊"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:401
msgid "當前"
msgstr "當前"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:83
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeMountNodeModal.web.tsx:106
msgid "當前 · 可管理"
msgstr "當前 · 可管理"

#: apps/dp-business/src/utils/dateRange.ts:108
msgid "當前{unit}"
msgstr "當前{unit}"

#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:52
msgid "當前BD"
msgstr "當前BD"

#. placeholder {0}: formatEmpty(merchant.bdName)
#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:112
msgid "當前BD：{0}"
msgstr "當前BD：{0}"

#: apps/dp-client/src/components/Upload/index.tsx:257
msgid "當前不允許上傳文件"
msgstr "當前不允許上傳文件"

#: apps/dp-client/src/utils/fileFilter.ts:156
msgid "當前不支持該類型"
msgstr "當前不支持該類型"

#: apps/dp-client/src/screens/home/components/ShopFilter/components/CascaderFilterContent.tsx:142
#: apps/dp-client/src/screens/home/components/ShopFilter/components/CascaderFilterContent.tsx:162
msgid "當前位置"
msgstr "當前位置"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:290
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CurrentCommissionCard.web.tsx:27
msgid "當前佣金"
msgstr "當前佣金"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:171
msgid "當前佣金查詢失敗"
msgstr "當前佣金查詢失敗"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:201
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CurrentCommissionCard.web.tsx:71
msgid "當前佣金比例"
msgstr "當前佣金比例"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:297
msgid "當前優惠已全額抵扣訂單金額"
msgstr "當前優惠已全額抵扣訂單金額"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:113
msgid "當前兜底頁面不可用，請重新選擇"
msgstr "當前兜底頁面不可用，請重新選擇"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:752
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:787
msgid "當前內容無法展示"
msgstr "當前內容無法展示"

#. placeholder {0}: list.total
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/index.web.tsx:162
msgid "當前共 {0} 條，單次最多導出 {CHANNEL_EXPORT_LIMIT} 條，將按當前排序導出前 {CHANNEL_EXPORT_LIMIT} 條，建議縮小篩選範圍。"
msgstr "當前共 {0} 條，單次最多導出 {CHANNEL_EXPORT_LIMIT} 條，將按當前排序導出前 {CHANNEL_EXPORT_LIMIT} 條，建議縮小篩選範圍。"

#. placeholder {0}: couponGroup?.name || ''
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/AddStockModal.web.tsx:96
msgid "當前券組：{0}"
msgstr "當前券組：{0}"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:125
msgid "當前剩餘庫存"
msgstr "當前剩餘庫存"

#. placeholder {0}: filteredFoods.length
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1152
msgid "當前可選餐點數量: {0}"
msgstr "當前可選餐點數量: {0}"

#: apps/dp-admin/src/pages/org-tree/components/ReviewHistoryModal/index.web.tsx:117
msgid "當前單"
msgstr "當前單"

#: apps/dp-client/src/screens/home/pages/Meal/pages/shopSelect/index.tsx:318
msgid "當前城市沒有適用店家，已顯示全部適用店家"
msgstr "當前城市沒有適用店家，已顯示全部適用店家"

#: apps/dp-client/src/screens/home/components/CitySelect/CityModal.tsx:131
#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:265
msgid "當前定位"
msgstr "當前定位"

#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:326
msgid "當前定位未找到地址資訊"
msgstr "當前定位未找到地址資訊"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/FeedbackDetail.web.tsx:157
msgid "當前工單"
msgstr "當前工單"

#: apps/dp-client/src/utils/sso.ts:289
msgid "當前平台不支援原生功能"
msgstr "當前平台不支援原生功能"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:403
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/MemberPreviewPanel/index.web.tsx:64
msgid "當前店家"
msgstr "當前店家"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:363
msgid "當前店家暫無菜單分類，無法複製菜單內容"
msgstr "當前店家暫無菜單分類，無法複製菜單內容"

#. placeholder {0}: Number(couponGroup?.totalStock) === -1 ? '無限' : couponGroup?.totalStock || 0
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/AddStockModal.web.tsx:97
msgid "當前庫存：{0} 張"
msgstr "當前庫存：{0} 張"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/MemberPreviewPanel/index.web.tsx:110
msgid "當前成員"
msgstr "當前成員"

#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:132
msgid "當前成員數"
msgstr "當前成員數"

#. placeholder {0}: formatPhone(userProfile.phone)
#: apps/dp-business/src/pages/MyProfile/index.tsx:162
msgid "當前手機門號：{0}"
msgstr "當前手機門號：{0}"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:143
msgid "當前排名"
msgstr "當前排名"

#. placeholder {0}: attachment?.nodePathDisplay || '-'
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeMountNodeModal.web.tsx:158
msgid "當前掛接：{0}"
msgstr "當前掛接：{0}"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/columns.web.tsx:56
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/columns.web.tsx:25
msgid "當前掛接所屬節點"
msgstr "當前掛接所屬節點"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:164
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:124
msgid "當前掛接狀態"
msgstr "當前掛接狀態"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:363
msgid "當前時段的用餐訂單"
msgstr "當前時段的用餐訂單"

#. placeholder {0}: now.format('YYYY-MM-DD HH:mm:ss')
#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionSuccessContent/index.tsx:40
msgid "當前時間：{0}"
msgstr "當前時間：{0}"

#. placeholder {0}: totalProbability.toFixed(2)
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:555
msgid "當前概率總和：{0}%"
msgstr "當前機率總和：{0}%"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:178
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:162
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:140
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:155
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:274
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponStatusModal.web.tsx:87
msgid "當前狀態"
msgstr "當前狀態"

#. placeholder {0}: detail.statusDesc
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:196
msgid "當前狀態: {0}"
msgstr "當前狀態: {0}"

#: apps/dp-client/src/utils/fetnet.ts:34
msgid "當前環境不支持打開Webview"
msgstr "當前環境不支持打開Webview"

#: apps/dp-client/src/utils/fetnet.ts:50
msgid "當前環境不支持關閉Webview"
msgstr "當前環境不支持關閉Webview"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:492
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:883
msgid "當前生效"
msgstr "當前生效"

#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitSummaryCard.tsx:63
msgid "當前生效權益數"
msgstr "當前生效權益數"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1724
msgid "當前申請不可提交，請刷新後確認狀態"
msgstr "當前申請不可提交，請刷新後確認狀態"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1318
msgid "當前申請單不可提交審核，請確認申請狀態"
msgstr "當前申請單不可提交審核，請確認申請狀態"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:48
msgid "當前登錄縣市"
msgstr "當前登錄縣市"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:216
msgid "當前節點"
msgstr "當前節點"

#. placeholder {0}: getNodePath(nodeId) || detail.nodeName
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementPanel.tsx:65
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimPanel.tsx:62
msgid "當前節點：{0}"
msgstr "當前節點：{0}"

#: apps/dp-admin/src/pages/org-tree/org-create/components/MountPanel/index.web.tsx:112
msgid "當前節點：{path}"
msgstr "當前節點：{path}"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainNonSettlementState.tsx:48
msgid "當前節點「{nodeName}」未掛請款商家，不是結算節點。可查看數據報表，但不能核對結算單，也不能發起請款。請切換到上級結算節點，或聯繫運營為本節點掛載請款商家。"
msgstr "當前節點「{nodeName}」未掛請款商家，不是結算節點。可查看數據報表，但不能核對結算單，也不能發起請款。請切換到上級結算節點，或聯繫運營為本節點掛載請款商家。"

#: apps/dp-admin/src/pages/org-tree/org-create/components/UnsavedNodeModal/index.web.tsx:38
msgid "當前節點有未保存修改，是否保存？"
msgstr "當前節點有未保存修改，是否保存？"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:911
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:314
msgid "當前結算節點：{routeName}"
msgstr "當前結算節點：{routeName}"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:93
msgid "當前結算路徑"
msgstr "當前結算路徑"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:148
msgid "當前處理中工單數"
msgstr "當前處理中工單數"

#: apps/dp-admin/src/modules/hooks/useGeolocation.ts:130
msgid "當前設備不支持地理位置功能"
msgstr "當前設備不支持地理位置功能"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:185
msgid "當前距離店家較遠"
msgstr "當前距離店家較遠"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:242
msgid "當前跳轉目標不可用，請重新選擇"
msgstr "當前跳轉目標不可用，請重新選擇"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:174
msgid "當前選中的商家，存在正在審核中的商家入駐/簽約審核單，審核通過後會和現在的商家資訊有異動點，請謹慎選擇"
msgstr "當前選中的商家，存在正在審核中的商家入駐/簽約審核單，審核通過後會和現在的商家資訊有異動點，請謹慎選擇"

#. placeholder {0}: route.key
#: apps/dp-client/src/components/TabView/example.tsx:33
msgid "當前選中的標籤:{0}"
msgstr "當前選中的標籤:{0}"

#. placeholder {0}: formatEmail(userProfile.email)
#: apps/dp-business/src/pages/MyProfile/index.tsx:176
msgid "當前郵箱：{0}"
msgstr "當前郵箱：{0}"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:123
msgid "當前頁暫無數據可匯出"
msgstr "當前頁暫無數據可匯出"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:243
#: apps/dp-client/src/screens/reservation/pages/main/hooks/useReservation.ts:400
#: apps/dp-client/src/screens/reservation/pages/main/hooks/useReservation.ts:461
msgid "當天已超過可預訂次數"
msgstr "當天已超過可預訂次數"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:880
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:470
#: apps/dp-admin/src/components/BusinessHours/constants.ts:71
msgid "當日休息"
msgstr "當日休息"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:398
msgid "當有新消息時，會在這裡顯示"
msgstr "當有新消息時，會在這裡顯示"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:344
msgid "當期積分競賽結算後"
msgstr "當期積分競賽結算後"

#: apps/dp-client/src/screens/diary/pages/rank/index.tsx:425
msgid "當積分相同時，依照達標時間順序來排名次"
msgstr "當積分相同時，依照達標時間順序來排名次"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:355
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:87
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:84
msgid "疊加規則"
msgstr "疊加規則"

#: apps/dp-admin/src/pages/audit-center/user-audit/services/hooks.ts:114
msgid "疑似虛假使用者"
msgstr "疑似虛假使用者"

#: apps/dp-client/src/screens/account/components/feedback-modal/index.tsx:97
#: apps/dp-client/src/components/FeedBackModal/index.tsx:120
msgid "疑問回報"
msgstr "疑問回報"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:303
#: apps/dp-client/src/components/GuestLoginPop/index.tsx:44
#: apps/dp-business/src/pages/Login/index.tsx:1126
#: apps/dp-business/src/pages/Login/index.tsx:1230
#: apps/dp-business/src/pages/Login/index.tsx:1601
#: apps/dp-business/src/pages/Login/index.tsx:1703
#: apps/dp-business/src/components/CodeVerification/index.tsx:99
msgid "登入"
msgstr "登入"

#: apps/dp-client/src/screens/login/pages/verify-login-code/index.tsx:80
#: apps/dp-client/src/screens/login/pages/login/index.tsx:276
#: apps/dp-business/src/pages/Login/Email/index.tsx:194
msgid "登入中..."
msgstr "登入中..."

#: apps/dp-client/src/screens/login/components/privacy-agreement/index.tsx:71
msgid "登入即代表您已同意"
msgstr "登入即代表您已同意"

#: apps/dp-client/src/screens/login/pages/account-info/index.tsx:67
#: apps/dp-business/src/services/auth.ts:170
#: apps/dp-admin/src/pages/login/services/api.ts:103
msgid "登入失敗"
msgstr "登入失敗"

#: apps/dp-client/src/screens/login/api/index.ts:232
msgid "登入失敗，用戶ID不存在"
msgstr "登入失敗，用戶ID不存在"

#: apps/dp-business/src/pages/Login/index.tsx:661
#: apps/dp-business/src/pages/Login/index.tsx:668
#: apps/dp-business/src/pages/Login/index.tsx:669
#: apps/dp-business/src/pages/Login/Email/index.tsx:172
#: apps/dp-business/src/pages/Login/Email/index.tsx:178
#: apps/dp-business/src/pages/Login/Email/index.tsx:179
msgid "登入失敗，請檢查Email和驗證碼"
msgstr "登入失敗，請檢查Email和驗證碼"

#: apps/dp-business/src/servers/auth/api.ts:382
#: apps/dp-business/src/pages/Login/index.tsx:487
#: apps/dp-business/src/pages/Login/index.tsx:801
msgid "登入失敗，請檢查帳號和密碼"
msgstr "登入失敗，請檢查帳號和密碼"

#: apps/dp-admin/src/pages/login/services/hooks.ts:92
msgid "登入失敗，請檢查用戶名和密碼"
msgstr "登入失敗，請檢查用戶名和密碼"

#: apps/dp-client/src/screens/login/pages/password-login/index.tsx:124
#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:262
#: apps/dp-client/src/screens/login/components/fet-login-modal/index.tsx:97
msgid "登入失敗，請稍後重試"
msgstr "登入失敗，請稍後重試"

#: apps/dp-business/src/pages/Login/index.tsx:493
#: apps/dp-business/src/pages/Login/index.tsx:807
msgid "登入失敗，請重試"
msgstr "登入失敗，請重試"

#: apps/dp-business/src/pages/Unauthorized/index.tsx:92
msgid "登入已過期"
msgstr "登入已過期"

#: apps/dp-client/src/store/userStore.ts:232
#: apps/dp-business/src/App.web.tsx:184
#: apps/dp-admin/src/modules/http/request.ts:328
msgid "登入已過期，請重新登入"
msgstr "資訊已過期，請重新登入"

#: apps/dp-business/src/components/ForgotPassword/index.tsx:428
msgid "登入帳號"
msgstr "登入帳號"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:294
msgid "登入後查看更多評論"
msgstr "登入後查看更多評論"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopLocationInfo.tsx:321
msgid "登入後查看營業時間"
msgstr "登入後查看營業時間"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopBasicInfo.tsx:124
msgid "登入後查看評分"
msgstr "登入後查看評分"

#: apps/dp-client/src/screens/login/pages/third-party-login/index.tsx:77
#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:233
#: apps/dp-client/src/screens/login/components/fet-login-modal/index.tsx:93
#: apps/dp-client/src/screens/login/api/index.ts:264
#: apps/dp-business/src/pages/Login/index.tsx:483
#: apps/dp-business/src/pages/Login/index.tsx:798
msgid "登入成功"
msgstr "登入成功"

#: apps/dp-client/src/screens/login/pages/login/components/login-form/index.tsx:68
msgid "登入或註冊"
msgstr "登入或註冊"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:80
msgid "登入次數"
msgstr "登入次數"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:173
msgid "登入異常"
msgstr "登入異常"

#: apps/dp-client/src/screens/login/hooks/use-unified-login.ts:79
#: apps/dp-client/src/screens/login/hooks/use-unified-login.ts:124
msgid "登入請求正在處理，請稍候再試"
msgstr "登入請求正在處理，請稍候再試"

#: apps/dp-admin/src/pages/login/services/hooks.ts:99
msgid "登入過程中發生錯誤"
msgstr "登入過程中發生錯誤"

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:270
#: apps/dp-business/src/pages/MyProfile/index.tsx:307
msgid "登出"
msgstr "登出"

#: apps/dp-business/src/pages/MyProfile/index.tsx:136
msgid "登出失敗，請重試"
msgstr "登出失敗，請重試"

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:66
#: apps/dp-business/src/pages/MyProfile/index.tsx:127
msgid "登出成功"
msgstr "登出成功"

#: apps/dp-client/src/configs/page-configs.tsx:1222
#: apps/dp-admin/src/router/config/baseRoutes.ts:15
#: apps/dp-admin/src/pages/login/components/LoginForm/index.web.tsx:107
msgid "登錄"
msgstr "登錄"

#. placeholder {0}: urlParams.get('error') || t`未知錯誤`
#: apps/dp-client/src/screens/login/pages/third-party-login/index.tsx:89
msgid "登錄失敗: {0}"
msgstr "登錄失敗: {0}"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:121
msgid "登錄密碼"
msgstr "登錄密碼"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteFormFooter.tsx:35
msgid "發佈"
msgstr "發佈"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/components/NoteFormFooter.tsx:35
msgid "發佈中..."
msgstr "發佈中..."

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:282
msgid "發佈店家資訊失敗，請稍後重試"
msgstr "發佈店家資訊失敗，請稍後重試"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:995
msgid "發佈後將無法編輯查看"
msgstr "發佈後將無法編輯查看"

#: apps/dp-client/src/screens/home/pages/Note/components/NoteSucessToast/index.tsx:65
#: apps/dp-client/src/screens/home/pages/Home/components/NotePublishTip/index.tsx:81
msgid "發佈成功"
msgstr "發佈成功"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2151
msgid "發佈成功！"
msgstr "發佈成功！"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:757
#: apps/dp-client/src/screens/diary/pages/detail/components/InteractionBar.tsx:49
msgid "發佈成功後可開始留言"
msgstr "發佈成功後可開始留言"

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/components/ReviewRewardCard.tsx:30
#: apps/dp-client/src/screens/home/pages/Note/components/NoteSucessToast/index.tsx:79
msgid "發佈成功後將獲得"
msgstr "發佈成功後將獲得"

#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:258
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:353
msgid "發佈日記失敗，請稍後重試"
msgstr "發佈日記失敗，請稍後重試"

#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:35
#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:113
msgid "發佈時間"
msgstr "發佈時間"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:118
msgid "發佈時間："
msgstr "發佈時間："

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:141
msgid "發佈筆記數"
msgstr "發佈筆記數"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:157
msgid "發佈筆記數（特定商家）"
msgstr "發佈筆記數（特定商家）"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:136
msgid "發佈評價數"
msgstr "發佈評價數"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:152
msgid "發佈評價數（特定商家）"
msgstr "發佈評價數（特定商家）"

#: apps/dp-business/src/pages/AddUser/index.tsx:185
msgid "發出邀請"
msgstr "發出邀請"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:264
msgid "發布"
msgstr "發布"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:189
msgid "發布・圖文筆記的商家歸屬以「發布來源入口」判定：僅當用戶從所選商家組內商家的詳情頁發起發布時計入；從其他入口（如個人主頁「＋」）發布的筆記不計入，且不另做提示。商家組只作用於發布瞬間的來源，不會綁定筆記內容。"
msgstr "發布・圖文筆記的商家歸屬以「發布來源入口」判定：僅當用戶從所選商家組內商家的詳情頁發起發布時計入；從其他入口（如個人主頁「＋」）發布的筆記不計入，且不另做提示。商家組只作用於發布瞬間的來源，不會綁定筆記內容。"

#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:370
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2158
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2164
msgid "發布失敗，請重試"
msgstr "發布失敗，請重新嘗試"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:113
msgid "發布排行榜"
msgstr "發布排行榜"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/apis.ts:230
msgid "發布排行榜失敗"
msgstr "發布排行榜失敗"

#: apps/dp-client/src/screens/diary/pages/my/components/UserProfileSection.tsx:178
msgid "發布筆記"
msgstr "發布筆記"

#: apps/dp-client/src/screens/account/pages/follow-list/hooks/useFollowListData.ts:55
msgid "發布筆記可以吸引更多朋友喔"
msgstr "發布筆記可以吸引更多朋友喔"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:351
msgid "發布筆記頁"
msgstr "發布筆記頁"

#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewHeader.tsx:31
msgid "發布規則"
msgstr "發布規則"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:226
msgid "發放份數必須為大於 0 的整數"
msgstr "發放份數必須為大於 0 的整數"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:151
msgid "發放判定"
msgstr "發放判定"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:100
msgid "發放到帳時間"
msgstr "發放到帳時間"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:111
msgid "發放券碼"
msgstr "發放券碼"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:54
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:66
msgid "發放失敗"
msgstr "發放失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:53
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:65
msgid "發放成功"
msgstr "發放成功"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:174
msgid "發放成功通知用戶"
msgstr "發放成功通知用戶"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:523
msgid "發放數量"
msgstr "發放數量"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:346
msgid "發放數量必須大於0"
msgstr "發放數量必須大於0"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:289
msgid "發放方式"
msgstr "發放方式"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:412
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:783
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:477
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:264
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:262
msgid "發放時間"
msgstr "發放時間"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:185
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:144
msgid "發放有效期"
msgstr "發放有效期"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:155
msgid "發放次數"
msgstr "發放次數"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:124
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:244
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:434
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:94
msgid "發放狀態"
msgstr "發放狀態"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:27
msgid "發放獎勵和獎勵機制"
msgstr "發放獎勵和獎勵機制"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:284
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:82
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:454
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:294
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:79
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:594
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:62
msgid "發放設定"
msgstr "發放設定"

#: apps/dp-admin/src/components/ClientVersionDropdown/index.web.tsx:129
msgid "發版內容"
msgstr "發版內容"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:408
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:556
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:597
#: apps/dp-admin/src/components/ClientVersionDropdown/index.web.tsx:127
msgid "發版時間"
msgstr "發版時間"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:235
msgid "發獎狀態"
msgstr "發獎狀態"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:292
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:150
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:326
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:251
msgid "發生時間"
msgstr "發生時間"

#: apps/dp-client/src/configs/page-configs.tsx:2380
#: apps/dp-client/src/configs/page-configs.tsx:2382
msgid "發票"
msgstr "發票"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:133
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:31
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:124
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:130
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:148
msgid "發票 ID"
msgstr "發票 ID"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:159
msgid "發票 ID 不存在"
msgstr "發票 ID 不存在"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/InvoiceInfoCard/index.web.tsx:43
msgid "發票ID"
msgstr "發票ID"

#: apps/dp-admin/src/router/config/routes.web.tsx:545
#: apps/dp-admin/src/pages/split-account/invoice-list/index.web.tsx:48
msgid "發票列表"
msgstr "發票列表"

#: apps/dp-admin/src/router/config/routes.web.tsx:396
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:213
msgid "發票審核"
msgstr "發票審核"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/services/hooks.ts:173
msgid "發票審核任務完成"
msgstr "發票審核任務完成"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:333
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:297
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:307
msgid "發票審核詳情"
msgstr "發票審核詳情"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:73
msgid "發票抬頭"
msgstr "發票抬頭"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:327
msgid "發票抬頭：聚流平台科技股份有限公司"
msgstr "發票抬頭：聚流平台科技股份有限公司"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:551
msgid "發票抬頭建立成功"
msgstr "發票抬頭建立成功"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:336
msgid "發票抬頭資訊"
msgstr "發票抬頭資訊"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:530
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:177
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:435
msgid "發票日期"
msgstr "發票日期"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:230
msgid "發票日期："
msgstr "發票日期："

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:349
msgid "發票明細"
msgstr "發票明細"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:276
msgid "發票時間"
msgstr "發票時間"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:139
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:55
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:190
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:137
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/InvoiceInfoCard/index.web.tsx:55
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:163
msgid "發票狀態"
msgstr "發票狀態"

#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:114
#: apps/dp-admin/src/pages/split-account/invoice-list/index.web.tsx:41
msgid "發票管理"
msgstr "發票管理"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:26
msgid "發票處理失敗"
msgstr "發票處理失敗"

#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:151
msgid "發票號"
msgstr "發票號"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:258
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:529
#: apps/dp-business/src/components/InvoiceForm/index.tsx:549
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:135
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:79
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:148
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:131
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:452
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/InvoiceInfoCard/index.web.tsx:46
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:153
msgid "發票號碼"
msgstr "發票號碼"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:234
msgid "發票號碼："
msgstr "發票號碼："

#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:228
msgid "發票號碼修改成功"
msgstr "發票號碼修改成功"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:159
msgid "發票號碼格式不正確，應為前 2 位英文字母 + 後 8 位數字"
msgstr "發票號碼格式不正確，應為前 2 位英文字母 + 後 8 位數字"

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:178
#: apps/dp-client/src/screens/account/pages/settings/index.tsx:194
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:593
#: apps/dp-client/src/configs/page-configs.tsx:2401
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:931
msgid "發票設定"
msgstr "發票設定"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:213
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:619
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:257
msgid "發票詳情"
msgstr "發票詳情"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:437
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:522
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:142
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/InvoiceInfoCard/index.web.tsx:41
msgid "發票資訊"
msgstr "發票資訊"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:61
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:106
msgid "發票資訊不完整"
msgstr "發票資訊不完整"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:547
#: apps/dp-business/src/components/InvoiceForm/index.tsx:208
#: apps/dp-business/src/components/InvoiceForm/index.tsx:253
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:138
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:178
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:191
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:447
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/InvoiceInfoCard/index.web.tsx:65
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:182
msgid "發票金額"
msgstr "發票金額"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:187
msgid "發票開立錯誤"
msgstr "發票開立錯誤"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:658
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:538
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:140
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:64
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:204
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:150
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:432
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/InvoiceInfoCard/index.web.tsx:60
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:158
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:324
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:281
msgid "發票類型"
msgstr "發票類型"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:244
msgid "發行總量"
msgstr "發行總量"

#: apps/dp-client/src/screens/diary/components/diary-entry/index.tsx:85
msgid "發表"
msgstr "發表"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:619
msgid "發證地不能超過20個字符"
msgstr "發證地不能超過20個字符"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:342
msgid "發起入駐失敗"
msgstr "發起入駐失敗"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:565
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:770
msgid "發起店家綁定失敗"
msgstr "發起店家綁定失敗"

#: apps/dp-business/src/pages/RefundList/index.tsx:205
#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:103
msgid "發起時間"
msgstr "發起時間"

#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:58
#: apps/dp-admin/src/pages/merchant/service/constants.ts:232
msgid "發起申請"
msgstr "發起申請"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:715
msgid "發起申請失敗，請稍後重試"
msgstr "發起申請失敗，請稍後重試"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/index.web.tsx:257
msgid "發起綁定"
msgstr "發起綁定"

#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:186
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:208
msgid "發起者"
msgstr "發起者"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/MerchantComplaintSection/index.web.tsx:92
msgid "發起者："
msgstr "發起者："

#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:203
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:225
msgid "發起者UID"
msgstr "發起者UID"

#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:193
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:215
msgid "發起者類型"
msgstr "發起者類型"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:519
msgid "發起請款"
msgstr "發起請款"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:899
msgid "發起變更申請失敗，請稍後重試"
msgstr "發起變更申請失敗，請稍後重試"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:580
msgid "發起預訂即視為同意《去哪吃預訂條款》，並確認店家可通過上述手機號碼與您溝通預訂事宜"
msgstr "發起預訂即視為同意《去哪吃預訂條款》，並確認店家可通過上述手機號碼與您溝通預訂事宜"

#: apps/dp-client/src/screens/home/components/InputMaskOverlay/index.tsx:621
#: apps/dp-business/src/pages/ContactBD/index.tsx:98
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:292
msgid "發送"
msgstr "發送"

#: apps/dp-business/src/servers/verification/api.ts:78
#: apps/dp-business/src/servers/auth/api.ts:151
#: apps/dp-business/src/servers/auth/api.ts:350
msgid "發送信箱驗證碼失敗"
msgstr "發送信箱驗證碼失敗"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:331
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:113
msgid "發送對象"
msgstr "發送對象"

#: apps/dp-business/src/servers/auth/api.ts:86
#: apps/dp-business/src/servers/auth/api.ts:321
msgid "發送手機驗證碼失敗"
msgstr "發送手機驗證碼失敗"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:86
msgid "發送技術通知、更新、安全警報和支援訊息"
msgstr "發送技術通知、更新、安全警報和支援訊息"

#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:44
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:95
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:117
msgid "發送方式"
msgstr "發送方式"

#: apps/dp-admin/src/router/config/routes.web.tsx:660
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:143
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:156
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/index.web.tsx:56
msgid "發送日誌"
msgstr "發送日誌"

#. placeholder {0}: templateName || templateCode || ''
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:432
msgid "發送日誌 - {0}"
msgstr "發送日誌 - {0}"

#: apps/dp-admin/src/pages/resource-config/delivery-record-list/index.web.tsx:71
msgid "發送日誌列表"
msgstr "發送日誌列表"

#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:102
msgid "發送時間"
msgstr "發送時間"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:135
msgid "發送時間不可早於當前時間"
msgstr "發送時間不可早於當前時間"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepTemplate.web.tsx:241
msgid "發送渠道"
msgstr "發送渠道"

#: apps/dp-business/src/servers/verification/api.ts:46
msgid "發送簡訊驗證碼失敗"
msgstr "發送簡訊驗證碼失敗"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:432
msgid "發送給"
msgstr "發送給"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:489
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:73
msgid "發送配置"
msgstr "發送配置"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:178
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:148
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateDetailInfo/index.web.tsx:71
msgid "發送類型"
msgstr "發送類型"

#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:211
#: apps/dp-business/src/components/ForgotPassword/index.tsx:419
msgid "發送驗證碼"
msgstr "發送驗證碼"

#: apps/dp-business/src/services/auth.ts:97
#: apps/dp-business/src/services/auth.ts:193
#: apps/dp-business/src/pages/VerifyPhone/index.tsx:78
#: apps/dp-business/src/pages/VerifyEmail/index.tsx:80
#: apps/dp-business/src/pages/Login/Phone/index.tsx:32
#: apps/dp-business/src/pages/ChangePhone/index.tsx:58
#: apps/dp-business/src/pages/ChangeEmail/index.tsx:61
#: apps/dp-business/src/pages/BindPhone/index.tsx:58
#: apps/dp-business/src/pages/BindEmail/index.tsx:60
#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:115
#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:122
msgid "發送驗證碼失敗"
msgstr "發送驗證碼失敗"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:188
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:149
#: apps/dp-client/src/hooks/useVerificationCode.ts:238
msgid "發送驗證碼失敗，請稍後重試"
msgstr "發送驗證碼失敗，請稍後重試"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:303
#: apps/dp-business/src/pages/Login/index.tsx:545
#: apps/dp-business/src/pages/Login/index.tsx:550
#: apps/dp-business/src/pages/Login/index.tsx:581
#: apps/dp-business/src/pages/Login/index.tsx:586
#: apps/dp-business/src/components/ForgotPassword/index.tsx:212
#: apps/dp-business/src/components/ForgotPassword/index.tsx:239
#: apps/dp-business/src/components/ForgotPassword/index.tsx:258
#: apps/dp-business/src/components/ForgotPassword/index.tsx:284
msgid "發送驗證碼失敗，請重試"
msgstr "發送驗證碼失敗，請重試"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:298
msgid "發送驗證碼失敗: {errorMessage}"
msgstr "發送驗證碼失敗: {errorMessage}"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:153
msgid "白色"
msgstr "白色"

#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:52
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:79
msgid "百貨"
msgstr "百貨"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:57
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:593
msgid "百貨名稱"
msgstr "百貨名稱"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:98
msgid "百貨資訊"
msgstr "百貨資訊"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:434
msgid "的"
msgstr "的"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1365
msgid "的庫存總數"
msgstr "的庫存總數"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:568
msgid "的抽獎情況"
msgstr "的抽獎情況"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:90
msgid "監控和分析趨勢、使用情況和活動"
msgstr "監控和分析趨勢、使用情況和活動"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:99
msgid "監新服務時間"
msgstr "監新服務時間"

#: apps/dp-admin/src/pages/merchant/components/LatestTaskPrompt/index.web.tsx:46
msgid "監測到有一條最新的工單，狀態為：{statusLabel}"
msgstr "監測到有一條最新的工單，狀態為：{statusLabel}"

#: apps/dp-client/src/screens/home/components/ShopCard/components/S500Label.tsx:27
msgid "盤"
msgstr "盤"

#: apps/dp-business/src/components/StoreSelector/index.tsx:288
msgid "目前"
msgstr "目前"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/SmsTemplateSection.web.tsx:125
msgid "目前 {smsLength}字/{smsSegments}則簡訊"
msgstr "目前 {smsLength}字/{smsSegments}則簡訊"

#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchAssignModal/index.web.tsx:55
msgid "目前BD"
msgstr "目前BD"

#: apps/dp-admin/src/components/RichTextEditor/services/hooks.ts:64
msgid "目前不支持插入圖片"
msgstr "目前不支持插入圖片"

#: apps/dp-business/src/components/PhotoUploader/upload.ts:189
msgid "目前不支援上傳文件檔，請選擇圖片"
msgstr "目前不支援上傳文件檔，請選擇圖片"

#: apps/dp-admin/src/pages/merchant/task-list/components/ActionButtons/index.web.tsx:85
msgid "目前任務無相關的商家資訊"
msgstr "目前任務無相關的商家資訊"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:78
msgid "目前任務資訊不完整!"
msgstr "目前任務資訊不完整!"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:661
msgid "目前位置"
msgstr "目前位置"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:163
msgid "目前內容"
msgstr "目前內容"

#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantBasicInfo/index.web.tsx:87
msgid "目前分配BD"
msgstr "目前分配BD"

#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:320
msgid "目前定位"
msgstr "目前定位"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:347
msgid "目前密碼"
msgstr "目前密碼"

#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:117
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:183
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:160
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:160
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:182
msgid "目前審核人"
msgstr "目前審核人"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:342
msgid "目前尚未添加步驟，可點擊下方按鈕新增。"
msgstr "目前尚未添加步驟，可點擊下方按鈕新增。"

#: apps/dp-client/src/screens/diary/pages/my/components/UserProfileSection.tsx:46
#: apps/dp-client/src/screens/diary/pages/home/components/points-card/index.tsx:253
msgid "目前排名"
msgstr "目前排名"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:157
msgid "目前此類訂單僅支持商家協商處理，您可直接聯繫商家處理。"
msgstr "目前此類訂單僅支持商家協商處理，您可直接聯繫商家處理。"

#: apps/dp-client/src/hooks/useCurrentLocation.ts:77
msgid "目前瀏覽器不支援定位功能"
msgstr "目前瀏覽器不支援定位功能"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:233
msgid "目前無法查看此團購券詳情"
msgstr "目前無法查看此團購券詳情"

#: apps/dp-business/src/pages/UserManagement/index.tsx:396
msgid "目前無法檢視帳號密碼"
msgstr "目前無法檢視帳號密碼"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:255
msgid "目前無法複製帳號資訊"
msgstr "目前無法複製帳號資訊"

#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:141
msgid "目前用戶"
msgstr "目前用戶"

#: apps/dp-admin/src/pages/org-tree/services/shopPathActions.ts:164
msgid "目前申請不可編輯或提交，請到組織樹管理確認狀態"
msgstr "目前申請不可編輯或提交，請到組織樹管理確認狀態"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:224
msgid "目前篩選條件下沒有可選擇的三級渠道"
msgstr "目前篩選條件下沒有可選擇的三級渠道"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:51
msgid "目前結算"
msgstr "目前結算"

#: apps/dp-client/src/screens/account/pages/coupon/CouponScan/index.tsx:301
msgid "目前裝置不支援手電筒"
msgstr "目前裝置不支援手電筒"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchAssignModal/index.web.tsx:48
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:122
msgid "目前追蹤者"
msgstr "目前追蹤者"

#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:189
msgid "目前追蹤者:"
msgstr "目前追蹤者:"

#: apps/dp-admin/src/pages/merchant/task-list/components/FollowUpHistoryModal/index.web.tsx:74
msgid "目前追蹤者："
msgstr "目前追蹤者："

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:390
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:412
#: apps/dp-business/src/components/InvoiceForm/index.tsx:180
msgid "目前選擇的結算單不滿足請款條件"
msgstr "目前選擇的結算單不滿足請款條件"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/exchange/index.tsx:166
msgid "目前點數"
msgstr "目前點數"

#: apps/dp-admin/src/components/UserFilterSection/index.web.tsx:23
msgid "目標城市"
msgstr "目標城市"

#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:316
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:89
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:670
msgid "目標店家"
msgstr "目標店家"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:122
msgid "目標狀態未變更"
msgstr "目標狀態未變更"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:221
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:208
msgid "目標節點：{targetPath}"
msgstr "目標節點：{targetPath}"

#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:91
msgid "目標開關"
msgstr "目標開關"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:648
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:786
msgid "直接付款"
msgstr "直接付款"

#: apps/dp-admin/src/modules/constants/options.ts:227
msgid "直接抵扣現金"
msgstr "直接抵扣現金"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/constants.ts:62
msgid "直接搜索"
msgstr "直接搜索"

#: apps/dp-admin/src/modules/constants/options.ts:234
msgid "直接減免固定金額"
msgstr "直接減免固定金額"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/index.tsx:940
msgid "直接發布"
msgstr "直接發布"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:13
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:230
msgid "直接發放"
msgstr "直接發放"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:209
msgid "直接發放僅可單獨配置，不可再添加其他觸發事件"
msgstr "直接發放僅可單獨配置，不可再添加其他觸發事件"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:578
msgid "直接發放僅可單獨配置，不可與其他觸發事件組合"
msgstr "直接發放僅可單獨配置，不可與其他觸發事件組合"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:803
msgid "直接退出"
msgstr "直接退出"

#: apps/dp-client/src/screens/home/pages/Note/pages/editPhoto/index.tsx:275
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:802
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:255
msgid "直接退出會丟失已編輯內容喔"
msgstr "直接退出會丟失已編輯內容喔"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:110
#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:119
msgid "直接領取或發放"
msgstr "直接領取或發放"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/chainReportFilterFields.ts:49
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:31
#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:40
#: apps/dp-admin/src/pages/marketing/services/constants.ts:258
msgid "直營"
msgstr "直營"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:155
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/columns.web.tsx:47
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:835
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:420
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:464
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:314
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:105
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:560
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:598
msgid "直營/加盟"
msgstr "直營/加盟"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:132
msgid "直營／加盟"
msgstr "直營／加盟"

#: apps/dp-admin/src/modules/hooks/options/useFranchiseTypeOptions.ts:111
msgid "直營/加盟數據取得失敗"
msgstr "直營/加盟數據取得失敗"

#: apps/dp-admin/src/modules/hooks/options/useFranchiseTypeOptions.ts:120
msgid "直營/加盟數據取得異常"
msgstr "直營/加盟數據取得異常"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:68
msgid "直營店"
msgstr "直營店"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:229
msgid "相似 {index}:"
msgstr "相似 {index}:"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:104
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ImageUploadTips/index.web.tsx:159
msgid "相似商家"
msgstr "相似商家"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:120
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:137
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:451
msgid "相似店家資訊"
msgstr "相似店家資訊"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:452
msgid "相似店家資訊（共找到{similarCount}家）"
msgstr "相似店家資訊（共找到{similarCount}家）"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:1226
msgid "相機出現問題"
msgstr "相機出現問題"

#: apps/dp-client/src/screens/home/pages/Note/constants/index.ts:23
msgid "相機啟動失敗，請檢查權限設置或嘗試刷新頁面"
msgstr "相機啟動失敗，請檢查權限設置或嘗試重整頁面"

#: apps/dp-business/src/App.native.tsx:248
#: apps/dp-business/src/App.native.tsx:272
msgid "相機權限未授予"
msgstr "相機權限未授予"

#: apps/dp-client/src/screens/home/pages/Note/constants/index.ts:22
msgid "相機權限被拒絕"
msgstr "相機權限被拒絕"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:91
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:101
msgid "相關任務"
msgstr "相關任務"

#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:149
msgid "相關任務列表"
msgstr "相關任務列表"

#: apps/dp-admin/src/pages/merchant/components/FollowUpModal/services/hooks/index.ts:116
msgid "相關任務失敗"
msgstr "相關任務失敗"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:147
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:231
msgid "相關圖片"
msgstr "相關圖片"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:415
msgid "相關圖片（可選）"
msgstr "相關圖片（可選）"

#: apps/dp-admin/src/pages/audit-center/components/AuditTable/index.web.tsx:163
msgid "相關審核數量"
msgstr "相關審核數量"

#: apps/dp-business/src/pages/UserManagement/index.tsx:489
msgid "相關店家數量"
msgstr "相關餐廳數量"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/NoteSection/index.tsx:172
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/NoteSection/index.tsx:187
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:312
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/NoteModule/index.tsx:196
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/NoteModule/index.tsx:227
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallNoteSection/index.tsx:197
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallNoteSection/index.tsx:213
#: apps/dp-client/src/configs/page-configs.tsx:463
#: apps/dp-client/src/configs/page-configs.tsx:465
msgid "相關筆記"
msgstr "相關筆記"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:213
msgid "相關角色"
msgstr "相關角色"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/index.web.tsx:59
msgid "相關訂單"
msgstr "相關訂單"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/DishDetail/DishDetailPage.tsx:291
msgid "相關評論"
msgstr "相關評論"

#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:84
msgid "相關門市數量"
msgstr "相關門市數量"

#: apps/dp-admin/src/pages/merchant/information-review/components/InformationChangeSection/index.web.tsx:107
msgid "相關附件"
msgstr "相關附件"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PreviewCard.tsx:118
msgid "省"
msgstr "省"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:186
msgid "看"
msgstr "看"

#: apps/dp-client/src/screens/login/components/fet-login-modal/index.tsx:196
msgid "看口碑 訂好位 享優惠"
msgstr "看口碑 訂好位 享優惠"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/home/index.tsx:340
msgid "看更多"
msgstr "看更多"

#: apps/dp-client/src/screens/diary/components/WarningModal/index.tsx:67
msgid "看看其他任務"
msgstr "看看其他任務"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:868
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:390
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:417
msgid "真的要刪除嗎？刪除後無法恢復喔～"
msgstr "真的要刪除嗎？刪除後無法恢復喔～"

#: apps/dp-client/src/screens/diary/pages/no-access/index.tsx:81
msgid "瞭解活動規則"
msgstr "瞭解活動規則"

#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:48
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1051
#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:254
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:224
#: apps/dp-admin/src/pages/audit-center/components/ClaimAuditFailureFeedback/index.web.tsx:26
msgid "知道了"
msgstr "知道了"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:190
msgid "矩形"
msgstr "矩形"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:218
msgid "矩形選框"
msgstr "矩形選框"

#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:39
msgid "短期"
msgstr "短期"

#: apps/dp-business/src/data/regions.ts:72
msgid "石碇區"
msgstr "石碇區"

#: apps/dp-business/src/data/regions.ts:75
msgid "石門區"
msgstr "石門區"

#: apps/dp-client/src/screens/home/components/ShopCard/components/S500Label.tsx:29
msgid "碗"
msgstr "碗"

#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ActionButtons/index.web.tsx:59
msgid "確信Google"
msgstr "確信Google"

#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ActionButtons/index.web.tsx:50
msgid "確信圖霸"
msgstr "確信圖霸"

#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ActionButtons/index.web.tsx:68
msgid "確信已有資訊"
msgstr "確信已有資訊"

#: apps/dp-client/src/utils/permission.ts:54
#: apps/dp-client/src/utils/permission.ts:63
#: apps/dp-client/src/utils/permission.ts:72
#: apps/dp-client/src/utils/permission.ts:81
#: apps/dp-client/src/screens/login/components/account-recreate-modal/index.tsx:70
#: apps/dp-client/src/screens/home/pages/Purchase/components/PurchaseModal/index.tsx:349
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:154
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:600
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/hooks/useGalleryAccess.ts:173
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:234
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:529
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1213
#: apps/dp-client/src/screens/home/pages/Meal/components/CouponPickerModal/index.tsx:201
#: apps/dp-client/src/screens/home/pages/Meal/components/CouponPickerModal/index.tsx:237
#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:761
#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:262
#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:89
#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:136
#: apps/dp-client/src/screens/account/pages/edit-profile/components/WheelDatePicker/index.tsx:182
#: apps/dp-client/src/screens/account/pages/edit-profile/components/DatePickerModal/index.tsx:660
#: apps/dp-client/src/screens/account/pages/advice/category-select/index.tsx:166
#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:94
#: apps/dp-business/src/services/modal.ts:304
#: apps/dp-business/src/services/modal.ts:335
#: apps/dp-business/src/pages/MenuManagement.tsx:705
#: apps/dp-business/src/pages/MenuManagement.tsx:750
#: apps/dp-business/src/pages/MenuManagement.tsx:791
#: apps/dp-business/src/pages/MenuManagement.tsx:816
#: apps/dp-business/src/pages/MenuManagement.tsx:834
#: apps/dp-business/src/pages/MenuManagement.tsx:849
#: apps/dp-business/src/pages/MenuManagement.tsx:906
#: apps/dp-business/src/pages/MenuManagement.tsx:952
#: apps/dp-business/src/pages/UserManagement/SelectShopsView.tsx:93
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:392
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:487
#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:370
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:402
#: apps/dp-business/src/pages/TableManagement/index.tsx:302
#: apps/dp-business/src/pages/TableManagement/index.tsx:407
#: apps/dp-business/src/pages/TableManagement/index.tsx:604
#: apps/dp-business/src/pages/TableManagement/index.tsx:782
#: apps/dp-business/src/pages/ServiceFacilities/AddCustomService.tsx:52
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1205
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1077
#: apps/dp-business/src/pages/PhoneEdit/index.tsx:131
#: apps/dp-business/src/pages/OrderOverview/FilterModal.tsx:364
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:296
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:366
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:436
#: apps/dp-business/src/pages/MyProfile/index.tsx:121
#: apps/dp-business/src/pages/MyProfile/index.tsx:332
#: apps/dp-business/src/pages/MyProfile/index.tsx:383
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1323
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1347
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:766
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:819
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:869
#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:240
#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:305
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:248
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:297
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:241
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:329
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:379
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:283
#: apps/dp-business/src/pages/EditUser/index.tsx:228
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:340
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:435
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:838
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:886
#: apps/dp-business/src/pages/BusinessHours/TimeRangePicker.tsx:206
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:1161
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:743
#: apps/dp-business/src/pages/AddStore/index.tsx:847
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:522
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:530
#: apps/dp-business/src/pages/AddStore/CategoryPage.tsx:246
#: apps/dp-business/src/pages/AddStore/components/PoiConfirmModal.tsx:90
#: apps/dp-business/src/pages/AddStore/components/PoiConfirmModal.tsx:143
#: apps/dp-business/src/components/DatePicker.tsx:638
#: apps/dp-business/src/components/TimePicker/TimePickerModal.tsx:124
#: apps/dp-business/src/components/ModalContainer/index.tsx:52
#: apps/dp-business/src/components/ModalContainer/index.tsx:74
#: apps/dp-business/src/components/Modal/StandardModal.tsx:101
#: apps/dp-business/src/components/Modal/ConfirmDialog.tsx:88
#: apps/dp-business/src/components/GoogleMap/index.tsx:847
#: apps/dp-business/src/components/GoogleMap/WebViewMap.tsx:729
#: apps/dp-business/src/components/GoogleMap/WebViewMap.tsx:792
#: apps/dp-business/src/components/CopyResultView/index.tsx:135
#: apps/dp-business/src/components/ConfirmModal/index.tsx:47
#: apps/dp-business/src/components/CompactTimePicker/index.tsx:469
#: apps/dp-business/src/components/CompactTimePicker/index.tsx:556
#: apps/dp-business/src/components/CityDistrictCascadeSelector/index.tsx:163
#: apps/dp-business/src/components/CascadeSelector/index.tsx:105
#: apps/dp-admin/src/pages/users/roles/components/RoleForm/index.web.tsx:61
#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:326
#: apps/dp-admin/src/pages/users/permissions/index.web.tsx:85
#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:312
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:398
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:379
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:626
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:154
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:148
#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:352
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:161
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:172
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:99
#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:281
#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:295
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:213
#: apps/dp-admin/src/pages/org-tree/org-detail/components/AddChildNodeModal/index.web.tsx:46
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:189
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:204
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:219
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:234
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:249
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:223
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:220
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1177
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:248
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:272
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:288
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:211
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:553
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:568
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:356
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:89
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:114
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:289
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:171
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:605
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:619
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:633
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:647
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:668
#: apps/dp-admin/src/pages/merchant/components/TagEditor/index.web.tsx:219
#: apps/dp-admin/src/pages/merchant/components/SortableItem/index.web.tsx:93
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:1030
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:217
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:344
#: apps/dp-admin/src/pages/merchant/components/CategoryEditModal/index.web.tsx:60
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:104
#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:131
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:307
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:392
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:289
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:606
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:419
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:132
#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:469
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:211
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:360
#: apps/dp-admin/src/pages/marketing/benefit-management/components/VoidInventoryModal.web.tsx:59
#: apps/dp-admin/src/pages/marketing/benefit-management/components/ExtendInventoryModal.web.tsx:70
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:303
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:985
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:113
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:319
#: apps/dp-admin/src/modules/hooks/useUnsavedChangesWarning.ts:67
#: apps/dp-admin/src/components/layout/services/hooks.ts:51
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:180
#: apps/dp-admin/src/components/BusinessHours/index.web.tsx:456
#: apps/dp-admin/src/components/ActionBar/index.web.tsx:139
msgid "確定"
msgstr "確定"

#: apps/dp-client/src/components/CouponDetailModal/index.tsx:227
msgid "確定使用這張券嗎？"
msgstr "確定使用這張券嗎？"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:325
#: apps/dp-client/src/screens/account/pages/order/index.tsx:237
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:176
#: apps/dp-business/src/pages/UserManagement/index.tsx:331
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:291
#: apps/dp-business/src/pages/PermissionManagement/index.tsx:123
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:130
msgid "確定刪除"
msgstr "確定刪除"

#: apps/dp-business/src/pages/MenuManagement.tsx:783
#: apps/dp-business/src/pages/MenuManagement.tsx:808
#: apps/dp-business/src/pages/MenuManagement.tsx:861
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1027
#: apps/dp-business/src/components/Modal/DeleteModal.tsx:41
msgid "確定刪除？"
msgstr "確定刪除？"

#: apps/dp-business/src/pages/MenuManagement.tsx:785
#: apps/dp-business/src/pages/MenuManagement.tsx:810
msgid "確定刪除以下分類"
msgstr "確定刪除以下分類"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:1029
msgid "確定刪除以下特殊日期營業時間"
msgstr "確定刪除以下特殊日期營業時間"

#: apps/dp-business/src/pages/MenuManagement.tsx:863
msgid "確定刪除以下餐點"
msgstr "確定刪除以下餐點"

#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:178
msgid "確定刪除這張圖片嗎？"
msgstr "確定刪除這張圖片嗎？"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2396
msgid "確定反核銷？"
msgstr "確定反核銷？"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2405
msgid "確定反核銷以下套餐券"
msgstr "確定反核銷以下套餐券"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:170
msgid "確定取消該申請？"
msgstr "確定取消該申請？"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:519
msgid "確定恢復"
msgstr "確定恢復"

#. placeholder {0}: selectedRowKeys.length
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/index.web.tsx:126
msgid "確定批量移除選中的 {0} 家店家？"
msgstr "確定批量移除選中的 {0} 家店家？"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:239
#: apps/dp-business/src/components/InvoiceForm/index.tsx:281
msgid "確定提交"
msgstr "確定提交"

#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:116
#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:369
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:636
msgid "確定放棄付款"
msgstr "確定放棄付款"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:597
msgid "確定放棄當前拍攝？"
msgstr "確定放棄當前拍攝？"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:273
msgid "確定啟用該渠道嗎？"
msgstr "確定啟用該渠道嗎？"

#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:87
msgid "確定是 {inputCode} 嗎？"
msgstr "確定是 {inputCode} 嗎？"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:483
msgid "確定暫停"
msgstr "確定暫停"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:756
msgid "確定更換"
msgstr "確定更換"

#: apps/dp-client/src/screens/home/pages/LocationSelect/components/HistorySection.tsx:38
msgid "確定清空所有最近指定記錄？"
msgstr "確定清空所有最近指定記錄？"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:227
msgid "確定移除"
msgstr "確定移除"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:217
msgid "確定移除該店家？"
msgstr "確定移除該店家？"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountCopyForm.tsx:125
msgid "確定複製"
msgstr "確定複製"

#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:213
msgid "確定要{action}{serviceTypeName}嗎？"
msgstr "確定要{action}{serviceTypeName}嗎？"

#. placeholder {0}: record.name
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:201
msgid "確定要{action}活動\"{0}\"嗎？操作後將依原活動時間重新判斷狀態，不一定變為進行中。"
msgstr "確定要{action}活動\"{0}\"嗎？操作後將依原活動時間重新判斷狀態，不一定變為進行中。"

#: apps/dp-business/src/pages/UserManagement/index.tsx:366
msgid "確定要{actionLabel}帳號「{displayName}」嗎？"
msgstr "確定要{actionLabel}帳號「{displayName}」嗎？"

#. placeholder {0}: record.name
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/index.web.tsx:113
msgid "確定要{actionText}券組\"{0}\"嗎？"
msgstr "確定要{actionText}券組\"{0}\"嗎？"

#. placeholder {0}: node.permissionName
#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:311
msgid "確定要{actionText}權限節點\"{0}\"嗎？"
msgstr "確定要{actionText}權限節點\"{0}\"嗎？"

#. placeholder {0}: item.title
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:335
msgid "確定要{actionText}配置\"{0}\"嗎？"
msgstr "確定要{actionText}配置\"{0}\"嗎？"

#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:33
msgid "確定要{statusText}此帳號嗎？"
msgstr "確定要{statusText}此帳號嗎？"

#. placeholder {0}: record.roleName
#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:31
msgid "確定要{statusText}角色「{0}」嗎？"
msgstr "確定要{statusText}角色「{0}」嗎？"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:817
msgid "確定要下架此套餐券嗎？下架後用戶將無法購買。"
msgstr "確定要下架此套餐券嗎？下架後用戶將無法購買。"

#. placeholder {0}: data.templateName
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:248
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:186
msgid "確定要作廢券包「{0}」嗎？此操作不可撤銷。"
msgstr "確定要作廢券包「{0}」嗎？此操作不可撤銷。"

#. placeholder {0}: selectedRows.length
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:397
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:378
msgid "確定要作廢選中的 {0} 張券包嗎？此操作不可恢復！"
msgstr "確定要作廢選中的 {0} 張券包嗎？此操作不可恢復！"

#. placeholder {0}: record.name
#. placeholder {0}: detail.name
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:397
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:95
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:90
msgid "確定要停用品類\"{0}\"嗎？"
msgstr "確定要停用品類\"{0}\"嗎？"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:122
msgid "確定要停用標籤\"{labelName}\"嗎？"
msgstr "確定要停用標籤\"{labelName}\"嗎？"

#. placeholder {0}: record.holidayName
#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:61
msgid "確定要停用節假日「{0}」嗎？"
msgstr "確定要停用節假日「{0}」嗎？"

#. placeholder {0}: selectedRowKeys.length
#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:100
msgid "確定要停用這 {0} 個節假日嗎？"
msgstr "確定要停用這 {0} 個節假日嗎？"

#. placeholder {0}: activeRecords.length
#. placeholder {0}: activeRows.length
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:466
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:582
msgid "確定要停用選中的 {0} 個品類嗎？"
msgstr "確定要停用選中的 {0} 個品類嗎？"

#. placeholder {0}: record.clientName
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/index.web.tsx:31
msgid "確定要刪除「{0}」嗎？刪除後不可恢復。"
msgstr "確定要刪除「{0}」嗎？刪除後不可恢復。"

#. placeholder {0}: currentSelected.size
#. placeholder {0}: selectedUids.size
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:529
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:573
msgid "確定要刪除已選的 {0} 張圖片嗎？"
msgstr "確定要刪除已選的 {0} 張圖片嗎？"

#: apps/dp-business/src/pages/TableManagement/index.tsx:865
msgid "確定要刪除桌位 \"{zoneName}\" 嗎？"
msgstr "確定要刪除桌位 \"{zoneName}\" 嗎？"

#: apps/dp-business/src/pages/TableManagement/index.tsx:461
msgid "確定要刪除桌型 \"{zoneName}\" 嗎？"
msgstr "確定要刪除桌型 \"{zoneName}\" 嗎？"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:290
msgid "確定要刪除此規則嗎？刪除後無法恢復。"
msgstr "確定要刪除此規則嗎？刪除後無法恢復。"

#: apps/dp-admin/src/pages/merchant/components/SortableItem/index.web.tsx:90
msgid "確定要刪除此類別嗎？"
msgstr "確定要刪除此類別嗎？"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:354
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:215
msgid "確定要刪除此餐點嗎？"
msgstr "確定要刪除此餐點嗎？"

#. placeholder {0}: record.name
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:163
msgid "確定要刪除活動\"{0}\"嗎？刪除後不可恢復。"
msgstr "確定要刪除活動\"{0}\"嗎？刪除後不可恢復。"

#. placeholder {0}: record.name
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:224
msgid "確定要刪除活動「{0}」嗎？此操作不可恢復。"
msgstr "確定要刪除活動「{0}」嗎？此操作不可恢復。"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:233
msgid "確定要刪除消息\"{notificationTitle}\"嗎？刪除後無法恢復。"
msgstr "確定要刪除消息\"{notificationTitle}\"嗎？刪除後無法恢復。"

#: apps/dp-business/src/pages/UserManagement/index.tsx:329
msgid "確定要刪除用戶「{displayName}」嗎？此操作無法撤銷。"
msgstr "確定要刪除用戶「{displayName}」嗎？此操作無法撤銷。"

#. placeholder {0}: record.roleName
#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:44
msgid "確定要刪除角色「{0}」嗎？"
msgstr "確定要刪除角色「{0}」嗎？"

#: apps/dp-business/src/pages/PermissionManagement/index.tsx:121
msgid "確定要刪除角色「{roleName}」嗎？此操作無法撤銷。"
msgstr "確定要刪除角色「{roleName}」嗎？此操作無法撤銷。"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:152
#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:129
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:303
msgid "確定要刪除訂單嗎？"
msgstr "確定要刪除訂單嗎？"

#. placeholder {0}: record.name
#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:52
msgid "確定要刪除賬號 \"{0}\" 嗎？刪除後不可恢復。"
msgstr "確定要刪除賬號 \"{0}\" 嗎？刪除後不可恢復。"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:90
msgid "確定要刪除這個商家嗎？"
msgstr "確定要刪除這個商家嗎？"

#: apps/dp-admin/src/pages/users/permissions/index.web.tsx:84
msgid "確定要刪除這個權限節點嗎？刪除後不可恢復。"
msgstr "確定要刪除這個權限節點嗎？刪除後不可恢復。"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:130
msgid "確定要刪除這個電話嗎？"
msgstr "確定要刪除這個電話嗎？"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:388
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:445
msgid "確定要刪除這條回覆嗎？"
msgstr "確定要刪除這條回覆嗎？"

#. placeholder {0}: item.title
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:315
msgid "確定要刪除配置\"{0}\"嗎？此操作不可撤銷。"
msgstr "確定要刪除配置\"{0}\"嗎？此操作不可撤銷。"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:91
msgid "確定要取消嗎？未儲存的資料將遺失"
msgstr "確定要取消嗎？未儲存的資料將遺失"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:348
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:256
#: apps/dp-client/src/screens/account/pages/order/index.tsx:210
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:154
msgid "確定要取消這個訂單嗎？"
msgstr "確定要取消這個訂單嗎？"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:129
#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:106
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:239
msgid "確定要取消預訂嗎？"
msgstr "確定要取消預訂嗎？"

#: apps/dp-client/src/screens/account/pages/user-profile/pages/permission-settings/index.tsx:52
msgid "確定要封鎖此用戶嗎？"
msgstr "確定要封鎖此用戶嗎？"

#. placeholder {0}: selectedShops.length
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:595
msgid "確定要將\"{optionLabels}\"從當前店家複製到選中的{0}個店家嗎？此操作將覆蓋目標店家的現有數據。"
msgstr "確定要將\"{optionLabels}\"從當前店家複製到選中的{0}個店家嗎？此操作將覆蓋目標店家的現有數據。"

#. placeholder {0}: offlineTarget?.merchantName ?? ''
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:993
msgid "確定要將商家「{0}」下架嗎？"
msgstr "確定要將商家「{0}」下架嗎？"

#. placeholder {0}: currentShelvesRecord?.shopName || ''
#. placeholder {0}: currentShelvesRecord?.merchantName || ''
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1134
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:622
msgid "確定要將店家「{0}」上架嗎？"
msgstr "確定要將店家「{0}」上架嗎？"

#. placeholder {0}: currentShelvesRecord?.shopName || ''
#. placeholder {0}: currentShelvesRecord?.merchantName || ''
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1133
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:621
msgid "確定要將店家「{0}」下架嗎？"
msgstr "確定要將店家「{0}」下架嗎？"

#. placeholder {0}: ids.length
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:142
msgid "確定要對選中的 {0} 筆記錄重新回傳嗎？"
msgstr "確定要對選中的 {0} 筆記錄重新回傳嗎？"

#. placeholder {0}: ids.length
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:195
msgid "確定要對選中的 {0} 筆記錄重新發放嗎？"
msgstr "確定要對選中的 {0} 筆記錄重新發放嗎？"

#. placeholder {0}: selectedRows.length
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:352
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:321
msgid "確定要延期選中的 {0} 張券包嗎？"
msgstr "確定要延期選中的 {0} 張券包嗎？"

#. placeholder {0}: activity.name
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:517
msgid "確定要恢復參與「{0}」活動嗎？"
msgstr "確定要恢復參與「{0}」活動嗎？"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:237
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:598
msgid "確定要提交{serviceLabel}的變更嗎？服務狀態：{statusText}。提交後需審核通過才會生效。"
msgstr "確定要提交{serviceLabel}的變更嗎？服務狀態：{statusText}。提交後需審核通過才會生效。"

#. placeholder {0}: record.name
#. placeholder {0}: detail.name
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:424
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:122
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:117
msgid "確定要啟用品類\"{0}\"嗎？"
msgstr "確定要啟用品類\"{0}\"嗎？"

#. placeholder {0}: record?.name ?? ''
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:96
msgid "確定要啟用標籤\"{0}\"嗎？"
msgstr "確定要啟用標籤\"{0}\"嗎？"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:147
msgid "確定要啟用標籤\"{labelName}\"嗎？"
msgstr "確定要啟用標籤\"{labelName}\"嗎？"

#. placeholder {0}: record.benefitName
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:156
msgid "確定要啟用權益「{0}」嗎？"
msgstr "確定要啟用權益「{0}」嗎？"

#. placeholder {0}: record.holidayName
#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:60
msgid "確定要啟用節假日「{0}」嗎？"
msgstr "確定要啟用節假日「{0}」嗎？"

#. placeholder {0}: selectedRowKeys.length
#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:99
msgid "確定要啟用這 {0} 個節假日嗎？"
msgstr "確定要啟用這 {0} 個節假日嗎？"

#. placeholder {0}: selectedRows.length
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:171
msgid "確定要啟用這{0}個標籤嗎？"
msgstr "確定要啟用這{0}個標籤嗎？"

#. placeholder {0}: enableableRows.length
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:250
msgid "確定要啟用選中的 {0} 個權益嗎？"
msgstr "確定要啟用選中的 {0} 個權益嗎？"

#. placeholder {0}: activity.name
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:481
msgid "確定要暫停參與「{0}」活動嗎？暫停後將暫時無法享受活動優惠。"
msgstr "確定要暫停參與「{0}」活動嗎？暫停後將暫時無法享受活動優惠。"

#. placeholder {0}: record.name
#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:102
msgid "確定要激活活動\"{0}\"嗎？"
msgstr "確定要激活活動\"{0}\"嗎？"

#: apps/dp-business/src/pages/MyProfile/index.tsx:120
msgid "確定要登出目前帳戶嗎？"
msgstr "確定要登出目前帳戶嗎？"

#. placeholder {0}: record.name
#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:80
msgid "確定要終止活動\"{0}\"嗎？終止之後不可開啟."
msgstr "確定要終止活動\"{0}\"嗎？終止之後不可開啟."

#. placeholder {0}: record.name
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:136
msgid "確定要終止活動\"{0}\"嗎？終止後可重新啟用，但原活動時間不會重置。"
msgstr "確定要終止活動\"{0}\"嗎？終止後可重新啟用，但原活動時間不會重置。"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:398
msgid "確定要解除心生活關聯嗎？"
msgstr "確定要解除心生活關聯嗎？"

#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:93
msgid "確定要解除綁定嗎？"
msgstr "確定要解除綁定嗎？"

#. placeholder {0}: activity.name
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:444
msgid "確定要退出「{0}」活動嗎？退出後將無法享受活動優惠。"
msgstr "確定要退出「{0}」活動嗎？退出後將無法享受活動優惠。"

#: apps/dp-admin/src/components/layout/services/hooks.ts:50
msgid "確定要退出目前帳戶嗎？"
msgstr "確定要退出目前帳戶嗎？"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:205
msgid "確定要退款嗎？"
msgstr "確定要退款嗎？"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/components/PoiActionButtons/index.web.tsx:36
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:381
msgid "確定要通過此POI審核嗎？"
msgstr "確定要通過此POI審核嗎？"

#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:112
msgid "確定要通過此審核嗎？"
msgstr "確定要通過此審核嗎？"

#. placeholder {0}: approvalRows[0]?.claimRequestId
#: apps/dp-admin/src/pages/audit-center/claim-audit/index.web.tsx:207
msgid "確定要通過請款單 {0} 嗎？"
msgstr "確定要通過請款單 {0} 嗎？"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:392
msgid "確定要通過這個套餐券的審核嗎？"
msgstr "確定要通過這個套餐券的審核嗎？"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:175
msgid "確定要通過這個結算單嗎？"
msgstr "確定要通過這個結算單嗎？"

#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:108
msgid "確定要通過這個請款單嗎？"
msgstr "確定要通過這個請款單嗎？"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:92
msgid "確定要重置表單嗎？"
msgstr "確定要重置表單嗎？"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountUnbindModal.tsx:81
msgid "確定解除"
msgstr "確定解除"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:62
#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:62
msgid "確定註銷？"
msgstr "確定註銷？"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:446
msgid "確定退出"
msgstr "確定退出"

#: apps/dp-client/src/screens/login/components/account-recreate-modal/index.tsx:50
msgid "確定這不是您的資料嗎？我們將為您解除綁定原帳號資料，創立一個全新的帳號"
msgstr "確定這不是您的資料嗎？我們將為您解除綁定原帳號資料，創立一個全新的帳號"

#: apps/dp-admin/src/pages/merchant/service/hooks.ts:32
msgid "確定離開"
msgstr "確定離開"

#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:116
#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:369
msgid "確定離開付款"
msgstr "確定離開付款"

#: apps/dp-client/src/screens/reservation/pages/main/components/TimeModal.tsx:193
#: apps/dp-client/src/screens/reservation/pages/main/components/DateModal.tsx:93
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:114
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/CompactAdvancedFilterContent.tsx:216
#: apps/dp-client/src/screens/home/components/ShopFilter/components/AdvancedFilterContent.tsx:292
#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:372
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:1136
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:253
#: apps/dp-client/src/components/RefundResonModal/index.tsx:179
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:232
#: apps/dp-client/src/components/ConfirmModal/index.tsx:112
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:752
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1558
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:538
#: apps/dp-business/src/pages/BusinessHours/index.tsx:903
#: apps/dp-business/src/pages/BusinessHours/index.tsx:998
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1275
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:587
#: apps/dp-business/src/pages/AddStore/index.tsx:1082
#: apps/dp-business/src/pages/AddRole/index.tsx:373
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:105
#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:34
#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:53
#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:32
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:176
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:193
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:260
#: apps/dp-admin/src/pages/org-tree/org-list/components/AssignBdModal/index.web.tsx:50
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:185
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:176
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1806
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:174
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:816
#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:433
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1124
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:614
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:208
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:73
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:241
#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/WinningConfirmModal.web.tsx:61
#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:81
#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:103
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:212
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/PreviewConfirmModal/index.web.tsx:32
#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:75
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/RejectWinnerModal.web.tsx:66
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:135
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:197
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:304
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:350
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchRejectWinnerModal.web.tsx:81
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchConfirmWinnerModal.web.tsx:49
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchCancelRejectWinnerModal.web.tsx:45
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:137
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:202
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:154
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:152
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:123
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:148
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:223
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:500
#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:75
#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:132
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/components/PoiActionButtons/index.web.tsx:37
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:311
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:371
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:313
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:43
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:75
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:132
#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:210
#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:276
#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:249
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:226
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:382
#: apps/dp-admin/src/components/MapPicker/index.web.tsx:153
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:339
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:359
msgid "確認"
msgstr "確認"

#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:214
msgid "確認{action}"
msgstr "確認{action}"

#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:212
msgid "確認{action}服務"
msgstr "確認{action}服務"

#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:200
msgid "確認{action}活動"
msgstr "確認{action}活動"

#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:310
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:334
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/index.web.tsx:112
msgid "確認{actionText}"
msgstr "確認{actionText}"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:46
msgid "確認{actionText}嗎"
msgstr "確認{actionText}嗎"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:320
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:321
#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:114
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:114
msgid "確認上架"
msgstr "確認上架"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:328
msgid "確認上架 {platform} {version}？"
msgstr "確認上架 {platform} {version}？"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:207
msgid "確認上架此 POI？"
msgstr "確認上架此 POI？"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1466
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1795
msgid "確認上次提交結果"
msgstr "確認上次提交結果"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:816
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:320
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:321
#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:224
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:978
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:987
#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:66
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:66
msgid "確認下架"
msgstr "確認下架"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:329
msgid "確認下架 {platform} {version}？"
msgstr "確認下架 {platform} {version}？"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:207
msgid "確認下架此 POI？"
msgstr "確認下架此 POI？"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:222
msgid "確認下架該組織樹？"
msgstr "確認下架該組織樹？"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/RejectWinnerModal.web.tsx:61
msgid "確認不予中獎"
msgstr "確認不予中獎"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:339
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:528
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:195
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:348
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:496
msgid "確認中獎"
msgstr "確認中獎"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:237
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:208
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:358
msgid "確認中獎失敗"
msgstr "確認中獎失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:232
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:205
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:355
msgid "確認中獎成功"
msgstr "確認中獎成功"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:853
msgid "確認位置"
msgstr "確認位置"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:247
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:249
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:185
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:187
msgid "確認作廢"
msgstr "確認作廢"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:337
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:357
msgid "確認使用草稿？"
msgstr "確認使用草稿？"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:247
msgid "確認使用這張券嗎？"
msgstr "確認使用這張券嗎？"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:238
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:599
msgid "確認保存"
msgstr "確認保存"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:39
msgid "確認保存並提交審核？"
msgstr "確認保存並提交審核？"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:39
msgid "確認保存草稿？"
msgstr "確認保存草稿？"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:236
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:597
msgid "確認保存設定"
msgstr "確認保存設定"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:402
msgid "確認修改"
msgstr "確認修改"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:58
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:396
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:94
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:89
#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:42
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDisableModal/index.web.tsx:58
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:174
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:74
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:216
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:121
msgid "確認停用"
msgstr "確認停用"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:116
msgid "確認停用？"
msgstr "確認停用？"

#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:210
msgid "確認停用此名單？"
msgstr "確認停用此名單？"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:148
msgid "確認停用此榜單？"
msgstr "確認停用此榜單？"

#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:237
msgid "確認停用此用戶名單？"
msgstr "確認停用此用戶名單？"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:40
msgid "確認停用節點「{nodeName}」？"
msgstr "確認停用節點「{nodeName}」？"

#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:160
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:143
msgid "確認分配"
msgstr "確認分配"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:154
#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:131
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:305
#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:352
#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:389
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:591
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:593
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:446
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:868
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:528
#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:51
#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:45
#: apps/dp-admin/src/pages/users/permissions/index.web.tsx:82
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/index.web.tsx:30
#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:349
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:314
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:232
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:234
#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:238
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1610
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1141
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:572
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:196
msgid "確認刪除"
msgstr "確認刪除"

#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:169
msgid "確認刪除？"
msgstr "確認刪除？"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:242
msgid "確認刪除此 POI？"
msgstr "確認刪除此 POI？"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:448
msgid "確認刪除此版本記錄？"
msgstr "確認刪除此版本記錄？"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:223
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:162
msgid "確認刪除活動"
msgstr "確認刪除活動"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:160
msgid "確認刪除活動位？"
msgstr "確認刪除活動位？"

#. placeholder {0}: detail.name
#. placeholder {0}: target.name
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1608
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1140
msgid "確認刪除節點「{0}」？"
msgstr "確認刪除節點「{0}」？"

#. placeholder {0}: record.chainName
#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:236
msgid "確認刪除組織樹「{0}」？"
msgstr "確認刪除組織樹「{0}」？"

#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:43
msgid "確認刪除角色"
msgstr "確認刪除角色"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:210
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:302
msgid "確認刪除該券碼？"
msgstr "確認刪除該券碼？"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:359
msgid "確認刪除選中的券碼？"
msgstr "確認刪除選中的券碼？"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:127
msgid "確認創建"
msgstr "確認創建"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:129
msgid "確認創建該工單嗎？"
msgstr "確認創建該工單嗎？"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:293
msgid "確認匯入"
msgstr "確認匯入"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:241
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:383
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:250
msgid "確認匯出範圍"
msgstr "確認匯出範圍"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:139
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:219
msgid "確認參加"
msgstr "確認參加"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:138
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:218
msgid "確認參加活動"
msgstr "確認參加活動"

#: apps/dp-client/src/screens/reservation/pages/list/pages/searchResult/index.tsx:131
#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:108
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:241
#: apps/dp-client/src/screens/reservation/components/ConfirmModal/index.tsx:25
msgid "確認取消"
msgstr "確認取消"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:133
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:302
msgid "確認取消不予中獎"
msgstr "確認取消不予中獎"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:334
msgid "確認取消不予發獎設置嗎？"
msgstr "確認取消不予發獎設置嗎？"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:209
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:551
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:87
msgid "確認取消編輯"
msgstr "確認取消編輯"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:150
msgid "確認合併"
msgstr "確認合併"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:721
msgid "確認失敗"
msgstr "確認失敗"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:727
msgid "確認失敗，請重試"
msgstr "確認失敗，請重試"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/SubmitConfirmModal.tsx:90
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/SubmitConfirmModal/index.web.tsx:83
msgid "確認套餐券"
msgstr "確認套餐券"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:765
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:270
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:561
msgid "確認套餐券上架"
msgstr "確認套餐券上架"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:270
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:561
msgid "確認套餐券下架"
msgstr "確認套餐券下架"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:221
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:224
msgid "確認完成"
msgstr "確認完成"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:431
msgid "確認完成任務"
msgstr "確認完成任務"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:222
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:225
msgid "確認完成當前任務嗎？"
msgstr "確認完成當前任務嗎？"

#. placeholder {0}: currentUserTasks.length
#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:427
msgid "確認完結這{0}個任務嗎？"
msgstr "確認完結這{0}個任務嗎？"

#. placeholder {0}: currentUserTasks.length
#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:426
msgid "確認完結這{0}個任務嗎？（已過濾掉{otherUserTasksCount}個非您負責的任務）"
msgstr "確認完結這{0}個任務嗎？（已過濾掉{otherUserTasksCount}個非您負責的任務）"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/PublishPreviewModal.web.tsx:109
msgid "確認定時"
msgstr "確認定時"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:169
msgid "確認將其設置上榜嗎？"
msgstr "確認將其設置上榜嗎？"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/WinningConfirmModal.web.tsx:66
msgid "確認將其設置中獎嗎？"
msgstr "確認將其設置中獎嗎？"

#. placeholder {0}: selectedRowKeys.length
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:172
msgid "確認將已選 {0} 家{unitLabel}掛接至「{targetPath}」？"
msgstr "確認將已選 {0} 家{unitLabel}掛接至「{targetPath}」？"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:66
msgid "確認將店家從本樹解除掛接？店家"
msgstr "確認將店家從本樹解除掛接？店家"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:42
msgid "確認將狀態改為上線嗎，上線後將開始接單並且處理工單。"
msgstr "確認將狀態改為上線嗎，上線後將開始接單並且處理工單。"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:43
msgid "確認將狀態改為下線嗎，下線後將無法繼續處理工單與接單。"
msgstr "確認將狀態改為下線嗎，下線後將無法繼續處理工單與接單。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:184
msgid "確認將節點「{targetPath}」的管理員由「{oldManagerLabel}」更換為「{newManagerLabel}」？原管理員將解除本節點管理權限；若其仍掛在其他節點或其他角色，其他權限不受影響。"
msgstr "確認將節點「{targetPath}」的管理員由「{oldManagerLabel}」更換為「{newManagerLabel}」？原管理員將解除本節點管理權限；若其仍掛在其他節點或其他角色，其他權限不受影響。"

#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:117
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:117
msgid "確認將該內容上架嗎？"
msgstr "確認將該內容上架嗎？"

#: apps/dp-admin/src/pages/audit-center/components/UnpublishReasonForm/index.web.tsx:59
msgid "確認將該內容下架嗎？"
msgstr "確認將該內容下架嗎？"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:196
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:349
msgid "確認將該記錄確認為中獎嗎？"
msgstr "確認將該記錄確認為中獎嗎？"

#. placeholder {0}: winnerIds.length
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchCancelRejectWinnerModal.web.tsx:49
msgid "確認將選中的 {0} 筆記錄恢復為待確認中獎狀態嗎？"
msgstr "確認將選中的 {0} 筆記錄恢復為待確認中獎狀態嗎？"

#. placeholder {0}: winnerIds.length
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchConfirmWinnerModal.web.tsx:53
msgid "確認將選中的 {0} 筆記錄確認為中獎嗎？"
msgstr "確認將選中的 {0} 筆記錄確認為中獎嗎？"

#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:129
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:130
msgid "確認導出當前名單？"
msgstr "確認導出當前名單？"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:212
#: apps/dp-admin/src/pages/marketing/user-group-create/components/PreviewConfirmModal/index.web.tsx:50
msgid "確認建立"
msgstr "確認建立"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/PreviewConfirmModal/index.web.tsx:25
msgid "確認建立商家名單"
msgstr "確認建立商家名單"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/PreviewConfirmModal/index.web.tsx:42
msgid "確認建立用戶名單"
msgstr "確認建立用戶名單"

#: apps/dp-client/src/components/CouponDetailModal/index.tsx:229
msgid "確認後，券碼狀態將更新為已使用狀態，不影響實際使用；後續可在「歷史使用」中更改。"
msgstr "確認後，券碼狀態將更新為已使用狀態，不影響實際使用；後續可在「歷史使用」中更改。"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:249
msgid ""
"確認後，券碼狀態將更新為已使用狀態；\n"
"後續可在「我的票券」中更改。"
msgstr ""
"確認後，券碼狀態將更新為已使用狀態；\n"
"後續可在「我的票券」中更改。"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:340
msgid "確認後工單、客服將展示這筆。"
msgstr "確認後工單、客服將展示這筆。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:100
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:85
msgid "確認後新增本節點掛接，保留其他節點的已有掛接關係"
msgstr "確認後新增本節點掛接，保留其他節點的已有掛接關係"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:516
msgid "確認恢復參與"
msgstr "確認恢復參與"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:707
msgid "確認成功"
msgstr "確認成功"

#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:255
msgid "確認批次下架"
msgstr "確認批次下架"

#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:208
msgid "確認批次標記抽檢"
msgstr "確認批次標記抽檢"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:396
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:377
msgid "確認批量作廢"
msgstr "確認批量作廢"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:97
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:465
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:581
msgid "確認批量停用"
msgstr "確認批量停用"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:142
msgid "確認批量停用？"
msgstr "確認批量停用？"

#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:273
msgid "確認批量刪除"
msgstr "確認批量刪除"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:97
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:249
msgid "確認批量啟用"
msgstr "確認批量啟用"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:141
msgid "確認批量啟用？"
msgstr "確認批量啟用？"

#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:150
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:516
msgid "確認拒絕"
msgstr "確認拒絕"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:174
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:201
msgid "確認掛接"
msgstr "確認掛接"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/SubmitConfirmModal.tsx:166
#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:236
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:197
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:197
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:189
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/SubmitConfirmModal/index.web.tsx:170
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:127
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:131
msgid "確認提交"
msgstr "確認提交"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:41
msgid "確認提交審核"
msgstr "確認提交審核"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:42
msgid "確認提交所有圖片的審核結果嗎？"
msgstr "確認提交所有圖片的審核結果嗎？"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:130
msgid "確認提交該工單嗎？提交後將無法修改，用戶將會收到回覆評論。"
msgstr "確認提交該工單嗎？提交後將無法修改，用戶將會收到回覆評論。"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:496
msgid "確認撤銷失敗變更？"
msgstr "確認撤銷失敗變更？"

#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:32
#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:30
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:191
msgid "確認操作"
msgstr "確認操作"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:58
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:423
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:121
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:116
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1645
#: apps/dp-admin/src/pages/merchant/brand-list/components/EnableBrandModal/index.web.tsx:65
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:155
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:95
#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:170
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:146
msgid "確認啟用"
msgstr "確認啟用"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:146
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:159
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:116
msgid "確認啟用？"
msgstr "確認啟用？"

#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:210
msgid "確認啟用此名單？"
msgstr "確認啟用此名單？"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:148
msgid "確認啟用此榜單？"
msgstr "確認啟用此榜單？"

#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:238
msgid "確認啟用此用戶名單？"
msgstr "確認啟用此用戶名單？"

#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:101
msgid "確認啟用活動"
msgstr "確認啟用活動"

#. placeholder {0}: detail.name
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1644
msgid "確認啟用節點「{0}」？"
msgstr "確認啟用節點「{0}」？"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:372
msgid "確認新密碼"
msgstr "確認新密碼"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:480
msgid "確認暫停參與"
msgstr "確認暫停參與"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:183
msgid "確認更換管理員"
msgstr "確認更換管理員"

#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:176
#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:205
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:500
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:598
#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:210
#: apps/dp-business/src/pages/CouponVerification/index.tsx:466
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:620
msgid "確認核銷"
msgstr "確認核銷"

#: apps/dp-business/src/pages/MyProfile/index.tsx:120
msgid "確認登出"
msgstr "確認登出"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:187
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2262
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2276
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:184
msgid "確認發佈"
msgstr "確認發佈"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:404
msgid "確認發放獎勵"
msgstr "確認發放獎勵"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:439
#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:653
msgid "確認發送"
msgstr "確認發送"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:429
msgid "確認發送？"
msgstr "確認發送？"

#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:68
msgid "確認禁用"
msgstr "確認禁用"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:146
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:159
msgid "確認禁用？"
msgstr "確認禁用？"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1721
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1906
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1393
#: apps/dp-admin/src/pages/org-tree/org-create/components/MountPanel/index.web.tsx:92
msgid "確認移除"
msgstr "確認移除"

#. placeholder {0}: shop.name
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1904
#: apps/dp-admin/src/pages/org-tree/org-create/components/MountPanel/index.web.tsx:91
msgid "確認移除店家「{0}」的掛接？"
msgstr "確認移除店家「{0}」的掛接？"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1717
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1389
msgid "確認移除簽約商家？"
msgstr "確認移除簽約商家？"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1717
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1389
msgid "確認移除請款商家？"
msgstr "確認移除請款商家？"

#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:79
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:135
msgid "確認終止活動"
msgstr "確認終止活動"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1804
msgid "確認結束店家／商場基礎信息設置並提交審核？"
msgstr "確認結束店家／商場基礎信息設置並提交審核？"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:229
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:305
msgid "確認繼續"
msgstr "確認繼續"

#: apps/dp-business/src/servers/permission/api.ts:669
msgid "確認臨時帳號申請失敗"
msgstr "確認臨時帳號申請失敗"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:476
#: apps/dp-business/src/pages/UserManagement/BatchCopyUsers.tsx:153
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:594
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:596
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:800
msgid "確認複製"
msgstr "確認複製"

#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:143
msgid "確認要停用此配置嗎？"
msgstr "確認要停用此配置嗎？"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:68
#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:81
#: apps/dp-client/src/screens/account/pages/drafts/main/index.tsx:58
msgid "確認要刪除嗎？"
msgstr "確認要刪除嗎？"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:196
msgid "確認要刪除此配置嗎？"
msgstr "確認要刪除此配置嗎？"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:144
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:123
msgid "確認要啟用此配置嗎？"
msgstr "確認要啟用此配置嗎？"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:170
msgid "確認要禁用此配置嗎？"
msgstr "確認要禁用此配置嗎？"

#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:173
msgid "確認要退款嗎？"
msgstr "確認要退款嗎？"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1849
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:98
msgid "確認解除"
msgstr "確認解除"

#. placeholder {0}: shop.name
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1847
msgid "確認解除店家「{0}」在本樹的掛接？"
msgstr "確認解除店家「{0}」在本樹的掛接？"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:61
msgid "確認解除店家掛接"
msgstr "確認解除店家掛接"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1579
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1601
#: apps/dp-client/src/configs/page-configs.tsx:938
msgid "確認訂單"
msgstr "確認訂單"

#: apps/dp-business/src/servers/reservation/api.ts:901
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:263
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:269
msgid "確認訂單失敗"
msgstr "確認訂單失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:165
msgid "確認設置上榜"
msgstr "確認設置上榜"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/WinningConfirmModal.web.tsx:56
msgid "確認設置中獎"
msgstr "確認設置中獎"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:141
msgid "確認註銷"
msgstr "確認註銷"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:141
msgid "確認註銷並承擔風險"
msgstr "確認註銷並承擔風險"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:336
#: apps/dp-admin/src/pages/merchant/shop-detail/components/ShopClosedImpactModal/index.web.tsx:58
msgid "確認變更"
msgstr "確認變更"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:184
msgid "確認變更影響"
msgstr "確認變更影響"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:288
#: apps/dp-business/src/pages/BusinessStatus/components/ShopClosedImpactContent.tsx:67
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:303
msgid "確認變更營業狀態嗎？"
msgstr "確認變更營業狀態嗎？"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:99
msgid "確認追加"
msgstr "確認追加"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1076
#: apps/dp-admin/src/components/layout/services/hooks.ts:49
msgid "確認退出"
msgstr "確認退出"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:443
msgid "確認退出活動"
msgstr "確認退出活動"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:280
msgid "確認退出活動嗎"
msgstr "確認退出活動嗎"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1074
msgid "確認退出編輯？"
msgstr "確認退出編輯？"

#: apps/dp-admin/src/pages/merchant/components/ActionButtons/index.web.tsx:69
#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:281
msgid "確認退回"
msgstr "確認退回"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:222
#: apps/dp-business/src/pages/OrderDetail/index.tsx:862
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1196
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:172
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:77
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:49
msgid "確認退款"
msgstr "確認退款"

#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:46
msgid "確認退款？"
msgstr "確認退款？"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:174
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:105
#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:451
#: apps/dp-admin/src/pages/merchant/components/ActionButtons/index.web.tsx:63
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/components/PoiActionButtons/index.web.tsx:35
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:111
#: apps/dp-admin/src/pages/audit-center/claim-audit/index.web.tsx:188
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:380
msgid "確認通過"
msgstr "確認通過"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:391
msgid "確認通過審核"
msgstr "確認通過審核"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:99
msgid "確認通過該套餐券的審核嗎？"
msgstr "確認通過該套餐券的審核嗎？"

#. placeholder {0}: chainName || '-'
#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:449
msgid "確認通過連鎖「{0}」的審核？"
msgstr "確認通過連鎖「{0}」的審核？"

#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:279
msgid "確認選中"
msgstr "確認選中"

#: apps/dp-client/src/components/ShopSelectSheet/index.tsx:181
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:529
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:138
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:126
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeMountNodeModal.web.tsx:144
msgid "確認選擇"
msgstr "確認選擇"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:273
msgid "確認選擇（{selectedCount}）"
msgstr "確認選擇（{selectedCount}）"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:141
msgid "確認重新回傳"
msgstr "確認重新回傳"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:191
msgid "確認重新發放"
msgstr "確認重新發放"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:496
msgid "確認重新落地？"
msgstr "確認重新落地？"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:97
msgid "確認重置密碼"
msgstr "確認重置密碼"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:588
msgid "確認開啟"
msgstr "確認開啟"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:203
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:810
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:184
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:566
#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:88
#: apps/dp-admin/src/pages/merchant/service/hooks.ts:30
#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:136
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:112
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:73
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:106
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:241
#: apps/dp-admin/src/modules/hooks/useUnsavedChangesWarning.ts:65
msgid "確認離開"
msgstr "確認離開"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1159
msgid "確認預定"
msgstr "確認預定"

#: apps/dp-admin/src/pages/org-tree/org-audit/components/RejectModal/index.web.tsx:41
msgid "確認駁回"
msgstr "確認駁回"

#. placeholder {0}: chainName || '-'
#: apps/dp-admin/src/pages/org-tree/org-audit/components/RejectModal/index.web.tsx:39
msgid "確認駁回連鎖「{0}」的審核？"
msgstr "確認駁回連鎖「{0}」的審核？"

#: apps/dp-admin/src/pages/merchant/components/imageTips/index.web.tsx:74
msgid "示例"
msgstr "示例"

#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:126
msgid "示例：車輛行駛至某路口，指示牌顯示「大熊美食餐廳此出」，遵循指示牌方向前進。"
msgstr "示例：車輛行駛至某路口，指示牌顯示「大熊美食餐廳此出」，遵循指示牌方向前進。"

#: apps/dp-business/src/components/MerchantBenefits/index.tsx:48
msgid "社群操作"
msgstr "社群操作"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:120
msgid "社群相關"
msgstr "社群相關"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/voucherUsageColumns.tsx:35
#: apps/dp-business/src/pages/ChainDashboard/components/reports/voucherSalesColumns.tsx:33
msgid "票券內容"
msgstr "票券內容"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:107
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:109
msgid "票券分類"
msgstr "票券分類"

#: apps/dp-client/src/screens/account/pages/profile/components/FunctionEntrySection/index.tsx:118
msgid "票券匣"
msgstr "票券匣"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:121
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:122
msgid "票券名稱"
msgstr "票券名稱"

#: apps/dp-business/src/servers/chain/reportApi.ts:170
msgid "票券已使用報表"
msgstr "票券已使用報表"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:25
msgid "票券已經使用報表"
msgstr "票券已經使用報表"

#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionSuccessContent/index.tsx:130
#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionConfirmContent/index.tsx:103
msgid "票券序號"
msgstr "票券序號"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:26
msgid "票券未經使用報表"
msgstr "票券未經使用報表"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/voucherUsageColumns.tsx:71
#: apps/dp-business/src/pages/ChainDashboard/components/reports/voucherSalesColumns.tsx:69
#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterSelects.tsx:215
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:247
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:342
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:384
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:414
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:444
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:202
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:312
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:364
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:404
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:444
msgid "票券狀態"
msgstr "票券狀態"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:257
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:215
msgid "票券類型"
msgstr "票券類型"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:117
#: apps/dp-business/src/utils/moduleTypeMapping.ts:246
#: apps/dp-business/src/components/PhotoUploader/validation.ts:112
#: apps/dp-business/src/components/PhotoUploader/upload.ts:361
#: apps/dp-business/src/components/PhotoUploader/upload.ts:407
msgid "視頻"
msgstr "影片"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:131
msgid "視頻儲存失敗，請稍後重試"
msgstr "影片儲存失敗，請稍後重試"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:113
msgid "視頻儲存成功"
msgstr "影片儲存成功"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:118
msgid "視頻內容完整度評分"
msgstr "影片內容完整度評分"

#: apps/dp-client/src/components/Upload/index.tsx:244
msgid "視頻最多隻能上傳1個"
msgstr "影片最多只能上傳1個"

#: apps/dp-client/src/components/Upload/index.tsx:379
msgid "視頻最多隻能選擇1個"
msgstr "影片最多只能選擇1個"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:117
msgid "視頻刪除成功"
msgstr "影片刪除成功"

#: apps/dp-client/src/screens/home/utils/utils.ts:322
msgid "視頻大小為 {sizeMB}MB，請選擇不超過 150MB的視頻。"
msgstr "視頻大小為 {sizeMB}MB，請選擇不超過 150MB的視頻。"

#: apps/dp-client/src/screens/diary/components/MediaItem/index.tsx:57
msgid "視頻封面"
msgstr "影片封面"

#: apps/dp-client/src/screens/home/utils/utils.ts:317
msgid "視頻時長為 {durationText}，請選擇 1分鐘以內的視頻。"
msgstr "視頻時長為 {durationText}，請選擇 1分鐘以內的視頻。"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:113
msgid "視頻更新成功"
msgstr "影片更新成功"

#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/index.tsx:130
#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/index.tsx:140
msgid "視頻替換失敗"
msgstr "視頻替換失敗"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1395
msgid "視頻管理功能開發中..."
msgstr "影片管理功能開發中..."

#: apps/dp-business/src/components/MediaPreview/index.tsx:51
msgid "視頻預覽"
msgstr "視頻預覽"

#: apps/dp-business/src/pages/UserManagement/index.tsx:605
#: apps/dp-admin/src/pages/users/user-tasks/components/ActionButtons/index.web.tsx:29
#: apps/dp-admin/src/pages/users/roles/components/StatusTag/index.web.tsx:30
#: apps/dp-admin/src/pages/users/roles/components/ActionButtons/index.web.tsx:27
#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:306
#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:307
#: apps/dp-admin/src/pages/users/permissions/components/StatusTag/index.web.tsx:22
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:194
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:152
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:69
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:124
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:165
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:260
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:331
#: apps/dp-admin/src/pages/merchant/service/constants.ts:512
#: apps/dp-admin/src/pages/merchant/service/constants.ts:522
#: apps/dp-admin/src/pages/merchant/service/constants.ts:528
#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:168
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:246
msgid "禁用"
msgstr "禁用"

#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:91
msgid "禁用原因"
msgstr "禁用原因"

#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:64
msgid "禁用品牌"
msgstr "禁用品牌"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:178
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:181
msgid "禁用失敗"
msgstr "禁用失敗"

#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:85
msgid "禁用後該品牌將不可使用，是否確認禁用？"
msgstr "禁用後該品牌將不可使用，是否確認禁用？"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:175
msgid "禁用成功"
msgstr "禁用成功"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:169
msgid "禁用配置"
msgstr "禁用配置"

#: apps/dp-business/src/data/regions.ts:41
msgid "萬華區"
msgstr "萬華區"

#: apps/dp-business/src/data/regions.ts:77
msgid "萬裡區"
msgstr "萬裡區"

#: apps/dp-client/src/screens/home/pages/PrivateChef/constants.ts:14
msgid "私廚座位數量有限，實際可訂日期與時段依店家頁面顯示為準。"
msgstr "私廚座位數量有限，實際可訂日期與時段依店家頁面顯示為準。"

#: apps/dp-client/src/screens/home/pages/PrivateChef/constants.ts:19
#: apps/dp-client/src/configs/page-configs.tsx:130
#: apps/dp-client/src/configs/page-configs.tsx:131
msgid "私廚訂位"
msgstr "私廚訂位"

#: apps/dp-client/src/screens/home/pages/PackageZone/templates/ActivityTemplate.tsx:168
#: apps/dp-client/src/screens/home/pages/PackageZone/templates/ActivityTemplate.tsx:180
#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:239
#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:284
msgid "秒"
msgstr "秒"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:107
msgid "移到前面"
msgstr "移到前面"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:185
msgid "移動"
msgstr "移動"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:214
#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:242
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:221
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitCard/index.web.tsx:54
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:123
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:166
#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:133
msgid "移除"
msgstr "移除"

#: apps/dp-business/src/pages/EditUser/index.tsx:221
msgid "移除使用者"
msgstr "移除使用者"

#: apps/dp-business/src/pages/EditUser/index.tsx:194
#: apps/dp-business/src/pages/EditUser/index.tsx:199
msgid "移除使用者失敗"
msgstr "移除使用者失敗"

#: apps/dp-business/src/pages/EditUser/index.tsx:181
msgid "移除使用者成功"
msgstr "移除使用者成功"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1905
msgid "移除僅在本頁生效，提交審核通過後才會正式解除。"
msgstr "移除僅在本頁生效，提交審核通過後才會正式解除。"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1719
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1391
msgid "移除後本節點不再是結算節點，結算路徑指向本節點的店家將在提交審核時由後端校驗。"
msgstr "移除後本節點不再是結算節點，結算路徑指向本節點的店家將在提交審核時由後端校驗。"

#. placeholder {0}: record.name
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:225
msgid "移除後該使用者在當前樹的全部授權將被解除（受保護的營運指定超管綁定除外），確定移除「{0}」？"
msgstr "移除後該使用者在當前樹的全部授權將被解除（受保護的營運指定超管綁定除外），確定移除「{0}」？"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:239
msgid "移除授權失敗"
msgstr "移除授權失敗"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:74
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedMallTable/index.web.tsx:103
msgid "移除掛載"
msgstr "移除掛載"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:478
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:416
msgid "稅務資訊"
msgstr "稅務資訊"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:271
msgid "稅率"
msgstr "稅率"

#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:205
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:205
msgid "稅號"
msgstr "稅號"

#: apps/dp-business/src/utils/passwordManager.ts:182
#: apps/dp-business/src/utils/passwordManager.ts:411
msgid "稍後再說"
msgstr "稍後再說"

#: apps/dp-business/src/components/CheckoutServiceModal/index.tsx:24
msgid "稍後可在「合約&服務管理」-「服務管理」- 選擇「結帳服務」查看管理"
msgstr "稍後可在「合約&服務管理」-「服務管理」- 選擇「結帳服務」查看管理"

#: apps/dp-business/src/components/CheckoutServiceModal/index.tsx:56
msgid "稍後查看"
msgstr "稍後查看"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:984
msgid "稱呼"
msgstr "稱呼"

#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:8
msgid "稽核中"
msgstr "稽核中"

#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:10
msgid "稽核拒絕"
msgstr "稽核拒絕"

#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:9
msgid "稽核通過"
msgstr "稽核通過"

#: apps/dp-client/src/screens/diary/pages/rank/components/rank-item.tsx:101
#: apps/dp-client/src/screens/diary/pages/rank/components/rank-item-nocoin.tsx:120
msgid "積分"
msgstr "積分"

#: apps/dp-client/src/screens/diary/pages/winning/components/WinningList/index.tsx:49
#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:150
msgid "積分排行榜"
msgstr "積分排行榜"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:51
msgid "積分流水"
msgstr "積分流水"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:154
msgid "積分總數"
msgstr "積分總數"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:102
msgid "空格分隔，如 api.read api.write"
msgstr "空格分隔，如 api.read api.write"

#. placeholder {0}: incentiveEnabled ? '賺積分' : '寫日記'
#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:177
msgid "立刻開始{0}"
msgstr "立刻開始{0}"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:216
#: apps/dp-client/src/screens/reservation/pages/detail/components/ModifyReservationModal.tsx:89
msgid "立即修改"
msgstr "立即修改"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/PublishPreviewModal.web.tsx:101
msgid "立即公佈"
msgstr "立即公佈"

#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:205
#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:211
msgid "立即分享"
msgstr "立即分享"

#: apps/dp-client/src/bootstrap/hooks/useMaintenanceCheck.ts:44
msgid "立即刷新"
msgstr "立即刷新"

#: apps/dp-business/src/pages/MerchantInfo/components/OptimizationCard.tsx:115
#: apps/dp-business/src/components/CheckoutServiceModal/index.tsx:59
msgid "立即前往"
msgstr "立即前往"

#: apps/dp-client/src/screens/home/pages/Note/pages/draft/index.tsx:220
msgid "立即創作"
msgstr "立即創作"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:132
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:195
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:212
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:285
msgid "立即參加"
msgstr "立即參加"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:735
msgid "立即團購"
msgstr "立即團購"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/RegistrationStatusBanner.tsx:78
msgid "立即報名"
msgstr "立即報名"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1119
msgid "立即報名參加活動"
msgstr "立即報名參加活動"

#: apps/dp-client/src/components/Version/index.tsx:44
#: apps/dp-client/src/components/ExpoUpdate/index.tsx:70
#: apps/dp-business/src/components/ExpoUpdate/index.tsx:22
msgid "立即更新"
msgstr "立即更新"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:731
msgid "立即生效"
msgstr "立即生效"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:196
#: apps/dp-admin/src/pages/merchant/shop-detail/components/SharedTemplatesModal/index.web.tsx:71
msgid "立即確認"
msgstr "立即確認"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:381
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:185
msgid "立即續約"
msgstr "立即續約"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:59
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:59
msgid "立即處理"
msgstr "立即處理"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1057
msgid "立即訂購"
msgstr "立即訂購"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/NoDiscount.tsx:31
msgid "立即開通享有更多曝光機會與補貼資源。"
msgstr "立即開通享有更多曝光機會與補貼資源。"

#: apps/dp-client/src/screens/login/components/fet-login-modal/index.tsx:217
#: apps/dp-business/src/pages/MarketingCenter/components/PreviewCard.tsx:77
msgid "立即領取"
msgstr "立即領取"

#: apps/dp-client/src/screens/home/pages/MediaGift/index.tsx:193
msgid "立即領取專屬福利"
msgstr "立即領取專屬福利"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:29
msgid "立減"
msgstr "立減"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1541
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:44
#: apps/dp-admin/src/modules/constants/options.ts:233
msgid "立減券"
msgstr "立減券"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:150
msgid "站內信"
msgstr "站內信"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/InAppTemplateSection.web.tsx:24
msgid "站內信內容不能超過150字"
msgstr "站內信內容不能超過150字"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/InAppTemplateSection.web.tsx:23
msgid "站內信內容可包含多個佔位符, 佔位符規範：｛中間填寫英文｝"
msgstr "站內信內容可包含多個佔位符, 佔位符規範：｛中間填寫英文｝"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/InAppTemplateSection.web.tsx:16
msgid "站內信標題不能超過20字"
msgstr "站內信標題不能超過20字"

#: apps/dp-business/src/store/HolidayContext.tsx:134
#: apps/dp-business/src/store/HolidayContext.tsx:152
msgid "端午"
msgstr "端午"

#: apps/dp-business/src/store/HolidayContext.tsx:134
msgid "端午節"
msgstr "端午節"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1944
msgid "端午節活動"
msgstr "端午節活動"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:358
msgid "符合圈選條件的門市數量"
msgstr "符合圈選條件的門市數量"

#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:199
msgid "符合條件的商家"
msgstr "符合條件的商家"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:84
msgid "符合藍新資格"
msgstr "符合藍新資格"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFilter.tsx:42
msgid "符合門檻"
msgstr "符合門檻"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:358
msgid "第"
msgstr "第"

#. placeholder {0}: index + 1
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:128
msgid "第 {0} 位"
msgstr "第 {0} 位"

#. placeholder {0}: i + 1
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:81
msgid "第 {0} 個停車場"
msgstr "第 {0} 個停車場"

#. placeholder {0}: depth + 1
#: apps/dp-admin/src/pages/org-tree/org-detail/services/apis.ts:64
msgid "第 {0} 級"
msgstr "第 {0} 級"

#. placeholder {0}: index + 1
#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:102
msgid "第 {0} 行參數缺少 key，請補充後再提交"
msgstr "第 {0} 行參數缺少 key，請補充後再提交"

#. placeholder {0}: i + 1
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/AddShopModal/index.web.tsx:47
msgid "第 {0} 行店家 ID 無效"
msgstr "第 {0} 行店家 ID 無效"

#. placeholder {0}: i + 1
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/AddShopModal/index.web.tsx:41
msgid "第 {0} 行格式錯誤：每行格式為「店家ID,樓層,位置描述」，請用換行分隔每條數據"
msgstr "第 {0} 行格式錯誤：每行格式為「店家ID,樓層,位置描述」，請用換行分隔每條數據"

#. placeholder {0}: range[0]
#. placeholder {1}: range[1]
#: apps/dp-admin/src/pages/resource-config/rank-list/components/RankDetailModal/index.web.tsx:142
msgid "第 {0}-{1} 條，共 {t_total} 條"
msgstr "第 {0}-{1} 條，共 {t_total} 條"

#. placeholder {0}: range[0]
#. placeholder {1}: range[1]
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:160
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1243
#: apps/dp-admin/src/pages/transaction/components/MerchantInfo/index.web.tsx:212
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:195
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1105
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:595
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1069
#: apps/dp-admin/src/pages/merchant/components/CommTable/index.web.tsx:53
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/PackageTemplateSection/index.web.tsx:68
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/CheckoutDiscountOrderSection/index.web.tsx:89
#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:535
#: apps/dp-admin/src/pages/marketing/user-activities/index.web.tsx:210
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/index.web.tsx:192
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponListModal.web.tsx:204
#: apps/dp-admin/src/pages/marketing/components/DiscountOrderListSection/index.web.tsx:126
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:237
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:207
#: apps/dp-admin/src/pages/data-center/merchant-reviews/index.web.tsx:185
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:483
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:212
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/index.web.tsx:291
#: apps/dp-admin/src/pages/audit-center/info-audit/components/InfoAuditTable/index.web.tsx:148
msgid "第 {0}-{1} 條，共 {total} 條"
msgstr "第 {0}-{1} 條，共 {total} 條"

#. placeholder {0}: range[0]
#. placeholder {1}: range[1]
#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:186
#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:142
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipantListTab.web.tsx:382
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/OrderListTab.web.tsx:66
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueDetailTab.web.tsx:159
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:228
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:389
msgid "第 {0}-{1} 條，共 {totalCount} 條"
msgstr "第 {0}-{1} 條，共 {totalCount} 條"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:42
msgid "第 {row} 條圍欄：中心點經度必填，範圍 -180~180"
msgstr "第 {row} 條圍欄：中心點經度必填，範圍 -180~180"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:45
msgid "第 {row} 條圍欄：中心點緯度必填，範圍 -90~90"
msgstr "第 {row} 條圍欄：中心點緯度必填，範圍 -90~90"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:48
msgid "第 {row} 條圍欄：半徑必填，且須大於 0"
msgstr "第 {row} 條圍欄：半徑必填，且須大於 0"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:128
msgid "第 1 位（同上級下最前）"
msgstr "第 1 位（同上級下最前）"

#. placeholder {0}: (page - 1) * pageSize + 1
#. placeholder {1}: Math.min(page * pageSize, totalItem)
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:224
msgid "第{0}-{1}條，共{totalItem}條"
msgstr "第{0}-{1}條，共{totalItem}條"

#. placeholder {0}: index + 1
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:390
msgid "第{0}步"
msgstr "第{0}步"

#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:107
msgid "第{chineseStepNumber}步"
msgstr "第{chineseStepNumber}步"

#: apps/dp-client/src/screens/home/pages/ShareKing/pages/RaffleWinners/index.tsx:173
msgid "第{period}期"
msgstr "第{period}期"

#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:407
msgid "第{winnerPeriodNumber}期中獎資訊"
msgstr "第{winnerPeriodNumber}期中獎資訊"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:48
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:70
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:92
msgid "第一步"
msgstr "第一步"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:62
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:52
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:66
msgid "第三方"
msgstr "第三方"

#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:405
msgid "第三方交易流水號"
msgstr "第三方交易流水號"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:57
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:51
msgid "第三方兌換券"
msgstr "第三方兌換券"

#: apps/dp-client/src/configs/page-configs.tsx:1880
msgid "第三方帳號"
msgstr "第三方帳號"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:103
msgid "第三方平台"
msgstr "第三方平台"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:218
msgid "第三方權益歸屬"
msgstr "第三方權益歸屬"

#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:413
msgid "第三方權益資料已帶回"
msgstr "第三方權益資料已帶回"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:460
msgid "第三方流水號"
msgstr "第三方流水號"

#: apps/dp-admin/src/router/config/routes.web.tsx:676
msgid "第三方渠道管理"
msgstr "第三方渠道管理"

#: apps/dp-client/src/configs/page-configs.tsx:1342
msgid "第三方登入"
msgstr "第三方登入"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:174
msgid "第三方登入後白畫面，無法進入首頁"
msgstr "第三方登入後白畫面，無法進入首頁"

#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:158
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/InvoiceInfoCard/index.web.tsx:52
msgid "第三方發票號"
msgstr "第三方發票號"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2374
msgid "第三方訂單號"
msgstr "第三方訂單號"

#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:402
msgid "第三方請款單號"
msgstr "第三方請款單號"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/RefundOrdersCard/index.web.tsx:59
msgid "第三方退款號"
msgstr "第三方退款號"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:58
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:80
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:102
msgid "第三步"
msgstr "第三步"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:53
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:75
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:97
msgid "第二步"
msgstr "第二步"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:63
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:85
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:107
msgid "第四步"
msgstr "第四步"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:19
msgid "第幾次發獎（整組共用同一個判定）"
msgstr "第幾次發獎（整組共用同一個判定）"

#: apps/dp-business/src/pages/OrderList/index.tsx:778
#: apps/dp-business/src/pages/OrderList/index.tsx:806
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesSummaryCards.tsx:42
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/index.tsx:142
#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:161
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/Statistics/index.web.tsx:90
msgid "筆"
msgstr "筆"

#: apps/dp-client/src/screens/home/utils/utils.ts:445
#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:427
#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:716
#: apps/dp-client/src/screens/home/pages/Review/pages/draft/index.tsx:19
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:274
#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:76
#: apps/dp-client/src/screens/account/pages/profile/components/ContentTabsSection/index.tsx:33
#: apps/dp-client/src/screens/account/pages/likes/pages/searchResult/index.tsx:31
#: apps/dp-client/src/screens/account/pages/likes/pages/main/index.tsx:15
#: apps/dp-client/src/screens/account/pages/favorites/pages/searchResult/index.tsx:338
#: apps/dp-client/src/screens/account/pages/favorites/pages/main/index.tsx:15
#: apps/dp-client/src/screens/account/pages/drafts/main/index.tsx:35
#: apps/dp-client/src/screens/account/pages/drafts/components/DraftCard.tsx:100
#: apps/dp-client/src/configs/page-configs.tsx:696
#: apps/dp-client/src/configs/page-configs.tsx:2732
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:296
msgid "筆記"
msgstr "筆記"

#. placeholder {0}: item.reviewAndNoteCntDisplay
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowUserListItem.tsx:101
msgid "筆記 評論 {0}"
msgstr "筆記 評論 {0}"

#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:29
msgid "筆記ID"
msgstr "筆記ID"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:309
msgid "筆記不存在"
msgstr "筆記不存在"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:598
msgid "筆記刪除成功"
msgstr "筆記刪除成功"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:145
msgid "筆記審批"
msgstr "筆記審批"

#: apps/dp-client/src/configs/page-configs.tsx:2750
msgid "筆記徵集"
msgstr "筆記徵集"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:91
msgid "筆記投訴"
msgstr "筆記投訴"

#: apps/dp-client/src/screens/account/pages/favorites/components/NotesContent/index.tsx:131
msgid "筆記收藏夾空空的"
msgstr "筆記收藏夾空空的"

#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:65
msgid "筆記數"
msgstr "筆記數"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:158
msgid "筆記數量"
msgstr "筆記數量"

#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:349
msgid "筆記更新成功"
msgstr "筆記更新成功"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:105
msgid "筆記次數"
msgstr "筆記次數"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/index.tsx:461
msgid "筆記訊息不存在"
msgstr "筆記訊息不存在"

#: apps/dp-client/src/configs/page-configs.tsx:767
msgid "筆記詳情"
msgstr "筆記詳情"

#: apps/dp-business/src/pages/OrderDetails/components/OrderListCard.tsx:65
msgid "筆記錄"
msgstr "筆記錄"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PreviewCard.tsx:96
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PreviewCard.tsx:103
msgid "等"
msgstr "等"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/constants.ts:224
msgid "等待上架"
msgstr "等待上架"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/utils/activityUtils.ts:70
msgid "等待中"
msgstr "等待中"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:514
msgid "等待商家確認中"
msgstr "等待商家確認中"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:567
msgid "等待支付"
msgstr "等待支付"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/constants.ts:18
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:22
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:18
#: apps/dp-admin/src/modules/constants/userGroup.ts:123
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:117
msgid "等於"
msgstr "等於"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:434
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:161
msgid "節假日不可用"
msgstr "節假日不可用"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:135
msgid "節假日列表"
msgstr "節假日列表"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1850
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2006
msgid "節假日可用"
msgstr "節假日可用"

#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:24
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:88
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:32
msgid "節假日名稱"
msgstr "節假日名稱"

#: apps/dp-admin/src/router/config/routes.web.tsx:668
msgid "節假日管理"
msgstr "節假日管理"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1753
msgid "節假日設置"
msgstr "節假日設置"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:51
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:34
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:61
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:165
msgid "節點"
msgstr "節點"

#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:78
msgid "節點信息"
msgstr "節點信息"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailBasicInfo.tsx:38
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:204
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeBasicInfo/index.web.tsx:102
#: apps/dp-admin/src/pages/org-tree/org-detail/components/AddChildNodeModal/index.web.tsx:57
#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:80
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:35
msgid "節點名稱"
msgstr "節點名稱"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:210
#: apps/dp-admin/src/pages/org-tree/org-detail/components/AddChildNodeModal/index.web.tsx:63
#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:86
msgid "節點名稱不能超過 {NODE_NAME_MAX_LENGTH} 個字符"
msgstr "節點名稱不能超過 {NODE_NAME_MAX_LENGTH} 個字符"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeSearchForm/index.web.tsx:33
msgid "節點名稱檢索"
msgstr "節點名稱檢索"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:54
msgid "節點商家"
msgstr "節點商家"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailBasicInfo.tsx:53
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeBasicInfo/index.web.tsx:74
msgid "節點基本信息"
msgstr "節點基本信息"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailBasicInfo.tsx:44
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:219
#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:95
msgid "節點層級"
msgstr "節點層級"

#: apps/dp-business/src/store/ChainBootstrapContext.tsx:125
msgid "節點已停用無法跳轉"
msgstr "節點已停用無法跳轉"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeBasicInfo/index.web.tsx:108
msgid "節點狀態"
msgstr "節點狀態"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:101
msgid "節點管理員"
msgstr "節點管理員"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:192
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:247
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountCopyForm.tsx:79
msgid "節點角色組合數量超出上限"
msgstr "節點角色組合數量超出上限"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailBasicInfo.tsx:41
#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:92
msgid "節點路徑"
msgstr "節點路徑"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:210
msgid "算了"
msgstr "算了"

#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:13
msgid "算法"
msgstr "算法"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:252
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:401
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:32
msgid "管理"
msgstr "管理"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:31
msgid "管理（簽約）"
msgstr "管理（簽約）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:72
msgid "管理人Email"
msgstr "管理人Email"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:251
msgid "管理人中文姓名"
msgstr "管理人中文姓名"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:271
msgid "管理人手機號"
msgstr "管理人手機號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:289
msgid "管理人英文名（名在前／姓在後）"
msgstr "管理人英文名（名在前／姓在後）"

#: apps/dp-admin/src/pages/users/services/apis.ts:390
msgid "管理使用者角色"
msgstr "管理使用者角色"

#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:155
msgid "管理和審核商家入駐相關任務"
msgstr "管理和審核商家入駐相關任務"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/index.web.tsx:275
msgid "管理和審核商家提交的套餐券模板"
msgstr "管理和審核商家提交的套餐券模板"

#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:255
msgid "管理和審核商家資訊相關任務"
msgstr "管理和審核商家資訊相關任務"

#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:151
msgid "管理和審核店家商家綁定相關任務"
msgstr "管理和審核店家商家綁定相關任務"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:214
msgid "管理和審核發票相關任務"
msgstr "管理和審核發票相關任務"

#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:134
msgid "管理和審核簽約相關任務"
msgstr "管理和審核簽約相關任務"

#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:152
msgid "管理和審核結算相關任務"
msgstr "管理和審核結算相關任務"

#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:260
msgid "管理和審核評價相關任務"
msgstr "管理和審核評價相關任務"

#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:238
msgid "管理和審核資訊報錯相關任務"
msgstr "管理和審核資訊報錯相關任務"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/index.web.tsx:112
msgid "管理和查看商家的所有用戶評論"
msgstr "管理和查看商家的所有用戶評論"

#: apps/dp-admin/src/pages/merchant/brand-list/index.web.tsx:137
msgid "管理和查看所有品牌資訊"
msgstr "管理和查看所有品牌資訊"

#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:421
msgid "管理和查看所有用戶的券包資訊"
msgstr "管理和查看所有用戶的券包資訊"

#: apps/dp-admin/src/pages/user-info/user-list/index.web.tsx:155
msgid "管理和查看所有用戶資訊"
msgstr "管理和查看所有用戶資訊"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:40
msgid "管理員"
msgstr "管理員"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailManagers.tsx:36
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:73
msgid "管理員信息"
msgstr "管理員信息"

#: apps/dp-admin/src/components/AdminUserSelect/index.web.tsx:29
msgid "管理員帳號載入失敗"
msgstr "管理員帳號載入失敗"

#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:99
#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:155
msgid "管理員資訊"
msgstr "管理員資訊"

#: apps/dp-admin/src/pages/merchant/task-list/index.web.tsx:175
msgid "管理商家相關任務，支援搜尋篩選、批量分配和批量創建功能"
msgstr "管理商家相關任務，支援搜尋篩選、批量分配和批量創建功能"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/index.web.tsx:38
msgid "管理平台商場與夜市商圈 POI，支援查詢、上下架與關聯店家管理"
msgstr "管理平台商場與夜市商圈 POI，支援查詢、上下架與關聯店家管理"

#: apps/dp-admin/src/pages/merchant/shop-list/index.web.tsx:203
msgid "管理店家資訊，支援搜尋篩選、批量分配和狀態管理功能"
msgstr "管理店家資訊，支援搜尋篩選、批量分配和狀態管理功能"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:544
msgid "管理後臺"
msgstr "管理後臺"

#: apps/dp-admin/src/pages/merchant/my-task/index.web.tsx:166
msgid "管理我的相關任務，支持搜索篩選、批量分配和批量創建功能"
msgstr "管理我的相關任務，支持搜索篩選、批量分配和批量創建功能"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/index.web.tsx:47
msgid "管理指定商場/夜市商圈下的活動位配置"
msgstr "管理指定商場/夜市商圈下的活動位配置"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:386
msgid "管理掛接（可多棵樹）"
msgstr "管理掛接（可多棵樹）"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:347
msgid "管理掛接可多條；結算路徑僅一條，請在上方結算區塊更換"
msgstr "管理掛接可多條；結算路徑僅一條，請在上方結算區塊更換"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:346
msgid "管理掛接可多條；結算路徑全店僅一條"
msgstr "管理掛接可多條；結算路徑全店僅一條"

#: apps/dp-admin/src/pages/resource-config/rank-list/index.web.tsx:78
msgid "管理榜單型別配置，包括店家榜、餐點榜、品牌榜等"
msgstr "管理榜單型別配置，包括店家榜、餐點榜、品牌榜等"

#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:263
msgid "管理活動配置，創建和編輯活動"
msgstr "管理活動配置，創建和編輯活動"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:279
msgid "管理渠道活動配置、渠道範圍與套餐權益"
msgstr "管理渠道活動配置、渠道範圍與套餐權益"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:583
msgid "管理的合約"
msgstr "管理的合約"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:87
msgid "管理端"
msgstr "管理端"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:90
msgid "管理節點"
msgstr "管理節點"

#: apps/dp-admin/src/pages/resource-config/message-template-list/index.web.tsx:215
msgid "管理系統中的消息模板配置"
msgstr "管理系統中的消息模板配置"

#: apps/dp-admin/src/pages/users/permissions/index.web.tsx:154
msgid "管理系統菜單、頁面和按鈕權限，控制用戶訪問範圍"
msgstr "管理系統菜單、頁面和按鈕權限，控制用戶訪問範圍"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:228
#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:104
#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:159
msgid "管理者信箱"
msgstr "管理者信箱"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:227
#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:103
#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:158
msgid "管理者姓名"
msgstr "管理者姓名"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/ContactInfo/index.web.tsx:38
#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:161
msgid "管理者帳號密碼為企業會員的最高權限人員所持有，該人員即為本服務主要聯絡人，請正確填寫。"
msgstr "管理者帳號密碼為企業會員的最高權限人員所持有，該人員即為本服務主要聯絡人，請正確填寫。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:229
#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:105
#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:160
msgid "管理者手機"
msgstr "管理者手機"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:122
msgid "管理者手機須為 09 開頭的 10 位號碼"
msgstr "管理者手機須為 09 開頭的 10 位號碼"

#: apps/dp-admin/src/pages/resource-config/landing-page-list/index.web.tsx:45
msgid "管理落地頁配置，支持查詢、批量啟用與停用"
msgstr "管理落地頁配置，支持查詢、批量啟用與停用"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:317
#: apps/dp-business/src/components/InvoiceForm/index.tsx:370
msgid "管理處"
msgstr "管理處"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:245
msgid "管理訂單"
msgstr "管理訂單"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/index.web.tsx:49
msgid "管理資源位置配置，包括活動位和瀑布流插卡運營位"
msgstr "管理資源位置配置，包括活動位和瀑布流插卡運營位"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:131
msgid "管理通知"
msgstr "管理通知"

#: apps/dp-admin/src/pages/resource-config/message-list/index.web.tsx:72
msgid "管理通知的創建與發送"
msgstr "管理通知的創建與發送"

#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:372
msgid "管理金剛位和資源位的設定資訊"
msgstr "管理金剛位和資源位的設定資訊"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedMallTable/index.web.tsx:118
msgid "管轄商場／商圈"
msgstr "管轄商場／商圈"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailMallTable.tsx:72
msgid "管轄商場／夜市商圈"
msgstr "管轄商場／夜市商圈"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:516
msgid "管轄商場載入失敗"
msgstr "管轄商場載入失敗"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:169
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:257
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:41
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:42
msgid "管轄店家"
msgstr "管轄店家"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:461
msgid "管轄店家載入失敗"
msgstr "管轄店家載入失敗"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:139
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:192
msgid "箭頭"
msgstr "箭頭"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:733
msgid "範例圖"
msgstr "範例圖"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:721
msgid "範例圖片"
msgstr "範例圖片"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:168
msgid "範本一對一對應："
msgstr "範本一對一對應："

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/channelCampaignPackageActions.ts:49
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/channelCampaignPackageActions.ts:64
msgid "範本下載失敗"
msgstr "範本下載失敗"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:44
msgid "範本依所選參數一對一對應"
msgstr "範本依所選參數一對一對應"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:161
msgid "範本包含「一級渠道／一級渠道代碼／二級渠道／二級渠道代碼／三級渠道／三級渠道代碼」六欄，請保留原有欄位名稱與順序。"
msgstr "範本包含「一級渠道／一級渠道代碼／二級渠道／二級渠道代碼／三級渠道／三級渠道代碼」六欄，請保留原有欄位名稱與順序。"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:184
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:382
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:295
msgid "篩選"
msgstr "篩選"

#: apps/dp-business/src/pages/RefundList/index.tsx:344
#: apps/dp-business/src/pages/OrderOverview/FilterModal.tsx:193
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:68
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageSourceField/index.web.tsx:78
#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:153
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:865
#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:702
msgid "篩選條件"
msgstr "篩選條件"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:178
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:194
msgid "篩選項"
msgstr "篩選項"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:422
#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:717
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopBrandStory.tsx:33
msgid "簡介"
msgstr "簡介"

#: apps/dp-business/src/pages/SimpleDashboard/components/ModeSwitchTabs.tsx:88
msgid "簡易版"
msgstr "簡易版"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:149
msgid "簡訊"
msgstr "簡訊"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/SmsTemplateSection.web.tsx:117
msgid "簡訊內容可包含多個佔位符，佔位符規範：｛中間填寫英文｝。"
msgstr "簡訊內容可包含多個佔位符，佔位符規範：｛中間填寫英文｝。"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/SmsTemplateSection.web.tsx:94
msgid "簡訊文案不得換行，單條字數最多70字，字數超過時會做為第二則簡訊發送。"
msgstr "簡訊文案不得換行，單條字數最多70字，字數超過時會做為第二則簡訊發送。"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/SmsTemplateSection.web.tsx:92
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/SmsTemplateSection.web.tsx:122
msgid "簡訊模板"
msgstr "簡訊模板"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/SmsTemplateSection.web.tsx:103
msgid "簡訊模板類型"
msgstr "簡訊模板類型"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:55
msgid "簡訊驗證"
msgstr "簡訊驗證"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:191
msgid "簽名檔不能超過{MAX_LENGTH}個字符"
msgstr "簽名檔不能超過{MAX_LENGTH}個字符"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:77
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:196
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:214
msgid "簽名檔最多輸入{MAX_ROWS}行"
msgstr "簽名檔最多輸入{MAX_ROWS}行"

#: apps/dp-admin/src/modules/hooks/usePrivateImage.ts:49
msgid "簽名獲取失敗"
msgstr "簽名獲取失敗"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:143
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:77
msgid "簽約"
msgstr "簽約"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:75
msgid "簽約 / 請款"
msgstr "簽約 / 請款"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:170
msgid "簽約 / 請款主體"
msgstr "簽約 / 請款主體"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:76
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:98
msgid "簽約_{batchId}.xlsx"
msgstr "簽約_{batchId}.xlsx"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:54
msgid "簽約／請款不受影響，不自動解綁"
msgstr "簽約／請款不受影響，不自動解綁"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:55
msgid "簽約／請款商家"
msgstr "簽約／請款商家"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:250
msgid "簽約中"
msgstr "簽約中"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/ContractTypeForm/index.web.tsx:37
msgid "簽約主體"
msgstr "簽約主體"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:186
msgid "簽約主體類型"
msgstr "簽約主體類型"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractUpload/index.web.tsx:27
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/ContractUpload/index.web.tsx:31
msgid "簽約合約"
msgstr "簽約合約"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:90
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:132
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:167
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractUpload/components/ContractInfo/index.web.tsx:48
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:101
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:30
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/ContractUpload/components/ContractInfo/index.web.tsx:48
msgid "簽約合約掃描件"
msgstr "簽約合約掃描件"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:117
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailMerchants.tsx:76
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:141
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/columns.web.tsx:64
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:43
msgid "簽約商家"
msgstr "簽約商家"

#. placeholder {0}: detail?.contractMerchant?.merchantName || '-'
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:130
msgid "簽約商家：{0}"
msgstr "簽約商家：{0}"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:172
msgid "簽約商家名稱/統編"
msgstr "簽約商家名稱/統編"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:209
msgid "簽約失敗"
msgstr "簽約失敗"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:92
msgid "簽約完成"
msgstr "簽約完成"

#: apps/dp-admin/src/router/config/routes.web.tsx:432
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:133
msgid "簽約審核"
msgstr "簽約審核"

#: apps/dp-admin/src/modules/constants/options.ts:53
msgid "簽約推進中"
msgstr "簽約推進中"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:181
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/BasicInfo/index.web.tsx:80
msgid "簽約日期"
msgstr "簽約日期"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:316
#: apps/dp-business/src/pages/ContractManagement/index.tsx:464
#: apps/dp-admin/src/pages/merchant/signing-management/index.web.tsx:130
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:138
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:715
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:330
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:98
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:125
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:667
msgid "簽約時間"
msgstr "簽約時間"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:310
msgid "簽約標籤"
msgstr "簽約標籤"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:617
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/SigningStatus/index.web.tsx:31
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:74
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:60
#: apps/dp-admin/src/pages/merchant/signing-management/index.web.tsx:124
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:126
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:89
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:520
msgid "簽約狀態"
msgstr "簽約狀態"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:312
msgid "簽約節點"
msgstr "簽約節點"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:147
msgid "簽約管理"
msgstr "簽約管理"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:166
msgid "簽約結束時間"
msgstr "簽約結束時間"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/ContractSettings/index.web.tsx:30
msgid "簽約設定"
msgstr "簽約設定"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:359
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:695
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:712
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:157
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:132
msgid "簽約詳情"
msgstr "簽約詳情"

#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:71
msgid "簽約通道更多營銷服務"
msgstr "簽約通道更多營銷服務"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/OverviewCards.web.tsx:30
msgid "簽約進度"
msgstr "簽約進度"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:161
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractUpload/components/ContractInfo/index.web.tsx:31
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:89
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/ContractUpload/components/ContractInfo/index.web.tsx:32
msgid "簽約開始時間"
msgstr "簽約開始時間"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:665
msgid "簽約開通更多營銷服務"
msgstr "簽約開通更多營銷服務"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:722
msgid "簽約類型"
msgstr "簽約類型"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:38
#: apps/dp-admin/src/pages/transaction/contract-management/components/NoContractView/index.web.tsx:48
msgid "簽署合約"
msgstr "簽署合約"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:393
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:483
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:180
msgid "米"
msgstr "米"

#: apps/dp-client/src/screens/account/pages/user-profile/components/UserInfoSection/index.tsx:144
#: apps/dp-client/src/screens/account/pages/profile/components/UserInfoSection/index.tsx:118
#: apps/dp-client/src/screens/account/pages/follow-list/index.tsx:17
msgid "粉絲"
msgstr "粉絲"

#. placeholder {0}: item.followerCntDisplay
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowUserListItem.tsx:95
msgid "粉絲 {0}"
msgstr "粉絲 {0}"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:121
msgid "粗斜體"
msgstr "粗斜體"

#: apps/dp-business/src/data/categories.ts:54
#: apps/dp-admin/src/pages/user-info/services/apis.ts:144
msgid "粵菜"
msgstr "粵菜"

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:68
#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:77
#: apps/dp-client/src/screens/home/pages/Review/pages/complete/index.tsx:86
msgid "精品咖啡"
msgstr "精品咖啡"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:93
msgid "精確匹配"
msgstr "精確匹配"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:33
msgid "精確查找"
msgstr "精確查找"

#: apps/dp-client/src/screens/home/pages/Home/components/PackageZoneEntry/index.tsx:48
msgid "精選好券 · 限時優惠搶購"
msgstr "精選好券 · 限時優惠搶購"

#: apps/dp-client/src/screens/home/pages/MallDetail/index.tsx:323
msgid "精選店家"
msgstr "精選店家"

#. placeholder {0}: activeFloorName ? `_${activeFloorName}` : '_全部'
#. placeholder {1}: shop.name
#. placeholder {2}: shop.shopId
#. placeholder {3}: index + 1
#: apps/dp-client/src/screens/home/pages/MallDetail/index.tsx:267
msgid "精選店家{0}_{1}_{2}_{3}"
msgstr "精選店家{0}_{1}_{2}_{3}"

#: apps/dp-client/src/screens/home/pages/PrivateChef/constants.ts:20
msgid "精選高品質聚餐體驗"
msgstr "精選高品質聚餐體驗"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:27
msgid "系列榜單"
msgstr "系列榜單"

#: apps/dp-business/src/types/orderFilter.ts:184
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:250
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:400
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/SigningAuditTab/index.web.tsx:152
msgid "系統"
msgstr "系統"

#: apps/dp-business/src/utils/download.ts:112
msgid "系統不支持分享功能"
msgstr "系統不支持分享功能"

#: apps/dp-business/src/constants/enums.ts:517
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:27
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:122
msgid "系統內建"
msgstr "系統內建"

#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:129
msgid "系統創建"
msgstr "系統創建"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyItem.web.tsx:33
msgid "系統回覆"
msgstr "系統回覆"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:81
msgid "系統導入"
msgstr "系統導入"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/ImageUploadTips/index.web.tsx:166
msgid "系統已存在的相似商家"
msgstr "系統已存在的相似商家"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:140
msgid "系統未找到相似商家，請到"
msgstr "系統未找到相似商家，請到"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:470
msgid "系統未找到相似店家家，請到"
msgstr "系統未找到相似店家家，請到"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:681
msgid "系統未檢測到套餐券內容變更~"
msgstr "系統未檢測到套餐券內容變更~"

#: apps/dp-client/src/screens/diary/components/content-warn-modal/index.tsx:62
msgid "系統檢測到您發表的內容多數不符基本品質，為保障平台活動公平性，若再次出現灌水內容，會影響您取得積分的資格"
msgstr "系統檢測到您發表的內容多數不符基本品質，為保障平台活動公平性，若再次出現灌水內容，會影響您取得積分的資格"

#: apps/dp-client/src/screens/diary/hooks/useUserPunishmentCheck.ts:72
msgid "系統檢測到您近日發表的日記內容品質有疑慮，為保障平台活動公平性於{endDate}前已暫停獲取積分，請再留意內容完整度與相關性以免影響活動資格，懇請見諒"
msgstr "系統檢測到您近日發表的日記內容品質有疑慮，為保障平台活動公平性於{endDate}前已暫停獲取積分，請再留意內容完整度與相關性以免影響活動資格，懇請見諒"

#: apps/dp-client/src/screens/diary/hooks/useUserPunishmentCheck.ts:67
#: apps/dp-client/src/screens/diary/hooks/useUserPunishmentCheck.ts:75
msgid "系統檢測到您近日發表的日記內容品質有疑慮，為保障平台活動公平性請稍加留意內容完整度與相關性，以免影響您取得積分的資格"
msgstr "系統檢測到您近日發表的日記內容品質有疑慮，為保障平台活動公平性請稍加留意內容完整度與相關性，以免影響您取得積分的資格"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:416
msgid "系統檢測到該商家還未設置服務，是否繼續設置服務"
msgstr "系統檢測到該商家還未設置服務，是否繼續設置服務"

#: apps/dp-business/src/utils/passwordManager.ts:179
msgid "系統的「自動填入」服務尚未開啟，登入密碼無法保存。開啟後，下次登入即可自動填入帳號密碼。"
msgstr "系統的「自動填入」服務尚未開啟，登入密碼無法保存。開啟後，下次登入即可自動填入帳號密碼。"

#: apps/dp-business/src/utils/passwordManager.ts:408
msgid "系統的密碼管理服務目前無法保存密碼，可能是服務未登入帳號或設定有誤。請至系統設定檢查，或改用其他密碼管理服務。"
msgstr "系統的密碼管理服務目前無法保存密碼，可能是服務未登入帳號或設定有誤。請至系統設定檢查，或改用其他密碼管理服務。"

#: apps/dp-client/src/configs/page-configs.tsx:33
msgid "系統維護"
msgstr "系統維護"

#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:67
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:158
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:54
msgid "系統編號"
msgstr "系統編號"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:196
msgid "系統自動"
msgstr "系統自動"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:68
#: apps/dp-admin/src/pages/customer-service/services/constants.ts:15
msgid "系統自動已解決"
msgstr "系統自動已解決"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:127
msgid "系統自動觸發"
msgstr "系統自動觸發"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:668
#: apps/dp-admin/src/pages/order/services/utils.ts:419
msgid "系統自動退款"
msgstr "系統自動退款"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:179
msgid "系統角色"
msgstr "系統角色"

#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:198
#: apps/dp-client/src/screens/account/pages/notifications/pages/CategoryNotifications/index.tsx:47
#: apps/dp-business/src/store/NotificationContext.tsx:826
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:113
#: apps/dp-admin/src/pages/other/services/constants.ts:43
msgid "系統通知"
msgstr "系統通知"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2520
#: apps/dp-admin/src/pages/order/services/utils.ts:591
msgid "系統過期"
msgstr "系統過期"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:236
msgid "系統預設"
msgstr "系統預設"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:458
msgid "系統預設任務圖示"
msgstr "系統預設任務圖示"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:268
msgid "系統預設使用固定任務圖示，可切換為自訂上傳。"
msgstr "系統預設使用固定任務圖示，可切換為自訂上傳。"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:60
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:61
msgid "紅燒牛肉麵"
msgstr "紅燒牛肉麵"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:165
msgid "紅色"
msgstr "紅色"

#: apps/dp-admin/src/pages/org-tree/org-create/components/EditableOrgTree/index.web.tsx:49
msgid "純管理"
msgstr "純管理"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreName/index.web.tsx:70
msgid "純英文、數字，可接受\"-\",\"_\"及空格"
msgstr "純英文、數字，可接受\"-\",\"_\"及空格"

#: apps/dp-admin/src/pages/split-account/services/constants.ts:273
#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:141
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:216
msgid "紙本發票"
msgstr "紙本發票"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:340
msgid "紙本發票/收據請郵寄至地址：臺北市承德路一段70號18樓"
msgstr "紙本發票/收據請郵寄至地址：臺北市承德路一段70號18樓"

#: apps/dp-admin/src/pages/split-account/services/constants.ts:261
msgid "紙質發票申請中"
msgstr "紙質發票申請中"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:167
msgid "紫紅色"
msgstr "紫紅色"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:168
msgid "紫色"
msgstr "紫色"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:310
msgid "累積{totalCount}次打卡"
msgstr "累積{totalCount}次打卡"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:334
msgid "累積打卡"
msgstr "累積打卡"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:90
msgid "累積更多點數，即可兌換"
msgstr "累積更多點數，即可兌換"

#: apps/dp-business/src/pages/OrderList/index.tsx:723
msgid "累積營業額"
msgstr "累積營業額"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/exchange/index.tsx:177
msgid "累積越多點數兌換美食金更划算"
msgstr "累積越多點數兌換美食金更划算"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:442
msgid "累計"
msgstr "累計"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/OverviewCards.web.tsx:58
msgid "累計交易用戶"
msgstr "累計交易用戶"

#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitSummaryCard.tsx:84
msgid "累計增加流量"
msgstr "累計增加流量"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:146
msgid "累計已生成張數"
msgstr "累計已生成張數"

#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitSummaryCard.tsx:91
msgid "累計獲得補貼"
msgstr "累計獲得補貼"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/OverviewCards.web.tsx:40
msgid "累計用戶數"
msgstr "累計用戶數"

#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitSummaryCard.tsx:74
msgid "累計節省佣金"
msgstr "累計節省佣金"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/OverviewCards.web.tsx:67
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/OverviewCards.web.tsx:58
msgid "累計評論"
msgstr "累計評論"

#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:207
msgid "終止"
msgstr "終止"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:218
msgid "終止活動"
msgstr "終止活動"

#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:94
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:148
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:151
msgid "終止活動失敗"
msgstr "終止活動失敗"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:154
msgid "組件名稱必須以大寫字母開頭，只能包含字母和數字"
msgstr "組件名稱必須以大寫字母開頭，只能包含字母和數字"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:119
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:102
#: apps/dp-admin/src/modules/constants/userGroup.ts:43
msgid "組合名單"
msgstr "組合名單"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:131
msgid "組合邏輯"
msgstr "組合邏輯"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:409
msgid "組織已生效，管理員權限同步中"
msgstr "組織已生效，管理員權限同步中"

#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreePanel.tsx:49
msgid "組織架構"
msgstr "組織架構"

#: apps/dp-admin/src/pages/org-tree/org-list/components/ApplicationModal/index.web.tsx:72
#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:141
msgid "組織樹"
msgstr "組織樹"

#. placeholder {0}: tree.treeId
#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeSwitcher.tsx:51
msgid "組織樹 {0}"
msgstr "組織樹 {0}"

#. placeholder {0}: record?.chainName || ''
#: apps/dp-admin/src/pages/org-tree/org-list/components/AssignBdModal/index.web.tsx:55
msgid "組織樹：{0}"
msgstr "組織樹：{0}"

#. placeholder {0}: chainName || '-'
#. placeholder {1}: businessData?.treeId || '-'
#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:169
msgid "組織樹：{0}（{1}）"
msgstr "組織樹：{0}（{1}）"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1561
msgid "組織樹最多 {MAX_NODE_LEVEL} 層，不能再新增子節點"
msgstr "組織樹最多 {MAX_NODE_LEVEL} 層，不能再新增子節點"

#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:41
#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:43
#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:47
msgid "組織樹名稱"
msgstr "組織樹名稱"

#: apps/dp-admin/src/router/config/routes.web.tsx:318
msgid "組織樹審核"
msgstr "組織樹審核"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:249
msgid "組織樹審核詳情"
msgstr "組織樹審核詳情"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/ChainPermissionPanel.tsx:84
msgid "組織樹已下架，暫不可用"
msgstr "組織樹已下架，暫不可用"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:218
msgid "組織樹管理"
msgstr "組織樹管理"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:980
msgid "組織樹結構未就緒，請刷新後重試"
msgstr "組織樹結構未就緒，請刷新後重試"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:136
msgid "結合所有功能的完整示例"
msgstr "結合所有功能的完整示例"

#: apps/dp-client/src/configs/page-configs.tsx:788
#: apps/dp-business/src/pages/RefundList/index.tsx:88
#: apps/dp-business/src/pages/RefundList/index.tsx:118
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFilter.tsx:36
#: apps/dp-business/src/pages/ContractManagement/index.tsx:192
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:58
#: apps/dp-admin/src/pages/order/services/utils.ts:79
#: apps/dp-admin/src/pages/marketing/services/constants.ts:12
#: apps/dp-admin/src/modules/constants/options.ts:423
msgid "結帳優惠"
msgstr "結帳折扣"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/index.web.tsx:186
msgid "結帳優惠訂單"
msgstr "結帳優惠訂單"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/CheckoutDiscountOrderSection/index.web.tsx:81
msgid "結帳優惠訂單列表"
msgstr "結帳優惠訂單列表"

#. placeholder {0}: totalRate.toFixed(0)
#. placeholder {0}: userRate.toFixed(0)
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:235
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:252
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:269
msgid "結帳即享{0}%折扣"
msgstr "結帳即享{0}%折扣"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:263
msgid "結帳即享折扣"
msgstr "結帳即享折扣"

#: apps/dp-client/src/screens/home/utils/filterData.ts:174
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:2013
#: apps/dp-client/src/screens/home/pages/Purchase/components/PurchaseModal/index.tsx:61
#: apps/dp-client/src/screens/home/pages/Home/components/RecommendMasonryList/RecommendCard/Shop.tsx:76
#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/UsergiftBanner.tsx:388
#: apps/dp-client/src/screens/home/pages/FoodMap/components/HorizontalShopCard.tsx:214
#: apps/dp-client/src/screens/home/pages/FoodMap/components/ShopList/MapShopCard.tsx:283
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:84
#: apps/dp-client/src/screens/home/components/ShopCard/index.tsx:439
#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:113
#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:195
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:498
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:319
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:686
#: apps/dp-business/src/pages/SimpleDashboard/components/RedeemCard.tsx:85
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:425
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:699
#: apps/dp-business/src/pages/OrderList/index.tsx:622
#: apps/dp-business/src/pages/OrderList/index.tsx:893
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:740
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:124
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:116
#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:60
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:26
msgid "結帳折扣"
msgstr "結帳折扣"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:458
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1344
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1395
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1435
msgid "結帳折扣券"
msgstr "結帳折扣券"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1394
msgid "結帳折扣券最高減{merchantText}"
msgstr "結帳折扣券最高減{merchantText}"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1466
msgid "結帳折扣券最高減{offlinePlatformText}"
msgstr "結帳折扣券最高減{offlinePlatformText}"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:451
msgid "結帳折扣券最高減{platformDiscountText}"
msgstr "結帳折扣券最高減{platformDiscountText}"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1343
msgid "結帳折扣券最高減{platformText}"
msgstr "結帳折扣券最高減{platformText}"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/SubsidyCard.tsx:85
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:554
msgid "結帳折扣可用次數"
msgstr "結帳折扣可用次數"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:447
msgid "結帳折扣可用次數："
msgstr "結帳折扣可用次數："

#: apps/dp-business/src/pages/ChainDashboard/components/reports/CheckoutDiscountReport.tsx:107
#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:62
msgid "結帳折扣報表"
msgstr "結帳折扣報表"

#: apps/dp-business/src/pages/OrderList/index.tsx:726
msgid "結帳折扣營收（包含平台補貼）+ 套餐券核銷收入，不含退費"
msgstr "結帳折扣營收（包含平台補貼）+ 套餐券核銷收入，不含退費"

#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/index.tsx:133
msgid "結帳折扣營業額"
msgstr "結帳折扣營業額"

#: apps/dp-business/src/pages/OrderList/index.tsx:781
msgid "結帳折扣營業額/訂單數"
msgstr "結帳折扣營業額/訂單數"

#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/index.tsx:167
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/index.tsx:188
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:808
#: apps/dp-business/src/components/CustomTabs/index.tsx:172
msgid "結帳折扣訂單"
msgstr "結帳折扣訂單"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:879
msgid "結帳折扣退款"
msgstr "結帳折扣退款"

#: apps/dp-client/src/screens/account/pages/coupon/GiftRule/index.tsx:212
msgid "結帳折扣這樣用，看完立刻省！"
msgstr "結帳折扣這樣用，看完立刻省！"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:48
msgid "結帳時套用優惠券顯示已過期，但實際未過期"
msgstr "結帳時套用優惠券顯示已過期，但實際未過期"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:408
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:637
#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:92
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:33
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:780
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:290
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:563
msgid "結帳服務"
msgstr "結帳服務"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:660
#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:228
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:67
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:208
msgid "結帳服務設定"
msgstr "結帳服務設定"

#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:175
msgid "結帳比例"
msgstr "結帳比例"

#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:173
msgid "結帳設定"
msgstr "結帳設定"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:132
#: apps/dp-business/src/components/DatePicker.tsx:573
msgid "結束"
msgstr "結束"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:222
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:279
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:306
msgid "結束售賣時間"
msgstr "結束售賣時間"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/CountdownField/index.web.tsx:69
msgid "結束後字體顏色"
msgstr "結束後字體顏色"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/CountdownField/index.web.tsx:79
msgid "結束後底色"
msgstr "結束後底色"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:218
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:102
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:109
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BookingFeeRules/index.web.tsx:97
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:81
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/BookingFeeRules/index.web.tsx:83
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:56
#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:58
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:127
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:57
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:192
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:168
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:181
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/searchConfig.ts:47
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:169
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:318
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:93
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:122
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:117
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:168
msgid "結束日期"
msgstr "結束日期"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:100
msgid "結束日期必須晚於開始日期"
msgstr "結束日期必須晚於開始日期"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1046
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:202
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:481
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:506
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:545
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:577
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:803
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:367
#: apps/dp-business/src/components/DatePicker.tsx:582
#: apps/dp-business/src/components/TimePicker/TimePickerModal.tsx:109
#: apps/dp-business/src/components/CompactTimePicker/index.tsx:130
#: apps/dp-business/src/components/CompactTimePicker/index.tsx:132
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:154
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:153
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:163
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:173
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:94
#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:118
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:781
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1265
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1285
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:27
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:57
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:95
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:125
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:57
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:61
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:263
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:306
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/CountdownField/index.web.tsx:36
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:236
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:76
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:144
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:732
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:756
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:127
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:137
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:334
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/components/TimeSlotItem/index.web.tsx:96
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:114
#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:170
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:87
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:97
#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:64
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:228
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:82
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:92
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:121
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:394
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:142
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:68
#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:60
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:618
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:671
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:129
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:190
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:118
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:143
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/config.web.tsx:81
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:187
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:198
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:697
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:115
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:605
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:52
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:116
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:73
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:81
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:81
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:72
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:80
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:81
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:55
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:65
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:77
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:269
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:301
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:63
#: apps/dp-admin/src/components/BusinessHours/components/BusinessStatusSelector.web.tsx:134
msgid "結束時間"
msgstr "結束時間"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:403
msgid "結束時間（可選）"
msgstr "結束時間（可選）"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:51
msgid "結束時間必須晚於開始時間"
msgstr "結束時間必須晚於開始時間"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:204
msgid "結束時間為 23：59：59"
msgstr "結束時間為 23：59：59"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1313
msgid "結束販售時間"
msgstr "結束販售時間"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:176
msgid "結束銷售時間不能早於開始銷售時間"
msgstr "結束銷售時間不能早於開始銷售時間"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:36
msgid "結果元數據"
msgstr "結果元數據"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:532
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:800
msgid "結果描述"
msgstr "結果描述"

#: apps/dp-client/src/configs/page-configs.tsx:972
msgid "結果頁"
msgstr "結果頁"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:109
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:204
msgid "結案"
msgstr "結案"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:51
msgid "結構／管理員"
msgstr "結構／管理員"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:77
msgid "結算"
msgstr "結算"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:156
msgid "結算："
msgstr "結算："

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:164
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:459
msgid "結算主體"
msgstr "結算主體"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementPanel.tsx:95
msgid "結算主體："
msgstr "結算主體："

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:128
msgid "結算商家"
msgstr "結算商家"

#: apps/dp-admin/src/pages/org-tree/components/S9BlockModal/index.web.tsx:18
msgid "結算單"
msgstr "結算單"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:191
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:149
msgid "結算單ID"
msgstr "結算單ID"

#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:92
msgid "結算單交易明細"
msgstr "結算單交易明細"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:304
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:760
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:811
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementPanel.tsx:78
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementPanel.tsx:93
#: apps/dp-business/src/configs/page-configs.ts:838
#: apps/dp-business/src/components/CustomTabs/index.tsx:198
#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:76
#: apps/dp-admin/src/router/config/routes.web.tsx:527
#: apps/dp-admin/src/pages/split-account/settlement-list/index.web.tsx:42
msgid "結算單列表"
msgstr "結算單列表"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:252
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:283
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:390
msgid "結算單匯出失敗"
msgstr "結算單匯出失敗"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:251
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:282
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:389
msgid "結算單匯出成功"
msgstr "結算單匯出成功"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:910
msgid "結算單由連鎖統一核對，請到「連鎖視角 → 財務管理 → 結算單列表」查看，店家視角不展示結算單信息。"
msgstr "結算單由連鎖統一核對，請到「連鎖視角 → 財務管理 → 結算單列表」查看，店家視角不展示結算單信息。"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:740
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:908
#: apps/dp-admin/src/pages/split-account/settlement-list/index.web.tsx:35
msgid "結算單管理"
msgstr "結算單管理"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:643
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:177
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:153
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:453
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:24
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:70
msgid "結算單號"
msgstr "結算單號"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:605
msgid "結算單訂單列表"
msgstr "結算單訂單列表"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:636
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:651
#: apps/dp-business/src/configs/page-configs.ts:230
#: apps/dp-business/src/configs/page-configs.ts:853
msgid "結算單詳情"
msgstr "結算單詳情"

#: apps/dp-admin/src/router/config/routes.web.tsx:387
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:151
msgid "結算審核"
msgstr "結算審核"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/services/hooks.ts:230
msgid "結算審核任務完成"
msgstr "結算審核任務完成"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:326
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:426
msgid "結算審核詳情"
msgstr "結算審核詳情"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:71
msgid "結算改走"
msgstr "結算改走"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:164
msgid "結算於其他連鎖樹"
msgstr "結算於其他連鎖樹"

#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:197
msgid "結算時間"
msgstr "結算時間"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:138
msgid "結算歸屬待確認"
msgstr "結算歸屬待確認"

#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:42
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:342
msgid "結算狀態"
msgstr "結算狀態"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailMerchants.tsx:86
#: apps/dp-admin/src/pages/org-tree/org-detail/components/OrgNodeTree/index.web.tsx:106
msgid "結算節點"
msgstr "結算節點"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:47
msgid "結算落點"
msgstr "結算落點"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:298
msgid "結算訂單ID"
msgstr "結算訂單ID"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:107
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:58
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:174
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:45
msgid "結算路徑"
msgstr "結算路徑"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:145
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:380
msgid "結算路徑（全店唯一）"
msgstr "結算路徑（全店唯一）"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:361
msgid "結算路徑全店唯一。"
msgstr "結算路徑全店唯一。"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:160
msgid "結算通知"
msgstr "結算通知"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:672
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:188
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:194
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:489
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:52
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:97
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:162
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:319
msgid "結算週期"
msgstr "結算週期"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:524
msgid "結算金額"
msgstr "結算金額"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:106
#: apps/dp-admin/src/pages/marketing/services/constants.ts:499
msgid "結賬折扣"
msgstr "結賬折扣"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:94
#: apps/dp-admin/src/modules/constants/userGroup.ts:157
msgid "結賬折扣次數"
msgstr "結賬折扣次數"

#: apps/dp-client/src/screens/home/components/ShopRatingEntry/index.tsx:53
msgid "給餐廳評分"
msgstr "給餐廳評分"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:106
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:458
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:154
msgid "統一編碼"
msgstr "統一編碼"

#: apps/dp-admin/src/utils/common.ts:157
msgid "統一編碼格式不正確，必須為8位數字"
msgstr "統一編碼格式不正確，必須為8位數字"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:743
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:798
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:812
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:245
#: apps/dp-business/src/components/NecessaryDocuments/index.tsx:55
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:313
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:73
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/CompanyRegistration/index.web.tsx:60
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:101
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:217
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:74
#: apps/dp-admin/src/pages/merchant/shop-detail/components/DetailMobile/components/MerchantContactInfo.web.tsx:55
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:149
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/BusinessLicenseInfo/index.web.tsx:38
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:60
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:79
#: apps/dp-admin/src/pages/merchant/audit-detail/components/BusinessLicense/index.web.tsx:37
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:188
msgid "統一編號"
msgstr "統一編號"

#. placeholder {0}: formatEmpty(merchant.businessLicenseNo)
#: apps/dp-admin/src/pages/merchant/components/BdRelatedMerchantShopsPreviewModal/index.web.tsx:107
msgid "統一編號：{0}"
msgstr "統一編號：{0}"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:328
#: apps/dp-business/src/components/InvoiceForm/index.tsx:381
msgid "統一編號：60560109"
msgstr "統一編號：60560109"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:76
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/CompanyRegistration/index.web.tsx:65
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:222
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:156
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:67
msgid "統一編號必須為8位數字"
msgstr "統一編號必須為8位數字"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:390
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:142
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/services/utils.ts:45
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:159
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:170
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/services/utils.ts:45
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:547
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:298
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:213
msgid "統編"
msgstr "統編"

#. placeholder {0}: item.merchantBusinessLicenseNo
#. placeholder {0}: merchant.businessLicenseNo
#. placeholder {0}: merchant.taxId || '-'
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:173
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:146
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:468
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailMerchants.tsx:57
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:112
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:127
msgid "統編 {0}"
msgstr "統編 {0}"

#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:77
msgid "統編:"
msgstr "統編:"

#. placeholder {0}: merchant.taxId || '-'
#. placeholder {0}: row.merchantBusinessLicenseNo || '-'
#. placeholder {0}: taxId || '-'
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MountedShopTable/index.web.tsx:153
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:142
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/columns.web.tsx:22
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:102
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:105
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:322
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:325
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:65
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:68
msgid "統編：{0}"
msgstr "統編：{0}"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:21
msgid "統計時間"
msgstr "統計時間"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/index.tsx:159
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/index.tsx:175
msgid "統計結果依下方篩選條件即時計算；均不計已退款"
msgstr "統計結果依下方篩選條件即時計算；均不計已退款"

#: apps/dp-business/src/pages/OrderList/index.tsx:705
msgid "統計結果基於下方搜索條件數據實時計算"
msgstr "統計結果基於下方搜索條件數據實時計算"

#: apps/dp-client/src/bootstrap/hooks/useNotificationStatsLifecycle.ts:57
msgid "統計請求未成功更新"
msgstr "統計請求未成功更新"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:161
msgid "統計資訊"
msgstr "統計資訊"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:484
#: apps/dp-client/src/configs/page-configs.tsx:1358
#: apps/dp-business/src/pages/MyProfile/index.tsx:258
#: apps/dp-business/src/pages/MyProfile/index.tsx:280
#: apps/dp-business/src/components/PhoneVerification/index.tsx:304
#: apps/dp-business/src/components/PhoneVerification/index.tsx:304
#: apps/dp-business/src/components/EmailVerification/index.tsx:310
#: apps/dp-business/src/components/EmailVerification/index.tsx:311
msgid "綁定"
msgstr "綁定"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:487
msgid "綁定 / 註冊"
msgstr "綁定 / 註冊"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:487
msgid "綁定 / 註冊中..."
msgstr "綁定 / 註冊中..."

#: apps/dp-client/src/screens/account/pages/account-security/email/bind-email/index.tsx:25
#: apps/dp-client/src/screens/account/pages/account-security/email/bind-email/index.tsx:72
#: apps/dp-client/src/configs/page-configs.tsx:1958
#: apps/dp-business/src/pages/MyProfile/index.tsx:275
#: apps/dp-business/src/pages/BindEmail/index.tsx:71
msgid "綁定Email"
msgstr "綁定Email"

#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:172
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:209
msgid "綁定ERP"
msgstr "綁定ERP"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:45
msgid "綁定FET UID"
msgstr "綁定FET UID"

#: apps/dp-admin/src/pages/customer-service/components/CreateTicketModal.web.tsx:85
msgid "綁定一個用戶開始創建工單"
msgstr "綁定一個用戶開始創建工單"

#: apps/dp-business/src/servers/verification/api.ts:177
msgid "綁定信箱失敗"
msgstr "綁定信箱失敗"

#: apps/dp-client/src/screens/account/pages/account-security/email/verification-email/index.tsx:69
msgid "綁定信箱失敗，請稍後重試"
msgstr "綁定信箱失敗，請稍後重試"

#: apps/dp-business/src/components/PhoneVerification/index.tsx:305
#: apps/dp-business/src/components/EmailVerification/index.tsx:312
msgid "綁定其他"
msgstr "綁定其他"

#: apps/dp-business/src/pages/MyProfile/index.tsx:175
msgid "綁定其他信箱"
msgstr "綁定其他信箱"

#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:67
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:109
#: apps/dp-business/src/pages/MyProfile/index.tsx:161
msgid "綁定其他手機門號"
msgstr "綁定其他手機門號"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:506
msgid "綁定商家狀態"
msgstr "綁定商家狀態"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:97
msgid "綁定商家資訊"
msgstr "綁定商家資訊"

#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:192
#: apps/dp-client/src/screens/home/pages/Home/components/FetBindGuideModal/index.tsx:186
#: apps/dp-client/src/screens/home/hooks/useHomeBindRedirect.ts:70
#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:132
#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:313
#: apps/dp-client/src/screens/account/pages/account-security/third-party/bind/index.tsx:111
#: apps/dp-client/src/screens/account/pages/account-security/third-party/bind/index.tsx:114
msgid "綁定失敗，請稍後重試"
msgstr "綁定失敗，請稍後重試"

#: apps/dp-admin/src/router/config/routes.web.tsx:325
#: apps/dp-admin/src/router/config/routes.web.tsx:466
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:150
msgid "綁定審核"
msgstr "綁定審核"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:256
msgid "綁定審核狀態"
msgstr "綁定審核狀態"

#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:247
msgid "綁定手機號"
msgstr "綁定手機號"

#: apps/dp-client/src/screens/bind/pages/phone-bind/index.tsx:94
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:109
#: apps/dp-client/src/configs/page-configs.tsx:1372
#: apps/dp-business/src/pages/MyProfile/index.tsx:253
#: apps/dp-business/src/pages/BindPhone/index.tsx:69
msgid "綁定手機門號"
msgstr "綁定手機門號"

#: apps/dp-client/src/screens/account/pages/check-phone/bind-phone/index.tsx:27
#: apps/dp-client/src/screens/account/pages/check-phone/bind-phone/index.tsx:68
#: apps/dp-client/src/configs/page-configs.tsx:2011
msgid "綁定新手機門號"
msgstr "綁定新手機門號"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:243
msgid "綁定狀態"
msgstr "綁定狀態"

#: apps/dp-client/src/configs/page-configs.tsx:1899
msgid "綁定第三方帳號"
msgstr "綁定第三方帳號"

#. placeholder {0}: nodeNames.join('、')
#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeSwitcher.tsx:59
msgid "綁定節點 {0}"
msgstr "綁定節點 {0}"

#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:805
msgid "綁定詳情"
msgstr "綁定詳情"

#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:808
msgid "綁定資訊"
msgstr "綁定資訊"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:560
msgid "綁定資訊提交成功"
msgstr "綁定資訊提交成功"

#: apps/dp-client/src/configs/page-configs.tsx:1389
msgid "綁定驗證"
msgstr "綁定驗證"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:270
#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:274
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:311
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:315
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:109
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:239
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:644
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:694
#: apps/dp-admin/src/pages/merchant/audit-detail/components/StoreInfo/index.web.tsx:109
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:151
#: apps/dp-admin/src/components/MapPicker/index.web.tsx:603
#: apps/dp-admin/src/components/MapPicker/index.web.tsx:664
msgid "經度"
msgstr "經度"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:81
msgid "經度、緯度"
msgstr "經度、緯度"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreTable.tsx:85
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:85
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailMallTable.tsx:57
msgid "經營型態"
msgstr "經營型態"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:283
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:86
#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:247
#: apps/dp-admin/src/pages/merchant/information-review/index.web.tsx:126
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:291
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:139
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:56
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:178
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:105
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:143
msgid "經緯度"
msgstr "經緯度"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:134
msgid "綜合範例"
msgstr "綜合範例"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:161
msgid "綠框是本商家掛請款的層。橘色「商家」是簽約 / 請款主體；青色「店家」是掛在樹上的店家。帳匯進來的店家就掛在請款這一層。"
msgstr "綠框是本商家掛請款的層。橘色「商家」是簽約 / 請款主體；青色「店家」是掛在樹上的店家。帳匯進來的店家就掛在請款這一層。"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:162
msgid "綠色"
msgstr "綠色"

#: apps/dp-client/src/screens/others/Maintenance.tsx:51
msgid "維護中"
msgstr "維護中"

#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:251
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:241
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:295
msgid "維護資訊"
msgstr "維護資訊"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:91
msgid "網友帶路"
msgstr "網友帶路"

#: apps/dp-client/src/bootstrap/listeners/network.ts:118
msgid "網絡異常，請重試"
msgstr "網絡異常，請重試"

#: apps/dp-admin/src/modules/http/request.ts:405
msgid "網絡連線失敗，請檢查網絡"
msgstr "網絡連線失敗，請檢查網絡"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:357
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:278
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:608
msgid "網路"
msgstr "網路"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:410
msgid "網路好像有點忙，再試一次吧"
msgstr "網路好像有點忙，再試一次吧"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:279
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:608
msgid "網路異常"
msgstr "網路異常"

#: apps/dp-client/src/screens/home/pages/ShopDetail/utils/ensureShopOnline.ts:65
#: apps/dp-client/src/screens/account/pages/order/index.tsx:304
msgid "網路異常，請稍後再試"
msgstr "網路異常，請稍後再試"

#: apps/dp-business/src/App.native.tsx:782
msgid "網路異常或正在更新版本，請重新整理後再試"
msgstr "網路異常或正在更新版本，請重新整理後再試"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:358
msgid "網路連接失敗，請檢查網路後重試"
msgstr "網路連接失敗，請檢查網路後重試"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:450
msgid "網路連線失敗"
msgstr "網路連線失敗"

#: apps/dp-client/src/bootstrap/listeners/network.ts:73
#: apps/dp-client/src/bootstrap/listeners/network.ts:88
msgid "網路連線失敗，檢查網路或重試"
msgstr "網路連線失敗，檢查網路或重試"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:482
#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:502
msgid "網路連線逾時，請檢查網路狀況後重試"
msgstr "網路連線逾時，請檢查網路狀況後重試"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:85
#: apps/dp-admin/src/pages/marketing/services/apis.ts:1568
#: apps/dp-admin/src/pages/marketing/services/apis.ts:1593
msgid "網路錯誤，請稍後重試"
msgstr "網路錯誤，請稍後重試"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:77
msgid "網頁版"
msgstr "網頁版"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:543
#: apps/dp-admin/src/pages/merchant/service/constants.ts:572
msgid "網頁端"
msgstr "網頁端"

#: apps/dp-admin/src/pages/merchant/task-list/components/PriorityTag/index.web.tsx:35
msgid "緊急"
msgstr "緊急"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:277
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:142
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:215
msgid "緊急程度"
msgstr "緊急程度"

#: apps/dp-client/src/screens/home/components/CommonShopListSection/index.tsx:679
msgid "線上通路"
msgstr "線上通路"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:968
msgid "線下支付"
msgstr "線下支付"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:575
msgid "線下活動"
msgstr "線下活動"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:2013
msgid "線下用券"
msgstr "線下用券"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:406
msgid "線下聯繫商家解決，點擊一鍵撥打電話"
msgstr "線下聯繫商家解決，點擊一鍵撥打電話"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:133
msgid "線寬"
msgstr "線寬"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:193
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:332
msgid "線條"
msgstr "線條"

#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:261
msgid "線路"
msgstr "線路"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:134
msgid "線顏色"
msgstr "線顏色"

#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:128
#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:266
#: apps/dp-client/src/screens/home/pages/Note/pages/editPhoto/index.tsx:454
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:332
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:318
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:21
#: apps/dp-client/src/screens/account/pages/invoice/components/InvoiceProfileCard/index.tsx:127
#: apps/dp-client/src/screens/account/pages/drafts/components/DraftCard.tsx:193
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:24
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:50
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:94
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:166
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:192
#: apps/dp-business/src/pages/MenuManagement.tsx:537
#: apps/dp-business/src/pages/MenuManagement.tsx:674
#: apps/dp-business/src/pages/MenuManagement.tsx:1354
#: apps/dp-business/src/pages/UserManagement/index.tsx:565
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:312
#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:293
#: apps/dp-business/src/pages/TableManagement/index.tsx:994
#: apps/dp-business/src/pages/TableManagement/index.tsx:1111
#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:267
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:469
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:668
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:865
#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:149
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:427
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:447
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:554
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:574
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:496
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:239
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:58
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:413
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1330
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1425
#: apps/dp-business/src/pages/BusinessHours/index.tsx:1476
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:571
#: apps/dp-business/src/components/PhotoUploader/components/PhotoDisplay.tsx:195
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:774
#: apps/dp-business/src/components/MaintenanceList/index.tsx:177
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:14
#: apps/dp-admin/src/pages/users/permissions/components/PermissionTreeTable/index.web.tsx:63
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:323
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:701
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:543
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/index.web.tsx:78
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:584
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:316
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:486
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/index.web.tsx:525
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:173
#: apps/dp-admin/src/pages/resource-config/message-list/components/columns/index.web.tsx:149
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:126
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeColumns.web.tsx:68
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:96
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:252
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:442
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:477
#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:164
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:115
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:609
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:149
#: apps/dp-admin/src/pages/merchant/components/SortableItem/index.web.tsx:85
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:189
#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:151
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:253
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:214
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:133
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:159
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:14
#: apps/dp-admin/src/components/BusinessHours/index.web.tsx:442
msgid "編輯"
msgstr "編輯"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:232
msgid "編輯{levelLabel}渠道"
msgstr "編輯{levelLabel}渠道"

#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:208
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:236
msgid "編輯一級品類"
msgstr "編輯一級品類"

#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:173
msgid "編輯中：改動僅保存在本頁，點「保存草稿」暫存，或點「保存並提交審核」送審；離開本頁將捨棄未保存的改動。"
msgstr "編輯中：改動僅保存在本頁，點「保存草稿」暫存，或點「保存並提交審核」送審；離開本頁將捨棄未保存的改動。"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:486
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:569
msgid "編輯二級品類"
msgstr "編輯二級品類"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:259
#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:428
msgid "編輯互斥組"
msgstr "編輯互斥組"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1314
msgid "編輯人均消費"
msgstr "編輯人均消費"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:249
#: apps/dp-business/src/pages/EditUser/index.tsx:214
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:301
msgid "編輯使用者"
msgstr "編輯使用者"

#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:64
msgid "編輯假日類型"
msgstr "編輯假日類型"

#: apps/dp-business/src/pages/TableManagement/index.tsx:405
msgid "編輯分區"
msgstr "編輯分區"

#: apps/dp-business/src/pages/TableManagement/index.tsx:444
msgid "編輯分區失敗"
msgstr "編輯分區失敗"

#: apps/dp-business/src/pages/TableManagement/index.tsx:437
msgid "編輯分區成功"
msgstr "編輯分區成功"

#: apps/dp-business/src/pages/MenuManagement.tsx:749
msgid "編輯分類"
msgstr "編輯分類"

#: apps/dp-business/src/utils/permissionData.ts:141
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:689
msgid "編輯刪除使用者"
msgstr "編輯刪除使用者"

#: apps/dp-business/src/utils/permissionData.ts:173
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:717
msgid "編輯刪除角色設定"
msgstr "編輯刪除角色設定"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:426
msgid "編輯到店指引"
msgstr "編輯到店指引"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:102
msgid "編輯券組"
msgstr "編輯券組"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:438
msgid "編輯可用日期"
msgstr "編輯可用日期"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:831
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:846
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:362
msgid "編輯合約"
msgstr "編輯合約"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:100
msgid "編輯品牌"
msgstr "編輯品牌"

#: apps/dp-admin/src/pages/merchant/merchant-onboard/index.web.tsx:64
msgid "編輯商家入駐"
msgstr "編輯商家入駐"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:48
msgid "編輯商家名單"
msgstr "編輯商家名單"

#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:67
msgid "編輯商家權益"
msgstr "編輯商家權益"

#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:172
msgid "編輯商家活動"
msgstr "編輯商家活動"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:642
msgid "編輯器未初始化"
msgstr "編輯器未初始化"

#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:449
msgid "編輯器未初始化，請重試"
msgstr "編輯器未初始化，請重試"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:204
msgid "編輯圍欄"
msgstr "編輯圍欄"

#: apps/dp-business/src/components/ImageEditorModal/index.tsx:163
#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:65
#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:479
msgid "編輯圖片"
msgstr "編輯圖片"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2177
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2205
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2289
msgid "編輯套餐券"
msgstr "編輯套餐券"

#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:233
msgid "編輯店家"
msgstr "編輯店家"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:166
msgid "編輯店家影片"
msgstr "編輯店家影片"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:43
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:607
msgid "編輯店家資訊"
msgstr "編輯店家資訊"

#: apps/dp-business/src/pages/VideoUpload/index.tsx:153
#: apps/dp-business/src/pages/VideoUpload/index.tsx:230
msgid "編輯影片"
msgstr "編輯影片"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:523
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:296
msgid "編輯成功"
msgstr "編輯成功"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:237
msgid "編輯手工發送消息"
msgstr "編輯手工發送消息"

#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:268
msgid "編輯按鈕權限"
msgstr "編輯按鈕權限"

#: apps/dp-business/src/utils/permissionData.ts:43
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:660
msgid "編輯提交資訊"
msgstr "編輯上傳資訊"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:109
msgid "編輯文本"
msgstr "編輯資訊"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:258
msgid "編輯日常規則"
msgstr "編輯日常規則"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1031
msgid "編輯日期範圍"
msgstr "編輯日期範圍"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:473
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:549
msgid "編輯時間"
msgstr "編輯時間"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:266
msgid "編輯時間段"
msgstr "編輯時間段"

#: apps/dp-client/src/screens/home/pages/Note/pages/editPhoto/index.tsx:274
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:801
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:254
msgid "編輯未保存，確認退出嗎？"
msgstr "編輯未保存，確認退出嗎？"

#: apps/dp-business/src/pages/TableManagement/index.tsx:780
msgid "編輯桌位"
msgstr "編輯桌位"

#: apps/dp-business/src/pages/TableManagement/index.tsx:844
msgid "編輯桌位失敗"
msgstr "編輯桌位失敗"

#: apps/dp-business/src/pages/TableManagement/index.tsx:828
msgid "編輯桌位成功"
msgstr "編輯桌位成功"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:379
msgid "編輯榜單"
msgstr "編輯榜單"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/columns/index.web.tsx:136
msgid "編輯模板"
msgstr "編輯模板"

#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:156
msgid "編輯權益"
msgstr "編輯權益"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityDetails.tsx:120
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:285
msgid "編輯活動"
msgstr "編輯活動"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:83
msgid "編輯消息模板"
msgstr "編輯消息模板"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/index.web.tsx:70
msgid "編輯渠道活動"
msgstr "編輯渠道活動"

#: apps/dp-client/src/configs/page-configs.tsx:731
msgid "編輯照片"
msgstr "編輯照片"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:888
#: apps/dp-admin/src/components/BusinessHours/index.web.tsx:451
msgid "編輯營業時間"
msgstr "編輯營業時間"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1338
msgid "編輯營業狀態"
msgstr "編輯營業狀態"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:517
msgid "編輯版本"
msgstr "編輯版本"

#: apps/dp-business/src/pages/BusinessHours/index.tsx:926
msgid "編輯特殊日期"
msgstr "編輯特殊日期"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:258
msgid "編輯特殊時間規則"
msgstr "編輯特殊時間規則"

#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:250
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:251
msgid "編輯特殊營業時間"
msgstr "編輯特殊營業時間"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:58
msgid "編輯用戶名單"
msgstr "編輯用戶名單"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:593
#: apps/dp-client/src/configs/page-configs.tsx:2439
msgid "編輯發票抬頭"
msgstr "編輯發票抬頭"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:79
msgid "編輯第三方渠道"
msgstr "編輯第三方渠道"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:947
msgid "編輯筆記"
msgstr "編輯筆記"

#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:77
msgid "編輯節假日"
msgstr "編輯節假日"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:187
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeBasicInfo/index.web.tsx:92
msgid "編輯節點"
msgstr "編輯節點"

#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:807
msgid "編輯綁定資訊"
msgstr "編輯綁定資訊"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:209
msgid "編輯臨時使用者"
msgstr "編輯臨時使用者"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:843
msgid "編輯自定義類目"
msgstr "編輯自定義類別"

#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:156
msgid "編輯草稿"
msgstr "編輯草稿"

#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:270
msgid "編輯菜單"
msgstr "編輯菜單"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:166
msgid "編輯落地頁"
msgstr "編輯落地頁"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:269
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:867
msgid "編輯規則成功"
msgstr "編輯規則成功"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:185
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:272
#: apps/dp-business/src/pages/AddRole/index.tsx:347
#: apps/dp-business/src/pages/AddRole/index.tsx:362
#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:197
msgid "編輯角色"
msgstr "編輯角色"

#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewHeader.tsx:20
msgid "編輯評論"
msgstr "編輯評論"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:747
msgid "編輯詳情"
msgstr "編輯詳情"

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:152
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:641
#: apps/dp-client/src/configs/page-configs.tsx:1753
msgid "編輯資料"
msgstr "編輯資料"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:350
msgid "編輯資料頁"
msgstr "編輯資料頁"

#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:107
msgid "編輯連鎖"
msgstr "編輯連鎖"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:479
msgid "編輯金剛位設定"
msgstr "編輯金剛位設定"

#: apps/dp-admin/src/pages/users/permissions/hooks/hooks.ts:270
msgid "編輯頁面"
msgstr "編輯頁面"

#: apps/dp-admin/src/pages/merchant/components/CategoryEditModal/index.web.tsx:56
msgid "編輯類別"
msgstr "編輯類別"

#: apps/dp-business/src/pages/MenuManagement.tsx:846
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:340
msgid "編輯餐點"
msgstr "編輯餐點"

#: apps/dp-client/src/screens/reservation/components/ReservationNotes/index.tsx:67
msgid "緩衝時間,逾時將自動取消"
msgstr "緩衝時間,逾時將自動取消"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:280
#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:284
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:324
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:328
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:103
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:248
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:651
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:695
#: apps/dp-admin/src/pages/merchant/audit-detail/components/StoreInfo/index.web.tsx:109
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:151
#: apps/dp-admin/src/components/MapPicker/index.web.tsx:590
#: apps/dp-admin/src/components/MapPicker/index.web.tsx:665
msgid "緯度"
msgstr "緯度"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:84
msgid "緯度、經度"
msgstr "緯度、經度"

#. placeholder {0}: searchCoords.lat.toFixed(6)
#. placeholder {1}: searchCoords.lng.toFixed(6)
#: apps/dp-client/src/screens/diary/pages/add-merchant/address-select/index.tsx:248
#: apps/dp-client/src/screens/diary/pages/add-merchant/address-select/index.tsx:269
msgid "緯度: {0}, 經度: {1}"
msgstr "緯度: {0}, 經度: {1}"

#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:206
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:112
#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:144
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:347
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:359
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:275
#: apps/dp-admin/src/pages/merchant/information-review/index.web.tsx:114
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:107
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:95
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/config.ts:46
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/config.ts:40
msgid "縣市"
msgstr "縣市"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:188
msgid "縣市 / 行政區"
msgstr "縣市 / 行政區"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:624
msgid "縣市/行政區"
msgstr "縣市/行政區"

#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:271
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:218
msgid "縣市區域"
msgstr "縣市區域"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:135
msgid "縣市行政級"
msgstr "縣市行政級"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:56
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:36
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:36
#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:509
msgid "縮小"
msgstr "縮小"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:269
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:34
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:62
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:34
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:63
msgid "縮放"
msgstr "縮放"

#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:67
msgid "縮略圖"
msgstr "縮略圖"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/OverviewCards.web.tsx:48
msgid "總交易額"
msgstr "總交易額"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2726
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:214
msgid "總共實際生效補貼"
msgstr "總共實際生效補貼"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:60
msgid "總分享次數"
msgstr "總分享次數"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:126
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:43
msgid "總參與用戶"
msgstr "總參與用戶"

#: apps/dp-admin/src/pages/report-center/audit-data/components/OverviewCards.web.tsx:15
msgid "總審核數量"
msgstr "總審核數量"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:155
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:400
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:766
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:465
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:457
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:300
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:140
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponListModal.web.tsx:65
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:596
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:70
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:252
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:228
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/BenefitInfoPanel/index.web.tsx:87
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:119
msgid "總庫存"
msgstr "總庫存"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1158
msgid "總庫存剩餘"
msgstr "總庫存剩餘"

#: apps/dp-business/src/pages/OrderOverview/Detail/components/ReservationSlots.tsx:70
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/components/ReservationSlots.web.tsx:119
msgid "總庫存數"
msgstr "總庫存數"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:78
msgid "總排行值"
msgstr "總排行值"

#: apps/dp-business/src/pages/ReservationManagement/StockInputGroup.tsx:61
msgid "總數"
msgstr "總數"

#. placeholder {0}: result.totalCount ?? 0
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:145
msgid "總數：{0}"
msgstr "總數：{0}"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:56
msgid "總星級"
msgstr "總星級"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/OverviewCards.web.tsx:15
msgid "總案件數量"
msgstr "總案件數量"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:100
msgid "總消耗活動點數值"
msgstr "總消耗活動點數值"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:84
msgid "總消費金額"
msgstr "總消費金額"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/OverviewCards/index.web.tsx:21
msgid "總異常訂單數"
msgstr "總異常訂單數"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:85
msgid "總簽到次數"
msgstr "總簽到次數"

#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:89
msgid "總覽數據（按天）"
msgstr "總覽數據（按天）"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:127
msgid "總觸發事件"
msgstr "總觸發事件"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/OverviewCards.web.tsx:39
msgid "總訂單"
msgstr "總訂單"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1111
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:98
msgid "總訂單金額"
msgstr "總訂單金額"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:406
msgid "總計"
msgstr "總計"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:495
msgid "總計金額"
msgstr "總計金額"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:215
#: apps/dp-business/src/components/InvoiceForm/index.tsx:266
msgid "總計金額："
msgstr "總計金額："

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/OverviewCards.web.tsx:21
msgid "總註冊用戶數"
msgstr "總註冊用戶數"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewContent.tsx:233
#: apps/dp-admin/src/pages/data-center/components/ReviewItem.web.tsx:120
msgid "總評"
msgstr "總評"

#: apps/dp-admin/src/pages/data-center/merchant-stats/services/hooks.tsx:78
msgid "總評價數"
msgstr "總評價數"

#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:140
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/OriginalReviewSection/index.web.tsx:73
msgid "總評分"
msgstr "總評分"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/OverviewCards.web.tsx:24
msgid "總評論次數"
msgstr "總評論次數"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:57
msgid "總費用金額"
msgstr "總費用金額"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:87
msgid "總連續簽到次數"
msgstr "總連續簽到次數"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:195
msgid "總量"
msgstr "總量"

#. placeholder {0}: `${record.totalStock === -1 ? '無限制' : record.totalStock}` || 0
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:247
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:272
msgid "總量: {0}"
msgstr "總量: {0}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:897
msgid "總金額"
msgstr "總金額"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:39
msgid "總銷量"
msgstr "總銷量"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:513
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1138
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:590
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:36
msgid "總領取量"
msgstr "總領取量"

#: apps/dp-client/src/screens/login/pages/welcome-back/index.tsx:60
#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:326
#: apps/dp-client/src/screens/login/pages/password-login/index.tsx:144
#: apps/dp-client/src/screens/login/pages/password-login/components/password-login-form/index.tsx:74
#: apps/dp-client/src/screens/login/pages/login/index.tsx:374
#: apps/dp-client/src/screens/login/pages/login/components/login-form/index.tsx:64
#: apps/dp-client/src/screens/login/pages/account-info/index.tsx:115
#: apps/dp-client/src/screens/bind/pages/phone-bind/index.tsx:119
#: apps/dp-client/src/screens/bind/pages/phone-bind/components/phone-bind-form/index.tsx:64
#: apps/dp-client/src/screens/account/pages/task-wall/pages/home/index.tsx:231
#: apps/dp-client/src/screens/account/pages/check-phone/bind-phone/index.tsx:111
#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:218
#: apps/dp-client/src/screens/account/pages/account-security/email/email-old/index.tsx:112
#: apps/dp-client/src/screens/account/pages/account-security/email/bind-email/index.tsx:106
#: apps/dp-client/src/screens/account/pages/account-security/check-password/index.tsx:119
#: apps/dp-client/src/screens/account/components/system-dialog/index.tsx:102
#: apps/dp-client/src/hooks/tasks/useTaskRewardFeedback.ts:81
#: apps/dp-business/src/pages/ChangePassword/index.tsx:203
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:468
#: apps/dp-business/src/components/SetPassword/index.tsx:265
msgid "繼續"
msgstr "繼續"

#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:120
#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:373
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:638
msgid "繼續付款"
msgstr "繼續付款"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:149
msgid "繼續保存"
msgstr "繼續保存"

#: apps/dp-client/src/screens/home/pages/ShareKing/index.tsx:207
#: apps/dp-client/src/screens/home/pages/ShareKing/components/ShareCompletedCard/index.tsx:69
msgid "繼續分享"
msgstr "繼續分享"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/index.tsx:363
msgid "繼續切換"
msgstr "繼續切換"

#: apps/dp-client/src/screens/home/pages/Meal/pages/result/index.tsx:59
msgid "繼續團購"
msgstr "繼續團購"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/index.tsx:364
msgid "繼續報名"
msgstr "繼續報名"

#: apps/dp-client/src/screens/diary/pages/comment-success/index.tsx:170
#: apps/dp-client/src/screens/diary/components/WarningModal/index.tsx:68
msgid "繼續寫日記"
msgstr "繼續寫日記"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/index.web.tsx:163
msgid "繼續導出"
msgstr "繼續導出"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:82
msgid "繼續提交"
msgstr "繼續提交"

#: apps/dp-client/src/screens/home/pages/Note/pages/editPhoto/index.tsx:277
#: apps/dp-client/src/screens/home/pages/Note/pages/draft/index.tsx:158
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:804
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:256
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:86
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:811
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1077
msgid "繼續編輯"
msgstr "繼續編輯"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:370
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:386
msgid "繼續編輯草稿"
msgstr "繼續編輯草稿"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:587
msgid "繼續複製"
msgstr "繼續複製"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:428
msgid "繼續設置服務"
msgstr "繼續設置服務"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:341
msgid "纂"
msgstr "纂"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:387
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:319
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:187
msgid "續付訂單失敗，請稍後重試"
msgstr "續付訂單失敗，請稍後重試"

#. placeholder {0}: record.autoRenewalPeriod
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:126
msgid "續約{0}個月"
msgstr "續約{0}個月"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:120
msgid "續約提醒"
msgstr "續約提醒"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/index.web.tsx:50
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/services/hooks.ts:35
msgid "缺少 POI ID"
msgstr "缺少 POI ID"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:405
msgid "缺少 POI ID，無法匯出套餐券"
msgstr "缺少 POI ID，無法匯出套餐券"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:241
msgid "缺少 POI ID，無法匯出店家"
msgstr "缺少 POI ID，無法匯出店家"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:542
msgid "缺少 POI ID，無法匯出訂單"
msgstr "缺少 POI ID，無法匯出訂單"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:210
msgid "缺少 POI ID，無法導入店家"
msgstr "缺少 POI ID，無法導入店家"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:186
msgid "缺少 POI ID，無法更新位置"
msgstr "缺少 POI ID，無法更新位置"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:362
msgid "缺少 POI ID，無法查詢套餐券"
msgstr "缺少 POI ID，無法查詢套餐券"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:77
msgid "缺少 POI ID，無法查詢活動位"
msgstr "缺少 POI ID，無法查詢活動位"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/hooks.ts:499
msgid "缺少 POI ID，無法查詢訂單"
msgstr "缺少 POI ID，無法查詢訂單"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:372
msgid "缺少userId 或 fetUid"
msgstr "缺少userId 或 fetUid"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/SigningAuditTab/index.web.tsx:100
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:350
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/EntryAuditTab/index.web.tsx:132
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:123
msgid "缺少任務資訊"
msgstr "缺少任務資訊"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/hooks.ts:98
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/hooks.ts:130
msgid "缺少任務資訊，請重新整理頁面重試"
msgstr "缺少任務資訊，請重新整理頁面重試"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:174
msgid "缺少商家ID，無法處理草稿"
msgstr "缺少商家ID，無法處理草稿"

#: apps/dp-admin/src/pages/merchant/audit-detail/index.web.tsx:135
msgid "缺少商家ID參數"
msgstr "缺少商家ID參數"

#: apps/dp-admin/src/pages/marketing/merchant-group-detail/index.web.tsx:172
msgid "缺少商家名單ID參數"
msgstr "缺少商家名單ID參數"

#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:48
msgid "缺少商家相關資訊！"
msgstr "缺少商家相關資訊！"

#: apps/dp-client/src/screens/home/pages/Meal/pages/shopSelect/index.tsx:71
msgid "缺少套餐券模板ID"
msgstr "缺少套餐券模板ID"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:421
msgid "缺少審批人信息，請重新登入後再試"
msgstr "缺少審批人信息，請重新登入後再試"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/index.web.tsx:36
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:52
#: apps/dp-admin/src/pages/audit-center/info-confirm/index.web.tsx:73
msgid "缺少審核ID參數"
msgstr "缺少審核ID參數"

#: apps/dp-admin/src/pages/audit-center/audit-detail-redirect/index.web.tsx:31
msgid "缺少審核任務ID"
msgstr "缺少審核任務ID"

#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:667
msgid "缺少店家ID，無法保存草稿"
msgstr "缺少店家ID，無法保存草稿"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:162
msgid "缺少店家ID，無法處理草稿"
msgstr "缺少店家ID，無法處理草稿"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:686
msgid "缺少店家資訊"
msgstr "缺少店家資訊"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1455
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1488
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:180
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:341
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:169
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:208
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:220
#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:98
#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:130
#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:142
#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:208
#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:451
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/index.web.tsx:44
msgid "缺少必要參數"
msgstr "缺少必要參數"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:875
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:692
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:326
msgid "缺少必要參數，無法進行分配"
msgstr "缺少必要參數，無法進行分配"

#: apps/dp-admin/src/pages/merchant/merchant-menu/services/hooks.ts:95
msgid "缺少必要參數：商家ID或使用者ID"
msgstr "缺少必要參數：商家ID或使用者ID"

#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:107
msgid "缺少必要的參數"
msgstr "缺少必要的參數"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:489
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:587
msgid "缺少必要的商家資訊，請重新進入頁面"
msgstr "缺少必要的商家資訊，請重新進入頁面"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/services/hooks.ts:233
msgid "缺少必要的審核資訊"
msgstr "缺少必要的審核資訊"

#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:153
msgid "缺少有效的店家 ID，請重新進入編輯頁面"
msgstr "缺少有效的店家 ID，請重新進入編輯頁面"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:84
#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:426
#: apps/dp-admin/src/pages/marketing/general-activity-detail/index.web.tsx:38
#: apps/dp-admin/src/pages/marketing/activity-statistics/index.web.tsx:97
#: apps/dp-admin/src/pages/marketing/activity-detail-list/index.web.tsx:243
msgid "缺少活動ID參數"
msgstr "缺少活動ID參數"

#: apps/dp-admin/src/pages/marketing/user-group-detail/index.web.tsx:172
msgid "缺少用戶名單ID參數"
msgstr "缺少用戶名單ID參數"

#: apps/dp-admin/src/pages/merchant/audit-detail/index.web.tsx:250
msgid "缺少申請ID"
msgstr "缺少申請ID"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:178
msgid "缺少當前登入用戶，無法保存草稿"
msgstr "缺少當前登入用戶，無法保存草稿"

#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:237
msgid "缺少發票ID參數"
msgstr "缺少發票ID參數"

#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:416
msgid "缺少組織樹 ID"
msgstr "缺少組織樹 ID"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:263
msgid "缺少綁定ID，無法解綁"
msgstr "缺少綁定ID，無法解綁"

#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:97
msgid "缺少訂單ID參數"
msgstr "缺少訂單ID參數"

#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:56
msgid "缺少請款單ID參數"
msgstr "缺少請款單ID參數"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:54
msgid "美味的食物特寫要上傳到「餐點」喔！"
msgstr "美味的食物特寫要上傳到「餐點」喔！"

#: apps/dp-business/src/pages/RefundList/index.tsx:87
msgid "美味餐廳"
msgstr "美味餐廳"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/hooks.ts:41
msgid "美家餐廳"
msgstr "美家餐廳"

#: apps/dp-client/src/screens/home/pages/PrivateChef/components/PrivateChefShopCard/index.tsx:180
#: apps/dp-client/src/screens/home/pages/FoodMap/components/ShopList/MapShopCard.tsx:183
#: apps/dp-client/src/screens/home/components/ShopCard/index.tsx:400
#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:56
msgid "美食"
msgstr "美食"

#: apps/dp-admin/src/pages/audit-center/services/apis.ts:413
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:424
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:435
msgid "美食品牌"
msgstr "美食品牌"

#: apps/dp-client/src/configs/page-configs.tsx:408
#: apps/dp-client/src/configs/page-configs.tsx:409
msgid "美食地圖"
msgstr "美食地圖"

#: apps/dp-client/src/configs/page-configs.tsx:82
msgid "美食地圖搜尋"
msgstr "美食地圖搜尋"

#: apps/dp-client/src/screens/diary/pages/home/index.tsx:534
msgid "美食控福利來了！吃美食＋紀錄餐廳就能拿積分換遠傳幣💰 前100名還有機會抽iPhone📱 快來參加吧！"
msgstr "美食控福利來了！吃美食＋紀錄餐廳就能拿積分換遠傳幣💰 前100名還有機會抽iPhone📱 快來參加吧！"

#: apps/dp-client/src/configs/main-config.tsx:130
#: apps/dp-client/src/configs/main-config.tsx:131
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:17
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/services/hooks.ts:150
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/MerchantBasicInfo/index.web.tsx:136
msgid "美食日記"
msgstr "美食日記"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:163
msgid "美食日記新增"
msgstr "美食日記新增"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/ArticleModule/index.tsx:227
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/ArticleModule/index.tsx:249
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/ArticleModule/index.tsx:268
msgid "美食特派員專欄"
msgstr "美食特派員專欄"

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:947
#: apps/dp-client/src/bootstrap/components/CenterTabButton.tsx:59
msgid "美食筆記"
msgstr "美食筆記"

#: apps/dp-client/src/screens/home/utils/showPostingRules.tsx:96
msgid "美食筆記，是把你吃過的餐廳與真實感受記錄下來，讓美食可以被保存，也能被分享給其他熱愛美食的人。"
msgstr "美食筆記，是把你吃過的餐廳與真實感受記錄下來，讓美食可以被保存，也能被分享給其他熱愛美食的人。"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:741
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:463
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:821
#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/UsergiftBanner.tsx:386
#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:217
#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:194
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:498
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:685
#: apps/dp-client/src/components/CouponCard/index.tsx:257
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1539
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:42
msgid "美食金"
msgstr "美食金"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:849
msgid "美食金使用後即失效，恕不找零、返還、退款或補發。"
msgstr "美食金使用後即失效，恕不找零、返還、退款或補發。"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:508
msgid "美食金使用後即失效，恕不退款或補發。"
msgstr "美食金使用後即失效，恕不退款或補發。"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:211
msgid "美食金使用後即視為失效，恕不退款或補發。"
msgstr "美食金使用後即視為失效，恕不退款或補發。"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:503
msgid "美食金優惠金額將平均分攤至每張套餐券。"
msgstr "美食金優惠金額將平均分攤至每張套餐券。"

#: apps/dp-client/src/screens/home/pages/Home/components/ClaimedCouponModal/index.tsx:146
msgid "美食金已入票券匣"
msgstr "美食金已入票券匣"

#: apps/dp-client/src/screens/account/pages/task-wall/components/ExchangeSuccessModal/index.tsx:71
msgid ""
"美食金已匯入，\n"
"可用於購買套餐券"
msgstr ""
"美食金已匯入，\n"
"可用於購買套餐券"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:218
msgid "美食金折抵金額將平均分攤至每張套餐券，故本張套餐券的退款金額為 ${refundAmount}元。"
msgstr "美食金折抵金額將平均分攤至每張套餐券，故本張套餐券的退款金額為 ${refundAmount}元。"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:28
msgid "美食金明細報表"
msgstr "美食金明細報表"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:27
msgid "美食金月結報表"
msgstr "美食金月結報表"

#: apps/dp-admin/src/pages/audit-center/services/apis.ts:405
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:416
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:427
msgid "美食餐廳"
msgstr "美食餐廳"

#: apps/dp-business/src/data/categories.ts:101
msgid "義大利菜"
msgstr "義大利菜"

#: apps/dp-business/src/data/categories.ts:113
msgid "義麵"
msgstr "義麵"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:33
msgid "老子鍋"
msgstr "老子鍋"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:62
msgid "老客"
msgstr "老客"

#: apps/dp-business/src/pages/RefundList/index.tsx:72
msgid "老爺爺"
msgstr "老爺爺"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:149
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:108
msgid "聚流"
msgstr "聚流"

#. placeholder {0}: juliuSignStatus.label || t`未知狀態`
#. placeholder {0}: getContractStatus(record.jlContractStatus as ContractStatus) ?.label
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/SigningStatus/index.web.tsx:41
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:500
msgid "聚流{0}"
msgstr "聚流{0}"

#: apps/dp-admin/src/pages/merchant/signing-management/index.web.tsx:94
#: apps/dp-admin/src/pages/merchant/signing-management/components/NoContractActions/index.web.tsx:56
msgid "聚流+藍新簽約"
msgstr "聚流+藍新簽約"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:196
msgid "聚流ERP"
msgstr "聚流ERP"

#: apps/dp-admin/src/pages/transaction/contract-management/index.web.tsx:173
msgid "聚流ID"
msgstr "聚流ID"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:30
msgid "聚流Paid Media推廣"
msgstr "聚流Paid Media推廣"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:738
msgid "聚流合約管理"
msgstr "聚流合約管理"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:272
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:242
msgid "聚流合約變更歷史"
msgstr "聚流合約變更歷史"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:371
msgid "聚流審批拒絕"
msgstr "聚流審核拒絕"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:364
msgid "聚流已到期"
msgstr "聚流已到期"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:350
msgid "聚流已簽約"
msgstr "聚流已簽約"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreName/index.web.tsx:32
msgid "聚流店家名稱"
msgstr "聚流店家名稱"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:357
msgid "聚流快到期"
msgstr "聚流快到期"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:630
msgid "聚流狀態"
msgstr "聚流狀態"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:232
msgid "聚流簽約"
msgstr "聚流簽約"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:219
msgid "聚流簽約審核狀態"
msgstr "聚流簽約審核狀態"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:75
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:256
msgid "聚流簽約狀態"
msgstr "聚流簽約狀態"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:88
msgid "聯合代開發票"
msgstr "聯合代開發票"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:218
msgid "聯想詞標題"
msgstr "聯想詞標題"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:389
msgid "聯絡地址"
msgstr "聯絡地址"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:347
msgid "聯絡地址之郵遞區號三碼"
msgstr "聯絡地址之郵遞區號三碼"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:368
#: apps/dp-business/src/pages/ContractManagement/index.tsx:512
#: apps/dp-business/src/pages/ContractManagement/index.tsx:686
#: apps/dp-business/src/components/ServiceNotEnabled/index.tsx:61
msgid "聯絡我們"
msgstr "聯絡我們"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:390
#: apps/dp-business/src/pages/OrderDetail/index.tsx:794
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1128
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:150
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:186
msgid "聯絡方式"
msgstr "聯絡方式"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:111
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/ContactInfo/index.web.tsx:46
msgid "聯絡者信箱"
msgstr "聯絡者信箱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:79
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/ContactInfo/index.web.tsx:33
msgid "聯絡者姓名"
msgstr "聯絡者姓名"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:84
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:101
msgid "聯絡者帳號密碼為企業會員的最高權限人員所持有，該人員即為本服務主要聯絡人，請正確填寫。"
msgstr "聯絡者帳號密碼為企業會員的最高權限人員所持有，該人員即為本服務主要聯絡人，請正確填寫。"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:126
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/ContactInfo/index.web.tsx:60
msgid "聯絡者手機"
msgstr "聯絡者手機"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:93
msgid "聯絡者英文姓名"
msgstr "聯絡者英文姓名"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:96
msgid "聯絡者英文姓名不能超過20個字符"
msgstr "聯絡者英文姓名不能超過20個字符"

#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:133
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/index.web.tsx:58
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/index.web.tsx:108
msgid "聯絡資訊"
msgstr "聯絡資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:78
msgid "聯絡資訊人的手機號和郵箱帳號合併"
msgstr "聯絡資訊人的手機號和郵箱帳號合併"

#: apps/dp-business/src/components/ShopSelectTable/index.tsx:282
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:86
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:76
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:766
msgid "聯絡電話"
msgstr "聯絡電話"

#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:113
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:153
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:208
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:231
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:254
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:277
#: apps/dp-business/src/pages/OrderOverview/Detail/components/OrderActionButtons.tsx:300
msgid "聯絡顧客"
msgstr "聯絡顧客"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:447
msgid "聯繫email"
msgstr "聯繫email"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:81
msgid "聯繫人"
msgstr "聯繫人"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:407
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:158
msgid "聯繫商家"
msgstr "聯繫商家"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:859
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:1082
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:872
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/OrderStatusArea.tsx:61
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:320
#: apps/dp-client/src/screens/account/pages/check-phone/index.tsx:70
#: apps/dp-client/src/screens/account/pages/advice/advice-feedback/index.tsx:239
#: apps/dp-client/src/screens/account/pages/advice/advice-detail/index.tsx:120
#: apps/dp-business/src/components/CustomerServiceButton/index.tsx:40
msgid "聯繫客服"
msgstr "聯繫客服"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/RegistrationStatusBanner.tsx:92
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/NoDiscount.tsx:39
msgid "聯繫專屬顧問"
msgstr "聯繫專屬顧問"

#: apps/dp-client/src/screens/diary/pages/home/components/upgrade-modal/index.tsx:117
msgid "聯繫我們，期待【去哪吃】繼續為您帶來更好的使用體驗！"
msgstr "聯繫我們，期待【去哪吃】繼續為您帶來更好的使用體驗！"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/NoSigned.tsx:30
msgid "聯繫我們：0912345678，立即獲取平台流量"
msgstr "聯繫我們：0912345678，立即獲取平台流量"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:203
msgid "聯繫手機號"
msgstr "聯繫手機號"

#: apps/dp-client/src/screens/reservation/pages/detail/components/OrderInfoSection.tsx:69
#: apps/dp-business/src/utils/moduleTypeMapping.ts:126
#: apps/dp-business/src/utils/moduleTypeMapping.ts:247
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:280
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:224
#: apps/dp-business/src/pages/AddUser/index.tsx:214
#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:189
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:484
#: apps/dp-admin/src/pages/merchant/components/HistoryTable/index.web.tsx:105
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:140
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:189
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:229
msgid "聯繫方式"
msgstr "聯繫方式"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:305
msgid "聯繫方式："
msgstr "聯繫方式："

#: apps/dp-business/src/utils/moduleTypeMapping.ts:127
msgid "聯繫方式資訊完整度評分"
msgstr "聯繫方式資訊完整度評分"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:462
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:125
msgid "聯繫方式類型"
msgstr "聯繫方式類型"

#: apps/dp-business/src/pages/ContactBD/index.tsx:112
#: apps/dp-business/src/pages/ContactBD/index.tsx:130
#: apps/dp-business/src/pages/ContactBD/index.tsx:145
msgid "聯繫業務專員"
msgstr "聯繫業務專員"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:250
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:121
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:75
#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:225
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/BasicInfoCard.web.tsx:69
msgid "聯繫郵箱"
msgstr "聯繫郵箱"

#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:82
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:88
#: apps/dp-admin/src/pages/transaction/components/MerchantInfo/index.web.tsx:140
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:126
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:69
#: apps/dp-admin/src/pages/merchant/shop-detail/components/DetailMobile/components/MerchantContactInfo.web.tsx:49
#: apps/dp-admin/src/pages/merchant/information-error/index.web.tsx:31
#: apps/dp-admin/src/pages/merchant/information-error/components/ErrorInfoSection/index.web.tsx:47
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/index.web.tsx:139
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/index.web.tsx:159
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/index.web.tsx:173
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/index.web.tsx:201
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/index.web.tsx:211
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/index.web.tsx:223
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/MerchantComplaintSection/index.web.tsx:74
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:203
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:207
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:90
msgid "聯繫電話"
msgstr "聯繫電話"

#: apps/dp-admin/src/pages/merchant/information-error/components/ErrorInfoSection/index.web.tsx:123
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/OriginalReviewSection/index.web.tsx:132
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/MerchantComplaintSection/index.web.tsx:125
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/AppealInfoSection/index.web.tsx:102
msgid "聯繫電話："
msgstr "聯繫電話："

#. placeholder {0}: data.userInfo.phone
#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:194
msgid "聯繫電話:{0}"
msgstr "聯繫電話:{0}"

#. placeholder {0}: shopInfo.phone
#. placeholder {0}: _selectedPoi?.phone || ''
#: apps/dp-business/src/pages/AddStore/index.tsx:1032
#: apps/dp-business/src/pages/AddStore/index.tsx:1077
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:172
msgid "聯繫電話：{0}"
msgstr "聯繫電話：{0}"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:171
msgid "背景圖"
msgstr "背景圖"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:37
msgid "能看清楚用餐座位區、吧檯或裝潢氛圍，避免拍到太多陌生客人"
msgstr "能看清楚用餐座位區、吧檯或裝潢氛圍，避免拍到太多陌生客人"

#. placeholder {0}: item.nodeName || '-'
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:140
msgid "能管、能看{0}報表。結算不在這棵樹。"
msgstr "能管、能看{0}報表。結算不在這棵樹。"

#. placeholder {0}: item.nodeName || '-'
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:139
msgid "能管、能看{0}報表。這家店的帳匯進{settleMerchantName}的結算單。"
msgstr "能管、能看{0}報表。這家店的帳匯進{settleMerchantName}的結算單。"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:93
msgid "能管店、看報表"
msgstr "能管店、看報表"

#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:50
msgid "臨時"
msgstr "臨時"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:222
msgid "臨時使用者名稱"
msgstr "臨時使用者名稱"

#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:234
msgid "臨時使用者將在有效期到期後自動停用。"
msgstr "臨時使用者將在有效期到期後自動停用。"

#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:159
msgid "臨時使用者已建立"
msgstr "臨時使用者已建立"

#: apps/dp-business/src/pages/UserManagement/EditTempUserPage.tsx:87
#: apps/dp-business/src/pages/UserManagement/EditTempUserPage.tsx:91
msgid "臨時使用者資訊更新失敗"
msgstr "臨時使用者資訊更新失敗"

#: apps/dp-business/src/pages/UserManagement/EditTempUserPage.tsx:81
msgid "臨時使用者資訊更新成功"
msgstr "臨時使用者資訊更新成功"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:247
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:258
msgid "臨時密碼"
msgstr "臨時密碼"

#: apps/dp-business/src/store/NotificationContext.tsx:655
msgid "臨時帳號申請待確認"
msgstr "臨時帳號申請待確認"

#: apps/dp-business/src/servers/reservation/api.ts:717
msgid "臨時關閉時段失敗"
msgstr "臨時關閉時段失敗"

#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:192
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:225
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:812
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:214
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:938
#: apps/dp-client/src/configs/page-configs.tsx:887
msgid "自主核銷"
msgstr "自主核銷"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:19
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:12
#: apps/dp-admin/src/pages/resource-config/app-notice/services.ts:42
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:12
msgid "自動"
msgstr "自動"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:71
msgid "自動參加"
msgstr "自動參加"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:156
msgid "自動填充公司登記地址"
msgstr "自動填充公司登記地址"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:176
msgid "自動填充實收資本額"
msgstr "自動填充實收資本額"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:666
#: apps/dp-admin/src/pages/order/services/utils.ts:414
msgid "自動審核通過"
msgstr "自動審核通過"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:99
msgid "自動寬度"
msgstr "自動寬度"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:903
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:910
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:917
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:924
msgid "自動帶入"
msgstr "自動帶入"

#: apps/dp-business/src/types/orderFilter.ts:165
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:407
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:656
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:853
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1202
#: apps/dp-business/src/pages/OrderOverview/index.tsx:2005
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1190
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:92
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:43
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:231
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:833
msgid "自動接單"
msgstr "自動接單"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1505
msgid "自動接單模式"
msgstr "自動接單模式"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:272
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:933
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:936
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:10
msgid "自動生成"
msgstr "自動生成"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:161
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:189
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:636
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:284
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:121
msgid "自動生成拼音編碼或手動輸入"
msgstr "自動生成拼音編碼或手動輸入"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:132
msgid "自動發放"
msgstr "自動發放"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:407
msgid "自動發放觸發條件"
msgstr "自動發放觸發條件"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:171
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:114
msgid "自動續約"
msgstr "自動續約"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:672
#: apps/dp-admin/src/pages/order/services/utils.ts:429
msgid "自動駁回"
msgstr "自動駁回"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:100
msgid "自動高度"
msgstr "自動高度"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1403
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1509
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:311
#: apps/dp-admin/src/pages/merchant/service/constants.ts:447
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:192
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:33
msgid "自定義"
msgstr "自定義"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:18
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:16
msgid "自定義區間"
msgstr "自定義區間"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:97
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:154
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:532
#: apps/dp-admin/src/components/BusinessHours/utils.ts:277
#: apps/dp-admin/src/components/BusinessHours/utils.ts:460
#: apps/dp-admin/src/components/BusinessHours/components/BusinessStatusSelector.web.tsx:315
msgid "自定義時段"
msgstr "自定義時段"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:112
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:126
msgid "自定義時段 1"
msgstr "自定義時段 1"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:113
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:127
msgid "自定義時段 2"
msgstr "自定義時段 2"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:114
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:128
msgid "自定義時段 3"
msgstr "自定義時段 3"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:115
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:129
msgid "自定義時段 4"
msgstr "自定義時段 4"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:116
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:130
msgid "自定義時段 5"
msgstr "自定義時段 5"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:430
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1268
msgid "自定義時段{num}"
msgstr "自定義時段{num}"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1948
#: apps/dp-business/src/components/DateRangeSelector/index.tsx:167
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:42
msgid "自定義時間"
msgstr "自定義時間"

#. placeholder {0}: timeEditModalState.label
#. placeholder {0}: gridTimeEditModal.label
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:798
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2365
msgid "自定義時間 - {0}"
msgstr "自定義時間 - {0}"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:408
msgid "自定義時間不得超出原始餐期時間範圍"
msgstr "自定義時間不得超出原始餐期時間範圍"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:305
msgid "自定義時間必須在 {originalStart}~{originalEnd} 範圍內"
msgstr "自定義時間必須在 {originalStart}~{originalEnd} 範圍內"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:186
msgid "自定義時間選擇"
msgstr "自定義時間選擇"

#: apps/dp-admin/src/pages/merchant/components/TagEditor/index.web.tsx:185
msgid "自定義標籤"
msgstr "自定義標籤"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:118
msgid "自定義規則示例"
msgstr "自定義規則示例"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:179
msgid "自定義角色"
msgstr "自定義角色"

#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:203
msgid "自定義設施"
msgstr "自定義設施"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:86
msgid "自定義跳轉"
msgstr "自定義跳轉"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:356
msgid "自定義類目刪除失敗，請稍後重試"
msgstr "自定義類別刪除失敗，請稍後重試"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:350
msgid "自定義類目刪除成功"
msgstr "自定義類別刪除成功"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:470
msgid "自定義類目新增失敗，請稍後重試"
msgstr "自定義類別新增失敗，請稍後重試"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:464
msgid "自定義類目新增成功"
msgstr "自定義類別新增成功"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:412
msgid "自定義類目更新失敗，請稍後重試"
msgstr "自定義類別更新失敗，請稍後重試"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:406
msgid "自定義類目更新成功"
msgstr "自定義類別更新成功"

#: apps/dp-client/src/screens/home/pages/ShareKing/pages/RaffleWinners/index.tsx:274
#: apps/dp-client/src/screens/home/pages/Note/components/ReviewCard/index.tsx:54
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:336
#: apps/dp-client/src/screens/home/components/ReplayCard/index.tsx:143
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:207
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:99
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:99
msgid "自己"
msgstr "自己"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:595
msgid "自核銷功能開啟後，顧客可於 App 內自行完成核銷，平台與商家端將不再進行即時核銷驗證。"
msgstr "自核銷功能開啟後，顧客可於 App 內自行完成核銷，平台與商家端將不再進行即時核銷驗證。"

#. placeholder {0}: checked ? '開啟' : '關閉'
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:576
msgid "自核銷服務{0}成功"
msgstr "自核銷服務{0}成功"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:575
msgid "自然流量"
msgstr "自然流量"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:34
msgid "自然週期"
msgstr "自然週期"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:88
msgid "自行配置內部頁面或外部鏈接，並指定兜底頁面。"
msgstr "自行配置內部頁面或外部鏈接，並指定兜底頁面。"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:202
msgid "自訂"
msgstr "自訂"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:237
msgid "自訂上傳"
msgstr "自訂上傳"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:243
msgid "自訂圖示"
msgstr "自訂圖示"

#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:405
msgid "自訂排序"
msgstr "自訂排序"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:96
msgid "自訂樣式"
msgstr "自訂樣式"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:98
msgid "自訂樣式面板"
msgstr "自訂樣式面板"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:353
msgid "自訂鏈接"
msgstr "自訂鏈接"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDetailDrawer/index.web.tsx:89
msgid "自身狀態"
msgstr "自身狀態"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:197
#: apps/dp-business/src/pages/BusinessHours/TimeRangePicker.tsx:145
#: apps/dp-business/src/components/TimePicker/index.tsx:312
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:88
#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:128
msgid "至"
msgstr "至"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:612
msgid "至少10字才能給分喔～"
msgstr "至少10字才能給分喔～"

#: apps/dp-client/src/screens/home/pages/Note/components/AddNoteTip/index.tsx:22
msgid "至少上傳3張圖片"
msgstr "至少上傳3張圖片"

#: apps/dp-client/src/screens/home/pages/Note/components/AddNoteTip/index.tsx:23
msgid "至少提供350字數"
msgstr "至少提供350字數"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1389
msgid "至少提前"
msgstr "至少提前"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1406
msgid "至少提前時間不能大於最多提前時間"
msgstr "至少提前時間不能大於最多提前時間"

#: apps/dp-admin/src/components/MapPicker/index.web.tsx:652
msgid "至少需要 3 個有效點位才會顯示多邊形邊界。"
msgstr "至少需要 3 個有效點位才會顯示多邊形邊界。"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:53
msgid "至少需要兩個標籤才能進行合併"
msgstr "至少需要兩個標籤才能進行合併"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:68
msgid "致命影響／系統中斷"
msgstr "致命影響／系統中斷"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:266
#: apps/dp-client/src/screens/home/pages/Meal/components/ShopInfoCard/index.tsx:319
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:255
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:1093
msgid "致電"
msgstr "致電"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:213
msgid "致電商家"
msgstr "致電商家"

#: apps/dp-business/src/data/regions.ts:12
msgid "臺中"
msgstr "臺中"

#: apps/dp-business/src/data/regions.ts:9
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:27
msgid "臺北"
msgstr "臺北"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:38
msgid "臺北101購物中心地下停車場"
msgstr "臺北101購物中心地下停車場"

#: apps/dp-client/src/screens/home/utils/location.ts:57
#: apps/dp-client/src/screens/home/components/CitySelect/index.tsx:81
#: apps/dp-client/src/screens/diary/store/location.ts:60
#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/index.tsx:229
#: apps/dp-business/src/pages/AddressEdit/index.tsx:518
#: apps/dp-business/src/pages/AddressEdit/index.tsx:548
#: apps/dp-business/src/pages/AddStore/index.tsx:626
#: apps/dp-business/src/pages/AddStore/index.tsx:627
#: apps/dp-business/src/pages/AddStore/index.tsx:632
#: apps/dp-business/src/pages/AddStore/index.tsx:633
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:95
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:407
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:418
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:429
msgid "臺北市"
msgstr "臺北市"

#: apps/dp-business/src/pages/AddressEdit/index.tsx:181
#: apps/dp-business/src/pages/AddressEdit/index.tsx:190
msgid "臺北市中正區"
msgstr "臺北市中正區"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/types.ts:114
msgid "臺北市信義區秀妍路838號"
msgstr "臺北市信義區秀妍路838號"

#: apps/dp-business/src/pages/AddressEdit/index.tsx:76
#: apps/dp-business/src/pages/AddressEdit/index.tsx:210
msgid "臺北市士林區天母西路50號"
msgstr "臺北市士林區天母西路50號"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:49
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:119
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:175
msgid "臺北產品"
msgstr "臺北產品"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:35
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:91
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:133
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:189
msgid "臺北維運"
msgstr "臺北維運"

#: apps/dp-business/src/data/regions.ts:13
msgid "臺南"
msgstr "臺南"

#: apps/dp-business/src/data/regions.ts:26
msgid "臺東"
msgstr "臺東"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:303
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:64
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:435
msgid "臺灣"
msgstr "臺灣"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:52
msgid "臺灣手機"
msgstr "臺灣手機"

#: apps/dp-business/src/servers/addStore/api.ts:202
#: apps/dp-business/src/pages/AddressEdit/index.tsx:516
#: apps/dp-business/src/pages/AddressEdit/index.tsx:546
msgid "臺灣省"
msgstr "臺灣省"

#: apps/dp-client/src/screens/login/components/privacy-agreement/index.tsx:76
#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:159
msgid "與"
msgstr "與"

#: apps/dp-client/src/screens/diary/pages/plaza/index.tsx:85
#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:349
msgid "與 {companionText} 一起用餐"
msgstr "與 {companionText} 一起用餐"

#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:127
msgid "與之前名稱一致，無需修改！"
msgstr "與之前名稱一致，無需修改！"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:301
msgid "與匯款作業相關，設定後即無法修改，請正確填寫。"
msgstr "與匯款作業相關，設定後即無法修改，請正確填寫。"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:117
msgid "與合併、收購或資產出售相關的情況。"
msgstr "與合併、收購或資產出售相關的情況。"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:109
msgid "與我們合作提供產品或服務的公司。"
msgstr "與我們合作提供產品或服務的公司。"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:363
msgid "與手機至少填寫一項"
msgstr "與手機至少填寫一項"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:133
msgid "與當前商家不一致"
msgstr "與當前商家不一致"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:348
msgid "與郵箱至少填寫一項"
msgstr "與郵箱至少填寫一項"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/LegalPerson/index.web.tsx:98
#: apps/dp-admin/src/pages/merchant/audit-detail/components/BusinessLicense/index.web.tsx:74
#: apps/dp-admin/src/pages/merchant/audit-detail/components/AccountInfo/index.web.tsx:102
msgid "舊資料"
msgstr "舊資料"

#: apps/dp-business/src/data/regions.ts:25
msgid "花蓮"
msgstr "花蓮"

#: apps/dp-business/src/data/regions.ts:17
msgid "苗栗"
msgstr "苗栗"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:54
msgid "若填寫了店家ID，請勿填寫「名稱、城市、行政區、詳細地址、分類」"
msgstr "若填寫了店家ID，請勿填寫「名稱、城市、行政區、詳細地址、分類」"

#: apps/dp-business/src/pages/AccountDeactivation/index.tsx:134
msgid "若未來需使用商路端帳號，需要運營端為你重新創建（需使用新的手機號）"
msgstr "若未來需使用商路端帳號，需要運營端為你重新創建（需使用新的手機號）"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:55
msgid "若沒有填寫店家ID，請必須填寫「名稱、城市、行政區、詳細地址、分類」"
msgstr "若沒有填寫店家ID，請必須填寫「名稱、城市、行政區、詳細地址、分類」"

#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:175
msgid "若活動權益歸屬第三方，用戶第三方綁定&解綁將影響用戶權益使用"
msgstr "若活動權益歸屬第三方，用戶第三方綁定&解綁將影響用戶權益使用"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:188
msgid "若請求超時或連線中斷，任務可能已受理。請先查看生成批次，確認後再重新開啟追加，避免重複生成。"
msgstr "若請求超時或連線中斷，任務可能已受理。請先查看生成批次，確認後再重新開啟追加，避免重複生成。"

#: apps/dp-client/src/screens/home/pages/PrivateChef/constants.ts:16
msgid "若需調整人數、日期或取消訂位，請依訂位詳情頁規則操作。"
msgstr "若需調整人數、日期或取消訂位，請依訂位詳情頁規則操作。"

#: apps/dp-business/src/pages/ContactBD/index.tsx:232
msgid "若非上述時間，建議以email聯繫"
msgstr "若非上述時間，建議以email聯繫"

#: apps/dp-admin/src/components/FileUpload/index.web.tsx:90
msgid "若非單頁文件，建議合併為單一PDF檔"
msgstr "若非單頁文件，建議合併為單一PDF檔"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1742
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1758
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:283
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:514
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:551
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:317
#: apps/dp-admin/src/pages/org-tree/services/constants.ts:60
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:84
#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:124
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:206
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:24
#: apps/dp-admin/src/pages/data-center/review-detail/index.web.tsx:24
#: apps/dp-admin/src/modules/constants/options.ts:616
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:57
msgid "草稿"
msgstr "草稿"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:194
msgid "草稿保存失敗，請重試"
msgstr "草稿保存失敗，請重試"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:195
msgid "草稿保存成功"
msgstr "草稿保存成功"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:543
msgid "草稿保存成功！"
msgstr "草稿保存成功！"

#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:298
#: apps/dp-client/src/screens/diary/hooks/useDraftSave.ts:158
msgid "草稿儲存失敗，請重試"
msgstr "草稿儲存失敗，請重試"

#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:292
#: apps/dp-client/src/screens/diary/hooks/useDraftSave.ts:151
msgid "草稿儲存成功"
msgstr "草稿儲存成功"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1988
msgid "草稿儲存成功！"
msgstr "草稿儲存成功！"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:323
msgid "草稿內容格式錯誤"
msgstr "草稿內容格式錯誤"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:292
msgid "草稿列表獲取失敗"
msgstr "草稿列表獲取失敗"

#: apps/dp-client/src/screens/account/pages/drafts/components/DraftCard.tsx:162
msgid "草稿圖片"
msgstr "草稿圖片"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:321
msgid "草稿已帶出"
msgstr "草稿已帶出"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1444
msgid "草稿已暫存，未提交審核"
msgstr "草稿已暫存，未提交審核"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1037
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:674
msgid "草稿已更新，請重新加載"
msgstr "草稿已更新，請重新加載"

#: apps/dp-client/src/screens/home/pages/Review/pages/draft/index.tsx:144
#: apps/dp-client/src/screens/account/pages/drafts/main/index.tsx:470
msgid "草稿應用程式卸載後會刪除，請及時發佈"
msgstr "草稿在移除應用程式後會被刪除，請及時發佈"

#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:289
msgid "草稿更新成功"
msgstr "草稿更新成功"

#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:131
msgid "草稿樹尚未生效，暫不支持上下架"
msgstr "草稿樹尚未生效，暫不支持上下架"

#: apps/dp-client/src/screens/home/pages/Note/pages/draft/index.tsx:179
#: apps/dp-client/src/screens/account/pages/profile/components/MyReviewsContent/index.tsx:228
#: apps/dp-client/src/screens/account/pages/profile/components/ContentTabsSection/UserNoteSection.tsx:199
#: apps/dp-client/src/screens/account/pages/profile/components/ContentTabsSection/UserNoteSection.tsx:258
#: apps/dp-client/src/screens/account/pages/drafts/main/index.tsx:456
#: apps/dp-client/src/configs/page-configs.tsx:2202
#: apps/dp-client/src/configs/page-configs.tsx:2204
msgid "草稿箱"
msgstr "草稿箱"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:315
msgid "草稿詳情獲取失敗"
msgstr "草稿詳情獲取失敗"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:37
msgid "菜品好評榜"
msgstr "菜品好評榜"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:17
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:28
msgid "菜品菜單"
msgstr "餐點菜單"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1061
msgid "菜品資訊"
msgstr "餐點資訊"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/TextMenu/index.tsx:125
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/Menu/index.tsx:83
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopDishGallery.tsx:189
#: apps/dp-client/src/screens/diary/pages/my/components/PointsInfoCard.tsx:52
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:546
#: apps/dp-client/src/configs/page-configs.tsx:167
#: apps/dp-admin/src/pages/users/permissions/components/PermissionTreeTable/index.web.tsx:48
msgid "菜單"
msgstr "菜單"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:115
msgid "菜單_{batchId}.xlsx"
msgstr "菜單_{batchId}.xlsx"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:99
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:84
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:94
#: apps/dp-admin/src/pages/merchant/shop-detail/components/DetailMobile/components/MerchantActionButtons.web.tsx:45
msgid "菜單&餐點"
msgstr "菜單&餐點"

#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:291
msgid "菜單儲存失敗，請重試"
msgstr "菜單儲存失敗，請重試"

#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:278
#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:280
msgid "菜單儲存成功！"
msgstr "菜單儲存成功！"

#: apps/dp-business/src/pages/MenuManagement.tsx:104
msgid "菜單分類名稱重複"
msgstr "菜單分類名稱重複"

#: apps/dp-business/src/pages/MenuManagement.tsx:760
msgid "菜單分類名稱重複，請重新輸入"
msgstr "菜單分類名稱重複，請重新輸入"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:208
msgid "菜單功能描述（可選）"
msgstr "菜單功能描述（可選）"

#: apps/dp-business/src/pages/MenuManagement.tsx:554
msgid "菜單名稱"
msgstr "菜單名稱"

#: apps/dp-business/src/pages/MenuManagement.tsx:715
msgid "菜單名稱重複，請重新輸入"
msgstr "菜單名稱重複，請重新輸入"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:168
msgid "菜單圖標"
msgstr "菜單圖標"

#: apps/dp-business/src/pages/MenuManagement.tsx:1126
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:346
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:93
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:411
#: apps/dp-business/src/components/MaintenanceList/index.tsx:228
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:903
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:491
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:896
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:246
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:140
msgid "菜單圖片"
msgstr "菜單圖片"

#: apps/dp-business/src/pages/MenuItemForm.tsx:545
msgid "菜單標籤"
msgstr "菜單標籤"

#: apps/dp-business/src/utils/permissionUtils.ts:423
msgid "菜單權限檢查: {menuCode}"
msgstr "菜單權限檢查: {menuCode}"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:117
msgid "菜單權限設定說明"
msgstr "菜單權限設定說明"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:154
msgid "菜單管理"
msgstr "菜單管理"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:244
#: apps/dp-business/src/pages/MenuManagement.tsx:1109
#: apps/dp-business/src/pages/MenuManagement.tsx:1411
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1012
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:132
#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:311
msgid "菜單與餐點"
msgstr "菜單與餐點"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:100
msgid "菜單與餐點資訊完整度評分"
msgstr "菜單與餐點資訊完整度評分"

#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:871
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:876
msgid "菜單識別失敗，請重試"
msgstr "菜單識別失敗，請重試"

#. placeholder {0}: data.menuItems.length
#. placeholder {1}: data.menuTypes.length
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:862
msgid "菜單識別完成！識別出 {0} 個菜品，{1} 個分類"
msgstr "菜單識別完成！識別出 {0} 個餐點，{1} 個分類"

#: apps/dp-business/src/pages/MenuManagement.tsx:1069
msgid "菜單資料儲存失敗"
msgstr "菜單資料儲存失敗"

#: apps/dp-business/src/pages/MenuManagement.tsx:1052
msgid "菜單資料儲存成功"
msgstr "菜單資料儲存成功"

#: apps/dp-business/src/pages/MenuManagement.tsx:514
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:199
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:280
msgid "菜單類別"
msgstr "菜單類別"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:121
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1107
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:698
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:73
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:88
msgid "菜單餐點"
msgstr "菜單餐點"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:245
msgid "菜色圖片"
msgstr "菜色圖片"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:73
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:91
msgid "落地頁"
msgstr "落地頁"

#: apps/dp-admin/src/pages/resource-config/landing-page-list/index.web.tsx:79
msgid "落地頁列表"
msgstr "落地頁列表"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:72
msgid "落地頁圖片"
msgstr "落地頁圖片"

#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:60
#: apps/dp-admin/src/components/LandingPage/LandingPageDetailInfo/index.web.tsx:45
msgid "落地頁編碼"
msgstr "落地頁編碼"

#: apps/dp-admin/src/router/config/routes.web.tsx:684
#: apps/dp-admin/src/pages/resource-config/landing-page-list/index.web.tsx:44
#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:182
#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:188
msgid "落地頁配置"
msgstr "落地頁配置"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:656
msgid "落地頁配置詳情"
msgstr "落地頁配置詳情"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:52
msgid "落地頁面"
msgstr "落地頁面"

#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/searchConfig.ts:26
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:48
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:217
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/searchConfig.ts:33
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/SearchForm/index.web.tsx:43
#: apps/dp-admin/src/components/LandingPage/LandingPageDetailInfo/index.web.tsx:48
msgid "落地頁類型"
msgstr "落地頁類型"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:292
msgid "薯條"
msgstr "薯條"

#: apps/dp-business/src/components/MerchantBenefits/index.tsx:50
msgid "藉由平台用戶的推薦與分享，您的餐廳會在社群廣泛傳播，提升品牌知名度與影響力。"
msgstr "藉由平台用戶的推薦與分享，您的餐廳會在社群廣泛傳播，提升品牌知名度與影響力。"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:150
msgid "藍新"
msgstr "藍新"

#. placeholder {0}: getStatusText(record.bluenewContractStatus)
#. placeholder {0}: lanxinSignStatus.label || t`未知狀態`
#. placeholder {0}: getContractStatus( record.bluenewContractStatus as ContractStatus )?.label
#: apps/dp-business/src/pages/ContractManagement/index.tsx:303
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/SigningStatus/index.web.tsx:55
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:518
msgid "藍新{0}"
msgstr "藍新{0}"

#: apps/dp-admin/src/pages/transaction/contract-management/index.web.tsx:167
msgid "藍新ID"
msgstr "藍新ID"

#. placeholder {0}: tradeNo || EMPTY_TEXT
#. placeholder {0}: row.newebpayTradeNo || EMPTY_TEXT
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCells.tsx:104
#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:66
msgid "藍新交易序號：{0}"
msgstr "藍新交易序號：{0}"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:626
msgid "藍新合約管理"
msgstr "藍新合約管理"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/BlueNewContractTab/index.web.tsx:161
msgid "藍新合約變更歷史"
msgstr "藍新合約變更歷史"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/OrderInfoCard/index.web.tsx:28
msgid "藍新單號"
msgstr "藍新單號"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:417
msgid "藍新審批拒絕"
msgstr "藍新審核拒絕"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:403
msgid "藍新審查中"
msgstr "藍新審查中"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:284
msgid "藍新審核狀態"
msgstr "藍新審核狀態"

#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:164
msgid "藍新審核通過開始日期 - 藍新審核通過結束日期"
msgstr "藍新審核通過開始日期 - 藍新審核通過結束日期"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:396
msgid "藍新已到期"
msgstr "藍新已到期"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:382
msgid "藍新已簽約"
msgstr "藍新已簽約"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:588
msgid "藍新帳號不能超過50個字符"
msgstr "藍新帳號不能超過50個字符"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreName/index.web.tsx:42
msgid "藍新店家名稱"
msgstr "藍新店家名稱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreName/index.web.tsx:48
msgid "藍新店家名稱不能超過20個字符"
msgstr "藍新店家名稱不能超過20個字符"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreName/index.web.tsx:60
msgid "藍新店家英文名稱"
msgstr "藍新店家英文名稱"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:389
msgid "藍新快到期"
msgstr "藍新快到期"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:410
msgid "藍新提交失敗"
msgstr "藍新上傳失敗"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:249
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:265
msgid "藍新服務"
msgstr "藍新服務"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:874
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:114
msgid "藍新服務時間"
msgstr "藍新服務時間"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:252
msgid "藍新服務正常運行"
msgstr "藍新服務正常運行"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:569
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:650
msgid "藍新狀態"
msgstr "藍新狀態"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:72
msgid "藍新登入帳號"
msgstr "藍新登入帳號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:132
msgid "藍新登錄賬號"
msgstr "藍新登錄賬號"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:254
msgid "藍新簽約受影響"
msgstr "藍新簽約受影響"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractDetailHeader/index.web.tsx:81
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:270
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:269
msgid "藍新簽約狀態"
msgstr "藍新簽約狀態"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:150
msgid "藍新資格不符"
msgstr "藍新資格不符"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainBluenewTag.tsx:20
msgid "藍新資格有效"
msgstr "藍新資格有效"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainBluenewTag.tsx:21
msgid "藍新資格無效"
msgstr "藍新資格無效"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:160
msgid "藍綠色"
msgstr "藍綠色"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:158
msgid "藍色"
msgstr "藍色"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:305
msgid "藍調"
msgstr "藍調"

#: apps/dp-business/src/data/regions.ts:61
msgid "蘆洲區"
msgstr "蘆洲區"

#: apps/dp-admin/src/pages/customer-service/components/TicketTable.web.tsx:70
msgid "處理"
msgstr "處理"

#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:54
#: apps/dp-client/src/screens/diary/components/StatusTag.tsx:12
#: apps/dp-client/src/screens/diary/components/StatusTag.tsx:13
#: apps/dp-client/src/screens/diary/components/PointsStatus.tsx:53
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:259
#: apps/dp-client/src/screens/account/pages/advice/my-feedback/index.tsx:62
#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:57
#: apps/dp-business/src/pages/RefundList/index.tsx:121
#: apps/dp-business/src/pages/RefundList/index.tsx:149
#: apps/dp-business/src/pages/ComplaintList/index.tsx:36
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:235
#: apps/dp-admin/src/pages/worker-order/services/constants.ts:39
#: apps/dp-admin/src/pages/report-center/services/apis.ts:212
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:65
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:139
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskFilterHeader/index.web.tsx:56
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:136
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:136
#: apps/dp-admin/src/pages/merchant/service/constants.ts:48
#: apps/dp-admin/src/pages/marketing/services/interface/batchTask.ts:31
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:52
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:64
#: apps/dp-admin/src/pages/customer-service/services/constants.ts:10
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:50
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:182
msgid "處理中"
msgstr "處理中"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:396
#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:127
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/PhotoManipulator.web.tsx:90
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/PhotoManipulator.native.tsx:92
#: apps/dp-client/src/screens/diary/pages/my/components/RNCropPhoto/CropPhoto.tsx:921
#: apps/dp-client/src/screens/diary/pages/my/components/CropPhoto/index.web.tsx:345
#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:89
#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:136
#: apps/dp-client/src/screens/account/pages/account-security/email/email-old/index.tsx:104
#: apps/dp-client/src/screens/account/pages/account-security/email/bind-email/index.tsx:98
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1037
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1046
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1058
#: apps/dp-business/src/components/InvoiceForm/index.tsx:590
msgid "處理中..."
msgstr "處理中..."

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:111
msgid "處理中工單"
msgstr "處理中工單"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:82
msgid "處理交易並發送相關通知"
msgstr "處理交易並發送相關通知"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1263
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:254
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:312
msgid "處理人員"
msgstr "處理人員"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:79
#: apps/dp-admin/src/pages/merchant/task-list/components/ActionButtons/index.web.tsx:55
msgid "處理任務"
msgstr "處理任務"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:424
msgid "處理備註"
msgstr "處理備註"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:369
msgid "處理動作"
msgstr "處理動作"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:223
msgid "處理參數"
msgstr "處理參數"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:81
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:413
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:47
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:48
msgid "處理圖像時出錯"
msgstr "處理圖像時出錯"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:149
#: apps/dp-admin/src/pages/marketing/services/interface/batchTask.ts:34
msgid "處理失敗"
msgstr "處理失敗"

#: apps/dp-admin/src/pages/marketing/services/interface/batchTask.ts:32
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:162
msgid "處理完成"
msgstr "處理完成"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:35
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:491
#: apps/dp-admin/src/pages/customer-service/components/TicketTable.web.tsx:40
msgid "處理客服"
msgstr "處理客服"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/Details.web.tsx:67
msgid "處理明細"
msgstr "處理明細"

#: apps/dp-admin/src/pages/order/order-detail/components/RefundRecords/index.web.tsx:64
msgid "處理時間"
msgstr "處理時間"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/Details.web.tsx:98
#: apps/dp-admin/src/pages/audit-center/components/AuditInfoHeader/config.ts:43
msgid "處理結果"
msgstr "處理結果"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:630
msgid "處理結果失敗: "
msgstr "處理結果失敗: "

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:364
msgid "處理詳情"
msgstr "處理詳情"

#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:211
#: apps/dp-admin/src/pages/audit-center/services/columns.web.tsx:438
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiDataTable/index.web.tsx:174
msgid "處理說明"
msgstr "處理說明"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:373
#: apps/dp-business/src/pages/ComplaintList/index.tsx:295
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/ExportHistoryTab/index.web.tsx:91
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/ExportHistoryTab/index.web.tsx:91
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:173
msgid "處理進度"
msgstr "處理進度"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:234
#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:322
msgid "處理類型"
msgstr "處理類型"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:33
msgid "虛假宣傳"
msgstr "虛假宣傳"

#: apps/dp-business/src/data/categories.ts:201
msgid "蛋糕"
msgstr "蛋糕"

#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:143
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/rawDataMapper.ts:178
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:118
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:365
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:113
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/columns/index.web.tsx:102
#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:453
msgid "行政區"
msgstr "行政區"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:815
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:864
msgid "行業類型"
msgstr "行業類型"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:257
msgid "行程有變，需要重新預訂"
msgstr "行程有變，需要重新預訂"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:27
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:27
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/previewColumns.web.tsx:28
msgid "行號"
msgstr "行號"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:129
msgid "行距"
msgstr "行距"

#: apps/dp-business/src/components/MerchantBenefits/index.tsx:43
msgid "行銷廣告"
msgstr "行銷廣告"

#: apps/dp-client/src/screens/home/utils/order.ts:613
#: apps/dp-client/src/screens/home/utils/order.ts:639
#: apps/dp-client/src/screens/home/utils/order.ts:655
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1807
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1965
msgid "行銷節假日不可用"
msgstr "行銷節假日不可用"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:790
#: apps/dp-business/src/components/CustomTabs/index.tsx:79
#: apps/dp-admin/src/router/config/routes.web.tsx:119
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:364
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:128
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:146
msgid "行銷管理"
msgstr "行銷管理"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:60
#: apps/dp-business/src/configs/page-configs.ts:971
msgid "行銷管理中心"
msgstr "行銷管理中心"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:44
msgid "街口支付"
msgstr "街口支付"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallProgressCard/index.tsx:67
msgid "衝吧～"
msgstr "衝吧～"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:239
msgid "表單已重置"
msgstr "表單已重置"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:183
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:274
msgid "表單校驗失敗"
msgstr "表單校驗失敗"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:800
msgid "表單校驗失敗，請檢查必填項和格式要求"
msgstr "表單校驗失敗，請檢查必填項和格式要求"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/index.web.tsx:91
msgid "表單校驗未通過，請檢查並完善必填項"
msgstr "表單校驗未通過，請檢查並完善必填項"

#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:566
msgid "表單校驗未通過，請檢查紅色提示項"
msgstr "表單校驗未通過，請檢查紅色提示項"

#: apps/dp-admin/src/components/ConfigurableForm/ConfigurableForm.web.tsx:413
msgid "表單設定錯誤"
msgstr "表單設定錯誤"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:87
#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:135
msgid "表單驗證失敗"
msgstr "表單驗證失敗"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:199
msgid "被合併標籤數:"
msgstr "被合併標籤數:"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:231
msgid "被合併的標籤將標記為“已停用”狀態"
msgstr "被合併的標籤將標記為“已停用”狀態"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:475
msgid "被平台終止"
msgstr "被平台終止"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:328
msgid "被投訴的評論"
msgstr "被投訴的評論"

#: apps/dp-admin/src/pages/merchant/content-report/index.web.tsx:108
msgid "被檢舉的內容"
msgstr "被檢舉的內容"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:190
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:255
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:201
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:190
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1119
msgid "被複製店家"
msgstr "被複製店家"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:230
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:51
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:52
msgid "裁剪"
msgstr "裁剪"

#. placeholder {0}: imageDimensions.width
#. placeholder {1}: imageDimensions.height
#: apps/dp-client/src/screens/diary/pages/my/components/RNCropPhoto/CropPhoto.tsx:497
msgid "裁剪區域無效: originX={originX}, originY={originY}, cropWidth={cropWidth}, cropHeight={cropHeight}, imageSize={0}x{1}"
msgstr "裁剪區域無效: originX={originX}, originY={originY}, cropWidth={cropWidth}, cropHeight={cropHeight}, imageSize={0}x{1}"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:262
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:57
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:58
msgid "裁剪形狀"
msgstr "裁剪形狀"

#: apps/dp-client/src/screens/diary/pages/my/components/RNCropPhoto/CropPhotoControls.tsx:41
#: apps/dp-client/src/screens/diary/pages/my/components/CropPhoto/index.web.tsx:337
msgid "裁剪照片"
msgstr "裁剪照片"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:264
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:58
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:59
msgid "裁剪邊界"
msgstr "裁剪邊界"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:110
msgid "補償任務列表"
msgstr "補償任務列表"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:892
msgid "補充商家（非必填）"
msgstr "補充商家（非必填）"

#: apps/dp-admin/src/pages/audit-center/merchant-audit/components/MerchantImages/index.web.tsx:172
msgid "補充圖片"
msgstr "補充圖片"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:177
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:195
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:210
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:312
msgid "補充說明"
msgstr "補充說明"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:293
msgid "補充說明（選填）"
msgstr "補充說明（選填）"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:569
msgid "補充退款原因詳情，有助於去哪吃為您提供更好的服務"
msgstr "補充退款原因詳情，有助於去哪吃為您提供更好的服務"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:69
msgid "補發"
msgstr "補發"

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:168
msgid "補貼上限"
msgstr "補貼上限"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2559
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:170
msgid "補貼明細"
msgstr "補貼明細"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/SubsidyCard.tsx:67
msgid "補貼比例"
msgstr "補貼比例"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:274
msgid "裝飾"
msgstr "裝飾"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:318
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:276
#: apps/dp-business/src/pages/UserManagement/index.tsx:590
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1407
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:430
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:192
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:193
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:210
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:211
#: apps/dp-admin/src/pages/merchant/information-error/components/ErrorInfoSection/index.web.tsx:133
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:221
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:412
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:199
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:148
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/OriginalReviewSection/index.web.tsx:142
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/MerchantComplaintSection/index.web.tsx:135
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/AppealInfoSection/index.web.tsx:112
#: apps/dp-admin/src/pages/audit-center/components/MerchantInfoCard/index.web.tsx:96
msgid "複製"
msgstr "複製"

#. placeholder {0}: item.label
#: apps/dp-admin/src/pages/order/order-detail/components/BasicInfo/index.web.tsx:100
msgid "複製{0}"
msgstr "複製{0}"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:53
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:34
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:35
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:37
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:63
msgid "複製中"
msgstr "複製中"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:562
msgid "複製任務已提交，請在「歷史記錄」查看進度"
msgstr "複製任務已提交，請在「歷史記錄」查看進度"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:212
msgid "複製任務已提交，請在下方歷史記錄中查看進度"
msgstr "複製任務已提交，請在下方歷史記錄中查看進度"

#: apps/dp-business/src/pages/UserManagement/index.tsx:697
msgid "複製使用者"
msgstr "複製使用者"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:202
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:264
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:265
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:90
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:193
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:630
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1122
msgid "複製內容"
msgstr "複製內容"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:196
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:269
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:252
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:212
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:83
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:623
msgid "複製到的店家"
msgstr "複製到的店家"

#: apps/dp-business/src/servers/permission/api.ts:529
msgid "複製員工帳號失敗"
msgstr "複製員工帳號失敗"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:50
msgid "複製商家名單"
msgstr "複製商家名單"

#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:69
msgid "複製商家權益"
msgstr "複製商家權益"

#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:174
msgid "複製商家活動"
msgstr "複製商家活動"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:117
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:535
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:118
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:133
#: apps/dp-client/src/screens/account/components/feedback-modal/index.tsx:39
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:128
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:143
#: apps/dp-business/src/pages/UserManagement/index.tsx:421
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:143
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:146
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:319
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:263
#: apps/dp-business/src/components/ShopInfoCard/index.tsx:104
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:66
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/MerchantInfo/index.web.tsx:28
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:28
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:24
#: apps/dp-admin/src/pages/order/order-detail/components/BasicInfo/index.web.tsx:71
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:84
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/CopyText.web.tsx:18
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:97
#: apps/dp-admin/src/pages/merchant/audit-detail/components/CopyText/index.web.tsx:14
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:84
#: apps/dp-admin/src/pages/audit-center/components/MerchantInfoCard/index.web.tsx:57
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:60
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:103
msgid "複製失敗"
msgstr "複製失敗"

#: apps/dp-admin/src/modules/hooks/usePhoneCall.ts:87
msgid "複製失敗，請手動撥打：{cleanPhoneNumber}"
msgstr "複製失敗，請手動撥打：{cleanPhoneNumber}"

#: apps/dp-admin/src/pages/merchant/information-error/components/ErrorInfoSection/index.web.tsx:41
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:575
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/OriginalReviewSection/index.web.tsx:54
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/MerchantComplaintSection/index.web.tsx:68
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/AppealInfoSection/index.web.tsx:43
msgid "複製失敗，請重試"
msgstr "複製失敗，請重試"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2207
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2290
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1111
msgid "複製套餐券"
msgstr "複製套餐券"

#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:457
msgid "複製帳號"
msgstr "複製帳號"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:784
msgid "複製店家資訊"
msgstr "複製店家資訊"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:115
#: apps/dp-client/src/screens/diary/pages/home/components/upgrade-modal/index.tsx:44
#: apps/dp-business/src/components/ShopInfoCard/index.tsx:104
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:20
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:84
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/CopyText.web.tsx:16
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:97
#: apps/dp-admin/src/pages/merchant/audit-detail/components/CopyText/index.web.tsx:12
#: apps/dp-admin/src/pages/audit-center/components/MerchantInfoCard/index.web.tsx:55
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:58
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:101
msgid "複製成功"
msgstr "複製成功"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:62
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountCopyForm.tsx:101
msgid "複製授權"
msgstr "複製授權"

#: apps/dp-business/src/servers/chain/accountApi.ts:184
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountCopyForm.tsx:90
msgid "複製授權失敗"
msgstr "複製授權失敗"

#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:152
msgid "複製權益"
msgstr "複製權益"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:633
msgid "複製歷史"
msgstr "複製歷史"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:197
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:287
msgid "複製活動"
msgstr "複製活動"

#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:61
msgid "複製活動功能開發中"
msgstr "複製活動功能開發中"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:223
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:297
msgid "複製狀態"
msgstr "複製狀態"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:60
msgid "複製用戶名單"
msgstr "複製用戶名單"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:168
msgid "複製角色時："
msgstr "複製角色時："

#: apps/dp-business/src/servers/reservation/api.ts:163
#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:177
msgid "複製訂位規則失敗"
msgstr "複製訂位規則失敗"

#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:153
msgid "複製記錄詳情"
msgstr "複製記錄詳情"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:838
msgid "複製設定"
msgstr "複製設定"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShareModal/index.tsx:101
#: apps/dp-client/src/screens/home/pages/MallDetail/index.tsx:259
#: apps/dp-client/src/components/ShareCard/index.tsx:162
msgid "複製連結"
msgstr "複製連結"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:165
#: apps/dp-client/src/screens/account/components/feedback-modal/index.tsx:106
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:175
msgid "複製郵箱地址"
msgstr "複製郵箱地址"

#: apps/dp-business/src/servers/shop/api.ts:491
msgid "複製餐廳資料失敗"
msgstr "複製餐廳資料失敗"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:112
msgid "複雜內容"
msgstr "複雜內容"

#: apps/dp-admin/src/components/RocDatePicker/index.web.tsx:89
msgid "西元"
msgstr "西元"

#: apps/dp-business/src/data/categories.ts:96
#: apps/dp-admin/src/pages/user-info/services/apis.ts:146
msgid "西餐"
msgstr "西餐"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:77
msgid "西餐·法式料理"
msgstr "西餐·法式料理"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:207
msgid "要刪除打卡紀錄嗎？"
msgstr "要刪除打卡紀錄嗎？"

#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:123
#: apps/dp-business/src/pages/CouponVerification/index.tsx:411
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:565
msgid "要核銷這張券碼？（套餐券）"
msgstr "要核銷這張券碼？（套餐券）"

#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:201
#: apps/dp-business/src/pages/CouponVerification/index.tsx:457
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:611
msgid "要核銷這張套餐券嗎？"
msgstr "要核銷這張套餐券嗎？"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:71
msgid "要求生成張數"
msgstr "要求生成張數"

#: apps/dp-client/src/screens/home/pages/ShareKing/components/ShareCompletedCard/index.tsx:57
msgid "要繼續分享嗎？"
msgstr "要繼續分享嗎？"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:297
msgid "覆蓋商家數量"
msgstr "覆蓋商家數量"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:564
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:759
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:12
msgid "規則"
msgstr "規則"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:194
msgid "規則不存在或刪除失敗"
msgstr "規則不存在或刪除失敗"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:134
msgid "規則不存在或更新失敗"
msgstr "規則不存在或更新失敗"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:208
msgid "規則已上架"
msgstr "規則已上架"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:208
msgid "規則已下架"
msgstr "規則已下架"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:181
msgid "規則狀態已更新"
msgstr "規則狀態已更新"

#: apps/dp-client/src/screens/home/pages/Purchase/components/RuleModal/index.tsx:72
msgid "規則說明"
msgstr "規則說明"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:276
msgid "規範"
msgstr "規範"

#: apps/dp-business/src/pages/UserManagement/index.tsx:498
#: apps/dp-business/src/pages/UserManagement/index.tsx:782
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:258
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:374
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:483
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:559
#: apps/dp-business/src/pages/EditUser/index.tsx:269
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:348
#: apps/dp-business/src/pages/AddUser/index.tsx:283
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:91
#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:91
#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:162
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:91
msgid "角色"
msgstr "角色"

#. placeholder {0}: roleNames.join('、')
#: apps/dp-business/src/pages/ChainDashboard/components/ChainTreeSwitcher.tsx:58
msgid "角色 {0}"
msgstr "角色 {0}"

#: apps/dp-business/src/pages/AddRole/index.tsx:264
msgid "角色 ID 不存在，無法更新"
msgstr "角色 ID 不存在，無法更新"

#. placeholder {0}: merchantUserInfo.roleName
#. placeholder {0}: operatorUserInfo.roleName
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:63
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:74
msgid "角色：{0}"
msgstr "角色：{0}"

#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:63
msgid "角色ID"
msgstr "角色ID"

#: apps/dp-admin/src/pages/users/roles/components/RoleTable/index.web.tsx:33
#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:70
msgid "角色代碼"
msgstr "角色代碼"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:247
msgid "角色保存失敗"
msgstr "角色保存失敗"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:395
msgid "角色列表"
msgstr "角色列表"

#: apps/dp-business/src/pages/PermissionManagement/index.tsx:135
#: apps/dp-business/src/pages/PermissionManagement/index.tsx:140
msgid "角色刪除失敗"
msgstr "角色刪除失敗"

#: apps/dp-business/src/pages/PermissionManagement/index.tsx:130
#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:317
msgid "角色刪除成功"
msgstr "角色刪除成功"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepRoles.web.tsx:101
msgid "角色加載失敗"
msgstr "角色加載失敗"

#: apps/dp-business/src/pages/PermissionManagement/index.tsx:151
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:152
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:280
#: apps/dp-business/src/pages/AddRole/index.tsx:387
#: apps/dp-admin/src/pages/users/roles/components/RoleTable/index.web.tsx:40
#: apps/dp-admin/src/pages/users/roles/components/RoleForm/index.web.tsx:71
#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:77
msgid "角色名稱"
msgstr "角色名稱"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:484
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepRoles.web.tsx:186
msgid "角色圈選"
msgstr "角色圈選"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:142
msgid "角色已刪除"
msgstr "角色已刪除"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:250
msgid "角色已建立"
msgstr "角色已建立"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:250
msgid "角色已更新"
msgstr "角色已更新"

#: apps/dp-business/src/pages/AddRole/index.tsx:324
#: apps/dp-business/src/pages/AddRole/index.tsx:330
msgid "角色建立失敗"
msgstr "角色建立失敗"

#: apps/dp-business/src/pages/AddRole/index.tsx:317
msgid "角色建立成功"
msgstr "角色建立成功"

#. placeholder {0}: role?.roleName || ''
#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:320
msgid "角色授權 - {0}"
msgstr "角色授權 - {0}"

#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:265
#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:269
msgid "角色授權失敗"
msgstr "角色授權失敗"

#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:260
msgid "角色授權成功"
msgstr "角色授權成功"

#: apps/dp-admin/src/pages/users/roles/components/RoleTable/index.web.tsx:47
#: apps/dp-admin/src/pages/users/roles/components/RoleForm/index.web.tsx:97
#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:84
msgid "角色描述"
msgstr "角色描述"

#: apps/dp-admin/src/pages/users/roles/components/RoleForm/index.web.tsx:98
msgid "角色描述不能超過200個字元"
msgstr "角色描述不能超過200個字元"

#: apps/dp-business/src/pages/AddRole/index.tsx:296
msgid "角色更新失敗"
msgstr "角色更新失敗"

#: apps/dp-business/src/pages/AddRole/index.tsx:289
msgid "角色更新成功"
msgstr "角色更新成功"

#: apps/dp-business/src/pages/PermissionManagement/index.tsx:217
msgid "角色權限管理"
msgstr "角色權限管理"

#: apps/dp-admin/src/pages/users/roles/services/hooks.ts:188
msgid "角色狀態更新成功"
msgstr "角色狀態更新成功"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:159
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:702
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:816
#: apps/dp-business/src/components/CustomTabs/index.tsx:234
#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:102
#: apps/dp-admin/src/router/config/routes.web.tsx:486
#: apps/dp-admin/src/pages/users/roles/index.web.tsx:56
msgid "角色管理"
msgstr "角色管理"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountToolbar/index.web.tsx:62
msgid "角色篩選"
msgstr "角色篩選"

#: apps/dp-admin/src/pages/users/roles/components/RoleForm/index.web.tsx:78
msgid "角色編碼"
msgstr "角色編碼"

#: apps/dp-admin/src/pages/users/roles/components/RoleDetailList/index.web.tsx:57
msgid "角色詳情"
msgstr "角色詳情"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:185
msgid "角色說明"
msgstr "角色說明"

#: apps/dp-admin/src/modules/hooks/options/useRoleOptions.ts:105
msgid "角色資料取得失敗"
msgstr "角色資料取得失敗"

#: apps/dp-admin/src/modules/hooks/options/useRoleOptions.ts:114
msgid "角色資料取得異常"
msgstr "角色資料取得異常"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleList.tsx:174
msgid "角色類型"
msgstr "角色類型"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/index.web.tsx:234
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/index.web.tsx:232
#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:140
msgid "解析中..."
msgstr "解析中..."

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:123
msgid "解析商家文件失敗"
msgstr "解析商家文件失敗"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:147
msgid "解析成功，共 {totalCount} 家商家"
msgstr "解析成功，共 {totalCount} 家商家"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:38
msgid "解決時長(分)"
msgstr "解決時長(分)"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:37
msgid "解決時間"
msgstr "解決時間"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:130
msgid "解綁商家"
msgstr "解綁商家"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:285
msgid "解綁失敗，請稍後重試"
msgstr "解綁失敗，請稍後重試"

#. placeholder {0}: lockedActivities.length
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:132
msgid "解鎖中 {0}"
msgstr "解鎖中 {0}"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityListSection.tsx:101
msgid "解鎖中活動"
msgstr "解鎖中活動"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1848
msgid "解除僅在本頁生效，保存並提交審核通過後才會正式解除。"
msgstr "解除僅在本頁生效，保存並提交審核通過後才會正式解除。"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:419
msgid "解除後，您將無法再透過該第三方帳號登入"
msgstr "解除後，您將無法再透過該第三方帳號登入"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/components/FetCouponDialog/index.tsx:82
msgid "解除後，您獲得的優惠券將無法使用"
msgstr "解除後，您獲得的優惠券將無法使用"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:53
msgid "解除後結算"
msgstr "解除後結算"

#: apps/dp-business/src/servers/chain/accountApi.ts:206
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountUnbindModal.tsx:69
msgid "解除授權失敗"
msgstr "解除授權失敗"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:281
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:314
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:173
msgid "解除本樹掛接"
msgstr "解除本樹掛接"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:50
msgid "解除節點"
msgstr "解除節點"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountUnbindModal.tsx:80
msgid "解除節點授權"
msgstr "解除節點授權"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:483
msgid "解除綁定"
msgstr "解除綁定"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:400
msgid "解除關聯"
msgstr "解除關聯"

#. placeholder {0}: index + 1
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:111
msgid "觸發事件 {0}"
msgstr "觸發事件 {0}"

#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:600
msgid "觸發事件已被進行中或待啟動活動佔用"
msgstr "觸發事件已被進行中或待啟動活動佔用"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:827
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:236
msgid "觸發事件與過濾項的組合不可重複"
msgstr "觸發事件與過濾項的組合不可重複"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:23
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:55
msgid "觸發事件適用商家"
msgstr "觸發事件適用商家"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/index.web.tsx:172
msgid "觸發事件配置"
msgstr "觸發事件配置"

#: apps/dp-client/src/screens/home/utils/filterData.ts:187
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopLocationInfo.tsx:205
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:97
#: apps/dp-client/src/screens/account/pages/profile/components/FunctionEntrySection/index.tsx:53
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:798
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:121
#: apps/dp-business/src/components/CustomTabs/index.tsx:120
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:110
msgid "訂位"
msgstr "訂位"

#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:134
msgid "訂位人姓名"
msgstr "訂位人姓名"

#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:161
msgid "訂位人手機號碼"
msgstr "訂位人手機號碼"

#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:175
#: apps/dp-client/src/configs/page-configs.tsx:1042
#: apps/dp-client/src/configs/page-configs.tsx:1057
#: apps/dp-admin/src/pages/user-info/user-detail/index.web.tsx:108
msgid "訂位列表"
msgstr "訂位列表"

#: apps/dp-client/src/screens/reservation/pages/list/pages/main/index.tsx:98
msgid "訂位列表空空的"
msgstr "訂位列表空空的"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:76
msgid "訂位成功後未收到推播通知"
msgstr "訂位成功後未收到推播通知"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1443
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1474
msgid "訂位按鈕點擊次數"
msgstr "訂位按鈕點擊次數"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:98
#: apps/dp-admin/src/pages/transaction/service/help/validate.ts:252
#: apps/dp-admin/src/pages/transaction/service/help/validate.ts:389
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BookingFeeRules/index.web.tsx:38
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/BookingFeeRules/index.web.tsx:41
msgid "訂位收費規則"
msgstr "訂位收費規則"

#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:66
msgid "訂位數"
msgstr "訂位數"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1190
msgid "訂位文字備註"
msgstr "訂位文字備註"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1966
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:2024
msgid "訂位文字描述 ( 用戶查看 )"
msgstr "訂位文字描述 ( 用戶查看 )"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:379
msgid "訂位時間間隔"
msgstr "訂位時間間隔"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:964
msgid "訂位時間間隔: 用戶可以隔30分鐘預約一次。"
msgstr "訂位時間間隔: 用戶可以隔30分鐘預約一次。"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:407
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:415
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:426
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:62
#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:91
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:32
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:141
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:757
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:299
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:562
msgid "訂位服務"
msgstr "訂位服務"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:431
#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:202
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:62
#: apps/dp-admin/src/pages/transaction/service-management/services/hooks.ts:203
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:302
msgid "訂位服務設定"
msgstr "訂位服務設定"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1387
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:799
#: apps/dp-business/src/components/CustomTabs/index.tsx:128
msgid "訂位概況"
msgstr "訂位概況"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:145
msgid "訂位無法取消"
msgstr "訂位無法取消"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:179
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:154
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:255
msgid "訂位狀態"
msgstr "訂位狀態"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1905
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:801
#: apps/dp-business/src/components/CustomTabs/index.tsx:142
msgid "訂位管理"
msgstr "訂位管理"

#: apps/dp-business/src/components/MerchantBenefits/index.tsx:38
msgid "訂位系統"
msgstr "訂位系統"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:380
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:491
msgid "訂位紀錄"
msgstr "訂位紀錄"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:200
msgid "訂位規則刪除成功"
msgstr "訂位規則刪除成功"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:55
msgid "訂位規則創建成功"
msgstr "訂位規則創建成功"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:140
msgid "訂位規則更新成功"
msgstr "訂位規則更新成功"

#: apps/dp-business/src/servers/reservation/mock/mockApi.ts:171
msgid "訂位規則複製成功"
msgstr "訂位規則複製成功"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1453
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1481
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:90
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:266
msgid "訂位訂單數"
msgstr "訂位訂單數"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:819
msgid "訂位訂單詳情"
msgstr "訂位訂單詳情"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:490
#: apps/dp-client/src/configs/page-configs.tsx:1120
#: apps/dp-business/src/configs/page-configs.ts:201
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:641
#: apps/dp-admin/src/pages/user-info/reservation-detail/index.web.tsx:76
msgid "訂位詳情"
msgstr "訂位詳情"

#: apps/dp-client/src/screens/reservation/components/ReservationNotes/index.tsx:36
msgid "訂位說明"
msgstr "訂位說明"

#: apps/dp-client/src/screens/home/pages/PrivateChef/constants.ts:15
msgid "訂位送出後，請留意訂位確認結果與店家通知。"
msgstr "訂位送出後，請留意訂位確認結果與店家通知。"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1433
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1467
msgid "訂位頁訪問次數"
msgstr "訂位頁訪問次數"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1133
msgid "訂位須知"
msgstr "訂位須知"

#: apps/dp-client/src/screens/account/pages/profile/components/FunctionEntrySection/index.tsx:97
msgid "訂單"
msgstr "訂單"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/chainReportFilterFields.ts:33
#: apps/dp-business/src/pages/ChainDashboard/components/reports/chainReportFilterFields.ts:41
msgid "訂單 ID"
msgstr "訂單 ID"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/index.tsx:35
msgid "訂單 ID 不存在"
msgstr "訂單 ID 不存在"

#: apps/dp-business/src/pages/OrderList/index.tsx:451
#: apps/dp-business/src/pages/OrderList/index.tsx:832
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/columns.tsx:47
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:36
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/columns.tsx:37
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:119
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:203
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:44
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:94
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:99
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:20
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:85
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:37
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:26
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:47
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:49
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:52
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:56
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:116
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:63
msgid "訂單ID"
msgstr "訂單ID"

#: apps/dp-admin/src/pages/marketing/activity-statistics/services/config.web.tsx:20
msgid "訂單ID、用戶ID、商家ID或商家名稱"
msgstr "訂單ID、用戶ID、商家ID或商家名稱"

#. placeholder {0}: orderId || EMPTY_TEXT
#. placeholder {0}: row.orderId || EMPTY_TEXT
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCells.tsx:101
#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:63
msgid "訂單ID：{0}"
msgstr "訂單ID：{0}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/selfRedemption/index.tsx:71
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:106
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:301
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:473
#: apps/dp-business/src/pages/OrderDetail/index.tsx:592
msgid "訂單ID不能為空"
msgstr "訂單ID為必填資訊"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/index.tsx:92
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/index.tsx:91
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/index.tsx:97
msgid "訂單ID格式不正確"
msgstr "訂單ID格式不正確"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:802
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:290
msgid "訂單不存在"
msgstr "訂單不存在"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1602
msgid "訂單佣金"
msgstr "訂單佣金"

#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:299
msgid "訂單來源"
msgstr "訂單來源"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:54
msgid "訂單信息"
msgstr "訂單信息"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:631
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:637
msgid "訂單修改失敗"
msgstr "訂單修改失敗"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:627
msgid "訂單修改成功"
msgstr "訂單修改成功"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1677
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1791
#: apps/dp-admin/src/pages/order/order-detail/components/BasicInfo/index.web.tsx:193
msgid "訂單備註"
msgstr "訂單備註"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:219
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:813
#: apps/dp-admin/src/router/config/routes.web.tsx:206
#: apps/dp-admin/src/pages/user-info/user-detail/index.web.tsx:88
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1083
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:198
#: apps/dp-admin/src/pages/order/merchant-order-list/index.web.tsx:76
#: apps/dp-admin/src/pages/order/merchant-order-list/index.web.tsx:136
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:183
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:184
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:201
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:202
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/index.web.tsx:151
#: apps/dp-admin/src/pages/marketing/order-list/index.web.tsx:46
#: apps/dp-admin/src/pages/marketing/order-list/index.web.tsx:54
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/OrderListTab.web.tsx:53
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:180
#: apps/dp-admin/src/pages/marketing/components/OrderListSection/index.web.tsx:162
#: apps/dp-admin/src/pages/marketing/components/DiscountOrderListSection/index.web.tsx:118
#: apps/dp-admin/src/pages/marketing/activity-statistics/index.web.tsx:156
msgid "訂單列表"
msgstr "訂單列表"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:352
msgid "訂單列表頁"
msgstr "訂單列表頁"

#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:276
msgid "訂單券"
msgstr "訂單券"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:429
msgid "訂單包含"
msgstr "訂單包含"

#: apps/dp-business/src/pages/OrderList/index.tsx:491
msgid "訂單包含的券碼"
msgstr "訂單包含的券碼"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:207
msgid "訂單原始金額"
msgstr "訂單原始金額"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:23
msgid "訂單取消"
msgstr "訂單取消"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:621
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:788
msgid "訂單商品"
msgstr "訂單商品"

#: apps/dp-admin/src/pages/report-center/services/apis.ts:211
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:50
msgid "訂單問題"
msgstr "訂單問題"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:106
msgid "訂單因超時未付款，交易已關閉"
msgstr "訂單因超時未付款，交易已關閉"

#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:90
#: apps/dp-admin/src/pages/order/order-detail/components/BasicInfo/index.web.tsx:171
msgid "訂單基本資訊"
msgstr "訂單基本資訊"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:335
#: apps/dp-client/src/screens/account/pages/order/index.tsx:250
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:185
msgid "訂單已刪除"
msgstr "訂單已刪除"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:784
#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:320
#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:361
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:246
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:269
#: apps/dp-client/src/screens/account/pages/order/index.tsx:225
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:392
msgid "訂單已取消"
msgstr "訂單已取消"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:322
msgid "訂單已拒絕"
msgstr "訂單已拒絕"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:259
msgid "訂單已確認"
msgstr "訂單已確認"

#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:58
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:16
msgid "訂單提醒"
msgstr "訂單提醒"

#: apps/dp-client/src/configs/page-configs.tsx:2165
#: apps/dp-client/src/configs/page-configs.tsx:2166
msgid "訂單搜尋"
msgstr "訂單搜尋"

#: apps/dp-client/src/configs/page-configs.tsx:2182
#: apps/dp-client/src/configs/page-configs.tsx:2183
msgid "訂單搜尋結果"
msgstr "訂單搜尋結果"

#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:523
msgid "訂單操作日誌"
msgstr "訂單操作日誌"

#: apps/dp-business/src/pages/OrderList/index.tsx:534
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:92
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/columns.tsx:95
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1751
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:465
msgid "訂單收入"
msgstr "訂單收入"

#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesSummaryCards.tsx:40
msgid "訂單數"
msgstr "訂單數"

#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:57
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:168
msgid "訂單數量"
msgstr "訂單數量"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1697
#: apps/dp-business/src/pages/OrderList/index.tsx:686
#: apps/dp-business/src/pages/OrderList/index.tsx:969
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:805
#: apps/dp-business/src/configs/page-configs.ts:897
#: apps/dp-business/src/components/CustomTabs/index.tsx:153
msgid "訂單明細"
msgstr "訂單明細"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1639
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1776
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:57
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:98
msgid "訂單時間"
msgstr "訂單時間"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:472
msgid "訂單未付款，交易已關閉"
msgstr "訂單未付款，交易已關閉"

#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:334
msgid "訂單概覽"
msgstr "訂單概覽"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1753
#: apps/dp-business/src/pages/OrderOverview/FilterModal.tsx:37
#: apps/dp-business/src/pages/OrderList/index.tsx:587
#: apps/dp-business/src/pages/OrderList/index.tsx:921
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/columns.tsx:122
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesFilterBar.tsx:106
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/columns.tsx:116
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/components/DiscountFilterBar.tsx:95
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1655
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1763
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:625
#: apps/dp-business/src/pages/ChainDashboard/components/reports/checkoutDiscountColumns.tsx:76
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:50
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:866
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1095
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:69
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:131
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:83
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:320
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:121
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:162
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/config.web.tsx:36
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:145
msgid "訂單狀態"
msgstr "訂單狀態"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:339
msgid "訂單筆數"
msgstr "訂單筆數"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:803
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:19
msgid "訂單管理"
msgstr "訂單管理"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:977
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:285
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:335
#: apps/dp-business/src/pages/SimpleDashboard/components/RedeemCard.tsx:130
#: apps/dp-business/src/pages/RefundList/index.tsx:214
#: apps/dp-business/src/pages/RefundList/index.tsx:356
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1036
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1976
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:858
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1631
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1762
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:136
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:388
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:158
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:582
#: apps/dp-business/src/pages/CouponVerification/index.tsx:573
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:845
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:318
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:31
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:62
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:267
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:86
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:138
msgid "訂單編號"
msgstr "訂單編號"

#. placeholder {0}: record.orderId
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:432
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:154
msgid "訂單編號：{0}"
msgstr "訂單編號：{0}"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1182
msgid "訂單編號/顧客姓名/手機號"
msgstr "訂單編號/顧客姓名/手機號"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:162
msgid "訂單編號不能為空"
msgstr "訂單編號不能為空"

#: apps/dp-client/src/screens/account/pages/order/index.tsx:531
#: apps/dp-client/src/configs/page-configs.tsx:2131
#: apps/dp-client/src/configs/page-configs.tsx:2133
msgid "訂單總覽"
msgstr "訂單總覽"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:490
msgid "訂單處理中"
msgstr "訂單處理中"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1222
msgid "訂單處理紀錄"
msgstr "訂單處理紀錄"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:258
#: apps/dp-client/src/screens/payment/pages/result/index.tsx:755
msgid "訂單處理超時"
msgstr "訂單處理超時"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:205
#: apps/dp-business/src/pages/OrderDetail/index.tsx:767
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1093
#: apps/dp-admin/src/pages/user-info/reservation-detail/index.web.tsx:80
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:42
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/OrderInfoCard/index.web.tsx:22
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:377
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:158
msgid "訂單號"
msgstr "訂單號"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:110
msgid "訂單號或用戶 ID"
msgstr "訂單號或用戶 ID"

#: apps/dp-client/src/screens/reservation/pages/detail/components/OrderInfoSection.tsx:57
msgid "訂單訊息"
msgstr "訂單訊息"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:256
msgid "訂單訊息有誤，需要重新預訂"
msgstr "訂單訊息有誤，需要重新預訂"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:298
msgid "訂單評論"
msgstr "訂單評論"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:583
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:874
#: apps/dp-business/src/pages/OrderDetail/index.tsx:966
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1688
#: apps/dp-business/src/configs/page-configs.ts:944
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:25
#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:350
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:373
msgid "訂單詳情"
msgstr "訂單詳情"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:610
msgid "訂單詳情資料格式錯誤"
msgstr "訂單詳情資料格式錯誤"

#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:396
msgid "訂單詳情資訊"
msgstr "訂單詳情資訊"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1712
msgid "訂單詳情載入失敗"
msgstr "訂單詳情載入失敗"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:952
msgid "訂單詳細資訊"
msgstr "訂單詳細資訊"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:192
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:305
msgid "訂單資料載入失敗"
msgstr "訂單資料載入失敗"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:329
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/components/VerificationFilterBar.tsx:48
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesFilterBar.tsx:54
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/components/DiscountFilterBar.tsx:52
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/OrderInfoCard/index.web.tsx:20
msgid "訂單資訊"
msgstr "訂單資訊"

#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:207
#: apps/dp-client/src/screens/account/pages/notifications/pages/CategoryNotifications/index.tsx:48
#: apps/dp-admin/src/pages/other/services/constants.ts:55
msgid "訂單通知"
msgstr "訂單通知"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:82
msgid "訂單量"
msgstr "訂單量"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:190
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:212
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/IncomeCalculationSection.tsx:100
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:622
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:604
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:95
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:33
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityCharts.web.tsx:115
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:170
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:106
msgid "訂單金額"
msgstr "訂單金額"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:700
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:719
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:845
msgid "訂單金額："
msgstr "訂單金額："

#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityCharts.web.tsx:75
msgid "訂單金額趨勢"
msgstr "訂單金額趨勢"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:471
#: apps/dp-business/src/pages/RefundList/index.tsx:252
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1644
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1779
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:60
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:91
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:89
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:119
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:93
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:75
msgid "訂單類型"
msgstr "訂單類型"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:39
#: apps/dp-client/src/components/RefundResonModal/index.tsx:24
msgid "計劃有變沒時間消費"
msgstr "計劃有變沒時間消費"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/CountdownField/index.web.tsx:59
msgid "計時器字體顏色"
msgstr "計時器字體顏色"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/CountdownField/index.web.tsx:49
msgid "計時器底色"
msgstr "計時器底色"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:158
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:442
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:19
#: apps/dp-admin/src/pages/split-account/services/constants.ts:78
msgid "計算中"
msgstr "計算中"

#: apps/dp-client/src/store/couponStore.ts:488
msgid "計算優惠失敗"
msgstr "計算優惠失敗"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ExistingFixedPackagesPanel/index.web.tsx:35
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:162
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:240
msgid "計算失敗"
msgstr "計算失敗"

#: apps/dp-admin/src/pages/resource-config/rank-list/components/RankDetailModal/index.web.tsx:39
msgid "計算得分"
msgstr "計算得分"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:101
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:77
msgid "計費方式"
msgstr "計費方式"

#: apps/dp-business/src/pages/Login/index.tsx:1209
#: apps/dp-business/src/pages/Login/index.tsx:1683
#: apps/dp-admin/src/pages/login/components/LoginForm/index.web.tsx:86
msgid "記住密碼"
msgstr "記住密碼"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:187
msgid "記號筆"
msgstr "記號筆"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:329
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:100
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:182
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1110
msgid "記錄ID"
msgstr "記錄ID"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:63
msgid "訪問次數"
msgstr "訪問次數"

#: apps/dp-admin/src/components/UserFilterSection/index.web.tsx:33
msgid "設備&常駐資訊"
msgstr "設備&常駐資訊"

#: apps/dp-admin/src/modules/hooks/usePhoneCall.ts:50
msgid "設備不支援撥打電話"
msgstr "設備不支援撥打電話"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:164
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:57
#: apps/dp-admin/src/components/UserFilterSection/index.web.tsx:17
msgid "設備系統"
msgstr "設備系統"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:59
msgid "設備資訊："
msgstr "設備資訊："

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:281
msgid "設定"
msgstr "設定"

#. placeholder {0}: name + 1
#. placeholder {0}: index + 1
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:375
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:488
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:753
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:879
msgid "設定 {0}"
msgstr "設定 {0}"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:68
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:45
msgid "設定不同時間段的套餐券佣金比例，支援添加多個時間段規則"
msgstr "設定不同時間段的套餐券佣金比例，支援添加多個時間段規則"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BookingFeeRules/index.web.tsx:62
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/BookingFeeRules/index.web.tsx:47
msgid "設定不同時間段的訂位收費方式，支援添加多個時間段規則"
msgstr "設定不同時間段的訂位收費方式，支援添加多個時間段規則"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:70
msgid "設定優惠買單的佣金比例和交易手續費"
msgstr "設定優惠買單的佣金比例和交易手續費"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1085
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1115
msgid "設定可用時間"
msgstr "設定可用時間"

#: apps/dp-admin/src/components/BusinessHours/index.web.tsx:465
msgid "設定哪幾天"
msgstr "設定哪幾天"

#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:68
msgid "設定失敗，請重試"
msgstr "設定失敗，請重試"

#: apps/dp-business/src/pages/SetPasswordPage/index.tsx:115
#: apps/dp-business/src/pages/SetPasswordPage/index.tsx:133
#: apps/dp-business/src/pages/MyProfile/index.tsx:295
#: apps/dp-business/src/components/SetPassword/index.tsx:74
msgid "設定密碼"
msgstr "設定密碼"

#: apps/dp-business/src/services/auth.ts:148
msgid "設定密碼失敗"
msgstr "設定密碼失敗"

#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:116
#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:117
msgid "設定密碼失敗，請稍後重試"
msgstr "設定密碼失敗，請稍後重試"

#: apps/dp-business/src/servers/auth/api.ts:480
#: apps/dp-business/src/pages/SetPasswordPage/index.tsx:102
#: apps/dp-business/src/pages/Login/index.tsx:1307
#: apps/dp-business/src/pages/Login/index.tsx:1779
#: apps/dp-business/src/components/SetPassword/index.tsx:173
msgid "設定密碼失敗，請重試"
msgstr "設定密碼失敗，請重試"

#: apps/dp-business/src/servers/shop/api.ts:197
msgid "設定店家分類失敗"
msgstr "設定店家分類失敗"

#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:65
msgid "設定成功"
msgstr "設定成功"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:302
msgid "設定暱稱"
msgstr "設定暱稱"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:659
msgid "設定特殊適用時間"
msgstr "設定特殊適用時間"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:591
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:621
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:215
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1169
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:284
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:1022
msgid "設定聚流標識"
msgstr "設定聚流標識"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:148
#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:153
msgid "設定聚流標識失敗"
msgstr "設定聚流標識失敗"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:145
msgid "設定聚流標識成功"
msgstr "設定聚流標識成功"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:118
msgid "設定菜單的基礎資訊、顯示控制、權限編碼以及頁面內的按鈕權限。系統將自動生成完整的權限樹結構。"
msgstr "設定菜單的基礎資訊、顯示控制、權限編碼以及頁面內的按鈕權限。系統將自動生成完整的權限樹結構。"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1981
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:2038
msgid "設定訂位規則"
msgstr "設定訂位規則"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:144
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:262
msgid "設定說明"
msgstr "設定說明"

#: apps/dp-client/src/store/invoiceStore.ts:157
msgid "設定預設發票抬頭失敗"
msgstr "設定預設發票抬頭失敗"

#: apps/dp-admin/src/modules/hooks/options/useFacilityOptions.ts:84
msgid "設施數據取得失敗"
msgstr "設施數據取得失敗"

#: apps/dp-admin/src/modules/hooks/options/useFacilityOptions.ts:93
msgid "設施數據取得異常"
msgstr "設施數據取得異常"

#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:269
msgid "設施資料取得失敗，請稍後重試"
msgstr "設施資料取得失敗，請稍後重試"

#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/index.tsx:253
msgid "設為封面"
msgstr "設為封面"

#: apps/dp-client/src/screens/account/pages/invoice/components/InvoiceProfileCard/index.tsx:97
msgid "設為預設"
msgstr "設為預設"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:792
msgid "設為預設設定"
msgstr "設為預設設定"

#: apps/dp-client/src/configs/page-configs.tsx:1496
#: apps/dp-business/src/pages/Settings/index.tsx:157
#: apps/dp-business/src/components/CustomTabs/index.tsx:273
msgid "設置"
msgstr "設置"

#. placeholder {0}: formData.mealPeriods.find((p) => p.id === editingPeriod)?.name || ''
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1022
msgid "設置{0}時間段"
msgstr "設置{0}時間段"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:320
msgid "設置上榜"
msgstr "設置上榜"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:184
msgid "設置上榜失敗"
msgstr "設置上榜失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:181
msgid "設置上榜成功"
msgstr "設置上榜成功"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:274
msgid "設置不予發獎"
msgstr "設置不予發獎"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:305
msgid "設置不予發獎失敗"
msgstr "設置不予發獎失敗"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:302
msgid "設置不予發獎成功"
msgstr "設置不予發獎成功"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:214
msgid "設置位置"
msgstr "設置位置"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:844
msgid "設置哪幾天"
msgstr "設定哪幾天"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:160
msgid "設置商家"
msgstr "設置商家"

#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:149
#: apps/dp-client/src/configs/page-configs.tsx:1863
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:346
msgid "設置密碼"
msgstr "設置密碼"

#: apps/dp-business/src/pages/Settings/index.tsx:124
msgid "設置已保存"
msgstr "設置已保存"

#: apps/dp-admin/src/pages/org-tree/org-create/services/constants.ts:15
msgid "設置店家/商場基礎信息"
msgstr "設置店家/商場基礎信息"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1216
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:141
msgid "設置時間"
msgstr "設定時間"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:71
msgid "設置時間範圍"
msgstr "設置時間範圍"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/UpdateLocationModal/index.web.tsx:81
msgid "設置樓層/位置"
msgstr "設置樓層/位置"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:296
msgid "設置活動基本資訊"
msgstr "設置活動基本資訊"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:298
msgid "設置目標用戶群體"
msgstr "設置目標用戶群體"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:194
msgid "設置節點管理員"
msgstr "設置節點管理員"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:76
msgid "設置管理員"
msgstr "設置管理員"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:210
msgid "設置簽約商家"
msgstr "設置簽約商家"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:210
msgid "設置請款商家"
msgstr "設置請款商家"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:11
msgid "設觸發條件"
msgstr "設觸發條件"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:236
msgid "註冊"
msgstr "註冊"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:103
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:154
msgid "註冊 30 天內的用戶"
msgstr "註冊 30 天內的用戶"

#: apps/dp-business/src/pages/Login/index.tsx:1007
#: apps/dp-business/src/pages/Login/index.tsx:1460
#: apps/dp-business/src/pages/Login/index.tsx:1796
msgid "註冊即表示你同意並接受我們的"
msgstr "註冊即表示你同意並接受我們的"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:15
msgid "註冊天數"
msgstr "註冊天數"

#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/UsergiftBanner.tsx:371
msgid "註冊好禮"
msgstr "註冊好禮"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityDetails.tsx:109
msgid "註冊後 30 天內的用戶"
msgstr "註冊後 30 天內的用戶"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:148
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:51
msgid "註冊方式"
msgstr "註冊方式"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:168
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:278
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:191
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:32
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/columns/index.web.tsx:54
#: apps/dp-admin/src/pages/marketing/user-group-create/components/MemberPreviewPanel/index.web.tsx:92
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:62
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:291
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:326
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:150
#: apps/dp-admin/src/modules/constants/userGroup.ts:155
#: apps/dp-admin/src/modules/constants/userGroup.ts:156
msgid "註冊時間"
msgstr "註冊時間"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:120
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:38
msgid "註冊渠道"
msgstr "註冊渠道"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:58
msgid "註冊登入相關"
msgstr "註冊登入相關"

#: apps/dp-client/src/screens/home/pages/UserGift/components/CustomHeader/index.tsx:92
msgid "註冊禮專區"
msgstr "註冊禮專區"

#: apps/dp-client/src/configs/page-configs.tsx:2541
msgid "註冊禮活動說明"
msgstr "註冊禮活動說明"

#: apps/dp-client/src/screens/home/pages/PackageZone/index.tsx:734
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:568
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:713
#: apps/dp-client/src/configs/page-configs.tsx:2539
msgid "註冊禮說明"
msgstr "註冊禮說明"

#: apps/dp-client/src/screens/account/pages/coupon/GiftRule/index.tsx:161
msgid "註冊禮領取指南"
msgstr "註冊禮領取指南"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:56
msgid "註銷"
msgstr "註銷"

#: apps/dp-business/src/pages/AccountDeactivation/index.tsx:73
msgid "註銷失敗"
msgstr "註銷失敗"

#: apps/dp-business/src/servers/auth/api.ts:561
#: apps/dp-business/src/pages/AccountDeactivation/index.tsx:78
msgid "註銷失敗，請重試"
msgstr "註銷失敗，請重試"

#: apps/dp-business/src/pages/MyProfile/index.tsx:316
#: apps/dp-business/src/pages/AccountDeactivation/index.tsx:89
#: apps/dp-business/src/configs/page-configs.ts:284
msgid "註銷帳號"
msgstr "註銷帳號"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:114
msgid "註銷後將無法登入商家端，且手機不可再次使用。"
msgstr "註銷後將無法登入商家端，且手機不可再次使用。"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:91
msgid "註銷後該商家將失去所有管理權限，可能導致："
msgstr "註銷後該商家將失去所有管理權限，可能導致："

#: apps/dp-business/src/pages/AccountDeactivation/index.tsx:67
#: apps/dp-business/src/configs/page-configs.ts:298
msgid "註銷成功"
msgstr "註銷成功"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:202
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserInfoCard/index.web.tsx:92
msgid "註銷時間"
msgstr "註銷時間"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:39
msgid "詐騙或欺詐"
msgstr "詐騙或欺詐"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:42
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:332
msgid "詐騙或詐欺"
msgstr "詐騙或詐欺"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:131
msgid "評價"
msgstr "評價"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:28
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:25
msgid "評價ID"
msgstr "評價ID"

#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:100
#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:113
#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:152
msgid "評價內容"
msgstr "評價內容"

#: apps/dp-client/src/screens/home/utils/filterData.ts:114
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:195
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:21
msgid "評價最高"
msgstr "評價最高"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingDistribution.web.tsx:225
msgid "評價分佈"
msgstr "評價分佈"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:39
msgid "評價分數"
msgstr "評價分數"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:92
msgid "評價商家申訴"
msgstr "評價商家申訴"

#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:166
msgid "評價圖片"
msgstr "評價圖片"

#. placeholder {0}: index + 1
#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:83
msgid "評價圖片{0}"
msgstr "評價圖片{0}"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:141
msgid "評價審批"
msgstr "評價審批"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:312
#: apps/dp-admin/src/pages/audit-center/review-audit/index.web.tsx:134
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:259
msgid "評價審核"
msgstr "評價審核"

#: apps/dp-admin/src/router/config/routes.web.tsx:414
msgid "評價審核列表"
msgstr "評價審核列表"

#: apps/dp-business/src/pages/ComplaintList/index.tsx:400
msgid "評價已被平台刪除"
msgstr "評價已被平台刪除"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:90
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:83
msgid "評價投訴"
msgstr "評價投訴"

#: apps/dp-admin/src/pages/merchant/components/PageHeader/index.web.tsx:63
msgid "評價投訴處理"
msgstr "評價投訴處理"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:340
msgid "評價投訴詳情"
msgstr "評價投訴詳情"

#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:296
msgid "評價數"
msgstr "評價數"

#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:170
msgid "評價數不足，展示Google評分"
msgstr "評價數不足，展示Google評分"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/index.web.tsx:54
msgid "評價數據"
msgstr "評價數據"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:148
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:732
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:338
msgid "評價數量"
msgstr "評價數量"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:91
msgid "評價文本"
msgstr "評價文本"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:48
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:149
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:55
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:37
msgid "評價時間"
msgstr "評價時間"

#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:176
msgid "評價時間："
msgstr "評價時間："

#. placeholder {0}: originalReview.reviewTime ? formatDate(originalReview.reviewTime) : '-'
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/OriginalReviewSection/index.web.tsx:109
msgid "評價時間：{0}"
msgstr "評價時間：{0}"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:39
msgid "評價標籤"
msgstr "評價標籤"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/OverviewCards.web.tsx:76
msgid "評價率"
msgstr "評價率"

#: apps/dp-business/src/utils/permissionData.ts:61
msgid "評價管理"
msgstr "評價管理"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewTrendChart.web.tsx:65
msgid "評價趨勢"
msgstr "評價趨勢"

#: apps/dp-client/src/screens/home/utils/filterData.ts:128
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:38
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:30
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:132
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:159
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/constants.ts:17
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileList/index.web.tsx:99
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:71
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:139
#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:478
#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:138
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:288
msgid "評分"
msgstr "評分"

#. placeholder {0}: payload[0].value.toFixed(1)
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingTrend.web.tsx:120
msgid "評分: {0} 分"
msgstr "評分: {0} 分"

#: apps/dp-business/src/pages/CustomerReviews/components/QualityMonitoringSection.tsx:124
msgid "評分下降提醒"
msgstr "評分下降提醒"

#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:178
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/RatingDistributionChart.web.tsx:55
msgid "評分分佈"
msgstr "評分分佈"

#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:178
msgid "評分區間"
msgstr "評分區間"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:167
msgid "評分提交成功"
msgstr "評分提交成功"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:171
msgid "評分範圍"
msgstr "評分範圍"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:102
msgid "評分詳情"
msgstr "評分詳情"

#: apps/dp-business/src/pages/CustomerReviews/components/TrendChartSection.tsx:157
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingTrend.web.tsx:133
msgid "評分趨勢"
msgstr "評分趨勢"

#: apps/dp-client/src/screens/home/utils/utils.ts:445
#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:418
#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:715
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:106
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:170
#: apps/dp-client/src/screens/home/pages/Review/pages/draft/index.tsx:20
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1179
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/MealSectionTabs.tsx:45
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:451
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:275
#: apps/dp-client/src/screens/account/pages/task-wall/components/WeeklyTaskSection/index.tsx:75
#: apps/dp-client/src/screens/account/pages/profile/components/ContentTabsSection/index.tsx:34
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:89
#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:177
#: apps/dp-client/src/screens/account/pages/likes/pages/searchResult/index.tsx:32
#: apps/dp-client/src/screens/account/pages/likes/pages/main/index.tsx:16
#: apps/dp-client/src/screens/account/pages/drafts/main/index.tsx:36
#: apps/dp-client/src/screens/account/pages/drafts/components/DraftCard.tsx:100
#: apps/dp-client/src/configs/page-configs.tsx:2685
msgid "評論"
msgstr "評論"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:312
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:285
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:301
#: apps/dp-admin/src/pages/data-center/review-detail/index.web.tsx:53
msgid "評論不存在"
msgstr "評論不存在"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:69
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:120
msgid "評論內容"
msgstr "評論內容"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/index.tsx:786
msgid "評論內容已達字數上限"
msgstr "評論內容已達字數上限"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:332
msgid "評論內容至少需要30個字元"
msgstr "評論內容至少需要30個字元"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:175
msgid "評論列表"
msgstr "評論列表"

#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:154
msgid "評論刪除失敗"
msgstr "評論刪除失敗"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:357
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:150
msgid "評論刪除成功"
msgstr "評論刪除成功"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:522
msgid "評論可見 / 命中文案"
msgstr "評論可見 / 命中文案"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:275
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:85
msgid "評論可見文案"
msgstr "評論可見文案"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:323
msgid "評論可見文案不能超過8個字"
msgstr "評論可見文案不能超過8個字"

#: apps/dp-admin/src/pages/audit-center/services/hooks.ts:143
msgid "評論圖片"
msgstr "評論圖片"

#. placeholder {0}: media.id
#: apps/dp-admin/src/pages/data-center/review-detail/services/hooks.ts:60
#: apps/dp-admin/src/pages/data-center/merchant-reviews/index.web.tsx:77
msgid "評論圖片{0}"
msgstr "評論圖片{0}"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:222
msgid "評論已提交成功"
msgstr "評論已成功送出"

#: apps/dp-client/src/configs/page-configs.tsx:2703
msgid "評論成功"
msgstr "評論成功"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ReviewGuide.tsx:48
msgid "評論提示"
msgstr "評論提示"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:114
#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:64
msgid "評論數"
msgstr "評論數"

#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:71
msgid "評論數量"
msgstr "評論數量"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:93
msgid "評論時間"
msgstr "評論時間"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/index.tsx:438
msgid "評論更新成功"
msgstr "評論更新成功"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:98
msgid "評論次數"
msgstr "評論次數"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/OverviewCards.web.tsx:15
msgid "評論率"
msgstr "評論率"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:129
msgid "評論者"
msgstr "評論者"

#: apps/dp-client/src/screens/home/pages/Review/pages/detail/index.tsx:682
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:294
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:175
#: apps/dp-admin/src/pages/data-center/review-detail/index.web.tsx:74
msgid "評論詳情"
msgstr "評論詳情"

#: apps/dp-client/src/configs/page-configs.tsx:1733
#: apps/dp-client/src/configs/page-configs.tsx:1735
msgid "評論通知"
msgstr "評論通知"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:89
msgid "評論顯示異常"
msgstr "評論顯示異常"

#: apps/dp-client/src/configs/page-configs.tsx:567
#: apps/dp-client/src/configs/page-configs.tsx:568
msgid "評選規則"
msgstr "評選規則"

#: apps/dp-client/src/screens/diary/pages/search/index.tsx:266
msgid "試試地圖找餐廳"
msgstr "試試地圖找餐廳"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:126
msgid "試試輸入 \"@張三 你好！:smile:\""
msgstr "試試輸入 \"@張三 你好！:smile:\""

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:84
msgid "試試輸入 \"這家餐廳的美食很不錯，推薦大家來試試！\""
msgstr "試試輸入 \"這家餐廳的美食很不錯，推薦大家來試試！\""

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:110
msgid "試試輸入 \"這是**粗體**和*斜體*文本，還有[鏈接](https://example.com)\""
msgstr "試試輸入 \"這是**粗體**和*斜體*文本，還有[鏈接](https://example.com)\""

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:141
msgid "試試輸入非純文字的內容..."
msgstr "試試輸入非純文字的內容..."

#. placeholder {0}: getUnitNameLabel(poiType)
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:311
msgid "該{0}已關聯店家，無法刪除"
msgstr "該{0}已關聯店家，無法刪除"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:619
msgid "該交易暫無費用明細"
msgstr "該交易暫無費用明細"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountUnbindModal.tsx:114
msgid "該使用者在可管理範圍內暫無節點授權"
msgstr "該使用者在可管理範圍內暫無節點授權"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountList.tsx:216
msgid "該使用者在當前樹內無可移除的授權"
msgstr "該使用者在當前樹內無可移除的授權"

#: apps/dp-admin/src/pages/audit-center/user-audit/services/hooks.ts:116
msgid "該使用者註冊資訊存在異常，疑似使用虛假身分資訊註冊，需要進一步核實身分真實性。"
msgstr "該使用者註冊資訊存在異常，疑似使用虛假身分資訊註冊，需要進一步核實身分真實性。"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:82
msgid "該停車場已被選擇，請勿重複選擇"
msgstr "該停車場已被選擇，請勿重複選擇"

#: apps/dp-business/src/pages/MenuItemForm.tsx:223
#: apps/dp-business/src/pages/MenuItemForm.tsx:235
#: apps/dp-business/src/pages/MenuItemForm.tsx:254
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:253
msgid "該分類下已有同名餐點"
msgstr "該分類下已有同名餐點"

#: apps/dp-business/src/pages/MarketingCenter/components/RedemptionRulesCard.tsx:61
msgid "該券核銷方式"
msgstr "該券核銷方式"

#: apps/dp-client/src/screens/home/pages/ShopList/components/AllRegionTip/index.tsx:86
msgid "該區內暫無結果，已為您擴大範圍"
msgstr "該區內暫無結果，已為您擴大範圍"

#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:82
msgid "該品牌目前已關聯 {shopCount} 家店家，禁用後該品牌將不可使用（已關聯店家不會被自動解綁），是否確認禁用？"
msgstr "該品牌目前已關聯 {shopCount} 家店家，禁用後該品牌將不可使用（已關聯店家不會被自動解綁），是否確認禁用？"

#: apps/dp-admin/src/pages/merchant/signing-management/components/NoContractActions/index.web.tsx:41
msgid "該商家尚未簽約，請選擇簽約方式"
msgstr "該商家尚未簽約，請選擇簽約方式"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:214
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:655
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:194
msgid "該商家已存在（商家ID：{existId}），不可新增"
msgstr "該商家已存在（商家ID：{existId}），不可新增"

#. placeholder {0}: occupied.name
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1678
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1363
msgid "該商家已是「{0}」的請款商家，一個商家只能作為一個結算節點的請款商家"
msgstr "該商家已是「{0}」的請款商家，一個商家只能作為一個結算節點的請款商家"

#: apps/dp-admin/src/pages/merchant/audit-detail/index.web.tsx:314
msgid "該商家已有店家資訊"
msgstr "該商家已有店家資訊"

#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:26
msgid "該商家暫未分配BD，您暫時無法查看"
msgstr "該商家暫未分配BD，您暫時無法查看"

#: apps/dp-client/src/screens/home/pages/MerchantGroup/index.tsx:242
msgid "該商家組下還沒有店家"
msgstr "該商家組下還沒有店家"

#: apps/dp-business/src/pages/ImageManagement/components/imageTips.tsx:33
#: apps/dp-admin/src/pages/merchant/components/imageTips/index.web.tsx:28
msgid "該圖片可能在用戶端個別位置被顯示為方版1:1，建議上傳時留意將內容重點放在圖片中心喔～"
msgstr "該圖片可能在用戶端個別位置被顯示為方版1:1，建議上傳時留意將內容重點放在圖片中心喔～"

#: apps/dp-business/src/pages/ImageManagement/components/imageTips.tsx:22
#: apps/dp-admin/src/pages/merchant/components/imageTips/index.web.tsx:22
msgid "該圖片可能在用戶端個別位置被顯示為橫版4:3，建議上傳時留意將內容重點放在圖片中心喔～"
msgstr "該圖片可能在用戶端個別位置被顯示為橫版4:3，建議上傳時留意將內容重點放在圖片中心喔～"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:232
msgid "該團購券已下架"
msgstr "該團購券已下架"

#. placeholder {0}: shopName ? shopName : '其他'
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:448
msgid "該套餐券由「{0}」店家創建分享，本店家無法編輯和操作上下架，請聯繫該店家作業"
msgstr "該套餐券由「{0}」店家創建分享，本店家無法編輯和操作上下架，請聯繫該店家作業"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1136
msgid "該套餐券的服務費超過了10%，請核實套餐券價格是否合理，避免出現假低價引流收取高服務費，最後套餐價格實際偏高的情況"
msgstr "該套餐券的服務費超過了10%，請核實套餐券價格是否合理，避免出現假低價引流收取高服務費，最後套餐價格實際偏高的情況"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1211
msgid "該套餐已被下架"
msgstr "該套餐已被下架"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1498
msgid "該套餐已超過兌換截止時間"
msgstr "該套餐已超過兌換截止時間"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1162
msgid "該套餐的有效日期與販售日期不同，請核實設定原因，避免顧客無法「即買即用」"
msgstr "該套餐的有效日期與販售日期不同，請核實設定原因，避免顧客無法「即買即用」"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:356
msgid "該工單當前不可審批，僅可查看"
msgstr "該工單當前不可審批，僅可查看"

#. placeholder {0}: existingShop.id
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:81
msgid "該店家POI在系統中已經存在，店家ID為：{0}"
msgstr "該店家POI在系統中已經存在，店家ID為：{0}"

#. placeholder {0}: poiStatusDesc || t`審核拒絕`
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:188
msgid "該店家POI狀態為：{0}，該店家綁定商家工單已變更狀態為：取消，需要BD重新發起"
msgstr "該店家POI狀態為：{0}，該店家綁定商家工單已變更狀態為：取消，需要BD重新發起"

#. placeholder {0}: poiStatusDesc || t`審核中`
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:198
msgid "該店家POI狀態為：{0}，需要POI審核通過後，才可以繼續審核店家綁定商家"
msgstr "該店家POI狀態為：{0}，需要POI審核通過後，才可以繼續審核店家綁定商家"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:175
msgid "該店家POI狀態為：審核通過，可以繼續審核綁定商家"
msgstr "該店家POI狀態為：審核通過，可以繼續審核綁定商家"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:160
msgid "該店家尚未發起商家入駐，需要商家入駐審核通過後，才可以繼續審核店家綁定商家"
msgstr "該店家尚未發起商家入駐，需要商家入駐審核通過後，才可以繼續審核店家綁定商家"

#: apps/dp-client/src/screens/home/pages/ShopDetail/utils/ensureShopOnline.ts:43
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopOffline.tsx:53
msgid "該店家已下架"
msgstr "該店家已下架"

#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:141
msgid "該店家已經被認領"
msgstr "該店家已經被認領"

#: apps/dp-business/src/pages/AddStore/index.tsx:1036
msgid "該店家是否為您的店家？"
msgstr "該店家是否為您的店家？"

#: apps/dp-admin/src/pages/audit-center/info-confirm/index.web.tsx:115
msgid "該店家標的資訊存在不一致，請判斷資訊，如果都不對，請人工更新"
msgstr "該店家標的資訊存在不一致，請判斷資訊，如果都不對，請人工更新"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:328
msgid "該店家目前暫不開放訂位服務"
msgstr "該店家目前暫不開放訂位服務"

#: apps/dp-client/src/screens/account/pages/order/index.tsx:296
msgid "該店家目前暫停營業/永久停業/待開業，無法提供套餐券購買服務"
msgstr "該店家目前暫停營業/永久停業/待開業，無法提供套餐券購買服務"

#. placeholder {0}: onboardingStatusDesc || t`審核拒絕`
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:210
msgid "該店家綁定的商家入駐狀態為：{0}，該店家綁定商家工單已變更狀態為：取消，需要BD重新發起"
msgstr "該店家綁定的商家入駐狀態為：{0}，該店家綁定商家工單已變更狀態為：取消，需要BD重新發起"

#. placeholder {0}: statusText || onboardingStatusValue
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:194
msgid "該店家綁定的商家入駐狀態為：{0}，需要商家入駐審核通過後，才可以繼續審核店家綁定商家"
msgstr "該店家綁定的商家入駐狀態為：{0}，需要商家入駐審核通過後，才可以繼續審核店家綁定商家"

#. placeholder {0}: onboardingStatusDesc || t`審核中`
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:222
msgid "該店家綁定的商家入駐狀態為：{0}，需要商家入駐審核通過後才可以繼續審核店家綁定商家"
msgstr "該店家綁定的商家入駐狀態為：{0}，需要商家入駐審核通過後才可以繼續審核店家綁定商家"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:203
msgid "該店家綁定的商家入駐狀態為：審核中，需要商家入駐審核通過後，才可以繼續審核店家綁定商家"
msgstr "該店家綁定的商家入駐狀態為：審核中，需要商家入駐審核通過後，才可以繼續審核店家綁定商家"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:183
msgid "該店家綁定的商家入駐狀態為：審核拒絕{reasonSuffix}，該店家綁定商家工單已變更狀態為：取消，需要BD重新發起"
msgstr "該店家綁定的商家入駐狀態為：審核拒絕{reasonSuffix}，該店家綁定商家工單已變更狀態為：取消，需要BD重新發起"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:172
msgid "該店家綁定的商家入駐狀態為：審核拒絕{reasonSuffix}，需要商家入駐審核通過後，才可以繼續審核店家綁定商家"
msgstr "該店家綁定的商家入駐狀態為：審核拒絕{reasonSuffix}，需要商家入駐審核通過後，才可以繼續審核店家綁定商家"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/index.web.tsx:153
msgid "該店家綁定的商家入駐狀態為：審核通過{reasonSuffix}"
msgstr "該店家綁定的商家入駐狀態為：審核通過{reasonSuffix}"

#: apps/dp-client/src/screens/home/pages/ShopDetail/utils/ensureShopOnline.ts:18
msgid "該店已下架，暫時無法提供服務。"
msgstr "該店已下架，暫時無法提供服務。"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopOffline.tsx:31
msgid "該店已下架,暫無法提供服務"
msgstr "該店已下架,暫無法提供服務"

#: apps/dp-client/src/screens/home/pages/ShopDetail/utils/ensureShopOnline.ts:54
msgid "該店待開業，暫時無法提供服務。"
msgstr "該店待開業，暫時無法提供服務。"

#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:1145
#: apps/dp-client/src/screens/home/pages/ShopDetail/index.tsx:1155
#: apps/dp-client/src/screens/home/pages/ShopDetail/utils/ensureShopOnline.ts:58
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:198
msgid "該店暫停營業，暫時無法提供服務。"
msgstr "該店暫停營業，暫時無法提供服務。"

#: apps/dp-client/src/screens/home/pages/ShopDetail/utils/ensureShopOnline.ts:21
msgid "該店永久停業，暫時無法提供服務。"
msgstr "該店永久停業，暫時無法提供服務。"

#: apps/dp-business/src/pages/AccountDeactivation/index.tsx:125
msgid "該手機號將無法再次註冊"
msgstr "該手機號將無法再次註冊"

#: apps/dp-client/src/screens/reservation/components/ReservationCalendar/index.tsx:152
msgid "該日期不可選"
msgstr "該日期不可選"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:2087
msgid "該日期暫無可用時段"
msgstr "該日期暫無可用時段"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:786
msgid "該時段無可選的營業時段"
msgstr "該時段無可選的營業時段"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:400
msgid "該時間段已被佔用"
msgstr "該時間段已被佔用"

#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:121
msgid "該服務使用相機功能，請在「瀏覽器-設置」中手動開啟相機權限"
msgstr "該服務使用相機功能，請在「瀏覽器-設置」中手動開啟相機權限"

#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:120
msgid "該服務使用相機功能，請在「設置-去哪吃」中開啟相機權限"
msgstr "該服務使用相機功能，請在「設置-去哪吃」中開啟相機權限"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:64
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:51
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:57
msgid "該條件支持實時更新"
msgstr "該條件支持實時更新"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:153
msgid "該業務項暫無費用明細"
msgstr "該業務項暫無費用明細"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:129
msgid "該標籤已添加"
msgstr "該標籤已添加"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:228
msgid "該消息"
msgstr "該消息"

#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:353
msgid "該用戶不存在或已被移除"
msgstr "該用戶不存在或已被移除"

#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:417
msgid "該用戶已限制你的訪問"
msgstr "該用戶已限制你的訪問"

#. placeholder {0}: record.historyListingCount || 0
#. placeholder {1}: record.historyLotteryCount || 0
#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:168
#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/WinningConfirmModal.web.tsx:65
msgid "該用戶過往上榜次數 {0} 次；該用戶過往中獎次數 {1} 次。"
msgstr "該用戶過往上榜次數 {0} 次；該用戶過往中獎次數 {1} 次。"

#: apps/dp-client/src/screens/home/utils/utils.ts:311
msgid ""
"該視頻時長為 {durationText}、大小為 {sizeMB}MB。\n"
"請選擇時長在 1 分鐘以內，且檔案大小不超過 150MB 的視頻"
msgstr ""
"該視頻時長為 {durationText}、大小為 {sizeMB}MB。\n"
"請選擇時長在 1 分鐘以內，且檔案大小不超過 150MB 的視頻"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/ChainPermissionPanel.tsx:125
msgid "該節點已停用，僅可查看，不可新增或編輯"
msgstr "該節點已停用，僅可查看，不可新增或編輯"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:230
#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:106
msgid "該節點的主要聯繫人，請正確填寫。"
msgstr "該節點的主要聯繫人，請正確填寫。"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:47
msgid "該組織樹仍有子節點，請先按審核流程清空後再刪除"
msgstr "該組織樹仍有子節點，請先按審核流程清空後再刪除"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:51
msgid "該組織樹仍有店家／商場掛接，請先解除掛接後再刪除"
msgstr "該組織樹仍有店家／商場掛接，請先解除掛接後再刪除"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:49
msgid "該組織樹仍有指定管理員，請先解除後再刪除"
msgstr "該組織樹仍有指定管理員，請先解除後再刪除"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:136
msgid "該組織樹已不存在，列表已刷新"
msgstr "該組織樹已不存在，列表已刷新"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:184
msgid "該組織樹正式版本已變為 {latestVersion}，確認後將以最新版本重新分配 BD。"
msgstr "該組織樹正式版本已變為 {latestVersion}，確認後將以最新版本重新分配 BD。"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:253
msgid "該組織樹正式版本已變為 {latestVersion}，確認後將以最新版本重新刪除。"
msgstr "該組織樹正式版本已變為 {latestVersion}，確認後將以最新版本重新刪除。"

#: apps/dp-admin/src/pages/org-tree/org-list/services/hooks.ts:212
msgid "該組織樹正式版本已變為 {latestVersion}，確認後將以最新版本重新提交上下架。"
msgstr "該組織樹正式版本已變為 {latestVersion}，確認後將以最新版本重新提交上下架。"

#: apps/dp-client/src/screens/reservation/pages/invitation/index.tsx:265
msgid "該訂位已失效"
msgstr "該訂位已失效"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:896
msgid "該連鎖已有進行中的申請，暫不可編輯"
msgstr "該連鎖已有進行中的申請，暫不可編輯"

#: apps/dp-admin/src/pages/org-tree/services/shopPathActions.ts:138
msgid "該連鎖已有進行中的申請，請先到組織樹管理處理"
msgstr "該連鎖已有進行中的申請，請先到組織樹管理處理"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:937
msgid "該連鎖有進行中的申請，暫不可編輯"
msgstr "該連鎖有進行中的申請，暫不可編輯"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:253
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:182
msgid "該門號已註冊過其他帳號,請更換手機門號後重試"
msgstr "該門號已註冊過其他帳號,請更換手機門號後重試"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:149
msgid "該餐點的原類別已被刪除，請重新選擇類別"
msgstr "該餐點的原類別已被刪除，請重新選擇類別"

#: apps/dp-client/src/components/CouponCard/index.tsx:449
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:350
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:245
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:100
#: apps/dp-admin/src/pages/transaction/components/MerchantInfo/index.web.tsx:169
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:268
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:232
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:185
#: apps/dp-admin/src/pages/resource-config/rank-list/services/columns.web.tsx:138
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/AbnormalOrderTable/index.web.tsx:197
#: apps/dp-admin/src/pages/order/merchant-order-list/components/columns/index.web.tsx:29
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:84
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/CheckoutDiscountOrderSection/index.web.tsx:36
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:230
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:103
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:117
#: apps/dp-admin/src/pages/merchant/check-in/components/ActionButtons/index.web.tsx:19
#: apps/dp-admin/src/pages/merchant/brand-list/components/columns/index.web.tsx:148
#: apps/dp-admin/src/pages/marketing/verification-record/components/columns/index.web.tsx:167
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:213
#: apps/dp-admin/src/pages/marketing/order-list/components/columns/index.web.tsx:28
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:193
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:504
#: apps/dp-admin/src/pages/marketing/components/OrderListSection/index.web.tsx:63
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:219
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/columns.web.tsx:250
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:202
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:174
#: apps/dp-admin/src/pages/marketing/activity-statistics/index.web.tsx:87
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:271
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:310
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:231
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:249
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:360
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:299
msgid "詳情"
msgstr "詳情"

#: apps/dp-admin/src/pages/marketing/activity-detail-list/index.web.tsx:78
msgid "詳情列表"
msgstr "詳情列表"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:508
msgid "詳情圖"
msgstr "詳情圖"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:505
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:622
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:274
msgid "詳情圖片"
msgstr "詳情圖片"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:189
msgid "詳情維護"
msgstr "詳情維護"

#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:153
msgid "詳情與操作"
msgstr "詳情與操作"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:607
#: apps/dp-business/src/pages/AddressEdit/index.tsx:683
#: apps/dp-business/src/pages/AddStore/index.tsx:1378
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:105
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:109
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:180
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:184
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:278
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:85
#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:223
#: apps/dp-admin/src/pages/merchant/information-review/index.web.tsx:122
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:283
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/config.ts:62
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:38
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/services/config.ts:160
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/config.ts:52
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:231
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:130
msgid "詳細地址"
msgstr "詳細地址"

#. placeholder {0}: shopInfo.address
#. placeholder {0}: _selectedPoi?.address || ''
#: apps/dp-business/src/pages/AddStore/index.tsx:1029
#: apps/dp-business/src/pages/AddStore/index.tsx:1074
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:167
msgid "詳細地址：{0}"
msgstr "詳細地址：{0}"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:355
msgid "詳細描述"
msgstr "詳細描述"

#: apps/dp-admin/src/pages/merchant/information-error/components/ErrorInfoSection/index.web.tsx:100
msgid "詳細描述："
msgstr "詳細描述："

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:471
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:863
msgid "詳細設定"
msgstr "詳細設定"

#: apps/dp-business/src/components/VerificationInput/index.tsx:288
msgid "認證成功"
msgstr "認證成功"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:231
msgid "語言"
msgstr "語言"

#: apps/dp-business/src/pages/Settings/index.tsx:163
msgid "語音播報"
msgstr "語音播報"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:56
msgid "語音驗證"
msgstr "語音驗證"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/hooks.ts:156
msgid "誤自核銷了怎麼辦？"
msgstr "誤自核銷了怎麼辦？"

#: apps/dp-client/src/screens/account/pages/notifications/components/InteractionNotificationCard/index.tsx:45
msgid "說你的筆記讚"
msgstr "說你的筆記讚"

#: apps/dp-client/src/screens/account/pages/notifications/components/InteractionNotificationCard/index.tsx:49
msgid "說你的評論讚"
msgstr "說你的評論讚"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:95
msgid "說明"
msgstr "說明"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityStepsField/index.web.tsx:62
#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:259
#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:319
msgid "說明文本"
msgstr "說明文本"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:519
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:572
msgid "說明範例"
msgstr "說明範例"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:675
#: apps/dp-admin/src/pages/split-account/services/constants.ts:70
msgid "調整"
msgstr "調整"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:203
msgid "調整："
msgstr "調整："

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:68
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:71
msgid "調整使用門檻"
msgstr "調整使用門檻"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:345
msgid "調整大小"
msgstr "調整大小"

#: apps/dp-business/src/servers/reservation/api.ts:672
msgid "調整庫存失敗"
msgstr "調整庫存失敗"

#: apps/dp-admin/src/pages/report-center/services/interface/manual-compensation.ts:74
msgid "調整訂單資訊"
msgstr "調整訂單資訊"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:379
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:63
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:154
msgid "調用服務"
msgstr "調用服務"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:35
msgid "調色板"
msgstr "調色板"

#: apps/dp-business/src/components/PhotoUploader/hooks/useImageAspectRatio.tsx:94
msgid "請上傳 4:3 比例的動圖，以保留動畫效果"
msgstr "請上傳 4:3 比例的動圖，以保留動畫效果"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponCodeUpload.web.tsx:77
msgid "請上傳 Excel 或 CSV 格式的檔案"
msgstr "請上傳 Excel 或 CSV 格式的檔案"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:700
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ImportShopModal/index.web.tsx:69
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:87
msgid "請上傳 Excel 檔案（.xlsx 或 .xls）"
msgstr "請上傳 Excel 檔案（.xlsx 或 .xls）"

#. placeholder {0}: doc.title
#. placeholder {0}: imageType.title
#. placeholder {0}: item.title
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:567
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:91
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:312
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:542
msgid "請上傳{0}"
msgstr "請上傳{0}"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:245
msgid "請上傳任務圖示"
msgstr "請上傳任務圖示"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:152
msgid "請上傳公司登記表（支援圖片或PDF格式，與商業登記抄本二選一）"
msgstr "請上傳公司登記表（支援圖片或PDF格式，與商業登記抄本二選一）"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:176
msgid "請上傳公司登記表（支援圖片或PDF格式）"
msgstr "請上傳公司登記表（支援圖片或PDF格式）"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:453
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:173
msgid "請上傳品類圖片"
msgstr "請上傳品類圖片"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:213
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:221
msgid "請上傳商品圖片"
msgstr "請上傳商品圖片"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:95
msgid "請上傳商品照片"
msgstr "請上傳商品照片"

#: apps/dp-admin/src/pages/marketing/activity-create/services/hooks.ts:205
msgid "請上傳商家ID文件"
msgstr "請上傳商家ID文件"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:670
msgid "請上傳商家列表頁標籤圖"
msgstr "請上傳商家列表頁標籤圖"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1410
msgid "請上傳商家確認截圖後方可審核通過"
msgstr "請上傳商家確認截圖後方可審核通過"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:143
msgid "請上傳商業登記抄本（支援圖片或PDF格式，與公司登記表二選一）"
msgstr "請上傳商業登記抄本（支援圖片或PDF格式，與公司登記表二選一）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:133
msgid "請上傳商業登記抄本（支援圖片或PDF格式）"
msgstr "請上傳商業登記抄本（支援圖片或PDF格式）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:303
msgid "請上傳商業登記抄本或公司登記表（二選一）"
msgstr "請上傳商業登記抄本或公司登記表（二選一）"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:80
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:422
msgid "請上傳圖標"
msgstr "請上傳圖標"

#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:146
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PosterListField/SortableRow.web.tsx:78
#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:203
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:170
msgid "請上傳圖片"
msgstr "請上傳圖片"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:124
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:148
msgid "請上傳存摺和影本"
msgstr "請上傳存摺和影本"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:83
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:125
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:160
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:94
msgid "請上傳存摺正本（支援圖片或PDF格式）"
msgstr "請上傳存摺正本（支援圖片或PDF格式）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:59
msgid "請上傳室內照"
msgstr "請上傳室內照"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:74
msgid "請上傳室外環境照"
msgstr "請上傳室外環境照"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:213
msgid "請上傳實際管理人身份證反面"
msgstr "請上傳實際管理人身份證反面"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:171
msgid "請上傳實際管理人身份證正面"
msgstr "請上傳實際管理人身份證正面"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:175
msgid "請上傳封面圖"
msgstr "請上傳封面圖"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:421
#: apps/dp-admin/src/pages/merchant/components/identity-fields/ArcIdentityFields.web.tsx:62
msgid "請上傳居留證反面"
msgstr "請上傳居留證反面"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:398
#: apps/dp-admin/src/pages/merchant/components/identity-fields/ArcIdentityFields.web.tsx:47
msgid "請上傳居留證正面"
msgstr "請上傳居留證正面"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:259
msgid "請上傳店家照片"
msgstr "請上傳餐廳照片"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:189
msgid "請上傳文件"
msgstr "請上傳文件"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:684
#: apps/dp-business/src/pages/AddStore/index.tsx:1452
msgid "請上傳有招牌資訊的門牌照片，方便用戶找店"
msgstr "請上傳有招牌資訊的門牌照片，方便用戶找到餐廳"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:99
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:120
msgid "請上傳核定稅籍通知書（支援圖片或PDF格式）"
msgstr "請上傳核定稅籍通知書（支援圖片或PDF格式）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:130
msgid "請上傳清晰的商店照片，支援 JPG、PNG、WebP 格式，單張圖片不超過 5MB"
msgstr "請上傳清晰的商店照片，支援 JPG、PNG、WebP 格式，單張圖片不超過 5MB"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:283
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:222
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:84
msgid "請上傳營利事業登記證"
msgstr "請上傳營利事業登記證"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:402
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:164
msgid "請上傳營業登記文件"
msgstr "請上傳營業登記文件"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:362
msgid "請上傳相關證件和檔案，支援圖片格式（JPG、PNG）和文檔格式（PDF、DOC、DOCX），每個檔案最大50MB"
msgstr "請上傳相關證件和檔案，支援圖片格式（JPG、PNG）和文檔格式（PDF、DOC、DOCX），每個檔案最大50MB"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractUpload/components/ContractInfo/index.web.tsx:49
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/ContractUpload/components/ContractInfo/index.web.tsx:49
msgid "請上傳簽約合約掃描件"
msgstr "請上傳簽約合約掃描件"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:91
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:133
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:168
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:102
msgid "請上傳簽約合約掃描件（支援圖片或PDF格式）"
msgstr "請上傳簽約合約掃描件（支援圖片或PDF格式）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/ContractInfoUpload/index.web.tsx:19
msgid "請上傳簽約商家資料合約的相關資訊"
msgstr "請上傳簽約商家資料合約的相關資訊"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:73
msgid "請上傳落地頁圖片"
msgstr "請上傳落地頁圖片"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:498
#: apps/dp-admin/src/pages/merchant/components/identity-fields/PassportIdentityFields.web.tsx:62
msgid "請上傳護照圖片"
msgstr "請上傳護照圖片"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:72
msgid "請上傳負責人身份證正反面"
msgstr "請上傳負責人身份證正反面"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:254
#: apps/dp-admin/src/pages/merchant/components/identity-fields/PersonalIdentityFields.web.tsx:78
#: apps/dp-admin/src/pages/merchant/components/identity-fields/DomesticIdentityFields.web.tsx:111
msgid "請上傳身份證反面"
msgstr "請上傳身份證反面"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:219
#: apps/dp-admin/src/pages/merchant/components/identity-fields/PersonalIdentityFields.web.tsx:52
#: apps/dp-admin/src/pages/merchant/components/identity-fields/DomesticIdentityFields.web.tsx:72
msgid "請上傳身份證正面"
msgstr "請上傳身份證正面"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:265
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:206
msgid "請上傳身分證反面"
msgstr "請上傳身分證反面"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:75
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:117
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:152
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:86
msgid "請上傳身分證反面（支援圖片或PDF格式，僅限1張）"
msgstr "請上傳身分證反面（支援圖片或PDF格式，僅限1張）"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:237
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:173
msgid "請上傳身分證正面"
msgstr "請上傳身分證正面"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:67
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:109
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:144
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:78
msgid "請上傳身分證正面（支援圖片或PDF格式，僅限1張）"
msgstr "請上傳身分證正面（支援圖片或PDF格式，僅限1張）"

#: apps/dp-business/src/pages/AddStore/index.tsx:1154
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:37
msgid "請上傳門牌照片"
msgstr "請上傳門牌照片"

#: apps/dp-admin/src/pages/marketing/channel-management/services/useChannelImport.ts:171
msgid "請上傳非空 Excel 文件"
msgstr "請上傳非空 Excel 文件"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:90
msgid "請上傳餐廳「店面或店內空間與裝潢」的清楚照片"
msgstr "請上傳餐廳「店面或店內空間與裝潢」的清楚照片"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:66
msgid "請下載範本並上傳 Excel 文件批量創建固定名單"
msgstr "請下載範本並上傳 Excel 文件批量創建固定名單"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:100
msgid "請以文字格式填寫九位用戶 user ID，保留開頭的 0。"
msgstr "請以文字格式填寫九位用戶 user ID，保留開頭的 0。"

#: apps/dp-admin/src/pages/login/components/LoginForm/index.web.tsx:112
msgid "請使用您的企業帳號登錄系統。如有問題，請聯繫管理員。"
msgstr "請使用您的企業帳號登錄系統。如有問題，請聯繫管理員。"

#: apps/dp-client/src/screens/reservation/utils/index.ts:109
msgid "請依照下方餐廳預訂說明完成預約訂位，祝您享受美好的私廚饗宴"
msgstr "請依照下方餐廳預訂說明完成預約訂位，祝您享受美好的私廚饗宴"

#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:72
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:94
#: apps/dp-admin/src/pages/merchant/batch-upload/services/config.web.tsx:111
msgid "請依照規定的格式上傳，以免上傳失敗"
msgstr "請依照規定的格式上傳，以免上傳失敗"

#: apps/dp-business/src/components/ValidatedCard/index.tsx:267
msgid "請修正以下錯誤："
msgstr "請修正以下錯誤："

#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:124
#: apps/dp-admin/src/components/FileUpload/index.web.tsx:299
msgid "請允許瀏覽器開啟新視窗"
msgstr "請允許瀏覽器開啟新視窗"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:152
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:152
#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:171
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:121
msgid "請先上傳 Excel 文件"
msgstr "請先上傳 Excel 文件"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:117
msgid "請先上傳任務資料"
msgstr "請先上傳任務資料"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/AddStockModal.web.tsx:54
msgid "請先上傳券碼檔案"
msgstr "請先上傳券碼檔案"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1443
msgid "請先上傳商家確認截圖"
msgstr "請先上傳商家確認截圖"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:386
msgid "請先上傳商家確認截圖後再審核通過"
msgstr "請先上傳商家確認截圖後再審核通過"

#: apps/dp-business/src/pages/MenuManagement.tsx:382
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:841
msgid "請先上傳菜單圖片"
msgstr "請先上傳菜單圖片"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:210
msgid "請先上傳負責人身份證正面"
msgstr "請先上傳負責人身份證正面"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:86
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:106
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:225
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:259
msgid "請先上傳身分證正面"
msgstr "請先上傳身分證正面"

#. placeholder {0}: selectedOption.label
#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:111
msgid "請先下載範本，填寫{0}後再上傳 Excel 文件"
msgstr "請先下載範本，填寫{0}後再上傳 Excel 文件"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:306
msgid "請先下載範本，填寫任務資料後上傳"
msgstr "請先下載範本，填寫任務資料後上傳"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/BatchUploadForm/index.web.tsx:30
msgid "請先下載範本，填寫商家資料後再上傳 Excel 文件"
msgstr "請先下載範本，填寫商家資料後再上傳 Excel 文件"

#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:160
msgid "請先下載範本，填寫後再上傳 Excel 文件"
msgstr "請先下載範本，填寫後再上傳 Excel 文件"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1600
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1132
msgid "請先刪除子節點"
msgstr "請先刪除子節點"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/index.web.tsx:290
msgid "請先勾選要匯出的訂位記錄"
msgstr "請先勾選要匯出的訂位記錄"

#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionConfirmContent/index.tsx:39
msgid "請先向店員確認，並核對以下資訊"
msgstr "請先向店員確認，並核對以下資訊"

#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:427
msgid "請先在列表中選擇要分配的工單"
msgstr "請先在列表中選擇要分配的工單"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:216
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:225
msgid "請先在基礎資訊中配置樓層/排"
msgstr "請先在基礎資訊中配置樓層/排"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:269
msgid "請先在第一步選擇發送渠道"
msgstr "請先在第一步選擇發送渠道"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:423
msgid "請先在第二步上傳佔位符參數文件"
msgstr "請先在第二步上傳佔位符參數文件"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/ChainPermissionPanel.tsx:98
#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:198
msgid "請先在組織樹中選擇節點"
msgstr "請先在組織樹中選擇節點"

#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:372
msgid "請先填寫經度、緯度和半徑"
msgstr "請先填寫經度、緯度和半徑"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:636
msgid "請先完善到店指引"
msgstr "請先完善到店指引"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1545
msgid "請先完善根節點信息"
msgstr "請先完善根節點信息"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:127
msgid "請先完成兌換權益詳情載入，失敗時請重試"
msgstr "請先完成兌換權益詳情載入，失敗時請重試"

#: apps/dp-client/src/screens/account/pages/privacy-settings/account-deletion/index.tsx:174
msgid "請先完成相關操作後，再重新提交刪除申請"
msgstr "請先完成相關操作後，再重新提交刪除申請"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/utils.ts:67
msgid "請先將適用訂單類型設為套餐券"
msgstr "請先將適用訂單類型設為套餐券"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:173
msgid "請先導入有效套餐名單"
msgstr "請先導入有效套餐名單"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:138
msgid "請先啟用套餐券服務"
msgstr "請先啟用套餐券服務"

#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:159
msgid "請先啟用結帳服務"
msgstr "請先啟用結帳服務"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:146
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:469
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:34
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:301
msgid "請先新增餐點類別"
msgstr "請先新增餐點類別"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ImportShopModal/index.web.tsx:126
msgid "請先準備包含店家 ID、樓層、位置描述的 Excel 文件，選擇文件後點擊確定導入。"
msgstr "請先準備包含店家 ID、樓層、位置描述的 Excel 文件，選擇文件後點擊確定導入。"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:185
msgid "請先產生密碼"
msgstr "請先產生密碼"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1451
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1484
msgid "請先登入"
msgstr "請先登入"

#: apps/dp-business/src/pages/ForgotPasswordPage/index.tsx:54
msgid "請先登入後再使用忘記密碼功能"
msgstr "請先登入後再使用忘記密碼功能"

#: apps/dp-business/src/pages/SetPasswordPage/index.tsx:57
msgid "請先登入後再設定密碼"
msgstr "請先登入後再設定密碼"

#: apps/dp-client/src/screens/home/pages/MediaGift/index.tsx:129
msgid "請先登入後再領取"
msgstr "請先登入後再領取"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1136
msgid "請先移除該節點的掛接商家"
msgstr "請先移除該節點的掛接商家"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1604
msgid "請先移除該節點的掛接店家"
msgstr "請先移除該節點的掛接店家"

#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:402
msgid "請先簽約再開啟服務"
msgstr "請先簽約再開啟服務"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:316
msgid "請先給出整體評分"
msgstr "請先給出整體評分"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BlueNewContractTab/components/NoContractView/index.web.tsx:27
msgid "請先綁定商家"
msgstr "請先綁定商家"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:456
msgid "請先設置排行榜"
msgstr "請先設置排行榜"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1945
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1959
msgid "請先輸入付款金額"
msgstr "請先輸入付款金額"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:505
msgid "請先輸入名稱或地址"
msgstr "請先輸入名稱或地址"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:836
msgid "請先輸入有效的消費金額"
msgstr "請先輸入有效的消費金額"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ImportShopModal/index.web.tsx:78
#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:287
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:257
#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/hooks.ts:100
msgid "請先選擇 Excel 文件"
msgstr "請先選擇 Excel 文件"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountModal/index.web.tsx:154
msgid "請先選擇{unitLabel}"
msgstr "請先選擇{unitLabel}"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:112
msgid "請先選擇上傳參數"
msgstr "請先選擇上傳參數"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:48
msgid "請先選擇兌換獲得權益並輸入消耗的積分值"
msgstr "請先選擇兌換獲得權益並輸入消耗的積分值"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepTemplate.web.tsx:252
msgid "請先選擇包含渠道的消息模板"
msgstr "請先選擇包含渠道的消息模板"

#: apps/dp-client/src/screens/home/pages/Review/pages/add/hooks/useReviewSubmit.ts:86
msgid "請先選擇商家"
msgstr "請先選擇商家"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/index.web.tsx:116
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/index.web.tsx:116
#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:62
msgid "請先選擇商家, 或者上傳商家列表"
msgstr "請先選擇商家, 或者上傳商家列表"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:215
msgid "請先選擇平台類型"
msgstr "請先選擇平台類型"

#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:111
#: apps/dp-business/src/pages/OrderList/index.tsx:214
#: apps/dp-business/src/pages/OrderList/index.tsx:281
#: apps/dp-business/src/pages/MerchantDashboard/config/routeComponentMap.tsx:98
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:73
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:154
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:310
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:438
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:475
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:511
#: apps/dp-business/src/pages/CouponVerification/index.tsx:394
#: apps/dp-business/src/pages/CouponVerification/index.tsx:491
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:550
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:645
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:182
msgid "請先選擇店家"
msgstr "請先選擇店家"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:572
msgid "請先選擇店家分類"
msgstr "請先選擇店家分類"

#: apps/dp-admin/src/pages/merchant/components/MetroStationExitSelector/index.web.tsx:55
#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:277
msgid "請先選擇捷運站"
msgstr "請先選擇捷運站"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:970
msgid "請先選擇桌型"
msgstr "請先選擇桌型"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/DynamicConfigSection.web.tsx:226
msgid "請先選擇權益類型"
msgstr "請先選擇權益類型"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:135
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/hooks.ts:179
msgid "請先選擇活動位"
msgstr "請先選擇活動位"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:392
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:63
msgid "請先選擇消息模板"
msgstr "請先選擇消息模板"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:222
msgid "請先選擇聯繫方式類型"
msgstr "請先選擇聯繫方式類型"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:145
msgid "請先選擇至少一個結算單"
msgstr "請先選擇至少一個結算單"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/StepSelectTemplate/index.web.tsx:37
msgid "請先選擇落地頁類型"
msgstr "請先選擇落地頁類型"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:156
msgid "請先選擇處理類型"
msgstr "請先選擇處理類型"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:186
msgid "請先選擇複製內容"
msgstr "請先選擇複製內容"

#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:191
msgid "請先選擇要停用的標籤"
msgstr "請先選擇要停用的標籤"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:92
msgid "請先選擇要停用的節假日"
msgstr "請先選擇要停用的節假日"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:388
msgid "請先選擇要分配的任務"
msgstr "請先選擇要分配的任務"

#: apps/dp-admin/src/pages/merchant/task-list/services/hooks.ts:402
msgid "請先選擇要完成的任務"
msgstr "請先選擇要完成的任務"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:221
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:162
msgid "請先選擇要操作的配置"
msgstr "請先選擇要操作的配置"

#: apps/dp-admin/src/pages/label-management/label-list/index.web.tsx:161
msgid "請先選擇要啟用的標籤"
msgstr "請先選擇要啟用的標籤"

#: apps/dp-admin/src/pages/resource-config/holiday-management/index.web.tsx:92
msgid "請先選擇要啟用的節假日"
msgstr "請先選擇要啟用的節假日"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:137
msgid "請先選擇要重新回傳的記錄"
msgstr "請先選擇要重新回傳的記錄"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:207
msgid "請先選擇觸發事件 1"
msgstr "請先選擇觸發事件 1"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/channelCampaignPackageActions.ts:116
msgid "請先配置商家組、商家類目或數值條件"
msgstr "請先配置商家組、商家類目或數值條件"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/MapNaviation/index.tsx:60
msgid "請先開啟定位權限後再嘗試導航"
msgstr "請先開啟定位權限後再嘗試導航"

#: apps/dp-client/src/screens/login/components/privacy-agreement-modal/index.tsx:67
#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:283
#: apps/dp-client/src/screens/login/components/fet-login-modal/index.tsx:115
msgid "請先閱讀並接受以下條款"
msgstr "請先閱讀並接受以下條款"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:578
msgid "請先驗證負責人驗證碼"
msgstr "請先驗證負責人驗證碼"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:197
#: apps/dp-business/src/components/InvoiceForm/index.tsx:249
msgid "請再次確認提交內容"
msgstr "請再次確認提交內容"

#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:51
#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:86
#: apps/dp-business/src/pages/ChangePassword/index.tsx:64
#: apps/dp-business/src/components/SetPassword/index.tsx:101
msgid "請再次輸入密碼"
msgstr "請再次輸入密碼"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:390
msgid "請再次輸入新密碼"
msgstr "請再次輸入新密碼"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:357
msgid "請出示二維碼進行兌換"
msgstr "請出示二維碼進行兌換"

#. placeholder {0}: path?.treeName || '-'
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:165
msgid "請到 {0} 樹編輯"
msgstr "請到 {0} 樹編輯"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:2073
msgid "請到店與服務人員確認再付款"
msgstr "請到店與服務人員確認再付款"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:653
msgid "請到運營端開啟服務"
msgstr "請到運營端開啟服務"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:431
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:511
#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:190
#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:225
#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:249
msgid "請去 POI 中修改"
msgstr "請去 POI 中修改"

#: apps/dp-client/src/screens/home/pages/LocationSelect/components/NoLocationPermission.tsx:17
msgid "請去系統設置開啟定位權限喔"
msgstr "請去系統設置開啟定位權限喔"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:62
msgid "請去綁定商家中修改"
msgstr "請去綁定商家中修改"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:467
msgid "請同意條款"
msgstr "請同意條款"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:184
msgid "請同意退款條款"
msgstr "請同意退款條款"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:846
msgid "請向商家出示二維碼"
msgstr "請向商家出示 QR code"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:757
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:872
msgid "請向店家出示核銷"
msgstr "請向店家出示核銷"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:756
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:871
msgid "請向店家出示核銷，或點擊自主核銷"
msgstr "請向店家出示核銷，或點擊自主核銷"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:207
msgid "請告訴我們下車後如何走到餐廳，或是附近的標誌物？"
msgstr "請告訴我們下車後如何走到餐廳，或是附近的標誌物？"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:192
msgid "請告訴我們出站後如何走到餐廳，或是附近的標誌物？"
msgstr "請告訴我們出站後如何走到餐廳，或是附近的標誌物？"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:188
msgid "請告訴我們在哪一站下車？以及最方便的出口？"
msgstr "請告訴我們在哪一站下車？以及最方便的出口？"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:173
msgid "請告訴我們方便的停車場名稱、收費等情況"
msgstr "請告訴我們方便的停車場名稱、收費等情況"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:204
msgid "請告訴我們離餐廳最近的公車站牌名稱"
msgstr "請告訴我們離餐廳最近的公車站牌名稱"

#: apps/dp-client/src/components/PageContainer/ErrorBoundary.tsx:43
msgid "請嘗試重啟APP"
msgstr "請嘗試重啟APP"

#: apps/dp-business/src/hooks/useQRScanner.ts:77
msgid "請在 HTTPS 環境下使用"
msgstr "請在 HTTPS 環境下使用"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:57
msgid "請在{validityEndTime}前到店消費"
msgstr "請在{validityEndTime}前到店消費"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1148
msgid "請在「歷史記錄」中點擊「查看詳情」"
msgstr "請在「歷史記錄」中點擊「查看詳情」"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:723
msgid "請在POS後臺操作退款"
msgstr "請在POS後臺操作退款"

#: apps/dp-client/src/utils/permission.ts:83
msgid "請在設定中啟用位置權限"
msgstr "請在設定中啟用位置權限"

#: apps/dp-client/src/utils/permission.ts:56
msgid "請在設定中啟用照片權限"
msgstr "請在設定中啟用照片權限"

#: apps/dp-client/src/utils/permission.ts:65
msgid "請在設定中啟用相機權限"
msgstr "請在設定中啟用相機權限"

#: apps/dp-client/src/utils/permission.ts:74
msgid "請在設定中啟用麥克風權限"
msgstr "請在設定中啟用麥克風權限"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:97
msgid "請在設置中開啟相簿權限"
msgstr "請在設定中開啟相簿權限"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:134
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:167
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:192
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:377
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:447
msgid "請填寫"
msgstr "請填寫"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:199
msgid "請填寫 Email"
msgstr "請填寫 Email"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:115
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:140
msgid "請填寫，長度限制為14碼"
msgstr "請填寫，長度限制為14碼"

#: apps/dp-admin/src/pages/marketing/activity-config-form/services/utils/validateForm.ts:26
msgid "請填寫「{label}」"
msgstr "請填寫「{label}」"

#: apps/dp-admin/src/pages/transaction/service-management/components/PosSettings/index.web.tsx:61
msgid "請填寫POS的廠商代碼"
msgstr "請填寫POS的廠商代碼"

#: apps/dp-admin/src/pages/transaction/service-management/components/PosSettings/index.web.tsx:77
msgid "請填寫POS門市（店家）代碼"
msgstr "請填寫POS門市（店家）代碼"

#: apps/dp-admin/src/pages/transaction/service-management/components/PosSettings/index.web.tsx:69
msgid "請填寫POS餐廳（商家）代碼"
msgstr "請填寫POS餐廳（商家）代碼"

#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:120
#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:136
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:120
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:136
msgid "請填寫上架備註"
msgstr "請填寫上架備註"

#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:86
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:86
#: apps/dp-admin/src/pages/audit-center/components/UnpublishReasonForm/index.web.tsx:73
#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:263
#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:280
msgid "請填寫下架備註"
msgstr "請填寫下架備註"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:289
msgid "請填寫不予發獎原因"
msgstr "請填寫不予發獎原因"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:277
msgid "請填寫不予發獎的原因："
msgstr "請填寫不予發獎的原因："

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:213
msgid "請填寫不受理理由..."
msgstr "請填寫不受理理由..."

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:131
msgid "請填寫代表人姓名"
msgstr "請填寫代表人姓名"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:180
msgid "請填寫代表人手機"
msgstr "請填寫代表人手機"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1527
msgid "請填寫以下餐廳資訊"
msgstr "請填寫以下餐廳資訊"

#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:148
#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:149
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:581
#: apps/dp-business/src/pages/AddressEdit/index.tsx:488
#: apps/dp-business/src/pages/AddressEdit/index.tsx:489
msgid "請填寫修改說明"
msgstr "請填寫修改說明"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:45
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:60
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:124
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:351
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:375
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:112
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:137
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:357
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/CompanyRegistration/index.web.tsx:85
msgid "請填寫內容"
msgstr "請填寫內容"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:374
msgid "請填寫卡片副標題"
msgstr "請填寫卡片副標題"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:331
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:571
msgid "請填寫可用次數"
msgstr "請填寫可用次數"

#: apps/dp-admin/src/pages/merchant/merchant-onboard/index.web.tsx:74
msgid "請填寫商家入駐資訊，包括會員類型、企業登記資料與代表人資料"
msgstr "請填寫商家入駐資訊，包括會員類型、企業登記資料與代表人資料"

#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:813
msgid "請填寫商家的進駐資訊，包括基本資訊和相關證件照片"
msgstr "請填寫商家的進駐資訊，包括基本資訊和相關證件照片"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:241
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:177
msgid "請填寫商家負責人姓名"
msgstr "請填寫商家負責人姓名"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:264
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:201
msgid "請填寫商家負責人手機號"
msgstr "請填寫商家負責人手機號"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:70
#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:145
msgid "請填寫商家負責人身份證號"
msgstr "請填寫商家負責人身份證號"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:483
msgid "請填寫套餐名稱"
msgstr "請填寫套餐名稱"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:145
msgid "請填寫完整的管理員資訊"
msgstr "請填寫完整的管理員資訊"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:154
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:237
msgid "請填寫完整的表單信息"
msgstr "請填寫完整的表單信息"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:972
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:980
msgid "請填寫完整的表單資訊"
msgstr "請填寫完整的表單資訊"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:139
msgid "請填寫審核說明"
msgstr "請填寫審核說明"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:146
msgid "請填寫審核說明，不超過 400 個字"
msgstr "請填寫審核說明，不超過 400 個字"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:81
msgid "請填寫店家實際管理人姓名"
msgstr "請填寫店家實際管理人姓名"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:144
msgid "請填寫店家實際管理人手機號"
msgstr "請填寫店家實際管理人手機號"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:115
msgid "請填寫店家實際管理人身份證號"
msgstr "請填寫店家實際管理人身份證號"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/ShopInfoSection.web.tsx:62
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/ShopInfoSection/index.web.tsx:73
msgid "請填寫店家聯絡電話"
msgstr "請填寫店家聯絡電話"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:169
msgid "請填寫必填項"
msgstr "請填寫必填項"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:560
msgid "請填寫憑證開立方式"
msgstr "請填寫憑證開立方式"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:510
msgid "請填寫所有品類名稱"
msgstr "請填寫所有品類名稱"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:477
msgid "請填寫所有必填項"
msgstr "請填寫所有必填項目"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:141
msgid "請填寫所有餐點的價格"
msgstr "請填寫所有餐點的價格"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:137
msgid "請填寫所有餐點的分類"
msgstr "請填寫所有餐點的分類"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:115
msgid "請填寫所有餐點的名稱"
msgstr "請填寫所有餐點的名稱"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:205
msgid "請填寫手機門號"
msgstr "請填寫手機門號"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:206
msgid "請填寫投訴描述"
msgstr "請填寫投訴描述"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:303
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:544
msgid "請填寫折扣上限"
msgstr "請填寫折扣上限"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:346
msgid "請填寫數字"
msgstr "請填寫數字"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:556
#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:650
msgid "請填寫數量"
msgstr "請填寫數量"

#: apps/dp-business/src/components/ArrivalGuideStep/index.tsx:132
msgid "請填寫文字描述"
msgstr "請填寫文字描述"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1439
msgid "請填寫有效天數"
msgstr "請填寫有效天數"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:299
msgid "請填寫有效的商家折扣"
msgstr "請填寫有效的商家折扣"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:304
msgid "請填寫有效的折扣上限"
msgstr "請填寫有效的折扣上限"

#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/components/PoiActionButtons/index.web.tsx:111
msgid "請填寫未通過原因"
msgstr "請填寫未通過原因"

#: apps/dp-client/src/screens/login/pages/login/index.tsx:211
msgid "請填寫正確格式的手機門號或Email"
msgstr "請填寫正確格式的手機門號或Email"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:55
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:152
msgid "請填寫民國年月日如 1040101"
msgstr "請填寫民國年月日如 1040101"

#: apps/dp-client/src/screens/account/pages/account-security/check-password/index.tsx:91
msgid "請填寫目前密碼"
msgstr "請填寫目前密碼"

#: apps/dp-client/src/screens/account/pages/account-security/email/email-old/index.tsx:78
msgid "請填寫目前帳號綁定的完整信箱地址"
msgstr "請填寫目前帳號綁定的完整信箱地址"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:238
msgid "請填寫真實姓名，此欄位與款項撥付及發票開立有關，請正確填寫，長度限制為20個字。"
msgstr "請填寫真實姓名，此欄位與款項撥付及發票開立有關，請正確填寫，長度限制為20個字。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:207
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:214
#: apps/dp-admin/src/pages/org-tree/org-detail/components/AddChildNodeModal/index.web.tsx:60
#: apps/dp-admin/src/pages/org-tree/org-detail/components/AddChildNodeModal/index.web.tsx:67
#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:83
#: apps/dp-admin/src/pages/org-tree/org-create/components/NodeInfoForm/index.web.tsx:90
msgid "請填寫節點名稱"
msgstr "請填寫節點名稱"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:392
msgid "請填寫聯絡地址"
msgstr "請填寫聯絡地址"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:173
msgid "請填寫聯絡資訊"
msgstr "請填寫聯絡資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:44
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:133
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:46
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:137
msgid "請填寫西元年月日如 20220405"
msgstr "請填寫西元年月日如 20220405"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:636
msgid "請填寫訂單金額"
msgstr "請填寫訂單金額"

#. placeholder {0}: title || ''
#: apps/dp-client/src/components/RefundResonModal/index.tsx:144
msgid "請填寫詳細{0}原因"
msgstr "請填寫詳細{0}原因"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:212
msgid "請填寫轉單理由與給對方單位的說明..."
msgstr "請填寫轉單理由與給對方單位的說明..."

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:136
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:137
msgid "請填寫追蹤詳情"
msgstr "請填寫追蹤詳情"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:100
#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:109
msgid "請填寫連鎖節點的一級名稱"
msgstr "請填寫連鎖節點的一級名稱"

#: apps/dp-business/src/pages/MenuItemForm.tsx:259
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:379
msgid "請填寫餐點價格"
msgstr "請填寫餐點價格"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:517
msgid "請填寫駁回原因"
msgstr "請填寫駁回原因"

#: apps/dp-admin/src/pages/org-tree/org-audit/services/hooks.ts:463
#: apps/dp-admin/src/pages/org-tree/org-audit/components/RejectModal/index.web.tsx:35
#: apps/dp-admin/src/pages/org-tree/org-audit/components/RejectModal/index.web.tsx:68
msgid "請填駁回原因"
msgstr "請填駁回原因"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:899
msgid "請增加餐點組合"
msgstr "請增加餐點組合"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1460
msgid "請完善使用範圍"
msgstr "請完整填寫使用範圍"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1467
msgid "請完善使用說明"
msgstr "請完整填寫使用說明"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1453
msgid "請完善使用限制"
msgstr "請完整填寫使用限制"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1418
msgid "請完善價格資訊"
msgstr "請完整填寫價格資訊"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:242
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:467
msgid "請完善地址資訊"
msgstr "請完善地址資訊"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1380
msgid "請完善基本資訊"
msgstr "請完整填寫基本資訊"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:657
msgid "請完善必填信息"
msgstr "請完善必填信息"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:135
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:198
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:317
msgid "請完善必填資訊"
msgstr "請完善必填資訊"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/EditForm.web.tsx:540
#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:164
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:746
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:318
msgid "請完善必填資訊後再提交"
msgstr "請完善必填資訊後再提交"

#: apps/dp-admin/src/pages/marketing/activity-create/services/hooks.ts:308
#: apps/dp-admin/src/pages/marketing/activity-create/services/hooks.ts:371
msgid "請完善所有必填資訊"
msgstr "請完善所有必填資訊"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1425
msgid "請完善有效期設定"
msgstr "請完整填寫有效期設定"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1446
msgid "請完善發放設定"
msgstr "請完整填寫發放設定"

#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:272
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:280
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:308
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:311
msgid "請完善目前步驟的必填資訊"
msgstr "請完善目前步驟的必填資訊"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1411
msgid "請完善菜品資訊"
msgstr "請完整填寫餐點資訊"

#. placeholder {0}: def.label
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/StepConfigInfo/index.web.tsx:67
msgid "請完成「{0}」"
msgstr "請完成「{0}」"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:326
msgid "請完成以下評分"
msgstr "請完成以下評分"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:158
msgid "請完成兜底頁面配置"
msgstr "請完成兜底頁面配置"

#: packages/captcha/src/SecurityCaptchaProvider.tsx:201
msgid "請完成安全驗證"
msgstr "請完成安全驗證"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:239
msgid "請完成後續驗證"
msgstr "請完成後續驗證"

#: apps/dp-admin/src/pages/audit-center/image-audit-detail/services/hooks.ts:248
msgid "請完成所有圖片的審核"
msgstr "請完成所有圖片的審核"

#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:256
msgid "請完成所有必填項"
msgstr "請完成所有必填項"

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:179
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:177
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:340
msgid "請完成所有必填項目"
msgstr "請完成所有必填項目"

#. placeholder {0}: incompleteItems.join('、')
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1289
msgid "請完成所有項目才能申請上架。還需完成：{0}"
msgstr "請完成所有項目才能申請上架。還需完成：{0}"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:798
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:139
msgid "請完成獎勵配置，至少添加一個獎勵規則"
msgstr "請完成獎勵配置，至少添加一個獎勵規則"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:164
msgid "請完成落地頁配置"
msgstr "請完成落地頁配置"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:116
msgid "請完整填寫必填項"
msgstr "請完整填寫必填項"

#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:514
msgid "請完整填寫週期循環的開始時間與循環次數"
msgstr "請完整填寫週期循環的開始時間與循環次數"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:823
msgid "請完整選擇觸發事件及所需過濾項"
msgstr "請完整選擇觸發事件及所需過濾項"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:455
msgid "請對這個回覆打分"
msgstr "請對這個回覆打分"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageSourceField/index.web.tsx:113
msgid "請導入至少一個套餐券"
msgstr "請導入至少一個套餐券"

#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:290
msgid "請從訂單概覽中選擇訂單查看詳情"
msgstr "請從訂單概覽中選擇訂單查看詳情"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:598
msgid "請您特別注意以下風險："
msgstr "請您特別注意以下風險："

#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:134
msgid "請手動設置"
msgstr "請手動設置"

#: apps/dp-admin/src/pages/transaction/contract-management/services/hooks.ts:37
msgid "請指定合約類型"
msgstr "請指定合約類型"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:247
msgid "請按 key / value 的形式填寫接口參數。value 支持普通文本，也支持 JSON，例如 [10001,10002]。"
msgstr "請按 key / value 的形式填寫接口參數。value 支持普通文本，也支持 JSON，例如 [10001,10002]。"

#: apps/dp-client/src/screens/reservation/utils/index.ts:112
msgid "請按時到店用餐，祝您用餐愉快！"
msgstr "請按時到店用餐，祝您用餐愉快！"

#: apps/dp-business/src/pages/StoreDescription.tsx:208
msgid "請描述一下您的店家吧"
msgstr "請描述一下您的店家吧"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:274
#: apps/dp-client/src/components/FeedBackModal/index.tsx:121
msgid "請描述問題，以幫助我們更快解決問題"
msgstr "請描述問題，以幫助我們更快解決問題"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/CorrectionModal.tsx:223
msgid "請描述正確的路線資訊，以幫助他人更快找到店家～"
msgstr "請描述正確的路線資訊，以幫助他人更快找到店家～"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:282
msgid "請描述發生的問題..."
msgstr "請描述發生的問題..."

#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:124
#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:228
msgid "請提供商家ID"
msgstr "請提供商家ID"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:39
#: apps/dp-admin/src/pages/data-center/merchant-reviews/services/hooks.tsx:268
msgid "請提供完整的查詢參數"
msgstr "請提供完整的查詢參數"

#: apps/dp-business/src/components/NecessaryDocuments/index.tsx:61
msgid "請提供您的身分證正反面照片"
msgstr "請提供您的身分證正反面照片"

#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:98
#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:194
#: apps/dp-business/src/components/QRScannerModal/index.tsx:81
msgid "請提供正確的券碼"
msgstr "請提供正確的券碼"

#: apps/dp-admin/src/pages/split-account/invoice-detail/services/hooks.ts:22
msgid "請提供發票ID"
msgstr "請提供發票ID"

#: apps/dp-business/src/components/NecessaryDocuments/index.tsx:56
msgid "請提供統一編號和食品業者登記字號"
msgstr "請提供統一編號和食品業者登記字號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:332
msgid "請提供與經濟部公司登記所記載相同之「代表人姓名」"
msgstr "請提供與經濟部公司登記所記載相同之「代表人姓名」"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:318
msgid "請提供與經濟部公司登記所記載相同之「統一編號」"
msgstr "請提供與經濟部公司登記所記載相同之「統一編號」"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:97
msgid "請提供與經濟部公司登記所記載相同之代表人姓名"
msgstr "請提供與經濟部公司登記所記載相同之代表人姓名"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:319
msgid "請提供與經濟部公司登記所記載相同之代表人居留證字號"
msgstr "請提供與經濟部公司登記所記載相同之代表人居留證字號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:161
msgid "請提供與經濟部公司登記所記載相同之代表人身分證字號"
msgstr "請提供與經濟部公司登記所記載相同之代表人身分證字號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:63
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/CompanyRegistration/index.web.tsx:51
msgid "請提供與經濟部公司登記所記載相同之企業名稱，長度限制為60個字"
msgstr "請提供與經濟部公司登記所記載相同之企業名稱，長度限制為60個字"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:82
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/CompanyRegistration/index.web.tsx:70
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:227
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:161
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:72
msgid "請提供與經濟部公司登記所記載相同之統一編號"
msgstr "請提供與經濟部公司登記所記載相同之統一編號"

#: apps/dp-admin/src/pages/data-center/review-detail/services/hooks.ts:120
msgid "請提供評價ID"
msgstr "請提供評價ID"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:647
msgid "請搜尋並選擇商家品牌"
msgstr "請搜尋並選擇商家品牌"

#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:633
msgid "請搜尋名單名稱或名單 ID"
msgstr "請搜尋名單名稱或名單 ID"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:783
msgid "請搜尋活動名稱或活動 ID"
msgstr "請搜尋活動名稱或活動 ID"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:196
msgid "請搜索並選擇"
msgstr "請搜索並選擇"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:39
msgid "請搜索並選擇商圈/夜市"
msgstr "請搜索並選擇商圈/夜市"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:33
msgid "請搜索並選擇商場"
msgstr "請搜索並選擇商場"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/constants.ts:172
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:323
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:69
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:295
msgid "請搜索並選擇活動"
msgstr "請搜索並選擇活動"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:21
msgid "請搜索並選擇縣市/行政區"
msgstr "請搜索並選擇縣市/行政區"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:27
msgid "請搜索並選擇類別"
msgstr "請搜索並選擇類別"

#: apps/dp-client/src/utils/permission.ts:80
msgid "請啟用位置權限"
msgstr "請啟用位置權限"

#: apps/dp-client/src/utils/permission.ts:53
msgid "請啟用照片權限"
msgstr "請啟用照片權限"

#: apps/dp-client/src/utils/permission.ts:62
msgid "請啟用相機權限"
msgstr "請啟用相機權限"

#: apps/dp-client/src/utils/permission.ts:71
msgid "請啟用麥克風權限"
msgstr "請啟用麥克風權限"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:697
msgid "請於商家完成支付，支付後請點擊下方按鈕刷新狀態。"
msgstr "請於商家完成支付，支付後請點擊下方按鈕刷新狀態。"

#: apps/dp-client/src/screens/diary/pages/no-access/index.tsx:70
msgid "請查看活動規則"
msgstr "請查看活動規則"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:163
msgid "請檢查參數後重新提交"
msgstr "請檢查參數後重新提交"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/useChannelCampaignSubmit.ts:36
msgid "請檢查活動配置"
msgstr "請檢查活動配置"

#: apps/dp-business/src/pages/TermsAndPrivacy/index.tsx:108
msgid "請檢查環境變數配置"
msgstr "請檢查環境變數配置"

#: apps/dp-client/src/screens/diary/components/ImageViewer/index.tsx:85
#: apps/dp-client/src/components/ImageViewer/index.tsx:306
msgid "請檢查網路連接"
msgstr "請檢查網路連接"

#: apps/dp-business/src/components/GoogleMap/WebViewMap.tsx:703
msgid "請檢查網路連接或API設定"
msgstr "請檢查網路連接或API設定"

#: apps/dp-client/src/screens/home/pages/ShareKing/components/WinningList/index.tsx:147
msgid "請檢查網路連線，並刷新頁面重試喔～"
msgstr "請檢查網路連線，並刷新頁面重試喔～"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:451
msgid "請檢查網路連線後重試"
msgstr "請檢查網路連線後重試"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:489
msgid "請檢查網路連線或稍後重試"
msgstr "請檢查網路連線或稍後重試"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:184
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:275
msgid "請檢查表單填寫是否完整"
msgstr "請檢查表單填寫是否完整"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:231
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:306
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:370
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:929
msgid "請檢查表單資訊並完善必填項"
msgstr "請檢查表單資訊並完善必填項"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:144
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:76
msgid "請款"
msgstr "請款"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:30
msgid "請款 · 帳匯進本商家"
msgstr "請款 · 帳匯進本商家"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:164
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:448
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:25
#: apps/dp-admin/src/pages/split-account/services/constants.ts:88
msgid "請款中"
msgstr "請款中"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:170
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:323
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:179
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:112
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:317
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:311
msgid "請款原因"
msgstr "請款原因"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:137
#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailMerchants.tsx:83
#: apps/dp-admin/src/pages/org-tree/org-audit/services/constants.ts:44
msgid "請款商家"
msgstr "請款商家"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimPanel.tsx:63
msgid "請款商家："
msgstr "請款商家："

#. placeholder {0}: edit.settlement.merchantName || '-'
#. placeholder {0}: item.merchantName || '-'
#. placeholder {0}: detail?.payeeMerchant?.merchantName || '-'
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:228
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:183
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:132
msgid "請款商家：{0}"
msgstr "請款商家：{0}"

#. placeholder {0}: item.merchantName || '-'
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:182
msgid "請款商家：{0}（店家自身商家）"
msgstr "請款商家：{0}（店家自身商家）"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailStoreModal.tsx:170
msgid "請款商家：{routeSubject}"
msgstr "請款商家：{routeSubject}"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/constants.ts:149
msgid "請款商家已佔用"
msgstr "請款商家已佔用"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:226
msgid "請款商家掛上即為結算節點；一個商家全平台只能作為一個節點的請款商家。"
msgstr "請款商家掛上即為結算節點；一個商家全平台只能作為一個節點的請款商家。"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:200
msgid "請款商家決定本節點是否為結算節點。店家實際請款還要看該店的「結算路徑」是否指向本節點。銀行帳戶來自商家主檔，只讀。"
msgstr "請款商家決定本節點是否為結算節點。店家實際請款還要看該店的「結算路徑」是否指向本節點。銀行帳戶來自商家主檔，只讀。"

#: apps/dp-admin/src/pages/org-tree/components/S9BlockModal/index.web.tsx:19
msgid "請款單"
msgstr "請款單"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:191
msgid "請款單 ID"
msgstr "請款單 ID"

#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:261
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:282
msgid "請款單ID"
msgstr "請款單ID"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:67
msgid "請款單ID不可為空"
msgstr "請款單ID不可為空"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:318
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:812
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimPanel.tsx:61
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimPanel.tsx:70
#: apps/dp-business/src/configs/page-configs.ts:867
#: apps/dp-business/src/components/CustomTabs/index.tsx:206
#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:82
#: apps/dp-admin/src/router/config/routes.web.tsx:536
#: apps/dp-admin/src/pages/split-account/claim-list/index.web.tsx:23
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:332
msgid "請款單列表"
msgstr "請款單列表"

#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:70
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:79
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:85
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:90
msgid "請款單匯出失敗"
msgstr "請款單匯出失敗"

#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:69
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:84
msgid "請款單匯出成功"
msgstr "請款單匯出成功"

#: apps/dp-admin/src/router/config/routes.web.tsx:405
#: apps/dp-admin/src/pages/audit-center/claim-audit/index.web.tsx:147
msgid "請款單審核"
msgstr "請款單審核"

#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:430
msgid "請款單審核詳情"
msgstr "請款單審核詳情"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:313
msgid "請款單由連鎖統一發起，請到「連鎖視角 → 財務管理 → 請款單列表」查看，店家視角不展示請款單信息。"
msgstr "請款單由連鎖統一發起，請到「連鎖視角 → 財務管理 → 請款單列表」查看，店家視角不展示請款單信息。"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/Statistics/index.web.tsx:59
msgid "請款單統計"
msgstr "請款單統計"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:148
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:309
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:126
msgid "請款單號"
msgstr "請款單號"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:270
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:284
#: apps/dp-business/src/configs/page-configs.ts:242
#: apps/dp-business/src/configs/page-configs.ts:882
#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:612
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:259
msgid "請款單詳情"
msgstr "請款單詳情"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:293
msgid "請款單詳情載入失敗"
msgstr "請款單詳情載入失敗"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:244
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:37
msgid "請款狀態"
msgstr "請款狀態"

#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:59
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:301
msgid "請款申請ID"
msgstr "請款申請ID"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:612
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:618
msgid "請款申請創建失敗"
msgstr "請款申請創建失敗"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:602
msgid "請款申請創建成功"
msgstr "請款申請創建成功"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:441
msgid "請款申請建立成功"
msgstr "請款申請建立成功"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:90
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/ChainMountTab/index.web.tsx:313
msgid "請款節點"
msgstr "請款節點"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:234
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:311
msgid "請款管理"
msgstr "請款管理"

#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:12
msgid "請款資料生失敗"
msgstr "請款資料生失敗"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:59
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:90
#: apps/dp-admin/src/pages/split-account/services/constants.ts:154
#: apps/dp-admin/src/pages/audit-center/claim-audit/services/constants.ts:11
msgid "請款資料生成中"
msgstr "請款資料生成中"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:60
#: apps/dp-business/src/pages/ChainDashboard/components/finance/financeStatus.ts:91
#: apps/dp-admin/src/pages/split-account/services/constants.ts:156
msgid "請款資料生成失敗"
msgstr "請款資料生成失敗"

#: apps/dp-business/src/pages/ClaimRequests/index.tsx:159
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:316
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:154
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:89
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:310
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:304
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:219
msgid "請款金額"
msgstr "請款金額"

#. placeholder {0}: result?.requestCount ?? 0
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:84
msgid "請求 {0} 家"
msgstr "請求 {0} 家"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:337
msgid "請求參數"
msgstr "請求參數"

#: apps/dp-admin/src/modules/http/request.ts:373
msgid "請求失敗"
msgstr "請求失敗"

#: apps/dp-admin/src/modules/http/request.ts:437
msgid "請求失敗，請稍後重試"
msgstr "請求失敗，請稍後重試"

#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:182
msgid "請求定位權限失敗，請稍後重試"
msgstr "請求定位權限失敗，請稍後重試"

#: apps/dp-admin/src/modules/http/request.ts:401
#: apps/dp-admin/src/modules/http/request.ts:402
#: apps/dp-admin/src/modules/http/request.ts:404
msgid "請求超時，請稍後重試"
msgstr "請求超時，請稍後重試"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:381
msgid "請求錯誤"
msgstr "請求錯誤"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientColumns/index.web.tsx:128
msgid "請求限制"
msgstr "請求限制"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1132
msgid "請注意"
msgstr "請注意"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:756
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:276
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:568
msgid "請注意："
msgstr "請注意："

#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:828
msgid "請添加內容後再預覽"
msgstr "請添加內容後再預覽"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:592
msgid "請添加套餐"
msgstr "請添加套餐"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:260
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:621
msgid "請添加服務"
msgstr "請添加服務"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1395
msgid "請添加菜品資訊"
msgstr "請添加餐點資訊"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:608
msgid "請為分組添加餐點"
msgstr "請為分組添加餐點"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1405
msgid "請為所有分組添加菜品"
msgstr "請為所有分組添加餐點"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:523
msgid "請為所有品類上傳圖片"
msgstr "請為所有品類上傳圖片"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:517
msgid "請為所有品類輸入名稱以生成編碼"
msgstr "請為所有品類輸入名稱以生成編碼"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:243
msgid "請為每個授權節點至少選擇一個角色"
msgstr "請為每個授權節點至少選擇一個角色"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:114
msgid "請為每項權益選擇有效權益"
msgstr "請為每項權益選擇有效權益"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:154
msgid "請生成臨時密碼"
msgstr "請生成臨時密碼"

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:500
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:385
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:481
#: apps/dp-client/src/screens/diary/components/content-warn-modal/index.tsx:61
msgid "請留意發表內容品質"
msgstr "請留意發表內容品質"

#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:407
msgid "請當面核銷，核銷後無法撤回"
msgstr "請當面核銷，核銷後無法撤回"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:443
msgid "請確保上傳的合約為清楚的掃描件或照片，文字要可辨識"
msgstr "請確保上傳的合約為清楚的掃描件或照片，文字要可辨識"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:445
msgid "請確保照片自然光色調清晰，避免反光、模糊或不完整反光"
msgstr "請確保照片自然光色調清晰，避免反光、模糊或不完整反光"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:409
msgid "請確認QR Code是否正確，再重新掃描"
msgstr "請確認QR Code是否正確，再重新掃描"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:144
msgid "請確認以下信息，確認提交後，已參與的活動可以在活動管理中查看"
msgstr "請確認以下信息，確認提交後，已參與的活動可以在活動管理中查看"

#: apps/dp-client/src/screens/home/pages/LocationSelect/components/EmptyState.tsx:37
msgid "請確認名稱是否正確"
msgstr "請確認名稱是否正確"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:350
#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:635
#: apps/dp-client/src/screens/home/pages/PackageSearch/index.tsx:249
#: apps/dp-client/src/screens/account/pages/user-profile/components/ReviewList/index.tsx:214
#: apps/dp-client/src/screens/account/pages/user-profile/components/NoteList/index.tsx:211
msgid ""
"請確認名稱是否正確\n"
"或換個搜尋詞試試～"
msgstr ""
"請確認名稱是否正確\n"
"或換個搜尋詞試試～"

#: apps/dp-client/src/screens/account/pages/likes/components/ReviewContent/index.tsx:215
#: apps/dp-client/src/screens/account/pages/likes/components/NotesContent/index.tsx:174
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowListScene.tsx:94
#: apps/dp-client/src/screens/account/pages/favorites/pages/searchResult/index.tsx:250
msgid "請確認名稱是否正確或換個搜尋詞試試～"
msgstr "請確認名稱是否正確或換個搜尋詞試試～"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1136
msgid "請確認客人的聯繫方式和用餐時間，代客預定成功後，系統將發送確認信息給客人。如需修改或取消預定，請及時聯繫客人並在系統中進行相應操作。"
msgstr "請確認客人的聯繫方式和用餐時間，代客預定成功後，系統將發送確認信息給客人。如需修改或取消預定，請及時聯繫客人並在系統中進行相應操作。"

#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:276
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageUploadGrid/index.web.tsx:287
msgid "請確認後點擊儲存"
msgstr "請確認後點擊儲存"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:615
msgid "請確認您已理解並願意自行承擔上述風險後，再行開啟。"
msgstr "請確認您已理解並願意自行承擔上述風險後，再行開啟。"

#: apps/dp-business/src/pages/AddStore/index.tsx:1081
msgid "請確認提交以下資訊："
msgstr "請確認上傳以下資訊："

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:374
msgid "請確認新密碼"
msgstr "請確認新密碼"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:908
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:479
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:872
msgid "請確認是否撤回？"
msgstr "請確認是否撤回？"

#: apps/dp-client/src/screens/home/pages/Meal/components/RedemptionConfirmContent/index.tsx:36
msgid "請確認核銷資訊"
msgstr "請確認核銷資訊"

#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/index.web.tsx:77
msgid "請確認該商家是否在正常營業"
msgstr "請確認該商家是否在正常營業"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:398
msgid "請稍候，正在為你領取兌換券"
msgstr "請稍候，正在為你領取兌換券"

#: apps/dp-business/src/components/GoogleMap/index.tsx:806
msgid "請稍候，正在連接地圖服務"
msgstr "請稍候，正在連接地圖服務"

#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:379
msgid "請稍候..."
msgstr "請稍候..."

#: apps/dp-client/src/screens/bind/pages/phone-bind/index.tsx:105
msgid "請綁定手機門號與心生活一致的手機門號，否則無法繼承權益"
msgstr "請綁定手機門號與心生活一致的手機門號，否則無法繼承權益"

#: apps/dp-business/src/pages/AccountDeactivationSuccess/index.tsx:52
msgid "請聯繫平台運營使用新手機創建帳號"
msgstr "請聯繫平台運營使用新手機創建帳號"

#: apps/dp-business/src/pages/Onboarding/index.tsx:78
msgid "請聯繫我們加入去哪吃"
msgstr "請聯繫我們加入去哪吃"

#: apps/dp-business/src/pages/BusinessStatus/components/SharedTemplatesContent.tsx:97
msgid "請至套餐券列表檢查並手動下架"
msgstr "請至套餐券列表檢查並手動下架"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/index.web.tsx:56
msgid "請至少上傳 1 條活動位素材"
msgstr "請至少上傳 1 條活動位素材"

#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:182
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:126
msgid "請至少上傳一張圖片"
msgstr "請至少上傳一張圖片"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PosterListField/index.web.tsx:27
msgid "請至少上傳一張海報圖片"
msgstr "請至少上傳一張海報圖片"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:237
msgid "請至少填寫一項測試目標"
msgstr "請至少填寫一項測試目標"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:211
msgid "請至少填寫帳號、Email 或手機門號其中一項"
msgstr "請至少填寫帳號、Email 或手機門號其中一項"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:645
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:646
msgid "請至少啟用一個餐段"
msgstr "請至少啟用一個餐段"

#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:195
msgid "請至少新增一位使用者"
msgstr "請至少新增一位使用者"

#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:174
msgid "請至少新增一位臨時使用者"
msgstr "請至少新增一位臨時使用者"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityStepsField/index.web.tsx:25
msgid "請至少新增一個步驟"
msgstr "請至少新增一個步驟"

#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:56
msgid "請至少新增一條佣金規則"
msgstr "請至少新增一條佣金規則"

#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/BookingFeeRules/index.web.tsx:58
msgid "請至少新增一條收費規則"
msgstr "請至少新增一條收費規則"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:59
msgid "請至少添加一個搜索關鍵詞"
msgstr "請至少添加一個搜索關鍵詞"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:638
msgid "請至少添加一個特殊日期"
msgstr "請至少添加一個特殊日期"

#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:314
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:302
msgid "請至少添加一個篩選條件"
msgstr "請至少添加一個篩選條件"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:155
msgid "請至少添加一個餐點"
msgstr "請至少添加一個餐點"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:60
msgid "請至少添加一條折扣規則"
msgstr "請至少添加一條折扣規則"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:358
msgid "請至少給30個字哦～"
msgstr "請至少輸入30個字哦～"

#: apps/dp-business/src/pages/AddRole/index.tsx:242
msgid "請至少設定一個權限"
msgstr "請至少設定一個權限"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:155
msgid "請至少選擇一位使用者"
msgstr "請至少選擇一位使用者"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1155
msgid "請至少選擇一個可用日期"
msgstr "請至少選擇一個可用日期"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:317
msgid "請至少選擇一個商家名單"
msgstr "請至少選擇一個商家名單"

#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:159
#: apps/dp-business/src/pages/UserManagement/BatchCopyUsers.tsx:47
msgid "請至少選擇一個店家"
msgstr "請至少選擇一個店家"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:194
msgid "請至少選擇一個店家名單"
msgstr "請至少選擇一個店家名單"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:613
msgid "請至少選擇一個時段"
msgstr "請至少選擇一個時段"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:96
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignChannelFields/index.web.tsx:70
msgid "請至少選擇一個有效的三級渠道"
msgstr "請至少選擇一個有效的三級渠道"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:769
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:770
msgid "請至少選擇一個桌位"
msgstr "請至少選擇一個桌位"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:623
msgid "請至少選擇一個營業時段"
msgstr "請至少選擇一個營業時段"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:850
msgid "請至少選擇一個特殊日期"
msgstr "請至少選擇一個特殊日期"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1174
msgid "請至少選擇一個特殊日期的餐期"
msgstr "請至少選擇一個特殊日期的餐期"

#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:353
#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:359
msgid "請至少選擇一個用戶名單"
msgstr "請至少選擇一個用戶名單"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountCopyForm.tsx:75
msgid "請至少選擇一個角色"
msgstr "請至少選擇一個角色"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1158
msgid "請至少選擇一個餐期"
msgstr "請至少選擇一個餐期"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:566
msgid "請至少選擇一級和二級分類"
msgstr "請至少選擇一級和二級分類"

#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:179
msgid "請至少選擇一間店家"
msgstr "請至少選擇一間店家"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:215
msgid "請至少選擇一項功能權限"
msgstr "請至少選擇一項功能權限"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageSourceField/index.web.tsx:93
msgid "請至少選擇店家名單或填寫一項篩選條件"
msgstr "請至少選擇店家名單或填寫一項篩選條件"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:109
msgid "請至少配置一項權益"
msgstr "請至少配置一項權益"

#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:326
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:324
msgid "請補充有效的篩選條件"
msgstr "請補充有效的篩選條件"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:346
msgid "請補充模板數區間"
msgstr "請補充模板數區間"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:59
msgid "請設定有效的週期維度和循環次數"
msgstr "請設定有效的週期維度和循環次數"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:49
msgid "請設定活動結束時間"
msgstr "請設定活動結束時間"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:47
msgid "請設定活動開始時間"
msgstr "請設定活動開始時間"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:129
msgid "請設定開始時間"
msgstr "請設定開始時間"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:112
msgid "請設定開始時間和結束時間"
msgstr "請設定開始時間和結束時間"

#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:267
msgid "請設置營業時間，支援常規時間和特殊日期設置"
msgstr "請設置營業時間，支援常規時間和特殊日期設置"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:415
msgid "請詳細描述您遇到的問題，包括具體的操作步驟，錯誤訊息等"
msgstr "請詳細描述您遇到的問題，包括具體的操作步驟，錯誤訊息等"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:398
msgid "請詳細描述投訴原因（10-1000字）"
msgstr "請詳細描述投訴原因（10-1000字）"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:372
msgid "請詳細敘述檢舉原因"
msgstr "請詳細敘述檢舉原因"

#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:166
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:532
msgid "請詳細說明拒絕的原因..."
msgstr "請詳細說明拒絕的原因..."

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:335
msgid "請詳細說明未通過原因，以便商家瞭解問題並進行修改。"
msgstr "請詳細說明未通過原因，以便商家瞭解問題並進行修改。"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:325
msgid "請詳細說明未通過原因..."
msgstr "請詳細說明未通過原因..."

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:222
msgid "請詳細說明標籤合併的理由"
msgstr "請詳細說明標籤合併的理由"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:114
msgid "請詳細說明駁回原因，以便商家瞭解問題並進行修改"
msgstr "請詳細說明駁回原因，以便商家瞭解問題並進行修改"

#: apps/dp-business/src/components/ModificationReason/index.tsx:96
msgid "請說明修改原因"
msgstr "請說明修改原因"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1213
msgid "請諮詢服務人員後輸入"
msgstr "請諮詢服務人員後輸入"

#: apps/dp-client/src/screens/bind/pages/phone-bind/index.tsx:117
#: apps/dp-client/src/screens/bind/pages/phone-bind/components/phone-bind-form/index.tsx:63
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:679
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:719
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:734
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:744
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:754
#: apps/dp-client/src/screens/account/pages/edit-profile/edit-nickname/index.tsx:182
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:451
#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:166
#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:192
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:318
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:347
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageConditionTree/index.web.tsx:56
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:115
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:47
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:57
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:127
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:150
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:176
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:105
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:97
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/RegisterTimeSelector.web.tsx:83
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:169
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:271
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:290
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:74
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ComparisonSelector.web.tsx:94
msgid "請輸入"
msgstr "請輸入"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:364
msgid "請輸入 1 至 180 天"
msgstr "請輸入 1 至 180 天"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:169
msgid "請輸入 1～100000 的整數"
msgstr "請輸入 1～100000 的整數"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:332
msgid "請輸入 6 至 22 位帳號名稱"
msgstr "請輸入 6 至 22 位帳號名稱"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:157
msgid "請輸入 Email"
msgstr "請輸入 Email"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:90
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:97
msgid "請輸入 mid"
msgstr "請輸入 mid"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:343
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:362
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:432
msgid "請輸入，最多一位小數"
msgstr "請輸入，最多一位小數"

#. placeholder {0}: getUnitLabel(poiType)
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:832
msgid "請輸入{0}"
msgstr "請輸入{0}"

#: apps/dp-admin/src/components/ConfigurableForm/ConfigurableForm.web.tsx:222
msgid "請輸入{labelText}"
msgstr "請輸入{labelText}"

#: apps/dp-business/src/pages/AveragePrice/index.tsx:248
msgid "請輸入$1-$100000之間的數字"
msgstr "請輸入$1-$100000之間的數字"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/JoinActivityModalContent.tsx:270
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:512
msgid "請輸入1-100之間的整數"
msgstr "請輸入1-100之間的整數"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:373
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:463
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:163
msgid "請輸入10000以內的數字"
msgstr "請輸入10000以內的數字"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:441
msgid "請輸入50字內標籤描述"
msgstr "請輸入50字內標籤描述"

#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:131
#: apps/dp-business/src/components/ForgotPassword/index.tsx:295
msgid "請輸入6位驗證碼"
msgstr "請輸入6位驗證碼"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/AppPushTemplateSection.web.tsx:18
msgid "請輸入App Push 標題"
msgstr "請輸入App Push 標題"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/AppPushTemplateSection.web.tsx:31
msgid "請輸入App Push內容"
msgstr "請輸入App Push內容"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:434
#: apps/dp-business/src/pages/AddUser/index.tsx:252
#: apps/dp-business/src/components/EmailVerification/index.tsx:86
#: apps/dp-business/src/components/EmailVerification/index.tsx:92
#: apps/dp-business/src/components/EmailVerification/index.tsx:113
#: apps/dp-business/src/components/EmailInput/index.tsx:51
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:89
msgid "請輸入Email"
msgstr "請輸入Email"

#: apps/dp-client/src/screens/account/pages/account-security/email/email-old/index.tsx:89
#: apps/dp-client/src/screens/account/pages/account-security/email/bind-email/index.tsx:83
#: apps/dp-business/src/utils/validation.ts:73
#: apps/dp-business/src/utils/validation.ts:331
#: apps/dp-business/src/pages/Login/index.tsx:318
#: apps/dp-business/src/pages/Login/index.tsx:1036
#: apps/dp-business/src/pages/Login/index.tsx:1063
#: apps/dp-business/src/pages/Login/index.tsx:1513
#: apps/dp-business/src/pages/Login/index.tsx:1540
#: apps/dp-business/src/pages/Login/Email/index.tsx:46
#: apps/dp-business/src/components/ForgotPassword/index.tsx:86
#: apps/dp-business/src/components/ForgotPassword/index.tsx:396
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:170
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:226
msgid "請輸入Email地址"
msgstr "請輸入Email地址"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:39
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:185
msgid "請輸入FetUID"
msgstr "請輸入FetUID"

#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:228
msgid "請輸入UID，回車確認"
msgstr "請輸入UID，回車確認"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:307
msgid "請輸入三級標籤名稱"
msgstr "請輸入三級標籤名稱"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:424
msgid "請輸入三級標籤名稱 (必填)"
msgstr "請輸入三級標籤名稱 (必填)"

#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:123
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:123
msgid "請輸入上架備註"
msgstr "請輸入上架備註"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:390
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:396
msgid "請輸入上限金額"
msgstr "請輸入上限金額"

#: apps/dp-admin/src/pages/audit-center/components/UnpublishReasonForm/index.web.tsx:77
#: apps/dp-admin/src/pages/audit-center/components/AuditPage/index.web.tsx:266
msgid "請輸入下架備註"
msgstr "請輸入下架備註"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:1000
msgid "請輸入下架原因（選填）"
msgstr "請輸入下架原因（選填）"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/RejectWinnerModal.web.tsx:78
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/RejectWinnerModal.web.tsx:83
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchRejectWinnerModal.web.tsx:97
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchRejectWinnerModal.web.tsx:102
msgid "請輸入不予中獎原因"
msgstr "請輸入不予中獎原因"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:279
msgid "請輸入不予發獎原因（必填）"
msgstr "請輸入不予發獎原因（必填）"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:176
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:176
msgid "請輸入並選擇商圈"
msgstr "請輸入並選擇商圈"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:436
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:182
msgid "請輸入並選擇商場/商圈/夜市名稱"
msgstr "請輸入並選擇商場/商圈/夜市名稱"

#: apps/dp-admin/src/pages/resource-config/category-management/components/PinyinInput/index.web.tsx:51
msgid "請輸入中文或英文編碼"
msgstr "請輸入中文或英文編碼"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:474
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:524
msgid "請輸入中英文哦"
msgstr "請輸入中英文哦"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:104
msgid "請輸入主標題"
msgstr "請輸入主標題"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:275
msgid "請輸入互斥組名稱"
msgstr "請輸入互斥組名稱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:163
msgid "請輸入交易手續費"
msgstr "請輸入交易手續費"

#: apps/dp-business/src/utils/validation.ts:153
#: apps/dp-business/src/utils/validation.ts:182
#: apps/dp-business/src/utils/validation.ts:348
msgid "請輸入人均價格"
msgstr "請輸入人均價格"

#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/PriceSection.tsx:35
msgid "請輸入人均消費金額"
msgstr "請輸入人均消費金額"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:328
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:93
msgid "請輸入代表人姓名"
msgstr "請輸入代表人姓名"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:81
msgid "請輸入代表人居留證號"
msgstr "請輸入代表人居留證號"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:83
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/hooks.ts:71
msgid "請輸入代表人護照號碼"
msgstr "請輸入代表人護照號碼"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:159
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:79
msgid "請輸入代表人身份證號"
msgstr "請輸入代表人身份證號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:156
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:103
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:107
msgid "請輸入代表人身分證字號"
msgstr "請輸入代表人身分證字號"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1354
msgid "請輸入以上的整數，設定後將即時更新可預定數量"
msgstr "請輸入以上的整數，設定後將即時更新可預定數量"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:281
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:283
msgid "請輸入任務名稱"
msgstr "請輸入任務名稱"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:289
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:292
msgid "請輸入任務說明"
msgstr "請輸入任務說明"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:59
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/CompanyRegistration/index.web.tsx:47
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:207
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:209
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:139
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:141
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:50
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:54
msgid "請輸入企業名稱"
msgstr "請輸入企業名稱"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/VoidInventoryModal.web.tsx:37
msgid "請輸入作廢原因"
msgstr "請輸入作廢原因"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/VoidInventoryModal.web.tsx:72
msgid "請輸入作廢原因（最多 {VOID_REASON_MAX_LENGTH} 字）"
msgstr "請輸入作廢原因（最多 {VOID_REASON_MAX_LENGTH} 字）"

#: apps/dp-client/src/screens/account/pages/edit-profile/edit-signature/index.tsx:237
msgid "請輸入你的個性簽名"
msgstr "請輸入你的簽名檔"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:118
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:141
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:146
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:97
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:118
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:613
msgid "請輸入佣金比例"
msgstr "請輸入佣金比例"

#: apps/dp-business/src/utils/phoneValidation.ts:108
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:307
#: apps/dp-business/src/pages/EditUser/index.tsx:112
#: apps/dp-business/src/pages/EditUser/index.tsx:260
#: apps/dp-business/src/pages/AddUser/index.tsx:205
msgid "請輸入使用者名稱"
msgstr "請輸入使用者名稱"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:116
msgid "請輸入使用者姓名"
msgstr "請輸入使用者姓名"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:182
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:511
msgid "請輸入使用說明"
msgstr "請輸入使用說明"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2349
msgid "請輸入使用說明..."
msgstr "請輸入使用說明..."

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:106
msgid "請輸入使用門檻"
msgstr "請輸入使用門檻"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:248
msgid "請輸入使用須知"
msgstr "請輸入使用須知"

#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:634
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:638
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:228
#: apps/dp-admin/src/pages/merchant/signing-management/components/ContractList/index.web.tsx:232
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1186
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1190
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:297
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:301
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:1038
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:1042
msgid "請輸入供應商代碼"
msgstr "請輸入供應商代碼"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:402
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:306
msgid "請輸入修改一級品類的理由"
msgstr "請輸入修改一級品類的理由"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:657
msgid "請輸入修改二級品類的理由"
msgstr "請輸入修改二級品類的理由"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:488
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:495
msgid "請輸入修改原因"
msgstr "請輸入修改原因"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:811
msgid "請輸入修改標籤的理由 (必填)"
msgstr "請輸入修改標籤的理由 (必填)"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:409
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:654
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:303
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:337
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:345
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:335
msgid "請輸入修改理由"
msgstr "請輸入修改理由"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDisableModal/index.web.tsx:73
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelDisableModal/index.web.tsx:80
msgid "請輸入停用原因"
msgstr "請輸入停用原因"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:82
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:207
msgid "請輸入停車場名稱"
msgstr "請輸入停車場名稱"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:322
msgid "請輸入備註"
msgstr "請輸入備註"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractUpload/components/OtherRemarks/index.web.tsx:33
msgid "請輸入備註（選填，不超過250字）"
msgstr "請輸入備註（選填，不超過250字）"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:427
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:431
#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:367
msgid "請輸入備註內容"
msgstr "請輸入備註內容"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1067
msgid "請輸入備註內容（可選）"
msgstr "請輸入備註內容（可選）"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:324
msgid "請輸入備註說明"
msgstr "請輸入備註說明"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:760
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:390
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:177
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:255
msgid "請輸入價格"
msgstr "請輸入價格"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:45
msgid "請輸入優先級"
msgstr "請輸入優先級"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageDescriptionCard.tsx:68
msgid "請輸入優惠券使用說明..."
msgstr "請輸入優惠券使用說明..."

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:48
msgid "請輸入優惠券名稱"
msgstr "請輸入優惠券名稱"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:73
msgid "請輸入優惠折扣"
msgstr "請輸入優惠折扣"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:252
msgid "請輸入兌換碼ID"
msgstr "請輸入兌換碼ID"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:261
msgid "請輸入兌換碼ID，如：ABC123"
msgstr "請輸入兌換碼ID，如：ABC123"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:249
msgid "請輸入內容 (限制1000字)"
msgstr "請輸入內容 (限制1000字)"

#: apps/dp-client/src/screens/home/components/RichTextInput/index.tsx:56
#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:70
#: apps/dp-client/src/components/QuillRichEditor/QuillRichEditor.web.tsx:90
#: apps/dp-client/src/components/QuillRichEditor/QuillRichEditor.native.tsx:43
msgid "請輸入內容..."
msgstr "請輸入內容..."

#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:154
msgid "請輸入內容ID"
msgstr "請輸入內容ID"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:528
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:531
msgid "請輸入內容名稱"
msgstr "請輸入內容名稱"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:276
msgid "請輸入內部備註 (限制500字)"
msgstr "請輸入內部備註 (限制500字)"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:126
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:106
msgid "請輸入內部連結地址"
msgstr "請輸入內部連結地址"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:644
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:30
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:80
msgid "請輸入公司登記名"
msgstr "請輸入公司登記名"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:372
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:134
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:649
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:35
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:99
msgid "請輸入公司登記地址"
msgstr "請輸入公司登記地址"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:433
msgid "請輸入公司行政抬頭"
msgstr "請輸入公司行政抬頭"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:585
msgid "請輸入具體內容"
msgstr "請輸入具體內容"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:69
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:97
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:118
msgid "請輸入最低價格"
msgstr "請輸入最低價格"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:134
msgid "請輸入最大人數"
msgstr "請輸入最大人數"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:94
msgid "請輸入最大價格"
msgstr "請輸入最大價格"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:55
msgid "請輸入最大排名"
msgstr "請輸入最大排名"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:104
msgid "請輸入最小人數"
msgstr "請輸入最小人數"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:83
msgid "請輸入最小價格"
msgstr "請輸入最小價格"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:45
msgid "請輸入最小排名"
msgstr "請輸入最小排名"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:227
msgid "請輸入最少分享數"
msgstr "請輸入最少分享數"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:75
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:109
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:130
msgid "請輸入最高價格"
msgstr "請輸入最高價格"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:635
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:41
msgid "請輸入出生日期"
msgstr "請輸入出生日期"

#: apps/dp-business/src/pages/TableManagement/index.tsx:288
#: apps/dp-business/src/pages/TableManagement/index.tsx:310
#: apps/dp-business/src/pages/TableManagement/index.tsx:393
#: apps/dp-business/src/pages/TableManagement/index.tsx:415
msgid "請輸入分區名稱"
msgstr "請輸入分區名稱"

#: apps/dp-admin/src/utils/validation.ts:43
msgid "請輸入分機號"
msgstr "請輸入分機號"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:197
msgid "請輸入分組名稱"
msgstr "請輸入分組名稱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:597
msgid "請輸入分行代碼"
msgstr "請輸入分行代碼"

#: apps/dp-business/src/pages/MenuManagement.tsx:102
#: apps/dp-business/src/pages/MenuManagement.tsx:710
#: apps/dp-business/src/pages/MenuManagement.tsx:755
msgid "請輸入分類名稱"
msgstr "請輸入分類名稱"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:131
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:136
msgid "請輸入券名稱"
msgstr "請輸入券名稱"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:828
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1040
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:47
msgid "請輸入券碼"
msgstr "請輸入券碼"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:335
msgid "請輸入券碼 / 用戶"
msgstr "請輸入券碼 / 用戶"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:33
msgid "請輸入券組ID"
msgstr "請輸入券組ID"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:39
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:96
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:100
msgid "請輸入券組名稱"
msgstr "請輸入券組名稱"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:111
msgid "請輸入副標題"
msgstr "請輸入副標題"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:68
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/searchConfig.ts:47
msgid "請輸入創建人名稱"
msgstr "請輸入創建人名稱"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:661
msgid "請輸入半徑"
msgstr "請輸入半徑"

#: apps/dp-business/src/pages/ChangePassword/index.tsx:38
#: apps/dp-business/src/pages/ChangePassword/index.tsx:219
msgid "請輸入原密碼"
msgstr "請輸入原密碼"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:357
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:361
msgid "請輸入取消原因"
msgstr "請輸入取消原因"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ExchangeLimitEditor/index.web.tsx:53
msgid "請輸入可兌換消耗上限"
msgstr "請輸入可兌換消耗上限"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:189
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:286
msgid "請輸入可選數量"
msgstr "請輸入可選數量"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:49
msgid "請輸入合併理由"
msgstr "請輸入合併理由"

#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:21
msgid "請輸入名單 ID"
msgstr "請輸入名單 ID"

#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:29
#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:32
#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:28
msgid "請輸入名單名稱"
msgstr "請輸入名單名稱"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepUserGroup.web.tsx:40
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepMerchantGroup.web.tsx:40
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchRejectWinnerModal.web.tsx:88
#: apps/dp-admin/src/components/UserGroup/UserGroupSelector/index.web.tsx:240
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupSelector/index.web.tsx:324
msgid "請輸入名單名稱搜尋"
msgstr "請輸入名單名稱搜尋"

#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:261
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:70
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:543
msgid "請輸入名稱"
msgstr "請輸入名稱"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelParentSelect/index.web.tsx:80
msgid "請輸入名稱搜尋"
msgstr "請輸入名稱搜尋"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:562
msgid "請輸入名稱搜尋 Google POI..."
msgstr "請輸入名稱搜尋 Google POI..."

#: apps/dp-admin/src/pages/merchant/brand-list/services/searchConfig.ts:18
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:116
#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:124
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:106
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:108
msgid "請輸入品牌名稱"
msgstr "請輸入品牌名稱"

#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:252
msgid "請輸入品牌名稱搜尋"
msgstr "請輸入品牌名稱搜尋"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandEditModal/index.web.tsx:155
msgid "請輸入品牌描述"
msgstr "請輸入品牌描述"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:352
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:359
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:442
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:449
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:507
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:514
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:174
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:614
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:623
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:262
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:271
msgid "請輸入品類名稱"
msgstr "請輸入品類名稱"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:460
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:180
msgid "請輸入品類名稱以生成品類編碼"
msgstr "請輸入品類名稱以生成品類編碼"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:476
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:526
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:201
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:644
msgid "請輸入品類描述"
msgstr "請輸入品類描述"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:386
#: apps/dp-admin/src/pages/resource-config/category-management/components/FirstCategoryModal/index.web.tsx:292
msgid "請輸入品類描述與新增理由"
msgstr "請輸入品類描述與新增理由"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:371
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:378
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:461
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:468
msgid "請輸入品類編碼"
msgstr "請輸入品類編碼"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:83
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:134
msgid "請輸入員工姓名"
msgstr "請輸入員工姓名"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:86
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:149
msgid "請輸入員工編號"
msgstr "請輸入員工編號"

#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:74
msgid "請輸入商家GoogleID/ID/統編/食品編號/名稱"
msgstr "請輸入商家GoogleID/ID/統編/食品編號/名稱"

#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:31
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:50
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:25
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:78
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:36
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:87
msgid "請輸入商家ID"
msgstr "請輸入商家ID"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:80
#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:83
msgid "請輸入商家名單名稱"
msgstr "請輸入商家名單名稱"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:94
msgid "請輸入商家名單描述"
msgstr "請輸入商家名單描述"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:132
#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:96
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:113
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:285
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:249
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:57
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:51
msgid "請輸入商家名稱"
msgstr "請輸入商家名稱"

#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:60
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:60
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:56
msgid "請輸入商家名稱/統編"
msgstr "請輸入商家名稱/統編"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:154
msgid "請輸入商家名稱或ID"
msgstr "請輸入商家名稱或ID"

#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:256
msgid "請輸入商家名稱搜尋Google店家..."
msgstr "請輸入商家名稱搜尋Google店家..."

#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:37
#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:32
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:159
msgid "請輸入商家統編"
msgstr "請輸入商家統編"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:562
msgid "請輸入商家英文名"
msgstr "請輸入商家英文名"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:527
msgid "請輸入商店爭議款信箱"
msgstr "請輸入商店爭議款信箱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:581
msgid "請輸入商店簡介"
msgstr "請輸入商店簡介"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:113
msgid "請輸入回覆內容"
msgstr "請輸入回覆內容"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:128
msgid "請輸入圍欄名稱"
msgstr "請輸入圍欄名稱"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:180
msgid "請輸入圖標名稱"
msgstr "請輸入圖標名稱"

#: apps/dp-client/src/screens/home/pages/LocationSelect/components/SearchHeader.tsx:48
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:84
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:224
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:637
msgid "請輸入地址"
msgstr "請輸入地址"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:237
msgid "請輸入地址或搜尋店家..."
msgstr "請輸入地址或搜尋店家..."

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:639
msgid "請輸入地址或範圍描述"
msgstr "請輸入地址或範圍描述"

#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:353
msgid "請輸入地址資訊"
msgstr "請輸入地址資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:125
msgid "請輸入基礎佣金比例"
msgstr "請輸入基礎佣金比例"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:276
msgid "請輸入報修問題描述"
msgstr "請輸入報修問題描述"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:125
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:105
msgid "請輸入外部連結地址"
msgstr "請輸入外部連結地址"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1065
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1140
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1147
msgid "請輸入大於 0 的整數"
msgstr "請輸入大於 0 的整數"

#: apps/dp-client/src/screens/home/utils/filterData.ts:102
msgid "請輸入大於0的整數哦"
msgstr "請輸入大於0的整數哦"

#: apps/dp-client/src/screens/home/utils/filterData.ts:60
#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:419
msgid "請輸入大於0的數字"
msgstr "請輸入大於0的數字"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:102
msgid "請輸入大標題"
msgstr "請輸入大標題"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:158
msgid "請輸入天數"
msgstr "請輸入天數"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:305
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:108
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:343
msgid "請輸入套餐價格"
msgstr "請輸入套餐價格"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/PackageCouponSelect/index.web.tsx:96
msgid "請輸入套餐券名稱搜尋"
msgstr "請輸入套餐券名稱搜尋"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:172
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:433
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:156
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:161
msgid "請輸入套餐名稱"
msgstr "請輸入套餐名稱"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageCouponPicker/index.web.tsx:165
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageCouponField/index.web.tsx:272
msgid "請輸入套餐名稱搜索"
msgstr "請輸入套餐名稱搜索"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:198
msgid "請輸入套餐折扣價"
msgstr "請輸入套餐折扣價"

#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:138
#: apps/dp-business/src/utils/validation.ts:114
#: apps/dp-business/src/utils/validation.ts:340
#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:314
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:92
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:96
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:228
msgid "請輸入姓名"
msgstr "請輸入姓名"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:207
msgid "請輸入姓名，最長 64 字"
msgstr "請輸入姓名，最長 64 字"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountToolbar/index.web.tsx:47
msgid "請輸入姓名、員工編碼、信箱"
msgstr "請輸入姓名、員工編碼、信箱"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:631
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:995
msgid "請輸入客人姓名"
msgstr "請輸入客人姓名"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:513
msgid "請輸入客服Email"
msgstr "請輸入客服Email"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:55
msgid "請輸入客服信箱"
msgstr "請輸入客服信箱"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/PromotionTab/index.web.tsx:102
msgid "請輸入宣傳語，不超過20字"
msgstr "請輸入宣傳語，不超過20字"

#: apps/dp-client/src/utils/utils.ts:72
#: apps/dp-client/src/screens/login/pages/verify-password/index.tsx:86
#: apps/dp-client/src/screens/login/pages/verify-password/components/verify-password-form/index.tsx:56
#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:222
#: apps/dp-client/src/screens/login/pages/password-login/index.tsx:69
#: apps/dp-client/src/screens/login/pages/password-login/index.tsx:143
#: apps/dp-client/src/screens/login/pages/password-login/components/password-login-form/index.tsx:73
#: apps/dp-client/src/screens/account/pages/account-security/check-password/index.tsx:37
#: apps/dp-business/src/utils/validation.ts:255
#: apps/dp-business/src/utils/validation.ts:354
#: apps/dp-business/src/pages/Login/index.tsx:708
#: apps/dp-business/src/pages/Login/index.tsx:1084
#: apps/dp-business/src/pages/Login/index.tsx:1190
#: apps/dp-business/src/pages/Login/index.tsx:1561
#: apps/dp-business/src/pages/Login/index.tsx:1664
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:93
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:182
#: apps/dp-admin/src/pages/login/components/LoginForm/index.web.tsx:69
#: apps/dp-admin/src/pages/login/components/LoginForm/index.web.tsx:74
msgid "請輸入密碼"
msgstr "請輸入密碼"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:343
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:107
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:654
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:40
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:118
msgid "請輸入實收資本額"
msgstr "請輸入實收資本額"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:157
msgid "請輸入實際庫存"
msgstr "請輸入實際庫存"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:76
#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:76
msgid "請輸入實際管理人姓名"
msgstr "請輸入實際管理人姓名"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:104
msgid "請輸入實際管理人手機號"
msgstr "請輸入實際管理人手機號"

#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:127
msgid "請輸入實際管理人手機門號"
msgstr "請輸入實際管理人手機門號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:557
msgid "請輸入實際管理人英文名"
msgstr "請輸入實際管理人英文名"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:120
msgid "請輸入實際管理人身分證號"
msgstr "請輸入實際管理人身分證號"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:512
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:403
msgid "請輸入審批意見（可選）"
msgstr "請輸入審批意見（可選）"

#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:517
msgid "請輸入審核意見（可選）"
msgstr "請輸入審核意見（可選）"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:119
msgid "請輸入對接人姓名"
msgstr "請輸入對接人姓名"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:354
#: apps/dp-admin/src/pages/merchant/components/identity-fields/ArcMetaFields.web.tsx:58
msgid "請輸入居留證期限"
msgstr "請輸入居留證期限"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:334
#: apps/dp-admin/src/pages/merchant/components/identity-fields/ArcMetaFields.web.tsx:46
msgid "請輸入居留證發證日期"
msgstr "請輸入居留證發證日期"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:314
msgid "請輸入居留證統一證號"
msgstr "請輸入居留證統一證號"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:375
#: apps/dp-admin/src/pages/merchant/components/identity-fields/ArcMetaFields.web.tsx:67
#: apps/dp-admin/src/pages/merchant/components/identity-fields/ArcMetaFields.web.tsx:69
msgid "請輸入居留證背面序號"
msgstr "請輸入居留證背面序號"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/ArcIdentityFields.web.tsx:36
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/hooks.ts:68
msgid "請輸入居留證號"
msgstr "請輸入居留證號"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:539
msgid "請輸入展示名稱"
msgstr "請輸入展示名稱"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:216
#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:238
msgid "請輸入展示時長"
msgstr "請輸入展示時長"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:293
#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:298
msgid "請輸入展示間隔"
msgstr "請輸入展示間隔"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:230
msgid "請輸入市話號碼"
msgstr "請輸入市話號碼"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:81
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:128
msgid "請輸入帳戶名"
msgstr "請輸入帳戶名"

#: apps/dp-business/src/pages/Login/index.tsx:1177
#: apps/dp-business/src/pages/Login/index.tsx:1651
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:110
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:602
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:51
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:135
msgid "請輸入帳號"
msgstr "請輸入帳號"

#: apps/dp-business/src/utils/passwordGenerator.ts:40
msgid "請輸入帳號名稱"
msgstr "請輸入帳號名稱"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:192
msgid "請輸入平台補貼"
msgstr "請輸入平台補貼"

#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:195
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:197
msgid "請輸入店名"
msgstr "請輸入店名"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:107
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:66
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:45
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:118
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:107
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:81
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:91
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:89
msgid "請輸入店家ID"
msgstr "請輸入店家ID"

#: apps/dp-admin/src/pages/marketing/merchant-group-detail/services/searchConfig.ts:14
msgid "請輸入店家ID / 店家名稱"
msgstr "請輸入店家ID / 店家名稱"

#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:39
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:60
msgid "請輸入店家ID、名稱"
msgstr "請輸入店家ID、名稱"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/shopConfig.web.tsx:13
msgid "請輸入店家ID或名稱"
msgstr "請輸入店家ID或名稱"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:227
#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:244
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:72
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ClientSearchPanel/index.web.tsx:68
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:233
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:240
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:432
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:436
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:375
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:63
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:54
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:51
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:116
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:90
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:100
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:98
msgid "請輸入店家名稱"
msgstr "請輸入店家名稱"

#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:62
msgid "請輸入店家名稱/ID"
msgstr "請輸入店家名稱/ID"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:56
msgid "請輸入店家名稱/店家ID"
msgstr "請輸入店家名稱/店家ID"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/AddShopModal/index.web.tsx:85
msgid "請輸入店家數據"
msgstr "請輸入店家數據"

#: apps/dp-business/src/pages/AveragePrice/index.tsx:259
msgid "請輸入店家的人均消費"
msgstr "請輸入店家的人均消費"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:270
msgid "請輸入店家的聯繫電話"
msgstr "請輸入店家的聯繫電話"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:134
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:383
msgid "請輸入店家簡介"
msgstr "請輸入店家簡介"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:314
msgid "請輸入店家英文名"
msgstr "請輸入店家英文名"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:119
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:567
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:333
msgid "請輸入店家英文地址"
msgstr "請輸入店家英文地址"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/services/searchConfig.ts:21
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:91
msgid "請輸入廠商名稱"
msgstr "請輸入廠商名稱"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:94
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:179
msgid "請輸入循環次數"
msgstr "請輸入循環次數"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:239
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:242
msgid "請輸入心生活MID"
msgstr "請輸入心生活MID"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:378
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:380
msgid "請輸入快遞編碼"
msgstr "請輸入快遞編碼"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:433
msgid "請輸入或選擇榜單編碼"
msgstr "請輸入或選擇榜單編碼"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:97
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:100
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:123
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:126
msgid "請輸入戶名"
msgstr "請輸入戶名"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:206
#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:218
msgid "請輸入手機號"
msgstr "請輸入手機號"

#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:166
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:636
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1050
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:328
msgid "請輸入手機號碼"
msgstr "請輸入手機號碼"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:144
#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:433
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:105
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:269
#: apps/dp-client/src/screens/bind/pages/phone-bind/index.tsx:63
#: apps/dp-client/src/screens/account/pages/check-phone/bind-phone/index.tsx:83
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:462
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:164
#: apps/dp-business/src/pages/Login/index.tsx:335
#: apps/dp-business/src/pages/Login/index.tsx:1037
#: apps/dp-business/src/pages/Login/index.tsx:1064
#: apps/dp-business/src/pages/Login/index.tsx:1514
#: apps/dp-business/src/pages/Login/index.tsx:1541
#: apps/dp-business/src/pages/AddUser/index.tsx:272
#: apps/dp-business/src/components/PhoneVerification/index.tsx:87
#: apps/dp-business/src/components/PhoneVerification/index.tsx:93
#: apps/dp-business/src/components/PhoneVerification/index.tsx:114
#: apps/dp-business/src/components/PhoneInput/index.tsx:54
#: apps/dp-business/src/components/ForgotPassword/index.tsx:103
#: apps/dp-business/src/components/ForgotPassword/index.tsx:397
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:87
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:261
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:228
msgid "請輸入手機門號"
msgstr "請輸入手機門號"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:178
msgid "請輸入手機門號（09開頭）"
msgstr "請輸入手機門號（09開頭）"

#: apps/dp-business/src/pages/OrderList/index.tsx:845
msgid "請輸入手機門號/用戶ID/用戶信箱"
msgstr "請輸入手機門號/用戶ID/用戶信箱"

#: apps/dp-client/src/screens/login/pages/password-login/index.tsx:53
#: apps/dp-client/src/screens/login/pages/password-login/index.tsx:142
#: apps/dp-client/src/screens/login/pages/password-login/components/password-login-form/index.tsx:72
#: apps/dp-client/src/screens/login/pages/login/index.tsx:204
#: apps/dp-client/src/screens/login/pages/login/index.tsx:373
#: apps/dp-client/src/screens/login/pages/login/components/login-form/index.tsx:63
msgid "請輸入手機門號或Email"
msgstr "請輸入手機門號或Email"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:184
msgid "請輸入手續費比例"
msgstr "請輸入手續費比例"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:139
msgid "請輸入折扣上限"
msgstr "請輸入折扣上限"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:287
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:291
#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:159
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/hooks.ts:225
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:525
#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:147
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:539
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:545
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:429
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:435
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:327
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:328
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:544
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:550
msgid "請輸入拒絕原因"
msgstr "請輸入拒絕原因"

#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:332
msgid "請輸入拒絕原因..."
msgstr "請輸入拒絕原因..."

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:134
msgid "請輸入按鈕功能描述"
msgstr "請輸入按鈕功能描述"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:113
msgid "請輸入按鈕名稱"
msgstr "請輸入按鈕名稱"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:525
msgid "請輸入按鈕文字"
msgstr "請輸入按鈕文字"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:119
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:127
msgid "請輸入排序數字"
msgstr "請輸入排序數字"

#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:92
msgid "請輸入排序順序"
msgstr "請輸入排序順序"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:710
msgid "請輸入接收郵箱地址"
msgstr "請輸入收件地址"

#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:75
msgid "請輸入推薦碼"
msgstr "請輸入推薦碼"

#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:88
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:135
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:354
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:611
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:85
msgid "請輸入描述"
msgstr "請輸入描述"

#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:219
msgid "請輸入提交人"
msgstr "請輸入提交人"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:197
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:174
msgid "請輸入搜尋關鍵字, 支援商家ID/商家名稱/商家標籤/統一編碼"
msgstr "請輸入搜尋關鍵字, 支援商家ID/商家名稱/商家標籤/統一編碼"

#: apps/dp-client/src/screens/account/pages/likes/components/ReviewContent/index.tsx:198
#: apps/dp-client/src/screens/account/pages/likes/components/NotesContent/index.tsx:153
#: apps/dp-client/src/screens/account/pages/likes/components/NotesContent/index.tsx:156
msgid "請輸入搜尋關鍵詞"
msgstr "請輸入搜尋關鍵詞"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:75
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:80
msgid "請輸入搜索關鍵詞"
msgstr "請輸入搜索關鍵詞"

#: apps/dp-business/src/pages/MenuManagement.tsx:1254
msgid "請輸入搜索餐點名稱"
msgstr "請輸入搜索餐點名稱"

#: apps/dp-business/src/pages/MenuManagement.tsx:1179
msgid "請輸入搜索餐點類別"
msgstr "請輸入搜索餐點類別"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:401
msgid "請輸入搜索餐點類別/餐點名稱"
msgstr "請輸入搜索餐點類別/餐點名稱"

#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:830
msgid "請輸入撤銷原因"
msgstr "請輸入撤銷原因"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:38
msgid "請輸入支付訂單ID"
msgstr "請輸入支付訂單ID"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:270
msgid "請輸入收取次數"
msgstr "請輸入收取次數"

#: apps/dp-admin/src/pages/merchant/brand-list/components/EnableBrandModal/index.web.tsx:86
msgid "請輸入啟用原因"
msgstr "請輸入啟用原因"

#: apps/dp-admin/src/pages/merchant/brand-list/components/EnableBrandModal/index.web.tsx:95
msgid "請輸入啟用原因，將寫入操作歷史"
msgstr "請輸入啟用原因，將寫入操作歷史"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:160
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:723
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:858
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2236
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2288
msgid "請輸入數量"
msgstr "請輸入數量"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:90
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:92
msgid "請輸入文字"
msgstr "請輸入文字"

#: apps/dp-business/src/components/EmailVerification/index.tsx:90
msgid "請輸入新Email"
msgstr "請輸入新Email"

#: apps/dp-business/src/pages/ChangePassword/index.tsx:236
#: apps/dp-business/src/components/SetPassword/index.tsx:219
#: apps/dp-business/src/components/SetPassword/index.tsx:223
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:360
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:365
msgid "請輸入新密碼"
msgstr "請輸入新密碼"

#: apps/dp-business/src/components/PhoneVerification/index.tsx:91
msgid "請輸入新手機門號"
msgstr "請輸入新手機門號"

#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:66
msgid "請輸入暱稱、ID、手機門號"
msgstr "請輸入暱稱、ID、手機門號"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:171
msgid "請輸入更新人"
msgstr "請輸入更新人"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:663
msgid "請輸入有效天數"
msgstr "請輸入有效天數"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:264
msgid "請輸入有效天數(1-85)"
msgstr "請輸入有效天數(1-85)"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:182
msgid "請輸入有效期"
msgstr "請輸入有效期"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:548
msgid "請輸入有效的 https:// 或 qnc:// 鏈接"
msgstr "請輸入有效的 https:// 或 qnc:// 鏈接"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:496
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:514
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:528
msgid "請輸入有效的Email地址"
msgstr "請輸入有效的Email地址"

#: apps/dp-business/src/utils/validation.ts:81
#: apps/dp-business/src/utils/validation.ts:332
msgid "請輸入有效的Email地址格式"
msgstr "請輸入有效的Email地址格式"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:321
msgid "請輸入有效的價格（0或正整數）"
msgstr "請輸入有效的價格（0或正整數）"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/AddShopModal/index.web.tsx:32
msgid "請輸入有效的店家數據"
msgstr "請輸入有效的店家數據"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:207
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:326
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:355
msgid "請輸入有效的庫存數量"
msgstr "請輸入有效的庫存數量"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:549
msgid "請輸入有效的手機號"
msgstr "請輸入有效的手機號"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/BusinessOwnerForm/index.web.tsx:96
msgid "請輸入有效的手機號碼"
msgstr "請輸入有效的手機號碼"

#: apps/dp-client/src/screens/home/pages/Search/index.tsx:395
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:376
msgid "請輸入有效的搜尋關鍵詞"
msgstr "請輸入有效的搜尋關鍵詞"

#: apps/dp-business/src/pages/MenuItemForm.tsx:266
msgid "請輸入有效的整數價格"
msgstr "請輸入有效的整數價格"

#: apps/dp-client/src/screens/home/utils/filterData.ts:28
#: apps/dp-client/src/screens/home/utils/filterData.ts:35
#: apps/dp-business/src/utils/validation.ts:159
#: apps/dp-business/src/utils/validation.ts:187
#: apps/dp-business/src/utils/validation.ts:193
#: apps/dp-business/src/utils/validation.ts:349
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:127
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:133
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:171
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:104
msgid "請輸入有效的數字"
msgstr "請輸入有效的數字"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:250
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:581
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:607
msgid "請輸入有效的每人每日購買限制數量"
msgstr "請輸入有效的每人每日購買限制數量"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:228
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:417
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:441
msgid "請輸入有效的每日庫存數量"
msgstr "請輸入有效的每日庫存數量"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:308
msgid "請輸入有效的臺灣聯絡電話："
msgstr "請輸入有效的臺灣聯絡電話："

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:239
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:495
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageDistributionCard.tsx:520
msgid "請輸入有效的購買限制數量"
msgstr "請輸入有效的購買限制數量"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:114
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:353
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/ContactInfo/index.web.tsx:49
msgid "請輸入有效的電子信箱"
msgstr "請輸入有效的電子信箱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:41
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:56
msgid "請輸入有效的電子郵箱"
msgstr "請輸入有效的電子郵箱"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:592
msgid "請輸入有效的電話號碼"
msgstr "請輸入有效的電話號碼"

#: apps/dp-business/src/pages/ServiceFacilities/AddCustomService.tsx:40
msgid "請輸入服務設施名稱"
msgstr "請輸入服務設施名稱"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:222
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:144
msgid "請輸入服務費率"
msgstr "請輸入服務費率"

#: apps/dp-admin/src/pages/merchant/components/ActionButtons/index.web.tsx:70
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:438
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:450
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/components/PoiActionButtons/index.web.tsx:58
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/components/PoiActionButtons/index.web.tsx:116
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:107
msgid "請輸入未通過原因"
msgstr "請輸入未通過原因"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:659
msgid "請輸入核准設立日期"
msgstr "請輸入核准設立日期"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:116
msgid "請輸入核銷地址"
msgstr "請輸入核銷地址"

#: apps/dp-business/src/pages/TableManagement/index.tsx:559
#: apps/dp-business/src/pages/TableManagement/index.tsx:614
#: apps/dp-business/src/pages/TableManagement/index.tsx:737
#: apps/dp-business/src/pages/TableManagement/index.tsx:792
msgid "請輸入桌位名稱"
msgstr "請輸入桌位名稱"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:44
msgid "請輸入業務訂單號"
msgstr "請輸入業務訂單號"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:282
msgid "請輸入概率"
msgstr "請輸入機率"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/searchConfig.ts:23
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:403
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:405
msgid "請輸入榜單名稱"
msgstr "請輸入榜單名稱"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/shopConfig.web.tsx:19
msgid "請輸入樓層"
msgstr "請輸入樓層"

#: apps/dp-admin/src/pages/merchant/components/TagEditor/index.web.tsx:89
msgid "請輸入標籤名稱"
msgstr "請輸入標籤名稱"

#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:327
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:107
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:96
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:99
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:143
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:36
msgid "請輸入標題"
msgstr "請輸入標題"

#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:43
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:38
msgid "請輸入模板代碼"
msgstr "請輸入模板代碼"

#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:49
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:147
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:150
#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:23
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:41
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:66
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:99
msgid "請輸入模板名稱"
msgstr "請輸入模板名稱"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:236
msgid "請輸入模板名稱以生成模板編碼"
msgstr "請輸入模板名稱以生成模板編碼"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepTemplate.web.tsx:174
msgid "請輸入模板名稱搜尋"
msgstr "請輸入模板名稱搜尋"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:224
msgid "請輸入模板描述"
msgstr "請輸入模板描述"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:343
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:350
msgid "請輸入模板數"
msgstr "請輸入模板數"

#: apps/dp-admin/src/components/Benefit/BenefitSelector/index.web.tsx:223
msgid "請輸入權益 ID、編碼或名稱搜尋"
msgstr "請輸入權益 ID、編碼或名稱搜尋"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:74
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:99
msgid "請輸入權益名稱"
msgstr "請輸入權益名稱"

#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:150
#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:435
msgid "請輸入權益名稱以生成權益編碼"
msgstr "請輸入權益名稱以生成權益編碼"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:68
msgid "請輸入權益編碼"
msgstr "請輸入權益編碼"

#: apps/dp-admin/src/pages/users/permissions/components/ButtonPermissionConfigForm/index.web.tsx:122
msgid "請輸入權限編碼"
msgstr "請輸入權限編碼"

#: apps/dp-client/src/screens/home/utils/filterData.ts:90
#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:70
msgid "請輸入正整數"
msgstr "請輸入正整數"

#: apps/dp-client/src/screens/account/pages/account-security/email/email-old/index.tsx:39
#: apps/dp-client/src/screens/account/pages/account-security/email/bind-email/index.tsx:39
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:90
#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:105
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:169
msgid "請輸入正確的信箱格式"
msgstr "請輸入正確的信箱格式"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:415
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:257
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:404
msgid "請輸入正確的手機門號"
msgstr "請輸入正確的手機門號"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:493
msgid "請輸入正確的聯繫方式格式"
msgstr "請輸入正確的聯繫方式格式"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:174
msgid "請輸入正確的郵箱格式"
msgstr "請輸入正確的郵箱格式"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:427
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:444
msgid "請輸入正確的電子郵件地址"
msgstr "請輸入正確的電子郵件地址"

#. placeholder {0}: formatExamples.join('、')
#: apps/dp-business/src/utils/phoneValidation.ts:90
#: apps/dp-admin/src/utils/validation.ts:103
msgid "請輸入正確的電話號碼格式。正確格式為：{0}"
msgstr "請輸入正確的電話號碼格式。正確格式為：{0}"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:375
msgid "請輸入此步驟的到店說明"
msgstr "請輸入此步驟的到店說明"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:262
msgid "請輸入每小時費用"
msgstr "請輸入每小時費用"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:142
msgid "請輸入每日庫存數量"
msgstr "請輸入每日庫存數量"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:252
msgid "請輸入每日購買限制數量"
msgstr "請輸入每日購買限制數量"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:672
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:61
msgid "請輸入法人實收資本額"
msgstr "請輸入法人實收資本額"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:667
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:56
msgid "請輸入法人登記地址"
msgstr "請輸入法人登記地址"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityNoticeField/index.web.tsx:30
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityNoticeField/index.web.tsx:33
msgid "請輸入注意事項"
msgstr "請輸入注意事項"

#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:59
#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:29
msgid "請輸入活動ID"
msgstr "請輸入活動ID"

#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:50
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:53
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:26
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:33
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:38
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:194
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:130
#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:23
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:79
msgid "請輸入活動名稱"
msgstr "請輸入活動名稱"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:193
msgid "請輸入活動名稱，80個字符以內"
msgstr "請輸入活動名稱，80個字符以內"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/searchConfig.ts:14
msgid "請輸入活動名稱或編號"
msgstr "請輸入活動名稱或編號"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:134
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:241
msgid "請輸入活動描述"
msgstr "請輸入活動描述"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:207
msgid "請輸入活動描述，200個字符以內"
msgstr "請輸入活動描述，200個字符以內"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:138
msgid "請輸入活動規則"
msgstr "請輸入活動規則"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:229
msgid "請輸入活動規則，{MAX_TEXT_LENGTH}個字符以內，支持富文本格式"
msgstr "請輸入活動規則，{MAX_TEXT_LENGTH}個字符以內，支持富文本格式"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConsumeConfigEditor/index.web.tsx:78
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:52
msgid "請輸入消耗的積分值"
msgstr "請輸入消耗的積分值"

#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:77
msgid "請輸入渠道代碼"
msgstr "請輸入渠道代碼"

#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:60
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:268
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:274
msgid "請輸入渠道名稱"
msgstr "請輸入渠道名稱"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:297
msgid "請輸入渠道外部代碼"
msgstr "請輸入渠道外部代碼"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:282
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:289
msgid "請輸入渠道描述"
msgstr "請輸入渠道描述"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:678
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:225
msgid "請輸入營登地址"
msgstr "請輸入營登地址"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:676
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:206
msgid "請輸入營登資訊"
msgstr "請輸入營登資訊"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:40
msgid "請輸入爭議款信箱"
msgstr "請輸入爭議款信箱"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:565
msgid "請輸入版本內容"
msgstr "請輸入版本內容"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:549
msgid "請輸入版本號"
msgstr "請輸入版本號"

#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:417
msgid "請輸入特殊日期名稱"
msgstr "請輸入特殊日期名稱"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/PromotionTab/index.web.tsx:84
msgid "請輸入特色標籤，不超過6字"
msgstr "請輸入特色標籤，不超過6字"

#: apps/dp-business/src/pages/RefundList/index.tsx:375
#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:491
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:185
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:54
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:33
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:128
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:116
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:626
msgid "請輸入用戶ID"
msgstr "請輸入用戶ID"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:243
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:171
msgid "請輸入用戶ID（9位）"
msgstr "請輸入用戶ID（9位）"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:225
msgid "請輸入用戶ID（選填）"
msgstr "請輸入用戶ID（選填）"

#: apps/dp-admin/src/pages/marketing/user-group-detail/services/searchConfig.ts:16
msgid "請輸入用戶ID/用戶名/手機號/遠傳UID"
msgstr "請輸入用戶ID/用戶名/手機號/遠傳UID"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:112
#: apps/dp-admin/src/pages/login/components/LoginForm/index.web.tsx:58
msgid "請輸入用戶名"
msgstr "請輸入用戶名"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:25
msgid "請輸入用戶名單ID"
msgstr "請輸入用戶名單ID"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:89
#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:92
msgid "請輸入用戶名單名稱"
msgstr "請輸入用戶名單名稱"

#: apps/dp-admin/src/pages/marketing/user-group-create/index.web.tsx:105
msgid "請輸入用戶名單描述"
msgstr "請輸入用戶名單描述"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:283
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:32
msgid "請輸入用戶名稱"
msgstr "請輸入用戶名稱"

#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:60
msgid "請輸入用戶手機"
msgstr "請輸入用戶手機"

#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:137
msgid "請輸入用戶手機號"
msgstr "請輸入用戶手機號"

#: apps/dp-business/src/pages/RefundList/index.tsx:388
msgid "請輸入用戶手機門號"
msgstr "請輸入用戶手機門號"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:252
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:27
msgid "請輸入用戶暱稱"
msgstr "請輸入用戶暱稱"

#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:261
msgid "請輸入用戶行動電話"
msgstr "請輸入用戶行動電話"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:192
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:268
msgid "請輸入用戶郵箱"
msgstr "請輸入用戶郵箱"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:246
msgid "請輸入用餐人數"
msgstr "請輸入用餐人數"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:239
msgid "請輸入申請原因"
msgstr "請輸入申請原因"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:323
msgid "請輸入登入及接收密碼用 Email"
msgstr "請輸入登入及接收密碼用 Email"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:344
msgid "請輸入登入及接收密碼用手機門號"
msgstr "請輸入登入及接收密碼用手機門號"

#: apps/dp-business/src/components/ForgotPassword/index.tsx:135
#: apps/dp-business/src/components/ForgotPassword/index.tsx:394
msgid "請輸入登入帳號"
msgstr "請輸入登入帳號"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:123
#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:146
msgid "請輸入登錄密碼"
msgstr "請輸入登錄密碼"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:222
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:234
msgid "請輸入發放份數"
msgstr "請輸入發放份數"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:342
msgid "請輸入發放數量"
msgstr "請輸入發放數量"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:32
msgid "請輸入發票ID"
msgstr "請輸入發票ID"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:74
msgid "請輸入發票抬頭名稱"
msgstr "請輸入發票抬頭名稱"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:157
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:80
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:459
#: apps/dp-admin/src/pages/split-account/claim-detail/services/hooks.ts:213
msgid "請輸入發票號碼"
msgstr "請輸入發票號碼"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:618
msgid "請輸入發證地"
msgstr "請輸入發證地"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:607
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:52
msgid "請輸入發證日期"
msgstr "請輸入發證日期"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:58
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:138
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:595
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:597
msgid "請輸入百貨名稱"
msgstr "請輸入百貨名稱"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:348
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:351
msgid "請輸入目前密碼"
msgstr "請輸入目前密碼"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:239
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:194
msgid "請輸入票券名稱"
msgstr "請輸入票券名稱"

#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:94
msgid "請輸入禁用原因"
msgstr "請輸入禁用原因"

#: apps/dp-admin/src/pages/merchant/brand-list/components/DisableBrandModal/index.web.tsx:103
msgid "請輸入禁用原因，將寫入操作歷史"
msgstr "請輸入禁用原因，將寫入操作歷史"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/InAppTemplateSection.web.tsx:27
msgid "請輸入站內信內容"
msgstr "請輸入站內信內容"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/InAppTemplateSection.web.tsx:18
msgid "請輸入站內信標題"
msgstr "請輸入站內信標題"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:93
msgid "請輸入第三方公司/廠商名稱"
msgstr "請輸入第三方公司/廠商名稱"

#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:25
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:89
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:91
msgid "請輸入節假日名稱"
msgstr "請輸入節假日名稱"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeSearchForm/index.web.tsx:38
msgid "請輸入節點名稱"
msgstr "請輸入節點名稱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:495
msgid "請輸入管理人Email"
msgstr "請輸入管理人Email"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:542
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:256
msgid "請輸入管理人中文姓名"
msgstr "請輸入管理人中文姓名"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:545
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:276
msgid "請輸入管理人手機號"
msgstr "請輸入管理人手機號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:295
msgid "請輸入管理人英文名"
msgstr "請輸入管理人英文名"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:68
msgid "請輸入管理者信箱或手機"
msgstr "請輸入管理者信箱或手機"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:67
msgid "請輸入管理者姓名"
msgstr "請輸入管理者姓名"

#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:68
msgid "請輸入系統編號"
msgstr "請輸入系統編號"

#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:25
msgid "請輸入結算單號"
msgstr "請輸入結算單號"

#: apps/dp-business/src/utils/validation.ts:94
#: apps/dp-business/src/utils/validation.ts:336
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:112
msgid "請輸入統一編碼"
msgstr "請輸入統一編碼"

#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:438
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:314
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:75
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/CompanyRegistration/index.web.tsx:64
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:219
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:153
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/EnterpriseInfoSection.web.tsx:64
msgid "請輸入統一編號"
msgstr "請輸入統一編號"

#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:308
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:85
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:243
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:647
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:719
msgid "請輸入經度"
msgstr "請輸入經度"

#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:246
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:369
msgid "請輸入經緯度"
msgstr "請輸入經緯度"

#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:321
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:86
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:252
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:654
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:732
msgid "請輸入緯度"
msgstr "請輸入緯度"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:88
msgid "請輸入總庫存數量"
msgstr "請輸入總庫存數量"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreName/index.web.tsx:35
msgid "請輸入聚流店家名稱"
msgstr "請輸入聚流店家名稱"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:223
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:228
msgid "請輸入聯想詞標題"
msgstr "請輸入聯想詞標題"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:353
msgid "請輸入聯絡地址之郵遞區號三碼"
msgstr "請輸入聯絡地址之郵遞區號三碼"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:113
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/ContactInfo/index.web.tsx:48
msgid "請輸入聯絡者信箱"
msgstr "請輸入聯絡者信箱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:80
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/ContactInfo/index.web.tsx:34
msgid "請輸入聯絡者姓名"
msgstr "請輸入聯絡者姓名"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:129
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/ContactInfo/index.web.tsx:63
msgid "請輸入聯絡者手機"
msgstr "請輸入聯絡者手機"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:95
msgid "請輸入聯絡者英文姓名"
msgstr "請輸入聯絡者英文姓名"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:77
msgid "請輸入聯絡電話"
msgstr "請輸入聯絡電話"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:232
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:486
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:142
msgid "請輸入聯繫方式"
msgstr "請輸入聯繫方式"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:122
msgid "請輸入聯繫郵箱"
msgstr "請輸入聯繫郵箱"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:129
msgid "請輸入聯繫電話"
msgstr "請輸入聯繫電話"

#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:151
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:237
msgid "請輸入臨時使用者名稱"
msgstr "請輸入臨時使用者名稱"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:696
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:1057
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:273
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:648
#: apps/dp-admin/src/components/BusinessHours/components/BusinessStatusSelector.web.tsx:338
msgid "請輸入自定義時段名稱"
msgstr "請輸入自定義時段名稱"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:848
msgid "請輸入自定義類目"
msgstr "請輸入自定義類別"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:162
msgid "請輸入臺灣手機號碼（如：0912345678）"
msgstr "請輸入臺灣手機號碼（如：0912345678）"

#: apps/dp-admin/src/components/DraftActions/index.web.tsx:177
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:233
msgid "請輸入草稿名稱"
msgstr "請輸入草稿名稱"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:138
msgid "請輸入菜單標題"
msgstr "請輸入菜單標題"

#: apps/dp-admin/src/components/LandingPage/LandingPageSelector/index.web.tsx:256
msgid "請輸入落地頁名稱搜尋"
msgstr "請輸入落地頁名稱搜尋"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:587
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:41
msgid "請輸入藍新帳號"
msgstr "請輸入藍新帳號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreName/index.web.tsx:52
msgid "請輸入藍新店家名稱"
msgstr "請輸入藍新店家名稱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreName/index.web.tsx:62
msgid "請輸入藍新店家英文名稱"
msgstr "請輸入藍新店家英文名稱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:78
msgid "請輸入藍新登入帳號"
msgstr "請輸入藍新登入帳號"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:127
msgid "請輸入處理備註"
msgstr "請輸入處理備註"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticCorporate/index.web.tsx:49
msgid "請輸入西元年月日如 20220405"
msgstr "請輸入西元年月日如 20220405"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:285
#: apps/dp-business/src/pages/AddRole/index.tsx:237
#: apps/dp-business/src/pages/AddRole/index.tsx:398
#: apps/dp-admin/src/pages/users/roles/components/RoleForm/index.web.tsx:72
#: apps/dp-admin/src/pages/users/roles/components/RoleForm/index.web.tsx:74
msgid "請輸入角色名稱"
msgstr "請輸入角色名稱"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:202
msgid "請輸入角色名稱，最長 128 字"
msgstr "請輸入角色名稱，最長 128 字"

#: apps/dp-admin/src/pages/users/roles/components/RoleToolbar/index.web.tsx:69
msgid "請輸入角色名稱或權限名稱"
msgstr "請輸入角色名稱或權限名稱"

#: apps/dp-admin/src/pages/users/roles/components/RoleForm/index.web.tsx:102
msgid "請輸入角色描述（選填，不超過200個字元）"
msgstr "請輸入角色描述（選填，不超過200個字元）"

#: apps/dp-admin/src/pages/users/roles/components/RoleForm/index.web.tsx:79
#: apps/dp-admin/src/pages/users/roles/components/RoleForm/index.web.tsx:81
msgid "請輸入角色編碼"
msgstr "請輸入角色編碼"

#: apps/dp-business/src/pages/OrderList/index.tsx:834
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1312
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:120
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:45
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:21
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:48
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:53
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:119
msgid "請輸入訂單ID"
msgstr "請輸入訂單ID"

#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:42
msgid "請輸入訂單ID、用戶名、手機號或店家名稱"
msgstr "請輸入訂單ID、用戶名、手機號或店家名稱"

#: apps/dp-business/src/pages/RefundList/index.tsx:362
msgid "請輸入訂單編號"
msgstr "請輸入訂單編號"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:263
msgid "請輸入設定說明（可選）"
msgstr "請輸入設定說明（可選）"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:199
msgid "請輸入評論內容"
msgstr "請輸入評論內容"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:251
#: apps/dp-business/src/pages/AddressEdit/index.tsx:464
#: apps/dp-business/src/pages/AddressEdit/index.tsx:693
#: apps/dp-business/src/pages/AddStore/index.tsx:369
#: apps/dp-business/src/pages/AddStore/index.tsx:1143
#: apps/dp-business/src/pages/AddStore/index.tsx:1423
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:106
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:181
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:291
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:365
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:285
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:287
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:97
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:232
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:235
msgid "請輸入詳細地址"
msgstr "請輸入詳細地址"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:654
msgid "請輸入詳細地址..."
msgstr "請輸入詳細地址..."

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityStepsField/index.web.tsx:63
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityStepsField/index.web.tsx:65
#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:163
msgid "請輸入說明文本"
msgstr "請輸入說明文本"

#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:64
msgid "請輸入調用服務"
msgstr "請輸入調用服務"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:460
#: apps/dp-admin/src/pages/merchant/components/identity-fields/PassportIdentityFields.web.tsx:86
msgid "請輸入護照效期"
msgstr "請輸入護照效期"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:445
#: apps/dp-admin/src/pages/merchant/components/identity-fields/PassportIdentityFields.web.tsx:43
msgid "請輸入護照號碼"
msgstr "請輸入護照號碼"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:195
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1149
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:94
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:632
msgid "請輸入變更原因"
msgstr "請輸入變更原因"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:237
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:173
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/RepresentativeSection.web.tsx:47
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/RepresentativeSection.web.tsx:51
msgid "請輸入負責人姓名"
msgstr "請輸入負責人姓名"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:64
msgid "請輸入負責人居留證號"
msgstr "請輸入負責人居留證號"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:874
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:249
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:186
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/RepresentativeSection.web.tsx:59
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/RepresentativeSection.web.tsx:74
msgid "請輸入負責人手機門號"
msgstr "請輸入負責人手機門號"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:66
msgid "請輸入負責人護照號碼"
msgstr "請輸入負責人護照號碼"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:62
msgid "請輸入負責人身份證號"
msgstr "請輸入負責人身份證號"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:164
msgid "請輸入負責人身分證"
msgstr "請輸入負責人身分證"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:574
msgid "請輸入負責人驗證碼"
msgstr "請輸入負責人驗證碼"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:815
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:826
msgid "請輸入費率"
msgstr "請輸入費率"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:197
msgid "請輸入購買限制數量"
msgstr "請輸入購買限制數量"

#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:291
msgid "請輸入距離"
msgstr "請輸入距離"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:191
#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:194
msgid "請輸入路由路徑"
msgstr "請輸入路由路徑"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:559
msgid "請輸入跳轉路徑"
msgstr "請輸入跳轉路徑"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:257
msgid "請輸入跳轉連接"
msgstr "請輸入跳轉連接"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:255
msgid "請輸入跳轉連接地址，例如：jeada://capp/store_detail?storeId=abc"
msgstr "請輸入跳轉連接地址，例如：jeada://capp/store_detail?storeId=abc"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:111
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:114
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:83
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:100
#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:80
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:542
msgid "請輸入跳轉鏈接"
msgstr "請輸入跳轉鏈接"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PosterListField/SortableRow.web.tsx:89
msgid "請輸入跳轉鏈接（選填）"
msgstr "請輸入跳轉鏈接（選填）"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:261
#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:283
msgid "請輸入跳過延遲"
msgstr "請輸入跳過延遲"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/hooks.ts:56
#: apps/dp-admin/src/pages/merchant/components/identity-fields/PersonalIdentityFields.web.tsx:36
#: apps/dp-admin/src/pages/merchant/components/identity-fields/DomesticIdentityFields.web.tsx:45
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/hooks.ts:65
#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:102
msgid "請輸入身份證字號"
msgstr "請輸入身份證字號"

#: apps/dp-business/src/utils/validation.ts:134
#: apps/dp-business/src/utils/validation.ts:344
msgid "請輸入身份證號碼"
msgstr "請輸入身份證號碼"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:62
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:171
msgid "請輸入身分證地址"
msgstr "請輸入身分證地址"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:292
msgid "請輸入身分證字號"
msgstr "請輸入身分證字號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:171
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:114
msgid "請輸入身分證發證日期"
msgstr "請輸入身分證發證日期"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:164
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:178
msgid "請輸入追加數量"
msgstr "請輸入追加數量"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:141
msgid "請輸入追蹤詳情，不超過2000字"
msgstr "請輸入追蹤詳情，不超過2000字"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:510
msgid "請輸入追蹤說明"
msgstr "請輸入追蹤說明"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:516
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:197
msgid "請輸入追蹤說明，不少於10個字，不超過9999個字"
msgstr "請輸入追蹤說明，不少於10個字，不超過9999個字"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:312
msgid "請輸入退款原因"
msgstr "請輸入退款原因"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:744
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1066
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:171
msgid "請輸入退款原因（選填）"
msgstr "請輸入退款原因（選填）"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:309
msgid "請輸入退款金額"
msgstr "請輸入退款金額"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:384
msgid "請輸入通知文案"
msgstr "請輸入通知文案"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:399
msgid "請輸入通知文案，最多{MAX_TEXT_LENGTH}個字"
msgstr "請輸入通知文案，最多{MAX_TEXT_LENGTH}個字"

#: apps/dp-admin/src/pages/merchant/components/ActionButtons/index.web.tsx:64
msgid "請輸入通過原因"
msgstr "請輸入通過原因"

#: apps/dp-admin/src/components/RichTextEditor/components/Toolbar.web.tsx:78
msgid "請輸入連結 URL"
msgstr "請輸入連結 URL"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:119
msgid "請輸入連結地址"
msgstr "請輸入連結地址"

#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:255
msgid "請輸入運營備注"
msgstr "請輸入運營備注"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:109
msgid "請輸入運營備注（選填）"
msgstr "請輸入運營備注（選填）"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:121
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:267
msgid "請輸入運營備註"
msgstr "請輸入運營備註"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:91
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:96
msgid "請輸入運營端標題"
msgstr "請輸入運營端標題"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:459
msgid "請輸入運營說明"
msgstr "請輸入運營說明"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:385
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:387
msgid "請輸入運輸公司"
msgstr "請輸入運輸公司"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:270
msgid "請輸入遠傳UID"
msgstr "請輸入遠傳UID"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:747
msgid "請輸入邊界範圍備註"
msgstr "請輸入邊界範圍備註"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/EmailTemplateSection.web.tsx:23
msgid "請輸入郵件內容"
msgstr "請輸入郵件內容"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:227
#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:231
msgid "請輸入郵箱"
msgstr "請輸入郵箱"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:573
msgid "請輸入郵編"
msgstr "請輸入郵編"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:94
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:169
msgid "請輸入郵遞區號"
msgstr "請輸入郵遞區號"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:32
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/searchConfig.ts:21
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:90
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:185
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:189
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:38
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:40
msgid "請輸入配置名稱"
msgstr "請輸入配置名稱"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:94
msgid "請輸入配置名稱(僅運營端展示)"
msgstr "請輸入配置名稱(僅運營端展示)"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/searchConfig.ts:18
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/SearchForm/index.web.tsx:33
msgid "請輸入配置名稱或標題"
msgstr "請輸入配置名稱或標題"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:592
msgid "請輸入金融機構代碼"
msgstr "請輸入金融機構代碼"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:115
msgid "請輸入金融機構帳戶之帳號"
msgstr "請輸入金融機構帳戶之帳號"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:224
msgid "請輸入金額"
msgstr "請輸入金額"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:93
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:97
msgid "請輸入銀行帳戶戶名"
msgstr "請輸入銀行帳戶戶名"

#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:62
msgid "請輸入關鍵字"
msgstr "請輸入關鍵字"

#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:198
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:232
msgid "請輸入關鍵詞"
msgstr "請輸入關鍵詞"

#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupShopList/index.web.tsx:86
msgid "請輸入關鍵詞搜尋"
msgstr "請輸入關鍵詞搜尋"

#: apps/dp-admin/src/components/SearchSelect/index.web.tsx:65
#: apps/dp-admin/src/components/InfiniteSearchSelect/index.web.tsx:52
msgid "請輸入關鍵詞搜尋..."
msgstr "請輸入關鍵詞搜尋..."

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:352
msgid "請輸入電子信箱"
msgstr "請輸入電子信箱"

#: apps/dp-admin/src/pages/login/components/LoginForm/index.web.tsx:53
msgid "請輸入電子信箱/手機門號"
msgstr "請輸入電子信箱/手機門號"

#: apps/dp-business/src/pages/Login/Email/index.tsx:217
msgid "請輸入電子信箱以登入/註冊"
msgstr "請輸入電子信箱以登入/註冊"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:809
msgid "請輸入電話"
msgstr "請輸入電話"

#: apps/dp-business/src/utils/phoneValidation.ts:21
#: apps/dp-business/src/pages/AddStore/index.tsx:1113
#: apps/dp-business/src/pages/AddStore/index.tsx:1494
#: apps/dp-admin/src/utils/validation.ts:30
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:207
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:209
msgid "請輸入電話號碼"
msgstr "請輸入電話號碼"

#. placeholder {0}: index + 1
#: apps/dp-admin/src/pages/merchant/shop-detail/components/PhoneEditor/index.web.tsx:67
msgid "請輸入電話號碼{0}"
msgstr "請輸入電話號碼{0}"

#: apps/dp-admin/src/utils/validation.ts:42
msgid "請輸入電話號碼主號"
msgstr "請輸入電話號碼主號"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:666
msgid "請輸入非負整數"
msgstr "請輸入非負整數"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:534
msgid "請輸入頁面名稱"
msgstr "請輸入頁面名稱"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:150
#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:159
msgid "請輸入頁面組件名稱"
msgstr "請輸入頁面組件名稱"

#: apps/dp-admin/src/pages/merchant/components/CategoryEditModal/index.web.tsx:70
#: apps/dp-admin/src/pages/merchant/components/CategoryEditModal/index.web.tsx:78
msgid "請輸入類別名稱"
msgstr "請輸入類別名稱"

#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:76
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:78
msgid "請輸入類型代碼"
msgstr "請輸入類型代碼"

#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:83
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:85
msgid "請輸入類型名稱"
msgstr "請輸入類型名稱"

#: apps/dp-business/src/utils/validation.ts:226
msgid "請輸入食品業者登記字號"
msgstr "請輸入食品業者登記字號"

#: apps/dp-business/src/pages/MenuItemForm.tsx:444
msgid "請輸入餐點價格（整數）"
msgstr "請輸入餐點價格（整數）"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:658
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:252
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:255
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:219
msgid "請輸入餐點分類"
msgstr "請輸入餐點分類"

#: apps/dp-business/src/pages/MenuItemForm.tsx:427
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:238
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:359
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:182
msgid "請輸入餐點名稱"
msgstr "請輸入餐點名稱"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:195
msgid "請輸入餐點描述"
msgstr "請輸入餐點描述"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:395
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:522
msgid "請輸入駁回原因"
msgstr "請輸入駁回原因"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:436
msgid "請輸入駁回原因："
msgstr "請輸入駁回原因："

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:318
#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:455
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:209
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:288
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:901
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:902
#: apps/dp-business/src/pages/Login/index.tsx:374
#: apps/dp-business/src/pages/Login/index.tsx:375
#: apps/dp-business/src/pages/Login/Email/index.tsx:63
#: apps/dp-business/src/pages/Login/Email/index.tsx:64
#: apps/dp-business/src/components/VerificationInput/index.tsx:109
#: apps/dp-business/src/components/PhoneVerification/index.tsx:89
#: apps/dp-business/src/components/PhoneVerification/index.tsx:134
#: apps/dp-business/src/components/PhoneVerification/index.tsx:135
#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:210
#: apps/dp-business/src/components/EmailVerification/index.tsx:88
#: apps/dp-business/src/components/EmailVerification/index.tsx:133
#: apps/dp-business/src/components/EmailVerification/index.tsx:134
#: apps/dp-business/src/components/CodeVerification/index.tsx:98
msgid "請輸入驗證碼"
msgstr "請輸入驗證碼"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1041
msgid "請選中可退款券碼"
msgstr "請選中可退款券碼"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:550
#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:387
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1416
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1448
#: apps/dp-business/src/components/Select.tsx:124
#: apps/dp-business/src/components/Select.tsx:403
#: apps/dp-business/src/components/CascadeSelector/index.tsx:104
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:208
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:150
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:114
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:41
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:109
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:684
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:710
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:537
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:74
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:89
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:126
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:141
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:159
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:172
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:186
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:58
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:70
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:84
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:125
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:137
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:152
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:165
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:45
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:68
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:85
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:54
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:71
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:82
#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:46
#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:69
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:196
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:212
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:228
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:245
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:235
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:140
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:160
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:168
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:118
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:128
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:48
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/SearchForm/index.web.tsx:39
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/SearchForm/index.web.tsx:47
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:52
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:65
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:261
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:86
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:142
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:89
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:234
#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:60
#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:76
#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:91
#: apps/dp-admin/src/pages/customer-service/components/AssignModal.web.tsx:100
msgid "請選擇"
msgstr "請選擇"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:48
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:339
msgid "請選擇 1-99 的整數"
msgstr "請選擇 1-99 的整數"

#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:59
#: apps/dp-admin/src/pages/org-tree/org-list/components/AssignBdModal/index.web.tsx:62
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:62
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:85
msgid "請選擇 BD"
msgstr "請選擇 BD"

#. placeholder {0}: assigneeLabel.replace(t`選擇`, '')
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:158
msgid "請選擇{0}"
msgstr "請選擇{0}"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:205
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:214
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:66
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:125
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:127
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:125
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:99
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:109
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:103
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:160
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:107
msgid "請選擇BD"
msgstr "請選擇BD"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:232
msgid "請選擇POI審核狀態"
msgstr "請選擇POI審核狀態"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:221
msgid "請選擇POI狀態"
msgstr "請選擇POI狀態"

#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:70
msgid "請選擇POI類型"
msgstr "請選擇POI類型"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/index.tsx:170
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/index.tsx:476
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/index.tsx:200
msgid "請選擇一個活動查看詳情"
msgstr "請選擇一個活動查看詳情"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:399
msgid "請選擇一級分類"
msgstr "請選擇一級分類"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:99
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:426
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:436
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:671
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:596
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:599
#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:703
msgid "請選擇一級品類"
msgstr "請選擇一級品類"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignLevel1Select/index.web.tsx:15
msgid "請選擇一級渠道"
msgstr "請選擇一級渠道"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:526
msgid "請選擇三級分類"
msgstr "請選擇三級分類"

#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:83
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:323
msgid "請選擇上下架狀態"
msgstr "請選擇上下架狀態"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:72
#: apps/dp-admin/src/pages/marketing/services/useGroupImportTemplate.ts:19
#: apps/dp-admin/src/pages/marketing/services/groupImport.ts:227
msgid "請選擇上傳參數"
msgstr "請選擇上傳參數"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:65
msgid "請選擇上榜狀態"
msgstr "請選擇上榜狀態"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:256
msgid "請選擇上級渠道"
msgstr "請選擇上級渠道"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:227
msgid "請選擇上級節點"
msgstr "請選擇上級節點"

#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:79
#: apps/dp-admin/src/pages/audit-center/content-review-audit/index.web.tsx:79
#: apps/dp-admin/src/pages/audit-center/components/UnpublishReasonForm/index.web.tsx:62
msgid "請選擇下架原因"
msgstr "請選擇下架原因"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:124
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:128
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:105
msgid "請選擇下次追蹤時間"
msgstr "請選擇下次追蹤時間"

#: apps/dp-client/src/screens/home/utils/utils.ts:336
msgid "請選擇不超過 {maxSizeMB}MB 的圖片。"
msgstr "請選擇不超過 {maxSizeMB}MB 的圖片。"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:80
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:209
msgid "請選擇中獎狀態"
msgstr "請選擇中獎狀態"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:45
#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:184
msgid "請選擇主標籤"
msgstr "請選擇主標籤"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:302
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:414
msgid "請選擇二級分類"
msgstr "請選擇二級分類"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:444
msgid "請選擇互斥組"
msgstr "請選擇互斥組"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:35
msgid "請選擇交易類型"
msgstr "請選擇交易類型"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/CorrectionModal.tsx:73
msgid "請選擇交通資訊類型"
msgstr "請選擇交通資訊類型"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:112
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/MemberTypeSection.web.tsx:54
msgid "請選擇代表人國籍"
msgstr "請選擇代表人國籍"

#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:116
msgid "請選擇任務優先級"
msgstr "請選擇任務優先級"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:258
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:261
msgid "請選擇任務分配人"
msgstr "請選擇任務分配人"

#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:102
msgid "請選擇任務狀態"
msgstr "請選擇任務狀態"

#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:129
msgid "請選擇任務類型"
msgstr "請選擇任務類型"

#: apps/dp-business/src/pages/MarketingCenter/components/StoreSelectionCard.tsx:201
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1387
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:1944
msgid "請選擇使用店家"
msgstr "請選擇使用店家"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:598
msgid "請選擇使用範圍"
msgstr "請選擇使用範圍"

#: apps/dp-business/src/pages/OrderList/index.tsx:897
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:83
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:86
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:239
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:133
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:96
msgid "請選擇來源"
msgstr "請選擇來源"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:461
#: apps/dp-admin/src/pages/marketing/activity-create/services/hooks.ts:210
msgid "請選擇保存方式"
msgstr "請選擇保存方式"

#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:36
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:96
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:99
msgid "請選擇假日類型"
msgstr "請選擇假日類型"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:336
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:72
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:270
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:273
msgid "請選擇優先級"
msgstr "請選擇優先級"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConsumeConfigEditor/index.web.tsx:37
msgid "請選擇兌換獲得權益"
msgstr "請選擇兌換獲得權益"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:107
msgid "請選擇兜底頁面"
msgstr "請選擇兜底頁面"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:247
msgid "請選擇入駐審核狀態"
msgstr "請選擇入駐審核狀態"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:233
msgid "請選擇入駐狀態"
msgstr "請選擇入駐狀態"

#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:125
msgid "請選擇內容類型"
msgstr "請選擇內容類型"

#: apps/dp-admin/src/pages/merchant/components/MetroStationExitSelector/index.web.tsx:54
#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:277
msgid "請選擇出入口"
msgstr "請選擇出入口"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:217
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:157
msgid "請選擇出生年月日"
msgstr "請選擇出生年月日"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:103
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:108
msgid "請選擇分行或支行"
msgstr "請選擇分行或支行"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:683
msgid "請選擇分配BD"
msgstr "請選擇分配BD"

#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:305
msgid "請選擇分配負責人"
msgstr "請選擇分配負責人"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:140
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:79
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:140
msgid "請選擇分類"
msgstr "請選擇分類"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponStatusModal.web.tsx:128
msgid "請選擇券狀態"
msgstr "請選擇券狀態"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:60
msgid "請選擇券組狀態"
msgstr "請選擇券組狀態"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/services/config.web.tsx:51
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:83
msgid "請選擇券組類型"
msgstr "請選擇券組類型"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:339
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:311
msgid "請選擇動作類型"
msgstr "請選擇動作類型"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:300
msgid "請選擇勿擾時間段"
msgstr "請選擇勿擾時間段"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:291
msgid "請選擇勿擾設置"
msgstr "請選擇勿擾設置"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:133
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:139
msgid "請選擇參與城市"
msgstr "請選擇參與城市"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageScopeSection/index.web.tsx:172
msgid "請選擇可使用該套餐券的店家"
msgstr "請選擇可使用該套餐券的店家"

#: apps/dp-admin/src/pages/audit-center/claim-audit/services/useClaimAuditActions.ts:113
msgid "請選擇可審核的請款單"
msgstr "請選擇可審核的請款單"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:546
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:408
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:422
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:437
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:95
msgid "請選擇合作意向"
msgstr "請選擇合作意向"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:550
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:866
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:455
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:434
msgid "請選擇合約類型"
msgstr "請選擇合約類型"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:43
msgid "請選擇名單狀態"
msgstr "請選擇名單狀態"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:75
#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:50
msgid "請選擇名單類型"
msgstr "請選擇名單類型"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:542
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:308
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:15
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:249
msgid "請選擇品牌"
msgstr "請選擇品牌"

#: apps/dp-admin/src/pages/merchant/brand-list/services/searchConfig.ts:28
msgid "請選擇品牌狀態"
msgstr "請選擇品牌狀態"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:505
msgid "請選擇品類"
msgstr "請選擇品類"

#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:61
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:129
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:717
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:740
msgid "請選擇品類來源"
msgstr "請選擇品類來源"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:172
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:180
msgid "請選擇商品類目"
msgstr "請選擇商品類目"

#: apps/dp-client/src/screens/diary/pages/note/index.tsx:168
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:163
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:243
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:169
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:111
msgid "請選擇商家"
msgstr "請選擇商家"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:139
#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:103
msgid "請選擇商家分類"
msgstr "請選擇商家分類"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:557
msgid "請選擇商家分類，支持多選"
msgstr "請選擇商家分類，支持多選"

#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:136
msgid "請選擇商家區域"
msgstr "請選擇商家區域"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepMerchantGroup.web.tsx:34
msgid "請選擇商家名單"
msgstr "請選擇商家名單"

#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:344
#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:360
msgid "請選擇商家和店家"
msgstr "請選擇商家和店家"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:630
msgid "請選擇商家標籤"
msgstr "請選擇商家標籤"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:299
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:231
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:190
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:207
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:509
#: apps/dp-admin/src/pages/marketing/activity-detail-list/services/config.web.tsx:205
msgid "請選擇商家狀態"
msgstr "請選擇商家狀態"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:494
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:305
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:587
msgid "請選擇商家等級"
msgstr "請選擇商家等級"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:62
msgid "請選擇商家組"
msgstr "請選擇商家組"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:460
msgid "請選擇商家選擇方式"
msgstr "請選擇商家選擇方式"

#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:301
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:383
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:339
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:342
#: apps/dp-admin/src/pages/merchant/components/CategoryCascader/index.web.tsx:34
msgid "請選擇商家類目"
msgstr "請選擇商家類目"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:112
msgid "請選擇問題分類"
msgstr "請選擇問題分類"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:158
msgid "請選擇問題原因"
msgstr "請選擇問題原因"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:336
msgid "請選擇問題原因並詳細說明未通過原因，以便商家瞭解問題並進行修改。"
msgstr "請選擇問題原因並詳細說明未通過原因，以便商家瞭解問題並進行修改。"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:275
#: apps/dp-client/src/components/FeedBackModal/index.tsx:51
#: apps/dp-client/src/components/FeedBackModal/index.tsx:139
msgid "請選擇問題類型"
msgstr "請選擇問題類型"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:140
msgid "請選擇回傳狀態"
msgstr "請選擇回傳狀態"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/searchConfig.ts:40
msgid "請選擇圈選方式"
msgstr "請選擇圈選方式"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:200
#: apps/dp-client/src/screens/diary/pages/my/components/RNCropPhoto/CropPhoto.tsx:271
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:132
msgid "請選擇圖片檔案"
msgstr "請選擇圖片檔案"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:626
msgid "請選擇地區"
msgstr "請選擇地區"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:490
msgid "請選擇地域，支持多選"
msgstr "請選擇地域，支持多選"

#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:154
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:353
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:281
msgid "請選擇城市"
msgstr "請選擇城市"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:126
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:88
msgid "請選擇城市/區域"
msgstr "請選擇城市/區域"

#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:297
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:357
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:361
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:219
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:223
msgid "請選擇城市區域"
msgstr "請選擇城市區域"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:629
#: apps/dp-business/src/pages/AddStore/index.tsx:1402
#: apps/dp-business/src/components/CityDistrictCascadeSelector/index.tsx:63
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:273
#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:276
#: apps/dp-admin/src/pages/merchant/components/CityDistrictSelector/index.web.tsx:57
msgid "請選擇城市和區域"
msgstr "請選擇城市和區域"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/AddressSelector/index.web.tsx:197
msgid "請選擇城市和行政區"
msgstr "請選擇城市和行政區"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:412
#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:127
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:202
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:205
msgid "請選擇報修類型"
msgstr "請選擇報修類型"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:153
msgid "請選擇報名時間"
msgstr "請選擇報名時間"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:174
msgid "請選擇套餐，或勾選全部套餐"
msgstr "請選擇套餐，或勾選全部套餐"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:62
#: apps/dp-admin/src/pages/marketing/components/OrderListSection/index.web.tsx:144
msgid "請選擇套餐券"
msgstr "請選擇套餐券"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:283
msgid "請選擇套餐券服務"
msgstr "請選擇套餐券服務"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:116
msgid "請選擇套餐券的創建端"
msgstr "請選擇套餐券的創建端"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:90
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:101
msgid "請選擇子類型"
msgstr "請選擇子類型"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:95
msgid "請選擇完整的時間範圍"
msgstr "請選擇完整的時間範圍"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:210
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:214
msgid "請選擇客戶類型"
msgstr "請選擇客戶類型"

#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:250
msgid "請選擇客服"
msgstr "請選擇客服"

#: apps/dp-admin/src/pages/customer-service/components/AssignModal.web.tsx:97
msgid "請選擇客服人員"
msgstr "請選擇客服人員"

#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/index.web.tsx:314
msgid "請選擇審核分類"
msgstr "請選擇審核分類"

#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:72
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:97
#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:148
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:40
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:81
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:70
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:69
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:60
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:69
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:43
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:53
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:106
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:65
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:193
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:51
msgid "請選擇審核狀態"
msgstr "請選擇審核狀態"

#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:60
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:122
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:89
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:88
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:89
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:63
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:73
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:128
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:85
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:281
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:71
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:190
msgid "請選擇審核者"
msgstr "請選擇審核者"

#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:86
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:179
msgid "請選擇審核類型"
msgstr "請選擇審核類型"

#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:114
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:107
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:113
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:205
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:208
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:648
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:797
msgid "請選擇展示位置"
msgstr "請選擇展示位置"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:259
msgid "請選擇展示日期範圍"
msgstr "請選擇展示日期範圍"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:52
msgid "請選擇展示時間"
msgstr "請選擇展示時間"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:292
msgid "請選擇展示時間範圍"
msgstr "請選擇展示時間範圍"

#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:161
#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:212
msgid "請選擇左側節點"
msgstr "請選擇左側節點"

#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:393
#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:345
msgid "請選擇左側節點查看詳情"
msgstr "請選擇左側節點查看詳情"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:134
msgid "請選擇帳戶之金融機構代碼"
msgstr "請選擇帳戶之金融機構代碼"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:288
msgid "請選擇帳號狀態"
msgstr "請選擇帳號狀態"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:534
msgid "請選擇平台"
msgstr "請選擇平台"

#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:55
msgid "請選擇平台 / 發送類型 / 業務模塊"
msgstr "請選擇平台 / 發送類型 / 業務模塊"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:360
msgid "請選擇平台活動"
msgstr "請選擇平台活動"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:168
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:171
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:22
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:129
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:166
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:169
msgid "請選擇平台類型"
msgstr "請選擇平台類型"

#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:43
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:107
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:112
msgid "請選擇年份"
msgstr "請選擇年份"

#: apps/dp-business/src/pages/AddStore/index.tsx:374
#: apps/dp-business/src/pages/AddStore/index.tsx:1103
#: apps/dp-business/src/components/StoreSelector/index.tsx:512
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionRenderer.web.tsx:249
msgid "請選擇店家"
msgstr "請選擇店家"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:235
#: apps/dp-business/src/pages/AddStore/index.tsx:379
#: apps/dp-business/src/pages/AddStore/index.tsx:1127
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:244
msgid "請選擇店家分類"
msgstr "請選擇店家分類"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:133
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PackageSourceField/index.web.tsx:58
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/MerchantGroupCouponField/index.web.tsx:93
msgid "請選擇店家名單（可多選）"
msgstr "請選擇店家名單（可多選）"

#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:386
msgid "請選擇店家後配置 POS 關聯資訊"
msgstr "請選擇店家後配置 POS 關聯資訊"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:313
msgid "請選擇店家所在地"
msgstr "請選擇店家所在地"

#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:282
msgid "請選擇店家提供的服務設施"
msgstr "請選擇店家提供的服務設施"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:474
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:432
msgid "請選擇店家標籤"
msgstr "請選擇店家標籤"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:411
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:242
msgid "請選擇店家營業狀態"
msgstr "請選擇店家營業狀態"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:526
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:378
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:388
msgid "請選擇店家狀態"
msgstr "請選擇店家狀態"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:550
msgid "請選擇店家等級"
msgstr "請選擇店家等級"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/DynamicConditionField/index.web.tsx:93
msgid "請選擇店家組或篩選條件"
msgstr "請選擇店家組或篩選條件"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:137
msgid "請選擇店家跟進BD"
msgstr "請選擇店家跟進BD"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:329
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:257
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:271
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/PoiTab/index.web.tsx:247
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:318
msgid "請選擇店家類別"
msgstr "請選擇店家類別"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:513
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:516
msgid "請選擇店家類目"
msgstr "請選擇店家類目"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:181
msgid "請選擇座位類型"
msgstr "請選擇座位類型"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:219
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:371
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:197
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:152
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:341
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:230
msgid "請選擇延期日期"
msgstr "請選擇延期日期"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:200
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:353
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:132
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:322
msgid "請選擇延期至的日期（含當日）："
msgstr "請選擇延期至的日期（含當日）："

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:166
msgid "請選擇循環週期"
msgstr "請選擇循環週期"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:25
#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:40
#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:575
msgid "請選擇您的評分"
msgstr "請選擇您的評分"

#: apps/dp-client/src/components/ShopSelectSheet/index.tsx:354
msgid "請選擇您目前所在的店家，並向店員確認後再進行核銷"
msgstr "請選擇您目前所在的店家，並向店員確認後再進行核銷"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:491
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/ContractSettings/index.web.tsx:53
msgid "請選擇憑證開立方式"
msgstr "請選擇憑證開立方式"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:274
msgid "請選擇或新增按鈕文字"
msgstr "請選擇或新增按鈕文字"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:436
msgid "請選擇或輸入榜單編碼"
msgstr "請選擇或輸入榜單編碼"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:243
#: apps/dp-business/src/pages/AddStore/index.tsx:382
#: apps/dp-business/src/pages/AddStore/index.tsx:1135
msgid "請選擇所在市區"
msgstr "請選擇所在市區"

#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:29
msgid "請選擇所屬一級"
msgstr "請選擇所屬一級"

#: apps/dp-admin/src/pages/resource-config/category-management/components/SecondCategoryModal/index.web.tsx:501
msgid "請選擇所屬一級品類"
msgstr "請選擇所屬一級品類"

#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:47
msgid "請選擇所屬二級"
msgstr "請選擇所屬二級"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:328
msgid "請選擇所屬商圈/夜市"
msgstr "請選擇所屬商圈/夜市"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:323
msgid "請選擇所屬商場"
msgstr "請選擇所屬商場"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:224
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:227
msgid "請選擇所屬第三方"
msgstr "請選擇所屬第三方"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:202
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:369
msgid "請選擇投訴原因"
msgstr "請選擇投訴原因"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:256
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:44
msgid "請選擇投遞渠道"
msgstr "請選擇投遞渠道"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:264
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/searchConfig.ts:54
msgid "請選擇投遞狀態"
msgstr "請選擇投遞狀態"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:639
msgid "請選擇折扣有效期類型"
msgstr "請選擇折扣有效期類型"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:149
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:153
msgid "請選擇折扣類型"
msgstr "請選擇折扣類型"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:280
msgid "請選擇按鈕文字"
msgstr "請選擇按鈕文字"

#: apps/dp-admin/src/pages/merchant/components/MetroStationExitSelector/index.web.tsx:53
msgid "請選擇捷運站"
msgstr "請選擇捷運站"

#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:264
msgid "請選擇捷運線路/站點"
msgstr "請選擇捷運線路/站點"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:196
msgid "請選擇排序規則（可多選）"
msgstr "請選擇排序規則（可多選）"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/searchConfig.ts:39
msgid "請選擇排行對象"
msgstr "請選擇排行對象"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:790
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:791
msgid "請選擇接單模式"
msgstr "請選擇接單模式"

#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:189
msgid "請選擇提交人"
msgstr "請選擇提交人"

#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:168
msgid "請選擇提交方式"
msgstr "請選擇提交方式"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:119
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:188
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:191
msgid "請選擇提報單位"
msgstr "請選擇提報單位"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:268
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:271
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:95
msgid "請選擇操作類型"
msgstr "請選擇操作類型"

#: apps/dp-business/src/pages/OrderList/index.tsx:915
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:71
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:104
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/config.web.tsx:68
msgid "請選擇支付狀態"
msgstr "請選擇支付狀態"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:233
msgid "請選擇收取上限類型"
msgstr "請選擇收取上限類型"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:276
msgid "請選擇收取次數"
msgstr "請選擇收取次數"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:792
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:796
msgid "請選擇收費規則"
msgstr "請選擇收費規則"

#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:65
msgid "請選擇啟用狀態"
msgstr "請選擇啟用狀態"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponStatusModal.web.tsx:125
msgid "請選擇新的券狀態"
msgstr "請選擇新的券狀態"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/ExtendInventoryModal.web.tsx:41
#: apps/dp-admin/src/pages/marketing/benefit-management/components/ExtendInventoryModal.web.tsx:86
msgid "請選擇新的截止時間"
msgstr "請選擇新的截止時間"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeMountNodeModal.web.tsx:62
msgid "請選擇新的掛接節點"
msgstr "請選擇新的掛接節點"

#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:202
#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:213
msgid "請選擇新追蹤者"
msgstr "請選擇新追蹤者"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:87
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:743
#: apps/dp-business/src/pages/BusinessStatus/index.tsx:406
#: apps/dp-business/src/components/DatePicker.tsx:524
#: apps/dp-business/src/components/DatePicker.tsx:548
#: apps/dp-business/src/components/DatePicker.tsx:574
#: apps/dp-business/src/components/DatePickModal/index.tsx:77
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:84
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:95
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractUpload/components/ContractInfo/index.web.tsx:38
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/ContractUpload/components/ContractInfo/index.web.tsx:39
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:252
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:106
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:57
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:392
msgid "請選擇日期"
msgstr "請選擇日期"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:630
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:631
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:935
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:446
#: apps/dp-business/src/components/DateRangeSelector/index.tsx:168
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:603
msgid "請選擇日期範圍"
msgstr "請選擇日期範圍"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/searchConfig.ts:50
msgid "請選擇是否全部套餐"
msgstr "請選擇是否全部套餐"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:449
msgid "請選擇是否可疊加優惠"
msgstr "請選擇是否可疊加優惠"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:247
msgid "請選擇是否可跳過"
msgstr "請選擇是否可跳過"

#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:55
msgid "請選擇是否平台活動"
msgstr "請選擇是否平台活動"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:93
msgid "請選擇是否有庫存"
msgstr "請選擇是否有庫存"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:480
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:484
msgid "請選擇是否為免開發票商家"
msgstr "請選擇是否為免開發票商家"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:200
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:203
msgid "請選擇是否為第三方活動"
msgstr "請選擇是否為第三方活動"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:578
msgid "請選擇是否百貨"
msgstr "請選擇是否百貨"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:447
msgid "請選擇是否聯繫成功"
msgstr "請選擇是否聯繫成功"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:340
msgid "請選擇是否開通套餐券服務"
msgstr "請選擇是否開通套餐券服務"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/transform.ts:336
msgid "請選擇是否開通結帳服務"
msgstr "請選擇是否開通結帳服務"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:103
msgid "請選擇是否需預約"
msgstr "請選擇是否需預約"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:96
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:769
msgid "請選擇時段"
msgstr "請選擇時段"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:431
msgid "請選擇時間"
msgstr "請選擇時間"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:484
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:257
msgid "請選擇時間段"
msgstr "請選擇時間段"

#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:55
#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:100
#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:165
msgid "請選擇時間範圍"
msgstr "請選擇時間範圍"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:227
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:160
msgid "請選擇晚於當前有效期的日期"
msgstr "請選擇晚於當前有效期的日期"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/index.web.tsx:55
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/MemberTypeSection.web.tsx:41
msgid "請選擇會員類型"
msgstr "請選擇會員類型"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:138
msgid "請選擇月份"
msgstr "請選擇月份"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:239
msgid "請選擇有效時間"
msgstr "請選擇有效時間"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:692
msgid "請選擇有效時間區間"
msgstr "請選擇有效時間區間"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:98
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:87
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BookingFeeRules/index.web.tsx:93
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:77
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/BookingFeeRules/index.web.tsx:79
msgid "請選擇有效時間範圍"
msgstr "請選擇有效時間範圍"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:310
msgid "請選擇有效期"
msgstr "請選擇有效期"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:459
msgid "請選擇有效的合約類型"
msgstr "請選擇有效的合約類型"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:471
msgid "請選擇有效的營約主體"
msgstr "請選擇有效的營約主體"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:627
msgid "請選擇有效的身分證領補換資料"
msgstr "請選擇有效的身分證領補換資料"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:397
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:774
msgid "請選擇服務時間"
msgstr "請選擇服務時間"

#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:58
msgid "請選擇服務類型"
msgstr "請選擇服務類型"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:107
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:108
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:397
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:398
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:413
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:81
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:84
msgid "請選擇本次追蹤進度"
msgstr "請選擇本次追蹤進度"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:360
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/CorporateRegistration/index.web.tsx:122
msgid "請選擇核准設立日期"
msgstr "請選擇核准設立日期"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:616
msgid "請選擇桌位"
msgstr "請選擇桌位"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:611
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:847
msgid "請選擇桌型"
msgstr "請選擇桌型"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:191
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:194
msgid "請選擇業務模塊"
msgstr "請選擇業務模塊"

#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:106
msgid "請選擇業務類型"
msgstr "請選擇業務類型"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:411
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:414
msgid "請選擇榜單排行值"
msgstr "請選擇榜單排行值"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/searchConfig.ts:59
msgid "請選擇榜單狀態"
msgstr "請選擇榜單狀態"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/searchConfig.ts:29
msgid "請選擇榜單編碼"
msgstr "請選擇榜單編碼"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/searchConfig.ts:49
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:422
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:425
msgid "請選擇榜單類型"
msgstr "請選擇榜單類型"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/UpdateLocationModal/index.web.tsx:97
msgid "請選擇樓層"
msgstr "請選擇樓層"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:216
msgid "請選擇樓層/排"
msgstr "請選擇樓層/排"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:329
msgid "請選擇標簽時效"
msgstr "請選擇標簽時效"

#: apps/dp-business/src/pages/MenuItemForm.tsx:557
#: apps/dp-business/src/pages/MenuItemForm.tsx:563
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:155
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:155
msgid "請選擇標籤"
msgstr "請選擇標籤"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:54
msgid "請選擇模式"
msgstr "請選擇模式"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:233
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/TemplateSelectField/index.web.tsx:79
msgid "請選擇模板"
msgstr "請選擇模板"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:49
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:75
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:108
msgid "請選擇模板狀態"
msgstr "請選擇模板狀態"

#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:207
msgid "請選擇機審結果"
msgstr "請選擇機審結果"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:63
msgid "請選擇檢舉類型"
msgstr "請選擇檢舉類型"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:148
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:151
msgid "請選擇權益子類型"
msgstr "請選擇權益子類型"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:270
msgid "請選擇權益歸屬"
msgstr "請選擇權益歸屬"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:80
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:130
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:133
msgid "請選擇權益類型"
msgstr "請選擇權益類型"

#: apps/dp-admin/src/components/RocDatePicker/index.web.tsx:84
msgid "請選擇民國年月日"
msgstr "請選擇民國年月日"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:268
msgid "請選擇活動時間"
msgstr "請選擇活動時間"

#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:62
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:96
msgid "請選擇活動標籤"
msgstr "請選擇活動標籤"

#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:83
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:182
msgid "請選擇活動權益歸屬"
msgstr "請選擇活動權益歸屬"

#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:71
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:86
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:35
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/searchConfig.ts:30
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:202
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:124
#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:74
msgid "請選擇活動狀態"
msgstr "請選擇活動狀態"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/CampaignMetaSection/index.web.tsx:32
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/CampaignMetaSection/index.web.tsx:35
msgid "請選擇活動發行廠商"
msgstr "請選擇活動發行廠商"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityDescriptionField/index.web.tsx:36
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ActivityDescriptionField/LandingPagePicker.web.tsx:171
msgid "請選擇活動說明落地頁"
msgstr "請選擇活動說明落地頁"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:36
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:196
msgid "請選擇活動開始時間"
msgstr "請選擇活動開始時間"

#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:60
#: apps/dp-admin/src/pages/marketing/platform-activities/services/config.web.tsx:77
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:45
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:128
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:180
#: apps/dp-admin/src/pages/marketing/activity-config-list/services/searchConfig.ts:51
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:87
msgid "請選擇活動類型"
msgstr "請選擇活動類型"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepTemplate.web.tsx:170
msgid "請選擇消息模板"
msgstr "請選擇消息模板"

#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:35
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:77
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:81
msgid "請選擇消息類型"
msgstr "請選擇消息類型"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConsumeConfigEditor/index.web.tsx:58
msgid "請選擇消耗權益"
msgstr "請選擇消耗權益"

#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:67
msgid "請選擇渠道類型"
msgstr "請選擇渠道類型"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:105
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:122
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:604
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:541
msgid "請選擇營業狀態"
msgstr "請選擇營業狀態"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:467
msgid "請選擇營約主體"
msgstr "請選擇營約主體"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:483
msgid "請選擇營運狀態"
msgstr "請選擇營運狀態"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:60
msgid "請選擇特定時間段"
msgstr "請選擇特定時間段"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:135
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountToolbar/index.web.tsx:105
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:38
#: apps/dp-admin/src/pages/resource-config/oauth-client-management/services/searchConfig.ts:32
#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:77
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/searchConfig.ts:37
#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:69
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:124
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:200
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:51
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:119
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:700
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:726
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:78
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:115
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:76
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/searchConfig.ts:24
#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:39
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:112
#: apps/dp-admin/src/pages/marketing/channel-management/services/searchConfig.web.tsx:89
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:228
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:122
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:63
msgid "請選擇狀態"
msgstr "請選擇狀態"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:183
msgid "請選擇獎勵權益"
msgstr "請選擇獎勵權益"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardLimitConfigEditor/index.web.tsx:58
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardLimitConfigEditor/index.web.tsx:62
msgid "請選擇獎勵週期"
msgstr "請選擇獎勵週期"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:194
msgid "請選擇獎勵類型"
msgstr "請選擇獎勵類型"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/WinningConfirmModal.web.tsx:82
#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/WinningConfirmModal.web.tsx:87
msgid "請選擇獎品類型"
msgstr "請選擇獎品類型"

#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:75
msgid "請選擇生效狀態"
msgstr "請選擇生效狀態"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepUserGroup.web.tsx:34
#: apps/dp-admin/src/pages/marketing/activity-create/services/hooks.ts:232
#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:630
msgid "請選擇用戶名單"
msgstr "請選擇用戶名單"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:142
msgid "請選擇用餐人數"
msgstr "請選擇用餐人數"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:1032
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:601
msgid "請選擇用餐日期"
msgstr "請選擇用餐日期"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:606
msgid "請選擇用餐時段"
msgstr "請選擇用餐時段"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:162
msgid "請選擇發放有效期"
msgstr "請選擇發放有效期"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:158
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:163
msgid "請選擇發放次數"
msgstr "請選擇發放次數"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:125
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:245
msgid "請選擇發放狀態"
msgstr "請選擇發放狀態"

#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:557
msgid "請選擇發版時間"
msgstr "請選擇發版時間"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:252
msgid "請選擇發生時間"
msgstr "請選擇發生時間"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1503
msgid "請選擇發票抬頭"
msgstr "請選擇發票抬頭"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:152
#: apps/dp-business/src/components/InvoiceForm/index.tsx:535
msgid "請選擇發票日期"
msgstr "請選擇發票日期"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:56
msgid "請選擇發票狀態"
msgstr "請選擇發票狀態"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:556
msgid "請選擇發票設定"
msgstr "請選擇發票設定"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:65
msgid "請選擇發票類型"
msgstr "請選擇發票類型"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:183
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:187
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:125
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:130
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:30
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:88
msgid "請選擇發證地"
msgstr "請選擇發證地"

#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:45
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:119
msgid "請選擇發送方式"
msgstr "請選擇發送方式"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:132
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:145
msgid "請選擇發送時間"
msgstr "請選擇發送時間"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepTemplate.web.tsx:243
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepTemplate.web.tsx:251
msgid "請選擇發送渠道"
msgstr "請選擇發送渠道"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:179
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:182
msgid "請選擇發送類型"
msgstr "請選擇發送類型"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:422
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:316
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:561
#: apps/dp-admin/src/pages/merchant/shop-create/services/hooks.ts:309
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:603
msgid "請選擇直營/加盟"
msgstr "請選擇直營/加盟"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:250
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:208
msgid "請選擇票券狀態"
msgstr "請選擇票券狀態"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:260
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:221
msgid "請選擇票券類型"
msgstr "請選擇票券類型"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:69
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:72
msgid "請選擇第三方"
msgstr "請選擇第三方"

#: apps/dp-business/src/pages/ChainDashboard/components/ChainNodeDetail.tsx:213
msgid "請選擇節點查看詳情"
msgstr "請選擇節點查看詳情"

#: apps/dp-admin/src/components/AdminUserSelect/index.web.tsx:51
msgid "請選擇管理員帳號"
msgstr "請選擇管理員帳號"

#: apps/dp-admin/src/pages/resource-config/components/ContentFilterSelector/index.web.tsx:50
msgid "請選擇篩選項"
msgstr "請選擇篩選項"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/SmsTemplateSection.web.tsx:109
msgid "請選擇簡訊模板類型"
msgstr "請選擇簡訊模板類型"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:553
msgid "請選擇簽約主體類型"
msgstr "請選擇簽約主體類型"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:316
msgid "請選擇簽約標籤"
msgstr "請選擇簽約標籤"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:525
msgid "請選擇簽約狀態"
msgstr "請選擇簽約狀態"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/ContractUpload/components/ContractInfo/index.web.tsx:32
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:508
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/ContractUpload/components/ContractInfo/index.web.tsx:33
msgid "請選擇簽約開始時間"
msgstr "請選擇簽約開始時間"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:138
msgid "請選擇組合邏輯"
msgstr "請選擇組合邏輯"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:292
msgid "請選擇結帳服務"
msgstr "請選擇結帳服務"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/CountdownField/index.web.tsx:72
msgid "請選擇結束後字體顏色"
msgstr "請選擇結束後字體顏色"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/CountdownField/index.web.tsx:82
msgid "請選擇結束後底色"
msgstr "請選擇結束後底色"

#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:128
msgid "請選擇結束日期"
msgstr "請選擇結束日期"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:380
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/CountdownField/index.web.tsx:37
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/CountdownField/index.web.tsx:43
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:206
msgid "請選擇結束時間"
msgstr "請選擇結束時間"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:171
msgid "請選擇結束銷售時間"
msgstr "請選擇結束銷售時間"

#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:43
msgid "請選擇結算狀態"
msgstr "請選擇結算狀態"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:259
msgid "請選擇綁定審核狀態"
msgstr "請選擇綁定審核狀態"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:245
msgid "請選擇綁定狀態"
msgstr "請選擇綁定狀態"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:143
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:216
msgid "請選擇緊急程度"
msgstr "請選擇緊急程度"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:631
msgid "請選擇縣市/行政區"
msgstr "請選擇縣市/行政區"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:69
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:74
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:152
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:157
msgid "請選擇縣市/鄉鎮市區"
msgstr "請選擇縣市/鄉鎮市區"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:222
msgid "請選擇聚流簽約審核狀態"
msgstr "請選擇聚流簽約審核狀態"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:258
msgid "請選擇聚流簽約狀態"
msgstr "請選擇聚流簽約狀態"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:190
msgid "請選擇聯繫方式"
msgstr "請選擇聯繫方式"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:463
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:476
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:128
msgid "請選擇聯繫方式類型"
msgstr "請選擇聯繫方式類型"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:471
msgid "請選擇至少一個地域"
msgstr "請選擇至少一個地域"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:573
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:384
msgid "請選擇至少一個結算單"
msgstr "請選擇至少一個結算單"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1135
msgid "請選擇至少一個菜品"
msgstr "請選擇至少一個餐點"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:319
msgid "請選擇至少一個適用品類"
msgstr "請選擇至少一個適用品類"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:53
msgid "請選擇落地頁面"
msgstr "請選擇落地頁面"

#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/searchConfig.ts:27
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:221
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/searchConfig.ts:34
msgid "請選擇落地頁類型"
msgstr "請選擇落地頁類型"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:287
msgid "請選擇藍新審核狀態"
msgstr "請選擇藍新審核狀態"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:273
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:272
msgid "請選擇藍新簽約狀態"
msgstr "請選擇藍新簽約狀態"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:119
msgid "請選擇處理方式"
msgstr "請選擇處理方式"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:235
msgid "請選擇處理類型"
msgstr "請選擇處理類型"

#: apps/dp-admin/src/pages/marketing/activity-create/components/UserTargetingForm/index.web.tsx:456
msgid "請選擇行政區"
msgstr "請選擇行政區"

#: apps/dp-admin/src/components/RocDatePicker/index.web.tsx:84
msgid "請選擇西元年月日"
msgstr "請選擇西元年月日"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:391
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:244
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:372
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:281
msgid "請選擇要作廢的券包"
msgstr "請選擇要作廢的券包"

#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:450
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:570
msgid "請選擇要停用的品類"
msgstr "請選擇要停用的品類"

#: apps/dp-admin/src/pages/org-tree/org-list/components/AssignBdModal/index.web.tsx:35
msgid "請選擇要分配的 BD"
msgstr "請選擇要分配的 BD"

#. placeholder {0}: assigneeLabel.replace(t`選擇`, '')
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:163
msgid "請選擇要分配的{0}"
msgstr "請選擇要分配的{0}"

#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:331
msgid "請選擇要導出的券包"
msgstr "請選擇要導出的券包"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/hooks.ts:932
#: apps/dp-admin/src/pages/merchant/shop-list/services/hooks.ts:753
msgid "請選擇要導出的商家"
msgstr "請選擇要導出的商家"

#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:104
msgid "請選擇要導出的商家組"
msgstr "請選擇要導出的商家組"

#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:110
msgid "請選擇要導出的用戶名單"
msgstr "請選擇要導出的用戶名單"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:183
msgid "請選擇要展示的篩選器（可多選）"
msgstr "請選擇要展示的篩選器（可多選）"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/index.web.tsx:343
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:193
#: apps/dp-admin/src/pages/user-info/user-coupon-list/index.web.tsx:311
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:225
msgid "請選擇要延期的券包"
msgstr "請選擇要延期的券包"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:165
msgid "請選擇要拒絕的結算訂單"
msgstr "請選擇要拒絕的結算訂單"

#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:166
msgid "請選擇要拒絕的請款單"
msgstr "請選擇要拒絕的請款單"

#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/hooks.ts:109
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/hooks.ts:132
msgid "請選擇要核銷的券包"
msgstr "請選擇要核銷的券包"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:103
msgid "請選擇要確認的結算訂單"
msgstr "請選擇要確認的結算訂單"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:453
msgid "請選擇要複製到的店家"
msgstr "請選擇要複製到的店家"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:458
msgid "請選擇要複製的內容"
msgstr "請選擇要複製的內容"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:475
msgid "請選擇要複製的圖片類型"
msgstr "請選擇要複製的圖片類型"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:468
msgid "請選擇要複製的菜單子項內容（菜單圖片或至少一個分類）"
msgstr "請選擇要複製的菜單子項內容（菜單圖片或至少一個分類）"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountUnbindModal.tsx:56
msgid "請選擇要解除授權的節點"
msgstr "請選擇要解除授權的節點"

#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:111
msgid "請選擇要通過的請款單"
msgstr "請選擇要通過的請款單"

#: apps/dp-business/src/pages/AddStore/index.tsx:945
msgid "請選擇要進駐的店家"
msgstr "請選擇要進駐的店家"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:214
#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:266
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:177
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:382
#: apps/dp-business/src/pages/EditUser/index.tsx:117
#: apps/dp-business/src/pages/EditUser/index.tsx:283
#: apps/dp-business/src/pages/AddUser/index.tsx:108
#: apps/dp-business/src/pages/AddUser/index.tsx:297
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountToolbar/index.web.tsx:65
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:95
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:217
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepRoles.web.tsx:215
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepRoles.web.tsx:222
#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:163
#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:166
msgid "請選擇角色"
msgstr "請選擇角色"

#. placeholder {0}: role?.roleName || ''
#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:331
msgid "請選擇角色「{0}」的權限範圍："
msgstr "請選擇角色「{0}」的權限範圍："

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:135
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:139
msgid "請選擇觸發事件"
msgstr "請選擇觸發事件"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:744
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:745
msgid "請選擇訂位時間間隔"
msgstr "請選擇訂位時間間隔"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:301
msgid "請選擇訂位服務"
msgstr "請選擇訂位服務"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:182
msgid "請選擇訂位狀態"
msgstr "請選擇訂位狀態"

#: apps/dp-business/src/pages/OrderList/index.tsx:942
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:51
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:84
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:165
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/config.web.tsx:37
msgid "請選擇訂單狀態"
msgstr "請選擇訂單狀態"

#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:61
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:94
msgid "請選擇訂單類型"
msgstr "請選擇訂單類型"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/CountdownField/index.web.tsx:62
msgid "請選擇計時器字體顏色"
msgstr "請選擇計時器字體顏色"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/CountdownField/index.web.tsx:52
msgid "請選擇計時器底色"
msgstr "請選擇計時器底色"

#: apps/dp-client/src/screens/account/pages/advice/feedback-detail/index.tsx:148
msgid "請選擇評分"
msgstr "請選擇評分"

#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:39
msgid "請選擇請款狀態"
msgstr "請選擇請款狀態"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/MemberTypeSection.web.tsx:66
msgid "請選擇證件類型"
msgstr "請選擇證件類型"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:93
msgid "請選擇識別類型"
msgstr "請選擇識別類型"

#: apps/dp-admin/src/pages/merchant/components/MerchantInfoSection/index.web.tsx:234
msgid "請選擇負責人"
msgstr "請選擇負責人"

#: apps/dp-admin/src/pages/merchant/components/BdSection/index.web.tsx:23
#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:154
#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:165
msgid "請選擇跟進 BD"
msgstr "請選擇跟進 BD"

#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:171
msgid "請選擇跟進BD"
msgstr "請選擇跟進BD"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:236
msgid "請選擇跳轉目標"
msgstr "請選擇跳轉目標"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:326
msgid "請選擇跳轉頁面"
msgstr "請選擇跳轉頁面"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:315
msgid "請選擇跳轉頁面，或新增有效的自訂鏈接"
msgstr "請選擇跳轉頁面，或新增有效的自訂鏈接"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:98
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:249
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:103
msgid "請選擇跳轉類型"
msgstr "請選擇跳轉類型"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:205
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:146
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:623
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:35
msgid "請選擇身分證的領補換資料"
msgstr "請選擇身分證的領補換資料"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:83
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:215
msgid "請選擇車輛類型"
msgstr "請選擇車輛類型"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:123
msgid "請選擇轉至報修類型"
msgstr "請選擇轉至報修類型"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:536
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:398
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:376
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:389
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:73
msgid "請選擇追蹤狀態"
msgstr "請選擇追蹤狀態"

#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:86
msgid "請選擇追蹤者"
msgstr "請選擇追蹤者"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:180
msgid "請選擇退款原因"
msgstr "請選擇退款原因"

#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:81
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:114
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/config.web.tsx:47
msgid "請選擇退款狀態"
msgstr "請選擇退款狀態"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:211
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:215
msgid "請選擇通知方式"
msgstr "請選擇通知方式"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:423
msgid "請選擇通知日期"
msgstr "請選擇通知日期"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:415
msgid "請選擇通知時間"
msgstr "請選擇通知時間"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:305
msgid "請選擇週期"
msgstr "請選擇週期"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:179
msgid "請選擇週期單位"
msgstr "請選擇週期單位"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:87
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ExchangeLimitEditor/index.web.tsx:76
msgid "請選擇週期維度"
msgstr "請選擇週期維度"

#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:55
msgid "請選擇週期類型"
msgstr "請選擇週期類型"

#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:114
msgid "請選擇運營狀態"
msgstr "請選擇運營狀態"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:292
msgid "請選擇運營端角色"
msgstr "請選擇運營端角色"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:160
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:166
msgid "請選擇過濾項"
msgstr "請選擇過濾項"

#: apps/dp-business/src/pages/TableManagement/index.tsx:627
#: apps/dp-business/src/pages/TableManagement/index.tsx:805
msgid "請選擇適用人數"
msgstr "請選擇適用人數"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:623
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:624
msgid "請選擇適用星期"
msgstr "請選擇適用星期"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:183
#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:186
msgid "請選擇適用訂單類型"
msgstr "請選擇適用訂單類型"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:22
msgid "請選擇配置位置"
msgstr "請選擇配置位置"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/index.web.tsx:484
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:195
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:198
msgid "請選擇配置類型"
msgstr "請選擇配置類型"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:66
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:71
msgid "請選擇金融機構"
msgstr "請選擇金融機構"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:82
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:88
msgid "請選擇金融機構分類"
msgstr "請選擇金融機構分類"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:46
msgid "請選擇銀行和分行"
msgstr "請選擇銀行和分行"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:93
msgid "請選擇鏈接類型"
msgstr "請選擇鏈接類型"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:298
msgid "請選擇開始和結束時間"
msgstr "請選擇開始和結束時間"

#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:120
msgid "請選擇開始日期"
msgstr "請選擇開始日期"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:274
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:65
msgid "請選擇開始日期和結束日期"
msgstr "請選擇開始日期和結束日期"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:341
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:176
#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:189
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:154
msgid "請選擇開始時間"
msgstr "請選擇開始時間"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterSelects.tsx:148
msgid "請選擇開始與結束日期"
msgstr "請選擇開始與結束日期"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:135
msgid "請選擇開始銷售時間"
msgstr "請選擇開始銷售時間"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:150
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:175
msgid "請選擇開票情況"
msgstr "請選擇開票情況"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:780
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:142
msgid "請選擇關聯活動"
msgstr "請選擇關聯活動"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardLimitConfigEditor/index.web.tsx:39
msgid "請選擇限制範圍"
msgstr "請選擇限制範圍"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:244
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:249
msgid "請選擇限制週期"
msgstr "請選擇限制週期"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:238
msgid "請選擇需要處理的異常類型"
msgstr "請選擇需要處理的異常類型"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:191
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/hooks.ts:163
msgid "請選擇需要重試的記錄"
msgstr "請選擇需要重試的記錄"

#: apps/dp-admin/src/pages/marketing/services/groupImport.ts:221
msgid "請選擇非空的 .xls 或 .xlsx 文件"
msgstr "請選擇非空的 .xls 或 .xlsx 文件"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:517
msgid "請選擇預將資訊複製過去的店家"
msgstr "請選擇預將資訊複製過去的店家"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:607
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:504
msgid "請選擇預批量複製到其他店家的內容"
msgstr "請選擇預批量複製到其他店家的內容"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:274
msgid "請選擇領補換資料"
msgstr "請選擇領補換資料"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:402
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:408
msgid "請選擇類別"
msgstr "請選擇類別"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:546
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:549
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:66
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:95
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:39
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:571
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:573
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:217
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:105
msgid "請選擇類型"
msgstr "請選擇類型"

#: apps/dp-business/src/pages/MenuItemForm.tsx:472
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:288
msgid "請選擇餐點類別"
msgstr "請選擇餐點類別"

#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:189
msgid "請選擇驗證方式"
msgstr "請選擇驗證方式"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:95
msgid "請選擇黑名單狀態"
msgstr "請選擇黑名單狀態"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:231
msgid "請配置總觸發事件，至少添加一個觸發事件"
msgstr "請配置總觸發事件，至少添加一個觸發事件"

#: apps/dp-client/src/screens/others/NoNetwork.tsx:35
msgid "請重新連結到網路後重新整理"
msgstr "請重新連結到網路後重新整理"

#: apps/dp-client/src/screens/home/pages/Note/constants/index.ts:31
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:711
msgid "請重試"
msgstr "請重新嘗試"

#: apps/dp-client/src/screens/login/pages/verify-password/index.tsx:74
#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:295
msgid "請驗證密碼"
msgstr "請驗證密碼"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:660
msgid "請點擊編輯按鈕上傳"
msgstr "請點擊編輯按鈕上傳"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:174
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:254
msgid "請點擊選擇類別"
msgstr "請點擊選擇類別"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:160
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:240
msgid "請點擊選擇餐點"
msgstr "請點擊選擇餐點"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:403
msgid "謝謝你的參與，期待下次再見"
msgstr "謝謝你的參與，期待下次再見"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:346
msgid "證件圖片"
msgstr "證件圖片"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1018
msgid "證件姓名"
msgstr "證件姓名"

#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:296
msgid "證件號碼"
msgstr "證件號碼"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/MemberTypeSection.web.tsx:64
msgid "證件類型"
msgstr "證件類型"

#: apps/dp-admin/src/pages/merchant/information-error/index.web.tsx:41
msgid "證明文件1"
msgstr "證明文件1"

#: apps/dp-admin/src/pages/merchant/information-error/index.web.tsx:46
msgid "證明文件2"
msgstr "證明文件2"

#: apps/dp-business/src/pages/MenuManagement.tsx:503
msgid "識別失敗，請檢查網路連接"
msgstr "識別失敗，請檢查網路連接"

#: apps/dp-business/src/pages/MenuManagement.tsx:499
msgid "識別失敗，請重試"
msgstr "識別失敗，請重試"

#: apps/dp-business/src/pages/MenuManagement.tsx:493
msgid "識別成功，但所有餐點都已存在"
msgstr "識別成功，但所有餐點都已存在"

#. placeholder {0}: newMenuItems.length
#: apps/dp-business/src/pages/MenuManagement.tsx:487
msgid "識別成功：已添加{0}個餐點"
msgstr "識別成功：已添加{0}個餐點"

#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:1004
msgid "識別為文字菜單"
msgstr "識別為文字菜單"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/Details.web.tsx:92
msgid "識別碼"
msgstr "識別碼"

#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:86
#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:108
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:86
msgid "識別類型"
msgstr "識別類型"

#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:141
msgid "識別類型（與原名單一致）"
msgstr "識別類型（與原名單一致）"

#: apps/dp-admin/src/pages/other/services/constants.ts:59
msgid "警告通知"
msgstr "警告通知"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:290
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/OwnerInfo/index.web.tsx:41
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/constants.ts:61
#: apps/dp-admin/src/pages/merchant/audit-detail/utils/transformers.ts:252
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:241
msgid "護照"
msgstr "護照"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:495
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:506
msgid "護照圖片"
msgstr "護照圖片"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:457
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:152
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:676
#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:186
msgid "護照效期"
msgstr "護照效期"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:442
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:83
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:59
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/OwnerInfo/index.web.tsx:36
#: apps/dp-admin/src/pages/merchant/audit-detail/utils/transformers.ts:251
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:240
msgid "護照號碼"
msgstr "護照號碼"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:669
msgid "護照首頁"
msgstr "護照首頁"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:656
msgid "讀取Blob失敗: "
msgstr "讀取Blob失敗: "

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:662
msgid "讀取申請草稿失敗"
msgstr "讀取申請草稿失敗"

#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:694
msgid "讀取組織樹詳情失敗"
msgstr "讀取組織樹詳情失敗"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1005
msgid "讀取草稿失敗，請稍後重試"
msgstr "讀取草稿失敗，請稍後重試"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:908
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:942
msgid "讀取變更草稿失敗，請稍後重試"
msgstr "讀取變更草稿失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelHistoryList/index.web.tsx:105
msgid "變更內容"
msgstr "變更內容"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:131
msgid "變更前"
msgstr "變更前"

#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:232
msgid "變更前（當前生效）"
msgstr "變更前（當前生效）"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:1144
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:627
msgid "變更原因"
msgstr "變更原因"

#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:223
msgid "變更對比"
msgstr "變更對比"

#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:236
msgid "變更後（待審核）"
msgstr "變更後（待審核）"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/OnboardImpactModal.web.tsx:210
msgid "變更欄位"
msgstr "變更欄位"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:56
msgid "讚"
msgstr "讚"

#: apps/dp-client/src/screens/account/pages/profile/components/UserInfoSection/index.tsx:129
msgid "讚與收藏"
msgstr "讚與收藏"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1528
msgid "豐富的資訊有助於提升曝光率和客戶信任度"
msgstr "豐富的資訊有助於提升曝光率和客戶信任度"

#: apps/dp-business/src/data/categories.ts:174
msgid "豚骨拉麵"
msgstr "豚骨拉麵"

#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:87
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:63
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:182
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:462
msgid "負向"
msgstr "負向"

#: apps/dp-client/src/components/TabView/example.tsx:20
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:74
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:99
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:125
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:41
msgid "負評"
msgstr "負評"

#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingDistribution.web.tsx:122
msgid "負評（1星）"
msgstr "負評（1星）"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:81
msgid "負評申訴"
msgstr "負評申訴"

#: apps/dp-admin/src/pages/merchant/components/PageHeader/index.web.tsx:61
msgid "負評申訴處理"
msgstr "負評申訴處理"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:824
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1116
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1131
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:107
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:235
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:103
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:634
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:171
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/RepresentativeSection.web.tsx:45
#: apps/dp-admin/src/pages/merchant/audit-detail/components/BusinessLicense/index.web.tsx:43
msgid "負責人姓名"
msgstr "負責人姓名"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:238
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:174
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/RepresentativeSection.web.tsx:48
msgid "負責人姓名不能超過20個字符"
msgstr "負責人姓名不能超過20個字符"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:124
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:162
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:72
msgid "負責人居留證"
msgstr "負責人居留證"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:142
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:63
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:366
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:74
msgid "負責人居留證反面"
msgstr "負責人居留證反面"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:132
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:62
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:363
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:73
msgid "負責人居留證正面"
msgstr "負責人居留證正面"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:57
msgid "負責人居留證統一編號"
msgstr "負責人居留證統一編號"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:372
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:63
msgid "負責人居留證號"
msgstr "負責人居留證號"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:108
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:128
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:646
msgid "負責人手機號"
msgstr "負責人手機號"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:854
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:247
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:183
#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/components/RepresentativeSection.web.tsx:57
msgid "負責人手機門號"
msgstr "負責人手機門號"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/MerchantAuditInfo/index.web.tsx:112
msgid "負責人詳情"
msgstr "負責人詳情"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:120
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:120
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:137
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:143
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:75
msgid "負責人護照"
msgstr "負責人護照"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:67
msgid "負責人護照效期"
msgstr "負責人護照效期"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:375
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:65
msgid "負責人護照號碼"
msgstr "負責人護照號碼"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:628
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/OwnerInfo/index.web.tsx:46
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:553
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:313
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:320
msgid "負責人資訊"
msgstr "負責人資訊"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:69
msgid "負責人身份證"
msgstr "負責人身份證"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:173
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:71
msgid "負責人身份證反面"
msgstr "負責人身份證反面"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1161
msgid "負責人身份證字號"
msgstr "負責人身份證字號"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:157
#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:70
msgid "負責人身份證正面"
msgstr "負責人身份證正面"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/types.ts:61
msgid "負責人身份證號"
msgstr "負責人身份證號"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:124
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:162
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:163
msgid "負責人身分證"
msgstr "負責人身分證"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:142
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:63
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:367
msgid "負責人身分證反面"
msgstr "負責人身分證反面"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1147
msgid "負責人身分證字號"
msgstr "負責人身分證字號"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:132
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:62
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:364
msgid "負責人身分證正面"
msgstr "負責人身分證正面"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/BoundMerchantInfo.web.tsx:84
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/MerchantInfoCard.web.tsx:60
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:369
msgid "負責人身分證號"
msgstr "負責人身分證號"

#: apps/dp-business/src/pages/CustomerReviews/components/KeywordStatsSection.tsx:108
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/KeywordStats.web.tsx:65
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/KeywordStats.web.tsx:160
msgid "負面"
msgstr "負面"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:63
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:63
msgid "負面評價警告"
msgstr "負面評價警告"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/handleChainFinanceFailure.ts:66
msgid "財務上下文已變更，正在重新載入"
msgstr "財務上下文已變更，正在重新載入"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:810
#: apps/dp-business/src/components/CustomTabs/index.tsx:190
#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:70
msgid "財務管理"
msgstr "財務管理"

#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:348
msgid "財務預檢未通過"
msgstr "財務預檢未通過"

#: apps/dp-admin/src/router/config/routes.web.tsx:734
msgid "財會報表"
msgstr "財會報表"

#: apps/dp-business/src/data/regions.ts:80
msgid "貢寮區"
msgstr "貢寮區"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:874
msgid "責任主體"
msgstr "責任主體"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:452
msgid "貴公司應開具之收據金額為"
msgstr "貴公司應開具之收據金額為"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:451
msgid "貴公司應開具之發票金額為"
msgstr "貴公司應開具之發票金額為"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:347
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:466
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityStatsCards.web.tsx:61
msgid "買單人次"
msgstr "結帳人次"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:171
msgid "買單如何退款"
msgstr "結帳如何退款"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:448
msgid "買單成功"
msgstr "結帳成功"

#: apps/dp-client/src/configs/page-configs.tsx:819
msgid "買單詳情"
msgstr "結帳詳情"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:40
#: apps/dp-client/src/components/RefundResonModal/index.tsx:25
msgid "買多了/買錯了"
msgstr "買多了/買錯了"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/PackageZoneV2.tsx:726
msgid "買套餐"
msgstr "買套餐"

#: apps/dp-client/src/screens/home/pages/Home/components/OperationsPosition/UsergiftBanner.tsx:393
msgid "買套餐！"
msgstr "買套餐！"

#: apps/dp-business/src/pages/ContractManagement/components/ContractServiceSection.tsx:107
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:813
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:914
msgid "費率"
msgstr "費率"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:819
msgid "費率不能小於0"
msgstr "費率不能小於0"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:129
msgid "費用分類"
msgstr "費用分類"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:105
msgid "費用描述"
msgstr "費用描述"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:199
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:623
#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:161
msgid "費用明細"
msgstr "費用明細"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:177
msgid "費用資訊"
msgstr "費用資訊"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:552
#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:112
msgid "費用金額"
msgstr "費用金額"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:138
msgid "費用項ID"
msgstr "費用項ID"

#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:81
msgid "費用項數量"
msgstr "費用項數量"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:147
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:559
#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:93
msgid "費用類型"
msgstr "費用類型"

#: apps/dp-client/src/screens/diary/pages/winning/index.tsx:228
msgid "貼心小叮嚀"
msgstr "貼心小叮嚀"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:115
msgid "貼心服務"
msgstr "貼心服務"

#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:323
msgid "貼文要有照片或影片喔！"
msgstr "貼文要有照片或影片喔！"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:195
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:367
msgid "貼紙"
msgstr "貼紙"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:359
msgid "資料上傳"
msgstr "資料上傳"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:99
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:59
msgid "資料不存在或無權限查看"
msgstr "資料不存在或無權限查看"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:355
msgid "資料不完整"
msgstr "資料不完整"

#: apps/dp-admin/src/router/config/routes.web.tsx:280
msgid "資料中心"
msgstr "資料中心"

#: apps/dp-business/src/components/DeleteAccountModal/index.tsx:117
msgid "資料僅做封存，不會被刪除。"
msgstr "資料僅做封存，不會被刪除。"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:546
msgid "資料匯入"
msgstr "資料匯入"

#: apps/dp-business/src/pages/AccountDeactivation/index.tsx:116
msgid "資料及歷史操作仍會保留"
msgstr "資料及歷史操作仍會保留"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:139
msgid "資料可攜性"
msgstr "資料可攜性"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:547
msgid "資料同步"
msgstr "資料同步"

#: apps/dp-business/src/pages/OnboardingComplete/index.tsx:55
msgid "資料提交成功"
msgstr "資料上傳成功"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:353
msgid "資料格式不正確"
msgstr "資料格式不正確"

#: apps/dp-admin/src/pages/merchant/shared/constants.ts:84
msgid "資料載入失敗"
msgstr "資料載入失敗"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:28
msgid "資源位"
msgstr "資源位"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:49
msgid "資源位 {index}"
msgstr "資源位 {index}"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/index.web.tsx:85
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:383
msgid "資源位列表"
msgstr "資源位列表"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:673
#: apps/dp-admin/src/pages/resource-config/slot-material-list/index.web.tsx:48
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:371
msgid "資源位設定"
msgstr "資源位設定"

#: apps/dp-admin/src/router/config/routes.web.tsx:611
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:189
msgid "資源位配置"
msgstr "資源位配置"

#: apps/dp-admin/src/router/config/routes.web.tsx:586
msgid "資源設定"
msgstr "資源設定"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:650
msgid "資源配置"
msgstr "資源配置"

#: apps/dp-business/src/pages/SubmitSuccess/index.tsx:76
msgid "資訊上傳成功"
msgstr "資訊上傳成功"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:634
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/components/CorrectionModal.tsx:87
msgid "資訊修正"
msgstr "資訊修正"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1474
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1588
msgid "資訊分數總分:"
msgstr "資訊分數總分:"

#: apps/dp-admin/src/router/config/routes.web.tsx:423
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:237
msgid "資訊報錯審核"
msgstr "資訊報錯審核"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:263
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:270
msgid "資訊報錯審核詳情"
msgstr "資訊報錯審核詳情"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:95
msgid "資訊報錯詳情"
msgstr "資訊報錯詳情"

#: apps/dp-business/src/pages/MerchantInfo/components/ProgressCard.tsx:35
msgid "資訊完善進度"
msgstr "資訊完善進度"

#: apps/dp-admin/src/router/config/routes.web.tsx:351
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:82
msgid "資訊審核"
msgstr "資訊審核"

#: apps/dp-admin/src/pages/audit-center/info-audit/index.web.tsx:60
msgid "資訊審核列表"
msgstr "資訊審核列表"

#: apps/dp-admin/src/pages/merchant/components/PageHeader/index.web.tsx:65
msgid "資訊審核處理"
msgstr "資訊審核處理"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:81
#: apps/dp-admin/src/pages/audit-center/info-audit/services/hooks.ts:129
msgid "資訊審核詳情"
msgstr "資訊審核詳情"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:456
msgid "資訊準確嗎？"
msgstr "資訊準確嗎？"

#: apps/dp-business/src/pages/AddStore/index.tsx:1584
msgid "資訊無誤，下一步"
msgstr "資訊無誤，下一步"

#: apps/dp-admin/src/pages/audit-center/info-confirm/index.web.tsx:114
#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:9
#: apps/dp-admin/src/pages/audit-center/info-audit/services/constants.ts:28
msgid "資訊確認"
msgstr "資訊確認"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:284
#: apps/dp-admin/src/pages/audit-center/info-audit/services/hooks.ts:116
msgid "資訊確認審核"
msgstr "資訊確認審核"

#: apps/dp-business/src/utils/permissionData.ts:20
msgid "資訊維護"
msgstr "資訊維護"

#: apps/dp-admin/src/pages/merchant/information-review/components/InformationChangeSection/index.web.tsx:84
msgid "資訊變更對比"
msgstr "資訊變更對比"

#: apps/dp-admin/src/pages/merchant/components/PageHeader/index.web.tsx:67
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:85
msgid "資訊錯誤回報"
msgstr "資訊錯誤回報"

#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:45
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:335
msgid "賭毒等違法或有害內容"
msgstr "賭毒等違法或有害內容"

#: apps/dp-client/src/screens/home/pages/Review/pages/complete/components/ReviewRewardCard.tsx:51
msgid "賺更多"
msgstr "賺更多"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/Card.tsx:219
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:589
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallActivityModal/index.tsx:374
msgid "購買"
msgstr "購買"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:443
msgid "購買人"
msgstr "購買人"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:561
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:278
msgid "購買後"
msgstr "購買後"

#. placeholder {0}: days || ''
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:147
msgid "購買後 {0} 天有效"
msgstr "購買後 {0} 天有效"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:65
msgid "購買後 {validDays} 天有效"
msgstr "購買後 {validDays} 天有效"

#. placeholder {0}: currentPackage?.validDays
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:111
msgid "購買後{0}天內有效"
msgstr "購買後{0}天內有效"

#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:430
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:444
msgid "購買後{validDays}天內有效"
msgstr "購買後{validDays}天內有效"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1227
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:156
msgid "購買數量"
msgstr "購買數量"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:475
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:599
msgid "購買條件"
msgstr "購買條件"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/TiersEditor.web.tsx:280
msgid "起 1 次 · 固定"
msgstr "起 1 次 · 固定"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:779
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:344
msgid "起始時間"
msgstr "起始時間"

#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:99
msgid "超出免費組數後按每組收費"
msgstr "超出免費組數後按每組收費"

#: apps/dp-client/src/components/DiscountBadge/index.tsx:74
msgid "超划算"
msgstr "超划算"

#: apps/dp-business/src/types/orderFilter.ts:133
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1115
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1953
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:886
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:49
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:31
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:196
msgid "超時取消"
msgstr "超時取消"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:755
msgid "超時未支付"
msgstr "超時未支付"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:20
msgid "超時狀態不一致"
msgstr "超時狀態不一致"

#: apps/dp-client/src/screens/home/components/SatisfactionModal/index.tsx:36
msgid "超級懂我口味！"
msgstr "超級懂我口味！"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:405
msgid "超級管理員須同時填寫 Email 與手機門號。"
msgstr "超級管理員須同時填寫 Email 與手機門號。"

#: apps/dp-client/src/utils/format.ts:74
#: apps/dp-client/src/screens/home/utils/utils.ts:38
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:42
#: apps/dp-client/src/screens/home/pages/Note/utils/index.ts:4
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:55
msgid "超讚"
msgstr "超讚"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/NewTagEditor/index.web.tsx:154
msgid "超過最大標籤數量限制 {maxCount}"
msgstr "超過最大標籤數量限制 {maxCount}"

#: apps/dp-business/src/pages/RefundList/index.tsx:107
msgid "超過退款時限"
msgstr "超過退款時限"

#. placeholder {0}: option.extraFeePerGroup
#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:130
msgid "超額{0}元/每組"
msgstr "超額{0}元/每組"

#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:148
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:129
#: apps/dp-admin/src/pages/audit-center/services/apis.ts:300
msgid "趙六"
msgstr "趙六"

#: apps/dp-client/src/components/ShopSelectSheet/index.tsx:313
msgid "距你"
msgstr "距你"

#. placeholder {0}: (shop.crowFlies / 1000).toFixed(1)
#: apps/dp-client/src/screens/home/pages/PackageZone/components/PackageZoneShopSheet/index.tsx:134
msgid "距你 {0}km"
msgstr "距你 {0}km"

#. placeholder {0}: Math.round(shop.crowFlies)
#: apps/dp-client/src/screens/home/pages/PackageZone/components/PackageZoneShopSheet/index.tsx:133
msgid "距你 {0}m"
msgstr "距你 {0}m"

#: apps/dp-client/src/screens/reservation/pages/detail/components/ShopInfoCard.tsx:78
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1137
msgid "距你{distanceText}"
msgstr "距你{distanceText}"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:276
msgid "距商圈"
msgstr "距商圈"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:44
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:55
msgid "距商圈 120m"
msgstr "距商圈 120m"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:66
msgid "距商圈 250m"
msgstr "距商圈 250m"

#. placeholder {0}: shop.city || ''
#: apps/dp-client/src/screens/home/components/ShopCard/utils.tsx:73
msgid "距您{formattedDistance}（{0}）"
msgstr "距您{formattedDistance}（{0}）"

#: apps/dp-client/src/screens/home/components/ShopCard/utils.tsx:66
msgid "距此地{formattedDistance}"
msgstr "距此地{formattedDistance}"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:11
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:128
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/rawDataMapper.ts:170
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/constants.ts:16
msgid "距離"
msgstr "距離"

#: apps/dp-admin/src/pages/merchant/commercial-poi/components/MetroRelationsCard/index.web.tsx:287
msgid "距離（公尺）"
msgstr "距離（公尺）"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:63
msgid "距離最近"
msgstr "距離最近"

#. placeholder {0}: transportInfo?.nearestSubway || ''
#. placeholder {1}: transportInfo.nearestStation
#. placeholder {2}: transportInfo?.subwayExit || ''
#: apps/dp-client/src/screens/home/utils/location.ts:397
msgid "距離捷運{0}{1}{2} 步行{distanceText}"
msgstr "距離捷運{0}{1}{2} 步行{distanceText}"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/constants.ts:11
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:72
msgid "距離更近"
msgstr "距離更近"

#: apps/dp-business/src/pages/ChainDashboard/components/detail/ChainDetailBasicInfo.tsx:45
#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:55
#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:90
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:160
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:58
#: apps/dp-admin/src/pages/org-tree/org-audit/components/AuditTable/index.web.tsx:75
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:433
#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:152
msgid "跟進 BD"
msgstr "跟進 BD"

#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:62
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/MerchantTable.web.tsx:43
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:132
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:110
#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:127
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/BdInfoCard.web.tsx:12
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:564
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:169
#: apps/dp-admin/src/pages/merchant/components/BdSection/index.web.tsx:19
msgid "跟進BD"
msgstr "跟進BD"

#. placeholder {0}: detail.assignedAgentName || t`未指派`
#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/BasicInfoCard.web.tsx:78
msgid "跟進客服 : {0}"
msgstr "跟進客服 : {0}"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:191
msgid "跟進狀態"
msgstr "跟進狀態"

#: apps/dp-admin/src/components/BusinessHours/index.web.tsx:503
msgid "跨天時段重疊提醒"
msgstr "跨天時段重疊提醒"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:124
msgid "路徑"
msgstr "路徑"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:188
msgid "路由路徑"
msgstr "路由路徑"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/HorizontalShopCard.tsx:277
msgid "路線"
msgstr "路線"

#: apps/dp-client/src/configs/page-configs.tsx:2608
msgid "跳轉中..."
msgstr "開啟中…"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1037
msgid "跳轉到{optionLabel}"
msgstr "跳轉到{optionLabel}"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:990
msgid "跳轉到商家圖片"
msgstr "跳轉到商家圖片"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:935
msgid "跳轉到餐點菜單"
msgstr "跳轉到餐點菜單"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:651
msgid "跳轉套餐券明細"
msgstr "跳轉套餐券明細"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1142
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1155
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1168
msgid "跳轉查看"
msgstr "跳轉查看"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:231
msgid "跳轉目標"
msgstr "跳轉目標"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:82
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:99
msgid "跳轉設定"
msgstr "跳轉設定"

#: apps/dp-business/src/utils/permissionData.ts:51
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:665
msgid "跳轉資訊分任務"
msgstr "跳轉資訊分任務"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:557
msgid "跳轉路徑"
msgstr "跳轉路徑"

#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:254
msgid "跳轉連接"
msgstr "跳轉連接"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateDetailCard.web.tsx:183
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:67
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:181
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/PosterListField/SortableRow.web.tsx:86
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:110
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/constants.ts:54
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:135
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:540
#: apps/dp-admin/src/components/LandingPage/LandingPageDetailInfo/index.web.tsx:71
msgid "跳轉鏈接"
msgstr "跳轉鏈接"

#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:124
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:164
msgid "跳轉鏈接（內部連結）"
msgstr "跳轉鏈接（內部連結）"

#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:128
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:165
msgid "跳轉鏈接（外部連結）"
msgstr "跳轉鏈接（外部連結）"

#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:358
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:476
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:429
msgid "跳轉鏈接不存在"
msgstr "跳轉鏈接不存在"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:289
msgid "跳轉頁面"
msgstr "跳轉頁面"

#: packages/navigation/src/hooks.ts:75
#: packages/navigation/src/hooks.ts:91
msgid "跳轉頁面有誤，將跳轉到首頁"
msgstr "跳轉頁面有誤，將跳轉到首頁"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:96
#: apps/dp-admin/src/pages/resource-config/diamond-config/index.web.tsx:221
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:244
#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/index.web.tsx:102
msgid "跳轉類型"
msgstr "跳轉類型"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:162
msgid "跳過"
msgstr "跳過"

#. placeholder {0}: skippedItems.length
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:107
msgid "跳過 ({0})"
msgstr "跳過 ({0})"

#. placeholder {0}: result?.skippedCount ?? 0
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:86
msgid "跳過 {0} 家"
msgstr "跳過 {0} 家"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/BatchResultModal/index.web.tsx:109
msgid "跳過原因"
msgstr "跳過原因"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:259
msgid "跳過延遲"
msgstr "跳過延遲"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:272
msgid "跳過延遲必須小於展示時長"
msgstr "跳過延遲必須小於展示時長"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:268
msgid "身份證反面"
msgstr "身份證反面"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:201
#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:147
msgid "身份證圖片"
msgstr "身份證圖片"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:102
msgid "身份證圖片："
msgstr "身份證圖片："

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerFormModal/index.web.tsx:155
msgid "身份證圖片上傳中或上傳失敗，請稍候或重新上傳"
msgstr "身份證圖片上傳中或上傳失敗，請稍候或重新上傳"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/hooks.ts:64
msgid "身份證字號"
msgstr "身份證字號"

#: apps/dp-admin/src/pages/merchant/components/identity-fields/hooks.ts:57
#: apps/dp-admin/src/pages/merchant/components/identity-fields/PersonalIdentityFields.web.tsx:37
msgid "身份證字號格式不正確"
msgstr "身份證字號格式不正確"

#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/OwnerInfo/index.web.tsx:42
msgid "身份證正反面"
msgstr "身份證正反面"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/RepresentativeInfo/index.web.tsx:233
msgid "身份證正面"
msgstr "身份證正面"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:89
#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:136
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/EntryTab/components/OwnerInfo/index.web.tsx:37
msgid "身份證號"
msgstr "身份證號"

#: apps/dp-client/src/configs/page-configs.tsx:1308
#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:179
msgid "身份驗證"
msgstr "身份驗證"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:113
#: apps/dp-admin/src/pages/merchant/audit-detail/utils/transformers.ts:244
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:240
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:119
msgid "身分證"
msgstr "身分證"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:74
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:116
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:151
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:274
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:85
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:28
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:215
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:248
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:254
#: apps/dp-admin/src/pages/merchant/audit-detail/components/LegalPerson/index.web.tsx:71
#: apps/dp-admin/src/pages/merchant/audit-detail/components/LegalPerson/index.web.tsx:76
#: apps/dp-admin/src/pages/merchant/audit-detail/components/AccountInfo/index.web.tsx:75
#: apps/dp-admin/src/pages/merchant/audit-detail/components/AccountInfo/index.web.tsx:80
msgid "身分證反面"
msgstr "身分證反面"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:228
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:163
msgid "身分證圖片"
msgstr "身分證圖片"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:165
msgid "身分證地址"
msgstr "身分證地址"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:1048
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:290
msgid "身分證字號"
msgstr "身分證字號"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:141
#: apps/dp-admin/src/pages/merchant/components/ActualManagerSection/index.web.tsx:109
msgid "身分證字號必須為1位字母加9位數字"
msgstr "身分證字號必須為1位字母加9位數字"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:295
msgid "身分證字號格式不正確（首字母 + 9 位數字）"
msgstr "身分證字號格式不正確（首字母 + 9 位數字）"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:129
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/MerchantBusinessInfo/index.web.tsx:241
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:152
msgid "身分證正反面"
msgstr "身分證正反面"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:66
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:108
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:143
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:246
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DocumentUpload/index.web.tsx:77
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:27
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:182
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:231
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:237
#: apps/dp-admin/src/pages/merchant/audit-detail/components/LegalPerson/index.web.tsx:58
#: apps/dp-admin/src/pages/merchant/audit-detail/components/LegalPerson/index.web.tsx:63
#: apps/dp-admin/src/pages/merchant/audit-detail/components/AccountInfo/index.web.tsx:62
#: apps/dp-admin/src/pages/merchant/audit-detail/components/AccountInfo/index.web.tsx:67
msgid "身分證正面"
msgstr "身分證正面"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:182
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:122
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:82
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:261
msgid "身分證發證地點"
msgstr "身分證發證地點"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:170
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:111
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:146
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:248
msgid "身分證發證日期"
msgstr "身分證發證日期"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/index.web.tsx:204
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/RepresentativeInfo/components/IdCardOcrModal/index.web.tsx:143
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DomesticIndividual/index.web.tsx:108
msgid "身分證的領補換資料"
msgstr "身分證的領補換資料"

#: apps/dp-admin/src/pages/merchant/audit-detail/utils/transformers.ts:243
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:207
#: apps/dp-admin/src/pages/merchant/audit-detail/components/LegalPerson/index.web.tsx:40
#: apps/dp-admin/src/pages/merchant/audit-detail/components/AccountInfo/index.web.tsx:45
msgid "身分證號碼"
msgstr "身分證號碼"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:369
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:49
msgid "車輛行駛至路口，指示牌顯示「大熊美食餐廳停車場由此進」，道路旁有小熊造型路燈。"
msgstr "車輛行駛至路口，指示牌顯示「大熊美食餐廳停車場由此進」，道路旁有小熊造型路燈。"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/ParkingLotsTab/ParkingLotCard.web.tsx:211
msgid "車輛類型"
msgstr "車輛類型"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:60
msgid "軟廣"
msgstr "軟廣"

#: apps/dp-client/src/utils/format.ts:77
#: apps/dp-client/src/screens/home/pages/Note/utils/index.ts:7
msgid "較差"
msgstr "較差"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:170
#: apps/dp-client/src/screens/diary/pages/my/components/UserProfileSection.tsx:104
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1316
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:44
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:53
msgid "載入中"
msgstr "載入中"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:307
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/TextMenu/index.tsx:80
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/TextMenu/components/FoodItemList.tsx:82
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/DishDetail/DishDetailPage.tsx:152
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:322
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:394
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:483
#: apps/dp-client/src/screens/home/pages/Search/index.tsx:624
#: apps/dp-client/src/screens/home/pages/Review/components/RecommendDishesModal/index.tsx:120
#: apps/dp-client/src/screens/home/pages/Review/components/RecommendDishesModal/index.tsx:355
#: apps/dp-client/src/screens/home/pages/Purchase/components/SelectDishContent/index.tsx:204
#: apps/dp-client/src/screens/home/pages/PrivateChef/index.tsx:295
#: apps/dp-client/src/screens/home/pages/PackageSearch/index.tsx:598
#: apps/dp-client/src/screens/home/pages/Note/pages/draft/index.tsx:229
#: apps/dp-client/src/screens/home/pages/MerchantGroup/index.tsx:206
#: apps/dp-client/src/screens/home/pages/Meal/pages/shopSelect/index.tsx:355
#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/index.tsx:122
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:228
#: apps/dp-client/src/screens/home/pages/Meal/components/CouponPickerModal/index.tsx:268
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:836
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:536
#: apps/dp-client/src/screens/help/pages/help/index.tsx:80
#: apps/dp-client/src/screens/diary/pages/search/index.tsx:246
#: apps/dp-client/src/screens/diary/pages/my/index.tsx:255
#: apps/dp-client/src/screens/diary/pages/merchant/index.tsx:183
#: apps/dp-client/src/screens/diary/pages/home/index.tsx:418
#: apps/dp-client/src/screens/diary/pages/home/components/points-card/index.tsx:269
#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:553
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:262
#: apps/dp-client/src/screens/diary/pages/detail/components/CommentReply.tsx:314
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:346
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:367
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:386
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:414
#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:761
#: apps/dp-client/src/screens/diary/components/diary-list/index.tsx:143
#: apps/dp-client/src/screens/diary/components/PullToLoad/index.tsx:92
#: apps/dp-client/src/screens/diary/components/ImageViewer/index.tsx:78
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:491
#: apps/dp-client/src/screens/account/pages/order/index.tsx:407
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:199
#: apps/dp-client/src/screens/account/pages/invoice/pages/selectInvoice/index.tsx:138
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowListScene.tsx:78
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:88
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:94
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:100
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:106
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:112
#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:308
#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:467
#: apps/dp-client/src/screens/account/pages/coupon/CouponHistory/index.tsx:355
#: apps/dp-client/src/screens/account/pages/coupon/CouponDetail/index.tsx:489
#: apps/dp-client/src/screens/account/pages/check-phone/bind-phone/index.tsx:103
#: apps/dp-client/src/screens/account/pages/advice/my-feedback/index.tsx:258
#: apps/dp-client/src/screens/account/pages/advice/advice-feedback/index.tsx:250
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:69
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:81
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:99
#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:111
#: apps/dp-client/src/components/PullToLoad/index.tsx:94
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:506
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:514
#: apps/dp-business/src/pages/VerifyPhone/index.tsx:116
#: apps/dp-business/src/pages/VerifyEmail/index.tsx:117
#: apps/dp-business/src/pages/TableManagement/index.tsx:1024
#: apps/dp-business/src/pages/TableManagement/index.tsx:1040
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:822
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:863
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:894
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:641
#: apps/dp-business/src/pages/ServiceManagement/index.tsx:893
#: apps/dp-business/src/pages/ServiceFacilities/index.tsx:496
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:275
#: apps/dp-business/src/pages/ReviewDetail/index.tsx:419
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1883
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:2115
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:2148
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:743
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:769
#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:846
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:790
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1090
#: apps/dp-business/src/pages/OrderList/index.tsx:976
#: apps/dp-business/src/pages/OrderDetails/components/OrderListCard.tsx:81
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationRecordDetail/index.tsx:90
#: apps/dp-business/src/pages/OrderDetail/index.tsx:972
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2570
#: apps/dp-business/src/pages/MyProfile/index.tsx:233
#: apps/dp-business/src/pages/MerchantReview/index.tsx:489
#: apps/dp-business/src/pages/MerchantDashboard/MobileLayout.tsx:125
#: apps/dp-business/src/pages/MerchantDashboard/DesktopLayout.tsx:184
#: apps/dp-business/src/pages/MerchantDashboard/DesktopLayout.tsx:312
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:972
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:189
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:766
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:793
#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1840
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:352
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1114
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1141
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1161
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1185
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1206
#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitSummaryCard.tsx:105
#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:148
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/index.tsx:156
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:210
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/index.tsx:429
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/index.tsx:460
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/index.tsx:190
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityFilterCard.tsx:158
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ResponsiveChart.tsx:223
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:176
#: apps/dp-business/src/pages/CustomerReviews/components/TrendChartSection.tsx:176
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsSection.tsx:160
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:199
#: apps/dp-business/src/pages/CustomerReviews/components/LazyChartSection.tsx:51
#: apps/dp-business/src/pages/CustomerReviews/components/KeywordStatsSection.tsx:144
#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:835
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:716
#: apps/dp-business/src/pages/ComplaintList/index.tsx:168
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:291
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:263
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:297
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:275
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:567
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:609
#: apps/dp-business/src/pages/AddStore/CategoryPage.tsx:233
#: apps/dp-business/src/components/VirtualList/index.tsx:589
#: apps/dp-business/src/components/StoreSelector/index.tsx:500
#: apps/dp-business/src/components/Layout/Container.tsx:210
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:660
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:435
#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:205
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:208
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:135
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileList/index.web.tsx:139
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:208
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:153
#: apps/dp-admin/src/pages/merchant/shared/constants.ts:97
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:549
#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:137
#: apps/dp-admin/src/pages/merchant/components/CityDistrictSelector/index.web.tsx:160
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:168
#: apps/dp-admin/src/pages/marketing/user-activity-detail/components/RankingPreviewModal.web.tsx:91
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityCharts.web.tsx:125
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityCharts.web.tsx:177
#: apps/dp-admin/src/pages/home/index.web.tsx:85
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewTrendChart.web.tsx:119
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/RatingDistributionChart.web.tsx:105
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingTrend.web.tsx:157
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingDistribution.web.tsx:253
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/KeywordStats.web.tsx:130
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:226
#: apps/dp-admin/src/components/InfiniteSearchSelect/index.web.tsx:252
#: apps/dp-admin/src/components/InfiniteSearchSelect/index.web.tsx:269
#: apps/dp-admin/src/components/DraftActions/index.web.tsx:265
msgid "載入中..."
msgstr "載入中..."

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1322
msgid "載入使用記錄中..."
msgstr "載入使用記錄中..."

#: apps/dp-client/src/screens/login/components/fet-login-agreement-modal/index.tsx:48
#: apps/dp-client/src/screens/account/pages/agreement/index.tsx:46
#: apps/dp-client/src/components/HtmlContent/index.tsx:104
msgid "載入內容失敗，請稍後重試"
msgstr "載入內容失敗，請稍後重試"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:737
msgid "載入分類資料中..."
msgstr "載入分類資料中..."

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2113
msgid "載入券碼資料中..."
msgstr "載入券碼資料中..."

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:766
msgid "載入區域資料中..."
msgstr "載入區域資料中..."

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:427
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:297
msgid "載入合約詳情失敗"
msgstr "載入合約詳情失敗"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:433
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:304
msgid "載入合約詳情失敗，請稍後重試"
msgstr "載入合約詳情失敗，請稍後重試"

#: apps/dp-business/src/pages/ContractManagement/index.tsx:132
msgid "載入合約資料失敗，請稍後重試"
msgstr "載入合約資料失敗，請稍後重試"

#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:132
msgid "載入商家營業資訊..."
msgstr "載入商家營業資訊..."

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:76
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:408
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:42
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:43
msgid "載入圖像出錯"
msgstr "載入圖像出錯"

#: apps/dp-client/src/screens/home/pages/PrivateChef/index.tsx:186
#: apps/dp-client/src/screens/home/pages/MerchantGroup/index.tsx:112
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Info/index.tsx:166
#: apps/dp-admin/src/pages/audit-center/components/AuditIssuesList/index.web.tsx:113
msgid "載入失敗"
msgstr "載入失敗"

#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/Details.web.tsx:140
msgid "載入失敗，請重新整理重試"
msgstr "載入失敗，請重新整理重試"

#: apps/dp-client/src/screens/home/pages/Home/components/RecommendMasonryList/index.tsx:263
#: apps/dp-client/src/screens/diary/pages/plaza/index.tsx:314
msgid "載入失敗，請重試"
msgstr "載入失敗，請重試"

#: apps/dp-client/src/components/ShopSelectSheet/index.tsx:337
msgid "載入店家中..."
msgstr "載入店家中..."

#: apps/dp-business/src/pages/MarketingCenter/components/StoreSelectionCard.tsx:305
#: apps/dp-business/src/components/StoreSelector/index.tsx:553
msgid "載入店家列表中..."
msgstr "載入餐廳列表中..."

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BasicInfoTab/index.web.tsx:70
msgid "載入店家詳情..."
msgstr "載入店家詳情..."

#: apps/dp-business/src/pages/OrderList/index.tsx:697
#: apps/dp-business/src/pages/OrderDetails/components/SummaryCardsPanel.tsx:67
msgid "載入指標中..."
msgstr "載入指標中..."

#: apps/dp-business/src/pages/CouponVerification/index.tsx:911
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1158
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:478
msgid "載入收銀記錄中..."
msgstr "載入收銀記錄中..."

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:164
#: apps/dp-client/src/screens/diary/components/diary-list/index.tsx:204
#: apps/dp-client/src/screens/diary/components/PullToLoad/index.tsx:335
#: apps/dp-client/src/screens/diary/components/PullToLoad/index.tsx:360
#: apps/dp-client/src/components/PullToLoad/index.tsx:338
#: apps/dp-client/src/components/PullToLoad/index.tsx:363
msgid "載入更多"
msgstr "載入更多"

#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:262
#: apps/dp-client/src/screens/home/pages/ShopList/hooks/useShopListRenderers.tsx:282
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/NoteSection/index.tsx:230
#: apps/dp-client/src/screens/home/pages/Ranking/DishRank/index.tsx:241
#: apps/dp-client/src/screens/home/pages/PrivateChef/index.tsx:272
#: apps/dp-client/src/screens/home/pages/PackageZone/components/PackageZoneContent/index.tsx:254
#: apps/dp-client/src/screens/home/pages/Note/components/MarkShopModal/index.tsx:376
#: apps/dp-client/src/screens/home/pages/MerchantGroup/index.tsx:188
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/SetMealList/index.tsx:258
#: apps/dp-client/src/screens/home/pages/MallDetail/pages/MallShopList/index.tsx:332
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallNoteSection/index.tsx:253
#: apps/dp-client/src/screens/home/pages/FoodMapSearch/index.tsx:747
#: apps/dp-client/src/screens/account/pages/user-profile/index.tsx:513
#: apps/dp-client/src/screens/account/pages/user-profile/pages/search/index.tsx:182
#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/index.tsx:152
#: apps/dp-client/src/screens/account/pages/order/index.tsx:503
#: apps/dp-client/src/screens/account/pages/order/pages/searchResult/index.tsx:234
#: apps/dp-client/src/screens/account/pages/favorites/components/ShopContent/index.tsx:138
msgid "載入更多..."
msgstr "載入更多..."

#: apps/dp-client/src/store/shopStore.ts:511
msgid "載入更多店家照片失敗"
msgstr "載入更多店家照片失敗"

#: apps/dp-client/src/store/shopStore.ts:404
msgid "載入更多招牌菜失敗"
msgstr "載入更多招牌菜失敗"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:714
msgid "載入更多評論..."
msgstr "載入更多評論..."

#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:298
msgid "載入服務資料中..."
msgstr "載入服務資料中..."

#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/index.tsx:68
msgid "載入權益列表失敗，請稍後重試"
msgstr "載入權益列表失敗，請稍後重試"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:751
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:824
msgid "載入權限中..."
msgstr "載入權限中..."

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/index.tsx:81
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:185
msgid "載入活動列表失敗，請稍後重試"
msgstr "載入活動列表失敗，請稍後重試"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityDetails.tsx:129
msgid "載入活動詳情中..."
msgstr "載入活動詳情中..."

#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:209
msgid "載入活動詳情失敗，請重試"
msgstr "載入活動詳情失敗，請重試"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:401
msgid "載入活動資料中..."
msgstr "載入活動資料中..."

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/index.tsx:96
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/index.tsx:306
msgid "載入活動資料失敗，請稍後重試"
msgstr "載入活動資料失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1165
msgid "載入菜品資料中..."
msgstr "載入餐點資料中..."

#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:330
msgid "載入菜單資料..."
msgstr "載入菜單資料..."

#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:63
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:231
msgid "載入複製記錄失敗"
msgstr "載入複製記錄失敗"

#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:344
msgid "載入訂單詳情..."
msgstr "載入訂單詳情..."

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:572
msgid "載入訂單資料中..."
msgstr "載入訂單資料中..."

#: apps/dp-admin/src/pages/merchant/components/StoreSettingsSection/index.web.tsx:261
msgid "載入設施資料中..."
msgstr "載入設施資料中..."

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:701
msgid "載入評論中..."
msgstr "載入評論中..."

#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:82
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:63
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:248
msgid "載入詳情失敗"
msgstr "載入詳情失敗"

#: apps/dp-client/src/screens/home/pages/PackageZone/components/PackageZoneShopSheet/index.tsx:258
msgid "載入門市中..."
msgstr "載入門市中..."

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:461
#: apps/dp-client/src/screens/account/pages/invoice/pages/invoicing/index.tsx:689
msgid "載具"
msgstr "載具"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:103
msgid "輪播規則：3秒自動滾動，支持手動切換"
msgstr "輪播規則：3秒自動滾動，支持手動切換"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/AppPushTemplateSection.web.tsx:15
msgid "輸入App Push標題"
msgstr "輸入App Push標題"

#: apps/dp-business/src/pages/Login/index.tsx:891
#: apps/dp-business/src/pages/Login/index.tsx:1365
msgid "輸入Email或手機免費進駐，讓更多顧客找到您"
msgstr "輸入Email或手機免費進駐，讓更多顧客找到您"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:413
msgid "輸入一個響亮好記的暱稱吧"
msgstr "輸入一個響亮好記的暱稱吧"

#: apps/dp-client/src/screens/home/components/RichTextInput/utils/constants.ts:207
msgid "輸入事件處理錯誤"
msgstr "輸入事件處理錯誤"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:79
msgid "輸入以下詞彙會被高亮：美食、推薦、好吃、不錯、讚"
msgstr "輸入以下詞彙會被特別強調：美食、推薦、好吃、不錯、讚"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:214
msgid "輸入備註內容..."
msgstr "輸入備註內容..."

#: apps/dp-business/src/pages/SimpleDashboard/components/ManualInputCard.tsx:81
#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/components/VerificationFilterBar.tsx:59
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesFilterBar.tsx:65
msgid "輸入券碼"
msgstr "輸入券碼"

#: apps/dp-business/src/pages/ChangePassword/index.tsx:215
msgid "輸入原密碼"
msgstr "輸入原密碼"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:102
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:102
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:529
msgid "輸入品牌名稱搜索"
msgstr "輸入品牌名稱搜索"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/MerchantInfoSection.web.tsx:101
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/MerchantInfoSection/index.web.tsx:114
msgid "輸入商家名稱、ID、統編檢索"
msgstr "輸入商家名稱、ID、統編檢索"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:128
msgid "輸入商家名稱、商家ID、統編"
msgstr "輸入商家名稱、商家ID、統編"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:163
msgid "輸入商家名稱或ID搜尋"
msgstr "輸入商家名稱或ID搜尋"

#: apps/dp-admin/src/pages/worker-order/components/MerchantSearchSelect.web.tsx:29
msgid "輸入商家名稱搜尋"
msgstr "輸入商家名稱搜尋"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/ShopTargetingConfig/index.web.tsx:62
msgid "輸入商家組名稱搜索"
msgstr "輸入商家組名稱搜索"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:286
msgid "輸入回覆"
msgstr "輸入回覆"

#: apps/dp-admin/src/components/MapPicker/index.web.tsx:557
msgid "輸入地址或地點名稱搜尋"
msgstr "輸入地址或地點名稱搜尋"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/PriceSection/index.web.tsx:227
msgid "輸入套餐價格"
msgstr "輸入套餐價格"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ManualPackageSelector/index.web.tsx:35
msgid "輸入套餐名稱或套餐 ID"
msgstr "輸入套餐名稱或套餐 ID"

#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:311
#: apps/dp-client/src/screens/account/pages/account-security/check-password/index.tsx:98
#: apps/dp-client/src/screens/account/pages/account-security/check-password/index.tsx:103
msgid "輸入密碼"
msgstr "輸入密碼"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ClientSearchPanel/index.web.tsx:72
msgid "輸入店家名稱搜索"
msgstr "輸入店家名稱搜索"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:218
msgid "輸入店家組名稱搜索，不選則適用全部店家"
msgstr "輸入店家組名稱搜索，不選則適用全部店家"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:328
msgid "輸入折扣價"
msgstr "輸入折扣價"

#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:117
msgid "輸入推薦碼"
msgstr "輸入推薦碼"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:102
msgid "輸入支付單號"
msgstr "輸入支付單號"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:297
msgid "輸入數字"
msgstr "輸入數字"

#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:161
#: apps/dp-business/src/pages/ChangePassword/index.tsx:232
msgid "輸入新密碼"
msgstr "輸入新密碼"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantTags/index.web.tsx:93
msgid "輸入新標籤名稱"
msgstr "輸入新標籤名稱"

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/components/VerificationFilterBar.tsx:68
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesFilterBar.tsx:74
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/components/DiscountFilterBar.tsx:63
msgid "輸入暱稱、用戶ID或聯繫方式"
msgstr "輸入暱稱、用戶ID或聯繫方式"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:119
msgid "輸入業務訂單號"
msgstr "輸入業務訂單號"

#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:52
msgid "輸入標籤名/標籤ID"
msgstr "輸入標籤名/標籤ID"

#: apps/dp-admin/src/pages/merchant/components/TagEditor/index.web.tsx:211
msgid "輸入標籤名稱"
msgstr "輸入標籤名稱"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateSelector/index.web.tsx:163
msgid "輸入模版名稱搜索"
msgstr "輸入模版名稱搜索"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardRulesEditor/index.web.tsx:186
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/BenefitInfiniteSelect/index.web.tsx:88
msgid "輸入權益名稱搜索"
msgstr "輸入權益名稱搜索"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:136
msgid "輸入用戶ID"
msgstr "輸入用戶ID"

#: apps/dp-admin/src/pages/customer-service/components/CreateTicketModal.web.tsx:89
msgid "輸入用戶ID、電話、郵箱進行檢索"
msgstr "輸入用戶ID、電話、郵箱進行檢索"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/UserTargetingConfig/index.web.tsx:73
msgid "輸入用戶組名稱搜索"
msgstr "輸入用戶組名稱搜索"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:229
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:174
msgid "輸入用戶組名稱搜索，不選則適用全部用戶"
msgstr "輸入用戶組名稱搜索，不選則適用全部用戶"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/InAppTemplateSection.web.tsx:15
msgid "輸入站內信標題"
msgstr "輸入站內信標題"

#: apps/dp-admin/src/pages/merchant/components/StoreSettingsSection/index.web.tsx:216
msgid "輸入自定義設施名稱"
msgstr "輸入自定義設施名稱"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/LandingPageConfig/index.web.tsx:68
msgid "輸入落地頁名稱搜索"
msgstr "輸入落地頁名稱搜索"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:215
msgid "輸入處理備註..."
msgstr "輸入處理備註..."

#: apps/dp-business/src/pages/OrderDetails/SetMealVerificationDetail/components/VerificationFilterBar.tsx:50
#: apps/dp-business/src/pages/OrderDetails/SetMealSalesOrder/components/SalesFilterBar.tsx:56
#: apps/dp-business/src/pages/OrderDetails/DiscountOrder/components/DiscountFilterBar.tsx:54
msgid "輸入訂單ID"
msgstr "輸入訂單ID"

#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:96
msgid "輸入運營人員名稱、商家ID"
msgstr "輸入運營人員名稱、商家ID"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/EmailTemplateSection.web.tsx:13
msgid "輸入郵件主題"
msgstr "輸入郵件主題"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1236
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1237
msgid "輸入金額"
msgstr "輸入金額"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:314
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:294
msgid "輸入門戶品牌名稱搜索"
msgstr "輸入門戶品牌名稱搜索"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:81
msgid "輸入關鍵字"
msgstr "輸入關鍵字"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/ShopInfoSection.web.tsx:37
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/ShopInfoSection/index.web.tsx:47
msgid "輸入食品業者登記字號"
msgstr "輸入食品業者登記字號"

#: apps/dp-client/src/components/verify-code-sender/index.tsx:61
msgid "輸入驗證碼"
msgstr "輸入驗證碼"

#: apps/dp-business/src/pages/CustomerReviews/components/QualityMonitoringSection.tsx:108
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SentimentMonitor.web.tsx:136
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/SentimentMonitor.web.tsx:136
msgid "輿情監控"
msgstr "輿情監控"

#: apps/dp-business/src/components/ClaimAmountAlert/index.tsx:35
msgid "轉帳手續費由去哪吃平台吸收，您無需額外負擔。"
msgstr "轉帳手續費由去哪吃平台吸收，您無需額外負擔。"

#: apps/dp-client/src/screens/diary/pages/my/pages/profile/index.tsx:328
msgid "轉換圖片格式失敗，請重試"
msgstr "轉換圖片格式失敗，請重試"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:106
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:195
msgid "轉派"
msgstr "轉派"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:38
msgid "轉派中"
msgstr "轉派中"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:408
msgid "轉至報修類型"
msgstr "轉至報修類型"

#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:63
msgid "辱罵/攻擊"
msgstr "辱罵/攻擊"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1400
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1506
#: apps/dp-business/src/pages/CustomerReviews/components/TrendChartSection.tsx:163
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:66
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:184
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingTrend.web.tsx:149
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingDistribution.web.tsx:246
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:32
msgid "近30天"
msgstr "近30天"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:371
msgid "近30天參與用戶"
msgstr "近30天參與用戶"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:378
msgid "近30天訂單金額"
msgstr "近30天訂單金額"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1399
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1505
#: apps/dp-business/src/pages/CustomerReviews/components/TrendChartSection.tsx:162
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:65
#: apps/dp-business/src/pages/CustomerReviews/components/RatingDistributionSection.tsx:183
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingTrend.web.tsx:142
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/RatingDistribution.web.tsx:239
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:31
msgid "近7天"
msgstr "近7天"

#: apps/dp-admin/src/pages/resource-config/category-management/services/constants.ts:88
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:622
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:651
msgid "近7日添加"
msgstr "近7日添加"

#: apps/dp-business/src/pages/SimpleDashboard/SimpleLayout.tsx:197
msgid "近期收銀"
msgstr "近期收銀"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:392
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:395
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:457
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:460
msgid "近期暫無可預訂座位"
msgstr "近期暫無可預訂座位"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:152
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopLocationInfo.tsx:307
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:180
msgid "近期營業時間調整"
msgstr "近期營業時間調整"

#: apps/dp-client/src/screens/home/pages/PrivateChef/constants.ts:10
msgid "近期開放"
msgstr "近期開放"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:1253
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:235
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:788
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1253
#: apps/dp-business/src/pages/MerchantDashboard/MobileLayout.tsx:189
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:344
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:409
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:2189
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:140
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:220
#: apps/dp-business/src/pages/AddStore/CategoryPage.tsx:221
#: apps/dp-business/src/components/BackButton.tsx:30
#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:226
#: apps/dp-business/src/components/GoogleMap/index.tsx:789
#: apps/dp-business/src/components/GoogleMap/WebViewMap.tsx:719
#: apps/dp-business/src/components/Button/index.tsx:177
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:229
#: apps/dp-admin/src/pages/user-info/user-detail/index.web.tsx:119
#: apps/dp-admin/src/pages/user-info/reservation-detail/index.web.tsx:74
#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:307
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:500
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:321
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/index.web.tsx:71
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:605
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:239
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:255
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:238
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:256
#: apps/dp-admin/src/pages/resource-config/slot-material-detail/index.web.tsx:538
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:375
#: apps/dp-admin/src/pages/resource-config/message-template-edit/index.web.tsx:301
#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:504
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:172
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:178
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:197
#: apps/dp-admin/src/pages/other/profile/index.web.tsx:199
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:322
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:323
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:131
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:120
#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:353
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:370
#: apps/dp-admin/src/pages/order/merchant-order-list/index.web.tsx:62
#: apps/dp-admin/src/pages/merchant/task-detail/index.web.tsx:171
#: apps/dp-admin/src/pages/merchant/task-detail/index.web.tsx:196
#: apps/dp-admin/src/pages/merchant/shop-detail/index.web.tsx:790
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeMountNodeModal.web.tsx:137
#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:230
#: apps/dp-admin/src/pages/merchant/shop-create/index.web.tsx:265
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:786
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:788
#: apps/dp-admin/src/pages/merchant/merchant-onboard/index.web.tsx:56
#: apps/dp-admin/src/pages/merchant/merchant-onboard/index.web.tsx:58
#: apps/dp-admin/src/pages/merchant/merchant-menu/index.web.tsx:308
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/index.web.tsx:219
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:111
#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:176
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:294
#: apps/dp-admin/src/pages/merchant/components/PageHeader/index.web.tsx:43
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/index.web.tsx:100
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/index.web.tsx:260
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/index.web.tsx:81
#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:280
#: apps/dp-admin/src/pages/merchant/audit-detail/components/PageHeader/index.web.tsx:23
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:55
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:207
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1103
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1427
#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:189
#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:259
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/index.web.tsx:45
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/index.web.tsx:63
#: apps/dp-admin/src/pages/marketing/merchant-activity-config-form/index.web.tsx:592
#: apps/dp-admin/src/pages/marketing/general-activity-detail/index.web.tsx:79
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/PublishPreviewModal.web.tsx:95
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/index.web.tsx:197
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/index.web.tsx:65
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/index.web.tsx:66
#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:506
#: apps/dp-admin/src/pages/marketing/benefit-form/index.web.tsx:577
#: apps/dp-admin/src/pages/marketing/activity-statistics/index.web.tsx:118
#: apps/dp-admin/src/pages/marketing/activity-detail-list/index.web.tsx:245
#: apps/dp-admin/src/pages/marketing/activity-create/index.web.tsx:495
#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:1200
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:221
#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:333
#: apps/dp-admin/src/pages/data-center/review-detail/index.web.tsx:68
#: apps/dp-admin/src/pages/customer-service/ticket-detail/index.web.tsx:152
#: apps/dp-admin/src/pages/audit-center/user-audit/index.web.tsx:62
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/index.web.tsx:37
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/index.web.tsx:54
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/index.web.tsx:68
#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:422
#: apps/dp-admin/src/pages/audit-center/review-audit/index.web.tsx:132
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:53
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:70
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/index.web.tsx:97
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:186
#: apps/dp-admin/src/pages/audit-center/merchant-audit/index.web.tsx:163
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:267
#: apps/dp-admin/src/pages/audit-center/info-confirm/index.web.tsx:74
#: apps/dp-admin/src/pages/audit-center/info-confirm/index.web.tsx:91
#: apps/dp-admin/src/pages/audit-center/info-confirm/index.web.tsx:105
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/MerchantBasicInfo/index.web.tsx:66
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:243
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:426
#: apps/dp-admin/src/components/ListPage/index.web.tsx:86
msgid "返回"
msgstr "返回"

#: apps/dp-client/src/screens/home/pages/ShopList/components/LocationTip/index.tsx:71
msgid "返回{cityName}搜尋"
msgstr "返回{cityName}搜尋"

#: apps/dp-admin/src/pages/error/404.web.tsx:90
#: apps/dp-admin/src/pages/error/403.web.tsx:94
msgid "返回上一頁"
msgstr "返回上一頁"

#: apps/dp-business/src/pages/AddStore/index.tsx:1083
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:243
#: apps/dp-admin/src/pages/org-tree/org-detail/components/SubmitEditConfirm/index.web.tsx:42
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:150
msgid "返回修改"
msgstr "返回修改"

#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:743
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:186
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-detail/index.web.tsx:202
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:176
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-detail/index.web.tsx:192
#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:122
#: apps/dp-admin/src/pages/org-tree/org-create/index.web.tsx:105
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:150
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/index.web.tsx:49
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:160
msgid "返回列表"
msgstr "返回列表"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:592
#: apps/dp-client/src/screens/payment/pages/result/index.tsx:618
#: apps/dp-client/src/screens/payment/pages/result/index.tsx:641
msgid "返回商圈"
msgstr "返回商圈"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:561
msgid "返回商圈詳情頁"
msgstr "返回商圈詳情頁"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:594
#: apps/dp-client/src/screens/payment/pages/result/index.tsx:618
#: apps/dp-client/src/screens/payment/pages/result/index.tsx:641
msgid "返回商家"
msgstr "返回商家"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:429
msgid "返回商家列表"
msgstr "返回商家列表"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:564
#: apps/dp-client/src/screens/home/pages/Meal/pages/result/index.tsx:71
msgid "返回商家詳情頁"
msgstr "返回商家詳情頁"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:563
#: apps/dp-client/src/screens/payment/pages/result/index.tsx:595
msgid "返回店家"
msgstr "返回店家"

#: apps/dp-admin/src/pages/marketing/activity-statistics/index.web.tsx:99
msgid "返回活動列表"
msgstr "返回活動列表"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:161
msgid "返回當前審核單"
msgstr "返回當前審核單"

#: apps/dp-business/src/pages/AccountDeactivationSuccess/index.tsx:64
msgid "返回登入頁"
msgstr "返回登入頁"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:494
msgid "返回訂位管理"
msgstr "返回訂位管理"

#: apps/dp-client/src/screens/home/pages/ShopList/components/LocationTip/index.tsx:69
msgid "返回附近搜尋"
msgstr "返回附近搜尋"

#: apps/dp-business/src/pages/OnboardingComplete/index.tsx:35
#: apps/dp-admin/src/pages/error/404.web.tsx:86
msgid "返回首頁"
msgstr "返回首頁"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:83
msgid "追加任務已受理，請在生成批次中查看進度"
msgstr "追加任務已受理，請在生成批次中查看進度"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:178
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:96
msgid "追加券碼"
msgstr "追加券碼"

#: apps/dp-admin/src/pages/marketing/activity-config-list/services/couponCodes.ts:117
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:86
msgid "追加券碼失敗"
msgstr "追加券碼失敗"

#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:83
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:236
msgid "追加匯入"
msgstr "追加匯入"

#: apps/dp-admin/src/pages/marketing/user-group-list/components/columns/index.web.tsx:267
#: apps/dp-admin/src/pages/marketing/merchant-group-list/components/columns/index.web.tsx:237
msgid "追加導入"
msgstr "追加導入"

#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:100
msgid "追加導入名單成員"
msgstr "追加導入名單成員"

#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:92
msgid "追加導入提交失敗"
msgstr "追加導入提交失敗"

#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:161
msgid "追加數量"
msgstr "追加數量"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/AuthorRelationshipButton.tsx:23
#: apps/dp-client/src/screens/account/pages/user-profile/components/UserInfoSection/index.tsx:127
#: apps/dp-client/src/screens/account/pages/user-profile/components/UserInfoSection/index.tsx:225
#: apps/dp-client/src/screens/account/pages/profile/components/UserInfoSection/index.tsx:105
#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:164
#: apps/dp-client/src/screens/account/pages/notifications/components/FollowNotificationCard/index.tsx:44
#: apps/dp-client/src/screens/account/pages/follow-list/index.tsx:16
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowUserListItem.tsx:59
msgid "追蹤"
msgstr "追蹤"

#: apps/dp-admin/src/modules/constants/options.ts:136
msgid "追蹤中"
msgstr "追蹤中"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:148
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:190
msgid "追蹤商家進度"
msgstr "追蹤商家進度"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:149
#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:191
msgid "追蹤商家進駐進度並提供協助"
msgstr "追蹤商家進駐進度並提供協助"

#: apps/dp-client/src/screens/account/pages/user-profile/components/UserInfoSection/index.tsx:225
#: apps/dp-client/src/screens/account/pages/follow-list/components/FollowUserListItem.tsx:58
msgid "追蹤回去"
msgstr "追蹤回去"

#: apps/dp-admin/src/modules/constants/options.ts:137
msgid "追蹤完成"
msgstr "追蹤完成"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:444
msgid "追蹤拜訪"
msgstr "追蹤拜訪"

#: apps/dp-admin/src/pages/merchant/components/HistoryTable/index.web.tsx:45
msgid "追蹤時間"
msgstr "追蹤時間"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskHandlerModal/index.web.tsx:150
#: apps/dp-admin/src/pages/merchant/task-list/components/FollowUpHistoryModal/index.web.tsx:50
#: apps/dp-admin/src/pages/merchant/task-list/components/ActionButtons/index.web.tsx:69
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:545
#: apps/dp-admin/src/pages/merchant/components/TaskAssigneeModal/index.web.tsx:228
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:268
msgid "追蹤歷史"
msgstr "追蹤歷史"

#: apps/dp-admin/src/pages/merchant/task-list/components/FollowUpHistoryModal/index.web.tsx:104
msgid "追蹤歷史記錄"
msgstr "追蹤歷史記錄"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:846
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:534
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:277
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:396
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:375
#: apps/dp-admin/src/pages/merchant/components/HistoryTable/index.web.tsx:63
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:70
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:182
msgid "追蹤狀態"
msgstr "追蹤狀態"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskTable/index.web.tsx:124
#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:84
#: apps/dp-admin/src/pages/merchant/components/HistoryTable/index.web.tsx:54
msgid "追蹤者"
msgstr "追蹤者"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/index.web.tsx:152
#: apps/dp-admin/src/pages/merchant/shop-list/index.web.tsx:149
#: apps/dp-admin/src/pages/merchant/my-shop/index.web.tsx:163
msgid "追蹤記錄保存成功"
msgstr "追蹤記錄保存成功"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:182
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ActionButtons/index.web.tsx:105
#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:115
#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:296
msgid "追蹤詳情"
msgstr "追蹤詳情"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:508
#: apps/dp-admin/src/pages/merchant/components/HistoryTable/index.web.tsx:120
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:194
msgid "追蹤說明"
msgstr "追蹤說明"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:511
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:200
msgid "追蹤說明不少於10個字"
msgstr "追蹤說明不少於10個字"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:512
#: apps/dp-admin/src/pages/merchant/components/FollowUpContent/index.web.tsx:201
msgid "追蹤說明不超過9999個字"
msgstr "追蹤說明不超過9999個字"

#: apps/dp-admin/src/pages/merchant/follow-up-detail/index.web.tsx:364
msgid "追蹤資訊"
msgstr "追蹤資訊"

#: apps/dp-client/src/configs/page-configs.tsx:1714
#: apps/dp-client/src/configs/page-configs.tsx:1716
msgid "追蹤通知"
msgstr "追蹤通知"

#: apps/dp-admin/src/pages/merchant/components/HistoryTable/index.web.tsx:79
msgid "追蹤進度"
msgstr "追蹤進度"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:866
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:474
msgid "退出"
msgstr "退出"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:281
msgid "退出後將無法繼續享受流量曝光與平台補貼喔，請謹慎操作"
msgstr "退出後將無法繼續享受流量曝光與平台補貼喔，請謹慎操作"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:1058
msgid "退出活動"
msgstr "退出活動"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:465
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:300
msgid "退出活動失敗，請稍後重試"
msgstr "退出活動失敗，請稍後重試"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:496
#: apps/dp-admin/src/pages/org-tree/org-detail/index.web.tsx:132
msgid "退出編輯"
msgstr "退出編輯"

#: apps/dp-admin/src/pages/worker-order/services/constants.ts:107
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:198
msgid "退單"
msgstr "退單"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:526
#: apps/dp-client/src/screens/account/pages/order/index.tsx:49
#: apps/dp-business/src/servers/order/types.ts:104
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:674
#: apps/dp-business/src/pages/OrderList/index.tsx:939
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1701
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2102
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:58
#: apps/dp-admin/src/pages/split-account/services/constants.ts:69
#: apps/dp-admin/src/pages/report-center/services/interface/manual-compensation.ts:70
#: apps/dp-admin/src/pages/order/services/utils.ts:63
#: apps/dp-admin/src/pages/marketing/services/constants.ts:336
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:205
msgid "退款"
msgstr "退款"

#. placeholder {0}: selectedCoupons.length
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2101
msgid "退款 ({0})"
msgstr "退款（{0}）"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:536
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:104
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:84
#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:67
#: apps/dp-business/src/servers/order/types.ts:191
#: apps/dp-business/src/servers/order/types.ts:266
#: apps/dp-business/src/pages/RefundList/index.tsx:146
#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCells.tsx:118
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherUsageReport.tsx:68
#: apps/dp-business/src/pages/ChainDashboard/components/reports/VoucherSalesReport.tsx:68
#: apps/dp-admin/src/pages/user-info/user-detail/components/UserCouponListTab/services/config.web.tsx:47
#: apps/dp-admin/src/pages/user-info/user-coupon-list/services/config.web.tsx:41
#: apps/dp-admin/src/pages/order/services/utils.ts:180
#: apps/dp-admin/src/pages/order/services/utils.ts:320
#: apps/dp-admin/src/pages/marketing/verification-record/services/utils.ts:29
#: apps/dp-admin/src/pages/marketing/services/constants.ts:321
msgid "退款中"
msgstr "退款中"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:193
msgid "退款中（{total}）"
msgstr "退款中（{total}）"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1870
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2178
msgid "退款人"
msgstr "退款人"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:738
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1060
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:169
msgid "退款備註"
msgstr "退款備註"

#: apps/dp-business/src/pages/RefundList/index.tsx:427
msgid "退款列表"
msgstr "退款列表"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:161
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:544
#: apps/dp-business/src/pages/RefundList/index.tsx:294
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1877
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2185
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:311
#: apps/dp-admin/src/pages/order/order-detail/components/RefundRecords/index.web.tsx:53
msgid "退款原因"
msgstr "退款原因"

#: apps/dp-admin/src/pages/report-center/services/interface/manual-compensation.ts:72
msgid "退款和退發票"
msgstr "退款和退發票"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:142
#: apps/dp-admin/src/pages/order/order-detail/components/RefundRecords/index.web.tsx:21
msgid "退款單號"
msgstr "退款單號"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:112
#: apps/dp-business/src/servers/order/types.ts:274
#: apps/dp-business/src/pages/OrderDetail/index.tsx:678
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:27
#: apps/dp-admin/src/pages/order/services/utils.ts:340
#: apps/dp-admin/src/pages/order/services/utils.ts:444
#: apps/dp-admin/src/pages/marketing/services/constants.ts:325
msgid "退款失敗"
msgstr "退款失敗"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1260
#: apps/dp-admin/src/pages/marketing/services/apis.ts:1073
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/hooks.ts:265
msgid "退款失敗，請稍後重試"
msgstr "退款失敗，請稍後重試"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:73
msgid "退款失敗請聯繫客服"
msgstr "退款失敗請聯繫客服"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:59
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2516
#: apps/dp-admin/src/pages/order/services/utils.ts:571
msgid "退款完成"
msgstr "退款完成"

#: apps/dp-business/src/pages/RefundList/index.tsx:303
msgid "退款完成時間"
msgstr "退款完成時間"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:674
#: apps/dp-admin/src/pages/order/services/utils.ts:434
msgid "退款已受理"
msgstr "退款已受理"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:562
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:92
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:99
msgid "退款已退回至原付款方"
msgstr "退款已退回至原付款方"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:152
msgid "退款張數"
msgstr "退款張數"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:676
#: apps/dp-admin/src/pages/order/services/utils.ts:439
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/hooks.ts:260
msgid "退款成功"
msgstr "退款成功"

#: apps/dp-business/src/pages/ChainDashboard/components/reports/reportCommonColumns.tsx:90
msgid "退款成功時間"
msgstr "退款成功時間"

#: apps/dp-business/src/pages/RefundList/index.tsx:270
msgid "退款手續費"
msgstr "退款手續費"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:193
msgid "退款描述"
msgstr "退款描述"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:854
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1188
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:185
msgid "退款提交後，款項預計24小時內會原路返回至用戶的付款帳戶。"
msgstr "退款提交後，款項預計24小時內會原路返回至用戶的付款帳戶。"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:432
msgid "退款數量"
msgstr "退款數量"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:188
msgid "退款數量必須大於0"
msgstr "退款數量必須大於0"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:60
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/RefundOrdersCard/index.web.tsx:66
msgid "退款時間"
msgstr "退款時間"

#: apps/dp-business/src/pages/RefundList/index.tsx:279
#: apps/dp-business/src/pages/RefundList/index.tsx:395
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:80
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:79
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/RefundOrdersCard/index.web.tsx:43
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:113
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:334
#: apps/dp-admin/src/pages/order/order-detail/components/RefundRecords/index.web.tsx:43
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:135
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/config.web.tsx:46
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/OrderTable/index.web.tsx:159
msgid "退款狀態"
msgstr "退款狀態"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/OverviewCards.web.tsx:86
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/OverviewCards.web.tsx:84
#: apps/dp-admin/src/pages/report-center/daily-overview/index.web.tsx:74
msgid "退款率"
msgstr "退款率"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2515
#: apps/dp-admin/src/pages/order/services/utils.ts:566
msgid "退款申請中"
msgstr "退款申請中"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:267
msgid "退款申請失敗，請稍後重試"
msgstr "退款申請失敗，請稍後重試"

#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:218
#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:222
msgid "退款申請失敗，請重試"
msgstr "退款申請失敗，請重試"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:45
#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:69
#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:94
msgid "退款申請審核中"
msgstr "退款申請審核中"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:47
#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:71
#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:96
msgid "退款申請已受理，去哪吃會儘快完成審核。"
msgstr "退款申請已受理，去哪吃會儘快完成審核。"

#: apps/dp-admin/src/pages/order/order-detail/index.web.tsx:213
msgid "退款申請已提交"
msgstr "退款申請已提交"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:259
msgid "退款申請已提交，請等待審核"
msgstr "退款申請已提交，請等待審核"

#: apps/dp-business/src/servers/order/api.ts:158
#: apps/dp-business/src/servers/order/api.ts:175
#: apps/dp-business/src/pages/OrderDetail/index.tsx:899
msgid "退款申請提交失敗"
msgstr "退款申請上傳失敗"

#: apps/dp-business/src/servers/order/api.ts:155
#: apps/dp-business/src/servers/order/api.ts:172
msgid "退款申請提交成功"
msgstr "退款申請上傳成功"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:861
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1195
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:63
msgid "退款確認"
msgstr "退款確認"

#: apps/dp-business/src/pages/RefundList/index.tsx:333
#: apps/dp-business/src/configs/page-configs.ts:959
msgid "退款管理"
msgstr "退款管理"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:136
msgid "退款總金額"
msgstr "退款總金額"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:52
#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundProgress.tsx:101
#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:75
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:84
msgid "退款處理中"
msgstr "退款處理中"

#: apps/dp-client/src/screens/home/pages/Meal/components/RuleCard/index.tsx:70
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:274
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:365
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:220
msgid "退款規則"
msgstr "退款規則"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/RefundOrdersCard/index.web.tsx:82
msgid "退款訂單"
msgstr "退款訂單"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/RefundOrdersCard/index.web.tsx:24
msgid "退款訂單ID"
msgstr "退款訂單ID"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1840
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2137
#: apps/dp-admin/src/pages/order/order-detail/components/RefundRecords/index.web.tsx:88
msgid "退款記錄"
msgstr "退款記錄"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/index.tsx:94
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/ProductArea.tsx:966
#: apps/dp-client/src/configs/page-configs.tsx:921
msgid "退款詳情"
msgstr "退款詳情"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:179
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:561
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1880
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2188
msgid "退款說明"
msgstr "退款說明"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:217
msgid "退款進度"
msgstr "退款進度"

#: apps/dp-client/src/screens/home/pages/Meal/pages/refundDetail/components/RefundItemCard.tsx:119
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:352
#: apps/dp-client/src/screens/home/pages/Meal/pages/refound/index.tsx:479
#: apps/dp-business/src/pages/RefundList/index.tsx:261
#: apps/dp-business/src/pages/OrderDetail/index.tsx:808
#: apps/dp-business/src/pages/OrderDetail/index.tsx:837
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1142
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1741
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/index.web.tsx:308
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/RefundOrdersCard/index.web.tsx:36
#: apps/dp-admin/src/pages/order/order-detail/components/RefundRecords/index.web.tsx:32
#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:99
msgid "退款金額"
msgstr "退款金額"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/RefundOrdersCard/index.web.tsx:52
msgid "退款類型"
msgstr "退款類型"

#: apps/dp-admin/src/pages/report-center/services/interface/manual-compensation.ts:71
msgid "退發票"
msgstr "退發票"

#: apps/dp-client/src/screens/home/pages/Review/components/RecommendDishesModal/index.tsx:119
#: apps/dp-client/src/screens/home/pages/Review/components/AddReview/ReviewActions.tsx:30
#: apps/dp-client/src/screens/home/components/ComplaintModal/index.tsx:423
#: apps/dp-client/src/screens/diary/pages/note/index.tsx:493
#: apps/dp-client/src/screens/diary/pages/comment/index.tsx:378
#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:474
#: apps/dp-business/src/pages/StoreNameEdit/index.tsx:282
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:887
#: apps/dp-business/src/pages/AddressEdit/index.tsx:795
#: apps/dp-business/src/components/EditHeader/index.tsx:72
#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:447
msgid "送出"
msgstr "送出"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:795
msgid "送出修改"
msgstr "送出修改"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:152
msgid "透明"
msgstr "透明"

#: apps/dp-admin/src/pages/resource-config/oauth-client-management/components/OAuthClientFormModal/index.web.tsx:107
msgid "逗號分隔，支持 CIDR 格式，為空表示不限制"
msgstr "逗號分隔，支持 CIDR 格式，為空表示不限制"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/MerchantTreePosition.web.tsx:94
msgid "這一層沒掛商家"
msgstr "這一層沒掛商家"

#: apps/dp-client/src/screens/login/pages/account-info/index.tsx:103
msgid "這不是我"
msgstr "這不是我"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:132
msgid "這些不算店家環境照喔！"
msgstr "這些不算店家環境照喔！"

#: apps/dp-client/src/screens/account/pages/privacy-settings/privacy-list/index.tsx:37
msgid "這些用戶無法看到你的筆記和評論"
msgstr "這些用戶無法看到你的筆記和評論"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:58
msgid "這個活動怎麼配置發獎？"
msgstr "這個活動怎麼配置發獎？"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:104
msgid "這個面板使用了自訂的標題和內容樣式。"
msgstr "這個面板使用了自訂的標題和內容樣式。"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:88
msgid "這個面板會在展開/收起時觸發回調函數。打開控制檯查看日誌。"
msgstr "這個面板會在展開/收起時觸發回調函數。打開控制檯查看日誌。"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:40
msgid ""
"這個面板預設是展開狀態。你可以透過 defaultExpanded\n"
"            屬性來控制初始狀態。"
msgstr ""
"這個面板預設是展開狀態。你可以透過 defaultExpanded\n"
"            屬性來控制初始狀態。"

#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:612
#: apps/dp-client/src/screens/diary/pages/detail/index.tsx:664
msgid "這則日記已違規，點擊查看Q&A"
msgstr "這則日記已違規，點擊查看Q&A"

#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:84
msgid "這家餐廳位於信義區附近，環境優雅舒適，非常適合拍照打卡。牛排肉質鮮嫩多汁，口感極佳，深受顧客喜愛。服務人員態度親切、服務細緻，讓人感受到賓至如歸的用餐體驗。無論是朋友聚餐、情侶約會或家庭聚會都非常合適，是一家值得再次造訪的優質餐廳，真的是超級推薦！"
msgstr "這家餐廳位於信義區附近，環境優雅舒適，非常適合拍照打卡。牛排肉質鮮嫩多汁，口感極佳，深受顧客喜愛。服務人員態度親切、服務細緻，讓人感受到賓至如歸的用餐體驗。無論是朋友聚餐、情侶約會或家庭聚會都非常合適，是一家值得再次造訪的優質餐廳，真的是超級推薦！"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:389
msgid "這張兌換券已領取"
msgstr "這張兌換券已領取"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:59
msgid "這是「人物照」請保護個人隱私喔！"
msgstr "這是「人物照」請保護個人隱私喔！"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:28
msgid "這是一個基礎的摺疊面板內容。點擊標題可以展開或收起內容區域。"
msgstr "這是一個基礎的摺疊面板內容。點擊標題可以展開或收起內容區域。"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:128
msgid "這是一個程式碼區塊範例："
msgstr "這是一個程式碼區塊範例："

#: apps/dp-admin/src/pages/user-info/services/apis.ts:166
msgid "這是一條{totalRating}星評價內容，體驗非常不錯，值得推薦！環境優雅，服務周到，菜品新鮮美味，性價比很高，下次還會再來的。"
msgstr "這是一條{totalRating}星評價內容，體驗非常不錯，值得推薦！環境優雅，服務周到，餐點新鮮美味，性價比很高，下次還會再來的。"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:53
msgid "這是父級面板的內容。下面是嵌套的子面板："
msgstr "這是父級面板的內容。下面是嵌套的子面板："

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:58
msgid "這是第一個子面板的內容。注意左側的縮排。"
msgstr "這是第一個子面板的內容。注意左側的縮排。"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:69
msgid "這是第三級嵌套面板的內容。"
msgstr "這是第三級嵌套面板的內容。"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:64
msgid "這是第二個子面板的內容。還可以繼續嵌套："
msgstr "這是第二個子面板的內容。還可以繼續嵌套："

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/index.web.tsx:137
msgid "這棵樹"
msgstr "這棵樹"

#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:709
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:270
#: apps/dp-client/src/screens/account/pages/user-profile/components/ReviewList/index.tsx:211
#: apps/dp-client/src/screens/account/pages/user-profile/components/NoteList/index.tsx:208
#: apps/dp-client/src/screens/account/pages/profile/components/MyReviewsContent/index.tsx:189
#: apps/dp-client/src/screens/account/pages/profile/components/ContentTabsSection/UserNoteSection.tsx:225
#: apps/dp-client/src/screens/account/pages/notifications/pages/likes/index.tsx:188
#: apps/dp-client/src/screens/account/pages/notifications/pages/follow/index.tsx:215
#: apps/dp-client/src/screens/account/pages/notifications/pages/comments/index.tsx:199
#: apps/dp-client/src/screens/account/pages/notifications/pages/CategoryNotifications/index.tsx:184
#: apps/dp-client/src/screens/account/pages/likes/components/ReviewContent/index.tsx:232
#: apps/dp-client/src/screens/account/pages/likes/components/NotesContent/index.tsx:192
msgid "這裡空空的"
msgstr "這裡空空的"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1749
msgid "這道菜值得推薦嗎？"
msgstr "這道菜值得推薦嗎？"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:756
msgid "這餐吃的怎麼樣？"
msgstr "這餐吃的怎麼樣？"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:25
#: apps/dp-admin/src/pages/marketing/services/constants.ts:105
msgid "通用"
msgstr "通用"

#: apps/dp-admin/src/modules/constants/options.ts:422
msgid "通用活動"
msgstr "通用活動"

#: apps/dp-client/src/screens/account/pages/notifications/pages/CategoryNotifications/index.tsx:50
#: apps/dp-business/src/App.web.tsx:256
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:859
msgid "通知"
msgstr "通知"

#: apps/dp-client/src/screens/account/pages/notifications/index.tsx:298
#: apps/dp-client/src/configs/page-configs.tsx:1656
#: apps/dp-client/src/configs/page-configs.tsx:1658
msgid "通知中心"
msgstr "通知中心"

#: apps/dp-client/src/configs/page-configs.tsx:1677
#: apps/dp-client/src/configs/page-configs.tsx:1679
msgid "通知列表"
msgstr "通知列表"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:585
msgid "通知圖片"
msgstr "通知圖片"

#. placeholder {0}: index + 1
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:612
msgid "通知圖片 {0}"
msgstr "通知圖片 {0}"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:379
msgid "通知文案"
msgstr "通知文案"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:389
msgid "通知文案不能超過{MAX_TEXT_LENGTH}個字符"
msgstr "通知文案不能超過{MAX_TEXT_LENGTH}個字符"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:210
msgid "通知方式（可多選）"
msgstr "通知方式（可多選）"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:410
msgid "通知時間"
msgstr "通知時間"

#: apps/dp-admin/src/pages/resource-config/message-edit/index.web.tsx:487
msgid "通知模板"
msgstr "通知模板"

#: apps/dp-admin/src/pages/resource-config/message-list/index.web.tsx:88
msgid "通知發送列表"
msgstr "通知發送列表"

#: apps/dp-admin/src/pages/resource-config/message-list/index.web.tsx:71
msgid "通知發送管理"
msgstr "通知發送管理"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:240
msgid "通知符合條件商家報名"
msgstr "通知符合條件商家報名"

#: apps/dp-client/src/store/notificationStore.ts:154
msgid "通知統計響應格式無效"
msgstr "通知統計響應格式無效"

#. placeholder {0}: selectedNotification.id
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:1029
msgid "通知編號：{0}"
msgstr "通知編號：{0}"

#: apps/dp-client/src/configs/page-configs.tsx:2571
#: apps/dp-client/src/configs/page-configs.tsx:2573
msgid "通知設置"
msgstr "通知設置"

#: apps/dp-client/src/screens/login/api/index.ts:333
msgid "通知註冊失敗，請重試"
msgstr "通知註冊失敗，請重試"

#: apps/dp-admin/src/pages/marketing/channel-management/index.web.tsx:55
msgid "通路匯入"
msgstr "通路匯入"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:154
msgid "通路批次匯入"
msgstr "通路批次匯入"

#: apps/dp-admin/src/pages/split-account/claim-list/services/config.web.tsx:171
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:120
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:273
#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:366
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:75
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:95
#: apps/dp-admin/src/pages/merchant/components/ActionButtons/index.web.tsx:49
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:280
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1448
#: apps/dp-admin/src/pages/audit-center/poi-audit-detail/components/PoiActionButtons/index.web.tsx:86
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:53
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/RemarkSection/index.web.tsx:26
#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:307
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/components/ImageAuditItem/index.web.tsx:87
#: apps/dp-admin/src/pages/audit-center/components/AuditActions/index.web.tsx:84
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:505
#: apps/dp-admin/src/pages/audit-center/claim-audit/index.web.tsx:196
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:308
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:501
msgid "通過"
msgstr "通過"

#: apps/dp-business/src/components/EmailVerification/index.tsx:393
msgid "通過XXX商家平台管理您的餐廳"
msgstr "通過XXX商家平台管理您的餐廳"

#: apps/dp-admin/src/pages/merchant/components/ActionButtons/index.web.tsx:62
msgid "通過原因"
msgstr "通過原因"

#: apps/dp-business/src/pages/Login/Email/index.tsx:251
#: apps/dp-business/src/components/PhoneVerification/index.tsx:403
msgid "通過去哪吃商家平台管理您的餐廳"
msgstr "通過去哪吃商家平台管理您的餐廳"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/index.web.tsx:56
msgid "通過條件篩選或組合名單創建動態商家名單"
msgstr "通過條件篩選或組合名單創建動態商家名單"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/ActionButtons/index.web.tsx:81
msgid "通過的店家"
msgstr "通過的店家"

#: apps/dp-admin/src/router/config/routes.web.tsx:127
msgid "通道(渠道)管理"
msgstr "通道(渠道)管理"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:362
msgid "連接中..."
msgstr "連接中..."

#: apps/dp-business/src/data/regions.ts:29
msgid "連江"
msgstr "連江"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/components/ResourceSlotField/SortableRow.web.tsx:118
msgid "連結地址"
msgstr "連結地址"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:278
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:608
msgid "連線"
msgstr "連線"

#: apps/dp-admin/src/modules/hooks/notificationConnection.ts:84
msgid "連線已中斷"
msgstr "連線已中斷"

#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:357
msgid "連線已中斷，請重新整理頁面"
msgstr "連線已中斷，請重新整理頁面"

#: apps/dp-client/src/screens/diary/pages/add-merchant/components/UnifiedMap/index.tsx:481
msgid "連線逾時"
msgstr "連線逾時"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:95
msgid "連鎖信息"
msgstr "連鎖信息"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:97
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:44
msgid "連鎖名稱"
msgstr "連鎖名稱"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:103
msgid "連鎖名稱不能超過 {CHAIN_NAME_MAX_LENGTH} 個字符"
msgstr "連鎖名稱不能超過 {CHAIN_NAME_MAX_LENGTH} 個字符"

#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:42
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:45
msgid "連鎖名稱或編碼"
msgstr "連鎖名稱或編碼"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:113
msgid "連鎖商標"
msgstr "連鎖商標"

#: apps/dp-business/src/components/CustomTabs/chainTabs.ts:38
msgid "連鎖樹管理"
msgstr "連鎖樹管理"

#: apps/dp-business/src/pages/ChainDashboard/MobileLayout.tsx:45
#: apps/dp-business/src/pages/ChainDashboard/components/PerspectiveSwitchTabs.tsx:131
msgid "連鎖視角"
msgstr "連鎖視角"

#: apps/dp-business/src/pages/ChainDashboard/index.tsx:155
msgid "連鎖視角加載失敗"
msgstr "連鎖視角加載失敗"

#: apps/dp-business/src/pages/ChainDashboard/MobileLayout.tsx:114
#: apps/dp-business/src/configs/page-configs.ts:216
msgid "連鎖管理"
msgstr "連鎖管理"

#: apps/dp-admin/src/pages/org-tree/org-create/services/constants.ts:14
msgid "連鎖管理信息/組織架構"
msgstr "連鎖管理信息/組織架構"

#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:207
msgid "連鎖資料載入失敗，請關閉後重試"
msgstr "連鎖資料載入失敗，請關閉後重試"

#: apps/dp-admin/src/pages/org-tree/org-create/services/constants.ts:13
msgid "連鎖資質"
msgstr "連鎖資質"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:348
#: apps/dp-admin/src/modules/constants/userGroup.ts:136
msgid "週"
msgstr "週"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:352
msgid "週{dayChar}"
msgstr "週{dayChar}"

#: apps/dp-client/src/screens/reservation/utils/index.ts:129
#: apps/dp-client/src/screens/home/utils/order.ts:80
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:25
#: apps/dp-client/src/screens/account/pages/check-in/utils.ts:9
#: apps/dp-business/src/utils/businessHours.ts:36
#: apps/dp-business/src/store/ReservationRulesContext.tsx:74
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:471
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:551
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:98
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:406
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:321
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:355
#: apps/dp-business/src/constants/enums.ts:109
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:92
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:58
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:33
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:139
#: apps/dp-admin/src/components/BusinessHours/constants.ts:7
msgid "週一"
msgstr "週一"

#: apps/dp-business/src/pages/ContactBD/index.tsx:228
msgid "週一至週五: 09:00 - 18:00"
msgstr "週一至週五: 09:00 - 18:00"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:246
msgid "週一至週日 11:00-22:00"
msgstr "週一至週日 11:00-22:00"

#: apps/dp-client/src/screens/reservation/utils/index.ts:131
#: apps/dp-client/src/screens/home/utils/order.ts:82
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:27
#: apps/dp-client/src/screens/account/pages/check-in/utils.ts:11
#: apps/dp-business/src/utils/businessHours.ts:38
#: apps/dp-business/src/store/ReservationRulesContext.tsx:74
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:471
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:553
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:100
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:408
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:321
#: apps/dp-business/src/constants/enums.ts:119
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:94
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:60
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:35
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:141
#: apps/dp-admin/src/components/BusinessHours/constants.ts:9
msgid "週三"
msgstr "週三"

#: apps/dp-client/src/screens/reservation/utils/index.ts:130
#: apps/dp-client/src/screens/home/utils/order.ts:81
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:26
#: apps/dp-client/src/screens/account/pages/check-in/utils.ts:10
#: apps/dp-business/src/utils/businessHours.ts:37
#: apps/dp-business/src/store/ReservationRulesContext.tsx:74
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:471
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:552
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:99
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:407
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:321
#: apps/dp-business/src/constants/enums.ts:114
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:93
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:59
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:34
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:140
#: apps/dp-admin/src/components/BusinessHours/constants.ts:8
msgid "週二"
msgstr "週二"

#: apps/dp-client/src/screens/reservation/utils/index.ts:133
#: apps/dp-client/src/screens/home/utils/order.ts:84
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:29
#: apps/dp-client/src/screens/account/pages/check-in/utils.ts:13
#: apps/dp-business/src/utils/businessHours.ts:40
#: apps/dp-business/src/store/ReservationRulesContext.tsx:74
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:471
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:555
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:102
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:410
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:321
#: apps/dp-business/src/constants/enums.ts:129
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:96
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:62
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:37
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:143
#: apps/dp-admin/src/components/BusinessHours/constants.ts:11
msgid "週五"
msgstr "週五"

#: apps/dp-client/src/screens/reservation/utils/index.ts:134
#: apps/dp-client/src/screens/home/utils/order.ts:85
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:30
#: apps/dp-client/src/screens/account/pages/check-in/utils.ts:14
#: apps/dp-business/src/utils/businessHours.ts:41
#: apps/dp-business/src/store/ReservationRulesContext.tsx:117
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:556
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:103
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:411
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:321
#: apps/dp-business/src/constants/enums.ts:134
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:97
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:63
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:38
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:144
#: apps/dp-admin/src/components/BusinessHours/constants.ts:12
msgid "週六"
msgstr "週六"

#: apps/dp-client/src/screens/reservation/utils/index.ts:132
#: apps/dp-client/src/screens/home/utils/order.ts:83
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:28
#: apps/dp-client/src/screens/account/pages/check-in/utils.ts:12
#: apps/dp-business/src/utils/businessHours.ts:39
#: apps/dp-business/src/store/ReservationRulesContext.tsx:74
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:471
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:554
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:101
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:409
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:321
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:355
#: apps/dp-business/src/constants/enums.ts:124
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:95
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:61
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:36
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:142
#: apps/dp-admin/src/components/BusinessHours/constants.ts:10
msgid "週四"
msgstr "週四"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1936
msgid "週年慶活動"
msgstr "週年慶活動"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:230
msgid "週幾"
msgstr "週幾"

#: apps/dp-client/src/screens/reservation/utils/index.ts:128
#: apps/dp-client/src/screens/home/utils/order.ts:86
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/components/BusinessHours.tsx:31
#: apps/dp-client/src/screens/account/pages/check-in/utils.ts:8
#: apps/dp-business/src/utils/businessHours.ts:42
#: apps/dp-business/src/store/ReservationRulesContext.tsx:117
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:550
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/index.tsx:104
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:412
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:321
#: apps/dp-business/src/constants/enums.ts:139
#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:98
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:64
#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:39
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:145
#: apps/dp-admin/src/components/BusinessHours/constants.ts:13
msgid "週日"
msgstr "週日"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:324
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:882
msgid "週期"
msgstr "週期"

#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:45
msgid "週期循環"
msgstr "週期循環"

#: apps/dp-admin/src/pages/marketing/activity-config-form/index.web.tsx:524
msgid "週期循環的開始時間不符合所選循環週期的對齊規則"
msgstr "週期循環的開始時間不符合所選循環週期的對齊規則"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:89
msgid "週期活動推算的結束時間必須晚於當前時間"
msgstr "週期活動推算的結束時間必須晚於當前時間"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:86
msgid "週期活動結束時間將由系統根據開始時間和循環次數計算"
msgstr "週期活動結束時間將由系統根據開始時間和循環次數計算"

#: apps/dp-admin/src/pages/resource-config/message-list/services/constants.ts:38
#: apps/dp-admin/src/pages/resource-config/message-edit/services/constants.ts:35
msgid "週期發送"
msgstr "週期發送"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:85
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ExchangeLimitEditor/index.web.tsx:74
msgid "週期維度"
msgstr "週期維度"

#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:302
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:65
msgid "週期選擇"
msgstr "週期選擇"

#: apps/dp-admin/src/pages/resource-config/message-list/services/searchConfig.ts:54
msgid "週期類型"
msgstr "週期類型"

#: apps/dp-client/src/screens/home/utils/order.ts:476
#: apps/dp-client/src/screens/home/utils/order.ts:890
msgid "週末"
msgstr "週末"

#: apps/dp-client/src/screens/home/utils/order.ts:889
msgid "週末可用"
msgstr "週末可用"

#: apps/dp-business/src/store/ReservationRulesContext.tsx:115
msgid "週末晚餐規則"
msgstr "週末晚餐規則"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:82
msgid "進入套餐券列表落地頁，跳轉時代入權益圈選的店家名單。"
msgstr "進入套餐券列表落地頁，跳轉時代入權益圈選的店家名單。"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:404
msgid "進入查看"
msgstr "進入查看"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:405
msgid "進入管理"
msgstr "進入管理"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:70
msgid "進入適用店家列表落地頁，跳轉時代入權益圈選的店家列表。"
msgstr "進入適用店家列表落地頁，跳轉時代入權益圈選的店家列表。"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:264
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:292
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:455
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:958
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:659
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:719
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/utils/activityUtils.ts:41
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:118
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityCardList.tsx:63
#: apps/dp-admin/src/pages/merchant/task-list/components/StatusTag/index.web.tsx:25
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:25
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:26
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/constants.ts:38
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityDetailInfo.web.tsx:38
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:16
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:25
#: apps/dp-admin/src/pages/marketing/benefit-management/services/utils/statusMaps.ts:40
#: apps/dp-admin/src/modules/constants/options.ts:485
msgid "進行中"
msgstr "進行中"

#. placeholder {0}: tabCounts[JoinedActivityTabKey.Ongoing]
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityFilterCard.tsx:99
msgid "進行中 {0}"
msgstr "進行中 {0}"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/UnmountConfirm.web.tsx:58
msgid "進行中單據"
msgstr "進行中單據"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/DisableNodeConfirm/index.web.tsx:55
msgid "進行中審核"
msgstr "進行中審核"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/buildChannelCampaignPayload.ts:93
msgid "進行中的活動不能修改開始時間"
msgstr "進行中的活動不能修改開始時間"

#: apps/dp-admin/src/pages/merchant/check-in/index.web.tsx:50
#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:80
msgid "進駐審核"
msgstr "進駐審核"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:441
msgid "進駐審核失敗"
msgstr "進駐審核失敗"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:440
msgid "進駐審核通過"
msgstr "進駐審核通過"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:439
msgid "進駐審核進度"
msgstr "進駐審核進度"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:960
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:514
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/constants.ts:19
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopListTable/index.web.tsx:494
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:416
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:140
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:194
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:614
msgid "進駐時間"
msgstr "進駐時間"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:86
msgid "進駐狀態"
msgstr "進駐狀態"

#: apps/dp-admin/src/pages/merchant/shop-list/components/ActionButtons/index.web.tsx:80
msgid "進駐申請"
msgstr "進駐申請"

#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/index.web.tsx:765
msgid "進駐資訊提交成功"
msgstr "進駐資訊提交成功"

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:110
msgid "進駐錄入"
msgstr "進駐錄入"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/EntityTypeSection.web.tsx:33
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/EntityTypeCard.web.tsx:17
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/EntityTypeSection/index.web.tsx:33
msgid "進駐類型"
msgstr "進駐類型"

#: apps/dp-client/src/screens/home/pages/Meal/constants/index.ts:18
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:169
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:99
msgid "逾期自動退款"
msgstr "逾期自動退款"

#: apps/dp-client/src/components/PageContainer/ErrorBoundary.tsx:42
msgid "遇到一點小問題"
msgstr "遇到一點小問題"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/detail/index.tsx:1048
#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:293
msgid "遇到問題"
msgstr "遇到問題"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:173
#: apps/dp-admin/src/pages/label-management/components/LabelTable.web.tsx:105
msgid "運營"
msgstr "運營"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:104
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:252
msgid "運營備注"
msgstr "運營備注"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:118
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:264
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:201
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:54
msgid "運營備註"
msgstr "運營備註"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:265
msgid "運營備註不能超過1000個字符"
msgstr "運營備註不能超過1000個字符"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:55
msgid "運營備註最多 100 個字"
msgstr "運營備註最多 100 個字"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:284
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:569
msgid "運營推薦"
msgstr "運營推薦"

#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:17
msgid "運營提交"
msgstr "運營提交"

#: apps/dp-business/src/constants/enums.ts:518
#: apps/dp-admin/src/pages/resource-config/category-management/services/constants.ts:45
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:21
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:10
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:363
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:416
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:119
msgid "運營端"
msgstr "運營端"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:28
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:84
msgid "運營端創建"
msgstr "運營端創建"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:162
msgid "運營端單個上傳"
msgstr "運營端單個上傳"

#: apps/dp-admin/src/pages/audit-center/services/constants.ts:161
msgid "運營端批量上傳"
msgstr "運營端批量上傳"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:88
msgid "運營端標題"
msgstr "運營端標題"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:291
msgid "運營端角色"
msgstr "運營端角色"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:65
#: apps/dp-admin/src/pages/other/notifications/index.web.tsx:40
#: apps/dp-admin/src/components/layout/index.web.tsx:38
msgid "運營管理"
msgstr "運營管理"

#: apps/dp-admin/src/pages/resource-config/category-management/services/constants.ts:46
msgid "運營規則"
msgstr "運營規則"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityBasicInfoForm/index.web.tsx:457
msgid "運營說明"
msgstr "運營說明"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageConditionTree/index.web.tsx:48
msgid "運算符"
msgstr "運算符"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:384
msgid "運輸公司"
msgstr "運輸公司"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:340
msgid "遍佈在{regionText}"
msgstr "遍佈在{regionText}"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:16
msgid "過去"
msgstr "過去"

#. placeholder {0}: timeRange.value ?? '-'
#. placeholder {1}: formatUnit(timeRange.unit)
#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:125
msgid "過去 {0} {1}"
msgstr "過去 {0} {1}"

#: apps/dp-business/src/utils/dateRange.ts:152
msgid "過去{amount}{unit}"
msgstr "過去{amount}{unit}"

#: apps/dp-business/src/utils/dateRange.ts:142
msgid "過去{amount}個月"
msgstr "過去{amount}個月"

#: apps/dp-business/src/utils/dateRange.ts:138
msgid "過去{amount}分鐘"
msgstr "過去{amount}分鐘"

#: apps/dp-business/src/utils/dateRange.ts:141
msgid "過去{amount}周"
msgstr "過去{amount}周"

#: apps/dp-business/src/utils/dateRange.ts:140
msgid "過去{amount}天"
msgstr "過去{amount}天"

#: apps/dp-business/src/utils/dateRange.ts:139
msgid "過去{amount}小時"
msgstr "過去{amount}小時"

#: apps/dp-business/src/utils/dateRange.ts:143
msgid "過去{amount}年"
msgstr "過去{amount}年"

#: apps/dp-business/src/utils/dateRange.ts:220
msgid "過去{days}天"
msgstr "過去{days}天"

#: apps/dp-business/src/utils/dateRange.ts:149
msgid "過去{minutes}分鐘"
msgstr "過去{minutes}分鐘"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:347
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:391
msgid "過去30天"
msgstr "過去30天"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:401
msgid "過去3小時新增訂單"
msgstr "過去3小時新增訂單"

#: apps/dp-business/src/types/orderFilter.ts:143
#: apps/dp-business/src/types/orderFilter.ts:155
#: apps/dp-business/src/pages/OrderOverview/index.tsx:348
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1783
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1809
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:209
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:221
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:392
msgid "過去7天"
msgstr "過去7天"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TriggerEventsEditor/index.web.tsx:157
msgid "過濾項"
msgstr "過濾項"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:630
msgid "達標"
msgstr "達標"

#: apps/dp-admin/src/pages/audit-center/user-audit/services/hooks.ts:87
msgid "違規暱稱"
msgstr "違規暱稱"

#: apps/dp-admin/src/pages/audit-center/user-audit/services/hooks.ts:100
msgid "違規頭像"
msgstr "違規頭像"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/services/constants.ts:51
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:109
msgid "遠傳"
msgstr "遠傳"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/MemberPreviewPanel/index.web.tsx:86
msgid "遠傳 UID"
msgstr "遠傳 UID"

#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:94
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:269
#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:97
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/columns/index.web.tsx:46
msgid "遠傳UID"
msgstr "遠傳UID"

#: apps/dp-client/src/screens/diary/pages/home/components/points-card/index.tsx:287
msgid "遠傳幣兌換已達上限，繼續累分衝擊排行榜"
msgstr "遠傳幣兌換已達上限，繼續累分衝擊排行榜"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:132
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:118
msgid "遠傳心生活"
msgstr "遠傳心生活"

#: apps/dp-client/src/screens/diary/pages/home/components/welcome-modal/index.tsx:50
msgid "遠傳月租型用戶"
msgstr "遠傳月租型用戶"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:27
msgid "遠傳門市員工推廣碼"
msgstr "遠傳門市員工推廣碼"

#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:48
msgid "適合初期試用的商家"
msgstr "適合初期試用的商家"

#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:75
msgid "適合大型連鎖餐廳"
msgstr "適合大型連鎖餐廳"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:131
msgid "適合對象"
msgstr "適合對象"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:57
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:37
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:37
msgid "適應"
msgstr "適應"

#: apps/dp-business/src/pages/TableManagement/index.tsx:570
#: apps/dp-business/src/pages/TableManagement/index.tsx:748
#: apps/dp-business/src/pages/TableManagement/index.tsx:969
msgid "適用人數"
msgstr "適用人數"

#: apps/dp-admin/src/pages/label-management/label-detail/index.web.tsx:265
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:470
msgid "適用品類"
msgstr "適用品類"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:375
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:500
msgid "適用商品"
msgstr "適用商品"

#: apps/dp-client/src/configs/page-configs.tsx:535
msgid "適用商家"
msgstr "適用商家"

#: apps/dp-client/src/screens/home/pages/UserGift/components/ShopListSection/index.tsx:520
#: apps/dp-client/src/screens/home/pages/UserGift/components/ShopListSection/index.tsx:682
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/MealSectionTabs.tsx:40
#: apps/dp-client/src/screens/home/pages/Meal/components/ShopInfoCard/index.tsx:125
#: apps/dp-client/src/screens/home/pages/Meal/components/ShopInfoCard/index.tsx:161
#: apps/dp-client/src/screens/home/components/CommonShopListSection/index.tsx:145
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:275
#: apps/dp-business/src/pages/BusinessStatus/components/SharedTemplatesContent.tsx:38
#: apps/dp-admin/src/pages/merchant/shop-detail/components/SharedTemplatesModal/index.web.tsx:41
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:366
msgid "適用店家"
msgstr "適用店家"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:135
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:342
msgid "適用店家："
msgstr "適用店家："

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:68
#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/CustomJumpConfig.web.tsx:121
msgid "適用店家列表"
msgstr "適用店家列表"

#: apps/dp-client/src/screens/home/pages/Meal/pages/shopSelect/index.tsx:289
#: apps/dp-client/src/configs/page-configs.tsx:904
msgid "適用店家清單"
msgstr "適用店家清單"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:137
#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:103
msgid "適用指定商品兌換"
msgstr "適用指定商品兌換"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:581
msgid "適用星期"
msgstr "適用星期"

#: apps/dp-client/src/screens/home/pages/Purchase/components/PurchaseModal/index.tsx:274
#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:131
#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:101
msgid "適用結帳折扣"
msgstr "適用結帳折扣"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/GeoFenceConfig/index.web.tsx:200
msgid "適用與 C 端行為：僅掃碼發放受圍欄校驗，未通過則彈窗攔截；多條圍欄任一命中即通過。"
msgstr "適用與 C 端行為：僅掃碼發放受圍欄校驗，未通過則彈窗攔截；多條圍欄任一命中即通過。"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/BasicInfoSection.web.tsx:182
msgid "適用訂單類型"
msgstr "適用訂單類型"

#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:141
#: apps/dp-client/src/components/CouponDetailModal/index.tsx:348
msgid "適用訂單類型："
msgstr "適用訂單類型："

#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:66
msgid "適閤中型連鎖餐廳"
msgstr "適閤中型連鎖餐廳"

#: apps/dp-admin/src/pages/transaction/components/BookingPricingSelector/index.web.tsx:57
msgid "適閤中小型餐廳"
msgstr "適閤中小型餐廳"

#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailCard/index.tsx:170
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailCard/index.tsx:178
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2027
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:867
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:993
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:807
#: apps/dp-business/src/pages/CouponVerification/components/VerificationModal.tsx:250
#: apps/dp-admin/src/pages/order/order-detail/components/SetMealDetails/index.web.tsx:501
msgid "選"
msgstr "選"

#. placeholder {0}: ids.length + ignoredCount
#. placeholder {1}: ids.length
#. placeholder {2}: ids.length
#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:194
msgid "選中 {0} 筆，其中符合重新發放條件 {1} 筆，{ignoredCount} 筆不符合將被忽略，是否對 {2} 筆執行重新發放？"
msgstr "選中 {0} 筆，其中符合重新發放條件 {1} 筆，{ignoredCount} 筆不符合將被忽略，是否對 {2} 筆執行重新發放？"

#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageItem/index.web.tsx:129
msgid "選中圖片"
msgstr "選中圖片"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:300
msgid "選中後完成「落地頁配置」→ 落地頁 URL 回填至本頁 → 保存後寫入權益配置；C 端「去使用」按該 URL 跳轉。"
msgstr "選中後完成「落地頁配置」→ 落地頁 URL 回填至本頁 → 保存後寫入權益配置；C 端「去使用」按該 URL 跳轉。"

#: apps/dp-business/src/pages/UserManagement/BatchCopyUsers.tsx:63
msgid "選中的使用者缺少身份資訊"
msgstr "選中的使用者缺少身份資訊"

#. placeholder {0}: getMenuNameById(menuId.toString())
#. placeholder {1}: parent.menuName
#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:278
msgid "選中的功能「{0}」需要依賴父級權限「{1}」，是否同時選中父級權限？"
msgstr "選中的功能「{0}」需要依賴父級權限「{1}」，是否同時選中父級權限？"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/hooks.ts:232
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/hooks.ts:173
msgid "選中的資料缺少 ID"
msgstr "選中的資料缺少 ID"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:753
msgid "選取其他交通方式，將不保留前一次輸入的內容喔！"
msgstr "選取其他交通方式，將不保留前一次輸入的內容喔！"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:402
msgid "選取或取消本頁可用渠道"
msgstr "選取或取消本頁可用渠道"

#: apps/dp-business/src/hooks/usePermissions.ts:87
msgid "選單權限檢查失敗"
msgstr "選單權限檢查失敗"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:328
msgid "選填"
msgstr "選填"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:379
msgid "選填，不覆蓋已存在身份的原密碼"
msgstr "選填，不覆蓋已存在身份的原密碼"

#: apps/dp-admin/src/pages/merchant/all-merchant/components/BatchBdModal/index.web.tsx:172
msgid "選填，最多 200 字"
msgstr "選填，最多 200 字"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeEditModal/index.web.tsx:266
msgid "選填，請輸入備註（最多 {REMARK_MAX_LENGTH} 字）"
msgstr "選填，請輸入備註（最多 {REMARK_MAX_LENGTH} 字）"

#: apps/dp-business/src/pages/UserManagement/AddTempUserPage.tsx:326
#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1193
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1332
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:158
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:163
msgid "選擇"
msgstr "選擇"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ImportShopModal/index.web.tsx:140
#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:155
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/BatchUploadForm/index.web.tsx:49
#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/index.web.tsx:185
msgid "選擇 Excel 文件"
msgstr "選擇 Excel 文件"

#: apps/dp-admin/src/pages/marketing/user-group-create/services/hooks.ts:207
#: apps/dp-admin/src/pages/marketing/merchant-group-create/services/hooks.ts:210
#: apps/dp-admin/src/pages/marketing/components/GroupAppendModal/hooks.ts:79
msgid "選擇 Excel 文件失敗"
msgstr "選擇 Excel 文件失敗"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:898
msgid "選擇 Google POI 後自動帶入"
msgstr "選擇 Google POI 後自動帶入"

#. placeholder {0}: group.label
#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/ConditionPickerModal.web.tsx:42
#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/components/ConditionPickerModal.web.tsx:35
msgid "選擇{0}條件"
msgstr "選擇{0}條件"

#: apps/dp-admin/src/pages/merchant/signing-management/components/NoContractActions/index.web.tsx:64
msgid "選擇「只聚流簽約」可以快速進入基礎合約錄入；選擇「聚流+藍新簽約」將前往批量簽約流程"
msgstr "選擇「只聚流簽約」可以快速進入基礎合約錄入；選擇「聚流+藍新簽約」將前往批量簽約流程"

#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:151
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:69
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:69
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchAssignModal/index.web.tsx:79
#: apps/dp-admin/src/pages/merchant/components/BdSection/index.web.tsx:26
#: apps/dp-admin/src/pages/merchant/components/BdAssignmentField/index.web.tsx:177
#: apps/dp-admin/src/pages/merchant/components/BdAssignmentField/index.web.tsx:229
msgid "選擇BD"
msgstr "選擇BD"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/BatchUploadForm/index.web.tsx:161
msgid "選擇上傳參數後開放"
msgstr "選擇上傳參數後開放"

#: apps/dp-business/src/pages/OrderOverview/FilterModal.tsx:265
msgid "選擇下單時間"
msgstr "選擇下單時間"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1274
msgid "選擇下單時間範圍"
msgstr "選擇下單時間範圍"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:212
msgid "選擇下次追蹤時間"
msgstr "選擇下次追蹤時間"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:182
msgid "選擇下載時間"
msgstr "選擇下載時間"

#: apps/dp-business/src/pages/MarketingCenter/components/StackingRulesCard.tsx:316
msgid "選擇互斥組"
msgstr "選擇互斥組"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:243
msgid "選擇任務優先級"
msgstr "選擇任務優先級"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:258
msgid "選擇任務狀態"
msgstr "選擇任務狀態"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:228
msgid "選擇任務類型"
msgstr "選擇任務類型"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:413
#: apps/dp-admin/src/pages/merchant/components/ImageUploadGrid/index.web.tsx:137
#: apps/dp-admin/src/pages/merchant/components/EnvironmentImageItem/index.web.tsx:167
msgid "選擇位置"
msgstr "選擇位置"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:1098
msgid "選擇優惠"
msgstr "選擇優惠"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1244
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1245
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1257
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1258
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1445
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:1471
#: apps/dp-client/src/screens/home/pages/Purchase/components/PurchaseModal/index.tsx:353
#: apps/dp-client/src/screens/home/pages/Meal/components/CouponPickerModal/index.tsx:180
#: apps/dp-client/src/screens/home/pages/Meal/components/CouponPickerModal/index.tsx:187
msgid "選擇優惠券"
msgstr "選擇優惠券"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConsumeConfigEditor/index.web.tsx:35
msgid "選擇兌換獲得權益"
msgstr "選擇兌換獲得權益"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/PublishPreviewModal.web.tsx:85
msgid "選擇公佈時間"
msgstr "選擇公佈時間"

#: apps/dp-client/src/screens/account/pages/account-security/third-party/index.tsx:448
msgid "選擇其他登入方式"
msgstr "選擇其他登入方式"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:642
#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:643
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:323
msgid "選擇最晚失效日期"
msgstr "選擇最晚失效日期"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskSearchFilter/index.web.tsx:197
msgid "選擇分配時間"
msgstr "選擇分配時間"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:135
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:135
msgid "選擇分類"
msgstr "選擇分類"

#: apps/dp-business/src/pages/OrderOverview/FilterModal.tsx:264
msgid "選擇到店時間"
msgstr "選擇到店時間"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1254
msgid "選擇到店時間範圍"
msgstr "選擇到店時間範圍"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:297
msgid "選擇參與活動的商家"
msgstr "選擇參與活動的商家"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:166
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFilter.tsx:92
msgid "選擇參與門檻"
msgstr "選擇參與門檻"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:405
msgid "選擇可用日期"
msgstr "選擇可用日期"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:93
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:93
msgid "選擇品牌"
msgstr "選擇品牌"

#: apps/dp-business/src/pages/UserManagement/BatchCopyUsers.tsx:129
msgid "選擇商家：將使用者資訊複製到所選商家"
msgstr "選擇商家：將使用者資訊複製到所選商家"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/CombinedListForm/index.web.tsx:29
msgid "選擇商家名單"
msgstr "選擇商家名單"

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:110
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:114
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:110
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:114
msgid "選擇商家等級"
msgstr "選擇商家等級"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/DynamicPackageFields/index.web.tsx:56
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:212
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/ShopTargetingConfig/index.web.tsx:57
msgid "選擇商家組"
msgstr "選擇商家組"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/DynamicPackageFields/index.web.tsx:87
msgid "選擇商家類目"
msgstr "選擇商家類目"

#: apps/dp-client/src/screens/account/pages/advice/category-select/index.tsx:51
#: apps/dp-client/src/screens/account/pages/advice/category-select/index.tsx:52
#: apps/dp-client/src/screens/account/pages/advice/category-select/index.tsx:151
#: apps/dp-client/src/configs/page-configs.tsx:1602
#: apps/dp-client/src/configs/page-configs.tsx:1604
msgid "選擇問題分類"
msgstr "選擇問題分類"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:86
msgid "選擇圖像"
msgstr "選擇圖片"

#: apps/dp-admin/src/components/ImageListUploader/index.web.tsx:30
msgid "選擇圖片"
msgstr "選擇圖片"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:115
msgid "選擇圖片失敗"
msgstr "選擇圖片失敗"

#: apps/dp-client/src/screens/home/pages/Note/pages/editPhoto/index.tsx:366
msgid "選擇圖片失敗，請稍後重試"
msgstr "選擇圖片失敗，請稍後重試"

#: apps/dp-client/src/screens/account/pages/edit-profile/index.tsx:340
msgid "選擇圖片失敗，請重試"
msgstr "選擇圖片失敗，請重試"

#: apps/dp-client/src/screens/home/components/CitySelect/CityModal.tsx:105
#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:294
msgid "選擇地區"
msgstr "選擇地區"

#: apps/dp-client/src/configs/page-configs.tsx:2892
msgid "選擇地址"
msgstr "選擇地址"

#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/index.tsx:393
#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/components/CitySelectModal.tsx:27
#: apps/dp-client/src/screens/diary/pages/add-merchant/merchant-search/components/CitySelectModal.tsx:85
msgid "選擇城市"
msgstr "選擇城市"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:85
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:758
msgid "選擇城市區域"
msgstr "選擇城市區域"

#: apps/dp-business/src/components/CityDistrictCascadeSelector/index.tsx:161
msgid "選擇城市和區域"
msgstr "選擇城市和區域"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:61
msgid "選擇套餐券"
msgstr "選擇套餐券"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ImportPackageFields/index.web.tsx:37
msgid "選擇套餐名單"
msgstr "選擇套餐名單"

#: apps/dp-admin/src/pages/resource-config/components/ContentTypeSection/PackageConditionTree/index.web.tsx:40
msgid "選擇字段"
msgstr "選擇字段"

#: apps/dp-admin/src/pages/customer-service/components/AssignModal.web.tsx:96
msgid "選擇客服"
msgstr "選擇客服"

#: apps/dp-client/src/configs/page-configs.tsx:1808
#: apps/dp-client/src/configs/page-configs.tsx:1810
msgid "選擇居住地"
msgstr "選擇居住地"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepMerchantGroup.web.tsx:32
msgid "選擇已有商家名單"
msgstr "選擇已有商家名單"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/services/interface.ts:19
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/services/interface.ts:19
msgid "選擇已有商家綁定"
msgstr "選擇已有商家綁定"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepTemplate.web.tsx:168
msgid "選擇已有消息模板"
msgstr "選擇已有消息模板"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepUserGroup.web.tsx:32
msgid "選擇已有用戶名單"
msgstr "選擇已有用戶名單"

#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:40
#: apps/dp-client/src/screens/diary/components/YearMonthPicker/index.tsx:38
msgid "選擇年月"
msgstr "選擇年月"

#: apps/dp-client/src/components/ShopSelectSheet/index.tsx:147
#: apps/dp-business/src/pages/UserManagement/SelectShopsView.tsx:68
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:400
#: apps/dp-business/src/pages/UserManagement/AddUserPage.tsx:335
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:456
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:497
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:532
#: apps/dp-business/src/pages/AddStore/index.tsx:1237
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:658
#: apps/dp-business/src/pages/AddStore/SearchPage.tsx:674
msgid "選擇店家"
msgstr "選擇店家"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:84
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/index.tsx:729
#: apps/dp-business/src/pages/AddStore/index.tsx:845
#: apps/dp-business/src/pages/AddStore/CategoryPage.tsx:226
#: apps/dp-business/src/pages/AddStore/CategoryPage.tsx:245
msgid "選擇店家分類"
msgstr "選擇店家分類"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:710
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:911
msgid "選擇店家經營範圍"
msgstr "選擇店家經營範圍"

#: apps/dp-client/src/screens/account/pages/edit-profile/components/GenderSelectModal/index.tsx:96
msgid "選擇性別"
msgstr "選擇性別"

#: apps/dp-client/src/screens/home/pages/LocationSelect/index.tsx:267
#: apps/dp-client/src/configs/page-configs.tsx:100
msgid "選擇指定地點"
msgstr "選擇指定地點"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:232
#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:314
msgid "選擇排序方式"
msgstr "選擇排序方式"

#: apps/dp-client/src/screens/home/pages/Review/components/RecommendDishesModal/index.tsx:118
msgid "選擇推薦菜"
msgstr "選擇推薦菜"

#: apps/dp-business/src/components/PhotoUploader/index.tsx:409
#: apps/dp-admin/src/pages/org-tree/org-create/components/ChainInfoForm/index.web.tsx:122
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/GeneratePhotoTaskModal/index.web.tsx:245
#: apps/dp-admin/src/pages/merchant/shop-list/components/GeneratePhotoTaskModal/index.web.tsx:245
#: apps/dp-admin/src/components/FileUpload/index.web.tsx:348
msgid "選擇文件"
msgstr "選擇文件"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:112
msgid "選擇文件（圖片 / GIF / 影片）"
msgstr "選擇文件（圖片 / GIF / 影片）"

#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:300
msgid "選擇新圖片上傳"
msgstr "選擇新圖片上傳"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:854
msgid "選擇方式"
msgstr "選擇方式"

#: apps/dp-business/src/pages/BusinessStatus/index.tsx:407
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:427
#: apps/dp-business/src/components/DatePicker.tsx:523
#: apps/dp-business/src/components/DatePickModal/index.tsx:79
#: apps/dp-business/src/components/DateFilterRadio/index.tsx:112
#: apps/dp-business/src/components/CustomRadioGroup/index.tsx:259
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:229
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:670
msgid "選擇日期"
msgstr "選擇日期"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:219
msgid "選擇日期（截止選中日期的未使用庫存）"
msgstr "選擇日期（截止選中日期的未使用庫存）"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:137
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsFilters.tsx:160
#: apps/dp-business/src/components/DateRangeSelector/index.tsx:239
msgid "選擇日期範圍"
msgstr "選擇日期範圍"

#: apps/dp-business/src/components/DatePicker.tsx:532
#: apps/dp-business/src/components/TimePicker/TimePickerModal.tsx:138
#: apps/dp-business/src/components/CompactTimePicker/index.tsx:128
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:44
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:49
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:208
msgid "選擇時間"
msgstr "選擇時間"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:219
#: apps/dp-business/src/pages/BusinessHours/TimeRangePicker.tsx:38
#: apps/dp-business/src/components/TimePicker/TimePickerModal.tsx:138
msgid "選擇時間段"
msgstr "選擇時間段"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:731
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1949
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1404
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1510
msgid "選擇時間範圍"
msgstr "選擇時間範圍"

#: apps/dp-client/src/screens/diary/pages/my/components/MonthPicker.tsx:30
#: apps/dp-client/src/screens/diary/components/MonthPicker/index.tsx:31
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:248
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:260
msgid "選擇月份"
msgstr "選擇月份"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:867
msgid "選擇桌位"
msgstr "選擇桌位"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:825
msgid "選擇桌型"
msgstr "選擇桌型"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:294
msgid "選擇標籤後，餐點圖片為必填項"
msgstr "選擇標籤後，餐點圖片為必填項"

#: apps/dp-business/src/pages/MenuItemForm.tsx:486
msgid "選擇標籤後為必填"
msgstr "選擇標籤後為必填"

#: apps/dp-business/src/pages/MenuItemForm.tsx:276
msgid "選擇標籤後餐點圖片為必填項"
msgstr "選擇標籤後餐點圖片為必填項"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:209
msgid "選擇模式"
msgstr "選擇模式"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:229
msgid "選擇模板"
msgstr "選擇模板"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchCreateModal/index.web.tsx:316
msgid "選擇檔案上傳"
msgstr "選擇檔案上傳"

#: apps/dp-client/src/components/Upload/index.tsx:364
msgid "選擇檔案失敗，請重試"
msgstr "選擇檔案失敗，請重試"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1507
msgid "選擇此項，顧客的訂位申請將自動接受"
msgstr "選擇此項，顧客的訂位申請將自動接受"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1518
msgid "選擇此項，顧客的訂位申請需要手動接受"
msgstr "選擇此項，顧客的訂位申請需要手動接受"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:259
msgid "選擇活動渠道"
msgstr "選擇活動渠道"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:154
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityFilter.tsx:77
msgid "選擇活動類型"
msgstr "選擇活動類型"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:75
msgid "選擇消息類型"
msgstr "選擇消息類型"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConsumeConfigEditor/index.web.tsx:56
msgid "選擇消耗權益"
msgstr "選擇消耗權益"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignChannelFields/index.web.tsx:26
msgid "選擇渠道"
msgstr "選擇渠道"

#: apps/dp-client/src/screens/home/bizComponents/NoteActionModal/NoteActionModalContent.tsx:21
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:110
msgid "選擇照片"
msgstr "選擇照片"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:506
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:505
msgid "選擇照片失敗，請重試"
msgstr "選擇照片失敗，請重試"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantEditForm/index.web.tsx:485
msgid "選擇營運狀態"
msgstr "選擇營運狀態"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:858
msgid "選擇特殊日期"
msgstr "選擇特殊日期"

#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:39
#: apps/dp-client/src/screens/diary/pages/my/components/DiarySearchFilter.tsx:167
#: apps/dp-business/src/pages/ClaimRequests/index.tsx:250
msgid "選擇狀態"
msgstr "選擇狀態"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:749
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:750
msgid "選擇生效時間"
msgstr "選擇生效時間"

#: apps/dp-client/src/screens/account/pages/edit-profile/components/WheelDatePicker/index.tsx:196
msgid "選擇生日"
msgstr "選擇生日"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/CombinedListForm/index.web.tsx:29
msgid "選擇用戶名單"
msgstr "選擇用戶名單"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BatchRejectWinnerModal.web.tsx:87
msgid "選擇用戶名單（選填）"
msgstr "選擇用戶名單（選填）"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:12
msgid "選擇用戶完成什麼行為才發獎，例如收藏店家、分享筆記或店家打卡。可設定一條或多條觸發事件，同一事件可選不同過濾項，但事件與過濾項的組合不可重複；需要過濾條件的事件，須完成對應條件設定。"
msgstr "選擇用戶完成什麼行為才發獎，例如收藏店家、分享筆記或店家打卡。可設定一條或多條觸發事件，同一事件可選不同過濾項，但事件與過濾項的組合不可重複；需要過濾條件的事件，須完成對應條件設定。"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/UserTargetingConfig/index.web.tsx:68
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/TriggerEventForm/index.web.tsx:224
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/PointConsumptionForm/index.web.tsx:169
msgid "選擇用戶組"
msgstr "選擇用戶組"

#: apps/dp-client/src/screens/reservation/pages/main/components/DateModal.tsx:62
msgid "選擇用餐日期"
msgstr "選擇用餐日期"

#: apps/dp-client/src/screens/reservation/pages/main/components/TimeModal.tsx:109
msgid "選擇用餐時段"
msgstr "選擇用餐時段"

#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:90
msgid "選擇登入方式"
msgstr "選擇登入方式"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/ConfigHelp/index.web.tsx:28
msgid "選擇發放給用戶的權益，再配置獎勵機制與發放數量。固定獎勵按設定數量發放；階梯獎勵需設定各階梯條件與獎勵。最後確認獎勵限制，並按需要開啟發放成功通知用戶。"
msgstr "選擇發放給用戶的權益，再配置獎勵機制與發放數量。固定獎勵按設定數量發放；階梯獎勵需設定各階梯條件與獎勵。最後確認獎勵限制，並按需要開啟發放成功通知用戶。"

#: apps/dp-client/src/configs/page-configs.tsx:2420
msgid "選擇發票抬頭"
msgstr "選擇發票抬頭"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:536
msgid "選擇發票日期"
msgstr "選擇發票日期"

#: apps/dp-client/src/screens/diary/pages/my/components/CropPhoto/index.web.tsx:158
msgid "選擇的圖片無效，請重新選擇圖片"
msgstr "選擇的圖片無效，請重新選擇圖片"

#: apps/dp-business/src/components/TimePicker/TimePickerModal.tsx:92
msgid "選擇的時間"
msgstr "選擇的時間"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:1048
msgid "選擇目標店家："
msgstr "選擇目標店家："

#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:122
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/BatchOperationModal/config.tsx:127
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:122
#: apps/dp-admin/src/pages/merchant/shop-list/components/BatchOperationModal/config.tsx:127
msgid "選擇直營/加盟"
msgstr "選擇直營/加盟"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:864
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:940
msgid "選擇管理店家"
msgstr "選擇管理店家"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodePickerDrawer/index.web.tsx:103
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/ChainMountTab/ChangeMountNodeModal.web.tsx:121
msgid "選擇管理掛接節點"
msgstr "選擇管理掛接節點"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1060
#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:382
msgid "選擇結束時間"
msgstr "選擇結束時間"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:151
msgid "選擇結算起點"
msgstr "選擇結算起點"

#: apps/dp-admin/src/pages/org-tree/org-detail/components/SettlementPickerDrawer/index.web.tsx:115
msgid "選擇結算路徑"
msgstr "選擇結算路徑"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:805
#: apps/dp-business/src/pages/SettlementOrders/index.tsx:806
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:304
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:305
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:586
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:587
msgid "選擇結算週期"
msgstr "選擇結算週期"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:265
msgid "選擇縣市"
msgstr "選擇縣市"

#: apps/dp-client/src/screens/home/pages/Purchase/components/SelectDishContent/index.tsx:203
#: apps/dp-client/src/configs/page-configs.tsx:804
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1123
msgid "選擇菜品"
msgstr "選擇餐點"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/LandingPageConfig/index.web.tsx:63
msgid "選擇落地頁"
msgstr "選擇落地頁"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:373
msgid "選擇處理方式"
msgstr "選擇處理方式"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:560
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:622
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:498
msgid "選擇複製內容"
msgstr "選擇複製內容"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:843
msgid "選擇要複製的內容："
msgstr "選擇要複製的內容："

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepRoles.web.tsx:208
msgid "選擇角色"
msgstr "選擇角色"

#: apps/dp-admin/src/pages/merchant/shop-list/components/ShopMobile/components/MobileFilterHeader/index.web.tsx:299
msgid "選擇評分區間"
msgstr "選擇評分區間"

#: apps/dp-admin/src/pages/merchant/task-list/components/BatchAssignModal/index.web.tsx:76
#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:63
msgid "選擇追蹤者"
msgstr "選擇追蹤者"

#: apps/dp-admin/src/pages/marketing/coupon-group-form/index.web.tsx:48
msgid "選擇適用商家"
msgstr "選擇適用商家"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1041
#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:342
msgid "選擇開始時間"
msgstr "選擇開始時間"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:338
msgid "選擇需要開通的服務"
msgstr "選擇需要開通的服務"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:295
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:447
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:377
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:574
msgid "選擇類別"
msgstr "選擇類別"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:246
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:427
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:546
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:327
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:554
msgid "選擇餐點"
msgstr "選擇餐點"

#: apps/dp-client/src/screens/reservation/pages/invitation/index.tsx:92
#: apps/dp-client/src/configs/page-configs.tsx:1135
msgid "邀請函"
msgstr "邀請函"

#: apps/dp-client/src/screens/home/pages/ShareKing/components/ShareCompletedCard/index.tsx:50
msgid "邀請更多好友，一起把好運放大"
msgstr "邀請更多好友，一起把好運放大"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:47
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2518
#: apps/dp-admin/src/pages/order/services/utils.ts:581
#: apps/dp-admin/src/components/ImageEditorModal/index.web.tsx:521
msgid "還原"
msgstr "還原"

#: apps/dp-business/src/components/ImageEditorModal/locale.ts:27
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:27
msgid "還原原圖"
msgstr "還原原圖"

#. placeholder {0}: (100 - totalProbability).toFixed(2)
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:569
msgid "還可分配 {0}% 概率"
msgstr "還可分配 {0}% 機率"

#. placeholder {0}: moduleDetail.improvableScore
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:854
msgid "還可提升 {0} 分"
msgstr "還可提升 {0} 分"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallProgressCard/index.tsx:80
msgid "還差"
msgstr "還差"

#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:178
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:196
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:211
msgid "還有什麼要補充說明的呢？歡迎提供相關資訊"
msgstr "還有什麼要補充說明的呢？歡迎提供相關資訊"

#: apps/dp-admin/src/pages/merchant/batch-upload/index.web.tsx:193
msgid "還有圖片正在上傳中，請稍候"
msgstr "還有圖片正在上傳中，請稍候"

#: apps/dp-admin/src/pages/audit-center/settlement-audit-detail/index.web.tsx:216
msgid "還有未處理的結算訂單，無法完成任務"
msgstr "還有未處理的結算訂單，無法完成任務"

#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:219
msgid "還有未處理的請款單，無法完成任務"
msgstr "還有未處理的請款單，無法完成任務"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:156
msgid "還沒人發現這間好店，等你推薦"
msgstr "還沒人發現這間好店，等你推薦"

#: apps/dp-client/src/screens/account/pages/likes/components/ReviewContent/index.tsx:233
#: apps/dp-client/src/screens/account/pages/likes/components/NotesContent/index.tsx:193
msgid "還沒按過讚喔"
msgstr "還沒按過讚喔"

#: apps/dp-client/src/screens/home/pages/UserGift/components/ShopListSection/index.tsx:659
#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:388
#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:391
#: apps/dp-client/src/screens/account/pages/coupon/CouponHistory/index.tsx:232
msgid "還沒有任何券喔"
msgstr "還沒有任何券喔"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/records/index.tsx:194
msgid "還沒有兌換紀錄喔"
msgstr "還沒有兌換紀錄喔"

#: apps/dp-client/src/screens/account/pages/coupon/CouponHistory/index.tsx:237
msgid "還沒有已使用的券喔"
msgstr "還沒有已使用的券喔"

#: apps/dp-client/src/screens/account/pages/coupon/CouponHistory/index.tsx:238
msgid "還沒有已失效的券喔"
msgstr "還沒有已失效的券喔"

#: apps/dp-client/src/screens/account/pages/check-in/pages/index.tsx:363
msgid "還沒有打卡過"
msgstr "還沒有打卡過"

#: apps/dp-client/src/screens/home/pages/Meal/components/CouponPickerModal/index.tsx:278
#: apps/dp-client/src/screens/home/pages/Meal/components/CouponPickerModal/index.tsx:281
msgid "還沒有折扣券"
msgstr "還沒有折扣券"

#: apps/dp-client/src/screens/diary/pages/my/components/MyDiaryContent.tsx:214
msgid "還沒有日記，快來新增第一筆日記吧～"
msgstr "還沒有日記，快來新增第一筆日記吧～"

#: apps/dp-client/src/screens/diary/components/diary-list/index.tsx:88
msgid "還沒有日記喔！快去寫日記賺分數吧～"
msgstr "還沒有日記喔！快去寫日記賺分數吧～"

#: apps/dp-client/src/screens/account/pages/user-profile/components/NoteList/index.tsx:213
msgid "還沒有發布筆記喔"
msgstr "還沒有發布筆記喔"

#: apps/dp-client/src/screens/diary/pages/my/components/MyPointsContent.tsx:92
msgid "還沒有積分喔！快去寫日記賺分數吧～"
msgstr "還沒有積分喔！快去寫日記賺分數吧～"

#: apps/dp-client/src/screens/account/pages/follow-list/hooks/useFollowListData.ts:51
msgid "還沒有粉絲"
msgstr "還沒有粉絲"

#: apps/dp-client/src/screens/home/pages/Review/pages/main/index.tsx:710
#: apps/dp-client/src/screens/account/pages/user-profile/components/ReviewList/index.tsx:216
#: apps/dp-client/src/screens/account/pages/profile/components/MyReviewsContent/index.tsx:190
msgid "還沒有評論過喔"
msgstr "還沒有評論過喔"

#: apps/dp-client/src/screens/account/pages/follow-list/hooks/useFollowListData.ts:50
msgid "還沒有追蹤任何人"
msgstr "還沒有追蹤任何人"

#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsList.tsx:169
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewsList.tsx:247
msgid "還沒有顧客評價，快去邀請顧客留下評價吧！"
msgstr "還沒有顧客評價，快去邀請顧客留下評價吧！"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:746
msgid "邊界範圍備註"
msgstr "邊界範圍備註"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:668
#: apps/dp-admin/src/components/MapPicker/index.web.tsx:637
msgid "邊界面坐標"
msgstr "邊界面坐標"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:491
msgid "部分品類"
msgstr "部分品類"

#. placeholder {0}: successFiles.length
#. placeholder {1}: mediaList.length
#: apps/dp-client/src/screens/home/pages/Note/hooks/useNoteDraft.ts:164
msgid "部分媒體文件上傳失敗，已上傳 {0}/{1} 個文件"
msgstr "部分媒體文件上傳失敗，已上傳 {0}/{1} 個文件"

#: apps/dp-business/src/components/CopyResultView/index.tsx:59
msgid "部分店家未複製成功，請重新嘗試"
msgstr "部分店家未複製成功，請重新嘗試"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:59
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:37
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:140
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:140
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:38
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:40
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:66
#: apps/dp-admin/src/pages/marketing/services/interface/batchTask.ts:33
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:160
msgid "部分成功"
msgstr "部分成功"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:391
msgid "部分日期可用"
msgstr "部分日期可用"

#: apps/dp-client/src/screens/home/utils/order.ts:925
#: apps/dp-client/src/screens/home/utils/order.ts:926
#: apps/dp-client/src/screens/home/utils/order.ts:1015
#: apps/dp-client/src/screens/home/utils/order.ts:1071
#: apps/dp-client/src/screens/home/utils/order.ts:1072
#: apps/dp-client/src/screens/home/utils/order.ts:1088
#: apps/dp-client/src/screens/home/utils/order.ts:1089
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:194
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:133
msgid "部分時段可用"
msgstr "部分時段可用"

#: apps/dp-business/src/pages/MarketingCenter/components/UsageLimitCard.tsx:507
msgid "部分時間可用"
msgstr "部分時間可用"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:873
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:463
#: apps/dp-admin/src/components/BusinessHours/constants.ts:70
msgid "部分時間營業"
msgstr "部分時間營業"

#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:31
msgid "部分核銷"
msgstr "部分核銷"

#: apps/dp-admin/src/components/Benefit/BenefitSelector/index.web.tsx:151
#: apps/dp-admin/src/components/Benefit/BenefitSelector/index.web.tsx:201
msgid "部分權益詳情載入失敗"
msgstr "部分權益詳情載入失敗"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1730
msgid "部分營業時段"
msgstr "部分營業時段"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:710
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:1460
msgid "部分營業時間可用"
msgstr "部分營業時間可用"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/templatePreviewData.ts:96
msgid "部分節假日不可用"
msgstr "部分節假日不可用"

#: apps/dp-client/src/screens/account/pages/order/components/OrderCard/index.tsx:70
#: apps/dp-business/src/servers/order/types.ts:272
#: apps/dp-admin/src/pages/report-center/abnormal-orders/service/constants.ts:55
#: apps/dp-admin/src/pages/order/services/utils.ts:335
#: apps/dp-admin/src/pages/marketing/services/constants.ts:324
msgid "部分退款"
msgstr "部分退款"

#: apps/dp-admin/src/modules/hooks/options/services/constants.ts:45
msgid "部分通過"
msgstr "部分通過"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:151
msgid "郵件"
msgstr "郵件"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/EmailTemplateSection.web.tsx:14
msgid "郵件主題不能超過30字"
msgstr "郵件主題不能超過30字"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/EmailTemplateSection.web.tsx:21
msgid "郵件內容可包含多個佔位符, 佔位符規範：｛中間填寫英文｝"
msgstr "郵件內容可包含多個佔位符, 佔位符規範：｛中間填寫英文｝"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/EmailTemplateSection.web.tsx:10
msgid "郵件模板"
msgstr "郵件模板"

#: apps/dp-admin/src/pages/split-account/services/constants.ts:324
msgid "郵寄中"
msgstr "郵寄中"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/account/ChainAccountForm.tsx:358
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/AccountMergeModal/index.web.tsx:69
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:43
#: apps/dp-admin/src/pages/report-center/services/apis.ts:576
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/UserInfoCard/index.web.tsx:45
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ManagerInfo/index.web.tsx:86
#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:122
#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:196
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:84
#: apps/dp-admin/src/pages/customer-service/services/interface/enums.ts:53
msgid "郵箱"
msgstr "郵箱"

#. placeholder {0}: formatEmail(userProfile.email)
#: apps/dp-business/src/pages/MyProfile/index.tsx:274
msgid "郵箱：{0}"
msgstr "郵箱：{0}"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/TestSendModal.web.tsx:218
msgid "郵箱「{tok}」格式錯誤"
msgstr "郵箱「{tok}」格式錯誤"

#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:228
msgid "郵箱格式不正確"
msgstr "郵箱格式不正確"

#: apps/dp-admin/src/pages/customer-service/components/CreateTicketModal.web.tsx:127
msgid "郵箱渠道"
msgstr "郵箱渠道"

#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:74
msgid "郵箱確認"
msgstr "郵箱確認"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:576
msgid "郵編為三位數字"
msgstr "郵編為三位數字"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:93
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:168
msgid "郵遞區號"
msgstr "郵遞區號"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreBasicInfo/index.web.tsx:97
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:172
msgid "郵遞區號三碼"
msgstr "郵遞區號三碼"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:318
msgid "配置三級渠道名稱時必須同時配置二級渠道名稱"
msgstr "配置三級渠道名稱時必須同時配置二級渠道名稱"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:21
msgid "配置位置"
msgstr "配置位置"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/MessageTemplateSelector/index.web.tsx:206
msgid "配置信息"
msgstr "配置信息"

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:31
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:58
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/searchConfig.ts:20
#: apps/dp-admin/src/pages/resource-config/landing-page-list/services/columns.web.tsx:40
#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/fieldRegistry.tsx:89
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:184
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/BasicInfoSection/index.web.tsx:37
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/searchConfig.ts:17
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/columns.web.tsx:35
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/SearchForm/index.web.tsx:32
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/ActivityListTable/index.web.tsx:53
msgid "配置名稱"
msgstr "配置名稱"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:93
msgid "配置尺寸：260*160"
msgstr "配置尺寸：260*160"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:99
msgid "配置尺寸：468*160"
msgstr "配置尺寸：468*160"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/SubmitConfirmModal.tsx:113
#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:1346
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/SubmitConfirmModal/index.web.tsx:125
msgid "配置摘要預覽"
msgstr "配置摘要預覽"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/index.web.tsx:88
msgid "配置活動位基礎規則、展示素材與定向條件"
msgstr "配置活動位基礎規則、展示素材與定向條件"

#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:302
msgid "配置訂位服務與收費"
msgstr "配置訂位服務與收費"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/index.web.tsx:243
#: apps/dp-admin/src/components/UserGroup/UserGroupSelector/index.web.tsx:285
#: apps/dp-admin/src/components/UserGroup/UserGroupFilterConditionsCard/index.web.tsx:361
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupSelector/index.web.tsx:369
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupSelector/index.web.tsx:379
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:348
#: apps/dp-admin/src/components/LandingPage/LandingPageSelector/index.web.tsx:302
msgid "配置資訊"
msgstr "配置資訊"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:299
msgid "配置路徑："
msgstr "配置路徑："

#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/columns.web.tsx:38
#: apps/dp-admin/src/pages/resource-config/components/BasicInfoSection/index.web.tsx:194
msgid "配置類型"
msgstr "配置類型"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:61
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:62
msgid "酸辣湯"
msgstr "酸辣湯"

#: apps/dp-business/src/data/categories.ts:180
msgid "醬油拉麵"
msgstr "醬油拉麵"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:50
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:30
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:30
msgid "重做"
msgstr "重做"

#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:733
msgid "重傳失敗"
msgstr "重傳失敗"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:252
msgid "重定向目標"
msgstr "重定向目標"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:258
msgid "重定向路由必須設置重定向目標"
msgstr "重定向路由必須設置重定向目標"

#: apps/dp-client/src/App.tsx:71
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/index.tsx:460
msgid "重啟"
msgstr "重啟"

#: apps/dp-client/src/components/verify-code-sender/index.tsx:185
msgid "重新"
msgstr "重新"

#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:871
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:310
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:395
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:301
msgid "重新上傳"
msgstr "重新上傳"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:466
msgid "重新上傳資料"
msgstr "重新上傳資料"

#: apps/dp-business/src/pages/ChainDashboard/components/ChainErrorState.tsx:57
#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1039
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:676
#: apps/dp-admin/src/components/ErrorBoundary/index.web.tsx:95
msgid "重新加載"
msgstr "重新加載"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1038
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:675
msgid "重新加載將捨棄本頁未保存的改動。"
msgstr "重新加載將捨棄本頁未保存的改動。"

#: apps/dp-business/src/components/CopyResultView/index.tsx:138
msgid "重新嘗試"
msgstr "重新嘗試"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:143
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:163
msgid "重新回傳"
msgstr "重新回傳"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:156
msgid "重新回傳失敗"
msgstr "重新回傳失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:156
msgid "重新回傳失敗：{reasonText}"
msgstr "重新回傳失敗：{reasonText}"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:162
msgid "重新回傳完成：成功 {successCount} 筆，失敗 {failedCount} 筆"
msgstr "重新回傳完成：成功 {successCount} 筆，失敗 {failedCount} 筆"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:161
msgid "重新回傳完成：成功 {successCount} 筆，失敗 {failedCount} 筆（{reasonText}）"
msgstr "重新回傳完成：成功 {successCount} 筆，失敗 {failedCount} 筆（{reasonText}）"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:153
msgid "重新回傳成功"
msgstr "重新回傳成功"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:256
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:52
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:53
msgid "重新居中"
msgstr "重新居中"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:468
msgid "重新掃描"
msgstr "重新掃描"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationErrorDialog.tsx:72
msgid "重新掃碼"
msgstr "重新掃碼"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:303
#: apps/dp-business/src/pages/MerchantReview/index.tsx:304
#: apps/dp-business/src/pages/MerchantReview/index.tsx:351
msgid "重新提交失敗，請稍後重試"
msgstr "重新上傳失敗，請稍後重試"

#: apps/dp-admin/src/components/ModifiedFieldTag/index.web.tsx:80
msgid "重新提交審核"
msgstr "重新提交審核"

#: apps/dp-business/src/pages/MerchantReview/index.tsx:327
msgid "重新提交成功，正在跳轉到相應頁面..."
msgstr "重新上傳成功，正在跳轉到相應頁面..."

#: apps/dp-business/src/servers/merchantReview/api.ts:97
msgid "重新提交申請失敗"
msgstr "重新上傳申請失敗"

#: apps/dp-client/src/screens/diary/pages/search/index.tsx:256
msgid "重新搜尋"
msgstr "重新搜尋"

#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:198
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/columns.web.tsx:209
msgid "重新啟用"
msgstr "重新啟用"

#: apps/dp-client/src/screens/others/NoNetwork.tsx:46
#: apps/dp-business/src/App.native.tsx:788
#: apps/dp-business/src/pages/TableManagement/index.tsx:1055
#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1918
#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:1078
#: apps/dp-business/src/components/ErrorPage/index.tsx:67
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/ExportHistoryTab/index.web.tsx:144
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/ExportHistoryTab/index.web.tsx:144
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/index.web.tsx:71
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:241
#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/Details.web.tsx:73
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:130
#: apps/dp-admin/src/modules/hooks/notificationConnection.ts:95
msgid "重新整理"
msgstr "重新整理"

#: apps/dp-client/src/screens/others/NoNetwork.tsx:46
#: apps/dp-client/src/screens/diary/components/diary-list/index.tsx:167
#: apps/dp-client/src/screens/diary/components/PullToLoad/index.tsx:376
#: apps/dp-client/src/screens/diary/components/PullToLoad/index.tsx:394
#: apps/dp-client/src/components/PullToLoad/index.tsx:379
#: apps/dp-client/src/components/PullToLoad/index.tsx:397
msgid "重新整理中..."
msgstr "重新整理中..."

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1007
msgid "重新整理失敗"
msgstr "重新整理失敗"

#: apps/dp-business/src/pages/ReservationManagement/index.tsx:1005
msgid "重新整理成功"
msgstr "重新整理成功"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:347
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:236
#: apps/dp-client/src/components/verify-code-sender/index.tsx:189
msgid "重新獲取"
msgstr "重新獲取"

#: apps/dp-business/src/pages/UserManagement/AddUserForm.tsx:377
#: apps/dp-business/src/pages/UserManagement/AddTempUserForm.tsx:272
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:192
#: apps/dp-admin/src/pages/merchant/merchant-account/components/TempAccountApplyModal.web.tsx:154
msgid "重新生成"
msgstr "重新生成"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/redemption/index.tsx:241
msgid "重新生成核銷券碼失敗，請重新發起"
msgstr "重新生成核銷券碼失敗，請重新發起"

#: apps/dp-business/src/servers/permission/api.ts:283
#: apps/dp-business/src/pages/UserManagement/EditUserPage.tsx:46
#: apps/dp-business/src/pages/UserManagement/EditUserPage.tsx:52
msgid "重新產生帳號密碼失敗"
msgstr "重新產生帳號密碼失敗"

#: packages/captcha/src/SecurityCaptchaProvider.tsx:195
msgid "重新產生驗證碼"
msgstr "重新產生驗證碼"

#: apps/dp-client/src/notifications/multi-login.ts:47
#: apps/dp-business/src/pages/Unauthorized/index.tsx:111
#: apps/dp-admin/src/pages/error/403.web.tsx:90
msgid "重新登入"
msgstr "重新登入"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:196
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/BenefitIssueColumns.web.tsx:172
msgid "重新發放"
msgstr "重新發放"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:209
msgid "重新發放失敗"
msgstr "重新發放失敗"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:209
msgid "重新發放失敗：{reasonText}"
msgstr "重新發放失敗：{reasonText}"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:215
msgid "重新發放完成：成功 {successCount} 筆，失敗 {failedCount} 筆"
msgstr "重新發放完成：成功 {successCount} 筆，失敗 {failedCount} 筆"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:214
msgid "重新發放完成：成功 {successCount} 筆，失敗 {failedCount} 筆（{reasonText}）"
msgstr "重新發放完成：成功 {successCount} 筆，失敗 {failedCount} 筆（{reasonText}）"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/benefitIssueHooks.ts:206
msgid "重新發放成功"
msgstr "重新發放成功"

#: apps/dp-client/src/screens/payment/pages/result/index.tsx:603
#: apps/dp-client/src/screens/payment/pages/result/index.tsx:626
#: apps/dp-client/src/screens/payment/pages/result/index.tsx:649
#: apps/dp-admin/src/pages/org-tree/org-list/services/constants.ts:76
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/index.web.tsx:257
#: apps/dp-admin/src/pages/merchant/service/constants.ts:252
#: apps/dp-admin/src/pages/merchant/service/constants.ts:257
msgid "重新發起"
msgstr "重新發起"

#: apps/dp-business/src/components/CodeVerification/index.tsx:256
msgid "重新發送驗證碼"
msgstr "重新發送驗證碼"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:218
msgid "重新落地"
msgstr "重新落地"

#: apps/dp-client/src/screens/diary/pages/bounty-form/index.tsx:401
#: apps/dp-business/src/pages/MerchantReview/index.tsx:511
#: apps/dp-admin/src/pages/merchant/information-review/index.web.tsx:80
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/index.web.tsx:107
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:388
msgid "重新載入"
msgstr "重新載入"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:663
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:692
#: apps/dp-client/src/screens/home/pages/Note/hooks/usePhotoSelection.ts:297
#: apps/dp-client/src/screens/home/pages/Note/components/MediaDisplay/index.tsx:122
msgid "重新選擇"
msgstr "重新選擇"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/LandingUrlField.web.tsx:38
msgid "重新配置"
msgstr "重新配置"

#: apps/dp-admin/src/pages/report-center/services/interface/manual-compensation.ts:73
msgid "重新開票"
msgstr "重新開票"

#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:179
msgid "重新顯示"
msgstr "重新顯示"

#: apps/dp-business/src/components/VerificationInput/index.tsx:344
msgid "重新驗證"
msgstr "重新驗證"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:17
#: apps/dp-business/src/pages/ServiceManagement/components/DiscountServiceSettings.tsx:273
#: apps/dp-business/src/pages/RefundList/index.tsx:411
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1883
#: apps/dp-business/src/pages/OrderOverview/FilterModal.tsx:356
#: apps/dp-business/src/pages/OrderList/index.tsx:960
#: apps/dp-business/src/pages/OrderDetails/components/FilterCard.tsx:44
#: apps/dp-business/src/pages/CouponVerification/index.tsx:901
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1079
#: apps/dp-business/src/pages/CouponVerification/components/CashierRecordsPanel.tsx:410
#: apps/dp-business/src/pages/ChainDashboard/components/reports/ChainReportFilterBar.tsx:98
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainSettlementList.tsx:310
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimList.tsx:267
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:592
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:10
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountToolbar/index.web.tsx:123
#: apps/dp-admin/src/pages/users/roles/components/RoleToolbar/index.web.tsx:127
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1198
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:446
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:748
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:772
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/SearchFilter.web.tsx:94
#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:205
#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/SearchFilter.web.tsx:103
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:171
#: apps/dp-admin/src/pages/report-center/merchant-entry-signing/components/SearchFilter.web.tsx:105
#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/SearchFilter.web.tsx:95
#: apps/dp-admin/src/pages/report-center/audit-data/components/SearchFilter.web.tsx:82
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:254
#: apps/dp-admin/src/pages/org-tree/org-list/components/SearchForm/index.web.tsx:118
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeSearchForm/index.web.tsx:42
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:273
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountShopModal/index.web.tsx:195
#: apps/dp-admin/src/pages/org-tree/org-detail/components/BatchMountMallModal/index.web.tsx:134
#: apps/dp-admin/src/pages/org-tree/org-audit/components/SearchForm/index.web.tsx:171
#: apps/dp-admin/src/pages/merchant/task-list/components/SearchForm/index.web.tsx:203
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/SearchForm/index.web.tsx:190
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ClientSearchPanel/index.web.tsx:53
#: apps/dp-admin/src/pages/merchant/shop-list/components/SearchForm/index.web.tsx:512
#: apps/dp-admin/src/pages/merchant/merchant-account/index.web.tsx:210
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:357
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:242
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/components/SearchForm/index.web.tsx:66
#: apps/dp-admin/src/pages/merchant/check-in/components/SearchForm/index.web.tsx:216
#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:179
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryUserDrawHistoryModal.web.tsx:132
#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:672
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:157
#: apps/dp-admin/src/pages/label-management/components/LabelFilter.web.tsx:133
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:199
#: apps/dp-admin/src/pages/customer-service/components/TicketFilter.web.tsx:118
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:149
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:147
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:319
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:216
#: apps/dp-admin/src/components/SearchForm/index.web.tsx:100
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:10
msgid "重置"
msgstr "重置"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:308
msgid "重置密碼"
msgstr "重置密碼"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:98
msgid "重置密碼後，新密碼將透過郵件發送給您。確定要重置密碼嗎？"
msgstr "重置密碼後，新密碼將透過郵件發送給您。確定要重置密碼嗎？"

#: apps/dp-business/src/pages/UserManagement/index.tsx:761
#: apps/dp-business/src/pages/UserManagement/index.tsx:799
#: apps/dp-business/src/pages/OrderOverview/index.tsx:1734
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:195
#: apps/dp-business/src/pages/MarketingCenter/ActivityManagementV2/components/JoinedActivityFilterCard.tsx:150
#: apps/dp-business/src/components/ShopSelectTable/index.tsx:396
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignChannelSelectorModal/index.web.tsx:353
msgid "重置篩選"
msgstr "重置篩選"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:457
msgid "重置表單"
msgstr "重置表單"

#: apps/dp-business/src/pages/OrderList/index.tsx:335
msgid "重置訂單明細失敗，請稍後重試"
msgstr "重置訂單明細失敗，請稍後重試"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:106
#: apps/dp-admin/src/pages/marketing/services/interface/batchTask.ts:202
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:188
#: apps/dp-admin/src/pages/marketing/components/GroupImportResultModal/index.web.tsx:85
msgid "重複"
msgstr "重複"

#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:39
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/services/hooks.ts:28
msgid "重複提交"
msgstr "重複提交"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:24
msgid "重複支付"
msgstr "重複支付"

#: apps/dp-business/src/pages/ChainDashboard/components/permission/role/ChainRoleForm.tsx:64
msgid "重設密碼"
msgstr "重設密碼"

#: apps/dp-business/src/servers/chain/accountApi.ts:236
msgid "重設密碼失敗"
msgstr "重設密碼失敗"

#: apps/dp-client/src/screens/diary/pages/merchant/index.tsx:190
#: apps/dp-client/src/components/PageContainer/ErrorBoundary.tsx:53
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:260
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:296
#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:173
#: apps/dp-business/src/pages/ContactBD/index.tsx:136
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:252
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:863
#: apps/dp-business/src/components/GoogleMap/WebViewMap.tsx:713
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CurrentCommissionCard.web.tsx:37
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CommissionBenefitListCard.web.tsx:97
#: apps/dp-admin/src/pages/transaction/service-management/components/MerchantPackageServiceOverview/index.web.tsx:82
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:420
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:201
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:130
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:297
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:715
#: apps/dp-admin/src/pages/marketing/merchant-benefit-form/index.web.tsx:232
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/SupplementCouponCodesModal.web.tsx:118
#: apps/dp-admin/src/components/PrivateImage/index.web.tsx:135
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:174
#: apps/dp-admin/src/components/Benefit/BenefitSelector/index.web.tsx:207
#: apps/dp-admin/src/components/Benefit/BenefitDetailInfo/index.web.tsx:70
msgid "重試"
msgstr "重試"

#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:55
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:35
#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:161
#: apps/dp-admin/src/pages/merchant/copy-record-list/index.web.tsx:36
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:38
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:64
msgid "重試中"
msgstr "重試中"

#: apps/dp-business/src/components/CopyResultView/index.tsx:137
msgid "重試中..."
msgstr "重試中..."

#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:106
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:131
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:78
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:275
msgid "重試任務已提交"
msgstr "重試任務已提交"

#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:169
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:818
#: apps/dp-admin/src/components/ImageListUploader/index.web.tsx:340
msgid "重試全部失敗"
msgstr "重試全部失敗"

#: apps/dp-business/src/servers/permission/api.ts:577
#: apps/dp-business/src/servers/permission/api.ts:600
#: apps/dp-business/src/pages/UserManagement/CopyShopPage.tsx:276
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:171
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:174
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:191
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:195
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:109
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:112
#: apps/dp-admin/src/pages/merchant/copy-record-detail/index.web.tsx:81
#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:278
msgid "重試失敗"
msgstr "重試失敗"

#: apps/dp-admin/src/pages/resource-config/delivery-record-list/components/columns/index.web.tsx:176
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/TaskList/index.web.tsx:79
msgid "重試次數"
msgstr "重試次數"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:1468
#: apps/dp-admin/src/pages/org-tree/org-create/services/hooks.ts:1797
msgid "重試確認"
msgstr "重試確認"

#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:534
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:339
msgid "重試複製"
msgstr "重試複製"

#: apps/dp-business/src/servers/shop/api.ts:719
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:134
#: apps/dp-business/src/pages/BatchCopyShopInfo/BatchCopyDetail.tsx:137
msgid "重試複製失敗"
msgstr "重試複製失敗"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:14
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:27
msgid "金剛位"
msgstr "金剛位"

#: apps/dp-admin/src/router/config/routes.web.tsx:602
msgid "金剛位設定"
msgstr "金剛位設定"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:288
msgid "金卡會員"
msgstr "金卡會員"

#: apps/dp-business/src/data/regions.ts:76
msgid "金山區"
msgstr "金山區"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/services/formConfig.ts:593
msgid "金融機構代碼不能超過10個字符"
msgstr "金融機構代碼不能超過10個字符"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:81
#: apps/dp-admin/src/pages/org-tree/org-detail/components/NodeMerchantSection/index.web.tsx:137
msgid "金融機構分類"
msgstr "金融機構分類"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:65
msgid "金融機構分類(分行/支行)"
msgstr "金融機構分類(分行/支行)"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:109
msgid "金融機構帳戶之帳號"
msgstr "金融機構帳戶之帳號"

#: apps/dp-business/src/data/regions.ts:28
msgid "金門"
msgstr "金門"

#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:169
#: apps/dp-business/src/pages/OrderDetail/index.tsx:1867
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2175
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2657
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:84
#: apps/dp-admin/src/pages/org-tree/components/S9BlockModal/index.web.tsx:66
#: apps/dp-admin/src/pages/order/order-detail/components/SubsidyDetailModal/index.web.tsx:141
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:220
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:263
msgid "金額"
msgstr "金額"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:659
msgid "金額只能輸入整數"
msgstr "金額只能輸入整數"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:229
msgid "金額必須大於0"
msgstr "金額必須大於0"

#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:664
msgid "金額必須大於1"
msgstr "金額必須大於1"

#: apps/dp-admin/src/pages/order/order-detail/components/RefundConfirmModal/index.web.tsx:108
msgid "金額明細"
msgstr "金額明細"

#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:141
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:115
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:277
#: apps/dp-admin/src/pages/order/order-detail/components/BasicInfo/index.web.tsx:132
#: apps/dp-admin/src/pages/order/hooks/useOrderColumns.web.tsx:149
#: apps/dp-admin/src/pages/marketing/verification-record-detail/index.web.tsx:90
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:327
msgid "金額資訊"
msgstr "金額資訊"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:1929
msgid "針對新註冊用戶的首單優惠活動"
msgstr "針對新註冊用戶的首單優惠活動"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:287
msgid "銀卡會員"
msgstr "銀卡會員"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:154
msgid "銀色"
msgstr "銀色"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:220
msgid "銀行帳戶"
msgstr "銀行帳戶"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PaymentConsultation/index.web.tsx:91
msgid "銀行帳戶戶名"
msgstr "銀行帳戶戶名"

#: apps/dp-client/src/screens/home/pages/PackageZone/constants.ts:10
msgid "銷售"
msgstr "銷售"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:201
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:257
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:282
msgid "銷售數據"
msgstr "銷售數據"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:322
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:384
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:486
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:123
msgid "銷售時間"
msgstr "銷售時間"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:190
msgid "銷售結束時間不能早於原結束時間"
msgstr "銷售結束時間不能早於原結束時間"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:209
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:181
msgid "銷售結束時間必須大於當前時間"
msgstr "銷售結束時間必須大於當前時間"

#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:198
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:140
msgid "銷售開始時間必須大於當前時間"
msgstr "銷售開始時間必須大於當前時間"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:372
msgid "銷售額（免稅）"
msgstr "銷售額（免稅）"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:361
msgid "銷售額（應稅）"
msgstr "銷售額（應稅）"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:251
msgid "銷貨明細"
msgstr "銷貨明細"

#: apps/dp-admin/src/pages/resource-config/landing-page-detail/services/constants.ts:76
#: apps/dp-admin/src/pages/resource-config/components/ContentFilterSelector/index.web.tsx:13
msgid "銷量"
msgstr "銷量"

#: apps/dp-client/src/screens/home/pages/PackageZone/v2/components/shared/PackageFilterBar.tsx:65
msgid "銷量最高"
msgstr "銷量最高"

#: apps/dp-client/src/screens/home/pages/Note/constants/index.ts:25
msgid "錄像失敗"
msgstr "錄影失敗"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:1178
msgid "錄影"
msgstr "錄影"

#: apps/dp-client/src/screens/home/pages/Note/constants/index.ts:30
msgid "錄音權限被拒絕"
msgstr "錄音權限被拒絕"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:685
#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:758
#: apps/dp-client/src/screens/home/pages/Note/hooks/usePhotoSelection.ts:194
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:593
msgid "錯誤"
msgstr "錯誤"

#. placeholder {0}: result.errorCount ?? 0
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:150
msgid "錯誤：{0}"
msgstr "錯誤：{0}"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:352
msgid "錯誤：保留了0"
msgstr "錯誤：保留了0"

#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:467
#: apps/dp-business/src/pages/BusinessHours/EditTimeModal.tsx:469
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:185
#: apps/dp-business/src/pages/BusinessHours/EditDateModal.tsx:187
msgid "錯誤：與已有時間段重複"
msgstr "錯誤：與已有時間段重複"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:308
msgid "錯誤回報"
msgstr "錯誤回報"

#. placeholder {0}: result.errors.length
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:156
msgid "錯誤明細（{0}）"
msgstr "錯誤明細（{0}）"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:2384
#: apps/dp-admin/src/pages/resource-config/message-edit/components/TemplateParamImport.web.tsx:28
msgid "錯誤資訊"
msgstr "錯誤資訊"

#: apps/dp-admin/src/pages/audit-center/information-error-audit-detail/index.web.tsx:225
msgid "錯誤類型"
msgstr "錯誤類型"

#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:18
#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:38
msgid "鎖定"
msgstr "鎖定"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/InAppTemplateSection.web.tsx:36
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/AppPushTemplateSection.web.tsx:39
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activity-detail/components/MediaLandingSection/index.web.tsx:92
msgid "鏈接類型"
msgstr "鏈接類型"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:306
msgid "鐵鏽色"
msgstr "鐵鏽色"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:295
msgid "鑲邊"
msgstr "鑲邊"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:289
msgid "鑽石會員"
msgstr "鑽石會員"

#: apps/dp-client/src/screens/account/pages/account-security/set-password/index.tsx:179
msgid "長度8-32位，需包含數字、字母、符號至少2種或以上元素"
msgstr "長度8-32位，需包含數字、字母、符號至少2種或以上"

#: apps/dp-admin/src/pages/merchant/merchant-account/services/constants.ts:53
#: apps/dp-admin/src/pages/label-management/label-list/services/constants.ts:41
msgid "長期"
msgstr "長期"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1327
#: apps/dp-business/src/pages/MarketingCenter/components/ValidityPeriodCard.tsx:380
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:802
#: apps/dp-business/src/components/DatePicker.tsx:601
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:286
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:206
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/ValiditySection/index.web.tsx:222
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:313
msgid "長期售賣"
msgstr "長期售賣"

#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/ServicesConfig/index.web.tsx:75
msgid "長期有效"
msgstr "長期有效"

#: apps/dp-business/src/data/categories.ts:80
msgid "長沙菜"
msgstr "長沙菜"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PriceCard.tsx:116
msgid "門店價"
msgstr "店內價"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:113
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:78
msgid "門店價格"
msgstr "門店價格"

#: apps/dp-business/src/pages/ContractManagement/ContractForm.tsx:188
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/StoreImageArchive/index.web.tsx:35
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/components/MaterialFiles/index.web.tsx:33
msgid "門牌"
msgstr "門牌"

#: apps/dp-admin/src/pages/merchant/service/utils/dataTransform.ts:380
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:326
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:332
msgid "門牌圖片"
msgstr "門牌圖片"

#: apps/dp-business/src/pages/AddStore/index.tsx:1441
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:36
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/StoreImages/index.web.tsx:46
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:96
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:98
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/ShopInfoSection.web.tsx:66
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/ShopInfoSection.web.tsx:72
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/ShopInfoSection/index.web.tsx:77
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/ShopInfoSection/index.web.tsx:83
msgid "門牌照片"
msgstr "門牌照片"

#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:175
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:181
msgid "門臉照片"
msgstr "門臉照片"

#: apps/dp-client/src/screens/account/pages/account-security/index.tsx:149
msgid "門號不存在，請聯絡客服"
msgstr "門號不存在，請聯絡客服"

#: apps/dp-business/src/pages/ChangePhone/index.tsx:30
msgid "門號換綁成功，請重新登入"
msgstr "門號換綁成功，請重新登入"

#: apps/dp-admin/src/pages/merchant/components/UploadTips/index.web.tsx:68
msgid "門頭圖片展示商家 <0>店面外觀</0>，幫助顧客識別店家"
msgstr "門頭圖片展示商家 <0>店面外觀</0>，幫助顧客識別店家"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:131
#: apps/dp-business/src/components/DatePicker.tsx:546
msgid "開始"
msgstr "開始"

#: apps/dp-business/src/components/DatePicker.tsx:546
msgid "開始（固定）"
msgstr "開始（固定）"

#: apps/dp-business/src/servers/ocr/api.ts:29
msgid "開始OCR識別失敗"
msgstr "開始OCR識別失敗"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:213
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:242
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:273
msgid "開始下載"
msgstr "開始下載"

#: apps/dp-business/src/pages/Login/Email/index.tsx:194
#: apps/dp-business/src/components/PhoneVerification/index.tsx:302
#: apps/dp-business/src/components/EmailVerification/index.tsx:307
msgid "開始使用"
msgstr "開始使用"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BasicInfoTab/index.web.tsx:83
msgid "開始入駐"
msgstr "開始入駐"

#: apps/dp-admin/src/pages/exception/services/constants.ts:43
msgid "開始切換"
msgstr "開始切換"

#: apps/dp-admin/src/pages/exception/services/constants.ts:35
#: apps/dp-admin/src/pages/exception/services/constants.ts:39
msgid "開始初始化"
msgstr "開始初始化"

#: apps/dp-client/src/screens/home/pages/Note/pages/draft/index.tsx:214
msgid "開始創作你的第一篇筆記吧"
msgstr "開始創作你的第一篇筆記吧"

#: apps/dp-admin/src/pages/customer-service/components/CreateTicketModal.web.tsx:78
msgid "開始創建"
msgstr "開始創建"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:216
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:272
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:298
msgid "開始售賣時間"
msgstr "開始售賣時間"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:623
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:276
msgid "開始填寫"
msgstr "開始填寫"

#: apps/dp-business/src/pages/SimpleDashboard/components/ScanCard.tsx:127
msgid "開始掃描"
msgstr "開始掃描"

#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:218
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/PackageCommissionRules/index.web.tsx:102
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/DiscountCommissionRules/index.web.tsx:109
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BookingFeeRules/index.web.tsx:97
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/components/BasicConsultation/index.web.tsx:95
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/PackageCommissionRules/index.web.tsx:81
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/components/BookingFeeRules/index.web.tsx:83
#: apps/dp-admin/src/pages/split-account/settlement-list/services/config.web.tsx:56
#: apps/dp-admin/src/pages/resource-config/holiday-management/services/searchConfig.ts:58
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayFormModal.web.tsx:119
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayColumns.web.tsx:51
#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:192
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:168
#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:181
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-activities/services/searchConfig.ts:47
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:169
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:318
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:93
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/FilterTabs.web.tsx:122
#: apps/dp-admin/src/pages/audit-center/info-audit/components/SearchForm/index.web.tsx:117
#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:168
msgid "開始日期"
msgstr "開始日期"

#: apps/dp-business/src/types/orderFilter.ts:145
#: apps/dp-business/src/types/orderFilter.ts:157
msgid "開始日期-結束日期"
msgstr "開始日期-結束日期"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/SearchForm/index.web.tsx:161
msgid "開始日期不能晚於結束日期"
msgstr "開始日期不能晚於結束日期"

#: apps/dp-business/src/pages/MarketingCenter/utils/validation.ts:284
msgid "開始日期必須小於結束日期"
msgstr "開始日期必須小於結束日期"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1027
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:166
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:474
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:499
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:538
#: apps/dp-business/src/pages/ContractManagement/ContractDetail.tsx:570
#: apps/dp-business/src/components/DatePicker.tsx:556
#: apps/dp-business/src/components/TimePicker/TimePickerModal.tsx:100
#: apps/dp-business/src/components/CompactTimePicker/index.tsx:129
#: apps/dp-business/src/components/CompactTimePicker/index.tsx:131
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReviewListTab/index.web.tsx:154
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:153
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:163
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:173
#: apps/dp-admin/src/pages/user-info/user-detail/components/OrderListTab/index.web.tsx:94
#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:118
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:403
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:781
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1265
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1285
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:51
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:89
#: apps/dp-admin/src/pages/transaction/merchant-contract-detail/services/config.tsx:119
#: apps/dp-admin/src/pages/split-account/settlement-orders/services/config.web.tsx:57
#: apps/dp-admin/src/pages/resource-config/slot-material-list/services/searchConfig.ts:61
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:263
#: apps/dp-admin/src/pages/resource-config/message-template-edit/components/BasicInfoSection.web.tsx:306
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:236
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:76
#: apps/dp-admin/src/pages/resource-config/category-management/services/config.web.tsx:144
#: apps/dp-admin/src/pages/resource-config/category-management/second-category-list/index.web.tsx:732
#: apps/dp-admin/src/pages/resource-config/category-management/first-category-list/index.web.tsx:756
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:127
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:137
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/components/SearchForm/index.web.tsx:334
#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/components/TimeSlotItem/index.web.tsx:86
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/services/packageTemplateConfig.web.tsx:114
#: apps/dp-admin/src/pages/merchant/batch-erp-download/index.web.tsx:170
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:87
#: apps/dp-admin/src/pages/marketing/verification-record/services/searchConfig.ts:97
#: apps/dp-admin/src/pages/marketing/user-group-list/services/searchConfig.ts:64
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:82
#: apps/dp-admin/src/pages/marketing/user-activities/services/config.web.tsx:92
#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:121
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:380
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:142
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/config.web.tsx:68
#: apps/dp-admin/src/pages/marketing/merchant-group-list/services/searchConfig.ts:60
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:618
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:671
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:122
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:187
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:118
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:128
#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:136
#: apps/dp-admin/src/pages/marketing/activity-statistics/services/config.web.tsx:81
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:187
#: apps/dp-admin/src/pages/marketing/activity-statistics/components/FilterForm/index.web.tsx:198
#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:697
#: apps/dp-admin/src/pages/marketing/activity-config-form/schema.ts:115
#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:605
#: apps/dp-admin/src/pages/audit-center/settlement-audit/index.web.tsx:52
#: apps/dp-admin/src/pages/audit-center/poi-audit/components/PoiSearchForm/index.web.tsx:116
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/searchConfig.ts:73
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/index.web.tsx:81
#: apps/dp-admin/src/pages/audit-center/merchant-onboarding-audit/index.web.tsx:81
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:72
#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/index.web.tsx:80
#: apps/dp-admin/src/pages/audit-center/merchant-binding-audit/index.web.tsx:81
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit/index.web.tsx:55
#: apps/dp-admin/src/pages/audit-center/information-error-audit/index.web.tsx:65
#: apps/dp-admin/src/pages/audit-center/contract-sign-audit/index.web.tsx:77
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:269
#: apps/dp-admin/src/pages/audit-center/components/SearchForm/index.web.tsx:301
#: apps/dp-admin/src/pages/audit-center/complaint-audit/index.web.tsx:63
#: apps/dp-admin/src/components/BusinessHours/components/BusinessStatusSelector.web.tsx:121
msgid "開始時間"
msgstr "開始時間"

#: apps/dp-admin/src/pages/resource-config/message-edit/components/StepSendConfig.web.tsx:158
msgid "開始時間 / 重複週期"
msgstr "開始時間 / 重複週期"

#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:211
#: apps/dp-admin/src/pages/transaction/service-management/services/interface.ts:223
msgid "開始時間-結束時間"
msgstr "開始時間-結束時間"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:310
#: apps/dp-admin/src/components/BusinessHours/components/BusinessStatusSelector.web.tsx:149
msgid "開始時間必須早於結束時間"
msgstr "開始時間必須早於結束時間"

#: apps/dp-admin/src/pages/report-center/financial-reports/index.web.tsx:203
msgid "開始時間為 00：00：00"
msgstr "開始時間為 00：00：00"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/CycleTimeRange/index.web.tsx:37
msgid "開始時間須為 00:00"
msgstr "開始時間須為 00:00"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BlueNewContractTab/components/NoContractView/index.web.tsx:31
#: apps/dp-admin/src/pages/merchant/merchant-info-detail/components/tabs/AggregateContractTab/index.web.tsx:260
msgid "開始簽約"
msgstr "開始簽約"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:213
msgid "開始處理"
msgstr "開始處理"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:1298
msgid "開始販售時間"
msgstr "開始販售時間"

#: apps/dp-client/src/screens/account/pages/notifications/components/FollowNotificationCard/index.tsx:94
msgid "開始追蹤你了"
msgstr "開始追蹤你了"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:155
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:180
msgid "開收據"
msgstr "開收據"

#: apps/dp-client/src/screens/home/pages/MallDetail/pages/Parking/index.tsx:253
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:41
#: apps/dp-client/src/screens/home/pages/MallDetail/components/ParkingModal/index.tsx:63
msgid "開放中"
msgstr "開放中"

#: apps/dp-client/src/screens/home/pages/PrivateChef/components/PrivateChefShopCard/index.tsx:241
msgid "開放訂位時間"
msgstr "開放訂位時間"

#: apps/dp-client/src/screens/home/components/CitySelect/CityModal.tsx:146
#: apps/dp-client/src/screens/home/components/CityBubble/index.tsx:45
#: apps/dp-client/src/screens/diary/pages/home/components/city-select/index.tsx:253
#: apps/dp-client/src/screens/account/pages/edit-profile/select-residence/index.tsx:280
#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:205
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:233
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:594
#: apps/dp-admin/src/pages/resource-config/services/constants.ts:43
#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:25
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:115
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:157
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:34
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:23
msgid "開啟"
msgstr "開啟"

#: apps/dp-client/src/screens/home/components/CityBubble/index.tsx:41
#: apps/dp-client/src/screens/diary/pages/home/components/city-select/index.tsx:247
msgid "開啟定位，發現更多附近美食"
msgstr "開啟定位，發現更多附近美食"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:572
msgid "開啟後用戶可以自己在APP發起核銷，請與商家充分溝通並且告知風險後開通"
msgstr "開啟後用戶可以自己在APP發起核銷，請與商家充分溝通並且告知風險後開通"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:571
msgid "開啟後算法會在基準分上增加固定權重；關閉時按算法基準排序。"
msgstr "開啟後算法會在基準分上增加固定權重；關閉時按算法基準排序。"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:146
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:164
msgid "開啟手機定位才可以打卡喔"
msgstr "開啟手機定位才可以打卡喔"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:407
msgid "開啟手機定位才可以領取"
msgstr "開啟手機定位才可以領取"

#: apps/dp-client/src/screens/account/pages/coupon/CouponList/index.tsx:178
msgid "開啟掃描"
msgstr "開啟掃描"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/MapNaviation/index.tsx:66
msgid "開啟權限"
msgstr "開啟權限"

#: apps/dp-client/src/screens/home/bizComponents/NoteActionModal/NoteActionModalContent.tsx:16
msgid "開啟相機"
msgstr "開啟相機"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:216
msgid "開啟結帳服務成功"
msgstr "開啟結帳服務成功"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:175
msgid "開啟自核銷服務成功"
msgstr "開啟自核銷服務成功"

#: apps/dp-business/src/components/ServiceNotEnabled/index.tsx:45
msgid "開啟訂位服務，讓顧客隨時鎖定座位，生意不再錯過！"
msgstr "開啟訂位服務，讓顧客隨時鎖定座位，生意不再錯過！"

#: apps/dp-client/src/screens/home/pages/Meal/pages/confirm/index.tsx:965
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:154
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:179
msgid "開發票"
msgstr "開發票"

#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:525
msgid "開票／請款主體：{merchantText}"
msgstr "開票／請款主體：{merchantText}"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:123
#: apps/dp-admin/src/pages/split-account/services/constants.ts:248
msgid "開票中"
msgstr "開票中"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:88
#: apps/dp-admin/src/pages/split-account/services/constants.ts:250
msgid "開票失敗"
msgstr "開票失敗"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/StoreInfo/components/PaymentInfo/index.web.tsx:148
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PaymentInfo/index.web.tsx:173
msgid "開票情況"
msgstr "開票情況"

#: apps/dp-admin/src/pages/split-account/invoice-list/services/hooks.ts:144
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:94
#: apps/dp-admin/src/pages/split-account/invoice-list/services/config.web.tsx:272
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:170
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:168
msgid "開票時間"
msgstr "開票時間"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:443
msgid "開票類型"
msgstr "開票類型"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:523
#: apps/dp-business/src/components/InvoiceForm/index.tsx:574
msgid "開立品名"
msgstr "開立品名"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:224
#: apps/dp-business/src/components/InvoiceForm/index.tsx:276
msgid "開立品名："
msgstr "開立品名："

#: apps/dp-business/src/components/InvoiceForm/index.tsx:220
#: apps/dp-business/src/components/InvoiceForm/index.tsx:271
#: apps/dp-business/src/components/InvoiceForm/index.tsx:515
msgid "開立品名資料"
msgstr "開立品名資料"

#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/InvoiceInfoCard/index.web.tsx:71
msgid "開立時間"
msgstr "開立時間"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:199
msgid "開立發票商家請依系統展示未稅金額及營業稅額開立發票後，將發票寄送至指定郵寄信箱或地址"
msgstr "開立發票商家請依系統展示未稅金額及營業稅額開立發票後，將發票寄送至指定郵寄信箱或地址"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:328
#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/StoreGuide/index.tsx:659
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:169
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:336
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:478
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:558
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:200
#: apps/dp-admin/src/pages/merchant/merchant-decoration/services/hooks.ts:579
msgid "開車"
msgstr "開車"

#: apps/dp-client/src/screens/diary/components/TrafficExampleModal.tsx:52
msgid "開車：從敬業四路進入賣場地下停車場，收費每小時40元，用餐500元可折抵1小時。"
msgstr "開車：從敬業四路進入賣場地下停車場，收費每小時40元，用餐500元可折抵1小時。"

#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:32
msgid "開車到店"
msgstr "開車到店"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:456
#: apps/dp-business/src/components/MaintenanceList/index.tsx:1030
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:252
msgid "開車指引"
msgstr "開車指引"

#: apps/dp-client/src/screens/home/utils/location.ts:400
msgid "開車約 {durationMinutes} 分鐘"
msgstr "開車約 {durationMinutes} 分鐘"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:49
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:174
msgid "開通套餐券服務"
msgstr "開通套餐券服務"

#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:337
#: apps/dp-admin/src/pages/transaction/merchant-contract-signing/index.web.tsx:406
#: apps/dp-admin/src/pages/transaction/components/ServiceActivation/index.web.tsx:41
msgid "開通服務"
msgstr "開通服務"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/ConditionFilterForm/constants.ts:55
#: apps/dp-admin/src/components/MerchantGroup/MerchantGroupFilterConditionsCard/index.web.tsx:187
msgid "開通結帳服務"
msgstr "開通結帳服務"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:585
msgid "開通自核銷風險須知"
msgstr "開通自核銷風險須知"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/PreviewConfirmModal/index.web.tsx:46
msgid "間"
msgstr "間"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:142
msgid "關係狀態"
msgstr "關係狀態"

#: apps/dp-client/src/configs/page-configs.tsx:1512
#: apps/dp-client/src/configs/page-configs.tsx:1513
msgid "關注/粉絲列表頁"
msgstr "關注/粉絲列表頁"

#: apps/dp-admin/src/pages/label-management/components/LabelMergeModal.web.tsx:119
msgid "關聯商家數"
msgstr "關聯商家數"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/BasicInfoCard.web.tsx:43
msgid "關聯工單："
msgstr "關聯工單："

#: apps/dp-admin/src/router/config/businessStaticRoutes.ts:196
#: apps/dp-admin/src/pages/org-tree/org-detail/components/MerchantSelectModal/index.web.tsx:166
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/index.web.tsx:106
#: apps/dp-admin/src/pages/audit-center/content-review-audit-detail/index.web.tsx:266
msgid "關聯店家"
msgstr "關聯店家"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:170
msgid "關聯店家數"
msgstr "關聯店家數"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/FacilitiesTab/index.web.tsx:207
msgid "關聯樓層/排"
msgstr "關聯樓層/排"

#: apps/dp-business/src/pages/ServiceManagement/components/CurrentCommissionCard.tsx:242
#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:101
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CommissionBenefitListCard.web.tsx:39
#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:778
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:141
#: apps/dp-admin/src/pages/marketing/benefit-management/components/columns.web.tsx:279
msgid "關聯活動"
msgstr "關聯活動"

#: apps/dp-admin/src/pages/marketing/components/MerchantSelectionForm/index.web.tsx:802
msgid "關聯活動加載失敗"
msgstr "關聯活動加載失敗"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:182
msgid "關聯活動明細"
msgstr "關聯活動明細"

#: apps/dp-admin/src/pages/marketing/benefit-management/components/RelatedCampaignsModal.web.tsx:182
msgid "關聯活動明細 - {benefitName}"
msgstr "關聯活動明細 - {benefitName}"

#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:360
#: apps/dp-business/src/pages/ClaimRequestDetail/index.tsx:561
#: apps/dp-admin/src/pages/split-account/claim-detail/index.web.tsx:498
msgid "關聯結算單"
msgstr "關聯結算單"

#: apps/dp-admin/src/pages/merchant/brand-list/components/BrandDetailDrawer/index.web.tsx:158
msgid "關聯門市"
msgstr "關聯門市"

#: apps/dp-admin/src/pages/worker-order/components/WorkerOrderList.web.tsx:111
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:74
#: apps/dp-admin/src/pages/marketing/benefit-management/services/searchConfig.ts:61
#: apps/dp-admin/src/pages/customer-service/ticket-management/index.web.tsx:209
#: apps/dp-admin/src/pages/customer-service/my-tickets/index.web.tsx:97
msgid "關鍵字"
msgstr "關鍵字"

#: apps/dp-admin/src/pages/marketing/user-group-detail/services/searchConfig.ts:15
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/services/searchConfig.ts:13
msgid "關鍵詞"
msgstr "關鍵詞"

#: apps/dp-admin/src/pages/users/roles/components/RoleToolbar/index.web.tsx:66
#: apps/dp-admin/src/pages/order/services/orderSearchConfig.web.ts:41
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:107
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:122
msgid "關鍵詞搜尋"
msgstr "關鍵詞搜尋"

#: apps/dp-business/src/pages/CustomerReviews/components/KeywordStatsSection.tsx:116
#: apps/dp-admin/src/pages/data-center/merchant-reviews/components/KeywordStats.web.tsx:105
msgid "關鍵詞統計"
msgstr "關鍵詞統計"

#: apps/dp-client/src/screens/home/utils/businessStatus.ts:266
msgid "關門"
msgstr "關門"

#: apps/dp-client/src/screens/splash-ad/SplashAdOverlay.tsx:153
#: apps/dp-client/src/screens/satisfaction-feedback/SatisfactionPrompt.tsx:58
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:22
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:70
#: apps/dp-business/src/services/modal.ts:391
#: apps/dp-business/src/pages/SettlementOrderDetail/index.tsx:212
#: apps/dp-business/src/pages/OrderDetail/index.tsx:2455
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:133
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityDetailSection.tsx:196
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:213
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityDetailPanel.tsx:286
#: apps/dp-business/src/components/ModalContainer/index.tsx:73
#: apps/dp-business/src/components/Modal/StandardModal.tsx:100
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:15
#: apps/dp-admin/src/pages/transaction/service-management/index.web.tsx:205
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:233
#: apps/dp-admin/src/pages/transaction/service-management/components/ServiceSettings/index.web.tsx:594
#: apps/dp-admin/src/pages/resource-config/services/constants.ts:44
#: apps/dp-admin/src/pages/resource-config/message-template-list/services/searchConfig.ts:26
#: apps/dp-admin/src/pages/resource-config/app-notice/index.web.tsx:464
#: apps/dp-admin/src/pages/org-tree/org-list/components/ApplicationModal/index.web.tsx:66
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:349
#: apps/dp-admin/src/pages/org-tree/components/ChainTreeViewDrawer/index.web.tsx:193
#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:82
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:116
#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:158
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/ScanQrCodeModal.web.tsx:82
#: apps/dp-admin/src/pages/marketing/activity-config-list/components/CouponCodeBatchesModal.web.tsx:121
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit-detail/index.web.tsx:34
#: apps/dp-admin/src/pages/audit-center/merchant-service-change-audit/columns.web.tsx:25
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/index.web.tsx:175
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:15
msgid "關閉"
msgstr "關閉"

#: packages/captcha/src/SecurityCaptchaProvider.tsx:204
msgid "關閉安全驗證"
msgstr "關閉安全驗證"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:216
msgid "關閉結帳服務成功"
msgstr "關閉結帳服務成功"

#: apps/dp-business/src/pages/ServiceManagement/index.tsx:175
msgid "關閉自核銷服務成功"
msgstr "關閉自核銷服務成功"

#: apps/dp-client/src/screens/home/pages/Review/components/NoticeBar/index.tsx:183
msgid "關閉通知"
msgstr "關閉通知"

#: apps/dp-admin/src/pages/org-tree/components/S9BlockModal/index.web.tsx:58
msgid "阻擋原因"
msgstr "阻擋原因"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/mock.ts:74
msgid "阿花"
msgstr "阿花"

#: apps/dp-admin/src/pages/worker-order/detail/index.web.tsx:321
#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:301
#: apps/dp-admin/src/pages/merchant/information-error/index.web.tsx:103
msgid "附件"
msgstr "附件"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyItem.web.tsx:49
msgid "附件 :"
msgstr "附件 :"

#. placeholder {0}: index + 1
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/utils.ts:699
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/FormFileUpload/index.web.tsx:49
msgid "附件{0}"
msgstr "附件{0}"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:259
msgid "附件圖片 (最多上傳10張)"
msgstr "附件圖片 (最多上傳10張)"

#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:342
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:326
#: apps/dp-client/src/screens/home/pages/FoodMap/components/MapFilterBar/index.tsx:343
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:544
#: apps/dp-client/src/screens/home/components/ShopFilter/index.tsx:793
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/transformers.ts:131
#: apps/dp-client/src/screens/home/components/ShopFilter/hooks/useFilterSelection.ts:184
#: apps/dp-client/src/screens/home/components/ShopFilter/hooks/useFilterSelection.ts:279
#: apps/dp-client/src/screens/home/components/ShopFilter/components/CascaderFilterContent.tsx:114
#: apps/dp-client/src/screens/home/components/ShopFilter/components/CascaderFilterContent.tsx:146
msgid "附近"
msgstr "附近"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:121
msgid "附近任務"
msgstr "附近任務"

#: apps/dp-business/src/components/GoogleMap/index.tsx:960
#: apps/dp-business/src/components/GoogleMap/WebViewMap.tsx:845
msgid "附近暫無地點"
msgstr "附近暫無地點"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/Card.tsx:165
msgid "限內用"
msgstr "限內用"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:138
msgid "限制或反對處理您的資料"
msgstr "限制或反對處理您的資料"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:202
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/DistributionSection/index.web.tsx:257
msgid "限制數量必須大於0"
msgstr "限制數量必須大於0"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:82
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/BasicInfoForm/index.web.tsx:152
msgid "限制時間"
msgstr "限制時間"

#: apps/dp-admin/src/pages/resource-config/message-template-edit/services/constants.ts:40
msgid "限制次數"
msgstr "限制次數"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardLimitConfigEditor/index.web.tsx:33
msgid "限制範圍"
msgstr "限制範圍"

#: apps/dp-client/src/screens/account/pages/invite-code/index.tsx:122
msgid "限填一次"
msgstr "限填一次"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PackageUsageLimitCard.tsx:1872
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/UsageSection/index.web.tsx:2061
msgid "限定可用日期時間（除此日期時間段都不可用）"
msgstr "限定可用日期時間（除此日期時間段都不可用）"

#: apps/dp-client/src/configs/page-configs.tsx:1026
msgid "限時套餐特賣活動說明"
msgstr "限時套餐特賣活動說明"

#: apps/dp-client/src/screens/diary/pages/merchant/index.tsx:159
msgid "限時高分"
msgstr "限時高分"

#: apps/dp-client/src/screens/diary/components/task-card/index.tsx:96
msgid "限時高分 +{pointsReward}分"
msgstr "限時高分 +{pointsReward}分"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:39
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:95
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:151
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:207
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:225
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:359
msgid "陳大文"
msgstr "陳大文"

#: apps/dp-business/src/pages/RefundList/index.tsx:71
msgid "陳小明"
msgstr "陳小明"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:53
msgid "階梯獎勵"
msgstr "階梯獎勵"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InvoiceDetail.tsx:267
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:159
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/InvoiceInfoCard/index.web.tsx:49
msgid "隨機碼"
msgstr "隨機碼"

#: apps/dp-client/src/screens/home/pages/Meal/constants/index.ts:16
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:167
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:97
msgid "隨買隨用"
msgstr "隨買隨用"

#: apps/dp-business/src/pages/TermsAndPrivacy/index.tsx:76
#: apps/dp-business/src/pages/Login/index.tsx:1015
#: apps/dp-business/src/pages/Login/index.tsx:1468
#: apps/dp-business/src/pages/Login/index.tsx:1804
msgid "隱私政策"
msgstr "隱私權政策"

#: apps/dp-client/src/screens/login/components/privacy-agreement-modal/index.tsx:48
#: apps/dp-client/src/screens/login/components/privacy-agreement-modal/index.tsx:49
#: apps/dp-client/src/screens/login/components/privacy-agreement/index.tsx:52
#: apps/dp-client/src/screens/diary/pages/my/pages/terms/index.tsx:45
#: apps/dp-client/src/screens/account/pages/settings/index.tsx:116
#: apps/dp-client/src/screens/account/pages/settings/index.tsx:117
#: apps/dp-client/src/screens/account/pages/settings/index.tsx:241
msgid "隱私權政策"
msgstr "隱私權政策"

#: apps/dp-client/src/screens/account/pages/settings/index.tsx:200
#: apps/dp-client/src/screens/account/pages/privacy-settings/index.tsx:72
msgid "隱私權與安全性"
msgstr "隱私權與安全性"

#: apps/dp-client/src/screens/account/pages/privacy-settings/index.tsx:83
#: apps/dp-client/src/configs/page-configs.tsx:2065
msgid "隱私設置"
msgstr "隱私設定"

#: apps/dp-admin/src/pages/users/permissions/components/PermissionTreeTable/index.web.tsx:135
#: apps/dp-admin/src/components/SensitiveInfo/MaskedText/index.web.tsx:52
msgid "隱藏"
msgstr "隱藏"

#: apps/dp-admin/src/pages/users/roles/components/RoleAuthorizationModal/index.web.tsx:85
msgid "隱藏路由-建議勾選"
msgstr "隱藏路由-建議勾選"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:35
msgid "雙11大促"
msgstr "雙11大促"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:110
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:146
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:156
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/diningPeopleTitle.ts:15
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/BasicInfoCard.tsx:279
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:317
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:188
msgid "雙人餐"
msgstr "雙人套餐"

#: apps/dp-business/src/data/regions.ts:79
msgid "雙溪區"
msgstr "雙溪區"

#: apps/dp-client/src/screens/home/utils/filterData.ts:112
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/filterHelpers.ts:193
#: apps/dp-client/src/screens/home/components/ShopFilter/utils/constants.ts:19
msgid "離你最近"
msgstr "離你最近"

#: apps/dp-client/src/screens/home/pages/FoodMap/components/ShopList/ShopList.tsx:195
#: apps/dp-client/src/screens/home/pages/FoodMap/components/ShopList/ShopList.tsx:205
msgid "離您 {dist}"
msgstr "離您 {dist}"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopLocationInfo.tsx:177
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:111
msgid "離您{distanceText}"
msgstr "離您{distanceText}"

#: apps/dp-admin/src/pages/customer-service/components/OverviewStats.web.tsx:105
#: apps/dp-admin/src/pages/customer-service/components/AssignModal.web.tsx:39
msgid "離線"
msgstr "離線"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:317
#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:121
#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:374
#: apps/dp-client/src/screens/home/pages/Purchase/pages/main/index.tsx:639
msgid "離開"
msgstr "離開"

#: apps/dp-admin/src/pages/org-tree/org-detail/services/hooks.ts:809
msgid "離開將捨棄未提交的改動，確認離開？"
msgstr "離開將捨棄未提交的改動，確認離開？"

#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:118
#: apps/dp-client/src/screens/payment/pages/payment/index.tsx:371
msgid "離開後訂單將保留為待支付，可稍後繼續付款"
msgstr "離開後訂單將保留為待支付，可稍後繼續付款"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/types.ts:155
msgid "雪碧"
msgstr "雪碧"

#: apps/dp-business/src/data/regions.ts:20
msgid "雲林"
msgstr "雲林"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:109
msgid "零售"
msgstr "零售"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:1100
#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/components/MerchantBasicInfo/components/ContactInfo/index.web.tsx:118
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:350
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/ContactInfo/index.web.tsx:53
#: apps/dp-admin/src/pages/org-tree/org-create/components/ManagerFields/index.web.tsx:107
msgid "電子信箱"
msgstr "電子信箱"

#: apps/dp-admin/src/pages/split-account/services/constants.ts:272
msgid "電子發票"
msgstr "電子發票"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:188
msgid "電子發票抬頭與統編資訊顯示錯誤"
msgstr "電子發票抬頭與統編資訊顯示錯誤"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:338
msgid "電子發票請email至電子信箱：Finance@tastetaiwan.com.tw"
msgstr "電子發票請email至電子信箱：Finance@tastetaiwan.com.tw"

#: apps/dp-business/src/pages/ContactBD/index.tsx:95
msgid "電子郵件"
msgstr "電子郵件"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:170
msgid "電子郵件：privacy@example.com"
msgstr "電子郵件：privacy@example.com"

#: apps/dp-client/src/screens/reservation/pages/invitation/index.tsx:221
#: apps/dp-client/src/screens/reservation/pages/detail/components/ShopInfoCard.tsx:140
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopLocationInfo.tsx:220
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallBasicSection/index.tsx:286
#: apps/dp-business/src/pages/PhoneEdit/index.tsx:244
#: apps/dp-business/src/pages/PhoneEdit/index.tsx:381
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1048
#: apps/dp-admin/src/pages/split-account/invoice-detail/index.web.tsx:207
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:780
#: apps/dp-admin/src/pages/customer-service/services/interface/enums.ts:54
#: apps/dp-admin/src/pages/audit-center/suspicious-merchant/services/config.ts:35
#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:215
#: apps/dp-admin/src/pages/audit-center/info-confirm/services/config.ts:33
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:176
#: apps/dp-admin/src/pages/audit-center/info-confirm/components/ManualInputModal/index.web.tsx:205
msgid "電話"
msgstr "電話"

#: apps/dp-business/src/pages/PrivacyPolicy/index.tsx:172
msgid "電話：+86 123 4567 8910"
msgstr "電話：+86 123 4567 8910"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:195
msgid "電話儲存失敗，請稍後重試"
msgstr "電話儲存失敗，請稍後重試"

#: apps/dp-business/src/pages/PhoneEdit/index.tsx:182
msgid "電話儲存成功"
msgstr "電話儲存成功"

#: apps/dp-admin/src/pages/customer-service/components/CreateTicketModal.web.tsx:126
msgid "電話渠道"
msgstr "電話渠道"

#: apps/dp-business/src/pages/ContactBD/index.tsx:82
msgid "電話聯繫"
msgstr "電話聯繫"

#: apps/dp-admin/src/modules/hooks/usePhoneCall.ts:103
msgid "電話號碼不能為空"
msgstr "電話號碼不能為空"

#: apps/dp-admin/src/utils/validation.ts:38
msgid "電話號碼最多隻能包含一個#"
msgstr "電話號碼最多隻能包含一個#"

#: apps/dp-business/src/utils/phoneValidation.ts:22
#: apps/dp-admin/src/utils/validation.ts:31
msgid "電話號碼只能包含數字、+、-、#"
msgstr "電話號碼只能包含數字、+、-、#"

#: apps/dp-admin/src/modules/hooks/usePhoneCall.ts:81
msgid "電話號碼已複製到剪貼板：{cleanPhoneNumber}"
msgstr "電話號碼已複製到剪貼板：{cleanPhoneNumber}"

#: apps/dp-client/src/screens/home/pages/Meal/constants/index.ts:22
#: apps/dp-client/src/screens/account/pages/order/pages/tickets/index.tsx:816
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:227
msgid "需先預約"
msgstr "需先預約"

#: apps/dp-admin/src/modules/constants/options.ts:98
msgid "需培育"
msgstr "需培育"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatformV2/components/ActivityFilterCard.tsx:72
msgid "需報名"
msgstr "需報名"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:146
msgid "需完成任務"
msgstr "需完成任務"

#. placeholder {0}: couponIds.length
#: apps/dp-admin/src/pages/marketing/benefit-management/components/ExtendInventoryModal.web.tsx:78
msgid "需晚於原截止時間，將對所選 {0} 張個人券生效"
msgstr "需晚於原截止時間，將對所選 {0} 張個人券生效"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:35
msgid "需要人工介入"
msgstr "需要人工介入"

#: apps/dp-client/src/utils/permission.ts:79
msgid "需要位置權限"
msgstr "需要位置權限"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:464
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:463
msgid "需要去設置開啟相機權限才能拍攝照片"
msgstr "需要去設定開啟相機權限才能拍攝照片"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:454
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:453
msgid "需要去設置開啟相簿權限才能選擇圖片或影片"
msgstr "需要去設定開啟相簿權限才能選擇圖片或影片"

#: apps/dp-client/src/screens/reservation/components/ConfirmModal/index.tsx:22
msgid "需要取消訂位嗎？"
msgstr "需要取消訂位嗎？"

#: apps/dp-client/src/screens/diary/pages/my/components/RNCropPhoto/CropPhoto.tsx:280
msgid "需要存取相簿權限才能選擇圖片"
msgstr "需要開啟相簿權限才能選擇圖片"

#: apps/dp-client/src/screens/home/pages/Note/components/AddNoteTip/index.tsx:24
msgid "需要新增標籤"
msgstr "需要新增標籤"

#: apps/dp-client/src/screens/home/pages/Note/components/AddNoteTip/index.tsx:25
msgid "需要標註商家，確保資訊真實"
msgstr "需要標註商家，確保資訊真實"

#: apps/dp-client/src/utils/permission.ts:52
msgid "需要照片權限"
msgstr "需要照片權限"

#: apps/dp-business/src/utils/download.ts:78
msgid "需要相冊權限才能保存圖片"
msgstr "需要相冊權限才能保存圖片"

#: apps/dp-client/src/screens/home/pages/Note/pages/camera/index.tsx:792
msgid "需要相機和相簿權限才能使用此功能"
msgstr "需要相機和相簿權限才能使用此功能"

#: apps/dp-client/src/utils/permission.ts:61
msgid "需要相機權限"
msgstr "需要相機權限"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:487
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:486
msgid "需要相機權限才能拍攝照片"
msgstr "需要相機權限才能拍攝照片"

#: apps/dp-client/src/screens/home/pages/Note/constants/index.ts:26
#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:97
msgid "需要相簿權限"
msgstr "需要相簿權限"

#: apps/dp-client/src/screens/diary/components/file-upload-horizon/index.tsx:475
#: apps/dp-client/src/screens/diary/components/file-upload/index.tsx:474
msgid "需要相簿權限才能選擇圖片或影片"
msgstr "需要相簿權限才能選擇圖片或影片"

#: apps/dp-client/src/utils/permission.ts:70
msgid "需要麥克風權限"
msgstr "需要麥克風權限"

#: apps/dp-client/src/screens/home/pages/Meal/constants/index.ts:32
msgid "需預約"
msgstr "需預約"

#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:442
msgid "露臺1"
msgstr "露臺1"

#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:449
msgid "露臺2"
msgstr "露臺2"

#: apps/dp-business/src/store/TableContext.tsx:75
#: apps/dp-business/src/servers/reservation/mock/mockDataManager.ts:437
msgid "露臺區"
msgstr "露臺區"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:279
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:142
msgid "靜"
msgstr "靜"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:115
msgid "靜態圖片：JPG，1125×2400（9:16），文件大小 ≤ 200KB，需加載快速"
msgstr "靜態圖片：JPG，1125×2400（9:16），文件大小 ≤ 200KB，需加載快速"

#: apps/dp-admin/src/pages/resource-config/components/StyleSection/index.web.tsx:72
msgid "靜態圖片（JPG）文件大小不能超過 200KB"
msgstr "靜態圖片（JPG）文件大小不能超過 200KB"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:379
msgid "靜音"
msgstr "靜音"

#: apps/dp-client/src/screens/home/utils/utils.ts:423
#: apps/dp-admin/src/pages/audit-center/services/constants.ts:286
msgid "非原創／侵犯權益"
msgstr "非原創／侵犯權益"

#: apps/dp-client/src/utils/utils.ts:143
#: apps/dp-client/src/screens/home/pages/Meal/pages/main/index.tsx:1202
#: apps/dp-client/src/screens/home/pages/Meal/components/MealDetailContent/index.tsx:468
msgid "非常好"
msgstr "非常好"

#: apps/dp-client/src/utils/format.ts:78
#: apps/dp-client/src/screens/home/utils/utils.ts:30
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:34
#: apps/dp-client/src/screens/home/pages/Note/utils/index.ts:8
#: apps/dp-client/src/screens/home/components/ReviewCad/index.tsx:47
msgid "非常差"
msgstr "非常差"

#: apps/dp-client/src/screens/account/pages/advice/issue-feedback/index.tsx:294
msgid "非常感謝您的提問，我們將盡快處理"
msgstr "非常感謝您的提問，我們將盡快處理"

#: apps/dp-client/src/screens/reservation/pages/main/hooks/useReservation.ts:401
#: apps/dp-client/src/screens/reservation/pages/main/hooks/useReservation.ts:462
#: apps/dp-client/src/screens/reservation/components/ReservationFailModal/index.tsx:18
msgid "非常抱歉，您預訂的時段桌位已滿，可嘗試再次預訂或電話聯繫商家"
msgstr "非常抱歉，您預訂的時段桌位已滿，可嘗試再次預訂或電話聯繫商家"

#: apps/dp-admin/src/pages/label-management/components/LabelModal.web.tsx:523
msgid "非必填，最多8字"
msgstr "非必填，最多8字"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1405
#: apps/dp-business/src/pages/CouponVerification/index.tsx:702
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/PackageCouponCard/index.web.tsx:62
msgid "非核銷店舖無法查看具體佣金金額"
msgstr "非核銷店舖無法查看具體佣金金額"

#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:80
msgid "非百貨"
msgstr "非百貨"

#: apps/dp-client/src/screens/home/components/RichTextInput/utils/constants.ts:206
msgid "非純文字渲染錯誤"
msgstr "非純文字渲染錯誤"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:61
msgid "非純文字輸入組件示例"
msgstr "非純文字輸入組件示例"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBasicFields/index.web.tsx:49
msgid "面向渠道的活動描述"
msgstr "面向渠道的活動描述"

#: apps/dp-admin/src/pages/data-center/merchant-stats/components/ReviewList.web.tsx:67
msgid "韓國料理·部隊鍋"
msgstr "韓國料理·部隊鍋"

#: apps/dp-business/src/utils/voiceBroadcast.ts:434
#: apps/dp-business/src/utils/voiceBroadcast.ts:512
msgid "音頻加載失敗: {audioKey}"
msgstr "音頻加載失敗: {audioKey}"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:96
#: apps/dp-admin/src/pages/resource-config/services/constants.ts:102
msgid "響應式：等比例縮放"
msgstr "響應式：等比例縮放"

#: apps/dp-admin/src/pages/users/permissions/components/PermissionTreeTable/index.web.tsx:49
#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:145
msgid "頁面"
msgstr "頁面"

#: apps/dp-admin/src/components/ErrorBoundary/index.web.tsx:91
msgid "頁面加載失敗"
msgstr "頁面加載失敗"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:533
msgid "頁面名稱"
msgstr "頁面名稱"

#: apps/dp-admin/src/components/LandingPage/LandingPageDetailInfo/index.web.tsx:62
msgid "頁面標題"
msgstr "頁面標題"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1388
#: apps/dp-business/src/components/StoreInfoCard/index.tsx:282
msgid "頁面跳轉失敗，請稍後重試"
msgstr "頁面跳轉失敗，請稍後重試"

#: apps/dp-client/src/components/PageContainer/PageContainer.tsx:139
#: apps/dp-business/src/App.native.tsx:780
#: apps/dp-business/src/components/ErrorPage/index.tsx:54
msgid "頁面載入失敗"
msgstr "頁面載入失敗"

#: apps/dp-client/src/screens/home/pages/Review/components/RecommendDishesModal/index.tsx:389
#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:161
#: apps/dp-admin/src/pages/split-account/settlement-orders/components/BusinessSettlementModal.web.tsx:230
msgid "項"
msgstr "項"

#: apps/dp-admin/src/pages/merchant/components/RelatedTaskList/index.web.tsx:151
msgid "項任務"
msgstr "項任務"

#: apps/dp-admin/src/pages/merchant/components/BatchAssignModal/index.web.tsx:64
msgid "項目"
msgstr "項目"

#: apps/dp-admin/src/pages/audit-center/invoice-paper-audit-detail/index.web.tsx:242
msgid "項目名稱"
msgstr "項目名稱"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PreviewCard.tsx:96
msgid "項餐點"
msgstr "項餐點"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/PreviewConfirmModal/index.web.tsx:60
msgid "預估命中人數"
msgstr "預估命中人數"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/PreviewConfirmModal/index.web.tsx:42
msgid "預估命中店家數"
msgstr "預估命中店家數"

#: apps/dp-admin/src/pages/marketing/merchant-group-create/components/PreviewConfirmModal/index.web.tsx:50
msgid "預估結果僅供參考，完整名單會由後端以當下資料重新計算。"
msgstr "預估結果僅供參考，完整名單會由後端以當下資料重新計算。"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/PreviewConfirmModal/index.web.tsx:74
msgid "預估結果僅供參考，實際名單會在建立時以當下資料為準重新計算。"
msgstr "預估結果僅供參考，實際名單會在建立時以當下資料為準重新計算。"

#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:266
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:130
msgid "預定分區"
msgstr "預定分區"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:1083
#: apps/dp-business/src/pages/OrderOverview/Detail/components/ReservationSlots.tsx:33
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/components/ReservationSlots.web.tsx:32
msgid "預定時段庫存"
msgstr "預定時段庫存"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1053
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:159
#: apps/dp-admin/src/pages/user-info/user-detail/components/ReservationListTab/services/config.web.tsx:252
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/OrderBasicInfo/index.web.tsx:122
msgid "預定時間"
msgstr "預定時間"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:1381
msgid "預定時間限制"
msgstr "預定時間限制"

#: apps/dp-admin/src/pages/transaction/merchant-contract-v2/index.web.tsx:252
#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:270
msgid "預檢未通過，無法提交"
msgstr "預檢未通過，無法提交"

#: apps/dp-business/src/servers/auth/api.ts:537
#: apps/dp-business/src/pages/AccountDeactivation/index.tsx:46
#: apps/dp-business/src/pages/AccountDeactivation/index.tsx:51
msgid "預檢查失敗，請重試"
msgstr "預檢查失敗，請重試"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignDetailDrawer/index.web.tsx:232
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/CampaignBenefitCard/index.web.tsx:94
msgid "預算承擔方"
msgstr "預算承擔方"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/index.tsx:745
msgid "預約訂座"
msgstr "預約訂座"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/components/InfoArea.tsx:196
msgid "預約須知"
msgstr "預約須知"

#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/VideoPage/index.tsx:460
#: apps/dp-client/src/screens/home/pages/Note/pages/detail/components/ImagePage/index.tsx:607
#: apps/dp-client/src/screens/home/pages/Note/pages/addNote/index.tsx:973
#: apps/dp-business/src/pages/MarketingCenter/components/PreviewCard.tsx:46
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/index.tsx:112
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/PreviewCard.tsx:47
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/index.tsx:109
#: apps/dp-admin/src/pages/audit-center/review-audit/components/ReviewContent/index.web.tsx:89
#: apps/dp-admin/src/components/ImageListUploader/UploadedImagesTable.web.tsx:94
msgid "預覽"
msgstr "預覽"

#. placeholder {0}: targetLabel || ''
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:498
msgid "預覽：將前往 {0}"
msgstr "預覽：將前往 {0}"

#: apps/dp-admin/src/pages/merchant/components/MerchantOnboardForm/index.web.tsx:308
msgid "預覽入駐變更影響失敗"
msgstr "預覽入駐變更影響失敗"

#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/DynamicPackageFields/index.web.tsx:116
msgid "預覽命中套餐"
msgstr "預覽命中套餐"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/services/config.web.tsx:344
#: apps/dp-admin/src/pages/marketing/merchant-marketing/services/packageTemplateConfig.web.tsx:365
msgid "預覽圖下載"
msgstr "預覽圖下載"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:246
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:257
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/SubmitConfirmModal/index.web.tsx:58
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/SubmitConfirmModal/index.web.tsx:72
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:513
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:524
msgid "預覽圖下載失敗，請稍後重試"
msgstr "預覽圖下載失敗，請稍後重試"

#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:254
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/SubmitConfirmModal/index.web.tsx:70
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:521
msgid "預覽圖下載成功"
msgstr "預覽圖下載成功"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/index.web.tsx:515
msgid "預覽排行榜"
msgstr "預覽排行榜"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:769
#: apps/dp-admin/src/pages/marketing/services/apis.ts:772
msgid "預覽條件命中店家失敗"
msgstr "預覽條件命中店家失敗"

#: apps/dp-admin/src/pages/marketing/services/apis.ts:580
#: apps/dp-admin/src/pages/marketing/services/apis.ts:583
msgid "預覽條件命中用戶失敗"
msgstr "預覽條件命中用戶失敗"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:213
msgid "預覽與校驗"
msgstr "預覽與校驗"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:435
#: apps/dp-client/src/screens/reservation/pages/main/components/BottomBar.tsx:89
msgid "預訂"
msgstr "預訂"

#: apps/dp-client/src/screens/reservation/components/ReservationNotes/index.tsx:48
msgid "預訂免費"
msgstr "預訂免費"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1179
msgid "預訂分區"
msgstr "預訂分區"

#: apps/dp-client/src/screens/reservation/pages/main/components/TimeModal.tsx:157
msgid "預訂喔"
msgstr "預訂喔"

#: apps/dp-client/src/screens/reservation/utils/index.ts:37
#: apps/dp-client/src/screens/reservation/utils/index.ts:67
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:242
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:253
#: apps/dp-client/src/screens/reservation/components/ReservationFailModal/index.tsx:42
msgid "預訂失敗"
msgstr "預訂失敗"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:254
msgid "預訂失敗，請稍後重試"
msgstr "預訂失敗，請稍後重試"

#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:369
#: apps/dp-client/src/screens/reservation/pages/main/index.tsx:473
#: apps/dp-client/src/configs/page-configs.tsx:1105
msgid "預訂座位"
msgstr "預訂座位"

#: apps/dp-client/src/screens/reservation/utils/index.ts:12
#: apps/dp-client/src/screens/reservation/utils/index.ts:18
#: apps/dp-client/src/screens/reservation/utils/index.ts:24
#: apps/dp-client/src/screens/reservation/utils/index.ts:43
#: apps/dp-client/src/screens/reservation/utils/index.ts:62
#: apps/dp-client/src/screens/reservation/components/ReservationSuccessModal/index.tsx:58
msgid "預訂成功"
msgstr "預訂成功"

#: apps/dp-client/src/screens/reservation/pages/detail/components/OrderInfoSection.tsx:63
#: apps/dp-client/src/screens/reservation/components/ConfirmView/index.tsx:110
msgid "預訂時間"
msgstr "預訂時間"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:473
#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:578
msgid "預訂訊息不存在"
msgstr "預訂訊息不存在"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:467
msgid "預訂詳情"
msgstr "預訂詳情"

#: apps/dp-client/src/screens/reservation/pages/detail/components/StatusSection.tsx:76
#: apps/dp-client/src/screens/home/pages/PrivateChef/index.tsx:76
#: apps/dp-client/src/screens/home/pages/PrivateChef/index.tsx:94
#: apps/dp-client/src/screens/home/pages/PrivateChef/components/PrivateChefNotice/index.tsx:22
msgid "預訂說明"
msgstr "預訂說明"

#: apps/dp-client/src/screens/home/pages/ShareKing/components/WinningList/index.tsx:42
msgid "預計{month}月{day}日前公佈，敬請期待"
msgstr "預計{month}月{day}日前公佈，敬請期待"

#. placeholder {0}: confirmTime ?? 0
#: apps/dp-client/src/screens/reservation/utils/index.ts:106
msgid "預計在{0}分鐘內確認完成，結果將通過簡訊通知您"
msgstr "預計在{0}分鐘內確認完成，結果將通過簡訊通知您"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:122
msgid "預計成功"
msgstr "預計成功"

#. placeholder {0}: rule.level
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/IncomeCalculationSection.tsx:126
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:659
msgid "預計收入（基礎規則{0}）"
msgstr "預計收入（基礎規則{0}）"

#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/IncomeCalculationSection.tsx:128
#: apps/dp-business/src/pages/MarketingCenter/ActivityPlatform/components/ActivityRegistrationForm.tsx:661
msgid ""
"預計收入為未扣手續費前的金額\n"
"\n"
"平台將依據訂單全額收取2%交易手續費\n"
"例：訂單金額$ 100，交易手續費為$ 2。"
msgstr ""
"預計收入為未扣手續費前的金額\n"
"\n"
"平台將依據訂單全額收取2%交易手續費\n"
"例：訂單金額$ 100，交易手續費為$ 2。"

#: apps/dp-client/src/screens/home/pages/ShareKing/components/WinningList/index.tsx:38
msgid "預計於次月月底前公佈，敬請期待"
msgstr "預計於次月月底前公佈，敬請期待"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:18
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:11
#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:69
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:11
msgid "預設"
msgstr "預設"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:36
msgid "預設展開"
msgstr "預設展開"

#: apps/dp-client/src/screens/diary/components/Collapse/example.tsx:37
msgid "預設展開的面板"
msgstr "預設展開的面板"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/SignatureDishes/components/BottomTip.tsx:18
msgid "預設綜合展示"
msgstr "預設綜合展示"

#: apps/dp-business/src/store/HolidayContext.tsx:353
msgid "預載入節假日資料失敗"
msgstr "預載入節假日資料失敗"

#: apps/dp-client/src/screens/home/pages/UserGift/hooks/useUserGiftClaim.ts:116
#: apps/dp-client/src/screens/home/pages/UserGift/hooks/useUserGiftClaim.ts:140
msgid "領券失敗"
msgstr "領券失敗"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:341
msgid "領取"
msgstr "領取"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/ParticipationInfoCard.web.tsx:69
msgid "領取/發放權益"
msgstr "領取/發放權益"

#: apps/dp-client/src/screens/account/pages/coupon/CouponClaimResult/index.tsx:388
msgid "領取中..."
msgstr "領取中..."

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:179
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:201
msgid "領取人"
msgstr "領取人"

#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:158
msgid "領取人&ID"
msgstr "領取人&ID"

#: apps/dp-client/src/store/couponStore.ts:427
msgid "領取商家優惠券失敗"
msgstr "領取商家優惠券失敗"

#: apps/dp-client/src/screens/home/pages/MediaGift/index.tsx:143
msgid "領取失敗，請稍後再試"
msgstr "領取失敗，請稍後再試"

#: apps/dp-client/src/store/couponStore.ts:392
msgid "領取平台優惠券失敗"
msgstr "領取平台優惠券失敗"

#: apps/dp-admin/src/pages/marketing/activity-create/components/ActivityTypeConfigForm/index.web.tsx:677
msgid "領取後"
msgstr "領取後"

#. placeholder {0}: reward.validDays
#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeModal/index.tsx:110
msgid "領取後{0}天內有效"
msgstr "領取後{0}天內有效"

#. placeholder {0}: couponDetail.validDays
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:259
msgid "領取後{0}天有效"
msgstr "領取後{0}天有效"

#: apps/dp-admin/src/pages/marketing/services/constants.ts:422
msgid "領取後生效"
msgstr "領取後生效"

#: apps/dp-client/src/screens/home/pages/MediaGift/index.tsx:140
msgid "領取成功，請查看票券匣"
msgstr "領取成功，請查看票券匣"

#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:145
#: apps/dp-business/src/pages/MarketingCenter/ReductionCouponDetail/index.tsx:633
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:167
#: apps/dp-business/src/pages/MarketingCenter/DiscountCouponDetail/index.tsx:693
#: apps/dp-business/src/components/CouponFilterCard/index.tsx:49
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:91
#: apps/dp-admin/src/pages/marketing/discount-coupon-detail/services/config.web.tsx:145
msgid "領取時間"
msgstr "領取時間"

#: apps/dp-client/src/configs/page-configs.tsx:2506
msgid "領取結果"
msgstr "領取結果"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/services/config.web.tsx:370
msgid "領獎狀態"
msgstr "領獎狀態"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/components/BasicMerchantInfo/components/PersonalRegistration/index.web.tsx:277
msgid "領補換"
msgstr "領補換"

#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:58
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountTable/index.web.tsx:65
#: apps/dp-admin/src/pages/users/user-tasks/components/UserAccountForm/index.web.tsx:112
#: apps/dp-admin/src/pages/user-info/user-list/services/config.web.tsx:55
#: apps/dp-admin/src/pages/report-center/abnormal-order-detail/components/UserInfoCard/index.web.tsx:25
msgid "頭像"
msgstr "頭像"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:171
msgid "頭像更新失敗"
msgstr "頭像更新失敗"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:175
msgid "頭像更新失敗，請稍後重試"
msgstr "頭像更新失敗，請稍後重試"

#: apps/dp-admin/src/pages/other/profile/index.web.tsx:169
msgid "頭像更新成功"
msgstr "頭像更新成功"

#: apps/dp-admin/src/pages/marketing/user-group-create/components/ConditionFilterForm/components/TimeRangeSelector.web.tsx:17
#: apps/dp-admin/src/pages/marketing/services/constants.ts:444
msgid "頻次"
msgstr "頻次"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:519
#: apps/dp-admin/src/pages/marketing/merchant-activity-detail/components/ActivityStatsCards.web.tsx:46
msgid "額外曝光次數"
msgstr "額外曝光次數"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:26
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:307
#: apps/dp-business/src/components/ImageEditorModal/locale.ts:18
#: apps/dp-admin/src/components/ImageEditorModal/locale.ts:18
msgid "顏色"
msgstr "顏色"

#: apps/dp-business/src/pages/MenuManagement.tsx:602
#: apps/dp-business/src/pages/MenuManagement.tsx:1295
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1057
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:424
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:660
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:874
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:400
msgid "類別"
msgstr "類別"

#: apps/dp-business/src/pages/MenuItemForm.tsx:453
msgid "類別 "
msgstr "類別 "

#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:149
msgid "類別："
msgstr "類別："

#: apps/dp-admin/src/pages/merchant/components/CategoryEditModal/index.web.tsx:67
msgid "類別名稱"
msgstr "類別名稱"

#: apps/dp-admin/src/pages/merchant/components/CategoryEditModal/index.web.tsx:74
msgid "類別名稱不能以空格開頭或結尾"
msgstr "類別名稱不能以空格開頭或結尾"

#: apps/dp-admin/src/pages/merchant/components/CategoryEditModal/index.web.tsx:71
msgid "類別名稱不能超過20個字符"
msgstr "類別名稱不能超過20個字符"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuCategorySection/index.web.tsx:77
#: apps/dp-admin/src/pages/merchant/components/MenuCategorySection/index.web.tsx:55
msgid "類別已刪除"
msgstr "類別已刪除"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuCategorySection/index.web.tsx:99
#: apps/dp-admin/src/pages/merchant/components/MenuCategorySection/index.web.tsx:86
msgid "類別已新增"
msgstr "類別已新增"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuCategorySection/index.web.tsx:90
#: apps/dp-admin/src/pages/merchant/components/MenuCategorySection/index.web.tsx:68
msgid "類別已更新"
msgstr "類別已更新"

#: apps/dp-business/src/pages/MenuManagement.tsx:905
msgid "類別排序"
msgstr "類別排序"

#: apps/dp-business/src/pages/MenuItemForm.tsx:271
msgid "類別為必填項"
msgstr "類別為必填項"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:157
msgid "類別狀態已更新"
msgstr "類別狀態已更新"

#: apps/dp-business/src/pages/MarketingCenter/MyBenefits/components/BenefitListCard.tsx:86
#: apps/dp-business/src/components/MultiPhotoUploader/index.tsx:274
#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:545
#: apps/dp-admin/src/pages/org-tree/org-detail/components/ShopPathDrawer/index.web.tsx:374
#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:172
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:607
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/SearchForm/index.web.tsx:92
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/PoiListTable/index.web.tsx:92
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-list/components/CreatePoiModal/index.web.tsx:37
#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-detail/components/BasicInfoTab/index.web.tsx:569
#: apps/dp-admin/src/pages/marketing/benefit-management/components/InventoryDetailModal.web.tsx:227
msgid "類型"
msgstr "類型"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:610
msgid "類型<0>*</0>"
msgstr "類型<0>*</0>"

#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:75
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeColumns.web.tsx:28
msgid "類型代碼"
msgstr "類型代碼"

#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeFormModal.web.tsx:82
#: apps/dp-admin/src/pages/resource-config/holiday-management/components/HolidayTypeColumns.web.tsx:34
msgid "類型名稱"
msgstr "類型名稱"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:728
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:929
msgid "類目一"
msgstr "類別一"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:754
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:955
msgid "類目二"
msgstr "類別二"

#: apps/dp-admin/src/pages/audit-center/merchant-info-audit/services/constants.ts:22
msgid "類目審核"
msgstr "類目審核"

#: apps/dp-business/src/pages/CategoryEdit/index.tsx:507
msgid "類目資訊正在審核中，無法修改"
msgstr "類別資訊正在審核中，無法修改"

#: apps/dp-business/src/pages/MarketingCenter/ActivityManagement/components/ActivityTracking.tsx:597
msgid "顧客姓名"
msgstr "顧客姓名"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:379
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:59
msgid "顧客穿過裝飾有餐廳海報的樓道，地面有引導腳印貼紙，兩側掛著食物卡通畫。"
msgstr "顧客穿過裝飾有餐廳海報的樓道，地面有引導腳印貼紙，兩側掛著食物卡通畫。"

#: apps/dp-business/src/utils/mockMenuPermissionData.ts:103
#: apps/dp-business/src/utils/mockMenuPermissionData.ts:783
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:788
msgid "顧客評價"
msgstr "顧客評價"

#: apps/dp-business/src/components/CustomTabs/index.tsx:181
msgid "顧客評論"
msgstr "顧客評論"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1137
#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:969
#: apps/dp-admin/src/pages/user-info/reservation-detail/components/CustomerInfo/index.web.tsx:72
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:884
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/index.web.tsx:415
msgid "顧客資訊"
msgstr "顧客資訊"

#: apps/dp-admin/src/pages/users/permissions/components/PermissionTreeTable/index.web.tsx:135
msgid "顯示"
msgstr "顯示"

#. placeholder {0}: range[0]
#. placeholder {1}: range[1]
#: apps/dp-admin/src/pages/marketing/channel-campaign-management/components/ChannelCampaignListTab/index.web.tsx:309
msgid "顯示 {0}-{1} 條，共 {count} 條"
msgstr "顯示 {0}-{1} 條，共 {count} 條"

#. placeholder {0}: range[0]
#. placeholder {1}: range[1]
#: apps/dp-admin/src/pages/transaction/contract-management/components/ContractListView/index.web.tsx:609
#: apps/dp-admin/src/pages/split-account/invoice-list/index.web.tsx:62
#: apps/dp-admin/src/pages/order/merchant-order-list/index.web.tsx:145
#: apps/dp-admin/src/pages/marketing/verification-record/components/VerificationRecordTable/index.web.tsx:98
#: apps/dp-admin/src/pages/marketing/order-list/index.web.tsx:63
#: apps/dp-admin/src/pages/audit-center/claim-audit-detail/index.web.tsx:487
msgid "顯示 {0}-{1} 條，共 {total} 條"
msgstr "顯示 {0}-{1} 條，共 {total} 條"

#. placeholder {0}: range[0]
#. placeholder {1}: range[1]
#: apps/dp-admin/src/pages/split-account/settlement-orders/index.web.tsx:127
#: apps/dp-admin/src/pages/marketing/platform-activities/index.web.tsx:226
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:755
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:797
#: apps/dp-admin/src/components/DataTable/index.web.tsx:139
msgid "顯示 {0}-{1} 條，共 {total} 條記錄"
msgstr "顯示 {0}-{1} 條，共 {total} 條記錄"

#. placeholder {0}: range[0]
#. placeholder {1}: range[1]
#: apps/dp-admin/src/pages/resource-config/message-template-list/index.web.tsx:240
#: apps/dp-admin/src/pages/resource-config/message-template-list/components/DeliveryRecordModal/index.web.tsx:474
#: apps/dp-admin/src/pages/resource-config/message-list/index.web.tsx:97
#: apps/dp-admin/src/pages/resource-config/delivery-record-list/index.web.tsx:91
#: apps/dp-admin/src/pages/merchant/components/BlueNewContractListView/index.web.tsx:278
#: apps/dp-admin/src/pages/merchant/brand-list/index.web.tsx:158
#: apps/dp-admin/src/pages/marketing/user-group-list/index.web.tsx:210
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/RefreshHistoryTab/index.web.tsx:101
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/MemberListTab/index.web.tsx:103
#: apps/dp-admin/src/pages/marketing/user-group-detail/components/ExportHistoryTab/index.web.tsx:162
#: apps/dp-admin/src/pages/marketing/merchant-group-list/index.web.tsx:180
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/RefreshHistoryTab/index.web.tsx:100
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/MemberListTab/index.web.tsx:93
#: apps/dp-admin/src/pages/marketing/merchant-group-detail/components/ExportHistoryTab/index.web.tsx:162
#: apps/dp-admin/src/pages/marketing/components/GroupUploadHistory/index.web.tsx:259
#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelListTab/index.web.tsx:243
#: apps/dp-admin/src/pages/marketing/benefit-management/index.web.tsx:395
msgid "顯示 {0}-{1} 條，共 {totalCount} 條"
msgstr "顯示 {0}-{1} 條，共 {totalCount} 條"

#. placeholder {0}: range[0]
#. placeholder {1}: range[1]
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:462
#: apps/dp-admin/src/pages/marketing/activity-config-list/index.web.tsx:285
msgid "顯示 {0}-{1} 條，共 {totalCount} 條記錄"
msgstr "顯示 {0}-{1} 條，共 {totalCount} 條記錄"

#: apps/dp-business/src/components/Pagination.tsx:149
#: apps/dp-business/src/components/Pagination/index.tsx:211
msgid "顯示 {start} 至 {end} 筆，共 {total} 筆結果"
msgstr "顯示 {start} 至 {end} 筆，共 {total} 筆結果"

#: apps/dp-admin/src/pages/audit-center/claim-audit/components/ClaimTable/index.web.tsx:372
msgid "顯示 {start}-{end} 筆，共 {total} 筆"
msgstr "顯示 {start}-{end} 筆，共 {total} 筆"

#. placeholder {0}: Math.min(pageSize, total)
#: apps/dp-admin/src/pages/merchant/check-in/components/MerchantTable/index.web.tsx:252
msgid "顯示 1 到 {0} 條，共 {total} 條記錄"
msgstr "顯示 1 到 {0} 條，共 {total} 條記錄"

#. placeholder {0}: (currentPage - 1) * pageSize + 1
#. placeholder {1}: Math.min(currentPage * pageSize, total)
#: apps/dp-admin/src/pages/users/roles/components/RoleTable/index.web.tsx:112
msgid "顯示{0} 到 {1}條，共{total}條記錄"
msgstr "顯示{0} 到 {1}條，共{total}條記錄"

#: apps/dp-admin/src/pages/users/permissions/components/MenuPermissionConfigForm/index.web.tsx:219
msgid "顯示控制"
msgstr "顯示控制"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopReviews/index.tsx:265
msgid "顯示更多評論"
msgstr "顯示更多評論"

#. placeholder {0}: range[0]
#. placeholder {1}: range[1]
#: apps/dp-admin/src/pages/transaction/service-management/components/ShopPackageCommission/CommissionBenefitListCard.web.tsx:115
msgid "顯示第 {0} 到 {1} 條，共 {total} 條"
msgstr "顯示第 {0} 到 {1} 條，共 {total} 條"

#. placeholder {0}: range[0]
#. placeholder {1}: range[1]
#: apps/dp-business/src/pages/RefundList/index.tsx:454
msgid "顯示第 {0}-{1} 條，共 {total} 條記錄"
msgstr "顯示第 {0}-{1} 條，共 {total} 條記錄"

#. placeholder {0}: (itemsPage - 1) * itemsPageSize + 1
#. placeholder {1}: Math.min(itemsPage * itemsPageSize, itemsTotal)
#: apps/dp-business/src/pages/UserManagement/CopyShopDetail.tsx:317
msgid "顯示第{0}到{1}條，共{itemsTotal}條"
msgstr "顯示第{0}到{1}條，共{itemsTotal}條"

#. placeholder {0}: (currentPage - 1) * pageSize + 1
#. placeholder {1}: Math.min(currentPage * pageSize, total)
#: apps/dp-business/src/pages/UserManagement/index.tsx:851
#: apps/dp-business/src/pages/PermissionManagement/index.tsx:263
msgid "顯示第{0}到{1}條，共{total}條"
msgstr "顯示第{0}到{1}條，共{total}條"

#. placeholder {0}: (current - 1) * pageSize + 1
#. placeholder {1}: Math.min( current * pageSize, total )
#: apps/dp-business/src/pages/CustomerReviews/components/Pagination.tsx:154
msgid "顯示第{0}條 - {1}條，共{total}條評價"
msgstr "顯示第{0}條 - {1}條，共{total}條評價"

#: apps/dp-business/src/components/Pagination.tsx:314
msgid "顯示第{start}到{end}條，共{total}條"
msgstr "顯示第{start}到{end}條，共{total}條"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:432
msgid "顯示該次數下最高可得份數；實際發放仍依內容達標條件判定。"
msgstr "顯示該次數下最高可得份數；實際發放仍依內容達標條件判定。"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/ShopBrandStory.tsx:64
#: apps/dp-client/src/screens/home/pages/ShopDetail/components/DealsSection/index.tsx:538
#: apps/dp-client/src/screens/home/pages/Note/components/ReviewCard/index.tsx:104
#: apps/dp-client/src/screens/home/components/ReplayCard/index.tsx:280
#: apps/dp-client/src/screens/home/bizComponents/ExpandableHtmlContent/index.tsx:235
msgid "顯示較少"
msgstr "顯示較少"

#: apps/dp-admin/src/router/config/routes.web.tsx:342
#: apps/dp-admin/src/pages/audit-center/risk-audit/index.web.tsx:200
msgid "風控審核"
msgstr "風控審核"

#: apps/dp-admin/src/pages/report-center/abnormal-orders/components/SearchFilter/index.web.tsx:21
msgid "風控攔截"
msgstr "風控攔截"

#: apps/dp-admin/src/pages/report-center/risk-control-analysis/index.web.tsx:7
msgid "風控管理分析"
msgstr "風控管理分析"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:54
msgid "飛漲"
msgstr "飛漲"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:921
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:941
#: apps/dp-business/src/components/NecessaryDocuments/index.tsx:55
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/view/ShopInfoDisplay.web.tsx:91
#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/ShopInfoSection.web.tsx:29
#: apps/dp-admin/src/pages/merchant/shop-detail/components/MerchantInfo/ShopInfoCard.web.tsx:135
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/ShopInfoSection/index.web.tsx:39
#: apps/dp-admin/src/pages/merchant/audit-detail/components/ShopApplicationAuditCard/index.web.tsx:166
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopInfoBody/index.web.tsx:94
msgid "食品業者登記字號"
msgstr "食品業者登記字號"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:932
msgid "食品業者登記字號最多16位"
msgstr "食品業者登記字號最多16位"

#: apps/dp-business/src/utils/validation.ts:230
msgid "食品業者登記字號必須為16位"
msgstr "食品業者登記字號必須為16位"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/tabs/BindMerchantTab/edit/ShopInfoSection.web.tsx:33
#: apps/dp-admin/src/pages/merchant/shop-bind-merchant/components/ShopInfoSection/index.web.tsx:43
msgid "食品業者登記字號必須為16位，包含字母和數字，最多1個連字號"
msgstr "食品業者登記字號必須為16位，包含字母和數字，最多1個連字號"

#: apps/dp-admin/src/utils/common.ts:168
msgid "食品業者登記字號格式不正確，必須為16位，1位字母開頭，後跟15位數字，最多1個連字符"
msgstr "食品業者登記字號格式不正確，必須為16位，1位字母開頭，後跟15位數字，最多1個連字符"

#: apps/dp-admin/src/pages/merchant/shop-detail/components/DetailMobile/components/MerchantContactInfo.web.tsx:60
msgid "食品業者登記號"
msgstr "食品業者登記號"

#: apps/dp-admin/src/pages/merchant/commercial-poi/poi-shops/components/ShopRelationTable/index.web.tsx:152
msgid "食品經營許可證號"
msgstr "食品經營許可證號"

#: apps/dp-business/src/pages/CustomerReviews/components/ProblemTrackingSection.tsx:27
msgid "食物品質"
msgstr "食物品質"

#: apps/dp-client/src/screens/diary/components/EnvironmentExampleModal.tsx:52
msgid "食物特寫"
msgstr "食物特寫"

#: apps/dp-client/src/screens/diary/pages/plaza/index.tsx:294
#: apps/dp-client/src/screens/diary/pages/no-access/index.tsx:129
#: apps/dp-client/src/screens/diary/pages/home/components/task-section/index.tsx:47
#: apps/dp-client/src/configs/page-configs.tsx:2841
msgid "食記廣場"
msgstr "食記廣場"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:62
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:69
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:63
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:70
#: apps/dp-business/src/data/categories.ts:215
msgid "飲品"
msgstr "飲品"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/SearchFilter.web.tsx:28
msgid "飲店優惠買單推廣"
msgstr "飲店優惠買單推廣"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/types.ts:148
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/hooks.ts:281
msgid "飲料"
msgstr "飲料"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:316
msgid "飽和度"
msgstr "飽和度"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:719
#: apps/dp-business/src/pages/OrderOverview/Detail/components/ReservationSlots.tsx:58
#: apps/dp-admin/src/pages/transaction/service-management/components/OrderDetail/components/ReservationSlots.web.tsx:86
msgid "餐別"
msgstr "餐別"

#: apps/dp-client/src/screens/home/pages/Meal/pages/detail/utils.tsx:213
msgid "餐券（{total}）"
msgstr "餐券（{total}）"

#: apps/dp-business/src/pages/ReviewDetail/index.tsx:142
#: apps/dp-business/src/pages/CustomerReviews/index.tsx:287
#: apps/dp-business/src/pages/CustomerReviews/index.tsx:483
#: apps/dp-business/src/pages/CustomerReviews/components/StoreInfoHeader.tsx:232
#: apps/dp-business/src/pages/CustomerReviews/components/ReviewItem.tsx:226
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:660
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:874
#: apps/dp-admin/src/pages/report-center/services/apis.ts:449
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:293
#: apps/dp-admin/src/pages/data-center/merchant-stats/components/SearchFilters.web.tsx:108
msgid "餐廳"
msgstr "餐廳"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:985
msgid "餐廳交通資訊"
msgstr "餐廳交通資訊"

#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:38
msgid "餐廳人氣榜"
msgstr "餐廳人氣榜"

#: apps/dp-business/src/pages/ReservationManagement/GuestBookingModal.tsx:663
msgid "餐廳信息缺失"
msgstr "餐廳信息缺失"

#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:177
msgid "餐廳分類"
msgstr "餐廳分類"

#: apps/dp-business/src/pages/OrderOverview/Detail/index.tsx:835
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1125
#: apps/dp-admin/src/pages/report-center/user-review-analysis/components/ReviewTable.web.tsx:28
#: apps/dp-admin/src/pages/report-center/transaction-data/components/TransactionTable.web.tsx:37
#: apps/dp-admin/src/pages/report-center/transaction-data/components/SearchFilter.web.tsx:74
msgid "餐廳名稱"
msgstr "餐廳名稱"

#: apps/dp-business/src/utils/moduleTypeMapping.ts:241
#: apps/dp-business/src/pages/MerchantDashboard/hooks/useDashboard.tsx:114
msgid "餐廳圖片"
msgstr "餐廳圖片"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:62
msgid "餐廳地圖標點與實際位置相差數百公尺"
msgstr "餐廳地圖標點與實際位置相差數百公尺"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1132
msgid "餐廳地址"
msgstr "餐廳地址"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:127
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1244
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:703
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:78
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:154
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:449
msgid "餐廳影片"
msgstr "餐廳影片"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:125
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1220
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:701
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:76
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:128
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:431
#: apps/dp-admin/src/pages/merchant/components/StoreDescriptionSection/index.web.tsx:51
msgid "餐廳描述"
msgstr "餐廳描述"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:976
msgid "餐廳描述與交通建議"
msgstr "餐廳描述與交通建議"

#: apps/dp-business/src/components/MaintenanceList/index.tsx:401
msgid "餐廳標籤"
msgstr "餐廳標籤"

#: apps/dp-client/src/screens/reservation/pages/detail/index.tsx:258
msgid "餐廳無法滿足需求"
msgstr "餐廳無法滿足需求"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:126
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1232
#: apps/dp-business/src/pages/BatchCopyShopInfo/index.tsx:702
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:77
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:135
msgid "餐廳照片"
msgstr "餐廳照片"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:147
msgid "餐廳特色"
msgstr "餐廳特色"

#: apps/dp-client/src/screens/diary/pages/my/components/PointsInfoCard.tsx:56
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:518
msgid "餐廳環境"
msgstr "餐廳環境"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:299
msgid "餐廳評論"
msgstr "餐廳評論"

#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:384
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:406
#: apps/dp-business/src/pages/StoreArrivalGuide.tsx:428
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:64
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:86
#: apps/dp-admin/src/pages/merchant/components/ArrivalGuideSection/index.web.tsx:108
msgid "餐廳門口有旋轉門和歡迎牌，門口站著戴廚師帽的小熊玩偶，上方有餐廳招牌。"
msgstr "餐廳門口有旋轉門和歡迎牌，門口站著戴廚師帽的小熊玩偶，上方有餐廳招牌。"

#: apps/dp-business/src/pages/OrderDetail/index.tsx:1949
#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1142
msgid "餐廳電話"
msgstr "餐廳電話"

#: apps/dp-business/src/pages/MerchantInfo/index.tsx:1150
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:696
#: apps/dp-business/src/pages/CategoryEdit/index.tsx:902
msgid "餐廳類別"
msgstr "餐廳類別"

#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:589
#: apps/dp-business/src/pages/ReservationManagement/ReservationRulesSettings.tsx:786
msgid "餐期"
msgstr "餐期"

#: apps/dp-business/src/pages/OrderOverview/index.tsx:1831
#: apps/dp-business/src/pages/OrderOverview/FilterModal.tsx:41
#: apps/dp-admin/src/pages/transaction/service-management/components/ReservationOverview/index.web.tsx:1163
msgid "餐段"
msgstr "餐段"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:676
msgid "餐段 {periodNames} 結束時間必須晚於開始時間"
msgstr "餐段 {periodNames} 結束時間必須晚於開始時間"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:656
msgid "餐段 {periodNames} 缺少時間設置"
msgstr "餐段 {periodNames} 缺少時間設置"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:657
msgid "餐段時間設置不完整"
msgstr "餐段時間設置不完整"

#: apps/dp-business/src/pages/ReservationManagement/AddReservationRuleModal.tsx:678
msgid "餐段時間設置錯誤"
msgstr "餐段時間設置錯誤"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:225
#: apps/dp-business/src/components/InvoiceForm/index.tsx:277
#: apps/dp-business/src/components/InvoiceForm/index.tsx:525
#: apps/dp-business/src/components/InvoiceForm/index.tsx:576
msgid "餐費"
msgstr "餐費"

#: apps/dp-client/src/screens/home/pages/ShopDetail/constants/index.ts:21
#: apps/dp-client/src/screens/diary/pages/my/components/PointsInfoCard.tsx:48
#: apps/dp-client/src/screens/diary/components/media-upload-form/index.tsx:533
#: apps/dp-business/src/pages/MerchantInfo/components/OptimizationCard.tsx:82
#: apps/dp-business/src/pages/MerchantInfo/components/OptimizationCard.tsx:87
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:430
msgid "餐點"
msgstr "餐點"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/SignatureDishes/components/DishImage.tsx:21
msgid ""
"餐點\n"
"圖片餐點\n"
"圖片"
msgstr ""
"餐點\n"
"圖片餐點\n"
"圖片"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/DishDetail/DishDetailPage.tsx:152
msgid "餐點不存在"
msgstr "餐點不存在"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/couponPreviewModel.ts:397
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:559
#: apps/dp-admin/src/pages/marketing/package-coupon-create/services/utils/couponPreviewModel.ts:496
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1065
msgid "餐點內容"
msgstr "餐點內容"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:251
msgid "餐點分類"
msgstr "餐點分類"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:643
msgid "餐點分類<0>*</0>"
msgstr "餐點分類<0>*</0>"

#: apps/dp-business/src/pages/MenuManagement.tsx:1238
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:391
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:252
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:349
msgid "餐點列表"
msgstr "餐點列表"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:772
msgid "餐點創建成功"
msgstr "餐點創建成功"

#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:803
msgid "餐點可選數量"
msgstr "餐點可選數量"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:875
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:935
#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:1001
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:205
#: apps/dp-business/src/pages/MarketingCenter/CreatePackageCoupon/components/MenuCard.tsx:674
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:286
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:239
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:104
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:352
#: apps/dp-admin/src/pages/marketing/package-coupon-detail/services/config.web.tsx:178
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:133
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:1217
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:174
msgid "餐點名稱"
msgstr "餐點名稱"

#: apps/dp-business/src/pages/MenuItemForm.tsx:421
msgid "餐點名稱 "
msgstr "餐點名稱 "

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:128
msgid "餐點名稱「{name}」已存在，請勿重複創建"
msgstr "餐點名稱「{name}」已存在，請勿重複創建"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:124
msgid "餐點名稱「{name}」重複，請勿填寫相同名稱"
msgstr "餐點名稱「{name}」重複，請勿填寫相同名稱"

#: apps/dp-business/src/pages/MenuItemForm.tsx:252
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:356
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:119
msgid "餐點名稱不能超過60個字符"
msgstr "餐點名稱不能超過60個字符"

#: apps/dp-business/src/pages/MenuItemForm.tsx:250
msgid "餐點名稱為必填項"
msgstr "餐點名稱為必填項"

#: apps/dp-business/src/pages/MenuManagement.tsx:617
#: apps/dp-business/src/pages/MenuItemForm.tsx:481
#: apps/dp-business/src/pages/MenuItemForm.tsx:496
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:224
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:305
#: apps/dp-business/src/pages/ImageManagement/index.tsx:252
#: apps/dp-business/src/pages/ImageManagement/index.tsx:446
#: apps/dp-admin/src/pages/merchant/merchant-decoration/index.web.tsx:266
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:432
#: apps/dp-admin/src/pages/merchant/components/CopyModal/constants.ts:39
#: apps/dp-admin/src/pages/audit-center/image-audit-detail/index.web.tsx:121
msgid "餐點圖片"
msgstr "餐點圖片"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:422
msgid "餐點圖片(選擇標籤後為必填)"
msgstr "餐點圖片(選擇標籤後為必填)"

#: apps/dp-client/src/screens/diary/components/CommentForm.tsx:813
msgid "餐點好吃嗎？用餐環境如何？對服務的感受？"
msgstr "餐點好吃嗎？用餐環境如何？對服務的感受？"

#: apps/dp-business/src/pages/MenuManagement.tsx:874
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:169
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:51
msgid "餐點已刪除"
msgstr "餐點已刪除"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:208
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:80
msgid "餐點已新增"
msgstr "餐點已新增"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:199
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:72
msgid "餐點已更新"
msgstr "餐點已更新"

#: apps/dp-business/src/pages/MenuManagement.tsx:951
msgid "餐點排序"
msgstr "餐點排序"

#: apps/dp-client/src/configs/page-configs.tsx:586
msgid "餐點排行榜"
msgstr "餐點排行榜"

#: apps/dp-business/src/pages/MenuManagement.tsx:651
#: apps/dp-business/src/pages/MenuManagement.tsx:1334
#: apps/dp-business/src/pages/MenuItemForm.tsx:570
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:506
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:189
msgid "餐點描述"
msgstr "餐點描述"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/CreateDishModal.web.tsx:133
msgid "餐點描述不能超過200個字符"
msgstr "餐點描述不能超過200個字符"

#: apps/dp-business/src/pages/MenuItemForm.tsx:281
msgid "餐點描述不能超過500個字元"
msgstr "餐點描述不能超過500個字元"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:508
msgid "餐點描述不能超過500個字符"
msgstr "餐點描述不能超過500個字符"

#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/DishRankSection/index.tsx:187
#: apps/dp-admin/src/pages/resource-config/rank-list/services/constants.ts:14
msgid "餐點榜"
msgstr "餐點榜"

#: apps/dp-client/src/screens/home/pages/Ranking/RankHome/components/DishRankSection/index.tsx:146
msgid "餐點榜單"
msgstr "餐點榜單"

#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:500
msgid "餐點標籤"
msgstr "餐點標籤"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:451
#: apps/dp-business/src/pages/BatchCopyShopInfo/SelectCopyContent.tsx:67
#: apps/dp-business/src/components/MaintenanceList/index.tsx:604
msgid "餐點照片"
msgstr "餐點照片"

#: apps/dp-admin/src/pages/merchant/components/CopyModal/index.web.tsx:872
msgid "餐點菜單："
msgstr "餐點菜單："

#: apps/dp-client/src/configs/page-configs.tsx:199
msgid "餐點詳情"
msgstr "餐點詳情"

#: apps/dp-business/src/pages/MarketingCenter/PackageCouponDetail/index.tsx:845
msgid "餐點資訊"
msgstr "餐點資訊"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/ShopInfo/index.tsx:163
#: apps/dp-business/src/pages/MenuManagement.tsx:1163
#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:274
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:356
#: apps/dp-business/src/components/MaintenanceList/index.tsx:261
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuItemSection/index.web.tsx:225
#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuCategorySection/index.web.tsx:128
#: apps/dp-admin/src/pages/merchant/components/MenuItemSection/index.web.tsx:90
#: apps/dp-admin/src/pages/merchant/components/MenuCategorySection/index.web.tsx:115
msgid "餐點類別"
msgstr "餐點類別"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/MenuInfoSection/index.web.tsx:263
msgid "餐點類型"
msgstr "餐點類型"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:76
msgid "首單時間"
msgstr "首單時間"

#: apps/dp-admin/src/pages/report-center/user-registration-data/components/RegistrationTable.web.tsx:82
msgid "首單金額"
msgstr "首單金額"

#: apps/dp-admin/src/pages/resource-config/services/constants.ts:15
msgid "首屏配置"
msgstr "首屏配置"

#: apps/dp-admin/src/pages/report-center/customer-service-analysis/components/CSTable.web.tsx:36
#: apps/dp-admin/src/pages/customer-service/components/TicketTable.web.tsx:42
msgid "首次回覆時間"
msgstr "首次回覆時間"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:422
msgid "首次收藏店舖"
msgstr "首次收藏餐廳"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:235
msgid "首次新增，無上次對比"
msgstr "首次新增，無上次對比"

#: apps/dp-business/src/pages/MarketingCenter/components/DistributionSettingsCard.tsx:434
msgid "首次消費"
msgstr "首次消費"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:284
#: apps/dp-client/src/screens/login/components/fet-login-modal/index.tsx:116
msgid "首次登錄會自動創建新帳號，且代表同意使用條款和隱私權政策。"
msgstr "首次登錄會自動創建新帳號，且代表同意使用條款和隱私權政策。"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:39
msgid "首次觸發"
msgstr "首次觸發"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/RewardLimitConfigEditor/index.web.tsx:75
msgid "首次觸發固定為整個活動僅領取 1 次"
msgstr "首次觸發固定為整個活動僅領取 1 次"

#: apps/dp-admin/src/pages/report-center/user-activity-analysis/components/ActivityTable.web.tsx:45
msgid "首次訪問時間"
msgstr "首次訪問時間"

#: apps/dp-client/src/configs/page-configs.tsx:46
#: apps/dp-client/src/configs/main-config.tsx:68
#: apps/dp-client/src/configs/main-config.tsx:69
#: apps/dp-admin/src/router/config/baseRoutes.ts:24
msgid "首頁"
msgstr "首頁"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:354
msgid "首頁（定位到瀑布流）"
msgstr "首頁（定位到瀑布流）"

#: apps/dp-admin/src/pages/org-tree/org-audit/detail/index.web.tsx:361
#: apps/dp-admin/src/pages/audit-center/negative-review-appeal/components/RemarkSection/index.web.tsx:23
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/SigningAuditTab/index.web.tsx:182
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:498
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/EntryAuditTab/index.web.tsx:204
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/BindingAuditTab/ShopBindingCard/index.web.tsx:298
msgid "駁回"
msgstr "駁回"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:628
msgid "駁回人："
msgstr "駁回人："

#: apps/dp-admin/src/pages/org-tree/org-audit/components/RejectModal/index.web.tsx:62
#: apps/dp-admin/src/pages/merchant/merchant-account/components/AccountHistoryModal.web.tsx:144
#: apps/dp-admin/src/pages/audit-center/audit-task-detail/components/PoiAuditTab/index.web.tsx:509
msgid "駁回原因"
msgstr "駁回原因"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:642
msgid "駁回原因："
msgstr "駁回原因："

#. placeholder {0}: recode?.approvalReason
#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/services/config/tableColumns.web.tsx:66
msgid "駁回原因:{0}"
msgstr "駁回原因:{0}"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:109
msgid "駁回原因不能超過200個字符"
msgstr "駁回原因不能超過200個字符"

#: apps/dp-admin/src/pages/audit-center/package-coupon-audit/components/AuditModal/index.web.tsx:108
msgid "駁回原因至少5個字符"
msgstr "駁回原因至少5個字符"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/index.web.tsx:433
msgid "駁回審核"
msgstr "駁回審核"

#: apps/dp-admin/src/pages/org-tree/org-audit/components/RejectModal/index.web.tsx:40
msgid "駁回後提交人需修改後重新提交。"
msgstr "駁回後提交人需修改後重新提交。"

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:631
msgid "駁回時間："
msgstr "駁回時間："

#: apps/dp-admin/src/pages/transaction/merchant-basic-contract/index.web.tsx:636
msgid "駁回節點："
msgstr "駁回節點："

#: apps/dp-client/src/screens/login/pages/verify-password/index.tsx:87
#: apps/dp-client/src/screens/login/pages/verify-password/components/verify-password-form/index.tsx:57
#: apps/dp-business/src/components/VerificationInput/index.tsx:120
msgid "驗證"
msgstr "驗證"

#: apps/dp-client/src/screens/account/pages/account-security/email/email-old/index.tsx:75
#: apps/dp-client/src/configs/page-configs.tsx:1920
msgid "驗證Email"
msgstr "驗證Email"

#: apps/dp-client/src/screens/account/pages/account-security/email/check-email/index.tsx:72
msgid "驗證Email失敗，請稍後重試"
msgstr "驗證Email失敗，請稍後重試"

#: apps/dp-business/src/pages/SettlementOrders/index.tsx:747
#: apps/dp-business/src/pages/ChainDashboard/components/finance/ChainClaimCreate.tsx:531
#: apps/dp-business/src/components/VerificationInput/index.tsx:328
#: apps/dp-business/src/components/InvoiceForm/index.tsx:439
msgid "驗證中..."
msgstr "驗證中..."

#: apps/dp-business/src/servers/auth/api.ts:186
msgid "驗證信箱驗證碼並建立商家失敗"
msgstr "驗證信箱驗證碼並建立商家失敗"

#: apps/dp-business/src/servers/verification/api.ts:112
msgid "驗證信箱驗證碼失敗"
msgstr "驗證信箱驗證碼失敗"

#: apps/dp-business/src/pages/CouponVerification/index.tsx:801
msgid "驗證券碼中..."
msgstr "驗證券碼中..."

#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:135
#: apps/dp-business/src/pages/SimpleDashboard/hooks/useCouponVerify.tsx:141
#: apps/dp-business/src/pages/CouponVerification/index.tsx:427
#: apps/dp-business/src/pages/CouponVerification/index.tsx:433
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:581
#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:587
msgid "驗證券碼失敗"
msgstr "驗證券碼失敗"

#: apps/dp-client/src/configs/page-configs.tsx:1939
msgid "驗證原Email"
msgstr "驗證原Email"

#: apps/dp-business/src/components/EmailVerification/index.tsx:283
#: apps/dp-business/src/components/EmailVerification/index.tsx:289
#: apps/dp-business/src/components/EmailVerification/index.tsx:290
msgid "驗證失敗，請檢查Email和驗證碼"
msgstr "驗證失敗，請檢查Email和驗證碼"

#: apps/dp-business/src/components/PhoneVerification/index.tsx:285
#: apps/dp-business/src/components/PhoneVerification/index.tsx:291
#: apps/dp-business/src/components/PhoneVerification/index.tsx:292
msgid "驗證失敗，請檢查手機門號和驗證碼"
msgstr "驗證失敗，請檢查手機門號和驗證碼"

#: apps/dp-client/src/screens/login/pages/verify-password/index.tsx:62
#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:242
#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:244
#: apps/dp-client/src/screens/account/pages/check-phone/index.tsx:105
#: apps/dp-client/src/screens/account/pages/check-phone/verification-code/index.tsx:86
#: apps/dp-client/src/screens/account/pages/account-security/check-password/index.tsx:57
msgid "驗證失敗，請稍後重試"
msgstr "驗證失敗，請稍後重試"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:343
#: apps/dp-business/src/components/VerificationInput/index.tsx:169
#: apps/dp-business/src/components/VerificationInput/index.tsx:268
#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:165
msgid "驗證失敗，請重試"
msgstr "驗證失敗，請重試"

#: apps/dp-client/src/configs/page-configs.tsx:1846
msgid "驗證密碼"
msgstr "驗證密碼"

#: apps/dp-client/src/screens/login/pages/verify-password/index.tsx:51
#: apps/dp-client/src/screens/account/pages/check-phone/verification-code/index.tsx:79
#: apps/dp-client/src/screens/account/pages/account-security/email/email-old/index.tsx:52
#: apps/dp-client/src/screens/account/pages/account-security/check-password/index.tsx:48
#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:155
msgid "驗證成功"
msgstr "驗證成功"

#: apps/dp-business/src/pages/ForgotPasswordPage/index.tsx:77
msgid "驗證成功，請設定新密碼"
msgstr "驗證成功，請設定新密碼"

#: apps/dp-client/src/screens/account/pages/check-phone/index.tsx:35
#: apps/dp-client/src/screens/account/pages/check-phone/index.tsx:37
#: apps/dp-client/src/configs/page-configs.tsx:1995
msgid "驗證手機門號"
msgstr "驗證手機門號"

#: apps/dp-business/src/servers/auth/api.ts:121
msgid "驗證手機驗證碼並建立商家失敗"
msgstr "驗證手機驗證碼並建立商家失敗"

#: apps/dp-business/src/servers/verification/api.ts:145
msgid "驗證手機驗證碼失敗"
msgstr "驗證手機驗證碼失敗"

#: apps/dp-client/src/screens/home/pages/UserGift/hooks/useUserGiftData.ts:165
msgid "驗證流程失敗:"
msgstr "驗證流程失敗:"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:443
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:279
#: apps/dp-client/src/screens/account/pages/check-phone/verification-code/index.tsx:43
#: apps/dp-client/src/screens/account/pages/check-phone/verification-code/index.tsx:99
#: apps/dp-client/src/screens/account/pages/account-security/email/verification-email/index.tsx:31
#: apps/dp-client/src/screens/account/pages/account-security/email/verification-email/index.tsx:80
#: apps/dp-client/src/configs/page-configs.tsx:1291
#: apps/dp-client/src/configs/page-configs.tsx:1977
#: apps/dp-client/src/configs/page-configs.tsx:2029
#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:891
#: apps/dp-business/src/pages/Login/Email/index.tsx:239
#: apps/dp-business/src/components/PhoneVerification/index.tsx:389
#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:204
#: apps/dp-business/src/components/EmailVerification/index.tsx:381
msgid "驗證碼"
msgstr "驗證碼"

#: apps/dp-business/src/components/VerificationInput/index.tsx:162
#: apps/dp-business/src/components/VerificationInput/index.tsx:250
msgid "驗證碼不正確"
msgstr "驗證碼不正確"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:337
msgid "驗證碼不正確，請重新輸入"
msgstr "驗證碼不正確，請重新輸入"

#: apps/dp-business/src/components/ForgotPassword/index.tsx:219
msgid "驗證碼已傳送到您的信箱"
msgstr "驗證碼已傳送到您的信箱"

#: apps/dp-business/src/components/ForgotPassword/index.tsx:220
msgid "驗證碼已傳送到您的手機"
msgstr "驗證碼已傳送到您的手機"

#: apps/dp-client/src/screens/login/components/fet-login-phone-modal/index.tsx:182
#: apps/dp-client/src/screens/login/components/fet-bind-phone-modal/index.tsx:143
#: apps/dp-client/src/hooks/useVerificationCode.ts:230
#: apps/dp-business/src/pages/Login/index.tsx:542
#: apps/dp-business/src/pages/Login/index.tsx:578
#: apps/dp-business/src/pages/Login/Email/index.tsx:103
#: apps/dp-business/src/components/PhoneVerification/index.tsx:180
#: apps/dp-business/src/components/PhoneVerification/index.tsx:189
#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:111
#: apps/dp-business/src/components/EmailVerification/index.tsx:175
#: apps/dp-business/src/components/EmailVerification/index.tsx:186
msgid "驗證碼已發送"
msgstr "驗證碼已發送"

#: apps/dp-client/src/screens/login/pages/verify-identify-code/index.tsx:284
msgid "驗證碼已發送Email"
msgstr "驗證碼已發送Email"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:289
msgid "驗證碼已發送到負責人手機"
msgstr "驗證碼已發送到負責人手機"

#: apps/dp-client/src/screens/account/pages/check-phone/index.tsx:118
#: apps/dp-client/src/screens/account/pages/check-phone/verification-code/index.tsx:100
#: apps/dp-client/src/screens/account/pages/account-security/email/verification-email/index.tsx:81
#: apps/dp-client/src/screens/account/pages/account-security/email/check-email/index.tsx:84
#: apps/dp-client/src/components/verify-code-sender/index.tsx:62
msgid "驗證碼已發送至"
msgstr "驗證碼已發送至"

#: apps/dp-business/src/components/PhoneVerification/index.tsx:338
#: apps/dp-business/src/components/EmailVerification/index.tsx:337
msgid "驗證碼已發送至{contactInfo}"
msgstr "驗證碼已發送至{contactInfo}"

#: apps/dp-business/src/components/ForgotPassword/index.tsx:265
msgid "驗證碼已重新傳送到您的信箱"
msgstr "驗證碼已重新傳送到您的信箱"

#: apps/dp-business/src/components/ForgotPassword/index.tsx:266
msgid "驗證碼已重新傳送到您的手機"
msgstr "驗證碼已重新傳送到您的手機"

#: apps/dp-business/src/pages/Login/index.tsx:378
#: apps/dp-business/src/pages/Login/index.tsx:379
#: apps/dp-business/src/pages/Login/Email/index.tsx:67
#: apps/dp-business/src/pages/Login/Email/index.tsx:68
#: apps/dp-business/src/components/PhoneVerification/index.tsx:138
#: apps/dp-business/src/components/PhoneVerification/index.tsx:139
#: apps/dp-business/src/components/EmailVerification/index.tsx:137
#: apps/dp-business/src/components/EmailVerification/index.tsx:138
msgid "驗證碼格式不正確"
msgstr "驗證碼格式不正確"

#: apps/dp-business/src/pages/Login/index.tsx:917
#: apps/dp-business/src/pages/Login/index.tsx:1381
msgid "驗證碼登入"
msgstr "驗證碼登入"

#: apps/dp-business/src/services/auth.ts:217
msgid "驗證碼登入失敗"
msgstr "驗證碼登入失敗"

#: apps/dp-business/src/components/CodeVerification/index.tsx:240
msgid "驗證碼發送中……"
msgstr "驗證碼發送中……"

#: apps/dp-business/src/pages/Login/Email/index.tsx:112
#: apps/dp-business/src/pages/Login/Email/index.tsx:122
#: apps/dp-business/src/components/PhoneVerification/index.tsx:183
#: apps/dp-business/src/components/PhoneVerification/index.tsx:192
#: apps/dp-business/src/components/PhoneVerification/index.tsx:197
#: apps/dp-business/src/components/EmailVerification/index.tsx:179
#: apps/dp-business/src/components/EmailVerification/index.tsx:190
#: apps/dp-business/src/components/EmailVerification/index.tsx:195
msgid "驗證碼發送失敗，請稍後重試"
msgstr "驗證碼發送失敗，請稍後重試"

#: packages/captcha/src/SecurityCaptchaProvider.tsx:215
msgid "驗證碼連續錯誤次數較多，請拖動滑塊後再試"
msgstr "驗證碼連續錯誤次數較多，請拖動滑塊後再試"

#: apps/dp-client/src/components/verify-code-sender/index.tsx:120
#: apps/dp-business/src/components/IdentityVerificationModal/index.tsx:159
#: apps/dp-business/src/components/ForgotPassword/index.tsx:309
#: apps/dp-business/src/components/ForgotPassword/index.tsx:327
msgid "驗證碼錯誤，請重新輸入"
msgstr "驗證碼錯誤，請重新輸入"

#: apps/dp-business/src/services/auth.ts:124
msgid "驗證碼驗證失敗"
msgstr "驗證碼驗證失敗"

#: apps/dp-business/src/servers/auth/api.ts:414
#: apps/dp-business/src/servers/auth/api.ts:446
msgid "驗證碼驗證失敗，請重試"
msgstr "驗證碼驗證失敗，請重試"

#: apps/dp-business/src/pages/SubmitDocuments/index.tsx:330
#: apps/dp-business/src/components/ForgotPassword/index.tsx:314
msgid "驗證碼驗證成功"
msgstr "驗證碼驗證成功"

#: apps/dp-business/src/pages/CouponVerification/components/VerificationDialog.tsx:1015
msgid "驗證票券中..."
msgstr "驗證票券中..."

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:353
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:354
#: apps/dp-admin/src/pages/merchant/task-list/components/PriorityTag/index.web.tsx:30
#: apps/dp-admin/src/pages/merchant/service/constants.ts:454
msgid "高"
msgstr "高"

#: apps/dp-business/src/pages/MenuManagement.tsx:135
#: apps/dp-business/src/pages/MenuItemForm.tsx:46
#: apps/dp-admin/src/pages/merchant/shop-list-v2/services/constants.ts:52
#: apps/dp-admin/src/pages/merchant/shop-list/services/constants.ts:52
msgid "高CP值"
msgstr "高CP值"

#: apps/dp-client/src/screens/home/components/RichTextInput/example.tsx:77
msgid "高亮詞彙示例"
msgstr "特別強調詞彙範例"

#: apps/dp-admin/src/pages/merchant/task-list/components/TaskMobile/components/TaskList/index.web.tsx:60
msgid "高優先級"
msgstr "高優先級"

#: apps/dp-admin/src/modules/constants/options.ts:95
msgid "高意向"
msgstr "高意向"

#: apps/dp-admin/src/pages/merchant/service/constants.ts:446
msgid "高潛拜訪"
msgstr "高潛拜訪"

#: apps/dp-business/src/data/regions.ts:14
msgid "高雄"
msgstr "高雄"

#: apps/dp-admin/src/pages/resource-config/slot-material-detail/services/constants.ts:16
msgid "鴻蒙"
msgstr "鴻蒙"

#: apps/dp-admin/src/pages/merchant/commercial-poi/services/constants.ts:172
msgid "鴻蒙 / Harmony"
msgstr "鴻蒙 / Harmony"

#: apps/dp-business/src/data/regions.ts:63
msgid "鶯歌區"
msgstr "鶯歌區"

#: apps/dp-business/src/data/categories.ts:40
msgid "麻辣川菜"
msgstr "麻辣川菜"

#: apps/dp-admin/src/pages/worker-order/services/mock.ts:67
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:123
#: apps/dp-admin/src/pages/worker-order/services/mock.ts:179
msgid "黃業務"
msgstr "黃業務"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:163
msgid "黃色"
msgstr "黃色"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:42
msgid "黃賭毒等違法或有害內容"
msgstr "黃賭毒等違法或有害內容"

#: apps/dp-client/src/configs/page-configs.tsx:2116
#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:211
msgid "黑名單"
msgstr "黑名單"

#: apps/dp-admin/src/pages/marketing/user-activity-detail/services/config.web.tsx:94
msgid "黑名單狀態"
msgstr "黑名單狀態"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:303
msgid "黑白紫"
msgstr "黑白紫"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:156
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:301
msgid "黑色"
msgstr "黑色"

#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.web.tsx:52
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/PinturaImageEditor.native.tsx:286
#: apps/dp-client/src/screens/home/pages/Note/components/PhotoManipulator/components/configs/index.ts:119
msgid "黑體"
msgstr "黑體"

#: apps/dp-client/src/screens/account/pages/invoice/components/InvoiceProfileCard/index.tsx:97
msgid "默認"
msgstr "預設"

#: apps/dp-admin/src/pages/exception/es-exception-handler/index.web.tsx:217
msgid "默認會提供參數："
msgstr "默認會提供參數："

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelFormModal/index.web.tsx:295
msgid "默認根據渠道名稱生成拼音代碼，可修改"
msgstr "默認根據渠道名稱生成拼音代碼，可修改"

#: apps/dp-client/src/screens/account/pages/task-wall/components/TaskWallProgressCard/index.tsx:85
#: apps/dp-client/src/screens/account/pages/task-wall/components/RewardExchangeCard/index.tsx:125
#: apps/dp-client/src/screens/account/pages/profile/components/TaskWallEntry/index.tsx:67
msgid "點"
msgstr "點"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:189
msgid "點「去配置」跳轉現有「新增落地頁」流程，落地頁類型自動鎖定為「套餐券列表」；完成後返回本頁並回填落地頁 URL。跳轉時帶入店家名單（同一商家組）。"
msgstr "點「去配置」跳轉現有「新增落地頁」流程，落地頁類型自動鎖定為「套餐券列表」；完成後返回本頁並回填落地頁 URL。跳轉時帶入店家名單（同一商家組）。"

#: apps/dp-admin/src/pages/marketing/benefit-form/components/UseJumpConfigSection/index.web.tsx:183
msgid "點「去配置」跳轉現有「新增落地頁」流程，落地頁類型自動鎖定為「店家組列表」；完成後返回本頁並回填落地頁 URL。跳轉時帶入店家列表（同一商家組）；全權益類型通用。"
msgstr "點「去配置」跳轉現有「新增落地頁」流程，落地頁類型自動鎖定為「店家組列表」；完成後返回本頁並回填落地頁 URL。跳轉時帶入店家列表（同一商家組）；全權益類型通用。"

#: apps/dp-business/src/pages/MarketingCenter/CreateReductionCoupon/components/BasicInfoCard.tsx:70
#: apps/dp-business/src/pages/MarketingCenter/CreateDiscountCoupon/components/BasicInfoCard.tsx:71
msgid "點心"
msgstr "點心"

#: apps/dp-business/src/pages/ComplaintForm/index.tsx:428
#: apps/dp-business/src/pages/ComplaintForm/index.tsx:460
#: apps/dp-business/src/components/PhotoUploader/components/PhotoUploadArea.tsx:140
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:454
#: apps/dp-admin/src/pages/merchant/components/MenuItemEditModal/index.web.tsx:492
#: apps/dp-admin/src/pages/merchant/components/MenuImageSection/index.web.tsx:889
#: apps/dp-admin/src/components/ImageUpload/index.web.tsx:300
msgid "點擊上傳"
msgstr "點擊上傳"

#: apps/dp-client/src/screens/diary/pages/add-merchant/add-merchant-form/components/PhotoUploader.tsx:392
#: apps/dp-admin/src/pages/resource-config/diamond-config/components/DiamondConfigModal/index.web.tsx:359
msgid "點擊上傳圖片"
msgstr "點擊上傳圖片"

#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:250
#: apps/dp-admin/src/pages/marketing/package-coupon-create/components/BasicInfoSection/index.web.tsx:285
msgid "點擊上傳圖片或動圖"
msgstr "點擊上傳圖片或動圖"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:370
msgid "點擊上傳店門口照片"
msgstr "點擊上傳店門口照片"

#: apps/dp-business/src/components/PhotoUploader/components/PhotoUploadArea.tsx:103
msgid "點擊上傳或拖拽至此處"
msgstr "點擊上傳或拖拽至此處"

#: apps/dp-business/src/pages/SubmitDocuments/components/DocumentUploader.tsx:44
#: apps/dp-business/src/components/PhotoUploader/index.tsx:325
msgid "點擊上傳檔案"
msgstr "點擊上傳檔案"

#: apps/dp-business/src/pages/MenuManagement.tsx:1135
msgid "點擊上傳菜單圖片"
msgstr "點擊上傳菜單圖片"

#: apps/dp-business/src/pages/ImageManagement/index.tsx:352
msgid "點擊上傳門市大頭照"
msgstr "點擊上傳門市大頭照"

#: apps/dp-admin/src/pages/merchant/merchant-menu/components/MenuCategorySection/index.web.tsx:157
#: apps/dp-admin/src/pages/merchant/components/MenuCategorySection/index.web.tsx:130
msgid "點擊上方按鈕新增類別"
msgstr "點擊上方按鈕新增類別"

#: apps/dp-admin/src/pages/merchant/components/BusinessHoursSection/index.web.tsx:241
msgid "點擊上方按鈕添加特殊營業時間"
msgstr "點擊上方按鈕添加特殊營業時間"

#: apps/dp-admin/src/components/VideoPlayer/index.web.tsx:60
msgid "點擊下載"
msgstr "點擊下載"

#: apps/dp-business/src/components/InvoiceForm/index.tsx:412
msgid "點擊下載收據樣本"
msgstr "點擊下載收據樣本"

#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:909
#: apps/dp-business/src/pages/MerchantDashboard/components/StoreSwitcher/StoreSwitchModal.tsx:966
msgid "點擊任一店家列即可切換管理店家；已下架店家仍可進入查看，但會保留狀態標示。"
msgstr "點擊任一店家列即可切換管理店家；已下架店家仍可進入查看，但會保留狀態標示。"

#: apps/dp-admin/src/pages/org-tree/org-list/components/OrgTreeTable/index.web.tsx:97
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:469
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:859
#: apps/dp-admin/src/pages/merchant/shop-list-v2/components/ShopListTable/index.web.tsx:890
#: apps/dp-admin/src/pages/merchant/components/MerchantDimensionListPage/index.web.tsx:605
msgid "點擊分配"
msgstr "點擊分配"

#: apps/dp-client/src/screens/diary/pages/home/components/city-modal/index.tsx:95
msgid "點擊取得目前位置"
msgstr "點擊取得目前定位"

#: apps/dp-admin/src/components/MapPicker/index.web.tsx:575
msgid "點擊地圖或拖拽標記選取中心點，可拖拉藍色圓形調整半徑。"
msgstr "點擊地圖或拖拽標記選取中心點，可拖拉藍色圓形調整半徑。"

#: apps/dp-admin/src/components/MapPicker/index.web.tsx:573
msgid "點擊地圖或拖拽標記選取位置，選點後自動回填地址。"
msgstr "點擊地圖或拖拽標記選取位置，選點後自動回填地址。"

#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/ShopIdUpload.web.tsx:54
#: apps/dp-admin/src/pages/marketing/platform-coupon-management/components/CouponCodeUpload.web.tsx:147
#: apps/dp-admin/src/pages/marketing/coupon-group-form/components/CouponCodeUpload/index.web.tsx:335
#: apps/dp-admin/src/pages/marketing/benefit-form/components/ImportCouponCodes/index.web.tsx:352
msgid "點擊或拖拽文件到此區域上傳"
msgstr "點擊或拖拽文件到此區域上傳"

#: apps/dp-business/src/components/ModificationReason/index.tsx:115
msgid "點擊或拖放圖片到這裡PNG，JPG（最大5Mb,最多9張）"
msgstr "點擊或拖放圖片到這裡PNG，JPG（最大5Mb,最多9張）"

#: apps/dp-admin/src/pages/resource-config/rank-create/index.web.tsx:719
#: apps/dp-admin/src/pages/merchant/batch-upload/components/UploadSection/index.web.tsx:212
msgid "點擊或拖曳上傳 Excel 檔案"
msgstr "點擊或拖曳上傳 Excel 檔案"

#: apps/dp-admin/src/pages/worker-order/components/CreateWorkerOrderModal.web.tsx:315
msgid "點擊或拖曳檔案至此上傳（最大 20 MB，僅限 1 個檔案，不支援影片）"
msgstr "點擊或拖曳檔案至此上傳（最大 20 MB，僅限 1 個檔案，不支援影片）"

#: apps/dp-admin/src/pages/marketing/general-activity-detail/components/LotteryDrawModal.web.tsx:462
msgid "點擊抽獎"
msgstr "點擊抽獎"

#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:348
#: apps/dp-business/src/pages/CouponVerification/components/QRCodeScanner.tsx:424
msgid "點擊掃描"
msgstr "點擊掃描"

#: apps/dp-business/src/components/CheckoutServiceModal/index.tsx:50
msgid "點擊查看您的結帳服務評價，自由設定篩選結帳折扣~"
msgstr "點擊查看您的結帳服務評價，自由設定篩選結帳折扣~"

#: apps/dp-client/src/screens/home/pages/Home/components/RecommendMasonryList/index.tsx:616
msgid "點擊查看更多推薦"
msgstr "點擊查看更多推薦"

#: apps/dp-business/src/pages/MerchantDashboard/components/NotificationPanel.tsx:832
msgid "點擊查看詳情"
msgstr "點擊查看詳情"

#: apps/dp-client/src/screens/home/pages/Purchase/components/SelectDishContent/index.tsx:429
msgid "點擊確認"
msgstr "點擊確認"

#: apps/dp-client/src/screens/home/pages/Purchase/components/SelectDishContent/index.tsx:429
msgid "點擊確認（已投 {votedCount}）"
msgstr "點擊確認（已投 {votedCount}）"

#: apps/dp-client/src/screens/home/pages/ShopDetail/pages/SignatureDishes/components/BottomTip.tsx:19
msgid "點擊篩選、再次點擊取消篩選"
msgstr "點擊篩選、再次點擊取消篩選"

#: apps/dp-admin/src/pages/marketing/channel-management/components/ChannelImportTab/index.web.tsx:189
msgid "點擊選擇 Excel 檔案，或將檔案拖曳至此"
msgstr "點擊選擇 Excel 檔案，或將檔案拖曳至此"

#: apps/dp-admin/src/pages/customer-service/ticket-detail/components/ReplyPanel.web.tsx:206
msgid "點擊開始處理後，該工單將不在自動分配流轉"
msgstr "點擊開始處理後，該工單將不在自動分配流轉"

#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/constants.ts:224
msgid "點擊領取"
msgstr "點擊領取"

#: apps/dp-client/src/screens/home/pages/ShopDetail/components/CheckInModal/index.tsx:394
#: apps/dp-client/src/screens/home/pages/Review/pages/complete/components/ReviewRewardCard.tsx:37
#: apps/dp-client/src/screens/home/pages/Note/components/NoteSucessToast/index.tsx:86
#: apps/dp-client/src/hooks/tasks/useTaskTooltip.ts:186
#: apps/dp-client/src/hooks/tasks/useTaskRewardHint.ts:93
#: apps/dp-client/src/hooks/tasks/useTaskRewardHint.ts:110
#: apps/dp-client/src/components/TaskRewardToast/index.tsx:24
#: apps/dp-admin/src/pages/marketing/activity-config-form/components/TaskWallSection/components/TaskWallCardConfig/index.web.tsx:193
msgid "點數"
msgstr "點數"

#: apps/dp-client/src/hooks/tasks/useTaskRewardHint.ts:77
msgid "點數！"
msgstr "點數！"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/exchange/index.tsx:87
msgid "點數兌換專區"
msgstr "點數兌換專區"

#: apps/dp-client/src/screens/account/pages/task-wall/pages/records/index.tsx:25
#: apps/dp-client/src/screens/account/pages/task-wall/pages/records/index.tsx:222
msgid "點數獲取紀錄"
msgstr "點數獲取紀錄"

#: apps/dp-client/src/screens/login/components/account-info-card/index.tsx:77
msgid "點評"
msgstr "評論"

#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/pages/NoteList/index.tsx:168
#: apps/dp-client/src/screens/home/pages/Ranking/RankBowl/components/NoteModule/index.tsx:174
#: apps/dp-client/src/screens/home/pages/MallDetail/components/MallNoteSection/index.tsx:137
msgid "點贊失敗"
msgstr "點贊失敗"

#: apps/dp-client/src/configs/page-configs.tsx:2343
#: apps/dp-client/src/configs/page-configs.tsx:2345
msgid "點贊搜尋"
msgstr "點贊搜尋"

#: apps/dp-client/src/configs/page-configs.tsx:2360
#: apps/dp-client/src/configs/page-configs.tsx:2362
msgid "點贊搜尋結果"
msgstr "點贊搜尋結果"

#: apps/dp-admin/src/pages/user-info/user-detail/components/NoteListTab/index.web.tsx:57
msgid "點贊數量"
msgstr "點讚數量"

#: apps/dp-business/src/pages/MarketingCenter/index.tsx:910
#: apps/dp-admin/src/pages/marketing/package-coupon-list/index.web.tsx:494
#: apps/dp-admin/src/pages/marketing/merchant-marketing/index.web.tsx:887
msgid "點選是後，您將無法對本次提交內容進行審核．"
msgstr "點選是後，您將無法對本次提交內容進行審核．"
